export const treeData = [
    {
        "id": "1",
        "linkid": "0",
        "code": "1",
        "paCode": null,
        "yn": "Y",
        "title": "货物",
        "alias": "货物",
        "about": null,
        "kws": null,
        "taxName": "货物",
        "taxRate": "",
        "vip": "5",
        "itaxRate": null,
        "taxCode": "1000000000000000000",
        "taxCodeTitle": "货物",
        "iTitle": "*货物*货物",
        "children": [
            {
                "id": "2",
                "linkid": "1",
                "code": "101",
                "paCode": "1",
                "yn": "Y",
                "title": "日用杂品",
                "alias": "日用杂品",
                "about": null,
                "kws": null,
                "taxName": "日用杂品",
                "taxRate": "",
                "vip": "5",
                "itaxRate": null,
                "taxCode": "1606051204",
                "taxCodeTitle": "日用杂品",
                "iTitle": "日用杂品",
                "children": [
                    {
                        "id": "4",
                        "linkid": "3",
                        "code": "10101",
                        "paCode": "101",
                        "yn": "Y",
                        "title": "清洁清扫类工具及其已加工材料编码",
                        "alias": "清洁清扫类工具及其已加工材料编码",
                        "about": "",
                        "kws": null,
                        "taxName": "清洁清扫类工具及其已加工材料编码",
                        "taxRate": "",
                        "vip": "5",
                        "itaxRate": null,
                        "taxCode": "1060512040000000000",
                        "taxCodeTitle": "清洁清扫类工具及其已加工材料编码",
                        "iTitle": "清洁清扫类工具及其已加工材料编码",
                        "children": []
                    },
                ]
            },
            {
                "id": "2",
                "linkid": "1",
                "code": "101",
                "paCode": "1",
                "yn": "Y",
                "title": "农、林、牧、渔业类产品",
                "alias": "农林牧渔",
                "about": null,
                "kws": null,
                "taxName": "农产品",
                "taxRate": "",
                "vip": "5",
                "itaxRate": null,
                "taxCode": "1010000000000000000",
                "taxCodeTitle": "农产品",
                "iTitle": "*农产品*农、林、牧、渔业类产品",
                "children": [
                    {
                        "id": "3",
                        "linkid": "2",
                        "code": "10101",
                        "paCode": "101",
                        "yn": "Y",
                        "title": "农业产品",
                        "alias": "农业产品",
                        "about": null,
                        "kws": null,
                        "taxName": "农业产品",
                        "taxRate": "",
                        "vip": "5",
                        "itaxRate": null,
                        "taxCode": "1010100000000000000",
                        "taxCodeTitle": "农业产品",
                        "iTitle": "*农业产品*农业产品",
                        "children": [
                            {
                                "id": "4",
                                "linkid": "3",
                                "code": "1010101",
                                "paCode": "10101",
                                "yn": "Y",
                                "title": "谷物",
                                "alias": "谷物",
                                "about": "包括稻谷、小麦、玉米、谷子、高粱、大麦、燕麦、黑麦、荞麦、其他谷物，不包括种用谷物（详见101011901）。",
                                "kws": null,
                                "taxName": "谷物",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1010101000000000000",
                                "taxCodeTitle": "谷物",
                                "iTitle": "*谷物*谷物",
                                "children": [
                                    {
                                        "id": "5",
                                        "linkid": "4",
                                        "code": "101010101",
                                        "paCode": "1010101",
                                        "yn": "N",
                                        "title": "稻谷",
                                        "alias": "稻谷",
                                        "about": "包括早籼稻、晚籼稻、中籼稻、粳稻、糯稻、其他稻谷。",
                                        "kws": "稻谷、早籼稻、晚籼稻、中籼稻、粳稻、糯稻",
                                        "taxName": "谷物",
                                        "taxRate": "9%",
                                        "vip": "5",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010101010000000000",
                                        "taxCodeTitle": "谷物",
                                        "iTitle": "*谷物*稻谷",
                                        "children": []
                                    },
                                    {
                                        "id": "6",
                                        "linkid": "4",
                                        "code": "101010102",
                                        "paCode": "1010101",
                                        "yn": "N",
                                        "title": "小麦",
                                        "alias": "小麦",
                                        "about": "包括硬质小麦、软质小麦、其他小麦。",
                                        "kws": "小麦、硬质小麦、软质小麦",
                                        "taxName": "谷物",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010101020000000000",
                                        "taxCodeTitle": "谷物",
                                        "iTitle": "*谷物*小麦",
                                        "children": []
                                    },
                                    {
                                        "id": "7",
                                        "linkid": "4",
                                        "code": "101010103",
                                        "paCode": "1010101",
                                        "yn": "N",
                                        "title": "玉米",
                                        "alias": "玉米",
                                        "about": "包括白玉米、黄玉米、糯玉米、甜玉米、其他玉米。",
                                        "kws": "玉米、白玉米、黄玉米、糯玉米、甜玉米",
                                        "taxName": "谷物",
                                        "taxRate": "9%",
                                        "vip": "5",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010101030000000000",
                                        "taxCodeTitle": "谷物",
                                        "iTitle": "*谷物*玉米",
                                        "children": []
                                    },
                                    {
                                        "id": "8",
                                        "linkid": "4",
                                        "code": "101010104",
                                        "paCode": "1010101",
                                        "yn": "N",
                                        "title": "谷子",
                                        "alias": "谷子",
                                        "about": "包括硬谷子、糯谷子、其他谷子。",
                                        "kws": "谷子、硬谷子、糯谷子",
                                        "taxName": "谷物",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010101040000000000",
                                        "taxCodeTitle": "谷物",
                                        "iTitle": "*谷物*谷子",
                                        "children": []
                                    },
                                    {
                                        "id": "9",
                                        "linkid": "4",
                                        "code": "101010105",
                                        "paCode": "1010101",
                                        "yn": "N",
                                        "title": "高粱",
                                        "alias": "高粱",
                                        "about": "包括红粒高粱、白粒高粱、糯高粱、其他高粱。",
                                        "kws": "高粱、红粒高粱、白粒高粱、糯高粱",
                                        "taxName": "谷物",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010101050000000000",
                                        "taxCodeTitle": "谷物",
                                        "iTitle": "*谷物*高粱",
                                        "children": []
                                    },
                                    {
                                        "id": "10",
                                        "linkid": "4",
                                        "code": "101010106",
                                        "paCode": "1010101",
                                        "yn": "N",
                                        "title": "大麦",
                                        "alias": "大麦",
                                        "about": "包括裸大麦、皮大麦。",
                                        "kws": "大麦、裸大麦、皮大麦",
                                        "taxName": "谷物",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010101060000000000",
                                        "taxCodeTitle": "谷物",
                                        "iTitle": "*谷物*大麦",
                                        "children": []
                                    },
                                    {
                                        "id": "11",
                                        "linkid": "4",
                                        "code": "101010107",
                                        "paCode": "1010101",
                                        "yn": "N",
                                        "title": "燕麦",
                                        "alias": "燕麦",
                                        "about": "包括裸燕麦、皮燕麦。",
                                        "kws": "裸燕麦、皮燕麦",
                                        "taxName": "谷物",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010101070000000000",
                                        "taxCodeTitle": "谷物",
                                        "iTitle": "*谷物*燕麦",
                                        "children": []
                                    },
                                    {
                                        "id": "12",
                                        "linkid": "4",
                                        "code": "101010108",
                                        "paCode": "1010101",
                                        "yn": "N",
                                        "title": "黑麦",
                                        "alias": "黑麦",
                                        "about": null,
                                        "kws": "黑麦",
                                        "taxName": "谷物",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010101080000000000",
                                        "taxCodeTitle": "谷物",
                                        "iTitle": "*谷物*黑麦",
                                        "children": []
                                    },
                                    {
                                        "id": "13",
                                        "linkid": "4",
                                        "code": "101010109",
                                        "paCode": "1010101",
                                        "yn": "N",
                                        "title": "荞麦",
                                        "alias": "荞麦",
                                        "about": "包括甜荞麦、苦荞麦。",
                                        "kws": "荞麦、甜荞麦、苦荞麦",
                                        "taxName": "谷物",
                                        "taxRate": "9%",
                                        "vip": "5",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010101090000000000",
                                        "taxCodeTitle": "谷物",
                                        "iTitle": "*谷物*荞麦",
                                        "children": []
                                    },
                                    {
                                        "id": "14",
                                        "linkid": "4",
                                        "code": "101010199",
                                        "paCode": "1010101",
                                        "yn": "N",
                                        "title": "其他谷物",
                                        "alias": "其他谷物",
                                        "about": "包括糜子（硬糜子、糯糜子）、紫米、薏苡等。",
                                        "kws": "糜子、硬糜子、糯糜子、紫米、薏苡",
                                        "taxName": "谷物",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010101990000000000",
                                        "taxCodeTitle": "谷物",
                                        "iTitle": "*谷物*其他谷物",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "15",
                                "linkid": "3",
                                "code": "1010102",
                                "paCode": "10101",
                                "yn": "Y",
                                "title": "薯类",
                                "alias": "薯类",
                                "about": "包括马铃薯、木薯、甘薯、其他薯类，不包括种用薯类（详见101011902）。",
                                "kws": null,
                                "taxName": "薯类",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1010102000000000000",
                                "taxCodeTitle": "薯类",
                                "iTitle": "*薯类*薯类",
                                "children": [
                                    {
                                        "id": "16",
                                        "linkid": "15",
                                        "code": "101010201",
                                        "paCode": "1010102",
                                        "yn": "N",
                                        "title": "马铃薯",
                                        "alias": "马铃薯",
                                        "about": "又称土豆、山药蛋。",
                                        "kws": "马铃薯、土豆、山药蛋",
                                        "taxName": "薯类",
                                        "taxRate": "9%",
                                        "vip": "5",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010102010000000000",
                                        "taxCodeTitle": "薯类",
                                        "iTitle": "*薯类*马铃薯",
                                        "children": []
                                    },
                                    {
                                        "id": "17",
                                        "linkid": "15",
                                        "code": "101010202",
                                        "paCode": "1010102",
                                        "yn": "N",
                                        "title": "木薯",
                                        "alias": "木薯",
                                        "about": "包括鲜木薯、木薯干、其他木薯。",
                                        "kws": "木薯、鲜木薯、木薯干",
                                        "taxName": "薯类",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010102020000000000",
                                        "taxCodeTitle": "薯类",
                                        "iTitle": "*薯类*木薯",
                                        "children": []
                                    },
                                    {
                                        "id": "18",
                                        "linkid": "15",
                                        "code": "101010203",
                                        "paCode": "1010102",
                                        "yn": "N",
                                        "title": "甘薯",
                                        "alias": "甘薯",
                                        "about": "又称红薯、白薯、地瓜、番薯、包括甘薯干、其他鲜甘薯。",
                                        "kws": "甘薯、红薯、白薯、地瓜、番薯、甘薯干",
                                        "taxName": "薯类",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010102030000000000",
                                        "taxCodeTitle": "薯类",
                                        "iTitle": "*薯类*甘薯",
                                        "children": []
                                    },
                                    {
                                        "id": "19",
                                        "linkid": "15",
                                        "code": "101010299",
                                        "paCode": "1010102",
                                        "yn": "N",
                                        "title": "其他薯类",
                                        "alias": "其他薯类",
                                        "about": "指其他未列明薯类。",
                                        "kws": null,
                                        "taxName": "薯类",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010102990000000000",
                                        "taxCodeTitle": "薯类",
                                        "iTitle": "*薯类*其他薯类",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "20",
                                "linkid": "3",
                                "code": "1010103",
                                "paCode": "10101",
                                "yn": "Y",
                                "title": "油料作物",
                                "alias": "油料作物",
                                "about": "包括花生、油菜籽、芝麻、其他油料，不包括种用油料（详见101011903）。",
                                "kws": null,
                                "taxName": "油料",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1010103000000000000",
                                "taxCodeTitle": "油料",
                                "iTitle": "*油料*油料作物",
                                "children": [
                                    {
                                        "id": "21",
                                        "linkid": "20",
                                        "code": "101010301",
                                        "paCode": "1010103",
                                        "yn": "N",
                                        "title": "花生",
                                        "alias": "花生",
                                        "about": "包括带壳花生、花生仁。",
                                        "kws": "花生、带壳花生、花生仁",
                                        "taxName": "油料",
                                        "taxRate": "9%",
                                        "vip": "5",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010103010000000000",
                                        "taxCodeTitle": "油料",
                                        "iTitle": "*油料*花生",
                                        "children": []
                                    },
                                    {
                                        "id": "22",
                                        "linkid": "20",
                                        "code": "101010302",
                                        "paCode": "1010103",
                                        "yn": "N",
                                        "title": "油菜籽",
                                        "alias": "油菜籽",
                                        "about": "包括双低油菜籽（指低硫苷、低芥酸油菜籽）、其他油菜籽。",
                                        "kws": "油菜籽、双低油菜籽、低硫苷油菜籽、低芥酸油菜籽",
                                        "taxName": "油料",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010103020000000000",
                                        "taxCodeTitle": "油料",
                                        "iTitle": "*油料*油菜籽",
                                        "children": []
                                    },
                                    {
                                        "id": "23",
                                        "linkid": "20",
                                        "code": "101010303",
                                        "paCode": "1010103",
                                        "yn": "N",
                                        "title": "芝麻",
                                        "alias": "芝麻",
                                        "about": "包括白芝麻、黑芝麻、黄芝麻。",
                                        "kws": "芝麻、黑芝麻、黄芝麻",
                                        "taxName": "油料",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010103030000000000",
                                        "taxCodeTitle": "油料",
                                        "iTitle": "*油料*芝麻",
                                        "children": []
                                    },
                                    {
                                        "id": "24",
                                        "linkid": "20",
                                        "code": "101010399",
                                        "paCode": "1010103",
                                        "yn": "N",
                                        "title": "其他油料",
                                        "alias": "其他油料",
                                        "about": "其他含油子仁及果实，如胡麻籽、棉籽、蓖麻籽、芥子、红花籽、油棕果及油棕仁、罂粟子、油橄榄果、油茶籽（油料）等。",
                                        "kws": "含油子仁、含油果实、胡麻籽、棉籽、蓖麻籽、芥子、红花籽、油棕果、油棕仁、罂粟子、油橄榄果、油茶籽",
                                        "taxName": "油料",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010103990000000000",
                                        "taxCodeTitle": "油料",
                                        "iTitle": "*油料*其他油料",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "25",
                                "linkid": "3",
                                "code": "1010104",
                                "paCode": "10101",
                                "yn": "Y",
                                "title": "干豆类",
                                "alias": "干豆类",
                                "about": "指脱荚的干豆；带荚的鲜豆列入蔬菜中。包括大豆、绿豆、其他杂豆、但不包括种用豆类（详见101011904）。",
                                "kws": null,
                                "taxName": "干豆",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1010104000000000000",
                                "taxCodeTitle": "干豆",
                                "iTitle": "*干豆*干豆类",
                                "children": [
                                    {
                                        "id": "26",
                                        "linkid": "25",
                                        "code": "101010401",
                                        "paCode": "1010104",
                                        "yn": "N",
                                        "title": "大豆",
                                        "alias": "大豆",
                                        "about": "包括黄大豆、黑大豆、青大豆、褐红大豆、双青豆、青仁乌豆、小黑豆、其他大豆。",
                                        "kws": "大豆、黄大豆、黑大豆、青大豆、褐红大豆、双青豆、青仁乌豆、小黑豆",
                                        "taxName": "干豆",
                                        "taxRate": "9%",
                                        "vip": "5",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010104010000000000",
                                        "taxCodeTitle": "干豆",
                                        "iTitle": "*干豆*大豆",
                                        "children": []
                                    },
                                    {
                                        "id": "27",
                                        "linkid": "25",
                                        "code": "101010402",
                                        "paCode": "1010104",
                                        "yn": "N",
                                        "title": "绿豆",
                                        "alias": "绿豆",
                                        "about": "包括明绿豆、毛绿豆。",
                                        "kws": "绿豆、明绿豆、毛绿豆",
                                        "taxName": "干豆",
                                        "taxRate": "9%",
                                        "vip": "5",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010104020000000000",
                                        "taxCodeTitle": "干豆",
                                        "iTitle": "*干豆*绿豆",
                                        "children": []
                                    },
                                    {
                                        "id": "28",
                                        "linkid": "25",
                                        "code": "101010499",
                                        "paCode": "1010104",
                                        "yn": "N",
                                        "title": "其他杂豆",
                                        "alias": "其他杂豆",
                                        "about": "其他杂豆、包括小豆、干豌豆、小扁豆、干蚕豆、芸豆、饭豆、干豇豆、鹰嘴豆、其他杂豆，但不包括种用其他杂豆（详见101011904）。",
                                        "kws": "小豆、干豌豆、小扁豆、干蚕豆、芸豆、饭豆、干豇豆、鹰嘴豆",
                                        "taxName": "干豆",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010104990000000000",
                                        "taxCodeTitle": "干豆",
                                        "iTitle": "*干豆*其他杂豆",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "29",
                                "linkid": "3",
                                "code": "1010105",
                                "paCode": "10101",
                                "yn": "N",
                                "title": "棉花",
                                "alias": "棉花",
                                "about": "不论是否轧过、具体包括籽棉、皮棉（细绒棉皮棉、长绒棉皮棉）、其他棉花。",
                                "kws": "棉花、籽棉、皮棉、细绒棉皮棉、长绒棉皮棉",
                                "taxName": "棉花",
                                "taxRate": "9%",
                                "vip": "7",
                                "itaxRate": "0.09",
                                "taxCode": "1010105000000000000",
                                "taxCodeTitle": "棉花",
                                "iTitle": "*棉花*棉花",
                                "children": []
                            },
                            {
                                "id": "30",
                                "linkid": "3",
                                "code": "1010106",
                                "paCode": "10101",
                                "yn": "N",
                                "title": "生麻",
                                "alias": "生麻",
                                "about": "包括生亚麻、生苎麻、生黄红麻、生线麻、生苘麻、生大麻、生剑麻、其他生麻。",
                                "kws": "生麻、生亚麻、生苎麻、生黄红麻、生线麻、生苘麻、生大麻、生剑麻",
                                "taxName": "生麻",
                                "taxRate": "9%",
                                "vip": "7",
                                "itaxRate": "0.09",
                                "taxCode": "1010106000000000000",
                                "taxCodeTitle": "生麻",
                                "iTitle": "*生麻*生麻",
                                "children": []
                            },
                            {
                                "id": "31",
                                "linkid": "3",
                                "code": "1010107",
                                "paCode": "10101",
                                "yn": "Y",
                                "title": "糖料",
                                "alias": "糖料",
                                "about": "包括甘蔗、甜菜、其他糖料。",
                                "kws": null,
                                "taxName": "糖料",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1010107000000000000",
                                "taxCodeTitle": "糖料",
                                "iTitle": "*糖料*糖料",
                                "children": [
                                    {
                                        "id": "32",
                                        "linkid": "31",
                                        "code": "101010701",
                                        "paCode": "1010107",
                                        "yn": "N",
                                        "title": "甘蔗",
                                        "alias": "甘蔗",
                                        "about": null,
                                        "kws": "甘蔗",
                                        "taxName": "糖料",
                                        "taxRate": "9%",
                                        "vip": "5",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010107010000000000",
                                        "taxCodeTitle": "糖料",
                                        "iTitle": "*糖料*甘蔗",
                                        "children": []
                                    },
                                    {
                                        "id": "33",
                                        "linkid": "31",
                                        "code": "101010702",
                                        "paCode": "1010107",
                                        "yn": "N",
                                        "title": "甜菜",
                                        "alias": "甜菜",
                                        "about": null,
                                        "kws": "甜菜",
                                        "taxName": "糖料",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010107020000000000",
                                        "taxCodeTitle": "糖料",
                                        "iTitle": "*糖料*甜菜",
                                        "children": []
                                    },
                                    {
                                        "id": "34",
                                        "linkid": "31",
                                        "code": "101010799",
                                        "paCode": "1010107",
                                        "yn": "N",
                                        "title": "其他糖料",
                                        "alias": "其他糖料",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "糖料",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010107990000000000",
                                        "taxCodeTitle": "糖料",
                                        "iTitle": "*糖料*其他糖料",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "35",
                                "linkid": "3",
                                "code": "1010108",
                                "paCode": "10101",
                                "yn": "Y",
                                "title": "未加工烟草",
                                "alias": "未加工烟草",
                                "about": "指未去梗的烟草，包括未去梗烤烟叶、未去梗晒烟叶、未去梗晾烟叶、未去梗白肋烟、其他未加工烟草。",
                                "kws": null,
                                "taxName": "烟草",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1010108000000000000",
                                "taxCodeTitle": "烟草",
                                "iTitle": "*烟草*未加工烟草",
                                "children": [
                                    {
                                        "id": "36",
                                        "linkid": "35",
                                        "code": "101010801",
                                        "paCode": "1010108",
                                        "yn": "N",
                                        "title": "未去梗烤烟叶",
                                        "alias": "未去梗烤烟叶",
                                        "about": "指初烤未去梗烤烟叶，不包括复烤烟叶（详见1030401）。",
                                        "kws": "未去梗烤烟叶",
                                        "taxName": "烟草",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010108010000000000",
                                        "taxCodeTitle": "烟草",
                                        "iTitle": "*烟草*未去梗烤烟叶",
                                        "children": []
                                    },
                                    {
                                        "id": "37",
                                        "linkid": "35",
                                        "code": "101010899",
                                        "paCode": "1010108",
                                        "yn": "N",
                                        "title": "其他未加工烟草",
                                        "alias": "其他未加工烟草",
                                        "about": "指其他未加工烟草，包括未去梗晒烟叶、未去梗晾烟叶、未去梗白肋烟、其他未加工烟草。",
                                        "kws": "未去梗晒烟叶、未去梗晾烟叶、未去梗白肋烟",
                                        "taxName": "烟草",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010108990000000000",
                                        "taxCodeTitle": "烟草",
                                        "iTitle": "*烟草*其他未加工烟草",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "38",
                                "linkid": "3",
                                "code": "1010109",
                                "paCode": "10101",
                                "yn": "Y",
                                "title": "饲料作物",
                                "alias": "饲料作物",
                                "about": "包括苜蓿、青饲料、饲料牧草、其他饲料作物，不包括种用饲料作物（详见101011905）。",
                                "kws": null,
                                "taxName": "饲料作物",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1010109000000000000",
                                "taxCodeTitle": "饲料作物",
                                "iTitle": "*饲料作物*饲料作物",
                                "children": [
                                    {
                                        "id": "39",
                                        "linkid": "38",
                                        "code": "101010901",
                                        "paCode": "1010109",
                                        "yn": "N",
                                        "title": "饲料牧草",
                                        "alias": "饲料牧草",
                                        "about": "包括苜蓿干草、羊草、沙打旺、其他饲料牧草。",
                                        "kws": "饲料牧草、苜蓿干草、羊草、沙打旺",
                                        "taxName": "饲料作物",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010109010000000000",
                                        "taxCodeTitle": "饲料作物",
                                        "iTitle": "*饲料作物*饲料牧草",
                                        "children": []
                                    },
                                    {
                                        "id": "40",
                                        "linkid": "38",
                                        "code": "101010999",
                                        "paCode": "1010109",
                                        "yn": "N",
                                        "title": "其他饲料作物",
                                        "alias": "其他饲料作物",
                                        "about": "包括青饲料、其他饲料作物。",
                                        "kws": "苜蓿、青饲料",
                                        "taxName": "饲料作物",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010109990000000000",
                                        "taxCodeTitle": "饲料作物",
                                        "iTitle": "*饲料作物*其他饲料作物",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "41",
                                "linkid": "3",
                                "code": "1010110",
                                "paCode": "10101",
                                "yn": "N",
                                "title": "水生植物类",
                                "alias": "水生植物类",
                                "about": "包括芦苇、席草、苇子、莲子、蒲草、慈姑、其他水生植物类。",
                                "kws": "水生植物类、芦苇、席草、苇子、莲子、蒲草、慈姑",
                                "taxName": "水生植物",
                                "taxRate": "9%",
                                "vip": "7",
                                "itaxRate": "0.09",
                                "taxCode": "1010110000000000000",
                                "taxCodeTitle": "水生植物",
                                "iTitle": "*水生植物*水生植物类",
                                "children": []
                            },
                            {
                                "id": "42",
                                "linkid": "3",
                                "code": "1010111",
                                "paCode": "10101",
                                "yn": "Y",
                                "title": "农作物副产品",
                                "alias": "农作物副产品",
                                "about": "包括红黑瓜籽、园参籽、作物茎（秆、根）、其他农作物副产品。",
                                "kws": null,
                                "taxName": "农副产品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1010111000000000000",
                                "taxCodeTitle": "农副产品",
                                "iTitle": "*农副产品*农作物副产品",
                                "children": [
                                    {
                                        "id": "43",
                                        "linkid": "42",
                                        "code": "101011101",
                                        "paCode": "1010111",
                                        "yn": "N",
                                        "title": "作物茎、秆、根",
                                        "alias": "作物茎、秆、根",
                                        "about": "包括稻草、麦秸、谷壳、谷子秸、玉米秸、高粱秸、薯藤、大豆秸、花生蔓、油菜籽秆、芝麻秆、向日葵秆、棉花秆、麻秆、烟秆、其他作物茎、杆、根。",
                                        "kws": "稻草、麦秸、谷壳、谷子秸、玉米秸、高粱秸、薯藤、大豆秸、花生蔓、油菜籽秆、芝麻秆、向日葵秆、棉花秆、麻秆、烟秆",
                                        "taxName": "农副产品",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010111010000000000",
                                        "taxCodeTitle": "农副产品",
                                        "iTitle": "*农副产品*作物茎、秆、根",
                                        "children": []
                                    },
                                    {
                                        "id": "44",
                                        "linkid": "42",
                                        "code": "101011199",
                                        "paCode": "1010111",
                                        "yn": "N",
                                        "title": "其他农作物副产品",
                                        "alias": "其他农作物副产品",
                                        "about": "包括红黑瓜籽、园参籽等。",
                                        "kws": "红黑瓜籽、园参籽",
                                        "taxName": "农副产品",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010111990000000000",
                                        "taxCodeTitle": "农副产品",
                                        "iTitle": "*农副产品*其他农作物副产品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "45",
                                "linkid": "3",
                                "code": "1010112",
                                "paCode": "10101",
                                "yn": "Y",
                                "title": "蔬菜及食用菌",
                                "alias": "蔬菜及食用菌",
                                "about": "包括萝卜等根菜类蔬菜、山药等薯芋类蔬菜、葱蒜类蔬菜、白菜类蔬菜、芥菜类蔬菜、甘蓝类蔬菜、芹菜叶菜类蔬菜、瓜类蔬菜、番茄等茄果类蔬菜、菜豆等豆类蔬菜、莲藕等水生蔬菜、竹笋等多年生及杂类蔬菜、香菇等食用菌、绿豆芽等芽苗菜、其他蔬菜。不包括蔬菜籽（详见01011906）。",
                                "kws": "蔬菜、食用菌、萝卜等根菜类蔬菜、山药、薯芋类蔬菜、葱蒜类蔬菜、白菜类蔬菜、芥菜类蔬菜、甘蓝类蔬菜、芹菜叶菜类蔬菜、瓜类蔬菜、番茄、茄果类蔬菜、菜豆、豆类蔬菜、莲藕、水生蔬菜、竹笋、多年生及杂类蔬菜、香菇、食用菌、绿豆芽、芽苗菜",
                                "taxName": "蔬菜及食用菌",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1010112000000000000",
                                "taxCodeTitle": "蔬菜及食用菌",
                                "iTitle": "*蔬菜及食用菌*蔬菜及食用菌",
                                "children": [
                                    {
                                        "id": "46",
                                        "linkid": "45",
                                        "code": "101011201",
                                        "paCode": "1010112",
                                        "yn": "N",
                                        "title": "萝卜等根菜类蔬菜",
                                        "alias": "萝卜等根菜类蔬菜",
                                        "about": "包括萝卜（别名：葖、芦菔、莱菔）、胡萝卜（别名：红萝卜、黄萝卜、丁香萝卜、药性萝卜、番萝卜）、芜菁（别名：蔓菁、圆根、盘菜）、芜菁甘蓝（别名：洋蔓菁、洋疙瘩、洋大头菜）、根菾菜（别名：红菜头、紫菜头）、美洲防风（别名：欧防风芹菜萝卜、蒲芹萝卜）、牛蒡（别名：东洋萝卜、蝙蝠刺、大力子）、根芹菜（别名：根洋芹菜、球根塘蒿）、婆罗门参（别名：西洋牛蒡、蒜叶婆罗门参）、山葵）、黑婆罗门参（别名：菊牛蒡、鸦葱）。",
                                        "kws": "根菜类蔬菜、萝卜、葖、芦菔、莱菔、胡萝卜、红萝卜、黄萝卜、丁香萝卜、药性萝卜、番萝卜、芜菁、蔓菁、圆根、盘菜、芜菁甘蓝、洋蔓菁、洋疙瘩、洋大头菜、根菾菜、红菜头、紫菜头、美洲防风、欧防风芹菜萝卜、蒲芹萝卜、牛蒡、东洋萝卜、蝙蝠刺、大力子、根芹菜、根洋芹菜、球根塘蒿、婆罗门参、西洋牛蒡、蒜叶婆罗门参、山葵、黑婆罗门参、菊牛蒡、鸦葱",
                                        "taxName": "蔬菜",
                                        "taxRate": "9%",
                                        "vip": "5",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010112010000000000",
                                        "taxCodeTitle": "蔬菜",
                                        "iTitle": "*蔬菜*萝卜等根菜类蔬菜",
                                        "children": []
                                    },
                                    {
                                        "id": "47",
                                        "linkid": "45",
                                        "code": "101011202",
                                        "paCode": "1010112",
                                        "yn": "N",
                                        "title": "山药等薯芋类蔬菜",
                                        "alias": "山药等薯芋类蔬菜",
                                        "about": "包括姜（别名：生姜、黄姜）、芋（别名：芋头、芋艿、毛芋）、魔芋（别名：磨芋、蒟蒻）、山药（别名：薯蓣、白苕、脚板苕、山薯、大薯、佛掌薯）、豆薯（别名：地瓜、凉薯、沙葛、新罗葛）、葛、菊芋（别名：洋姜、鬼子姜）、菜用土圞儿（别名：香芋、美洲土圞儿）、蕉芋（别名：蕉藕、姜芋、食用美人蕉、食用莲蕉）、草石蚕（别名：螺丝菜、宝塔菜、甘露儿、地蚕）。不包括马铃薯（详见101010201）、甘薯（详见101010203）。",
                                        "kws": "薯芋类蔬菜、姜、生姜、黄姜、芋、芋头、芋艿、毛芋、魔芋、磨芋、蒟蒻、山药、薯蓣、白苕、脚板苕、山薯、大薯、佛掌薯、豆薯、地瓜、凉薯、沙葛、新罗葛、葛、菊芋、洋姜、鬼子姜、菜用土圞儿、香芋、美洲土圞儿、蕉芋、蕉藕、姜芋、食用美人蕉、食用莲蕉、草石蚕、螺丝菜、宝塔菜、甘露儿、地蚕",
                                        "taxName": "蔬菜",
                                        "taxRate": "9%",
                                        "vip": "5",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010112020000000000",
                                        "taxCodeTitle": "蔬菜",
                                        "iTitle": "*蔬菜*山药等薯芋类蔬菜",
                                        "children": []
                                    },
                                    {
                                        "id": "48",
                                        "linkid": "45",
                                        "code": "101011203",
                                        "paCode": "1010112",
                                        "yn": "N",
                                        "title": "葱蒜类蔬菜",
                                        "alias": "葱蒜类蔬菜",
                                        "about": "包括韭（别名：草钟乳、起阳草、懒人菜、韭黄）、大葱（别名：木葱、汉葱）、洋葱（别名：葱头、圆葱）、大蒜（别名：胡蒜、蒜）、蒜薹（别名：蒜苔）、蒜苗（别名：蒜黄、青蒜）、分葱（别名：四季葱、菜葱、冬葱）、胡葱（别名：蒜头葱、瓣子葱、火葱、肉葱）、细香葱（别名：四季葱、香葱、蝦夷葱）、韭葱（别名：扁葱、扁叶葱、洋蒜苗）、楼葱（别名：龙爪葱、龙角葱）、蕹（别名：藠头、藠子、莱芝）。",
                                        "kws": "葱蒜类蔬菜、韭菜、草钟乳、起阳草、懒人菜、韭黄、大葱、木葱、汉葱、洋葱、葱头、圆葱、大蒜、胡蒜、蒜、蒜薹、蒜苔、蒜苗、蒜黄、青蒜、分葱、菜葱、冬葱、胡葱、蒜头葱、瓣子葱、火葱、肉葱、细香葱、四季葱、香葱、蝦夷葱、韭葱、扁葱、扁叶葱、洋蒜苗、楼葱、龙爪葱、龙角葱、蕹、藠头、藠子、莱芝",
                                        "taxName": "蔬菜",
                                        "taxRate": "9%",
                                        "vip": "5",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010112030000000000",
                                        "taxCodeTitle": "蔬菜",
                                        "iTitle": "*蔬菜*葱蒜类蔬菜",
                                        "children": []
                                    },
                                    {
                                        "id": "49",
                                        "linkid": "45",
                                        "code": "101011204",
                                        "paCode": "1010112",
                                        "yn": "N",
                                        "title": "白菜类蔬菜",
                                        "alias": "白菜类蔬菜",
                                        "about": "包括大白菜（别名：结球白菜、黄芽菜、包心白菜）、普通白菜（别名：白菜、小白菜、青菜、油菜）、乌塌菜（别名：榻菜、塌棵菜、榻地菘、黑菜）、菜薹（别名：菜心、绿菜薹、菜尖）、薹菜、紫菜薹（别名：红菜薹）。",
                                        "kws": "白菜类蔬菜、大白菜、结球白菜、黄芽菜、包心白菜、普通白菜、白菜、小白菜、青菜、油菜、乌塌菜、榻菜、塌棵菜、榻地菘、黑菜、菜薹、菜心、绿菜薹、菜尖、薹菜、紫菜薹、红菜薹",
                                        "taxName": "蔬菜",
                                        "taxRate": "9%",
                                        "vip": "5",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010112040000000000",
                                        "taxCodeTitle": "蔬菜",
                                        "iTitle": "*蔬菜*白菜类蔬菜",
                                        "children": []
                                    },
                                    {
                                        "id": "50",
                                        "linkid": "45",
                                        "code": "101011205",
                                        "paCode": "1010112",
                                        "yn": "N",
                                        "title": "芥菜类蔬菜",
                                        "alias": "芥菜类蔬菜",
                                        "about": "包括茎芥（别名：茎瘤芥、青菜头、菜头、包包菜、羊角菜、菱角菜、抱子芥、儿菜、娃娃菜、笋子芥、棒菜）、叶芥（别名：青菜、苦菜、春菜、辣菜、雪里蕻）、根芥（别名：辣疙瘩、冲菜、芥头、大头菜、疙瘩菜）、薹芥。",
                                        "kws": "茎芥、茎瘤芥、青菜头、菜头、包包菜、羊角菜、菱角菜、抱子芥、儿菜、娃娃菜、笋子芥、棒菜、叶芥、青菜、苦菜、春菜、辣菜、雪里蕻、根芥、辣疙瘩、冲菜、芥头、大头菜、疙瘩菜、薹芥",
                                        "taxName": "蔬菜",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010112050000000000",
                                        "taxCodeTitle": "蔬菜",
                                        "iTitle": "*蔬菜*芥菜类蔬菜",
                                        "children": []
                                    },
                                    {
                                        "id": "51",
                                        "linkid": "45",
                                        "code": "101011206",
                                        "paCode": "1010112",
                                        "yn": "N",
                                        "title": "甘蓝类蔬菜",
                                        "alias": "甘蓝类蔬菜",
                                        "about": "包括结球甘蓝（别名：洋白菜、卷心菜、包心菜、椰菜、莲花白、包包白、圆白菜、茴子白）、球茎甘蓝（别名：苤蓝、菘、玉蔓菁、芥蓝头、擘蓝）、花椰菜（别名：花菜、菜花）、青花菜（别名：木立花椰菜、意大利花椰菜、嫩茎花椰菜、绿菜花、西兰花）、芥蓝（别名：白花芥蓝）、抱子甘蓝（别名：芽甘蓝、子持甘蓝）、羽衣甘蓝（别名：绿叶甘蓝、菜用羽衣甘蓝、叶牡丹、花包菜）。",
                                        "kws": "甘蓝类蔬菜、结球甘蓝、洋白菜、卷心菜、包心菜、椰菜、莲花白、包包白、圆白菜、茴子白、球茎甘蓝、苤蓝、菘、玉蔓菁、芥蓝头、擘蓝、花椰菜、花菜、菜花、青花菜、木立花椰菜、意大利花椰菜、嫩茎花椰菜、绿菜花、西兰花、芥蓝、白花芥蓝、抱子甘蓝、芽甘蓝、子持甘蓝、羽衣甘蓝、绿叶甘蓝、菜用羽衣甘蓝、叶牡丹、花包菜",
                                        "taxName": "蔬菜",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010112060000000000",
                                        "taxCodeTitle": "蔬菜",
                                        "iTitle": "*蔬菜*甘蓝类蔬菜",
                                        "children": []
                                    },
                                    {
                                        "id": "52",
                                        "linkid": "45",
                                        "code": "101011207",
                                        "paCode": "1010112",
                                        "yn": "N",
                                        "title": "芹菜等叶菜类蔬菜",
                                        "alias": "芹菜等叶菜类蔬菜",
                                        "about": "包括菠菜（别名：菠稜菜、赤根菜、角菜、波斯草）、莴苣（别名：千金菜、莴笋、生菜、青笋、莴苣笋、莴菜、油麦菜、莜麦菜）、芹菜（别名：芹、药芹、苦堇、堇葵、堇菜、旱芹）、蕹菜（别名：空心菜、竹叶菜、通菜、藤菜、蓊菜）、苋菜（别名：米苋、赤苋、刺苋、青香苋、苋）、叶菾菜（别名：莙荙菜、牛皮菜、厚皮菜、光菜、叶甜菜）、菊苣（别名：欧洲菊苣、苞菜、吉康菜、法国莒荬菜）、冬寒菜（别名：冬苋菜、冬葵、葵菜、滑肠菜）、落葵（别名：木耳菜、软浆叶、软姜子、染浆叶、胭脂豆、豆腐菜、藤菜、紫果菜）、茼蒿（别名：蒿子秆、大叶茼蒿",
                                        "kws": "叶菜类蔬菜、菠菜、菠稜菜、赤根菜、角菜、波斯草、莴苣、千金菜、莴笋、生菜、青笋、莴苣笋、莴菜、油麦菜、莜麦菜、芹菜、芹、药芹、苦堇、堇葵、堇菜、旱芹、蕹菜、空心菜、竹叶菜、通菜、蓊菜、苋菜、米苋、赤苋、刺苋、青香苋、苋、叶菾菜、莙荙菜、牛皮菜、厚皮菜、光菜、叶甜菜、菊苣、欧洲菊苣、苞菜、吉康菜、法国莒荬菜、冬寒菜、冬苋菜、冬葵、葵菜、滑肠菜、落葵、木耳菜、软浆叶、软姜子、染浆叶、胭脂豆、豆腐菜、藤菜、紫果菜、茼蒿、蒿子秆、大叶茼蒿、蓬蒿、春菊、芫荽、香菜、胡荽、香荽、茴香、小茴香、香丝菜、结球茴香、鲜茎茴",
                                        "taxName": "蔬菜",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010112070000000000",
                                        "taxCodeTitle": "蔬菜",
                                        "iTitle": "*蔬菜*芹菜等叶菜类蔬菜",
                                        "children": []
                                    },
                                    {
                                        "id": "53",
                                        "linkid": "45",
                                        "code": "101011208",
                                        "paCode": "1010112",
                                        "yn": "N",
                                        "title": "瓜类蔬菜",
                                        "alias": "瓜类蔬菜",
                                        "about": "包括黄瓜（别名：王瓜、胡瓜）、冬瓜（别名：东瓜）、节瓜（别名：毛瓜）、南瓜（别名：中国南瓜、倭瓜、番瓜、饭瓜）、笋瓜（别名：印度南瓜、玉瓜、北瓜）、西葫芦（别名：美洲南瓜、蔓瓜、白瓜、香瓜）、越瓜（别名：白瓜、脆瓜、酥瓜、梢瓜）、菜瓜（别名：蛇甜瓜、老羊瓜、酱瓜）、丝瓜（别名：圆筒丝瓜、蛮瓜、水瓜、棱角丝瓜、胜瓜）、苦瓜（别名：凉瓜）、瓠瓜（别名：扁蒲、葫芦、蒲瓜、夜开花、瓠子）、佛手瓜（别名：洋丝瓜、合掌瓜、菜肴梨、瓦瓜、万年瓜、拳头瓜）、蛇瓜（别名：蛇豆、蛇丝瓜、长豆角）。",
                                        "kws": "瓜类蔬菜、黄瓜、王瓜、胡瓜、冬瓜、东瓜、节瓜、毛瓜、南瓜、中国南瓜、倭瓜、番瓜、饭瓜、笋瓜、印度南瓜、玉瓜、北瓜、西葫芦、美洲南瓜、蔓瓜、香瓜、越瓜、白瓜、脆瓜、酥瓜、梢瓜、菜瓜、蛇甜瓜、老羊瓜、酱瓜、丝瓜、圆筒丝瓜、蛮瓜、水瓜、棱角丝瓜、胜瓜、苦瓜、凉瓜、瓠瓜、扁蒲、葫芦、蒲瓜、夜开花、瓠子、佛手瓜、洋丝瓜、合掌瓜、菜肴梨、瓦瓜、万年瓜、拳头瓜、蛇瓜、蛇豆、蛇丝瓜、长豆角",
                                        "taxName": "蔬菜",
                                        "taxRate": "9%",
                                        "vip": "5",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010112080000000000",
                                        "taxCodeTitle": "蔬菜",
                                        "iTitle": "*蔬菜*瓜类蔬菜",
                                        "children": []
                                    },
                                    {
                                        "id": "54",
                                        "linkid": "45",
                                        "code": "101011209",
                                        "paCode": "1010112",
                                        "yn": "N",
                                        "title": "番茄等茄果类蔬菜",
                                        "alias": "番茄等茄果类蔬菜",
                                        "about": "包括番茄（别名：西红柿、番柿、柿子、洋柿子）、茄子（别名：落苏）、辣椒（别名：海椒、辣子、辣角、番椒）、青椒（别名：大椒、灯笼椒、柿子椒、彩色甜椒、甜椒）、酸浆（别名：红姑娘、洋姑娘、灯笼草、洛神珠）。",
                                        "kws": "茄果类蔬菜、番茄、西红柿、番柿、柿子、洋柿子、茄子、落苏、辣椒、海椒、辣子、辣角、番椒、青椒、大椒、灯笼椒、柿子椒、彩色甜椒、甜椒、酸浆、红姑娘、洋姑娘、灯笼草、洛神珠",
                                        "taxName": "蔬菜",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010112090000000000",
                                        "taxCodeTitle": "蔬菜",
                                        "iTitle": "*蔬菜*番茄等茄果类蔬菜",
                                        "children": []
                                    },
                                    {
                                        "id": "55",
                                        "linkid": "45",
                                        "code": "101011210",
                                        "paCode": "1010112",
                                        "yn": "N",
                                        "title": "菜豆等豆类蔬菜",
                                        "alias": "菜豆等豆类蔬菜",
                                        "about": "包括菜豆（别名：四季豆、芸豆、芸扁豆、豆角、刀豆、敏豆、玉豆、油豆）、长豇豆（别名：长豆角、豆角、带豆、裙带豆）、菜用大豆（别名：毛豆、枝豆）、豌豆（别名：青斑豆、麻豆、青小豆、荷兰豆、淮豆、留豆、金豆、麦豆、回回豆、甜豌豆）、蚕豆（别名：胡豆、佛豆、寒豆、罗汉豆）、扁豆（别名：峨眉豆、沿篱豆、眉豆、肉豆、龙爪豆）、莱豆（别名：金甲豆、科马豆、荷豆、玉豆、雪豆、洋扁豆、白豆、状元豆、棉豆、荷包豆）、刀豆（别名：大刀豆、关刀豆、洋刀豆）、多花菜豆（别名：红花菜豆、大白芸豆、大花芸豆、看花豆）、四棱豆（别名：",
                                        "kws": "豆类蔬菜、菜豆、四季豆、芸豆、芸扁豆、敏豆、油豆、长豇豆、长豆角、豆角、带豆、裙带豆、菜用大豆、毛豆、枝豆、豌豆、青斑豆、麻豆、青小豆、荷兰豆、淮豆、留豆、金豆、麦豆、回回豆、甜豌豆、蚕豆、胡豆、佛豆、寒豆、罗汉豆、扁豆、峨眉豆、沿篱豆、眉豆、肉豆、龙爪豆、莱豆、金甲豆、科马豆、荷豆、玉豆、雪豆、洋扁豆、白豆、状元豆、棉豆、荷包豆、刀豆、大刀豆、关刀豆、洋刀豆、多花菜豆、红花菜豆、大白芸豆、大花芸豆、看花豆、四棱豆、翼豆、翅豆、四角豆、杨桃豆、热带大豆、四稔豆、藜豆、黧豆、黎豆、猫猫豆、毛毛豆、毛胡豆、毛",
                                        "taxName": "蔬菜",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010112100000000000",
                                        "taxCodeTitle": "蔬菜",
                                        "iTitle": "*蔬菜*菜豆等豆类蔬菜",
                                        "children": []
                                    },
                                    {
                                        "id": "56",
                                        "linkid": "45",
                                        "code": "101011211",
                                        "paCode": "1010112",
                                        "yn": "N",
                                        "title": "莲藕等水生蔬菜",
                                        "alias": "莲藕等水生蔬菜",
                                        "about": "包括莲藕（别名：莲、藕、荷）、茭白（别名：茭瓜、茭笋、菰首）、慈姑（别名：剪刀草、燕尾草）、水芹（别名：刀芹、楚葵、蜀芹、紫堇、蕲）、荸荠（别名：马蹄、地栗、乌芋、凫茈）、菱（别名：菱角、龙角、水栗）、豆瓣菜（别名：西洋菜、水田芥、水蔊菜）、芡实（别名：鸡头米、鸡头、水底黄蜂）、莼菜（别名：马蹄草、水葵、水荷叶、湖菜、露葵）、蒲菜（别名：香蒲、甘蒲）、海带（别名：江白菜、昆布）、紫菜。",
                                        "kws": "水生蔬菜、莲藕、莲、藕、荷、茭白、茭瓜、茭笋、菰首、慈姑、剪刀草、燕尾草、水芹、刀芹、楚葵、蜀芹、紫堇、蕲、荸荠、马蹄、地栗、乌芋、凫茈、菱、菱角、龙角、水栗、豆瓣菜、西洋菜、水田芥、水蔊菜、芡实、鸡头米、鸡头、水底黄蜂、莼菜、马蹄草、水葵、水荷叶、湖菜、露葵、蒲菜、香蒲、甘蒲、海带、江白菜、昆布、紫菜",
                                        "taxName": "蔬菜",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010112110000000000",
                                        "taxCodeTitle": "蔬菜",
                                        "iTitle": "*蔬菜*莲藕等水生蔬菜",
                                        "children": []
                                    },
                                    {
                                        "id": "57",
                                        "linkid": "45",
                                        "code": "101011212",
                                        "paCode": "1010112",
                                        "yn": "N",
                                        "title": "竹笋等多年生及杂类蔬菜",
                                        "alias": "竹笋等多年生及杂类蔬菜",
                                        "about": "包括笋用竹（别名：竹笋）、芦笋（别名：石刁柏、龙须菜）、黄花菜（别名：萱草、金针菜）、百合（别名：夜合、中篷花）、香椿（别名：香椿树、红椿、椿花、椿甜树）、枸杞（别名：枸杞菜、枸杞头、枸杞芽）、蘘荷（别名：阳霍、野姜、蘘草、茗荷、苴蓴）、菜蓟（别名：朝鲜蓟、洋蓟、荷兰百合、法国百合）、辣根（别名：西洋山萮菜、山葵萝卜）、食用大黄（别名：原叶大黄、圆叶大黄）、黄秋葵（别名：秋葵、羊角豆）、桔梗（别名：地参、四叶菜、绿花根、铃铛花、沙油菜、梗草、道拉基）、蕨（别名：蕨菜、蕨苔、龙头菜、蕨儿菜鹿蕨菜）、乾苔（别",
                                        "kws": "笋用竹、竹笋、芦笋、石刁柏、龙须菜、黄花菜、萱草、金针菜、百合、夜合、中篷花、香椿、香椿树、红椿、椿花、椿甜树、枸杞、枸杞菜、枸杞头、枸杞芽、蘘荷、阳霍、野姜、蘘草、茗荷、苴蓴、菜蓟、朝鲜蓟、洋蓟、荷兰百合、法国百合、辣根、西洋山萮菜、山葵萝卜、食用大黄、原叶大黄、圆叶大黄、黄秋葵、秋葵、羊角豆、桔梗、地参、四叶菜、绿花根、铃铛花、沙油菜、梗草、道拉基、蕨、蕨菜、蕨苔、龙头菜、蕨儿菜鹿蕨菜、乾苔、发菜、头发菜、石发、蒌蒿、芦蒿、水蒿、香艾蒿、小艾、水艾、薇菜、野豌豆、大巢菜、斑矛架、野苕子、车前草、车轮菜",
                                        "taxName": "蔬菜",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010112120000000000",
                                        "taxCodeTitle": "蔬菜",
                                        "iTitle": "*蔬菜*竹笋等多年生及杂类蔬菜",
                                        "children": []
                                    },
                                    {
                                        "id": "58",
                                        "linkid": "45",
                                        "code": "101011213",
                                        "paCode": "1010112",
                                        "yn": "N",
                                        "title": "香菇等食用菌",
                                        "alias": "香菇等食用菌",
                                        "about": "包括香菇（别名：香蕈、冬菇、花菇）、双孢蘑菇（别名：蘑菇、白蘑菇、双孢菇、洋菇、褐蘑菇、棕色蘑菇）、糙皮侧耳（别名：平菇、北风菌、青蘑、桐子菌）、草菇（别名：兰花菇、美味包脚菇、秆菇、麻菇、中国蘑菇）、金针菇（别名：毛柄金钱菇、冬菇、朴菇、朴菰）、黑木耳（别名：木耳、光木耳、云耳）、银耳（别名：白木耳、雪耳）、猴头菇（别名：猴头蘑、刺猬菌）、毛头鬼伞（别名：鸡腿蘑、鸡腿菇）、姬松茸（别名：巴西蘑菇、巴氏蘑菇）、茶薪菇（别名：杨树菇、柱状田头菇、柳环菌、茶树菇）、真姬菇（别名：玉蕈、斑玉蕈、蟹味菇、胶玉蘑、",
                                        "kws": "食用菌、香菇、香蕈、花菇、双孢蘑菇、蘑菇、白蘑菇、双孢菇、洋菇、褐蘑菇、棕色蘑菇、糙皮侧耳、平菇、北风菌、青蘑、桐子菌、草菇、兰花菇、美味包脚菇、秆菇、麻菇、中国蘑菇、金针菇、毛柄金钱菇、冬菇、朴菇、朴菰、黑木耳、木耳、光木耳、云耳、银耳、白木耳、雪耳、猴头菇、猴头蘑、刺猬菌、毛头鬼伞、鸡腿蘑、鸡腿菇、姬松茸、巴西蘑菇、巴氏蘑菇、茶薪菇、杨树菇、柱状田头菇、柳环菌、茶树菇、真姬菇、玉蕈、斑玉蕈、蟹味菇、胶玉蘑、鸿喜菇、海鲜菇、灰树花、贝叶多孔菌、云蕈、栗蘑、舞茸、莲花菌、千佛菌、滑菇、珍珠菇、光帽鳞伞、滑",
                                        "taxName": "食用菌",
                                        "taxRate": "9%",
                                        "vip": "5",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010112130000000000",
                                        "taxCodeTitle": "食用菌",
                                        "iTitle": "*食用菌*香菇等食用菌",
                                        "children": []
                                    },
                                    {
                                        "id": "59",
                                        "linkid": "45",
                                        "code": "101011214",
                                        "paCode": "1010112",
                                        "yn": "N",
                                        "title": "绿豆芽等芽苗菜",
                                        "alias": "绿豆芽等芽苗菜",
                                        "about": "包括绿豆芽（别名：绿豆芽幼芽）、黄豆芽（别名：黄豆幼芽）、黑豆芽（别名：黑豆幼芽）、青豆芽（别名：青豆幼芽）、红豆芽（别名：红豆幼芽）、蚕豆芽（别名：蚕豆幼芽）、红小豆苗（别名：红小豆幼芽）、豌豆苗（别名：豌豆幼芽）、花生芽（别名：花生幼芽）、苜蓿芽（别名：苜蓿幼芽或幼苗）、小扁豆芽（别名：小扁豆幼芽或幼苗）、萝卜芽（别名：萝卜芽幼苗）、菘蓝芽（别名：菘蓝幼芽或幼苗）、沙芥芽（别名：沙芥幼芽或幼苗）、芥菜芽（别名：芥菜幼芽或幼苗）、芥蓝芽（别名：芥蓝幼芽或幼苗）、白菜芽（别名：白菜幼芽或幼苗）、独行菜芽（",
                                        "kws": "芽苗菜、绿豆芽、绿豆芽幼芽、黄豆芽、黄豆幼芽、黑豆芽、黑豆幼芽、青豆芽、青豆幼芽、红豆芽、红豆幼芽、蚕豆芽、蚕豆幼芽、红小豆苗、红小豆幼芽、豌豆苗、豌豆幼芽、花生芽、花生幼芽、苜蓿芽、苜蓿幼芽或幼苗、小扁豆芽、小扁豆幼芽或幼苗、萝卜芽、萝卜芽幼苗、菘蓝芽、菘蓝幼芽或幼苗、沙芥芽、沙芥幼芽或幼苗、芥菜芽、芥菜幼芽或幼苗、芥蓝芽、芥蓝幼芽或幼苗、白菜芽、白菜幼芽或幼苗、独行菜芽、独行菜幼苗、香椿苗、香椿幼苗、向日葵芽、向日葵幼芽、荞麦芽、荞麦幼苗、胡椒芽、胡椒幼芽或幼苗、紫苏芽、紫苏幼芽或幼苗、水芹芽、水芹幼",
                                        "taxName": "蔬菜",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1010112140000000000",
                                        "taxCodeTitle": "蔬菜",
                                        "iTitle": "*蔬菜*绿豆芽等芽苗菜",
                                        "children": []
                                    },
                                    {
                                        "id": "60",
                                        "linkid": "45",
                                        "code": "101011215",
                                        "paCode": "1010112",
                                        "yn": "N",
                                        "title": "其他蔬菜",
                                        "alias": "其他蔬菜",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "蔬菜",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010112150000000000",
                                        "taxCodeTitle": "蔬菜",
                                        "iTitle": "*蔬菜*其他蔬菜",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "61",
                                "linkid": "3",
                                "code": "1010113",
                                "paCode": "10101",
                                "yn": "Y",
                                "title": "花卉",
                                "alias": "花卉",
                                "about": "包括盆栽花、鲜切花及花蕾、切叶、切枝、干燥花。",
                                "kws": "花卉、盆栽花、鲜切花、鲜切花蕾、切叶、切枝、干燥花",
                                "taxName": "花卉",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1010113000000000000",
                                "taxCodeTitle": "花卉",
                                "iTitle": "*花卉*花卉",
                                "children": [
                                    {
                                        "id": "62",
                                        "linkid": "61",
                                        "code": "101011301",
                                        "paCode": "1010113",
                                        "yn": "N",
                                        "title": "盆栽花",
                                        "alias": "盆栽花",
                                        "about": "包括鳞茎、块茎、块根、球茎、根颈及根茎等花卉。",
                                        "kws": "盆栽花、鳞茎、块茎、块根、球茎、根颈、根茎",
                                        "taxName": "花卉",
                                        "taxRate": "9%",
                                        "vip": "5",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010113010000000000",
                                        "taxCodeTitle": "花卉",
                                        "iTitle": "*花卉*盆栽花",
                                        "children": []
                                    },
                                    {
                                        "id": "63",
                                        "linkid": "61",
                                        "code": "101011302",
                                        "paCode": "1010113",
                                        "yn": "N",
                                        "title": "鲜切花及花蕾",
                                        "alias": "鲜切花及花蕾",
                                        "about": "包括康乃馨、满天星、勿忘我、玫瑰、情人草、紫罗兰、月季、香石竹、唐菖蒲、百合花、非洲菊、补血草、马蹄莲、火鹤、其他鲜切花及花蕾。",
                                        "kws": "鲜切花、花蕾、康乃馨、满天星、勿忘我、玫瑰、情人草、紫罗兰、月季、香石竹、唐菖蒲、百合花、非洲菊、补血草、马蹄莲、火鹤",
                                        "taxName": "花卉",
                                        "taxRate": "9%",
                                        "vip": "5",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010113020000000000",
                                        "taxCodeTitle": "花卉",
                                        "iTitle": "*花卉*鲜切花及花蕾",
                                        "children": []
                                    },
                                    {
                                        "id": "64",
                                        "linkid": "61",
                                        "code": "101011303",
                                        "paCode": "1010113",
                                        "yn": "N",
                                        "title": "切叶",
                                        "alias": "切叶",
                                        "about": "包括肾蕨、散尾葵、苏铁、富贵竹、龟背竹、其他切叶。",
                                        "kws": "切叶、肾蕨、散尾葵、苏铁、富贵竹、龟背竹",
                                        "taxName": "花卉",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010113030000000000",
                                        "taxCodeTitle": "花卉",
                                        "iTitle": "*花卉*切叶",
                                        "children": []
                                    },
                                    {
                                        "id": "65",
                                        "linkid": "61",
                                        "code": "101011304",
                                        "paCode": "1010113",
                                        "yn": "N",
                                        "title": "切枝",
                                        "alias": "切枝",
                                        "about": "包括银芽柳、其他切枝。",
                                        "kws": "切枝、银芽柳",
                                        "taxName": "花卉",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010113040000000000",
                                        "taxCodeTitle": "花卉",
                                        "iTitle": "*花卉*切枝",
                                        "children": []
                                    },
                                    {
                                        "id": "66",
                                        "linkid": "61",
                                        "code": "101011305",
                                        "paCode": "1010113",
                                        "yn": "N",
                                        "title": "干燥花",
                                        "alias": "干燥花",
                                        "about": "指经过干制处理的花卉。",
                                        "kws": "干燥花",
                                        "taxName": "花卉",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010113050000000000",
                                        "taxCodeTitle": "花卉",
                                        "iTitle": "*花卉*干燥花",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "67",
                                "linkid": "3",
                                "code": "1010114",
                                "paCode": "10101",
                                "yn": "Y",
                                "title": "盆景及园艺产品",
                                "alias": "盆景及园艺产品",
                                "about": "包括园艺产品、盆栽观叶植物、草皮、草坪、其他园艺产品、其他盆景及园艺产品。",
                                "kws": "盆景、园艺产品、盆栽观叶植物、草皮、草坪",
                                "taxName": "园艺产品",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1010114000000000000",
                                "taxCodeTitle": "园艺产品",
                                "iTitle": "*园艺产品*盆景及园艺产品",
                                "children": [
                                    {
                                        "id": "68",
                                        "linkid": "67",
                                        "code": "101011401",
                                        "paCode": "1010114",
                                        "yn": "Y",
                                        "title": "园艺产品",
                                        "alias": "园艺产品",
                                        "about": "包括盆栽观叶植物、草皮、草坪、其他园艺产品。",
                                        "kws": "园艺产品、盆栽观叶植物、草皮、草坪",
                                        "taxName": "园艺产品",
                                        "taxRate": "",
                                        "vip": "5",
                                        "itaxRate": null,
                                        "taxCode": "1010114010000000000",
                                        "taxCodeTitle": "园艺产品",
                                        "iTitle": "*园艺产品*园艺产品",
                                        "children": [
                                            {
                                                "id": "69",
                                                "linkid": "68",
                                                "code": "10101140101",
                                                "paCode": "101011401",
                                                "yn": "N",
                                                "title": "盆栽观叶植物",
                                                "alias": "盆栽观叶植物",
                                                "about": "包括龙血树（巴西木）、马拉巴栗（发财树）、喜林芋、绿萝、变叶木、袖珍椰子、盆栽散尾葵、绿巨人、花叶万年青（黛粉）、竹芋、白鹤芋、花叶芋、亮丝草、其他盆栽观叶植物。",
                                                "kws": "盆栽观叶植物、龙血树、巴西木、马拉巴栗、发财树、喜林芋、绿萝、变叶木、袖珍椰子、盆栽散尾葵、绿巨人、花叶万年青、黛粉、竹芋、白鹤芋、花叶芋、亮丝草",
                                                "taxName": "园艺产品",
                                                "taxRate": "9%",
                                                "vip": "5",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010114010100000000",
                                                "taxCodeTitle": "园艺产品",
                                                "iTitle": "*园艺产品*盆栽观叶植物",
                                                "children": []
                                            },
                                            {
                                                "id": "70",
                                                "linkid": "68",
                                                "code": "10101140102",
                                                "paCode": "101011401",
                                                "yn": "N",
                                                "title": "草皮",
                                                "alias": "草皮",
                                                "about": null,
                                                "kws": "草皮",
                                                "taxName": "园艺产品",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010114010200000000",
                                                "taxCodeTitle": "园艺产品",
                                                "iTitle": "*园艺产品*草皮",
                                                "children": []
                                            },
                                            {
                                                "id": "71",
                                                "linkid": "68",
                                                "code": "10101140103",
                                                "paCode": "101011401",
                                                "yn": "N",
                                                "title": "草坪",
                                                "alias": "草坪",
                                                "about": null,
                                                "kws": "草坪",
                                                "taxName": "园艺产品",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010114010300000000",
                                                "taxCodeTitle": "园艺产品",
                                                "iTitle": "*园艺产品*草坪",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "72",
                                        "linkid": "67",
                                        "code": "101011499",
                                        "paCode": "1010114",
                                        "yn": "N",
                                        "title": "其他盆景及园艺产品",
                                        "alias": "其他盆景及园艺产品",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "园艺产品",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010114990000000000",
                                        "taxCodeTitle": "园艺产品",
                                        "iTitle": "*园艺产品*其他盆景及园艺产品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "73",
                                "linkid": "3",
                                "code": "1010115",
                                "paCode": "10101",
                                "yn": "Y",
                                "title": "水果及坚果",
                                "alias": "水果及坚果",
                                "about": "包括水果（园林水果）、干制水果、水果籽、食用坚果。",
                                "kws": "水果、园林水果、干制水果、水果籽、食用坚果",
                                "taxName": "水果及坚果",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1010115000000000000",
                                "taxCodeTitle": "水果及坚果",
                                "iTitle": "*水果及坚果*水果及坚果",
                                "children": [
                                    {
                                        "id": "74",
                                        "linkid": "73",
                                        "code": "101011501",
                                        "paCode": "1010115",
                                        "yn": "Y",
                                        "title": "水果（园林水果）",
                                        "alias": "水果",
                                        "about": "包括苹果、梨、柑橘类水果、葡萄、香蕉、菠萝、龙眼、荔枝、枇杷、红毛丹、芒果、橄榄、无花果、鳄梨、番石榴、山竹果、杨桃、莲雾、火龙果、西瓜、哈密瓜、华莱士瓜、香瓜、伊利沙白瓜、木瓜、樱桃、枣、红果、柿子、桃、李子、石榴、杏、杨梅、草莓、黑莓、桑椹、猕猴桃、沙棘、其他未列明水果。",
                                        "kws": "水果、苹果、梨、柑橘类水果、葡萄、香蕉、菠萝、龙眼、荔枝、枇杷、红毛丹、芒果、橄榄、无花果、鳄梨、番石榴、山竹果、杨桃、莲雾、火龙果、西瓜、哈密瓜、华莱士瓜、香瓜、伊利沙白瓜、木瓜、樱桃、枣、红果、柿子、桃、李子、石榴、杏、杨梅、草莓、黑莓、桑椹、猕猴桃、沙棘",
                                        "taxName": "水果",
                                        "taxRate": "",
                                        "vip": "5",
                                        "itaxRate": null,
                                        "taxCode": "1010115010000000000",
                                        "taxCodeTitle": "水果",
                                        "iTitle": "*水果*水果（园林水果）",
                                        "children": [
                                            {
                                                "id": "75",
                                                "linkid": "74",
                                                "code": "10101150101",
                                                "paCode": "101011501",
                                                "yn": "N",
                                                "title": "苹果",
                                                "alias": "苹果",
                                                "about": "包括红富士苹果、国光苹果、秦冠苹果、香蕉苹果、金冠苹果、元帅苹果、新红星苹果、其他苹果。",
                                                "kws": "苹果、红富士苹果、国光苹果、秦冠苹果、香蕉苹果、金冠苹果、元帅苹果、新红星苹果",
                                                "taxName": "水果",
                                                "taxRate": "9%",
                                                "vip": "5",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115010100000000",
                                                "taxCodeTitle": "水果",
                                                "iTitle": "*水果*苹果",
                                                "children": []
                                            },
                                            {
                                                "id": "76",
                                                "linkid": "74",
                                                "code": "10101150102",
                                                "paCode": "101011501",
                                                "yn": "N",
                                                "title": "梨",
                                                "alias": "梨",
                                                "about": "包括雪花梨、鸭梨、酥梨、香梨、苹果梨、黄冠梨、绿宝石梨、冬果梨、贡梨、黄花梨、其他梨。",
                                                "kws": "梨、雪花梨、鸭梨、酥梨、香梨、苹果梨、黄冠梨、绿宝石梨、冬果梨、贡梨、黄花梨",
                                                "taxName": "水果",
                                                "taxRate": "9%",
                                                "vip": "5",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115010200000000",
                                                "taxCodeTitle": "水果",
                                                "iTitle": "*水果*梨",
                                                "children": []
                                            },
                                            {
                                                "id": "77",
                                                "linkid": "74",
                                                "code": "10101150103",
                                                "paCode": "101011501",
                                                "yn": "N",
                                                "title": "柑橘类水果",
                                                "alias": "柑橘类水果",
                                                "about": "包括柑、橘、橙、柚、柠檬等。",
                                                "kws": "柑橘、橙、宽皮柑橘、柚类、金柑、柠檬",
                                                "taxName": "水果",
                                                "taxRate": "9%",
                                                "vip": "5",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115010300000000",
                                                "taxCodeTitle": "水果",
                                                "iTitle": "*水果*柑橘类水果",
                                                "children": []
                                            },
                                            {
                                                "id": "78",
                                                "linkid": "74",
                                                "code": "10101150104",
                                                "paCode": "101011501",
                                                "yn": "N",
                                                "title": "葡萄",
                                                "alias": "葡萄",
                                                "about": "指鲜葡萄，包括巨峰葡萄、玫瑰香葡萄、白葡萄、龙眼葡萄、木纳格葡萄、红提葡萄、酿造葡萄、其他葡萄。",
                                                "kws": "葡萄、巨峰葡萄、玫瑰香葡萄、白葡萄、龙眼葡萄、木纳格葡萄、红提葡萄、酿造葡萄",
                                                "taxName": "水果",
                                                "taxRate": "9%",
                                                "vip": "5",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115010400000000",
                                                "taxCodeTitle": "水果",
                                                "iTitle": "*水果*葡萄",
                                                "children": []
                                            },
                                            {
                                                "id": "79",
                                                "linkid": "74",
                                                "code": "10101150105",
                                                "paCode": "101011501",
                                                "yn": "N",
                                                "title": "香蕉",
                                                "alias": "香蕉",
                                                "about": "包括芭蕉。",
                                                "kws": "香蕉、芭蕉",
                                                "taxName": "水果",
                                                "taxRate": "9%",
                                                "vip": "5",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115010500000000",
                                                "taxCodeTitle": "水果",
                                                "iTitle": "*水果*香蕉",
                                                "children": []
                                            },
                                            {
                                                "id": "80",
                                                "linkid": "74",
                                                "code": "10101150106",
                                                "paCode": "101011501",
                                                "yn": "N",
                                                "title": "菠萝",
                                                "alias": "菠萝",
                                                "about": null,
                                                "kws": "菠萝",
                                                "taxName": "水果",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115010600000000",
                                                "taxCodeTitle": "水果",
                                                "iTitle": "*水果*菠萝",
                                                "children": []
                                            },
                                            {
                                                "id": "81",
                                                "linkid": "74",
                                                "code": "10101150107",
                                                "paCode": "101011501",
                                                "yn": "N",
                                                "title": "龙眼",
                                                "alias": "龙眼",
                                                "about": null,
                                                "kws": "龙眼",
                                                "taxName": "水果",
                                                "taxRate": "9%",
                                                "vip": "5",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115010700000000",
                                                "taxCodeTitle": "水果",
                                                "iTitle": "*水果*龙眼",
                                                "children": []
                                            },
                                            {
                                                "id": "82",
                                                "linkid": "74",
                                                "code": "10101150108",
                                                "paCode": "101011501",
                                                "yn": "N",
                                                "title": "荔枝",
                                                "alias": "荔枝",
                                                "about": null,
                                                "kws": "荔枝",
                                                "taxName": "水果",
                                                "taxRate": "9%",
                                                "vip": "5",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115010800000000",
                                                "taxCodeTitle": "水果",
                                                "iTitle": "*水果*荔枝",
                                                "children": []
                                            },
                                            {
                                                "id": "83",
                                                "linkid": "74",
                                                "code": "10101150109",
                                                "paCode": "101011501",
                                                "yn": "N",
                                                "title": "枇杷",
                                                "alias": "枇杷",
                                                "about": null,
                                                "kws": "枇杷",
                                                "taxName": "水果",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115010900000000",
                                                "taxCodeTitle": "水果",
                                                "iTitle": "*水果*枇杷",
                                                "children": []
                                            },
                                            {
                                                "id": "84",
                                                "linkid": "74",
                                                "code": "10101150110",
                                                "paCode": "101011501",
                                                "yn": "N",
                                                "title": "红毛丹",
                                                "alias": "红毛丹",
                                                "about": null,
                                                "kws": "红毛丹",
                                                "taxName": "水果",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115011000000000",
                                                "taxCodeTitle": "水果",
                                                "iTitle": "*水果*红毛丹",
                                                "children": []
                                            },
                                            {
                                                "id": "85",
                                                "linkid": "74",
                                                "code": "10101150111",
                                                "paCode": "101011501",
                                                "yn": "N",
                                                "title": "芒果",
                                                "alias": "芒果",
                                                "about": null,
                                                "kws": "芒果",
                                                "taxName": "水果",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115011100000000",
                                                "taxCodeTitle": "水果",
                                                "iTitle": "*水果*芒果",
                                                "children": []
                                            },
                                            {
                                                "id": "86",
                                                "linkid": "74",
                                                "code": "10101150112",
                                                "paCode": "101011501",
                                                "yn": "N",
                                                "title": "橄榄",
                                                "alias": "橄榄",
                                                "about": null,
                                                "kws": "橄榄",
                                                "taxName": "水果",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115011200000000",
                                                "taxCodeTitle": "水果",
                                                "iTitle": "*水果*橄榄",
                                                "children": []
                                            },
                                            {
                                                "id": "87",
                                                "linkid": "74",
                                                "code": "10101150113",
                                                "paCode": "101011501",
                                                "yn": "N",
                                                "title": "无花果",
                                                "alias": "无花果",
                                                "about": null,
                                                "kws": "无花果",
                                                "taxName": "水果",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115011300000000",
                                                "taxCodeTitle": "水果",
                                                "iTitle": "*水果*无花果",
                                                "children": []
                                            },
                                            {
                                                "id": "88",
                                                "linkid": "74",
                                                "code": "10101150114",
                                                "paCode": "101011501",
                                                "yn": "N",
                                                "title": "鳄梨",
                                                "alias": "鳄梨",
                                                "about": null,
                                                "kws": "鳄梨",
                                                "taxName": "水果",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115011400000000",
                                                "taxCodeTitle": "水果",
                                                "iTitle": "*水果*鳄梨",
                                                "children": []
                                            },
                                            {
                                                "id": "89",
                                                "linkid": "74",
                                                "code": "10101150115",
                                                "paCode": "101011501",
                                                "yn": "N",
                                                "title": "番石榴",
                                                "alias": "番石榴",
                                                "about": null,
                                                "kws": "番石榴",
                                                "taxName": "水果",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115011500000000",
                                                "taxCodeTitle": "水果",
                                                "iTitle": "*水果*番石榴",
                                                "children": []
                                            },
                                            {
                                                "id": "90",
                                                "linkid": "74",
                                                "code": "10101150116",
                                                "paCode": "101011501",
                                                "yn": "N",
                                                "title": "山竹果",
                                                "alias": "山竹果",
                                                "about": null,
                                                "kws": "山竹果",
                                                "taxName": "水果",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115011600000000",
                                                "taxCodeTitle": "水果",
                                                "iTitle": "*水果*山竹果",
                                                "children": []
                                            },
                                            {
                                                "id": "91",
                                                "linkid": "74",
                                                "code": "10101150117",
                                                "paCode": "101011501",
                                                "yn": "N",
                                                "title": "杨桃",
                                                "alias": "杨桃",
                                                "about": null,
                                                "kws": "杨桃",
                                                "taxName": "水果",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115011700000000",
                                                "taxCodeTitle": "水果",
                                                "iTitle": "*水果*杨桃",
                                                "children": []
                                            },
                                            {
                                                "id": "92",
                                                "linkid": "74",
                                                "code": "10101150118",
                                                "paCode": "101011501",
                                                "yn": "N",
                                                "title": "莲雾",
                                                "alias": "莲雾",
                                                "about": null,
                                                "kws": "莲雾",
                                                "taxName": "水果",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115011800000000",
                                                "taxCodeTitle": "水果",
                                                "iTitle": "*水果*莲雾",
                                                "children": []
                                            },
                                            {
                                                "id": "93",
                                                "linkid": "74",
                                                "code": "10101150119",
                                                "paCode": "101011501",
                                                "yn": "N",
                                                "title": "火龙果",
                                                "alias": "火龙果",
                                                "about": null,
                                                "kws": "火龙果",
                                                "taxName": "水果",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115011900000000",
                                                "taxCodeTitle": "水果",
                                                "iTitle": "*水果*火龙果",
                                                "children": []
                                            },
                                            {
                                                "id": "94",
                                                "linkid": "74",
                                                "code": "10101150120",
                                                "paCode": "101011501",
                                                "yn": "N",
                                                "title": "西瓜",
                                                "alias": "西瓜",
                                                "about": null,
                                                "kws": "西瓜",
                                                "taxName": "水果",
                                                "taxRate": "9%",
                                                "vip": "5",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115012000000000",
                                                "taxCodeTitle": "水果",
                                                "iTitle": "*水果*西瓜",
                                                "children": []
                                            },
                                            {
                                                "id": "95",
                                                "linkid": "74",
                                                "code": "10101150121",
                                                "paCode": "101011501",
                                                "yn": "N",
                                                "title": "哈密瓜",
                                                "alias": "哈密瓜",
                                                "about": null,
                                                "kws": "哈密瓜",
                                                "taxName": "水果",
                                                "taxRate": "9%",
                                                "vip": "5",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115012100000000",
                                                "taxCodeTitle": "水果",
                                                "iTitle": "*水果*哈密瓜",
                                                "children": []
                                            },
                                            {
                                                "id": "96",
                                                "linkid": "74",
                                                "code": "10101150122",
                                                "paCode": "101011501",
                                                "yn": "N",
                                                "title": "华莱士瓜",
                                                "alias": "华莱士瓜",
                                                "about": null,
                                                "kws": "华莱士瓜",
                                                "taxName": "水果",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115012200000000",
                                                "taxCodeTitle": "水果",
                                                "iTitle": "*水果*华莱士瓜",
                                                "children": []
                                            },
                                            {
                                                "id": "97",
                                                "linkid": "74",
                                                "code": "10101150123",
                                                "paCode": "101011501",
                                                "yn": "N",
                                                "title": "香瓜",
                                                "alias": "香瓜",
                                                "about": null,
                                                "kws": "香瓜",
                                                "taxName": "水果",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115012300000000",
                                                "taxCodeTitle": "水果",
                                                "iTitle": "*水果*香瓜",
                                                "children": []
                                            },
                                            {
                                                "id": "98",
                                                "linkid": "74",
                                                "code": "10101150124",
                                                "paCode": "101011501",
                                                "yn": "N",
                                                "title": "伊利沙白瓜",
                                                "alias": "伊利沙白瓜",
                                                "about": null,
                                                "kws": "伊利沙白瓜",
                                                "taxName": "水果",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115012400000000",
                                                "taxCodeTitle": "水果",
                                                "iTitle": "*水果*伊利沙白瓜",
                                                "children": []
                                            },
                                            {
                                                "id": "99",
                                                "linkid": "74",
                                                "code": "10101150125",
                                                "paCode": "101011501",
                                                "yn": "N",
                                                "title": "木瓜",
                                                "alias": "木瓜",
                                                "about": null,
                                                "kws": "木瓜",
                                                "taxName": "水果",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115012500000000",
                                                "taxCodeTitle": "水果",
                                                "iTitle": "*水果*木瓜",
                                                "children": []
                                            },
                                            {
                                                "id": "100",
                                                "linkid": "74",
                                                "code": "10101150126",
                                                "paCode": "101011501",
                                                "yn": "N",
                                                "title": "樱桃",
                                                "alias": "樱桃",
                                                "about": null,
                                                "kws": "樱桃",
                                                "taxName": "水果",
                                                "taxRate": "9%",
                                                "vip": "5",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115012600000000",
                                                "taxCodeTitle": "水果",
                                                "iTitle": "*水果*樱桃",
                                                "children": []
                                            },
                                            {
                                                "id": "101",
                                                "linkid": "74",
                                                "code": "10101150127",
                                                "paCode": "101011501",
                                                "yn": "N",
                                                "title": "枣",
                                                "alias": "枣",
                                                "about": "指鲜枣，包括小枣、冬枣、沙枣、青枣等。",
                                                "kws": "枣",
                                                "taxName": "水果",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115012700000000",
                                                "taxCodeTitle": "水果",
                                                "iTitle": "*水果*枣",
                                                "children": []
                                            },
                                            {
                                                "id": "102",
                                                "linkid": "74",
                                                "code": "10101150128",
                                                "paCode": "101011501",
                                                "yn": "N",
                                                "title": "红果",
                                                "alias": "红果",
                                                "about": null,
                                                "kws": "红果",
                                                "taxName": "水果",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115012800000000",
                                                "taxCodeTitle": "水果",
                                                "iTitle": "*水果*红果",
                                                "children": []
                                            },
                                            {
                                                "id": "103",
                                                "linkid": "74",
                                                "code": "10101150129",
                                                "paCode": "101011501",
                                                "yn": "N",
                                                "title": "柿子",
                                                "alias": "柿子",
                                                "about": null,
                                                "kws": "柿子",
                                                "taxName": "水果",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115012900000000",
                                                "taxCodeTitle": "水果",
                                                "iTitle": "*水果*柿子",
                                                "children": []
                                            },
                                            {
                                                "id": "104",
                                                "linkid": "74",
                                                "code": "10101150130",
                                                "paCode": "101011501",
                                                "yn": "N",
                                                "title": "桃",
                                                "alias": "桃",
                                                "about": null,
                                                "kws": "桃",
                                                "taxName": "水果",
                                                "taxRate": "9%",
                                                "vip": "5",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115013000000000",
                                                "taxCodeTitle": "水果",
                                                "iTitle": "*水果*桃",
                                                "children": []
                                            },
                                            {
                                                "id": "105",
                                                "linkid": "74",
                                                "code": "10101150131",
                                                "paCode": "101011501",
                                                "yn": "N",
                                                "title": "李子",
                                                "alias": "李子",
                                                "about": null,
                                                "kws": "李子",
                                                "taxName": "水果",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115013100000000",
                                                "taxCodeTitle": "水果",
                                                "iTitle": "*水果*李子",
                                                "children": []
                                            },
                                            {
                                                "id": "106",
                                                "linkid": "74",
                                                "code": "10101150132",
                                                "paCode": "101011501",
                                                "yn": "N",
                                                "title": "石榴",
                                                "alias": "石榴",
                                                "about": null,
                                                "kws": "石榴",
                                                "taxName": "水果",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115013200000000",
                                                "taxCodeTitle": "水果",
                                                "iTitle": "*水果*石榴",
                                                "children": []
                                            },
                                            {
                                                "id": "107",
                                                "linkid": "74",
                                                "code": "10101150133",
                                                "paCode": "101011501",
                                                "yn": "N",
                                                "title": "杏",
                                                "alias": "杏",
                                                "about": null,
                                                "kws": "杏",
                                                "taxName": "水果",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115013300000000",
                                                "taxCodeTitle": "水果",
                                                "iTitle": "*水果*杏",
                                                "children": []
                                            },
                                            {
                                                "id": "108",
                                                "linkid": "74",
                                                "code": "10101150134",
                                                "paCode": "101011501",
                                                "yn": "N",
                                                "title": "杨梅",
                                                "alias": "杨梅",
                                                "about": null,
                                                "kws": "杨梅",
                                                "taxName": "水果",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115013400000000",
                                                "taxCodeTitle": "水果",
                                                "iTitle": "*水果*杨梅",
                                                "children": []
                                            },
                                            {
                                                "id": "109",
                                                "linkid": "74",
                                                "code": "10101150135",
                                                "paCode": "101011501",
                                                "yn": "N",
                                                "title": "草莓",
                                                "alias": "草莓",
                                                "about": null,
                                                "kws": "草莓",
                                                "taxName": "水果",
                                                "taxRate": "9%",
                                                "vip": "5",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115013500000000",
                                                "taxCodeTitle": "水果",
                                                "iTitle": "*水果*草莓",
                                                "children": []
                                            },
                                            {
                                                "id": "110",
                                                "linkid": "74",
                                                "code": "10101150136",
                                                "paCode": "101011501",
                                                "yn": "N",
                                                "title": "黑莓",
                                                "alias": "黑莓",
                                                "about": null,
                                                "kws": "黑莓",
                                                "taxName": "水果",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115013600000000",
                                                "taxCodeTitle": "水果",
                                                "iTitle": "*水果*黑莓",
                                                "children": []
                                            },
                                            {
                                                "id": "111",
                                                "linkid": "74",
                                                "code": "10101150137",
                                                "paCode": "101011501",
                                                "yn": "N",
                                                "title": "桑椹",
                                                "alias": "桑椹",
                                                "about": null,
                                                "kws": "桑椹",
                                                "taxName": "水果",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115013700000000",
                                                "taxCodeTitle": "水果",
                                                "iTitle": "*水果*桑椹",
                                                "children": []
                                            },
                                            {
                                                "id": "112",
                                                "linkid": "74",
                                                "code": "10101150138",
                                                "paCode": "101011501",
                                                "yn": "N",
                                                "title": "猕猴桃",
                                                "alias": "猕猴桃",
                                                "about": "又名奇异果",
                                                "kws": "猕猴桃、奇异果",
                                                "taxName": "水果",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115013800000000",
                                                "taxCodeTitle": "水果",
                                                "iTitle": "*水果*猕猴桃",
                                                "children": []
                                            },
                                            {
                                                "id": "113",
                                                "linkid": "74",
                                                "code": "10101150139",
                                                "paCode": "101011501",
                                                "yn": "N",
                                                "title": "沙棘",
                                                "alias": "沙棘",
                                                "about": null,
                                                "kws": "沙棘",
                                                "taxName": "水果",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115013900000000",
                                                "taxCodeTitle": "水果",
                                                "iTitle": "*水果*沙棘",
                                                "children": []
                                            },
                                            {
                                                "id": "114",
                                                "linkid": "74",
                                                "code": "10101150199",
                                                "paCode": "101011501",
                                                "yn": "N",
                                                "title": "其他未列明水果",
                                                "alias": "其他未列明水果",
                                                "about": "包括罗甘莓、木莓等。",
                                                "kws": "罗甘莓、木莓",
                                                "taxName": "水果",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115019900000000",
                                                "taxCodeTitle": "水果",
                                                "iTitle": "*水果*其他未列明水果",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "115",
                                        "linkid": "73",
                                        "code": "101011502",
                                        "paCode": "1010115",
                                        "yn": "N",
                                        "title": "干制水果",
                                        "alias": "干制水果",
                                        "about": "包括葡萄干、杏干、梅干及李干、苹果干、龙眼干（肉）、柿饼、干枣、椰子干、荔枝干、其他干制水果。",
                                        "kws": "干制水果、葡萄干、杏干、梅干、李干、苹果干、龙眼干、龙眼肉、柿饼、干枣、椰子干、荔枝干",
                                        "taxName": "干制水果",
                                        "taxRate": "9%",
                                        "vip": "5",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010115020000000000",
                                        "taxCodeTitle": "干制水果",
                                        "iTitle": "*干制水果*干制水果",
                                        "children": []
                                    },
                                    {
                                        "id": "116",
                                        "linkid": "73",
                                        "code": "101011503",
                                        "paCode": "1010115",
                                        "yn": "Y",
                                        "title": "食用坚果",
                                        "alias": "食用坚果",
                                        "about": "包括鲜或干的坚果。不包括炒制的坚果（详见103011107）、煮制的坚果（详见103011108）。",
                                        "kws": "食用坚果",
                                        "taxName": "坚果",
                                        "taxRate": "",
                                        "vip": "5",
                                        "itaxRate": null,
                                        "taxCode": "1010115030000000000",
                                        "taxCodeTitle": "坚果",
                                        "iTitle": "*坚果*食用坚果",
                                        "children": [
                                            {
                                                "id": "117",
                                                "linkid": "116",
                                                "code": "10101150301",
                                                "paCode": "101011503",
                                                "yn": "N",
                                                "title": "椰子",
                                                "alias": "椰子",
                                                "about": "包括种用椰子、其他椰子。",
                                                "kws": "椰子",
                                                "taxName": "坚果",
                                                "taxRate": "9%",
                                                "vip": "5",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115030100000000",
                                                "taxCodeTitle": "坚果",
                                                "iTitle": "*坚果*椰子",
                                                "children": []
                                            },
                                            {
                                                "id": "118",
                                                "linkid": "116",
                                                "code": "10101150302",
                                                "paCode": "101011503",
                                                "yn": "N",
                                                "title": "腰果",
                                                "alias": "腰果",
                                                "about": null,
                                                "kws": "腰果",
                                                "taxName": "坚果",
                                                "taxRate": "9%",
                                                "vip": "5",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115030200000000",
                                                "taxCodeTitle": "坚果",
                                                "iTitle": "*坚果*腰果",
                                                "children": []
                                            },
                                            {
                                                "id": "119",
                                                "linkid": "116",
                                                "code": "10101150303",
                                                "paCode": "101011503",
                                                "yn": "N",
                                                "title": "核桃",
                                                "alias": "核桃",
                                                "about": null,
                                                "kws": "核桃",
                                                "taxName": "坚果",
                                                "taxRate": "9%",
                                                "vip": "5",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115030300000000",
                                                "taxCodeTitle": "坚果",
                                                "iTitle": "*坚果*核桃",
                                                "children": []
                                            },
                                            {
                                                "id": "120",
                                                "linkid": "116",
                                                "code": "10101150304",
                                                "paCode": "101011503",
                                                "yn": "N",
                                                "title": "山核桃",
                                                "alias": "山核桃",
                                                "about": null,
                                                "kws": "山核桃",
                                                "taxName": "坚果",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115030400000000",
                                                "taxCodeTitle": "坚果",
                                                "iTitle": "*坚果*山核桃",
                                                "children": []
                                            },
                                            {
                                                "id": "121",
                                                "linkid": "116",
                                                "code": "10101150305",
                                                "paCode": "101011503",
                                                "yn": "N",
                                                "title": "栗子",
                                                "alias": "栗子",
                                                "about": "包括板栗、锥栗、丹东栗、其他栗子。",
                                                "kws": "栗子",
                                                "taxName": "坚果",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115030500000000",
                                                "taxCodeTitle": "坚果",
                                                "iTitle": "*坚果*栗子",
                                                "children": []
                                            },
                                            {
                                                "id": "122",
                                                "linkid": "116",
                                                "code": "10101150306",
                                                "paCode": "101011503",
                                                "yn": "N",
                                                "title": "松子",
                                                "alias": "松子",
                                                "about": null,
                                                "kws": "松子",
                                                "taxName": "坚果",
                                                "taxRate": "9%",
                                                "vip": "5",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115030600000000",
                                                "taxCodeTitle": "坚果",
                                                "iTitle": "*坚果*松子",
                                                "children": []
                                            },
                                            {
                                                "id": "123",
                                                "linkid": "116",
                                                "code": "10101150307",
                                                "paCode": "101011503",
                                                "yn": "N",
                                                "title": "榛子",
                                                "alias": "榛子",
                                                "about": null,
                                                "kws": "榛子",
                                                "taxName": "坚果",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115030700000000",
                                                "taxCodeTitle": "坚果",
                                                "iTitle": "*坚果*榛子",
                                                "children": []
                                            },
                                            {
                                                "id": "124",
                                                "linkid": "116",
                                                "code": "10101150308",
                                                "paCode": "101011503",
                                                "yn": "N",
                                                "title": "阿月浑子果（开心果）",
                                                "alias": "开心果",
                                                "about": null,
                                                "kws": "阿月浑子果、开心果",
                                                "taxName": "坚果",
                                                "taxRate": "9%",
                                                "vip": "5",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115030800000000",
                                                "taxCodeTitle": "坚果",
                                                "iTitle": "*坚果*阿月浑子果（开心果）",
                                                "children": []
                                            },
                                            {
                                                "id": "125",
                                                "linkid": "116",
                                                "code": "10101150309",
                                                "paCode": "101011503",
                                                "yn": "N",
                                                "title": "槟榔",
                                                "alias": "槟榔",
                                                "about": null,
                                                "kws": "槟榔",
                                                "taxName": "坚果",
                                                "taxRate": "9%",
                                                "vip": "5",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115030900000000",
                                                "taxCodeTitle": "坚果",
                                                "iTitle": "*坚果*槟榔",
                                                "children": []
                                            },
                                            {
                                                "id": "126",
                                                "linkid": "116",
                                                "code": "10101150310",
                                                "paCode": "101011503",
                                                "yn": "N",
                                                "title": "白果",
                                                "alias": "白果",
                                                "about": null,
                                                "kws": "白果",
                                                "taxName": "坚果",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115031000000000",
                                                "taxCodeTitle": "坚果",
                                                "iTitle": "*坚果*白果",
                                                "children": []
                                            },
                                            {
                                                "id": "127",
                                                "linkid": "116",
                                                "code": "10101150311",
                                                "paCode": "101011503",
                                                "yn": "N",
                                                "title": "香榧",
                                                "alias": "香榧",
                                                "about": null,
                                                "kws": "香榧",
                                                "taxName": "坚果",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115031100000000",
                                                "taxCodeTitle": "坚果",
                                                "iTitle": "*坚果*香榧",
                                                "children": []
                                            },
                                            {
                                                "id": "128",
                                                "linkid": "116",
                                                "code": "10101150312",
                                                "paCode": "101011503",
                                                "yn": "N",
                                                "title": "巴旦杏",
                                                "alias": "巴旦杏",
                                                "about": null,
                                                "kws": "巴旦杏",
                                                "taxName": "坚果",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115031200000000",
                                                "taxCodeTitle": "坚果",
                                                "iTitle": "*坚果*巴旦杏",
                                                "children": []
                                            },
                                            {
                                                "id": "129",
                                                "linkid": "116",
                                                "code": "10101150313",
                                                "paCode": "101011503",
                                                "yn": "N",
                                                "title": "夏威夷果",
                                                "alias": "夏威夷果",
                                                "about": "又名“澳洲坚果”、山龙眼科、澳洲坚果属、生长在热带地区",
                                                "kws": "夏威夷果、澳洲坚果",
                                                "taxName": "坚果",
                                                "taxRate": "9%",
                                                "vip": "5",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115031300000000",
                                                "taxCodeTitle": "坚果",
                                                "iTitle": "*坚果*夏威夷果",
                                                "children": []
                                            },
                                            {
                                                "id": "130",
                                                "linkid": "116",
                                                "code": "10101150399",
                                                "paCode": "101011503",
                                                "yn": "N",
                                                "title": "其他食用坚果",
                                                "alias": "其他食用坚果",
                                                "about": null,
                                                "kws": null,
                                                "taxName": "坚果",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010115039900000000",
                                                "taxCodeTitle": "坚果",
                                                "iTitle": "*坚果*其他食用坚果",
                                                "children": []
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "id": "131",
                                "linkid": "3",
                                "code": "1010116",
                                "paCode": "10101",
                                "yn": "Y",
                                "title": "茶及饮料原料",
                                "alias": "茶及饮料",
                                "about": null,
                                "kws": null,
                                "taxName": "茶及饮料",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1010116000000000000",
                                "taxCodeTitle": "茶及饮料",
                                "iTitle": "*茶及饮料*茶及饮料原料",
                                "children": [
                                    {
                                        "id": "132",
                                        "linkid": "131",
                                        "code": "101011601",
                                        "paCode": "1010116",
                                        "yn": "N",
                                        "title": "茶叶",
                                        "alias": "茶叶",
                                        "about": "指茶农采集和经过初加工（如炒制、晾晒）的毛茶。如红毛茶、绿毛茶、乌龙毛茶、白毛茶、黑毛茶等。",
                                        "kws": "茶叶、红毛茶、绿毛茶、乌龙毛茶、白毛茶、黑毛茶",
                                        "taxName": "茶及饮料",
                                        "taxRate": "9%",
                                        "vip": "5",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010116010000000000",
                                        "taxCodeTitle": "茶及饮料",
                                        "iTitle": "*茶及饮料*茶叶",
                                        "children": []
                                    },
                                    {
                                        "id": "133",
                                        "linkid": "131",
                                        "code": "101011602",
                                        "paCode": "1010116",
                                        "yn": "N",
                                        "title": "饮料原料",
                                        "alias": "饮料原料",
                                        "about": "包括可可豆、咖啡豆。",
                                        "kws": "饮料原料",
                                        "taxName": "茶及饮料",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010116020000000000",
                                        "taxCodeTitle": "茶及饮料",
                                        "iTitle": "*茶及饮料*饮料原料",
                                        "children": []
                                    },
                                    {
                                        "id": "134",
                                        "linkid": "131",
                                        "code": "101011699",
                                        "paCode": "1010116",
                                        "yn": "N",
                                        "title": "其他未列明饮料原料",
                                        "alias": "其他未列明饮料原料",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "茶及饮料",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010116990000000000",
                                        "taxCodeTitle": "茶及饮料",
                                        "iTitle": "*茶及饮料*其他未列明饮料原料",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "135",
                                "linkid": "3",
                                "code": "1010117",
                                "paCode": "10101",
                                "yn": "N",
                                "title": "香料原料",
                                "alias": "香料原料",
                                "about": "指未研磨香料原料，包括调味香料（如花椒、胡椒、八椒、桂皮、桂花、丁香、豆蔻、小茴香、咖喱、枯茗子、蒿子、杜松果等）、香味料（香子兰、香茅草、留兰香、番红花、姜黄、啤酒花、麝香草、月桂叶等）。不包括研磨过香料原料（详见103020604）。",
                                "kws": "香料原料、花椒、胡椒、八椒、桂皮、桂花、丁香、豆蔻、小茴香、咖喱、枯茗子、蒿子、杜松果、香子兰、香茅草、留兰香、番红花、姜黄、啤酒花、麝香草、月桂叶",
                                "taxName": "香料原料",
                                "taxRate": "9%",
                                "vip": "5",
                                "itaxRate": "0.09",
                                "taxCode": "1010117000000000000",
                                "taxCodeTitle": "香料原料",
                                "iTitle": "*香料原料*香料原料",
                                "children": []
                            },
                            {
                                "id": "136",
                                "linkid": "3",
                                "code": "1010118",
                                "paCode": "10101",
                                "yn": "N",
                                "title": "中草药材",
                                "alias": "中草药材",
                                "about": "指主要作香料、药料、杀虫、杀菌等用途的植物。包括甘草、人参、古柯叶、罂粟杆、当归、田七、党参、黄连、菊花、冬虫夏草、贝母、川芎、半夏、白芍、天麻、黄芪、大黄、籽黄、白术、地黄、槐米、杜仲、茯苓、枸杞、大海子、沉香、沙参、青蒿、鱼藤根、除虫菊、灵芝、五味子、刺五加、生地、麦冬、云木香、白芷、元胡、山茱萸、莲翘、辛荑、厚朴、黄芩、葛根、柴胡、麻黄、列当、肉苁蓉、锁阳、罗布麻等。",
                                "kws": "中草药材、甘草、人参、古柯叶、罂粟杆、当归、田七、党参、黄连、菊花、冬虫夏草、贝母、川芎、半夏、白芍、天麻、黄芪、大黄、籽黄、白术、地黄、槐米、杜仲、茯苓、枸杞、大海子、沉香、沙参、青蒿、鱼藤根、除虫菊、灵芝、五味子、刺五加、生地、麦冬、云木香、白芷、元胡、山茱萸、莲翘、辛荑、厚朴、黄芩、葛根、柴胡、麻黄、列当、肉苁蓉、锁阳、罗布麻",
                                "taxName": "中草药材",
                                "taxRate": "9%",
                                "vip": "5",
                                "itaxRate": "0.09",
                                "taxCode": "1010118000000000000",
                                "taxCodeTitle": "中草药材",
                                "iTitle": "*中草药材*中草药材",
                                "children": []
                            },
                            {
                                "id": "137",
                                "linkid": "3",
                                "code": "1010119",
                                "paCode": "10101",
                                "yn": "Y",
                                "title": "种子、种苗",
                                "alias": "种子种苗",
                                "about": "包括种用谷物、种用薯类、种用油料、种用豆类、种用饲料作物、蔬菜籽、花草种、水果籽及其他种子、种苗",
                                "kws": "种子、种苗、种用谷物、种用薯类、种用油料、种用豆类、种用饲料作物、蔬菜籽、花草种、水果籽",
                                "taxName": "种子种苗",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1010119000000000000",
                                "taxCodeTitle": "种子种苗",
                                "iTitle": "*种子种苗*种子、种苗",
                                "children": [
                                    {
                                        "id": "138",
                                        "linkid": "137",
                                        "code": "101011901",
                                        "paCode": "1010119",
                                        "yn": "N",
                                        "title": "种用谷物",
                                        "alias": "种用谷物",
                                        "about": "包括种用硬质小麦、种用甜玉米、种用软质小麦、种用皮大麦、种用糯玉米、种用糯高粱、种用裸大麦、种用黄玉米、种用红粒高粱、种用白玉米、种用白粒高粱、其他种用玉米、其他种用小麦、其他种用高粱、种用中籼稻、种用早籼稻、种用晚籼稻、种用糯稻、种用粳稻、其他种用稻谷。",
                                        "kws": "种用谷物、种用皮大麦、种用裸大麦、种用糯高粱、种用红粒高粱、种用白粒高粱、种用甜玉米、种用糯玉米、种用黄玉米、种用白玉米、种用硬质小麦、种用软质小麦、种用中籼稻、种用早籼稻、种用晚籼稻、种用糯稻、种用粳稻",
                                        "taxName": "种子种苗",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010119010000000000",
                                        "taxCodeTitle": "种子种苗",
                                        "iTitle": "*种子种苗*种用谷物",
                                        "children": []
                                    },
                                    {
                                        "id": "139",
                                        "linkid": "137",
                                        "code": "101011902",
                                        "paCode": "1010119",
                                        "yn": "N",
                                        "title": "种用薯类",
                                        "alias": "种用薯类",
                                        "about": "包括种用马铃薯、种用甘薯。",
                                        "kws": "种用薯类、种用马铃薯、种用甘薯",
                                        "taxName": "种子种苗",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010119020000000000",
                                        "taxCodeTitle": "种子种苗",
                                        "iTitle": "*种子种苗*种用薯类",
                                        "children": []
                                    },
                                    {
                                        "id": "140",
                                        "linkid": "137",
                                        "code": "101011903",
                                        "paCode": "1010119",
                                        "yn": "N",
                                        "title": "种用油料",
                                        "alias": "种用油料",
                                        "about": "包括种用油棕果及油棕仁、种用棉籽、种用蓖麻籽、种用芥子、种用胡麻籽、种用红花籽、种用黄芝麻、种用黑芝麻、种用带壳花生、种用白芝麻、种用油葵、种用双低油菜籽、种用食葵、其他种用油菜籽。",
                                        "kws": "种用油料、种用油棕果、种用油棕仁、种用棉籽、种用蓖麻籽、种用芥子、种用胡麻籽、种用红花籽、种用黄芝麻、种用黑芝麻、种用带壳花生、种用白芝麻、种用油葵、种用双低油菜籽、种用食葵",
                                        "taxName": "种子种苗",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010119030000000000",
                                        "taxCodeTitle": "种子种苗",
                                        "iTitle": "*种子种苗*种用油料",
                                        "children": []
                                    },
                                    {
                                        "id": "141",
                                        "linkid": "137",
                                        "code": "101011904",
                                        "paCode": "1010119",
                                        "yn": "N",
                                        "title": "种用豆类",
                                        "alias": "种用豆类",
                                        "about": "包括种用杂豆、种用芸豆、种用鹰嘴豆、种用干豇豆、种用干蚕豆、种用饭豆、种用明绿豆、种用毛绿豆、种用麻豌豆、种用绿豌豆、种用白豌豆。",
                                        "kws": "种用豆类、种用杂豆、种用芸豆、种用鹰嘴豆、种用干豇豆、种用干蚕豆、种用饭豆、种用明绿豆、种用毛绿豆、种用麻豌豆、种用绿豌豆、种用白豌豆",
                                        "taxName": "种子种苗",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010119040000000000",
                                        "taxCodeTitle": "种子种苗",
                                        "iTitle": "*种子种苗*种用豆类",
                                        "children": []
                                    },
                                    {
                                        "id": "142",
                                        "linkid": "137",
                                        "code": "101011905",
                                        "paCode": "1010119",
                                        "yn": "N",
                                        "title": "种用饲料作物",
                                        "alias": "种用饲料作物",
                                        "about": "指饲料作物用种子。",
                                        "kws": "种用饲料",
                                        "taxName": "种子种苗",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010119050000000000",
                                        "taxCodeTitle": "种子种苗",
                                        "iTitle": "*种子种苗*种用饲料作物",
                                        "children": []
                                    },
                                    {
                                        "id": "143",
                                        "linkid": "137",
                                        "code": "101011906",
                                        "paCode": "1010119",
                                        "yn": "N",
                                        "title": "蔬菜籽",
                                        "alias": "蔬菜籽",
                                        "about": null,
                                        "kws": "蔬菜籽",
                                        "taxName": "种子种苗",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010119060000000000",
                                        "taxCodeTitle": "种子种苗",
                                        "iTitle": "*种子种苗*蔬菜籽",
                                        "children": []
                                    },
                                    {
                                        "id": "144",
                                        "linkid": "137",
                                        "code": "101011907",
                                        "paCode": "1010119",
                                        "yn": "N",
                                        "title": "花草种",
                                        "alias": "花草种",
                                        "about": "包括草种（苜蓿草种、箭舌豌豆草种、红豆草草种、草木犀草种、燕麦草种、多花黑麦草草种、披碱草草种、柠挑草种、沙打旺草种、锦鸡儿草种、老芒麦草种、羊柴草种、其他草种）、花卉种球（唐菖蒲种球、百合种球、郁金香种球、水仙种球、马蹄莲种球、大丽花种球、美人蕉种球、风信子种球、小苍兰种球、球根鸢尾种球、晚香玉种球、其他花卉种球）、花卉种子（一串红种子、矮牵牛种子、万寿菊种子、凤仙花种子、鸡冠花种子、三色堇种子、金鱼草种子、石竹种子、翠菊种子、四季秋海棠种子、其他花卉种子）、花卉种苗（香石竹种苗、菊花种苗、非洲菊种苗、",
                                        "kws": "花草种、草种、苜蓿草种、箭舌豌豆草种、红豆草草种、草木犀草种、燕麦草种、多花黑麦草草种、披碱草草种、柠挑草种、沙打旺草种、锦鸡儿草种、老芒麦草种、羊柴草种、花卉种球、唐菖蒲种球、百合种球、郁金香种球、水仙种球、马蹄莲种球、大丽花种球、美人蕉种球、风信子种球、小苍兰种球、球根鸢尾种球、晚香玉种球、花卉种子、一串红种子、矮牵牛种子、万寿菊种子、凤仙花种子、鸡冠花种子、三色堇种子、金鱼草种子、石竹种子、翠菊种子、四季秋海棠种子、花卉种苗、香石竹种苗、菊花种苗、非洲菊种苗、月季种苗、火鹤种苗、兰花种苗、君子兰种苗",
                                        "taxName": "种子种苗",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010119070000000000",
                                        "taxCodeTitle": "种子种苗",
                                        "iTitle": "*种子种苗*花草种",
                                        "children": []
                                    },
                                    {
                                        "id": "145",
                                        "linkid": "137",
                                        "code": "101011908",
                                        "paCode": "1010119",
                                        "yn": "N",
                                        "title": "水果籽",
                                        "alias": "水果籽",
                                        "about": "包括杏核、葡萄籽、其他水果籽。",
                                        "kws": "杏核、葡萄籽",
                                        "taxName": "种子种苗",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010119080000000000",
                                        "taxCodeTitle": "种子种苗",
                                        "iTitle": "*种子种苗*水果籽",
                                        "children": []
                                    },
                                    {
                                        "id": "146",
                                        "linkid": "137",
                                        "code": "101011999",
                                        "paCode": "1010119",
                                        "yn": "N",
                                        "title": "其他种子、种苗",
                                        "alias": "其他种子种苗",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "种子种苗",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010119990000000000",
                                        "taxCodeTitle": "种子种苗",
                                        "iTitle": "*种子种苗*其他种子、种苗",
                                        "children": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "id": "147",
                        "linkid": "2",
                        "code": "10102",
                        "paCode": "101",
                        "yn": "Y",
                        "title": "林业产品",
                        "alias": "林业产品",
                        "about": null,
                        "kws": null,
                        "taxName": "林业产品",
                        "taxRate": "",
                        "vip": "7",
                        "itaxRate": null,
                        "taxCode": "1010200000000000000",
                        "taxCodeTitle": "林业产品",
                        "iTitle": "*林业产品*林业产品",
                        "children": [
                            {
                                "id": "148",
                                "linkid": "147",
                                "code": "1010201",
                                "paCode": "10102",
                                "yn": "N",
                                "title": "育种和育苗",
                                "alias": "育种育苗",
                                "about": "包括林木种子（针叶乔木树种种子、阔叶乔木树种种子、其他林木种子）、灌木藤木相关林木种子、针叶乔木苗类、阔叶乔木苗类、果树苗、竹苗、灌木树苗。",
                                "kws": "林木种子、针叶乔木树种种子、杉树种子、柏树种子、松树种子、银杏种子、阔叶乔木树种种子、槭树类种子、枫树类种子、冬青树类种子、桦树类种子、木棉树类种子、榛树类种子、榆树类种子、楠木类种子、樟树类种子、相思类种子、壳斗科类种子、灌木、藤木、相关林木种子、灌木种子、蕃荔枝类灌木种子、夹竹桃类灌木种子、冬青类灌木种子、小檗类灌木种子、榛树类灌木种子、胡枝子灌木种子、沙棘类灌木种子",
                                "taxName": "林业产品",
                                "taxRate": "9%",
                                "vip": "7",
                                "itaxRate": "0.09",
                                "taxCode": "1010201000000000000",
                                "taxCodeTitle": "林业产品",
                                "iTitle": "*林业产品*育种和育苗",
                                "children": []
                            },
                            {
                                "id": "149",
                                "linkid": "147",
                                "code": "1010202",
                                "paCode": "10102",
                                "yn": "Y",
                                "title": "木材采伐产品",
                                "alias": "木材采伐产品",
                                "about": null,
                                "kws": "木材采伐产品",
                                "taxName": "林业产品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1010202000000000000",
                                "taxCodeTitle": "林业产品",
                                "iTitle": "*林业产品*木材采伐产品",
                                "children": [
                                    {
                                        "id": "150",
                                        "linkid": "149",
                                        "code": "101020201",
                                        "paCode": "1010202",
                                        "yn": "N",
                                        "title": "原木",
                                        "alias": "原木",
                                        "about": "指将砍伐倒的乔木去其枝芽,梢头或者皮的乔木、灌木,以及锯成一定长度的木段。",
                                        "kws": "针叶原木、红松原木、樟子松原木、白松原木、云杉原木、冷杉原木、辐射松原木、落叶松原木、马尾松原木、云南松原木、杉木原条、非针叶原木、栎木原木、橡木原木、山毛榉木原木、楠木原木、樟木原木、泡桐木原木、杨树原木、水曲柳原木、胡桃楸原木、柞木原木、桦木原木、榆木原木、柳木原木、椴木原木、桉树原木",
                                        "taxName": "林业产品",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010202010000000000",
                                        "taxCodeTitle": "林业产品",
                                        "iTitle": "*林业产品*原木",
                                        "children": []
                                    },
                                    {
                                        "id": "151",
                                        "linkid": "149",
                                        "code": "101020202",
                                        "paCode": "1010202",
                                        "yn": "N",
                                        "title": "小规格木材",
                                        "alias": "小规格木材",
                                        "about": "包括针叶木小规格木材、其他木小规格木材、木箍木、木劈条、木片及粗修整的木棒等。",
                                        "kws": "小规格木材、针叶木小规格木材、木箍木、木劈条、木片、木棒",
                                        "taxName": "林业产品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1010202020000000000",
                                        "taxCodeTitle": "林业产品",
                                        "iTitle": "*林业产品*小规格木材",
                                        "children": []
                                    },
                                    {
                                        "id": "152",
                                        "linkid": "149",
                                        "code": "101020203",
                                        "paCode": "1010202",
                                        "yn": "N",
                                        "title": "薪材",
                                        "alias": "薪材",
                                        "about": "一般是作为燃料或木炭原料的材种。",
                                        "kws": "薪材",
                                        "taxName": "林业产品",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010202030000000000",
                                        "taxCodeTitle": "林业产品",
                                        "iTitle": "*林业产品*薪材",
                                        "children": []
                                    },
                                    {
                                        "id": "153",
                                        "linkid": "149",
                                        "code": "101020204",
                                        "paCode": "1010202",
                                        "yn": "N",
                                        "title": "短条及细枝等",
                                        "alias": "短条及细枝等",
                                        "about": null,
                                        "kws": "短条、细枝、木片、木粒、木废料、木碎片、圆木段、圆木块、圆木片",
                                        "taxName": "林业产品",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010202040000000000",
                                        "taxCodeTitle": "林业产品",
                                        "iTitle": "*林业产品*短条及细枝等",
                                        "children": []
                                    },
                                    {
                                        "id": "154",
                                        "linkid": "149",
                                        "code": "101020299",
                                        "paCode": "1010202",
                                        "yn": "N",
                                        "title": "其他木材采伐产品",
                                        "alias": "其他木材采伐产品",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "林业产品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1010202990000000000",
                                        "taxCodeTitle": "林业产品",
                                        "iTitle": "*林业产品*其他木材采伐产品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "155",
                                "linkid": "147",
                                "code": "1010203",
                                "paCode": "10102",
                                "yn": "Y",
                                "title": "竹材采伐产品",
                                "alias": "竹材采伐产品",
                                "about": null,
                                "kws": "竹材采伐产品",
                                "taxName": "林业产品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1010203000000000000",
                                "taxCodeTitle": "林业产品",
                                "iTitle": "*林业产品*竹材采伐产品",
                                "children": [
                                    {
                                        "id": "156",
                                        "linkid": "155",
                                        "code": "101020301",
                                        "paCode": "1010203",
                                        "yn": "N",
                                        "title": "原竹",
                                        "alias": "原竹",
                                        "about": "指将砍倒的竹去其枝,梢或者叶的竹类植物,以及锯成一定长度的竹段。",
                                        "kws": "竹材、毛竹、撑蒿竹、水竹、淡竹、慈竹、红壳竹",
                                        "taxName": "林业产品",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010203010000000000",
                                        "taxCodeTitle": "林业产品",
                                        "iTitle": "*林业产品*原竹",
                                        "children": []
                                    },
                                    {
                                        "id": "157",
                                        "linkid": "155",
                                        "code": "101020399",
                                        "paCode": "1010203",
                                        "yn": "N",
                                        "title": "其他竹材采伐产品",
                                        "alias": "其他竹材采伐产品",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "林业产品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1010203990000000000",
                                        "taxCodeTitle": "林业产品",
                                        "iTitle": "*林业产品*其他竹材采伐产品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "158",
                                "linkid": "147",
                                "code": "1010204",
                                "paCode": "10102",
                                "yn": "Y",
                                "title": "林产品",
                                "alias": "林产品",
                                "about": null,
                                "kws": "林产品",
                                "taxName": "林业产品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1010204000000000000",
                                "taxCodeTitle": "林业产品",
                                "iTitle": "*林业产品*林产品",
                                "children": [
                                    {
                                        "id": "159",
                                        "linkid": "158",
                                        "code": "101020401",
                                        "paCode": "1010204",
                                        "yn": "N",
                                        "title": "天然橡胶",
                                        "alias": "天然橡胶",
                                        "about": "未加工的天然橡胶，包括天然橡胶乳、烟胶片、胶清片、白皱片、褐胶片、标准胶片、其他天然橡胶。",
                                        "kws": "天然橡胶、天然橡胶乳、烟胶片、胶清片、白皱片、褐胶片、标准胶片",
                                        "taxName": "林业产品",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010204010000000000",
                                        "taxCodeTitle": "林业产品",
                                        "iTitle": "*林业产品*天然橡胶",
                                        "children": []
                                    },
                                    {
                                        "id": "160",
                                        "linkid": "158",
                                        "code": "101020402",
                                        "paCode": "1010204",
                                        "yn": "N",
                                        "title": "天然树脂、树胶",
                                        "alias": "天然树脂、树胶",
                                        "about": "主要来源于植物渗（泌）出物的无定形半固体或固体有机物。包括天然生漆、天然松脂、虫胶、桃胶、冷杉胶、其他天然树脂、树胶。",
                                        "kws": "天然树脂、树胶、天然生漆、天然松脂、虫胶、桃胶、冷杉胶",
                                        "taxName": "林业产品",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010204020000000000",
                                        "taxCodeTitle": "林业产品",
                                        "iTitle": "*林业产品*天然树脂、树胶",
                                        "children": []
                                    },
                                    {
                                        "id": "161",
                                        "linkid": "158",
                                        "code": "101020403",
                                        "paCode": "1010204",
                                        "yn": "N",
                                        "title": "栲胶原料",
                                        "alias": "栲胶原料",
                                        "about": "用于栲胶工业性生产的富含单宁的木质、皮层、叶子、荚壳等。包括落叶松树皮、杨梅树皮、油柑树皮、檞树皮、木麻黄树皮、黑荆树皮、橡碗、化香果、其他栲胶原料。",
                                        "kws": "栲胶原料、落叶松树皮、杨梅树皮、油柑树皮、檞树皮、木麻黄树皮、黑荆树皮、橡碗、化香果",
                                        "taxName": "林业产品",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010204030000000000",
                                        "taxCodeTitle": "林业产品",
                                        "iTitle": "*林业产品*栲胶原料",
                                        "children": []
                                    },
                                    {
                                        "id": "162",
                                        "linkid": "158",
                                        "code": "101020404",
                                        "paCode": "1010204",
                                        "yn": "N",
                                        "title": "非直接食用果类",
                                        "alias": "非直接食用果类",
                                        "about": "包括油桐籽、油茶籽、沙棘果、油棕果、乌桕子、油橄榄、文冠果、山苍籽、黑椋子、其他非食用坚果。",
                                        "kws": "非直接食用果类、桐籽、油茶籽、沙棘果、油棕果、乌桕子、油橄榄、文冠果、山苍籽、黑椋子、非食用坚果",
                                        "taxName": "林业产品",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010204040000000000",
                                        "taxCodeTitle": "林业产品",
                                        "iTitle": "*林业产品*非直接食用果类",
                                        "children": []
                                    },
                                    {
                                        "id": "163",
                                        "linkid": "158",
                                        "code": "101020405",
                                        "paCode": "1010204",
                                        "yn": "N",
                                        "title": "编结用原料",
                                        "alias": "编结用原料",
                                        "about": "包括藤条、柳条、柠条、荆条、桑条、灯心草、菖蒲、葵叶、其他编织用原料。",
                                        "kws": "编结用原料、藤条、柳条、柠条、荆条、桑条、灯心草、菖蒲、葵叶",
                                        "taxName": "林业产品",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010204050000000000",
                                        "taxCodeTitle": "林业产品",
                                        "iTitle": "*林业产品*编结用原料",
                                        "children": []
                                    },
                                    {
                                        "id": "164",
                                        "linkid": "158",
                                        "code": "101020406",
                                        "paCode": "1010204",
                                        "yn": "N",
                                        "title": "染色、鞣革用植物原料",
                                        "alias": "染色、鞣革用植物原料",
                                        "about": "包括五倍子、地衣、蓝靛、薯茛、其他染色、鞣革用植物原料。",
                                        "kws": "染色鞣革用植物原料、五倍子、地衣、蓝靛、薯茛",
                                        "taxName": "林业产品",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010204060000000000",
                                        "taxCodeTitle": "林业产品",
                                        "iTitle": "*林业产品*染色、鞣革用植物原料",
                                        "children": []
                                    },
                                    {
                                        "id": "165",
                                        "linkid": "158",
                                        "code": "101020407",
                                        "paCode": "1010204",
                                        "yn": "N",
                                        "title": "野生植物活体",
                                        "alias": "野生植物活体",
                                        "about": "包括野生乔木、灌木、草灌木、菌类、以及其他野生植物活体。",
                                        "kws": "野生植物活体、野生乔木、灌木、草灌木、菌类",
                                        "taxName": "林业产品",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010204070000000000",
                                        "taxCodeTitle": "林业产品",
                                        "iTitle": "*林业产品*野生植物活体",
                                        "children": []
                                    },
                                    {
                                        "id": "166",
                                        "linkid": "158",
                                        "code": "101020408",
                                        "paCode": "1010204",
                                        "yn": "N",
                                        "title": "野生植物采集产品",
                                        "alias": "野生植物采集产品",
                                        "about": "包括野生植物根、茎、叶、花、果实、以及其他野生植物采集产品。",
                                        "kws": "野生植物采集产品、野生植物根、茎、叶、花、果实",
                                        "taxName": "林业产品",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010204080000000000",
                                        "taxCodeTitle": "林业产品",
                                        "iTitle": "*林业产品*野生植物采集产品",
                                        "children": []
                                    },
                                    {
                                        "id": "167",
                                        "linkid": "158",
                                        "code": "101020499",
                                        "paCode": "1010204",
                                        "yn": "N",
                                        "title": "其他林产品",
                                        "alias": "其他林产品",
                                        "about": "未加工天然软木、棕片、竹笋干、黄柏桕、山苍子、桉树叶、其他未列明林产品。",
                                        "kws": "天然软木、棕片、竹笋干、黄柏桕、山苍子、桉树叶",
                                        "taxName": "林业产品",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010204990000000000",
                                        "taxCodeTitle": "林业产品",
                                        "iTitle": "*林业产品*其他林产品",
                                        "children": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "id": "168",
                        "linkid": "2",
                        "code": "10103",
                        "paCode": "101",
                        "yn": "Y",
                        "title": "饲养动物、野生动物及其产品",
                        "alias": "饲养动物、野生动物及其产品",
                        "about": "指饲养的家畜、家禽、为经济等目的饲养的各种动物、捕获动物以及动物产品，不包括人工养殖的鱼类、虾类、蟹类、贝类等（详见10104）。",
                        "kws": null,
                        "taxName": "动物及其产品",
                        "taxRate": "",
                        "vip": "7",
                        "itaxRate": null,
                        "taxCode": "1010300000000000000",
                        "taxCodeTitle": "动物及其产品",
                        "iTitle": "*动物及其产品*饲养动物、野生动物及其产品",
                        "children": [
                            {
                                "id": "169",
                                "linkid": "168",
                                "code": "1010301",
                                "paCode": "10103",
                                "yn": "Y",
                                "title": "活牲畜",
                                "alias": "活牲畜",
                                "about": "指为某种用途所饲养的家畜、包括菜畜、奶牛和役畜。",
                                "kws": "菜畜、奶牛、役畜",
                                "taxName": "活牲畜",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1010301000000000000",
                                "taxCodeTitle": "活牲畜",
                                "iTitle": "*活牲畜*活牲畜",
                                "children": [
                                    {
                                        "id": "170",
                                        "linkid": "169",
                                        "code": "101030101",
                                        "paCode": "1010301",
                                        "yn": "N",
                                        "title": "猪",
                                        "alias": "猪",
                                        "about": "包括种猪、仔猪、中猪、能繁殖母猪、其他活猪。",
                                        "kws": "猪、仔猪、中猪、能繁殖母猪",
                                        "taxName": "活牲畜",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010301010000000000",
                                        "taxCodeTitle": "活牲畜",
                                        "iTitle": "*活牲畜*猪",
                                        "children": []
                                    },
                                    {
                                        "id": "171",
                                        "linkid": "169",
                                        "code": "101030102",
                                        "paCode": "1010301",
                                        "yn": "N",
                                        "title": "牛",
                                        "alias": "牛",
                                        "about": "包括种牛、黄牛、水牛、奶牛、牦牛、牛犊、能繁殖母牛、其他活牛。",
                                        "kws": "牛、黄牛、水牛、奶牛、牦牛、牛犊、能繁殖母牛",
                                        "taxName": "活牲畜",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010301020000000000",
                                        "taxCodeTitle": "活牲畜",
                                        "iTitle": "*活牲畜*牛",
                                        "children": []
                                    },
                                    {
                                        "id": "172",
                                        "linkid": "169",
                                        "code": "101030103",
                                        "paCode": "1010301",
                                        "yn": "N",
                                        "title": "马",
                                        "alias": "马",
                                        "about": "包括种马、马驹、其他活马。",
                                        "kws": "马、种马、马驹",
                                        "taxName": "活牲畜",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010301030000000000",
                                        "taxCodeTitle": "活牲畜",
                                        "iTitle": "*活牲畜*马",
                                        "children": []
                                    },
                                    {
                                        "id": "173",
                                        "linkid": "169",
                                        "code": "101030104",
                                        "paCode": "1010301",
                                        "yn": "N",
                                        "title": "驴",
                                        "alias": "驴",
                                        "about": "包括种驴、其他驴。",
                                        "kws": "驴、种驴",
                                        "taxName": "活牲畜",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010301040000000000",
                                        "taxCodeTitle": "活牲畜",
                                        "iTitle": "*活牲畜*驴",
                                        "children": []
                                    },
                                    {
                                        "id": "174",
                                        "linkid": "169",
                                        "code": "101030105",
                                        "paCode": "1010301",
                                        "yn": "N",
                                        "title": "骡",
                                        "alias": "骡",
                                        "about": null,
                                        "kws": "骡",
                                        "taxName": "活牲畜",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010301050000000000",
                                        "taxCodeTitle": "活牲畜",
                                        "iTitle": "*活牲畜*骡",
                                        "children": []
                                    },
                                    {
                                        "id": "175",
                                        "linkid": "169",
                                        "code": "101030106",
                                        "paCode": "1010301",
                                        "yn": "N",
                                        "title": "羊",
                                        "alias": "羊",
                                        "about": "包括绵羊、山羊、能繁殖母羊、羔羊等。",
                                        "kws": "绵羊、细毛羊、半细毛羊、种绵羊、能繁殖母绵羊、山羊、种山羊、奶山羊、种绒山羊、绒山羊、能繁殖母山羊、能繁殖母羊、羔羊",
                                        "taxName": "活牲畜",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010301060000000000",
                                        "taxCodeTitle": "活牲畜",
                                        "iTitle": "*活牲畜*羊",
                                        "children": []
                                    },
                                    {
                                        "id": "176",
                                        "linkid": "169",
                                        "code": "101030107",
                                        "paCode": "1010301",
                                        "yn": "N",
                                        "title": "骆驼",
                                        "alias": "骆驼",
                                        "about": null,
                                        "kws": "骆驼",
                                        "taxName": "活牲畜",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010301070000000000",
                                        "taxCodeTitle": "活牲畜",
                                        "iTitle": "*活牲畜*骆驼",
                                        "children": []
                                    },
                                    {
                                        "id": "177",
                                        "linkid": "169",
                                        "code": "101030199",
                                        "paCode": "1010301",
                                        "yn": "N",
                                        "title": "其他活牲畜",
                                        "alias": "其他活牲畜",
                                        "about": null,
                                        "kws": "活牲畜",
                                        "taxName": "活牲畜",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010301990000000000",
                                        "taxCodeTitle": "活牲畜",
                                        "iTitle": "*活牲畜*其他活牲畜",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "178",
                                "linkid": "168",
                                "code": "1010302",
                                "paCode": "10103",
                                "yn": "Y",
                                "title": "活家禽",
                                "alias": "活家禽",
                                "about": "指主要用于食用的活家禽。",
                                "kws": null,
                                "taxName": "活家禽",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1010302000000000000",
                                "taxCodeTitle": "活家禽",
                                "iTitle": "*活家禽*活家禽",
                                "children": [
                                    {
                                        "id": "179",
                                        "linkid": "178",
                                        "code": "101030201",
                                        "paCode": "1010302",
                                        "yn": "N",
                                        "title": "活鸡",
                                        "alias": "活鸡",
                                        "about": "包括蛋鸡、雏鸡、肉鸡、其他活鸡。",
                                        "kws": "活鸡、蛋鸡、种蛋鸡、雏鸡、种雏鸡、肉鸡、种肉鸡、未列明活鸡",
                                        "taxName": "活家禽",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010302010000000000",
                                        "taxCodeTitle": "活家禽",
                                        "iTitle": "*活家禽*活鸡",
                                        "children": []
                                    },
                                    {
                                        "id": "180",
                                        "linkid": "178",
                                        "code": "101030202",
                                        "paCode": "1010302",
                                        "yn": "N",
                                        "title": "活鸭",
                                        "alias": "活鸭",
                                        "about": "包括雏鸭、成鸭。",
                                        "kws": "雏鸭、种用雏鸭、成鸭、种用成鸭",
                                        "taxName": "活家禽",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010302020000000000",
                                        "taxCodeTitle": "活家禽",
                                        "iTitle": "*活家禽*活鸭",
                                        "children": []
                                    },
                                    {
                                        "id": "181",
                                        "linkid": "178",
                                        "code": "101030203",
                                        "paCode": "1010302",
                                        "yn": "N",
                                        "title": "活鹅",
                                        "alias": "活鹅",
                                        "about": "包括雏鹅、成鹅。",
                                        "kws": "雏鹅、种用雏鹅、成鹅、种用成鹅",
                                        "taxName": "活家禽",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010302030000000000",
                                        "taxCodeTitle": "活家禽",
                                        "iTitle": "*活家禽*活鹅",
                                        "children": []
                                    },
                                    {
                                        "id": "182",
                                        "linkid": "178",
                                        "code": "101030299",
                                        "paCode": "1010302",
                                        "yn": "N",
                                        "title": "其他活家禽",
                                        "alias": "其他活家禽",
                                        "about": "包括鸽子、鸵鸟、野鸭、鹌鹑、其他未列明活家禽。",
                                        "kws": "鸽子、鸵鸟、野鸭、鹌鹑、未列明活家禽",
                                        "taxName": "活家禽",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010302990000000000",
                                        "taxCodeTitle": "活家禽",
                                        "iTitle": "*活家禽*其他活家禽",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "183",
                                "linkid": "168",
                                "code": "1010303",
                                "paCode": "10103",
                                "yn": "Y",
                                "title": "畜禽产品",
                                "alias": "畜禽产品",
                                "about": null,
                                "kws": null,
                                "taxName": "畜禽产品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1010303000000000000",
                                "taxCodeTitle": "畜禽产品",
                                "iTitle": "*畜禽产品*畜禽产品",
                                "children": [
                                    {
                                        "id": "184",
                                        "linkid": "183",
                                        "code": "101030301",
                                        "paCode": "1010303",
                                        "yn": "N",
                                        "title": "生奶",
                                        "alias": "生奶",
                                        "about": "指未经过消毒和杀菌的奶。包括生牛奶、生羊奶、生马奶等。",
                                        "kws": "生奶、生牛奶、生羊奶、生马奶、奶酪、黄油",
                                        "taxName": "畜禽产品",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010303010000000000",
                                        "taxCodeTitle": "畜禽产品",
                                        "iTitle": "*畜禽产品*生奶",
                                        "children": []
                                    },
                                    {
                                        "id": "185",
                                        "linkid": "183",
                                        "code": "101030302",
                                        "paCode": "1010303",
                                        "yn": "Y",
                                        "title": "禽蛋",
                                        "alias": "禽蛋",
                                        "about": "指未加工的带壳鲜禽蛋。",
                                        "kws": "禽蛋",
                                        "taxName": "畜禽产品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1010303020000000000",
                                        "taxCodeTitle": "畜禽产品",
                                        "iTitle": "*畜禽产品*禽蛋",
                                        "children": [
                                            {
                                                "id": "186",
                                                "linkid": "185",
                                                "code": "10103030201",
                                                "paCode": "101030302",
                                                "yn": "N",
                                                "title": "鸡蛋",
                                                "alias": "鸡蛋",
                                                "about": null,
                                                "kws": "种用鸡蛋、鲜鸡蛋",
                                                "taxName": "畜禽产品",
                                                "taxRate": "9%",
                                                "vip": "5",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010303020100000000",
                                                "taxCodeTitle": "畜禽产品",
                                                "iTitle": "*畜禽产品*鸡蛋",
                                                "children": []
                                            },
                                            {
                                                "id": "187",
                                                "linkid": "185",
                                                "code": "10103030202",
                                                "paCode": "101030302",
                                                "yn": "N",
                                                "title": "鸭蛋",
                                                "alias": "鸭蛋",
                                                "about": null,
                                                "kws": "种用鸭蛋、鲜鸭蛋",
                                                "taxName": "畜禽产品",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010303020200000000",
                                                "taxCodeTitle": "畜禽产品",
                                                "iTitle": "*畜禽产品*鸭蛋",
                                                "children": []
                                            },
                                            {
                                                "id": "188",
                                                "linkid": "185",
                                                "code": "10103030203",
                                                "paCode": "101030302",
                                                "yn": "N",
                                                "title": "鹅蛋",
                                                "alias": "鹅蛋",
                                                "about": null,
                                                "kws": "种用鹅蛋、鲜鹅蛋",
                                                "taxName": "畜禽产品",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010303020300000000",
                                                "taxCodeTitle": "畜禽产品",
                                                "iTitle": "*畜禽产品*鹅蛋",
                                                "children": []
                                            },
                                            {
                                                "id": "189",
                                                "linkid": "185",
                                                "code": "10103030204",
                                                "paCode": "101030302",
                                                "yn": "N",
                                                "title": "鹌鹑蛋",
                                                "alias": "鹌鹑蛋",
                                                "about": "又名鹑鸟蛋。",
                                                "kws": "种用鹌鹑蛋、鲜鹌鹑蛋",
                                                "taxName": "畜禽产品",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010303020400000000",
                                                "taxCodeTitle": "畜禽产品",
                                                "iTitle": "*畜禽产品*鹌鹑蛋",
                                                "children": []
                                            },
                                            {
                                                "id": "190",
                                                "linkid": "185",
                                                "code": "10103030299",
                                                "paCode": "101030302",
                                                "yn": "N",
                                                "title": "其他禽蛋",
                                                "alias": "其他禽蛋",
                                                "about": null,
                                                "kws": "其他禽蛋",
                                                "taxName": "畜禽产品",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010303029900000000",
                                                "taxCodeTitle": "畜禽产品",
                                                "iTitle": "*畜禽产品*其他禽蛋",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "191",
                                        "linkid": "183",
                                        "code": "101030303",
                                        "paCode": "1010303",
                                        "yn": "Y",
                                        "title": "天然蜂蜜及副产品",
                                        "alias": "天然蜂蜜",
                                        "about": "天然蜂蜜、蜂蜡、鲜蜂王浆、其他天然蜂蜜及副产品。",
                                        "kws": "天然蜂蜜、蜂蜡、鲜蜂王浆、鲜蜂王浆粉",
                                        "taxName": "畜禽产品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1010303030000000000",
                                        "taxCodeTitle": "畜禽产品",
                                        "iTitle": "*畜禽产品*天然蜂蜜及副产品",
                                        "children": [
                                            {
                                                "id": "192",
                                                "linkid": "191",
                                                "code": "10103030301",
                                                "paCode": "101030303",
                                                "yn": "N",
                                                "title": "天然蜂蜜",
                                                "alias": "天然蜂蜜",
                                                "about": null,
                                                "kws": "天然蜂蜜",
                                                "taxName": "畜禽产品",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010303030100000000",
                                                "taxCodeTitle": "畜禽产品",
                                                "iTitle": "*畜禽产品*天然蜂蜜",
                                                "children": []
                                            },
                                            {
                                                "id": "193",
                                                "linkid": "191",
                                                "code": "10103030302",
                                                "paCode": "101030303",
                                                "yn": "N",
                                                "title": "蜂蜡",
                                                "alias": "蜂蜡",
                                                "about": "蜂蜡是工蜂腹部下面四对蜡腺分泌的物质。",
                                                "kws": "蜂蜡",
                                                "taxName": "畜禽产品",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010303030200000000",
                                                "taxCodeTitle": "畜禽产品",
                                                "iTitle": "*畜禽产品*蜂蜡",
                                                "children": []
                                            },
                                            {
                                                "id": "194",
                                                "linkid": "191",
                                                "code": "10103030303",
                                                "paCode": "101030303",
                                                "yn": "N",
                                                "title": "鲜蜂王浆",
                                                "alias": "鲜蜂王浆",
                                                "about": "又称蜂皇浆、蜂王乳等、是工蜂的一种分泌物、喂蜂后的食物。",
                                                "kws": "鲜蜂王浆、蜂皇浆、蜂王乳",
                                                "taxName": "畜禽产品",
                                                "taxRate": "9%",
                                                "vip": "5",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010303030300000000",
                                                "taxCodeTitle": "畜禽产品",
                                                "iTitle": "*畜禽产品*鲜蜂王浆",
                                                "children": []
                                            },
                                            {
                                                "id": "195",
                                                "linkid": "191",
                                                "code": "10103030399",
                                                "paCode": "101030303",
                                                "yn": "N",
                                                "title": "其他天然蜂蜜及副产品",
                                                "alias": "其他天然蜂蜜",
                                                "about": null,
                                                "kws": "其他天然蜂蜜、其他天然蜂蜜副产品",
                                                "taxName": "畜禽产品",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1010303039900000000",
                                                "taxCodeTitle": "畜禽产品",
                                                "iTitle": "*畜禽产品*其他天然蜂蜜及副产品",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "196",
                                        "linkid": "183",
                                        "code": "101030304",
                                        "paCode": "1010303",
                                        "yn": "N",
                                        "title": "蚕茧",
                                        "alias": "蚕茧",
                                        "about": "指适于缫丝的丝茧。包括桑蚕茧、柞蚕茧、蓖麻蚕茧、其他蚕茧。",
                                        "kws": "蚕茧、桑蚕茧、柞蚕茧、蓖麻蚕茧",
                                        "taxName": "畜禽产品",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010303040000000000",
                                        "taxCodeTitle": "畜禽产品",
                                        "iTitle": "*畜禽产品*蚕茧",
                                        "children": []
                                    },
                                    {
                                        "id": "197",
                                        "linkid": "183",
                                        "code": "101030305",
                                        "paCode": "1010303",
                                        "yn": "N",
                                        "title": "动物毛类",
                                        "alias": "动物毛类",
                                        "about": "指未梳毛。包括绵羊毛、山羊毛、山羊粗毛、牦牛毛、兔毛、骆驼毛、马毛、其他动物毛类。",
                                        "kws": "绵羊毛、细羊毛、半细羊毛、剪羊毛、山羊毛、山羊粗毛、山羊绒、牦牛毛、粗牦牛毛、牦牛绒、兔毛、骆驼毛、骆驼粗毛、骆驼绒、马毛、马鬃、马尾",
                                        "taxName": "畜禽产品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1010303050000000000",
                                        "taxCodeTitle": "畜禽产品",
                                        "iTitle": "*畜禽产品*动物毛类",
                                        "children": []
                                    },
                                    {
                                        "id": "198",
                                        "linkid": "183",
                                        "code": "101030306",
                                        "paCode": "1010303",
                                        "yn": "N",
                                        "title": "生皮",
                                        "alias": "生皮",
                                        "about": "指经简单干燥的整张动物生皮、包括整张生牛皮、整张绵羊生皮、整张山羊生皮、整张生猪皮、整张生马皮、整张爬行动物皮、其他生皮，不包括生毛皮（详见101030307）、半成品革（详见1040301）。",
                                        "kws": "生皮、整张生牛皮、整张黄牛生皮、整张水牛生皮、整张绵羊生皮、整张带毛绵羊生皮、整张不带毛绵羊生皮、整张山羊生皮、整张山羊板皮、整张生猪皮、整张生马皮、整张爬行动物皮",
                                        "taxName": "畜禽产品",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010303060000000000",
                                        "taxCodeTitle": "畜禽产品",
                                        "iTitle": "*畜禽产品*生皮",
                                        "children": []
                                    },
                                    {
                                        "id": "199",
                                        "linkid": "183",
                                        "code": "101030307",
                                        "paCode": "1010303",
                                        "yn": "N",
                                        "title": "生毛皮",
                                        "alias": "生毛皮",
                                        "about": "指未经鞣制或硝制的整张动物毛皮、整张羔羊生毛皮、整张水貂生毛皮、整张狐生毛皮、整张兔生毛皮、其他生毛皮，不包括生皮（详见101030306）、鞣制毛皮（详见104030601）。",
                                        "kws": "生毛皮、整张羔羊生毛皮、整张水貂生毛皮、整张狐生毛皮、整张兔生毛皮",
                                        "taxName": "畜禽产品",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010303070000000000",
                                        "taxCodeTitle": "畜禽产品",
                                        "iTitle": "*畜禽产品*生毛皮",
                                        "children": []
                                    },
                                    {
                                        "id": "200",
                                        "linkid": "183",
                                        "code": "101030308",
                                        "paCode": "1010303",
                                        "yn": "N",
                                        "title": "制刷用兽毛",
                                        "alias": "制刷用兽毛",
                                        "about": "包括猪鬃、制刷用山羊毛、其他制刷用兽毛、猪鬃、猪毛及其废料。",
                                        "kws": "制刷用兽毛、猪鬃、制刷用山羊毛",
                                        "taxName": "畜禽产品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1010303080000000000",
                                        "taxCodeTitle": "畜禽产品",
                                        "iTitle": "*畜禽产品*制刷用兽毛",
                                        "children": []
                                    },
                                    {
                                        "id": "201",
                                        "linkid": "183",
                                        "code": "101030309",
                                        "paCode": "1010303",
                                        "yn": "N",
                                        "title": "麝香",
                                        "alias": "麝香",
                                        "about": "为雄麝的肚脐和生殖器之间的腺囊的分泌物、干燥后呈颗粒状或块状。",
                                        "kws": "麝香",
                                        "taxName": "畜禽产品",
                                        "taxRate": "9%",
                                        "vip": "5",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010303090000000000",
                                        "taxCodeTitle": "畜禽产品",
                                        "iTitle": "*畜禽产品*麝香",
                                        "children": []
                                    },
                                    {
                                        "id": "202",
                                        "linkid": "183",
                                        "code": "101030310",
                                        "paCode": "1010303",
                                        "yn": "N",
                                        "title": "鹿茸",
                                        "alias": "鹿茸",
                                        "about": "雄鹿没有长成硬骨时、带茸毛、含血液的嫩角。",
                                        "kws": "鹿茸",
                                        "taxName": "畜禽产品",
                                        "taxRate": "9%",
                                        "vip": "5",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010303100000000000",
                                        "taxCodeTitle": "畜禽产品",
                                        "iTitle": "*畜禽产品*鹿茸",
                                        "children": []
                                    },
                                    {
                                        "id": "203",
                                        "linkid": "183",
                                        "code": "101030311",
                                        "paCode": "1010303",
                                        "yn": "N",
                                        "title": "燕窝",
                                        "alias": "燕窝",
                                        "about": "又称燕菜、燕根、燕蔬菜、为雨燕科动物金丝燕及多种同属燕类用唾液与绒羽等混合凝结所筑成的巢窝。",
                                        "kws": "燕窝、燕根、燕蔬菜",
                                        "taxName": "畜禽产品",
                                        "taxRate": "",
                                        "vip": "5",
                                        "itaxRate": null,
                                        "taxCode": "1010303110000000000",
                                        "taxCodeTitle": "畜禽产品",
                                        "iTitle": "*畜禽产品*燕窝",
                                        "children": []
                                    },
                                    {
                                        "id": "204",
                                        "linkid": "183",
                                        "code": "101030399",
                                        "paCode": "1010303",
                                        "yn": "N",
                                        "title": "其他畜禽产品",
                                        "alias": "其他畜禽产品",
                                        "about": null,
                                        "kws": "其他畜禽产品",
                                        "taxName": "畜禽产品",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010303990000000000",
                                        "taxCodeTitle": "畜禽产品",
                                        "iTitle": "*畜禽产品*其他畜禽产品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "205",
                                "linkid": "168",
                                "code": "1010304",
                                "paCode": "10103",
                                "yn": "Y",
                                "title": "野生动物禽类",
                                "alias": "野生动物禽类",
                                "about": null,
                                "kws": null,
                                "taxName": "野生动物",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1010304000000000000",
                                "taxCodeTitle": "野生动物",
                                "iTitle": "*野生动物*野生动物禽类",
                                "children": [
                                    {
                                        "id": "206",
                                        "linkid": "205",
                                        "code": "101030401",
                                        "paCode": "1010304",
                                        "yn": "N",
                                        "title": "野生动物",
                                        "alias": "野生动物",
                                        "about": "是指生存于自然状态下、野外环境生长繁殖的动物。包括野兔、狐狸、其他野生动物。",
                                        "kws": "野生动物、野兔、狐狸",
                                        "taxName": "野生动物",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010304010000000000",
                                        "taxCodeTitle": "野生动物",
                                        "iTitle": "*野生动物*野生动物",
                                        "children": []
                                    },
                                    {
                                        "id": "207",
                                        "linkid": "205",
                                        "code": "101030402",
                                        "paCode": "1010304",
                                        "yn": "N",
                                        "title": "野生鸟类",
                                        "alias": "野生鸟类",
                                        "about": "包括水禽、雉鸡、野鸡、其他野生鸟类。",
                                        "kws": "野生鸟类、水禽、雉鸡、野鸡",
                                        "taxName": "野生动物",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010304020000000000",
                                        "taxCodeTitle": "野生动物",
                                        "iTitle": "*野生动物*野生鸟类",
                                        "children": []
                                    },
                                    {
                                        "id": "208",
                                        "linkid": "205",
                                        "code": "101030499",
                                        "paCode": "1010304",
                                        "yn": "N",
                                        "title": "其他野生动物",
                                        "alias": "其他野生动物",
                                        "about": null,
                                        "kws": "其他野生动物",
                                        "taxName": "野生动物",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1010304990000000000",
                                        "taxCodeTitle": "野生动物",
                                        "iTitle": "*野生动物*其他野生动物",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "209",
                                "linkid": "168",
                                "code": "1010399",
                                "paCode": "10103",
                                "yn": "N",
                                "title": "其他饲养动物",
                                "alias": "其他饲养动物",
                                "about": "包括人工饲养或野生的其他珍禽动物。",
                                "kws": "其他饲养动物",
                                "taxName": "野生动物",
                                "taxRate": "9%",
                                "vip": "7",
                                "itaxRate": "0.09",
                                "taxCode": "1010399000000000000",
                                "taxCodeTitle": "野生动物",
                                "iTitle": "*野生动物*其他饲养动物",
                                "children": []
                            }
                        ]
                    },
                    {
                        "id": "210",
                        "linkid": "2",
                        "code": "10104",
                        "paCode": "101",
                        "yn": "Y",
                        "title": "海水养殖、捕捞产品",
                        "alias": "海水养殖捕捞产品",
                        "about": "包括海水养殖产品和海水捕捞产品。",
                        "kws": "海水养殖产品、海水捕捞产品",
                        "taxName": "海水产品",
                        "taxRate": "",
                        "vip": "7",
                        "itaxRate": null,
                        "taxCode": "1010400000000000000",
                        "taxCodeTitle": "海水产品",
                        "iTitle": "*海水产品*海水养殖、捕捞产品",
                        "children": [
                            {
                                "id": "211",
                                "linkid": "210",
                                "code": "1010401",
                                "paCode": "10104",
                                "yn": "N",
                                "title": "海水鱼",
                                "alias": "海水鱼",
                                "about": "包括大黄鱼、小黄鱼、带鱼、鳓鱼、比目鱼、金枪鱼、鳕鱼、沙丁鱼、鲑鱼、大马哈鱼、角鲨、相关鲨鱼、海鳗、鳀鱼、鲳鱼、鲱鱼、石斑鱼、蓝圆鲹、白姑鱼、黄姑鱼、梅童鱼、方头鱼、玉筋鱼、梭鱼、鲻鱼、鲐鱼、鲅鱼、马面鲀、竹荚鱼等。",
                                "kws": "大黄鱼、小黄鱼、带鱼、鳓鱼、比目鱼、金枪鱼、鳕鱼、沙丁鱼、鲑鱼、大马哈鱼、角鲨、相关鲨鱼、海鳗、鳀鱼、鲳鱼、鲱鱼、石斑鱼、蓝圆鲹、白姑鱼、黄姑鱼、梅童鱼、方头鱼、玉筋鱼、梭鱼、鲻鱼、鲐鱼、鲅鱼、马面鲀、竹荚鱼",
                                "taxName": "海水产品",
                                "taxRate": "9%",
                                "vip": "5",
                                "itaxRate": "0.09",
                                "taxCode": "1010401000000000000",
                                "taxCodeTitle": "海水产品",
                                "iTitle": "*海水产品*海水鱼",
                                "children": []
                            },
                            {
                                "id": "212",
                                "linkid": "210",
                                "code": "1010402",
                                "paCode": "10104",
                                "yn": "N",
                                "title": "海水虾",
                                "alias": "海水虾",
                                "about": "包括龙虾、斑节对虾、中国对虾、日本对虾、毛虾、虾蛄、鹰爪虾等。",
                                "kws": "龙虾、斑节对虾、中国对虾、日本对虾、毛虾、虾蛄、鹰爪虾",
                                "taxName": "海水产品",
                                "taxRate": "9%",
                                "vip": "5",
                                "itaxRate": "0.09",
                                "taxCode": "1010402000000000000",
                                "taxCodeTitle": "海水产品",
                                "iTitle": "*海水产品*海水虾",
                                "children": []
                            },
                            {
                                "id": "213",
                                "linkid": "210",
                                "code": "1010403",
                                "paCode": "10104",
                                "yn": "N",
                                "title": "海水蟹",
                                "alias": "海水蟹",
                                "about": "包括梭子蟹、青蟹等。",
                                "kws": "梭子蟹、青蟹",
                                "taxName": "海水产品",
                                "taxRate": "9%",
                                "vip": "5",
                                "itaxRate": "0.09",
                                "taxCode": "1010403000000000000",
                                "taxCodeTitle": "海水产品",
                                "iTitle": "*海水产品*海水蟹",
                                "children": []
                            },
                            {
                                "id": "214",
                                "linkid": "210",
                                "code": "1010404",
                                "paCode": "10104",
                                "yn": "N",
                                "title": "海水贝类",
                                "alias": "海水贝类",
                                "about": "包括牡蛎、扇贝、贻贝、江珧、鲍、螺、蚶、蛤、蛏等。",
                                "kws": "牡蛎、扇贝、贻贝、江珧、鲍、螺、蚶、蛤、蛏",
                                "taxName": "海水产品",
                                "taxRate": "9%",
                                "vip": "5",
                                "itaxRate": "0.09",
                                "taxCode": "1010404000000000000",
                                "taxCodeTitle": "海水产品",
                                "iTitle": "*海水产品*海水贝类",
                                "children": []
                            },
                            {
                                "id": "215",
                                "linkid": "210",
                                "code": "1010405",
                                "paCode": "10104",
                                "yn": "N",
                                "title": "海水藻类",
                                "alias": "海水藻类",
                                "about": "包括裙带菜、江蓠、麒麟菜、石花菜、羊栖菜、苔菜、其他藻类，不包括海带和紫菜（详见101011211）。",
                                "kws": "海带、紫菜、裙带菜、江蓠、麒麟菜、石花菜、羊栖菜、苔菜",
                                "taxName": "海水产品",
                                "taxRate": "9%",
                                "vip": "7",
                                "itaxRate": "0.09",
                                "taxCode": "1010405000000000000",
                                "taxCodeTitle": "海水产品",
                                "iTitle": "*海水产品*海水藻类",
                                "children": []
                            },
                            {
                                "id": "216",
                                "linkid": "210",
                                "code": "1010406",
                                "paCode": "10104",
                                "yn": "N",
                                "title": "海水软体水生动物",
                                "alias": "海水软体水生动物",
                                "about": "包括墨鱼、鱿鱼、沙蚕等。",
                                "kws": "墨鱼、鱿鱼、沙蚕",
                                "taxName": "海水产品",
                                "taxRate": "9%",
                                "vip": "7",
                                "itaxRate": "0.09",
                                "taxCode": "1010406000000000000",
                                "taxCodeTitle": "海水产品",
                                "iTitle": "*海水产品*海水软体水生动物",
                                "children": []
                            },
                            {
                                "id": "217",
                                "linkid": "210",
                                "code": "1010407",
                                "paCode": "10104",
                                "yn": "N",
                                "title": "海水产品种苗",
                                "alias": "海水产品种苗",
                                "about": "包括鱼苗、虾种苗、蟹苗、贝类种苗、藻类育苗等。",
                                "kws": "鱼苗、虾种苗、蟹苗、贝类种苗、藻类育苗",
                                "taxName": "海水产品",
                                "taxRate": "9%",
                                "vip": "7",
                                "itaxRate": "0.09",
                                "taxCode": "1010407000000000000",
                                "taxCodeTitle": "海水产品",
                                "iTitle": "*海水产品*海水产品种苗",
                                "children": []
                            },
                            {
                                "id": "218",
                                "linkid": "210",
                                "code": "1010499",
                                "paCode": "10104",
                                "yn": "N",
                                "title": "其他海水产品",
                                "alias": "其他海水产品",
                                "about": "包括海参、海胆、珍珠、海蜇等。",
                                "kws": "海参、海胆、珍珠、海蜇",
                                "taxName": "海水产品",
                                "taxRate": "9%",
                                "vip": "7",
                                "itaxRate": "0.09",
                                "taxCode": "1010499000000000000",
                                "taxCodeTitle": "海水产品",
                                "iTitle": "*海水产品*其他海水产品",
                                "children": []
                            }
                        ]
                    },
                    {
                        "id": "219",
                        "linkid": "2",
                        "code": "10105",
                        "paCode": "101",
                        "yn": "Y",
                        "title": "淡水养殖产品、捕捞产品",
                        "alias": "淡水养殖产品捕捞产品",
                        "about": "包括淡水养殖产品和捕捞产品。",
                        "kws": "淡水养殖产品、淡水捕捞产品",
                        "taxName": "淡水产品",
                        "taxRate": "",
                        "vip": "7",
                        "itaxRate": null,
                        "taxCode": "1010500000000000000",
                        "taxCodeTitle": "淡水产品",
                        "iTitle": "*淡水产品*淡水养殖产品、捕捞产品",
                        "children": [
                            {
                                "id": "220",
                                "linkid": "219",
                                "code": "1010501",
                                "paCode": "10105",
                                "yn": "N",
                                "title": "淡水鱼",
                                "alias": "淡水鱼",
                                "about": "包括淡水观赏鱼、淡水鳟鱼、淡水鳗鲡、淡水鲤鱼、淡水草鱼、淡水鳙鱼、淡水鲟鱼、淡水罗非鱼、淡水河鲀、淡水青鱼、淡水鲢鱼、淡水鲫鱼、淡水鳊鲂、淡水鲶鱼、淡水鮰鱼、淡水黄颡鱼、淡水鲑鱼、淡水池沼公鱼、淡水银鱼、淡水短盖巨脂鲤、淡水长吻鮠、淡水黄鳝、淡水鳜鱼、淡水鲈鱼、淡水乌鳢、淡水泥鳅等。",
                                "kws": "淡水观赏鱼、淡水鳟鱼、淡水鳗鲡、淡水鲤鱼、淡水草鱼、淡水鳙鱼、淡水鲟鱼、淡水罗非鱼、淡水河鲀、淡水青鱼、淡水鲢鱼、淡水鲫鱼、淡水鳊鲂、淡水鲶鱼、淡水鮰鱼、淡水黄颡鱼、淡水鲑鱼、淡水池沼公鱼、淡水银鱼、淡水短盖巨脂鲤、淡水长吻鮠、淡水黄鳝、淡水鳜鱼、淡水鲈鱼、淡水乌鳢、淡水泥鳅",
                                "taxName": "淡水产品",
                                "taxRate": "9%",
                                "vip": "5",
                                "itaxRate": "0.09",
                                "taxCode": "1010501000000000000",
                                "taxCodeTitle": "淡水产品",
                                "iTitle": "*淡水产品*淡水鱼",
                                "children": []
                            },
                            {
                                "id": "221",
                                "linkid": "219",
                                "code": "1010502",
                                "paCode": "10105",
                                "yn": "N",
                                "title": "淡水虾",
                                "alias": "淡水虾",
                                "about": "包括淡水罗氏沼虾、淡水青虾、淡水克氏原鳌虾、淡水南美白对虾等。",
                                "kws": "淡水罗氏沼虾、淡水青虾、淡水克氏原鳌虾、淡水南美白对虾",
                                "taxName": "淡水产品",
                                "taxRate": "9%",
                                "vip": "5",
                                "itaxRate": "0.09",
                                "taxCode": "1010502000000000000",
                                "taxCodeTitle": "淡水产品",
                                "iTitle": "*淡水产品*淡水虾",
                                "children": []
                            },
                            {
                                "id": "222",
                                "linkid": "219",
                                "code": "1010503",
                                "paCode": "10105",
                                "yn": "N",
                                "title": "淡水蟹",
                                "alias": "淡水蟹",
                                "about": "包括淡水蟹、华绒毛蟹等。",
                                "kws": "淡水蟹、华绒毛蟹",
                                "taxName": "淡水产品",
                                "taxRate": "9%",
                                "vip": "5",
                                "itaxRate": "0.09",
                                "taxCode": "1010503000000000000",
                                "taxCodeTitle": "淡水产品",
                                "iTitle": "*淡水产品*淡水蟹",
                                "children": []
                            },
                            {
                                "id": "223",
                                "linkid": "219",
                                "code": "1010504",
                                "paCode": "10105",
                                "yn": "N",
                                "title": "淡水贝类",
                                "alias": "淡水贝类",
                                "about": "包括淡水蚌、淡水螺、淡水蚬等。",
                                "kws": "淡水蚌、淡水螺、淡水蚬",
                                "taxName": "淡水产品",
                                "taxRate": "9%",
                                "vip": "7",
                                "itaxRate": "0.09",
                                "taxCode": "1010504000000000000",
                                "taxCodeTitle": "淡水产品",
                                "iTitle": "*淡水产品*淡水贝类",
                                "children": []
                            },
                            {
                                "id": "224",
                                "linkid": "219",
                                "code": "1010505",
                                "paCode": "10105",
                                "yn": "N",
                                "title": "淡水藻类",
                                "alias": "淡水藻类",
                                "about": null,
                                "kws": "淡水藻类",
                                "taxName": "淡水产品",
                                "taxRate": "9%",
                                "vip": "7",
                                "itaxRate": "0.09",
                                "taxCode": "1010505000000000000",
                                "taxCodeTitle": "淡水产品",
                                "iTitle": "*淡水产品*淡水藻类",
                                "children": []
                            },
                            {
                                "id": "225",
                                "linkid": "219",
                                "code": "1010506",
                                "paCode": "10105",
                                "yn": "N",
                                "title": "淡水鲜软体动物",
                                "alias": "淡水鲜软体动物",
                                "about": "包括水生无脊椎动物、蜗牛、螺、河蚌、蚬、其他淡水鲜软体动物、包括活、鲜、冷、冻、干、盐腌或盐渍蜗牛。",
                                "kws": "水生无脊椎动物、蜗牛、螺、河蚌、蚬、其他淡水鲜软体动物、活蜗牛、鲜蜗牛、冷蜗牛、冻蜗牛、干蜗牛、盐腌蜗牛、盐渍蜗牛",
                                "taxName": "淡水产品",
                                "taxRate": "9%",
                                "vip": "7",
                                "itaxRate": "0.09",
                                "taxCode": "1010506000000000000",
                                "taxCodeTitle": "淡水产品",
                                "iTitle": "*淡水产品*淡水鲜软体动物",
                                "children": []
                            },
                            {
                                "id": "226",
                                "linkid": "219",
                                "code": "1010507",
                                "paCode": "10105",
                                "yn": "N",
                                "title": "淡水产品种苗",
                                "alias": "淡水产品种苗",
                                "about": "包括淡水鱼苗、淡水虾苗、淡水蟹种苗、淡水贝壳种苗、淡水藻类种苗、其他淡水产品种苗。",
                                "kws": "淡水鱼苗、淡水虾苗、淡水蟹种苗、淡水贝壳种苗、淡水藻类种苗",
                                "taxName": "淡水产品",
                                "taxRate": "9%",
                                "vip": "7",
                                "itaxRate": "0.09",
                                "taxCode": "1010507000000000000",
                                "taxCodeTitle": "淡水产品",
                                "iTitle": "*淡水产品*淡水产品种苗",
                                "children": []
                            },
                            {
                                "id": "227",
                                "linkid": "219",
                                "code": "1010599",
                                "paCode": "10105",
                                "yn": "N",
                                "title": "其他淡水产品",
                                "alias": "其他淡水产品",
                                "about": "包括淡水龟、淡水鳖、淡水蛙、淡水珍珠、丰年虫、其他未列明淡水产品。",
                                "kws": "淡水龟、淡水鳖、淡水蛙、淡水珍珠、丰年虫",
                                "taxName": "淡水产品",
                                "taxRate": "9%",
                                "vip": "7",
                                "itaxRate": "0.09",
                                "taxCode": "1010599000000000000",
                                "taxCodeTitle": "淡水产品",
                                "iTitle": "*淡水产品*其他淡水产品",
                                "children": []
                            }
                        ]
                    }
                ]
            },
            {
                "id": "228",
                "linkid": "1",
                "code": "102",
                "paCode": "1",
                "yn": "Y",
                "title": "矿产品",
                "alias": "矿产品",
                "about": null,
                "kws": null,
                "taxName": "矿产品",
                "taxRate": "",
                "vip": "7",
                "itaxRate": null,
                "taxCode": "1020000000000000000",
                "taxCodeTitle": "矿产品",
                "iTitle": "*矿产品*矿产品",
                "children": [
                    {
                        "id": "229",
                        "linkid": "228",
                        "code": "10201",
                        "paCode": "102",
                        "yn": "Y",
                        "title": "煤炭采选产品",
                        "alias": "煤炭采选产品",
                        "about": "指经过验收、符合质量标准（即绝对干燥灰分在40%以下）的原煤；对于绝对灰分在40%～60%之间的低质煤、如有固定销售对象、亦应计入原煤产量；不符合上述标准的列入煤炭低热值产品。",
                        "kws": "煤炭",
                        "taxName": "煤炭",
                        "taxRate": "",
                        "vip": "7",
                        "itaxRate": null,
                        "taxCode": "1020100000000000000",
                        "taxCodeTitle": "煤炭",
                        "iTitle": "*煤炭*煤炭采选产品",
                        "children": [
                            {
                                "id": "230",
                                "linkid": "229",
                                "code": "1020101",
                                "paCode": "10201",
                                "yn": "N",
                                "title": "原煤",
                                "alias": "原煤",
                                "about": "从地上或地下采掘出的毛煤经筛选加工去掉矸石、黄铁矿等后的煤。包括：无烟煤、烟煤、褐烟等。",
                                "kws": "原煤、无烟煤、烟煤、褐烟、贫煤、贫瘦煤、瘦煤、焦煤、肥煤、1/3焦煤、气肥煤、气煤、1/2中黏煤、弱黏煤、不黏煤、长焰煤、褐煤",
                                "taxName": "煤炭",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1020101000000000000",
                                "taxCodeTitle": "煤炭",
                                "iTitle": "*煤炭*原煤",
                                "children": []
                            },
                            {
                                "id": "231",
                                "linkid": "229",
                                "code": "1020102",
                                "paCode": "10201",
                                "yn": "N",
                                "title": "洗煤",
                                "alias": "洗煤",
                                "about": "洗煤是将原煤中的杂质剔除、或将优质煤和劣质煤炭进行分门别类的一种工业工艺。洗煤过程后所产生的产品包括：洗精煤、洗块煤、洗粒级煤、洗混末煤、洗中煤、筛选块煤等。",
                                "kws": "洗煤、洗精煤、洗块煤、洗粒级煤、洗混末煤、洗中煤、筛选块煤、洗选煤",
                                "taxName": "煤炭",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1020102000000000000",
                                "taxCodeTitle": "煤炭",
                                "iTitle": "*煤炭*洗煤",
                                "children": []
                            },
                            {
                                "id": "232",
                                "linkid": "229",
                                "code": "1020199",
                                "paCode": "10201",
                                "yn": "N",
                                "title": "其他煤炭采选产品（低热值燃料）",
                                "alias": "其他煤炭采选产品",
                                "about": "包括泥炭（泥煤）、石煤、风化煤、煤矸石、洗矸、其他煤矸石、煤炭低热值燃料（指不属于原煤、灰分一般在40%以上的低热值燃料）、其他未列明煤炭采选产品。",
                                "kws": "泥炭、泥煤、石煤、风化煤、煤矸石、洗矸",
                                "taxName": "煤炭",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1020199000000000000",
                                "taxCodeTitle": "煤炭",
                                "iTitle": "*煤炭*其他煤炭采选产品（低热值燃料）",
                                "children": []
                            }
                        ]
                    },
                    {
                        "id": "233",
                        "linkid": "228",
                        "code": "10202",
                        "paCode": "102",
                        "yn": "Y",
                        "title": "石油和天然气开采产品",
                        "alias": "石油和天然气开采产品",
                        "about": null,
                        "kws": null,
                        "taxName": "石油天然气开采品",
                        "taxRate": "",
                        "vip": "7",
                        "itaxRate": null,
                        "taxCode": "1020200000000000000",
                        "taxCodeTitle": "石油天然气开采品",
                        "iTitle": "*石油天然气开采品*石油和天然气开采产品",
                        "children": [
                            {
                                "id": "234",
                                "linkid": "233",
                                "code": "1020201",
                                "paCode": "10202",
                                "yn": "Y",
                                "title": "原油",
                                "alias": "原油",
                                "about": "指直接从油井中开采出来未加工的石油、是一种由各种烃类组成的黑褐色或暗绿色黏稠液态或半固态的可燃物质。地壳上层部分地区有石油储存。它由不同的碳氢化合物混合组成、其主要组成成分是烷烃、此外石油中还含硫、氧、氮、磷、钒等元素。可溶于多种有机溶剂、不溶于水、但可与水形成乳状液。按密度范围分为轻质原油、中质原油和重质原油。",
                                "kws": "原油",
                                "taxName": "原油",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1020201000000000000",
                                "taxCodeTitle": "原油",
                                "iTitle": "*原油*原油",
                                "children": [
                                    {
                                        "id": "235",
                                        "linkid": "234",
                                        "code": "102020101",
                                        "paCode": "1020201",
                                        "yn": "N",
                                        "title": "天然原油",
                                        "alias": "天然原油",
                                        "about": "指各种碳氢化合物的复杂混合物、通常是暗褐色或者是黑色的液体、也有少数原油呈黄色、淡红色或淡褐色。",
                                        "kws": "原油、天然原油",
                                        "taxName": "原油",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020201010000000000",
                                        "taxCodeTitle": "原油",
                                        "iTitle": "*原油*天然原油",
                                        "children": []
                                    },
                                    {
                                        "id": "236",
                                        "linkid": "234",
                                        "code": "102020102",
                                        "paCode": "1020201",
                                        "yn": "N",
                                        "title": "沥青矿原油",
                                        "alias": "沥青矿原油",
                                        "about": "指从沥青矿中提取的原油",
                                        "kws": "沥青矿原油",
                                        "taxName": "原油",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020201020000000000",
                                        "taxCodeTitle": "原油",
                                        "iTitle": "*原油*沥青矿原油",
                                        "children": []
                                    },
                                    {
                                        "id": "237",
                                        "linkid": "234",
                                        "code": "102020103",
                                        "paCode": "1020201",
                                        "yn": "N",
                                        "title": "稳定轻烃",
                                        "alias": "稳定轻烃",
                                        "about": "仅包括油气田企业在生产石油、天然气过程中，通过加热、增压、冷却、制冷等方法回收、以戊烷和以上重烃组分组成的稳定轻烃。",
                                        "kws": "稳定轻烃",
                                        "taxName": "原油",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020201030000000000",
                                        "taxCodeTitle": "原油",
                                        "iTitle": "*原油*稳定轻烃",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "238",
                                "linkid": "233",
                                "code": "1020202",
                                "paCode": "10202",
                                "yn": "N",
                                "title": "天然气",
                                "alias": "天然气",
                                "about": "指以气态碳氢化合物为主的各种气体组成的混合物。由有机物质经生物化学作用分解而成、或与石油共存于岩石的裂缝和空洞中、或以溶解状态存在于地下水中，主要成分是甲烷、乙烷、丙烷和丁烷。",
                                "kws": "天然气",
                                "taxName": "天然气",
                                "taxRate": "9%",
                                "vip": "7",
                                "itaxRate": "0.09",
                                "taxCode": "1020202000000000000",
                                "taxCodeTitle": "天然气",
                                "iTitle": "*天然气*天然气",
                                "children": []
                            },
                            {
                                "id": "239",
                                "linkid": "233",
                                "code": "1020203",
                                "paCode": "10202",
                                "yn": "N",
                                "title": "液化天然气",
                                "alias": "液化天然气",
                                "about": "主要以二次加工的气体为原料、经分离、脱硫精制而成。",
                                "kws": "液化天然气",
                                "taxName": "液化天然气",
                                "taxRate": "9%",
                                "vip": "7",
                                "itaxRate": "0.09",
                                "taxCode": "1020203000000000000",
                                "taxCodeTitle": "液化天然气",
                                "iTitle": "*液化天然气*液化天然气",
                                "children": []
                            },
                            {
                                "id": "240",
                                "linkid": "233",
                                "code": "1020204",
                                "paCode": "10202",
                                "yn": "N",
                                "title": "煤层气",
                                "alias": "煤层气",
                                "about": "主要存在于煤矿的伴生气体、是热值高、无污染的新能源、可以用来发电、用作工业燃料、化工原料和居民生活燃料。",
                                "kws": "煤层气",
                                "taxName": "煤层气",
                                "taxRate": "9%",
                                "vip": "7",
                                "itaxRate": "0.09",
                                "taxCode": "1020204000000000000",
                                "taxCodeTitle": "煤层气",
                                "iTitle": "*煤层气*煤层气",
                                "children": []
                            },
                            {
                                "id": "241",
                                "linkid": "233",
                                "code": "1020205",
                                "paCode": "10202",
                                "yn": "N",
                                "title": "天然气水合物",
                                "alias": "天然气水合物",
                                "about": "指水和天然气在高压和低温条件下混合时产生的一种固态物质，外貌极像冰雪或固体酒精，点火即可燃烧，有“可燃水”、“气冰”、“固体瓦斯”之称。天然气水合物是一种新型高效能源，其成分与人们平时所使用的天然气成分相近，但更为纯净，开采时只需将固体的“天然气水合物”升温减压即可释放出大量的甲烷气体。",
                                "kws": "天然气水合物",
                                "taxName": "天然气水合物",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1020205000000000000",
                                "taxCodeTitle": "天然气水合物",
                                "iTitle": "*天然气水合物*天然气水合物",
                                "children": []
                            },
                            {
                                "id": "242",
                                "linkid": "233",
                                "code": "1020206",
                                "paCode": "10202",
                                "yn": "Y",
                                "title": "油页岩",
                                "alias": "油页岩",
                                "about": "一种高灰分的含可燃有机质的沉积岩，和煤的主要区别是灰分超过40%，与碳质页岩的主要区别是含油率大于3.5%。油页岩经低温干馏可以得到页岩油、页岩油类似原油，可以制成汽油、柴油或作为燃料油。单独成藏外，油页岩还经常与煤形成伴生矿藏、一起被开采出来。",
                                "kws": null,
                                "taxName": "油页岩",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1020206000000000000",
                                "taxCodeTitle": "油页岩",
                                "iTitle": "*油页岩*油页岩",
                                "children": [
                                    {
                                        "id": "243",
                                        "linkid": "242",
                                        "code": "102020601",
                                        "paCode": "1020206",
                                        "yn": "N",
                                        "title": "沥青页岩",
                                        "alias": "沥青页岩",
                                        "about": "天然沥青储藏在地下，有的形成矿层或在地壳表面堆积。",
                                        "kws": "沥青页岩",
                                        "taxName": "油页岩",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020206010000000000",
                                        "taxCodeTitle": "油页岩",
                                        "iTitle": "*油页岩*沥青页岩",
                                        "children": []
                                    },
                                    {
                                        "id": "244",
                                        "linkid": "242",
                                        "code": "102020602",
                                        "paCode": "1020206",
                                        "yn": "N",
                                        "title": "油母页岩",
                                        "alias": "油母页岩",
                                        "about": null,
                                        "kws": "油母页岩、油页岩",
                                        "taxName": "油页岩",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020206020000000000",
                                        "taxCodeTitle": "油页岩",
                                        "iTitle": "*油页岩*油母页岩",
                                        "children": []
                                    },
                                    {
                                        "id": "245",
                                        "linkid": "242",
                                        "code": "102020603",
                                        "paCode": "1020206",
                                        "yn": "N",
                                        "title": "焦（重）油砂",
                                        "alias": "焦重油砂",
                                        "about": "一种黏土、水、石油和沥青的混合物，胶状黑色物质，可以用来产生液体燃料。",
                                        "kws": "焦油砂、重油砂",
                                        "taxName": "油页岩",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020206030000000000",
                                        "taxCodeTitle": "油页岩",
                                        "iTitle": "*油页岩*焦（重）油砂",
                                        "children": []
                                    },
                                    {
                                        "id": "246",
                                        "linkid": "242",
                                        "code": "102020699",
                                        "paCode": "1020206",
                                        "yn": "N",
                                        "title": "其他油页岩",
                                        "alias": "其他油页岩",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "油页岩",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020206990000000000",
                                        "taxCodeTitle": "油页岩",
                                        "iTitle": "*油页岩*其他油页岩",
                                        "children": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "id": "247",
                        "linkid": "228",
                        "code": "10203",
                        "paCode": "102",
                        "yn": "Y",
                        "title": "黑色金属矿石",
                        "alias": "黑色金属矿石",
                        "about": "根据金属元素的性质和用途将其分为黑色金属矿产，如铁矿石、锰矿等",
                        "kws": null,
                        "taxName": "黑色金属矿石",
                        "taxRate": "",
                        "vip": "7",
                        "itaxRate": null,
                        "taxCode": "1020300000000000000",
                        "taxCodeTitle": "黑色金属矿石",
                        "iTitle": "*黑色金属矿石*黑色金属矿石",
                        "children": [
                            {
                                "id": "248",
                                "linkid": "247",
                                "code": "1020301",
                                "paCode": "10203",
                                "yn": "N",
                                "title": "铁矿石",
                                "alias": "铁矿石",
                                "about": "包括原矿（磁铁矿石、赤铁矿石、褐铁矿石、菱铁矿石、多金属矿）、铁矿石成品矿（炼钢块矿石、炼铁块矿石、铁富粉矿石、铁精矿）、人造富铁矿（烧结铁矿石、球团铁矿石、其他人造富铁矿）等",
                                "kws": "铁矿石、原铁矿石、磁铁矿石、赤铁矿石、褐铁矿石、菱铁矿石、多金属矿石、炼钢块矿石、炼铁块矿石、铁富粉矿石、铁精矿石、人造富铁矿石、烧结铁矿石、球团铁矿石",
                                "taxName": "黑色金属矿石",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1020301000000000000",
                                "taxCodeTitle": "黑色金属矿石",
                                "iTitle": "*黑色金属矿石*铁矿石",
                                "children": []
                            },
                            {
                                "id": "249",
                                "linkid": "247",
                                "code": "1020302",
                                "paCode": "10203",
                                "yn": "N",
                                "title": "锰矿石",
                                "alias": "锰矿石",
                                "about": "包括锰矿石原矿石、锰矿石成品矿石、锰矿石（锰块矿石、锰粉矿）、人造富锰矿（烧结锰矿石、球团锰矿石、焙烧锰矿石、富锰渣）等。",
                                "kws": "锰矿石、锰矿石原矿石、锰块矿石、锰粉矿石、人造富锰矿石、烧结锰矿石、球团锰矿石、焙烧锰矿石、富锰渣",
                                "taxName": "黑色金属矿石",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1020302000000000000",
                                "taxCodeTitle": "黑色金属矿石",
                                "iTitle": "*黑色金属矿石*锰矿石",
                                "children": []
                            },
                            {
                                "id": "250",
                                "linkid": "247",
                                "code": "1020303",
                                "paCode": "10203",
                                "yn": "N",
                                "title": "铬矿石",
                                "alias": "铬矿石",
                                "about": "包括铬矿石原矿石、铬矿石成品矿（富铬块矿石、铬精矿）、人造富铬矿（烧结球团铬矿石、预还原球团铬矿石、其他人造富铬矿）等",
                                "kws": "铬矿石、铬矿石原矿石、铬矿石成品矿石、富铬块矿石、铬精矿石、人造富铬矿石、烧结球团铬矿石、预还原球团铬矿石",
                                "taxName": "黑色金属矿石",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1020303000000000000",
                                "taxCodeTitle": "黑色金属矿石",
                                "iTitle": "*黑色金属矿石*铬矿石",
                                "children": []
                            }
                        ]
                    },
                    {
                        "id": "251",
                        "linkid": "228",
                        "code": "10204",
                        "paCode": "102",
                        "yn": "Y",
                        "title": "有色金属矿石",
                        "alias": "有色金属矿石",
                        "about": null,
                        "kws": null,
                        "taxName": "有色金属矿石",
                        "taxRate": "",
                        "vip": "7",
                        "itaxRate": null,
                        "taxCode": "1020400000000000000",
                        "taxCodeTitle": "有色金属矿石",
                        "iTitle": "*有色金属矿石*有色金属矿石",
                        "children": [
                            {
                                "id": "252",
                                "linkid": "251",
                                "code": "1020401",
                                "paCode": "10204",
                                "yn": "Y",
                                "title": "常用有色金属矿石",
                                "alias": "常用有色金属矿石",
                                "about": null,
                                "kws": null,
                                "taxName": "有色金属矿石",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1020401000000000000",
                                "taxCodeTitle": "有色金属矿石",
                                "iTitle": "*有色金属矿石*常用有色金属矿石",
                                "children": [
                                    {
                                        "id": "253",
                                        "linkid": "252",
                                        "code": "102040101",
                                        "paCode": "1020401",
                                        "yn": "N",
                                        "title": "铜矿石",
                                        "alias": "铜矿石",
                                        "about": null,
                                        "kws": "铜矿石",
                                        "taxName": "有色金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020401010000000000",
                                        "taxCodeTitle": "有色金属矿石",
                                        "iTitle": "*有色金属矿石*铜矿石",
                                        "children": []
                                    },
                                    {
                                        "id": "254",
                                        "linkid": "252",
                                        "code": "102040102",
                                        "paCode": "1020401",
                                        "yn": "N",
                                        "title": "铅锌矿石",
                                        "alias": "铅锌矿石",
                                        "about": null,
                                        "kws": "铅锌矿石",
                                        "taxName": "有色金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020401020000000000",
                                        "taxCodeTitle": "有色金属矿石",
                                        "iTitle": "*有色金属矿石*铅锌矿石",
                                        "children": []
                                    },
                                    {
                                        "id": "255",
                                        "linkid": "252",
                                        "code": "102040103",
                                        "paCode": "1020401",
                                        "yn": "N",
                                        "title": "镍矿石",
                                        "alias": "镍矿石",
                                        "about": null,
                                        "kws": "镍矿石",
                                        "taxName": "有色金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020401030000000000",
                                        "taxCodeTitle": "有色金属矿石",
                                        "iTitle": "*有色金属矿石*镍矿石",
                                        "children": []
                                    },
                                    {
                                        "id": "256",
                                        "linkid": "252",
                                        "code": "102040104",
                                        "paCode": "1020401",
                                        "yn": "N",
                                        "title": "钴矿石",
                                        "alias": "钴矿石",
                                        "about": null,
                                        "kws": "钴矿石",
                                        "taxName": "有色金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020401040000000000",
                                        "taxCodeTitle": "有色金属矿石",
                                        "iTitle": "*有色金属矿石*钴矿石",
                                        "children": []
                                    },
                                    {
                                        "id": "257",
                                        "linkid": "252",
                                        "code": "102040105",
                                        "paCode": "1020401",
                                        "yn": "N",
                                        "title": "锡矿石",
                                        "alias": "锡矿石",
                                        "about": null,
                                        "kws": "锡矿石",
                                        "taxName": "有色金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020401050000000000",
                                        "taxCodeTitle": "有色金属矿石",
                                        "iTitle": "*有色金属矿石*锡矿石",
                                        "children": []
                                    },
                                    {
                                        "id": "258",
                                        "linkid": "252",
                                        "code": "102040106",
                                        "paCode": "1020401",
                                        "yn": "N",
                                        "title": "锑矿石",
                                        "alias": "锑矿石",
                                        "about": null,
                                        "kws": "锑矿石",
                                        "taxName": "有色金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020401060000000000",
                                        "taxCodeTitle": "有色金属矿石",
                                        "iTitle": "*有色金属矿石*锑矿石",
                                        "children": []
                                    },
                                    {
                                        "id": "259",
                                        "linkid": "252",
                                        "code": "102040107",
                                        "paCode": "1020401",
                                        "yn": "N",
                                        "title": "铝土矿石",
                                        "alias": "铝土矿石",
                                        "about": null,
                                        "kws": "铝土矿石",
                                        "taxName": "有色金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020401070000000000",
                                        "taxCodeTitle": "有色金属矿石",
                                        "iTitle": "*有色金属矿石*铝土矿石",
                                        "children": []
                                    },
                                    {
                                        "id": "260",
                                        "linkid": "252",
                                        "code": "102040108",
                                        "paCode": "1020401",
                                        "yn": "N",
                                        "title": "镁矿石",
                                        "alias": "镁矿石",
                                        "about": null,
                                        "kws": "镁矿石",
                                        "taxName": "有色金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020401080000000000",
                                        "taxCodeTitle": "有色金属矿石",
                                        "iTitle": "*有色金属矿石*镁矿石",
                                        "children": []
                                    },
                                    {
                                        "id": "261",
                                        "linkid": "252",
                                        "code": "102040109",
                                        "paCode": "1020401",
                                        "yn": "N",
                                        "title": "汞矿石",
                                        "alias": "汞矿石",
                                        "about": null,
                                        "kws": "汞矿石",
                                        "taxName": "有色金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020401090000000000",
                                        "taxCodeTitle": "有色金属矿石",
                                        "iTitle": "*有色金属矿石*汞矿石",
                                        "children": []
                                    },
                                    {
                                        "id": "262",
                                        "linkid": "252",
                                        "code": "102040110",
                                        "paCode": "1020401",
                                        "yn": "N",
                                        "title": "铋矿石",
                                        "alias": "铋矿石",
                                        "about": null,
                                        "kws": "铋矿石",
                                        "taxName": "有色金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020401100000000000",
                                        "taxCodeTitle": "有色金属矿石",
                                        "iTitle": "*有色金属矿石*铋矿石",
                                        "children": []
                                    },
                                    {
                                        "id": "263",
                                        "linkid": "252",
                                        "code": "102040111",
                                        "paCode": "1020401",
                                        "yn": "N",
                                        "title": "钛矿石",
                                        "alias": "钛矿石",
                                        "about": null,
                                        "kws": "钛矿石",
                                        "taxName": "有色金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020401110000000000",
                                        "taxCodeTitle": "有色金属矿石",
                                        "iTitle": "*有色金属矿石*钛矿石",
                                        "children": []
                                    },
                                    {
                                        "id": "264",
                                        "linkid": "252",
                                        "code": "102040112",
                                        "paCode": "1020401",
                                        "yn": "N",
                                        "title": "钠矿石",
                                        "alias": "钠矿石",
                                        "about": null,
                                        "kws": "钠矿石",
                                        "taxName": "有色金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020401120000000000",
                                        "taxCodeTitle": "有色金属矿石",
                                        "iTitle": "*有色金属矿石*钠矿石",
                                        "children": []
                                    },
                                    {
                                        "id": "265",
                                        "linkid": "252",
                                        "code": "102040199",
                                        "paCode": "1020401",
                                        "yn": "N",
                                        "title": "其他常用有色金属矿石",
                                        "alias": "其他常用有色金属矿石",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "有色金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020401990000000000",
                                        "taxCodeTitle": "有色金属矿石",
                                        "iTitle": "*有色金属矿石*其他常用有色金属矿石",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "266",
                                "linkid": "251",
                                "code": "1020402",
                                "paCode": "10204",
                                "yn": "Y",
                                "title": "贵金属矿石",
                                "alias": "贵金属矿石",
                                "about": null,
                                "kws": null,
                                "taxName": "贵金属矿石",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1020402000000000000",
                                "taxCodeTitle": "贵金属矿石",
                                "iTitle": "*贵金属矿石*贵金属矿石",
                                "children": [
                                    {
                                        "id": "267",
                                        "linkid": "266",
                                        "code": "102040201",
                                        "paCode": "1020402",
                                        "yn": "N",
                                        "title": "金矿砂及其精矿石",
                                        "alias": "金矿砂及其精矿石",
                                        "about": null,
                                        "kws": "金矿砂、黄金矿砂、黄金矿",
                                        "taxName": "贵金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020402010000000000",
                                        "taxCodeTitle": "贵金属矿石",
                                        "iTitle": "*贵金属矿石*金矿砂及其精矿石",
                                        "children": []
                                    },
                                    {
                                        "id": "268",
                                        "linkid": "266",
                                        "code": "102040202",
                                        "paCode": "1020402",
                                        "yn": "N",
                                        "title": "银矿砂及其精矿石",
                                        "alias": "银矿砂及其精矿石",
                                        "about": null,
                                        "kws": "银矿砂、银矿石、银精矿石",
                                        "taxName": "贵金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020402020000000000",
                                        "taxCodeTitle": "贵金属矿石",
                                        "iTitle": "*贵金属矿石*银矿砂及其精矿石",
                                        "children": []
                                    },
                                    {
                                        "id": "269",
                                        "linkid": "266",
                                        "code": "102040299",
                                        "paCode": "1020402",
                                        "yn": "N",
                                        "title": "其他贵金属矿石",
                                        "alias": "其他贵金属矿石",
                                        "about": "指含铂、铱、锇、钌、钯、铑的贵金属矿。",
                                        "kws": "铂、铱、锇、钌、钯、铑",
                                        "taxName": "贵金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020402990000000000",
                                        "taxCodeTitle": "贵金属矿石",
                                        "iTitle": "*贵金属矿石*其他贵金属矿石",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "270",
                                "linkid": "251",
                                "code": "1020403",
                                "paCode": "10204",
                                "yn": "Y",
                                "title": "稀有金属矿石",
                                "alias": "稀有金属矿石",
                                "about": null,
                                "kws": null,
                                "taxName": "稀有金属矿石",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1020403000000000000",
                                "taxCodeTitle": "稀有金属矿石",
                                "iTitle": "*稀有金属矿石*稀有金属矿石",
                                "children": [
                                    {
                                        "id": "271",
                                        "linkid": "270",
                                        "code": "102040301",
                                        "paCode": "1020403",
                                        "yn": "N",
                                        "title": "钨矿石",
                                        "alias": "钨矿石",
                                        "about": null,
                                        "kws": "钨矿石",
                                        "taxName": "稀有金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020403010000000000",
                                        "taxCodeTitle": "稀有金属矿石",
                                        "iTitle": "*稀有金属矿石*钨矿石",
                                        "children": []
                                    },
                                    {
                                        "id": "272",
                                        "linkid": "270",
                                        "code": "102040302",
                                        "paCode": "1020403",
                                        "yn": "N",
                                        "title": "钼矿石",
                                        "alias": "钼矿石",
                                        "about": null,
                                        "kws": "钼矿石",
                                        "taxName": "稀有金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020403020000000000",
                                        "taxCodeTitle": "稀有金属矿石",
                                        "iTitle": "*稀有金属矿石*钼矿石",
                                        "children": []
                                    },
                                    {
                                        "id": "273",
                                        "linkid": "270",
                                        "code": "102040303",
                                        "paCode": "1020403",
                                        "yn": "Y",
                                        "title": "稀土矿产品",
                                        "alias": "稀土矿产品",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "稀土矿产品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1020403030000000000",
                                        "taxCodeTitle": "稀土矿产品",
                                        "iTitle": "*稀土矿产品*稀土矿产品",
                                        "children": [
                                            {
                                                "id": "274",
                                                "linkid": "273",
                                                "code": "10204030301",
                                                "paCode": "102040303",
                                                "yn": "N",
                                                "title": "高钇混合稀土氧化物",
                                                "alias": "高钇混合稀土氧化物",
                                                "about": "高钇矿石、高钇稀土矿石、高钇氧化稀土、稀土矿（高钇）等。",
                                                "kws": "高钇混合稀土氧化物",
                                                "taxName": "稀土矿产品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1020403030100000000",
                                                "taxCodeTitle": "稀土矿产品",
                                                "iTitle": "*稀土矿产品*高钇混合稀土氧化物",
                                                "children": []
                                            },
                                            {
                                                "id": "275",
                                                "linkid": "273",
                                                "code": "10204030302",
                                                "paCode": "102040303",
                                                "yn": "N",
                                                "title": "中钇富铕混合稀土氧化物",
                                                "alias": "中钇富铕混合稀土氧化物",
                                                "about": "中钇富铕矿石、中钇富铕稀土矿石、中钇富铕氧化稀土、富铕混合稀土氧化物、稀土矿（中钇）等。",
                                                "kws": "中钇富铕混合稀土氧化物",
                                                "taxName": "稀土矿产品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1020403030200000000",
                                                "taxCodeTitle": "稀土矿产品",
                                                "iTitle": "*稀土矿产品*中钇富铕混合稀土氧化物",
                                                "children": []
                                            },
                                            {
                                                "id": "276",
                                                "linkid": "273",
                                                "code": "10204030303",
                                                "paCode": "102040303",
                                                "yn": "N",
                                                "title": "低钇低铕混合稀土氧化物",
                                                "alias": "低钇低铕混合稀土氧化物",
                                                "about": "低钇低铕矿石、低钇低铕混合稀土、稀土矿（低钇低铕）等。",
                                                "kws": "低钇低铕混合稀土氧化物",
                                                "taxName": "稀土矿产品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1020403030300000000",
                                                "taxCodeTitle": "稀土矿产品",
                                                "iTitle": "*稀土矿产品*低钇低铕混合稀土氧化物",
                                                "children": []
                                            },
                                            {
                                                "id": "277",
                                                "linkid": "273",
                                                "code": "10204030304",
                                                "paCode": "102040303",
                                                "yn": "N",
                                                "title": "高钇混合碳酸稀土（折氧化物计量计价）",
                                                "alias": "高钇混合碳酸稀土",
                                                "about": "高钇碳酸稀土、碳酸高钇、高钇稀土碳酸物等。",
                                                "kws": "高钇混合碳酸稀土",
                                                "taxName": "稀土矿产品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1020403030400000000",
                                                "taxCodeTitle": "稀土矿产品",
                                                "iTitle": "*稀土矿产品*高钇混合碳酸稀土（折氧化物计量计价）",
                                                "children": []
                                            },
                                            {
                                                "id": "278",
                                                "linkid": "273",
                                                "code": "10204030305",
                                                "paCode": "102040303",
                                                "yn": "N",
                                                "title": "中钇富铕混合碳酸稀土（折氧化物计量计价）",
                                                "alias": "中钇富铕混合碳酸稀土",
                                                "about": "中钇富铕碳酸稀土、中钇富铕碳酸物、中钇富铕矿（碳酸盐）等。",
                                                "kws": "中钇富铕混合碳酸稀土",
                                                "taxName": "稀土矿产品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1020403030500000000",
                                                "taxCodeTitle": "稀土矿产品",
                                                "iTitle": "*稀土矿产品*中钇富铕混合碳酸稀土（折氧化物计量计价）",
                                                "children": []
                                            },
                                            {
                                                "id": "279",
                                                "linkid": "273",
                                                "code": "10204030306",
                                                "paCode": "102040303",
                                                "yn": "N",
                                                "title": "低钇低铕混合碳酸稀土（折氧化物计量计价）",
                                                "alias": "低钇低铕混合碳酸稀土",
                                                "about": "低钇低铕碳酸稀土、低钇低铕碳酸物等。",
                                                "kws": "低钇低铕混合碳酸稀土",
                                                "taxName": "稀土矿产品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1020403030600000000",
                                                "taxCodeTitle": "稀土矿产品",
                                                "iTitle": "*稀土矿产品*低钇低铕混合碳酸稀土（折氧化物计量计价）",
                                                "children": []
                                            },
                                            {
                                                "id": "280",
                                                "linkid": "273",
                                                "code": "10204030307",
                                                "paCode": "102040303",
                                                "yn": "N",
                                                "title": "高钇混合草酸稀土（折氧化物计量计价）",
                                                "alias": "高钇混合草酸稀土",
                                                "about": "高钇草酸稀土、高钇矿（草酸盐）、草酸高钇稀土等。",
                                                "kws": "高钇混合草酸稀土",
                                                "taxName": "稀土矿产品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1020403030700000000",
                                                "taxCodeTitle": "稀土矿产品",
                                                "iTitle": "*稀土矿产品*高钇混合草酸稀土（折氧化物计量计价）",
                                                "children": []
                                            },
                                            {
                                                "id": "281",
                                                "linkid": "273",
                                                "code": "10204030308",
                                                "paCode": "102040303",
                                                "yn": "N",
                                                "title": "中钇富铕混合草酸稀土（折氧化物计量计价）",
                                                "alias": "中钇富铕混合草酸稀土",
                                                "about": "中钇富铕草酸稀土、中钇富铕矿（草酸盐）等。",
                                                "kws": "中钇富铕混合草酸稀土",
                                                "taxName": "稀土矿产品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1020403030800000000",
                                                "taxCodeTitle": "稀土矿产品",
                                                "iTitle": "*稀土矿产品*中钇富铕混合草酸稀土（折氧化物计量计价）",
                                                "children": []
                                            },
                                            {
                                                "id": "282",
                                                "linkid": "273",
                                                "code": "10204030309",
                                                "paCode": "102040303",
                                                "yn": "N",
                                                "title": "低钇低铕混合草酸稀土（折氧化物计量计价）",
                                                "alias": "低钇低铕混合草酸稀土",
                                                "about": "低钇低铕草酸稀土、低钇低铕稀土矿（草酸盐）等。",
                                                "kws": "低钇低铕混合草酸稀土",
                                                "taxName": "稀土矿产品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1020403030900000000",
                                                "taxCodeTitle": "稀土矿产品",
                                                "iTitle": "*稀土矿产品*低钇低铕混合草酸稀土（折氧化物计量计价）",
                                                "children": []
                                            },
                                            {
                                                "id": "283",
                                                "linkid": "273",
                                                "code": "10204030310",
                                                "paCode": "102040303",
                                                "yn": "N",
                                                "title": "磷钇矿精矿（折氧化物计量计价）",
                                                "alias": "磷钇矿精矿",
                                                "about": null,
                                                "kws": "磷钇矿精矿",
                                                "taxName": "稀土矿产品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1020403031000000000",
                                                "taxCodeTitle": "稀土矿产品",
                                                "iTitle": "*稀土矿产品*磷钇矿精矿（折氧化物计量计价）",
                                                "children": []
                                            },
                                            {
                                                "id": "284",
                                                "linkid": "273",
                                                "code": "10204030311",
                                                "paCode": "102040303",
                                                "yn": "N",
                                                "title": "独居石精矿（折氧化物计量计价）",
                                                "alias": "独居石精矿",
                                                "about": "独居石、独居石稀土矿等。",
                                                "kws": "独居石精矿",
                                                "taxName": "稀土矿产品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1020403031100000000",
                                                "taxCodeTitle": "稀土矿产品",
                                                "iTitle": "*稀土矿产品*独居石精矿（折氧化物计量计价）",
                                                "children": []
                                            },
                                            {
                                                "id": "285",
                                                "linkid": "273",
                                                "code": "10204030312",
                                                "paCode": "102040303",
                                                "yn": "N",
                                                "title": "氟碳铈精矿（折氧化物计量计价）",
                                                "alias": "氟碳铈精矿",
                                                "about": null,
                                                "kws": "氟碳铈精矿",
                                                "taxName": "稀土矿产品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1020403031200000000",
                                                "taxCodeTitle": "稀土矿产品",
                                                "iTitle": "*稀土矿产品*氟碳铈精矿（折氧化物计量计价）",
                                                "children": []
                                            },
                                            {
                                                "id": "286",
                                                "linkid": "273",
                                                "code": "10204030313",
                                                "paCode": "102040303",
                                                "yn": "N",
                                                "title": "氟碳铈镧矿精矿（折氧化物计量计价）",
                                                "alias": "氟碳铈镧矿精矿",
                                                "about": "氟碳铈镧矿石、氟碳铈镧稀土矿等。",
                                                "kws": "氟碳铈镧矿精矿",
                                                "taxName": "稀土矿产品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1020403031300000000",
                                                "taxCodeTitle": "稀土矿产品",
                                                "iTitle": "*稀土矿产品*氟碳铈镧矿精矿（折氧化物计量计价）",
                                                "children": []
                                            },
                                            {
                                                "id": "287",
                                                "linkid": "273",
                                                "code": "10204030314",
                                                "paCode": "102040303",
                                                "yn": "N",
                                                "title": "氟碳铈矿-独居石混合精矿（折氧化物计量计价）",
                                                "alias": "氟碳铈矿-独居石混合精矿",
                                                "about": null,
                                                "kws": "氟碳铈矿-独居石混合精矿",
                                                "taxName": "稀土矿产品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1020403031400000000",
                                                "taxCodeTitle": "稀土矿产品",
                                                "iTitle": "*稀土矿产品*氟碳铈矿-独居石混合精矿（折氧化物计量计价）",
                                                "children": []
                                            },
                                            {
                                                "id": "288",
                                                "linkid": "273",
                                                "code": "10204030315",
                                                "paCode": "102040303",
                                                "yn": "N",
                                                "title": "混合碳酸稀土（折氧化物计量计价）",
                                                "alias": "混合碳酸稀土",
                                                "about": null,
                                                "kws": "混合碳酸稀土",
                                                "taxName": "稀土矿产品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1020403031500000000",
                                                "taxCodeTitle": "稀土矿产品",
                                                "iTitle": "*稀土矿产品*混合碳酸稀土（折氧化物计量计价）",
                                                "children": []
                                            },
                                            {
                                                "id": "289",
                                                "linkid": "273",
                                                "code": "10204030316",
                                                "paCode": "102040303",
                                                "yn": "N",
                                                "title": "混合氯化稀土（折氧化物计量计价）",
                                                "alias": "混合氯化稀土",
                                                "about": null,
                                                "kws": "混合氯化稀土",
                                                "taxName": "稀土矿产品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1020403031600000000",
                                                "taxCodeTitle": "稀土矿产品",
                                                "iTitle": "*稀土矿产品*混合氯化稀土（折氧化物计量计价）",
                                                "children": []
                                            },
                                            {
                                                "id": "290",
                                                "linkid": "273",
                                                "code": "10204030317",
                                                "paCode": "102040303",
                                                "yn": "N",
                                                "title": "钐钴废料（折氧化物计量计价）",
                                                "alias": "钐钴废料",
                                                "about": null,
                                                "kws": "钐钴废料",
                                                "taxName": "稀土矿产品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1020403031700000000",
                                                "taxCodeTitle": "稀土矿产品",
                                                "iTitle": "*稀土矿产品*钐钴废料（折氧化物计量计价）",
                                                "children": []
                                            },
                                            {
                                                "id": "291",
                                                "linkid": "273",
                                                "code": "10204030318",
                                                "paCode": "102040303",
                                                "yn": "N",
                                                "title": "钕铁硼废料（折氧化物计量计价）",
                                                "alias": "钕铁硼废料",
                                                "about": null,
                                                "kws": "钕铁硼废料",
                                                "taxName": "稀土矿产品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1020403031800000000",
                                                "taxCodeTitle": "稀土矿产品",
                                                "iTitle": "*稀土矿产品*钕铁硼废料（折氧化物计量计价）",
                                                "children": []
                                            },
                                            {
                                                "id": "292",
                                                "linkid": "273",
                                                "code": "10204030319",
                                                "paCode": "102040303",
                                                "yn": "N",
                                                "title": "稀土荧光材料废料（折氧化物计量计价）",
                                                "alias": "稀土荧光材料废料",
                                                "about": null,
                                                "kws": "稀土荧光材料废料",
                                                "taxName": "稀土矿产品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1020403031900000000",
                                                "taxCodeTitle": "稀土矿产品",
                                                "iTitle": "*稀土矿产品*稀土荧光材料废料（折氧化物计量计价）",
                                                "children": []
                                            },
                                            {
                                                "id": "293",
                                                "linkid": "273",
                                                "code": "10204030320",
                                                "paCode": "102040303",
                                                "yn": "N",
                                                "title": "稀土储氢材料废料（折氧化物计量计价）",
                                                "alias": "稀土储氢材料废料",
                                                "about": null,
                                                "kws": "稀土储氢材料废料",
                                                "taxName": "稀土矿产品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1020403032000000000",
                                                "taxCodeTitle": "稀土矿产品",
                                                "iTitle": "*稀土矿产品*稀土储氢材料废料（折氧化物计量计价）",
                                                "children": []
                                            },
                                            {
                                                "id": "294",
                                                "linkid": "273",
                                                "code": "10204030321",
                                                "paCode": "102040303",
                                                "yn": "N",
                                                "title": "稀土抛光粉废料（折氧化物计量计价）",
                                                "alias": "稀土抛光粉废料",
                                                "about": null,
                                                "kws": "稀土抛光粉废料",
                                                "taxName": "稀土矿产品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1020403032100000000",
                                                "taxCodeTitle": "稀土矿产品",
                                                "iTitle": "*稀土矿产品*稀土抛光粉废料（折氧化物计量计价）",
                                                "children": []
                                            },
                                            {
                                                "id": "295",
                                                "linkid": "273",
                                                "code": "10204030322",
                                                "paCode": "102040303",
                                                "yn": "N",
                                                "title": "稀土催化剂废料（折氧化物计量计价）",
                                                "alias": "稀土催化剂废料",
                                                "about": null,
                                                "kws": "稀土催化剂废料",
                                                "taxName": "稀土矿产品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1020403032200000000",
                                                "taxCodeTitle": "稀土矿产品",
                                                "iTitle": "*稀土矿产品*稀土催化剂废料（折氧化物计量计价）",
                                                "children": []
                                            },
                                            {
                                                "id": "296",
                                                "linkid": "273",
                                                "code": "10204030323",
                                                "paCode": "102040303",
                                                "yn": "N",
                                                "title": "其他稀土废料（折氧化物计量计价）",
                                                "alias": "其他稀土废料",
                                                "about": "废稀土矿渣、稀土酸溶渣等。",
                                                "kws": "其他稀土废料、废稀土矿渣、稀土酸溶渣",
                                                "taxName": "稀土矿产品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1020403032300000000",
                                                "taxCodeTitle": "稀土矿产品",
                                                "iTitle": "*稀土矿产品*其他稀土废料（折氧化物计量计价）",
                                                "children": []
                                            },
                                            {
                                                "id": "297",
                                                "linkid": "273",
                                                "code": "10204030324",
                                                "paCode": "102040303",
                                                "yn": "N",
                                                "title": "磁矿尾矿（折氧化物计量计价）",
                                                "alias": "磁矿尾矿",
                                                "about": null,
                                                "kws": null,
                                                "taxName": "稀土矿产品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1020403032400000000",
                                                "taxCodeTitle": "稀土矿产品",
                                                "iTitle": "*稀土矿产品*磁矿尾矿（折氧化物计量计价）",
                                                "children": []
                                            },
                                            {
                                                "id": "298",
                                                "linkid": "273",
                                                "code": "10204030325",
                                                "paCode": "102040303",
                                                "yn": "N",
                                                "title": "强磁尾矿（折氧化物计量计价）",
                                                "alias": "强磁尾矿",
                                                "about": null,
                                                "kws": null,
                                                "taxName": "稀土矿产品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1020403032500000000",
                                                "taxCodeTitle": "稀土矿产品",
                                                "iTitle": "*稀土矿产品*强磁尾矿（折氧化物计量计价）",
                                                "children": []
                                            },
                                            {
                                                "id": "299",
                                                "linkid": "273",
                                                "code": "10204030326",
                                                "paCode": "102040303",
                                                "yn": "N",
                                                "title": "强磁中矿（折氧化物计量计价）",
                                                "alias": "强磁中矿",
                                                "about": null,
                                                "kws": null,
                                                "taxName": "稀土矿产品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1020403032600000000",
                                                "taxCodeTitle": "稀土矿产品",
                                                "iTitle": "*稀土矿产品*强磁中矿（折氧化物计量计价）",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "300",
                                        "linkid": "270",
                                        "code": "102040304",
                                        "paCode": "1020403",
                                        "yn": "N",
                                        "title": "磷钇矿石",
                                        "alias": "磷钇矿石",
                                        "about": null,
                                        "kws": "磷钇矿",
                                        "taxName": "稀有稀土金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020403040000000000",
                                        "taxCodeTitle": "稀有稀土金属矿石",
                                        "iTitle": "*稀有稀土金属矿石*磷钇矿石",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "301",
                                "linkid": "251",
                                "code": "1020404",
                                "paCode": "10204",
                                "yn": "Y",
                                "title": "放射性金属矿石",
                                "alias": "放射性金属矿石",
                                "about": null,
                                "kws": null,
                                "taxName": "放射性金属矿石",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1020404000000000000",
                                "taxCodeTitle": "放射性金属矿石",
                                "iTitle": "*放射性金属矿石*放射性金属矿石",
                                "children": [
                                    {
                                        "id": "302",
                                        "linkid": "301",
                                        "code": "102040401",
                                        "paCode": "1020404",
                                        "yn": "N",
                                        "title": "铀矿石",
                                        "alias": "铀矿石",
                                        "about": null,
                                        "kws": "铀矿石",
                                        "taxName": "放射性金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020404010000000000",
                                        "taxCodeTitle": "放射性金属矿石",
                                        "iTitle": "*放射性金属矿石*铀矿石",
                                        "children": []
                                    },
                                    {
                                        "id": "303",
                                        "linkid": "301",
                                        "code": "102040402",
                                        "paCode": "1020404",
                                        "yn": "N",
                                        "title": "钍矿石",
                                        "alias": "钍矿石",
                                        "about": null,
                                        "kws": "钍矿石",
                                        "taxName": "放射性金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020404020000000000",
                                        "taxCodeTitle": "放射性金属矿石",
                                        "iTitle": "*放射性金属矿石*钍矿石",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "304",
                                "linkid": "251",
                                "code": "1020499",
                                "paCode": "10204",
                                "yn": "Y",
                                "title": "其他有色金属矿石",
                                "alias": "其他有色金属矿石",
                                "about": null,
                                "kws": null,
                                "taxName": "其他有色金属矿石",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1020499000000000000",
                                "taxCodeTitle": "其他有色金属矿石",
                                "iTitle": "*其他有色金属矿石*其他有色金属矿石",
                                "children": [
                                    {
                                        "id": "305",
                                        "linkid": "304",
                                        "code": "102049901",
                                        "paCode": "1020499",
                                        "yn": "N",
                                        "title": "锂矿石",
                                        "alias": "锂矿石",
                                        "about": null,
                                        "kws": "锂矿石",
                                        "taxName": "其他有色金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020499010000000000",
                                        "taxCodeTitle": "其他有色金属矿石",
                                        "iTitle": "*其他有色金属矿石*锂矿石",
                                        "children": []
                                    },
                                    {
                                        "id": "306",
                                        "linkid": "304",
                                        "code": "102049902",
                                        "paCode": "1020499",
                                        "yn": "N",
                                        "title": "铍矿石",
                                        "alias": "铍矿石",
                                        "about": null,
                                        "kws": "铍矿石",
                                        "taxName": "其他有色金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020499020000000000",
                                        "taxCodeTitle": "其他有色金属矿石",
                                        "iTitle": "*其他有色金属矿石*铍矿石",
                                        "children": []
                                    },
                                    {
                                        "id": "307",
                                        "linkid": "304",
                                        "code": "102049903",
                                        "paCode": "1020499",
                                        "yn": "N",
                                        "title": "铯矿石",
                                        "alias": "铯矿石",
                                        "about": null,
                                        "kws": "铯矿石",
                                        "taxName": "其他有色金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020499030000000000",
                                        "taxCodeTitle": "其他有色金属矿石",
                                        "iTitle": "*其他有色金属矿石*铯矿石",
                                        "children": []
                                    },
                                    {
                                        "id": "308",
                                        "linkid": "304",
                                        "code": "102049904",
                                        "paCode": "1020499",
                                        "yn": "N",
                                        "title": "钽矿石",
                                        "alias": "钽矿石",
                                        "about": null,
                                        "kws": "钽矿石",
                                        "taxName": "其他有色金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020499040000000000",
                                        "taxCodeTitle": "其他有色金属矿石",
                                        "iTitle": "*其他有色金属矿石*钽矿石",
                                        "children": []
                                    },
                                    {
                                        "id": "309",
                                        "linkid": "304",
                                        "code": "102049905",
                                        "paCode": "1020499",
                                        "yn": "N",
                                        "title": "铌矿石",
                                        "alias": "铌矿石",
                                        "about": null,
                                        "kws": "铌矿石",
                                        "taxName": "其他有色金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020499050000000000",
                                        "taxCodeTitle": "其他有色金属矿石",
                                        "iTitle": "*其他有色金属矿石*铌矿石",
                                        "children": []
                                    },
                                    {
                                        "id": "310",
                                        "linkid": "304",
                                        "code": "102049906",
                                        "paCode": "1020499",
                                        "yn": "N",
                                        "title": "钛钽铌矿石",
                                        "alias": "钛钽铌矿石",
                                        "about": null,
                                        "kws": "钛钽铌矿石",
                                        "taxName": "其他有色金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020499060000000000",
                                        "taxCodeTitle": "其他有色金属矿石",
                                        "iTitle": "*其他有色金属矿石*钛钽铌矿石",
                                        "children": []
                                    },
                                    {
                                        "id": "311",
                                        "linkid": "304",
                                        "code": "102049907",
                                        "paCode": "1020499",
                                        "yn": "N",
                                        "title": "钒矿石",
                                        "alias": "钒矿石",
                                        "about": null,
                                        "kws": "钒矿石",
                                        "taxName": "其他有色金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020499070000000000",
                                        "taxCodeTitle": "其他有色金属矿石",
                                        "iTitle": "*其他有色金属矿石*钒矿石",
                                        "children": []
                                    },
                                    {
                                        "id": "312",
                                        "linkid": "304",
                                        "code": "102049908",
                                        "paCode": "1020499",
                                        "yn": "N",
                                        "title": "锆矿石",
                                        "alias": "锆矿石",
                                        "about": null,
                                        "kws": "锆矿石",
                                        "taxName": "其他有色金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020499080000000000",
                                        "taxCodeTitle": "其他有色金属矿石",
                                        "iTitle": "*其他有色金属矿石*锆矿石",
                                        "children": []
                                    },
                                    {
                                        "id": "313",
                                        "linkid": "304",
                                        "code": "102049999",
                                        "paCode": "1020499",
                                        "yn": "N",
                                        "title": "其他未列明有色金属矿石",
                                        "alias": "其他未列明有色金属矿石",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "其他有色金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020499990000000000",
                                        "taxCodeTitle": "其他有色金属矿石",
                                        "iTitle": "*其他有色金属矿石*其他未列明有色金属矿石",
                                        "children": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "id": "314",
                        "linkid": "228",
                        "code": "10205",
                        "paCode": "102",
                        "yn": "Y",
                        "title": "非金属矿石",
                        "alias": "非金属矿石",
                        "about": null,
                        "kws": null,
                        "taxName": "非金属矿石",
                        "taxRate": "",
                        "vip": "7",
                        "itaxRate": null,
                        "taxCode": "1020500000000000000",
                        "taxCodeTitle": "非金属矿石",
                        "iTitle": "*非金属矿石*非金属矿石",
                        "children": [
                            {
                                "id": "315",
                                "linkid": "314",
                                "code": "1020501",
                                "paCode": "10205",
                                "yn": "Y",
                                "title": "石灰石、石膏类",
                                "alias": "石灰石膏",
                                "about": null,
                                "kws": "石灰石、石膏",
                                "taxName": "非金属矿石",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1020501000000000000",
                                "taxCodeTitle": "非金属矿石",
                                "iTitle": "*非金属矿石*石灰石、石膏类",
                                "children": [
                                    {
                                        "id": "316",
                                        "linkid": "315",
                                        "code": "102050101",
                                        "paCode": "1020501",
                                        "yn": "N",
                                        "title": "石灰石",
                                        "alias": "石灰石",
                                        "about": "指成品矿，主要由碳酸钙组成的沉积岩石，包括冶金用石灰石、水泥用石灰石、石灰用石灰石、化工用石灰石、其他石灰石。",
                                        "kws": "石灰石、天然石灰石、冶金用石灰石、水泥用石灰石、石灰用石灰石、化工用石灰石",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020501010000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*石灰石",
                                        "children": []
                                    },
                                    {
                                        "id": "317",
                                        "linkid": "315",
                                        "code": "102050102",
                                        "paCode": "1020501",
                                        "yn": "N",
                                        "title": "石膏类",
                                        "alias": "石膏类",
                                        "about": "以二水硫酸钙、无水硫酸钙为主要成分的天然矿石",
                                        "kws": "石膏、天然石膏",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020501020000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*石膏类",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "318",
                                "linkid": "314",
                                "code": "1020502",
                                "paCode": "10205",
                                "yn": "Y",
                                "title": "建筑用天然石料",
                                "alias": "建筑用天然石料",
                                "about": null,
                                "kws": null,
                                "taxName": "非金属矿石",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1020502000000000000",
                                "taxCodeTitle": "非金属矿石",
                                "iTitle": "*非金属矿石*建筑用天然石料",
                                "children": [
                                    {
                                        "id": "319",
                                        "linkid": "318",
                                        "code": "102050201",
                                        "paCode": "1020502",
                                        "yn": "N",
                                        "title": "天然大理石荒料",
                                        "alias": "天然大理石荒料",
                                        "about": "自矿山采下的具有六面体的大理岩等碳酸盐类岩石，色泽多样，是加工大理石板材的原料",
                                        "kws": "天然大理石、大理石",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020502010000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*天然大理石荒料",
                                        "children": []
                                    },
                                    {
                                        "id": "320",
                                        "linkid": "318",
                                        "code": "102050202",
                                        "paCode": "1020502",
                                        "yn": "N",
                                        "title": "天然花岗石荒料",
                                        "alias": "天然花岗石荒料",
                                        "about": "自矿山采下的具有六面体的花岗岩等硅酸盐类岩石，色泽多样，是加工花岗石板材的原料；花岗石质地坚硬，硬度大于大理石，是装饰墙面、地面的高级装饰材料",
                                        "kws": "天然花岗石、花岗石",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020502020000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*天然花岗石荒料",
                                        "children": []
                                    },
                                    {
                                        "id": "321",
                                        "linkid": "318",
                                        "code": "102050203",
                                        "paCode": "1020502",
                                        "yn": "N",
                                        "title": "石英岩",
                                        "alias": "石英岩",
                                        "about": "是硅石的天然结晶体",
                                        "kws": "石英岩石",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020502030000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*石英岩",
                                        "children": []
                                    },
                                    {
                                        "id": "322",
                                        "linkid": "318",
                                        "code": "102050204",
                                        "paCode": "1020502",
                                        "yn": "N",
                                        "title": "砂岩",
                                        "alias": "砂岩",
                                        "about": "石英颗粒被胶结而成的沉积岩",
                                        "kws": "砂岩石",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020502040000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*砂岩",
                                        "children": []
                                    },
                                    {
                                        "id": "323",
                                        "linkid": "318",
                                        "code": "102050205",
                                        "paCode": "1020502",
                                        "yn": "N",
                                        "title": "板岩",
                                        "alias": "板岩",
                                        "about": "一种具有特殊的板状构造，由粘土岩、粉沙岩或中、酸性凝灰岩轻微变质作用形成的浅变质岩石，可沿板里面成片剥离作装饰石材",
                                        "kws": "板岩石",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020502050000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*板岩",
                                        "children": []
                                    },
                                    {
                                        "id": "324",
                                        "linkid": "318",
                                        "code": "102050206",
                                        "paCode": "1020502",
                                        "yn": "N",
                                        "title": "蜡石",
                                        "alias": "蜡石",
                                        "about": "腊石又名黄蜡石，石质因素，尤其表层呈蜡质感包浆态",
                                        "kws": "蜡石、黄蜡石",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020502060000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*蜡石",
                                        "children": []
                                    },
                                    {
                                        "id": "325",
                                        "linkid": "318",
                                        "code": "102050299",
                                        "paCode": "1020502",
                                        "yn": "N",
                                        "title": "其他建筑用天然石料",
                                        "alias": "其他建筑用天然石料",
                                        "about": "不作建筑装饰用的一种建筑材料；如用作建筑物砌块砖、骨料、大坝、河道、蓄水池等建筑，包括煤矸石",
                                        "kws": "#煤矸石",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020502990000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*其他建筑用天然石料",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "326",
                                "linkid": "314",
                                "code": "1020503",
                                "paCode": "10205",
                                "yn": "Y",
                                "title": "耐火土石类",
                                "alias": "耐火土石类",
                                "about": null,
                                "kws": null,
                                "taxName": "非金属矿石",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1020503000000000000",
                                "taxCodeTitle": "非金属矿石",
                                "iTitle": "*非金属矿石*耐火土石类",
                                "children": [
                                    {
                                        "id": "327",
                                        "linkid": "326",
                                        "code": "102050301",
                                        "paCode": "1020503",
                                        "yn": "N",
                                        "title": "耐火粘土",
                                        "alias": "耐火粘土",
                                        "about": null,
                                        "kws": "耐火粘土",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020503010000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*耐火粘土",
                                        "children": []
                                    },
                                    {
                                        "id": "328",
                                        "linkid": "326",
                                        "code": "102050302",
                                        "paCode": "1020503",
                                        "yn": "N",
                                        "title": "耐火粘土熟料",
                                        "alias": "耐火粘土熟料",
                                        "about": null,
                                        "kws": "耐火粘土熟料",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020503020000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*耐火粘土熟料",
                                        "children": []
                                    },
                                    {
                                        "id": "329",
                                        "linkid": "326",
                                        "code": "102050303",
                                        "paCode": "1020503",
                                        "yn": "N",
                                        "title": "铁铝矾土",
                                        "alias": "铁铝矾土",
                                        "about": null,
                                        "kws": "铁铝矾土",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020503030000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*铁铝矾土",
                                        "children": []
                                    },
                                    {
                                        "id": "330",
                                        "linkid": "326",
                                        "code": "102050304",
                                        "paCode": "1020503",
                                        "yn": "N",
                                        "title": "白云岩",
                                        "alias": "白云岩",
                                        "about": null,
                                        "kws": "白云岩石",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020503040000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*白云岩",
                                        "children": []
                                    },
                                    {
                                        "id": "331",
                                        "linkid": "326",
                                        "code": "102050305",
                                        "paCode": "1020503",
                                        "yn": "N",
                                        "title": "煅烧白云石",
                                        "alias": "煅烧白云石",
                                        "about": null,
                                        "kws": "煅烧白云石",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020503050000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*煅烧白云石",
                                        "children": []
                                    },
                                    {
                                        "id": "332",
                                        "linkid": "326",
                                        "code": "102050306",
                                        "paCode": "1020503",
                                        "yn": "N",
                                        "title": "红柱石",
                                        "alias": "红柱石",
                                        "about": null,
                                        "kws": "红柱石",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020503060000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*红柱石",
                                        "children": []
                                    },
                                    {
                                        "id": "333",
                                        "linkid": "326",
                                        "code": "102050307",
                                        "paCode": "1020503",
                                        "yn": "N",
                                        "title": "蓝晶石",
                                        "alias": "蓝晶石",
                                        "about": null,
                                        "kws": "蓝晶石",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020503070000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*蓝晶石",
                                        "children": []
                                    },
                                    {
                                        "id": "334",
                                        "linkid": "326",
                                        "code": "102050308",
                                        "paCode": "1020503",
                                        "yn": "N",
                                        "title": "夕线石",
                                        "alias": "夕线石",
                                        "about": null,
                                        "kws": "夕线石",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020503080000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*夕线石",
                                        "children": []
                                    },
                                    {
                                        "id": "335",
                                        "linkid": "326",
                                        "code": "102050399",
                                        "paCode": "1020503",
                                        "yn": "N",
                                        "title": "其他耐火土石类",
                                        "alias": "其他耐火土石类",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020503990000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*其他耐火土石类",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "336",
                                "linkid": "314",
                                "code": "1020504",
                                "paCode": "10205",
                                "yn": "Y",
                                "title": "粘土、砂、石",
                                "alias": "粘土、砂、石",
                                "about": null,
                                "kws": null,
                                "taxName": "非金属矿石",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1020504000000000000",
                                "taxCodeTitle": "非金属矿石",
                                "iTitle": "*非金属矿石*粘土、砂、石",
                                "children": [
                                    {
                                        "id": "337",
                                        "linkid": "336",
                                        "code": "102050401",
                                        "paCode": "1020504",
                                        "yn": "N",
                                        "title": "粘土",
                                        "alias": "粘土",
                                        "about": "包括高岭土（煅烧高岭土、未煅烧高岭土、造纸用高岭土、搪瓷用高岭土、橡塑用高岭土、陶瓷用高岭土、涂料工业用高岭土）、膨润土（钠基膨润土、钙基膨润土、膨润土粉、有机膨润土粉、活性膨润土粉）、脱色土、漂白土、海泡石粘土、凹凸棒石粘土、伊利石粘土、其他粘土，不包括耐火粘土（详见102050301）。",
                                        "kws": "高岭土、煅烧高岭土、未煅烧高岭土、造纸用高岭土、搪瓷用高岭土、橡塑用高岭土、陶瓷用高岭土、涂料工业用高岭土、膨润土、钠基膨润土、钙基膨润土、膨润土粉、有机膨润土粉、活性膨润土粉、脱色土、漂白土、海泡石粘土、凹凸棒石粘土、伊利石粘土、陶土",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020504010000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*粘土",
                                        "children": []
                                    },
                                    {
                                        "id": "338",
                                        "linkid": "336",
                                        "code": "102050402",
                                        "paCode": "1020504",
                                        "yn": "N",
                                        "title": "煅烧高岭土",
                                        "alias": "煅烧高岭土",
                                        "about": null,
                                        "kws": "煅烧高岭土",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020504020000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*煅烧高岭土",
                                        "children": []
                                    },
                                    {
                                        "id": "339",
                                        "linkid": "336",
                                        "code": "102050403",
                                        "paCode": "1020504",
                                        "yn": "N",
                                        "title": "硅质土",
                                        "alias": "硅质土",
                                        "about": "包括硅质化石粗粉、硅藻土和其他硅质土",
                                        "kws": "硅质土、硅质化石粗粉、硅藻土",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020504030000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*硅质土",
                                        "children": []
                                    },
                                    {
                                        "id": "340",
                                        "linkid": "336",
                                        "code": "102050404",
                                        "paCode": "1020504",
                                        "yn": "N",
                                        "title": "建筑用砂、土",
                                        "alias": "建筑用砂、土",
                                        "about": null,
                                        "kws": "砂石、海沙、湖沙、河沙、碎石、建筑用土",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020504040000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*建筑用砂、土",
                                        "children": []
                                    },
                                    {
                                        "id": "341",
                                        "linkid": "336",
                                        "code": "102050405",
                                        "paCode": "1020504",
                                        "yn": "N",
                                        "title": "其他砂石骨料",
                                        "alias": "其他砂石骨料",
                                        "about": null,
                                        "kws": "其他砂石骨料",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020504050000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*其他砂石骨料",
                                        "children": []
                                    },
                                    {
                                        "id": "342",
                                        "linkid": "336",
                                        "code": "102050406",
                                        "paCode": "1020504",
                                        "yn": "N",
                                        "title": "干化污泥",
                                        "alias": "干化污泥",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020504060000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*干化污泥",
                                        "children": []
                                    },
                                    {
                                        "id": "343",
                                        "linkid": "336",
                                        "code": "102050407",
                                        "paCode": "1020504",
                                        "yn": "N",
                                        "title": "以自己采掘的砂、土、石料或其他矿物连续生产的砖、瓦、石灰（不含粘土实心砖、瓦）",
                                        "alias": "以自己采掘的砂、土、石料或其他矿物连续生产的砖、瓦、石灰（不含粘土实心砖、瓦）",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020504070000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*以自己采掘的砂、土、石料或其他矿物连续生产的砖、瓦、石灰（不含粘土实心砖、瓦）",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "344",
                                "linkid": "314",
                                "code": "1020505",
                                "paCode": "10205",
                                "yn": "Y",
                                "title": "化学矿石",
                                "alias": "化学矿石",
                                "about": null,
                                "kws": null,
                                "taxName": "非金属矿石",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1020505000000000000",
                                "taxCodeTitle": "非金属矿石",
                                "iTitle": "*非金属矿石*化学矿石",
                                "children": [
                                    {
                                        "id": "345",
                                        "linkid": "344",
                                        "code": "102050501",
                                        "paCode": "1020505",
                                        "yn": "N",
                                        "title": "硫铁矿石",
                                        "alias": "硫铁矿石",
                                        "about": "包括未焙烧黄铁矿",
                                        "kws": "硫铁矿石",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020505010000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*硫铁矿石",
                                        "children": []
                                    },
                                    {
                                        "id": "346",
                                        "linkid": "344",
                                        "code": "102050502",
                                        "paCode": "1020505",
                                        "yn": "N",
                                        "title": "磷矿石",
                                        "alias": "磷矿石",
                                        "about": null,
                                        "kws": "磷矿石",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020505020000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*磷矿石",
                                        "children": []
                                    },
                                    {
                                        "id": "347",
                                        "linkid": "344",
                                        "code": "102050503",
                                        "paCode": "1020505",
                                        "yn": "N",
                                        "title": "钾矿石",
                                        "alias": "钾矿石",
                                        "about": null,
                                        "kws": "钾矿石",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020505030000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*钾矿石",
                                        "children": []
                                    },
                                    {
                                        "id": "348",
                                        "linkid": "344",
                                        "code": "102050504",
                                        "paCode": "1020505",
                                        "yn": "N",
                                        "title": "硼矿石",
                                        "alias": "硼矿石",
                                        "about": null,
                                        "kws": "硼矿石",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020505040000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*硼矿石",
                                        "children": []
                                    },
                                    {
                                        "id": "349",
                                        "linkid": "344",
                                        "code": "102050505",
                                        "paCode": "1020505",
                                        "yn": "N",
                                        "title": "硫磺矿石",
                                        "alias": "硫磺矿石",
                                        "about": "游离状态的自然硫，不论是否已用机械法除去石质杂物",
                                        "kws": "硫磺矿石",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020505050000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*硫磺矿石",
                                        "children": []
                                    },
                                    {
                                        "id": "350",
                                        "linkid": "344",
                                        "code": "102050506",
                                        "paCode": "1020505",
                                        "yn": "N",
                                        "title": "萤石",
                                        "alias": "萤石",
                                        "about": null,
                                        "kws": "萤石",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020505060000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*萤石",
                                        "children": []
                                    },
                                    {
                                        "id": "351",
                                        "linkid": "344",
                                        "code": "102050507",
                                        "paCode": "1020505",
                                        "yn": "N",
                                        "title": "重晶石",
                                        "alias": "重晶石",
                                        "about": "指天然硫酸钡",
                                        "kws": "重晶石",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020505070000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*重晶石",
                                        "children": []
                                    },
                                    {
                                        "id": "352",
                                        "linkid": "344",
                                        "code": "102050508",
                                        "paCode": "1020505",
                                        "yn": "N",
                                        "title": "毒重石",
                                        "alias": "毒重石",
                                        "about": "指天然碳酸钡",
                                        "kws": "毒重石",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020505080000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*毒重石",
                                        "children": []
                                    },
                                    {
                                        "id": "353",
                                        "linkid": "344",
                                        "code": "102050509",
                                        "paCode": "1020505",
                                        "yn": "N",
                                        "title": "冰晶石",
                                        "alias": "冰晶石",
                                        "about": null,
                                        "kws": "冰晶石",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020505090000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*冰晶石",
                                        "children": []
                                    },
                                    {
                                        "id": "354",
                                        "linkid": "344",
                                        "code": "102050510",
                                        "paCode": "1020505",
                                        "yn": "N",
                                        "title": "冰洲晶石",
                                        "alias": "冰洲晶石",
                                        "about": null,
                                        "kws": "冰洲晶石",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020505100000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*冰洲晶石",
                                        "children": []
                                    },
                                    {
                                        "id": "355",
                                        "linkid": "344",
                                        "code": "102050511",
                                        "paCode": "1020505",
                                        "yn": "N",
                                        "title": "硫镁矾矿石",
                                        "alias": "硫镁矾矿石",
                                        "about": null,
                                        "kws": "硫镁矾矿石",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020505110000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*硫镁矾矿石",
                                        "children": []
                                    },
                                    {
                                        "id": "356",
                                        "linkid": "344",
                                        "code": "102050512",
                                        "paCode": "1020505",
                                        "yn": "N",
                                        "title": "蛇纹石",
                                        "alias": "蛇纹石",
                                        "about": null,
                                        "kws": "蛇纹石",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020505120000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*蛇纹石",
                                        "children": []
                                    },
                                    {
                                        "id": "357",
                                        "linkid": "344",
                                        "code": "102050513",
                                        "paCode": "1020505",
                                        "yn": "N",
                                        "title": "天青石",
                                        "alias": "天青石",
                                        "about": null,
                                        "kws": "天青石",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020505130000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*天青石",
                                        "children": []
                                    },
                                    {
                                        "id": "358",
                                        "linkid": "344",
                                        "code": "102050514",
                                        "paCode": "1020505",
                                        "yn": "N",
                                        "title": "天然碱",
                                        "alias": "天然碱",
                                        "about": null,
                                        "kws": "天然碱",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020505140000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*天然碱",
                                        "children": []
                                    },
                                    {
                                        "id": "359",
                                        "linkid": "344",
                                        "code": "102050515",
                                        "paCode": "1020505",
                                        "yn": "N",
                                        "title": "芒硝矿石",
                                        "alias": "芒硝矿石",
                                        "about": null,
                                        "kws": "芒硝矿石",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020505150000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*芒硝矿石",
                                        "children": []
                                    },
                                    {
                                        "id": "360",
                                        "linkid": "344",
                                        "code": "102050516",
                                        "paCode": "1020505",
                                        "yn": "N",
                                        "title": "天然硝石",
                                        "alias": "天然硝石",
                                        "about": null,
                                        "kws": "天然硝石",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020505160000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*天然硝石",
                                        "children": []
                                    },
                                    {
                                        "id": "361",
                                        "linkid": "344",
                                        "code": "102050517",
                                        "paCode": "1020505",
                                        "yn": "N",
                                        "title": "明矾石",
                                        "alias": "明矾石",
                                        "about": "因其用于提取明矾而得名，石质，灰红色或浅黄色。",
                                        "kws": "明矾石",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020505170000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*明矾石",
                                        "children": []
                                    },
                                    {
                                        "id": "362",
                                        "linkid": "344",
                                        "code": "102050518",
                                        "paCode": "1020505",
                                        "yn": "N",
                                        "title": "砷矿石",
                                        "alias": "砷矿石",
                                        "about": null,
                                        "kws": "砷矿石",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020505180000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*砷矿石",
                                        "children": []
                                    },
                                    {
                                        "id": "363",
                                        "linkid": "344",
                                        "code": "102050599",
                                        "paCode": "1020505",
                                        "yn": "N",
                                        "title": "其他化学矿石",
                                        "alias": "其他化学矿石",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020505990000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*其他化学矿石",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "364",
                                "linkid": "314",
                                "code": "1020506",
                                "paCode": "10205",
                                "yn": "Y",
                                "title": "原盐",
                                "alias": "原盐",
                                "about": "指通过以海水（含沿海浅层地下卤水）为原料晒制，或以钻井汲取地下卤水、注水溶解地下岩盐为原料，经真空蒸发干燥，以及从盐湖中采掘制成的以氯化钠为主要成分的盐产品；不包括以原盐为原料的盐加工产品（详见1030210）",
                                "kws": "原盐",
                                "taxName": "原盐",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1020506000000000000",
                                "taxCodeTitle": "原盐",
                                "iTitle": "*原盐*原盐",
                                "children": [
                                    {
                                        "id": "365",
                                        "linkid": "364",
                                        "code": "102050601",
                                        "paCode": "1020506",
                                        "yn": "N",
                                        "title": "海盐",
                                        "alias": "海盐",
                                        "about": null,
                                        "kws": "海盐",
                                        "taxName": "原盐",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020506010000000000",
                                        "taxCodeTitle": "原盐",
                                        "iTitle": "*原盐*海盐",
                                        "children": []
                                    },
                                    {
                                        "id": "366",
                                        "linkid": "364",
                                        "code": "102050602",
                                        "paCode": "1020506",
                                        "yn": "N",
                                        "title": "湖盐",
                                        "alias": "湖盐",
                                        "about": null,
                                        "kws": "湖盐",
                                        "taxName": "原盐",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020506020000000000",
                                        "taxCodeTitle": "原盐",
                                        "iTitle": "*原盐*湖盐",
                                        "children": []
                                    },
                                    {
                                        "id": "367",
                                        "linkid": "364",
                                        "code": "102050603",
                                        "paCode": "1020506",
                                        "yn": "N",
                                        "title": "井矿盐",
                                        "alias": "井矿盐",
                                        "about": null,
                                        "kws": "井矿盐",
                                        "taxName": "原盐",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020506030000000000",
                                        "taxCodeTitle": "原盐",
                                        "iTitle": "*原盐*井矿盐",
                                        "children": []
                                    },
                                    {
                                        "id": "368",
                                        "linkid": "364",
                                        "code": "102050699",
                                        "paCode": "1020506",
                                        "yn": "N",
                                        "title": "其他原盐",
                                        "alias": "其他原盐",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "原盐",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020506990000000000",
                                        "taxCodeTitle": "原盐",
                                        "iTitle": "*原盐*其他原盐",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "369",
                                "linkid": "314",
                                "code": "1020507",
                                "paCode": "10205",
                                "yn": "N",
                                "title": "石棉",
                                "alias": "石棉",
                                "about": null,
                                "kws": "石棉",
                                "taxName": "非金属矿石",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1020507000000000000",
                                "taxCodeTitle": "非金属矿石",
                                "iTitle": "*非金属矿石*石棉",
                                "children": []
                            },
                            {
                                "id": "370",
                                "linkid": "314",
                                "code": "1020508",
                                "paCode": "10205",
                                "yn": "N",
                                "title": "云母",
                                "alias": "云母",
                                "about": "是天然的复杂硅酸铝类，其特点是易于剥成有光泽的各种颜色透明弹性薄片",
                                "kws": "云母",
                                "taxName": "非金属矿石",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1020508000000000000",
                                "taxCodeTitle": "非金属矿石",
                                "iTitle": "*非金属矿石*云母",
                                "children": []
                            },
                            {
                                "id": "371",
                                "linkid": "314",
                                "code": "1020509",
                                "paCode": "10205",
                                "yn": "N",
                                "title": "天然石墨",
                                "alias": "天然石墨",
                                "about": "又称“黑铅”，是碳的一种，其特别之处是有光泽并且能在纸上留有明显印迹。不包括人造石墨（详见1080127）。",
                                "kws": "天然石墨、黑铅",
                                "taxName": "非金属矿石",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1020509000000000000",
                                "taxCodeTitle": "非金属矿石",
                                "iTitle": "*非金属矿石*天然石墨",
                                "children": []
                            },
                            {
                                "id": "372",
                                "linkid": "314",
                                "code": "1020510",
                                "paCode": "10205",
                                "yn": "N",
                                "title": "滑石",
                                "alias": "滑石",
                                "about": "包括原状滑石、滑石粉",
                                "kws": "滑石、原状滑石、滑石粉",
                                "taxName": "非金属矿石",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1020510000000000000",
                                "taxCodeTitle": "非金属矿石",
                                "iTitle": "*非金属矿石*滑石",
                                "children": []
                            },
                            {
                                "id": "373",
                                "linkid": "314",
                                "code": "1020511",
                                "paCode": "10205",
                                "yn": "Y",
                                "title": "宝石、玉石矿石",
                                "alias": "宝石、玉石矿石",
                                "about": null,
                                "kws": null,
                                "taxName": "非金属矿石",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1020511000000000000",
                                "taxCodeTitle": "非金属矿石",
                                "iTitle": "*非金属矿石*宝石、玉石矿石",
                                "children": [
                                    {
                                        "id": "374",
                                        "linkid": "373",
                                        "code": "102051101",
                                        "paCode": "1020511",
                                        "yn": "N",
                                        "title": "天然宝石类矿石",
                                        "alias": "天然宝石类矿石",
                                        "about": "包括钻石（矿类）、红宝石（刚玉）、蓝宝石（矿类）、祖母绿（矿类）、玛瑙、紫晶、琥珀、尖晶石、碧玺等",
                                        "kws": "钻石矿石、红宝石矿、刚玉矿、蓝宝石矿石、祖母绿矿、玛瑙矿石、紫晶矿石、琥珀原石、尖晶石矿石、碧玺矿石",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020511010000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*天然宝石类矿石",
                                        "children": []
                                    },
                                    {
                                        "id": "375",
                                        "linkid": "373",
                                        "code": "102051102",
                                        "paCode": "1020511",
                                        "yn": "N",
                                        "title": "天然玉石类矿石",
                                        "alias": "天然玉石类矿石",
                                        "about": "包括翡翠（矿类）、白玉、青玉、岫岩玉、芙蓉石、孔雀石、绿松石、乾青、石青、蓝田玉、独山玉、其他天然玉石类矿",
                                        "kws": "翡翠矿石、白玉矿石、青玉矿石、岫岩玉矿石、芙蓉石矿石、孔雀石矿石、绿松石矿石、乾青矿石、石青矿石、蓝田玉矿石、独山玉矿石",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020511020000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*天然玉石类矿石",
                                        "children": []
                                    },
                                    {
                                        "id": "376",
                                        "linkid": "373",
                                        "code": "102051103",
                                        "paCode": "1020511",
                                        "yn": "N",
                                        "title": "彩石类矿石",
                                        "alias": "彩石类矿石",
                                        "about": "包括浙川石、祁连玉、粉翠等",
                                        "kws": "浙川石矿石、祁连玉矿石、粉翠矿石、寿山石矿石、青田石矿石、鸡血石矿石、绿冻石矿石、巴林石矿石、汉白玉矿石、菊花石矿石",
                                        "taxName": "非金属矿石",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1020511030000000000",
                                        "taxCodeTitle": "非金属矿石",
                                        "iTitle": "*非金属矿石*彩石类矿石",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "377",
                                "linkid": "314",
                                "code": "1020599",
                                "paCode": "10205",
                                "yn": "N",
                                "title": "其他非金属矿石",
                                "alias": "其他非金属矿石",
                                "about": null,
                                "kws": null,
                                "taxName": "非金属矿石",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1020599000000000000",
                                "taxCodeTitle": "非金属矿石",
                                "iTitle": "*非金属矿石*其他非金属矿石",
                                "children": []
                            }
                        ]
                    },
                    {
                        "id": "378",
                        "linkid": "228",
                        "code": "10206",
                        "paCode": "102",
                        "yn": "N",
                        "title": "其他矿产品",
                        "alias": "其他矿产品",
                        "about": null,
                        "kws": null,
                        "taxName": "矿产品",
                        "taxRate": "13%",
                        "vip": "7",
                        "itaxRate": "0.13",
                        "taxCode": "1020600000000000000",
                        "taxCodeTitle": "矿产品",
                        "iTitle": "*矿产品*其他矿产品",
                        "children": []
                    }
                ]
            },
            {
                "id": "379",
                "linkid": "1",
                "code": "103",
                "paCode": "1",
                "yn": "Y",
                "title": "食品、饮料、烟、酒类产品",
                "alias": "食品类产品",
                "about": null,
                "kws": null,
                "taxName": "食品类产品",
                "taxRate": "",
                "vip": "3",
                "itaxRate": null,
                "taxCode": "1030000000000000000",
                "taxCodeTitle": "食品类产品",
                "iTitle": "*食品类产品*食品、饮料、烟、酒类产品",
                "children": [
                    {
                        "id": "380",
                        "linkid": "379",
                        "code": "10301",
                        "paCode": "103",
                        "yn": "Y",
                        "title": "农副食品，动、植物油制品",
                        "alias": "农副食品",
                        "about": null,
                        "kws": null,
                        "taxName": "农副食品",
                        "taxRate": "",
                        "vip": "7",
                        "itaxRate": null,
                        "taxCode": "1030100000000000000",
                        "taxCodeTitle": "农副食品",
                        "iTitle": "*农副食品*农副食品，动、植物油制品",
                        "children": [
                            {
                                "id": "381",
                                "linkid": "380",
                                "code": "1030101",
                                "paCode": "10301",
                                "yn": "Y",
                                "title": "谷物细粉",
                                "alias": "谷物细粉",
                                "about": null,
                                "kws": null,
                                "taxName": "谷物细粉",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1030101000000000000",
                                "taxCodeTitle": "谷物细粉",
                                "iTitle": "*谷物细粉*谷物细粉",
                                "children": [
                                    {
                                        "id": "382",
                                        "linkid": "381",
                                        "code": "103010101",
                                        "paCode": "1030101",
                                        "yn": "N",
                                        "title": "小麦粉",
                                        "alias": "小麦粉",
                                        "about": null,
                                        "kws": "小麦粉、小麦专用粉、小麦自发粉",
                                        "taxName": "谷物细粉",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1030101010000000000",
                                        "taxCodeTitle": "谷物细粉",
                                        "iTitle": "*谷物细粉*小麦粉",
                                        "children": []
                                    },
                                    {
                                        "id": "383",
                                        "linkid": "381",
                                        "code": "103010102",
                                        "paCode": "1030101",
                                        "yn": "N",
                                        "title": "大米粉",
                                        "alias": "大米粉",
                                        "about": null,
                                        "kws": "大米粉、籼米细粉、粳米细粉",
                                        "taxName": "谷物细粉",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1030101020000000000",
                                        "taxCodeTitle": "谷物细粉",
                                        "iTitle": "*谷物细粉*大米粉",
                                        "children": []
                                    },
                                    {
                                        "id": "384",
                                        "linkid": "381",
                                        "code": "103010199",
                                        "paCode": "1030101",
                                        "yn": "N",
                                        "title": "其他谷物细粉",
                                        "alias": "其他谷物细粉",
                                        "about": null,
                                        "kws": "玉米细粉、糯米细粉、荞麦细粉、黑麦细粉、莜麦细粉、高粱细粉、大麦细粉",
                                        "taxName": "谷物细粉",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1030101990000000000",
                                        "taxCodeTitle": "谷物细粉",
                                        "iTitle": "*谷物细粉*其他谷物细粉",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "385",
                                "linkid": "380",
                                "code": "1030102",
                                "paCode": "10301",
                                "yn": "Y",
                                "title": "碾磨谷物及谷物加工品",
                                "alias": "谷物加工品",
                                "about": null,
                                "kws": null,
                                "taxName": "谷物加工品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1030102000000000000",
                                "taxCodeTitle": "谷物加工品",
                                "iTitle": "*谷物加工品*碾磨谷物及谷物加工品",
                                "children": [
                                    {
                                        "id": "386",
                                        "linkid": "385",
                                        "code": "103010201",
                                        "paCode": "1030102",
                                        "yn": "Y",
                                        "title": "碾磨、脱壳谷物",
                                        "alias": "碾磨脱壳谷物",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "谷物加工品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1030102010000000000",
                                        "taxCodeTitle": "谷物加工品",
                                        "iTitle": "*谷物加工品*碾磨、脱壳谷物",
                                        "children": [
                                            {
                                                "id": "387",
                                                "linkid": "386",
                                                "code": "10301020101",
                                                "paCode": "103010201",
                                                "yn": "N",
                                                "title": "大米",
                                                "alias": "大米",
                                                "about": null,
                                                "kws": "籼米、粳米、大米",
                                                "taxName": "谷物加工品",
                                                "taxRate": "9%",
                                                "vip": "5",
                                                "itaxRate": "0.09",
                                                "taxCode": "1030102010100000000",
                                                "taxCodeTitle": "谷物加工品",
                                                "iTitle": "*谷物加工品*大米",
                                                "children": []
                                            },
                                            {
                                                "id": "388",
                                                "linkid": "386",
                                                "code": "10301020102",
                                                "paCode": "103010201",
                                                "yn": "N",
                                                "title": "小米",
                                                "alias": "小米",
                                                "about": null,
                                                "kws": "小米",
                                                "taxName": "谷物加工品",
                                                "taxRate": "9%",
                                                "vip": "5",
                                                "itaxRate": "0.09",
                                                "taxCode": "1030102010200000000",
                                                "taxCodeTitle": "谷物加工品",
                                                "iTitle": "*谷物加工品*小米",
                                                "children": []
                                            },
                                            {
                                                "id": "389",
                                                "linkid": "386",
                                                "code": "10301020103",
                                                "paCode": "103010201",
                                                "yn": "N",
                                                "title": "糯米",
                                                "alias": "糯米",
                                                "about": null,
                                                "kws": "糯米",
                                                "taxName": "谷物加工品",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1030102010300000000",
                                                "taxCodeTitle": "谷物加工品",
                                                "iTitle": "*谷物加工品*糯米",
                                                "children": []
                                            },
                                            {
                                                "id": "390",
                                                "linkid": "386",
                                                "code": "10301020104",
                                                "paCode": "103010201",
                                                "yn": "N",
                                                "title": "高粱米",
                                                "alias": "高粱米",
                                                "about": null,
                                                "kws": "高粱米",
                                                "taxName": "谷物加工品",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1030102010400000000",
                                                "taxCodeTitle": "谷物加工品",
                                                "iTitle": "*谷物加工品*高粱米",
                                                "children": []
                                            },
                                            {
                                                "id": "391",
                                                "linkid": "386",
                                                "code": "10301020105",
                                                "paCode": "103010201",
                                                "yn": "N",
                                                "title": "脱壳燕麦",
                                                "alias": "脱壳燕麦",
                                                "about": "指已脱壳但未去皮的燕麦。",
                                                "kws": "脱壳燕麦",
                                                "taxName": "谷物加工品",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1030102010500000000",
                                                "taxCodeTitle": "谷物加工品",
                                                "iTitle": "*谷物加工品*脱壳燕麦",
                                                "children": []
                                            },
                                            {
                                                "id": "392",
                                                "linkid": "386",
                                                "code": "10301020106",
                                                "paCode": "103010201",
                                                "yn": "N",
                                                "title": "脱壳青稞",
                                                "alias": "脱壳青稞",
                                                "about": null,
                                                "kws": "脱壳青稞",
                                                "taxName": "谷物加工品",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1030102010600000000",
                                                "taxCodeTitle": "谷物加工品",
                                                "iTitle": "*谷物加工品*脱壳青稞",
                                                "children": []
                                            },
                                            {
                                                "id": "393",
                                                "linkid": "386",
                                                "code": "10301020107",
                                                "paCode": "103010201",
                                                "yn": "N",
                                                "title": "珠粒大麦",
                                                "alias": "珠粒大麦",
                                                "about": null,
                                                "kws": "珠粒大麦",
                                                "taxName": "谷物加工品",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1030102010700000000",
                                                "taxCodeTitle": "谷物加工品",
                                                "iTitle": "*谷物加工品*珠粒大麦",
                                                "children": []
                                            },
                                            {
                                                "id": "394",
                                                "linkid": "386",
                                                "code": "10301020199",
                                                "paCode": "103010201",
                                                "yn": "N",
                                                "title": "其他碾磨、脱壳谷物",
                                                "alias": "其他碾磨脱壳谷物",
                                                "about": null,
                                                "kws": null,
                                                "taxName": "谷物加工品",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1030102019900000000",
                                                "taxCodeTitle": "谷物加工品",
                                                "iTitle": "*谷物加工品*其他碾磨、脱壳谷物",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "395",
                                        "linkid": "385",
                                        "code": "103010202",
                                        "paCode": "1030102",
                                        "yn": "N",
                                        "title": "粗磨谷物",
                                        "alias": "粗磨谷物",
                                        "about": "包括谷物去壳谷粉、粗粉及团粒。",
                                        "kws": "小麦粗磨、大米粗磨、玉米粗磨、燕麦粗磨",
                                        "taxName": "谷物加工品",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1030102020000000000",
                                        "taxCodeTitle": "谷物加工品",
                                        "iTitle": "*谷物加工品*粗磨谷物",
                                        "children": []
                                    },
                                    {
                                        "id": "396",
                                        "linkid": "385",
                                        "code": "103010203",
                                        "paCode": "1030102",
                                        "yn": "N",
                                        "title": "谷物加工制品",
                                        "alias": "谷物加工制品",
                                        "about": "包括燕麦片、大麦片、玉米片，谷物胚芽等。",
                                        "kws": "燕麦片、大麦片、玉米片、谷物胚芽",
                                        "taxName": "谷物加工品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1030102030000000000",
                                        "taxCodeTitle": "谷物加工品",
                                        "iTitle": "*谷物加工品*谷物加工制品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "397",
                                "linkid": "380",
                                "code": "1030103",
                                "paCode": "10301",
                                "yn": "Y",
                                "title": "薯、豆，相关植物加工品",
                                "alias": "薯豆加工品",
                                "about": null,
                                "kws": null,
                                "taxName": "薯豆加工品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1030103000000000000",
                                "taxCodeTitle": "薯豆加工品",
                                "iTitle": "*薯豆加工品*薯、豆，相关植物加工品",
                                "children": [
                                    {
                                        "id": "398",
                                        "linkid": "397",
                                        "code": "103010301",
                                        "paCode": "1030103",
                                        "yn": "N",
                                        "title": "薯类及类似植物加工品",
                                        "alias": "薯类加工品",
                                        "about": "不包括用以上原料制得的淀粉（详见1030112）",
                                        "kws": "马铃薯粉、马铃薯片、马铃薯颗粒、马铃薯团粒、红薯粉、魔芋粉、芋头粉、木薯",
                                        "taxName": "薯豆加工品",
                                        "taxRate": "",
                                        "vip": "5",
                                        "itaxRate": null,
                                        "taxCode": "1030103010000000000",
                                        "taxCodeTitle": "薯豆加工品",
                                        "iTitle": "*薯豆加工品*薯类及类似植物加工品",
                                        "children": []
                                    },
                                    {
                                        "id": "399",
                                        "linkid": "397",
                                        "code": "103010302",
                                        "paCode": "1030103",
                                        "yn": "N",
                                        "title": "干豆粉",
                                        "alias": "干豆粉",
                                        "about": "包括菜豆、扁豆、豇豆或兵豆制得的细粉、粗粉及粉末，主要用于做汤或豆泥",
                                        "kws": "干豆粉、菜豆粉、扁豆粉、豇豆粉、兵豆粉",
                                        "taxName": "薯豆加工品",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1030103020000000000",
                                        "taxCodeTitle": "薯豆加工品",
                                        "iTitle": "*薯豆加工品*干豆粉",
                                        "children": []
                                    },
                                    {
                                        "id": "400",
                                        "linkid": "397",
                                        "code": "103010303",
                                        "paCode": "1030103",
                                        "yn": "N",
                                        "title": "水果、坚果粉",
                                        "alias": "水果坚果粉",
                                        "about": null,
                                        "kws": "水果粉、坚果粉、栗子粉、杏仁粉、椰子粉",
                                        "taxName": "植物加工品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030103030000000000",
                                        "taxCodeTitle": "植物加工品",
                                        "iTitle": "*植物加工品*水果、坚果粉",
                                        "children": []
                                    },
                                    {
                                        "id": "401",
                                        "linkid": "397",
                                        "code": "103010399",
                                        "paCode": "1030103",
                                        "yn": "N",
                                        "title": "其他植物加工品",
                                        "alias": "其他植物加工品",
                                        "about": "包括碾碎的干小麦",
                                        "kws": "干小麦",
                                        "taxName": "植物加工品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1030103990000000000",
                                        "taxCodeTitle": "植物加工品",
                                        "iTitle": "*植物加工品*其他植物加工品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "402",
                                "linkid": "380",
                                "code": "1030104",
                                "paCode": "10301",
                                "yn": "Y",
                                "title": "饲料及宠物食品",
                                "alias": "饲料及宠物食品",
                                "about": null,
                                "kws": null,
                                "taxName": "饲料",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1030104000000000000",
                                "taxCodeTitle": "饲料",
                                "iTitle": "*饲料*饲料及宠物食品",
                                "children": [
                                    {
                                        "id": "403",
                                        "linkid": "402",
                                        "code": "103010401",
                                        "paCode": "1030104",
                                        "yn": "N",
                                        "title": "饲料",
                                        "alias": "饲料",
                                        "about": "指配制的动物饲料，除豆粕（详见103010407）以外的单一大宗饲料。",
                                        "kws": "配合饲料、浓缩饲料、预混合饲料、蛋白质饲料、混合饲料、猪配合饲料、蛋禽配合饲料、肉禽配合饲料、水产配合饲料、反刍动物配合饲料、猪浓缩饲料、蛋禽浓缩饲料、肉禽浓缩饲料、水产浓缩饲料、反刍动物浓缩饲料、猪预混合饲料、蛋禽预混合饲料、肉禽预混合饲料、水产预混合饲料、反刍动物预混合饲料",
                                        "taxName": "饲料",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1030104010000000000",
                                        "taxCodeTitle": "饲料",
                                        "iTitle": "*饲料*饲料",
                                        "children": []
                                    },
                                    {
                                        "id": "404",
                                        "linkid": "402",
                                        "code": "103010402",
                                        "paCode": "1030104",
                                        "yn": "N",
                                        "title": "饲料添加剂",
                                        "alias": "饲料添加剂",
                                        "about": "指动物饲料专用添加剂，也称“预配料”，一般说来，是由多种物质（有时称为添加剂）混合组成",
                                        "kws": "饲料稳定剂、饲料抗氧剂、促进动物食欲饲料添加剂、饲料保存添加剂、",
                                        "taxName": "饲料",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1030104020000000000",
                                        "taxCodeTitle": "饲料",
                                        "iTitle": "*饲料*饲料添加剂",
                                        "children": []
                                    },
                                    {
                                        "id": "405",
                                        "linkid": "402",
                                        "code": "103010403",
                                        "paCode": "1030104",
                                        "yn": "N",
                                        "title": "动物源性饲料",
                                        "alias": "动物源性饲料",
                                        "about": "指不适于供人食用的肉及其他动物的渣粉及团粒细粉、粗粉及团粒，主要用作动物饲料，也有用于其他方面（例如，做肥料）",
                                        "kws": "肉骨粉、血粉、血浆蛋白粉、肠衣蛋白粉、油渣、动物下脚料粉",
                                        "taxName": "饲料",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1030104030000000000",
                                        "taxCodeTitle": "饲料",
                                        "iTitle": "*饲料*动物源性饲料",
                                        "children": []
                                    },
                                    {
                                        "id": "406",
                                        "linkid": "402",
                                        "code": "103010404",
                                        "paCode": "1030104",
                                        "yn": "N",
                                        "title": "饲料用植物根粉",
                                        "alias": "饲料用植物根粉",
                                        "about": "指饲料甜菜、饲料萝卜、饲料胡萝卜（白色或淡黄色）、芜菁甘蓝及其他饲料用根磨制成粉或团粒",
                                        "kws": "饲料甜菜、饲料萝卜、白色饲料胡萝卜、淡黄色饲料萝卜、芜菁甘蓝",
                                        "taxName": "饲料",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1030104040000000000",
                                        "taxCodeTitle": "饲料",
                                        "iTitle": "*饲料*饲料用植物根粉",
                                        "children": []
                                    },
                                    {
                                        "id": "407",
                                        "linkid": "402",
                                        "code": "103010405",
                                        "paCode": "1030104",
                                        "yn": "N",
                                        "title": "饲料用水产品渣粉",
                                        "alias": "饲料用水产品渣粉",
                                        "about": "指非食用鱼、甲壳及软体动物等的渣粉及团粒",
                                        "kws": "饲料用鱼粉、饲料用鱼头粉、虾头粉饲料、贝壳粉饲料",
                                        "taxName": "饲料",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1030104050000000000",
                                        "taxCodeTitle": "饲料",
                                        "iTitle": "*饲料*饲料用水产品渣粉",
                                        "children": []
                                    },
                                    {
                                        "id": "408",
                                        "linkid": "402",
                                        "code": "103010406",
                                        "paCode": "1030104",
                                        "yn": "N",
                                        "title": "豆粕",
                                        "alias": "豆粕",
                                        "about": "豆粕是大豆提取豆油后得到的一种副产品，豆粕是制作牲畜与家禽饲料的主要原料",
                                        "kws": "豆粕",
                                        "taxName": "饲料",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1030104060000000000",
                                        "taxCodeTitle": "饲料",
                                        "iTitle": "*饲料*豆粕",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "409",
                                "linkid": "380",
                                "code": "1030105",
                                "paCode": "10301",
                                "yn": "Y",
                                "title": "植物油及其制品",
                                "alias": "植物油及其制品",
                                "about": null,
                                "kws": null,
                                "taxName": "植物油",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1030105000000000000",
                                "taxCodeTitle": "植物油",
                                "iTitle": "*植物油*植物油及其制品",
                                "children": [
                                    {
                                        "id": "410",
                                        "linkid": "409",
                                        "code": "103010501",
                                        "paCode": "1030105",
                                        "yn": "Y",
                                        "title": "食用植物油及食用植物油脂",
                                        "alias": "食用植物油及食用植物油脂",
                                        "about": "包括毛油（初榨植物油）和精制食用植物油。",
                                        "kws": "毛油",
                                        "taxName": "植物油",
                                        "taxRate": "",
                                        "vip": "5",
                                        "itaxRate": null,
                                        "taxCode": "1030105010000000000",
                                        "taxCodeTitle": "植物油",
                                        "iTitle": "*植物油*食用植物油及食用植物油脂",
                                        "children": [
                                            {
                                                "id": "411",
                                                "linkid": "410",
                                                "code": "10301050101",
                                                "paCode": "103010501",
                                                "yn": "N",
                                                "title": "大豆油",
                                                "alias": "大豆油",
                                                "about": null,
                                                "kws": null,
                                                "taxName": "植物油",
                                                "taxRate": "9%",
                                                "vip": "5",
                                                "itaxRate": "0.09",
                                                "taxCode": "1030105010100000000",
                                                "taxCodeTitle": "植物油",
                                                "iTitle": "*植物油*大豆油",
                                                "children": []
                                            },
                                            {
                                                "id": "412",
                                                "linkid": "410",
                                                "code": "10301050102",
                                                "paCode": "103010501",
                                                "yn": "N",
                                                "title": "棕榈油",
                                                "alias": "棕榈油",
                                                "about": null,
                                                "kws": "棕油、棕皮油",
                                                "taxName": "植物油",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1030105010200000000",
                                                "taxCodeTitle": "植物油",
                                                "iTitle": "*植物油*棕榈油",
                                                "children": []
                                            },
                                            {
                                                "id": "413",
                                                "linkid": "410",
                                                "code": "10301050103",
                                                "paCode": "103010501",
                                                "yn": "N",
                                                "title": "菜籽油",
                                                "alias": "菜籽油",
                                                "about": null,
                                                "kws": "菜油、油菜籽油、香菜油、芸苔油、芥花油",
                                                "taxName": "植物油",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1030105010300000000",
                                                "taxCodeTitle": "植物油",
                                                "iTitle": "*植物油*菜籽油",
                                                "children": []
                                            },
                                            {
                                                "id": "414",
                                                "linkid": "410",
                                                "code": "10301050104",
                                                "paCode": "103010501",
                                                "yn": "N",
                                                "title": "其他食用植物油",
                                                "alias": "其他食用植物油",
                                                "about": "包括花生油、牡丹籽油等",
                                                "kws": "花生油、牡丹籽油、花生毛油、棉籽毛油、玉米胚毛油、芝麻毛油、葵花籽毛油、红花籽毛油、橄榄毛油、芥子毛油、米糠毛油、花生精制油、棉籽精制油、精制玉米胚油、芝麻精制油、精制葵花籽油、精制红花籽油、精制橄榄油、精制茶籽油、精制米糠油、精制椰子油、亚麻子油",
                                                "taxName": "植物油",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1030105010400000000",
                                                "taxCodeTitle": "植物油",
                                                "iTitle": "*植物油*其他食用植物油",
                                                "children": []
                                            },
                                            {
                                                "id": "415",
                                                "linkid": "410",
                                                "code": "10301050105",
                                                "paCode": "103010501",
                                                "yn": "N",
                                                "title": "食用植物油脂",
                                                "alias": "食用植物油脂",
                                                "about": null,
                                                "kws": "人造奶油、人造黄油、液态人造奶油、起酥油、糕饼油、粉末油脂",
                                                "taxName": "植物油",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1030105010500000000",
                                                "taxCodeTitle": "植物油",
                                                "iTitle": "*植物油*食用植物油脂",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "416",
                                        "linkid": "409",
                                        "code": "103010502",
                                        "paCode": "1030105",
                                        "yn": "Y",
                                        "title": "非食用植物油",
                                        "alias": "非食用植物油",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "植物油",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1030105020000000000",
                                        "taxCodeTitle": "植物油",
                                        "iTitle": "*植物油*非食用植物油",
                                        "children": [
                                            {
                                                "id": "417",
                                                "linkid": "416",
                                                "code": "10301050201",
                                                "paCode": "103010502",
                                                "yn": "N",
                                                "title": "茴油、毛椰子油",
                                                "alias": "茴油毛椰子油",
                                                "about": null,
                                                "kws": "茴油、毛椰子油",
                                                "taxName": "植物油",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1030105020100000000",
                                                "taxCodeTitle": "植物油",
                                                "iTitle": "*植物油*茴油、毛椰子油",
                                                "children": []
                                            },
                                            {
                                                "id": "418",
                                                "linkid": "416",
                                                "code": "10301050299",
                                                "paCode": "103010502",
                                                "yn": "N",
                                                "title": "其他非食用植物油",
                                                "alias": "其他非食用植物油",
                                                "about": null,
                                                "kws": "初榨非食用植物油、精制非食用植物油、亚麻子初榨油、小桐子初榨油、黄连木果初榨油、文冠果初榨油、光皮梾果初榨油、蓖麻油、桐油、梓油、非食用精制椰子油、非食用亚麻子油",
                                                "taxName": "植物油",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1030105029900000000",
                                                "taxCodeTitle": "植物油",
                                                "iTitle": "*植物油*其他非食用植物油",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "419",
                                        "linkid": "409",
                                        "code": "103010503",
                                        "paCode": "1030105",
                                        "yn": "N",
                                        "title": "植物油分离制品",
                                        "alias": "植物油分离制品",
                                        "about": null,
                                        "kws": "豆油分离品、花生油分离品、葵花油分离品、红花油分离品、棉籽油分离品、低芥子酸菜籽油分离品、菜籽油分离品、芥子油分离品、橄榄油分离品、芝麻油分离品、玉米油分离品、蓖麻油分离品、桐油分离品、亚麻子油分离品、椰子油分离品、棕榈油分离品、油菜籽油分离制品、核桃油分离制品、沙棘籽油分离制品",
                                        "taxName": "植物油",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030105030000000000",
                                        "taxCodeTitle": "植物油",
                                        "iTitle": "*植物油*植物油分离制品",
                                        "children": []
                                    },
                                    {
                                        "id": "420",
                                        "linkid": "409",
                                        "code": "103010504",
                                        "paCode": "1030105",
                                        "yn": "N",
                                        "title": "植物油脂加工产品",
                                        "alias": "植物油脂加工产品",
                                        "about": null,
                                        "kws": "棉短绒、植物蜡、油鞣回收脂、油渣饼、甘蔗蜡、棉蜡、亚麻蜡、天然油鞣回收脂、人造油鞣回收脂、油脚、皂料、硬脂沥青、豆饼、花生油渣饼、棉籽油渣饼、亚麻籽油渣饼、葵花籽油渣饼、油菜籽油渣饼、玉米胚芽油渣饼、椰子油渣饼、干椰肉油渣饼",
                                        "taxName": "植物油",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1030105040000000000",
                                        "taxCodeTitle": "植物油",
                                        "iTitle": "*植物油*植物油脂加工产品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "421",
                                "linkid": "380",
                                "code": "1030106",
                                "paCode": "10301",
                                "yn": "Y",
                                "title": "糖、加工糖及制糖副产品",
                                "alias": "糖产品",
                                "about": "指以甘蔗、甜菜为原料制作的成品糖，以及以原糖或砂糖为原料精练加工的各种精制糖；不包括淀粉糖及糖果，淀粉糖（详见103011204），糖果（详见103020201）",
                                "kws": null,
                                "taxName": "糖",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1030106000000000000",
                                "taxCodeTitle": "糖",
                                "iTitle": "*糖*糖、加工糖及制糖副产品",
                                "children": [
                                    {
                                        "id": "422",
                                        "linkid": "421",
                                        "code": "103010601",
                                        "paCode": "1030106",
                                        "yn": "N",
                                        "title": "原糖",
                                        "alias": "原糖",
                                        "about": "未加香料或着色剂",
                                        "kws": "原糖、粗糖、二号糖、甘蔗制原糖、甜菜制原糖",
                                        "taxName": "糖",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030106010000000000",
                                        "taxCodeTitle": "糖",
                                        "iTitle": "*糖*原糖",
                                        "children": []
                                    },
                                    {
                                        "id": "423",
                                        "linkid": "421",
                                        "code": "103010602",
                                        "paCode": "1030106",
                                        "yn": "N",
                                        "title": "成品糖",
                                        "alias": "成品糖",
                                        "about": null,
                                        "kws": "成品糖、白砂糖、绵白糖、赤砂糖、红糖、黄砂糖",
                                        "taxName": "糖",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030106020000000000",
                                        "taxCodeTitle": "糖",
                                        "iTitle": "*糖*成品糖",
                                        "children": []
                                    },
                                    {
                                        "id": "424",
                                        "linkid": "421",
                                        "code": "103010603",
                                        "paCode": "1030106",
                                        "yn": "N",
                                        "title": "加工糖",
                                        "alias": "加工糖",
                                        "about": null,
                                        "kws": "加工糖、冰片糖、冰糖、方糖、精制糖浆",
                                        "taxName": "糖",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030106030000000000",
                                        "taxCodeTitle": "糖",
                                        "iTitle": "*糖*加工糖",
                                        "children": []
                                    },
                                    {
                                        "id": "425",
                                        "linkid": "421",
                                        "code": "103010604",
                                        "paCode": "1030106",
                                        "yn": "N",
                                        "title": "制糖副产品",
                                        "alias": "制糖副产品",
                                        "about": null,
                                        "kws": "糖蜜、甘蔗糖蜜、甜菜糖蜜、糖蜜粉",
                                        "taxName": "糖",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030106040000000000",
                                        "taxCodeTitle": "糖",
                                        "iTitle": "*糖*制糖副产品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "426",
                                "linkid": "380",
                                "code": "1030107",
                                "paCode": "10301",
                                "yn": "Y",
                                "title": "畜禽肉、油脂及食用杂碎",
                                "alias": "肉及肉制品",
                                "about": null,
                                "kws": null,
                                "taxName": "肉及肉制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1030107000000000000",
                                "taxCodeTitle": "肉及肉制品",
                                "iTitle": "*肉及肉制品*畜禽肉、油脂及食用杂碎",
                                "children": [
                                    {
                                        "id": "427",
                                        "linkid": "426",
                                        "code": "103010701",
                                        "paCode": "1030107",
                                        "yn": "Y",
                                        "title": "鲜、冷、冻肉",
                                        "alias": "鲜冷冻肉",
                                        "about": "包括鲜肉和暂时冷藏的肉、冻肉",
                                        "kws": null,
                                        "taxName": "肉及肉制品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1030107010000000000",
                                        "taxCodeTitle": "肉及肉制品",
                                        "iTitle": "*肉及肉制品*鲜、冷、冻肉",
                                        "children": [
                                            {
                                                "id": "428",
                                                "linkid": "427",
                                                "code": "10301070101",
                                                "paCode": "103010701",
                                                "yn": "N",
                                                "title": "猪、牛、羊、鸡、鸭、鹅鲜、冷、冻肉",
                                                "alias": "猪牛羊鸡",
                                                "about": null,
                                                "kws": "冻猪肉、冻牛肉、冻羊肉、冻鸡肉、冻鸭肉、冻鹅肉、鲜猪肉、鲜牛肉、鲜羊肉、鲜鸡肉、鲜鸭肉、鲜鹅肉、冷猪肉、冷牛肉、冷羊肉、冷鸡肉、冷鸭肉、冷鹅肉",
                                                "taxName": "肉及肉制品",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1030107010100000000",
                                                "taxCodeTitle": "肉及肉制品",
                                                "iTitle": "*肉及肉制品*猪、牛、羊、鸡、鸭、鹅鲜、冷、冻肉",
                                                "children": []
                                            },
                                            {
                                                "id": "429",
                                                "linkid": "427",
                                                "code": "10301070199",
                                                "paCode": "103010701",
                                                "yn": "N",
                                                "title": "其他鲜、冷、冻肉",
                                                "alias": "其他鲜冷冻肉",
                                                "about": null,
                                                "kws": null,
                                                "taxName": "肉及肉制品",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1030107019900000000",
                                                "taxCodeTitle": "肉及肉制品",
                                                "iTitle": "*肉及肉制品*其他鲜、冷、冻肉",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "430",
                                        "linkid": "426",
                                        "code": "103010702",
                                        "paCode": "1030107",
                                        "yn": "N",
                                        "title": "动物肠衣",
                                        "alias": "动物肠衣",
                                        "about": "包括动物的肠、肚、膀胱、皮囊或类似肠衣",
                                        "kws": "肚、膀胱、皮囊、猪肠衣、牛肠衣、羊肠衣",
                                        "taxName": "肉及肉制品",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1030107020000000000",
                                        "taxCodeTitle": "肉及肉制品",
                                        "iTitle": "*肉及肉制品*动物肠衣",
                                        "children": []
                                    },
                                    {
                                        "id": "431",
                                        "linkid": "426",
                                        "code": "103010703",
                                        "paCode": "1030107",
                                        "yn": "N",
                                        "title": "可食用动物杂碎",
                                        "alias": "可食用动物杂碎",
                                        "about": null,
                                        "kws": "猪杂碎、牛杂碎、羊杂碎、鸡杂碎、鸭杂碎、鹅杂碎",
                                        "taxName": "肉及肉制品",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1030107030000000000",
                                        "taxCodeTitle": "肉及肉制品",
                                        "iTitle": "*肉及肉制品*可食用动物杂碎",
                                        "children": []
                                    },
                                    {
                                        "id": "432",
                                        "linkid": "426",
                                        "code": "103010704",
                                        "paCode": "1030107",
                                        "yn": "N",
                                        "title": "动物油脂及加工制品",
                                        "alias": "动物油脂及加工制品",
                                        "about": null,
                                        "kws": "猪脂肪、家禽脂肪、压榨油脂、食用动物脂油、油硬脂、骨油、骨髓油、蛋黄油、牛脚油",
                                        "taxName": "肉及肉制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030107040000000000",
                                        "taxCodeTitle": "肉及肉制品",
                                        "iTitle": "*肉及肉制品*动物油脂及加工制品",
                                        "children": []
                                    },
                                    {
                                        "id": "433",
                                        "linkid": "426",
                                        "code": "103010705",
                                        "paCode": "1030107",
                                        "yn": "N",
                                        "title": "动物精及汁",
                                        "alias": "动物精及汁",
                                        "about": "肉“精”用于制造某些配制食品，例如，汤料（不论是否浓缩）及调味汁；而“汁”主要作为营养食品",
                                        "kws": "汤料、调味汁",
                                        "taxName": "肉及肉制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030107050000000000",
                                        "taxCodeTitle": "肉及肉制品",
                                        "iTitle": "*肉及肉制品*动物精及汁",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "434",
                                "linkid": "380",
                                "code": "1030108",
                                "paCode": "10301",
                                "yn": "Y",
                                "title": "熟肉制品",
                                "alias": "熟肉制品",
                                "about": "不包括罐头制品（详见1030205）",
                                "kws": null,
                                "taxName": "熟肉制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1030108000000000000",
                                "taxCodeTitle": "熟肉制品",
                                "iTitle": "*熟肉制品*熟肉制品",
                                "children": [
                                    {
                                        "id": "435",
                                        "linkid": "434",
                                        "code": "103010801",
                                        "paCode": "1030108",
                                        "yn": "N",
                                        "title": "蒸煮香肠制品",
                                        "alias": "蒸煮香肠制品",
                                        "about": "包括各类香肠、发酵香肠、高温蒸煮火腿肠、法兰克福肠、肉粉肠、肉粉肚、软包装肉类罐头等",
                                        "kws": "火腿肠、肉粉肠、肉粉肚、法兰克福肠",
                                        "taxName": "熟肉制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030108010000000000",
                                        "taxCodeTitle": "熟肉制品",
                                        "iTitle": "*熟肉制品*蒸煮香肠制品",
                                        "children": []
                                    },
                                    {
                                        "id": "436",
                                        "linkid": "434",
                                        "code": "103010802",
                                        "paCode": "1030108",
                                        "yn": "N",
                                        "title": "熏肉制品",
                                        "alias": "熏肉制品",
                                        "about": null,
                                        "kws": "熏猪肉制品、熏牛肉制品、熏羊肉制品、熏鸡肉制品、熏鸭肉制品、熏鹅肉制品",
                                        "taxName": "熟肉制品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1030108020000000000",
                                        "taxCodeTitle": "熟肉制品",
                                        "iTitle": "*熟肉制品*熏肉制品",
                                        "children": []
                                    },
                                    {
                                        "id": "437",
                                        "linkid": "434",
                                        "code": "103010803",
                                        "paCode": "1030108",
                                        "yn": "N",
                                        "title": "酱卤烧烤肉制品",
                                        "alias": "酱卤烧烤肉制品",
                                        "about": "指经煮（不包括烫洗或类似处理）、蒸、烤、炒或其他方法烹饪的肉或食用杂碎；包括各类酱肉、扒鸡、烧鸡、烤鸭、酱肘子、卤肉、卤下货、盐水鸭、叫花鸡、叉烧肉",
                                        "kws": "扒鸡、烧鸡、烤鸭、酱肘子、卤肉、卤下货、盐水鸭、叫花鸡、叉烧肉",
                                        "taxName": "熟肉制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030108030000000000",
                                        "taxCodeTitle": "熟肉制品",
                                        "iTitle": "*熟肉制品*酱卤烧烤肉制品",
                                        "children": []
                                    },
                                    {
                                        "id": "438",
                                        "linkid": "434",
                                        "code": "103010804",
                                        "paCode": "1030108",
                                        "yn": "N",
                                        "title": "腌腊肉制品",
                                        "alias": "腌腊肉制品",
                                        "about": "指干、盐腌或盐渍的肉及杂碎；包括各类火腿、腊肉、腊肠、板鸭、腊乳猪、咸肉、酱封肉",
                                        "kws": "火腿、腊肉、腊肠、板鸭、腊乳猪、咸肉、酱封肉",
                                        "taxName": "熟肉制品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1030108040000000000",
                                        "taxCodeTitle": "熟肉制品",
                                        "iTitle": "*熟肉制品*腌腊肉制品",
                                        "children": []
                                    },
                                    {
                                        "id": "439",
                                        "linkid": "434",
                                        "code": "103010805",
                                        "paCode": "1030108",
                                        "yn": "N",
                                        "title": "干炸肉制品",
                                        "alias": "干炸肉制品",
                                        "about": "指经煎、炸、炒或其他方法烹饪的肉或食用杂碎；包括各类风干肉、肉干、肉松、肉脯及各类油炸肉制品",
                                        "kws": "风干肉、肉干、肉松、肉脯、油炸肉",
                                        "taxName": "熟肉制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030108050000000000",
                                        "taxCodeTitle": "熟肉制品",
                                        "iTitle": "*熟肉制品*干炸肉制品",
                                        "children": []
                                    },
                                    {
                                        "id": "440",
                                        "linkid": "434",
                                        "code": "103010899",
                                        "paCode": "1030108",
                                        "yn": "N",
                                        "title": "其他熟肉制品",
                                        "alias": "其他熟肉制品",
                                        "about": "包括未列明制作的肉、食用杂碎及动物血熟制品",
                                        "kws": null,
                                        "taxName": "熟肉制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030108990000000000",
                                        "taxCodeTitle": "熟肉制品",
                                        "iTitle": "*熟肉制品*其他熟肉制品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "441",
                                "linkid": "380",
                                "code": "1030109",
                                "paCode": "10301",
                                "yn": "Y",
                                "title": "水产加工品",
                                "alias": "水产加工品",
                                "about": null,
                                "kws": null,
                                "taxName": "水产加工品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1030109000000000000",
                                "taxCodeTitle": "水产加工品",
                                "iTitle": "*水产加工品*水产加工品",
                                "children": [
                                    {
                                        "id": "442",
                                        "linkid": "441",
                                        "code": "103010901",
                                        "paCode": "1030109",
                                        "yn": "N",
                                        "title": "冷冻水产品",
                                        "alias": "冷冻水产品",
                                        "about": null,
                                        "kws": "冷冻鱼、冻鱼片、冻鱼肉、冷冻虾、冷冻蟹、冷冻软体动物",
                                        "taxName": "水产加工品",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1030109010000000000",
                                        "taxCodeTitle": "水产加工品",
                                        "iTitle": "*水产加工品*冷冻水产品",
                                        "children": []
                                    },
                                    {
                                        "id": "443",
                                        "linkid": "441",
                                        "code": "103010902",
                                        "paCode": "1030109",
                                        "yn": "N",
                                        "title": "干制水产品",
                                        "alias": "干制水产品",
                                        "about": null,
                                        "kws": "干制鱼、干制鱼片、干制软体动物、干制水生植物",
                                        "taxName": "水产加工品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1030109020000000000",
                                        "taxCodeTitle": "水产加工品",
                                        "iTitle": "*水产加工品*干制水产品",
                                        "children": []
                                    },
                                    {
                                        "id": "444",
                                        "linkid": "441",
                                        "code": "103010903",
                                        "paCode": "1030109",
                                        "yn": "N",
                                        "title": "腌渍水产品",
                                        "alias": "腌渍水产品",
                                        "about": "包括盐腌渍的鱼及可食用的鱼粉和粒",
                                        "kws": "腌渍鱼、腌渍鱼片、腌渍软体动物",
                                        "taxName": "水产加工品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1030109030000000000",
                                        "taxCodeTitle": "水产加工品",
                                        "iTitle": "*水产加工品*腌渍水产品",
                                        "children": []
                                    },
                                    {
                                        "id": "445",
                                        "linkid": "441",
                                        "code": "103010904",
                                        "paCode": "1030109",
                                        "yn": "N",
                                        "title": "熏制水产品",
                                        "alias": "熏制水产品",
                                        "about": null,
                                        "kws": "熏鱼、熏鱼片",
                                        "taxName": "水产加工品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1030109040000000000",
                                        "taxCodeTitle": "水产加工品",
                                        "iTitle": "*水产加工品*熏制水产品",
                                        "children": []
                                    },
                                    {
                                        "id": "446",
                                        "linkid": "441",
                                        "code": "103010905",
                                        "paCode": "1030109",
                                        "yn": "N",
                                        "title": "鱼糜（熟肉）制品",
                                        "alias": "鱼糜（熟肉）制品",
                                        "about": "经煮、蒸、烤、煎、炸、炒或用醋、油等其他方法制作或保藏的可直接食用，或简单加工即可食用的水生动物制品，不包括罐头制品（详见1030205）",
                                        "kws": "鱼香肠、鱼丸、鱼肉酱、鱼子酱、含鱼配制食品",
                                        "taxName": "水产加工品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1030109050000000000",
                                        "taxCodeTitle": "水产加工品",
                                        "iTitle": "*水产加工品*鱼糜（熟肉）制品",
                                        "children": []
                                    },
                                    {
                                        "id": "447",
                                        "linkid": "441",
                                        "code": "103010906",
                                        "paCode": "1030109",
                                        "yn": "N",
                                        "title": "甲壳水产品加工品",
                                        "alias": "甲壳水产品加工品",
                                        "about": "经煮、蒸、烤、煎、炸、炒或用醋、油等其他方法制作或保藏的甲壳水生动物熟制品，可直接食用，或简单加工即可食用的水生动物制品，不包括罐头制品（详见1030205）",
                                        "kws": "加工蟹、虾皮",
                                        "taxName": "水产加工品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1030109060000000000",
                                        "taxCodeTitle": "水产加工品",
                                        "iTitle": "*水产加工品*甲壳水产品加工品",
                                        "children": []
                                    },
                                    {
                                        "id": "448",
                                        "linkid": "441",
                                        "code": "103010907",
                                        "paCode": "1030109",
                                        "yn": "N",
                                        "title": "水产品精、汁制品",
                                        "alias": "水产品精、汁制品",
                                        "about": null,
                                        "kws": "鱼精、鱼汁、甲壳动物精、甲壳动物汁",
                                        "taxName": "水产加工品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030109070000000000",
                                        "taxCodeTitle": "水产加工品",
                                        "iTitle": "*水产加工品*水产品精、汁制品",
                                        "children": []
                                    },
                                    {
                                        "id": "449",
                                        "linkid": "441",
                                        "code": "103010908",
                                        "paCode": "1030109",
                                        "yn": "N",
                                        "title": "水产品油脂制品",
                                        "alias": "水产品油脂制品",
                                        "about": "包括鱼或海生哺乳动物的油、脂及其分离品",
                                        "kws": "鱼油、鱼脂",
                                        "taxName": "水产加工品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030109080000000000",
                                        "taxCodeTitle": "水产加工品",
                                        "iTitle": "*水产加工品*水产品油脂制品",
                                        "children": []
                                    },
                                    {
                                        "id": "450",
                                        "linkid": "441",
                                        "code": "103010999",
                                        "paCode": "1030109",
                                        "yn": "N",
                                        "title": "其他水产加工品",
                                        "alias": "其他水产加工品",
                                        "about": null,
                                        "kws": "珍珠粉",
                                        "taxName": "水产加工品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030109990000000000",
                                        "taxCodeTitle": "水产加工品",
                                        "iTitle": "*水产加工品*其他水产加工品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "451",
                                "linkid": "380",
                                "code": "1030110",
                                "paCode": "10301",
                                "yn": "Y",
                                "title": "蔬菜加工品",
                                "alias": "蔬菜加工品",
                                "about": "不包括蔬菜罐头食品（详见1030205）",
                                "kws": null,
                                "taxName": "蔬菜加工品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1030110000000000000",
                                "taxCodeTitle": "蔬菜加工品",
                                "iTitle": "*蔬菜加工品*蔬菜加工品",
                                "children": [
                                    {
                                        "id": "452",
                                        "linkid": "451",
                                        "code": "103011001",
                                        "paCode": "1030110",
                                        "yn": "N",
                                        "title": "冷冻蔬菜",
                                        "alias": "冷冻蔬菜",
                                        "about": "冷冻蔬菜通常是以工业速冻法制得",
                                        "kws": "冷冻马铃薯、冷冻豆类蔬菜、冷冻菠菜、冷冻甜玉米、冷冻松茸、冷冻蒜苔、冷冻蒜苗、冷冻青蒜、冷冻蒜头",
                                        "taxName": "蔬菜加工品",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1030110010000000000",
                                        "taxCodeTitle": "蔬菜加工品",
                                        "iTitle": "*蔬菜加工品*冷冻蔬菜",
                                        "children": []
                                    },
                                    {
                                        "id": "453",
                                        "linkid": "451",
                                        "code": "103011002",
                                        "paCode": "1030110",
                                        "yn": "N",
                                        "title": "暂时保藏蔬菜（原料）",
                                        "alias": "暂时保藏蔬菜（原料）",
                                        "about": "指适用于在运输或贮存时，仅为暂时保藏而进行处理（例如，存于二氧化硫气体、盐水、亚硫酸水或其他防腐液中），但不适于直接食用的蔬菜，主要用作食品工业的原材料",
                                        "kws": "暂时保藏油橄榄、暂时保藏刺山柑、暂时保藏黄瓜、暂时保藏小黄瓜、盐水伞菌属蘑菇、盐水蘑菇、盐水块菌、盐水竹笋、盐水大蒜",
                                        "taxName": "蔬菜加工品",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1030110020000000000",
                                        "taxCodeTitle": "蔬菜加工品",
                                        "iTitle": "*蔬菜加工品*暂时保藏蔬菜（原料）",
                                        "children": []
                                    },
                                    {
                                        "id": "454",
                                        "linkid": "451",
                                        "code": "103011003",
                                        "paCode": "1030110",
                                        "yn": "N",
                                        "title": "干制蔬菜（脱水蔬菜）",
                                        "alias": "干制蔬菜（脱水蔬菜）",
                                        "about": "指经干制（包括脱水、蒸干或冻干），即用各种方法使其所含天然水分去掉的蔬菜；包括干制蔬菜、干菜碎片或干菜粉",
                                        "kws": "干制蔬菜、脱水蔬菜、干菜碎片、干菜粉",
                                        "taxName": "蔬菜加工品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1030110030000000000",
                                        "taxCodeTitle": "蔬菜加工品",
                                        "iTitle": "*蔬菜加工品*干制蔬菜（脱水蔬菜）",
                                        "children": []
                                    },
                                    {
                                        "id": "455",
                                        "linkid": "451",
                                        "code": "103011004",
                                        "paCode": "1030110",
                                        "yn": "N",
                                        "title": "腌渍菜",
                                        "alias": "腌渍菜",
                                        "about": "包括酱腌渍菜、盐渍菜、清水渍菜及其他腌渍菜",
                                        "kws": "糖醋渍菜、醋酸黄瓜、糖蒜、酱腌菜、咸榨菜、咸蕨菜、酱腌藠头、酱腌什锦蔬菜、朝鲜泡菜、川味泡菜、盐渍腌制番茄、盐渍番茄、番茄酱、番茄浆汁、盐渍伞菌属蘑菇、盐渍块菌、非醋腌制豆、笋、腌渍豌豆、盐渍豇豆、盐渍菜豆、盐渍芦笋、清水渍甜玉米、赤豆馅、虾油渍菜、糟糠渍菜",
                                        "taxName": "蔬菜加工品",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1030110040000000000",
                                        "taxCodeTitle": "蔬菜加工品",
                                        "iTitle": "*蔬菜加工品*腌渍菜",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "456",
                                "linkid": "380",
                                "code": "1030111",
                                "paCode": "10301",
                                "yn": "Y",
                                "title": "水果、坚果加工品",
                                "alias": "果类加工品",
                                "about": null,
                                "kws": null,
                                "taxName": "果类加工品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1030111000000000000",
                                "taxCodeTitle": "果类加工品",
                                "iTitle": "*果类加工品*水果、坚果加工品",
                                "children": [
                                    {
                                        "id": "457",
                                        "linkid": "456",
                                        "code": "103011101",
                                        "paCode": "1030111",
                                        "yn": "N",
                                        "title": "冷冻水果及坚果",
                                        "alias": "冷冻水果及坚果",
                                        "about": "通常是以工业速冻法制得；包括冻前蒸过或用水煮过的水果及坚果",
                                        "kws": "冷冻水果、冷冻坚果、冷冻草莓、冷冻樱桃、冷冻栗子",
                                        "taxName": "果类加工品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1030111010000000000",
                                        "taxCodeTitle": "果类加工品",
                                        "iTitle": "*果类加工品*冷冻水果及坚果",
                                        "children": []
                                    },
                                    {
                                        "id": "458",
                                        "linkid": "456",
                                        "code": "103011102",
                                        "paCode": "1030111",
                                        "yn": "N",
                                        "title": "水果酱",
                                        "alias": "水果酱",
                                        "about": "不包括罐头（详见1030205）。",
                                        "kws": "水果酱、柑橘类酱、苹果酱、红果酱、草莓酱、桃酱",
                                        "taxName": "果类加工品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030111020000000000",
                                        "taxCodeTitle": "果类加工品",
                                        "iTitle": "*果类加工品*水果酱",
                                        "children": []
                                    },
                                    {
                                        "id": "459",
                                        "linkid": "456",
                                        "code": "103011103",
                                        "paCode": "1030111",
                                        "yn": "N",
                                        "title": "坚果酱",
                                        "alias": "坚果酱",
                                        "about": "不包括罐头（详见1030205）。",
                                        "kws": "花生酱、栗子酱、坚果酱",
                                        "taxName": "果类加工品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030111030000000000",
                                        "taxCodeTitle": "果类加工品",
                                        "iTitle": "*果类加工品*坚果酱",
                                        "children": []
                                    },
                                    {
                                        "id": "460",
                                        "linkid": "456",
                                        "code": "103011104",
                                        "paCode": "1030111",
                                        "yn": "N",
                                        "title": "果泥",
                                        "alias": "果泥",
                                        "about": "不包括罐头（详见1030205）。",
                                        "kws": "果泥、柑橘类果泥、苹果泥、红果泥、草莓泥、枣泥",
                                        "taxName": "果类加工品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030111040000000000",
                                        "taxCodeTitle": "果类加工品",
                                        "iTitle": "*果类加工品*果泥",
                                        "children": []
                                    },
                                    {
                                        "id": "461",
                                        "linkid": "456",
                                        "code": "103011105",
                                        "paCode": "1030111",
                                        "yn": "N",
                                        "title": "果膏及类似制品",
                                        "alias": "果膏及类似制品",
                                        "about": "不包括罐头（详见1030205）。",
                                        "kws": "柑橘类果膏、果膏、秋梨膏",
                                        "taxName": "果类加工品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030111050000000000",
                                        "taxCodeTitle": "果类加工品",
                                        "iTitle": "*果类加工品*果膏及类似制品",
                                        "children": []
                                    },
                                    {
                                        "id": "462",
                                        "linkid": "456",
                                        "code": "103011106",
                                        "paCode": "1030111",
                                        "yn": "N",
                                        "title": "果核及核仁",
                                        "alias": "果核及核仁",
                                        "about": "指直接或间接供人食用的果核、果仁及其他植物产品。",
                                        "kws": "苦杏仁、甜杏仁、果核、核仁",
                                        "taxName": "果类加工品",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1030111060000000000",
                                        "taxCodeTitle": "果类加工品",
                                        "iTitle": "*果类加工品*果核及核仁",
                                        "children": []
                                    },
                                    {
                                        "id": "463",
                                        "linkid": "456",
                                        "code": "103011107",
                                        "paCode": "1030111",
                                        "yn": "N",
                                        "title": "焙、炒加工坚果及果仁",
                                        "alias": "焙炒加工坚果及果仁",
                                        "about": "指干炒、用油或脂肪烘炒的杏仁、花生、槟榔子及其他坚果，不论是否含或裹植物油、盐、香料、调味香料及其他添加剂",
                                        "kws": "焙加工坚果、炒加工坚果、焙加工果仁、炒加工果仁、焙炒花生、焙炒花生仁、焙炒栗子、焙炒瓜子、焙炒瓜子仁、焙炒松子、焙炒杏仁、焙炒榛子、焙炒榛子仁",
                                        "taxName": "果类加工品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030111070000000000",
                                        "taxCodeTitle": "果类加工品",
                                        "iTitle": "*果类加工品*焙、炒加工坚果及果仁",
                                        "children": []
                                    },
                                    {
                                        "id": "464",
                                        "linkid": "456",
                                        "code": "103011108",
                                        "paCode": "1030111",
                                        "yn": "N",
                                        "title": "蒸煮加工坚果及果仁",
                                        "alias": "蒸煮加工坚果及果仁",
                                        "about": null,
                                        "kws": "蒸煮加工坚果、蒸煮加工果仁、煮花生、煮花生仁",
                                        "taxName": "果类加工品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030111080000000000",
                                        "taxCodeTitle": "果类加工品",
                                        "iTitle": "*果类加工品*蒸煮加工坚果及果仁",
                                        "children": []
                                    },
                                    {
                                        "id": "465",
                                        "linkid": "456",
                                        "code": "103011109",
                                        "paCode": "1030111",
                                        "yn": "N",
                                        "title": "暂时保藏水果及坚果（原料）",
                                        "alias": "暂时保藏水果及坚果",
                                        "about": "指使用二氧化硫气体、盐水、亚硫酸水或其他防腐液暂时保藏的水果及坚果，不适于直接食用，主要用于食品工业（制果酱、蜜饯水果等）",
                                        "kws": "暂时保藏水果、暂时保藏坚果",
                                        "taxName": "果类加工品",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1030111090000000000",
                                        "taxCodeTitle": "果类加工品",
                                        "iTitle": "*果类加工品*暂时保藏水果及坚果（原料）",
                                        "children": []
                                    },
                                    {
                                        "id": "466",
                                        "linkid": "456",
                                        "code": "103011199",
                                        "paCode": "1030111",
                                        "yn": "N",
                                        "title": "其他水果、坚果加工品",
                                        "alias": "其他果类加工品",
                                        "about": "指其他方法制作或保藏的水果，包括各种水果干；但不包括水果罐头（详见1030205）。",
                                        "kws": null,
                                        "taxName": "果类加工品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1030111990000000000",
                                        "taxCodeTitle": "果类加工品",
                                        "iTitle": "*果类加工品*其他水果、坚果加工品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "467",
                                "linkid": "380",
                                "code": "1030112",
                                "paCode": "10301",
                                "yn": "Y",
                                "title": "淀粉及淀粉制品",
                                "alias": "淀粉制品",
                                "about": null,
                                "kws": null,
                                "taxName": "淀粉制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1030112000000000000",
                                "taxCodeTitle": "淀粉制品",
                                "iTitle": "*淀粉制品*淀粉及淀粉制品",
                                "children": [
                                    {
                                        "id": "468",
                                        "linkid": "467",
                                        "code": "103011201",
                                        "paCode": "1030112",
                                        "yn": "Y",
                                        "title": "淀粉",
                                        "alias": "淀粉",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "淀粉制品",
                                        "taxRate": "",
                                        "vip": "5",
                                        "itaxRate": null,
                                        "taxCode": "1030112010000000000",
                                        "taxCodeTitle": "淀粉制品",
                                        "iTitle": "*淀粉制品*淀粉",
                                        "children": [
                                            {
                                                "id": "469",
                                                "linkid": "468",
                                                "code": "10301120101",
                                                "paCode": "103011201",
                                                "yn": "N",
                                                "title": "小麦淀粉",
                                                "alias": "小麦淀粉",
                                                "about": null,
                                                "kws": "小麦淀粉",
                                                "taxName": "淀粉制品",
                                                "taxRate": "13%",
                                                "vip": "5",
                                                "itaxRate": "0.13",
                                                "taxCode": "1030112010100000000",
                                                "taxCodeTitle": "淀粉制品",
                                                "iTitle": "*淀粉制品*小麦淀粉",
                                                "children": []
                                            },
                                            {
                                                "id": "470",
                                                "linkid": "468",
                                                "code": "10301120102",
                                                "paCode": "103011201",
                                                "yn": "N",
                                                "title": "玉米淀粉",
                                                "alias": "玉米淀粉",
                                                "about": null,
                                                "kws": "玉米淀粉",
                                                "taxName": "淀粉制品",
                                                "taxRate": "13%",
                                                "vip": "5",
                                                "itaxRate": "0.13",
                                                "taxCode": "1030112010200000000",
                                                "taxCodeTitle": "淀粉制品",
                                                "iTitle": "*淀粉制品*玉米淀粉",
                                                "children": []
                                            },
                                            {
                                                "id": "471",
                                                "linkid": "468",
                                                "code": "10301120103",
                                                "paCode": "103011201",
                                                "yn": "N",
                                                "title": "马铃薯淀粉",
                                                "alias": "马铃薯淀粉",
                                                "about": null,
                                                "kws": "马铃薯淀粉、土豆淀粉",
                                                "taxName": "淀粉制品",
                                                "taxRate": "13%",
                                                "vip": "5",
                                                "itaxRate": "0.13",
                                                "taxCode": "1030112010300000000",
                                                "taxCodeTitle": "淀粉制品",
                                                "iTitle": "*淀粉制品*马铃薯淀粉",
                                                "children": []
                                            },
                                            {
                                                "id": "472",
                                                "linkid": "468",
                                                "code": "10301120199",
                                                "paCode": "103011201",
                                                "yn": "N",
                                                "title": "其他淀粉",
                                                "alias": "其他淀粉",
                                                "about": null,
                                                "kws": null,
                                                "taxName": "淀粉制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1030112019900000000",
                                                "taxCodeTitle": "淀粉制品",
                                                "iTitle": "*淀粉制品*其他淀粉",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "473",
                                        "linkid": "467",
                                        "code": "103011202",
                                        "paCode": "1030112",
                                        "yn": "N",
                                        "title": "菊粉",
                                        "alias": "菊粉",
                                        "about": "菊粉从菊芋、大丽花根及菊苣根提取而得；经长时间在沸水中煎煮水解后成为果糖（左旋糖）",
                                        "kws": "菊粉",
                                        "taxName": "淀粉制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030112020000000000",
                                        "taxCodeTitle": "淀粉制品",
                                        "iTitle": "*淀粉制品*菊粉",
                                        "children": []
                                    },
                                    {
                                        "id": "474",
                                        "linkid": "467",
                                        "code": "103011203",
                                        "paCode": "1030112",
                                        "yn": "N",
                                        "title": "淀粉制品",
                                        "alias": "淀粉制品",
                                        "about": "淀粉制品是以淀粉为原料，经过机械的、化学的或生化工艺的加工而制成的产品。",
                                        "kws": "淀粉制品、粉丝、粉条、粉皮",
                                        "taxName": "淀粉制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030112030000000000",
                                        "taxCodeTitle": "淀粉制品",
                                        "iTitle": "*淀粉制品*淀粉制品",
                                        "children": []
                                    },
                                    {
                                        "id": "475",
                                        "linkid": "467",
                                        "code": "103011204",
                                        "paCode": "1030112",
                                        "yn": "N",
                                        "title": "淀粉糖",
                                        "alias": "淀粉糖",
                                        "about": "利用含淀粉的粮食、薯类等为原料，经过酸法、酸酶法或酶法制取的糖",
                                        "kws": "淀粉糖、麦芽糖、葡萄糖、果葡糖浆、葡萄糖浆、果糖",
                                        "taxName": "淀粉制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030112040000000000",
                                        "taxCodeTitle": "淀粉制品",
                                        "iTitle": "*淀粉制品*淀粉糖",
                                        "children": []
                                    },
                                    {
                                        "id": "476",
                                        "linkid": "467",
                                        "code": "103011205",
                                        "paCode": "1030112",
                                        "yn": "N",
                                        "title": "面筋",
                                        "alias": "面筋",
                                        "about": "面筋是用面粉通过简单水分法使其与其他成分（淀粉等）分离制得",
                                        "kws": "面筋、湿面筋、干面筋",
                                        "taxName": "淀粉制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030112050000000000",
                                        "taxCodeTitle": "淀粉制品",
                                        "iTitle": "*淀粉制品*面筋",
                                        "children": []
                                    },
                                    {
                                        "id": "477",
                                        "linkid": "467",
                                        "code": "103011206",
                                        "paCode": "1030112",
                                        "yn": "N",
                                        "title": "糊精及改性淀粉",
                                        "alias": "糊精改性淀粉",
                                        "about": "即淀粉经热、化学品（例如，酸、碱）或淀粉酶的作用而转化的产品，及经氧化、酯化、醚化等处理的改性淀粉",
                                        "kws": "糊精、改性淀粉、可溶性淀粉、醚化淀粉、酯化淀粉、β-环状糊精、羧甲基纤维素钠",
                                        "taxName": "淀粉制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030112060000000000",
                                        "taxCodeTitle": "淀粉制品",
                                        "iTitle": "*淀粉制品*糊精及改性淀粉",
                                        "children": []
                                    },
                                    {
                                        "id": "478",
                                        "linkid": "467",
                                        "code": "103011299",
                                        "paCode": "1030112",
                                        "yn": "N",
                                        "title": "其他淀粉及淀粉制品",
                                        "alias": "其他淀粉制品",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "淀粉制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030112990000000000",
                                        "taxCodeTitle": "淀粉制品",
                                        "iTitle": "*淀粉制品*其他淀粉及淀粉制品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "479",
                                "linkid": "380",
                                "code": "1030113",
                                "paCode": "10301",
                                "yn": "Y",
                                "title": "豆腐及豆制品",
                                "alias": "豆腐及豆制品",
                                "about": null,
                                "kws": null,
                                "taxName": "豆制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1030113000000000000",
                                "taxCodeTitle": "豆制品",
                                "iTitle": "*豆制品*豆腐及豆制品",
                                "children": [
                                    {
                                        "id": "480",
                                        "linkid": "479",
                                        "code": "103011301",
                                        "paCode": "1030113",
                                        "yn": "N",
                                        "title": "水豆腐",
                                        "alias": "水豆腐",
                                        "about": null,
                                        "kws": "水豆腐、盒包装水豆腐、散装水豆腐",
                                        "taxName": "豆制品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030113010000000000",
                                        "taxCodeTitle": "豆制品",
                                        "iTitle": "*豆制品*水豆腐",
                                        "children": []
                                    },
                                    {
                                        "id": "481",
                                        "linkid": "479",
                                        "code": "103011302",
                                        "paCode": "1030113",
                                        "yn": "N",
                                        "title": "豆制品",
                                        "alias": "豆制品",
                                        "about": null,
                                        "kws": "豆制品、豆腐乳、油炸豆腐制品、卤制豆腐制品、干豆腐制品",
                                        "taxName": "豆制品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030113020000000000",
                                        "taxCodeTitle": "豆制品",
                                        "iTitle": "*豆制品*豆制品",
                                        "children": []
                                    },
                                    {
                                        "id": "482",
                                        "linkid": "479",
                                        "code": "103011303",
                                        "paCode": "1030113",
                                        "yn": "N",
                                        "title": "豆浆及豆浆粉",
                                        "alias": "豆浆及豆浆粉",
                                        "about": null,
                                        "kws": "鲜豆浆、豆浆粉、豆浆",
                                        "taxName": "豆制品",
                                        "taxRate": "",
                                        "vip": "5",
                                        "itaxRate": null,
                                        "taxCode": "1030113030000000000",
                                        "taxCodeTitle": "豆制品",
                                        "iTitle": "*豆制品*豆浆及豆浆粉",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "483",
                                "linkid": "380",
                                "code": "1030114",
                                "paCode": "10301",
                                "yn": "Y",
                                "title": "蛋制品",
                                "alias": "蛋制品",
                                "about": "包括以蛋为材料的制品。",
                                "kws": null,
                                "taxName": "蛋制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1030114000000000000",
                                "taxCodeTitle": "蛋制品",
                                "iTitle": "*蛋制品*蛋制品",
                                "children": [
                                    {
                                        "id": "484",
                                        "linkid": "483",
                                        "code": "103011401",
                                        "paCode": "1030114",
                                        "yn": "N",
                                        "title": "鸡鸭鹅蛋品",
                                        "alias": "鸡鸭鹅蛋品",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "蛋制品",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1030114010000000000",
                                        "taxCodeTitle": "蛋制品",
                                        "iTitle": "*蛋制品*鸡鸭鹅蛋品",
                                        "children": []
                                    },
                                    {
                                        "id": "485",
                                        "linkid": "483",
                                        "code": "103011402",
                                        "paCode": "1030114",
                                        "yn": "N",
                                        "title": "其他蛋品",
                                        "alias": "其他蛋品",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "蛋制品",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1030114020000000000",
                                        "taxCodeTitle": "蛋制品",
                                        "iTitle": "*蛋制品*其他蛋品",
                                        "children": []
                                    },
                                    {
                                        "id": "486",
                                        "linkid": "483",
                                        "code": "103011403",
                                        "paCode": "1030114",
                                        "yn": "N",
                                        "title": "再制蛋",
                                        "alias": "再制蛋",
                                        "about": "包括腌蛋等经加工的蛋",
                                        "kws": "再制蛋、咸蛋、松花蛋、糟蛋",
                                        "taxName": "蛋制品",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1030114030000000000",
                                        "taxCodeTitle": "蛋制品",
                                        "iTitle": "*蛋制品*再制蛋",
                                        "children": []
                                    },
                                    {
                                        "id": "487",
                                        "linkid": "483",
                                        "code": "103011404",
                                        "paCode": "1030114",
                                        "yn": "N",
                                        "title": "卵清蛋白",
                                        "alias": "卵清蛋白",
                                        "about": "卵清蛋白就是动物卵中的贮藏蛋白，一种糖蛋白，含有微量的磷，系卵清中蛋白质的主要成分",
                                        "kws": "卵清蛋白、干卵清蛋白",
                                        "taxName": "蛋白制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030114040000000000",
                                        "taxCodeTitle": "蛋白制品",
                                        "iTitle": "*蛋白制品*卵清蛋白",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "488",
                                "linkid": "380",
                                "code": "1030115",
                                "paCode": "10301",
                                "yn": "N",
                                "title": "植物蛋白",
                                "alias": "植物蛋白",
                                "about": null,
                                "kws": "植物蛋白",
                                "taxName": "蛋白制品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1030115000000000000",
                                "taxCodeTitle": "蛋白制品",
                                "iTitle": "*蛋白制品*植物蛋白",
                                "children": []
                            },
                            {
                                "id": "489",
                                "linkid": "380",
                                "code": "1030116",
                                "paCode": "10301",
                                "yn": "N",
                                "title": "微生物蛋白",
                                "alias": "微生物蛋白",
                                "about": null,
                                "kws": "微生物蛋白",
                                "taxName": "蛋白制品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1030116000000000000",
                                "taxCodeTitle": "蛋白制品",
                                "iTitle": "*蛋白制品*微生物蛋白",
                                "children": []
                            },
                            {
                                "id": "490",
                                "linkid": "380",
                                "code": "1030199",
                                "paCode": "10301",
                                "yn": "N",
                                "title": "其他农副食品",
                                "alias": "其他农副食品",
                                "about": "指其他未列明农副产品、加工产品",
                                "kws": null,
                                "taxName": "农副食品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1030199000000000000",
                                "taxCodeTitle": "农副食品",
                                "iTitle": "*农副食品*其他农副食品",
                                "children": []
                            }
                        ]
                    },
                    {
                        "id": "491",
                        "linkid": "379",
                        "code": "10302",
                        "paCode": "103",
                        "yn": "Y",
                        "title": "食品及加工盐",
                        "alias": "食品及加工盐",
                        "about": null,
                        "kws": null,
                        "taxName": "食品",
                        "taxRate": "",
                        "vip": "3",
                        "itaxRate": null,
                        "taxCode": "1030200000000000000",
                        "taxCodeTitle": "食品",
                        "iTitle": "*食品*食品及加工盐",
                        "children": [
                            {
                                "id": "492",
                                "linkid": "491",
                                "code": "1030201",
                                "paCode": "10302",
                                "yn": "Y",
                                "title": "焙烤食品",
                                "alias": "焙烤食品",
                                "about": null,
                                "kws": null,
                                "taxName": "焙烤食品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1030201000000000000",
                                "taxCodeTitle": "焙烤食品",
                                "iTitle": "*焙烤食品*焙烤食品",
                                "children": [
                                    {
                                        "id": "493",
                                        "linkid": "492",
                                        "code": "103020101",
                                        "paCode": "1030201",
                                        "yn": "N",
                                        "title": "糕点",
                                        "alias": "糕点",
                                        "about": null,
                                        "kws": "糕点、西式糕点、月饼、西式蛋糕、西式素点心、西式包馅点心、烘烤糕点、油炸糕点、水蒸糕点、熟粉糕点",
                                        "taxName": "焙烤食品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030201010000000000",
                                        "taxCodeTitle": "焙烤食品",
                                        "iTitle": "*焙烤食品*糕点",
                                        "children": []
                                    },
                                    {
                                        "id": "494",
                                        "linkid": "492",
                                        "code": "103020102",
                                        "paCode": "1030201",
                                        "yn": "N",
                                        "title": "面包",
                                        "alias": "面包",
                                        "about": null,
                                        "kws": "面包、软式面包、硬式面包、起酥面包、调理面包",
                                        "taxName": "焙烤食品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030201020000000000",
                                        "taxCodeTitle": "焙烤食品",
                                        "iTitle": "*焙烤食品*面包",
                                        "children": []
                                    },
                                    {
                                        "id": "495",
                                        "linkid": "492",
                                        "code": "103020103",
                                        "paCode": "1030201",
                                        "yn": "N",
                                        "title": "饼干",
                                        "alias": "饼干",
                                        "about": null,
                                        "kws": "饼干、酥性饼干、韧性饼干、发酵饼干、威化饼干、夹心饼干、曲奇饼干、压缩饼干、蛋圆饼干、煎饼、蛋卷",
                                        "taxName": "焙烤食品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030201030000000000",
                                        "taxCodeTitle": "焙烤食品",
                                        "iTitle": "*焙烤食品*饼干",
                                        "children": []
                                    },
                                    {
                                        "id": "496",
                                        "linkid": "492",
                                        "code": "103020104",
                                        "paCode": "1030201",
                                        "yn": "N",
                                        "title": "膨化食品",
                                        "alias": "膨化食品",
                                        "about": "指以谷物、薯类或豆类等为主要原料，经焙烤、油炸或挤压等方式膨化而制成的，具有一定膨化度的各类酥脆食品",
                                        "kws": "膨化食品、谷物类膨化食品、薯类膨化食品、豆类膨化食品",
                                        "taxName": "焙烤食品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030201040000000000",
                                        "taxCodeTitle": "焙烤食品",
                                        "iTitle": "*焙烤食品*膨化食品",
                                        "children": []
                                    },
                                    {
                                        "id": "497",
                                        "linkid": "492",
                                        "code": "103020105",
                                        "paCode": "1030201",
                                        "yn": "N",
                                        "title": "焙烤松脆食品",
                                        "alias": "焙烤松脆食品",
                                        "about": "指用玉米面、薯粉、其他谷物面团加奶酪、味精及盐调味，然后用植物油烹炸，制成后可即供食用；包括锅巴、炸薯片等类似食品",
                                        "kws": "焙烤松脆食品、锅巴、炸薯片、油炒面茶、爆米花、麦圈",
                                        "taxName": "焙烤食品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030201050000000000",
                                        "taxCodeTitle": "焙烤食品",
                                        "iTitle": "*焙烤食品*焙烤松脆食品",
                                        "children": []
                                    },
                                    {
                                        "id": "498",
                                        "linkid": "492",
                                        "code": "103020199",
                                        "paCode": "1030201",
                                        "yn": "N",
                                        "title": "其他焙烤食品",
                                        "alias": "其他焙烤食品",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "焙烤食品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030201990000000000",
                                        "taxCodeTitle": "焙烤食品",
                                        "iTitle": "*焙烤食品*其他焙烤食品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "499",
                                "linkid": "491",
                                "code": "1030202",
                                "paCode": "10302",
                                "yn": "Y",
                                "title": "糖果、巧克力、蜜饯及类似食品",
                                "alias": "糖果类食品",
                                "about": null,
                                "kws": null,
                                "taxName": "糖果类食品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1030202000000000000",
                                "taxCodeTitle": "糖果类食品",
                                "iTitle": "*糖果类食品*糖果、巧克力、蜜饯及类似食品",
                                "children": [
                                    {
                                        "id": "500",
                                        "linkid": "499",
                                        "code": "103020201",
                                        "paCode": "1030202",
                                        "yn": "N",
                                        "title": "糖果",
                                        "alias": "糖果",
                                        "about": "指不含巧克力的糖果",
                                        "kws": "糖果、口香糖、硬质糖果、酥质糖果、充气糖果、奶糖糖果、凝胶糖果、胶基糖果、压片糖果、焦香糖果、乳脂糖果、太妃糖果",
                                        "taxName": "糖果类食品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030202010000000000",
                                        "taxCodeTitle": "糖果类食品",
                                        "iTitle": "*糖果类食品*糖果",
                                        "children": []
                                    },
                                    {
                                        "id": "501",
                                        "linkid": "499",
                                        "code": "103020202",
                                        "paCode": "1030202",
                                        "yn": "N",
                                        "title": "巧克力",
                                        "alias": "巧克力",
                                        "about": "指以可可制品（可可脂、可可液块或可可粉）、白砂糖和（或）甜味剂为主要原料，添加或不添加乳制品、食品添加剂，经特定工艺制成的固体食品；不包括用巧克力与其他食品按一定比例加工制成的巧克力制品（详见103020203）。",
                                        "kws": "巧克力、白巧克力、黑巧克力、牛奶巧克力",
                                        "taxName": "糖果类食品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030202020000000000",
                                        "taxCodeTitle": "糖果类食品",
                                        "iTitle": "*糖果类食品*巧克力",
                                        "children": []
                                    },
                                    {
                                        "id": "502",
                                        "linkid": "499",
                                        "code": "103020203",
                                        "paCode": "1030202",
                                        "yn": "N",
                                        "title": "巧克力制品",
                                        "alias": "巧克力制品",
                                        "about": "指用巧克力与其他食品按一定比例加工制成的块、片、条、锭、丸、粒、粉等形状的固体食品",
                                        "kws": "巧克力制品、混合型巧克力制品、涂层型巧克力制品、糖衣型巧克力制品、巧克力豆",
                                        "taxName": "糖果类食品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030202030000000000",
                                        "taxCodeTitle": "糖果类食品",
                                        "iTitle": "*糖果类食品*巧克力制品",
                                        "children": []
                                    },
                                    {
                                        "id": "503",
                                        "linkid": "499",
                                        "code": "103020204",
                                        "paCode": "1030202",
                                        "yn": "N",
                                        "title": "代可可脂巧克力",
                                        "alias": "代可可脂巧克力",
                                        "about": "指以代可可脂、白砂糖和（或）甜味料为主要原料，添加或不添加可可制品（可可脂、可可液块或可可粉）、乳制品及食品添加剂，经特定工艺制成的在常温下保持固体状态，并具有巧克力风味及性状的食品",
                                        "kws": "代可可脂巧克力、代可可脂黑巧克力、代可可脂白巧克力、代可可脂牛奶巧克力",
                                        "taxName": "糖果类食品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030202040000000000",
                                        "taxCodeTitle": "糖果类食品",
                                        "iTitle": "*糖果类食品*代可可脂巧克力",
                                        "children": []
                                    },
                                    {
                                        "id": "504",
                                        "linkid": "499",
                                        "code": "103020205",
                                        "paCode": "1030202",
                                        "yn": "N",
                                        "title": "代可可脂巧克力制品",
                                        "alias": "代可可脂巧克力制品",
                                        "about": "指用代可可脂巧克力与其他食品按一定比例加工制成的食品",
                                        "kws": "代可可脂巧克力制品、混合型代可可脂巧克力制品、涂层型代可可脂巧克力制品、糖衣型代可可脂巧克力制品",
                                        "taxName": "糖果类食品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030202050000000000",
                                        "taxCodeTitle": "糖果类食品",
                                        "iTitle": "*糖果类食品*代可可脂巧克力制品",
                                        "children": []
                                    },
                                    {
                                        "id": "505",
                                        "linkid": "499",
                                        "code": "103020206",
                                        "paCode": "1030202",
                                        "yn": "N",
                                        "title": "蜜饯",
                                        "alias": "蜜饯",
                                        "about": null,
                                        "kws": "蜜饯、糖渍类蜜饯、糖青梅、蜜樱桃、蜜金橘、红绿瓜、糖桂花、糖玫瑰、炒红果、糖霜类蜜饯、糖冬瓜条、糖橘饼、红绿丝、金橘饼、姜片、果脯类蜜饯、杏脯、桃脯、苹果脯、梨脯、枣脯、海棠脯、地瓜脯、胡萝卜脯、番茄脯、凉果类蜜饯、加应子",
                                        "taxName": "糖果类食品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030202060000000000",
                                        "taxCodeTitle": "糖果类食品",
                                        "iTitle": "*糖果类食品*蜜饯",
                                        "children": []
                                    },
                                    {
                                        "id": "506",
                                        "linkid": "499",
                                        "code": "103020207",
                                        "paCode": "1030202",
                                        "yn": "Y",
                                        "title": "果冻及果冻罐头",
                                        "alias": "果冻及果冻罐头",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "糖果类食品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1030202070000000000",
                                        "taxCodeTitle": "糖果类食品",
                                        "iTitle": "*糖果类食品*果冻及果冻罐头",
                                        "children": [
                                            {
                                                "id": "507",
                                                "linkid": "506",
                                                "code": "10302020701",
                                                "paCode": "103020207",
                                                "yn": "N",
                                                "title": "果冻",
                                                "alias": "果冻",
                                                "about": "指以水、食糖和增稠剂等为原料，经溶胶、调配、灌装、杀菌、冷却等工序加工而成的胶冻食品。不包括果冻罐头（详见10302020702）。",
                                                "kws": "果冻、果味型果冻、果汁型果冻、果肉型果冻、含乳型果冻",
                                                "taxName": "糖果类食品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1030202070100000000",
                                                "taxCodeTitle": "糖果类食品",
                                                "iTitle": "*糖果类食品*果冻",
                                                "children": []
                                            },
                                            {
                                                "id": "508",
                                                "linkid": "506",
                                                "code": "10302020702",
                                                "paCode": "103020207",
                                                "yn": "N",
                                                "title": "果冻罐头",
                                                "alias": "果冻罐头",
                                                "about": "指将处理过的水果加水或不加水煮沸,经压榨、取汁、过滤、澄清后加入白砂糖、柠檬酸（或苹果酸）、果胶等配料,浓缩至可溶性固形物65%～70%装罐等工序制成的罐头产品；包括果汁果冻罐头[以一种或数种果汁混合,加入白砂糖、柠檬酸、增稠剂（或不加）等按比例调配后加热浓缩制成]，含果块（或果皮）的果冻罐头[以果汁、果块（或先用糖渍成透明的果皮）、白砂糖、柠檬酸、增稠剂等调配而成]。",
                                                "kws": "果冻罐头",
                                                "taxName": "糖果类食品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1030202070200000000",
                                                "taxCodeTitle": "糖果类食品",
                                                "iTitle": "*糖果类食品*果冻罐头",
                                                "children": []
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "id": "509",
                                "linkid": "491",
                                "code": "1030203",
                                "paCode": "10302",
                                "yn": "Y",
                                "title": "方便食品",
                                "alias": "方便食品",
                                "about": null,
                                "kws": null,
                                "taxName": "方便食品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1030203000000000000",
                                "taxCodeTitle": "方便食品",
                                "iTitle": "*方便食品*方便食品",
                                "children": [
                                    {
                                        "id": "510",
                                        "linkid": "509",
                                        "code": "103020301",
                                        "paCode": "1030203",
                                        "yn": "N",
                                        "title": "米、面制半成品",
                                        "alias": "米面半成品",
                                        "about": "指用谷物、薯类、杂粮类作物制作的方便半成品食品；包括面制半成品和米制半成品",
                                        "kws": "切面、通心粉、龙须面、乌冬面、莜麦面、年糕、米粉干、面制半成品、米制半成品、小麦挂面、米粉丝",
                                        "taxName": "方便食品",
                                        "taxRate": "",
                                        "vip": "5",
                                        "itaxRate": null,
                                        "taxCode": "1030203010000000000",
                                        "taxCodeTitle": "方便食品",
                                        "iTitle": "*方便食品*米、面制半成品",
                                        "children": []
                                    },
                                    {
                                        "id": "511",
                                        "linkid": "509",
                                        "code": "103020302",
                                        "paCode": "1030203",
                                        "yn": "N",
                                        "title": "速冻食品",
                                        "alias": "速冻食品",
                                        "about": null,
                                        "kws": "速冻食品、速冻米面食品、速冻包馅米面食品、速冻无馅米面食品",
                                        "taxName": "方便食品",
                                        "taxRate": "",
                                        "vip": "5",
                                        "itaxRate": null,
                                        "taxCode": "1030203020000000000",
                                        "taxCodeTitle": "方便食品",
                                        "iTitle": "*方便食品*速冻食品",
                                        "children": []
                                    },
                                    {
                                        "id": "512",
                                        "linkid": "509",
                                        "code": "103020303",
                                        "paCode": "1030203",
                                        "yn": "N",
                                        "title": "即食方便食品",
                                        "alias": "即食方便食品",
                                        "about": "指不需加工即可食用的熟制品",
                                        "kws": "即食方便食品、米面熟制品、馒头、窝头、烙饼、干制方便食品、方便面、方便粥、方便米饭、方便米粉",
                                        "taxName": "方便食品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030203030000000000",
                                        "taxCodeTitle": "方便食品",
                                        "iTitle": "*方便食品*即食方便食品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "513",
                                "linkid": "491",
                                "code": "1030204",
                                "paCode": "10302",
                                "yn": "Y",
                                "title": "乳制品",
                                "alias": "乳制品",
                                "about": "指以牛、羊乳为主要原料,经分级、净乳、杀菌、浓缩、干燥、发酵等加工制成的含天然乳的制品，包括液体乳。不包括未经加工的生鲜乳（详见101030301）",
                                "kws": null,
                                "taxName": "乳制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1030204000000000000",
                                "taxCodeTitle": "乳制品",
                                "iTitle": "*乳制品*乳制品",
                                "children": [
                                    {
                                        "id": "514",
                                        "linkid": "513",
                                        "code": "103020401",
                                        "paCode": "1030204",
                                        "yn": "N",
                                        "title": "液体乳",
                                        "alias": "液体乳",
                                        "about": "指未浓缩的未加糖及加糖或其他甜物质、或其他物质的液体乳。不包括含乳饮料和植物蛋白饮料（详见103030703）。",
                                        "kws": "液体乳、灭菌乳、灭菌全脂纯牛乳、灭菌全脂纯羊乳、灭菌低脂纯牛乳、灭菌低脂纯羊乳、灭菌脱脂纯牛乳、灭菌全脱脂纯羊乳、灭菌全脂调味乳、灭菌低脂调味乳、灭菌脱脂调味乳、巴氏杀菌乳、全脂巴氏杀菌乳、低脂巴氏杀菌乳、脱脂巴氏杀菌乳、酸牛乳、全脂纯酸牛乳、低脂纯酸牛乳、脱脂纯酸牛乳、调味果料酸牛乳",
                                        "taxName": "乳制品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1030204010000000000",
                                        "taxCodeTitle": "乳制品",
                                        "iTitle": "*乳制品*液体乳",
                                        "children": []
                                    },
                                    {
                                        "id": "515",
                                        "linkid": "513",
                                        "code": "103020402",
                                        "paCode": "1030204",
                                        "yn": "N",
                                        "title": "固体及半固体乳制品",
                                        "alias": "固体及半固体乳制品",
                                        "about": null,
                                        "kws": "固体乳制品、半固体乳制品、乳粉、全脂乳粉、全脂加糖乳粉、脱脂乳粉、全脂调味乳粉、脱脂调味乳粉、婴幼儿配方乳粉、炼乳、全脂无糖炼乳、全脂加糖炼乳、乳脂肪、稀奶油、奶油、无水奶油、干酪、奶酪、鲜干酪、磨碎干酪、粉化干酪、加工重制发酵干酪、蓝纹干酪、干酪素、食用干酪素、乳清粉、不脱盐乳清粉、脱盐乳清粉",
                                        "taxName": "乳制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030204020000000000",
                                        "taxCodeTitle": "乳制品",
                                        "iTitle": "*乳制品*固体及半固体乳制品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "516",
                                "linkid": "491",
                                "code": "1030205",
                                "paCode": "10302",
                                "yn": "Y",
                                "title": "罐头",
                                "alias": "罐头",
                                "about": null,
                                "kws": null,
                                "taxName": "罐头",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1030205000000000000",
                                "taxCodeTitle": "罐头",
                                "iTitle": "*罐头*罐头",
                                "children": [
                                    {
                                        "id": "517",
                                        "linkid": "516",
                                        "code": "103020501",
                                        "paCode": "1030205",
                                        "yn": "N",
                                        "title": "畜肉类罐头",
                                        "alias": "畜肉类罐头",
                                        "about": "包括清蒸类（如清蒸猪肉、原汁猪肉等），调味类（如红烧牛肉、五香牛肉、浓汁排骨等），腌制类（如火腿、午餐肉、咸牛肉等），烟熏类（如烟熏肋肉等），香肠类，内脏类（如猪舌、卤猪杂等）畜肉及其他动物肉罐头",
                                        "kws": "畜肉类罐头、猪肉罐头、猪杂碎罐头、牛肉罐头、牛杂碎罐头、羊肉罐头、羊杂碎罐头、兔肉罐头、兔杂碎罐头",
                                        "taxName": "罐头",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030205010000000000",
                                        "taxCodeTitle": "罐头",
                                        "iTitle": "*罐头*畜肉类罐头",
                                        "children": []
                                    },
                                    {
                                        "id": "518",
                                        "linkid": "516",
                                        "code": "103020502",
                                        "paCode": "1030205",
                                        "yn": "N",
                                        "title": "禽肉类罐头",
                                        "alias": "禽肉类罐头",
                                        "about": "包括白烧类（如白烧鸡等），去骨类（如去骨鸡、去骨鸭等），调味类（如红烧鸡、咖喱鸭、炸子鸡、全鸡等）禽肉罐头",
                                        "kws": "禽肉类罐头、鸡肉罐头、鸭肉罐头、鹅肉罐头",
                                        "taxName": "罐头",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030205020000000000",
                                        "taxCodeTitle": "罐头",
                                        "iTitle": "*罐头*禽肉类罐头",
                                        "children": []
                                    },
                                    {
                                        "id": "519",
                                        "linkid": "516",
                                        "code": "103020503",
                                        "paCode": "1030205",
                                        "yn": "N",
                                        "title": "水产动物类罐头",
                                        "alias": "水产动物类罐头",
                                        "about": "包括油浸（熏制）类水产罐头（如油浸鲭鱼、油浸腌鳗鱼等），调味类水产罐头（如茄汁鲭鱼、葱烤鲫鱼、豆豉鲮鱼等），清蒸类水产罐头（如清蒸对虾、清蒸蟹、原汁贻贝等）",
                                        "kws": "水产动物类罐头、鱼类罐头、鲮鱼类罐头、沙丁鱼类罐头、鲭鱼类罐头、金枪鱼类罐头、鱼翅罐头、鱼糜肉罐头、甲壳动物类罐头、蟹罐头、虾罐头、水生无脊椎动物类罐头、鲜贝罐头",
                                        "taxName": "罐头",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030205030000000000",
                                        "taxCodeTitle": "罐头",
                                        "iTitle": "*罐头*水产动物类罐头",
                                        "children": []
                                    },
                                    {
                                        "id": "520",
                                        "linkid": "516",
                                        "code": "103020504",
                                        "paCode": "1030205",
                                        "yn": "N",
                                        "title": "蔬菜类罐头",
                                        "alias": "蔬菜类罐头",
                                        "about": "包括清渍类蔬菜罐头（如青刀豆、清水笋、清水荸荠、蘑菇等），醋渍类蔬菜罐头（如酸黄瓜、甜酸藠头等），盐渍（酱渍）类蔬菜罐头（如雪菜、香菜心等），调味类蔬菜罐头（如油焖笋、八宝斋等），蔬菜酱类罐头（如番茄汁、番茄酱、胡萝卜汁等）。不包括豆类制品（如茄汁黄豆等）罐头（详见103020509）。",
                                        "kws": "蔬菜类罐头、番茄罐头、番茄酱罐头、蘑菇罐头、豇豆罐头、菜豆罐头、竹笋罐头、芦笋罐头、清水马蹄罐头、蚕豆罐头、榨菜罐头、食用菌罐头、脱荚豇豆罐头、脱荚菜豆罐头、藠头罐头",
                                        "taxName": "罐头",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030205040000000000",
                                        "taxCodeTitle": "罐头",
                                        "iTitle": "*罐头*蔬菜类罐头",
                                        "children": []
                                    },
                                    {
                                        "id": "521",
                                        "linkid": "516",
                                        "code": "103020505",
                                        "paCode": "1030205",
                                        "yn": "N",
                                        "title": "水果类罐头",
                                        "alias": "水果类罐头",
                                        "about": "不包括浓缩果汁、果汁、果汁饮料等果汁类罐头（详见103030702）。",
                                        "kws": "糖水类水果罐头、糖水菠萝罐头、糖水柑橘属水果罐头、糖水洋梨罐头、糖水梨罐头、糖水桃罐头、糖水荔枝罐头、糖水龙眼罐头、糖水草莓罐头、糖水枇杷罐头、糖水樱桃罐头、糖水山楂罐头、糖水类什锦水果罐头、糖浆类水果罐头、液态蜜饯罐头",
                                        "taxName": "罐头",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030205050000000000",
                                        "taxCodeTitle": "罐头",
                                        "iTitle": "*罐头*水果类罐头",
                                        "children": []
                                    },
                                    {
                                        "id": "522",
                                        "linkid": "516",
                                        "code": "103020506",
                                        "paCode": "1030205",
                                        "yn": "N",
                                        "title": "果酱类罐头",
                                        "alias": "果酱类罐头",
                                        "about": "包括水果制果酱、果泥及果膏罐头",
                                        "kws": "果酱类罐头、柑橘酱罐头、苹果酱罐头、红果酱罐头、草莓酱罐头、杏酱罐头",
                                        "taxName": "罐头",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030205060000000000",
                                        "taxCodeTitle": "罐头",
                                        "iTitle": "*罐头*果酱类罐头",
                                        "children": []
                                    },
                                    {
                                        "id": "523",
                                        "linkid": "516",
                                        "code": "103020507",
                                        "paCode": "1030205",
                                        "yn": "N",
                                        "title": "干果和坚果类罐头",
                                        "alias": "干果和坚果类罐头",
                                        "about": "指以符合要求的坚、干果原料，经挑选、去皮（壳）、油炸拌盐（糖或糖衣）后装罐而成的罐头产品",
                                        "kws": "干果罐头、坚果罐头、花生米罐头、核桃仁罐头、栗子仁罐头、榛子仁罐头、莲籽罐头",
                                        "taxName": "罐头",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030205070000000000",
                                        "taxCodeTitle": "罐头",
                                        "iTitle": "*罐头*干果和坚果类罐头",
                                        "children": []
                                    },
                                    {
                                        "id": "524",
                                        "linkid": "516",
                                        "code": "103020508",
                                        "paCode": "1030205",
                                        "yn": "N",
                                        "title": "谷物制品类罐头",
                                        "alias": "谷物制品类罐头",
                                        "about": "指经过处理后的谷类、干果及其他原料（桂圆、枸杞、蔬菜等）装罐制成的罐头产品",
                                        "kws": "谷物制品类罐头、甜玉米罐头、米粥罐头、米饭罐头、八宝粥罐头、蔬菜粥罐头、八宝饭罐头",
                                        "taxName": "罐头",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030205080000000000",
                                        "taxCodeTitle": "罐头",
                                        "iTitle": "*罐头*谷物制品类罐头",
                                        "children": []
                                    },
                                    {
                                        "id": "525",
                                        "linkid": "516",
                                        "code": "103020509",
                                        "paCode": "1030205",
                                        "yn": "N",
                                        "title": "豆类制品罐头",
                                        "alias": "豆类制品罐头",
                                        "about": null,
                                        "kws": "豆类制品罐头、茄汁黄豆罐头",
                                        "taxName": "罐头",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030205090000000000",
                                        "taxCodeTitle": "罐头",
                                        "iTitle": "*罐头*豆类制品罐头",
                                        "children": []
                                    },
                                    {
                                        "id": "526",
                                        "linkid": "516",
                                        "code": "103020510",
                                        "paCode": "1030205",
                                        "yn": "N",
                                        "title": "汤类罐头",
                                        "alias": "汤类罐头",
                                        "about": "指以符合要求的肉、禽、水产及蔬菜原料,经切块（片或丝）、烹调等加工后装罐而制成的罐头产品",
                                        "kws": "汤类罐头、水鱼汤罐头、猪肚汤罐头、牛尾汤罐头",
                                        "taxName": "罐头",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030205100000000000",
                                        "taxCodeTitle": "罐头",
                                        "iTitle": "*罐头*汤类罐头",
                                        "children": []
                                    },
                                    {
                                        "id": "527",
                                        "linkid": "516",
                                        "code": "103020511",
                                        "paCode": "1030205",
                                        "yn": "N",
                                        "title": "调味类罐头",
                                        "alias": "调味类罐头",
                                        "about": "指以发酵面酱或番茄等为基料，加入多种辅料及香辛料加工制成各种不同口味的调味料，经装罐制成的罐头产品",
                                        "kws": "调味类罐头、香菇肉酱罐头、番茄沙司罐头",
                                        "taxName": "罐头",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030205110000000000",
                                        "taxCodeTitle": "罐头",
                                        "iTitle": "*罐头*调味类罐头",
                                        "children": []
                                    },
                                    {
                                        "id": "528",
                                        "linkid": "516",
                                        "code": "103020512",
                                        "paCode": "1030205",
                                        "yn": "N",
                                        "title": "混合类罐头",
                                        "alias": "混合类罐头",
                                        "about": "指将动物和植物类食品原料分别加工处理，经调配装罐制成的罐头产品",
                                        "kws": "混合类罐头、榨菜肉丝罐头、豆干猪肉罐头",
                                        "taxName": "罐头",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030205120000000000",
                                        "taxCodeTitle": "罐头",
                                        "iTitle": "*罐头*混合类罐头",
                                        "children": []
                                    },
                                    {
                                        "id": "529",
                                        "linkid": "516",
                                        "code": "103020513",
                                        "paCode": "1030205",
                                        "yn": "N",
                                        "title": "婴幼儿辅助食品类罐头",
                                        "alias": "婴幼儿辅助食品类罐头",
                                        "about": "指根据婴幼儿不同月龄营养素的要求，将食品原料经加工、研磨等处理制成的泥状罐头食品（如肝泥、菜泥、肉泥等）；均化混合食品指两种或两种以上的基本配料，例如，肉、鱼、蔬菜或果实等，经精细均化混合制成供婴幼儿食用或营养用的零售包装食品（每件净重不超过250克）；除以上基本配料外，这类食品可含有少量奶酪、蛋黄、淀粉、糊精、盐或维生素等。",
                                        "kws": "肉类均化食品罐头、婴幼儿食品类罐头、均化蔬菜类食品罐头、果类均化食品罐头、均化混合食品罐头、婴幼儿辅助食品类罐头",
                                        "taxName": "罐头",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030205130000000000",
                                        "taxCodeTitle": "罐头",
                                        "iTitle": "*罐头*婴幼儿辅助食品类罐头",
                                        "children": []
                                    },
                                    {
                                        "id": "530",
                                        "linkid": "516",
                                        "code": "103020599",
                                        "paCode": "1030205",
                                        "yn": "N",
                                        "title": "其他罐头",
                                        "alias": "其他罐头",
                                        "about": "不包括宠物饲料罐头（详见103010402）。",
                                        "kws": null,
                                        "taxName": "罐头",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030205990000000000",
                                        "taxCodeTitle": "罐头",
                                        "iTitle": "*罐头*其他罐头",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "531",
                                "linkid": "491",
                                "code": "1030206",
                                "paCode": "10302",
                                "yn": "Y",
                                "title": "调味品",
                                "alias": "调味品",
                                "about": null,
                                "kws": null,
                                "taxName": "调味品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1030206000000000000",
                                "taxCodeTitle": "调味品",
                                "iTitle": "*调味品*调味品",
                                "children": [
                                    {
                                        "id": "532",
                                        "linkid": "531",
                                        "code": "103020601",
                                        "paCode": "1030206",
                                        "yn": "N",
                                        "title": "味精（谷氨酸钠）",
                                        "alias": "味精",
                                        "about": null,
                                        "kws": "味精、谷氨酸钠",
                                        "taxName": "调味品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030206010000000000",
                                        "taxCodeTitle": "调味品",
                                        "iTitle": "*调味品*味精（谷氨酸钠）",
                                        "children": []
                                    },
                                    {
                                        "id": "533",
                                        "linkid": "531",
                                        "code": "103020602",
                                        "paCode": "1030206",
                                        "yn": "N",
                                        "title": "酱油及酱类制品",
                                        "alias": "酱油",
                                        "about": null,
                                        "kws": "酱油、酿造酱油、勾兑酱油、黄酱、甜面酱、特制酱油、辣酱油、蘑菇酱油、水果酱油",
                                        "taxName": "调味品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030206020000000000",
                                        "taxCodeTitle": "调味品",
                                        "iTitle": "*调味品*酱油及酱类制品",
                                        "children": []
                                    },
                                    {
                                        "id": "534",
                                        "linkid": "531",
                                        "code": "103020603",
                                        "paCode": "1030206",
                                        "yn": "N",
                                        "title": "醋及醋代用品",
                                        "alias": "醋",
                                        "about": null,
                                        "kws": "食醋、米醋、酒醋、啤酒醋、麦芽醋、酒精醋、水果醋、醋精",
                                        "taxName": "调味品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030206030000000000",
                                        "taxCodeTitle": "调味品",
                                        "iTitle": "*调味品*醋及醋代用品",
                                        "children": []
                                    },
                                    {
                                        "id": "535",
                                        "linkid": "531",
                                        "code": "103020604",
                                        "paCode": "1030206",
                                        "yn": "N",
                                        "title": "复合调味品",
                                        "alias": "复合调味品",
                                        "about": null,
                                        "kws": "调味油、辣椒油、花椒油、沙拉油调味汁、酱、番茄调味汁、姜汁、芝麻酱、沙拉酱、蛋黄酱、辣椒酱、调味料、鸡精、香辛调味料、复合调味料、风味调味料、芥子粉及其调制品、芥子粉、调制芥末、芥末油、芥末酱、汤料及其制品、方便汤料、调味紫菜",
                                        "taxName": "调味品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030206040000000000",
                                        "taxCodeTitle": "调味品",
                                        "iTitle": "*调味品*复合调味品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "536",
                                "linkid": "491",
                                "code": "1030207",
                                "paCode": "10302",
                                "yn": "Y",
                                "title": "发酵类制品",
                                "alias": "发酵类制品",
                                "about": null,
                                "kws": null,
                                "taxName": "发酵类制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1030207000000000000",
                                "taxCodeTitle": "发酵类制品",
                                "iTitle": "*发酵类制品*发酵类制品",
                                "children": [
                                    {
                                        "id": "537",
                                        "linkid": "536",
                                        "code": "103020701",
                                        "paCode": "1030207",
                                        "yn": "N",
                                        "title": "酵母",
                                        "alias": "酵母",
                                        "about": null,
                                        "kws": "酵母、活性酵母、非活性酵母、发酵粉、发酵剂、啤酒酵母、酿酒酵母、发面酵母、培养酵母、种用酵母、干酵母",
                                        "taxName": "发酵类制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030207010000000000",
                                        "taxCodeTitle": "发酵类制品",
                                        "iTitle": "*发酵类制品*酵母",
                                        "children": []
                                    },
                                    {
                                        "id": "538",
                                        "linkid": "536",
                                        "code": "103020702",
                                        "paCode": "1030207",
                                        "yn": "N",
                                        "title": "食品用氨基酸",
                                        "alias": "食品用氨基酸",
                                        "about": "不包括味精（谷氨酸钠）（详见103020601）。",
                                        "kws": "食品用氨基酸、食品用赖氨酸、食品用谷氨酸、食品用呈味核苷酸、食品用脯氨酸、食品用缬氨酸、食品用天门冬氨酸、食品用苯丙氨酸",
                                        "taxName": "发酵类制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030207020000000000",
                                        "taxCodeTitle": "发酵类制品",
                                        "iTitle": "*发酵类制品*食品用氨基酸",
                                        "children": []
                                    },
                                    {
                                        "id": "539",
                                        "linkid": "536",
                                        "code": "103020703",
                                        "paCode": "1030207",
                                        "yn": "N",
                                        "title": "柠檬酸及其盐和酸酯",
                                        "alias": "柠檬酸及其盐和酸酯",
                                        "about": null,
                                        "kws": "柠檬酸、柠檬酸盐、柠檬酸酯",
                                        "taxName": "发酵类制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030207030000000000",
                                        "taxCodeTitle": "发酵类制品",
                                        "iTitle": "*发酵类制品*柠檬酸及其盐和酸酯",
                                        "children": []
                                    },
                                    {
                                        "id": "540",
                                        "linkid": "536",
                                        "code": "103020704",
                                        "paCode": "1030207",
                                        "yn": "N",
                                        "title": "食品用发酵有机酸",
                                        "alias": "食品用发酵有机酸",
                                        "about": "包括苹果醋、梨醋或其他发酵水果醋",
                                        "kws": "食品用发酵有机酸、食品用苹果酸、食品用苹果酸盐、食品用曲酸、食品用衣康酸、食品用乳酸、食品用乳酸盐、食品用乳酸酯、食品用酒石酸、食品用酒石酸盐、食品用乙酸、醋酸、食品用乙酸盐、醋酸盐",
                                        "taxName": "发酵类制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030207040000000000",
                                        "taxCodeTitle": "发酵类制品",
                                        "iTitle": "*发酵类制品*食品用发酵有机酸",
                                        "children": []
                                    },
                                    {
                                        "id": "541",
                                        "linkid": "536",
                                        "code": "103020705",
                                        "paCode": "1030207",
                                        "yn": "N",
                                        "title": "食品用酶制剂",
                                        "alias": "食品用酶制剂",
                                        "about": "由动物或植物的可食或非可食部分直接提取，或由传统或基因修饰的微生物（包括但不限于细菌、放射线、真菌菌种）发酵、提取制得，用于食品加工，具有特殊催化功能的生物制品",
                                        "kws": "食品用酶制剂、食品用糖化酶、食品用淀粉酶、食品用蛋白酶、嫩肉粉、食品用异构酶、食品用脂肪酶、食品用果胶酶",
                                        "taxName": "发酵类制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030207050000000000",
                                        "taxCodeTitle": "发酵类制品",
                                        "iTitle": "*发酵类制品*食品用酶制剂",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "542",
                                "linkid": "491",
                                "code": "1030208",
                                "paCode": "10302",
                                "yn": "Y",
                                "title": "营养、保健食品",
                                "alias": "营养保健食品",
                                "about": null,
                                "kws": null,
                                "taxName": "营养保健食品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1030208000000000000",
                                "taxCodeTitle": "营养保健食品",
                                "iTitle": "*营养保健食品*营养、保健食品",
                                "children": [
                                    {
                                        "id": "543",
                                        "linkid": "542",
                                        "code": "103020801",
                                        "paCode": "1030208",
                                        "yn": "N",
                                        "title": "婴幼儿用均化食品",
                                        "alias": "婴幼儿用均化食品",
                                        "about": "不包括罐头食品（详见103020513）。",
                                        "kws": "婴幼儿用均化食品、肉类均化食品、均化蔬菜、水果均化食品、均化混合食品、供婴幼儿食用谷物食品",
                                        "taxName": "营养保健食品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030208010000000000",
                                        "taxCodeTitle": "营养保健食品",
                                        "iTitle": "*营养保健食品*婴幼儿用均化食品",
                                        "children": []
                                    },
                                    {
                                        "id": "544",
                                        "linkid": "542",
                                        "code": "103020802",
                                        "paCode": "1030208",
                                        "yn": "N",
                                        "title": "营养配餐食品",
                                        "alias": "营养配餐食品",
                                        "about": "直接供人食用或加工（例如用水或乳等烹煮、溶解）后供人食用的制品",
                                        "kws": "营养配餐食品、燕麦营养配餐食品、补钙配餐食品、麦精乳、食品补充剂制品",
                                        "taxName": "营养保健食品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030208020000000000",
                                        "taxCodeTitle": "营养保健食品",
                                        "iTitle": "*营养保健食品*营养配餐食品",
                                        "children": []
                                    },
                                    {
                                        "id": "545",
                                        "linkid": "542",
                                        "code": "103020803",
                                        "paCode": "1030208",
                                        "yn": "N",
                                        "title": "蜂蜜营养制品",
                                        "alias": "蜂蜜营养制品",
                                        "about": null,
                                        "kws": "蜂蜜营养制品、加蜂王浆天然蜂蜜、蜂王浆制剂、鲜蜂王浆粉",
                                        "taxName": "营养保健食品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030208030000000000",
                                        "taxCodeTitle": "营养保健食品",
                                        "iTitle": "*营养保健食品*蜂蜜营养制品",
                                        "children": []
                                    },
                                    {
                                        "id": "546",
                                        "linkid": "542",
                                        "code": "103020899",
                                        "paCode": "1030208",
                                        "yn": "N",
                                        "title": "其他营养、保健食品",
                                        "alias": "其他营养保健食品",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "营养保健食品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030208990000000000",
                                        "taxCodeTitle": "营养保健食品",
                                        "iTitle": "*营养保健食品*其他营养、保健食品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "547",
                                "linkid": "491",
                                "code": "1030209",
                                "paCode": "10302",
                                "yn": "Y",
                                "title": "冷冻饮品",
                                "alias": "冷冻饮品",
                                "about": null,
                                "kws": null,
                                "taxName": "冷冻饮品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1030209000000000000",
                                "taxCodeTitle": "冷冻饮品",
                                "iTitle": "*冷冻饮品*冷冻饮品",
                                "children": [
                                    {
                                        "id": "548",
                                        "linkid": "547",
                                        "code": "103020901",
                                        "paCode": "1030209",
                                        "yn": "N",
                                        "title": "冰淇淋",
                                        "alias": "冰淇淋",
                                        "about": null,
                                        "kws": "全乳脂冰淇淋、半乳脂冰淇淋、植脂冰淇淋、低脂冰淇淋、冰淇淋",
                                        "taxName": "冷冻饮品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030209010000000000",
                                        "taxCodeTitle": "冷冻饮品",
                                        "iTitle": "*冷冻饮品*冰淇淋",
                                        "children": []
                                    },
                                    {
                                        "id": "549",
                                        "linkid": "547",
                                        "code": "103020902",
                                        "paCode": "1030209",
                                        "yn": "N",
                                        "title": "雪糕类",
                                        "alias": "雪糕类",
                                        "about": null,
                                        "kws": "清型雪糕、组合型雪糕",
                                        "taxName": "冷冻饮品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030209020000000000",
                                        "taxCodeTitle": "冷冻饮品",
                                        "iTitle": "*冷冻饮品*雪糕类",
                                        "children": []
                                    },
                                    {
                                        "id": "550",
                                        "linkid": "547",
                                        "code": "103020903",
                                        "paCode": "1030209",
                                        "yn": "N",
                                        "title": "冰棍",
                                        "alias": "冰棍",
                                        "about": "也称棒冰",
                                        "kws": "冰棍、棒冰",
                                        "taxName": "冷冻饮品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030209030000000000",
                                        "taxCodeTitle": "冷冻饮品",
                                        "iTitle": "*冷冻饮品*冰棍",
                                        "children": []
                                    },
                                    {
                                        "id": "551",
                                        "linkid": "547",
                                        "code": "103020904",
                                        "paCode": "1030209",
                                        "yn": "N",
                                        "title": "甜味冰",
                                        "alias": "甜味冰",
                                        "about": "指以饮用水、食糖等为主要原料，可添加适量食品添加剂，经混合、灭菌、灌装、硬化等工艺制成的冷冻饮品；如甜橙味甜味冰、菠萝味甜味冰等",
                                        "kws": "甜味冰",
                                        "taxName": "冷冻饮品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030209040000000000",
                                        "taxCodeTitle": "冷冻饮品",
                                        "iTitle": "*冷冻饮品*甜味冰",
                                        "children": []
                                    },
                                    {
                                        "id": "552",
                                        "linkid": "547",
                                        "code": "103020905",
                                        "paCode": "1030209",
                                        "yn": "N",
                                        "title": "雪泥",
                                        "alias": "雪泥",
                                        "about": "指以饮用水、食糖等为主要原料，可添加适量食品添加剂，经混合、灭菌、凝冻、硬化等工艺制成的冰雪状的冷冻饮品",
                                        "kws": "雪泥",
                                        "taxName": "冷冻饮品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030209050000000000",
                                        "taxCodeTitle": "冷冻饮品",
                                        "iTitle": "*冷冻饮品*雪泥",
                                        "children": []
                                    },
                                    {
                                        "id": "553",
                                        "linkid": "547",
                                        "code": "103020906",
                                        "paCode": "1030209",
                                        "yn": "N",
                                        "title": "食用冰",
                                        "alias": "食用冰",
                                        "about": "指以饮用水为原料，经灭菌、注模、冻结、脱模、包装等工艺制成的冷冻饮品",
                                        "kws": "食用冰",
                                        "taxName": "冷冻饮品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030209060000000000",
                                        "taxCodeTitle": "冷冻饮品",
                                        "iTitle": "*冷冻饮品*食用冰",
                                        "children": []
                                    },
                                    {
                                        "id": "554",
                                        "linkid": "547",
                                        "code": "103020999",
                                        "paCode": "1030209",
                                        "yn": "N",
                                        "title": "其他冷冻饮品",
                                        "alias": "其他冷冻饮品",
                                        "about": "指以上未包括的冷冻饮品；如冷冻饮品部分所占质量比例不低于50%的混合型制品；低脂冷冻饮品；低糖冷冻饮品；无糖冷冻饮品等",
                                        "kws": "#低脂冷冻饮品、低糖冷冻饮品、无糖冷冻饮品",
                                        "taxName": "冷冻饮品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030209990000000000",
                                        "taxCodeTitle": "冷冻饮品",
                                        "iTitle": "*冷冻饮品*其他冷冻饮品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "555",
                                "linkid": "491",
                                "code": "1030210",
                                "paCode": "10302",
                                "yn": "Y",
                                "title": "加工盐",
                                "alias": "加工盐",
                                "about": "指以原盐为原料，经过化卤、蒸发、洗涤、粉碎、干燥、脱水、筛分等工序，或在其中添加碘酸钾及调味品等加工制成的盐产品",
                                "kws": null,
                                "taxName": "加工盐",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1030210000000000000",
                                "taxCodeTitle": "加工盐",
                                "iTitle": "*加工盐*加工盐",
                                "children": [
                                    {
                                        "id": "556",
                                        "linkid": "555",
                                        "code": "103021001",
                                        "paCode": "1030210",
                                        "yn": "N",
                                        "title": "食用盐",
                                        "alias": "食用盐",
                                        "about": null,
                                        "kws": "加碘盐、营养盐、调味盐、食用盐",
                                        "taxName": "加工盐",
                                        "taxRate": "9%",
                                        "vip": "5",
                                        "itaxRate": "0.09",
                                        "taxCode": "1030210010000000000",
                                        "taxCodeTitle": "加工盐",
                                        "iTitle": "*加工盐*食用盐",
                                        "children": []
                                    },
                                    {
                                        "id": "557",
                                        "linkid": "555",
                                        "code": "103021002",
                                        "paCode": "1030210",
                                        "yn": "N",
                                        "title": "非食用盐",
                                        "alias": "非食用盐",
                                        "about": null,
                                        "kws": "溶雪盐、饲料盐、渔用盐、非食用盐",
                                        "taxName": "加工盐",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030210020000000000",
                                        "taxCodeTitle": "加工盐",
                                        "iTitle": "*加工盐*非食用盐",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "558",
                                "linkid": "491",
                                "code": "1030211",
                                "paCode": "10302",
                                "yn": "Y",
                                "title": "食品添加剂",
                                "alias": "食品添加剂",
                                "about": null,
                                "kws": "食品添加剂、食品增稠剂、果胶酸盐及果胶酸酯、果胶、果胶酸盐、果胶酸酯、食品用琼脂、食品用植物胶液、食品用明胶、食品用卡拉胶、食品用阿拉伯胶、食品用黄原胶、食品用汉生胶、蛋白质添加剂、浓缩蛋白质、人造蛋白物质、食品甜味添加剂、食品用糖醇、食品用山梨醇、食品用甘露糖醇、食品用丙三醇、食品用木糖醇、食品用麦芽糖醇、合成甜味剂、食用甜味剂、食品用糖精钠、食品用环己基氨基磺酸钠、食品用天门冬酰苯丙氨酸甲酯",
                                "taxName": "食品添加剂",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1030211000000000000",
                                "taxCodeTitle": "食品添加剂",
                                "iTitle": "*食品添加剂*食品添加剂",
                                "children": [
                                    {
                                        "id": "559",
                                        "linkid": "558",
                                        "code": "103021101",
                                        "paCode": "1030211",
                                        "yn": "N",
                                        "title": "木糖",
                                        "alias": "木糖",
                                        "about": null,
                                        "kws": "木糖",
                                        "taxName": "食品添加剂",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030211010000000000",
                                        "taxCodeTitle": "食品添加剂",
                                        "iTitle": "*食品添加剂*木糖",
                                        "children": []
                                    },
                                    {
                                        "id": "560",
                                        "linkid": "558",
                                        "code": "103021199",
                                        "paCode": "1030211",
                                        "yn": "N",
                                        "title": "其他食品添加剂",
                                        "alias": "其他食品添加剂",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "食品添加剂",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030211990000000000",
                                        "taxCodeTitle": "食品添加剂",
                                        "iTitle": "*食品添加剂*其他食品添加剂",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "561",
                                "linkid": "491",
                                "code": "1030212",
                                "paCode": "10302",
                                "yn": "Y",
                                "title": "食品用类似原料",
                                "alias": "食品用类似原料",
                                "about": null,
                                "kws": null,
                                "taxName": "食品用原料",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1030212000000000000",
                                "taxCodeTitle": "食品用原料",
                                "iTitle": "*食品用原料*食品用类似原料",
                                "children": [
                                    {
                                        "id": "562",
                                        "linkid": "561",
                                        "code": "103021201",
                                        "paCode": "1030212",
                                        "yn": "N",
                                        "title": "食品用原料粉",
                                        "alias": "食品用原料粉",
                                        "about": null,
                                        "kws": "食品用原料粉、冰淇淋粉、食品用香料粉、餐用奶油粉",
                                        "taxName": "食品用原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030212010000000000",
                                        "taxCodeTitle": "食品用原料",
                                        "iTitle": "*食品用原料*食品用原料粉",
                                        "children": []
                                    },
                                    {
                                        "id": "563",
                                        "linkid": "561",
                                        "code": "103021202",
                                        "paCode": "1030212",
                                        "yn": "N",
                                        "title": "饮料用原料",
                                        "alias": "饮料用原料",
                                        "about": null,
                                        "kws": "饮料用原料、复合酒精制品、碳酸饮料浓缩物",
                                        "taxName": "食品用原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030212020000000000",
                                        "taxCodeTitle": "食品用原料",
                                        "iTitle": "*食品用原料*饮料用原料",
                                        "children": []
                                    },
                                    {
                                        "id": "564",
                                        "linkid": "561",
                                        "code": "103021203",
                                        "paCode": "1030212",
                                        "yn": "N",
                                        "title": "植物液汁及浸膏",
                                        "alias": "植物液汁及浸膏",
                                        "about": null,
                                        "kws": "植物液汁、浸膏、甘草液汁及浸膏、啤酒花液汁及浸膏、除虫菊液汁及浸膏、鸦片液汁及浸膏、人参精、芦荟浸膏、印楝素、生漆",
                                        "taxName": "食品用原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030212030000000000",
                                        "taxCodeTitle": "食品用原料",
                                        "iTitle": "*食品用原料*植物液汁及浸膏",
                                        "children": []
                                    },
                                    {
                                        "id": "565",
                                        "linkid": "561",
                                        "code": "103021204",
                                        "paCode": "1030212",
                                        "yn": "N",
                                        "title": "糯米纸",
                                        "alias": "糯米纸",
                                        "about": null,
                                        "kws": "糯米纸",
                                        "taxName": "食品用原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030212040000000000",
                                        "taxCodeTitle": "食品用原料",
                                        "iTitle": "*食品用原料*糯米纸",
                                        "children": []
                                    },
                                    {
                                        "id": "566",
                                        "linkid": "561",
                                        "code": "103021299",
                                        "paCode": "1030212",
                                        "yn": "N",
                                        "title": "其他食品用类似原料",
                                        "alias": "其他食品用类似原料",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "食品用原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030212990000000000",
                                        "taxCodeTitle": "食品用原料",
                                        "iTitle": "*食品用原料*其他食品用类似原料",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "567",
                                "linkid": "491",
                                "code": "1030299",
                                "paCode": "10302",
                                "yn": "N",
                                "title": "其他食品",
                                "alias": "其他食品",
                                "about": null,
                                "kws": null,
                                "taxName": "其他食品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1030299000000000000",
                                "taxCodeTitle": "其他食品",
                                "iTitle": "*其他食品*其他食品",
                                "children": []
                            }
                        ]
                    },
                    {
                        "id": "568",
                        "linkid": "379",
                        "code": "10303",
                        "paCode": "103",
                        "yn": "Y",
                        "title": "饮料、酒及酒精",
                        "alias": "饮料及酒",
                        "about": null,
                        "kws": null,
                        "taxName": "饮料及酒",
                        "taxRate": "",
                        "vip": "3",
                        "itaxRate": null,
                        "taxCode": "1030300000000000000",
                        "taxCodeTitle": "饮料及酒",
                        "iTitle": "*饮料及酒*饮料、酒及酒精",
                        "children": [
                            {
                                "id": "569",
                                "linkid": "568",
                                "code": "1030301",
                                "paCode": "10303",
                                "yn": "Y",
                                "title": "酒精",
                                "alias": "酒精",
                                "about": null,
                                "kws": null,
                                "taxName": "酒精",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1030301000000000000",
                                "taxCodeTitle": "酒精",
                                "iTitle": "*酒精*酒精",
                                "children": [
                                    {
                                        "id": "570",
                                        "linkid": "569",
                                        "code": "103030101",
                                        "paCode": "1030301",
                                        "yn": "N",
                                        "title": "木质水解酒精",
                                        "alias": "木质水解酒精",
                                        "about": null,
                                        "kws": "木质水解酒精",
                                        "taxName": "酒精",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030301010000000000",
                                        "taxCodeTitle": "酒精",
                                        "iTitle": "*酒精*木质水解酒精",
                                        "children": []
                                    },
                                    {
                                        "id": "571",
                                        "linkid": "569",
                                        "code": "103030199",
                                        "paCode": "1030301",
                                        "yn": "N",
                                        "title": "其他酒精",
                                        "alias": "其他酒精",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "酒精",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030301990000000000",
                                        "taxCodeTitle": "酒精",
                                        "iTitle": "*酒精*其他酒精",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "572",
                                "linkid": "568",
                                "code": "1030302",
                                "paCode": "10303",
                                "yn": "N",
                                "title": "白酒",
                                "alias": "白酒",
                                "about": null,
                                "kws": "白酒",
                                "taxName": "酒",
                                "taxRate": "13%",
                                "vip": "5",
                                "itaxRate": "0.13",
                                "taxCode": "1030302000000000000",
                                "taxCodeTitle": "酒",
                                "iTitle": "*酒*白酒",
                                "children": []
                            },
                            {
                                "id": "573",
                                "linkid": "568",
                                "code": "1030303",
                                "paCode": "10303",
                                "yn": "Y",
                                "title": "啤酒",
                                "alias": "啤酒",
                                "about": "指以麦芽和水为主要原料，加啤酒花（包括酒花制品），经酵母发酵酿制而成的、含有二氧化碳的、起泡的低酒精度的发酵酒",
                                "kws": null,
                                "taxName": "酒",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1030303000000000000",
                                "taxCodeTitle": "酒",
                                "iTitle": "*酒*啤酒",
                                "children": [
                                    {
                                        "id": "574",
                                        "linkid": "573",
                                        "code": "103030301",
                                        "paCode": "1030303",
                                        "yn": "N",
                                        "title": "每吨不超过3000元的啤酒",
                                        "alias": "每吨不超过3000元的啤酒",
                                        "about": null,
                                        "kws": "啤酒、瓶装熟啤酒、易拉罐装熟啤酒、生啤酒、瓶装生啤酒、桶装生啤酒、特种啤酒、无醇啤酒、果啤",
                                        "taxName": "酒",
                                        "taxRate": "13%",
                                        "vip": "8",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030303010000000000",
                                        "taxCodeTitle": "酒",
                                        "iTitle": "*酒*每吨不超过3000元的啤酒",
                                        "children": []
                                    },
                                    {
                                        "id": "575",
                                        "linkid": "573",
                                        "code": "103030302",
                                        "paCode": "1030303",
                                        "yn": "N",
                                        "title": "每吨3000元（含）以上的啤酒",
                                        "alias": "每吨3000元（含）以上的啤酒",
                                        "about": null,
                                        "kws": "啤酒、瓶装熟啤酒、易拉罐装熟啤酒、生啤酒、瓶装生啤酒、桶装生啤酒、特种啤酒、无醇啤酒、果啤",
                                        "taxName": "酒",
                                        "taxRate": "13%",
                                        "vip": "8",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030303020000000000",
                                        "taxCodeTitle": "酒",
                                        "iTitle": "*酒*每吨3000元（含）以上的啤酒",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "576",
                                "linkid": "568",
                                "code": "1030304",
                                "paCode": "10303",
                                "yn": "N",
                                "title": "黄酒",
                                "alias": "黄酒",
                                "about": null,
                                "kws": "黄酒、稻米黄酒、干黄酒、半干黄酒、半甜黄酒、浓甜黄酒、非稻米黄酒、非稻米干黄酒、非稻米半干黄酒、非稻米半甜黄酒、非稻米浓甜黄酒",
                                "taxName": "酒",
                                "taxRate": "13%",
                                "vip": "5",
                                "itaxRate": "0.13",
                                "taxCode": "1030304000000000000",
                                "taxCodeTitle": "酒",
                                "iTitle": "*酒*黄酒",
                                "children": []
                            },
                            {
                                "id": "577",
                                "linkid": "568",
                                "code": "1030305",
                                "paCode": "10303",
                                "yn": "N",
                                "title": "葡萄酒",
                                "alias": "葡萄酒",
                                "about": "指以新鲜葡萄或葡萄汁为原料，经全部或部分发酵酿制而成的、含有一定酒精度的发酵酒",
                                "kws": "干红、干白、葡萄酒、干葡萄酒、干红葡萄酒、干桃红葡萄酒、干白葡萄酒、半干葡萄酒、半干红葡萄酒、半干桃红葡萄酒、半干白葡萄酒、半甜葡萄酒、半甜红葡萄酒、半甜桃红葡萄酒、半甜白葡萄酒、甜葡萄酒、甜红葡萄酒、甜桃红葡萄酒、甜白葡萄酒、起泡葡萄酒、特种葡萄酒、冰葡萄酒、加香葡萄酒、山葡萄酒、葡萄汽酒",
                                "taxName": "酒",
                                "taxRate": "13%",
                                "vip": "5",
                                "itaxRate": "0.13",
                                "taxCode": "1030305000000000000",
                                "taxCodeTitle": "酒",
                                "iTitle": "*酒*葡萄酒",
                                "children": []
                            },
                            {
                                "id": "578",
                                "linkid": "568",
                                "code": "1030306",
                                "paCode": "10303",
                                "yn": "N",
                                "title": "其他酒",
                                "alias": "其他酒",
                                "about": "指以上未列明的酒",
                                "kws": null,
                                "taxName": "酒",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1030306000000000000",
                                "taxCodeTitle": "酒",
                                "iTitle": "*酒*其他酒",
                                "children": []
                            },
                            {
                                "id": "579",
                                "linkid": "568",
                                "code": "1030307",
                                "paCode": "10303",
                                "yn": "Y",
                                "title": "软饮料",
                                "alias": "软饮料",
                                "about": "指经过定量包装的，供直接饮用或用水冲调饮用的，乙醇（酒精）含量≤质量分数为0.5%的制品。不包括液体乳（详见103020401）。",
                                "kws": null,
                                "taxName": "软饮料",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1030307000000000000",
                                "taxCodeTitle": "软饮料",
                                "iTitle": "*软饮料*软饮料",
                                "children": [
                                    {
                                        "id": "580",
                                        "linkid": "579",
                                        "code": "103030701",
                                        "paCode": "1030307",
                                        "yn": "N",
                                        "title": "碳酸型饮料（汽水）",
                                        "alias": "汽水",
                                        "about": "指在一定条件下充入二氧化碳气的饮料；包括果汁型、果味型、可乐型，以及其他型碳酸饮料",
                                        "kws": "碳酸型饮料、汽水、果汁型碳酸饮料、果味型碳酸饮料、可乐型碳酸饮料",
                                        "taxName": "软饮料",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030307010000000000",
                                        "taxCodeTitle": "软饮料",
                                        "iTitle": "*软饮料*碳酸型饮料（汽水）",
                                        "children": []
                                    },
                                    {
                                        "id": "581",
                                        "linkid": "579",
                                        "code": "103030702",
                                        "paCode": "1030307",
                                        "yn": "N",
                                        "title": "果汁和蔬菜汁类饮料",
                                        "alias": "果汁和蔬菜汁类饮料",
                                        "about": "指用水果和（或）蔬菜（包括可食的根、茎、叶、花、果实）等为原料，经加工或发酵制成的饮料；包括果汁（浆）和蔬菜汁（浆）、浓缩果汁（浆）和浓缩蔬菜汁（浆）、果汁饮料和蔬菜汁饮料、果汁饮料浓浆和蔬菜汁饮料浓浆、复合果蔬汁（浆）及饮料、果肉饮料、发酵型果蔬汁饮料、水果饮料、其他果蔬汁饮料",
                                        "kws": "果汁、果浆、蔬菜汁、蔬菜浆、浓缩果汁、浓缩果浆、浓缩蔬菜汁、浓缩蔬菜浆、果汁饮料、蔬菜汁饮料、果汁饮料浓浆、蔬菜汁饮料浓浆、果肉饮料、水果饮料",
                                        "taxName": "软饮料",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030307020000000000",
                                        "taxCodeTitle": "软饮料",
                                        "iTitle": "*软饮料*果汁和蔬菜汁类饮料",
                                        "children": []
                                    },
                                    {
                                        "id": "582",
                                        "linkid": "579",
                                        "code": "103030703",
                                        "paCode": "1030307",
                                        "yn": "N",
                                        "title": "蛋白饮料",
                                        "alias": "蛋白饮料",
                                        "about": "指以乳或乳制品、或有一定蛋白质含量的植物的果实、种子或种仁等为原料，经加工或发酵制成的饮料；包括含乳饮料、植物蛋白饮料、复合蛋白饮料，以及其他未列明的蛋白饮料",
                                        "kws": "蛋白饮料、含乳饮料、植物蛋白饮料、豆奶、豆乳、椰子汁、椰子乳、杏仁露、杏仁乳、核桃露、核桃乳、花生露、花生乳",
                                        "taxName": "软饮料",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030307030000000000",
                                        "taxCodeTitle": "软饮料",
                                        "iTitle": "*软饮料*蛋白饮料",
                                        "children": []
                                    },
                                    {
                                        "id": "583",
                                        "linkid": "579",
                                        "code": "103030704",
                                        "paCode": "1030307",
                                        "yn": "N",
                                        "title": "包装饮用水",
                                        "alias": "包装饮用水",
                                        "about": "指密封于容器中可直接饮用的水",
                                        "kws": "包装饮用水、饮用天然水、饮用天然矿泉水、饮用纯净水、饮用矿物质水",
                                        "taxName": "软饮料",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030307040000000000",
                                        "taxCodeTitle": "软饮料",
                                        "iTitle": "*软饮料*包装饮用水",
                                        "children": []
                                    },
                                    {
                                        "id": "584",
                                        "linkid": "579",
                                        "code": "103030705",
                                        "paCode": "1030307",
                                        "yn": "N",
                                        "title": "茶饮料",
                                        "alias": "茶饮料",
                                        "about": "指以茶叶的水提取液或其浓缩液、茶粉等为原料，经加工制成的饮料",
                                        "kws": "茶饮料、茶浓缩液、调味茶饮料、奶茶饮料、奶味茶饮料、碳酸茶饮料",
                                        "taxName": "软饮料",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030307050000000000",
                                        "taxCodeTitle": "软饮料",
                                        "iTitle": "*软饮料*茶饮料",
                                        "children": []
                                    },
                                    {
                                        "id": "585",
                                        "linkid": "579",
                                        "code": "103030706",
                                        "paCode": "1030307",
                                        "yn": "N",
                                        "title": "咖啡饮料",
                                        "alias": "咖啡饮料",
                                        "about": "指以咖啡的水提取液或其浓缩液、速溶咖啡粉为原料，经加工制成的液体饮料；包括咖啡因含量≥400mg/kg的浓咖啡饮料，咖啡因含量200～400mg/kg的咖啡饮料，咖啡因含量≤50mg/kg的低咖啡因咖啡饮料，以及其他未列明的符合咖啡饮料基本技术要求的咖啡饮料。",
                                        "kws": "咖啡、咖啡饮料",
                                        "taxName": "软饮料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030307060000000000",
                                        "taxCodeTitle": "软饮料",
                                        "iTitle": "*软饮料*咖啡饮料",
                                        "children": []
                                    },
                                    {
                                        "id": "586",
                                        "linkid": "579",
                                        "code": "103030707",
                                        "paCode": "1030307",
                                        "yn": "N",
                                        "title": "固体饮料",
                                        "alias": "固体饮料",
                                        "about": "指用食品原料、食品添加剂等加工制成粉末状、颗粒状或块状等固态料的供冲调饮用的制品[固体饮料在稀释冲调后应达到相应种类非固体饮料的技术指标和要求]；包括果汁粉、豆粉、茶粉、咖啡粉、果味型固体饮料、固态汽水（泡腾片）、姜汁粉等",
                                        "kws": "固体饮料、果汁粉、豆粉、茶粉、咖啡粉、果味型固体饮料、固态汽水、泡腾片、姜汁粉",
                                        "taxName": "软饮料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030307070000000000",
                                        "taxCodeTitle": "软饮料",
                                        "iTitle": "*软饮料*固体饮料",
                                        "children": []
                                    },
                                    {
                                        "id": "587",
                                        "linkid": "579",
                                        "code": "103030799",
                                        "paCode": "1030307",
                                        "yn": "N",
                                        "title": "其他软饮料",
                                        "alias": "其他软饮料",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "软饮料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030307990000000000",
                                        "taxCodeTitle": "软饮料",
                                        "iTitle": "*软饮料*其他软饮料",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "588",
                                "linkid": "568",
                                "code": "1030308",
                                "paCode": "10303",
                                "yn": "Y",
                                "title": "精制茶及茶制品",
                                "alias": "精制茶及茶制品",
                                "about": null,
                                "kws": null,
                                "taxName": "茶",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1030308000000000000",
                                "taxCodeTitle": "茶",
                                "iTitle": "*茶*精制茶及茶制品",
                                "children": [
                                    {
                                        "id": "589",
                                        "linkid": "588",
                                        "code": "103030801",
                                        "paCode": "1030308",
                                        "yn": "N",
                                        "title": "精制茶",
                                        "alias": "精制茶",
                                        "about": "指对毛茶或半成品原料茶进行筛分、轧切、风选、干燥、匀堆、拼配等工序加工成的精茶",
                                        "kws": "精制茶、精制红茶、精制绿茶、精制花茶、精制乌龙茶、精制紧压茶、精制普洱茶",
                                        "taxName": "茶",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030308010000000000",
                                        "taxCodeTitle": "茶",
                                        "iTitle": "*茶*精制茶",
                                        "children": []
                                    },
                                    {
                                        "id": "590",
                                        "linkid": "588",
                                        "code": "103030802",
                                        "paCode": "1030308",
                                        "yn": "N",
                                        "title": "茶制品",
                                        "alias": "茶制品",
                                        "about": null,
                                        "kws": "茶制品、浓缩茶精汁、保健茶",
                                        "taxName": "茶",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030308020000000000",
                                        "taxCodeTitle": "茶",
                                        "iTitle": "*茶*茶制品",
                                        "children": []
                                    },
                                    {
                                        "id": "591",
                                        "linkid": "588",
                                        "code": "103030803",
                                        "paCode": "1030308",
                                        "yn": "N",
                                        "title": "边销茶",
                                        "alias": "边销茶",
                                        "about": "指以黑毛茶、老青茶、红茶末、绿茶为主要原料，经过发酵、蒸制、加压或者压碎、炒制，专门销往边疆少数民族地区的紧压茶、方包茶(马茶)",
                                        "kws": "紧压茶、方包茶、马茶、边茶",
                                        "taxName": "茶",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030308030000000000",
                                        "taxCodeTitle": "茶",
                                        "iTitle": "*茶*边销茶",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "592",
                                "linkid": "568",
                                "code": "1030309",
                                "paCode": "10303",
                                "yn": "Y",
                                "title": "饮料、酒及酒精专用原辅料",
                                "alias": "饮料酒精原辅料",
                                "about": null,
                                "kws": null,
                                "taxName": "饮料酒精原辅料",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1030309000000000000",
                                "taxCodeTitle": "饮料酒精原辅料",
                                "iTitle": "*饮料酒精原辅料*饮料、酒及酒精专用原辅料",
                                "children": [
                                    {
                                        "id": "593",
                                        "linkid": "592",
                                        "code": "103030901",
                                        "paCode": "1030309",
                                        "yn": "N",
                                        "title": "酒及酒精专用原辅料",
                                        "alias": "酒精原辅料",
                                        "about": null,
                                        "kws": "啤酒麦芽、酿酒葡萄汁",
                                        "taxName": "饮料酒精原辅料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030309010000000000",
                                        "taxCodeTitle": "饮料酒精原辅料",
                                        "iTitle": "*饮料酒精原辅料*酒及酒精专用原辅料",
                                        "children": []
                                    },
                                    {
                                        "id": "594",
                                        "linkid": "592",
                                        "code": "103030902",
                                        "paCode": "1030309",
                                        "yn": "N",
                                        "title": "饮料专用原辅料",
                                        "alias": "饮料原辅料",
                                        "about": null,
                                        "kws": "酒专用原辅料、酒精专用原辅料",
                                        "taxName": "饮料酒精原辅料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030309020000000000",
                                        "taxCodeTitle": "饮料酒精原辅料",
                                        "iTitle": "*饮料酒精原辅料*饮料专用原辅料",
                                        "children": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "id": "595",
                        "linkid": "379",
                        "code": "10304",
                        "paCode": "103",
                        "yn": "Y",
                        "title": "烟草制品",
                        "alias": "烟草制品",
                        "about": "以烟叶为原料制成的产品",
                        "kws": null,
                        "taxName": "烟草制品",
                        "taxRate": "",
                        "vip": "7",
                        "itaxRate": null,
                        "taxCode": "1030400000000000000",
                        "taxCodeTitle": "烟草制品",
                        "iTitle": "*烟草制品*烟草制品",
                        "children": [
                            {
                                "id": "596",
                                "linkid": "595",
                                "code": "1030401",
                                "paCode": "10304",
                                "yn": "Y",
                                "title": "复烤烟叶",
                                "alias": "复烤烟叶",
                                "about": "初烤烟经再次干燥处理，含水率达到适合于贮存、醇化或人工发酵的烟叶",
                                "kws": null,
                                "taxName": "烟草制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1030401000000000000",
                                "taxCodeTitle": "烟草制品",
                                "iTitle": "*烟草制品*复烤烟叶",
                                "children": [
                                    {
                                        "id": "597",
                                        "linkid": "596",
                                        "code": "103040101",
                                        "paCode": "1030401",
                                        "yn": "N",
                                        "title": "片烟",
                                        "alias": "片烟",
                                        "about": "经过打叶等方法进行去梗处理，已将直径大于1.5mm的烟梗去除后的烟叶",
                                        "kws": "片烟",
                                        "taxName": "烟草制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030401010000000000",
                                        "taxCodeTitle": "烟草制品",
                                        "iTitle": "*烟草制品*片烟",
                                        "children": []
                                    },
                                    {
                                        "id": "598",
                                        "linkid": "596",
                                        "code": "103040102",
                                        "paCode": "1030401",
                                        "yn": "N",
                                        "title": "烟梗",
                                        "alias": "烟梗",
                                        "about": "烟叶的主脉",
                                        "kws": "烟梗",
                                        "taxName": "烟草制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030401020000000000",
                                        "taxCodeTitle": "烟草制品",
                                        "iTitle": "*烟草制品*烟梗",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "599",
                                "linkid": "595",
                                "code": "1030402",
                                "paCode": "10304",
                                "yn": "Y",
                                "title": "卷烟",
                                "alias": "卷烟",
                                "about": "将烟叶等切成烟丝，用卷烟纸把烟丝卷制成供人们燃吸或以其他方式抽吸的烟草制品",
                                "kws": null,
                                "taxName": "烟草制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1030402000000000000",
                                "taxCodeTitle": "烟草制品",
                                "iTitle": "*烟草制品*卷烟",
                                "children": [
                                    {
                                        "id": "600",
                                        "linkid": "599",
                                        "code": "103040201",
                                        "paCode": "1030402",
                                        "yn": "N",
                                        "title": "甲类卷烟",
                                        "alias": "甲类卷烟",
                                        "about": "每标准条(200支)调拨价格在70元(不含增值税)以上(含70元)的卷烟",
                                        "kws": "甲类卷烟、一类烟、二类烟",
                                        "taxName": "烟草制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030402010000000000",
                                        "taxCodeTitle": "烟草制品",
                                        "iTitle": "*烟草制品*甲类卷烟",
                                        "children": []
                                    },
                                    {
                                        "id": "601",
                                        "linkid": "599",
                                        "code": "103040202",
                                        "paCode": "1030402",
                                        "yn": "N",
                                        "title": "乙类卷烟",
                                        "alias": "乙类卷烟",
                                        "about": "每标准条(200支)调拨价格在70元(不含增值税)以下的卷烟",
                                        "kws": "乙类卷烟、三类烟、四类烟、五类烟",
                                        "taxName": "烟草制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030402020000000000",
                                        "taxCodeTitle": "烟草制品",
                                        "iTitle": "*烟草制品*乙类卷烟",
                                        "children": []
                                    },
                                    {
                                        "id": "602",
                                        "linkid": "599",
                                        "code": "103040203",
                                        "paCode": "1030402",
                                        "yn": "N",
                                        "title": "烟草代用品制的卷烟",
                                        "alias": "烟草代用品制的卷烟",
                                        "about": null,
                                        "kws": "电子烟",
                                        "taxName": "烟草制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030402030000000000",
                                        "taxCodeTitle": "烟草制品",
                                        "iTitle": "*烟草制品*烟草代用品制的卷烟",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "603",
                                "linkid": "595",
                                "code": "1030403",
                                "paCode": "10304",
                                "yn": "Y",
                                "title": "雪茄烟",
                                "alias": "雪茄烟",
                                "about": "用烟草做茄芯，烟草或含有烟草成分的材料做茄衣卷制而成，具有雪茄型烟草香味特征的烟草制品",
                                "kws": null,
                                "taxName": "烟草制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1030403000000000000",
                                "taxCodeTitle": "烟草制品",
                                "iTitle": "*烟草制品*雪茄烟",
                                "children": [
                                    {
                                        "id": "604",
                                        "linkid": "603",
                                        "code": "103040301",
                                        "paCode": "1030403",
                                        "yn": "N",
                                        "title": "烟草制的雪茄烟",
                                        "alias": "烟草雪茄烟",
                                        "about": null,
                                        "kws": "雪茄烟",
                                        "taxName": "烟草制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030403010000000000",
                                        "taxCodeTitle": "烟草制品",
                                        "iTitle": "*烟草制品*烟草制的雪茄烟",
                                        "children": []
                                    },
                                    {
                                        "id": "605",
                                        "linkid": "603",
                                        "code": "103040302",
                                        "paCode": "1030403",
                                        "yn": "N",
                                        "title": "烟草代用品制的雪茄烟",
                                        "alias": "烟草代用品制的雪茄烟",
                                        "about": null,
                                        "kws": "烟草代用品制的雪茄烟",
                                        "taxName": "烟草制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1030403020000000000",
                                        "taxCodeTitle": "烟草制品",
                                        "iTitle": "*烟草制品*烟草代用品制的雪茄烟",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "606",
                                "linkid": "595",
                                "code": "1030404",
                                "paCode": "10304",
                                "yn": "N",
                                "title": "烟丝",
                                "alias": "烟丝",
                                "about": "由叶丝、梗丝、再造烟叶丝、膨胀烟丝、膨胀梗丝等组成的混合物，用于卷制卷烟",
                                "kws": "烟丝",
                                "taxName": "烟草制品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1030404000000000000",
                                "taxCodeTitle": "烟草制品",
                                "iTitle": "*烟草制品*烟丝",
                                "children": []
                            }
                        ]
                    }
                ]
            },
            {
                "id": "607",
                "linkid": "1",
                "code": "104",
                "paCode": "1",
                "yn": "Y",
                "title": "纺织、服装、皮革类产品",
                "alias": "纺织、服装、皮革类产品",
                "about": null,
                "kws": null,
                "taxName": "纺织服装皮革产品",
                "taxRate": "",
                "vip": "5",
                "itaxRate": null,
                "taxCode": "1040000000000000000",
                "taxCodeTitle": "纺织服装皮革产品",
                "iTitle": "*纺织服装皮革产品*纺织、服装、皮革类产品",
                "children": [
                    {
                        "id": "608",
                        "linkid": "607",
                        "code": "10401",
                        "paCode": "104",
                        "yn": "Y",
                        "title": "纺织产品",
                        "alias": "纺织产品",
                        "about": null,
                        "kws": null,
                        "taxName": "纺织产品",
                        "taxRate": "",
                        "vip": "3",
                        "itaxRate": null,
                        "taxCode": "1040100000000000000",
                        "taxCodeTitle": "纺织产品",
                        "iTitle": "*纺织产品*纺织产品",
                        "children": [
                            {
                                "id": "609",
                                "linkid": "608",
                                "code": "1040101",
                                "paCode": "10401",
                                "yn": "Y",
                                "title": "棉、化纤纺织及印染产品",
                                "alias": "棉、化纤纺织及印染产品",
                                "about": null,
                                "kws": null,
                                "taxName": "纺织产品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1040101000000000000",
                                "taxCodeTitle": "纺织产品",
                                "iTitle": "*纺织产品*棉、化纤纺织及印染产品",
                                "children": [
                                    {
                                        "id": "610",
                                        "linkid": "609",
                                        "code": "104010101",
                                        "paCode": "1040101",
                                        "yn": "N",
                                        "title": "已梳皮棉",
                                        "alias": "已梳皮棉",
                                        "about": "包括精梳或粗梳皮棉",
                                        "kws": "精梳皮棉、粗梳皮棉",
                                        "taxName": "纺织产品",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1040101010000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*已梳皮棉",
                                        "children": []
                                    },
                                    {
                                        "id": "611",
                                        "linkid": "609",
                                        "code": "104010102",
                                        "paCode": "1040101",
                                        "yn": "N",
                                        "title": "纱",
                                        "alias": "纱",
                                        "about": "指棉、化学纤维与毛麻等将纤维拉长加捻纺成的细缕，通常用作织布的原材料。包括棉纱、棉混纺纱、化学纤维纱。不包括线（详见104010103）、缝纫线（详见104010104）、毛纱（详见104010202）、绒线（详见104010203）、麻纱线（详见104010302）。",
                                        "kws": "普梳纱、精梳纱、合成纤维棉混纺纱、人造纤维棉混纺纱、合成纤维纱、人造纤维纱、合成纤维混纺纱、人造纤维混纺纱、色纺棉纱、色纺棉混纺纱、色纺化学纤维纱",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040101020000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*纱",
                                        "children": []
                                    },
                                    {
                                        "id": "612",
                                        "linkid": "609",
                                        "code": "104010103",
                                        "paCode": "1040101",
                                        "yn": "N",
                                        "title": "线",
                                        "alias": "线",
                                        "about": "指两根及以上单纱经过捻线机、倍捻机加捻合股后的产品；是将纱进一步加工的产品，用于梭织或针织织造。包括棉线、棉混纺线、化学纤维线、色纺线",
                                        "kws": "棉线、棉混纺线、合成纤维长丝纱线、人造纤维长丝纱线、多种化学纤维长丝混合线、色纺棉线、色纺棉混纺线、色纺化学纤维线",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040101030000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*线",
                                        "children": []
                                    },
                                    {
                                        "id": "613",
                                        "linkid": "609",
                                        "code": "104010104",
                                        "paCode": "1040101",
                                        "yn": "N",
                                        "title": "缝纫线",
                                        "alias": "缝纫线",
                                        "about": "指股线的再加工产品，是为缝制加工纺织品用的。包括短纤维缝纫线、长丝缝纫线",
                                        "kws": "棉缝纫线、棉混纺缝纫线、化学纤维缝纫线、天然丝缝纫线、化学纤维长丝缝纫线",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040101040000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*缝纫线",
                                        "children": []
                                    },
                                    {
                                        "id": "614",
                                        "linkid": "609",
                                        "code": "104010105",
                                        "paCode": "1040101",
                                        "yn": "N",
                                        "title": "布",
                                        "alias": "布",
                                        "about": "指用纱或股线在棉织机上（包括有梭织机、无梭织机）织造的机织布；指坯布（经有梭织机或无梭织机织造的下机布，未经染整加工、未漂白的坯布）。包括棉布、棉混纺布、化学纤维短纤布、色织布、牛仔布",
                                        "kws": "棉平布、棉绒布、棉混纺平布、棉混纺绒布、化学纤维短纤平布、化学纤维短纤绒布、化学纤维短纤混纺平布、化学纤维短纤混纺绒布、棉色织布、棉混纺色织布、棉牛仔布、棉混纺牛仔布",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040101050000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*布",
                                        "children": []
                                    },
                                    {
                                        "id": "615",
                                        "linkid": "609",
                                        "code": "104010106",
                                        "paCode": "1040101",
                                        "yn": "N",
                                        "title": "印染布",
                                        "alias": "印染布",
                                        "about": "指棉纺织厂生产的棉布、棉混纺布、化学纤维布的坯布经棉印染生产设备加工整理的漂白布、染色布、印花布的统称。包括漂白布、染色布、印花布",
                                        "kws": "漂白棉布、漂白棉混纺布、漂白化学纤维布、染色棉布、染色棉混纺布、染色化学纤维布、印花棉布、印花棉混纺布、印花化学纤维布",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040101060000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*印染布",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "616",
                                "linkid": "608",
                                "code": "1040102",
                                "paCode": "10401",
                                "yn": "Y",
                                "title": "毛纺织、染整加工产品",
                                "alias": "毛纺织、染整加工产品",
                                "about": null,
                                "kws": "毛条、毛纱、绒线、毛机织物、呢绒、特种羊毛织物、动物细毛织物、毛染整精加工产品",
                                "taxName": "纺织产品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1040102000000000000",
                                "taxCodeTitle": "纺织产品",
                                "iTitle": "*纺织产品*毛纺织、染整加工产品",
                                "children": [
                                    {
                                        "id": "617",
                                        "linkid": "616",
                                        "code": "104010201",
                                        "paCode": "1040102",
                                        "yn": "N",
                                        "title": "毛条",
                                        "alias": "毛条",
                                        "about": "洗净毛经梳理成条后，经过精梳及其前后的准备和整理过程，即毛条制成。包括动物毛条、合成纤维毛条",
                                        "kws": "精梳动物毛条、涤纶毛条、腈纶毛条",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040102010000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*毛条",
                                        "children": []
                                    },
                                    {
                                        "id": "618",
                                        "linkid": "616",
                                        "code": "104010202",
                                        "paCode": "1040102",
                                        "yn": "N",
                                        "title": "毛纱",
                                        "alias": "毛纱",
                                        "about": "毛纱是以羊毛为原料纺制而成有捻向的单纱。包括羊毛纱、混纺羊毛纱、其他毛纱",
                                        "kws": "粗梳羊毛纱、精梳羊毛纱、粗梳混纺羊毛纱、精梳混纺羊毛纱、精梳羊绒纱线、粗梳羊绒纱线、半精纺羊绒纱、动物毛粗梳细毛纱、动物毛精梳细毛纱、半精纺混纺毛纱",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040102020000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*毛纱",
                                        "children": []
                                    },
                                    {
                                        "id": "619",
                                        "linkid": "616",
                                        "code": "104010203",
                                        "paCode": "1040102",
                                        "yn": "N",
                                        "title": "绒线",
                                        "alias": "绒线",
                                        "about": "俗称毛线。包括纯毛绒线、混纺绒线、化学纤维绒线、其他绒线",
                                        "kws": "针织纯毛绒线、编织纯毛绒线、针织混纺绒线、编织混纺绒线、针织化学纤维绒线、编织化学纤维绒线、手编羊绒毛线",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040102030000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*绒线",
                                        "children": []
                                    },
                                    {
                                        "id": "620",
                                        "linkid": "616",
                                        "code": "104010204",
                                        "paCode": "1040102",
                                        "yn": "N",
                                        "title": "毛机织物（呢绒）",
                                        "alias": "呢绒",
                                        "about": "或称毛织品。包括纯毛机织物、毛混纺机织物、化学纤维毛机织物、其他毛机织物",
                                        "kws": "粗梳毛机织物、精梳毛机织物、粗梳毛混纺机织物、精梳毛混纺机织物、精纺化学纤维毛机织物、粗纺化学纤维毛机织物、粗梳羊绒机织物",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040102040000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*毛机织物（呢绒）",
                                        "children": []
                                    },
                                    {
                                        "id": "621",
                                        "linkid": "616",
                                        "code": "104010205",
                                        "paCode": "1040102",
                                        "yn": "N",
                                        "title": "特种羊毛或动物细毛织物",
                                        "alias": "特种羊毛或动物细毛织物",
                                        "about": "包括毛制起绒织物、毛制绳绒织物、毛制毛巾织物、毛制簇绒织物",
                                        "kws": "毛制起绒织物、毛制绳绒织物、毛制毛巾织物、毛制簇绒织物",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040102050000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*特种羊毛或动物细毛织物",
                                        "children": []
                                    },
                                    {
                                        "id": "622",
                                        "linkid": "616",
                                        "code": "104010206",
                                        "paCode": "1040102",
                                        "yn": "N",
                                        "title": "毛染整精加工产品",
                                        "alias": "毛染整精加工产品",
                                        "about": null,
                                        "kws": "毛染整精加工产品",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040102060000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*毛染整精加工产品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "623",
                                "linkid": "608",
                                "code": "1040103",
                                "paCode": "10401",
                                "yn": "Y",
                                "title": "麻纺织品",
                                "alias": "麻纺织品",
                                "about": null,
                                "kws": "麻纤维原料、麻纱线、亚麻布、亚麻印染布、苎麻布、苎麻印染布",
                                "taxName": "纺织产品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1040103000000000000",
                                "taxCodeTitle": "纺织产品",
                                "iTitle": "*纺织产品*麻纺织品",
                                "children": [
                                    {
                                        "id": "624",
                                        "linkid": "623",
                                        "code": "104010301",
                                        "paCode": "1040103",
                                        "yn": "N",
                                        "title": "麻纤维原料",
                                        "alias": "麻纤维原料",
                                        "about": "纺前经加工的麻纤维，也称精干麻；指经破开、打成、栉梳或其他加工。包括苎麻原麻、苎麻精干麻、亚麻打成麻、亚麻短纤、黄（红）麻（熟麻）、大麻原麻、其他麻纤维原料",
                                        "kws": "苎麻原麻、苎麻精干麻、亚麻打成麻、亚麻短纤、黄麻、红麻、熟麻、大麻原麻",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040103010000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*麻纤维原料",
                                        "children": []
                                    },
                                    {
                                        "id": "625",
                                        "linkid": "623",
                                        "code": "104010302",
                                        "paCode": "1040103",
                                        "yn": "N",
                                        "title": "麻纱线",
                                        "alias": "麻纱线",
                                        "about": "包括亚麻纱、苎麻纱、黄红麻纱、大麻纱线、其他麻纱线",
                                        "kws": "含亚麻≥55%的亚麻纱、含亚麻＜55%的亚麻纱、含苎麻≥55%的苎麻纱、含苎麻＜55%的苎麻纱、黄红麻单纱、黄红麻多股纱线、大麻单纱、大麻多股纱线、亚麻纱、苎麻纱",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040103020000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*麻纱线",
                                        "children": []
                                    },
                                    {
                                        "id": "626",
                                        "linkid": "623",
                                        "code": "104010303",
                                        "paCode": "1040103",
                                        "yn": "N",
                                        "title": "亚麻布",
                                        "alias": "亚麻布",
                                        "about": "包括亚麻布，含亚麻≥55%、其他亚麻布，含亚麻＜55%",
                                        "kws": "亚麻布",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040103030000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*亚麻布",
                                        "children": []
                                    },
                                    {
                                        "id": "627",
                                        "linkid": "623",
                                        "code": "104010304",
                                        "paCode": "1040103",
                                        "yn": "N",
                                        "title": "亚麻印染布",
                                        "alias": "亚麻印染布",
                                        "about": "包括亚麻漂白布、亚麻染色布、亚麻印花布",
                                        "kws": "亚麻漂白布、亚麻染色布、亚麻印花布",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040103040000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*亚麻印染布",
                                        "children": []
                                    },
                                    {
                                        "id": "628",
                                        "linkid": "623",
                                        "code": "104010305",
                                        "paCode": "1040103",
                                        "yn": "N",
                                        "title": "苎麻布",
                                        "alias": "苎麻布",
                                        "about": "包括苎麻布，含苎麻≥55%、其他苎麻布，含苎麻＜55%",
                                        "kws": "苎麻布",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040103050000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*苎麻布",
                                        "children": []
                                    },
                                    {
                                        "id": "629",
                                        "linkid": "623",
                                        "code": "104010306",
                                        "paCode": "1040103",
                                        "yn": "N",
                                        "title": "苎麻印染布",
                                        "alias": "苎麻印染布",
                                        "about": "包括苎麻漂白布、苎麻染色布、苎麻印花布",
                                        "kws": "苎麻漂白布、苎麻染色布、苎麻印花布",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040103060000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*苎麻印染布",
                                        "children": []
                                    },
                                    {
                                        "id": "630",
                                        "linkid": "623",
                                        "code": "104010307",
                                        "paCode": "1040103",
                                        "yn": "N",
                                        "title": "黄红麻织物",
                                        "alias": "黄红麻织物",
                                        "about": null,
                                        "kws": "黄红麻织物",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040103070000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*黄红麻织物",
                                        "children": []
                                    },
                                    {
                                        "id": "631",
                                        "linkid": "623",
                                        "code": "104010308",
                                        "paCode": "1040103",
                                        "yn": "N",
                                        "title": "大麻织物",
                                        "alias": "大麻织物",
                                        "about": null,
                                        "kws": "大麻织物",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040103080000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*大麻织物",
                                        "children": []
                                    },
                                    {
                                        "id": "632",
                                        "linkid": "623",
                                        "code": "104010399",
                                        "paCode": "1040103",
                                        "yn": "N",
                                        "title": "其他麻纺织品",
                                        "alias": "其他麻纺织品",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040103990000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*其他麻纺织品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "633",
                                "linkid": "608",
                                "code": "1040104",
                                "paCode": "10401",
                                "yn": "Y",
                                "title": "丝绢纺织及精加工产品",
                                "alias": "丝绢纺织及精加工产品",
                                "about": null,
                                "kws": null,
                                "taxName": "纺织产品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1040104000000000000",
                                "taxCodeTitle": "纺织产品",
                                "iTitle": "*纺织产品*丝绢纺织及精加工产品",
                                "children": [
                                    {
                                        "id": "634",
                                        "linkid": "633",
                                        "code": "104010401",
                                        "paCode": "1040104",
                                        "yn": "N",
                                        "title": "蚕丝",
                                        "alias": "蚕丝",
                                        "about": "包括桑蚕丝、柞蚕丝、绢纺丝、蚕丝短纤维、丝纱线、其他蚕丝",
                                        "kws": "蚕丝、桑蚕丝、桑蚕生丝、桑蚕土丝、桑蚕双宫丝、柞蚕丝、绢丝、丝、蚕丝短纤维、丝纱线、厂丝",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040104010000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*蚕丝",
                                        "children": []
                                    },
                                    {
                                        "id": "635",
                                        "linkid": "633",
                                        "code": "104010402",
                                        "paCode": "1040104",
                                        "yn": "N",
                                        "title": "蚕丝及交织机织物",
                                        "alias": "蚕丝及交织机织物",
                                        "about": "包括含蚕丝≥50%的蚕丝及交织机织物、含蚕丝＜50%的蚕丝交织机织物",
                                        "kws": "桑蚕丝交织物、柞蚕丝交织物、绢丝交织物、丝交织物、桑蚕混纺织物、柞蚕混纺织物",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040104020000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*蚕丝及交织机织物",
                                        "children": []
                                    },
                                    {
                                        "id": "636",
                                        "linkid": "633",
                                        "code": "104010403",
                                        "paCode": "1040104",
                                        "yn": "N",
                                        "title": "印染蚕丝及交织机织物",
                                        "alias": "印染蚕丝及交织机织物",
                                        "about": "包括含蚕丝≥50%的印染蚕丝及交织机织物、含蚕丝＜50%印染的蚕丝及交织机织物，",
                                        "kws": "练白蚕丝交织物、染色蚕丝交织物、印花蚕丝交织物",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040104030000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*印染蚕丝及交织机织物",
                                        "children": []
                                    },
                                    {
                                        "id": "637",
                                        "linkid": "633",
                                        "code": "104010404",
                                        "paCode": "1040104",
                                        "yn": "N",
                                        "title": "化纤长丝机织物",
                                        "alias": "化纤长丝机织物",
                                        "about": "指经向、纬向均为合成纤维长丝或再生纤维长丝在织机上（喷水织机、剑杆织机、喷气织机等）生产的长丝织物。包括合成纤维长丝机织物、人造纤维长丝机织物、化学纤维长丝绒布、其他化纤长丝机织物",
                                        "kws": "锦纶长丝机织物、涤纶长丝机织物、涤纶加工丝机织物、合纤混纺交织机织物、粘胶长丝机织物、醋酸长丝机织物、人造丝混纺交织机织物、化学纤维长丝绒布",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040104040000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*化纤长丝机织物",
                                        "children": []
                                    },
                                    {
                                        "id": "638",
                                        "linkid": "633",
                                        "code": "104010405",
                                        "paCode": "1040104",
                                        "yn": "N",
                                        "title": "特种丝织物",
                                        "alias": "特种丝织物",
                                        "about": "包括丝制起绒织物及绳绒织物、丝制毛巾织物及类似毛圈机织物、丝制纱罗、丝制簇绒织物，含蚕丝50%及以上",
                                        "kws": "丝制起绒织物及绳绒织物、丝制毛巾织物及类似毛圈机织物、丝制纱罗、丝制簇绒织物",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040104050000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*特种丝织物",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "639",
                                "linkid": "608",
                                "code": "1040105",
                                "paCode": "10401",
                                "yn": "Y",
                                "title": "床上用织物制品",
                                "alias": "床上用织物制品",
                                "about": "包括床褥单、被面、枕套、被罩、床罩、毯子、寝具及类似填充用品、毛巾被、枕巾。不包括针织或钩编的床上制品（详见104011302）。",
                                "kws": "床褥单、被面、枕套、被罩、床罩、毯子、寝具、寝具填充物、毛巾被、枕巾",
                                "taxName": "纺织产品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1040105000000000000",
                                "taxCodeTitle": "纺织产品",
                                "iTitle": "*纺织产品*床上用织物制品",
                                "children": [
                                    {
                                        "id": "640",
                                        "linkid": "639",
                                        "code": "104010501",
                                        "paCode": "1040105",
                                        "yn": "N",
                                        "title": "床褥单",
                                        "alias": "床褥单",
                                        "about": "包括棉制床褥单、化学纤维制床褥单、麻制床单。不包括针织或钩编的床上用品（详见104011302）",
                                        "kws": "棉制印花床褥单、棉制刺绣床褥单、化纤制印花床褥单、化纤制刺绣床褥单、麻制印花床单、麻制刺绣床单",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040105010000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*床褥单",
                                        "children": []
                                    },
                                    {
                                        "id": "641",
                                        "linkid": "639",
                                        "code": "104010502",
                                        "paCode": "1040105",
                                        "yn": "N",
                                        "title": "被面",
                                        "alias": "被面",
                                        "about": "包括丝绸被面、其他被面",
                                        "kws": "丝制印花被面、丝制绣花被面",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040105020000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*被面",
                                        "children": []
                                    },
                                    {
                                        "id": "642",
                                        "linkid": "639",
                                        "code": "104010503",
                                        "paCode": "1040105",
                                        "yn": "N",
                                        "title": "枕套",
                                        "alias": "枕套",
                                        "about": "包括棉制枕套、化学纤维制枕套、丝绸枕套、其他枕套。不包括针织或钩编的床上用品（详见104011302）。",
                                        "kws": "棉制印花枕套、棉制刺绣枕套、化纤制印花枕套、化纤制刺绣枕套、丝制印花枕套、丝制绣花枕套",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040105030000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*枕套",
                                        "children": []
                                    },
                                    {
                                        "id": "643",
                                        "linkid": "639",
                                        "code": "104010504",
                                        "paCode": "1040105",
                                        "yn": "N",
                                        "title": "被罩",
                                        "alias": "被罩",
                                        "about": "包括棉制被罩、化学纤维制被罩、麻制被罩、其他被罩。不包括针织或钩编的床上用品（详见104011302）。",
                                        "kws": "棉制印花被罩、棉制刺绣被罩、化纤制印花被罩、化纤制刺绣被罩、麻制印花被罩、麻制刺绣被罩",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040105040000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*被罩",
                                        "children": []
                                    },
                                    {
                                        "id": "644",
                                        "linkid": "639",
                                        "code": "104010505",
                                        "paCode": "1040105",
                                        "yn": "N",
                                        "title": "床罩",
                                        "alias": "床罩",
                                        "about": "包括棉制床罩、化学纤维制床罩、麻制床罩、丝制床罩、其他床罩。不包括针织或钩编的床上用品（详见104011302）。",
                                        "kws": "棉制刺绣床罩、化纤制刺绣床罩、麻制刺绣床罩、丝制床罩",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040105050000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*床罩",
                                        "children": []
                                    },
                                    {
                                        "id": "645",
                                        "linkid": "639",
                                        "code": "104010506",
                                        "paCode": "1040105",
                                        "yn": "N",
                                        "title": "毯子",
                                        "alias": "毯子",
                                        "about": "包括棉制毯、毛制毯、麻制毯、其他毯子",
                                        "kws": "棉制毯、纯毛毛毯、毛混纺毛毯、化纤毛毯、麻制毯",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040105060000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*毯子",
                                        "children": []
                                    },
                                    {
                                        "id": "646",
                                        "linkid": "639",
                                        "code": "104010507",
                                        "paCode": "1040105",
                                        "yn": "N",
                                        "title": "寝具及类似填充用品",
                                        "alias": "寝具及类似填充用品",
                                        "about": "指以各种纺织材料作为面料（不论是否包面），用丝棉、化纤棉、兽毛等填充的棉被、枕头、靠垫、座垫等寝具及类似用品。包括羽绒（毛）、兽毛制寝具及类似填充制品、棉制寝具及类似填充制品、丝制寝具及类似填充制品、其他寝具及类似填充用品",
                                        "kws": "羽绒被、羽绒睡袋、羽毛睡袋、羽绒枕头、绒毛靠垫、羽毛靠垫、羊毛被、棉被、化纤棉制睡袋、化纤棉枕头、化纤棉靠垫、座垫、蚕丝被、丝制睡袋、丝制枕头、丝制靠垫",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040105070000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*寝具及类似填充用品",
                                        "children": []
                                    },
                                    {
                                        "id": "647",
                                        "linkid": "639",
                                        "code": "104010508",
                                        "paCode": "1040105",
                                        "yn": "N",
                                        "title": "毛巾被",
                                        "alias": "毛巾被",
                                        "about": "包括棉制毛巾被、化纤制毛巾被、麻制毛巾被、丝及绢丝制毛巾被，花式品种分单色、多色、条格、印花、喷花、提花毛巾被等",
                                        "kws": "棉制单人毛巾被、棉制双人毛巾被、棉制儿童毛巾被、化纤制单人毛巾被、化纤制双人毛巾被、化纤制儿童毛巾被、麻制单人毛巾被、麻制双人毛巾被、麻制儿童毛巾被、丝制毛巾被、绢丝制毛巾被",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040105080000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*毛巾被",
                                        "children": []
                                    },
                                    {
                                        "id": "648",
                                        "linkid": "639",
                                        "code": "104010509",
                                        "paCode": "1040105",
                                        "yn": "N",
                                        "title": "枕巾",
                                        "alias": "枕巾",
                                        "about": "包括棉制枕巾、化纤制枕巾、麻制枕巾、丝制枕巾、其他枕巾",
                                        "kws": "棉制枕巾、化纤制枕巾、麻制枕巾、丝制枕巾",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040105090000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*枕巾",
                                        "children": []
                                    },
                                    {
                                        "id": "649",
                                        "linkid": "639",
                                        "code": "104010599",
                                        "paCode": "1040105",
                                        "yn": "N",
                                        "title": "其他床上用织物制品",
                                        "alias": "其他床上用织物制品",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040105990000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*其他床上用织物制品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "650",
                                "linkid": "608",
                                "code": "1040106",
                                "paCode": "10401",
                                "yn": "Y",
                                "title": "日用织物制品",
                                "alias": "日用织物制品",
                                "about": "指餐桌、盥洗及厨房用织物制品，装饰织物制品、地毯和挂毯，包括台布（桌布）、毛巾、餐桌、盥洗及厨房用织物制品",
                                "kws": "台布、桌布、毛巾、餐桌、盥洗用织物制品、厨房用织物制品",
                                "taxName": "纺织产品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1040106000000000000",
                                "taxCodeTitle": "纺织产品",
                                "iTitle": "*纺织产品*日用织物制品",
                                "children": [
                                    {
                                        "id": "651",
                                        "linkid": "650",
                                        "code": "104010601",
                                        "paCode": "1040106",
                                        "yn": "N",
                                        "title": "台布（桌布）",
                                        "alias": "桌布",
                                        "about": "包括棉制台布、化学纤维制台布、毛制台布、丝制台布、麻制台布、其他纺织材料制台布。不包括针织或钩编台布（详见104011303）。",
                                        "kws": "台布、桌布、棉制刺绣台布、化学纤维制刺绣台布、毛制台布、丝制餐桌用织物制品、亚麻制刺绣餐桌用织物制品",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040106010000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*台布（桌布）",
                                        "children": []
                                    },
                                    {
                                        "id": "652",
                                        "linkid": "650",
                                        "code": "104010602",
                                        "paCode": "1040106",
                                        "yn": "N",
                                        "title": "毛巾",
                                        "alias": "毛巾",
                                        "about": "包括面巾、方巾、浴巾、其他毛巾",
                                        "kws": "棉制面巾、化纤制面巾、丝制面巾、棉制方巾、化纤制方巾、丝制方巾、棉制浴巾、化纤制浴巾、丝制浴巾",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040106020000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*毛巾",
                                        "children": []
                                    },
                                    {
                                        "id": "653",
                                        "linkid": "650",
                                        "code": "104010603",
                                        "paCode": "1040106",
                                        "yn": "N",
                                        "title": "餐桌、盥洗及厨房用织物制品",
                                        "alias": "餐桌厨房用织物制品",
                                        "about": "包括棉制餐桌、盥洗织物制品、化学纤维制餐桌、盥洗织物制品、亚麻制餐桌、盥洗用织物制品、丝制盥洗及厨房织物制品、其他餐桌、盥洗及厨房用织物制品。不包括针织或钩编相关餐桌用制品（详见104011304）。",
                                        "kws": "餐桌用棉制刺绣织物制品、盥洗用棉制织物制品、厨房用棉制织物制品、餐桌用化纤制刺绣织物制品、盥洗用化学纤维制织物制品、厨房用化学纤维制织物制品、餐桌用亚麻制刺绣织物制品、盥洗用亚麻制织物制品、厨房用亚麻制织物制品、丝制盥洗织物制品、丝制厨房织物制品",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040106030000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*餐桌、盥洗及厨房用织物制品",
                                        "children": []
                                    },
                                    {
                                        "id": "654",
                                        "linkid": "650",
                                        "code": "104010604",
                                        "paCode": "1040106",
                                        "yn": "N",
                                        "title": "窗帘及类似品",
                                        "alias": "窗帘及类似品",
                                        "about": "包括棉制窗帘及类似品、合成纤维制窗帘及类似品、丝制非针织非钩编窗帘、毛制窗帘及类似品、其他纺织材料制窗帘及类似品。不包括针织或钩编窗帘及类似品（详见104011305）。",
                                        "kws": "棉制窗帘、棉制帐幔、棉制帘帷、棉制床帷、合成纤维制窗帘、合成纤维制帐幔、合成纤维制帘帷、丝制非针织非钩编窗帘、毛制窗帘",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040106040000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*窗帘及类似品",
                                        "children": []
                                    },
                                    {
                                        "id": "655",
                                        "linkid": "650",
                                        "code": "104010605",
                                        "paCode": "1040106",
                                        "yn": "N",
                                        "title": "垫子套",
                                        "alias": "垫子套",
                                        "about": "包括棉制垫子套、丝制垫子套、合成纤维制垫子套、其他垫子套。不包括针织或钩编制品（详见1040113）。",
                                        "kws": "棉制刺绣垫子、丝制刺绣垫子套、合成纤维制垫子套",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040106050000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*垫子套",
                                        "children": []
                                    },
                                    {
                                        "id": "656",
                                        "linkid": "650",
                                        "code": "104010606",
                                        "paCode": "1040106",
                                        "yn": "N",
                                        "title": "安全用织物制品",
                                        "alias": "安全用织物制品",
                                        "about": "救生衣、安全带、其他安全用织物制品",
                                        "kws": "救生衣、安全带",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040106060000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*安全用织物制品",
                                        "children": []
                                    },
                                    {
                                        "id": "657",
                                        "linkid": "650",
                                        "code": "104010699",
                                        "paCode": "1040106",
                                        "yn": "N",
                                        "title": "其他纺织制品",
                                        "alias": "其他纺织制品",
                                        "about": "包括擦地布、抹布及类似擦拭用布、其他未列明纺织制品",
                                        "kws": "擦地布、抹布、擦拭用布",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040106990000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*其他纺织制品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "658",
                                "linkid": "608",
                                "code": "1040107",
                                "paCode": "10401",
                                "yn": "Y",
                                "title": "毡呢、包装用织物制品",
                                "alias": "毡呢、包装用织物制品",
                                "about": "包括毡呢、包装用织物制品",
                                "kws": "毡呢、包装用织物制品",
                                "taxName": "纺织产品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1040107000000000000",
                                "taxCodeTitle": "纺织产品",
                                "iTitle": "*纺织产品*毡呢、包装用织物制品",
                                "children": [
                                    {
                                        "id": "659",
                                        "linkid": "658",
                                        "code": "104010701",
                                        "paCode": "1040107",
                                        "yn": "N",
                                        "title": "毡呢",
                                        "alias": "毡呢",
                                        "about": "包括毛制毡呢、其他毡呢，不论是否浸渍、涂布、包覆或层压",
                                        "kws": "毛制毡呢",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040107010000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*毡呢",
                                        "children": []
                                    },
                                    {
                                        "id": "660",
                                        "linkid": "658",
                                        "code": "104010702",
                                        "paCode": "1040107",
                                        "yn": "N",
                                        "title": "包装用织物制品",
                                        "alias": "包装用织物制品",
                                        "about": "指主要包括散装货物的棉及化学纤维材料制，具有不同尺寸及形状的物品储运袋；也包括邮袋和邮寄货样用的小袋子，以及袋泡茶袋，包括棉制包装袋、化学纤维制包装袋、麻袋",
                                        "kws": "棉制包装袋、化学纤维制包装袋",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040107020000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*包装用织物制品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "661",
                                "linkid": "608",
                                "code": "1040108",
                                "paCode": "10401",
                                "yn": "Y",
                                "title": "油苫布、天篷、遮阳篷及类似品",
                                "alias": "油苫布、天篷、遮阳篷及类似品",
                                "about": "包括油苫布、天篷、遮阳篷、帐篷、篷房、风帆、充气褥垫、野营用织物制品、降落伞、旗帜及类似品",
                                "kws": null,
                                "taxName": "纺织产品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1040108000000000000",
                                "taxCodeTitle": "纺织产品",
                                "iTitle": "*纺织产品*油苫布、天篷、遮阳篷及类似品",
                                "children": [
                                    {
                                        "id": "662",
                                        "linkid": "661",
                                        "code": "104010801",
                                        "paCode": "1040108",
                                        "yn": "N",
                                        "title": "油苫布",
                                        "alias": "油苫布",
                                        "about": "包括棉制油苫布、合成纤维制油苫布、其他油苫布",
                                        "kws": "棉制油苫布、合成纤维制油苫布",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040108010000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*油苫布",
                                        "children": []
                                    },
                                    {
                                        "id": "663",
                                        "linkid": "661",
                                        "code": "104010802",
                                        "paCode": "1040108",
                                        "yn": "N",
                                        "title": "天篷",
                                        "alias": "天篷",
                                        "about": "包括棉制天篷、合成纤维制天篷、其他天篷",
                                        "kws": "天篷、棉制天篷、合成纤维制天篷",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040108020000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*天篷",
                                        "children": []
                                    },
                                    {
                                        "id": "664",
                                        "linkid": "661",
                                        "code": "104010803",
                                        "paCode": "1040108",
                                        "yn": "N",
                                        "title": "遮阳篷",
                                        "alias": "遮阳篷",
                                        "about": "包括棉制遮阳篷、合成纤维制遮阳篷、其他遮阳篷",
                                        "kws": "遮阳篷、棉制曲臂遮阳篷、棉制直臂遮阳篷、棉制伸缩遮阳篷、棉制折叠遮阳篷、合成纤维制曲臂遮阳篷、合成纤维制直臂遮阳篷、合成纤维制伸缩臂遮阳篷、合成纤维制折叠遮阳篷",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040108030000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*遮阳篷",
                                        "children": []
                                    },
                                    {
                                        "id": "665",
                                        "linkid": "661",
                                        "code": "104010804",
                                        "paCode": "1040108",
                                        "yn": "N",
                                        "title": "帐篷",
                                        "alias": "帐篷",
                                        "about": "包括棉制帐篷、合成纤维制帐篷、其他帐篷",
                                        "kws": "帐篷、棉制庭院帐篷、棉制野营帐篷、棉制车顶折叠帐篷、合成纤维制庭院帐篷、合成纤维制野营帐篷、合成纤维制车顶折叠帐篷",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040108040000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*帐篷",
                                        "children": []
                                    },
                                    {
                                        "id": "666",
                                        "linkid": "661",
                                        "code": "104010805",
                                        "paCode": "1040108",
                                        "yn": "N",
                                        "title": "篷房",
                                        "alias": "篷房",
                                        "about": "包括棉制篷房、合成纤维制篷房、其他篷房",
                                        "kws": "棉制篷房、合成纤维制篷房",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040108050000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*篷房",
                                        "children": []
                                    },
                                    {
                                        "id": "667",
                                        "linkid": "661",
                                        "code": "104010806",
                                        "paCode": "1040108",
                                        "yn": "N",
                                        "title": "风帆",
                                        "alias": "风帆",
                                        "about": "包括棉制风帆、合成纤维制风帆、其他风帆",
                                        "kws": "棉制风帆、合成纤维制风帆",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040108060000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*风帆",
                                        "children": []
                                    },
                                    {
                                        "id": "668",
                                        "linkid": "661",
                                        "code": "104010807",
                                        "paCode": "1040108",
                                        "yn": "N",
                                        "title": "充气褥垫",
                                        "alias": "充气褥垫",
                                        "about": "包括棉制充气褥垫、化纤制充气褥垫、其他充气褥垫",
                                        "kws": "棉制充气褥垫、化纤制充气褥垫",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040108070000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*充气褥垫",
                                        "children": []
                                    },
                                    {
                                        "id": "669",
                                        "linkid": "661",
                                        "code": "104010808",
                                        "paCode": "1040108",
                                        "yn": "N",
                                        "title": "野营用织物制品",
                                        "alias": "野营用织物制品",
                                        "about": "包括棉制野营用织物制品、化纤制野营用织物制品、其他野营用织物制品。不包括背包、背囊及类似容器（详见104030302），装有衬垫的睡袋及填充褥垫、枕头及座垫等（详见104010507），野营用帐篷（详见104010804）。",
                                        "kws": "棉制野营用吊床、化纤制野营用吊床",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040108080000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*野营用织物制品",
                                        "children": []
                                    },
                                    {
                                        "id": "670",
                                        "linkid": "661",
                                        "code": "104010809",
                                        "paCode": "1040108",
                                        "yn": "N",
                                        "title": "降落伞、旗帜及类似品",
                                        "alias": "降落伞、旗帜及类似品",
                                        "about": "包括旋翼降落伞及其零件、附件、锦旗、三角旗、横幅及其他娱乐或节日用旗布",
                                        "kws": "降落伞、旗帜",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040108090000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*降落伞、旗帜及类似品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "671",
                                "linkid": "608",
                                "code": "1040109",
                                "paCode": "10401",
                                "yn": "Y",
                                "title": "纤维纺制线、绳、索、缆",
                                "alias": "纤维纺制线、绳、索、缆",
                                "about": "包括纤维纺制绳、缆、网类制品、吊装绳索具、绳梯类制品。",
                                "kws": "纤维纺制绳、缆、网类制品、吊装绳索具、绳梯类制品",
                                "taxName": "纺织产品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1040109000000000000",
                                "taxCodeTitle": "纺织产品",
                                "iTitle": "*纺织产品*纤维纺制线、绳、索、缆",
                                "children": [
                                    {
                                        "id": "672",
                                        "linkid": "671",
                                        "code": "104010901",
                                        "paCode": "1040109",
                                        "yn": "N",
                                        "title": "纤维纺制绳、缆",
                                        "alias": "纤维纺制绳、缆",
                                        "about": "包括麻纤维纺制绳、缆、合成纤维纺制绳、缆、龙舌兰类纤维纺制绳、缆、蕉麻等硬质（叶）纤维纺绳、缆、其他合成纤维纺制绳、缆",
                                        "kws": "黄麻纤维纺制绳、黄麻纤维纺制缆、大麻纤维纺制绳、聚乙烯纺制绳、聚乙烯纺制缆、聚丙烯纺制绳、聚丙烯纺制缆、龙舌兰类纤维纺制包扎用绳、蕉麻纤维纺绳、蕉麻纤维纺缆",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040109010000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*纤维纺制绳、缆",
                                        "children": []
                                    },
                                    {
                                        "id": "673",
                                        "linkid": "671",
                                        "code": "104010902",
                                        "paCode": "1040109",
                                        "yn": "N",
                                        "title": "网类制品",
                                        "alias": "网类制品",
                                        "about": "包括渔网、安全网、体育项目用网（兜）、网料、其他网类制品",
                                        "kws": "化纤制渔网、锦纶制安全网、维纶制安全网、涤纶制安全网、丙纶制安全网、聚乙烯制安全网、蚕丝制安全网、网球网、篮球网、乒乓球网、羽毛球网、化纤材料制网料",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040109020000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*网类制品",
                                        "children": []
                                    },
                                    {
                                        "id": "674",
                                        "linkid": "671",
                                        "code": "104010903",
                                        "paCode": "1040109",
                                        "yn": "N",
                                        "title": "吊装绳索具",
                                        "alias": "吊装绳索具",
                                        "about": "包括吊装绳、安全保险绳、吊带、汽车牵引带、石油管道专用带、其他吊装绳索具。不包括钢丝绳索具（详见108041201）。",
                                        "kws": "吊装绳、安全保险绳、吊带、汽车牵引带、石油管道专用带",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040109030000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*吊装绳索具",
                                        "children": []
                                    },
                                    {
                                        "id": "675",
                                        "linkid": "671",
                                        "code": "104010904",
                                        "paCode": "1040109",
                                        "yn": "N",
                                        "title": "绳梯类制品",
                                        "alias": "绳梯类制品",
                                        "about": "包括尼龙绳梯、其他绳梯类制品。不包括钢丝绳梯（详见108041299）。",
                                        "kws": "滑动尼龙软梯、带环尼龙绳梯",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040109040000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*绳梯类制品",
                                        "children": []
                                    },
                                    {
                                        "id": "676",
                                        "linkid": "671",
                                        "code": "104010999",
                                        "paCode": "1040109",
                                        "yn": "N",
                                        "title": "其他纤维纺制线、绳、索、缆",
                                        "alias": "其他纤维纺制线、绳、索、缆",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040109990000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*其他纤维纺制线、绳、索、缆",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "677",
                                "linkid": "608",
                                "code": "1040110",
                                "paCode": "10401",
                                "yn": "Y",
                                "title": "浸渍、涂布或包覆处理纺织物",
                                "alias": "浸渍、涂布或包覆处理纺织物",
                                "about": "包括帘子布、纺织材料制传输带、用塑料处理纺织物、涂胶或淀粉纺织物、涂焦油、蜡、沥青或类似产品纺织物、硬挺纺织物、狭幅机织物",
                                "kws": "帘子布、纺织材料制传输带、用塑料处理纺织物、涂胶纺织物、淀粉纺织物、涂焦油纺织物、涂蜡纺织物、涂沥青纺织物、硬挺纺织物、狭幅机织物",
                                "taxName": "纺织产品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1040110000000000000",
                                "taxCodeTitle": "纺织产品",
                                "iTitle": "*纺织产品*浸渍、涂布或包覆处理纺织物",
                                "children": [
                                    {
                                        "id": "678",
                                        "linkid": "677",
                                        "code": "104011001",
                                        "paCode": "1040110",
                                        "yn": "N",
                                        "title": "帘子布",
                                        "alias": "帘子布",
                                        "about": "包括聚酰胺高强力纱制帘子布、聚酯高强力纱制帘子布、粘胶纤维高强力纱制帘子布、其他帘子布",
                                        "kws": "帘子布、聚酰胺高强力纱制帘子布、聚酯高强力纱制帘子布、粘胶纤维高强力纱制帘子布",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040110010000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*帘子布",
                                        "children": []
                                    },
                                    {
                                        "id": "679",
                                        "linkid": "677",
                                        "code": "104011002",
                                        "paCode": "1040110",
                                        "yn": "N",
                                        "title": "纺织材料制传输带",
                                        "alias": "纺织材料制传输带",
                                        "about": "包括棉制传输带、化学纤维制传输带、毛制传输带、其他纺织材料制传输带",
                                        "kws": "纺织材料制传输带、棉制传输带、化学纤维制传输带、毛制传输带",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040110020000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*纺织材料制传输带",
                                        "children": []
                                    },
                                    {
                                        "id": "680",
                                        "linkid": "677",
                                        "code": "104011003",
                                        "paCode": "1040110",
                                        "yn": "N",
                                        "title": "用塑料处理纺织物",
                                        "alias": "用塑料处理纺织物",
                                        "about": "包括聚氯乙烯处理纺织物、聚氨基甲酸酯处理纺织物、其他塑料处理纺织物",
                                        "kws": "用塑料处理纺织物、聚氯乙烯处理绝缘布、聚氯乙烯处理绝缘带、聚氯乙烯处理人造革、聚氨基甲酸酯处理绝缘布、聚氨基甲酸酯处理绝缘带、聚氨基甲酸酯处理人造革",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040110030000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*用塑料处理纺织物",
                                        "children": []
                                    },
                                    {
                                        "id": "681",
                                        "linkid": "677",
                                        "code": "104011004",
                                        "paCode": "1040110",
                                        "yn": "N",
                                        "title": "涂胶或淀粉纺织物",
                                        "alias": "涂胶或淀粉纺织物",
                                        "about": "包括涂胶或淀粉棉织物、涂胶或淀粉化纤纺织物、涂胶或淀粉麻织物、其他涂胶或淀粉纺织物",
                                        "kws": "涂胶纺织物、淀粉纺织物、涂胶棉织物、淀粉棉织物、涂胶化纤纺织物、淀粉化纤纺织物、涂胶麻织物、淀粉麻织物",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040110040000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*涂胶或淀粉纺织物",
                                        "children": []
                                    },
                                    {
                                        "id": "682",
                                        "linkid": "677",
                                        "code": "104011005",
                                        "paCode": "1040110",
                                        "yn": "N",
                                        "title": "涂焦油、蜡、沥青或类似产品纺织物",
                                        "alias": "涂焦油、蜡、沥青或类似产品纺织物",
                                        "about": "指经浸渍、涂布或包覆处理的纺织物；包括涂焦油、蜡、沥青，或用天然树脂和樟脑、油或干性油作为基料的制剂涂布或浸渍的织物。包括涂焦油、蜡、沥青绝缘布或带、涂焦油、蜡、沥青舞台用画布、其他材料处理纺织物",
                                        "kws": "涂焦油纺织布、涂蜡纺织布、涂沥青纺织布、涂焦油绝缘布、涂蜡绝缘布、涂沥青绝缘布、涂焦油绝缘带、涂蜡绝缘带、涂沥青绝缘带、涂焦油舞台用画布、涂蜡舞台用画布、涂沥青舞台用画布",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040110050000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*涂焦油、蜡、沥青或类似产品纺织物",
                                        "children": []
                                    },
                                    {
                                        "id": "683",
                                        "linkid": "677",
                                        "code": "104011006",
                                        "paCode": "1040110",
                                        "yn": "N",
                                        "title": "硬挺纺织物",
                                        "alias": "硬挺纺织物",
                                        "about": "包括油画布、描图布、硬衬布及类似纺织物、其他硬挺纺织物",
                                        "kws": "硬挺纺织物、油画布、棉制描图布、麻制描图布、化纤制描图布、棉制硬衬布、麻制硬衬布、化纤制硬衬布",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040110060000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*硬挺纺织物",
                                        "children": []
                                    },
                                    {
                                        "id": "684",
                                        "linkid": "677",
                                        "code": "104011007",
                                        "paCode": "1040110",
                                        "yn": "N",
                                        "title": "狭幅机织物",
                                        "alias": "狭幅机织物",
                                        "about": "指幅宽不超过30厘米狭条织物（带子及带状织物），从宽幅经纬织物剪成的狭条，或压平宽度不超过30厘米的无缝管筒经纬织物。包括狭幅起绒、绳绒机织物、松紧带、其他狭幅机织物",
                                        "kws": "狭幅机织物、棉制狭幅起绒、麻制狭幅起绒、丝制狭幅起绒、绳绒机织物、松紧带",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040110070000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*狭幅机织物",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "685",
                                "linkid": "608",
                                "code": "1040111",
                                "paCode": "10401",
                                "yn": "Y",
                                "title": "无纺布及其制品",
                                "alias": "无纺布及其制品",
                                "about": "包括无纺布（无纺织物）、无纺织物制品",
                                "kws": null,
                                "taxName": "纺织产品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1040111000000000000",
                                "taxCodeTitle": "纺织产品",
                                "iTitle": "*纺织产品*无纺布及其制品",
                                "children": [
                                    {
                                        "id": "686",
                                        "linkid": "685",
                                        "code": "104011101",
                                        "paCode": "1040111",
                                        "yn": "N",
                                        "title": "无纺布（无纺织物）",
                                        "alias": "无纺布（无纺织物）",
                                        "about": "也称非织造布，指以化学纤维为基本原料（主要是涤纶、腈纶、维纶、丙纶、粘胶纤维，也可用棉、毛、麻天然纤维的下脚料或再生纤维以及高科技用的碳素纤维、硼素纤维等）经化学粘合、热熔粘合、针刺、水刺、缝编高频等工艺制作的产品。包括化学纤维长丝制非织造布（无纺织物）、短纤维制非织造布（无纺织物）、其他无纺织物制品",
                                        "kws": "无纺布、无纺织物、纺粘法非织造布、熔喷法非织造布、短纤维制非织造布、短纤维制无纺织物、针刺法非织造布、水刺法非织造布、热粘合法非织造布、化学粘合法非织造布、盖面纤维网、盖面纤维面网、婴儿尿布表层垫片、卫生巾表层垫片、衬里织物、液体过滤片、空气过滤片、填塞片、隔音片、土木工程用过滤片、土木工程用分隔片、无纺布袋",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040111010000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*无纺布（无纺织物）",
                                        "children": []
                                    },
                                    {
                                        "id": "687",
                                        "linkid": "685",
                                        "code": "104011102",
                                        "paCode": "1040111",
                                        "yn": "N",
                                        "title": "无纺织物制品",
                                        "alias": "无纺织物制品",
                                        "about": "除无纺布（详见104011101）以外的无纺织物制品。",
                                        "kws": "盖面纤维网、面网、婴儿尿布表层垫片、卫生巾表层垫片、衬里织物、液体过滤片、空气过滤片、填塞片、隔音片、土木工程用过滤片、土木工程用分隔片",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040111020000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*无纺织物制品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "688",
                                "linkid": "608",
                                "code": "1040112",
                                "paCode": "10401",
                                "yn": "Y",
                                "title": "针织、编织物",
                                "alias": "针织、编织物",
                                "about": null,
                                "kws": "针织物、编织物、针织起绒织物、钩编起绒织物、针织钩编织物、针织坯布、经编织物、纬编制物",
                                "taxName": "纺织产品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1040112000000000000",
                                "taxCodeTitle": "纺织产品",
                                "iTitle": "*纺织产品*针织、编织物",
                                "children": [
                                    {
                                        "id": "689",
                                        "linkid": "688",
                                        "code": "104011201",
                                        "paCode": "1040112",
                                        "yn": "N",
                                        "title": "经编织物",
                                        "alias": "经编织物",
                                        "about": "包括棉制经编、织物、合成纤维制经编织物、人造纤维制经编织物、毛制经编织物、丝及绢丝制经编织物、其他经编织物。不包括针织或钩编的起绒织物（详见1040112）、弹性或橡胶线≥5%的针织钩编织物（详见1040112）。",
                                        "kws": "经编织物、棉制未漂白经编织物、棉制漂白经编织物、棉制染色经编织物、棉制色织经编织物、棉制印花经编织物、合成纤维制未漂白经编织物、合成纤维制漂白经编织物、人造纤维制染色经编织物人造纤维制漂白经编织物合成纤维制染色经编织物、合成纤维制色织经编织物、合成纤维制印花经编织物、人造纤维制未漂白经编织物、人造纤维制色织经编织物、人造纤维制印花、毛制经编织物、丝及绢丝制经编织物",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040112010000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*经编织物",
                                        "children": []
                                    },
                                    {
                                        "id": "690",
                                        "linkid": "688",
                                        "code": "104011202",
                                        "paCode": "1040112",
                                        "yn": "N",
                                        "title": "纬编制物",
                                        "alias": "纬编制物",
                                        "about": "包括棉制纬编织物、合成纤维制纬编织物、人造纤维制纬编织物、毛制纬编织物、丝及绢丝制纬编织物、其他纬编织物",
                                        "kws": "棉制未漂白纬编织物、棉制漂白纬编织物、棉制染色纬编织物、棉制色织纬编织物、棉制印花纬编织物、合成纤维制未漂白纬编织物、合成纤维制漂白纬编织物、合成纤维制染色纬、合成纤维制色织纬编织物、合成纤维制印花纬编织物、人造纤维制未漂白纬编织物、人造纤维制漂白纬编织物、人造纤维制染色纬编织物、人造纤维制色织纬编织物、人造纤维制印花纬编织物、毛制纬编织物、丝及绢丝制纬编织物",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040112020000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*纬编制物",
                                        "children": []
                                    },
                                    {
                                        "id": "691",
                                        "linkid": "688",
                                        "code": "104011203",
                                        "paCode": "1040112",
                                        "yn": "N",
                                        "title": "针织或钩编起绒织物",
                                        "alias": "针织或钩编起绒织物",
                                        "about": "包括棉针织钩编物、合成纤维针织钩编物、丝针织钩编物",
                                        "kws": "针织长毛绒织物、针织毛圈绒头织物、针织起绒织物",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040112030000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*针织或钩编起绒织物",
                                        "children": []
                                    },
                                    {
                                        "id": "692",
                                        "linkid": "688",
                                        "code": "104011204",
                                        "paCode": "1040112",
                                        "yn": "N",
                                        "title": "针织钩编织物（针织坯布）",
                                        "alias": "针织钩编织物（针织坯布）",
                                        "about": "包括合成纤维针织钩编物、毛针织钩编织物、人造纤维针织钩编物、丝针织钩编物",
                                        "kws": "弹性或橡胶线≥5%的棉针织钩编物、弹性或橡胶线≥5%的合成纤维针织钩编物、弹性或橡胶线≥5%的毛针织钩编织物、弹性或橡胶线≥5%的人造纤维针织钩编物、弹性丝针织钩编物、橡胶线≥5%的丝针织钩编物",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040112040000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*针织钩编织物（针织坯布）",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "693",
                                "linkid": "608",
                                "code": "1040113",
                                "paCode": "10401",
                                "yn": "Y",
                                "title": "针织、编织制品",
                                "alias": "针织、编织制品",
                                "about": null,
                                "kws": "针织床罩、钩编床罩、针织相关床上制品、钩编相关床上制品、针织台布、钩编台布、针织相关餐桌用制品、钩编相关餐桌用制品、针织窗帘、钩编窗帘、针织袜、针织手套",
                                "taxName": "纺织产品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1040113000000000000",
                                "taxCodeTitle": "纺织产品",
                                "iTitle": "*纺织产品*针织、编织制品",
                                "children": [
                                    {
                                        "id": "694",
                                        "linkid": "693",
                                        "code": "104011301",
                                        "paCode": "1040113",
                                        "yn": "N",
                                        "title": "针织或钩编床罩",
                                        "alias": "针织或钩编床罩",
                                        "about": "包括针织床罩、钩编床罩",
                                        "kws": "针织床罩、钩编床罩、手工针织床罩、非手工针织床罩、手工钩编床罩、非手工钩编床罩",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040113010000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*针织或钩编床罩",
                                        "children": []
                                    },
                                    {
                                        "id": "695",
                                        "linkid": "693",
                                        "code": "104011302",
                                        "paCode": "1040113",
                                        "yn": "N",
                                        "title": "针织或钩编相关床上制品",
                                        "alias": "针织或钩编相关床上制品",
                                        "about": "包括棉针织床上用织物制品、化纤针织床上用织物制品、丝制针织床上用织物制品、麻针织床上用织物制品、其他针织或钩编相关床上制品",
                                        "kws": "针织相关床上制品、钩编相关床上制品、棉针织枕套、化纤针织枕套、丝制针织床上用织物制品、麻针织凉席",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040113020000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*针织或钩编相关床上制品",
                                        "children": []
                                    },
                                    {
                                        "id": "696",
                                        "linkid": "693",
                                        "code": "104011303",
                                        "paCode": "1040113",
                                        "yn": "N",
                                        "title": "针织或钩编台布",
                                        "alias": "针织或钩编台布",
                                        "about": "包括针织台布、钩编台布",
                                        "kws": "针织台布、钩编台布、手工针织台布、非手工针织台布、手工钩编台布、非手工钩编台布",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040113030000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*针织或钩编台布",
                                        "children": []
                                    },
                                    {
                                        "id": "697",
                                        "linkid": "693",
                                        "code": "104011304",
                                        "paCode": "1040113",
                                        "yn": "N",
                                        "title": "针织或钩编相关餐桌用制品",
                                        "alias": "针织或钩编相关餐桌用制品",
                                        "about": "包括针织相关餐桌用制品、钩编相关餐桌用制品",
                                        "kws": "针织相关餐桌用制品、钩编相关餐桌用制品、手工针织餐桌用织物制品、非手工针织餐桌用织物制品、手工钩编餐桌用织物制品、非手工钩编餐桌用织物制品",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040113040000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*针织或钩编相关餐桌用制品",
                                        "children": []
                                    },
                                    {
                                        "id": "698",
                                        "linkid": "693",
                                        "code": "104011305",
                                        "paCode": "1040113",
                                        "yn": "N",
                                        "title": "针织或钩编窗帘及类似品",
                                        "alias": "针织或钩编窗帘及类似品",
                                        "about": "包括棉针织或钩编窗帘及类似品、合成纤维针织或钩编窗帘及类似品、其他针织或钩编窗帘及类似品",
                                        "kws": "针织窗帘、钩编窗帘、棉针织窗帘、棉钩编窗帘、合成纤维针织窗帘、合成纤维钩编窗帘",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040113050000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*针织或钩编窗帘及类似品",
                                        "children": []
                                    },
                                    {
                                        "id": "699",
                                        "linkid": "693",
                                        "code": "104011306",
                                        "paCode": "1040113",
                                        "yn": "N",
                                        "title": "针织袜",
                                        "alias": "针织袜",
                                        "about": "包括连裤及紧身裤袜、长统袜及中统袜、短针织袜",
                                        "kws": "针织袜、棉制连裤、棉制紧身袜、合成纤维制连裤、合成纤维制紧身袜、毛针织连裤、毛针织连裤袜、丝制连裤、丝制紧身袜、棉制长统袜、棉制中统袜、合成纤维制长统袜、合成纤维制中统袜、毛针织长统袜、毛针织中统袜、丝制长统袜、丝制中统袜、棉制短袜、合成纤维制短袜、毛针织短袜、麻针织短袜、丝针织短袜",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040113060000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*针织袜",
                                        "children": []
                                    },
                                    {
                                        "id": "700",
                                        "linkid": "693",
                                        "code": "104011307",
                                        "paCode": "1040113",
                                        "yn": "N",
                                        "title": "针织手套",
                                        "alias": "针织手套",
                                        "about": "包括棉制针织手套、合成纤维制针织手套、毛针织手套、丝制针织手套",
                                        "kws": "针织手套、未浸涂棉针织手套、经浸涂棉针织手套、未浸涂合成纤维针织手套、经浸涂合成纤维针织手套、未浸涂毛针织手套、经浸涂毛针织手套、丝制针织手套",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040113070000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*针织手套",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "701",
                                "linkid": "608",
                                "code": "1040114",
                                "paCode": "10401",
                                "yn": "Y",
                                "title": "围巾、领带、手帕",
                                "alias": "围巾、领带、手帕",
                                "about": "包括围巾类、领带、手帕",
                                "kws": "围巾类、领带、手帕",
                                "taxName": "纺织产品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1040114000000000000",
                                "taxCodeTitle": "纺织产品",
                                "iTitle": "*纺织产品*围巾、领带、手帕",
                                "children": [
                                    {
                                        "id": "702",
                                        "linkid": "701",
                                        "code": "104011401",
                                        "paCode": "1040114",
                                        "yn": "N",
                                        "title": "围巾类",
                                        "alias": "围巾类",
                                        "about": "包括针织围巾、钩编围巾、非针织或钩编围巾类",
                                        "kws": "围巾、羊绒针织围巾、羊毛针织围巾、丝针织围巾、合成纤维长丝针织围巾、毛钩编围巾、丝钩编围巾、合成纤维长丝钩编围巾、非针织丝制围巾、羊绒机织围巾、羊毛机织围巾、合成纤维制围巾类、人造纤维制围巾类",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040114010000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*围巾类",
                                        "children": []
                                    },
                                    {
                                        "id": "703",
                                        "linkid": "701",
                                        "code": "104011402",
                                        "paCode": "1040114",
                                        "yn": "N",
                                        "title": "领带",
                                        "alias": "领带",
                                        "about": "包括针织领带、非针织领带",
                                        "kws": "领带、丝针织领带、毛针织领带、丝制领带、化纤制领带",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040114020000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*领带",
                                        "children": []
                                    },
                                    {
                                        "id": "704",
                                        "linkid": "701",
                                        "code": "104011403",
                                        "paCode": "1040114",
                                        "yn": "N",
                                        "title": "手帕",
                                        "alias": "手帕",
                                        "about": "包括丝制手帕、棉制手帕、化纤制手帕",
                                        "kws": "手帕、丝制刺绣手帕、棉制刺绣手帕、化纤制刺绣手帕",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040114030000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*手帕",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "705",
                                "linkid": "608",
                                "code": "1040199",
                                "paCode": "10401",
                                "yn": "Y",
                                "title": "其他纺织产品",
                                "alias": "其他纺织产品",
                                "about": "指纺织材料制其他织物制品，包括纺织材料絮胎及其制品、纺织材料制标签、徽章及类似品、成匹编带、装饰带及类似品、网眼薄纱，相关网眼织物、图案花边、供技术用途纺织品",
                                "kws": "纺织材料絮胎、纺织材料制标签、徽章、成匹编带、装饰带、网眼薄纱、相关网眼织物、图案花边、供技术用途纺织品",
                                "taxName": "纺织产品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1040199000000000000",
                                "taxCodeTitle": "纺织产品",
                                "iTitle": "*纺织产品*其他纺织产品",
                                "children": [
                                    {
                                        "id": "706",
                                        "linkid": "705",
                                        "code": "104019901",
                                        "paCode": "1040199",
                                        "yn": "N",
                                        "title": "纺织材料絮胎及其制品",
                                        "alias": "纺织材料絮胎及其制品",
                                        "about": "包括纺织材料絮胎制卫生用品、纤维制絮胎及其制品",
                                        "kws": "纺织材料絮胎、絮胎制卫生巾、絮胎制止血塞、絮胎制尿布、棉制絮胎、棉制絮胎制品、化纤制絮胎、化纤制絮胎制品",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040199010000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*纺织材料絮胎及其制品",
                                        "children": []
                                    },
                                    {
                                        "id": "707",
                                        "linkid": "705",
                                        "code": "104019902",
                                        "paCode": "1040199",
                                        "yn": "N",
                                        "title": "纺织材料制标签、徽章及类似品",
                                        "alias": "纺织材料制标签、徽章及类似品",
                                        "about": "指非绣制的纺织材料制标签、徽章及类似品，包括机织标签、徽章及类似品、非机织标签、徽章及类似品",
                                        "kws": "纺织材料制标签、纺织材料制徽章、机织标签、机织徽章、非机织标签、非机织徽章",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040199020000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*纺织材料制标签、徽章及类似品",
                                        "children": []
                                    },
                                    {
                                        "id": "708",
                                        "linkid": "705",
                                        "code": "104019903",
                                        "paCode": "1040199",
                                        "yn": "N",
                                        "title": "成匹编带、装饰带及类似品",
                                        "alias": "成匹编带、装饰带及类似品",
                                        "about": "包括成匹编带、流苏、绒球、其他成匹装饰带",
                                        "kws": "成匹装饰带、成匹编带、流苏、绒球",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040199030000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*成匹编带、装饰带及类似品",
                                        "children": []
                                    },
                                    {
                                        "id": "709",
                                        "linkid": "705",
                                        "code": "104019904",
                                        "paCode": "1040199",
                                        "yn": "N",
                                        "title": "网眼薄纱，相关网眼织物",
                                        "alias": "网眼薄纱，相关网眼织物",
                                        "about": "丝及绢丝制网眼薄纱，相关网眼织物、棉制网眼薄纱，相关网眼织物、化纤制网眼薄纱，相关网眼织物、其他网眼薄纱及网眼织物",
                                        "kws": "网眼薄纱、丝制网眼薄纱、绢丝制网眼薄纱、网眼织物、棉制网眼薄纱、相关网眼织物、化纤制网眼薄纱",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040199040000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*网眼薄纱，相关网眼织物",
                                        "children": []
                                    },
                                    {
                                        "id": "710",
                                        "linkid": "705",
                                        "code": "104019905",
                                        "paCode": "1040199",
                                        "yn": "N",
                                        "title": "图案花边",
                                        "alias": "图案花边",
                                        "about": "包括机制花边、手工制花边",
                                        "kws": "图案花边、化纤制机制花边、丝及绢丝制机制花边、棉制机制花边、手工制花边",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040199050000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*图案花边",
                                        "children": []
                                    },
                                    {
                                        "id": "711",
                                        "linkid": "705",
                                        "code": "104019906",
                                        "paCode": "1040199",
                                        "yn": "N",
                                        "title": "供技术用途纺织品",
                                        "alias": "供技术用途纺织品",
                                        "about": "包括纺织材料包覆橡胶线、橡塑浸涂纺织纱线及类似品、含金属纱线、纺织材料制软管、筛布、滤布、机械用联接物织物、纸纱线机织物",
                                        "kws": "供技术用途纺织品、纺织材料包覆橡胶线、橡塑浸涂纺织纱线、含金属纱线、纺织材料制软管、筛布、滤布、机械用联接物织物、纸纱线机织物",
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040199060000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*供技术用途纺织品",
                                        "children": []
                                    },
                                    {
                                        "id": "712",
                                        "linkid": "705",
                                        "code": "104019999",
                                        "paCode": "1040199",
                                        "yn": "N",
                                        "title": "其他未列明纺织产品",
                                        "alias": "其他未列明纺织产品",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "纺织产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040199990000000000",
                                        "taxCodeTitle": "纺织产品",
                                        "iTitle": "*纺织产品*其他未列明纺织产品",
                                        "children": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "id": "713",
                        "linkid": "607",
                        "code": "10402",
                        "paCode": "104",
                        "yn": "Y",
                        "title": "服装、鞋、帽",
                        "alias": "服装鞋帽",
                        "about": null,
                        "kws": null,
                        "taxName": "服装鞋帽",
                        "taxRate": "",
                        "vip": "3",
                        "itaxRate": null,
                        "taxCode": "1040200000000000000",
                        "taxCodeTitle": "服装鞋帽",
                        "iTitle": "*服装鞋帽*服装、鞋、帽",
                        "children": [
                            {
                                "id": "714",
                                "linkid": "713",
                                "code": "1040201",
                                "paCode": "10402",
                                "yn": "Y",
                                "title": "服装",
                                "alias": "服装",
                                "about": "包括针织服装、梭织服装、皮革服装、毛皮服装及其附件",
                                "kws": null,
                                "taxName": "服装",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1040201000000000000",
                                "taxCodeTitle": "服装",
                                "iTitle": "*服装*服装",
                                "children": [
                                    {
                                        "id": "715",
                                        "linkid": "714",
                                        "code": "104020101",
                                        "paCode": "1040201",
                                        "yn": "N",
                                        "title": "女内衣",
                                        "alias": "女内衣",
                                        "about": "包括针织女内衣、胸罩（乳罩）、束腰带及腹带、紧身胸衣、吊裤带及类似品",
                                        "kws": "女内衣、棉针织内衣、化学纤维针织内衣、化纤制胸罩、棉制胸罩、丝制胸罩、化纤制束腰带、化纤制束腹带、化纤制紧身胸衣、胸罩、束腰带",
                                        "taxName": "服装",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040201010000000000",
                                        "taxCodeTitle": "服装",
                                        "iTitle": "*服装*女内衣",
                                        "children": []
                                    },
                                    {
                                        "id": "716",
                                        "linkid": "714",
                                        "code": "104020102",
                                        "paCode": "1040201",
                                        "yn": "N",
                                        "title": "男内衣",
                                        "alias": "男内衣",
                                        "about": "包括针织男内衣",
                                        "kws": "男内衣、棉针织内衣、化学纤维针织内衣",
                                        "taxName": "服装",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040201020000000000",
                                        "taxCodeTitle": "服装",
                                        "iTitle": "*服装*男内衣",
                                        "children": []
                                    },
                                    {
                                        "id": "717",
                                        "linkid": "714",
                                        "code": "104020103",
                                        "paCode": "1040201",
                                        "yn": "N",
                                        "title": "女睡衣",
                                        "alias": "女睡衣",
                                        "about": "包括女式针织睡衣裤、女式梭织睡衣裤、棉制女式睡衣裤、化纤制女式睡衣裤、丝制女式睡衣裤、其他女式睡衣裤",
                                        "kws": "女睡衣、女式针织睡衣裤、女式梭织睡衣裤、棉制女式睡衣裤、化纤制女式睡衣裤、丝制女式睡衣裤",
                                        "taxName": "服装",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040201030000000000",
                                        "taxCodeTitle": "服装",
                                        "iTitle": "*服装*女睡衣",
                                        "children": []
                                    },
                                    {
                                        "id": "718",
                                        "linkid": "714",
                                        "code": "104020104",
                                        "paCode": "1040201",
                                        "yn": "N",
                                        "title": "男睡衣",
                                        "alias": "男睡衣",
                                        "about": "包括男式针织睡衣裤、男式梭织睡衣裤、棉制男式睡衣裤、化纤制男式睡衣裤、丝制男式睡衣裤、其他男式睡衣裤",
                                        "kws": "男睡衣、男式针织睡衣裤、男式梭织睡衣裤、棉制男式睡衣裤、化纤制男式睡衣裤、丝制男式睡衣裤",
                                        "taxName": "服装",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040201040000000000",
                                        "taxCodeTitle": "服装",
                                        "iTitle": "*服装*男睡衣",
                                        "children": []
                                    },
                                    {
                                        "id": "719",
                                        "linkid": "714",
                                        "code": "104020105",
                                        "paCode": "1040201",
                                        "yn": "N",
                                        "title": "女浴衣",
                                        "alias": "女浴衣",
                                        "about": "包括女式针织浴衣及类似服装、女式梭织浴衣及类似服装、棉制女浴衣及类似品、化纤制女浴衣及类似品、丝制女浴衣及类似品、其他女浴衣及类似品",
                                        "kws": "女浴衣、女式针织浴衣、女式梭织浴衣、棉制女浴衣、化纤制女浴衣、丝制女浴衣",
                                        "taxName": "服装",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040201050000000000",
                                        "taxCodeTitle": "服装",
                                        "iTitle": "*服装*女浴衣",
                                        "children": []
                                    },
                                    {
                                        "id": "720",
                                        "linkid": "714",
                                        "code": "104020106",
                                        "paCode": "1040201",
                                        "yn": "N",
                                        "title": "男浴衣",
                                        "alias": "男浴衣",
                                        "about": "包括男式针织浴衣及类似服装、男式梭织浴衣及类似服装、棉制男浴衣及类似品、化纤制男浴衣及类似品、丝制男浴衣及类似品、其他男浴衣及类似品",
                                        "kws": "男浴衣、男式针织浴衣、男式梭织浴衣、棉制男浴衣、化纤制男浴衣、丝制男浴衣",
                                        "taxName": "服装",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040201060000000000",
                                        "taxCodeTitle": "服装",
                                        "iTitle": "*服装*男浴衣",
                                        "children": []
                                    },
                                    {
                                        "id": "721",
                                        "linkid": "714",
                                        "code": "104020107",
                                        "paCode": "1040201",
                                        "yn": "N",
                                        "title": "女衬衫",
                                        "alias": "女衬衫",
                                        "about": "包括针织女衬衫、梭织女衬衫、毛制女衬衫、棉制女衬衫、化纤制女衬衫、丝制女衬衫、其他女衬衫",
                                        "kws": "女衬衫、针织女衬衫、梭织女衬衫、毛制女衬衫、棉制女衬衫、化纤制女衬衫、丝制女衬衫",
                                        "taxName": "服装",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040201070000000000",
                                        "taxCodeTitle": "服装",
                                        "iTitle": "*服装*女衬衫",
                                        "children": []
                                    },
                                    {
                                        "id": "722",
                                        "linkid": "714",
                                        "code": "104020108",
                                        "paCode": "1040201",
                                        "yn": "N",
                                        "title": "男衬衫",
                                        "alias": "男衬衫",
                                        "about": "包括毛制男衬衫、棉制男衬衫、化纤制男衬衫、丝制男衬衫（含丝或绢丝50%及以上）、其他男衬衫",
                                        "kws": "男衬衫、毛制男衬衫、棉制男衬衫、化纤制男衬衫、丝制男衬衫、其他男衬衫、针织",
                                        "taxName": "服装",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040201080000000000",
                                        "taxCodeTitle": "服装",
                                        "iTitle": "*服装*男衬衫",
                                        "children": []
                                    },
                                    {
                                        "id": "723",
                                        "linkid": "714",
                                        "code": "104020109",
                                        "paCode": "1040201",
                                        "yn": "N",
                                        "title": "女T恤衫",
                                        "alias": "女T恤衫",
                                        "about": "包括各类棉针织T恤衫、化学纤维针织T恤衫、丝针织T恤衫、其他针织T恤衫",
                                        "kws": "T恤衫",
                                        "taxName": "服装",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040201090000000000",
                                        "taxCodeTitle": "服装",
                                        "iTitle": "*服装*女T恤衫",
                                        "children": []
                                    },
                                    {
                                        "id": "724",
                                        "linkid": "714",
                                        "code": "104020110",
                                        "paCode": "1040201",
                                        "yn": "N",
                                        "title": "男T恤衫",
                                        "alias": "男T恤衫",
                                        "about": "包括各类棉针织T恤衫、化学纤维针织T恤衫、丝针织T恤衫、其他针织T恤衫",
                                        "kws": "T恤衫",
                                        "taxName": "服装",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040201100000000000",
                                        "taxCodeTitle": "服装",
                                        "iTitle": "*服装*男T恤衫",
                                        "children": []
                                    },
                                    {
                                        "id": "725",
                                        "linkid": "714",
                                        "code": "104020111",
                                        "paCode": "1040201",
                                        "yn": "N",
                                        "title": "女上衣",
                                        "alias": "女上衣",
                                        "about": "包括马甲、背心、坎肩、夹克，包括防风衣",
                                        "kws": "上衣、马甲、背心、坎肩、夹克、防风衣",
                                        "taxName": "服装",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040201110000000000",
                                        "taxCodeTitle": "服装",
                                        "iTitle": "*服装*女上衣",
                                        "children": []
                                    },
                                    {
                                        "id": "726",
                                        "linkid": "714",
                                        "code": "104020112",
                                        "paCode": "1040201",
                                        "yn": "N",
                                        "title": "男上衣",
                                        "alias": "男上衣",
                                        "about": "包括马甲、背心、坎肩、夹克，包括防风衣",
                                        "kws": "上衣、马甲、背心、坎肩、夹克、防风衣",
                                        "taxName": "服装",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040201120000000000",
                                        "taxCodeTitle": "服装",
                                        "iTitle": "*服装*男上衣",
                                        "children": []
                                    },
                                    {
                                        "id": "727",
                                        "linkid": "714",
                                        "code": "104020113",
                                        "paCode": "1040201",
                                        "yn": "N",
                                        "title": "女裤子",
                                        "alias": "女裤子",
                                        "about": "不包括内衣裤（详见104020101、104020102）、睡衣裤（详见104020103、104020104）。",
                                        "kws": "裤、牛仔裤、棉裤、毛裤、丝裤、化纤裤、紧身裤、塑身裤、喇叭裤、小脚裤、直筒裤、短裤、沙滩裤、休闲裤、防风裤",
                                        "taxName": "服装",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040201130000000000",
                                        "taxCodeTitle": "服装",
                                        "iTitle": "*服装*女裤子",
                                        "children": []
                                    },
                                    {
                                        "id": "728",
                                        "linkid": "714",
                                        "code": "104020114",
                                        "paCode": "1040201",
                                        "yn": "N",
                                        "title": "男裤子",
                                        "alias": "男裤子",
                                        "about": "不包括内衣裤（详见104020101、104020102）、睡衣裤（详见104020103、104020104）。",
                                        "kws": "裤、牛仔裤、棉裤、毛裤、丝裤、化纤裤、紧身裤、塑身裤、喇叭裤、小脚裤、直筒裤、短裤、沙滩裤、休闲裤、防风裤",
                                        "taxName": "服装",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040201140000000000",
                                        "taxCodeTitle": "服装",
                                        "iTitle": "*服装*男裤子",
                                        "children": []
                                    },
                                    {
                                        "id": "729",
                                        "linkid": "714",
                                        "code": "104020115",
                                        "paCode": "1040201",
                                        "yn": "N",
                                        "title": "裙子",
                                        "alias": "裙子",
                                        "about": null,
                                        "kws": "连衣裙、裙裤、衬裙",
                                        "taxName": "服装",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040201150000000000",
                                        "taxCodeTitle": "服装",
                                        "iTitle": "*服装*裙子",
                                        "children": []
                                    },
                                    {
                                        "id": "730",
                                        "linkid": "714",
                                        "code": "104020116",
                                        "paCode": "1040201",
                                        "yn": "N",
                                        "title": "女大衣、女风衣",
                                        "alias": "女大衣女风衣",
                                        "about": "包括女式毛大衣。不包括羽绒服（详见104020122）。",
                                        "kws": "女大衣、女风衣、女毛大衣、大衣、风衣、毛大衣",
                                        "taxName": "服装",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040201160000000000",
                                        "taxCodeTitle": "服装",
                                        "iTitle": "*服装*女大衣、女风衣",
                                        "children": []
                                    },
                                    {
                                        "id": "731",
                                        "linkid": "714",
                                        "code": "104020117",
                                        "paCode": "1040201",
                                        "yn": "N",
                                        "title": "男大衣、男风衣",
                                        "alias": "男大衣男风衣",
                                        "about": "包括男式毛大衣。不包括羽绒服（详见104020122）。",
                                        "kws": "男大衣、男风衣、男毛大衣、大衣、风衣、毛大衣",
                                        "taxName": "服装",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040201170000000000",
                                        "taxCodeTitle": "服装",
                                        "iTitle": "*服装*男大衣、男风衣",
                                        "children": []
                                    },
                                    {
                                        "id": "732",
                                        "linkid": "714",
                                        "code": "104020118",
                                        "paCode": "1040201",
                                        "yn": "N",
                                        "title": "便服套装",
                                        "alias": "便服套装",
                                        "about": "指各种针织和非针织的男女便服套装，包括牛仔套装、休闲服套装、时装套装、中式套装、中山服套装、其他便服套装。不包括西服套装（详见104020119）、运动服装（详见104020123）。",
                                        "kws": "便服套装、男式便服套装、女式便服套装、针织便服套装、男式针织便服套装、女式针织便服套装、毛制男式便服套装、棉制男式便服套装、合成纤维制男式便服套装、丝制男式便服套装、毛制女式便服套装、棉制女式便服套装、合成纤维制女式便服套装、丝制女式便服套装、棉针织男式便服套装、合成纤维针织男式便服套装、丝纤维针织男式便服套装、棉针织女式便服套装、合成纤维针织女式便服套装、丝针织女式便服套装、丝钩编女式便服套装",
                                        "taxName": "服装",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040201180000000000",
                                        "taxCodeTitle": "服装",
                                        "iTitle": "*服装*便服套装",
                                        "children": []
                                    },
                                    {
                                        "id": "733",
                                        "linkid": "714",
                                        "code": "104020119",
                                        "paCode": "1040201",
                                        "yn": "N",
                                        "title": "西服套装",
                                        "alias": "西服套装",
                                        "about": "指各种针织和非针织的男女西服套装，包括套裙。。男西服套装包括上衣、裤子、西服背心（两件套、三件套、四件套），男晚礼服（燕尾服）、男无燕尾套装、夜礼服、西服套装背心，女式非针织西服套装包括上衣、背心、西服裙、裤子（两件套、三件套、四件套）。",
                                        "kws": "西服套装、男式西服套装、女式西服套装、女式西服套裙、针织西服套装、男式针织西服套装、女式针织西服套装、女式针织西服套裙、毛制男式西服套装、合成纤维制男式西服套装、丝制男式西服套装、毛制女式西服套装、棉制女式西服套装、合成纤维制女式西服套装、丝制女式西服套装、棉针织男式西服套装、合成纤维针织西服套装、丝制针织男式西服套装、钩编男式西服套装、棉针织女式西服套装、合成纤维针织女式西服套装、丝制针织女式西服套装、钩编女式西服套装",
                                        "taxName": "服装",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040201190000000000",
                                        "taxCodeTitle": "服装",
                                        "iTitle": "*服装*西服套装",
                                        "children": []
                                    },
                                    {
                                        "id": "734",
                                        "linkid": "714",
                                        "code": "104020120",
                                        "paCode": "1040201",
                                        "yn": "N",
                                        "title": "女毛衣",
                                        "alias": "女毛衣",
                                        "about": null,
                                        "kws": "女式毛衣",
                                        "taxName": "服装",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040201200000000000",
                                        "taxCodeTitle": "服装",
                                        "iTitle": "*服装*女毛衣",
                                        "children": []
                                    },
                                    {
                                        "id": "735",
                                        "linkid": "714",
                                        "code": "104020121",
                                        "paCode": "1040201",
                                        "yn": "N",
                                        "title": "男毛衣",
                                        "alias": "男毛衣",
                                        "about": null,
                                        "kws": "男式毛衣",
                                        "taxName": "服装",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040201210000000000",
                                        "taxCodeTitle": "服装",
                                        "iTitle": "*服装*男毛衣",
                                        "children": []
                                    },
                                    {
                                        "id": "736",
                                        "linkid": "714",
                                        "code": "104020122",
                                        "paCode": "1040201",
                                        "yn": "N",
                                        "title": "防寒服",
                                        "alias": "防寒服",
                                        "about": "指以羽绒、化纤棉、丝棉、棉花、鸵绒、羊绒絮片、人造毛皮、针织棉等为填充物或内胎制作的各式服装。",
                                        "kws": "羽绒服、防寒服",
                                        "taxName": "服装",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040201220000000000",
                                        "taxCodeTitle": "服装",
                                        "iTitle": "*服装*防寒服",
                                        "children": []
                                    },
                                    {
                                        "id": "737",
                                        "linkid": "714",
                                        "code": "104020123",
                                        "paCode": "1040201",
                                        "yn": "N",
                                        "title": "运动服装",
                                        "alias": "运动服装",
                                        "about": "包括田径服、击剑服、跆拳道服、滑雪服及游泳服、舞裙、体操或练功紧身衣、非针织的体操用特种服装等类似服装。不包括戏装（详见104020199）。",
                                        "kws": "运动服、滑雪服、游泳服、针织运动服、针织滑雪服、针织游泳服、棉针织运动服、合成纤维针织运动服、棉针织滑雪服、化学纤维针织滑雪服、男式针织游泳服、女式针织游泳服、男式运动服、女式运动服、棉制滑雪服、化纤制滑雪服、男式游泳服、女式游泳服",
                                        "taxName": "服装",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040201230000000000",
                                        "taxCodeTitle": "服装",
                                        "iTitle": "*服装*运动服装",
                                        "children": []
                                    },
                                    {
                                        "id": "738",
                                        "linkid": "714",
                                        "code": "104020124",
                                        "paCode": "1040201",
                                        "yn": "N",
                                        "title": "婴幼儿服装",
                                        "alias": "婴幼儿服装",
                                        "about": "指以各种服装材料制成的婴儿服装和儿童服装。包括儿童服装、婴儿紧身衣裤、连脚裤、游戏服、小丑服、背心连裤童装外衣、婴儿围涎、分指手套、连指手套、露指手套、紧身衣裤及婴儿连袜鞋、婴儿尿布。",
                                        "kws": "婴幼儿服装、婴儿服装、棉毛类棉针织婴儿服装、绒布类棉针织婴儿服装、单面布类棉针织婴儿服装、棉毛类合成纤维针织婴儿服装、绒布类合成纤维针织婴儿服装、单面布类合成纤维针织婴儿服装、毛针织婴儿服装、丝针织婴儿服装、棉制婴儿服装、合成纤维制婴儿服装、毛制婴儿服装、婴儿衣着附件、儿童服装",
                                        "taxName": "服装",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040201240000000000",
                                        "taxCodeTitle": "服装",
                                        "iTitle": "*服装*婴幼儿服装",
                                        "children": []
                                    },
                                    {
                                        "id": "739",
                                        "linkid": "714",
                                        "code": "104020125",
                                        "paCode": "1040201",
                                        "yn": "N",
                                        "title": "特种服装",
                                        "alias": "特种服装",
                                        "about": "指有特殊功能或特殊用途的服装，包括迷彩服、航天服、潜水服、阻燃服、均压服、防弹衣、防酸服、防火服、抗油拒水服、焊接防护服、防电弧服等。",
                                        "kws": "迷彩服、航天服、潜水服、阻燃服、均压服、防弹衣、防酸服、防火服、抗油拒水服、焊接防护服、防电弧服",
                                        "taxName": "服装",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040201250000000000",
                                        "taxCodeTitle": "服装",
                                        "iTitle": "*服装*特种服装",
                                        "children": []
                                    },
                                    {
                                        "id": "740",
                                        "linkid": "714",
                                        "code": "104020199",
                                        "paCode": "1040201",
                                        "yn": "N",
                                        "title": "其他服装",
                                        "alias": "其他服装",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "服装",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040201990000000000",
                                        "taxCodeTitle": "服装",
                                        "iTitle": "*服装*其他服装",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "741",
                                "linkid": "713",
                                "code": "1040202",
                                "paCode": "10402",
                                "yn": "Y",
                                "title": "皮革服装",
                                "alias": "皮革服装",
                                "about": null,
                                "kws": null,
                                "taxName": "服装",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1040202000000000000",
                                "taxCodeTitle": "服装",
                                "iTitle": "*服装*皮革服装",
                                "children": [
                                    {
                                        "id": "742",
                                        "linkid": "741",
                                        "code": "104020201",
                                        "paCode": "1040202",
                                        "yn": "N",
                                        "title": "天然皮革服装",
                                        "alias": "天然皮革服装",
                                        "about": "指用猪、牛、羊以及其他动物等天然皮革（包括头层和剖层革）制作的服装,包括天然皮革大衣、天然皮革上衣、天然皮革裤、天然皮革背心、其他天然皮革服装。",
                                        "kws": "天然皮革服装、天然皮革大衣、天然皮革上衣、天然皮革裤、天然皮革背心、羊皮革大衣、猪皮革大衣、牛皮革大衣、羊皮革上衣、猪皮革上衣、牛皮革上衣、羊皮革裤、猪皮革裤、牛皮革裤、羊皮革背心、猪皮革背心、牛皮革背心",
                                        "taxName": "服装",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040202010000000000",
                                        "taxCodeTitle": "服装",
                                        "iTitle": "*服装*天然皮革服装",
                                        "children": []
                                    },
                                    {
                                        "id": "743",
                                        "linkid": "741",
                                        "code": "104020202",
                                        "paCode": "1040202",
                                        "yn": "N",
                                        "title": "非天然皮革服装",
                                        "alias": "非天然皮革服装",
                                        "about": "指用人造革、合成革、再生革等非天然皮革制作的服装,包括非天然皮革大衣、非天然皮革上衣、非天然皮革裤、非天然皮革背心、其他非天然皮革服装。",
                                        "kws": "非天然皮革服装、合成革大衣、人造革大衣、再生皮革大衣、合成革上衣、人造革上衣、再生皮革上衣、合成革皮裤、人造革皮裤、再生皮革皮裤、合成革皮背心、人造革皮背心、再生皮革皮背心",
                                        "taxName": "服装",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040202020000000000",
                                        "taxCodeTitle": "服装",
                                        "iTitle": "*服装*非天然皮革服装",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "744",
                                "linkid": "713",
                                "code": "1040203",
                                "paCode": "10402",
                                "yn": "Y",
                                "title": "毛皮服装及其附件",
                                "alias": "毛皮服装及其附件",
                                "about": null,
                                "kws": null,
                                "taxName": "服装",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1040203000000000000",
                                "taxCodeTitle": "服装",
                                "iTitle": "*服装*毛皮服装及其附件",
                                "children": [
                                    {
                                        "id": "745",
                                        "linkid": "744",
                                        "code": "104020301",
                                        "paCode": "1040203",
                                        "yn": "N",
                                        "title": "毛皮服装",
                                        "alias": "毛皮服装",
                                        "about": "指以各种毛皮为原料生产的服装。包括天然毛皮服装和人造毛皮服装。",
                                        "kws": "毛皮服装、貂皮服装、狐皮服装、兔皮服装、毛革两用皮外衣、毛皮背心、人造毛皮大衣",
                                        "taxName": "服装",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040203010000000000",
                                        "taxCodeTitle": "服装",
                                        "iTitle": "*服装*毛皮服装",
                                        "children": []
                                    },
                                    {
                                        "id": "746",
                                        "linkid": "744",
                                        "code": "104020302",
                                        "paCode": "1040203",
                                        "yn": "N",
                                        "title": "毛皮服装附件",
                                        "alias": "毛皮服装附件",
                                        "about": "包括天然毛皮服装附件和人造毛皮服装附件。",
                                        "kws": "毛皮服装附件、天然毛皮披肩、天然毛皮围巾、天然毛皮衣领、天然毛皮手筒、人造毛皮披肩、人造毛皮围巾、人造毛皮衣领、人造毛皮手筒",
                                        "taxName": "服装",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040203020000000000",
                                        "taxCodeTitle": "服装",
                                        "iTitle": "*服装*毛皮服装附件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "747",
                                "linkid": "713",
                                "code": "1040204",
                                "paCode": "10402",
                                "yn": "Y",
                                "title": "鞋",
                                "alias": "鞋",
                                "about": null,
                                "kws": null,
                                "taxName": "鞋",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1040204000000000000",
                                "taxCodeTitle": "鞋",
                                "iTitle": "*鞋*鞋",
                                "children": [
                                    {
                                        "id": "748",
                                        "linkid": "747",
                                        "code": "104020401",
                                        "paCode": "1040204",
                                        "yn": "N",
                                        "title": "皮革鞋靴",
                                        "alias": "皮革鞋靴",
                                        "about": "指以天然皮革（头层、二层）、合成革、人造革和再生皮革作面的鞋靴；包括皮革面普通鞋靴、皮革面旅游（运动）鞋靴、皮革面凉鞋或拖鞋、皮革面劳保专用鞋靴、其他皮革面鞋靴、竞技用运动鞋靴。",
                                        "kws": "皮鞋、皮靴、天然皮革面普通鞋靴、天然皮革面旅游鞋靴、天然皮革面运动鞋靴、天然皮革面凉鞋、天然皮革面拖鞋、天然皮革面劳保专用鞋靴、非天然皮革面普通鞋靴、非天然皮革面旅游鞋靴、非天然皮革面运动鞋靴、非天然皮革面凉鞋、非天然皮革面拖鞋、非天然皮革面劳保专用鞋靴",
                                        "taxName": "鞋",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040204010000000000",
                                        "taxCodeTitle": "鞋",
                                        "iTitle": "*鞋*皮革鞋靴",
                                        "children": []
                                    },
                                    {
                                        "id": "749",
                                        "linkid": "747",
                                        "code": "104020402",
                                        "paCode": "1040204",
                                        "yn": "N",
                                        "title": "纺织面鞋",
                                        "alias": "纺织面鞋",
                                        "about": "指以纺织织物作为面料制作的鞋，包括纺织面单鞋、纺织面棉鞋、纺织面凉鞋、纺织面拖鞋、纺织面运动鞋、纺织面其他鞋。",
                                        "kws": "纺织面鞋、橡塑底布单鞋、皮底布单鞋、布底布单鞋、橡塑底布棉鞋、皮底布棉鞋、布底布棉鞋、橡塑底布凉鞋、皮底布凉鞋、橡塑底布拖鞋、皮底布拖鞋、纺织面普通运动鞋、纺织面普通旅游鞋、橡塑底纺织面普通运动鞋",
                                        "taxName": "鞋",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040204020000000000",
                                        "taxCodeTitle": "鞋",
                                        "iTitle": "*鞋*纺织面鞋",
                                        "children": []
                                    },
                                    {
                                        "id": "750",
                                        "linkid": "747",
                                        "code": "104020403",
                                        "paCode": "1040204",
                                        "yn": "N",
                                        "title": "胶鞋",
                                        "alias": "胶鞋",
                                        "about": "以橡胶为鞋底或鞋帮制成的鞋靴，包括胶面胶鞋、橡胶凉鞋或拖鞋、橡塑防护鞋、其他胶鞋。",
                                        "kws": "胶鞋、高统防水橡胶靴、中统防水橡胶靴、短统防水橡胶靴、短统橡塑靴、橡胶凉鞋、橡胶拖鞋、金属防护鞋头橡塑鞋、金属防护鞋头橡塑鞋靴",
                                        "taxName": "鞋",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040204030000000000",
                                        "taxCodeTitle": "鞋",
                                        "iTitle": "*鞋*胶鞋",
                                        "children": []
                                    },
                                    {
                                        "id": "751",
                                        "linkid": "747",
                                        "code": "104020404",
                                        "paCode": "1040204",
                                        "yn": "N",
                                        "title": "塑料鞋",
                                        "alias": "塑料鞋",
                                        "about": "指以合成树脂为主要原料加工成型的鞋，包括全塑凉鞋或拖鞋、其他塑料鞋。",
                                        "kws": "塑料鞋、全塑凉鞋、全塑拖鞋",
                                        "taxName": "鞋",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040204040000000000",
                                        "taxCodeTitle": "鞋",
                                        "iTitle": "*鞋*塑料鞋",
                                        "children": []
                                    },
                                    {
                                        "id": "752",
                                        "linkid": "747",
                                        "code": "104020405",
                                        "paCode": "1040204",
                                        "yn": "N",
                                        "title": "木制鞋",
                                        "alias": "木制鞋",
                                        "about": "指木制的鞋，包括木屐、其他木制鞋。",
                                        "kws": "木制鞋、木屐",
                                        "taxName": "鞋",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040204050000000000",
                                        "taxCodeTitle": "鞋",
                                        "iTitle": "*鞋*木制鞋",
                                        "children": []
                                    },
                                    {
                                        "id": "753",
                                        "linkid": "747",
                                        "code": "104020406",
                                        "paCode": "1040204",
                                        "yn": "N",
                                        "title": "舞蹈、戏剧用靴鞋",
                                        "alias": "舞蹈、戏剧用靴鞋",
                                        "about": "指舞蹈、戏剧专用的靴鞋，包括皮制舞蹈或戏剧用靴鞋、纺织材料鞋面制舞蹈或戏剧用靴鞋。",
                                        "kws": "舞蹈靴鞋、戏剧靴鞋、皮制舞蹈剧用靴鞋、皮制戏剧用靴鞋、纺织材料鞋面制舞蹈用靴鞋、纺织材料鞋面制戏剧用靴鞋",
                                        "taxName": "鞋",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040204060000000000",
                                        "taxCodeTitle": "鞋",
                                        "iTitle": "*鞋*舞蹈、戏剧用靴鞋",
                                        "children": []
                                    },
                                    {
                                        "id": "754",
                                        "linkid": "747",
                                        "code": "104020407",
                                        "paCode": "1040204",
                                        "yn": "N",
                                        "title": "靴鞋零件、护腿及类似品",
                                        "alias": "靴鞋零件、护腿及类似品",
                                        "about": "包括靴鞋零件、护腿或裹腿及类似品。",
                                        "kws": "靴鞋零件、鞋外底、鞋跟、鞋面零件、木制鞋靴零件、橡胶鞋套、护腿、裹腿",
                                        "taxName": "鞋",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040204070000000000",
                                        "taxCodeTitle": "鞋",
                                        "iTitle": "*鞋*靴鞋零件、护腿及类似品",
                                        "children": []
                                    },
                                    {
                                        "id": "755",
                                        "linkid": "747",
                                        "code": "104020499",
                                        "paCode": "1040204",
                                        "yn": "N",
                                        "title": "其他鞋",
                                        "alias": "其他鞋",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "鞋",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040204990000000000",
                                        "taxCodeTitle": "鞋",
                                        "iTitle": "*鞋*其他鞋",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "756",
                                "linkid": "713",
                                "code": "1040205",
                                "paCode": "10402",
                                "yn": "Y",
                                "title": "帽子及附件",
                                "alias": "帽子及附件",
                                "about": null,
                                "kws": null,
                                "taxName": "帽子",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1040205000000000000",
                                "taxCodeTitle": "帽子",
                                "iTitle": "*帽子*帽子及附件",
                                "children": [
                                    {
                                        "id": "757",
                                        "linkid": "756",
                                        "code": "104020501",
                                        "paCode": "1040205",
                                        "yn": "N",
                                        "title": "帽子",
                                        "alias": "帽子",
                                        "about": "包括普通帽、有边帽、贝雷帽、制服帽、民族帽、学生帽、学位帽、职业帽、工作帽（厨师帽及类似帽、海员用的防水帽）、运动帽、旅游帽、大礼帽及夜礼帽、兜帽等",
                                        "kws": "帽子、普通帽、有边帽、贝雷帽、制服帽、民族帽、学生帽、学位帽、职业帽、工作帽、运动帽、旅游帽、大礼帽、夜礼帽、兜帽",
                                        "taxName": "帽子",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040205010000000000",
                                        "taxCodeTitle": "帽子",
                                        "iTitle": "*帽子*帽子",
                                        "children": []
                                    },
                                    {
                                        "id": "758",
                                        "linkid": "756",
                                        "code": "104020502",
                                        "paCode": "1040205",
                                        "yn": "N",
                                        "title": "帽子附件",
                                        "alias": "帽子附件",
                                        "about": "包括帽圈、衬、套、帮、骨架、舌及颏带等",
                                        "kws": "帽子附件",
                                        "taxName": "帽子",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040205020000000000",
                                        "taxCodeTitle": "帽子",
                                        "iTitle": "*帽子*帽子附件",
                                        "children": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "id": "759",
                        "linkid": "607",
                        "code": "10403",
                        "paCode": "104",
                        "yn": "Y",
                        "title": "皮革、毛皮及其制品",
                        "alias": "皮革、毛皮及其制品",
                        "about": null,
                        "kws": null,
                        "taxName": "皮革毛皮制品",
                        "taxRate": "",
                        "vip": "5",
                        "itaxRate": null,
                        "taxCode": "1040300000000000000",
                        "taxCodeTitle": "皮革毛皮制品",
                        "iTitle": "*皮革毛皮制品*皮革、毛皮及其制品",
                        "children": [
                            {
                                "id": "760",
                                "linkid": "759",
                                "code": "1040301",
                                "paCode": "10403",
                                "yn": "N",
                                "title": "半成品革",
                                "alias": "半成品革",
                                "about": "指经脱毛和鞣制等物理、化学加工所得到的已经变性不易腐烂的半成品动物皮。包括牛半成品革、马半成品革、绵羊半成品革、山羊半成品革、猪半成品革、爬行动物半成品革、其他半成品革。",
                                "kws": "半成品革、牛半成品革、马半成品革、绵羊半成品革、山羊半成品革、猪半成品革、爬行动物半成品革",
                                "taxName": "皮革毛皮制品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1040301000000000000",
                                "taxCodeTitle": "皮革毛皮制品",
                                "iTitle": "*皮革毛皮制品*半成品革",
                                "children": []
                            },
                            {
                                "id": "761",
                                "linkid": "759",
                                "code": "1040302",
                                "paCode": "10403",
                                "yn": "Y",
                                "title": "成品革和再生革",
                                "alias": "成品革和再生革",
                                "about": null,
                                "kws": null,
                                "taxName": "皮革毛皮制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1040302000000000000",
                                "taxCodeTitle": "皮革毛皮制品",
                                "iTitle": "*皮革毛皮制品*成品革和再生革",
                                "children": [
                                    {
                                        "id": "762",
                                        "linkid": "761",
                                        "code": "104030201",
                                        "paCode": "1040302",
                                        "yn": "N",
                                        "title": "成品革",
                                        "alias": "成品革",
                                        "about": "指经脱毛和鞣制等物理、化学加工所得到的已经变性不易腐烂的动物皮，包括重革、轻革、油鞣革。",
                                        "kws": "成品革、猪重革、牛重革、马重革、牛轻革、马轻革、绵羊轻革、山羊轻革、猪轻革、爬行动物轻革、油鞣革",
                                        "taxName": "皮革毛皮制品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040302010000000000",
                                        "taxCodeTitle": "皮革毛皮制品",
                                        "iTitle": "*皮革毛皮制品*成品革",
                                        "children": []
                                    },
                                    {
                                        "id": "763",
                                        "linkid": "761",
                                        "code": "104030202",
                                        "paCode": "1040302",
                                        "yn": "N",
                                        "title": "再生皮革",
                                        "alias": "再生皮革",
                                        "about": "指以皮革或皮革纤维为基本成分的再生皮革。",
                                        "kws": "再生皮革",
                                        "taxName": "皮革毛皮制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040302020000000000",
                                        "taxCodeTitle": "皮革毛皮制品",
                                        "iTitle": "*皮革毛皮制品*再生皮革",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "764",
                                "linkid": "759",
                                "code": "1040303",
                                "paCode": "10403",
                                "yn": "Y",
                                "title": "箱、包及类似容器",
                                "alias": "箱、包及类似容器",
                                "about": "指用来装东西的各种包.包括衣箱或提箱及类似容器、手提包（袋）或背包、皮革作面类似箱或包容器、塑料作面类似箱或包容器、纺织材料作面类似箱或包容器、其他箱或包及类似容器。不包括高尔夫球包（袋）（详见10604060209）。",
                                "kws": "衣箱、提箱、手提包、手提袋、背包、皮革作面箱包、塑料作面箱包、纺织材料作面箱包",
                                "taxName": "皮革毛皮制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1040303000000000000",
                                "taxCodeTitle": "皮革毛皮制品",
                                "iTitle": "*皮革毛皮制品*箱、包及类似容器",
                                "children": [
                                    {
                                        "id": "765",
                                        "linkid": "764",
                                        "code": "104030301",
                                        "paCode": "1040303",
                                        "yn": "N",
                                        "title": "衣箱、提箱及类似容器",
                                        "alias": "衣箱、提箱及类似容器",
                                        "about": null,
                                        "kws": "衣箱、提箱、皮革制行李箱、皮革制公文箱、塑料作面行李箱、塑料作面提箱、塑料作面公文箱、纺织材料作面行李箱、纺织材料作面提箱",
                                        "taxName": "皮革毛皮制品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040303010000000000",
                                        "taxCodeTitle": "皮革毛皮制品",
                                        "iTitle": "*皮革毛皮制品*衣箱、提箱及类似容器",
                                        "children": []
                                    },
                                    {
                                        "id": "766",
                                        "linkid": "764",
                                        "code": "104030302",
                                        "paCode": "1040303",
                                        "yn": "N",
                                        "title": "手提包（袋）、背包",
                                        "alias": "手提包（袋）、背包",
                                        "about": "不包括高尔夫球包（袋）（详见10604060209）。",
                                        "kws": "手提包、手提袋、背包",
                                        "taxName": "皮革毛皮制品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040303020000000000",
                                        "taxCodeTitle": "皮革毛皮制品",
                                        "iTitle": "*皮革毛皮制品*手提包（袋）、背包",
                                        "children": []
                                    },
                                    {
                                        "id": "767",
                                        "linkid": "764",
                                        "code": "104030303",
                                        "paCode": "1040303",
                                        "yn": "N",
                                        "title": "皮革作面类似箱、包容器",
                                        "alias": "皮革作面类似箱、包容器",
                                        "about": "包括再生皮革或漆皮作面的其他类似容器，不包括高尔夫球包（袋）（详见10604060209）。",
                                        "kws": "皮革面望远镜盒、皮革面相机套、皮革面乐器盒、皮革面枪套",
                                        "taxName": "皮革毛皮制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040303030000000000",
                                        "taxCodeTitle": "皮革毛皮制品",
                                        "iTitle": "*皮革毛皮制品*皮革作面类似箱、包容器",
                                        "children": []
                                    },
                                    {
                                        "id": "768",
                                        "linkid": "764",
                                        "code": "104030304",
                                        "paCode": "1040303",
                                        "yn": "N",
                                        "title": "塑料作面类似箱、包容器",
                                        "alias": "塑料作面类似箱、包容器",
                                        "about": "不包括高尔夫球包（袋）（详见10604060209）。",
                                        "kws": "塑料面运动包、塑料面工具包、塑料面刀叉餐具盒",
                                        "taxName": "皮革毛皮制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040303040000000000",
                                        "taxCodeTitle": "皮革毛皮制品",
                                        "iTitle": "*皮革毛皮制品*塑料作面类似箱、包容器",
                                        "children": []
                                    },
                                    {
                                        "id": "769",
                                        "linkid": "764",
                                        "code": "104030305",
                                        "paCode": "1040303",
                                        "yn": "N",
                                        "title": "纺织材料作面类似箱、包容器",
                                        "alias": "纺织材料作面类似箱、包容器",
                                        "about": "不包括高尔夫球包（袋）（详见10604060209）。",
                                        "kws": "纺织材料面运动包、纺织材料面工具包、纺织材料面刀叉餐具盒",
                                        "taxName": "皮革毛皮制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040303050000000000",
                                        "taxCodeTitle": "皮革毛皮制品",
                                        "iTitle": "*皮革毛皮制品*纺织材料作面类似箱、包容器",
                                        "children": []
                                    },
                                    {
                                        "id": "770",
                                        "linkid": "764",
                                        "code": "104030399",
                                        "paCode": "1040303",
                                        "yn": "N",
                                        "title": "其他箱、包及类似容器",
                                        "alias": "其他箱、包及类似容器",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "皮革毛皮制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040303990000000000",
                                        "taxCodeTitle": "皮革毛皮制品",
                                        "iTitle": "*皮革毛皮制品*其他箱、包及类似容器",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "771",
                                "linkid": "759",
                                "code": "1040304",
                                "paCode": "10403",
                                "yn": "Y",
                                "title": "皮手套及皮革制衣着附件",
                                "alias": "皮手套及皮革制衣着附件",
                                "about": "包括皮革手套、毛皮手套、皮革制衣着附件，不包括运动专用手套的运动防护用具（详见106040606）。",
                                "kws": null,
                                "taxName": "皮革毛皮制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1040304000000000000",
                                "taxCodeTitle": "皮革毛皮制品",
                                "iTitle": "*皮革毛皮制品*皮手套及皮革制衣着附件",
                                "children": [
                                    {
                                        "id": "772",
                                        "linkid": "771",
                                        "code": "104030401",
                                        "paCode": "1040304",
                                        "yn": "N",
                                        "title": "皮革手套",
                                        "alias": "皮革手套",
                                        "about": "指皮革及再生皮革制手套，包括日常用皮革制手套、劳保用皮革制手套、其他皮革手套，不包括运动专用手套运动防护用具（详见106040606）。",
                                        "kws": "皮革手套、日常用皮革制手套、劳保用皮革制手套",
                                        "taxName": "皮革毛皮制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040304010000000000",
                                        "taxCodeTitle": "皮革毛皮制品",
                                        "iTitle": "*皮革毛皮制品*皮革手套",
                                        "children": []
                                    },
                                    {
                                        "id": "773",
                                        "linkid": "771",
                                        "code": "104030402",
                                        "paCode": "1040304",
                                        "yn": "N",
                                        "title": "毛皮手套",
                                        "alias": "毛皮手套",
                                        "about": "包括动物毛皮手套、人造毛皮手套。",
                                        "kws": "毛皮手套、动物毛皮手套、人造毛皮手套",
                                        "taxName": "皮革毛皮制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040304020000000000",
                                        "taxCodeTitle": "皮革毛皮制品",
                                        "iTitle": "*皮革毛皮制品*毛皮手套",
                                        "children": []
                                    },
                                    {
                                        "id": "774",
                                        "linkid": "771",
                                        "code": "104030403",
                                        "paCode": "1040304",
                                        "yn": "N",
                                        "title": "皮革制衣着附件",
                                        "alias": "皮革制衣着附件",
                                        "about": "包括皮革腰带、皮领带、皮革制子弹带、其他皮革制衣着附件",
                                        "kws": "皮革制衣着附件、天然皮革制腰带、非天然皮革制腰带、皮领带、皮革制子弹带",
                                        "taxName": "皮革毛皮制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040304030000000000",
                                        "taxCodeTitle": "皮革毛皮制品",
                                        "iTitle": "*皮革毛皮制品*皮革制衣着附件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "775",
                                "linkid": "759",
                                "code": "1040305",
                                "paCode": "10403",
                                "yn": "Y",
                                "title": "钱包、座套，相关皮革制品",
                                "alias": "钱包、座套，相关皮革制品",
                                "about": null,
                                "kws": null,
                                "taxName": "皮革毛皮制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1040305000000000000",
                                "taxCodeTitle": "皮革毛皮制品",
                                "iTitle": "*皮革毛皮制品*钱包、座套，相关皮革制品",
                                "children": [
                                    {
                                        "id": "776",
                                        "linkid": "775",
                                        "code": "104030501",
                                        "paCode": "1040305",
                                        "yn": "N",
                                        "title": "钱包及类似物品",
                                        "alias": "钱包及类似物品",
                                        "about": "指用各种材料制作的通常置于口袋或手提包内的物品，包括钱包、皮夹、钥匙包及类似物品。",
                                        "kws": "钱包、皮夹",
                                        "taxName": "皮革毛皮制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040305010000000000",
                                        "taxCodeTitle": "皮革毛皮制品",
                                        "iTitle": "*皮革毛皮制品*钱包及类似物品",
                                        "children": []
                                    },
                                    {
                                        "id": "777",
                                        "linkid": "775",
                                        "code": "104030502",
                                        "paCode": "1040305",
                                        "yn": "N",
                                        "title": "皮革制座套",
                                        "alias": "皮革制座套",
                                        "about": "包括天然皮革、合成革、人造革、再生皮革制沙发座套、汽车座套及类似制品。",
                                        "kws": "皮革制座套、天然皮革制沙发座套、天然皮革制汽车座套、非天然皮革制座套",
                                        "taxName": "皮革毛皮制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040305020000000000",
                                        "taxCodeTitle": "皮革毛皮制品",
                                        "iTitle": "*皮革毛皮制品*皮革制座套",
                                        "children": []
                                    },
                                    {
                                        "id": "778",
                                        "linkid": "775",
                                        "code": "104030503",
                                        "paCode": "1040305",
                                        "yn": "N",
                                        "title": "专门技术用途皮革制品",
                                        "alias": "专门技术用途皮革制品",
                                        "about": "指机器等专门技术用途的皮革或再生皮革制品，包括机器任何部位的皮革制传动带或输送带、皮革制输送吊斗、纺织机械用肚档皮带、清棉皮带、精梳皮革、综丝皮条及其他皮革制品、生皮锤等",
                                        "kws": "专门技术用途皮革制品",
                                        "taxName": "皮革毛皮制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040305030000000000",
                                        "taxCodeTitle": "皮革毛皮制品",
                                        "iTitle": "*皮革毛皮制品*专门技术用途皮革制品",
                                        "children": []
                                    },
                                    {
                                        "id": "779",
                                        "linkid": "775",
                                        "code": "104030504",
                                        "paCode": "1040305",
                                        "yn": "N",
                                        "title": "鞍具及挽具",
                                        "alias": "鞍具及挽具",
                                        "about": "指各种材料制成适合各种动物用的鞍具及挽具。",
                                        "kws": "鞍具、挽具",
                                        "taxName": "皮革毛皮制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040305040000000000",
                                        "taxCodeTitle": "皮革毛皮制品",
                                        "iTitle": "*皮革毛皮制品*鞍具及挽具",
                                        "children": []
                                    },
                                    {
                                        "id": "780",
                                        "linkid": "775",
                                        "code": "104030599",
                                        "paCode": "1040305",
                                        "yn": "N",
                                        "title": "其他相关皮革制品",
                                        "alias": "其他相关皮革制品",
                                        "about": "包括皮革制行李标签、磨剃刀的皮带、靴带、书籍封皮等未列明的皮革制品",
                                        "kws": "皮革制行李标签、磨剃刀的皮带、靴带、书籍封皮",
                                        "taxName": "皮革毛皮制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040305990000000000",
                                        "taxCodeTitle": "皮革毛皮制品",
                                        "iTitle": "*皮革毛皮制品*其他相关皮革制品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "781",
                                "linkid": "759",
                                "code": "1040306",
                                "paCode": "10403",
                                "yn": "Y",
                                "title": "鞣制毛皮、人造毛皮及其制品",
                                "alias": "鞣制毛皮、人造毛皮及其制品",
                                "about": "不包括毛皮服装(详见1040203)",
                                "kws": null,
                                "taxName": "皮革毛皮制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1040306000000000000",
                                "taxCodeTitle": "皮革毛皮制品",
                                "iTitle": "*皮革毛皮制品*鞣制毛皮、人造毛皮及其制品",
                                "children": [
                                    {
                                        "id": "782",
                                        "linkid": "781",
                                        "code": "104030601",
                                        "paCode": "1040306",
                                        "yn": "N",
                                        "title": "鞣制毛皮",
                                        "alias": "鞣制毛皮",
                                        "about": "指已鞣制或硝制的毛皮（包括未缝制和已缝制的），包括未缝制整张毛皮、未缝制头或尾或爪及其块或片。",
                                        "kws": "鞣制毛皮、未缝制整张水貂皮、未缝制整张狐狸皮、未缝制羔羊整张毛皮、未缝制整张兔皮、未缝制头、未缝制尾、未缝制爪",
                                        "taxName": "皮革毛皮制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040306010000000000",
                                        "taxCodeTitle": "皮革毛皮制品",
                                        "iTitle": "*皮革毛皮制品*鞣制毛皮",
                                        "children": []
                                    },
                                    {
                                        "id": "783",
                                        "linkid": "781",
                                        "code": "104030602",
                                        "paCode": "1040306",
                                        "yn": "N",
                                        "title": "已缝制整张毛皮及其块、片",
                                        "alias": "已缝制整张毛皮及其块、片",
                                        "about": "包括已缝制的已鞣制或硝制的毛皮。",
                                        "kws": "已缝制整张水貂皮、已缝制整张羔羊毛皮、已缝制整张兔皮、已缝制整张毛皮",
                                        "taxName": "皮革毛皮制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040306020000000000",
                                        "taxCodeTitle": "皮革毛皮制品",
                                        "iTitle": "*皮革毛皮制品*已缝制整张毛皮及其块、片",
                                        "children": []
                                    },
                                    {
                                        "id": "784",
                                        "linkid": "781",
                                        "code": "104030603",
                                        "paCode": "1040306",
                                        "yn": "N",
                                        "title": "天然毛皮制品",
                                        "alias": "天然毛皮制品",
                                        "about": "包括毛皮小地毯、毛皮床罩、毛皮坐垫、毛皮狩猎袋、供机器或机械器具用的毛皮制品。不包括天然毛皮服装(详见1040203)。",
                                        "kws": "天然毛皮制品、毛皮小地毯、毛皮床罩、毛皮坐垫、毛皮狩猎袋、供机器用毛皮制品、机械器具用毛皮制品",
                                        "taxName": "皮革毛皮制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040306030000000000",
                                        "taxCodeTitle": "皮革毛皮制品",
                                        "iTitle": "*皮革毛皮制品*天然毛皮制品",
                                        "children": []
                                    },
                                    {
                                        "id": "785",
                                        "linkid": "781",
                                        "code": "104030604",
                                        "paCode": "1040306",
                                        "yn": "N",
                                        "title": "人造毛皮",
                                        "alias": "人造毛皮",
                                        "about": "指外观类似动物毛皮的长毛绒型织物。",
                                        "kws": "人造毛皮",
                                        "taxName": "皮革毛皮制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040306040000000000",
                                        "taxCodeTitle": "皮革毛皮制品",
                                        "iTitle": "*皮革毛皮制品*人造毛皮",
                                        "children": []
                                    },
                                    {
                                        "id": "786",
                                        "linkid": "781",
                                        "code": "104030605",
                                        "paCode": "1040306",
                                        "yn": "N",
                                        "title": "人造毛皮制品",
                                        "alias": "人造毛皮制品",
                                        "about": "包括人造兽尾制品,不包括人造毛皮服装(详见104020302)。",
                                        "kws": "人造毛皮制品",
                                        "taxName": "皮革毛皮制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040306050000000000",
                                        "taxCodeTitle": "皮革毛皮制品",
                                        "iTitle": "*皮革毛皮制品*人造毛皮制品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "787",
                                "linkid": "759",
                                "code": "1040307",
                                "paCode": "10403",
                                "yn": "Y",
                                "title": "加工羽毛（绒）",
                                "alias": "加工羽毛（绒）",
                                "about": null,
                                "kws": null,
                                "taxName": "皮革毛皮制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1040307000000000000",
                                "taxCodeTitle": "皮革毛皮制品",
                                "iTitle": "*皮革毛皮制品*加工羽毛（绒）",
                                "children": [
                                    {
                                        "id": "788",
                                        "linkid": "787",
                                        "code": "104030701",
                                        "paCode": "1040307",
                                        "yn": "N",
                                        "title": "加工填充用羽毛",
                                        "alias": "加工填充用羽毛",
                                        "about": null,
                                        "kws": "羽毛",
                                        "taxName": "皮革毛皮制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040307010000000000",
                                        "taxCodeTitle": "皮革毛皮制品",
                                        "iTitle": "*皮革毛皮制品*加工填充用羽毛",
                                        "children": []
                                    },
                                    {
                                        "id": "789",
                                        "linkid": "787",
                                        "code": "104030702",
                                        "paCode": "1040307",
                                        "yn": "N",
                                        "title": "加工填充用羽绒",
                                        "alias": "加工填充用羽绒",
                                        "about": null,
                                        "kws": "羽绒",
                                        "taxName": "皮革毛皮制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1040307020000000000",
                                        "taxCodeTitle": "皮革毛皮制品",
                                        "iTitle": "*皮革毛皮制品*加工填充用羽绒",
                                        "children": []
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "id": "790",
                "linkid": "1",
                "code": "105",
                "paCode": "1",
                "yn": "Y",
                "title": "木制品、家具类产品",
                "alias": "木制品、家具类产品",
                "about": null,
                "kws": null,
                "taxName": "木制品",
                "taxRate": "",
                "vip": "5",
                "itaxRate": null,
                "taxCode": "1050000000000000000",
                "taxCodeTitle": "木制品",
                "iTitle": "*木制品*木制品、家具类产品",
                "children": [
                    {
                        "id": "791",
                        "linkid": "790",
                        "code": "10501",
                        "paCode": "105",
                        "yn": "Y",
                        "title": "木材及木、竹、藤、棕、草制品",
                        "alias": "木材及木、竹、藤、棕、草制品",
                        "about": null,
                        "kws": null,
                        "taxName": "木制品",
                        "taxRate": "",
                        "vip": "5",
                        "itaxRate": null,
                        "taxCode": "1050100000000000000",
                        "taxCodeTitle": "木制品",
                        "iTitle": "*木制品*木材及木、竹、藤、棕、草制品",
                        "children": [
                            {
                                "id": "792",
                                "linkid": "791",
                                "code": "1050101",
                                "paCode": "10501",
                                "yn": "Y",
                                "title": "锯材",
                                "alias": "锯材",
                                "about": "伐倒木经打枝和剥皮后的原木或原条，按一定的规格要求加工后的成材",
                                "kws": null,
                                "taxName": "木制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1050101000000000000",
                                "taxCodeTitle": "木制品",
                                "iTitle": "*木制品*锯材",
                                "children": [
                                    {
                                        "id": "793",
                                        "linkid": "792",
                                        "code": "105010101",
                                        "paCode": "1050101",
                                        "yn": "N",
                                        "title": "普通锯材",
                                        "alias": "普通锯材",
                                        "about": "不包括铁路货车锯材、载重汽车锯材、船用锯材、罐道木、包装箱锯材、机台木（详见105010102）",
                                        "kws": "普通锯材",
                                        "taxName": "木制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050101010000000000",
                                        "taxCodeTitle": "木制品",
                                        "iTitle": "*木制品*普通锯材",
                                        "children": []
                                    },
                                    {
                                        "id": "794",
                                        "linkid": "792",
                                        "code": "105010102",
                                        "paCode": "1050101",
                                        "yn": "N",
                                        "title": "特种锯材",
                                        "alias": "特种锯材",
                                        "about": "包括铁路货车锯材、载重汽车锯材、船用锯材、罐道木、包装箱锯材、机台木",
                                        "kws": "铁路货车锯材、载重汽车锯材、船用锯材、罐道木、包装箱锯材、机台木、特种锯材",
                                        "taxName": "木制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050101020000000000",
                                        "taxCodeTitle": "木制品",
                                        "iTitle": "*木制品*特种锯材",
                                        "children": []
                                    },
                                    {
                                        "id": "795",
                                        "linkid": "792",
                                        "code": "105010103",
                                        "paCode": "1050101",
                                        "yn": "N",
                                        "title": "枕木",
                                        "alias": "枕木",
                                        "about": "是用于铁路、专用轨道走行设备铺设和承载设备铺垫的材料。",
                                        "kws": "未浸渍普通枕木、未浸渍道岔枕木、未浸渍桥梁枕木、已浸渍枕木、已浸渍普通枕木、已浸渍道岔枕木、已浸渍桥梁枕木",
                                        "taxName": "木制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050101030000000000",
                                        "taxCodeTitle": "木制品",
                                        "iTitle": "*木制品*枕木",
                                        "children": []
                                    },
                                    {
                                        "id": "796",
                                        "linkid": "792",
                                        "code": "105010199",
                                        "paCode": "1050101",
                                        "yn": "N",
                                        "title": "其他锯材",
                                        "alias": "其他锯材",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "木制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050101990000000000",
                                        "taxCodeTitle": "木制品",
                                        "iTitle": "*木制品*其他锯材",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "797",
                                "linkid": "791",
                                "code": "1050102",
                                "paCode": "10501",
                                "yn": "Y",
                                "title": "木片、木粒加工产品",
                                "alias": "木片、木粒加工产品",
                                "about": null,
                                "kws": null,
                                "taxName": "木制品",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1050102000000000000",
                                "taxCodeTitle": "木制品",
                                "iTitle": "*木制品*木片、木粒加工产品",
                                "children": [
                                    {
                                        "id": "798",
                                        "linkid": "797",
                                        "code": "105010201",
                                        "paCode": "1050102",
                                        "yn": "N",
                                        "title": "木片、木粒",
                                        "alias": "木片、木粒",
                                        "about": "指用机械方法将木材制成小片（扁平刚硬且粗制成方形）或小粒（细小且有柔性），用于机械法、化学法或机械-化学法制纤维素浆，或制造纤维板或木质碎料板",
                                        "kws": "木片、针叶木木片、非针叶木木片、木粒、针叶木木粒、非针叶木木粒、造纸木片、人造板木片、纺织业生产人造纤维用木片",
                                        "taxName": "木制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050102010000000000",
                                        "taxCodeTitle": "木制品",
                                        "iTitle": "*木制品*木片、木粒",
                                        "children": []
                                    },
                                    {
                                        "id": "799",
                                        "linkid": "797",
                                        "code": "105010202",
                                        "paCode": "1050102",
                                        "yn": "N",
                                        "title": "木丝、木粉",
                                        "alias": "木丝、木粉",
                                        "about": null,
                                        "kws": "木丝、木粉",
                                        "taxName": "木制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050102020000000000",
                                        "taxCodeTitle": "木制品",
                                        "iTitle": "*木制品*木丝、木粉",
                                        "children": []
                                    },
                                    {
                                        "id": "800",
                                        "linkid": "797",
                                        "code": "105010203",
                                        "paCode": "1050102",
                                        "yn": "N",
                                        "title": "锯末、木废料及碎片",
                                        "alias": "锯末、木废料及碎片",
                                        "about": null,
                                        "kws": "锯末、木废料",
                                        "taxName": "木制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050102030000000000",
                                        "taxCodeTitle": "木制品",
                                        "iTitle": "*木制品*锯末、木废料及碎片",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "801",
                                "linkid": "791",
                                "code": "1050103",
                                "paCode": "10501",
                                "yn": "Y",
                                "title": "人造板",
                                "alias": "人造板",
                                "about": null,
                                "kws": null,
                                "taxName": "木制品",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1050103000000000000",
                                "taxCodeTitle": "木制品",
                                "iTitle": "*木制品*人造板",
                                "children": [
                                    {
                                        "id": "802",
                                        "linkid": "801",
                                        "code": "105010301",
                                        "paCode": "1050103",
                                        "yn": "N",
                                        "title": "胶合板",
                                        "alias": "胶合板",
                                        "about": "是由木段旋切成单板或由木方刨切成薄木，再用胶粘剂胶合而成的三层或多层的板状材料",
                                        "kws": "薄板制胶合板、多层板制胶合板、竹胶合板、竹材胶合板、竹编胶合板、竹材层压板、胶合板",
                                        "taxName": "木制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050103010000000000",
                                        "taxCodeTitle": "木制品",
                                        "iTitle": "*木制品*胶合板",
                                        "children": []
                                    },
                                    {
                                        "id": "803",
                                        "linkid": "801",
                                        "code": "105010302",
                                        "paCode": "1050103",
                                        "yn": "N",
                                        "title": "纤维板",
                                        "alias": "纤维板",
                                        "about": "由木质纤维素纤维交织成型并利用其固有胶粘性能制成的人造板。",
                                        "kws": "木质纤维板、硬质纤维板、中密度纤维板、软质纤维板、非木质纤维板、稻草板、麦秸板、蔗渣板、棉秆板、稻壳板、麻秆板",
                                        "taxName": "木制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050103020000000000",
                                        "taxCodeTitle": "木制品",
                                        "iTitle": "*木制品*纤维板",
                                        "children": []
                                    },
                                    {
                                        "id": "804",
                                        "linkid": "801",
                                        "code": "105010303",
                                        "paCode": "1050103",
                                        "yn": "N",
                                        "title": "刨花板",
                                        "alias": "刨花板",
                                        "about": "也称碎料板",
                                        "kws": "刨花板、木质刨花板、普通刨花板、定向刨花板、装饰刨花板、木丝板、非木质刨花板、水泥刨花板、石膏刨花板、水泥木屑板、竹材刨花板",
                                        "taxName": "木制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050103030000000000",
                                        "taxCodeTitle": "木制品",
                                        "iTitle": "*木制品*刨花板",
                                        "children": []
                                    },
                                    {
                                        "id": "805",
                                        "linkid": "801",
                                        "code": "105010304",
                                        "paCode": "1050103",
                                        "yn": "N",
                                        "title": "细木工板",
                                        "alias": "细木工板",
                                        "about": "指单板饰面板",
                                        "kws": "细木工板",
                                        "taxName": "木制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050103040000000000",
                                        "taxCodeTitle": "木制品",
                                        "iTitle": "*木制品*细木工板",
                                        "children": []
                                    },
                                    {
                                        "id": "806",
                                        "linkid": "801",
                                        "code": "105010399",
                                        "paCode": "1050103",
                                        "yn": "N",
                                        "title": "其他人造板",
                                        "alias": "其他人造板",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "木制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050103990000000000",
                                        "taxCodeTitle": "木制品",
                                        "iTitle": "*木制品*其他人造板",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "807",
                                "linkid": "791",
                                "code": "1050104",
                                "paCode": "10501",
                                "yn": "Y",
                                "title": "二次加工材，相关板材",
                                "alias": "二次加工材，相关板材",
                                "about": null,
                                "kws": null,
                                "taxName": "木制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1050104000000000000",
                                "taxCodeTitle": "木制品",
                                "iTitle": "*木制品*二次加工材，相关板材",
                                "children": [
                                    {
                                        "id": "808",
                                        "linkid": "807",
                                        "code": "105010401",
                                        "paCode": "1050104",
                                        "yn": "N",
                                        "title": "单板",
                                        "alias": "单板",
                                        "about": "是指原木通过旋切或刨切获得的，厚度在1mm左右，用于制造胶合板等人造板材的木质材料。",
                                        "kws": "单板、刨切单板、针叶木刨切单板、红柳安木刨切单板、热带木刨切单板、竹刨切单板、非针叶木刨切单板、旋切单板、针叶木旋切单板、红柳安木旋切单板、热带木旋切单板、竹旋切单板、非针叶木旋切单板、微薄木、针叶木微薄木、红柳安木微薄木、热带木微薄木、非针叶木微薄木",
                                        "taxName": "木制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050104010000000000",
                                        "taxCodeTitle": "木制品",
                                        "iTitle": "*木制品*单板",
                                        "children": []
                                    },
                                    {
                                        "id": "809",
                                        "linkid": "807",
                                        "code": "105010402",
                                        "paCode": "1050104",
                                        "yn": "N",
                                        "title": "强化木",
                                        "alias": "强化木",
                                        "about": null,
                                        "kws": "强化木",
                                        "taxName": "木制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050104020000000000",
                                        "taxCodeTitle": "木制品",
                                        "iTitle": "*木制品*强化木",
                                        "children": []
                                    },
                                    {
                                        "id": "810",
                                        "linkid": "807",
                                        "code": "105010403",
                                        "paCode": "1050104",
                                        "yn": "N",
                                        "title": "指接材",
                                        "alias": "指接材",
                                        "about": "由多块木板端面采用锯齿状接口,类似两手手指交叉对接,纵向拼接而成。",
                                        "kws": "指接材",
                                        "taxName": "木制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050104030000000000",
                                        "taxCodeTitle": "木制品",
                                        "iTitle": "*木制品*指接材",
                                        "children": []
                                    },
                                    {
                                        "id": "811",
                                        "linkid": "807",
                                        "code": "105010404",
                                        "paCode": "1050104",
                                        "yn": "N",
                                        "title": "人造板表面装饰板",
                                        "alias": "人造板表面装饰板",
                                        "about": "指单板贴面板",
                                        "kws": "人造板表面装饰板、合成树脂浸渍贴面板、印刷木纹纸贴面板、直接印刷板、人造染色板",
                                        "taxName": "木制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050104040000000000",
                                        "taxCodeTitle": "木制品",
                                        "iTitle": "*木制品*人造板表面装饰板",
                                        "children": []
                                    },
                                    {
                                        "id": "812",
                                        "linkid": "807",
                                        "code": "105010405",
                                        "paCode": "1050104",
                                        "yn": "N",
                                        "title": "热固性树脂装饰层压板",
                                        "alias": "热固性树脂装饰层压板",
                                        "about": null,
                                        "kws": "热固性树脂装饰层压板",
                                        "taxName": "木制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050104050000000000",
                                        "taxCodeTitle": "木制品",
                                        "iTitle": "*木制品*热固性树脂装饰层压板",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "813",
                                "linkid": "791",
                                "code": "1050105",
                                "paCode": "10501",
                                "yn": "Y",
                                "title": "建筑用木料及加工木材组件",
                                "alias": "建筑用木料及加工木材组件",
                                "about": null,
                                "kws": null,
                                "taxName": "木制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1050105000000000000",
                                "taxCodeTitle": "木制品",
                                "iTitle": "*木制品*建筑用木料及加工木材组件",
                                "children": [
                                    {
                                        "id": "814",
                                        "linkid": "813",
                                        "code": "105010501",
                                        "paCode": "1050105",
                                        "yn": "N",
                                        "title": "木制门及其框架和门槛",
                                        "alias": "木制门及其框架和门槛",
                                        "about": null,
                                        "kws": "实木制门、非实木制门、木制门、木质门框架、木质门槛",
                                        "taxName": "木制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050105010000000000",
                                        "taxCodeTitle": "木制品",
                                        "iTitle": "*木制品*木制门及其框架和门槛",
                                        "children": []
                                    },
                                    {
                                        "id": "815",
                                        "linkid": "813",
                                        "code": "105010502",
                                        "paCode": "1050105",
                                        "yn": "N",
                                        "title": "木制窗及其木制框架",
                                        "alias": "木制窗及其木制框架",
                                        "about": null,
                                        "kws": "木制窗、木制窗框架",
                                        "taxName": "木制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050105020000000000",
                                        "taxCodeTitle": "木制品",
                                        "iTitle": "*木制品*木制窗及其木制框架",
                                        "children": []
                                    },
                                    {
                                        "id": "816",
                                        "linkid": "813",
                                        "code": "105010503",
                                        "paCode": "1050105",
                                        "yn": "N",
                                        "title": "木模",
                                        "alias": "木模",
                                        "about": "指木制水泥构件的模板",
                                        "kws": "木模",
                                        "taxName": "木制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050105030000000000",
                                        "taxCodeTitle": "木制品",
                                        "iTitle": "*木制品*木模",
                                        "children": []
                                    },
                                    {
                                        "id": "817",
                                        "linkid": "813",
                                        "code": "105010504",
                                        "paCode": "1050105",
                                        "yn": "Y",
                                        "title": "木制地板",
                                        "alias": "木制地板",
                                        "about": null,
                                        "kws": "实木木地板、复合木地板",
                                        "taxName": "木制品",
                                        "taxRate": "",
                                        "vip": "5",
                                        "itaxRate": null,
                                        "taxCode": "1050105040000000000",
                                        "taxCodeTitle": "木制品",
                                        "iTitle": "*木制品*木制地板",
                                        "children": [
                                            {
                                                "id": "818",
                                                "linkid": "817",
                                                "code": "10501050401",
                                                "paCode": "105010504",
                                                "yn": "N",
                                                "title": "实木地板",
                                                "alias": "实木地板",
                                                "about": "以木材为原料，通过一定的工艺将木材刨切加工成单板（刨切薄木）或旋切加工成单板，然后将多层单板经过胶压复合等工艺生产的实木地板。",
                                                "kws": "柚木实木地板、印茄实木地板、香茶茱萸实木地板、水曲柳实木地板、加枫实木地板、水青冈实木地板、桦木实木地板、红橡实木地板、亚花梨实木地板、槲栎实木地板、铁苏木实木地板、香脂木豆实木地板、拉帕乔实木地板、乔木树参实木地板、胡桃木实木地板、鸡翅木实木地板、紫心木实木地板、香二翅豆实木地板、木荚豆实木地板、甘巴豆实木地板",
                                                "taxName": "木制品",
                                                "taxRate": "13%",
                                                "vip": "5",
                                                "itaxRate": "0.13",
                                                "taxCode": "1050105040100000000",
                                                "taxCodeTitle": "木制品",
                                                "iTitle": "*木制品*实木地板",
                                                "children": []
                                            },
                                            {
                                                "id": "819",
                                                "linkid": "817",
                                                "code": "10501050499",
                                                "paCode": "105010504",
                                                "yn": "N",
                                                "title": "其他木制地板",
                                                "alias": "其他木制地板",
                                                "about": null,
                                                "kws": null,
                                                "taxName": "木制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1050105049900000000",
                                                "taxCodeTitle": "木制品",
                                                "iTitle": "*木制品*其他木制地板",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "820",
                                        "linkid": "813",
                                        "code": "105010505",
                                        "paCode": "1050105",
                                        "yn": "N",
                                        "title": "木瓦",
                                        "alias": "木瓦",
                                        "about": null,
                                        "kws": "木瓦",
                                        "taxName": "木制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050105050000000000",
                                        "taxCodeTitle": "木制品",
                                        "iTitle": "*木制品*木瓦",
                                        "children": []
                                    },
                                    {
                                        "id": "821",
                                        "linkid": "813",
                                        "code": "105010506",
                                        "paCode": "1050105",
                                        "yn": "N",
                                        "title": "木制盖屋板",
                                        "alias": "木制盖屋板",
                                        "about": null,
                                        "kws": "木制盖屋板",
                                        "taxName": "木制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050105060000000000",
                                        "taxCodeTitle": "木制品",
                                        "iTitle": "*木制品*木制盖屋板",
                                        "children": []
                                    },
                                    {
                                        "id": "822",
                                        "linkid": "813",
                                        "code": "105010507",
                                        "paCode": "1050105",
                                        "yn": "N",
                                        "title": "木制梁、椽、屋顶支梁",
                                        "alias": "木制梁、椽、屋顶支梁",
                                        "about": null,
                                        "kws": "木制梁、椽、屋顶支梁",
                                        "taxName": "木制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050105070000000000",
                                        "taxCodeTitle": "木制品",
                                        "iTitle": "*木制品*木制梁、椽、屋顶支梁",
                                        "children": []
                                    },
                                    {
                                        "id": "823",
                                        "linkid": "813",
                                        "code": "105010508",
                                        "paCode": "1050105",
                                        "yn": "N",
                                        "title": "木制楼梯",
                                        "alias": "木制楼梯",
                                        "about": null,
                                        "kws": "木制楼梯",
                                        "taxName": "木制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050105080000000000",
                                        "taxCodeTitle": "木制品",
                                        "iTitle": "*木制品*木制楼梯",
                                        "children": []
                                    },
                                    {
                                        "id": "824",
                                        "linkid": "813",
                                        "code": "105010509",
                                        "paCode": "1050105",
                                        "yn": "N",
                                        "title": "木制栏杆",
                                        "alias": "木制栏杆",
                                        "about": null,
                                        "kws": "木制栏杆",
                                        "taxName": "木制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050105090000000000",
                                        "taxCodeTitle": "木制品",
                                        "iTitle": "*木制品*木制栏杆",
                                        "children": []
                                    },
                                    {
                                        "id": "825",
                                        "linkid": "813",
                                        "code": "105010599",
                                        "paCode": "1050105",
                                        "yn": "N",
                                        "title": "其他建筑用木料及加工木材组件",
                                        "alias": "其他建筑用木料及加工木材组件",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "木制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050105990000000000",
                                        "taxCodeTitle": "木制品",
                                        "iTitle": "*木制品*其他建筑用木料及加工木材组件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "826",
                                "linkid": "791",
                                "code": "1050106",
                                "paCode": "10501",
                                "yn": "Y",
                                "title": "木容器",
                                "alias": "木容器",
                                "about": null,
                                "kws": null,
                                "taxName": "木制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1050106000000000000",
                                "taxCodeTitle": "木制品",
                                "iTitle": "*木制品*木容器",
                                "children": [
                                    {
                                        "id": "827",
                                        "linkid": "826",
                                        "code": "105010601",
                                        "paCode": "1050106",
                                        "yn": "N",
                                        "title": "木制桶、槽、盆及类似容器",
                                        "alias": "木制桶、槽、盆及类似容器",
                                        "about": null,
                                        "kws": "木桶、木制槽、木质盆、木质桶板木、木制桶容器配件、木箍桶、大酒桶、琵琶桶、大木桶、箍木",
                                        "taxName": "木制品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050106010000000000",
                                        "taxCodeTitle": "木制品",
                                        "iTitle": "*木制品*木制桶、槽、盆及类似容器",
                                        "children": []
                                    },
                                    {
                                        "id": "828",
                                        "linkid": "826",
                                        "code": "105010602",
                                        "paCode": "1050106",
                                        "yn": "N",
                                        "title": "包装用木容器",
                                        "alias": "包装用木容器",
                                        "about": "包括包装用木箱、木盒、板条箱及类似包装容器",
                                        "kws": "包装用木箱、包装用木盒、板条箱、电缆卷筒、木质电缆盘",
                                        "taxName": "木制品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050106020000000000",
                                        "taxCodeTitle": "木制品",
                                        "iTitle": "*木制品*包装用木容器",
                                        "children": []
                                    },
                                    {
                                        "id": "829",
                                        "linkid": "826",
                                        "code": "105010603",
                                        "paCode": "1050106",
                                        "yn": "N",
                                        "title": "木质保温容器",
                                        "alias": "木质保温容器",
                                        "about": null,
                                        "kws": "木质保温容器",
                                        "taxName": "木制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050106030000000000",
                                        "taxCodeTitle": "木制品",
                                        "iTitle": "*木制品*木质保温容器",
                                        "children": []
                                    },
                                    {
                                        "id": "830",
                                        "linkid": "826",
                                        "code": "105010604",
                                        "paCode": "1050106",
                                        "yn": "N",
                                        "title": "木托板、箱形托盘及类似装载木板",
                                        "alias": "木托板、箱形托盘及类似装载木板",
                                        "about": null,
                                        "kws": "木托板、箱形木托盘、装载用木板、托盘、护框",
                                        "taxName": "木制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050106040000000000",
                                        "taxCodeTitle": "木制品",
                                        "iTitle": "*木制品*木托板、箱形托盘及类似装载木板",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "831",
                                "linkid": "791",
                                "code": "1050107",
                                "paCode": "10501",
                                "yn": "Y",
                                "title": "软木及软木制品",
                                "alias": "软木及软木制品",
                                "about": null,
                                "kws": null,
                                "taxName": "木制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1050107000000000000",
                                "taxCodeTitle": "木制品",
                                "iTitle": "*木制品*软木及软木制品",
                                "children": [
                                    {
                                        "id": "832",
                                        "linkid": "831",
                                        "code": "105010701",
                                        "paCode": "1050107",
                                        "yn": "N",
                                        "title": "天然软木",
                                        "alias": "天然软木",
                                        "about": "植物木栓层非常发达的树种的外皮产物",
                                        "kws": "软木板、软木片、天然制软木废压制软木废料、软木碎、软木粒、软木粉",
                                        "taxName": "木制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050107010000000000",
                                        "taxCodeTitle": "木制品",
                                        "iTitle": "*木制品*天然软木",
                                        "children": []
                                    },
                                    {
                                        "id": "833",
                                        "linkid": "831",
                                        "code": "105010702",
                                        "paCode": "1050107",
                                        "yn": "N",
                                        "title": "软木制品",
                                        "alias": "软木制品",
                                        "about": "由软木加工后制成的产品，不包括压制软木及其制品（详见105010703）",
                                        "kws": "软木塞子、软木圆片、垫片及薄片、天然软木垫、极薄软木片条、软木制救生圈、软木制浴室防滑垫",
                                        "taxName": "木制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050107020000000000",
                                        "taxCodeTitle": "木制品",
                                        "iTitle": "*木制品*软木制品",
                                        "children": []
                                    },
                                    {
                                        "id": "834",
                                        "linkid": "831",
                                        "code": "105010703",
                                        "paCode": "1050107",
                                        "yn": "N",
                                        "title": "压制软木及其制品",
                                        "alias": "压制软木及其制品",
                                        "about": "压制软木通常是将软木碎、软木粒或软木粉用加入粘合物质，或不加粘合物质的方法高温加压制得",
                                        "kws": "压制软木砖、压制软木块、压制软木条",
                                        "taxName": "木制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050107030000000000",
                                        "taxCodeTitle": "木制品",
                                        "iTitle": "*木制品*压制软木及其制品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "835",
                                "linkid": "791",
                                "code": "1050108",
                                "paCode": "10501",
                                "yn": "Y",
                                "title": "木制餐具，相关木制品",
                                "alias": "木制餐具，相关木制品",
                                "about": null,
                                "kws": null,
                                "taxName": "木制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1050108000000000000",
                                "taxCodeTitle": "木制品",
                                "iTitle": "*木制品*木制餐具，相关木制品",
                                "children": [
                                    {
                                        "id": "836",
                                        "linkid": "835",
                                        "code": "105010801",
                                        "paCode": "1050108",
                                        "yn": "N",
                                        "title": "木制餐具及厨房用具",
                                        "alias": "木制餐具及厨房用具",
                                        "about": "不包括木制一次性筷子（详见105010802）。",
                                        "kws": "木制餐具、木制厨房用具、木筷子、木碗、木勺、木铲、木案板",
                                        "taxName": "木制品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050108010000000000",
                                        "taxCodeTitle": "木制品",
                                        "iTitle": "*木制品*木制餐具及厨房用具",
                                        "children": []
                                    },
                                    {
                                        "id": "837",
                                        "linkid": "835",
                                        "code": "105010802",
                                        "paCode": "1050108",
                                        "yn": "N",
                                        "title": "木制一次性筷子",
                                        "alias": "木制一次性筷子",
                                        "about": null,
                                        "kws": "木制一次性筷子",
                                        "taxName": "木制品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050108020000000000",
                                        "taxCodeTitle": "木制品",
                                        "iTitle": "*木制品*木制一次性筷子",
                                        "children": []
                                    },
                                    {
                                        "id": "838",
                                        "linkid": "835",
                                        "code": "105010803",
                                        "paCode": "1050108",
                                        "yn": "N",
                                        "title": "木质框架，相关木制品",
                                        "alias": "木质框架，相关木制品",
                                        "about": null,
                                        "kws": "木制镜框、木制相框、木制晾衣架、木制工具、木制洗衣板",
                                        "taxName": "木制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050108030000000000",
                                        "taxCodeTitle": "木制品",
                                        "iTitle": "*木制品*木质框架，相关木制品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "839",
                                "linkid": "791",
                                "code": "1050109",
                                "paCode": "10501",
                                "yn": "Y",
                                "title": "竹制品",
                                "alias": "竹制品",
                                "about": null,
                                "kws": null,
                                "taxName": "竹制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1050109000000000000",
                                "taxCodeTitle": "竹制品",
                                "iTitle": "*竹制品*竹制品",
                                "children": [
                                    {
                                        "id": "840",
                                        "linkid": "839",
                                        "code": "105010901",
                                        "paCode": "1050109",
                                        "yn": "N",
                                        "title": "竹制工业、建筑用品",
                                        "alias": "竹制工业、建筑用品",
                                        "about": "指工业及建筑生产用竹制品",
                                        "kws": "竹地板、竹梯子、竹踏板、竹架子、竹勾片、竹船篷",
                                        "taxName": "竹制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050109010000000000",
                                        "taxCodeTitle": "竹制品",
                                        "iTitle": "*竹制品*竹制工业、建筑用品",
                                        "children": []
                                    },
                                    {
                                        "id": "841",
                                        "linkid": "839",
                                        "code": "105010902",
                                        "paCode": "1050109",
                                        "yn": "N",
                                        "title": "竹制包装用品",
                                        "alias": "竹制包装用品",
                                        "about": "指包装用竹制品",
                                        "kws": "竹篓子、竹篮子、竹苫席、竹酒囤",
                                        "taxName": "竹制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050109020000000000",
                                        "taxCodeTitle": "竹制品",
                                        "iTitle": "*竹制品*竹制包装用品",
                                        "children": []
                                    },
                                    {
                                        "id": "842",
                                        "linkid": "839",
                                        "code": "105010903",
                                        "paCode": "1050109",
                                        "yn": "N",
                                        "title": "竹制炊事用具",
                                        "alias": "竹制炊事用具",
                                        "about": "指炊事用竹制品",
                                        "kws": "竹筷子、竹蒸笼、竹盖、竹饭桶、竹淘米、洗菜箩筐、竹砧板、竹锅盖、竹缸盖",
                                        "taxName": "竹制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050109030000000000",
                                        "taxCodeTitle": "竹制品",
                                        "iTitle": "*竹制品*竹制炊事用具",
                                        "children": []
                                    },
                                    {
                                        "id": "843",
                                        "linkid": "839",
                                        "code": "105010904",
                                        "paCode": "1050109",
                                        "yn": "N",
                                        "title": "竹编结制品，相关竹制品",
                                        "alias": "竹编结制品，相关竹制品",
                                        "about": "采用编结方法制成的竹制品",
                                        "kws": "竹帘、竹睡席、竹笼子、竹扇子、竹床笆、竹童车、竹斗笠、竹保温瓶壳、竹晒衣架",
                                        "taxName": "竹制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050109040000000000",
                                        "taxCodeTitle": "竹制品",
                                        "iTitle": "*竹制品*竹编结制品，相关竹制品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "844",
                                "linkid": "791",
                                "code": "1050110",
                                "paCode": "10501",
                                "yn": "Y",
                                "title": "棕、藤、草及类似制品",
                                "alias": "棕、藤、草及类似制品",
                                "about": "包括棕、藤、草、柳条、苇等类似制品",
                                "kws": null,
                                "taxName": "棕藤草制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1050110000000000000",
                                "taxCodeTitle": "棕藤草制品",
                                "iTitle": "*棕藤草制品*棕、藤、草及类似制品",
                                "children": [
                                    {
                                        "id": "845",
                                        "linkid": "844",
                                        "code": "105011001",
                                        "paCode": "1050110",
                                        "yn": "N",
                                        "title": "棕制品",
                                        "alias": "棕制品",
                                        "about": "由山棕的粽叶、棕丝、棕骨等制成的产品",
                                        "kws": "棕席、棕蓑衣、棕坐垫、棕蒲团、棕扫帚、棕笤帚",
                                        "taxName": "棕藤草制品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1050110010000000000",
                                        "taxCodeTitle": "棕藤草制品",
                                        "iTitle": "*棕藤草制品*棕制品",
                                        "children": []
                                    },
                                    {
                                        "id": "846",
                                        "linkid": "844",
                                        "code": "105011002",
                                        "paCode": "1050110",
                                        "yn": "N",
                                        "title": "藤制品",
                                        "alias": "藤制品",
                                        "about": "藤条经加工处理后制成的产品",
                                        "kws": "藤制席、藤枕头、藤垫子、藤包、藤篮、藤帽",
                                        "taxName": "棕藤草制品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1050110020000000000",
                                        "taxCodeTitle": "棕藤草制品",
                                        "iTitle": "*棕藤草制品*藤制品",
                                        "children": []
                                    },
                                    {
                                        "id": "847",
                                        "linkid": "844",
                                        "code": "105011003",
                                        "paCode": "1050110",
                                        "yn": "N",
                                        "title": "柳（荆）条制品",
                                        "alias": "柳（荆）条制品",
                                        "about": "柳（荆）条经加工处理后制成的产品",
                                        "kws": "柳条筐、柳条篓、柳条包、柳条箱、柳条篮、柳条帽",
                                        "taxName": "棕藤草制品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1050110030000000000",
                                        "taxCodeTitle": "棕藤草制品",
                                        "iTitle": "*棕藤草制品*柳（荆）条制品",
                                        "children": []
                                    },
                                    {
                                        "id": "848",
                                        "linkid": "844",
                                        "code": "105011004",
                                        "paCode": "1050110",
                                        "yn": "N",
                                        "title": "苇制品",
                                        "alias": "苇制品",
                                        "about": "芦苇经加工处理后制成的产品",
                                        "kws": "苇帘、苇席、苇箔",
                                        "taxName": "棕藤草制品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1050110040000000000",
                                        "taxCodeTitle": "棕藤草制品",
                                        "iTitle": "*棕藤草制品*苇制品",
                                        "children": []
                                    },
                                    {
                                        "id": "849",
                                        "linkid": "844",
                                        "code": "105011005",
                                        "paCode": "1050110",
                                        "yn": "N",
                                        "title": "草制品",
                                        "alias": "草制品",
                                        "about": "草经加工处理后制成的产品，不包括草帽（详见104020501）、草鞋（详见104020499）",
                                        "kws": "草席、草制篮筐、草蓑衣、草扫帚",
                                        "taxName": "棕藤草制品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1050110050000000000",
                                        "taxCodeTitle": "棕藤草制品",
                                        "iTitle": "*棕藤草制品*草制品",
                                        "children": []
                                    },
                                    {
                                        "id": "850",
                                        "linkid": "844",
                                        "code": "105011006",
                                        "paCode": "1050110",
                                        "yn": "N",
                                        "title": "玉米皮制篮筐，类似编结品",
                                        "alias": "玉米皮制篮筐，类似编结品",
                                        "about": null,
                                        "kws": "玉米皮制篮筐",
                                        "taxName": "棕藤草制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050110060000000000",
                                        "taxCodeTitle": "棕藤草制品",
                                        "iTitle": "*棕藤草制品*玉米皮制篮筐，类似编结品",
                                        "children": []
                                    },
                                    {
                                        "id": "851",
                                        "linkid": "844",
                                        "code": "105011099",
                                        "paCode": "1050110",
                                        "yn": "N",
                                        "title": "其他棕、藤、草及类似制品",
                                        "alias": "其他棕、藤、草及类似制品",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "棕藤草制品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1050110990000000000",
                                        "taxCodeTitle": "棕藤草制品",
                                        "iTitle": "*棕藤草制品*其他棕、藤、草及类似制品",
                                        "children": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "id": "852",
                        "linkid": "790",
                        "code": "10502",
                        "paCode": "105",
                        "yn": "Y",
                        "title": "家具及配件",
                        "alias": "家具及配件",
                        "about": null,
                        "kws": null,
                        "taxName": "家具及配件",
                        "taxRate": "",
                        "vip": "3",
                        "itaxRate": null,
                        "taxCode": "1050200000000000000",
                        "taxCodeTitle": "家具及配件",
                        "iTitle": "*家具及配件*家具及配件",
                        "children": [
                            {
                                "id": "853",
                                "linkid": "852",
                                "code": "1050201",
                                "paCode": "10502",
                                "yn": "Y",
                                "title": "家具",
                                "alias": "家具",
                                "about": null,
                                "kws": null,
                                "taxName": "家具",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1050201000000000000",
                                "taxCodeTitle": "家具",
                                "iTitle": "*家具*家具",
                                "children": [
                                    {
                                        "id": "851",
                                        "linkid": "850",
                                        "code": "105020098",
                                        "paCode": "1050198",
                                        "yn": "N",
                                        "title": "书柜",
                                        "alias": "书柜",
                                        "about": "指以天然木材和木质人造板为主要材料制作的家具，包括木质普通家具和木质工艺家具",
                                        "kws": "木质家具、木质普通家具、卧室用木质家具、木质床、木质床头柜、木质卧室柜、木质五斗橱、木质梳妆台、木质坐具、木质沙发、木质沙发床、办公室用木质家具、木质桌、木质柜、餐厅用木质家具、红木制客厅、餐厅用家具、漆木制客厅、厨房用木质家具、木质厨房整体橱柜、木质碗柜、木质工艺家具、红木雕刻工艺家具",
                                        "taxName": "家具",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050201010000000000",
                                        "taxCodeTitle": "家具",
                                        "iTitle": "*家具*书柜",
                                        "children": []
                                    },
                                    {
                                        "id": "852",
                                        "linkid": "851",
                                        "code": "105020099",
                                        "paCode": "1050199",
                                        "yn": "N",
                                        "title": "办公桌",
                                        "alias": "办公桌",
                                        "about": "指以天然木材和木质人造板为主要材料制作的家具，包括木质普通家具和木质工艺家具",
                                        "kws": "木质家具、木质普通家具、卧室用木质家具、木质床、木质床头柜、木质卧室柜、木质五斗橱、木质梳妆台、木质坐具、木质沙发、木质沙发床、办公室用木质家具、木质桌、木质柜、餐厅用木质家具、红木制客厅、餐厅用家具、漆木制客厅、厨房用木质家具、木质厨房整体橱柜、木质碗柜、木质工艺家具、红木雕刻工艺家具",
                                        "taxName": "家具",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050201010000000000",
                                        "taxCodeTitle": "家具",
                                        "iTitle": "*家具*办公桌",
                                        "children": []
                                    },
                                    {
                                        "id": "853",
                                        "linkid": "852",
                                        "code": "105020100",
                                        "paCode": "1050200",
                                        "yn": "N",
                                        "title": "实木床",
                                        "alias": "实木床",
                                        "about": "指以天然木材和木质人造板为主要材料制作的家具，包括木质普通家具和木质工艺家具",
                                        "kws": "木质家具、木质普通家具、卧室用木质家具、木质床、木质床头柜、木质卧室柜、木质五斗橱、木质梳妆台、木质坐具、木质沙发、木质沙发床、办公室用木质家具、木质桌、木质柜、餐厅用木质家具、红木制客厅、餐厅用家具、漆木制客厅、厨房用木质家具、木质厨房整体橱柜、木质碗柜、木质工艺家具、红木雕刻工艺家具",
                                        "taxName": "家具",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050201010000000000",
                                        "taxCodeTitle": "家具",
                                        "iTitle": "*家具*实木床",
                                        "children": []
                                    },
                                    {
                                        "id": "854",
                                        "linkid": "853",
                                        "code": "105020101",
                                        "paCode": "1050201",
                                        "yn": "N",
                                        "title": "木质家具",
                                        "alias": "木质家具",
                                        "about": "指以天然木材和木质人造板为主要材料制作的家具，包括木质普通家具和木质工艺家具",
                                        "kws": "木质家具、木质普通家具、卧室用木质家具、木质床、木质床头柜、木质卧室柜、木质五斗橱、木质梳妆台、木质坐具、木质沙发、木质沙发床、办公室用木质家具、木质桌、木质柜、餐厅用木质家具、红木制客厅、餐厅用家具、漆木制客厅、厨房用木质家具、木质厨房整体橱柜、木质碗柜、木质工艺家具、红木雕刻工艺家具",
                                        "taxName": "家具",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050201010000000000",
                                        "taxCodeTitle": "家具",
                                        "iTitle": "*家具*木质家具",
                                        "children": []
                                    },

                                    {
                                        "id": "855",
                                        "linkid": "853",
                                        "code": "105020102",
                                        "paCode": "1050201",
                                        "yn": "N",
                                        "title": "竹家具",
                                        "alias": "竹家具",
                                        "about": "指以天然竹材和人造竹材为主要材料制作的家具，包括竹材普通家具和竹材工艺家具",
                                        "kws": "竹床、竹制卧室柜、竹制五斗橱、竹制梳妆台、竹制坐具、竹椅、竹凳、竹躺椅、竹制沙发、竹制桌、竹桌、竹茶几、竹制柜、竹制箱",
                                        "taxName": "家具",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050201020000000000",
                                        "taxCodeTitle": "家具",
                                        "iTitle": "*家具*竹家具",
                                        "children": []
                                    },
                                    {
                                        "id": "856",
                                        "linkid": "853",
                                        "code": "105020103",
                                        "paCode": "1050201",
                                        "yn": "N",
                                        "title": "藤家具",
                                        "alias": "藤家具",
                                        "about": null,
                                        "kws": "藤床、藤制卧室柜、藤制五斗橱、藤制梳妆台、藤制桌、藤桌、藤茶几、藤制坐具、藤椅、藤凳、藤躺椅、藤制沙发、藤制柜、藤制箱",
                                        "taxName": "家具",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050201030000000000",
                                        "taxCodeTitle": "家具",
                                        "iTitle": "*家具*藤家具",
                                        "children": []
                                    },
                                    {
                                        "id": "857",
                                        "linkid": "853",
                                        "code": "105020104",
                                        "paCode": "1050201",
                                        "yn": "N",
                                        "title": "金属家具",
                                        "alias": "金属家具",
                                        "about": "指主要结构是金属的家具",
                                        "kws": "金属制坐具、飞机用坐具、机动车辆用坐具、金属底座转动坐具、金属框架沙发、金属框架沙发床、金属框架躺椅、金属椅、金属框架凳、金属制床、钢木床、铜床、办公室用金属家具、金属衣帽柜、金属框架电脑桌、钢木桌、厨房用金属家具、不锈钢厨房整体橱柜、金属架家具、金属书架、金属花架、金属框架屏风",
                                        "taxName": "家具",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050201040000000000",
                                        "taxCodeTitle": "家具",
                                        "iTitle": "*家具*金属家具",
                                        "children": []
                                    },
                                    {
                                        "id": "858",
                                        "linkid": "853",
                                        "code": "105020105",
                                        "paCode": "1050201",
                                        "yn": "N",
                                        "title": "塑料家具",
                                        "alias": "塑料家具",
                                        "about": "指主要结构是塑料的家具",
                                        "kws": "塑料坐具、塑料制电脑椅、塑料桌、塑料柜、塑料架家具、软体家具、软体坐具、软体沙发、床垫、褥垫、弹簧床垫、棕制床垫、海绵橡胶制褥垫、泡沫塑料制褥垫",
                                        "taxName": "家具",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050201050000000000",
                                        "taxCodeTitle": "家具",
                                        "iTitle": "*家具*塑料家具",
                                        "children": []
                                    },
                                    {
                                        "id": "859",
                                        "linkid": "853",
                                        "code": "105020106",
                                        "paCode": "1050201",
                                        "yn": "N",
                                        "title": "软体家具",
                                        "alias": "软体家具",
                                        "about": "指的是以海绵、织物为主体的家具。例如沙发、床等家具。",
                                        "kws": "休闲布艺、真皮、仿皮、皮加布类的沙发、软床",
                                        "taxName": "家具",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050201060000000000",
                                        "taxCodeTitle": "家具",
                                        "iTitle": "*家具*软体家具",
                                        "children": []
                                    },
                                    {
                                        "id": "860",
                                        "linkid": "853",
                                        "code": "105020107",
                                        "paCode": "1050201",
                                        "yn": "N",
                                        "title": "玻璃、玻璃纤维增强塑料家具",
                                        "alias": "玻璃、玻璃纤维增强塑料家具",
                                        "about": "指主要结构是玻璃、玻璃纤维增强塑料的家具",
                                        "kws": "玻璃家具、玻璃桌、玻璃柜、玻璃茶几、玻璃纤维增强塑料坐具、玻璃钢餐椅、玻璃钢课椅、玻璃钢等候椅、玻璃钢运动场座椅、玻璃钢公园休闲椅、玻璃钢餐桌、玻璃钢课桌、玻璃钢制茶几",
                                        "taxName": "家具",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050201070000000000",
                                        "taxCodeTitle": "家具",
                                        "iTitle": "*家具*玻璃、玻璃纤维增强塑料家具",
                                        "children": []
                                    },
                                    {
                                        "id": "861",
                                        "linkid": "853",
                                        "code": "105020108",
                                        "paCode": "1050201",
                                        "yn": "N",
                                        "title": "石头、陶瓷制家具",
                                        "alias": "石头、陶瓷制家具",
                                        "about": "指主要结构是石头、陶瓷的家具",
                                        "kws": "石制家具、石制坐具、陶瓷制家具、陶瓷桌、陶瓷椅、凳",
                                        "taxName": "家具",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050201080000000000",
                                        "taxCodeTitle": "家具",
                                        "iTitle": "*家具*石头、陶瓷制家具",
                                        "children": []
                                    },
                                    {
                                        "id": "862",
                                        "linkid": "853",
                                        "code": "105020199",
                                        "paCode": "1050201",
                                        "yn": "N",
                                        "title": "其他家具",
                                        "alias": "其他家具",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "家具",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050201990000000000",
                                        "taxCodeTitle": "家具",
                                        "iTitle": "*家具*其他家具",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "863",
                                "linkid": "852",
                                "code": "1050202",
                                "paCode": "10502",
                                "yn": "Y",
                                "title": "家具配件",
                                "alias": "家具配件",
                                "about": null,
                                "kws": null,
                                "taxName": "家具配件",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1050202000000000000",
                                "taxCodeTitle": "家具配件",
                                "iTitle": "*家具配件*家具配件",
                                "children": [
                                    {
                                        "id": "863",
                                        "linkid": "862",
                                        "code": "105020200",
                                        "paCode": "1050201",
                                        "yn": "N",
                                        "title": "五金配件",
                                        "alias": "五金配件",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "家具配件",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050202040000000000",
                                        "taxCodeTitle": "家具配件",
                                        "iTitle": "*家具配件*五金配件",
                                        "children": []
                                    },
                                    {
                                        "id": "864",
                                        "linkid": "863",
                                        "code": "105020201",
                                        "paCode": "1050202",
                                        "yn": "N",
                                        "title": "木质家具零配件",
                                        "alias": "木质家具零配件",
                                        "about": "不包括坐具零配件（详见105020208）",
                                        "kws": "木质床板、木质床架",
                                        "taxName": "家具配件",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050202010000000000",
                                        "taxCodeTitle": "家具配件",
                                        "iTitle": "*家具配件*木质家具零配件",
                                        "children": []
                                    },
                                    {
                                        "id": "865",
                                        "linkid": "863",
                                        "code": "105020202",
                                        "paCode": "1050202",
                                        "yn": "N",
                                        "title": "竹家具零配件",
                                        "alias": "竹家具零配件",
                                        "about": "不包括坐具零配件（详见105020208）",
                                        "kws": "竹家具零配件、竹床板、竹床架",
                                        "taxName": "家具配件",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050202020000000000",
                                        "taxCodeTitle": "家具配件",
                                        "iTitle": "*家具配件*竹家具零配件",
                                        "children": []
                                    },
                                    {
                                        "id": "866",
                                        "linkid": "863",
                                        "code": "105020203",
                                        "paCode": "1050202",
                                        "yn": "N",
                                        "title": "藤家具零配件",
                                        "alias": "藤家具零配件",
                                        "about": "不包括坐具零配件（详见105020208）",
                                        "kws": "藤家具零配件、藤床架",
                                        "taxName": "家具配件",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050202030000000000",
                                        "taxCodeTitle": "家具配件",
                                        "iTitle": "*家具配件*藤家具零配件",
                                        "children": []
                                    },
                                    {
                                        "id": "867",
                                        "linkid": "863",
                                        "code": "105020204",
                                        "paCode": "1050202",
                                        "yn": "N",
                                        "title": "金属家具零配件",
                                        "alias": "金属家具零配件",
                                        "about": "不包括坐具零配件（详见105020208）",
                                        "kws": "金属家具零配件、钢床架、钢床绷、铜床架",
                                        "taxName": "家具配件",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050202040000000000",
                                        "taxCodeTitle": "家具配件",
                                        "iTitle": "*家具配件*金属家具零配件",
                                        "children": []
                                    },
                                    {
                                        "id": "868",
                                        "linkid": "863",
                                        "code": "105020205",
                                        "paCode": "1050202",
                                        "yn": "N",
                                        "title": "塑料家具零配件",
                                        "alias": "塑料家具零配件",
                                        "about": "不包括坐具零配件（详见105020208）",
                                        "kws": "塑料家具零配件",
                                        "taxName": "家具配件",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050202050000000000",
                                        "taxCodeTitle": "家具配件",
                                        "iTitle": "*家具配件*塑料家具零配件",
                                        "children": []
                                    },
                                    {
                                        "id": "869",
                                        "linkid": "863",
                                        "code": "105020206",
                                        "paCode": "1050202",
                                        "yn": "N",
                                        "title": "软体家具零配件",
                                        "alias": "软体家具零配件",
                                        "about": "不包括坐具零配件（详见105020208）",
                                        "kws": "软体家具零配件",
                                        "taxName": "家具配件",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050202060000000000",
                                        "taxCodeTitle": "家具配件",
                                        "iTitle": "*家具配件*软体家具零配件",
                                        "children": []
                                    },
                                    {
                                        "id": "870",
                                        "linkid": "863",
                                        "code": "105020207",
                                        "paCode": "1050202",
                                        "yn": "N",
                                        "title": "玻璃家具零配件",
                                        "alias": "玻璃家具零配件",
                                        "about": "不包括坐具零配件（详见105020208）",
                                        "kws": "玻璃家具零配件",
                                        "taxName": "家具配件",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050202070000000000",
                                        "taxCodeTitle": "家具配件",
                                        "iTitle": "*家具配件*玻璃家具零配件",
                                        "children": []
                                    },
                                    {
                                        "id": "871",
                                        "linkid": "863",
                                        "code": "105020208",
                                        "paCode": "1050202",
                                        "yn": "N",
                                        "title": "坐具零配件",
                                        "alias": "坐具零配件",
                                        "about": null,
                                        "kws": "坐具零配件",
                                        "taxName": "家具配件",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050202080000000000",
                                        "taxCodeTitle": "家具配件",
                                        "iTitle": "*家具配件*坐具零配件",
                                        "children": []
                                    },
                                    {
                                        "id": "872",
                                        "linkid": "863",
                                        "code": "105020299",
                                        "paCode": "1050202",
                                        "yn": "N",
                                        "title": "其他家具配件",
                                        "alias": "其他家具配件",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "家具配件",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1050202990000000000",
                                        "taxCodeTitle": "家具配件",
                                        "iTitle": "*家具配件*其他家具配件",
                                        "children": []
                                    },
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "id": "873",
                "linkid": "1",
                "code": "106",
                "paCode": "1",
                "yn": "Y",
                "title": "纸、印刷品、软件、文教、工艺品类产品",
                "alias": "纸、印刷品、软件、文教、工艺品类产品",
                "about": null,
                "kws": null,
                "taxName": "纸印刷品文教产品",
                "taxRate": "",
                "vip": "3",
                "itaxRate": null,
                "taxCode": "1060000000000000000",
                "taxCodeTitle": "纸印刷品文教产品",
                "iTitle": "*纸印刷品文教产品*纸、印刷品、软件、文教、工艺品类产品",
                "children": [
                    {
                        "id": "874",
                        "linkid": "873",
                        "code": "10601",
                        "paCode": "106",
                        "yn": "Y",
                        "title": "纸及纸制品",
                        "alias": "纸及纸制品",
                        "about": null,
                        "kws": null,
                        "taxName": "纸制品",
                        "taxRate": "",
                        "vip": "3",
                        "itaxRate": null,
                        "taxCode": "1060100000000000000",
                        "taxCodeTitle": "纸制品",
                        "iTitle": "*纸制品*纸及纸制品",
                        "children": [
                            {
                                "id": "875",
                                "linkid": "874",
                                "code": "1060101",
                                "paCode": "10601",
                                "yn": "Y",
                                "title": "纸浆",
                                "alias": "纸浆",
                                "about": "指原生浆及废纸浆，包括木浆，非木材纤维纸浆[如：苇（荻）浆、竹浆、蔗渣浆、麦草浆、稻草浆（禾草浆）、麻浆、棉短绒纸浆等]，废纸纸浆，再生纸浆，化学溶解浆，以及其他原生纸浆。不包括纺织用化学浆粕（详见1070401）。",
                                "kws": null,
                                "taxName": "纸制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1060101000000000000",
                                "taxCodeTitle": "纸制品",
                                "iTitle": "*纸制品*纸浆",
                                "children": [
                                    {
                                        "id": "876",
                                        "linkid": "875",
                                        "code": "106010101",
                                        "paCode": "1060101",
                                        "yn": "N",
                                        "title": "木浆",
                                        "alias": "木浆",
                                        "about": "包括磨石磨木浆、木片磨木浆、漂白化学木浆、未漂白化学木浆、化学机械木浆等。",
                                        "kws": "木浆、磨石磨木浆、木片磨木浆、漂白化学木浆、未漂白化学木浆、化学机械木浆",
                                        "taxName": "纸制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060101010000000000",
                                        "taxCodeTitle": "纸制品",
                                        "iTitle": "*纸制品*木浆",
                                        "children": []
                                    },
                                    {
                                        "id": "877",
                                        "linkid": "875",
                                        "code": "106010102",
                                        "paCode": "1060101",
                                        "yn": "N",
                                        "title": "非木材纤维纸浆",
                                        "alias": "非木材纤维纸浆",
                                        "about": "不包括秸秆浆（详见106010105）。",
                                        "kws": "非木材纤维纸浆、苇浆、荻浆、竹浆、棉短绒纸浆",
                                        "taxName": "纸制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060101020000000000",
                                        "taxCodeTitle": "纸制品",
                                        "iTitle": "*纸制品*非木材纤维纸浆",
                                        "children": []
                                    },
                                    {
                                        "id": "878",
                                        "linkid": "875",
                                        "code": "106010103",
                                        "paCode": "1060101",
                                        "yn": "N",
                                        "title": "废纸纸浆",
                                        "alias": "废纸纸浆",
                                        "about": "指采用回收纸和纸制品制造的纸浆。",
                                        "kws": "废纸纸浆、脱墨废纸浆、未脱墨废纸浆",
                                        "taxName": "纸制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060101030000000000",
                                        "taxCodeTitle": "纸制品",
                                        "iTitle": "*纸制品*废纸纸浆",
                                        "children": []
                                    },
                                    {
                                        "id": "879",
                                        "linkid": "875",
                                        "code": "106010104",
                                        "paCode": "1060101",
                                        "yn": "N",
                                        "title": "化学溶解浆",
                                        "alias": "化学溶解浆",
                                        "about": "指在制浆过程中除去了木素和半纤维素,只保留纤维素的高纯度精制化学浆。",
                                        "kws": "化学溶解浆",
                                        "taxName": "纸制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060101040000000000",
                                        "taxCodeTitle": "纸制品",
                                        "iTitle": "*纸制品*化学溶解浆",
                                        "children": []
                                    },
                                    {
                                        "id": "880",
                                        "linkid": "875",
                                        "code": "106010105",
                                        "paCode": "1060101",
                                        "yn": "N",
                                        "title": "秸秆浆",
                                        "alias": "秸秆浆",
                                        "about": "含蔗渣浆、麦草浆、稻草浆（禾草浆）、麻浆。",
                                        "kws": "秸秆浆、蔗渣浆、麦草浆、稻草浆、禾草浆、麻浆",
                                        "taxName": "纸制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060101050000000000",
                                        "taxCodeTitle": "纸制品",
                                        "iTitle": "*纸制品*秸秆浆",
                                        "children": []
                                    },
                                    {
                                        "id": "881",
                                        "linkid": "875",
                                        "code": "106010106",
                                        "paCode": "1060101",
                                        "yn": "N",
                                        "title": "再生纸浆",
                                        "alias": "再生纸浆",
                                        "about": "废铝塑（纸铝、纸塑）复合纸包装材料生产的纸浆。",
                                        "kws": "再生纸浆",
                                        "taxName": "纸制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060101060000000000",
                                        "taxCodeTitle": "纸制品",
                                        "iTitle": "*纸制品*再生纸浆",
                                        "children": []
                                    },
                                    {
                                        "id": "882",
                                        "linkid": "875",
                                        "code": "106010199",
                                        "paCode": "1060101",
                                        "yn": "N",
                                        "title": "其他纸浆",
                                        "alias": "其他纸浆",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "纸制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060101990000000000",
                                        "taxCodeTitle": "纸制品",
                                        "iTitle": "*纸制品*其他纸浆",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "883",
                                "linkid": "874",
                                "code": "1060102",
                                "paCode": "10601",
                                "yn": "Y",
                                "title": "机制纸及纸板",
                                "alias": "机制纸及纸板",
                                "about": "包括未涂布印刷书写用纸、涂布类印刷用纸、卫生用纸原纸、包装用纸及纸板、感应纸及纸板、纤维类过滤纸及纸板、其他机制纸及纸板。不包括外购原纸加工（详见1060103）。",
                                "kws": "机制纸、纸板",
                                "taxName": "纸制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1060102000000000000",
                                "taxCodeTitle": "纸制品",
                                "iTitle": "*纸制品*机制纸及纸板",
                                "children": [
                                    {
                                        "id": "884",
                                        "linkid": "883",
                                        "code": "106010201",
                                        "paCode": "1060102",
                                        "yn": "N",
                                        "title": "未涂布印刷书写用纸",
                                        "alias": "未涂布印刷书写用纸",
                                        "about": "包括新闻纸、书写印刷纸、其他未涂布印刷书写用纸，不包括外购原纸加工（详见1060103）。",
                                        "kws": "未涂布印刷书写用纸、超级压光纸、书写纸、胶版纸、复印原纸",
                                        "taxName": "纸制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060102010000000000",
                                        "taxCodeTitle": "纸制品",
                                        "iTitle": "*纸制品*未涂布印刷书写用纸",
                                        "children": []
                                    },
                                    {
                                        "id": "885",
                                        "linkid": "883",
                                        "code": "106010202",
                                        "paCode": "1060102",
                                        "yn": "N",
                                        "title": "涂布类印刷用纸",
                                        "alias": "涂布类印刷用纸",
                                        "about": "指涂有高岭土或其他无机物质的纸和纸板，包括铜版纸、轻量涂布纸、其他涂布类印刷用纸。",
                                        "kws": "涂布类印刷用纸、铜版纸、轻量涂布纸",
                                        "taxName": "纸制品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060102020000000000",
                                        "taxCodeTitle": "纸制品",
                                        "iTitle": "*纸制品*涂布类印刷用纸",
                                        "children": []
                                    },
                                    {
                                        "id": "886",
                                        "linkid": "883",
                                        "code": "106010203",
                                        "paCode": "1060102",
                                        "yn": "N",
                                        "title": "卫生用纸原纸",
                                        "alias": "卫生用纸原纸",
                                        "about": "指成卷或成张的卫生纸、面巾纸、餐巾纸等卫生用纸的原纸，包括卫生纸原纸、面巾纸原纸、餐巾纸原纸、其他卫生用纸原纸。",
                                        "kws": "卫生纸原纸、面巾纸原纸、餐巾纸原纸",
                                        "taxName": "纸制品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060102030000000000",
                                        "taxCodeTitle": "纸制品",
                                        "iTitle": "*纸制品*卫生用纸原纸",
                                        "children": []
                                    },
                                    {
                                        "id": "887",
                                        "linkid": "883",
                                        "code": "106010204",
                                        "paCode": "1060102",
                                        "yn": "N",
                                        "title": "包装用纸及纸板",
                                        "alias": "包装用纸及纸板",
                                        "about": "包括包装纸、箱纸板、白纸板、瓦楞原纸、工业技术配套用纸、其他包装用纸及纸板，无论是否涂布均属此类。",
                                        "kws": "包装纸、箱纸板、白纸板、瓦楞原纸、工业技术配套用纸、包装用纸、包装用纸板、袋用牛皮纸、薄页类包装纸、牛皮挂面箱纸板、挂面箱纸板、涂布箱纸板、白卡纸、白底白纸板、灰底白纸板、半化学瓦楞原纸、草浆瓦楞原纸、卷烟纸、装饰原纸、建筑用纸、纸管原纸、电器绝缘用纸",
                                        "taxName": "纸制品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060102040000000000",
                                        "taxCodeTitle": "纸制品",
                                        "iTitle": "*纸制品*包装用纸及纸板",
                                        "children": []
                                    },
                                    {
                                        "id": "888",
                                        "linkid": "883",
                                        "code": "106010205",
                                        "paCode": "1060102",
                                        "yn": "N",
                                        "title": "感应纸及纸板",
                                        "alias": "感应纸及纸板",
                                        "about": "包括光敏、热敏、压敏及其他感应纸及纸板的原纸和原纸板。",
                                        "kws": "感应纸、感应纸板、照相原纸、热敏纸原纸、热敏纸原纸板、压敏纸原纸、压敏纸原纸板",
                                        "taxName": "纸制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060102050000000000",
                                        "taxCodeTitle": "纸制品",
                                        "iTitle": "*纸制品*感应纸及纸板",
                                        "children": []
                                    },
                                    {
                                        "id": "889",
                                        "linkid": "883",
                                        "code": "106010206",
                                        "paCode": "1060102",
                                        "yn": "N",
                                        "title": "纤维类过滤纸及纸板",
                                        "alias": "纤维类过滤纸及纸板",
                                        "about": "包括油滤纸及纸板、空气过滤纸及纸板、液体过滤纸及纸板、其他纤维类过滤纸及纸板。",
                                        "kws": "纤维类过滤纸、纤维类纸板、油滤纸、油滤纸板、空气过滤纸、空气过滤纸板、液体过滤纸、液体过滤纸板",
                                        "taxName": "纸制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060102060000000000",
                                        "taxCodeTitle": "纸制品",
                                        "iTitle": "*纸制品*纤维类过滤纸及纸板",
                                        "children": []
                                    },
                                    {
                                        "id": "890",
                                        "linkid": "883",
                                        "code": "106010299",
                                        "paCode": "1060102",
                                        "yn": "N",
                                        "title": "其他机制纸及纸板",
                                        "alias": "其他机制纸及纸板",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "纸制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060102990000000000",
                                        "taxCodeTitle": "纸制品",
                                        "iTitle": "*纸制品*其他机制纸及纸板",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "891",
                                "linkid": "874",
                                "code": "1060103",
                                "paCode": "10601",
                                "yn": "Y",
                                "title": "加工纸",
                                "alias": "加工纸",
                                "about": "指对原纸或纸板等成品纸进行再次加工处理而成的纸，包括美纹或穿孔纸及纸板、转印纸、油印蜡纸或胶印版纸、涂布浸渍覆盖纸、瓦楞纸板、其他加工纸。",
                                "kws": null,
                                "taxName": "纸制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1060103000000000000",
                                "taxCodeTitle": "纸制品",
                                "iTitle": "*纸制品*加工纸",
                                "children": [
                                    {
                                        "id": "892",
                                        "linkid": "891",
                                        "code": "106010301",
                                        "paCode": "1060103",
                                        "yn": "N",
                                        "title": "美纹、穿孔纸及纸板",
                                        "alias": "美纹、穿孔纸及纸板",
                                        "about": "包括美纹纸及纸板、穿孔纸及纸板。",
                                        "kws": "美纹纸、美纹纸板、穿孔纸、穿孔纸纸板",
                                        "taxName": "纸制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060103010000000000",
                                        "taxCodeTitle": "纸制品",
                                        "iTitle": "*纸制品*美纹、穿孔纸及纸板",
                                        "children": []
                                    },
                                    {
                                        "id": "893",
                                        "linkid": "891",
                                        "code": "106010302",
                                        "paCode": "1060103",
                                        "yn": "N",
                                        "title": "转印纸",
                                        "alias": "转印纸",
                                        "about": "包括静电复印纸、复写纸、热敏纸（即热成像纸）、工业转移印刷纸、其他转印纸。",
                                        "kws": "转印纸、静电复印纸、无碳复写纸、涂碳复写纸、热敏纸、工业转移印刷纸",
                                        "taxName": "纸制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060103020000000000",
                                        "taxCodeTitle": "纸制品",
                                        "iTitle": "*纸制品*转印纸",
                                        "children": []
                                    },
                                    {
                                        "id": "894",
                                        "linkid": "891",
                                        "code": "106010303",
                                        "paCode": "1060103",
                                        "yn": "N",
                                        "title": "油印蜡纸或胶印版纸",
                                        "alias": "油印蜡纸或胶印版纸",
                                        "about": "包括油印蜡纸、胶印版纸。",
                                        "kws": "油印蜡纸、胶印版纸",
                                        "taxName": "纸制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060103030000000000",
                                        "taxCodeTitle": "纸制品",
                                        "iTitle": "*纸制品*油印蜡纸或胶印版纸",
                                        "children": []
                                    },
                                    {
                                        "id": "895",
                                        "linkid": "891",
                                        "code": "106010304",
                                        "paCode": "1060103",
                                        "yn": "N",
                                        "title": "涂布浸渍覆盖纸",
                                        "alias": "涂布浸渍覆盖纸",
                                        "about": "指涂有蜡、树脂、胶、塑料等涂布的成卷成张矩形涂布浸渍覆盖染面饰面或印花纸，包括焦油纸及纸板、沥青纸及纸板、胶粘纸及纸板、塑料涂布或浸渍或覆盖纸及纸板、用蜡或石蜡浸涂纸、用硬脂精或油或甘油浸涂纸、其他涂布浸渍覆盖纸。",
                                        "kws": "涂布浸渍覆盖纸、焦油纸、焦油纸纸板、沥青纸、沥青纸纸板、粘胶纸、粘胶纸纸板、自粘胶粘纸、彩色相纸用双面涂塑纸、漂白纸、绝缘纸、绝缘纸纸板",
                                        "taxName": "纸制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060103040000000000",
                                        "taxCodeTitle": "纸制品",
                                        "iTitle": "*纸制品*涂布浸渍覆盖纸",
                                        "children": []
                                    },
                                    {
                                        "id": "896",
                                        "linkid": "891",
                                        "code": "106010305",
                                        "paCode": "1060103",
                                        "yn": "N",
                                        "title": "瓦楞纸板",
                                        "alias": "瓦楞纸板",
                                        "about": "指由至少一层瓦楞纸和一层箱板纸(也叫箱纸板)粘合而成的纸板。",
                                        "kws": "瓦楞纸板",
                                        "taxName": "纸制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060103050000000000",
                                        "taxCodeTitle": "纸制品",
                                        "iTitle": "*纸制品*瓦楞纸板",
                                        "children": []
                                    },
                                    {
                                        "id": "897",
                                        "linkid": "891",
                                        "code": "106010399",
                                        "paCode": "1060103",
                                        "yn": "N",
                                        "title": "其他加工纸",
                                        "alias": "其他加工纸",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "纸制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060103990000000000",
                                        "taxCodeTitle": "纸制品",
                                        "iTitle": "*纸制品*其他加工纸",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "898",
                                "linkid": "874",
                                "code": "1060104",
                                "paCode": "10601",
                                "yn": "Y",
                                "title": "手工制纸及纸板",
                                "alias": "手工制纸及纸板",
                                "about": "包括手工纸和手工纸板。",
                                "kws": null,
                                "taxName": "纸制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1060104000000000000",
                                "taxCodeTitle": "纸制品",
                                "iTitle": "*纸制品*手工制纸及纸板",
                                "children": [
                                    {
                                        "id": "899",
                                        "linkid": "898",
                                        "code": "106010401",
                                        "paCode": "1060104",
                                        "yn": "N",
                                        "title": "手工纸",
                                        "alias": "手工纸",
                                        "about": "包括宣纸、国画纸、其他手工纸。",
                                        "kws": "手工纸、宣纸、国画纸",
                                        "taxName": "纸制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060104010000000000",
                                        "taxCodeTitle": "纸制品",
                                        "iTitle": "*纸制品*手工纸",
                                        "children": []
                                    },
                                    {
                                        "id": "900",
                                        "linkid": "898",
                                        "code": "106010402",
                                        "paCode": "1060104",
                                        "yn": "N",
                                        "title": "手工纸板",
                                        "alias": "手工纸板",
                                        "about": null,
                                        "kws": "手工纸板",
                                        "taxName": "纸制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060104020000000000",
                                        "taxCodeTitle": "纸制品",
                                        "iTitle": "*纸制品*手工纸板",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "901",
                                "linkid": "874",
                                "code": "1060105",
                                "paCode": "10601",
                                "yn": "Y",
                                "title": "纸制品",
                                "alias": "纸制品",
                                "about": "指用纸或纸板为原料进一步加工而成的纸的制品，包括纸和纸板容器，纸制文具及办公用品，纸浆模制品，用成卷或成张的卫生用纸原纸为原料进一步加工而成的卫生用纸制品，纸制壁纸、窗纸、铺地制品及类似品，纸浆制滤块、滤板及滤片，纸或纸板制标签，纸制筒管、卷轴、纡子及类似品，神纸及类似用品，纸扇以及未列明的其他纸制品。",
                                "kws": null,
                                "taxName": "纸制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1060105000000000000",
                                "taxCodeTitle": "纸制品",
                                "iTitle": "*纸制品*纸制品",
                                "children": [
                                    {
                                        "id": "902",
                                        "linkid": "901",
                                        "code": "106010501",
                                        "paCode": "1060105",
                                        "yn": "N",
                                        "title": "纸和纸板制容器",
                                        "alias": "纸和纸板制容器",
                                        "about": "指用纸或纸板制的各种容器，包括瓦楞纸及纸板容器、非瓦楞纸及纸板容器、纸袋、纸制餐具、其他纸和纸板制容器。不包括纸制文具及办公用品（详见106010502）。",
                                        "kws": "纸制容器、纸板制容器、瓦楞纸箱、瓦楞纸盒、瓦楞纸匣、可折叠纸箱、可折叠纸盒、可折叠纸匣、纸袋、锥形纸袋、手提纸袋、纸杯、纸餐盒、纸制盘、纸制碟、纸碗",
                                        "taxName": "纸制品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060105010000000000",
                                        "taxCodeTitle": "纸制品",
                                        "iTitle": "*纸制品*纸和纸板制容器",
                                        "children": []
                                    },
                                    {
                                        "id": "903",
                                        "linkid": "901",
                                        "code": "106010502",
                                        "paCode": "1060105",
                                        "yn": "N",
                                        "title": "纸制文具及用品",
                                        "alias": "纸制文具及用品",
                                        "about": "指用纸或纸板为原料进一步加工而成的纸制文具及办公用品。包括纸制卷宗盒、信件盘、存储盒、文件袋（夹）、信封、明信片类制品等。不包括练习本、账册、集邮簿等本册（详见1060202）",
                                        "kws": "纸制文具、纸制办公用品、纸制卷宗盒、纸制信件盘、纸制存储盒、纸制唱片套、纸制文件袋、纸制文件夹、信封",
                                        "taxName": "纸制品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060105020000000000",
                                        "taxCodeTitle": "纸制品",
                                        "iTitle": "*纸制品*纸制文具及用品",
                                        "children": []
                                    },
                                    {
                                        "id": "904",
                                        "linkid": "901",
                                        "code": "106010503",
                                        "paCode": "1060105",
                                        "yn": "N",
                                        "title": "纸浆模制品",
                                        "alias": "纸浆模制品",
                                        "about": "指压制或模制纸浆制品，包括一次性纸浆模餐具、方便面碗、纸浆模制超市托盒（盘）、医用一次性托盘和用具、精密工业品包装纸浆模制品、其他纸浆模制品。",
                                        "kws": "纸浆模制品、一次性纸浆模餐具、方便面碗、纸浆模制超市托盒、纸浆模制超市托盘、医用一次性托盘、精密工业品包装纸浆模制品",
                                        "taxName": "纸制品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060105030000000000",
                                        "taxCodeTitle": "纸制品",
                                        "iTitle": "*纸制品*纸浆模制品",
                                        "children": []
                                    },
                                    {
                                        "id": "905",
                                        "linkid": "901",
                                        "code": "106010504",
                                        "paCode": "1060105",
                                        "yn": "N",
                                        "title": "卫生用纸制品",
                                        "alias": "卫生用纸制品",
                                        "about": "指用成卷或成张的卫生用纸原纸为原料,进一步加工而成的卫生用纸制品（含一次性卫生制品），包括卫生纸、纸手帕及面巾纸、纸餐巾、纸台布、纸卫生巾、纸止血塞、纸尿布、尿布衬里、纸浆或纸或纤维素絮制服装、卫生用纸制品。",
                                        "kws": "卫生用纸制品、卫生纸、纸手帕、面巾纸、纸餐巾、纸台布、纸卫生巾、纸止血塞、纸尿布、尿布衬里",
                                        "taxName": "纸制品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060105040000000000",
                                        "taxCodeTitle": "纸制品",
                                        "iTitle": "*纸制品*卫生用纸制品",
                                        "children": []
                                    },
                                    {
                                        "id": "906",
                                        "linkid": "901",
                                        "code": "106010505",
                                        "paCode": "1060105",
                                        "yn": "N",
                                        "title": "纸制壁纸、窗纸、铺地制品及类似品",
                                        "alias": "纸制壁纸、窗纸、铺地制品及类似品",
                                        "about": "包括壁纸及类似品、纸制窗纸及类似品、纸制铺地制品及类似品。",
                                        "kws": "木粒饰面壁纸、草粒饰面壁纸、塑料涂面壁纸、塑料盖面壁纸、编结材料盖面壁纸、纺织材料糊墙纸、窗用透明纸、纸制铺地制品",
                                        "taxName": "纸制品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060105050000000000",
                                        "taxCodeTitle": "纸制品",
                                        "iTitle": "*纸制品*纸制壁纸、窗纸、铺地制品及类似品",
                                        "children": []
                                    },
                                    {
                                        "id": "907",
                                        "linkid": "901",
                                        "code": "106010506",
                                        "paCode": "1060105",
                                        "yn": "N",
                                        "title": "纸浆制滤块、滤板及滤片",
                                        "alias": "纸浆制滤块、滤板及滤片",
                                        "about": "包括纸浆制滤块、纸浆制滤板及滤片。",
                                        "kws": "纸浆制滤块、纸浆制滤板、纸浆制滤片",
                                        "taxName": "纸制品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060105060000000000",
                                        "taxCodeTitle": "纸制品",
                                        "iTitle": "*纸制品*纸浆制滤块、滤板及滤片",
                                        "children": []
                                    },
                                    {
                                        "id": "908",
                                        "linkid": "901",
                                        "code": "106010507",
                                        "paCode": "1060105",
                                        "yn": "N",
                                        "title": "纸或纸板制标签",
                                        "alias": "纸或纸板制标签",
                                        "about": "包括印有文字图画纸制标签、未印文字图画纸制标签，不论是否印制均属此项。",
                                        "kws": "纸制标签、纸板制标签、印有文字图画纸制标签、未印文字图画纸制标签",
                                        "taxName": "纸制品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060105070000000000",
                                        "taxCodeTitle": "纸制品",
                                        "iTitle": "*纸制品*纸或纸板制标签",
                                        "children": []
                                    },
                                    {
                                        "id": "909",
                                        "linkid": "901",
                                        "code": "106010508",
                                        "paCode": "1060105",
                                        "yn": "N",
                                        "title": "纸制筒管、卷轴、纡子及类似品",
                                        "alias": "纸制筒管、卷轴、纡子及类似品",
                                        "about": "指纸浆、纸或纸板制的筒管、卷轴、纡子等物品，包括纸制纺织纱线用筒管、纸制纺织纱线用卷轴、其他纸制纡子及类似品。",
                                        "kws": "纸制纺织纱线用筒管、纸制纺织纱线用卷轴",
                                        "taxName": "纸制品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060105080000000000",
                                        "taxCodeTitle": "纸制品",
                                        "iTitle": "*纸制品*纸制筒管、卷轴、纡子及类似品",
                                        "children": []
                                    },
                                    {
                                        "id": "910",
                                        "linkid": "901",
                                        "code": "106010509",
                                        "paCode": "1060105",
                                        "yn": "N",
                                        "title": "神纸及类似用品",
                                        "alias": "神纸及类似用品",
                                        "about": "指祭祀用纸及类似品。",
                                        "kws": "神纸",
                                        "taxName": "纸制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060105090000000000",
                                        "taxCodeTitle": "纸制品",
                                        "iTitle": "*纸制品*神纸及类似用品",
                                        "children": []
                                    },
                                    {
                                        "id": "911",
                                        "linkid": "901",
                                        "code": "106010510",
                                        "paCode": "1060105",
                                        "yn": "N",
                                        "title": "纸扇",
                                        "alias": "纸扇",
                                        "about": null,
                                        "kws": "纸扇",
                                        "taxName": "纸制品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060105100000000000",
                                        "taxCodeTitle": "纸制品",
                                        "iTitle": "*纸制品*纸扇",
                                        "children": []
                                    },
                                    {
                                        "id": "912",
                                        "linkid": "901",
                                        "code": "106010511",
                                        "paCode": "1060105",
                                        "yn": "N",
                                        "title": "箱板纸",
                                        "alias": "箱板纸",
                                        "about": "指纸箱用纸，又称牛皮纸、牛卡纸。",
                                        "kws": "箱板纸",
                                        "taxName": "纸制品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060105110000000000",
                                        "taxCodeTitle": "纸制品",
                                        "iTitle": "*纸制品*箱板纸",
                                        "children": []
                                    },
                                    {
                                        "id": "913",
                                        "linkid": "901",
                                        "code": "106010599",
                                        "paCode": "1060105",
                                        "yn": "N",
                                        "title": "其他纸制品",
                                        "alias": "其他纸制品",
                                        "about": null,
                                        "kws": "皮纸、牛卡纸",
                                        "taxName": "纸制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060105990000000000",
                                        "taxCodeTitle": "纸制品",
                                        "iTitle": "*纸制品*其他纸制品",
                                        "children": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "id": "914",
                        "linkid": "873",
                        "code": "10602",
                        "paCode": "106",
                        "yn": "Y",
                        "title": "印刷品、记录媒介复制品",
                        "alias": "印刷品、记录媒介复制品",
                        "about": "包括印刷品、本册、装订活动及印刷用附件、磁介质复制品、非磁介质复制品",
                        "kws": null,
                        "taxName": "印刷品",
                        "taxRate": "",
                        "vip": "3",
                        "itaxRate": null,
                        "taxCode": "1060200000000000000",
                        "taxCodeTitle": "印刷品",
                        "iTitle": "*印刷品*印刷品、记录媒介复制品",
                        "children": [
                            {
                                "id": "915",
                                "linkid": "914",
                                "code": "1060201",
                                "paCode": "10602",
                                "yn": "Y",
                                "title": "印刷品",
                                "alias": "印刷品",
                                "about": "包括图书、报纸、期刊、广告宣传等印刷品,不包括邮政部门报刊发行服务（详见3020103）、邮册等邮品销售服务（详见3020301）",
                                "kws": null,
                                "taxName": "印刷品",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1060201000000000000",
                                "taxCodeTitle": "印刷品",
                                "iTitle": "*印刷品*印刷品",
                                "children": [
                                    {
                                        "id": "916",
                                        "linkid": "915",
                                        "code": "106020101",
                                        "paCode": "1060201",
                                        "yn": "Y",
                                        "title": "有刊号图书、报纸、期刊类印刷品",
                                        "alias": "有刊号图书、报纸、期刊类印刷品",
                                        "about": "包括单色、多色",
                                        "kws": "图书、书籍、词典、读物、绘本、丛书",
                                        "taxName": "印刷品",
                                        "taxRate": "",
                                        "vip": "5",
                                        "itaxRate": null,
                                        "taxCode": "1060201010000000000",
                                        "taxCodeTitle": "印刷品",
                                        "iTitle": "*印刷品*有刊号图书、报纸、期刊类印刷品",
                                        "children": [
                                            {
                                                "id": "917",
                                                "linkid": "916",
                                                "code": "10602010101",
                                                "paCode": "106020101",
                                                "yn": "N",
                                                "title": "党报",
                                                "alias": "党报",
                                                "about": "包括单色、多色，不包括邮政部门报刊发行服务（详见3020103）",
                                                "kws": "日报、周报、月报、早报、晚报",
                                                "taxName": "印刷品",
                                                "taxRate": "9%",
                                                "vip": "5",
                                                "itaxRate": "0.09",
                                                "taxCode": "1060201010100000000",
                                                "taxCodeTitle": "印刷品",
                                                "iTitle": "*印刷品*党报",
                                                "children": []
                                            },
                                            {
                                                "id": "918",
                                                "linkid": "916",
                                                "code": "10602010102",
                                                "paCode": "106020101",
                                                "yn": "N",
                                                "title": "党刊",
                                                "alias": "党刊",
                                                "about": "包括单色、多色，不包括邮政部门报刊发行服务（详见3020103）",
                                                "kws": "日刊、周刊、旬刊、月刊、季刊、年刊",
                                                "taxName": "印刷品",
                                                "taxRate": "9%",
                                                "vip": "5",
                                                "itaxRate": "0.09",
                                                "taxCode": "1060201010200000000",
                                                "taxCodeTitle": "印刷品",
                                                "iTitle": "*印刷品*党刊",
                                                "children": []
                                            },
                                            {
                                                "id": "919",
                                                "linkid": "916",
                                                "code": "10602010103",
                                                "paCode": "106020101",
                                                "yn": "N",
                                                "title": "机关报刊、机关期刊",
                                                "alias": "机关报刊、机关期刊",
                                                "about": "指中国共产党和各民主党派的各级组织的机关报纸和机关期刊，各级人大、政协、政府、工会、共青团、妇联、残联、科协的机关报纸和机关期刊，新华社的机关报纸和机关期刊，军事部门的机关报纸和机关期刊",
                                                "kws": "#机关报刊、机关期刊",
                                                "taxName": "印刷品",
                                                "taxRate": "9%",
                                                "vip": "5",
                                                "itaxRate": "0.09",
                                                "taxCode": "1060201010300000000",
                                                "taxCodeTitle": "印刷品",
                                                "iTitle": "*印刷品*机关报刊、机关期刊",
                                                "children": []
                                            },
                                            {
                                                "id": "920",
                                                "linkid": "916",
                                                "code": "10602010104",
                                                "paCode": "106020101",
                                                "yn": "N",
                                                "title": "盲文图书和盲文期刊",
                                                "alias": "盲文图书和盲文期刊",
                                                "about": "不包括党报（详见10602010101）、期刊（详见10602010102）",
                                                "kws": "盲文图书、盲文期刊",
                                                "taxName": "印刷品",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1060201010400000000",
                                                "taxCodeTitle": "印刷品",
                                                "iTitle": "*印刷品*盲文图书和盲文期刊",
                                                "children": []
                                            },
                                            {
                                                "id": "921",
                                                "linkid": "916",
                                                "code": "10602010105",
                                                "paCode": "106020101",
                                                "yn": "N",
                                                "title": "少数民族文字出版物",
                                                "alias": "少数民族文字出版物",
                                                "about": null,
                                                "kws": null,
                                                "taxName": "印刷品",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1060201010500000000",
                                                "taxCodeTitle": "印刷品",
                                                "iTitle": "*印刷品*少数民族文字出版物",
                                                "children": []
                                            },
                                            {
                                                "id": "922",
                                                "linkid": "916",
                                                "code": "10602010106",
                                                "paCode": "106020101",
                                                "yn": "N",
                                                "title": "特定地区出版物",
                                                "alias": "特定地区出版物",
                                                "about": "指经批准在内蒙古、广西、西藏、宁夏、新疆五个自治区内注册的出版单位出版的出版物。",
                                                "kws": "#地区出版物",
                                                "taxName": "印刷品",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1060201010600000000",
                                                "taxCodeTitle": "印刷品",
                                                "iTitle": "*印刷品*特定地区出版物",
                                                "children": []
                                            },
                                            {
                                                "id": "923",
                                                "linkid": "916",
                                                "code": "10602010107",
                                                "paCode": "106020101",
                                                "yn": "N",
                                                "title": "特定图书、报纸和期刊",
                                                "alias": "特定图书、报纸和期刊",
                                                "about": "指《财政部国家税务总局关于延续宣传文化增值税和营业税优惠政策的通知》（财税〔2013〕87号）附件1所列图书、报纸和期刊",
                                                "kws": "#学生课本、老年人报纸、老年人期刊、盲文图书、盲文期刊",
                                                "taxName": "印刷品",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1060201010700000000",
                                                "taxCodeTitle": "印刷品",
                                                "iTitle": "*印刷品*特定图书、报纸和期刊",
                                                "children": []
                                            },
                                            {
                                                "id": "924",
                                                "linkid": "916",
                                                "code": "10602010108",
                                                "paCode": "106020101",
                                                "yn": "N",
                                                "title": "少年儿童报刊及课本",
                                                "alias": "少年儿童报刊及课本",
                                                "about": "指专为初中及初中以下少年儿童出版发行的报纸和期刊，普通中小学学生课本和中等职业教育课本。",
                                                "kws": "#少年儿童报刊、少年儿童课本",
                                                "taxName": "印刷品",
                                                "taxRate": "9%",
                                                "vip": "5",
                                                "itaxRate": "0.09",
                                                "taxCode": "1060201010800000000",
                                                "taxCodeTitle": "印刷品",
                                                "iTitle": "*印刷品*少年儿童报刊及课本",
                                                "children": []
                                            },
                                            {
                                                "id": "925",
                                                "linkid": "916",
                                                "code": "10602010109",
                                                "paCode": "106020101",
                                                "yn": "N",
                                                "title": "老年报刊",
                                                "alias": "老年报刊",
                                                "about": "指专为老年人出版发行的报纸和期刊",
                                                "kws": "#老年报刊",
                                                "taxName": "印刷品",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1060201010900000000",
                                                "taxCodeTitle": "印刷品",
                                                "iTitle": "*印刷品*老年报刊",
                                                "children": []
                                            },
                                            {
                                                "id": "926",
                                                "linkid": "916",
                                                "code": "10602010199",
                                                "paCode": "106020101",
                                                "yn": "N",
                                                "title": "其他有刊号图书、报纸、期刊类印刷品",
                                                "alias": "其他有刊号图书、报纸、期刊类印刷品",
                                                "about": null,
                                                "kws": null,
                                                "taxName": "印刷品",
                                                "taxRate": "9%",
                                                "vip": "5",
                                                "itaxRate": "0.09",
                                                "taxCode": "1060201019900000000",
                                                "taxCodeTitle": "印刷品",
                                                "iTitle": "*印刷品*其他有刊号图书、报纸、期刊类印刷品",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "927",
                                        "linkid": "915",
                                        "code": "106020102",
                                        "paCode": "1060201",
                                        "yn": "N",
                                        "title": "无刊号图书、报纸、期刊类印刷品",
                                        "alias": "无刊号图书、报纸、期刊类印刷品",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "印刷品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060201020000000000",
                                        "taxCodeTitle": "印刷品",
                                        "iTitle": "*印刷品*无刊号图书、报纸、期刊类印刷品",
                                        "children": []
                                    },
                                    {
                                        "id": "928",
                                        "linkid": "915",
                                        "code": "106020103",
                                        "paCode": "1060201",
                                        "yn": "N",
                                        "title": "广告宣传印刷品",
                                        "alias": "广告宣传印刷品",
                                        "about": null,
                                        "kws": "广告类年刊、商品海报、商品目录册、艺术作品目录",
                                        "taxName": "印刷品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060201030000000000",
                                        "taxCodeTitle": "印刷品",
                                        "iTitle": "*印刷品*广告宣传印刷品",
                                        "children": []
                                    },
                                    {
                                        "id": "929",
                                        "linkid": "915",
                                        "code": "106020104",
                                        "paCode": "1060201",
                                        "yn": "N",
                                        "title": "地图、地图册",
                                        "alias": "地图、地图册",
                                        "about": null,
                                        "kws": "地图、地图册、地图仪",
                                        "taxName": "印刷品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060201040000000000",
                                        "taxCodeTitle": "印刷品",
                                        "iTitle": "*印刷品*地图、地图册",
                                        "children": []
                                    },
                                    {
                                        "id": "930",
                                        "linkid": "915",
                                        "code": "106020105",
                                        "paCode": "1060201",
                                        "yn": "N",
                                        "title": "图片、设计图样及照片",
                                        "alias": "图片、设计图样及照片",
                                        "about": null,
                                        "kws": "示意图、教学示教图表及图解、设计图案、集邮大型张、印有图画首日封、宣传画",
                                        "taxName": "印刷品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060201050000000000",
                                        "taxCodeTitle": "印刷品",
                                        "iTitle": "*印刷品*图片、设计图样及照片",
                                        "children": []
                                    },
                                    {
                                        "id": "931",
                                        "linkid": "915",
                                        "code": "106020106",
                                        "paCode": "1060201",
                                        "yn": "N",
                                        "title": "票证",
                                        "alias": "票证",
                                        "about": null,
                                        "kws": "邮票、钞票、有价证券凭证、印花税票",
                                        "taxName": "印刷品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060201060000000000",
                                        "taxCodeTitle": "印刷品",
                                        "iTitle": "*印刷品*票证",
                                        "children": []
                                    },
                                    {
                                        "id": "932",
                                        "linkid": "915",
                                        "code": "106020107",
                                        "paCode": "1060201",
                                        "yn": "N",
                                        "title": "明信片、卡片、日历、挂历",
                                        "alias": "明信片、卡片、日历、挂历",
                                        "about": null,
                                        "kws": "明信片、印制问候卡片、印刷各种日历、奖状及证书",
                                        "taxName": "印刷品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060201070000000000",
                                        "taxCodeTitle": "印刷品",
                                        "iTitle": "*印刷品*明信片、卡片、日历、挂历",
                                        "children": []
                                    },
                                    {
                                        "id": "933",
                                        "linkid": "915",
                                        "code": "106020199",
                                        "paCode": "1060201",
                                        "yn": "N",
                                        "title": "其他印刷品",
                                        "alias": "其他印刷品",
                                        "about": null,
                                        "kws": "塑料印刷品、金属印刷品",
                                        "taxName": "印刷品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060201990000000000",
                                        "taxCodeTitle": "印刷品",
                                        "iTitle": "*印刷品*其他印刷品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "934",
                                "linkid": "914",
                                "code": "1060202",
                                "paCode": "10602",
                                "yn": "Y",
                                "title": "本册",
                                "alias": "本册",
                                "about": null,
                                "kws": null,
                                "taxName": "印刷品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1060202000000000000",
                                "taxCodeTitle": "印刷品",
                                "iTitle": "*印刷品*本册",
                                "children": [
                                    {
                                        "id": "935",
                                        "linkid": "934",
                                        "code": "106020201",
                                        "paCode": "1060202",
                                        "yn": "N",
                                        "title": "用于书写本册",
                                        "alias": "用于书写本册",
                                        "about": "包括练习簿、学生簿（课业簿册）、笔记簿、日记簿、效率手册、螺旋本、收据本",
                                        "kws": "练习簿、学生簿、课业簿册、笔记簿、日记簿、效率手册、螺旋本、收据本",
                                        "taxName": "印刷品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060202010000000000",
                                        "taxCodeTitle": "印刷品",
                                        "iTitle": "*印刷品*用于书写本册",
                                        "children": []
                                    },
                                    {
                                        "id": "936",
                                        "linkid": "934",
                                        "code": "106020299",
                                        "paCode": "1060202",
                                        "yn": "N",
                                        "title": "其他本册",
                                        "alias": "其他本册",
                                        "about": null,
                                        "kws": "相册、集邮册、名片册、纪念册、粘贴簿",
                                        "taxName": "印刷品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060202990000000000",
                                        "taxCodeTitle": "印刷品",
                                        "iTitle": "*印刷品*其他本册",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "937",
                                "linkid": "914",
                                "code": "1060203",
                                "paCode": "10602",
                                "yn": "N",
                                "title": "印刷用附件",
                                "alias": "印刷用附件",
                                "about": "包括排版用活字、印版、滚筒",
                                "kws": "排版用活字、印版、滚筒",
                                "taxName": "印刷品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1060203000000000000",
                                "taxCodeTitle": "印刷品",
                                "iTitle": "*印刷品*印刷用附件",
                                "children": []
                            },
                            {
                                "id": "938",
                                "linkid": "914",
                                "code": "1060204",
                                "paCode": "10602",
                                "yn": "Y",
                                "title": "磁介质复制品",
                                "alias": "磁介质复制品",
                                "about": "包括：录音带、录像、软磁盘等复制品",
                                "kws": "录音带、录像、软磁盘",
                                "taxName": "磁介质复制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1060204000000000000",
                                "taxCodeTitle": "磁介质复制品",
                                "iTitle": "*磁介质复制品*磁介质复制品",
                                "children": [
                                    {
                                        "id": "939",
                                        "linkid": "938",
                                        "code": "106020401",
                                        "paCode": "1060204",
                                        "yn": "N",
                                        "title": "录音带复制品",
                                        "alias": "录音带复制品",
                                        "about": "包括已录制录音带，宽≤4mm、已录制教学用录音带、已录制非教学用录音带、已录制录音带，4mm＜宽≤6.5mm、已录制教学用录音带、已录制非教学用录音带、已录制录音带，宽＞6.5mm、已录制教学用录音带、已录制非教学用录音带",
                                        "kws": "已录制录音带、已录制教学用录音带、已录制非教学用录音带",
                                        "taxName": "磁介质复制品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1060204010000000000",
                                        "taxCodeTitle": "磁介质复制品",
                                        "iTitle": "*磁介质复制品*录音带复制品",
                                        "children": []
                                    },
                                    {
                                        "id": "940",
                                        "linkid": "938",
                                        "code": "106020402",
                                        "paCode": "1060204",
                                        "yn": "N",
                                        "title": "录像带复制品",
                                        "alias": "录像带复制品",
                                        "about": "包括已录制录像带，宽≤4mm、已录制教学用录像带、已录制非教学用录像、已录制录像带，4mm＜宽≤6.5mm、已录制教学用录像带、已录制非教学用录像带、已录制录像带，宽＞6.5mm、已录制教学用录像带、已录制非教学用录像带",
                                        "kws": "已录制录像带、已录制教学用录像带、已录制非教学用录像",
                                        "taxName": "磁介质复制品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1060204020000000000",
                                        "taxCodeTitle": "磁介质复制品",
                                        "iTitle": "*磁介质复制品*录像带复制品",
                                        "children": []
                                    },
                                    {
                                        "id": "941",
                                        "linkid": "938",
                                        "code": "106020403",
                                        "paCode": "1060204",
                                        "yn": "N",
                                        "title": "软磁盘复制品",
                                        "alias": "软磁盘复制品",
                                        "about": "包括教学用磁盘、非教学用磁盘",
                                        "kws": "教学用磁盘、非教学用磁盘",
                                        "taxName": "磁介质复制品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1060204030000000000",
                                        "taxCodeTitle": "磁介质复制品",
                                        "iTitle": "*磁介质复制品*软磁盘复制品",
                                        "children": []
                                    },
                                    {
                                        "id": "942",
                                        "linkid": "938",
                                        "code": "106020499",
                                        "paCode": "1060204",
                                        "yn": "N",
                                        "title": "其他磁介质复制品",
                                        "alias": "其他磁介质复制品",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "磁介质复制品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1060204990000000000",
                                        "taxCodeTitle": "磁介质复制品",
                                        "iTitle": "*磁介质复制品*其他磁介质复制品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "943",
                                "linkid": "914",
                                "code": "1060205",
                                "paCode": "10602",
                                "yn": "Y",
                                "title": "非磁介质复制品",
                                "alias": "非磁介质复制品",
                                "about": null,
                                "kws": null,
                                "taxName": "非磁介质复制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1060205000000000000",
                                "taxCodeTitle": "非磁介质复制品",
                                "iTitle": "*非磁介质复制品*非磁介质复制品",
                                "children": [
                                    {
                                        "id": "944",
                                        "linkid": "943",
                                        "code": "106020501",
                                        "paCode": "1060205",
                                        "yn": "N",
                                        "title": "唱片复制品",
                                        "alias": "唱片复制品",
                                        "about": "指已灌（录）信息的唱片，不包括电子出版物（详见1060302）",
                                        "kws": "唱片",
                                        "taxName": "非磁介质复制品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1060205010000000000",
                                        "taxCodeTitle": "非磁介质复制品",
                                        "iTitle": "*非磁介质复制品*唱片复制品",
                                        "children": []
                                    },
                                    {
                                        "id": "945",
                                        "linkid": "943",
                                        "code": "106020502",
                                        "paCode": "1060205",
                                        "yn": "N",
                                        "title": "光盘复制品",
                                        "alias": "光盘复制品",
                                        "about": "指已灌（录）音的光盘，不包括电子出版物（详见1060302）",
                                        "kws": "音频光盘复制品",
                                        "taxName": "非磁介质复制品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1060205020000000000",
                                        "taxCodeTitle": "非磁介质复制品",
                                        "iTitle": "*非磁介质复制品*光盘复制品",
                                        "children": []
                                    },
                                    {
                                        "id": "946",
                                        "linkid": "943",
                                        "code": "106020503",
                                        "paCode": "1060205",
                                        "yn": "N",
                                        "title": "非音像复制品",
                                        "alias": "非音像复制品",
                                        "about": "指已录制声音或图像以外信息的其他媒体不包括电子出版物（详见1060302）",
                                        "kws": "非音像复制品",
                                        "taxName": "非磁介质复制品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1060205030000000000",
                                        "taxCodeTitle": "非磁介质复制品",
                                        "iTitle": "*非磁介质复制品*非音像复制品",
                                        "children": []
                                    },
                                    {
                                        "id": "947",
                                        "linkid": "943",
                                        "code": "106020504",
                                        "paCode": "1060205",
                                        "yn": "N",
                                        "title": "电影胶片拷贝",
                                        "alias": "电影胶片拷贝",
                                        "about": null,
                                        "kws": "电影胶片拷贝",
                                        "taxName": "非磁介质复制品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1060205040000000000",
                                        "taxCodeTitle": "非磁介质复制品",
                                        "iTitle": "*非磁介质复制品*电影胶片拷贝",
                                        "children": []
                                    },
                                    {
                                        "id": "948",
                                        "linkid": "943",
                                        "code": "106020599",
                                        "paCode": "1060205",
                                        "yn": "N",
                                        "title": "其他非磁介质复制品",
                                        "alias": "其他非磁介质复制品",
                                        "about": "指其他记录媒介复制品",
                                        "kws": "非磁介质复制品",
                                        "taxName": "非磁介质复制品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1060205990000000000",
                                        "taxCodeTitle": "非磁介质复制品",
                                        "iTitle": "*非磁介质复制品*其他非磁介质复制品",
                                        "children": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "id": "949",
                        "linkid": "873",
                        "code": "10603",
                        "paCode": "106",
                        "yn": "Y",
                        "title": "软件、电子出版物",
                        "alias": "软件、电子出版物",
                        "about": null,
                        "kws": null,
                        "taxName": "软件电子出版物",
                        "taxRate": "",
                        "vip": "3",
                        "itaxRate": null,
                        "taxCode": "1060300000000000000",
                        "taxCodeTitle": "软件电子出版物",
                        "iTitle": "*软件电子出版物*软件、电子出版物",
                        "children": [
                            {
                                "id": "950",
                                "linkid": "949",
                                "code": "1060301",
                                "paCode": "10603",
                                "yn": "Y",
                                "title": "软件产品",
                                "alias": "软件产品",
                                "about": "包括基础软件、应用软件、嵌入式软件，不包括软件服务（详见3040201）",
                                "kws": null,
                                "taxName": "软件",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1060301000000000000",
                                "taxCodeTitle": "软件",
                                "iTitle": "*软件*软件产品",
                                "children": [
                                    {
                                        "id": "951",
                                        "linkid": "950",
                                        "code": "106030101",
                                        "paCode": "1060301",
                                        "yn": "Y",
                                        "title": "基础软件产品",
                                        "alias": "基础软件产品",
                                        "about": null,
                                        "kws": "基础软件",
                                        "taxName": "软件",
                                        "taxRate": "",
                                        "vip": "5",
                                        "itaxRate": null,
                                        "taxCode": "1060301010000000000",
                                        "taxCodeTitle": "软件",
                                        "iTitle": "*软件*基础软件产品",
                                        "children": [
                                            {
                                                "id": "952",
                                                "linkid": "951",
                                                "code": "10603010101",
                                                "paCode": "106030101",
                                                "yn": "N",
                                                "title": "系统软件产品",
                                                "alias": "系统软件产品",
                                                "about": "指属于独立完成一项应用的软件系统",
                                                "kws": "系统软件",
                                                "taxName": "软件",
                                                "taxRate": "13%",
                                                "vip": "5",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060301010100000000",
                                                "taxCodeTitle": "软件",
                                                "iTitle": "*软件*系统软件产品",
                                                "children": []
                                            },
                                            {
                                                "id": "953",
                                                "linkid": "951",
                                                "code": "10603010102",
                                                "paCode": "106030101",
                                                "yn": "N",
                                                "title": "数据库软件产品",
                                                "alias": "数据库软件产品",
                                                "about": null,
                                                "kws": "数据库软件",
                                                "taxName": "软件",
                                                "taxRate": "13%",
                                                "vip": "5",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060301010200000000",
                                                "taxCodeTitle": "软件",
                                                "iTitle": "*软件*数据库软件产品",
                                                "children": []
                                            },
                                            {
                                                "id": "954",
                                                "linkid": "951",
                                                "code": "10603010103",
                                                "paCode": "106030101",
                                                "yn": "N",
                                                "title": "中间件软件产品",
                                                "alias": "中间件软件产品",
                                                "about": null,
                                                "kws": "中间件软件",
                                                "taxName": "软件",
                                                "taxRate": "13%",
                                                "vip": "5",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060301010300000000",
                                                "taxCodeTitle": "软件",
                                                "iTitle": "*软件*中间件软件产品",
                                                "children": []
                                            },
                                            {
                                                "id": "955",
                                                "linkid": "951",
                                                "code": "10603010199",
                                                "paCode": "106030101",
                                                "yn": "N",
                                                "title": "其他基础软件产品",
                                                "alias": "其他基础软件产品",
                                                "about": null,
                                                "kws": "基础软件",
                                                "taxName": "软件",
                                                "taxRate": "13%",
                                                "vip": "5",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060301019900000000",
                                                "taxCodeTitle": "软件",
                                                "iTitle": "*软件*其他基础软件产品",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "956",
                                        "linkid": "950",
                                        "code": "106030102",
                                        "paCode": "1060301",
                                        "yn": "Y",
                                        "title": "应用软件产品",
                                        "alias": "应用软件产品",
                                        "about": null,
                                        "kws": "应用软件",
                                        "taxName": "软件",
                                        "taxRate": "",
                                        "vip": "5",
                                        "itaxRate": null,
                                        "taxCode": "1060301020000000000",
                                        "taxCodeTitle": "软件",
                                        "iTitle": "*软件*应用软件产品",
                                        "children": [
                                            {
                                                "id": "957",
                                                "linkid": "956",
                                                "code": "10603010201",
                                                "paCode": "106030102",
                                                "yn": "N",
                                                "title": "通用应用软件",
                                                "alias": "通用应用软件",
                                                "about": null,
                                                "kws": "通用应用软件",
                                                "taxName": "软件",
                                                "taxRate": "13%",
                                                "vip": "5",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060301020100000000",
                                                "taxCodeTitle": "软件",
                                                "iTitle": "*软件*通用应用软件",
                                                "children": []
                                            },
                                            {
                                                "id": "958",
                                                "linkid": "956",
                                                "code": "10603010202",
                                                "paCode": "106030102",
                                                "yn": "N",
                                                "title": "行业应用软件产品",
                                                "alias": "行业应用软件产品",
                                                "about": null,
                                                "kws": "行业应用软件",
                                                "taxName": "软件",
                                                "taxRate": "13%",
                                                "vip": "5",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060301020200000000",
                                                "taxCodeTitle": "软件",
                                                "iTitle": "*软件*行业应用软件产品",
                                                "children": []
                                            },
                                            {
                                                "id": "959",
                                                "linkid": "956",
                                                "code": "10603010203",
                                                "paCode": "106030102",
                                                "yn": "N",
                                                "title": "游戏软件产品",
                                                "alias": "游戏软件产品",
                                                "about": null,
                                                "kws": "游戏软件",
                                                "taxName": "软件",
                                                "taxRate": "13%",
                                                "vip": "5",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060301020300000000",
                                                "taxCodeTitle": "软件",
                                                "iTitle": "*软件*游戏软件产品",
                                                "children": []
                                            },
                                            {
                                                "id": "960",
                                                "linkid": "956",
                                                "code": "10603010204",
                                                "paCode": "106030102",
                                                "yn": "N",
                                                "title": "动漫软件产品",
                                                "alias": "动漫软件产品",
                                                "about": null,
                                                "kws": "动漫软件",
                                                "taxName": "软件",
                                                "taxRate": "13%",
                                                "vip": "5",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060301020400000000",
                                                "taxCodeTitle": "软件",
                                                "iTitle": "*软件*动漫软件产品",
                                                "children": []
                                            },
                                            {
                                                "id": "961",
                                                "linkid": "956",
                                                "code": "10603010205",
                                                "paCode": "106030102",
                                                "yn": "N",
                                                "title": "地理信息软件产品",
                                                "alias": "地理信息软件产品",
                                                "about": null,
                                                "kws": "地理信息软件",
                                                "taxName": "软件",
                                                "taxRate": "13%",
                                                "vip": "5",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060301020500000000",
                                                "taxCodeTitle": "软件",
                                                "iTitle": "*软件*地理信息软件产品",
                                                "children": []
                                            },
                                            {
                                                "id": "962",
                                                "linkid": "956",
                                                "code": "10603010206",
                                                "paCode": "106030102",
                                                "yn": "N",
                                                "title": "语言处理软件产品",
                                                "alias": "语言处理软件产品",
                                                "about": null,
                                                "kws": "语言处理软件",
                                                "taxName": "软件",
                                                "taxRate": "13%",
                                                "vip": "5",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060301020600000000",
                                                "taxCodeTitle": "软件",
                                                "iTitle": "*软件*语言处理软件产品",
                                                "children": []
                                            },
                                            {
                                                "id": "963",
                                                "linkid": "956",
                                                "code": "10603010299",
                                                "paCode": "106030102",
                                                "yn": "N",
                                                "title": "其他应用软件产品",
                                                "alias": "其他应用软件产品",
                                                "about": null,
                                                "kws": "应用软件",
                                                "taxName": "软件",
                                                "taxRate": "13%",
                                                "vip": "5",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060301029900000000",
                                                "taxCodeTitle": "软件",
                                                "iTitle": "*软件*其他应用软件产品",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "964",
                                        "linkid": "950",
                                        "code": "106030103",
                                        "paCode": "1060301",
                                        "yn": "Y",
                                        "title": "嵌入式软件产品",
                                        "alias": "嵌入式软件产品",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "软件",
                                        "taxRate": "",
                                        "vip": "5",
                                        "itaxRate": null,
                                        "taxCode": "1060301030000000000",
                                        "taxCodeTitle": "软件",
                                        "iTitle": "*软件*嵌入式软件产品",
                                        "children": [
                                            {
                                                "id": "965",
                                                "linkid": "964",
                                                "code": "10603010301",
                                                "paCode": "106030103",
                                                "yn": "N",
                                                "title": "通信设备嵌入式软件",
                                                "alias": "通信设备嵌入式软件",
                                                "about": null,
                                                "kws": "通信设备嵌入式软件",
                                                "taxName": "软件",
                                                "taxRate": "13%",
                                                "vip": "5",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060301030100000000",
                                                "taxCodeTitle": "软件",
                                                "iTitle": "*软件*通信设备嵌入式软件",
                                                "children": []
                                            },
                                            {
                                                "id": "966",
                                                "linkid": "964",
                                                "code": "10603010302",
                                                "paCode": "106030103",
                                                "yn": "N",
                                                "title": "网络设备嵌入式软件",
                                                "alias": "网络设备嵌入式软件",
                                                "about": null,
                                                "kws": "网络设备嵌入式软件",
                                                "taxName": "软件",
                                                "taxRate": "13%",
                                                "vip": "5",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060301030200000000",
                                                "taxCodeTitle": "软件",
                                                "iTitle": "*软件*网络设备嵌入式软件",
                                                "children": []
                                            },
                                            {
                                                "id": "967",
                                                "linkid": "964",
                                                "code": "10603010303",
                                                "paCode": "106030103",
                                                "yn": "N",
                                                "title": "数字装备设备嵌入式软件",
                                                "alias": "数字装备设备嵌入式软件",
                                                "about": "包括智能识别装置、安全防卫系统嵌入式软件",
                                                "kws": "智能识别装置、安全防卫系统嵌入式软件",
                                                "taxName": "软件",
                                                "taxRate": "13%",
                                                "vip": "5",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060301030300000000",
                                                "taxCodeTitle": "软件",
                                                "iTitle": "*软件*数字装备设备嵌入式软件",
                                                "children": []
                                            },
                                            {
                                                "id": "968",
                                                "linkid": "964",
                                                "code": "10603010304",
                                                "paCode": "106030103",
                                                "yn": "N",
                                                "title": "数字视频产品嵌入式软件",
                                                "alias": "数字视频产品嵌入式软件",
                                                "about": "包括数字电视机顶盒、其他数字视频产品嵌入式软件",
                                                "kws": "数字电视机顶盒、其他数字视频产品嵌入式软件",
                                                "taxName": "软件",
                                                "taxRate": "13%",
                                                "vip": "5",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060301030400000000",
                                                "taxCodeTitle": "软件",
                                                "iTitle": "*软件*数字视频产品嵌入式软件",
                                                "children": []
                                            },
                                            {
                                                "id": "969",
                                                "linkid": "964",
                                                "code": "10603010305",
                                                "paCode": "106030103",
                                                "yn": "N",
                                                "title": "自动控制产品嵌入式软件",
                                                "alias": "自动控制产品嵌入式软件",
                                                "about": "包括集散控制系统、过程控制系统、智能传感器智能机器人嵌入式软件",
                                                "kws": "集散控制系统、过程控制系统、智能传感器智能机器人嵌入式软件",
                                                "taxName": "软件",
                                                "taxRate": "13%",
                                                "vip": "5",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060301030500000000",
                                                "taxCodeTitle": "软件",
                                                "iTitle": "*软件*自动控制产品嵌入式软件",
                                                "children": []
                                            },
                                            {
                                                "id": "970",
                                                "linkid": "964",
                                                "code": "10603010306",
                                                "paCode": "106030103",
                                                "yn": "N",
                                                "title": "汽车电子嵌入式软件",
                                                "alias": "汽车电子嵌入式软件",
                                                "about": "包括通信系统、自动控制系统嵌入式软件",
                                                "kws": "通信系统、自动控制系统嵌入式软件",
                                                "taxName": "软件",
                                                "taxRate": "13%",
                                                "vip": "5",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060301030600000000",
                                                "taxCodeTitle": "软件",
                                                "iTitle": "*软件*汽车电子嵌入式软件",
                                                "children": []
                                            },
                                            {
                                                "id": "971",
                                                "linkid": "964",
                                                "code": "10603010399",
                                                "paCode": "106030103",
                                                "yn": "N",
                                                "title": "其他嵌入式软件",
                                                "alias": "其他嵌入式软件",
                                                "about": null,
                                                "kws": "其他嵌入式软件",
                                                "taxName": "软件",
                                                "taxRate": "13%",
                                                "vip": "5",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060301039900000000",
                                                "taxCodeTitle": "软件",
                                                "iTitle": "*软件*其他嵌入式软件",
                                                "children": []
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "id": "972",
                                "linkid": "949",
                                "code": "1060302",
                                "paCode": "10603",
                                "yn": "N",
                                "title": "电子出版物",
                                "alias": "电子出版物",
                                "about": "是指以数字代码方式，使用计算机应用程序，将图文声像等内容信息编辑加工后存储在具有确定的物理形态的磁、光、电等介质上，通过内嵌在计算机、手机、电子阅读设备、电子显示设备、数字音／视频播放设备、电子游戏机、导航仪以及其他具有类似功能的设备上读取使用，具有交互功能，用以表达思想、普及知识和积累文化的大众传播媒体。",
                                "kws": "只读光盘、一次写入式光盘、可擦写光盘",
                                "taxName": "电子出版物",
                                "taxRate": "9%",
                                "vip": "5",
                                "itaxRate": "0.09",
                                "taxCode": "1060302000000000000",
                                "taxCodeTitle": "电子出版物",
                                "iTitle": "*电子出版物*电子出版物",
                                "children": []
                            }
                        ]
                    },
                    {
                        "id": "973",
                        "linkid": "873",
                        "code": "10604",
                        "paCode": "106",
                        "yn": "Y",
                        "title": "文教体育用品",
                        "alias": "文教体育用品",
                        "about": null,
                        "kws": null,
                        "taxName": "文教体育用品",
                        "taxRate": "",
                        "vip": "3",
                        "itaxRate": null,
                        "taxCode": "1060400000000000000",
                        "taxCodeTitle": "文教体育用品",
                        "iTitle": "*文教体育用品*文教体育用品",
                        "children": [
                            {
                                "id": "974",
                                "linkid": "973",
                                "code": "1060401",
                                "paCode": "10604",
                                "yn": "Y",
                                "title": "文具及类似用品",
                                "alias": "文具及类似用品",
                                "about": null,
                                "kws": null,
                                "taxName": "文具",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1060401000000000000",
                                "taxCodeTitle": "文具",
                                "iTitle": "*文具*文具及类似用品",
                                "children": [
                                    {
                                        "id": "975",
                                        "linkid": "974",
                                        "code": "106040101",
                                        "paCode": "1060401",
                                        "yn": "N",
                                        "title": "文具盒（袋）",
                                        "alias": "文具盒（袋）",
                                        "about": "包括塑料、金属以及其他材质制的文具盒（铅笔盒）和文具袋（即笔袋）",
                                        "kws": "文具盒、铅笔盒、文具袋",
                                        "taxName": "文具",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060401010000000000",
                                        "taxCodeTitle": "文具",
                                        "iTitle": "*文具*文具盒（袋）",
                                        "children": []
                                    },
                                    {
                                        "id": "976",
                                        "linkid": "974",
                                        "code": "106040102",
                                        "paCode": "1060401",
                                        "yn": "N",
                                        "title": "文件夹",
                                        "alias": "文件夹",
                                        "about": "包括非纸制的资料册、管理夹、整理夹、文件袋（套）、文件盒、文件包等文件夹类文具；不包括纸制文件夹（详见106010502），塑料磁带盒（详见107060109）。",
                                        "kws": "资料册、管理夹、整理夹、文件袋、文件盒、文件包",
                                        "taxName": "文具",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060401020000000000",
                                        "taxCodeTitle": "文具",
                                        "iTitle": "*文具*文件夹",
                                        "children": []
                                    },
                                    {
                                        "id": "977",
                                        "linkid": "974",
                                        "code": "106040103",
                                        "paCode": "1060401",
                                        "yn": "N",
                                        "title": "文件架",
                                        "alias": "文件架",
                                        "about": "指主要用于存放文件等文化办公用品的架、柜、筐类物品，包括金属或塑料制成的。",
                                        "kws": "金属办公架、金属办公柜、金属办公筐、塑料办公架、塑料办公柜、塑料办公筐",
                                        "taxName": "文具",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060401030000000000",
                                        "taxCodeTitle": "文具",
                                        "iTitle": "*文具*文件架",
                                        "children": []
                                    },
                                    {
                                        "id": "978",
                                        "linkid": "974",
                                        "code": "106040104",
                                        "paCode": "1060401",
                                        "yn": "N",
                                        "title": "装订类文具",
                                        "alias": "装订类文具",
                                        "about": null,
                                        "kws": "装订文具",
                                        "taxName": "文具",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060401040000000000",
                                        "taxCodeTitle": "文具",
                                        "iTitle": "*文具*装订类文具",
                                        "children": []
                                    },
                                    {
                                        "id": "979",
                                        "linkid": "974",
                                        "code": "106040105",
                                        "paCode": "1060401",
                                        "yn": "N",
                                        "title": "夹具类文具",
                                        "alias": "夹具类文具",
                                        "about": null,
                                        "kws": "夹具文具",
                                        "taxName": "文具",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060401050000000000",
                                        "taxCodeTitle": "文具",
                                        "iTitle": "*文具*夹具类文具",
                                        "children": []
                                    },
                                    {
                                        "id": "980",
                                        "linkid": "974",
                                        "code": "106040106",
                                        "paCode": "1060401",
                                        "yn": "N",
                                        "title": "修正液",
                                        "alias": "修正液",
                                        "about": "修正液（又称涂改液、立可白、改写液）是一种普通文具。内含白色不透明颜料，涂在纸上以遮盖错字，干涸后可于其上重新书写。",
                                        "kws": "修正液、涂改液、立可白、改写液、修正笔、修正带",
                                        "taxName": "文具",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060401060000000000",
                                        "taxCodeTitle": "文具",
                                        "iTitle": "*文具*修正液",
                                        "children": []
                                    },
                                    {
                                        "id": "981",
                                        "linkid": "974",
                                        "code": "106040107",
                                        "paCode": "1060401",
                                        "yn": "N",
                                        "title": "橡皮",
                                        "alias": "橡皮",
                                        "about": "包括橡皮擦、绘图橡皮等",
                                        "kws": "橡皮擦、绘图橡皮",
                                        "taxName": "文具",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060401070000000000",
                                        "taxCodeTitle": "文具",
                                        "iTitle": "*文具*橡皮",
                                        "children": []
                                    },
                                    {
                                        "id": "982",
                                        "linkid": "974",
                                        "code": "106040108",
                                        "paCode": "1060401",
                                        "yn": "N",
                                        "title": "浆糊",
                                        "alias": "浆糊",
                                        "about": "将面粉或淀粉加水熬制为糊状。",
                                        "kws": "浆糊",
                                        "taxName": "文具",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060401080000000000",
                                        "taxCodeTitle": "文具",
                                        "iTitle": "*文具*浆糊",
                                        "children": []
                                    },
                                    {
                                        "id": "983",
                                        "linkid": "974",
                                        "code": "106040109",
                                        "paCode": "1060401",
                                        "yn": "N",
                                        "title": "胶水",
                                        "alias": "胶水",
                                        "about": "连接两种材料的中间体，多以水剂出现，属精细化工类，种类繁多，主要以粘料、物理形态、硬化方法和被粘物材质的分类方法。",
                                        "kws": "胶水、强力胶、502",
                                        "taxName": "文具",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060401090000000000",
                                        "taxCodeTitle": "文具",
                                        "iTitle": "*文具*胶水",
                                        "children": []
                                    },
                                    {
                                        "id": "984",
                                        "linkid": "974",
                                        "code": "106040110",
                                        "paCode": "1060401",
                                        "yn": "N",
                                        "title": "固体胶",
                                        "alias": "固体胶",
                                        "about": "固体胶又称固体胶棒、固体浆糊、唇膏式浆糊等。系以胶料、香精和水等为原料，经合理配制而成。",
                                        "kws": "固体胶、固体胶棒、固体浆糊、唇膏式浆糊",
                                        "taxName": "文具",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060401100000000000",
                                        "taxCodeTitle": "文具",
                                        "iTitle": "*文具*固体胶",
                                        "children": []
                                    },
                                    {
                                        "id": "985",
                                        "linkid": "974",
                                        "code": "106040111",
                                        "paCode": "1060401",
                                        "yn": "N",
                                        "title": "文印类用品",
                                        "alias": "文印类用品",
                                        "about": "包括印泥、印油、印章、印台",
                                        "kws": "印泥、印油、印章、印台",
                                        "taxName": "文具",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060401110000000000",
                                        "taxCodeTitle": "文具",
                                        "iTitle": "*文具*文印类用品",
                                        "children": []
                                    },
                                    {
                                        "id": "986",
                                        "linkid": "974",
                                        "code": "106040112",
                                        "paCode": "1060401",
                                        "yn": "N",
                                        "title": "画具及类似用品",
                                        "alias": "画具及类似用品",
                                        "about": "不包括油画布（详见104011006）",
                                        "kws": "画具",
                                        "taxName": "文具",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060401120000000000",
                                        "taxCodeTitle": "文具",
                                        "iTitle": "*文具*画具及类似用品",
                                        "children": []
                                    },
                                    {
                                        "id": "987",
                                        "linkid": "974",
                                        "code": "106040199",
                                        "paCode": "1060401",
                                        "yn": "N",
                                        "title": "其他文具及类似用品",
                                        "alias": "其他文具及类似用品",
                                        "about": "包括学生书袋及类似品（按照学生的使用需求设计的书袋及类似品）和其他文具",
                                        "kws": "学生书袋、书包、文具袋",
                                        "taxName": "文具",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060401990000000000",
                                        "taxCodeTitle": "文具",
                                        "iTitle": "*文具*其他文具及类似用品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "988",
                                "linkid": "973",
                                "code": "1060402",
                                "paCode": "10604",
                                "yn": "Y",
                                "title": "笔及其零件",
                                "alias": "笔及其零件",
                                "about": null,
                                "kws": null,
                                "taxName": "文具",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1060402000000000000",
                                "taxCodeTitle": "文具",
                                "iTitle": "*文具*笔及其零件",
                                "children": [
                                    {
                                        "id": "989",
                                        "linkid": "988",
                                        "code": "106040201",
                                        "paCode": "1060402",
                                        "yn": "Y",
                                        "title": "笔",
                                        "alias": "笔",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "文具",
                                        "taxRate": "",
                                        "vip": "5",
                                        "itaxRate": null,
                                        "taxCode": "1060402010000000000",
                                        "taxCodeTitle": "文具",
                                        "iTitle": "*文具*笔",
                                        "children": [
                                            {
                                                "id": "990",
                                                "linkid": "989",
                                                "code": "10604020101",
                                                "paCode": "106040201",
                                                "yn": "N",
                                                "title": "自来水笔",
                                                "alias": "自来水笔",
                                                "about": null,
                                                "kws": "自来水笔",
                                                "taxName": "文具",
                                                "taxRate": "13%",
                                                "vip": "5",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060402010100000000",
                                                "taxCodeTitle": "文具",
                                                "iTitle": "*文具*自来水笔",
                                                "children": []
                                            },
                                            {
                                                "id": "991",
                                                "linkid": "989",
                                                "code": "10604020102",
                                                "paCode": "106040201",
                                                "yn": "N",
                                                "title": "圆珠笔",
                                                "alias": "圆珠笔",
                                                "about": "包括中性圆珠笔、水性圆珠笔（滚珠笔）、油性圆珠笔、中油圆珠笔、可擦圆珠笔、其他圆珠笔",
                                                "kws": "中性圆珠笔、水性圆珠笔、滚珠笔、油性圆珠笔、中油圆珠笔、可擦圆珠笔",
                                                "taxName": "文具",
                                                "taxRate": "13%",
                                                "vip": "5",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060402010200000000",
                                                "taxCodeTitle": "文具",
                                                "iTitle": "*文具*圆珠笔",
                                                "children": []
                                            },
                                            {
                                                "id": "992",
                                                "linkid": "989",
                                                "code": "10604020103",
                                                "paCode": "106040201",
                                                "yn": "N",
                                                "title": "铅笔",
                                                "alias": "铅笔",
                                                "about": "包括木杆铅笔、活动铅笔、纸杆铅笔、塑料铅笔、其他铅笔",
                                                "kws": "木杆铅笔、活动铅笔、纸杆铅笔、塑料铅笔",
                                                "taxName": "文具",
                                                "taxRate": "13%",
                                                "vip": "5",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060402010300000000",
                                                "taxCodeTitle": "文具",
                                                "iTitle": "*文具*铅笔",
                                                "children": []
                                            },
                                            {
                                                "id": "993",
                                                "linkid": "989",
                                                "code": "10604020104",
                                                "paCode": "106040201",
                                                "yn": "N",
                                                "title": "绘画笔",
                                                "alias": "绘画笔",
                                                "about": "包括毛笔、油画笔、油画棒、粉笔、木炭笔、蜡笔、其他绘画用笔",
                                                "kws": "毛笔、油画笔、油画棒、粉笔、木炭笔、蜡笔",
                                                "taxName": "文具",
                                                "taxRate": "13%",
                                                "vip": "5",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060402010400000000",
                                                "taxCodeTitle": "文具",
                                                "iTitle": "*文具*绘画笔",
                                                "children": []
                                            },
                                            {
                                                "id": "994",
                                                "linkid": "989",
                                                "code": "10604020105",
                                                "paCode": "106040201",
                                                "yn": "N",
                                                "title": "记号笔",
                                                "alias": "记号笔",
                                                "about": "彩色水笔、荧光笔、荧光笔、白板笔、微孔墨水笔（签字笔）、油性记号笔、其他记号笔",
                                                "kws": "彩色水笔、荧光笔、白板笔、微孔墨水笔、签字笔、油性记号笔",
                                                "taxName": "文具",
                                                "taxRate": "13%",
                                                "vip": "5",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060402010500000000",
                                                "taxCodeTitle": "文具",
                                                "iTitle": "*文具*记号笔",
                                                "children": []
                                            },
                                            {
                                                "id": "995",
                                                "linkid": "989",
                                                "code": "10604020106",
                                                "paCode": "106040201",
                                                "yn": "N",
                                                "title": "专业用笔",
                                                "alias": "专业用笔",
                                                "about": "机器用笔、仪器用笔、蜡纸铁笔、其他专业用笔、其他笔",
                                                "kws": "机器用笔、仪器用笔、蜡纸铁笔",
                                                "taxName": "文具",
                                                "taxRate": "13%",
                                                "vip": "5",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060402010600000000",
                                                "taxCodeTitle": "文具",
                                                "iTitle": "*文具*专业用笔",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "996",
                                        "linkid": "988",
                                        "code": "106040202",
                                        "paCode": "1060402",
                                        "yn": "N",
                                        "title": "笔配件和零件",
                                        "alias": "笔配件和零件",
                                        "about": "铅笔芯、圆珠笔芯、自来水笔笔尖、笔杆、圆珠笔笔头、纤维笔笔头、其他笔配件和零件",
                                        "kws": "铅笔芯、圆珠笔芯、自来水笔笔尖、圆珠笔笔头、纤维笔笔头",
                                        "taxName": "文具",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060402020000000000",
                                        "taxCodeTitle": "文具",
                                        "iTitle": "*文具*笔配件和零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "997",
                                "linkid": "973",
                                "code": "1060403",
                                "paCode": "10604",
                                "yn": "Y",
                                "title": "教具及类似用具",
                                "alias": "教具及类似用具",
                                "about": null,
                                "kws": null,
                                "taxName": "教具",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1060403000000000000",
                                "taxCodeTitle": "教具",
                                "iTitle": "*教具*教具及类似用具",
                                "children": [
                                    {
                                        "id": "998",
                                        "linkid": "997",
                                        "code": "106040301",
                                        "paCode": "1060403",
                                        "yn": "N",
                                        "title": "教学用模型",
                                        "alias": "教学用模型",
                                        "about": "包括数学用模型、液压机模型、化学化工用模型、动物模型、植物模型、微生物模型、人体模型、医学模型、语文教学用模型、历史教学用模型、人物模型、地理模型、天文模型、气象模型、美术模型、交通模型、建筑模型、制图模型、机械模型、电器模型、输变电模型、其他教学用模型",
                                        "kws": "数学用模型、液压机模型、化学化工用模型、动物模型、植物模型、微生物模型、人体模型、医学模型、语文教学用模型、历史教学用模型、人物模型、地理模型、天文模型、气象模型、美术模型、交通模型、建筑模型、制图模型、机械模型、电器模型、输变电模型",
                                        "taxName": "教具",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060403010000000000",
                                        "taxCodeTitle": "教具",
                                        "iTitle": "*教具*教学用模型",
                                        "children": []
                                    },
                                    {
                                        "id": "999",
                                        "linkid": "997",
                                        "code": "106040302",
                                        "paCode": "1060403",
                                        "yn": "N",
                                        "title": "教学用标本",
                                        "alias": "教学用标本",
                                        "about": "包括人体解剖浸制标本、人体干制标本、塑化标本、全身骨骼标本、人体封埋标本、人体组织显微标本、动物整体浸制标本、动物解剖浸制标本、动物干制标本、动物骨骼标本、动物封埋标本（化石）、动物表皮细胞装片、动物解剖（塑化）干制标本、植物浸制标本、植物干制标本、植物封埋覆膜标本（化石）、植物根尖纵切、黑根霉装片、岩石标本、结晶矿物标本、土壤实物标本、玻璃标本、原材料标本（金相）、石油、化工、煤炭产品标本、机械产品标本、其他教学用标本",
                                        "kws": "人体解剖浸制标本、人体干制标本、塑化标本、全身骨骼标本、人体封埋标本、人体组织显微标本、动物整体浸制标本、动物解剖浸制标本、动物干制标本、动物骨骼标本、动物封埋标本、动物表皮细胞装片、动物解剖干制标本、植物浸制标本、植物干制标本、植物封埋覆膜标本、植物根尖纵切、黑根霉装片、岩石标本、结晶矿物标本、土壤实物标本、玻璃标本",
                                        "taxName": "教具",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060403020000000000",
                                        "taxCodeTitle": "教具",
                                        "iTitle": "*教具*教学用标本",
                                        "children": []
                                    },
                                    {
                                        "id": "1000",
                                        "linkid": "997",
                                        "code": "106040303",
                                        "paCode": "1060403",
                                        "yn": "N",
                                        "title": "具有书写或绘画面板类教具",
                                        "alias": "具有书写或绘画面板类教具",
                                        "about": "包括可书写石板、黑板、白板、电子白板、其他具有书写或绘画面板类教具",
                                        "kws": "可书写石板、黑板、白板、电子白板",
                                        "taxName": "教具",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060403030000000000",
                                        "taxCodeTitle": "教具",
                                        "iTitle": "*教具*具有书写或绘画面板类教具",
                                        "children": []
                                    },
                                    {
                                        "id": "1001",
                                        "linkid": "997",
                                        "code": "106040304",
                                        "paCode": "1060403",
                                        "yn": "N",
                                        "title": "教学或学生绘图用具、量具及类似器具",
                                        "alias": "教学或学生绘图用具、量具及类似器具",
                                        "about": "包括教学或学生绘图用具、学生圆规、分规、其他教学或学生用绘图用具",
                                        "kws": "绘图用具、学生圆规、分规、三角尺、直尺",
                                        "taxName": "教具",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060403040000000000",
                                        "taxCodeTitle": "教具",
                                        "iTitle": "*教具*教学或学生绘图用具、量具及类似器具",
                                        "children": []
                                    },
                                    {
                                        "id": "1002",
                                        "linkid": "997",
                                        "code": "106040399",
                                        "paCode": "1060403",
                                        "yn": "N",
                                        "title": "其他教具及类似用具",
                                        "alias": "其他教具及类似用具",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "教具",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060403990000000000",
                                        "taxCodeTitle": "教具",
                                        "iTitle": "*教具*其他教具及类似用具",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1003",
                                "linkid": "973",
                                "code": "1060404",
                                "paCode": "10604",
                                "yn": "Y",
                                "title": "墨水",
                                "alias": "墨水",
                                "about": null,
                                "kws": null,
                                "taxName": "墨水",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1060404000000000000",
                                "taxCodeTitle": "墨水",
                                "iTitle": "*墨水*墨水",
                                "children": [
                                    {
                                        "id": "1004",
                                        "linkid": "1003",
                                        "code": "106040401",
                                        "paCode": "1060404",
                                        "yn": "N",
                                        "title": "普通墨水",
                                        "alias": "普通墨水",
                                        "about": "普通用于书写的墨水",
                                        "kws": "墨水",
                                        "taxName": "墨水",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060404010000000000",
                                        "taxCodeTitle": "墨水",
                                        "iTitle": "*墨水*普通墨水",
                                        "children": []
                                    },
                                    {
                                        "id": "1005",
                                        "linkid": "1003",
                                        "code": "106040402",
                                        "paCode": "1060404",
                                        "yn": "N",
                                        "title": "专用墨水",
                                        "alias": "专用墨水",
                                        "about": null,
                                        "kws": "专用墨水",
                                        "taxName": "墨水",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060404020000000000",
                                        "taxCodeTitle": "墨水",
                                        "iTitle": "*墨水*专用墨水",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1006",
                                "linkid": "973",
                                "code": "1060405",
                                "paCode": "10604",
                                "yn": "Y",
                                "title": "墨汁及类似品",
                                "alias": "墨汁及类似品",
                                "about": null,
                                "kws": null,
                                "taxName": "墨水",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1060405000000000000",
                                "taxCodeTitle": "墨水",
                                "iTitle": "*墨水*墨汁及类似品",
                                "children": [
                                    {
                                        "id": "1007",
                                        "linkid": "1006",
                                        "code": "106040501",
                                        "paCode": "1060405",
                                        "yn": "N",
                                        "title": "墨汁",
                                        "alias": "墨汁",
                                        "about": "包括瓶装墨汁、其他墨汁、",
                                        "kws": "瓶装墨汁",
                                        "taxName": "墨水",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060405010000000000",
                                        "taxCodeTitle": "墨水",
                                        "iTitle": "*墨水*墨汁",
                                        "children": []
                                    },
                                    {
                                        "id": "1008",
                                        "linkid": "1006",
                                        "code": "106040502",
                                        "paCode": "1060405",
                                        "yn": "N",
                                        "title": "墨汁类似品",
                                        "alias": "墨汁类似品",
                                        "about": "包括方便墨、其他墨汁类似品",
                                        "kws": "方便墨",
                                        "taxName": "墨水",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060405020000000000",
                                        "taxCodeTitle": "墨水",
                                        "iTitle": "*墨水*墨汁类似品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1009",
                                "linkid": "973",
                                "code": "1060406",
                                "paCode": "10604",
                                "yn": "Y",
                                "title": "体育用品",
                                "alias": "体育用品",
                                "about": null,
                                "kws": null,
                                "taxName": "体育用品",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1060406000000000000",
                                "taxCodeTitle": "体育用品",
                                "iTitle": "*体育用品*体育用品",
                                "children": [
                                    {
                                        "id": "1010",
                                        "linkid": "1009",
                                        "code": "106040601",
                                        "paCode": "1060406",
                                        "yn": "N",
                                        "title": "运动用球",
                                        "alias": "运动用球",
                                        "about": "包括可充气或不可充气运动用球以及其他运动用球；不包括高尔夫球（详见10604060208），艺术体操用球、台球、沙狐球、保龄球等休闲娱乐活动用球(详见106040608)。",
                                        "kws": "足球、篮球、排球、乒乓球、网球、羽毛球、橄榄球",
                                        "taxName": "体育用品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060406010000000000",
                                        "taxCodeTitle": "体育用品",
                                        "iTitle": "*体育用品*运动用球",
                                        "children": []
                                    },
                                    {
                                        "id": "1011",
                                        "linkid": "1009",
                                        "code": "106040602",
                                        "paCode": "1060406",
                                        "yn": "Y",
                                        "title": "运动用球类器材及器械",
                                        "alias": "运动用球类器材及器械",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "体育用品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1060406020000000000",
                                        "taxCodeTitle": "体育用品",
                                        "iTitle": "*体育用品*运动用球类器材及器械",
                                        "children": [
                                            {
                                                "id": "1012",
                                                "linkid": "1011",
                                                "code": "10604060201",
                                                "paCode": "106040602",
                                                "yn": "N",
                                                "title": "乒乓球拍",
                                                "alias": "乒乓球拍",
                                                "about": null,
                                                "kws": "乒乓球拍",
                                                "taxName": "体育用品",
                                                "taxRate": "13%",
                                                "vip": "5",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060406020100000000",
                                                "taxCodeTitle": "体育用品",
                                                "iTitle": "*体育用品*乒乓球拍",
                                                "children": []
                                            },
                                            {
                                                "id": "1013",
                                                "linkid": "1011",
                                                "code": "10604060202",
                                                "paCode": "106040602",
                                                "yn": "N",
                                                "title": "网球拍",
                                                "alias": "网球拍",
                                                "about": "包括软式网球拍",
                                                "kws": "网球拍",
                                                "taxName": "体育用品",
                                                "taxRate": "13%",
                                                "vip": "5",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060406020200000000",
                                                "taxCodeTitle": "体育用品",
                                                "iTitle": "*体育用品*网球拍",
                                                "children": []
                                            },
                                            {
                                                "id": "1014",
                                                "linkid": "1011",
                                                "code": "10604060203",
                                                "paCode": "106040602",
                                                "yn": "N",
                                                "title": "羽毛球拍",
                                                "alias": "羽毛球拍",
                                                "about": null,
                                                "kws": "羽毛球拍",
                                                "taxName": "体育用品",
                                                "taxRate": "13%",
                                                "vip": "5",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060406020300000000",
                                                "taxCodeTitle": "体育用品",
                                                "iTitle": "*体育用品*羽毛球拍",
                                                "children": []
                                            },
                                            {
                                                "id": "1015",
                                                "linkid": "1011",
                                                "code": "10604060204",
                                                "paCode": "106040602",
                                                "yn": "N",
                                                "title": "球棒",
                                                "alias": "球棒",
                                                "about": "包括棒、垒球球棒",
                                                "kws": "球棒",
                                                "taxName": "体育用品",
                                                "taxRate": "13%",
                                                "vip": "5",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060406020400000000",
                                                "taxCodeTitle": "体育用品",
                                                "iTitle": "*体育用品*球棒",
                                                "children": []
                                            },
                                            {
                                                "id": "1016",
                                                "linkid": "1011",
                                                "code": "10604060205",
                                                "paCode": "106040602",
                                                "yn": "N",
                                                "title": "壁球拍",
                                                "alias": "壁球拍",
                                                "about": null,
                                                "kws": "壁球拍",
                                                "taxName": "体育用品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060406020500000000",
                                                "taxCodeTitle": "体育用品",
                                                "iTitle": "*体育用品*壁球拍",
                                                "children": []
                                            },
                                            {
                                                "id": "1017",
                                                "linkid": "1011",
                                                "code": "10604060206",
                                                "paCode": "106040602",
                                                "yn": "N",
                                                "title": "柔力球拍",
                                                "alias": "柔力球拍",
                                                "about": null,
                                                "kws": "柔力球拍",
                                                "taxName": "体育用品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060406020600000000",
                                                "taxCodeTitle": "体育用品",
                                                "iTitle": "*体育用品*柔力球拍",
                                                "children": []
                                            },
                                            {
                                                "id": "1018",
                                                "linkid": "1011",
                                                "code": "10604060207",
                                                "paCode": "106040602",
                                                "yn": "N",
                                                "title": "高尔夫球杆",
                                                "alias": "高尔夫球杆",
                                                "about": "指完整的高尔夫球杆",
                                                "kws": "高尔夫球杆",
                                                "taxName": "体育用品",
                                                "taxRate": "13%",
                                                "vip": "5",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060406020700000000",
                                                "taxCodeTitle": "体育用品",
                                                "iTitle": "*体育用品*高尔夫球杆",
                                                "children": []
                                            },
                                            {
                                                "id": "1019",
                                                "linkid": "1011",
                                                "code": "10604060208",
                                                "paCode": "106040602",
                                                "yn": "N",
                                                "title": "高尔夫球",
                                                "alias": "高尔夫球",
                                                "about": null,
                                                "kws": "高尔夫球",
                                                "taxName": "体育用品",
                                                "taxRate": "13%",
                                                "vip": "5",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060406020800000000",
                                                "taxCodeTitle": "体育用品",
                                                "iTitle": "*体育用品*高尔夫球",
                                                "children": []
                                            },
                                            {
                                                "id": "1020",
                                                "linkid": "1011",
                                                "code": "10604060209",
                                                "paCode": "106040602",
                                                "yn": "N",
                                                "title": "高尔夫球包",
                                                "alias": "高尔夫球包",
                                                "about": null,
                                                "kws": "高尔夫球包",
                                                "taxName": "体育用品",
                                                "taxRate": "13%",
                                                "vip": "5",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060406020900000000",
                                                "taxCodeTitle": "体育用品",
                                                "iTitle": "*体育用品*高尔夫球包",
                                                "children": []
                                            },
                                            {
                                                "id": "1021",
                                                "linkid": "1011",
                                                "code": "10604060210",
                                                "paCode": "106040602",
                                                "yn": "N",
                                                "title": "其他高尔夫球器械及配件",
                                                "alias": "其他高尔夫球器械及配件",
                                                "about": "包括高尔夫球球座（支架）、沙耙、果岭叉、球道补沙机、开洞机、高尔夫球模拟器等",
                                                "kws": "高尔夫球球座、高尔夫球支架、沙耙、果岭叉、球道补沙机、开洞机、高尔夫球模拟器",
                                                "taxName": "体育用品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060406021000000000",
                                                "taxCodeTitle": "体育用品",
                                                "iTitle": "*体育用品*其他高尔夫球器械及配件",
                                                "children": []
                                            },
                                            {
                                                "id": "1022",
                                                "linkid": "1011",
                                                "code": "10604060299",
                                                "paCode": "106040602",
                                                "yn": "N",
                                                "title": "其他球拍、棍",
                                                "alias": "其他球拍、棍",
                                                "about": "包括曲棍球、板球、长曲棍球、冰球等球类使用的棍和拍、柳条勺、回力球勺",
                                                "kws": "曲棍球棍、板球棍、长曲棍球棍、冰球棍、柳条勺、回力球勺",
                                                "taxName": "体育用品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060406029900000000",
                                                "taxCodeTitle": "体育用品",
                                                "iTitle": "*体育用品*其他球拍、棍",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "1023",
                                        "linkid": "1009",
                                        "code": "106040603",
                                        "paCode": "1060406",
                                        "yn": "N",
                                        "title": "体育器材及配件",
                                        "alias": "体育器材及配件",
                                        "about": "包括体操及蹦床器械、田径器械、举重、拳击及摔跤器械、冰雪运动用器械和用品、运动用船、水上运动器械和用品、射击器械及器材、射箭器材、击剑器材及零件、武术器械和用品、登山器材、龙狮运动器材及配件、拔河器材及配件、风筝器材及配件、",
                                        "kws": "蹦床器械、田径器械、体操器械、举重、拳击及摔跤器械、冰雪运动用器械、运动用船、水上运动器械、射击器械及器材、射箭器材、击剑器材及零件、武术器械、登山器材、龙狮运动器材、拔河器材、风筝器材",
                                        "taxName": "体育用品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060406030000000000",
                                        "taxCodeTitle": "体育用品",
                                        "iTitle": "*体育用品*体育器材及配件",
                                        "children": []
                                    },
                                    {
                                        "id": "1024",
                                        "linkid": "1009",
                                        "code": "106040604",
                                        "paCode": "1060406",
                                        "yn": "N",
                                        "title": "室内训练健身器材",
                                        "alias": "室内训练健身器材",
                                        "about": "包括力量型训练器材、力量型举重训练床、健身车、跑步机、划船训练器、椭圆训练器材、踏步机、阶梯机、攀登机、带固定轮或无飞轮健身车、一般体疗康复健身器材、其他室内训练健身器材。",
                                        "kws": "力量型训练器材、力量型举重训练床、健身车、跑步机、划船训练器、椭圆训练器材、踏步机、阶梯机、攀登机、体疗康复健身器材",
                                        "taxName": "体育用品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060406040000000000",
                                        "taxCodeTitle": "体育用品",
                                        "iTitle": "*体育用品*室内训练健身器材",
                                        "children": []
                                    },
                                    {
                                        "id": "1025",
                                        "linkid": "1009",
                                        "code": "106040605",
                                        "paCode": "1060406",
                                        "yn": "N",
                                        "title": "室外健身器材",
                                        "alias": "室外健身器材",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "体育用品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060406050000000000",
                                        "taxCodeTitle": "体育用品",
                                        "iTitle": "*体育用品*室外健身器材",
                                        "children": []
                                    },
                                    {
                                        "id": "1026",
                                        "linkid": "1009",
                                        "code": "106040606",
                                        "paCode": "1060406",
                                        "yn": "N",
                                        "title": "运动防护用具",
                                        "alias": "运动防护用具",
                                        "about": "包括运动专用手套、运动专用帽、运动专用鞋靴、运动专用护具。",
                                        "kws": "运动专用手套、运动专用帽、运动专用鞋靴、运动专用护具",
                                        "taxName": "体育用品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060406060000000000",
                                        "taxCodeTitle": "体育用品",
                                        "iTitle": "*体育用品*运动防护用具",
                                        "children": []
                                    },
                                    {
                                        "id": "1027",
                                        "linkid": "1009",
                                        "code": "106040607",
                                        "paCode": "1060406",
                                        "yn": "N",
                                        "title": "钓鱼用品和器材",
                                        "alias": "钓鱼用品和器材",
                                        "about": "包括钓鱼竿、钓鱼钩（不论有无系钩丝，包括带有单倒钩或多倒钩的鱼钩）、鱼线轮（包括绕线架）、钓鱼线、钓鱼饵（不论是金属、非金属、高分子化合物拟饵、鱼漂）、其他钓鱼用品和器材（包括鱼护、抄网、架竿、轮座；装好的线及投掷器、钓鱼浮子、装配好的钓鱼环、坠子及钓杆铃）等。",
                                        "kws": "钓鱼竿、钓鱼钩、鱼线轮、绕线架、钓鱼线、钓鱼饵、投掷器、钓鱼浮子、钓鱼环、坠子及钓杆铃",
                                        "taxName": "体育用品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060406070000000000",
                                        "taxCodeTitle": "体育用品",
                                        "iTitle": "*体育用品*钓鱼用品和器材",
                                        "children": []
                                    },
                                    {
                                        "id": "1028",
                                        "linkid": "1009",
                                        "code": "106040608",
                                        "paCode": "1060406",
                                        "yn": "N",
                                        "title": "休闲运动器材和用品",
                                        "alias": "休闲运动器材和用品",
                                        "about": "包括狩猎休闲用品、狩猎专用防护用品及用具（包括专业狩猎服、喷雾剂、防护靴、导航设备等）、狩猎工具及装备（包括狩猎专用驽、弓、陷井、捕兽器、爬树架、隐蔽篷等）、狩猎培训设备（包括狩猎培训专用靶场等、其他狩猎休闲用品）、马术休闲用品、马附具（包括马护胸、马护肘、马护腿、马被、马汗垫、马刺等）、马术骑手用品（包括骑士服、骑士帽、骑士附具等、其他马术休闲用品）、艺术体操用球、台球、台球桌、沙狐球、保龄球、其他休闲运动器材和用品。",
                                        "kws": "专业狩猎服、喷雾剂、防护靴、狩猎专用驽、弓、陷井、捕兽器、爬树架、隐蔽篷、狩猎培训专用靶场等、马护胸、马护肘、马护腿、马被、马汗垫、马刺、骑士服、骑士帽、骑士附具、艺术体操用球、台球、台球桌、沙狐球、保龄球",
                                        "taxName": "体育用品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060406080000000000",
                                        "taxCodeTitle": "体育用品",
                                        "iTitle": "*体育用品*休闲运动器材和用品",
                                        "children": []
                                    },
                                    {
                                        "id": "1029",
                                        "linkid": "1009",
                                        "code": "106040699",
                                        "paCode": "1060406",
                                        "yn": "N",
                                        "title": "其他体育用品",
                                        "alias": "其他体育用品",
                                        "about": null,
                                        "kws": "其他体育用品",
                                        "taxName": "体育用品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060406990000000000",
                                        "taxCodeTitle": "体育用品",
                                        "iTitle": "*体育用品*其他体育用品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1030",
                                "linkid": "973",
                                "code": "1060407",
                                "paCode": "10604",
                                "yn": "Y",
                                "title": "乐器、乐器辅助用品及零件",
                                "alias": "乐器、乐器辅助用品及零件",
                                "about": null,
                                "kws": null,
                                "taxName": "乐器",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1060407000000000000",
                                "taxCodeTitle": "乐器",
                                "iTitle": "*乐器*乐器、乐器辅助用品及零件",
                                "children": [
                                    {
                                        "id": "1031",
                                        "linkid": "1030",
                                        "code": "106040701",
                                        "paCode": "1060407",
                                        "yn": "N",
                                        "title": "中乐器",
                                        "alias": "中乐器",
                                        "about": "包括中乐器、中乐弦乐器、二胡、京胡、板胡、其他中乐弦乐器、中乐弹拨乐器、古筝、三弦、琵琶、月琴、柳琴、其他中乐弹拨乐、中乐吹管乐器、竹笛、箫笙、唢呐、其他中乐吹管乐器、中乐打击乐器、扬琴、鼓（中乐）、锣、响板、响铜乐器、其他中乐打击乐器、其他中乐器",
                                        "kws": "二胡、京胡、板胡、中乐弹拨乐器、古筝、三弦、琵琶、月琴、柳琴、中乐吹管乐器、竹笛、箫笙、唢呐、扬琴、鼓、锣、响板",
                                        "taxName": "乐器",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060407010000000000",
                                        "taxCodeTitle": "乐器",
                                        "iTitle": "*乐器*中乐器",
                                        "children": []
                                    },
                                    {
                                        "id": "1032",
                                        "linkid": "1030",
                                        "code": "106040702",
                                        "paCode": "1060407",
                                        "yn": "N",
                                        "title": "西乐器",
                                        "alias": "西乐器",
                                        "about": "小提琴、大提琴、竖琴、吉他、其他西弦乐器、号、笛、双簧管、单簧管（黑管）、萨克斯、其他西管乐器、鼓（西乐）、镲、木琴、沙槌、其他西乐打击乐器、钢琴、手风琴、其他西乐键盘乐器、口琴、其他西乐器。",
                                        "kws": "小提琴、大提琴、竖琴、吉他、号、笛、双簧管、单簧管、黑管、萨克斯、鼓、镲、木琴、沙槌、手风琴、口琴、钢琴",
                                        "taxName": "乐器",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060407020000000000",
                                        "taxCodeTitle": "乐器",
                                        "iTitle": "*乐器*西乐器",
                                        "children": []
                                    },
                                    {
                                        "id": "1033",
                                        "linkid": "1030",
                                        "code": "106040703",
                                        "paCode": "1060407",
                                        "yn": "N",
                                        "title": "电子乐器",
                                        "alias": "电子乐器",
                                        "about": "指通过电产生或扩大声音的乐器",
                                        "kws": "电子琴、电吉他、电贝司",
                                        "taxName": "乐器",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060407030000000000",
                                        "taxCodeTitle": "乐器",
                                        "iTitle": "*乐器*电子乐器",
                                        "children": []
                                    },
                                    {
                                        "id": "1034",
                                        "linkid": "1030",
                                        "code": "106040704",
                                        "paCode": "1060407",
                                        "yn": "N",
                                        "title": "媒诱音响器，相关乐器",
                                        "alias": "媒诱音响器，相关乐器",
                                        "about": "包括百音盒、哨子、其他相关乐器",
                                        "kws": "百音盒、哨子",
                                        "taxName": "乐器",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060407040000000000",
                                        "taxCodeTitle": "乐器",
                                        "iTitle": "*乐器*媒诱音响器，相关乐器",
                                        "children": []
                                    },
                                    {
                                        "id": "1035",
                                        "linkid": "1030",
                                        "code": "106040705",
                                        "paCode": "1060407",
                                        "yn": "N",
                                        "title": "乐器辅助用品及零件",
                                        "alias": "乐器辅助用品及零件",
                                        "about": "包括节拍器、音叉、定音管、百音盒机械装置、乐器用弦、其他乐器零件",
                                        "kws": "节拍器、音叉、定音管、百音盒机械装置、乐器用弦",
                                        "taxName": "乐器",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060407050000000000",
                                        "taxCodeTitle": "乐器",
                                        "iTitle": "*乐器*乐器辅助用品及零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1036",
                                "linkid": "973",
                                "code": "1060408",
                                "paCode": "10604",
                                "yn": "Y",
                                "title": "玩具",
                                "alias": "玩具",
                                "about": null,
                                "kws": null,
                                "taxName": "玩具",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1060408000000000000",
                                "taxCodeTitle": "玩具",
                                "iTitle": "*玩具*玩具",
                                "children": [
                                    {
                                        "id": "1037",
                                        "linkid": "1036",
                                        "code": "106040801",
                                        "paCode": "1060408",
                                        "yn": "N",
                                        "title": "供儿童乘骑带轮玩具",
                                        "alias": "供儿童乘骑带轮玩具",
                                        "about": "不包括拖拉类带轮玩具和玩偶车（详见106040899）",
                                        "kws": "儿童车",
                                        "taxName": "玩具",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060408010000000000",
                                        "taxCodeTitle": "玩具",
                                        "iTitle": "*玩具*供儿童乘骑带轮玩具",
                                        "children": []
                                    },
                                    {
                                        "id": "1038",
                                        "linkid": "1036",
                                        "code": "106040802",
                                        "paCode": "1060408",
                                        "yn": "N",
                                        "title": "填充类玩具",
                                        "alias": "填充类玩具",
                                        "about": "包括PP棉填充的布绒玩具和其他填充类的布绒玩具及其附属品",
                                        "kws": "布绒玩具、填充玩具",
                                        "taxName": "玩具",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060408020000000000",
                                        "taxCodeTitle": "玩具",
                                        "iTitle": "*玩具*填充类玩具",
                                        "children": []
                                    },
                                    {
                                        "id": "1039",
                                        "linkid": "1036",
                                        "code": "106040803",
                                        "paCode": "1060408",
                                        "yn": "N",
                                        "title": "玩偶及其零配件和装饰品",
                                        "alias": "玩偶及其零配件和装饰品",
                                        "about": "不包括填充类玩具（详见106040802）",
                                        "kws": "塑料玩偶、陶瓷玩偶、塑胶玩偶",
                                        "taxName": "玩具",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060408030000000000",
                                        "taxCodeTitle": "玩具",
                                        "iTitle": "*玩具*玩偶及其零配件和装饰品",
                                        "children": []
                                    },
                                    {
                                        "id": "1040",
                                        "linkid": "1036",
                                        "code": "106040804",
                                        "paCode": "1060408",
                                        "yn": "N",
                                        "title": "仿真模型及其附件",
                                        "alias": "仿真模型及其附件",
                                        "about": "指缩小（按比例缩小）的无动力装置或带动力装置的全套仿真模型组件及其附件",
                                        "kws": "无动力装置仿真模型、无动力装置仿真车模、无动力装置仿真航模、无动力装置仿真船模、无动力装置仿真建筑套件、带动力装置仿真车模、带动力装置仿真航模、带动力装置仿真船模",
                                        "taxName": "玩具",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060408040000000000",
                                        "taxCodeTitle": "玩具",
                                        "iTitle": "*玩具*仿真模型及其附件",
                                        "children": []
                                    },
                                    {
                                        "id": "1041",
                                        "linkid": "1036",
                                        "code": "106040805",
                                        "paCode": "1060408",
                                        "yn": "N",
                                        "title": "木制玩具",
                                        "alias": "木制玩具",
                                        "about": "指木制的各类玩具；不包括供儿童乘骑的带轮玩具玩偶（详见106040801），仿真模型（详见106040804）。",
                                        "kws": "木制拼插玩具、木制积木玩具、木制拖拉玩具、木制幼教玩具",
                                        "taxName": "玩具",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060408050000000000",
                                        "taxCodeTitle": "玩具",
                                        "iTitle": "*玩具*木制玩具",
                                        "children": []
                                    },
                                    {
                                        "id": "1042",
                                        "linkid": "1036",
                                        "code": "106040806",
                                        "paCode": "1060408",
                                        "yn": "N",
                                        "title": "塑胶玩具",
                                        "alias": "塑胶玩具",
                                        "about": "指塑胶制的各类玩具；不包括供儿童乘骑的带轮玩具（详见106040801），填充类玩具玩偶（详见106040802），仿真模型（详见106040804）。",
                                        "kws": "静态塑胶玩具、机动塑胶玩具、电动塑胶玩具",
                                        "taxName": "玩具",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060408060000000000",
                                        "taxCodeTitle": "玩具",
                                        "iTitle": "*玩具*塑胶玩具",
                                        "children": []
                                    },
                                    {
                                        "id": "1043",
                                        "linkid": "1036",
                                        "code": "106040807",
                                        "paCode": "1060408",
                                        "yn": "N",
                                        "title": "玩具乐器",
                                        "alias": "玩具乐器",
                                        "about": "包括玩具电子琴、喇叭、鼓等",
                                        "kws": "玩具乐器",
                                        "taxName": "玩具",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060408070000000000",
                                        "taxCodeTitle": "玩具",
                                        "iTitle": "*玩具*玩具乐器",
                                        "children": []
                                    },
                                    {
                                        "id": "1044",
                                        "linkid": "1036",
                                        "code": "106040808",
                                        "paCode": "1060408",
                                        "yn": "N",
                                        "title": "儿童娱乐塑形用膏、泥",
                                        "alias": "儿童娱乐塑形用膏、泥",
                                        "about": null,
                                        "kws": "儿童娱乐塑形用膏、橡皮泥",
                                        "taxName": "玩具",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060408080000000000",
                                        "taxCodeTitle": "玩具",
                                        "iTitle": "*玩具*儿童娱乐塑形用膏、泥",
                                        "children": []
                                    },
                                    {
                                        "id": "1045",
                                        "linkid": "1036",
                                        "code": "106040899",
                                        "paCode": "1060408",
                                        "yn": "N",
                                        "title": "其他玩具",
                                        "alias": "其他玩具",
                                        "about": "包括玩偶车",
                                        "kws": "玩偶车",
                                        "taxName": "玩具",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060408990000000000",
                                        "taxCodeTitle": "玩具",
                                        "iTitle": "*玩具*其他玩具",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1046",
                                "linkid": "973",
                                "code": "1060409",
                                "paCode": "10604",
                                "yn": "Y",
                                "title": "游乐场设备",
                                "alias": "游乐场设备",
                                "about": "指露天游乐场所游乐设备",
                                "kws": null,
                                "taxName": "游乐场设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1060409000000000000",
                                "taxCodeTitle": "游乐场设备",
                                "iTitle": "*游乐场设备*游乐场设备",
                                "children": [
                                    {
                                        "id": "1047",
                                        "linkid": "1046",
                                        "code": "106040901",
                                        "paCode": "1060409",
                                        "yn": "N",
                                        "title": "电动游乐设备",
                                        "alias": "电动游乐设备",
                                        "about": "包括大型电动游乐设备，如观缆车、过山车、电动小飞船、电动转车、碰碰车、卡丁车、转伞、旋转木马",
                                        "kws": "电动游乐设备、观缆车、过山车、电动小飞船、电动转车、碰碰车、卡丁车、转伞、旋转木马",
                                        "taxName": "游乐场设备",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060409010000000000",
                                        "taxCodeTitle": "游乐场设备",
                                        "iTitle": "*游乐场设备*电动游乐设备",
                                        "children": []
                                    },
                                    {
                                        "id": "1048",
                                        "linkid": "1046",
                                        "code": "106040902",
                                        "paCode": "1060409",
                                        "yn": "N",
                                        "title": "非电动游乐设备",
                                        "alias": "非电动游乐设备",
                                        "about": "包括转椅、滑轮车、滑梯、秋千、秋千船、压板、悬梯、幸运转轮机",
                                        "kws": "非电动游乐设备、转椅、滑轮车、滑梯、秋千、秋千船、压板、悬梯、幸运转轮机",
                                        "taxName": "游乐场设备",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060409020000000000",
                                        "taxCodeTitle": "游乐场设备",
                                        "iTitle": "*游乐场设备*非电动游乐设备",
                                        "children": []
                                    },
                                    {
                                        "id": "1049",
                                        "linkid": "1046",
                                        "code": "106040999",
                                        "paCode": "1060409",
                                        "yn": "N",
                                        "title": "其他游乐场设备",
                                        "alias": "其他游乐场设备",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "游乐场设备",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060409990000000000",
                                        "taxCodeTitle": "游乐场设备",
                                        "iTitle": "*游乐场设备*其他游乐场设备",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1050",
                                "linkid": "973",
                                "code": "1060410",
                                "paCode": "10604",
                                "yn": "Y",
                                "title": "游艺用品及室内游艺器材",
                                "alias": "游艺用品及室内游艺器材",
                                "about": "包括电子游戏机、投币式游戏机、台球器材及配件、保龄球设备及器材、沙狐球桌及其配套器材、桌式足球器材及配件、飞镖器材及配件、棋类娱乐用品、牌类娱乐用品、专供游戏用家具式桌子、其他游艺用品及室内游艺器材",
                                "kws": "游艺用品、室内游艺器材、电子游戏机、投币式游戏机、台球、保龄球设备、保龄球器材、沙狐球桌、沙狐球配套器材、桌式足球器材、桌式足球配件、飞镖器材、飞镖配件、棋、牌",
                                "taxName": "游艺器材",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1060410000000000000",
                                "taxCodeTitle": "游艺器材",
                                "iTitle": "*游艺器材*游艺用品及室内游艺器材",
                                "children": [
                                    {
                                        "id": "1051",
                                        "linkid": "1050",
                                        "code": "106041001",
                                        "paCode": "1060410",
                                        "yn": "N",
                                        "title": "电子游戏机",
                                        "alias": "电子游戏机",
                                        "about": "包括自身装荧光屏电子游戏机、投币式电子游戏机",
                                        "kws": "电子游戏机、自身装荧光屏电子游戏机、投币式电子游戏机",
                                        "taxName": "游艺器材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060410010000000000",
                                        "taxCodeTitle": "游艺器材",
                                        "iTitle": "*游艺器材*电子游戏机",
                                        "children": []
                                    },
                                    {
                                        "id": "1052",
                                        "linkid": "1050",
                                        "code": "106041002",
                                        "paCode": "1060410",
                                        "yn": "N",
                                        "title": "投币式游戏机",
                                        "alias": "投币式游戏机",
                                        "about": "指使用硬币、钞票及类似品的游戏用品，如弹球机、旋转机",
                                        "kws": "投币式游戏机、弹球机、旋转机",
                                        "taxName": "游艺器材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060410020000000000",
                                        "taxCodeTitle": "游艺器材",
                                        "iTitle": "*游艺器材*投币式游戏机",
                                        "children": []
                                    },
                                    {
                                        "id": "1053",
                                        "linkid": "1050",
                                        "code": "106041003",
                                        "paCode": "1060410",
                                        "yn": "N",
                                        "title": "台球器材及配件",
                                        "alias": "台球器材及配件",
                                        "about": "包括8球台球、9球台球、斯诺克台球、开伦台球、比利台球用球、台球杆、球杆盒、球杆皮头、擦粉、摆球器、定位器、开杆器",
                                        "kws": "台球器材、8球台球、9球台球、斯诺克台球、开伦台球、比利台球用球、台球杆、球杆盒、球杆皮头、擦粉、摆球器、定位器、开杆器",
                                        "taxName": "游艺器材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060410030000000000",
                                        "taxCodeTitle": "游艺器材",
                                        "iTitle": "*游艺器材*台球器材及配件",
                                        "children": []
                                    },
                                    {
                                        "id": "1054",
                                        "linkid": "1050",
                                        "code": "106041004",
                                        "paCode": "1060410",
                                        "yn": "N",
                                        "title": "保龄球设备及器材",
                                        "alias": "保龄球设备及器材",
                                        "about": "包括保龄球自动分瓶机、保龄球、保龄球瓶、保龄球自动球道设备、指套、指贴、下油机及配件、测油机、球检仪、球秤",
                                        "kws": "保龄球、保龄球自动分瓶机、保龄球瓶、保龄球自动球道设备、保龄球指套、保龄球指贴、保龄球下油机、保龄球下油机配件、保龄球测油机、保龄球球检仪、保龄球球秤",
                                        "taxName": "游艺器材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060410040000000000",
                                        "taxCodeTitle": "游艺器材",
                                        "iTitle": "*游艺器材*保龄球设备及器材",
                                        "children": []
                                    },
                                    {
                                        "id": "1055",
                                        "linkid": "1050",
                                        "code": "106041005",
                                        "paCode": "1060410",
                                        "yn": "N",
                                        "title": "沙狐球桌及其配套器材",
                                        "alias": "沙狐球桌及其配套器材",
                                        "about": null,
                                        "kws": "沙狐球、沙狐球桌、沙壶球、桌掷球",
                                        "taxName": "游艺器材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060410050000000000",
                                        "taxCodeTitle": "游艺器材",
                                        "iTitle": "*游艺器材*沙狐球桌及其配套器材",
                                        "children": []
                                    },
                                    {
                                        "id": "1056",
                                        "linkid": "1050",
                                        "code": "106041006",
                                        "paCode": "1060410",
                                        "yn": "N",
                                        "title": "桌式足球器材及配件",
                                        "alias": "桌式足球器材及配件",
                                        "about": null,
                                        "kws": "桌式足球、波比足球",
                                        "taxName": "游艺器材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060410060000000000",
                                        "taxCodeTitle": "游艺器材",
                                        "iTitle": "*游艺器材*桌式足球器材及配件",
                                        "children": []
                                    },
                                    {
                                        "id": "1057",
                                        "linkid": "1050",
                                        "code": "106041007",
                                        "paCode": "1060410",
                                        "yn": "N",
                                        "title": "飞镖器材及配件",
                                        "alias": "飞镖器材及配件",
                                        "about": null,
                                        "kws": "飞镖、镖盘、镖",
                                        "taxName": "游艺器材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060410070000000000",
                                        "taxCodeTitle": "游艺器材",
                                        "iTitle": "*游艺器材*飞镖器材及配件",
                                        "children": []
                                    },
                                    {
                                        "id": "1058",
                                        "linkid": "1050",
                                        "code": "106041008",
                                        "paCode": "1060410",
                                        "yn": "N",
                                        "title": "棋类娱乐用品",
                                        "alias": "棋类娱乐用品",
                                        "about": null,
                                        "kws": "棋类娱乐用品、中国象棋、国际象棋、围棋、军棋、跳棋、骰子游戏、蛇梯棋、棋、桌游",
                                        "taxName": "游艺器材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060410080000000000",
                                        "taxCodeTitle": "游艺器材",
                                        "iTitle": "*游艺器材*棋类娱乐用品",
                                        "children": []
                                    },
                                    {
                                        "id": "1059",
                                        "linkid": "1050",
                                        "code": "106041009",
                                        "paCode": "1060410",
                                        "yn": "N",
                                        "title": "牌类娱乐用品",
                                        "alias": "牌类娱乐用品",
                                        "about": null,
                                        "kws": "牌类娱乐用品、扑克牌、麻将牌、纸麻将牌、图纸牌、三国杀、桌游",
                                        "taxName": "游艺器材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060410090000000000",
                                        "taxCodeTitle": "游艺器材",
                                        "iTitle": "*游艺器材*牌类娱乐用品",
                                        "children": []
                                    },
                                    {
                                        "id": "1060",
                                        "linkid": "1050",
                                        "code": "106041010",
                                        "paCode": "1060410",
                                        "yn": "N",
                                        "title": "专供游戏用家具式桌子",
                                        "alias": "专供游戏用家具式桌子",
                                        "about": "包括麻将桌",
                                        "kws": "麻将桌",
                                        "taxName": "游艺器材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060410100000000000",
                                        "taxCodeTitle": "游艺器材",
                                        "iTitle": "*游艺器材*专供游戏用家具式桌子",
                                        "children": []
                                    },
                                    {
                                        "id": "1061",
                                        "linkid": "1050",
                                        "code": "106041099",
                                        "paCode": "1060410",
                                        "yn": "N",
                                        "title": "其他游艺用品及室内游艺器材",
                                        "alias": "其他游艺用品及室内游艺器材",
                                        "about": "包括桌上游戏用品，如骰子、骰子盘、计数器、纸牌花色显示器、专供游戏用的特制布等",
                                        "kws": null,
                                        "taxName": "游艺器材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060410990000000000",
                                        "taxCodeTitle": "游艺器材",
                                        "iTitle": "*游艺器材*其他游艺用品及室内游艺器材",
                                        "children": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "id": "1062",
                        "linkid": "873",
                        "code": "10605",
                        "paCode": "106",
                        "yn": "Y",
                        "title": "工艺品及其他制造产品",
                        "alias": "工艺品及其他制造产品",
                        "about": "包括雕塑工艺品、金属工艺品、漆器工艺品、花画工艺品、天然植物纤维及人造纤维编织工艺品、抽纱刺绣工艺品、地毯、挂毯类工艺品、珠宝首饰及有关物品、剧装道具及相关工艺美术品、保健休闲用品、日用杂品、宠物用品、其他未列明制造产品",
                        "kws": null,
                        "taxName": "工艺品",
                        "taxRate": "",
                        "vip": "3",
                        "itaxRate": null,
                        "taxCode": "1060500000000000000",
                        "taxCodeTitle": "工艺品",
                        "iTitle": "*工艺品*工艺品及其他制造产品",
                        "children": [
                            {
                                "id": "1063",
                                "linkid": "1062",
                                "code": "1060501",
                                "paCode": "10605",
                                "yn": "Y",
                                "title": "雕塑工艺品",
                                "alias": "雕塑工艺品",
                                "about": "指用各种石材、动物牙（角、骨）等天然或人造硬质材料，各种木、竹、果壳（核）等天然植物材料，以及石膏、泥、面、塑料等可塑性材料为原料，经雕、刻、琢、磨、捏或塑等艺术加工而制成的各种供欣赏和实用的工艺品；包括雕刻工艺品、塑造工艺品，以及类似的雕塑工艺品",
                                "kws": "牌类娱乐用品、雕塑",
                                "taxName": "工艺品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1060501000000000000",
                                "taxCodeTitle": "工艺品",
                                "iTitle": "*工艺品*雕塑工艺品",
                                "children": [
                                    {
                                        "id": "1064",
                                        "linkid": "1063",
                                        "code": "106050101",
                                        "paCode": "1060501",
                                        "yn": "N",
                                        "title": "雕刻工艺品",
                                        "alias": "雕刻工艺品",
                                        "about": "指用玉石、宝石、彩石、象牙、角、骨、贝壳等天然或人造硬质材料，以及木、竹、果壳（核）等天然植物材料为原料，经雕、刻、琢、磨等艺术加工而制成的各种供欣赏和实用的工艺品",
                                        "kws": "雕刻工艺品、玉石雕刻、宝石雕刻、水晶雕刻、彩石雕刻、建筑石材雕刻、牙雕、骨雕、角雕、贝壳雕、木雕、根雕、竹雕、果壳、果核雕刻、微雕、砖雕、煤晶雕、刻砚、料器雕刻、冷加工玻璃雕刻",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060501010000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*雕刻工艺品",
                                        "children": []
                                    },
                                    {
                                        "id": "1065",
                                        "linkid": "1063",
                                        "code": "106050102",
                                        "paCode": "1060501",
                                        "yn": "N",
                                        "title": "塑造工艺品",
                                        "alias": "塑造工艺品",
                                        "about": "指用石膏、泥、面、蜡、树脂、糖、酥油、塑料等可塑性材料为原料，经捏或塑等艺术加工而制成的各种供欣赏和实用的工艺品（包括庭园用喷泉等装饰品）",
                                        "kws": "塑造工艺品、石膏塑造画框、石膏塑造相框、石膏塑造庭园喷泉装饰品、面塑、面人、泥膏塑造画框、泥膏塑造相框、泥膏塑造庭园喷泉装饰品、蜡塑、蜡像、树脂塑造画框、树脂塑造相框、树脂塑造庭园喷泉装饰品",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060501020000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*塑造工艺品",
                                        "children": []
                                    },
                                    {
                                        "id": "1066",
                                        "linkid": "1063",
                                        "code": "106050199",
                                        "paCode": "1060501",
                                        "yn": "N",
                                        "title": "其他雕塑工艺品",
                                        "alias": "其他雕塑工艺品",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060501990000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*其他雕塑工艺品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1067",
                                "linkid": "1062",
                                "code": "1060502",
                                "paCode": "10605",
                                "yn": "Y",
                                "title": "金属工艺品",
                                "alias": "金属工艺品",
                                "about": "指以金、银、铁、铜、锡等各种金属为原料，经过制胎、浇铸、锻打、錾刻、搓丝、焊接、纺织、镶嵌、点蓝、烧制、打磨、电镀等工艺加工制成的造型美观、花纹图案精致的工艺品",
                                "kws": "金属工艺品",
                                "taxName": "工艺品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1060502000000000000",
                                "taxCodeTitle": "工艺品",
                                "iTitle": "*工艺品*金属工艺品",
                                "children": [
                                    {
                                        "id": "1068",
                                        "linkid": "1067",
                                        "code": "106050201",
                                        "paCode": "1060502",
                                        "yn": "N",
                                        "title": "景泰蓝工艺品",
                                        "alias": "景泰蓝工艺品",
                                        "about": "亦称铜胎掐丝珐琅，包括铜胎掐丝珐琅、掐丝景泰蓝、机制景泰蓝、画珐琅（烧瓷）",
                                        "kws": "景泰蓝工艺品、铜胎掐丝珐琅、掐丝景泰蓝、机制景泰蓝、画珐琅",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060502010000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*景泰蓝工艺品",
                                        "children": []
                                    },
                                    {
                                        "id": "1069",
                                        "linkid": "1067",
                                        "code": "106050202",
                                        "paCode": "1060502",
                                        "yn": "N",
                                        "title": "珐琅珀晶工艺品",
                                        "alias": "珐琅珀晶工艺品",
                                        "about": "指借鉴景泰蓝工艺，在胎上掐丝、点蓝，经涂饰后制成的金属工艺品",
                                        "kws": "珐琅珀晶",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060502020000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*珐琅珀晶工艺品",
                                        "children": []
                                    },
                                    {
                                        "id": "1070",
                                        "linkid": "1067",
                                        "code": "106050203",
                                        "paCode": "1060502",
                                        "yn": "N",
                                        "title": "银蓝工艺品",
                                        "alias": "银蓝工艺品",
                                        "about": null,
                                        "kws": "银蓝",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060502030000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*银蓝工艺品",
                                        "children": []
                                    },
                                    {
                                        "id": "1071",
                                        "linkid": "1067",
                                        "code": "106050204",
                                        "paCode": "1060502",
                                        "yn": "N",
                                        "title": "贵金属摆件",
                                        "alias": "贵金属摆件",
                                        "about": "指用金、铂、银、钯等贵金属及其合金，经镶嵌或未镶嵌工艺而制成的盘、碗、碟等各类器皿及工艺陈设摆件",
                                        "kws": "金摆件、银摆件、铂摆件",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060502040000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*贵金属摆件",
                                        "children": []
                                    },
                                    {
                                        "id": "1072",
                                        "linkid": "1067",
                                        "code": "106050205",
                                        "paCode": "1060502",
                                        "yn": "N",
                                        "title": "铜制工艺品",
                                        "alias": "铜制工艺品",
                                        "about": "包括斑铜工艺品、仿古铜工艺品、铸铜、镀铜、煅铜工艺品等；不包括铜制刀剑工艺品（详见106050208）",
                                        "kws": "斑铜、仿古铜、铸铜、镀铜、煅铜",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060502050000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*铜制工艺品",
                                        "children": []
                                    },
                                    {
                                        "id": "1073",
                                        "linkid": "1067",
                                        "code": "106050206",
                                        "paCode": "1060502",
                                        "yn": "N",
                                        "title": "铁制工艺品",
                                        "alias": "铁制工艺品",
                                        "about": "包括铁制的各种室内外陈列工艺品包括铁画、藤铁制品；不包括铸铁的艺术门窗（详见108040201），铁制刀剑工艺品（详见106050206）。",
                                        "kws": "铁画",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060502060000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*铁制工艺品",
                                        "children": []
                                    },
                                    {
                                        "id": "1074",
                                        "linkid": "1067",
                                        "code": "106050207",
                                        "paCode": "1060502",
                                        "yn": "N",
                                        "title": "锡制工艺品",
                                        "alias": "锡制工艺品",
                                        "about": "包括锡烛台，不包括锡制刀剑工艺品（详见106050207）",
                                        "kws": "锡烛台",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060502070000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*锡制工艺品",
                                        "children": []
                                    },
                                    {
                                        "id": "1075",
                                        "linkid": "1067",
                                        "code": "106050208",
                                        "paCode": "1060502",
                                        "yn": "N",
                                        "title": "金属制民间刀剑工艺品",
                                        "alias": "金属制民间刀剑工艺品",
                                        "about": "包括用各种金属材料制作的民族工艺刀剑（如龙泉宝剑、蒙古刀、藏刀等）",
                                        "kws": "工艺刀剑、龙泉宝剑、蒙古刀、藏刀",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060502080000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*金属制民间刀剑工艺品",
                                        "children": []
                                    },
                                    {
                                        "id": "1076",
                                        "linkid": "1067",
                                        "code": "106050209",
                                        "paCode": "1060502",
                                        "yn": "N",
                                        "title": "金属丝编织工艺品",
                                        "alias": "金属丝编织工艺品",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060502090000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*金属丝编织工艺品",
                                        "children": []
                                    },
                                    {
                                        "id": "1077",
                                        "linkid": "1067",
                                        "code": "106050210",
                                        "paCode": "1060502",
                                        "yn": "N",
                                        "title": "金属制艺术标牌及类似品",
                                        "alias": "金属制艺术标牌及类似品",
                                        "about": "包括用各种金属材料制作的艺术徽章、纪念章、标牌、挂牌、奖杯、奖章及类似品",
                                        "kws": "艺术徽章、纪念章、标牌、挂牌、艺术装潢标牌、仿古金属挂牌、奖杯、奖章",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060502100000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*金属制艺术标牌及类似品",
                                        "children": []
                                    },
                                    {
                                        "id": "1078",
                                        "linkid": "1067",
                                        "code": "106050211",
                                        "paCode": "1060502",
                                        "yn": "N",
                                        "title": "蒙镶工艺品",
                                        "alias": "蒙镶工艺品",
                                        "about": "包括蒙镶炉、鼎等和蒙镶动物等",
                                        "kws": "蒙镶炉、蒙镶鼎、蒙镶动物",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060502110000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*蒙镶工艺品",
                                        "children": []
                                    },
                                    {
                                        "id": "1079",
                                        "linkid": "1067",
                                        "code": "106050212",
                                        "paCode": "1060502",
                                        "yn": "N",
                                        "title": "金属制工艺框架类制品",
                                        "alias": "金属制工艺框架类制品",
                                        "about": "包括金属制工艺画框、相框等",
                                        "kws": "金属制工艺画框、相框",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060502120000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*金属制工艺框架类制品",
                                        "children": []
                                    },
                                    {
                                        "id": "1080",
                                        "linkid": "1067",
                                        "code": "106050299",
                                        "paCode": "1060502",
                                        "yn": "N",
                                        "title": "其他金属工艺品",
                                        "alias": "其他金属工艺品",
                                        "about": "包括用于家居、商业空间及类似场所的金属装饰品",
                                        "kws": null,
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060502990000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*其他金属工艺品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1081",
                                "linkid": "1062",
                                "code": "1060503",
                                "paCode": "10605",
                                "yn": "Y",
                                "title": "漆器工艺品",
                                "alias": "漆器工艺品",
                                "about": "指将半生漆、腰果漆加工调配成各种鲜艳的漆料，以木、纸、塑料、铜、布、皮等作胎，采用推光、雕填、彩画、嵌镶、刻灰等传统工艺和现代漆器工艺进行加工的工艺品；不包括漆器家具（详见105020199）",
                                "kws": null,
                                "taxName": "工艺品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1060503000000000000",
                                "taxCodeTitle": "工艺品",
                                "iTitle": "*工艺品*漆器工艺品",
                                "children": [
                                    {
                                        "id": "1082",
                                        "linkid": "1081",
                                        "code": "106050301",
                                        "paCode": "1060503",
                                        "yn": "N",
                                        "title": "镶嵌漆器工艺品",
                                        "alias": "镶嵌漆器工艺品",
                                        "about": "包括牙玉镶嵌漆器、骨石镶嵌漆器（金漆镶嵌）、螺钿镶嵌漆器、点螺镶嵌漆器",
                                        "kws": "镶嵌漆器工艺品、牙玉镶嵌漆器、骨石镶嵌漆器、金漆镶嵌、螺钿镶嵌漆器、点螺镶嵌漆器",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060503010000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*镶嵌漆器工艺品",
                                        "children": []
                                    },
                                    {
                                        "id": "1083",
                                        "linkid": "1081",
                                        "code": "106050302",
                                        "paCode": "1060503",
                                        "yn": "N",
                                        "title": "雕漆漆器工艺品",
                                        "alias": "雕漆漆器工艺品",
                                        "about": null,
                                        "kws": "镶嵌漆器工艺品、云雕漆器、木雕漆器",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060503020000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*雕漆漆器工艺品",
                                        "children": []
                                    },
                                    {
                                        "id": "1084",
                                        "linkid": "1081",
                                        "code": "106050303",
                                        "paCode": "1060503",
                                        "yn": "N",
                                        "title": "脱胎漆器工艺品",
                                        "alias": "脱胎漆器工艺品",
                                        "about": null,
                                        "kws": "脱胎漆器工艺品、夹苎胎漆器工艺品、麻胎漆器、纸胎漆器工艺品",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060503030000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*脱胎漆器工艺品",
                                        "children": []
                                    },
                                    {
                                        "id": "1085",
                                        "linkid": "1081",
                                        "code": "106050304",
                                        "paCode": "1060503",
                                        "yn": "N",
                                        "title": "彩绘雕填漆器工艺品",
                                        "alias": "彩绘雕填漆器工艺品",
                                        "about": null,
                                        "kws": "彩绘漆器、雕填漆器",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060503040000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*彩绘雕填漆器工艺品",
                                        "children": []
                                    },
                                    {
                                        "id": "1086",
                                        "linkid": "1081",
                                        "code": "106050305",
                                        "paCode": "1060503",
                                        "yn": "N",
                                        "title": "漆线雕工艺品",
                                        "alias": "漆线雕工艺品",
                                        "about": null,
                                        "kws": "漆线雕工艺品、堆漆漆器",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060503050000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*漆线雕工艺品",
                                        "children": []
                                    },
                                    {
                                        "id": "1087",
                                        "linkid": "1081",
                                        "code": "106050306",
                                        "paCode": "1060503",
                                        "yn": "N",
                                        "title": "刻灰漆器工艺品",
                                        "alias": "刻灰漆器工艺品",
                                        "about": null,
                                        "kws": "刻灰漆器",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060503060000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*刻灰漆器工艺品",
                                        "children": []
                                    },
                                    {
                                        "id": "1088",
                                        "linkid": "1081",
                                        "code": "106050307",
                                        "paCode": "1060503",
                                        "yn": "N",
                                        "title": "漆画工艺品",
                                        "alias": "漆画工艺品",
                                        "about": null,
                                        "kws": "漆画工艺品、漆画",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060503070000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*漆画工艺品",
                                        "children": []
                                    },
                                    {
                                        "id": "1089",
                                        "linkid": "1081",
                                        "code": "106050308",
                                        "paCode": "1060503",
                                        "yn": "N",
                                        "title": "漆器工艺框架类制品",
                                        "alias": "漆器工艺框架类制品",
                                        "about": "包括漆器工艺画框、相框等",
                                        "kws": "漆器工艺框架",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060503080000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*漆器工艺框架类制品",
                                        "children": []
                                    },
                                    {
                                        "id": "1090",
                                        "linkid": "1081",
                                        "code": "106050399",
                                        "paCode": "1060503",
                                        "yn": "N",
                                        "title": "其他漆器工艺品",
                                        "alias": "其他漆器工艺品",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060503990000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*其他漆器工艺品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1091",
                                "linkid": "1062",
                                "code": "1060504",
                                "paCode": "10605",
                                "yn": "Y",
                                "title": "花画工艺品",
                                "alias": "花画工艺品",
                                "about": "指用绢、丝、绒、纸、涤纶、塑料、羽毛、通草以及鲜花草等制成的植物、叶、花、果实、盆景等各种人造花类工艺品和以画面出现、可以挂或摆的具有欣赏性、装饰性的各种画类工艺品",
                                "kws": null,
                                "taxName": "工艺品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1060504000000000000",
                                "taxCodeTitle": "工艺品",
                                "iTitle": "*工艺品*花画工艺品",
                                "children": [
                                    {
                                        "id": "1092",
                                        "linkid": "1091",
                                        "code": "106050401",
                                        "paCode": "1060504",
                                        "yn": "N",
                                        "title": "人造花类工艺品",
                                        "alias": "人造花类工艺品",
                                        "about": "指以绢、丝、绒、纸、涤纶、塑料、羽毛、通草以及鲜花草等为原料，经造型设计、压模、剪贴、干燥等工艺制成的人造植物、叶、花、果实、盆景等花类艺术制品（包括人造花类工艺品的零件）",
                                        "kws": "人造花类工艺品、塑料制人造花、羽毛制人造、丝制人造花类工艺品、绢丝制人造花类工艺品、化纤制人造花类工艺品",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060504010000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*人造花类工艺品",
                                        "children": []
                                    },
                                    {
                                        "id": "1093",
                                        "linkid": "1091",
                                        "code": "106050402",
                                        "paCode": "1060504",
                                        "yn": "N",
                                        "title": "画类工艺品",
                                        "alias": "画类工艺品",
                                        "about": "指以画面出现、可以挂或摆的具有欣赏性、装饰性的画，包括国画、西洋画、皮革画、油画、粉画、手绘画、雕版画、印制画、石印画、拼贴画及类似装饰板、版画、邮票画等画类工艺品",
                                        "kws": "国画、油画、粉画、手绘画、彩绘、水彩画、雕版画、石印画、白云石画、工艺装饰画、版画、木版年画、烙画、邮票画、邮票、首日封、纪念封",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060504020000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*画类工艺品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1094",
                                "linkid": "1062",
                                "code": "1060505",
                                "paCode": "10605",
                                "yn": "Y",
                                "title": "天然植物纤维及人造纤维编织工艺品",
                                "alias": "天然植物纤维及人造纤维编织工艺品",
                                "about": "指以竹、藤、棕、草、柳、葵、麻等天然植物纤维和人造纤维为材料，经编织或镶嵌而成具有造型艺术或图案花纹，以欣赏为主的工艺陈列品以及实用工艺品",
                                "kws": "天然植物纤维工艺品、人造纤维编织工艺品",
                                "taxName": "工艺品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1060505000000000000",
                                "taxCodeTitle": "工艺品",
                                "iTitle": "*工艺品*天然植物纤维及人造纤维编织工艺品",
                                "children": [
                                    {
                                        "id": "1095",
                                        "linkid": "1094",
                                        "code": "106050501",
                                        "paCode": "1060505",
                                        "yn": "N",
                                        "title": "天然植物纤维编织工艺品",
                                        "alias": "天然植物纤维编织工艺品",
                                        "about": "指以竹、藤、棕、草、柳、葵、麻等天然植物纤维为材料，经编织或镶嵌而成具有造型艺术或图案花纹，以欣赏为主的工艺陈列品以及实用工艺品",
                                        "kws": "天然植物纤维编织工艺品、竹编工艺品、藤编工艺品、草编工艺品、棕编工艺品、玉米皮编织工艺品、柳编工艺品、葵编工艺品、麻制工艺品",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060505010000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*天然植物纤维编织工艺品",
                                        "children": []
                                    },
                                    {
                                        "id": "1096",
                                        "linkid": "1094",
                                        "code": "106050502",
                                        "paCode": "1060505",
                                        "yn": "N",
                                        "title": "人造纤维编织工艺品",
                                        "alias": "人造纤维编织工艺品",
                                        "about": "指以人造纤维为材料，经编织或镶嵌而成，具有造型艺术或图案花纹，以欣赏为主的工艺陈列品以及实用工艺品",
                                        "kws": "人造纤维编织工艺品",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060505020000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*人造纤维编织工艺品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1097",
                                "linkid": "1062",
                                "code": "1060506",
                                "paCode": "10605",
                                "yn": "Y",
                                "title": "抽纱刺绣工艺品",
                                "alias": "抽纱刺绣工艺品",
                                "about": "指以棉、麻、丝、毛及人造纤维纺织品等为主要原料，采用刺绣、抽、拉、钩等特殊手工工艺或机制方法加工制成的、具有较强装饰效果的各种生活用纺织工艺品",
                                "kws": null,
                                "taxName": "工艺品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1060506000000000000",
                                "taxCodeTitle": "工艺品",
                                "iTitle": "*工艺品*抽纱刺绣工艺品",
                                "children": [
                                    {
                                        "id": "1098",
                                        "linkid": "1097",
                                        "code": "106050601",
                                        "paCode": "1060506",
                                        "yn": "N",
                                        "title": "刺绣工艺品",
                                        "alias": "刺绣工艺品",
                                        "about": "指以绣针引彩线（丝、绒线），按设计的花样在织物（丝绸、布帛）上刺缀运针，以绣迹构成纹样或文字而制成的工艺品",
                                        "kws": "刺绣工艺品、手工刺绣工艺品、机绣工艺品",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060506010000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*刺绣工艺品",
                                        "children": []
                                    },
                                    {
                                        "id": "1099",
                                        "linkid": "1097",
                                        "code": "106050602",
                                        "paCode": "1060506",
                                        "yn": "N",
                                        "title": "抽纱工艺品",
                                        "alias": "抽纱工艺品",
                                        "about": "指根据图案设计，将花纹部分的经线或纬线抽去后加以连缀，形成透空的装饰花纹的日用工艺品；或运用雕平绣、彩平绣、十字花绣、挑花绣、补花绣等工艺手法制成的各种日用工艺品",
                                        "kws": "抽纱工艺品",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060506020000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*抽纱工艺品",
                                        "children": []
                                    },
                                    {
                                        "id": "1100",
                                        "linkid": "1097",
                                        "code": "106050603",
                                        "paCode": "1060506",
                                        "yn": "N",
                                        "title": "手工编结工艺品",
                                        "alias": "手工编结工艺品",
                                        "about": "包括万缕丝、万缕丝镶边、镶拼制品、网扣、花边等",
                                        "kws": "手工编结工艺品、万缕丝工艺品、万缕丝镶边工艺品、镶拼制品工艺品、网扣工艺品、花边工艺品、针结工艺品、线结工艺品、勾针工艺品",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060506030000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*手工编结工艺品",
                                        "children": []
                                    },
                                    {
                                        "id": "1101",
                                        "linkid": "1097",
                                        "code": "106050604",
                                        "paCode": "1060506",
                                        "yn": "N",
                                        "title": "手工染织工艺品及机织工艺品",
                                        "alias": "手工染织工艺品及机织工艺品",
                                        "about": "指手工印花布，如蜡染、扎染、拔染、手绘、烧花制品、缂丝",
                                        "kws": "手工染织工艺品、手工机织工艺品、手工印花布、印花品、蜡染工艺品、扎染工艺品、拔染工艺品、手绘工艺品、烧花制品工艺品、缂丝工艺品",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060506040000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*手工染织工艺品及机织工艺品",
                                        "children": []
                                    },
                                    {
                                        "id": "1102",
                                        "linkid": "1097",
                                        "code": "106050605",
                                        "paCode": "1060506",
                                        "yn": "N",
                                        "title": "工艺织锦",
                                        "alias": "工艺织锦",
                                        "about": "包括云锦、宋锦、蜀锦以及其他民族织锦和工艺织锦",
                                        "kws": "工艺织锦、云锦、宋锦、蜀锦、傣锦、民族织锦",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060506050000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*工艺织锦",
                                        "children": []
                                    },
                                    {
                                        "id": "1103",
                                        "linkid": "1097",
                                        "code": "106050699",
                                        "paCode": "1060506",
                                        "yn": "N",
                                        "title": "其他抽纱刺绣工艺品",
                                        "alias": "其他抽纱刺绣工艺品",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060506990000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*其他抽纱刺绣工艺品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1104",
                                "linkid": "1062",
                                "code": "1060507",
                                "paCode": "10605",
                                "yn": "Y",
                                "title": "地毯、挂毯类工艺品",
                                "alias": "地毯、挂毯类工艺品",
                                "about": "指以羊毛、丝、棉、麻及人造纤维等为原料，经手工编织、机织、栽绒等方式加工而成的各种具有装饰性的地面覆盖物或可用于悬挂、垫坐等用途的生活装饰用品",
                                "kws": "地毯、挂毯",
                                "taxName": "工艺品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1060507000000000000",
                                "taxCodeTitle": "工艺品",
                                "iTitle": "*工艺品*地毯、挂毯类工艺品",
                                "children": [
                                    {
                                        "id": "1105",
                                        "linkid": "1104",
                                        "code": "106050701",
                                        "paCode": "1060507",
                                        "yn": "N",
                                        "title": "手工地毯、挂毯",
                                        "alias": "手工地毯、挂毯",
                                        "about": null,
                                        "kws": "手工地毯、挂毯、手工打结羊毛、手工打结羊毛挂毯、手工打结真丝挂毯、手工打结人造丝、手工打结人造丝挂毯、手工簇绒、手工胶背、手工簇绒挂毯、手工簇绒羊毛、手工簇绒羊毛挂毯、手工簇绒化纤挂毯、手工簇绒浴室垫、手工编织地毯、手工编织挂毯、无绒头地毯、手工编织羊毛地毯、奥比松地毯",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060507010000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*手工地毯、挂毯",
                                        "children": []
                                    },
                                    {
                                        "id": "1106",
                                        "linkid": "1104",
                                        "code": "106050702",
                                        "paCode": "1060507",
                                        "yn": "N",
                                        "title": "机制地毯、挂毯",
                                        "alias": "机制地毯、挂毯",
                                        "about": "包括威尔顿地毯或挂毯、阿克明斯地毯或挂毯、机制簇绒地毯或挂毯、羊毛簇绒地毯或挂毯、化纤簇绒地毯或挂毯、混纺簇绒地毯或挂毯、机织地毯或挂毯、机制地毯或挂毯、针刺地毯或挂毯、化纤针刺地毯或挂毯、羊毛针刺地毯或挂毯、化纤浴室毯、化纤浴室垫、化纤门前毯、化纤门前垫、羊毛浴室毯、羊毛浴室垫、羊毛门前毯、羊毛门前垫、棉浴室毯、棉浴室垫、人造草坪毯、运动草坪毯、休闲草坪毯",
                                        "kws": "机制地毯、挂毯、威尔顿地毯、威尔顿挂毯、阿克明斯地毯、阿克明斯挂毯、羊毛簇绒地毯、羊毛簇绒挂毯、化纤簇绒地毯、化纤簇绒挂毯、混纺簇绒地毯、混纺簇绒挂毯、浴室毯、浴室垫、门前毯、门前垫、棉浴室毯、人造草坪毯、运动草坪毯、休闲草坪毯、草坪毯",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060507020000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*机制地毯、挂毯",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1107",
                                "linkid": "1062",
                                "code": "1060508",
                                "paCode": "10605",
                                "yn": "Y",
                                "title": "陈设艺术陶瓷制品",
                                "alias": "陈设艺术陶瓷制品",
                                "about": "包括室内陈设艺术陶瓷制品、工艺陶瓷制品、陶瓷壁画，以及其他未列明陈设艺术陶瓷制品",
                                "kws": "陈设艺术陶瓷、工艺陶瓷制品、陶瓷壁画",
                                "taxName": "工艺品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1060508000000000000",
                                "taxCodeTitle": "工艺品",
                                "iTitle": "*工艺品*陈设艺术陶瓷制品",
                                "children": [
                                    {
                                        "id": "1108",
                                        "linkid": "1107",
                                        "code": "106050801",
                                        "paCode": "1060508",
                                        "yn": "N",
                                        "title": "室内陈设艺术陶瓷制品",
                                        "alias": "室内陈设艺术陶瓷制品",
                                        "about": "包括陶瓷制人物、动物、静物等的摆件或挂件，艺术花瓶、茶具、酒具等",
                                        "kws": "室内陈设、摆件艺术陶瓷制品、挂件艺术陶瓷制品、艺术花瓶、茶具陶瓷制品、酒具陶瓷制品",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060508010000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*室内陈设艺术陶瓷制品",
                                        "children": []
                                    },
                                    {
                                        "id": "1109",
                                        "linkid": "1107",
                                        "code": "106050802",
                                        "paCode": "1060508",
                                        "yn": "N",
                                        "title": "工艺陶瓷制品",
                                        "alias": "工艺陶瓷制品",
                                        "about": "包括陶瓷制人物、动物小雕塑、圣诞节小礼品，各类陶瓷饰物等",
                                        "kws": "工艺陶瓷、陶瓷饰物",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060508020000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*工艺陶瓷制品",
                                        "children": []
                                    },
                                    {
                                        "id": "1110",
                                        "linkid": "1107",
                                        "code": "106050803",
                                        "paCode": "1060508",
                                        "yn": "N",
                                        "title": "陶瓷壁画",
                                        "alias": "陶瓷壁画",
                                        "about": "包括室内壁画和户外壁画",
                                        "kws": "室内陶瓷壁画、户外陶瓷壁画",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060508030000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*陶瓷壁画",
                                        "children": []
                                    },
                                    {
                                        "id": "1111",
                                        "linkid": "1107",
                                        "code": "106050804",
                                        "paCode": "1060508",
                                        "yn": "N",
                                        "title": "陶瓷制塑像",
                                        "alias": "陶瓷制塑像",
                                        "about": "包括瓷质、陶质及类似材料制作的人物、动物等塑像（不论建在园林或类似场所的室内或室外）",
                                        "kws": "瓷制塑像、陶制塑像",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060508040000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*陶瓷制塑像",
                                        "children": []
                                    },
                                    {
                                        "id": "1112",
                                        "linkid": "1107",
                                        "code": "106050899",
                                        "paCode": "1060508",
                                        "yn": "N",
                                        "title": "其他陈设艺术陶瓷制品",
                                        "alias": "其他陈设艺术陶瓷制品",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060508990000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*其他陈设艺术陶瓷制品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1113",
                                "linkid": "1062",
                                "code": "1060509",
                                "paCode": "10605",
                                "yn": "Y",
                                "title": "珠宝首饰",
                                "alias": "珠宝首饰",
                                "about": "各类珠宝及首饰",
                                "kws": "珠宝首饰",
                                "taxName": "珠宝首饰",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1060509000000000000",
                                "taxCodeTitle": "珠宝首饰",
                                "iTitle": "*珠宝首饰*珠宝首饰",
                                "children": [
                                    {
                                        "id": "1114",
                                        "linkid": "1113",
                                        "code": "106050901",
                                        "paCode": "1060509",
                                        "yn": "N",
                                        "title": "金银珠宝首饰",
                                        "alias": "金银珠宝首饰",
                                        "about": "以金、银、白金、宝石、珍珠、钻石、翡翠、珊瑚、玛瑙等高贵稀有物质以及其他金属、人造宝石等制作的各种纯金银首饰及镶嵌首饰，包括铂首饰。",
                                        "kws": "金银珠宝、项链、胸针、戒指、对戒、钻戒、钻、钯、耳环、耳钉、手镯、手链、脚链、发卡、挂件、吊坠、项坠、耳饰、耳夹、耳线、手串、锁骨链、佛珠、宝石、钻石、珍珠、松石、波斯松石、美国松石、墨西哥松石、埃及松石、绿松石、青金石、波斯青金石、苏联青金石、西班牙青金石、智利青金石、欧泊石、白欧泊石、黑欧泊石、晶质欧泊石、火欧泊石、胶状欧泊石、玉滴欧泊石、漂砾欧泊石、脉石欧泊石、基质中欧泊石、橄榄石、贵橄榄石、黄玉、镁橄榄石、铁橄榄石、黄昏祖母绿、祖母绿、硼铝镁石、长石、冰长石、日光石、砂金石的长石、拉长石、天河石、",
                                        "taxName": "珠宝首饰",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060509010000000000",
                                        "taxCodeTitle": "珠宝首饰",
                                        "iTitle": "*珠宝首饰*金银珠宝首饰",
                                        "children": []
                                    },
                                    {
                                        "id": "1115",
                                        "linkid": "1113",
                                        "code": "106050902",
                                        "paCode": "1060509",
                                        "yn": "Y",
                                        "title": "珠宝玉石",
                                        "alias": "珠宝玉石",
                                        "about": "包括钻石、珍珠、松石、青金石、欧泊石、橄榄石、长石、.玉、石英、玉髓、石榴石、锆石、尖晶石、黄玉、碧玺、金绿玉、绿柱石、刚玉、琥珀、珊瑚、煤玉、龟甲、合成刚玉、合成宝石、双合石、玻璃仿制品",
                                        "kws": null,
                                        "taxName": "珠宝首饰",
                                        "taxRate": "",
                                        "vip": "5",
                                        "itaxRate": null,
                                        "taxCode": "1060509020000000000",
                                        "taxCodeTitle": "珠宝首饰",
                                        "iTitle": "*珠宝首饰*珠宝玉石",
                                        "children": [
                                            {
                                                "id": "1116",
                                                "linkid": "1115",
                                                "code": "10605090201",
                                                "paCode": "106050902",
                                                "yn": "N",
                                                "title": "已加工钻石",
                                                "alias": "已加工钻石",
                                                "about": "成品钻",
                                                "kws": "已加工裸钻、已加工钻石、已加工钻",
                                                "taxName": "珠宝首饰",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060509020100000000",
                                                "taxCodeTitle": "珠宝首饰",
                                                "iTitle": "*珠宝首饰*已加工钻石",
                                                "children": []
                                            },
                                            {
                                                "id": "1117",
                                                "linkid": "1115",
                                                "code": "10605090202",
                                                "paCode": "106050902",
                                                "yn": "N",
                                                "title": "未加工钻石",
                                                "alias": "未加工钻石",
                                                "about": "毛钻",
                                                "kws": "未加工钻石、毛钻、未加工钻",
                                                "taxName": "珠宝首饰",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060509020200000000",
                                                "taxCodeTitle": "珠宝首饰",
                                                "iTitle": "*珠宝首饰*未加工钻石",
                                                "children": []
                                            },
                                            {
                                                "id": "1118",
                                                "linkid": "1115",
                                                "code": "10605090299",
                                                "paCode": "106050902",
                                                "yn": "N",
                                                "title": "其他珠宝玉石",
                                                "alias": "其他珠宝玉石",
                                                "about": null,
                                                "kws": "宝石、珍珠、松石、波斯松石、美国松石、墨西哥松石、埃及松石、绿松石、青金石、波斯青金石、苏联青金石、西班牙青金石、智利青金石、欧泊石、白欧泊石、黑欧泊石、晶质欧泊石、火欧泊石、胶状欧泊石、玉滴欧泊石、漂砾欧泊石、脉石欧泊石、基质中欧泊石、橄榄石、贵橄榄石、黄玉、镁橄榄石、铁橄榄石、黄昏祖母绿、祖母绿、硼铝镁石、长石、冰长石、日光石、砂金石的长石、拉长石、天河石、亚马逊石、玉、硬玉、软玉、翡翠、石英、水晶、晕彩、彩红石英、金红石斑点、网金红石石英、紫晶、黄晶、烟石英、烟晶、芙蓉石、东陵石、蓝线石石英、乳石英",
                                                "taxName": "珠宝首饰",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060509029900000000",
                                                "taxCodeTitle": "珠宝首饰",
                                                "iTitle": "*珠宝首饰*其他珠宝玉石",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "1119",
                                        "linkid": "1113",
                                        "code": "106050999",
                                        "paCode": "1060509",
                                        "yn": "N",
                                        "title": "其他珠宝首饰",
                                        "alias": "其他珠宝首饰",
                                        "about": null,
                                        "kws": "珠宝、石、玉、首饰",
                                        "taxName": "珠宝首饰",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060509990000000000",
                                        "taxCodeTitle": "珠宝首饰",
                                        "iTitle": "*珠宝首饰*其他珠宝首饰",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1120",
                                "linkid": "1062",
                                "code": "1060510",
                                "paCode": "10605",
                                "yn": "Y",
                                "title": "剧装道具，相关工艺美术品",
                                "alias": "剧装道具，相关工艺美术品",
                                "about": "包括剧装、道具、发制品及其专用原料、民间工艺品、工艺扇、工艺伞、灯彩、料器、美术人形、节庆庆典用品及相关娱乐用品、",
                                "kws": null,
                                "taxName": "工艺品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1060510000000000000",
                                "taxCodeTitle": "工艺品",
                                "iTitle": "*工艺品*剧装道具，相关工艺美术品",
                                "children": [
                                    {
                                        "id": "1121",
                                        "linkid": "1120",
                                        "code": "106051001",
                                        "paCode": "1060510",
                                        "yn": "N",
                                        "title": "剧装、道具",
                                        "alias": "剧装、道具",
                                        "about": null,
                                        "kws": "剧装、道具、戏剧演员用剧装、舞台道具",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060510010000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*剧装、道具",
                                        "children": []
                                    },
                                    {
                                        "id": "1122",
                                        "linkid": "1120",
                                        "code": "106051002",
                                        "paCode": "1060510",
                                        "yn": "Y",
                                        "title": "发制品及其专用原料",
                                        "alias": "发制品及其专用原料",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "工艺品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1060510020000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*发制品及其专用原料",
                                        "children": [
                                            {
                                                "id": "1123",
                                                "linkid": "1122",
                                                "code": "10605100201",
                                                "paCode": "106051002",
                                                "yn": "N",
                                                "title": "合成纺织材料制假发",
                                                "alias": "合成纺织材料制假发",
                                                "about": "包括合成纺织材料制整头假发",
                                                "kws": "假发、合成纺织材料制假发",
                                                "taxName": "工艺品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060510020100000000",
                                                "taxCodeTitle": "工艺品",
                                                "iTitle": "*工艺品*合成纺织材料制假发",
                                                "children": []
                                            },
                                            {
                                                "id": "1124",
                                                "linkid": "1122",
                                                "code": "10605100202",
                                                "paCode": "106051002",
                                                "yn": "N",
                                                "title": "档发",
                                                "alias": "档发",
                                                "about": "假发的一种，由辫发或削发加工而成，两端处理的较平整，多个人的头发，同样的长度整理在一起。档发分为单档，双档，双拐档。",
                                                "kws": "档发",
                                                "taxName": "工艺品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060510020200000000",
                                                "taxCodeTitle": "工艺品",
                                                "iTitle": "*工艺品*档发",
                                                "children": []
                                            },
                                            {
                                                "id": "1125",
                                                "linkid": "1122",
                                                "code": "10605100203",
                                                "paCode": "106051002",
                                                "yn": "N",
                                                "title": "人发制假发",
                                                "alias": "人发制假发",
                                                "about": null,
                                                "kws": "人发、假发",
                                                "taxName": "工艺品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060510020300000000",
                                                "taxCodeTitle": "工艺品",
                                                "iTitle": "*工艺品*人发制假发",
                                                "children": []
                                            },
                                            {
                                                "id": "1126",
                                                "linkid": "1122",
                                                "code": "10605100204",
                                                "paCode": "106051002",
                                                "yn": "N",
                                                "title": "人体毛发装饰用品",
                                                "alias": "人体毛发装饰用品",
                                                "about": "不包括合成纺织材料制假发（详见10605100201）、档发（详见10605100202）、人发制假发（详见10605100203）",
                                                "kws": "假胡须、假眉毛、假睫毛",
                                                "taxName": "工艺品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060510020400000000",
                                                "taxCodeTitle": "工艺品",
                                                "iTitle": "*工艺品*人体毛发装饰用品",
                                                "children": []
                                            },
                                            {
                                                "id": "1127",
                                                "linkid": "1122",
                                                "code": "10605100205",
                                                "paCode": "106051002",
                                                "yn": "N",
                                                "title": "发制品及类似品专用原料",
                                                "alias": "发制品及类似品专用原料",
                                                "about": "包括经梳理等加工的人发，以及制作假发用的纺织材料、羊毛原料等",
                                                "kws": null,
                                                "taxName": "工艺品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1060510020500000000",
                                                "taxCodeTitle": "工艺品",
                                                "iTitle": "*工艺品*发制品及类似品专用原料",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "1128",
                                        "linkid": "1120",
                                        "code": "106051003",
                                        "paCode": "1060510",
                                        "yn": "N",
                                        "title": "民间工艺品",
                                        "alias": "民间工艺品",
                                        "about": "包括风筝、皮影、剪纸、鼻烟壶等",
                                        "kws": "工艺、风筝、皮影、剪纸、鼻烟壶",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060510030000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*民间工艺品",
                                        "children": []
                                    },
                                    {
                                        "id": "1129",
                                        "linkid": "1120",
                                        "code": "106051004",
                                        "paCode": "1060510",
                                        "yn": "N",
                                        "title": "工艺扇",
                                        "alias": "工艺扇",
                                        "about": "包括象牙扇、檀香扇、羽毛扇、绢折扇等",
                                        "kws": "象牙扇、檀香扇、羽毛扇、绢折扇、工艺扇",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060510040000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*工艺扇",
                                        "children": []
                                    },
                                    {
                                        "id": "1130",
                                        "linkid": "1120",
                                        "code": "106051005",
                                        "paCode": "1060510",
                                        "yn": "N",
                                        "title": "工艺伞",
                                        "alias": "工艺伞",
                                        "about": "包括绢伞、绸伞等",
                                        "kws": "绢伞、绸伞、工艺伞",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060510050000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*工艺伞",
                                        "children": []
                                    },
                                    {
                                        "id": "1131",
                                        "linkid": "1120",
                                        "code": "106051006",
                                        "paCode": "1060510",
                                        "yn": "N",
                                        "title": "灯彩",
                                        "alias": "灯彩",
                                        "about": "包括木雕工艺灯、宫灯、纱灯、走马灯、彩灯等",
                                        "kws": "木雕工艺灯、宫灯、纱灯、走马灯、彩灯",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060510060000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*灯彩",
                                        "children": []
                                    },
                                    {
                                        "id": "1132",
                                        "linkid": "1120",
                                        "code": "106051007",
                                        "paCode": "1060510",
                                        "yn": "N",
                                        "title": "料器",
                                        "alias": "料器",
                                        "about": "指用加颜料的玻璃原料制成的器皿或手工艺品",
                                        "kws": "料器、琉璃、玻璃器",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060510070000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*料器",
                                        "children": []
                                    },
                                    {
                                        "id": "1133",
                                        "linkid": "1120",
                                        "code": "106051008",
                                        "paCode": "1060510",
                                        "yn": "N",
                                        "title": "美术人形",
                                        "alias": "美术人形",
                                        "about": "包括美术人偶",
                                        "kws": "人形、人偶",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060510080000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*美术人形",
                                        "children": []
                                    },
                                    {
                                        "id": "1134",
                                        "linkid": "1120",
                                        "code": "106051009",
                                        "paCode": "1060510",
                                        "yn": "N",
                                        "title": "节庆庆典用品及相关娱乐用品",
                                        "alias": "节庆庆典用品及相关娱乐用品",
                                        "about": "包括中西式节庆庆典娱乐活动用品，如魔术道具、花彩、花环等，以及用纸、金属箔、玻璃纤维等制成的人造雪、彩球、铃，化装舞会或中式节庆用面具及服装等各种节日用品",
                                        "kws": "魔术道具、花彩、花环、人造雪、彩球、铃、圣诞树、圣诞树裙、布挂、圣诞球、圣诞彩灯、圣诞服、圣诞帽、圣诞头饰、圣诞背饰、翅膀、灯笼、拉花、挂花、贴花、气球、充气拱门",
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060510090000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*节庆庆典用品及相关娱乐用品",
                                        "children": []
                                    },
                                    {
                                        "id": "1135",
                                        "linkid": "1120",
                                        "code": "106051099",
                                        "paCode": "1060510",
                                        "yn": "N",
                                        "title": "其他相关工艺美术品",
                                        "alias": "其他相关工艺美术品",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "工艺品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060510990000000000",
                                        "taxCodeTitle": "工艺品",
                                        "iTitle": "*工艺品*其他相关工艺美术品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1136",
                                "linkid": "1062",
                                "code": "1060511",
                                "paCode": "10605",
                                "yn": "Y",
                                "title": "保健休闲用品",
                                "alias": "保健休闲用品",
                                "about": "包括桑拿浴箱、排汗活动机、熏蒸足道机、养生桑拿蒸汽机、养生美体美容仪、养生理疗枕、养生塑身机、养生制氧机、养生水氧吧、Spa水疗机、Spa气泡按摩机、Spa精油温灸仪、高温竹炭制品、其他保健休闲用品",
                                "kws": null,
                                "taxName": "保健休闲用品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1060511000000000000",
                                "taxCodeTitle": "保健休闲用品",
                                "iTitle": "*保健休闲用品*保健休闲用品",
                                "children": [
                                    {
                                        "id": "1137",
                                        "linkid": "1136",
                                        "code": "106051101",
                                        "paCode": "1060511",
                                        "yn": "N",
                                        "title": "桑拿浴箱",
                                        "alias": "桑拿浴箱",
                                        "about": null,
                                        "kws": "桑拿浴箱",
                                        "taxName": "保健休闲用品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060511010000000000",
                                        "taxCodeTitle": "保健休闲用品",
                                        "iTitle": "*保健休闲用品*桑拿浴箱",
                                        "children": []
                                    },
                                    {
                                        "id": "1138",
                                        "linkid": "1136",
                                        "code": "106051102",
                                        "paCode": "1060511",
                                        "yn": "N",
                                        "title": "排汗活动机",
                                        "alias": "排汗活动机",
                                        "about": null,
                                        "kws": "排汗活动机",
                                        "taxName": "保健休闲用品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060511020000000000",
                                        "taxCodeTitle": "保健休闲用品",
                                        "iTitle": "*保健休闲用品*排汗活动机",
                                        "children": []
                                    },
                                    {
                                        "id": "1139",
                                        "linkid": "1136",
                                        "code": "106051103",
                                        "paCode": "1060511",
                                        "yn": "N",
                                        "title": "熏蒸足道机",
                                        "alias": "熏蒸足道机",
                                        "about": null,
                                        "kws": "熏蒸足道机",
                                        "taxName": "保健休闲用品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060511030000000000",
                                        "taxCodeTitle": "保健休闲用品",
                                        "iTitle": "*保健休闲用品*熏蒸足道机",
                                        "children": []
                                    },
                                    {
                                        "id": "1140",
                                        "linkid": "1136",
                                        "code": "106051104",
                                        "paCode": "1060511",
                                        "yn": "N",
                                        "title": "养生桑拿蒸汽机",
                                        "alias": "养生桑拿蒸汽机",
                                        "about": null,
                                        "kws": "养生桑拿蒸汽机",
                                        "taxName": "保健休闲用品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060511040000000000",
                                        "taxCodeTitle": "保健休闲用品",
                                        "iTitle": "*保健休闲用品*养生桑拿蒸汽机",
                                        "children": []
                                    },
                                    {
                                        "id": "1141",
                                        "linkid": "1136",
                                        "code": "106051105",
                                        "paCode": "1060511",
                                        "yn": "N",
                                        "title": "养生美体美容仪",
                                        "alias": "养生美体美容仪",
                                        "about": null,
                                        "kws": "养生美体美容仪",
                                        "taxName": "保健休闲用品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060511050000000000",
                                        "taxCodeTitle": "保健休闲用品",
                                        "iTitle": "*保健休闲用品*养生美体美容仪",
                                        "children": []
                                    },
                                    {
                                        "id": "1142",
                                        "linkid": "1136",
                                        "code": "106051106",
                                        "paCode": "1060511",
                                        "yn": "N",
                                        "title": "养生理疗枕",
                                        "alias": "养生理疗枕",
                                        "about": null,
                                        "kws": "养生理疗枕",
                                        "taxName": "保健休闲用品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060511060000000000",
                                        "taxCodeTitle": "保健休闲用品",
                                        "iTitle": "*保健休闲用品*养生理疗枕",
                                        "children": []
                                    },
                                    {
                                        "id": "1143",
                                        "linkid": "1136",
                                        "code": "106051107",
                                        "paCode": "1060511",
                                        "yn": "N",
                                        "title": "养生塑身机",
                                        "alias": "养生塑身机",
                                        "about": null,
                                        "kws": "养生塑身机",
                                        "taxName": "保健休闲用品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060511070000000000",
                                        "taxCodeTitle": "保健休闲用品",
                                        "iTitle": "*保健休闲用品*养生塑身机",
                                        "children": []
                                    },
                                    {
                                        "id": "1144",
                                        "linkid": "1136",
                                        "code": "106051108",
                                        "paCode": "1060511",
                                        "yn": "N",
                                        "title": "养生制氧机",
                                        "alias": "养生制氧机",
                                        "about": null,
                                        "kws": "养生制氧机",
                                        "taxName": "保健休闲用品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060511080000000000",
                                        "taxCodeTitle": "保健休闲用品",
                                        "iTitle": "*保健休闲用品*养生制氧机",
                                        "children": []
                                    },
                                    {
                                        "id": "1145",
                                        "linkid": "1136",
                                        "code": "106051109",
                                        "paCode": "1060511",
                                        "yn": "N",
                                        "title": "养生水氧吧",
                                        "alias": "养生水氧吧",
                                        "about": null,
                                        "kws": "养生水氧吧",
                                        "taxName": "保健休闲用品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060511090000000000",
                                        "taxCodeTitle": "保健休闲用品",
                                        "iTitle": "*保健休闲用品*养生水氧吧",
                                        "children": []
                                    },
                                    {
                                        "id": "1146",
                                        "linkid": "1136",
                                        "code": "106051110",
                                        "paCode": "1060511",
                                        "yn": "N",
                                        "title": "Spa水疗机",
                                        "alias": "Spa水疗机",
                                        "about": null,
                                        "kws": "Spa水疗机",
                                        "taxName": "保健休闲用品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060511100000000000",
                                        "taxCodeTitle": "保健休闲用品",
                                        "iTitle": "*保健休闲用品*Spa水疗机",
                                        "children": []
                                    },
                                    {
                                        "id": "1147",
                                        "linkid": "1136",
                                        "code": "106051111",
                                        "paCode": "1060511",
                                        "yn": "N",
                                        "title": "Spa气泡按摩机",
                                        "alias": "Spa气泡按摩机",
                                        "about": null,
                                        "kws": "Spa气泡按摩机",
                                        "taxName": "保健休闲用品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060511110000000000",
                                        "taxCodeTitle": "保健休闲用品",
                                        "iTitle": "*保健休闲用品*Spa气泡按摩机",
                                        "children": []
                                    },
                                    {
                                        "id": "1148",
                                        "linkid": "1136",
                                        "code": "106051112",
                                        "paCode": "1060511",
                                        "yn": "N",
                                        "title": "Spa精油温灸仪",
                                        "alias": "Spa精油温灸仪",
                                        "about": null,
                                        "kws": "Spa精油温灸仪",
                                        "taxName": "保健休闲用品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060511120000000000",
                                        "taxCodeTitle": "保健休闲用品",
                                        "iTitle": "*保健休闲用品*Spa精油温灸仪",
                                        "children": []
                                    },
                                    {
                                        "id": "1149",
                                        "linkid": "1136",
                                        "code": "106051113",
                                        "paCode": "1060511",
                                        "yn": "N",
                                        "title": "高温竹炭制品",
                                        "alias": "高温竹炭制品",
                                        "about": "包括可食用竹炭、净化竹炭、养生竹炭、家居竹炭、杀菌竹炭、美容竹炭、高温竹炭等",
                                        "kws": "竹炭、可食用竹炭、净化竹炭、养生竹炭、家居竹炭、杀菌竹炭、美容竹炭、高温竹炭",
                                        "taxName": "保健休闲用品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060511130000000000",
                                        "taxCodeTitle": "保健休闲用品",
                                        "iTitle": "*保健休闲用品*高温竹炭制品",
                                        "children": []
                                    },
                                    {
                                        "id": "1150",
                                        "linkid": "1136",
                                        "code": "106051199",
                                        "paCode": "1060511",
                                        "yn": "N",
                                        "title": "其他保健休闲用品",
                                        "alias": "其他保健休闲用品",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "保健休闲用品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060511990000000000",
                                        "taxCodeTitle": "保健休闲用品",
                                        "iTitle": "*保健休闲用品*其他保健休闲用品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1151",
                                "linkid": "1062",
                                "code": "1060512",
                                "paCode": "10605",
                                "yn": "Y",
                                "title": "日用杂品",
                                "alias": "日用杂品",
                                "about": "包括镜子类制品及零配件、刷子类制品、已加工刷类制品材料、清洁清扫类工具及其已加工材料、伞、手杖、鞭子、马鞭及其零件、拉链及其零件、扣类制品及其零件、打火机及其零件、烟具、头发装饰用物品、香水喷射器、粉扑及粉拍、礼仪电子用品、棉胎、其他日用杂品",
                                "kws": null,
                                "taxName": "日用杂品",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1060512000000000000",
                                "taxCodeTitle": "日用杂品",
                                "iTitle": "*日用杂品*日用杂品",
                                "children": [
                                    {
                                        "id": "1152",
                                        "linkid": "1151",
                                        "code": "106051201",
                                        "paCode": "1060512",
                                        "yn": "N",
                                        "title": "镜子类制品及零配件",
                                        "alias": "镜子类制品及零配件",
                                        "about": "包括民用镜、专用镜及其他镜类制品和配件",
                                        "kws": null,
                                        "taxName": "日用杂品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060512010000000000",
                                        "taxCodeTitle": "日用杂品",
                                        "iTitle": "*日用杂品*镜子类制品及零配件",
                                        "children": []
                                    },
                                    {
                                        "id": "1153",
                                        "linkid": "1151",
                                        "code": "106051202",
                                        "paCode": "1060512",
                                        "yn": "N",
                                        "title": "刷子类制品",
                                        "alias": "刷子类制品",
                                        "about": "包括用原毛、成品毛、棕、金属丝、塑料丝等材料制成的各种用途的刷子及类似品，如牙刷、发刷、剔须刷、指甲刷、睫毛刷、眉笔刷、施敷化妆品用刷、衣刷、鞋刷、洗涤用刷、漆刷、金属丝刷、非金属丝刷、油漆块垫、滚筒",
                                        "kws": "发刷、剔须刷、指甲刷、睫毛刷、眉笔刷、施敷化妆品用刷、家用刷、衣刷、鞋刷、洗涤用刷、漆刷及类似刷、猪鬃制漆刷、金属丝刷、机器零件用金属丝刷、器具零件用金属丝刷、车辆零件用金属丝刷、器具零件用非金属丝刷、车辆零件用非金属丝刷",
                                        "taxName": "日用杂品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060512020000000000",
                                        "taxCodeTitle": "日用杂品",
                                        "iTitle": "*日用杂品*刷子类制品",
                                        "children": []
                                    },
                                    {
                                        "id": "1154",
                                        "linkid": "1151",
                                        "code": "106051203",
                                        "paCode": "1060512",
                                        "yn": "N",
                                        "title": "已加工刷类制品材料",
                                        "alias": "已加工刷类制品材料",
                                        "about": "指用原毛、棕、金属丝、塑料丝等加工的，用于制作各种刷子的专用材料或半成品",
                                        "kws": null,
                                        "taxName": "日用杂品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060512030000000000",
                                        "taxCodeTitle": "日用杂品",
                                        "iTitle": "*日用杂品*已加工刷类制品材料",
                                        "children": []
                                    },
                                    {
                                        "id": "1155",
                                        "linkid": "1151",
                                        "code": "106051204",
                                        "paCode": "1060512",
                                        "yn": "N",
                                        "title": "清洁清扫类工具及其已加工材料",
                                        "alias": "清洁清扫类工具及其已加工材料",
                                        "about": "除刷子类制品(详见106051202)和已加工的刷类制品（详见106051203）以外的清洁清扫类工具及其已加工材料。",
                                        "kws": "羽毛掸、扫帚、拖把",
                                        "taxName": "日用杂品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060512040000000000",
                                        "taxCodeTitle": "日用杂品",
                                        "iTitle": "*日用杂品*清洁清扫类工具及其已加工材料",
                                        "children": []
                                    },
                                    {
                                        "id": "1156",
                                        "linkid": "1151",
                                        "code": "106051205",
                                        "paCode": "1060512",
                                        "yn": "N",
                                        "title": "伞、手杖、鞭子、马鞭及其零件",
                                        "alias": "伞、手杖、鞭子、马鞭及其零件",
                                        "about": "包括手杖、鞭子、马鞭、晴雨伞、太阳伞、带座手杖、助步杖、登山杖、鞭子、鞭、把柄、伞骨，及其零件",
                                        "kws": "伞、手杖、鞭子、马鞭、晴雨伞、太阳伞、带座手杖、助步杖、登山杖、把柄、伞骨",
                                        "taxName": "日用杂品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060512050000000000",
                                        "taxCodeTitle": "日用杂品",
                                        "iTitle": "*日用杂品*伞、手杖、鞭子、马鞭及其零件",
                                        "children": []
                                    },
                                    {
                                        "id": "1157",
                                        "linkid": "1151",
                                        "code": "106051206",
                                        "paCode": "1060512",
                                        "yn": "N",
                                        "title": "拉链及其零件",
                                        "alias": "拉链及其零件",
                                        "about": "包括金属齿拉链、尼龙齿拉链、树脂齿拉链、拉链零件",
                                        "kws": "拉链、拉链拉头、拉链纱带、金属齿拉链、尼龙齿拉链、树脂齿拉链、拉链零件",
                                        "taxName": "日用杂品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060512060000000000",
                                        "taxCodeTitle": "日用杂品",
                                        "iTitle": "*日用杂品*拉链及其零件",
                                        "children": []
                                    },
                                    {
                                        "id": "1158",
                                        "linkid": "1151",
                                        "code": "106051207",
                                        "paCode": "1060512",
                                        "yn": "N",
                                        "title": "扣类制品及其零件",
                                        "alias": "扣类制品及其零件",
                                        "about": null,
                                        "kws": "扣类制品、揿扣类制品、金属制揿扣、塑料制揿扣、树脂制揿扣",
                                        "taxName": "日用杂品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060512070000000000",
                                        "taxCodeTitle": "日用杂品",
                                        "iTitle": "*日用杂品*扣类制品及其零件",
                                        "children": []
                                    },
                                    {
                                        "id": "1159",
                                        "linkid": "1151",
                                        "code": "106051208",
                                        "paCode": "1060512",
                                        "yn": "N",
                                        "title": "打火机及其零件",
                                        "alias": "打火机及其零件",
                                        "about": null,
                                        "kws": "打火机",
                                        "taxName": "日用杂品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060512080000000000",
                                        "taxCodeTitle": "日用杂品",
                                        "iTitle": "*日用杂品*打火机及其零件",
                                        "children": []
                                    },
                                    {
                                        "id": "1160",
                                        "linkid": "1151",
                                        "code": "106051209",
                                        "paCode": "1060512",
                                        "yn": "N",
                                        "title": "烟具",
                                        "alias": "烟具",
                                        "about": "包括烟斗、烟斗头、烟嘴",
                                        "kws": "烟斗、烟斗头、烟嘴",
                                        "taxName": "日用杂品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060512090000000000",
                                        "taxCodeTitle": "日用杂品",
                                        "iTitle": "*日用杂品*烟具",
                                        "children": []
                                    },
                                    {
                                        "id": "1161",
                                        "linkid": "1151",
                                        "code": "106051210",
                                        "paCode": "1060512",
                                        "yn": "N",
                                        "title": "头发装饰用物品",
                                        "alias": "头发装饰用物品",
                                        "about": "包括梳子、橡胶梳、塑料梳、金属梳、牛角梳、木梳、发夹",
                                        "kws": "梳子、橡胶梳、塑料梳、金属梳、牛角梳、木梳、发夹",
                                        "taxName": "日用杂品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060512100000000000",
                                        "taxCodeTitle": "日用杂品",
                                        "iTitle": "*日用杂品*头发装饰用物品",
                                        "children": []
                                    },
                                    {
                                        "id": "1162",
                                        "linkid": "1151",
                                        "code": "106051211",
                                        "paCode": "1060512",
                                        "yn": "N",
                                        "title": "香水喷射器、粉扑及粉拍",
                                        "alias": "香水喷射器、粉扑及粉拍",
                                        "about": null,
                                        "kws": "香水喷射器、粉扑、粉拍、化妆喷雾器、座架、喷头",
                                        "taxName": "日用杂品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060512110000000000",
                                        "taxCodeTitle": "日用杂品",
                                        "iTitle": "*日用杂品*香水喷射器、粉扑及粉拍",
                                        "children": []
                                    },
                                    {
                                        "id": "1163",
                                        "linkid": "1151",
                                        "code": "106051212",
                                        "paCode": "1060512",
                                        "yn": "N",
                                        "title": "礼仪电子用品",
                                        "alias": "礼仪电子用品",
                                        "about": "指带有半导体和播放功能的礼仪用品，包括电子画框、电子相框、电子问候卡、电子广告卡",
                                        "kws": "电子画框、电子相框、电子问候卡、电子广告卡",
                                        "taxName": "日用杂品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060512120000000000",
                                        "taxCodeTitle": "日用杂品",
                                        "iTitle": "*日用杂品*礼仪电子用品",
                                        "children": []
                                    },
                                    {
                                        "id": "1164",
                                        "linkid": "1151",
                                        "code": "106051213",
                                        "paCode": "1060512",
                                        "yn": "N",
                                        "title": "棉胎",
                                        "alias": "棉胎",
                                        "about": "指纺织材料与胎料组合制被褥状纺织品，通常用于生产绗缝外套、被褥、床罩、褥垫、衣服、窗帘、座垫、台布内垫等",
                                        "kws": "棉胎、丝棉棉胎、毛制棉胎、棉制棉胎、化纤棉制棉胎",
                                        "taxName": "日用杂品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060512130000000000",
                                        "taxCodeTitle": "日用杂品",
                                        "iTitle": "*日用杂品*棉胎",
                                        "children": []
                                    },
                                    {
                                        "id": "1165",
                                        "linkid": "1151",
                                        "code": "106051214",
                                        "paCode": "1060512",
                                        "yn": "N",
                                        "title": "居民用煤制品",
                                        "alias": "居民用煤制品",
                                        "about": "包括型煤、蜂窝煤、煤砖、煤球、煤饼、引火炭",
                                        "kws": "型煤、蜂窝煤、煤砖、煤球、煤饼、引火炭",
                                        "taxName": "日用杂品",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1060512140000000000",
                                        "taxCodeTitle": "日用杂品",
                                        "iTitle": "*日用杂品*居民用煤制品",
                                        "children": []
                                    },
                                    {
                                        "id": "1166",
                                        "linkid": "1151",
                                        "code": "106051299",
                                        "paCode": "1060512",
                                        "yn": "N",
                                        "title": "其他日用杂品",
                                        "alias": "其他日用杂品",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "日用杂品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060512990000000000",
                                        "taxCodeTitle": "日用杂品",
                                        "iTitle": "*日用杂品*其他日用杂品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1167",
                                "linkid": "1062",
                                "code": "1060513",
                                "paCode": "10605",
                                "yn": "Y",
                                "title": "宠物用品",
                                "alias": "宠物用品",
                                "about": null,
                                "kws": null,
                                "taxName": "宠物用品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1060513000000000000",
                                "taxCodeTitle": "宠物用品",
                                "iTitle": "*宠物用品*宠物用品",
                                "children": [
                                    {
                                        "id": "1168",
                                        "linkid": "1167",
                                        "code": "106051301",
                                        "paCode": "1060513",
                                        "yn": "N",
                                        "title": "宠物玩具",
                                        "alias": "宠物玩具",
                                        "about": null,
                                        "kws": "宠物玩具",
                                        "taxName": "宠物用品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060513010000000000",
                                        "taxCodeTitle": "宠物用品",
                                        "iTitle": "*宠物用品*宠物玩具",
                                        "children": []
                                    },
                                    {
                                        "id": "1169",
                                        "linkid": "1167",
                                        "code": "106051302",
                                        "paCode": "1060513",
                                        "yn": "N",
                                        "title": "宠物服装",
                                        "alias": "宠物服装",
                                        "about": null,
                                        "kws": "宠物服装",
                                        "taxName": "宠物用品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060513020000000000",
                                        "taxCodeTitle": "宠物用品",
                                        "iTitle": "*宠物用品*宠物服装",
                                        "children": []
                                    },
                                    {
                                        "id": "1170",
                                        "linkid": "1167",
                                        "code": "106051303",
                                        "paCode": "1060513",
                                        "yn": "N",
                                        "title": "宠物消毒用品",
                                        "alias": "宠物消毒用品",
                                        "about": null,
                                        "kws": "宠物消毒用品",
                                        "taxName": "宠物用品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060513030000000000",
                                        "taxCodeTitle": "宠物用品",
                                        "iTitle": "*宠物用品*宠物消毒用品",
                                        "children": []
                                    },
                                    {
                                        "id": "1171",
                                        "linkid": "1167",
                                        "code": "106051304",
                                        "paCode": "1060513",
                                        "yn": "N",
                                        "title": "宠物专用品",
                                        "alias": "宠物专用品",
                                        "about": "包括窝垫、笼、牵绳、项圈、咬胶、猫砂、食具、美容用具、亚克利水族缸、水族缸过滤器、水族缸潜水泵、水族缸灯、水族景观水处理、底沙、水族装饰品、喂食器、饮水器、沙杠、笼、窝、宠物护栏、宠物护网、宠物训练器材及工具、跟踪器、防丢器，及其附属装置和零件",
                                        "kws": "宠物窝垫、宠物笼、宠物牵绳、宠物项圈、咬胶、猫砂、亚克利水族缸、水族缸过滤器、水族缸潜水泵、水族缸灯、水族景观水处理、水族景观底沙、水族装饰品、喂食器、宠物护栏、宠物护网、宠物训练器材及工具、宠物跟踪器、宠物防丢器",
                                        "taxName": "宠物用品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1060513040000000000",
                                        "taxCodeTitle": "宠物用品",
                                        "iTitle": "*宠物用品*宠物专用品",
                                        "children": []
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "id": "1172",
                "linkid": "1",
                "code": "107",
                "paCode": "1",
                "yn": "Y",
                "title": "石油、化工、医药产品",
                "alias": "石油、化工、医药产品",
                "about": null,
                "kws": null,
                "taxName": "石化医药产品",
                "taxRate": "",
                "vip": "7",
                "itaxRate": null,
                "taxCode": "1070000000000000000",
                "taxCodeTitle": "石化医药产品",
                "iTitle": "*石化医药产品*石油、化工、医药产品",
                "children": [
                    {
                        "id": "1173",
                        "linkid": "1172",
                        "code": "10701",
                        "paCode": "107",
                        "yn": "Y",
                        "title": "石油加工、炼焦及核燃料",
                        "alias": "石油加工、炼焦及核燃料",
                        "about": null,
                        "kws": null,
                        "taxName": "石油加工炼焦",
                        "taxRate": "",
                        "vip": "7",
                        "itaxRate": null,
                        "taxCode": "1070100000000000000",
                        "taxCodeTitle": "石油加工炼焦",
                        "iTitle": "*石油加工炼焦*石油加工、炼焦及核燃料",
                        "children": [
                            {
                                "id": "1174",
                                "linkid": "1173",
                                "code": "1070101",
                                "paCode": "10701",
                                "yn": "Y",
                                "title": "石油制品",
                                "alias": "石油制品",
                                "about": "包括以煤和页岩油为原料（包括其他原料）生成的成品油。",
                                "kws": null,
                                "taxName": "石油制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070101000000000000",
                                "taxCodeTitle": "石油制品",
                                "iTitle": "*石油制品*石油制品",
                                "children": [
                                    {
                                        "id": "1175",
                                        "linkid": "1174",
                                        "code": "107010101",
                                        "paCode": "1070101",
                                        "yn": "Y",
                                        "title": "汽油类",
                                        "alias": "汽油类",
                                        "about": "指用原油或其他原料加工生产的辛烷值不小于66的可用作汽油发动机燃料的各种轻质油。汽油分为车用汽油和航空汽油。以汽油、汽油组分调和生产的甲醇汽油、乙醇汽油；以废原矿物油生产的汽油、汽油组分；用于调和乙醇汽油的车用乙醇汽油调和组分油均属于汽油范围。",
                                        "kws": "汽油",
                                        "taxName": "汽油",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1070101010000000000",
                                        "taxCodeTitle": "汽油",
                                        "iTitle": "*汽油*汽油类",
                                        "children": [
                                            {
                                                "id": "1176",
                                                "linkid": "1175",
                                                "code": "10701010101",
                                                "paCode": "107010101",
                                                "yn": "N",
                                                "title": "汽油",
                                                "alias": "汽油",
                                                "about": "包括除甲醇汽油、乙醇汽油、车用乙醇汽油调和组分油、以废矿物油按规定生产的汽油以外的所有汽油和非标汽油。",
                                                "kws": "汽油",
                                                "taxName": "汽油",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070101010100000000",
                                                "taxCodeTitle": "汽油",
                                                "iTitle": "*汽油*汽油",
                                                "children": []
                                            },
                                            {
                                                "id": "1177",
                                                "linkid": "1175",
                                                "code": "10701010102",
                                                "paCode": "107010101",
                                                "yn": "N",
                                                "title": "甲醇汽油",
                                                "alias": "甲醇汽油",
                                                "about": "仅指符合国家标准的用作汽油发动机燃料的甲醇汽油，不符合国家标准的汽油发动机燃料归入汽油编码。",
                                                "kws": "汽油",
                                                "taxName": "甲醇汽油",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070101010200000000",
                                                "taxCodeTitle": "甲醇汽油",
                                                "iTitle": "*甲醇汽油*甲醇汽油",
                                                "children": []
                                            },
                                            {
                                                "id": "1178",
                                                "linkid": "1175",
                                                "code": "10701010103",
                                                "paCode": "107010101",
                                                "yn": "N",
                                                "title": "乙醇汽油",
                                                "alias": "乙醇汽油",
                                                "about": "仅指符合国家标准的用作汽油发动机燃料的乙醇汽油，不符合国家标准的汽油发动机燃料归入汽油编码。",
                                                "kws": "汽油",
                                                "taxName": "乙醇汽油",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070101010300000000",
                                                "taxCodeTitle": "乙醇汽油",
                                                "iTitle": "*乙醇汽油*乙醇汽油",
                                                "children": []
                                            },
                                            {
                                                "id": "1179",
                                                "linkid": "1175",
                                                "code": "10701010104",
                                                "paCode": "107010101",
                                                "yn": "N",
                                                "title": "汽油【废矿物油】",
                                                "alias": "汽油【废矿物油】",
                                                "about": "符合《财政部国家税务总局关于对废矿物油再生油品免征消费税的通知》（财税〔2013〕105号）规定，以废矿物油为原料生产的汽油。",
                                                "kws": "汽油",
                                                "taxName": "汽油【废矿物油】",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070101010400000000",
                                                "taxCodeTitle": "汽油【废矿物油】",
                                                "iTitle": "*汽油【废矿物油】*汽油【废矿物油】",
                                                "children": []
                                            },
                                            {
                                                "id": "1180",
                                                "linkid": "1175",
                                                "code": "10701010105",
                                                "paCode": "107010101",
                                                "yn": "N",
                                                "title": "车用乙醇汽油调和组分油",
                                                "alias": "车用乙醇汽油调和组分油",
                                                "about": "用于调和乙醇汽油的汽油组分油。",
                                                "kws": "汽油",
                                                "taxName": "乙醇汽油调和组分油",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070101010500000000",
                                                "taxCodeTitle": "乙醇汽油调和组分油",
                                                "iTitle": "*乙醇汽油调和组分油*车用乙醇汽油调和组分油",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "1181",
                                        "linkid": "1174",
                                        "code": "107010102",
                                        "paCode": "1070101",
                                        "yn": "Y",
                                        "title": "煤油类",
                                        "alias": "煤油类",
                                        "about": "包括航空煤油和其他煤油",
                                        "kws": "煤油",
                                        "taxName": "煤油",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1070101020000000000",
                                        "taxCodeTitle": "煤油",
                                        "iTitle": "*煤油*煤油类",
                                        "children": [
                                            {
                                                "id": "1182",
                                                "linkid": "1181",
                                                "code": "10701010201",
                                                "paCode": "107010102",
                                                "yn": "N",
                                                "title": "航空煤油",
                                                "alias": "航空煤油",
                                                "about": "航空煤油也叫喷气燃料，是用原油或其他原料加工生产的用作喷气发动机和喷气推进系统燃料的各种轻质油。",
                                                "kws": "航空煤油",
                                                "taxName": "航空煤油",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070101020100000000",
                                                "taxCodeTitle": "航空煤油",
                                                "iTitle": "*航空煤油*航空煤油",
                                                "children": []
                                            },
                                            {
                                                "id": "1183",
                                                "linkid": "1181",
                                                "code": "10701010202",
                                                "paCode": "107010102",
                                                "yn": "N",
                                                "title": "其他煤油",
                                                "alias": "其他煤油",
                                                "about": "除航空煤油以外所有煤油及煤油组分油",
                                                "kws": "煤油",
                                                "taxName": "其他煤油",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070101020200000000",
                                                "taxCodeTitle": "其他煤油",
                                                "iTitle": "*其他煤油*其他煤油",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "1184",
                                        "linkid": "1174",
                                        "code": "107010103",
                                        "paCode": "1070101",
                                        "yn": "Y",
                                        "title": "柴油类",
                                        "alias": "柴油类",
                                        "about": "指用原油或其他原料加工生产的倾点或凝点在-50至30的可用作柴油发动机燃料的各种轻质油和以柴油组分为主、经调和精制可用作柴油发动机燃料的非标油。以柴油、柴油组分调和生产的生物柴油也属于柴油范围。",
                                        "kws": "柴油",
                                        "taxName": "柴油",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1070101030000000000",
                                        "taxCodeTitle": "柴油",
                                        "iTitle": "*柴油*柴油类",
                                        "children": [
                                            {
                                                "id": "1185",
                                                "linkid": "1184",
                                                "code": "10701010301",
                                                "paCode": "107010103",
                                                "yn": "N",
                                                "title": "柴油",
                                                "alias": "柴油",
                                                "about": "除生物柴油、符合国家标准的纯生产柴油以及废矿物油生产的柴油外的全部柴油。",
                                                "kws": "柴油",
                                                "taxName": "柴油",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070101030100000000",
                                                "taxCodeTitle": "柴油",
                                                "iTitle": "*柴油*柴油",
                                                "children": []
                                            },
                                            {
                                                "id": "1186",
                                                "linkid": "1184",
                                                "code": "10701010302",
                                                "paCode": "107010103",
                                                "yn": "N",
                                                "title": "生物柴油",
                                                "alias": "生物柴油",
                                                "about": "含有纯生物柴油组分的柴油发动机燃料。",
                                                "kws": "生物柴油",
                                                "taxName": "生物柴油",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070101030200000000",
                                                "taxCodeTitle": "生物柴油",
                                                "iTitle": "*生物柴油*生物柴油",
                                                "children": []
                                            },
                                            {
                                                "id": "1187",
                                                "linkid": "1184",
                                                "code": "10701010303",
                                                "paCode": "107010103",
                                                "yn": "N",
                                                "title": "纯生物柴油",
                                                "alias": "纯生物柴油",
                                                "about": "按《财政部国家税务总局关于对利用废弃的动植物油生产纯生物柴油免征消费税的通知》（财税〔2010〕118号）规定，利用废弃的动物油和植物油为原料生产的符合国家《柴油机燃料调合用生物柴油（BD100）》标准的纯生物柴油。",
                                                "kws": "生物柴油",
                                                "taxName": "柴油【免】",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070101030300000000",
                                                "taxCodeTitle": "柴油【免】",
                                                "iTitle": "*柴油【免】*纯生物柴油",
                                                "children": []
                                            },
                                            {
                                                "id": "1188",
                                                "linkid": "1184",
                                                "code": "10701010304",
                                                "paCode": "107010103",
                                                "yn": "N",
                                                "title": "柴油【废矿物油】",
                                                "alias": "柴油【废矿物油】",
                                                "about": "符合《财政部国家税务总局关于对废矿物油再生油品免征消费税的通知》（财税〔2013〕105号）规定，以废矿物油为原料生产的柴油。",
                                                "kws": "柴油",
                                                "taxName": "柴油【废矿物油】",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070101030400000000",
                                                "taxCodeTitle": "柴油【废矿物油】",
                                                "iTitle": "*柴油【废矿物油】*柴油【废矿物油】",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "1189",
                                        "linkid": "1174",
                                        "code": "107010104",
                                        "paCode": "1070101",
                                        "yn": "Y",
                                        "title": "燃料油类",
                                        "alias": "燃料油类",
                                        "about": "也称重油、渣油，是用原油或其他原料加工生产，主要用作电厂发电、锅炉用燃料、加热炉燃料、冶金和其他工业炉燃料。",
                                        "kws": "燃料油",
                                        "taxName": "燃料油",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1070101040000000000",
                                        "taxCodeTitle": "燃料油",
                                        "iTitle": "*燃料油*燃料油类",
                                        "children": [
                                            {
                                                "id": "1190",
                                                "linkid": "1189",
                                                "code": "10701010401",
                                                "paCode": "107010104",
                                                "yn": "N",
                                                "title": "燃料油",
                                                "alias": "燃料油",
                                                "about": "除定点直供燃料油和以废矿物油为原料生产的燃料油外的全部燃料油。",
                                                "kws": "燃料油",
                                                "taxName": "燃料油",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070101040100000000",
                                                "taxCodeTitle": "燃料油",
                                                "iTitle": "*燃料油*燃料油",
                                                "children": []
                                            },
                                            {
                                                "id": "1191",
                                                "linkid": "1189",
                                                "code": "10701010402",
                                                "paCode": "107010104",
                                                "yn": "N",
                                                "title": "燃料油定点直供",
                                                "alias": "燃料油定点直供",
                                                "about": "按燃料油定点直供计划用于生产乙烯芳烃的燃料油",
                                                "kws": "燃料油",
                                                "taxName": "燃料油DDZG",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070101040200000000",
                                                "taxCodeTitle": "燃料油DDZG",
                                                "iTitle": "*燃料油DDZG*燃料油定点直供",
                                                "children": []
                                            },
                                            {
                                                "id": "1192",
                                                "linkid": "1189",
                                                "code": "10701010403",
                                                "paCode": "107010104",
                                                "yn": "N",
                                                "title": "燃料油【废矿物油】",
                                                "alias": "燃料油【废矿物油】",
                                                "about": "符合《财政部国家税务总局关于对废矿物油再生油品免征消费税的通知》（财税〔2013〕105号）规定，以废矿物油为原料生产的燃料油。",
                                                "kws": "燃料油",
                                                "taxName": "燃料油【废矿物油】",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070101040300000000",
                                                "taxCodeTitle": "燃料油【废矿物油】",
                                                "iTitle": "*燃料油【废矿物油】*燃料油【废矿物油】",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "1193",
                                        "linkid": "1174",
                                        "code": "107010105",
                                        "paCode": "1070101",
                                        "yn": "Y",
                                        "title": "石脑油类",
                                        "alias": "石脑油类",
                                        "about": "也称化工轻油，是以原油或其他原料加工生产的用于化工原料的轻质油。",
                                        "kws": "石脑油",
                                        "taxName": "石脑油",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1070101050000000000",
                                        "taxCodeTitle": "石脑油",
                                        "iTitle": "*石脑油*石脑油类",
                                        "children": [
                                            {
                                                "id": "1194",
                                                "linkid": "1193",
                                                "code": "10701010501",
                                                "paCode": "107010105",
                                                "yn": "N",
                                                "title": "石脑油",
                                                "alias": "石脑油",
                                                "about": "除定点直供燃料油和以废矿物油为原料生产的燃料油外的全部石脑油油。",
                                                "kws": "石脑油",
                                                "taxName": "石脑油",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070101050100000000",
                                                "taxCodeTitle": "石脑油",
                                                "iTitle": "*石脑油*石脑油",
                                                "children": []
                                            },
                                            {
                                                "id": "1195",
                                                "linkid": "1193",
                                                "code": "10701010502",
                                                "paCode": "107010105",
                                                "yn": "N",
                                                "title": "石脑油定点直供",
                                                "alias": "石脑油定点直供",
                                                "about": "按石脑油定点直供计划用于生产乙烯芳烃的石脑油",
                                                "kws": "石脑油",
                                                "taxName": "石脑油DDZG",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070101050200000000",
                                                "taxCodeTitle": "石脑油DDZG",
                                                "iTitle": "*石脑油DDZG*石脑油定点直供",
                                                "children": []
                                            },
                                            {
                                                "id": "1196",
                                                "linkid": "1193",
                                                "code": "10701010503",
                                                "paCode": "107010105",
                                                "yn": "N",
                                                "title": "石脑油【废矿物油】",
                                                "alias": "石脑油【废矿物油】",
                                                "about": "符合《财政部国家税务总局关于对废矿物油再生油品免征消费税的通知》（财税〔2013〕105号）规定，以废矿物油为原料生产的石脑油。",
                                                "kws": "石脑油",
                                                "taxName": "石脑油【废矿物油】",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070101050300000000",
                                                "taxCodeTitle": "石脑油【废矿物油】",
                                                "iTitle": "*石脑油【废矿物油】*石脑油【废矿物油】",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "1197",
                                        "linkid": "1174",
                                        "code": "107010106",
                                        "paCode": "1070101",
                                        "yn": "Y",
                                        "title": "溶剂油类",
                                        "alias": "溶剂油类",
                                        "about": "指用原油或其他原料加工生产的用于涂料、油漆、食用油、印刷油墨、皮革、农药、橡胶、化妆品生产和机械清洗、胶粘行业的轻质油，包括工业溶剂油、异构烷烃溶剂油、油墨溶剂油、专用溶剂油、其他溶剂油以及橡胶填充油、溶剂油原料等",
                                        "kws": null,
                                        "taxName": "溶剂油",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1070101060000000000",
                                        "taxCodeTitle": "溶剂油",
                                        "iTitle": "*溶剂油*溶剂油类",
                                        "children": [
                                            {
                                                "id": "1198",
                                                "linkid": "1197",
                                                "code": "10701010601",
                                                "paCode": "107010106",
                                                "yn": "N",
                                                "title": "溶剂油",
                                                "alias": "溶剂油",
                                                "about": "指用原油或其他原料加工生产的用于涂料、油漆、食用油、印刷油墨、皮革、农药、橡胶、化妆品生产和机械清洗、胶粘行业的轻质油，包括工业溶剂油、异构烷烃溶剂油、油墨溶剂油、专用溶剂油、其他溶剂油以及橡胶填充油、溶剂油原料等",
                                                "kws": "溶剂油",
                                                "taxName": "溶剂油",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070101060100000000",
                                                "taxCodeTitle": "溶剂油",
                                                "iTitle": "*溶剂油*溶剂油",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "1199",
                                        "linkid": "1174",
                                        "code": "107010107",
                                        "paCode": "1070101",
                                        "yn": "Y",
                                        "title": "润滑油类",
                                        "alias": "润滑油类",
                                        "about": "指用原油或其他原料加工生产的用于内燃机、机械加工过程的润滑产品。润滑油分为矿物性润滑油、植物性润滑油、动物性润滑油和化工原料合成润滑油。包括矿物性润滑油、矿物性润滑油基础油、植物性润滑油、动物性润滑油和化工原料合成润滑油。以植物性、动物性和矿物性基础油（或矿物性润滑油）混合掺配而成的“混合性”润滑油，不论矿物性基础油（或矿物性润滑油）所占比例高低，均属润滑油范围。",
                                        "kws": "润滑油",
                                        "taxName": "润滑油",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1070101070000000000",
                                        "taxCodeTitle": "润滑油",
                                        "iTitle": "*润滑油*润滑油类",
                                        "children": [
                                            {
                                                "id": "1200",
                                                "linkid": "1199",
                                                "code": "10701010701",
                                                "paCode": "107010107",
                                                "yn": "N",
                                                "title": "润滑油",
                                                "alias": "润滑油",
                                                "about": "除润滑脂和废矿物油生产的润滑油基础油外的全部润滑油和润滑油基础油。",
                                                "kws": "润滑油",
                                                "taxName": "润滑油",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070101070100000000",
                                                "taxCodeTitle": "润滑油",
                                                "iTitle": "*润滑油*润滑油",
                                                "children": []
                                            },
                                            {
                                                "id": "1201",
                                                "linkid": "1199",
                                                "code": "10701010702",
                                                "paCode": "107010107",
                                                "yn": "N",
                                                "title": "润滑脂",
                                                "alias": "润滑脂",
                                                "about": "主要由矿物油（或合成润滑油）和稠化剂调制而成",
                                                "kws": "润滑脂",
                                                "taxName": "润滑脂",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070101070200000000",
                                                "taxCodeTitle": "润滑脂",
                                                "iTitle": "*润滑脂*润滑脂",
                                                "children": []
                                            },
                                            {
                                                "id": "1202",
                                                "linkid": "1199",
                                                "code": "10701010703",
                                                "paCode": "107010107",
                                                "yn": "N",
                                                "title": "润滑油基础油【废矿物油】",
                                                "alias": "润滑油基础油【废矿物油】",
                                                "about": "符合《财政部国家税务总局关于对废矿物油再生油品免征消费税的通知》（财税〔2013〕105号）规定，以废矿物油为原料生产的润滑油基础油。",
                                                "kws": "润滑油基础油",
                                                "taxName": "润滑油基础油【废】",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070101070300000000",
                                                "taxCodeTitle": "润滑油基础油【废】",
                                                "iTitle": "*润滑油基础油【废】*润滑油基础油【废矿物油】",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "1203",
                                        "linkid": "1174",
                                        "code": "107010110",
                                        "paCode": "1070101",
                                        "yn": "N",
                                        "title": "液体石蜡",
                                        "alias": "液体石蜡",
                                        "about": "包括重质液体石蜡；是从原油分馏所得到的无色无味的混合物；它可以分成轻质矿物油及一般矿物油两种；可用作软膏、搽剂和化妆品的基质",
                                        "kws": "液体石蜡",
                                        "taxName": "液体石蜡",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070101100000000000",
                                        "taxCodeTitle": "液体石蜡",
                                        "iTitle": "*液体石蜡*液体石蜡",
                                        "children": []
                                    },
                                    {
                                        "id": "1204",
                                        "linkid": "1174",
                                        "code": "107010111",
                                        "paCode": "1070101",
                                        "yn": "Y",
                                        "title": "石油气，相关烃类气石油气",
                                        "alias": "石油气，相关烃类气石油气",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "石油气体",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1070101110000000000",
                                        "taxCodeTitle": "石油气体",
                                        "iTitle": "*石油气体*石油气，相关烃类气石油气",
                                        "children": [
                                            {
                                                "id": "1205",
                                                "linkid": "1204",
                                                "code": "10701011101",
                                                "paCode": "107010111",
                                                "yn": "N",
                                                "title": "液化石油气",
                                                "alias": "液化石油气",
                                                "about": "主要指以石油在提炼汽油、煤油、柴油、重油等油品过程中剩下的石油尾气为原料，经分离、脱硫精制而成的气体。",
                                                "kws": "液化石油气、石油液化气",
                                                "taxName": "液化气",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1070101110100000000",
                                                "taxCodeTitle": "液化气",
                                                "iTitle": "*液化气*液化石油气",
                                                "children": []
                                            },
                                            {
                                                "id": "1206",
                                                "linkid": "1204",
                                                "code": "10701011199",
                                                "paCode": "107010111",
                                                "yn": "N",
                                                "title": "其他石油气和相关烃类气",
                                                "alias": "其他石油气和相关烃类气",
                                                "about": "在炼油生产过程中产品的可燃气体",
                                                "kws": "打火机用丁烷气",
                                                "taxName": "石油气",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070101119900000000",
                                                "taxCodeTitle": "石油气",
                                                "iTitle": "*石油气*其他石油气和相关烃类气",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "1207",
                                        "linkid": "1174",
                                        "code": "107010112",
                                        "paCode": "1070101",
                                        "yn": "N",
                                        "title": "矿物蜡及合成法制类似产品",
                                        "alias": "矿物蜡及合成法制类似产品",
                                        "about": "包括凡士林、石蜡和其他合成方法制类似产品",
                                        "kws": "矿物蜡、凡士林、石蜡、精炼石蜡、食品石蜡、皂蜡、微晶石蜡",
                                        "taxName": "矿物蜡",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070101120000000000",
                                        "taxCodeTitle": "矿物蜡",
                                        "iTitle": "*矿物蜡*矿物蜡及合成法制类似产品",
                                        "children": []
                                    },
                                    {
                                        "id": "1208",
                                        "linkid": "1174",
                                        "code": "107010113",
                                        "paCode": "1070101",
                                        "yn": "Y",
                                        "title": "油类残渣",
                                        "alias": "油类残渣",
                                        "about": "指从石油等提取的油类残渣，包括石油焦（油渣类）、石油沥青、其他石油沥青等",
                                        "kws": "石油焦、石油沥青、道路沥青、建筑沥青、专用沥青",
                                        "taxName": "非成品油石油制品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1070101130000000000",
                                        "taxCodeTitle": "非成品油石油制品",
                                        "iTitle": "*非成品油石油制品*油类残渣",
                                        "children": [
                                            {
                                                "id": "1209",
                                                "linkid": "1208",
                                                "code": "10701011301",
                                                "paCode": "107010113",
                                                "yn": "N",
                                                "title": "石油沥青",
                                                "alias": "石油沥青",
                                                "about": "符合国家标准或石油化工行业标准的沥青产品。",
                                                "kws": "#石油沥青",
                                                "taxName": "沥青",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070101130100000000",
                                                "taxCodeTitle": "沥青",
                                                "iTitle": "*沥青*石油沥青",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "1210",
                                        "linkid": "1174",
                                        "code": "107010114",
                                        "paCode": "1070101",
                                        "yn": "N",
                                        "title": "绝缘油",
                                        "alias": "绝缘油",
                                        "about": "符合国家行业标准或行业标准的变压器油、导热类油类产品",
                                        "kws": "#绝缘油",
                                        "taxName": "绝缘油",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070101140000000000",
                                        "taxCodeTitle": "绝缘油",
                                        "iTitle": "*绝缘油*绝缘油",
                                        "children": []
                                    },
                                    {
                                        "id": "1211",
                                        "linkid": "1174",
                                        "code": "107010115",
                                        "paCode": "1070101",
                                        "yn": "N",
                                        "title": "废矿物油",
                                        "alias": "废矿物油",
                                        "about": "工业生产领域机械设备及汽车、船舶等交通运输设备使用后失去或降低功效更换下来的废润滑油",
                                        "kws": "废矿物油、废润滑油、废机油",
                                        "taxName": "废润滑油",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070101150000000000",
                                        "taxCodeTitle": "废润滑油",
                                        "iTitle": "*废润滑油*废矿物油",
                                        "children": []
                                    },
                                    {
                                        "id": "1212",
                                        "linkid": "1174",
                                        "code": "107010199",
                                        "paCode": "1070101",
                                        "yn": "N",
                                        "title": "其他石油制品",
                                        "alias": "其他石油制品",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "非成品油石油制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070101990000000000",
                                        "taxCodeTitle": "非成品油石油制品",
                                        "iTitle": "*非成品油石油制品*其他石油制品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1213",
                                "linkid": "1173",
                                "code": "1070102",
                                "paCode": "10701",
                                "yn": "Y",
                                "title": "人造能源产品",
                                "alias": "人造能源产品",
                                "about": null,
                                "kws": null,
                                "taxName": "人造能源",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070102000000000000",
                                "taxCodeTitle": "人造能源",
                                "iTitle": "*人造能源*人造能源产品",
                                "children": [
                                    {
                                        "id": "1214",
                                        "linkid": "1213",
                                        "code": "107010201",
                                        "paCode": "1070102",
                                        "yn": "N",
                                        "title": "页岩原油",
                                        "alias": "页岩原油",
                                        "about": "亦称油母页岩原油；指以油母页岩为原料生产的一种人造原油；",
                                        "kws": "页岩原油、油母页岩原油、页岩油",
                                        "taxName": "人造原油",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070102010000000000",
                                        "taxCodeTitle": "人造原油",
                                        "iTitle": "*人造原油*页岩原油",
                                        "children": []
                                    },
                                    {
                                        "id": "1215",
                                        "linkid": "1213",
                                        "code": "107010202",
                                        "paCode": "1070102",
                                        "yn": "Y",
                                        "title": "生物能源",
                                        "alias": "生物能源",
                                        "about": "主要指以动物、植物等生物质为原料生产的石油替代能源",
                                        "kws": null,
                                        "taxName": "人造能源",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1070102020000000000",
                                        "taxCodeTitle": "人造能源",
                                        "iTitle": "*人造能源*生物能源",
                                        "children": [
                                            {
                                                "id": "1216",
                                                "linkid": "1215",
                                                "code": "10701020204",
                                                "paCode": "107010202",
                                                "yn": "N",
                                                "title": "沼气",
                                                "alias": "沼气",
                                                "about": "是有机物质在厌氧条件下，经过微生物的发酵作用而生成的一种混合气体",
                                                "kws": "沼气",
                                                "taxName": "沼气",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1070102020400000000",
                                                "taxCodeTitle": "沼气",
                                                "iTitle": "*沼气*沼气",
                                                "children": []
                                            },
                                            {
                                                "id": "1217",
                                                "linkid": "1215",
                                                "code": "10701020205",
                                                "paCode": "107010202",
                                                "yn": "N",
                                                "title": "生物氢气",
                                                "alias": "生物氢气",
                                                "about": null,
                                                "kws": "生物氢气",
                                                "taxName": "氢气",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070102020500000000",
                                                "taxCodeTitle": "氢气",
                                                "iTitle": "*氢气*生物氢气",
                                                "children": []
                                            },
                                            {
                                                "id": "1218",
                                                "linkid": "1215",
                                                "code": "10701020206",
                                                "paCode": "107010202",
                                                "yn": "N",
                                                "title": "生物质致密成型燃料",
                                                "alias": "生物质致密成型燃料",
                                                "about": "由各种生物质压制成型的固体燃料",
                                                "kws": "生物质致密成型燃料、生物质压块",
                                                "taxName": "固体燃料",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070102020600000000",
                                                "taxCodeTitle": "固体燃料",
                                                "iTitle": "*固体燃料*生物质致密成型燃料",
                                                "children": []
                                            },
                                            {
                                                "id": "1219",
                                                "linkid": "1215",
                                                "code": "10701020207",
                                                "paCode": "107010202",
                                                "yn": "N",
                                                "title": "生物炭",
                                                "alias": "生物炭",
                                                "about": "是生物有机材料（生物质）在缺氧或绝氧环境中，经高温热裂解后生成的固态产物",
                                                "kws": "生物炭",
                                                "taxName": "生物炭",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070102020700000000",
                                                "taxCodeTitle": "生物炭",
                                                "iTitle": "*生物炭*生物炭",
                                                "children": []
                                            },
                                            {
                                                "id": "1220",
                                                "linkid": "1215",
                                                "code": "10701020208",
                                                "paCode": "107010202",
                                                "yn": "N",
                                                "title": "变性燃料乙醇",
                                                "alias": "变性燃料乙醇",
                                                "about": "符合国家标准的变性燃料乙醇（GB18350-2013）。",
                                                "kws": "乙醇",
                                                "taxName": "变性燃料乙醇",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070102020800000000",
                                                "taxCodeTitle": "变性燃料乙醇",
                                                "iTitle": "*变性燃料乙醇*变性燃料乙醇",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "1221",
                                        "linkid": "1213",
                                        "code": "107010203",
                                        "paCode": "1070102",
                                        "yn": "Y",
                                        "title": "合成液体燃料",
                                        "alias": "合成液体燃料",
                                        "about": "包括乙醇汽油、甲醇汽油、其他合成液体燃料",
                                        "kws": "合成液体燃料",
                                        "taxName": "非成品油燃料",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1070102030000000000",
                                        "taxCodeTitle": "非成品油燃料",
                                        "iTitle": "*非成品油燃料*合成液体燃料",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1222",
                                "linkid": "1173",
                                "code": "1070103",
                                "paCode": "10701",
                                "yn": "Y",
                                "title": "焦炭及其副产品",
                                "alias": "焦炭及其副产品",
                                "about": null,
                                "kws": null,
                                "taxName": "焦炭产品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070103000000000000",
                                "taxCodeTitle": "焦炭产品",
                                "iTitle": "*焦炭产品*焦炭及其副产品",
                                "children": [
                                    {
                                        "id": "1223",
                                        "linkid": "1222",
                                        "code": "107010301",
                                        "paCode": "1070103",
                                        "yn": "N",
                                        "title": "焦炭",
                                        "alias": "焦炭",
                                        "about": "煤炭等原料在隔绝空气的条件下，加热到950℃～1050℃，经过干燥、热解、熔融、粘结、固化、收缩等阶段最终制成焦炭，用于高炉冶炼、铸造和气化；净化后的焦炉煤气既是高热值的燃料，又是重要的有机合成工业原料",
                                        "kws": "焦炭、煤制焦炭、沥青焦",
                                        "taxName": "焦炭",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070103010000000000",
                                        "taxCodeTitle": "焦炭",
                                        "iTitle": "*焦炭*焦炭",
                                        "children": []
                                    },
                                    {
                                        "id": "1224",
                                        "linkid": "1222",
                                        "code": "107010302",
                                        "paCode": "1070103",
                                        "yn": "N",
                                        "title": "矿物焦油",
                                        "alias": "矿物焦油",
                                        "about": "从煤、褐煤或泥煤干馏所得的焦油等矿物焦油",
                                        "kws": "矿物焦油、煤焦油",
                                        "taxName": "非成品油焦油制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070103020000000000",
                                        "taxCodeTitle": "非成品油焦油制品",
                                        "iTitle": "*非成品油焦油制品*矿物焦油",
                                        "children": []
                                    },
                                    {
                                        "id": "1225",
                                        "linkid": "1222",
                                        "code": "107010303",
                                        "paCode": "1070103",
                                        "yn": "N",
                                        "title": "石油焦、碳黑",
                                        "alias": "石油焦、碳黑",
                                        "about": "包括以石油焦、和炭黑类产品",
                                        "kws": "石油焦、碳黑",
                                        "taxName": "石油焦制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070103030000000000",
                                        "taxCodeTitle": "石油焦制品",
                                        "iTitle": "*石油焦制品*石油焦、碳黑",
                                        "children": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "id": "1226",
                        "linkid": "1172",
                        "code": "10702",
                        "paCode": "107",
                        "yn": "Y",
                        "title": "化学原料及化学制品",
                        "alias": "化学原料及化学制品",
                        "about": null,
                        "kws": null,
                        "taxName": "化学原料及制品",
                        "taxRate": "",
                        "vip": "7",
                        "itaxRate": null,
                        "taxCode": "1070200000000000000",
                        "taxCodeTitle": "化学原料及制品",
                        "iTitle": "*化学原料及制品*化学原料及化学制品",
                        "children": [
                            {
                                "id": "1227",
                                "linkid": "1226",
                                "code": "1070201",
                                "paCode": "10702",
                                "yn": "Y",
                                "title": "无机基础化学原料",
                                "alias": "无机基础化学原料",
                                "about": null,
                                "kws": null,
                                "taxName": "无机化学原料",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070201000000000000",
                                "taxCodeTitle": "无机化学原料",
                                "iTitle": "*无机化学原料*无机基础化学原料",
                                "children": [
                                    {
                                        "id": "1228",
                                        "linkid": "1227",
                                        "code": "107020101",
                                        "paCode": "1070201",
                                        "yn": "Y",
                                        "title": "无机酸类",
                                        "alias": "无机酸类",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "无机化学原料",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1070201010000000000",
                                        "taxCodeTitle": "无机化学原料",
                                        "iTitle": "*无机化学原料*无机酸类",
                                        "children": [
                                            {
                                                "id": "1229",
                                                "linkid": "1228",
                                                "code": "10702010101",
                                                "paCode": "107020101",
                                                "yn": "N",
                                                "title": "硫酸类",
                                                "alias": "硫酸类",
                                                "about": "包括硫酸、发烟硫酸等",
                                                "kws": "硫酸、发烟硫酸",
                                                "taxName": "无机化学原料",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070201010100000000",
                                                "taxCodeTitle": "无机化学原料",
                                                "iTitle": "*无机化学原料*硫酸类",
                                                "children": []
                                            },
                                            {
                                                "id": "1230",
                                                "linkid": "1228",
                                                "code": "10702010102",
                                                "paCode": "107020101",
                                                "yn": "N",
                                                "title": "其他无机酸",
                                                "alias": "其他无机酸",
                                                "about": "包括硝酸类、盐酸、氯磺酸、磷酸、多磷酸、硼酸、氢氰酸（氰化氢）、氟酸、氯化酸、碘酸、氢硫酸、氢溴酸、钨酸、硅酸、硒酸、砷酸、钼酸、偏钛酸、氯铀酸、偏锡酸、溴酸、辛酸亚锡、其他无机酸",
                                                "kws": "无机酸、硝酸、浓硝酸、磺硝酸、盐酸、氯磺酸、磷酸、亚磷酸、次磷酸、多磷酸、偏磷酸、焦磷酸、多聚磷酸（四磷酸）、焦磷酸亚锡、硼酸、氢氰酸、氟酸、无水氢氟酸、氟硅酸、氟硼酸、氯化酸、次氯酸、氯酸、高氯酸、碘酸、氢碘酸、高碘酸、氢硫酸、氢溴酸、钨酸、硅酸、硒酸、砷酸、钼酸、偏钛酸、氯铀酸、偏锡酸、溴酸、辛酸亚锡",
                                                "taxName": "无机化学原料",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070201010200000000",
                                                "taxCodeTitle": "无机化学原料",
                                                "iTitle": "*无机化学原料*其他无机酸",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "1231",
                                        "linkid": "1227",
                                        "code": "107020102",
                                        "paCode": "1070201",
                                        "yn": "Y",
                                        "title": "非金属无机氧化物",
                                        "alias": "非金属无机氧化物",
                                        "about": "包括硼氧化物、硫氧化物、硅氧化物、硒氧化物、磷氧化物、砷氧化物、氧化氘等",
                                        "kws": "非金属无机氧化物、氧化硼、二氧化硫、三氧化硫、三氧化二硫、二氧化硅、二氧化硒、硒化氢、亚硒酸、五氧化二磷、三氧化二砷、五氧化二砷、氧化氘",
                                        "taxName": "无机化学原料",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1070201020000000000",
                                        "taxCodeTitle": "无机化学原料",
                                        "iTitle": "*无机化学原料*非金属无机氧化物",
                                        "children": [
                                            {
                                                "id": "1232",
                                                "linkid": "1231",
                                                "code": "10702010201",
                                                "paCode": "107020102",
                                                "yn": "N",
                                                "title": "粉煤灰",
                                                "alias": "粉煤灰",
                                                "about": "指从煤燃烧后的烟气中收捕下来的细灰，是燃煤电厂排出的主要固体废物。是从煤燃烧后的烟气中收捕下来的细灰，粉煤灰是燃煤电厂排出的主要固体废物。",
                                                "kws": "粉煤灰",
                                                "taxName": "无机化学原料",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070201020100000000",
                                                "taxCodeTitle": "无机化学原料",
                                                "iTitle": "*无机化学原料*粉煤灰",
                                                "children": []
                                            },
                                            {
                                                "id": "1233",
                                                "linkid": "1231",
                                                "code": "10702010299",
                                                "paCode": "107020102",
                                                "yn": "N",
                                                "title": "其他非金属无机氧化物",
                                                "alias": "其他非金属无机氧化物",
                                                "about": null,
                                                "kws": null,
                                                "taxName": "无机化学原料",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070201029900000000",
                                                "taxCodeTitle": "无机化学原料",
                                                "iTitle": "*无机化学原料*其他非金属无机氧化物",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "1234",
                                        "linkid": "1227",
                                        "code": "107020103",
                                        "paCode": "1070201",
                                        "yn": "N",
                                        "title": "过氧化氢（双氧水）",
                                        "alias": "过氧化氢（双氧水）",
                                        "about": "由硫酸作用于过氧化钡，或由电解氧化硫酸成过硫酸或硫酸盐成过硫酸盐再经水解，或由2-乙基蒽醌经氢化再经氧化而制得过氧化氢电解制取",
                                        "kws": "过氧化氢、双氧水",
                                        "taxName": "无机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070201030000000000",
                                        "taxCodeTitle": "无机化学原料",
                                        "iTitle": "*无机化学原料*过氧化氢（双氧水）",
                                        "children": []
                                    },
                                    {
                                        "id": "1235",
                                        "linkid": "1227",
                                        "code": "107020104",
                                        "paCode": "1070201",
                                        "yn": "N",
                                        "title": "非金属卤化物及硫化物",
                                        "alias": "非金属卤化物及硫化物",
                                        "about": "包括非金属卤化物、非金属氯氧化物、非金属硫化物",
                                        "kws": "非金属卤化物及硫化物、一氯化硫、氯化硫、二氯化硫、三氯化磷、三氯化砷、五氯化磷、氯化碘、三氯化碘、四氯化硅、溴化氢、三溴化磷、五溴化磷、三溴氧磷、五氟化磷、氯化亚砜、二氯氧化硫、亚硫酰氯、氧氯化磷、磷酰氯、三氯氧磷、碳酰二氯、光气、二氯氧化硒、氯氧化氮、二氧化氯、二硫化碳、二硫化硅、二硫化二砷、三硫化二砷、五硫化二砷、三硫化二磷、三硫化四磷、五硫化二磷、硫化氢",
                                        "taxName": "无机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070201040000000000",
                                        "taxCodeTitle": "无机化学原料",
                                        "iTitle": "*无机化学原料*非金属卤化物及硫化物",
                                        "children": []
                                    },
                                    {
                                        "id": "1236",
                                        "linkid": "1227",
                                        "code": "107020105",
                                        "paCode": "1070201",
                                        "yn": "N",
                                        "title": "烧碱",
                                        "alias": "烧碱",
                                        "about": "包括由盐水电解法或由纯碱（或天然碱）苛化法等方法生产的固体和液体的氢氧化钠",
                                        "kws": "烧碱",
                                        "taxName": "无机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070201050000000000",
                                        "taxCodeTitle": "无机化学原料",
                                        "iTitle": "*无机化学原料*烧碱",
                                        "children": []
                                    },
                                    {
                                        "id": "1237",
                                        "linkid": "1227",
                                        "code": "107020106",
                                        "paCode": "1070201",
                                        "yn": "N",
                                        "title": "纯碱类",
                                        "alias": "纯碱类",
                                        "about": "包括纯碱（碳酸钠）、碳酸氢钠（小苏打）、碳酸钾、碳酸氢钾（重碳酸钾）等",
                                        "kws": "纯碱、碳酸钠、轻质碳酸钠、重质碳酸钠、碳酸氢钠、小苏打、碳酸钾、碳酸氢钾、重碳酸钾",
                                        "taxName": "无机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070201060000000000",
                                        "taxCodeTitle": "无机化学原料",
                                        "iTitle": "*无机化学原料*纯碱类",
                                        "children": []
                                    },
                                    {
                                        "id": "1238",
                                        "linkid": "1227",
                                        "code": "107020107",
                                        "paCode": "1070201",
                                        "yn": "N",
                                        "title": "金属氢氧化物",
                                        "alias": "金属氢氧化物",
                                        "about": "包括氢氧化钾（苛性钾）、氢氧化铝、氢氧化镁、氢氧化锶、氢氧化钡、氢氧化铬、氢氧化铁、氢氧化钴、氢氧化锂、氢氧化镍、氢氧化铜、氢氧化钼、氢氧化钨、氢氧化钙、氢氧化锌、氢氧化锆、氢氧化铵、其他金属氢氧化物，不包括镍钴锰氢氧化物（详见107020233）",
                                        "kws": "金属氢氧化物、氢氧化钾、苛性钾、氢氧化铝、氢氧化镁、氢氧化锶、氢氧化钡、氢氧化铬、氢氧化铁、氢氧化钴、氢氧化锂、氢氧化镍、氢氧化铜、氢氧化钼、氢氧化钨、氢氧化钙、氢氧化锌、氢氧化锆、氢氧化铵",
                                        "taxName": "无机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070201070000000000",
                                        "taxCodeTitle": "无机化学原料",
                                        "iTitle": "*无机化学原料*金属氢氧化物",
                                        "children": []
                                    },
                                    {
                                        "id": "1239",
                                        "linkid": "1227",
                                        "code": "107020108",
                                        "paCode": "1070201",
                                        "yn": "N",
                                        "title": "金属氧化物",
                                        "alias": "金属氧化物",
                                        "about": "包括氧化锌、氧化锶、氧化钡、铬氧化物、锰氧化物、氧化钽、钴氧化物、钛氧化物、铅氧化物、氧化锂、钒氧化物、镍氧化物、氧化铜、锗氧化物、钼氧化物、锑氧化物、氧化钨、锡氧化物、其他金属氧化物，不包括氧化铝（详见108030601）、氧化铁（详见107020123）",
                                        "kws": "金属氧化物、氧化锌、氧化锶、氧化钡、三氧化铬、铬酸酐、三氧化二铬、二氧化锰、氧化锰、三氧化二锰、高纯级氧化钽、普通级氧化钽、四氧化三钴、二氧化钛、氧化铅、铅丹及铅橙、二氧化铅、氧化锂、五氧化二钒、镍氧化物、氧化铜、锗氧化物、三氧化钼、五氧化二锑、三氧化钨、蓝色氧化钨、黄色氧化钨、紫色氧化钨、氧化亚锡、二氧化锡",
                                        "taxName": "无机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070201080000000000",
                                        "taxCodeTitle": "无机化学原料",
                                        "iTitle": "*无机化学原料*金属氧化物",
                                        "children": []
                                    },
                                    {
                                        "id": "1240",
                                        "linkid": "1227",
                                        "code": "107020109",
                                        "paCode": "1070201",
                                        "yn": "N",
                                        "title": "金属过氧化物、超氧化物",
                                        "alias": "金属过氧化物、超氧化物",
                                        "about": "包括过氧化钠、过氧化钾、过氧化镁、过氧化锶、过氧化钡、过氧化锌、过氧化钙、超氧化钠、超氧化钾、其他金属超氧化物、其他金属过氧化物",
                                        "kws": "金属过氧化物、金属超氧化物、过氧化钠、过氧化钾、过氧化镁、过氧化锶、过氧化钡、过氧化锌、过氧化钙、超氧化钠、超氧化钾",
                                        "taxName": "无机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070201090000000000",
                                        "taxCodeTitle": "无机化学原料",
                                        "iTitle": "*无机化学原料*金属过氧化物、超氧化物",
                                        "children": []
                                    },
                                    {
                                        "id": "1241",
                                        "linkid": "1227",
                                        "code": "107020110",
                                        "paCode": "1070201",
                                        "yn": "N",
                                        "title": "金属硫化物及硫酸盐",
                                        "alias": "金属硫化物及硫酸盐",
                                        "about": "包括金属硫化物、金属多硫化物、金属硫酸盐、金属亚硫酸盐、次亚硫酸钠、硫代硫酸盐、过硫酸盐等",
                                        "kws": "金属硫化物及硫酸盐、硫酸锆、三盐基硫酸铅、硫酸铁铵、硫酸亚铁铵、硫酸铁钾、硫酸铬钾、硫酸铝钾、硫酸铝铵、硫酸亚锡、次亚硫酸钠、连二亚硫酸钾、连二亚硫酸钙、连二亚硫酸镁、亚硫酸氢钠、亚硫酸钠、二亚硫酸二钠、亚硫酸铵、亚硫酸氢铵、亚硫酸氢钾、二亚硫酸二钾、亚硫酸氢钙、中性亚硫酸钙、亚硫酸锌、硫代硫酸钠、硫代硫酸铵、硫代硫酸钙、硫代硫酸钡、过硫酸铵、过硫酸钠、过硫酸钾",
                                        "taxName": "无机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070201100000000000",
                                        "taxCodeTitle": "无机化学原料",
                                        "iTitle": "*无机化学原料*金属硫化物及硫酸盐",
                                        "children": []
                                    },
                                    {
                                        "id": "1242",
                                        "linkid": "1227",
                                        "code": "107020111",
                                        "paCode": "1070201",
                                        "yn": "N",
                                        "title": "金属硝酸盐、亚硝酸盐",
                                        "alias": "金属硝酸盐、亚硝酸盐",
                                        "about": "包括硝酸盐、亚硝酸盐",
                                        "kws": "金属硝酸盐、金属亚硝酸盐、硝酸钾、硝酸钴、硝酸钡、硝酸铋、硝酸铬、硝酸钍、硝酸钙、硝酸铅、硝酸铜、硝酸锌、硝酸锰、硝酸锶、硝酸镍、亚硝酸钠、亚硝酸钡",
                                        "taxName": "无机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070201110000000000",
                                        "taxCodeTitle": "无机化学原料",
                                        "iTitle": "*无机化学原料*金属硝酸盐、亚硝酸盐",
                                        "children": []
                                    },
                                    {
                                        "id": "1243",
                                        "linkid": "1227",
                                        "code": "107020112",
                                        "paCode": "1070201",
                                        "yn": "N",
                                        "title": "金属氧化物酸盐、金属过氧化物酸盐",
                                        "alias": "金属氧化物酸盐、金属过氧化物酸盐",
                                        "about": "包括铝酸盐、铬酸盐及重铬酸盐、锰酸盐、高锰酸盐、钼酸盐、钨酸盐、钛酸盐、钒酸盐、高铁酸盐及铁酸盐、锌酸盐、锡酸盐、锑酸盐、锆酸盐、铼酸盐、高铅酸盐、其他金属氧化物酸盐、其他金属过氧化物酸盐，不包括铝酸钠（详见107020124）、铝酸三钙（详见107020125）。",
                                        "kws": "金属氧化物酸盐、金属过氧化物酸盐、铝酸钾、铝酸钙、铝酸铬、铝酸钴、铝酸锌、铝酸钡、铝酸铅、铬酸锌、铬酸铅、铬酸钠、重铬酸钠、铬酸钾、重铬酸钾、铬酸铵、重铬酸铵、铬酸钙、铬酸锰、铬酸铁、铬酸锶、过铬酸盐、锰酸钠、锰酸钾、锰酸钡、高锰酸钾、高锰酸钠、高锰酸钙、钼酸铵、钼酸钠、钼酸钙、钼酸钡、钨酸钠、钨酸钙、钨酸铵、仲钨酸铵、仲钨酸钠、偏钨酸铵、原钛酸盐、偏钛酸盐、过钛酸盐钒酸铵、钠钒酸盐铁酸盐、高铁酸盐锌酸钠、锌酸铁、锌酸钴、锌酸钡、锡酸钠、锡酸铝、锡酸铬、锡酸钴、锡酸铜、锡酸锌、羟基锡酸锌、锡酸钾、氨基磺酸",
                                        "taxName": "无机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070201120000000000",
                                        "taxCodeTitle": "无机化学原料",
                                        "iTitle": "*无机化学原料*金属氧化物酸盐、金属过氧化物酸盐",
                                        "children": []
                                    },
                                    {
                                        "id": "1244",
                                        "linkid": "1227",
                                        "code": "107020113",
                                        "paCode": "1070201",
                                        "yn": "N",
                                        "title": "磷化物、金属磷酸盐",
                                        "alias": "磷化物、金属磷酸盐",
                                        "about": "包括磷化物、次磷酸盐及亚磷酸盐、磷酸盐、焦磷酸盐、偏磷酸盐、缩聚磷酸盐、磷酸复盐等",
                                        "kws": "磷化物、金属磷酸盐、磷化钙、磷化锌、磷化镁、磷化氢、磷化硼、磷化钼、磷化镓、磷化铝、三氯氧磷、三氯硫磷、次磷酸盐及亚磷酸盐、次磷酸钠、次磷酸钙、次磷酸铵、次磷酸铁、次磷酸铅、亚磷酸铵、亚磷酸钠、亚磷酸钾、亚磷酸钙、次亚磷酸钠、次磷酸二氢钠、磷酸盐、磷酸三钠、磷酸钾、磷酸二氢钾、磷酸二氢钙、正磷酸氢钙磷酸二钙、磷酸铜钙、磷酸钙钾、磷酸铵钾、磷酸一铵、磷酸二铵、磷酸三铵、镍磷铁、磷酸钡、磷酸锌、磷酸铜、磷酸铬、磷酸铁、单氟磷酸钠、酸式磷酸锰、磷酸二氢钠、磷酸二氢铝、磷酸二氢锌、磷酸氢二钠、磷酸氢二钾、磷酸镁、",
                                        "taxName": "无机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070201130000000000",
                                        "taxCodeTitle": "无机化学原料",
                                        "iTitle": "*无机化学原料*磷化物、金属磷酸盐",
                                        "children": []
                                    },
                                    {
                                        "id": "1245",
                                        "linkid": "1227",
                                        "code": "107020114",
                                        "paCode": "1070201",
                                        "yn": "N",
                                        "title": "氟化物及其盐",
                                        "alias": "氟化物及其盐",
                                        "about": "包括氟化物、氟硅酸盐、氟铝酸盐及相关复合氟盐等",
                                        "kws": "氟化物及其盐、氟化钠、氟化铵、氟化铝、氟化钾、氟化镁、氟化氢钾、氟化氢钠、氟化氢铵、全氟化碳、氢氟碳化物、氟硅酸钾、氟硅酸钠、氟硅酸镁、六氟铝酸钠、氟铝酸钠、氟锆酸钾",
                                        "taxName": "无机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070201140000000000",
                                        "taxCodeTitle": "无机化学原料",
                                        "iTitle": "*无机化学原料*氟化物及其盐",
                                        "children": []
                                    },
                                    {
                                        "id": "1246",
                                        "linkid": "1227",
                                        "code": "107020115",
                                        "paCode": "1070201",
                                        "yn": "N",
                                        "title": "氯化物及其盐",
                                        "alias": "氯化物及其盐",
                                        "about": "包括氯化物、氯酸盐、高氯酸盐、亚氯酸盐、次氯酸盐、其他亚氯酸盐、其他次氯酸盐，不包括氯化钴（详见107020236）",
                                        "kws": "氯化物及其盐、氯化钠、氯化钙、氯化镁、氯化锌、氯化钡、氯化铁、三氯化铁、氯化铝、三氯化铝、聚氯化铝、氯化钴、氯化镍、氯化锂、氯化铜、氯化亚铜、氯化锰、氯化汞、氯化锶、氯化镉、三氯化锑、氯化亚锡、商品液氯、四氯化锡、无水四氯化锡、无水氯化亚锡、氯酸钠、氯酸钾、高氯酸钾、高氯酸铵、次氯酸钙、漂白粉、漂粉精、次氯酸钠、亚氯酸钠",
                                        "taxName": "无机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070201150000000000",
                                        "taxCodeTitle": "无机化学原料",
                                        "iTitle": "*无机化学原料*氯化物及其盐",
                                        "children": []
                                    },
                                    {
                                        "id": "1247",
                                        "linkid": "1227",
                                        "code": "107020116",
                                        "paCode": "1070201",
                                        "yn": "N",
                                        "title": "氯氧化物及氢氧基氯化物",
                                        "alias": "氯氧化物及氢氧基氯化物",
                                        "about": "包括氯氧化铜、氢氧基氯化铜、氢氧基氯化铝、氯氧化锆、氯氧化铬、氯氧化锡、氯氧化锑、氯氧化铅、氢氧基氯化铅、其他氯氧化物及氢氧基氯化物",
                                        "kws": "氯氧化物及氢氧基氯化物、氯氧化铜、氢氧基氯化铜、氢氧基氯化铝、氯氧化锆、氯氧化铬、氯氧化锡、氯氧化锑、氯氧化铅、氢氧基氯化铅",
                                        "taxName": "无机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070201160000000000",
                                        "taxCodeTitle": "无机化学原料",
                                        "iTitle": "*无机化学原料*氯氧化物及氢氧基氯化物",
                                        "children": []
                                    },
                                    {
                                        "id": "1248",
                                        "linkid": "1227",
                                        "code": "107020117",
                                        "paCode": "1070201",
                                        "yn": "N",
                                        "title": "溴化物及其盐",
                                        "alias": "溴化物及其盐",
                                        "about": "包括溴化物及溴氧化物、溴酸盐及过溴酸盐",
                                        "kws": "溴化物及其盐、溴化钠、溴化钾、溴化钙、溴化铵、溴化锂、溴化铜、溴化亚铜、溴化钡、溴酸钠、溴酸钾、亚溴酸钠",
                                        "taxName": "无机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070201170000000000",
                                        "taxCodeTitle": "无机化学原料",
                                        "iTitle": "*无机化学原料*溴化物及其盐",
                                        "children": []
                                    },
                                    {
                                        "id": "1249",
                                        "linkid": "1227",
                                        "code": "107020118",
                                        "paCode": "1070201",
                                        "yn": "N",
                                        "title": "碘化物及其盐",
                                        "alias": "碘化物及其盐",
                                        "about": "包括碘化物、碘酸盐",
                                        "kws": "碘化物及其盐、碘化钠、碘化钾、碘化铵、碘化钙、碘化汞、碘化锂、碘酸钠、碘酸钾、碘酸钡",
                                        "taxName": "无机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070201180000000000",
                                        "taxCodeTitle": "无机化学原料",
                                        "iTitle": "*无机化学原料*碘化物及其盐",
                                        "children": []
                                    },
                                    {
                                        "id": "1250",
                                        "linkid": "1227",
                                        "code": "107020119",
                                        "paCode": "1070201",
                                        "yn": "N",
                                        "title": "氰化物、氧氰化物及氰络合物",
                                        "alias": "氰化物、氧氰化物及氰络合物",
                                        "about": "包括氰化物、氰氧化物及氰络合物",
                                        "kws": "氰化物、氧氰化物及氰络合物、氰化钠、氧氰化钠、氰化钾、氰化锌、氰化亚铜、氰氨化钙、石灰氮、氰化钙、氰化镍、氰化亚金钾、金氰化钾、氰化银钾、银氰化钾、铁氰化钾、赤血盐钾、铁氰化钠、赤血盐钠、亚铁氰化钾、黄血盐钾、亚铁氰化钠、黄血盐钠、氰酸钠、氰酸铵、氰酸钾、硫氰酸钠、硫氰酸铵、硫氰酸钾",
                                        "taxName": "无机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070201190000000000",
                                        "taxCodeTitle": "无机化学原料",
                                        "iTitle": "*无机化学原料*氰化物、氧氰化物及氰络合物",
                                        "children": []
                                    },
                                    {
                                        "id": "1251",
                                        "linkid": "1227",
                                        "code": "107020120",
                                        "paCode": "1070201",
                                        "yn": "N",
                                        "title": "硅化物及硅酸盐",
                                        "alias": "硅化物及硅酸盐",
                                        "about": "包括硅化物、硅酸盐",
                                        "kws": "硅化物及硅酸盐、硅化锂、硅化钙、硅化镁、硅化铁、硅化硼、氟硅化钠、硅酸钠、硅酸钾、硅酸钾钠、硅酸锂、硅酸铅、硅酸镁、硅酸铝、硅酸钙",
                                        "taxName": "无机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070201200000000000",
                                        "taxCodeTitle": "无机化学原料",
                                        "iTitle": "*无机化学原料*硅化物及硅酸盐",
                                        "children": []
                                    },
                                    {
                                        "id": "1252",
                                        "linkid": "1227",
                                        "code": "107020121",
                                        "paCode": "1070201",
                                        "yn": "N",
                                        "title": "硼化物、硼酸盐和过硼酸盐",
                                        "alias": "硼化物、硼酸盐和过硼酸盐",
                                        "about": "包括硼化物、硼酸盐、过硼酸盐",
                                        "kws": "硼化物、硼酸盐、过硼酸盐、氮化硼、硼化钙、硼化铝、硼氢化钾、钾硼氢、硼氢化钠、钠硼氢、氢硼化钠、四硼酸钠、硼砂、偏硼酸钡、偏硼酸铅、硼酸锌、硼酸锰、硼酸铅、过硼酸钠、过硼酸镁、过硼酸钾、过硼酸铵",
                                        "taxName": "无机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070201210000000000",
                                        "taxCodeTitle": "无机化学原料",
                                        "iTitle": "*无机化学原料*硼化物、硼酸盐和过硼酸盐",
                                        "children": []
                                    },
                                    {
                                        "id": "1253",
                                        "linkid": "1227",
                                        "code": "107020122",
                                        "paCode": "1070201",
                                        "yn": "N",
                                        "title": "碳化物及碳酸盐",
                                        "alias": "碳化物及碳酸盐",
                                        "about": "包括碳化物、碳酸盐、过碳酸盐",
                                        "kws": "碳化物及碳酸盐、碳化钙、碳化硅、碳化硼、碳化钨、碳化钛、碳化锆、碳化钒、碳化铌、碳化钽、碳化铬、碳化钼、碳化铁、重质碳酸钙、轻质碳酸钙、活性碳酸钙、碳酸钡、碳酸铅、碳酸锶、碳酸锂、轻质碳酸镁、重质碳酸镁、碱式碳酸铅、中性碳酸铅、碳酸镍、碳酸锰、碳酸亚锰、碳酸铷、碳酸铯",
                                        "taxName": "无机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070201220000000000",
                                        "taxCodeTitle": "无机化学原料",
                                        "iTitle": "*无机化学原料*碳化物及碳酸盐",
                                        "children": []
                                    },
                                    {
                                        "id": "1254",
                                        "linkid": "1227",
                                        "code": "107020123",
                                        "paCode": "1070201",
                                        "yn": "N",
                                        "title": "氧化铁",
                                        "alias": "氧化铁",
                                        "about": null,
                                        "kws": "氧化铁",
                                        "taxName": "无机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070201230000000000",
                                        "taxCodeTitle": "无机化学原料",
                                        "iTitle": "*无机化学原料*氧化铁",
                                        "children": []
                                    },
                                    {
                                        "id": "1255",
                                        "linkid": "1227",
                                        "code": "107020124",
                                        "paCode": "1070201",
                                        "yn": "N",
                                        "title": "铝酸钠",
                                        "alias": "铝酸钠",
                                        "about": null,
                                        "kws": "铝酸钠",
                                        "taxName": "无机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070201240000000000",
                                        "taxCodeTitle": "无机化学原料",
                                        "iTitle": "*无机化学原料*铝酸钠",
                                        "children": []
                                    },
                                    {
                                        "id": "1256",
                                        "linkid": "1227",
                                        "code": "107020125",
                                        "paCode": "1070201",
                                        "yn": "N",
                                        "title": "铝酸三钙",
                                        "alias": "铝酸三钙",
                                        "about": null,
                                        "kws": "铝酸三钙",
                                        "taxName": "无机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070201250000000000",
                                        "taxCodeTitle": "无机化学原料",
                                        "iTitle": "*无机化学原料*铝酸三钙",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1257",
                                "linkid": "1226",
                                "code": "1070202",
                                "paCode": "10702",
                                "yn": "Y",
                                "title": "有机化学原料",
                                "alias": "有机化学原料",
                                "about": null,
                                "kws": null,
                                "taxName": "有机化学原料",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070202000000000000",
                                "taxCodeTitle": "有机化学原料",
                                "iTitle": "*有机化学原料*有机化学原料",
                                "children": [
                                    {
                                        "id": "1258",
                                        "linkid": "1257",
                                        "code": "107020201",
                                        "paCode": "1070202",
                                        "yn": "Y",
                                        "title": "无环烃",
                                        "alias": "无环烃",
                                        "about": "包括饱和无环烃、不饱和无环烃、其他不饱和无环烃",
                                        "kws": "无环烃、甲烷、乙烷、丙烷、丁烷、戊烷、己烷、异辛烷、庚烷、乙烯、丙烯、丁烯、异丁烯、丁二烯、丙二烯、异戊二烯、甲基丁二烯、异戊烯、双戊烯、溶解乙炔、醋酸乙炔",
                                        "taxName": "有机化学原料",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1070202010000000000",
                                        "taxCodeTitle": "有机化学原料",
                                        "iTitle": "*有机化学原料*无环烃",
                                        "children": [
                                            {
                                                "id": "1259",
                                                "linkid": "1258",
                                                "code": "10702020101",
                                                "paCode": "107020201",
                                                "yn": "N",
                                                "title": "甲烷",
                                                "alias": "甲烷",
                                                "about": "是最简单的有机化合物，也是最简单的脂肪族烷烃",
                                                "kws": "甲烷",
                                                "taxName": "有机化学原料",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070202010100000000",
                                                "taxCodeTitle": "有机化学原料",
                                                "iTitle": "*有机化学原料*甲烷",
                                                "children": []
                                            },
                                            {
                                                "id": "1260",
                                                "linkid": "1258",
                                                "code": "10702020102",
                                                "paCode": "107020201",
                                                "yn": "N",
                                                "title": "乙烯",
                                                "alias": "乙烯",
                                                "about": "乙烯产品通常以液态形态在压力下储存于乙烯厂内，纯度可达到99.95%",
                                                "kws": "乙烯",
                                                "taxName": "有机化学原料",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070202010200000000",
                                                "taxCodeTitle": "有机化学原料",
                                                "iTitle": "*有机化学原料*乙烯",
                                                "children": []
                                            },
                                            {
                                                "id": "1261",
                                                "linkid": "1258",
                                                "code": "10702020103",
                                                "paCode": "107020201",
                                                "yn": "N",
                                                "title": "丙烯",
                                                "alias": "丙烯",
                                                "about": null,
                                                "kws": "丙稀",
                                                "taxName": "有机化学原料",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070202010300000000",
                                                "taxCodeTitle": "有机化学原料",
                                                "iTitle": "*有机化学原料*丙烯",
                                                "children": []
                                            },
                                            {
                                                "id": "1262",
                                                "linkid": "1258",
                                                "code": "10702020104",
                                                "paCode": "107020201",
                                                "yn": "N",
                                                "title": "丁二烯",
                                                "alias": "丁二烯",
                                                "about": null,
                                                "kws": "丁二稀",
                                                "taxName": "有机化学原料",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070202010400000000",
                                                "taxCodeTitle": "有机化学原料",
                                                "iTitle": "*有机化学原料*丁二烯",
                                                "children": []
                                            },
                                            {
                                                "id": "1263",
                                                "linkid": "1258",
                                                "code": "10702020199",
                                                "paCode": "107020201",
                                                "yn": "N",
                                                "title": "其他无环烃",
                                                "alias": "其他无环烃",
                                                "about": null,
                                                "kws": "乙烷、丙烷、丁烷、戊烷、己烷、异辛烷、庚烷、丁烯、异丁烯、丙二烯、异戊二烯、甲基丁二烯、异戊烯、双戊烯、溶解乙炔、醋酸乙炔",
                                                "taxName": "有机化学原料",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070202019900000000",
                                                "taxCodeTitle": "有机化学原料",
                                                "iTitle": "*有机化学原料*其他无环烃",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "1264",
                                        "linkid": "1257",
                                        "code": "107020202",
                                        "paCode": "1070202",
                                        "yn": "Y",
                                        "title": "环烃",
                                        "alias": "环烃",
                                        "about": "包括环烷烃、环烯、环萜烯、芳香烃",
                                        "kws": null,
                                        "taxName": "有机化学原料",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1070202020000000000",
                                        "taxCodeTitle": "有机化学原料",
                                        "iTitle": "*有机化学原料*环烃",
                                        "children": [
                                            {
                                                "id": "1265",
                                                "linkid": "1264",
                                                "code": "10702020201",
                                                "paCode": "107020202",
                                                "yn": "Y",
                                                "title": "芳香烃",
                                                "alias": "芳香烃",
                                                "about": "包括粗苯、纯苯、粗甲苯、甲苯、粗二甲苯、邻二甲苯、间二甲苯、对二甲苯、混合二甲苯、苯乙烯、乙苯（乙基苯）、异丙基苯、联苯、三甲苯、重质苯、二乙苯、甲基苯乙烯、二乙烯苯、烷基苯、重烷基苯、甲基萘、二甲基萘、四氢萘、萘、十二烷基苯、粗蒽、精蒽、其他芳香烃",
                                                "kws": "芳香烃、粗苯、纯苯、粗甲苯、甲苯、粗二甲苯、邻二甲苯、间二甲苯、对二甲苯、混合二甲苯、苯乙烯、乙苯、异丙基苯、联苯、三甲苯、重质苯、二乙苯、甲基苯乙烯、二乙烯苯、烷基苯、重烷基苯、甲基萘、二甲基萘、四氢萘、萘、十二烷基苯、粗蒽、精蒽",
                                                "taxName": "有机化学原料",
                                                "taxRate": "",
                                                "vip": "7",
                                                "itaxRate": null,
                                                "taxCode": "1070202020100000000",
                                                "taxCodeTitle": "有机化学原料",
                                                "iTitle": "*有机化学原料*芳香烃",
                                                "children": [
                                                    {
                                                        "id": "1266",
                                                        "linkid": "1265",
                                                        "code": "1070202020101",
                                                        "paCode": "10702020201",
                                                        "yn": "N",
                                                        "title": "纯苯",
                                                        "alias": "纯苯",
                                                        "about": null,
                                                        "kws": "纯苯",
                                                        "taxName": "有机化学原料",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070202020101000000",
                                                        "taxCodeTitle": "有机化学原料",
                                                        "iTitle": "*有机化学原料*纯苯",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1267",
                                                        "linkid": "1265",
                                                        "code": "1070202020102",
                                                        "paCode": "10702020201",
                                                        "yn": "N",
                                                        "title": "甲苯",
                                                        "alias": "甲苯",
                                                        "about": "符合国家标准的甲苯",
                                                        "kws": "甲苯",
                                                        "taxName": "有机化学原料",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070202020102000000",
                                                        "taxCodeTitle": "有机化学原料",
                                                        "iTitle": "*有机化学原料*甲苯",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1268",
                                                        "linkid": "1265",
                                                        "code": "1070202020103",
                                                        "paCode": "10702020201",
                                                        "yn": "N",
                                                        "title": "邻二甲苯、间二甲苯、对二甲苯、混合二甲苯",
                                                        "alias": "邻二甲苯、间二甲苯、对二甲苯、混合二甲苯",
                                                        "about": "符合国家标准的二甲苯、间二甲苯、对二甲苯、混合二甲苯",
                                                        "kws": "邻二甲苯、间二甲苯、对二甲苯、混合二甲苯",
                                                        "taxName": "有机化学原料",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070202020103000000",
                                                        "taxCodeTitle": "有机化学原料",
                                                        "iTitle": "*有机化学原料*邻二甲苯、间二甲苯、对二甲苯、混合二甲苯",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1269",
                                                        "linkid": "1265",
                                                        "code": "1070202020199",
                                                        "paCode": "10702020201",
                                                        "yn": "N",
                                                        "title": "其他芳香烃",
                                                        "alias": "其他芳香烃",
                                                        "about": null,
                                                        "kws": null,
                                                        "taxName": "有机化学原料",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070202020199000000",
                                                        "taxCodeTitle": "有机化学原料",
                                                        "iTitle": "*有机化学原料*其他芳香烃",
                                                        "children": []
                                                    }
                                                ]
                                            },
                                            {
                                                "id": "1270",
                                                "linkid": "1264",
                                                "code": "10702020299",
                                                "paCode": "107020202",
                                                "yn": "N",
                                                "title": "其他环烃",
                                                "alias": "其他环烃",
                                                "about": "包括环氧乙烷、环氧丁烷、环氧丙烷、环丙烷、环戊烷、环己烷、环十二烷、环戊烯、环己烯、二聚环戊二烯、茨烯等",
                                                "kws": "环氧乙烷、环氧丁烷、环氧丙烷、环丙烷、环戊烷、环己烷、环十二烷、环戊烯、环己烯、二聚环戊二烯、茨烯",
                                                "taxName": "有机化学原料",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070202029900000000",
                                                "taxCodeTitle": "有机化学原料",
                                                "iTitle": "*有机化学原料*其他环烃",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "1271",
                                        "linkid": "1257",
                                        "code": "107020203",
                                        "paCode": "1070202",
                                        "yn": "N",
                                        "title": "无环烃饱和氯化衍生物",
                                        "alias": "无环烃饱和氯化衍生物",
                                        "about": "包括一氯甲烷、二氯甲烷、三氯甲烷（氯仿）、四氯化碳、氯乙烷、二氯乙烷、三氯乙烷、四氯乙烷、六氯乙烷、其他无环烃饱和氯化衍生物",
                                        "kws": "无环烃饱、氯化衍生物、一氯甲烷、二氯甲烷、三氯甲烷、氯仿、四氯化碳、氯乙烷、二氯乙烷、三氯乙烷、四氯乙烷、六氯乙烷",
                                        "taxName": "有机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070202030000000000",
                                        "taxCodeTitle": "有机化学原料",
                                        "iTitle": "*有机化学原料*无环烃饱和氯化衍生物",
                                        "children": []
                                    },
                                    {
                                        "id": "1272",
                                        "linkid": "1257",
                                        "code": "107020204",
                                        "paCode": "1070202",
                                        "yn": "N",
                                        "title": "无环烃不饱和氯化衍生物",
                                        "alias": "无环烃不饱和氯化衍生物",
                                        "about": "包括氯乙烯、三氯乙烯、四氯乙烯、二氯乙烯、氯丙烯、三氯丙烯、其他无环烃不饱和氯化衍生物",
                                        "kws": "无环烃不饱、氯化衍生物、氯乙烯、三氯乙烯、四氯乙烯、二氯乙烯、氯丙烯、三氯丙烯",
                                        "taxName": "有机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070202040000000000",
                                        "taxCodeTitle": "有机化学原料",
                                        "iTitle": "*有机化学原料*无环烃不饱和氯化衍生物",
                                        "children": []
                                    },
                                    {
                                        "id": "1273",
                                        "linkid": "1257",
                                        "code": "107020205",
                                        "paCode": "1070202",
                                        "yn": "N",
                                        "title": "无环烃氟化、溴化或碘化衍生物",
                                        "alias": "无环烃氟化、溴化或碘化衍生物",
                                        "about": "包括溴甲烷（甲基溴）、溴乙烷、溴丙烷、碘乙烷、三氟溴甲烷、四氟乙烯、1-氯丁烷、1-溴丁烷、四溴丁烷、二溴戊烷、二碘代甲烷、三碘代甲烷、其他无环烃氟化、溴化或碘化衍生物",
                                        "kws": "无环烃氟化衍生物、无环烃溴化衍生物、无环烃碘化衍生物、溴甲烷、甲基溴、溴乙烷、溴丙烷、碘乙烷、三氟溴甲烷、四氟乙烯、1-氯丁烷、1-溴丁烷、四溴丁烷、二溴戊烷、二碘代甲烷、三碘代甲烷",
                                        "taxName": "有机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070202050000000000",
                                        "taxCodeTitle": "有机化学原料",
                                        "iTitle": "*有机化学原料*无环烃氟化、溴化或碘化衍生物",
                                        "children": []
                                    },
                                    {
                                        "id": "1274",
                                        "linkid": "1257",
                                        "code": "107020206",
                                        "paCode": "1070202",
                                        "yn": "N",
                                        "title": "含不同卤素无环烃卤化衍生物",
                                        "alias": "含不同卤素无环烃卤化衍生物",
                                        "about": "含两种不同卤素的无环烃卤化衍生物，包括三氯氟甲烷、二氯二氟甲烷、三氯三氟乙烷、二氯四氟乙烷、二氯五氟乙烷、氯三氟甲烷、五氯氟乙烷、四氯二氟乙烷、七氯氟丙烷、六氯二氟丙烷、五氯三氟丙烷、四氯四氟丙烷、三氯五氟丙烷、二氯六氟丙烷、二氯七氟丙烷、一氟三氯甲烷、二氟一氯甲烷（氟利昂-22）、二氟一氯乙烷（氟利昂-142）、其他含不同卤素无环烃卤化衍生物",
                                        "kws": "无环烃卤化衍生物、三氯氟甲烷、二氯二氟甲烷、三氯三氟乙烷、二氯四氟乙烷、二氯五氟乙烷、氯三氟甲烷、五氯氟乙烷、四氯二氟乙烷、七氯氟丙烷、六氯二氟丙烷、五氯三氟丙烷、四氯四氟丙烷、三氯五氟丙烷、二氯六氟丙烷、二氯七氟丙烷、一氟三氯甲烷、二氟一氯甲烷、氟利昂-22、二氟一氯乙烷、氟利昂-142",
                                        "taxName": "有机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070202060000000000",
                                        "taxCodeTitle": "有机化学原料",
                                        "iTitle": "*有机化学原料*含不同卤素无环烃卤化衍生物",
                                        "children": []
                                    },
                                    {
                                        "id": "1275",
                                        "linkid": "1257",
                                        "code": "107020207",
                                        "paCode": "1070202",
                                        "yn": "N",
                                        "title": "芳香烃卤化衍生物",
                                        "alias": "芳香烃卤化衍生物",
                                        "about": "包括氯化苯、邻二氯苯、对二氯苯、六氯苯、对氯甲苯、3，4-二氯三氟甲苯、三氯乙醛、其他芳香烃卤化衍生物",
                                        "kws": "芳香烃卤化衍生物、氯化苯、邻二氯苯、对二氯苯、六氯苯、对氯甲苯、3,4-二氯三氟甲苯、三氯乙醛",
                                        "taxName": "有机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070202070000000000",
                                        "taxCodeTitle": "有机化学原料",
                                        "iTitle": "*有机化学原料*芳香烃卤化衍生物",
                                        "children": []
                                    },
                                    {
                                        "id": "1276",
                                        "linkid": "1257",
                                        "code": "107020208",
                                        "paCode": "1070202",
                                        "yn": "N",
                                        "title": "烃磺化、硝化或亚硝化衍生物",
                                        "alias": "烃磺化、硝化或亚硝化衍生物",
                                        "about": "包括苯磺酸、苯磺酰氯、烷基苯磺酸、对氨基苯磺酰氯、甲苯磺酸、二甲苯磺酸、苯二磺酸、萘磺酸、硝基苯、硝基甲苯、二硝基甲苯、三硝基甲苯（TNT）、硝基氯化苯、二硝基氯化苯、三氯硝基甲烷（氯化苦；硝基氯仿）、一硝基甲烷、邻硝基甲苯、对硝基甲苯、邻硝基氯苯、对硝基氯苯、二硝基氯苯、硝化棉、其他烃磺化、硝化或亚硝化衍生物",
                                        "kws": "烃磺化衍生物、硝化衍生物、亚硝化衍生物、苯磺酸、苯磺酰氯、烷基苯磺酸、对氨基苯磺酰氯、甲苯磺酸、二甲苯磺酸、苯二磺酸、萘磺酸、硝基苯、硝基甲苯、二硝基甲苯、三硝基甲苯、TNT、硝基氯化苯、二硝基氯化苯、三氯硝基甲烷、氯化苦、硝基氯仿、一硝基甲烷、邻硝基甲苯、对硝基甲苯、邻硝基氯苯、对硝基氯苯、二硝基氯苯、硝化棉",
                                        "taxName": "有机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070202080000000000",
                                        "taxCodeTitle": "有机化学原料",
                                        "iTitle": "*有机化学原料*烃磺化、硝化或亚硝化衍生物",
                                        "children": []
                                    },
                                    {
                                        "id": "1277",
                                        "linkid": "1257",
                                        "code": "107020209",
                                        "paCode": "1070202",
                                        "yn": "N",
                                        "title": "无环醇及其衍生物",
                                        "alias": "无环醇及其衍生物",
                                        "about": "包括无环醇及其卤化、磺化、硝化或亚硝化衍生物",
                                        "kws": "无环醇、精甲醇、丙醇、异丙醇、丁醇、正丁醇、异丁醇、叔丁醇、戊醇、异戊醇、叔戊醇、辛醇、正辛醇、异辛醇、仲辛醇、丁辛醇、十二烷醇、月桂醇、十六烷醇、棕榈醇、十八烷醇、硬脂醇、香叶醇、橙花醇、香茅醇、芳樟醇、烯丙醇、丙烯醇、丙二醇、丁二醇、2,5-二甲基已二醇、1,2-丙二醇、二甲基乙二醇、一缩二丙二醇、一缩二乙二醇、三乙二醇、多缩丙二醇、新戊二醇、2,2-二甲基-1,3-丙二醇、甲基异丁基甲醇、丙烯二醇、1,4一丁烯二醇、丁炔二醇、2-丁炔-1,4-二醇、三羟基甲基丙烷、季戊四醇、甘露糖醇、山梨醇、丙三醇",
                                        "taxName": "有机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070202090000000000",
                                        "taxCodeTitle": "有机化学原料",
                                        "iTitle": "*有机化学原料*无环醇及其衍生物",
                                        "children": []
                                    },
                                    {
                                        "id": "1278",
                                        "linkid": "1257",
                                        "code": "107020210",
                                        "paCode": "1070202",
                                        "yn": "N",
                                        "title": "环醇",
                                        "alias": "环醇",
                                        "about": "包括环醇、芳香醇",
                                        "kws": "环醇、薄荷醇、环己醇、甲基环己醇、二甲基环己醇、固醇、环己六醇、肌醇、萜品醇、松油醇、苯甲醇、苄醇、苯乙醇、β-苯丙烯醇、肉桂醇、杂醇油",
                                        "taxName": "有机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070202100000000000",
                                        "taxCodeTitle": "有机化学原料",
                                        "iTitle": "*有机化学原料*环醇",
                                        "children": []
                                    },
                                    {
                                        "id": "1279",
                                        "linkid": "1257",
                                        "code": "107020211",
                                        "paCode": "1070202",
                                        "yn": "N",
                                        "title": "酚",
                                        "alias": "酚",
                                        "about": "包括一元酚、多元酚、酚醇",
                                        "kws": "酚、苯酚、苯酚钠、间甲酚、邻甲酚、合成甲酚、三混甲酚、甲酚盐、壬基酚、辛基酚、二甲苯酚、β－萘酚、α－萘酚、邻仲丁基酚、邻异丙基酚、2,3-酸、间苯二酚、对苯二酚、对苯二酚盐、4,4-异亚丙基联苯酚、邻苯二酚",
                                        "taxName": "有机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070202110000000000",
                                        "taxCodeTitle": "有机化学原料",
                                        "iTitle": "*有机化学原料*酚",
                                        "children": []
                                    },
                                    {
                                        "id": "1280",
                                        "linkid": "1257",
                                        "code": "107020212",
                                        "paCode": "1070202",
                                        "yn": "N",
                                        "title": "酚及酚醇衍生物",
                                        "alias": "酚及酚醇衍生物",
                                        "about": "包括酚及酚醇的卤化、磺化、硝化或亚硝化衍生物",
                                        "kws": "酚及酚醇衍生物、对氯苯酚、邻氯苯酚、二氯苯酚、对氯苯硫酚、4-磺酸-2-氨基酚、硫酚、对氨基苯酚、对氨基硫酚、对氟苯硫酚、对羧基苯硫酚、对硝基苯酚、对硝基酚钠、邻硝基对甲酚、邻硝基苯硫酚",
                                        "taxName": "有机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070202120000000000",
                                        "taxCodeTitle": "有机化学原料",
                                        "iTitle": "*有机化学原料*酚及酚醇衍生物",
                                        "children": []
                                    },
                                    {
                                        "id": "1281",
                                        "linkid": "1257",
                                        "code": "107020213",
                                        "paCode": "1070202",
                                        "yn": "N",
                                        "title": "羧酸及其衍生物",
                                        "alias": "羧酸及其衍生物",
                                        "about": "包括甲酸及甲酸盐、甲酸酯、乙酸及乙酸盐、乙酸酯、氯乙酸及其盐和酯、丙酸及其盐和酯、丁酸及其盐和酯、戊酸及其盐和酯、硬脂酸及其盐、棕榈酸及其盐、丙烯酸及其盐和酯、甲基丙烯酸及其盐和酯、油酸及其盐和酯、亚油酸及其盐和酯、亚麻酸及其盐和酯、苯甲酸及其盐和酯、苯甲酸衍生物、苯乙酸及其盐和酯、草酸及其盐和酯、己二酸及其盐和酯、癸二酸及其盐和酯、壬二酸及其盐和酯、邻苯二甲酸酯、邻苯二甲酸酐、对苯二甲酸及其盐、乳酸及其盐和酯、酒石酸及其盐和酯、葡糖酸及其盐和酯、苯乙醇酸及其盐和酯、环烷酸及其水不溶性盐和酯",
                                        "kws": "羧酸、甲酸、甲酸钠、甲酸钙、甲酸镍、甲酸甲酯、甲酸乙酯、甲酸苄酯、甲酸冰片酯、冰乙酸、冰醋酸、乙酸、乙酸钠、醋酸钠、乙酸钴、醋酸钴、乙酸酐、醋酸酐、乙酸钾、醋酸钾、乙酸钙、醋酸钙、乙酸汞、醋酸汞、乙酸乙酯、乙酸乙烯酯、乙酸正丁酯、乙酸异丁酯、乙酸-2-乙氧基乙酯、乙酸甲酯、氯代乙酸、二氯乙酸、三氯乙酸、丙酸、丙酸盐、丙酸酯正丁酸、异丁酸、丁酸酐、氧化丁酰、丁二酸酐、琥珀酸酐、苯基丁酸、顺丁烯二酸、顺丁烯二酸酐、反丁烯二酸、富马酸、戊酸、异戊酸、戊酸酯、硬脂酸、硬脂酸钙、硬脂酸镁、硬脂酸锌、硬脂酸铝、硬脂酸",
                                        "taxName": "有机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070202130000000000",
                                        "taxCodeTitle": "有机化学原料",
                                        "iTitle": "*有机化学原料*羧酸及其衍生物",
                                        "children": []
                                    },
                                    {
                                        "id": "1282",
                                        "linkid": "1257",
                                        "code": "107020214",
                                        "paCode": "1070202",
                                        "yn": "N",
                                        "title": "氨基化合物",
                                        "alias": "氨基化合物",
                                        "about": "包括无环单胺、无环多胺、环单胺或多胺及其衍生物、环芳香单胺、芳香多胺、含氧基氨基化合物、腈基化合物、重氮、偶氮或氧化偶氮化合物、肼或胲有机衍生物",
                                        "kws": "氨基化合物、一甲胺、二甲胺、三甲胺、一乙胺、二乙胺、三乙胺、二正丙胺、异丙胺、甲基乙胺、2-氨基丙烷、NN-二、2-氯乙基乙胺、N,N-二2-氯乙基甲胺、三2-氯乙基胺、二烷氨基乙基-2-氯、乙二胺、乙二胺盐、己二酸己二胺盐、尼龙66盐、六亚甲基二胺盐、六亚甲基四胺、乌洛托品、环已胺、二甲氨基环已胺、苯胺、苯胺盐、苯胺衍生物盐、甲苯胺、邻甲苯胺、甲苯胺衍生物、甲苯胺盐、二苯胺、二苯胺衍生物、二苯胺盐、苯萘胺、1-萘胺、1-萘胺衍生物和盐、2-萘胺衍生物、2-萘胺盐、甲萘胺、对异丙基苯胺、二甲基苯胺、2,6",
                                        "taxName": "有机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070202140000000000",
                                        "taxCodeTitle": "有机化学原料",
                                        "iTitle": "*有机化学原料*氨基化合物",
                                        "children": []
                                    },
                                    {
                                        "id": "1283",
                                        "linkid": "1257",
                                        "code": "107020215",
                                        "paCode": "1070202",
                                        "yn": "N",
                                        "title": "含氮基化合物",
                                        "alias": "含氮基化合物",
                                        "about": "包括异氰酸酯、环己基氨基磺酸钠（甜蜜素）、其他含氮基化合物",
                                        "kws": "含氮基化合物、TDI、二甲苯二异氰酸酯、二苯基甲烷二异氰酸酯、六亚甲基二异氰酸酯、二烷氨基膦酰二卤、二烷氨基膦酸二烷酯",
                                        "taxName": "有机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070202150000000000",
                                        "taxCodeTitle": "有机化学原料",
                                        "iTitle": "*有机化学原料*含氮基化合物",
                                        "children": []
                                    },
                                    {
                                        "id": "1284",
                                        "linkid": "1257",
                                        "code": "107020216",
                                        "paCode": "1070202",
                                        "yn": "N",
                                        "title": "醚",
                                        "alias": "醚",
                                        "about": "包括乙醚、二氯乙醚、二异丙醚、二丁醚、二戊醚、甲乙醚、乙基异丙基醚、乙基丁基醚、乙基戊基醚、环醚、多元醇缩水甘油醚、甘油醚、环萜烯醚、茴香醚、苯乙醚、二苯醚、1，2-二苯氧基乙烷（乙二醇二苯基醚）、茴香脑（对丙烯基茴香醚）、二苄醚、硝基苯乙醚、硝基茴香醚、2-叔丁基-5-甲基-4，6-二硝基茴香醚、β-萘甲醚、β-萘基乙醚、间甲酚甲醚、丁基间甲酚甲醚、苯基甲苯基醚、二甲苯基醚、苄基乙基醚、甲基叔丁基醚、间甲基二苯醚、其他醚，不包括二甲醚（甲醚）（详见107020240）",
                                        "kws": "醚、甲醚、乙醚、二氯乙醚、二异丙醚、二丁醚、二戊醚、甲乙醚、乙基异丙基醚、乙基丁基醚、乙基戊基醚、环醚、多元醇缩水甘油醚、甘油醚、环萜烯醚、茴香醚、苯乙醚、二苯醚、乙二醇二苯基醚、茴香脑、对丙烯基茴香醚、二苄醚、硝基苯乙醚、硝基茴香醚、2-叔丁基-5-甲基-4,6-二硝基茴香醚、β-萘甲醚、β-萘基乙醚、间甲酚甲醚、丁基间甲酚甲醚、苯基甲苯基醚、二甲苯基醚、苄基乙基醚、甲基叔丁基醚、间甲基二苯醚",
                                        "taxName": "有机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070202160000000000",
                                        "taxCodeTitle": "有机化学原料",
                                        "iTitle": "*有机化学原料*醚",
                                        "children": []
                                    },
                                    {
                                        "id": "1285",
                                        "linkid": "1257",
                                        "code": "107020217",
                                        "paCode": "1070202",
                                        "yn": "N",
                                        "title": "醚醇",
                                        "alias": "醚醇",
                                        "about": "包括醚醇及其卤、磺、硝或亚硝化衍生物",
                                        "kws": "醚醇、二甘醇、乙二醇单甲醚、二甘醇单甲醚、乙二醇单丁醚、二甘醇单丁醚、乙二醇、相关单烷基醚、二丁醇、间苯氧基苄醇",
                                        "taxName": "有机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070202170000000000",
                                        "taxCodeTitle": "有机化学原料",
                                        "iTitle": "*有机化学原料*醚醇",
                                        "children": []
                                    },
                                    {
                                        "id": "1286",
                                        "linkid": "1257",
                                        "code": "107020218",
                                        "paCode": "1070202",
                                        "yn": "N",
                                        "title": "醚酚及醚醇酚",
                                        "alias": "醚酚及醚醇酚",
                                        "about": "包括醚酚、醚醇酚及其卤、磺、硝或亚硝化衍生物",
                                        "kws": "醚酚及醚醇酚、醚酚、醚醇酚、焦儿茶酚单乙醚",
                                        "taxName": "有机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070202180000000000",
                                        "taxCodeTitle": "有机化学原料",
                                        "iTitle": "*有机化学原料*醚酚及醚醇酚",
                                        "children": []
                                    },
                                    {
                                        "id": "1287",
                                        "linkid": "1257",
                                        "code": "107020219",
                                        "paCode": "1070202",
                                        "yn": "N",
                                        "title": "过氧化醇、过氧化醚及过氧化酮",
                                        "alias": "过氧化醇、过氧化醚及过氧化酮",
                                        "about": "包括乙过醇（乙基过氧化氢）、过氧化二乙基、过氧醚、其他过氧化醇、过氧化醚及过氧化酮",
                                        "kws": "过氧化醇、过氧化醚、过氧化酮乙过醇、乙基过氧化氢、过氧化二乙基、过氧醚",
                                        "taxName": "有机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070202190000000000",
                                        "taxCodeTitle": "有机化学原料",
                                        "iTitle": "*有机化学原料*过氧化醇、过氧化醚及过氧化酮",
                                        "children": []
                                    },
                                    {
                                        "id": "1288",
                                        "linkid": "1257",
                                        "code": "107020220",
                                        "paCode": "1070202",
                                        "yn": "N",
                                        "title": "醛",
                                        "alias": "醛",
                                        "about": "指不含其他含氧基的无环醛",
                                        "kws": "醛、甲醛、乙醛、丁醛、庚醛、丙醛、辛醛、癸醛、壬醛、十一醛、十二醛、丙烯醛、2-丁烯醛、巴豆醛、柠檬醛、香茅醛、环柠檬醛A、环柠檬醛B、紫苏醛、藏花醛、苯甲醛、铃兰醛、肉桂醛、α-戊基肉桂醛、3-对枯烯基-2-甲基丙醛、苯乙醛",
                                        "taxName": "有机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070202200000000000",
                                        "taxCodeTitle": "有机化学原料",
                                        "iTitle": "*有机化学原料*醛",
                                        "children": []
                                    },
                                    {
                                        "id": "1289",
                                        "linkid": "1257",
                                        "code": "107020221",
                                        "paCode": "1070202",
                                        "yn": "N",
                                        "title": "醛醇",
                                        "alias": "醛醇",
                                        "about": "包括乙醇醛、3-羟基丁醛、羟基香茅醛、其他醛醇",
                                        "kws": "醛醇、乙醇醛、3-羟基丁醛、羟基香茅醛",
                                        "taxName": "有机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070202210000000000",
                                        "taxCodeTitle": "有机化学原料",
                                        "iTitle": "*有机化学原料*醛醇",
                                        "children": []
                                    },
                                    {
                                        "id": "1290",
                                        "linkid": "1257",
                                        "code": "107020222",
                                        "paCode": "1070202",
                                        "yn": "N",
                                        "title": "醛醚、醛酚及含有相关含氧基醛",
                                        "alias": "醛醚、醛酚及含有相关含氧基醛",
                                        "about": "包括香草醛（3-甲氧基-4-羟基苯甲醛）、乙基香草醛（3-乙氧基-4-羟基苯甲醛）、水杨醛（邻羟基苯甲醛）、3，4-二羟基苯甲醛（原儿茶醛）、茴香醛（对甲氧基苯甲醛）、其他醛醚、醛酚及含有相关含氧基醛",
                                        "kws": "醛醚、醛酚、含有相关含氧基醛香草醛、3-甲氧基-4-羟基苯甲醛、乙基香草醛、3-乙氧基-4-羟基苯甲醛、水杨醛、邻羟基苯甲醛、3,4-二羟基苯甲醛、原儿茶醛、茴香醛、对甲氧基苯甲醛",
                                        "taxName": "有机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070202220000000000",
                                        "taxCodeTitle": "有机化学原料",
                                        "iTitle": "*有机化学原料*醛醚、醛酚及含有相关含氧基醛",
                                        "children": []
                                    },
                                    {
                                        "id": "1291",
                                        "linkid": "1257",
                                        "code": "107020223",
                                        "paCode": "1070202",
                                        "yn": "N",
                                        "title": "环聚醛",
                                        "alias": "环聚醛",
                                        "about": "包括三聚甲醛（三恶烷）、三聚乙醛（仲乙醛）、四聚乙醛、其他环聚醛",
                                        "kws": "环聚醛、三聚甲醛、三恶烷、三聚乙醛、仲乙醛、四聚乙醛",
                                        "taxName": "有机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070202230000000000",
                                        "taxCodeTitle": "有机化学原料",
                                        "iTitle": "*有机化学原料*环聚醛",
                                        "children": []
                                    },
                                    {
                                        "id": "1292",
                                        "linkid": "1257",
                                        "code": "107020224",
                                        "paCode": "1070202",
                                        "yn": "N",
                                        "title": "多聚甲醛",
                                        "alias": "多聚甲醛",
                                        "about": "包括仲甲醛、其他多聚甲醛",
                                        "kws": "多聚甲醛、仲甲醛、吊白块、甲醛次硫酸氢钠",
                                        "taxName": "有机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070202240000000000",
                                        "taxCodeTitle": "有机化学原料",
                                        "iTitle": "*有机化学原料*多聚甲醛",
                                        "children": []
                                    },
                                    {
                                        "id": "1293",
                                        "linkid": "1257",
                                        "code": "107020225",
                                        "paCode": "1070202",
                                        "yn": "N",
                                        "title": "酮",
                                        "alias": "酮",
                                        "about": null,
                                        "kws": "酮、丙酮、丁酮、4-甲基-2-戊酮、莱基化氧、异亚丙基丙酮、佛尔酮、假紫罗酮、假甲基紫罗酮、联乙酰、丁二酮、乙酰丙酮、丙酮基丙酮、环己酮、甲基环己酮、乙烯酮、双乙烯酮、芷香酮、甲基芷香酮、紫罗酮、甲基紫罗酮、葑酮、鸢尾酮、茉莉酮、香芹酮、环戊酮、薄荷酮、芳香酮、苯丙酮、苯乙酮、甲基萘基酮、亚苄基丙酮、苯基乙基酮、甲基苯乙酮、丁基二甲基苯乙酮、二苯甲酮、苯并蒽酮、苯基丙酮、过氧化环己酮",
                                        "taxName": "有机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070202250000000000",
                                        "taxCodeTitle": "有机化学原料",
                                        "iTitle": "*有机化学原料*酮",
                                        "children": []
                                    },
                                    {
                                        "id": "1294",
                                        "linkid": "1257",
                                        "code": "107020226",
                                        "paCode": "1070202",
                                        "yn": "N",
                                        "title": "酮醇、酮醛及酮酚",
                                        "alias": "酮醇、酮醛及酮酚",
                                        "about": "包括酮醇、酮醛、酮酚、其他酮醇、其他酮醛、其他酮酚",
                                        "kws": "酮醇、酮醛、酮酚",
                                        "taxName": "有机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070202260000000000",
                                        "taxCodeTitle": "有机化学原料",
                                        "iTitle": "*有机化学原料*酮醇、酮醛及酮酚",
                                        "children": []
                                    },
                                    {
                                        "id": "1295",
                                        "linkid": "1257",
                                        "code": "107020227",
                                        "paCode": "1070202",
                                        "yn": "N",
                                        "title": "醌基化合物",
                                        "alias": "醌基化合物",
                                        "about": "包括蒽醌、对苯醌、1，4-萘醌、2-甲基蒽醌、二氢苊醌、菲醌、α-羟基蒽醌、醌茜、柯嗪、1-氨基蒽醌、酞菁铜、其他醌基化合物",
                                        "kws": "醌基化合物、蒽醌、对苯醌、1,4-萘醌、2-甲基蒽醌、二氢苊醌、菲醌、α-羟基蒽醌、醌茜、柯嗪、1-氨基蒽醌、酞菁铜、溶剂法酞菁铜、固相法酞菁铜",
                                        "taxName": "有机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070202270000000000",
                                        "taxCodeTitle": "有机化学原料",
                                        "iTitle": "*有机化学原料*醌基化合物",
                                        "children": []
                                    },
                                    {
                                        "id": "1296",
                                        "linkid": "1257",
                                        "code": "107020228",
                                        "paCode": "1070202",
                                        "yn": "N",
                                        "title": "无机酸酯及其盐",
                                        "alias": "无机酸酯及其盐",
                                        "about": "包括磷酸酯及其盐、硫代磷酸酯及其盐、硫酸酯及其盐",
                                        "kws": "甘油磷酸、肌醇六磷酸、肌醇六磷酸盐、磷酸三丁酯、磷酸三苯酯、磷酸三甲苯酯、磷酸二甲酯、磷酸三甲酯、磷酸三乙酯、磷酸二辛酯、磷酸愈创木酯、乳磷酸盐、乳磷酸酯、二丁基硫代磷酸钠、二甲苯基二硫代磷酸钠、二甲基硫代磷酸酯、硫酸氢甲酯、硫酸二甲酯、硫酸氢乙酯、硫酸二乙酯",
                                        "taxName": "有机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070202280000000000",
                                        "taxCodeTitle": "有机化学原料",
                                        "iTitle": "*有机化学原料*无机酸酯及其盐",
                                        "children": []
                                    },
                                    {
                                        "id": "1297",
                                        "linkid": "1257",
                                        "code": "107020229",
                                        "paCode": "1070202",
                                        "yn": "N",
                                        "title": "亚磷酸酯",
                                        "alias": "亚磷酸酯",
                                        "about": "包括亚磷酸三甲酯、亚磷酸三乙酯、亚磷酸二甲酯、亚磷酸二乙酯、其他亚磷酸酯",
                                        "kws": "亚磷酸酯亚磷酸三甲酯、亚磷酸三乙酯、亚磷酸二甲酯、亚磷酸二乙酯",
                                        "taxName": "有机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070202290000000000",
                                        "taxCodeTitle": "有机化学原料",
                                        "iTitle": "*有机化学原料*亚磷酸酯",
                                        "children": []
                                    },
                                    {
                                        "id": "1298",
                                        "linkid": "1257",
                                        "code": "107020230",
                                        "paCode": "1070202",
                                        "yn": "N",
                                        "title": "亚硝酸酯及硝酸酯",
                                        "alias": "亚硝酸酯及硝酸酯",
                                        "about": "包括亚硝酸酯、硝酸酯",
                                        "kws": "亚硝酸酯、硝酸酯",
                                        "taxName": "有机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070202300000000000",
                                        "taxCodeTitle": "有机化学原料",
                                        "iTitle": "*有机化学原料*亚硝酸酯及硝酸酯",
                                        "children": []
                                    },
                                    {
                                        "id": "1299",
                                        "linkid": "1257",
                                        "code": "107020231",
                                        "paCode": "1070202",
                                        "yn": "N",
                                        "title": "碳酸酯、过碳酸酯及其盐",
                                        "alias": "碳酸酯、过碳酸酯及其盐",
                                        "about": "包括碳酸二乙酯、碳酸二愈创木酯、碳酸丙烯酯、碳酸二苯酯、二甘醇双烯丙基碳酸酯、原碳酸四乙酯、过氧化二碳酸双（4-叔丁基环己）酯、其他碳酸酯、过碳酸酯及其盐",
                                        "kws": "碳酸酯、过碳酸酯、盐碳酸二乙酯、碳酸二愈创木酯、碳酸丙烯酯、碳酸二苯酯、二甘醇双烯丙基碳酸酯、原碳酸四乙酯、过氧化二碳酸双酯",
                                        "taxName": "有机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070202310000000000",
                                        "taxCodeTitle": "有机化学原料",
                                        "iTitle": "*有机化学原料*碳酸酯、过碳酸酯及其盐",
                                        "children": []
                                    },
                                    {
                                        "id": "1300",
                                        "linkid": "1257",
                                        "code": "107020232",
                                        "paCode": "1070202",
                                        "yn": "N",
                                        "title": "硅酸酯及其盐",
                                        "alias": "硅酸酯及其盐",
                                        "about": "包括硅酸乙酯（四乙氧基硅或硅酸四乙酯）、其他硅酸酯及其盐",
                                        "kws": "硅酸酯、盐硅酸乙酯、四乙氧基硅、硅酸四乙酯",
                                        "taxName": "有机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070202320000000000",
                                        "taxCodeTitle": "有机化学原料",
                                        "iTitle": "*有机化学原料*硅酸酯及其盐",
                                        "children": []
                                    },
                                    {
                                        "id": "1301",
                                        "linkid": "1257",
                                        "code": "107020233",
                                        "paCode": "1070202",
                                        "yn": "N",
                                        "title": "镍钴锰氢氧化物",
                                        "alias": "镍钴锰氢氧化物",
                                        "about": null,
                                        "kws": "镍钴锰氢氧化物",
                                        "taxName": "无机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070202330000000000",
                                        "taxCodeTitle": "无机化学原料",
                                        "iTitle": "*无机化学原料*镍钴锰氢氧化物",
                                        "children": []
                                    },
                                    {
                                        "id": "1302",
                                        "linkid": "1257",
                                        "code": "107020234",
                                        "paCode": "1070202",
                                        "yn": "N",
                                        "title": "镍钴锰酸锂",
                                        "alias": "镍钴锰酸锂",
                                        "about": null,
                                        "kws": "镍钴锰酸锂",
                                        "taxName": "无机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070202340000000000",
                                        "taxCodeTitle": "无机化学原料",
                                        "iTitle": "*无机化学原料*镍钴锰酸锂",
                                        "children": []
                                    },
                                    {
                                        "id": "1303",
                                        "linkid": "1257",
                                        "code": "107020235",
                                        "paCode": "1070202",
                                        "yn": "N",
                                        "title": "硫酸铵",
                                        "alias": "硫酸铵",
                                        "about": null,
                                        "kws": "硫酸铵",
                                        "taxName": "无机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070202350000000000",
                                        "taxCodeTitle": "无机化学原料",
                                        "iTitle": "*无机化学原料*硫酸铵",
                                        "children": []
                                    },
                                    {
                                        "id": "1304",
                                        "linkid": "1257",
                                        "code": "107020236",
                                        "paCode": "1070202",
                                        "yn": "N",
                                        "title": "氯化钴",
                                        "alias": "氯化钴",
                                        "about": null,
                                        "kws": "氯化钴",
                                        "taxName": "无机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070202360000000000",
                                        "taxCodeTitle": "无机化学原料",
                                        "iTitle": "*无机化学原料*氯化钴",
                                        "children": []
                                    },
                                    {
                                        "id": "1305",
                                        "linkid": "1257",
                                        "code": "107020237",
                                        "paCode": "1070202",
                                        "yn": "N",
                                        "title": "活性硅酸钙",
                                        "alias": "活性硅酸钙",
                                        "about": null,
                                        "kws": "活性硅酸钙",
                                        "taxName": "无机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070202370000000000",
                                        "taxCodeTitle": "无机化学原料",
                                        "iTitle": "*无机化学原料*活性硅酸钙",
                                        "children": []
                                    },
                                    {
                                        "id": "1306",
                                        "linkid": "1257",
                                        "code": "107020238",
                                        "paCode": "1070202",
                                        "yn": "N",
                                        "title": "环氧环己烷",
                                        "alias": "环氧环己烷",
                                        "about": null,
                                        "kws": "环氧环己烷",
                                        "taxName": "有机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070202380000000000",
                                        "taxCodeTitle": "有机化学原料",
                                        "iTitle": "*有机化学原料*环氧环己烷",
                                        "children": []
                                    },
                                    {
                                        "id": "1307",
                                        "linkid": "1257",
                                        "code": "107020239",
                                        "paCode": "1070202",
                                        "yn": "N",
                                        "title": "正戊醇",
                                        "alias": "正戊醇",
                                        "about": null,
                                        "kws": "正戊醇",
                                        "taxName": "有机化学原料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070202390000000000",
                                        "taxCodeTitle": "有机化学原料",
                                        "iTitle": "*有机化学原料*正戊醇",
                                        "children": []
                                    },
                                    {
                                        "id": "1308",
                                        "linkid": "1257",
                                        "code": "107020240",
                                        "paCode": "1070202",
                                        "yn": "N",
                                        "title": "二甲醚",
                                        "alias": "二甲醚",
                                        "about": "又称甲醚，指化学分子式为CH3OCH3，常温常压下为具有轻微醚香味，易燃、无毒、无腐蚀性的气体",
                                        "kws": "二甲醚、甲醚",
                                        "taxName": "有机化学原料",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1070202400000000000",
                                        "taxCodeTitle": "有机化学原料",
                                        "iTitle": "*有机化学原料*二甲醚",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1309",
                                "linkid": "1226",
                                "code": "1070203",
                                "paCode": "10702",
                                "yn": "Y",
                                "title": "贵金属化合物、相关基础化学品",
                                "alias": "贵金属化合物、相关基础化学品",
                                "about": "包括贵金属化合物、有机－无机化合物、相关基础化学品",
                                "kws": null,
                                "taxName": "基础化学品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070203000000000000",
                                "taxCodeTitle": "基础化学品",
                                "iTitle": "*基础化学品*贵金属化合物、相关基础化学品",
                                "children": [
                                    {
                                        "id": "1310",
                                        "linkid": "1309",
                                        "code": "107020301",
                                        "paCode": "1070203",
                                        "yn": "Y",
                                        "title": "活性炭、硫磺、磷",
                                        "alias": "活性炭、硫磺、磷",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "基础化学品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1070203010000000000",
                                        "taxCodeTitle": "基础化学品",
                                        "iTitle": "*基础化学品*活性炭、硫磺、磷",
                                        "children": [
                                            {
                                                "id": "1311",
                                                "linkid": "1310",
                                                "code": "10702030101",
                                                "paCode": "107020301",
                                                "yn": "N",
                                                "title": "活性炭",
                                                "alias": "活性炭",
                                                "about": "有多孔结构和对气体、蒸汽或胶态固体有强大吸附本领的炭；木、竹、果壳、兽骨、兽血、泥煤、褐煤等都可作为制造活性炭的原料；可将炭质用过热蒸汽、氯、氨或空气共同加热至高温活化，或将未碳化原料用氯化锌、氯化铵、氯化钙、硫酸、磷等浸渍后在低温碳化，再灼烧活化而得；主要用于脱色净化、溶剂的回收、气体的吸收、分离和提纯，化学合成的催化剂和催化剂载体等",
                                                "kws": "活性炭、粉状活性炭、颗粒活性炭",
                                                "taxName": "基础化学品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070203010100000000",
                                                "taxCodeTitle": "基础化学品",
                                                "iTitle": "*基础化学品*活性炭",
                                                "children": []
                                            },
                                            {
                                                "id": "1312",
                                                "linkid": "1310",
                                                "code": "10702030102",
                                                "paCode": "107020301",
                                                "yn": "N",
                                                "title": "硫磺",
                                                "alias": "硫磺",
                                                "about": "硫磺别名硫、胶体硫、硫黄块，外观为淡黄色脆性结晶或粉末，有特殊气味。主要用于制造染料、农药、火药等。",
                                                "kws": "硫磺、精制硫磺、硫、胶体硫、硫黄块",
                                                "taxName": "基础化学品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070203010200000000",
                                                "taxCodeTitle": "基础化学品",
                                                "iTitle": "*基础化学品*硫磺",
                                                "children": []
                                            },
                                            {
                                                "id": "1313",
                                                "linkid": "1310",
                                                "code": "10702030103",
                                                "paCode": "107020301",
                                                "yn": "N",
                                                "title": "磷",
                                                "alias": "磷",
                                                "about": "一种非金属元素，包括：黄磷、赤磷、其他磷",
                                                "kws": "磷、黄磷、赤磷",
                                                "taxName": "基础化学品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070203010300000000",
                                                "taxCodeTitle": "基础化学品",
                                                "iTitle": "*基础化学品*磷",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "1314",
                                        "linkid": "1309",
                                        "code": "107020302",
                                        "paCode": "1070203",
                                        "yn": "N",
                                        "title": "非金属基础化学品",
                                        "alias": "非金属基础化学品",
                                        "about": "包含硅、精硅、硒、砷、硼、碲等",
                                        "kws": "硅、精硅、硒、砷、硼、碲",
                                        "taxName": "基础化学品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070203020000000000",
                                        "taxCodeTitle": "基础化学品",
                                        "iTitle": "*基础化学品*非金属基础化学品",
                                        "children": []
                                    },
                                    {
                                        "id": "1315",
                                        "linkid": "1309",
                                        "code": "107020303",
                                        "paCode": "1070203",
                                        "yn": "N",
                                        "title": "贵金属化合物",
                                        "alias": "贵金属化合物",
                                        "about": "由贵金属元素与其他一种或一种以上元素形成的化合物。包含银化合物、金化合物、胶态贵金属、其他贵金属化合物等。",
                                        "kws": "银化合物、金化合物、胶态贵金属、贵金属化合物",
                                        "taxName": "基础化学品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070203030000000000",
                                        "taxCodeTitle": "基础化学品",
                                        "iTitle": "*基础化学品*贵金属化合物",
                                        "children": []
                                    },
                                    {
                                        "id": "1316",
                                        "linkid": "1309",
                                        "code": "107020304",
                                        "paCode": "1070203",
                                        "yn": "Y",
                                        "title": "稀土冶炼分离产品",
                                        "alias": "稀土冶炼分离产品",
                                        "about": "包括稀土金属、钇、钪及其混合物的化合物",
                                        "kws": null,
                                        "taxName": "稀土冶炼分离产品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1070203040000000000",
                                        "taxCodeTitle": "稀土冶炼分离产品",
                                        "iTitle": "*稀土冶炼分离产品*稀土冶炼分离产品",
                                        "children": [
                                            {
                                                "id": "1317",
                                                "linkid": "1316",
                                                "code": "10702030401",
                                                "paCode": "107020304",
                                                "yn": "Y",
                                                "title": "氧化稀土",
                                                "alias": "氧化稀土",
                                                "about": null,
                                                "kws": "氧化稀土",
                                                "taxName": "稀土冶炼分离产品",
                                                "taxRate": "",
                                                "vip": "7",
                                                "itaxRate": null,
                                                "taxCode": "1070203040100000000",
                                                "taxCodeTitle": "稀土冶炼分离产品",
                                                "iTitle": "*稀土冶炼分离产品*氧化稀土",
                                                "children": [
                                                    {
                                                        "id": "1318",
                                                        "linkid": "1317",
                                                        "code": "1070203040101",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化镧",
                                                        "alias": "氧化镧",
                                                        "about": "氧化镧试剂、镧化合物等",
                                                        "kws": "氧化镧试剂、镧化合物、氧化镧",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040101000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化镧",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1319",
                                                        "linkid": "1317",
                                                        "code": "1070203040102",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化铈",
                                                        "alias": "氧化铈",
                                                        "about": "氧化铈试剂、铈化合物等",
                                                        "kws": "氧化铈试剂、铈化合物、氧化铈",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040102000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化铈",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1320",
                                                        "linkid": "1317",
                                                        "code": "1070203040103",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化镨",
                                                        "alias": "氧化镨",
                                                        "about": "氧化镨试剂等",
                                                        "kws": "氧化镨试剂、氧化镨",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040103000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化镨",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1321",
                                                        "linkid": "1317",
                                                        "code": "1070203040104",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化钕",
                                                        "alias": "氧化钕",
                                                        "about": "氧化钕试剂等",
                                                        "kws": "氧化钕试剂、氧化钕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040104000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化钕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1322",
                                                        "linkid": "1317",
                                                        "code": "1070203040105",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化钐",
                                                        "alias": "氧化钐",
                                                        "about": "氧化钐试剂等",
                                                        "kws": "氧化钐试剂、氧化钐",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040105000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化钐",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1323",
                                                        "linkid": "1317",
                                                        "code": "1070203040106",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化铕",
                                                        "alias": "氧化铕",
                                                        "about": "氧化铕试剂等",
                                                        "kws": "氧化铕试剂、氧化铕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040106000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化铕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1324",
                                                        "linkid": "1317",
                                                        "code": "1070203040107",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化钆",
                                                        "alias": "氧化钆",
                                                        "about": "氧化钆试剂等",
                                                        "kws": "氧化钆试剂、氧化钆",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040107000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化钆",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1325",
                                                        "linkid": "1317",
                                                        "code": "1070203040108",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化铽",
                                                        "alias": "氧化铽",
                                                        "about": "氧化铽试剂等",
                                                        "kws": "氧化铽试剂、氧化铽",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040108000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化铽",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1326",
                                                        "linkid": "1317",
                                                        "code": "1070203040109",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化镝",
                                                        "alias": "氧化镝",
                                                        "about": "氧化镝试剂等",
                                                        "kws": "氧化镝试剂、氧化镝",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040109000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化镝",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1327",
                                                        "linkid": "1317",
                                                        "code": "1070203040110",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化钬",
                                                        "alias": "氧化钬",
                                                        "about": "氧化钬试剂等",
                                                        "kws": "氧化钬试剂、氧化钬",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040110000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化钬",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1328",
                                                        "linkid": "1317",
                                                        "code": "1070203040111",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化铒",
                                                        "alias": "氧化铒",
                                                        "about": "氧化铒试剂等",
                                                        "kws": "氧化铒试剂、氧化铒",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040111000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化铒",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1329",
                                                        "linkid": "1317",
                                                        "code": "1070203040112",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化铥",
                                                        "alias": "氧化铥",
                                                        "about": "氧化铥试剂等",
                                                        "kws": "氧化铥试剂、氧化铥",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040112000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化铥",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1330",
                                                        "linkid": "1317",
                                                        "code": "1070203040113",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化镱",
                                                        "alias": "氧化镱",
                                                        "about": "氧化镱试剂等",
                                                        "kws": "氧化镱试剂、氧化镱",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040113000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化镱",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1331",
                                                        "linkid": "1317",
                                                        "code": "1070203040114",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化镥",
                                                        "alias": "氧化镥",
                                                        "about": "氧化镥试剂等",
                                                        "kws": "氧化镥试剂、氧化镥",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040114000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化镥",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1332",
                                                        "linkid": "1317",
                                                        "code": "1070203040115",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化钪",
                                                        "alias": "氧化钪",
                                                        "about": "氧化钪试剂等",
                                                        "kws": "氧化钪试剂、氧化钪",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040115000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化钪",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1333",
                                                        "linkid": "1317",
                                                        "code": "1070203040116",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化钇",
                                                        "alias": "氧化钇",
                                                        "about": "氧化钇试剂等",
                                                        "kws": "氧化钇试剂、氧化钇",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040116000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化钇",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1334",
                                                        "linkid": "1317",
                                                        "code": "1070203040117",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化镧铈",
                                                        "alias": "氧化镧铈",
                                                        "about": "镧铈氧化物、镧铈富集物等",
                                                        "kws": "镧铈氧化物、镧铈富集物、氧化镧铈",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040117000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化镧铈",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1335",
                                                        "linkid": "1317",
                                                        "code": "1070203040118",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化镧铈镨",
                                                        "alias": "氧化镧铈镨",
                                                        "about": "镧铈镨氧化物等",
                                                        "kws": "镧铈镨氧化物、氧化镧铈镨",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040118000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化镧铈镨",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1336",
                                                        "linkid": "1317",
                                                        "code": "1070203040119",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化镧铈钕",
                                                        "alias": "氧化镧铈钕",
                                                        "about": "镧钕氧化物等",
                                                        "kws": "镧钕氧化物、氧化镧铈钕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040119000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化镧铈钕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1337",
                                                        "linkid": "1317",
                                                        "code": "1070203040120",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化镧铈镨钕",
                                                        "alias": "氧化镧铈镨钕",
                                                        "about": "镧铈镨钕氧化物、少钕氧化稀土、镧铈镨钕富集物等",
                                                        "kws": "镧铈镨钕氧化物、少钕氧化稀土、镧铈镨钕富集物、氧化镧铈镨钕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040120000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化镧铈镨钕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1338",
                                                        "linkid": "1317",
                                                        "code": "1070203040121",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化镧镨钕",
                                                        "alias": "氧化镧镨钕",
                                                        "about": "镧镨钕氧化物等",
                                                        "kws": "镧镨钕氧化物、氧化镧镨钕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040121000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化镧镨钕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1339",
                                                        "linkid": "1317",
                                                        "code": "1070203040122",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化镧铈铽",
                                                        "alias": "氧化镧铈铽",
                                                        "about": "镧铈铽氧化物、镧铽氧化物、镧铈铽共沉物等",
                                                        "kws": "镧铈铽氧化物、镧铽氧化物、镧铈铽共沉物、氧化镧铈铽",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040122000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化镧铈铽",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1340",
                                                        "linkid": "1317",
                                                        "code": "1070203040123",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化铈铽",
                                                        "alias": "氧化铈铽",
                                                        "about": "铈铽氧化物、铈铽共沉物等",
                                                        "kws": "铈铽氧化物、铈铽共沉物、氧化铈铽",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040123000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化铈铽",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1341",
                                                        "linkid": "1317",
                                                        "code": "1070203040124",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化镨钕",
                                                        "alias": "氧化镨钕",
                                                        "about": "镨钕稀土氧化物、镨钕氧化物、镨钕富集物等",
                                                        "kws": "镨钕稀土氧化物、镨钕氧化物、镨钕富集物、氧化镨钕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040124000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化镨钕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1342",
                                                        "linkid": "1317",
                                                        "code": "1070203040125",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化钐钆",
                                                        "alias": "氧化钐钆",
                                                        "about": "钐钆氧化物、钐钆富集物等",
                                                        "kws": "钐钆氧化物、钐钆富集物、氧化钐钆",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040125000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化钐钆",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1343",
                                                        "linkid": "1317",
                                                        "code": "1070203040126",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化钐铕",
                                                        "alias": "氧化钐铕",
                                                        "about": null,
                                                        "kws": "氧化钐铕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040126000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化钐铕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1344",
                                                        "linkid": "1317",
                                                        "code": "1070203040127",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化钐铕钆",
                                                        "alias": "氧化钐铕钆",
                                                        "about": "钐铕钆氧化物、钐铕钆富集物等",
                                                        "kws": "钐铕钆氧化物、钐铕钆富集物、氧化钐铕钆",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040127000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化钐铕钆",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1345",
                                                        "linkid": "1317",
                                                        "code": "1070203040128",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化铽镝",
                                                        "alias": "氧化铽镝",
                                                        "about": "铽镝氧化物、铽镝富集物等",
                                                        "kws": "铽镝氧化物、铽镝富集物、氧化铽镝",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040128000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化铽镝",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1346",
                                                        "linkid": "1317",
                                                        "code": "1070203040129",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化富镧",
                                                        "alias": "氧化富镧",
                                                        "about": "富镧稀土氧化物、富镧氧化物、镧钆富集物等",
                                                        "kws": "富镧稀土氧化物、富镧氧化物、镧钆富集物、氧化富镧",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040129000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化富镧",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1347",
                                                        "linkid": "1317",
                                                        "code": "1070203040130",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化富铈",
                                                        "alias": "氧化富铈",
                                                        "about": "富铈稀土氧化物、富铈氧化物、铈富集物等",
                                                        "kws": "富铈稀土氧化物、富铈氧化物、铈富集物、氧化富铈",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040130000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化富铈",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1348",
                                                        "linkid": "1317",
                                                        "code": "1070203040131",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化富镨",
                                                        "alias": "氧化富镨",
                                                        "about": null,
                                                        "kws": "氧化富镨",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040131000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化富镨",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1349",
                                                        "linkid": "1317",
                                                        "code": "1070203040132",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化富钕",
                                                        "alias": "氧化富钕",
                                                        "about": null,
                                                        "kws": "氧化富钕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040132000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化富钕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1350",
                                                        "linkid": "1317",
                                                        "code": "1070203040133",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化富钐",
                                                        "alias": "氧化富钐",
                                                        "about": "富钐氧化物、钐富集物等",
                                                        "kws": "富钐氧化物、钐富集物、氧化富钐",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040133000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化富钐",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1351",
                                                        "linkid": "1317",
                                                        "code": "1070203040134",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化富铕",
                                                        "alias": "氧化富铕",
                                                        "about": "粗铕氧化物、富铕氧化物等",
                                                        "kws": "粗铕氧化物、富铕氧化物、氧化富铕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040134000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化富铕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1352",
                                                        "linkid": "1317",
                                                        "code": "1070203040135",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化富钆",
                                                        "alias": "氧化富钆",
                                                        "about": "富钆氧化物等",
                                                        "kws": "富钆氧化物、氧化富钆",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040135000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化富钆",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1353",
                                                        "linkid": "1317",
                                                        "code": "1070203040136",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化富钬",
                                                        "alias": "氧化富钬",
                                                        "about": "富钬氧化物等",
                                                        "kws": "富钬氧化物、氧化富钬",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040136000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化富钬",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1354",
                                                        "linkid": "1317",
                                                        "code": "1070203040137",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化富铥",
                                                        "alias": "氧化富铥",
                                                        "about": "富铥氧化物等",
                                                        "kws": "富铥氧化物、氧化富铥",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040137000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化富铥",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1355",
                                                        "linkid": "1317",
                                                        "code": "1070203040138",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化富镱",
                                                        "alias": "氧化富镱",
                                                        "about": "富镱氧化物等",
                                                        "kws": "富镱氧化物、氧化富镱",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040138000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化富镱",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1356",
                                                        "linkid": "1317",
                                                        "code": "1070203040139",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化富镥",
                                                        "alias": "氧化富镥",
                                                        "about": "富镥氧化物等",
                                                        "kws": "富镥氧化物、氧化富镥",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040139000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化富镥",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1357",
                                                        "linkid": "1317",
                                                        "code": "1070203040140",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化富铽",
                                                        "alias": "氧化富铽",
                                                        "about": "富铽稀土氧化物、富铽氧化物、铽富集物等",
                                                        "kws": "富铽稀土氧化物、富铽氧化物、铽富集物、氧化富铽",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040140000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化富铽",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1358",
                                                        "linkid": "1317",
                                                        "code": "1070203040141",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化富镝",
                                                        "alias": "氧化富镝",
                                                        "about": "富镝氧化物、镝钬富集物等",
                                                        "kws": "氧化富镝、富镝氧化物、镝钬富集物",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040141000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化富镝",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1359",
                                                        "linkid": "1317",
                                                        "code": "1070203040142",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化富铒",
                                                        "alias": "氧化富铒",
                                                        "about": null,
                                                        "kws": "氧化富铒",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040142000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化富铒",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1360",
                                                        "linkid": "1317",
                                                        "code": "1070203040143",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化富钇",
                                                        "alias": "氧化富钇",
                                                        "about": "富钇氧化物、钇富集物、富钇富集物等",
                                                        "kws": "氧化富钇、富钇氧化物、钇富集物、富钇富集物",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040143000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化富钇",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1361",
                                                        "linkid": "1317",
                                                        "code": "1070203040144",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化钬铒铥镱镥",
                                                        "alias": "氧化钬铒铥镱镥",
                                                        "about": "铥镱镥氧化物、钬铒铥镱镥氧化稀土等",
                                                        "kws": "氧化钬铒铥镱镥、铥镱镥氧化物、钬铒铥镱镥氧化稀土",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040144000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化钬铒铥镱镥",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1362",
                                                        "linkid": "1317",
                                                        "code": "1070203040145",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化钬铒钇",
                                                        "alias": "氧化钬铒钇",
                                                        "about": "钬铒钇氧化物等",
                                                        "kws": "氧化钬铒钇、钬铒钇氧化物",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040145000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化钬铒钇",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1363",
                                                        "linkid": "1317",
                                                        "code": "1070203040146",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化钇铕",
                                                        "alias": "氧化钇铕",
                                                        "about": "钇铕氧化物、钇铕富集物、钇铕共沉物等",
                                                        "kws": "氧化钇铕、钇铕氧化物、钇铕富集物、钇铕共沉物",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040146000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化钇铕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1364",
                                                        "linkid": "1317",
                                                        "code": "1070203040147",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化钇铽",
                                                        "alias": "氧化钇铽",
                                                        "about": "钇铽氧化物、钇铽共沉物等",
                                                        "kws": "氧化钇铽、钇铽氧化物、钇铽共沉物",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040147000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化钇铽",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1365",
                                                        "linkid": "1317",
                                                        "code": "1070203040148",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "氧化钇镥",
                                                        "alias": "氧化钇镥",
                                                        "about": null,
                                                        "kws": "氧化钇镥",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040148000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氧化钇镥",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1366",
                                                        "linkid": "1317",
                                                        "code": "1070203040199",
                                                        "paCode": "10702030401",
                                                        "yn": "N",
                                                        "title": "其他氧化稀土",
                                                        "alias": "其他氧化稀土",
                                                        "about": null,
                                                        "kws": null,
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040199000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*其他氧化稀土",
                                                        "children": []
                                                    }
                                                ]
                                            },
                                            {
                                                "id": "1367",
                                                "linkid": "1316",
                                                "code": "10702030402",
                                                "paCode": "107020304",
                                                "yn": "Y",
                                                "title": "氯化稀土",
                                                "alias": "氯化稀土",
                                                "about": "用作电解混合稀土金属、稀土合金和提取单一稀土元素的原料，也可作石化催化剂、助催化剂和稀土抛光粉原料。包括：混合氯化稀土，其他氯化稀土等。",
                                                "kws": null,
                                                "taxName": "稀土冶炼分离产品",
                                                "taxRate": "",
                                                "vip": "7",
                                                "itaxRate": null,
                                                "taxCode": "1070203040200000000",
                                                "taxCodeTitle": "稀土冶炼分离产品",
                                                "iTitle": "*稀土冶炼分离产品*氯化稀土",
                                                "children": [
                                                    {
                                                        "id": "1368",
                                                        "linkid": "1367",
                                                        "code": "1070203040201",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化镧",
                                                        "alias": "氯化镧",
                                                        "about": "镧料液、无水氯化镧、镧化合物等",
                                                        "kws": "氯化镧、镧料液、无水氯化镧、镧化合物",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040201000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化镧",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1369",
                                                        "linkid": "1367",
                                                        "code": "1070203040202",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化铈",
                                                        "alias": "氯化铈",
                                                        "about": "铈料液、无水氯化铈、铈化合物等",
                                                        "kws": "氯化铈、铈料液、无水氯化铈、铈化合物",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040202000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化铈",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1370",
                                                        "linkid": "1367",
                                                        "code": "1070203040203",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化镨",
                                                        "alias": "氯化镨",
                                                        "about": "镨料液、无水氯化镨等",
                                                        "kws": "氯化镨、镨料液、无水氯化镨",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040203000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化镨",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1371",
                                                        "linkid": "1367",
                                                        "code": "1070203040204",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化钕",
                                                        "alias": "氯化钕",
                                                        "about": "钕料液、无水氯化钕等",
                                                        "kws": "氯化钕、钕料液、无水氯化钕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040204000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化钕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1372",
                                                        "linkid": "1367",
                                                        "code": "1070203040205",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化钐",
                                                        "alias": "氯化钐",
                                                        "about": "无水氯化钐等",
                                                        "kws": "氯化钐、无水氯化钐",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040205000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化钐",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1373",
                                                        "linkid": "1367",
                                                        "code": "1070203040206",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化铕",
                                                        "alias": "氯化铕",
                                                        "about": "无水氯化铕等",
                                                        "kws": "氯化铕、无水氯化铕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040206000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化铕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1374",
                                                        "linkid": "1367",
                                                        "code": "1070203040207",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化钆",
                                                        "alias": "氯化钆",
                                                        "about": "钆料液等",
                                                        "kws": "氯化钆、钆料液",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040207000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化钆",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1375",
                                                        "linkid": "1367",
                                                        "code": "1070203040208",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化铽",
                                                        "alias": "氯化铽",
                                                        "about": "铽料液、无水氯化铽等",
                                                        "kws": "氯化铽、铽料液、无水氯化铽",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040208000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化铽",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1376",
                                                        "linkid": "1367",
                                                        "code": "1070203040209",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化镝",
                                                        "alias": "氯化镝",
                                                        "about": "镝料液、无水氯化镝等",
                                                        "kws": "氯化镝、镝料液、无水氯化镝",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040209000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化镝",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1377",
                                                        "linkid": "1367",
                                                        "code": "1070203040210",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化钬",
                                                        "alias": "氯化钬",
                                                        "about": "钬料液等",
                                                        "kws": "氯化钬、钬料液",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040210000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化钬",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1378",
                                                        "linkid": "1367",
                                                        "code": "1070203040211",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化铒",
                                                        "alias": "氯化铒",
                                                        "about": "铒料液等",
                                                        "kws": "氯化铒、铒料液",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040211000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化铒",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1379",
                                                        "linkid": "1367",
                                                        "code": "1070203040212",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化铥",
                                                        "alias": "氯化铥",
                                                        "about": "铥料液等",
                                                        "kws": "氯化铥、铥料液",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040212000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化铥",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1380",
                                                        "linkid": "1367",
                                                        "code": "1070203040213",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化镱",
                                                        "alias": "氯化镱",
                                                        "about": "镱料液等",
                                                        "kws": "氯化镱、镱料液",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040213000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化镱",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1381",
                                                        "linkid": "1367",
                                                        "code": "1070203040214",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化镥",
                                                        "alias": "氯化镥",
                                                        "about": "镥料液等",
                                                        "kws": "氯化镥、镥料液",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040214000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化镥",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1382",
                                                        "linkid": "1367",
                                                        "code": "1070203040215",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化钪",
                                                        "alias": "氯化钪",
                                                        "about": "钪料液等",
                                                        "kws": "氯化钪、钪料液",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040215000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化钪",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1383",
                                                        "linkid": "1367",
                                                        "code": "1070203040216",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化钇",
                                                        "alias": "氯化钇",
                                                        "about": "钇料液、无水氯化钇等",
                                                        "kws": "氯化钇、钇料液、无水氯化钇",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040216000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化钇",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1384",
                                                        "linkid": "1367",
                                                        "code": "1070203040217",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化镧铈",
                                                        "alias": "氯化镧铈",
                                                        "about": "镧铈料液、镧铈氯化物、液体氯化镧铈等",
                                                        "kws": "氯化镧铈、镧铈料液、镧铈氯化物、液体氯化镧铈",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040217000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化镧铈",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1385",
                                                        "linkid": "1367",
                                                        "code": "1070203040218",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化镧铈镨",
                                                        "alias": "氯化镧铈镨",
                                                        "about": "镧铈镨料液、少钕料液、少钕氯化稀土等",
                                                        "kws": "氯化镧铈镨、镧铈镨料液、少钕料液、少钕氯化稀土",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040218000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化镧铈镨",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1386",
                                                        "linkid": "1367",
                                                        "code": "1070203040219",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化镧铈钕",
                                                        "alias": "氯化镧铈钕",
                                                        "about": "镧钕料液等",
                                                        "kws": "氯化镧铈钕、镧钕料液",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040219000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化镧铈钕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1387",
                                                        "linkid": "1367",
                                                        "code": "1070203040220",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化镧铈镨钕",
                                                        "alias": "氯化镧铈镨钕",
                                                        "about": "镧铈镨钕料液、镧铈镨钕氯化物等",
                                                        "kws": "氯化镧铈镨钕、镧铈镨钕料液、镧铈镨钕氯化物",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040220000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化镧铈镨钕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1388",
                                                        "linkid": "1367",
                                                        "code": "1070203040221",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化镧镨钕",
                                                        "alias": "氯化镧镨钕",
                                                        "about": null,
                                                        "kws": "氯化镧镨钕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040221000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化镧镨钕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1389",
                                                        "linkid": "1367",
                                                        "code": "1070203040222",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化镧铈铽",
                                                        "alias": "氯化镧铈铽",
                                                        "about": "镧铈铽氯化物、镧铽氯化物等",
                                                        "kws": "氯化镧铈铽、镧铈铽氯化物、镧铽氯化物",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040222000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化镧铈铽",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1390",
                                                        "linkid": "1367",
                                                        "code": "1070203040223",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化铈铽",
                                                        "alias": "氯化铈铽",
                                                        "about": "铈铽料液、铈铽氯化物等",
                                                        "kws": "氯化铈铽、铈铽料液、铈铽氯化物",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040223000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化铈铽",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1391",
                                                        "linkid": "1367",
                                                        "code": "1070203040224",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化镨钕",
                                                        "alias": "氯化镨钕",
                                                        "about": "镨钕料液、镨钕氯化物、无水氯化镨钕等",
                                                        "kws": "氯化镨钕、镨钕料液、镨钕氯化物、无水氯化镨钕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040224000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化镨钕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1392",
                                                        "linkid": "1367",
                                                        "code": "1070203040225",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化钐钆",
                                                        "alias": "氯化钐钆",
                                                        "about": "钐钆料液等",
                                                        "kws": "氯化钐钆、钐钆料液",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040225000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化钐钆",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1393",
                                                        "linkid": "1367",
                                                        "code": "1070203040226",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化钐铕",
                                                        "alias": "氯化钐铕",
                                                        "about": null,
                                                        "kws": "氯化钐铕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040226000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化钐铕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1394",
                                                        "linkid": "1367",
                                                        "code": "1070203040227",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化钐铕钆",
                                                        "alias": "氯化钐铕钆",
                                                        "about": "钐铕钆料液、钐铕钆氯化物等",
                                                        "kws": "氯化钐铕钆、钐铕钆料液、钐铕钆氯化物",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040227000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化钐铕钆",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1395",
                                                        "linkid": "1367",
                                                        "code": "1070203040228",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化铽镝",
                                                        "alias": "氯化铽镝",
                                                        "about": "铽镝料液等",
                                                        "kws": "氯化铽镝、铽镝料液",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040228000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化铽镝",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1396",
                                                        "linkid": "1367",
                                                        "code": "1070203040229",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化富镧",
                                                        "alias": "氯化富镧",
                                                        "about": "富镧料液、富镧氯化物、少铈富镧料液、富镧液等",
                                                        "kws": "氯化富镧、富镧料液、富镧氯化物、少铈富镧料液、富镧液",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040229000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化富镧",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1397",
                                                        "linkid": "1367",
                                                        "code": "1070203040230",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化富铈",
                                                        "alias": "氯化富铈",
                                                        "about": "富铈氯化物等",
                                                        "kws": "氯化富铈、富铈氯化物",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040230000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化富铈",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1398",
                                                        "linkid": "1367",
                                                        "code": "1070203040231",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化富镨",
                                                        "alias": "氯化富镨",
                                                        "about": null,
                                                        "kws": "氯化富镨",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040231000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化富镨",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1399",
                                                        "linkid": "1367",
                                                        "code": "1070203040232",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化富钕",
                                                        "alias": "氯化富钕",
                                                        "about": null,
                                                        "kws": "氯化富钕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040232000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化富钕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1400",
                                                        "linkid": "1367",
                                                        "code": "1070203040233",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化富钐",
                                                        "alias": "氯化富钐",
                                                        "about": "富钐氯化物等",
                                                        "kws": "氯化富钐、富钐氯化物",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040233000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化富钐",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1401",
                                                        "linkid": "1367",
                                                        "code": "1070203040234",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化富铕",
                                                        "alias": "氯化富铕",
                                                        "about": "粗铕料液、富铕料液等",
                                                        "kws": "氯化富铕、粗铕料液、富铕料液",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040234000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化富铕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1402",
                                                        "linkid": "1367",
                                                        "code": "1070203040235",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化富钆",
                                                        "alias": "氯化富钆",
                                                        "about": "富钆液等",
                                                        "kws": "氯化富钆、富钆液",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040235000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化富钆",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1403",
                                                        "linkid": "1367",
                                                        "code": "1070203040236",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化富钬",
                                                        "alias": "氯化富钬",
                                                        "about": "富钬液等",
                                                        "kws": "氯化富钬、富钬液",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040236000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化富钬",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1404",
                                                        "linkid": "1367",
                                                        "code": "1070203040237",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化富铥",
                                                        "alias": "氯化富铥",
                                                        "about": "富铥液等",
                                                        "kws": "氯化富铥、富铥液",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040237000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化富铥",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1405",
                                                        "linkid": "1367",
                                                        "code": "1070203040238",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化富镱",
                                                        "alias": "氯化富镱",
                                                        "about": "富镱液等",
                                                        "kws": "氯化富镱、富镱液",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040238000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化富镱",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1406",
                                                        "linkid": "1367",
                                                        "code": "1070203040239",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化富镥",
                                                        "alias": "氯化富镥",
                                                        "about": "富镥液等",
                                                        "kws": "氯化富镥、富镥液",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040239000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化富镥",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1407",
                                                        "linkid": "1367",
                                                        "code": "1070203040240",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化富铽",
                                                        "alias": "氯化富铽",
                                                        "about": "富铽料液、富铽氯化物、富铽液等",
                                                        "kws": "氯化富铽、富铽料液、富铽氯化物、富铽液",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040240000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化富铽",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1408",
                                                        "linkid": "1367",
                                                        "code": "1070203040241",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化富镝",
                                                        "alias": "氯化富镝",
                                                        "about": "富镝料液、富镝氯化物等",
                                                        "kws": "氯化富镝、富镝料液、富镝氯化物",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040241000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化富镝",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1409",
                                                        "linkid": "1367",
                                                        "code": "1070203040242",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化富铒",
                                                        "alias": "氯化富铒",
                                                        "about": null,
                                                        "kws": "氯化富铒",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040242000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化富铒",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1410",
                                                        "linkid": "1367",
                                                        "code": "1070203040243",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化富钇",
                                                        "alias": "氯化富钇",
                                                        "about": "富钇料液、富钇氯化物等",
                                                        "kws": "氯化富钇、富钇料液、富钇氯化物",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040243000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化富钇",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1411",
                                                        "linkid": "1367",
                                                        "code": "1070203040244",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化钬铒铥镱镥",
                                                        "alias": "氯化钬铒铥镱镥",
                                                        "about": "铥镱镥料液、钬镥料液等",
                                                        "kws": "氯化钬铒铥镱镥、铥镱镥料液、钬镥料液",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040244000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化钬铒铥镱镥",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1412",
                                                        "linkid": "1367",
                                                        "code": "1070203040245",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化钬铒钇",
                                                        "alias": "氯化钬铒钇",
                                                        "about": "钬铒料液、钬铒钇氯化物、钬钇料液等",
                                                        "kws": "氯化钬铒钇、钬铒料液、钬铒钇氯化物、钬钇料液",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040245000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化钬铒钇",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1413",
                                                        "linkid": "1367",
                                                        "code": "1070203040246",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化钇铕",
                                                        "alias": "氯化钇铕",
                                                        "about": "低钇低铕混合稀土氯化物、钇铕氯化物等",
                                                        "kws": "氯化钇铕、钇铕氯化物、低钇低铕混合稀土氯化物",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040246000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化钇铕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1414",
                                                        "linkid": "1367",
                                                        "code": "1070203040247",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化钇铽",
                                                        "alias": "氯化钇铽",
                                                        "about": "钇铽氯化物等",
                                                        "kws": "氯化钇铽、钇铽氯化物",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040247000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化钇铽",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1415",
                                                        "linkid": "1367",
                                                        "code": "1070203040248",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "氯化钇镥",
                                                        "alias": "氯化钇镥",
                                                        "about": null,
                                                        "kws": "氯化钇镥",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040248000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氯化钇镥",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1416",
                                                        "linkid": "1367",
                                                        "code": "1070203040299",
                                                        "paCode": "10702030402",
                                                        "yn": "N",
                                                        "title": "其他氯化稀土",
                                                        "alias": "其他氯化稀土",
                                                        "about": null,
                                                        "kws": null,
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040299000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*其他氯化稀土",
                                                        "children": []
                                                    }
                                                ]
                                            },
                                            {
                                                "id": "1417",
                                                "linkid": "1316",
                                                "code": "10702030403",
                                                "paCode": "107020304",
                                                "yn": "Y",
                                                "title": "氟化稀土",
                                                "alias": "氟化稀土",
                                                "about": null,
                                                "kws": null,
                                                "taxName": "稀土冶炼分离产品",
                                                "taxRate": "",
                                                "vip": "7",
                                                "itaxRate": null,
                                                "taxCode": "1070203040300000000",
                                                "taxCodeTitle": "稀土冶炼分离产品",
                                                "iTitle": "*稀土冶炼分离产品*氟化稀土",
                                                "children": [
                                                    {
                                                        "id": "1418",
                                                        "linkid": "1417",
                                                        "code": "1070203040301",
                                                        "paCode": "10702030403",
                                                        "yn": "N",
                                                        "title": "氟化镧",
                                                        "alias": "氟化镧",
                                                        "about": "镧化合物",
                                                        "kws": "氟化镧",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040301000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氟化镧",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1419",
                                                        "linkid": "1417",
                                                        "code": "1070203040302",
                                                        "paCode": "10702030403",
                                                        "yn": "N",
                                                        "title": "氟化铈",
                                                        "alias": "氟化铈",
                                                        "about": "铈化合物",
                                                        "kws": "氟化铈",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040302000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氟化铈",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1420",
                                                        "linkid": "1417",
                                                        "code": "1070203040303",
                                                        "paCode": "10702030403",
                                                        "yn": "N",
                                                        "title": "氟化镨",
                                                        "alias": "氟化镨",
                                                        "about": null,
                                                        "kws": "氟化镨",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040303000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氟化镨",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1421",
                                                        "linkid": "1417",
                                                        "code": "1070203040304",
                                                        "paCode": "10702030403",
                                                        "yn": "N",
                                                        "title": "氟化钕",
                                                        "alias": "氟化钕",
                                                        "about": null,
                                                        "kws": "氟化钕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040304000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氟化钕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1422",
                                                        "linkid": "1417",
                                                        "code": "1070203040305",
                                                        "paCode": "10702030403",
                                                        "yn": "N",
                                                        "title": "氟化钐",
                                                        "alias": "氟化钐",
                                                        "about": null,
                                                        "kws": "氟化钐",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040305000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氟化钐",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1423",
                                                        "linkid": "1417",
                                                        "code": "1070203040306",
                                                        "paCode": "10702030403",
                                                        "yn": "N",
                                                        "title": "氟化铕",
                                                        "alias": "氟化铕",
                                                        "about": null,
                                                        "kws": "氟化铕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040306000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氟化铕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1424",
                                                        "linkid": "1417",
                                                        "code": "1070203040307",
                                                        "paCode": "10702030403",
                                                        "yn": "N",
                                                        "title": "氟化钆",
                                                        "alias": "氟化钆",
                                                        "about": null,
                                                        "kws": "氟化钆",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040307000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氟化钆",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1425",
                                                        "linkid": "1417",
                                                        "code": "1070203040308",
                                                        "paCode": "10702030403",
                                                        "yn": "N",
                                                        "title": "氟化铽",
                                                        "alias": "氟化铽",
                                                        "about": null,
                                                        "kws": "氟化铽",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040308000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氟化铽",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1426",
                                                        "linkid": "1417",
                                                        "code": "1070203040309",
                                                        "paCode": "10702030403",
                                                        "yn": "N",
                                                        "title": "氟化镝",
                                                        "alias": "氟化镝",
                                                        "about": null,
                                                        "kws": "氟化镝",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040309000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氟化镝",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1427",
                                                        "linkid": "1417",
                                                        "code": "1070203040310",
                                                        "paCode": "10702030403",
                                                        "yn": "N",
                                                        "title": "氟化钬",
                                                        "alias": "氟化钬",
                                                        "about": null,
                                                        "kws": "氟化钬",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040310000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氟化钬",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1428",
                                                        "linkid": "1417",
                                                        "code": "1070203040311",
                                                        "paCode": "10702030403",
                                                        "yn": "N",
                                                        "title": "氟化铒",
                                                        "alias": "氟化铒",
                                                        "about": null,
                                                        "kws": "氟化铒",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040311000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氟化铒",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1429",
                                                        "linkid": "1417",
                                                        "code": "1070203040312",
                                                        "paCode": "10702030403",
                                                        "yn": "N",
                                                        "title": "氟化铥",
                                                        "alias": "氟化铥",
                                                        "about": null,
                                                        "kws": "氟化铥",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040312000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氟化铥",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1430",
                                                        "linkid": "1417",
                                                        "code": "1070203040313",
                                                        "paCode": "10702030403",
                                                        "yn": "N",
                                                        "title": "氟化镱",
                                                        "alias": "氟化镱",
                                                        "about": null,
                                                        "kws": "氟化镱",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040313000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氟化镱",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1431",
                                                        "linkid": "1417",
                                                        "code": "1070203040314",
                                                        "paCode": "10702030403",
                                                        "yn": "N",
                                                        "title": "氟化镥",
                                                        "alias": "氟化镥",
                                                        "about": null,
                                                        "kws": "氟化镥",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040314000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氟化镥",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1432",
                                                        "linkid": "1417",
                                                        "code": "1070203040315",
                                                        "paCode": "10702030403",
                                                        "yn": "N",
                                                        "title": "氟化钪",
                                                        "alias": "氟化钪",
                                                        "about": null,
                                                        "kws": "氟化钪",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040315000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氟化钪",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1433",
                                                        "linkid": "1417",
                                                        "code": "1070203040316",
                                                        "paCode": "10702030403",
                                                        "yn": "N",
                                                        "title": "氟化钇",
                                                        "alias": "氟化钇",
                                                        "about": null,
                                                        "kws": "氟化钇",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040316000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氟化钇",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1434",
                                                        "linkid": "1417",
                                                        "code": "1070203040317",
                                                        "paCode": "10702030403",
                                                        "yn": "N",
                                                        "title": "氟化镨钕",
                                                        "alias": "氟化镨钕",
                                                        "about": "镨钕氟化物等",
                                                        "kws": "氟化镨钕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040317000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氟化镨钕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1435",
                                                        "linkid": "1417",
                                                        "code": "1070203040399",
                                                        "paCode": "10702030403",
                                                        "yn": "N",
                                                        "title": "其他氟化稀土",
                                                        "alias": "其他氟化稀土",
                                                        "about": null,
                                                        "kws": null,
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040399000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*其他氟化稀土",
                                                        "children": []
                                                    }
                                                ]
                                            },
                                            {
                                                "id": "1436",
                                                "linkid": "1316",
                                                "code": "10702030404",
                                                "paCode": "107020304",
                                                "yn": "Y",
                                                "title": "碳酸稀土",
                                                "alias": "碳酸稀土",
                                                "about": "碳酸稀土是稀土碳酸盐的混合物，属稀土分离中的初级产品。包括：碳酸铈，混合碳酸稀土，其他碳酸稀土等。",
                                                "kws": "碳酸铈、混合碳酸稀土、碳酸稀土",
                                                "taxName": "稀土冶炼分离产品",
                                                "taxRate": "",
                                                "vip": "7",
                                                "itaxRate": null,
                                                "taxCode": "1070203040400000000",
                                                "taxCodeTitle": "稀土冶炼分离产品",
                                                "iTitle": "*稀土冶炼分离产品*碳酸稀土",
                                                "children": [
                                                    {
                                                        "id": "1437",
                                                        "linkid": "1436",
                                                        "code": "1070203040401",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸镧",
                                                        "alias": "碳酸镧",
                                                        "about": "低钙镧碳酸盐、低钙镧稀土碳酸物、低钙碳酸镧、碳酸低钙镧、碳酸氧镧、镧化合物等",
                                                        "kws": "碳酸镧",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040401000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸镧",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1438",
                                                        "linkid": "1436",
                                                        "code": "1070203040402",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸铈",
                                                        "alias": "碳酸铈",
                                                        "about": "低氯根碳酸铈、碱式碳酸铈、铈化合物等",
                                                        "kws": "碳酸铈",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040402000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸铈",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1439",
                                                        "linkid": "1436",
                                                        "code": "1070203040403",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸镨",
                                                        "alias": "碳酸镨",
                                                        "about": null,
                                                        "kws": "碳酸镨",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040403000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸镨",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1440",
                                                        "linkid": "1436",
                                                        "code": "1070203040404",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸钕",
                                                        "alias": "碳酸钕",
                                                        "about": null,
                                                        "kws": "碳酸钕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040404000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸钕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1441",
                                                        "linkid": "1436",
                                                        "code": "1070203040405",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸钐",
                                                        "alias": "碳酸钐",
                                                        "about": "钐碳酸盐等",
                                                        "kws": "碳酸钐",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040405000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸钐",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1442",
                                                        "linkid": "1436",
                                                        "code": "1070203040406",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸铕",
                                                        "alias": "碳酸铕",
                                                        "about": null,
                                                        "kws": "碳酸铕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040406000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸铕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1443",
                                                        "linkid": "1436",
                                                        "code": "1070203040407",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸钆",
                                                        "alias": "碳酸钆",
                                                        "about": null,
                                                        "kws": "碳酸钆",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040407000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸钆",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1444",
                                                        "linkid": "1436",
                                                        "code": "1070203040408",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸铽",
                                                        "alias": "碳酸铽",
                                                        "about": null,
                                                        "kws": "碳酸铽",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040408000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸铽",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1445",
                                                        "linkid": "1436",
                                                        "code": "1070203040409",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸镝",
                                                        "alias": "碳酸镝",
                                                        "about": null,
                                                        "kws": "碳酸镝",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040409000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸镝",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1446",
                                                        "linkid": "1436",
                                                        "code": "1070203040410",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸钬",
                                                        "alias": "碳酸钬",
                                                        "about": null,
                                                        "kws": "碳酸钬",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040410000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸钬",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1447",
                                                        "linkid": "1436",
                                                        "code": "1070203040411",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸铒",
                                                        "alias": "碳酸铒",
                                                        "about": null,
                                                        "kws": "碳酸铒",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040411000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸铒",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1448",
                                                        "linkid": "1436",
                                                        "code": "1070203040412",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸铥",
                                                        "alias": "碳酸铥",
                                                        "about": null,
                                                        "kws": "碳酸铥",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040412000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸铥",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1449",
                                                        "linkid": "1436",
                                                        "code": "1070203040413",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸镱",
                                                        "alias": "碳酸镱",
                                                        "about": null,
                                                        "kws": "碳酸镱",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040413000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸镱",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1450",
                                                        "linkid": "1436",
                                                        "code": "1070203040414",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸镥",
                                                        "alias": "碳酸镥",
                                                        "about": null,
                                                        "kws": "碳酸镥",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040414000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸镥",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1451",
                                                        "linkid": "1436",
                                                        "code": "1070203040415",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸钪",
                                                        "alias": "碳酸钪",
                                                        "about": null,
                                                        "kws": "碳酸钪",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040415000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸钪",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1452",
                                                        "linkid": "1436",
                                                        "code": "1070203040416",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸钇",
                                                        "alias": "碳酸钇",
                                                        "about": "高钇碳酸稀土等",
                                                        "kws": "碳酸钇",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040416000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸钇",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1453",
                                                        "linkid": "1436",
                                                        "code": "1070203040417",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸镧铈",
                                                        "alias": "碳酸镧铈",
                                                        "about": "镧铈碳酸盐、镧铈稀土碳酸物等",
                                                        "kws": "碳酸镧铈",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040417000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸镧铈",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1454",
                                                        "linkid": "1436",
                                                        "code": "1070203040418",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸镧铈镨",
                                                        "alias": "碳酸镧铈镨",
                                                        "about": "镧铈镨碳酸盐、少钕碳酸盐、少钕碳酸稀土等",
                                                        "kws": "碳酸镧铈镨",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040418000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸镧铈镨",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1455",
                                                        "linkid": "1436",
                                                        "code": "1070203040419",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸镧铈钕",
                                                        "alias": "碳酸镧铈钕",
                                                        "about": "镧钕碳酸盐等",
                                                        "kws": "碳酸镧铈钕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040419000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸镧铈钕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1456",
                                                        "linkid": "1436",
                                                        "code": "1070203040420",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸镧铈镨钕",
                                                        "alias": "碳酸镧铈镨钕",
                                                        "about": "镧铈镨钕碳酸盐等",
                                                        "kws": "碳酸镧铈镨钕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040420000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸镧铈镨钕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1457",
                                                        "linkid": "1436",
                                                        "code": "1070203040421",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸镧镨钕",
                                                        "alias": "碳酸镧镨钕",
                                                        "about": "镧镨钕碳酸稀土等",
                                                        "kws": "碳酸镧镨钕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040421000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸镧镨钕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1458",
                                                        "linkid": "1436",
                                                        "code": "1070203040422",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸镧铈铽",
                                                        "alias": "碳酸镧铈铽",
                                                        "about": null,
                                                        "kws": "碳酸镧铈铽",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040422000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸镧铈铽",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1459",
                                                        "linkid": "1436",
                                                        "code": "1070203040423",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸铈铽",
                                                        "alias": "碳酸铈铽",
                                                        "about": "铈铽碳酸盐等",
                                                        "kws": "碳酸铈铽",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040423000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸铈铽",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1460",
                                                        "linkid": "1436",
                                                        "code": "1070203040424",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸镨钕",
                                                        "alias": "碳酸镨钕",
                                                        "about": "镨钕碳酸盐等",
                                                        "kws": "碳酸镨钕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040424000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸镨钕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1461",
                                                        "linkid": "1436",
                                                        "code": "1070203040425",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸钐钆",
                                                        "alias": "碳酸钐钆",
                                                        "about": "钐钆碳酸盐等",
                                                        "kws": "碳酸钐钆",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040425000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸钐钆",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1462",
                                                        "linkid": "1436",
                                                        "code": "1070203040426",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸钐铕",
                                                        "alias": "碳酸钐铕",
                                                        "about": "钐铕碳酸盐等",
                                                        "kws": "碳酸钐铕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040426000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸钐铕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1463",
                                                        "linkid": "1436",
                                                        "code": "1070203040427",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸钐铕钆",
                                                        "alias": "碳酸钐铕钆",
                                                        "about": "钐铕钆碳酸盐等",
                                                        "kws": "碳酸钐铕钆",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040427000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸钐铕钆",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1464",
                                                        "linkid": "1436",
                                                        "code": "1070203040428",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸铽镝",
                                                        "alias": "碳酸铽镝",
                                                        "about": "铽镝碳酸盐等",
                                                        "kws": "碳酸铽镝",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040428000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸铽镝",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1465",
                                                        "linkid": "1436",
                                                        "code": "1070203040429",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸富镧",
                                                        "alias": "碳酸富镧",
                                                        "about": "富镧碳酸盐、富镧稀土碳酸物等",
                                                        "kws": "碳酸富镧",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040429000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸富镧",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1466",
                                                        "linkid": "1436",
                                                        "code": "1070203040430",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸富铈",
                                                        "alias": "碳酸富铈",
                                                        "about": "富铈碳酸盐、富铈稀土碳酸物等",
                                                        "kws": "碳酸富铈",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040430000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸富铈",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1467",
                                                        "linkid": "1436",
                                                        "code": "1070203040431",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸富镨",
                                                        "alias": "碳酸富镨",
                                                        "about": null,
                                                        "kws": "碳酸富镨",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040431000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸富镨",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1468",
                                                        "linkid": "1436",
                                                        "code": "1070203040432",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸富钕",
                                                        "alias": "碳酸富钕",
                                                        "about": null,
                                                        "kws": "碳酸富钕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040432000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸富钕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1469",
                                                        "linkid": "1436",
                                                        "code": "1070203040433",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸富钐",
                                                        "alias": "碳酸富钐",
                                                        "about": "富钐碳酸盐、富钐稀土碳酸物等",
                                                        "kws": "碳酸富钐",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040433000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸富钐",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1470",
                                                        "linkid": "1436",
                                                        "code": "1070203040434",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸富铕",
                                                        "alias": "碳酸富铕",
                                                        "about": "粗铕碳酸盐、富铕碳酸盐等",
                                                        "kws": "碳酸富铕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040434000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸富铕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1471",
                                                        "linkid": "1436",
                                                        "code": "1070203040435",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸富钆",
                                                        "alias": "碳酸富钆",
                                                        "about": "富钆碳酸盐等",
                                                        "kws": "碳酸富钆",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040435000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸富钆",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1472",
                                                        "linkid": "1436",
                                                        "code": "1070203040436",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸富铽",
                                                        "alias": "碳酸富铽",
                                                        "about": "富铽碳酸盐、富铽稀土碳酸物等",
                                                        "kws": "碳酸富铽",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040436000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸富铽",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1473",
                                                        "linkid": "1436",
                                                        "code": "1070203040437",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸富钬",
                                                        "alias": "碳酸富钬",
                                                        "about": "富钬碳酸盐等",
                                                        "kws": "碳酸富钬",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040437000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸富钬",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1474",
                                                        "linkid": "1436",
                                                        "code": "1070203040438",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸富铥",
                                                        "alias": "碳酸富铥",
                                                        "about": "富铥碳酸盐等",
                                                        "kws": "碳酸富铥",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040438000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸富铥",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1475",
                                                        "linkid": "1436",
                                                        "code": "1070203040439",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸富镱",
                                                        "alias": "碳酸富镱",
                                                        "about": "富镱碳酸盐等",
                                                        "kws": "碳酸富镱",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040439000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸富镱",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1476",
                                                        "linkid": "1436",
                                                        "code": "1070203040440",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸富镥",
                                                        "alias": "碳酸富镥",
                                                        "about": "富镥碳酸盐等",
                                                        "kws": "碳酸富镥",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040440000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸富镥",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1477",
                                                        "linkid": "1436",
                                                        "code": "1070203040441",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸富镝",
                                                        "alias": "碳酸富镝",
                                                        "about": "富镝碳酸盐等",
                                                        "kws": "碳酸富镝",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040441000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸富镝",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1478",
                                                        "linkid": "1436",
                                                        "code": "1070203040442",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸富铒",
                                                        "alias": "碳酸富铒",
                                                        "about": "富铒碳酸盐等",
                                                        "kws": "碳酸富铒",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040442000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸富铒",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1479",
                                                        "linkid": "1436",
                                                        "code": "1070203040443",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸富钇",
                                                        "alias": "碳酸富钇",
                                                        "about": "富钇碳酸盐等",
                                                        "kws": "碳酸富钇",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040443000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸富钇",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1480",
                                                        "linkid": "1436",
                                                        "code": "1070203040444",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸钬铒铥镱镥",
                                                        "alias": "碳酸钬铒铥镱镥",
                                                        "about": "铥镱镥硫酸盐、钬铒铥镱镥碳酸盐、钬镥碳酸盐等",
                                                        "kws": "碳酸钬铒铥镱镥",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040444000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸钬铒铥镱镥",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1481",
                                                        "linkid": "1436",
                                                        "code": "1070203040445",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸钬铒钇",
                                                        "alias": "碳酸钬铒钇",
                                                        "about": "钬铒碳酸盐、钬铒钇碳酸盐等",
                                                        "kws": "碳酸钬铒钇",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040445000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸钬铒钇",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1482",
                                                        "linkid": "1436",
                                                        "code": "1070203040446",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸钇铕",
                                                        "alias": "碳酸钇铕",
                                                        "about": null,
                                                        "kws": "碳酸钇铕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040446000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸钇铕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1483",
                                                        "linkid": "1436",
                                                        "code": "1070203040447",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸钇铽",
                                                        "alias": "碳酸钇铽",
                                                        "about": null,
                                                        "kws": "碳酸钇铽",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040447000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸钇铽",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1484",
                                                        "linkid": "1436",
                                                        "code": "1070203040448",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "碳酸钇镥",
                                                        "alias": "碳酸钇镥",
                                                        "about": null,
                                                        "kws": "碳酸钇镥",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040448000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*碳酸钇镥",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1485",
                                                        "linkid": "1436",
                                                        "code": "1070203040499",
                                                        "paCode": "10702030404",
                                                        "yn": "N",
                                                        "title": "其他碳酸稀土",
                                                        "alias": "其他碳酸稀土",
                                                        "about": null,
                                                        "kws": null,
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040499000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*其他碳酸稀土",
                                                        "children": []
                                                    }
                                                ]
                                            },
                                            {
                                                "id": "1486",
                                                "linkid": "1316",
                                                "code": "10702030405",
                                                "paCode": "107020304",
                                                "yn": "Y",
                                                "title": "硝酸稀土",
                                                "alias": "硝酸稀土",
                                                "about": "包括硝酸铈，硝酸铈铵，其他硝酸稀土化合物。",
                                                "kws": "硝酸铈、硝酸铈铵、硝酸稀土化合物",
                                                "taxName": "稀土冶炼分离产品",
                                                "taxRate": "",
                                                "vip": "7",
                                                "itaxRate": null,
                                                "taxCode": "1070203040500000000",
                                                "taxCodeTitle": "稀土冶炼分离产品",
                                                "iTitle": "*稀土冶炼分离产品*硝酸稀土",
                                                "children": [
                                                    {
                                                        "id": "1487",
                                                        "linkid": "1486",
                                                        "code": "1070203040501",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸镧",
                                                        "alias": "硝酸镧",
                                                        "about": "低钙镧硝酸盐、镧化合物等",
                                                        "kws": "硝酸镧",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040501000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸镧",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1488",
                                                        "linkid": "1486",
                                                        "code": "1070203040502",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸铈",
                                                        "alias": "硝酸铈",
                                                        "about": "铈化合物",
                                                        "kws": "硝酸铈",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040502000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸铈",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1489",
                                                        "linkid": "1486",
                                                        "code": "1070203040503",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸镨",
                                                        "alias": "硝酸镨",
                                                        "about": null,
                                                        "kws": "硝酸镨",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040503000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸镨",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1490",
                                                        "linkid": "1486",
                                                        "code": "1070203040504",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸钕",
                                                        "alias": "硝酸钕",
                                                        "about": null,
                                                        "kws": "硝酸钕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040504000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸钕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1491",
                                                        "linkid": "1486",
                                                        "code": "1070203040505",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸钐",
                                                        "alias": "硝酸钐",
                                                        "about": null,
                                                        "kws": "硝酸钐",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040505000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸钐",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1492",
                                                        "linkid": "1486",
                                                        "code": "1070203040506",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸铕",
                                                        "alias": "硝酸铕",
                                                        "about": null,
                                                        "kws": "硝酸铕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040506000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸铕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1493",
                                                        "linkid": "1486",
                                                        "code": "1070203040507",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸钆",
                                                        "alias": "硝酸钆",
                                                        "about": null,
                                                        "kws": "硝酸钆",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040507000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸钆",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1494",
                                                        "linkid": "1486",
                                                        "code": "1070203040508",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸铽",
                                                        "alias": "硝酸铽",
                                                        "about": null,
                                                        "kws": "硝酸铽",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040508000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸铽",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1495",
                                                        "linkid": "1486",
                                                        "code": "1070203040509",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸镝",
                                                        "alias": "硝酸镝",
                                                        "about": null,
                                                        "kws": "硝酸镝",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040509000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸镝",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1496",
                                                        "linkid": "1486",
                                                        "code": "1070203040510",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸钬",
                                                        "alias": "硝酸钬",
                                                        "about": null,
                                                        "kws": "硝酸钬",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040510000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸钬",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1497",
                                                        "linkid": "1486",
                                                        "code": "1070203040511",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸铒",
                                                        "alias": "硝酸铒",
                                                        "about": null,
                                                        "kws": "硝酸铒",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040511000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸铒",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1498",
                                                        "linkid": "1486",
                                                        "code": "1070203040512",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸铥",
                                                        "alias": "硝酸铥",
                                                        "about": null,
                                                        "kws": "硝酸铥",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040512000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸铥",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1499",
                                                        "linkid": "1486",
                                                        "code": "1070203040513",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸镱",
                                                        "alias": "硝酸镱",
                                                        "about": null,
                                                        "kws": "硝酸镱",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040513000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸镱",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1500",
                                                        "linkid": "1486",
                                                        "code": "1070203040514",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸镥",
                                                        "alias": "硝酸镥",
                                                        "about": null,
                                                        "kws": "硝酸镥",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040514000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸镥",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1501",
                                                        "linkid": "1486",
                                                        "code": "1070203040515",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸钪",
                                                        "alias": "硝酸钪",
                                                        "about": null,
                                                        "kws": "硝酸钪",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040515000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸钪",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1502",
                                                        "linkid": "1486",
                                                        "code": "1070203040516",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸钇",
                                                        "alias": "硝酸钇",
                                                        "about": null,
                                                        "kws": "硝酸钇",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040516000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸钇",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1503",
                                                        "linkid": "1486",
                                                        "code": "1070203040517",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸镧铈",
                                                        "alias": "硝酸镧铈",
                                                        "about": "镧铈硝酸盐等",
                                                        "kws": "硝酸镧铈",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040517000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸镧铈",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1504",
                                                        "linkid": "1486",
                                                        "code": "1070203040518",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸镧铈镨",
                                                        "alias": "硝酸镧铈镨",
                                                        "about": null,
                                                        "kws": "硝酸镧铈镨",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040518000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸镧铈镨",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1505",
                                                        "linkid": "1486",
                                                        "code": "1070203040519",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸镧铈钕",
                                                        "alias": "硝酸镧铈钕",
                                                        "about": null,
                                                        "kws": "硝酸镧铈钕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040519000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸镧铈钕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1506",
                                                        "linkid": "1486",
                                                        "code": "1070203040520",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸镧铈镨钕",
                                                        "alias": "硝酸镧铈镨钕",
                                                        "about": "镧铈镨钕硝酸盐等",
                                                        "kws": "硝酸镧铈镨钕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040520000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸镧铈镨钕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1507",
                                                        "linkid": "1486",
                                                        "code": "1070203040521",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸镧镨钕",
                                                        "alias": "硝酸镧镨钕",
                                                        "about": null,
                                                        "kws": "硝酸镧镨钕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040521000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸镧镨钕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1508",
                                                        "linkid": "1486",
                                                        "code": "1070203040522",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸镧铈铽",
                                                        "alias": "硝酸镧铈铽",
                                                        "about": null,
                                                        "kws": "硝酸镧铈铽",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040522000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸镧铈铽",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1509",
                                                        "linkid": "1486",
                                                        "code": "1070203040523",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸铈铵",
                                                        "alias": "硝酸铈铵",
                                                        "about": null,
                                                        "kws": "硝酸铈铵",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040523000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸铈铵",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1510",
                                                        "linkid": "1486",
                                                        "code": "1070203040524",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸铈铽",
                                                        "alias": "硝酸铈铽",
                                                        "about": null,
                                                        "kws": "硝酸铈铽",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040524000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸铈铽",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1511",
                                                        "linkid": "1486",
                                                        "code": "1070203040525",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸镨钕",
                                                        "alias": "硝酸镨钕",
                                                        "about": "镨钕硝酸盐等",
                                                        "kws": "硝酸镨钕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040525000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸镨钕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1512",
                                                        "linkid": "1486",
                                                        "code": "1070203040526",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸钐钆",
                                                        "alias": "硝酸钐钆",
                                                        "about": "钐钆硝酸盐等",
                                                        "kws": "硝酸钐钆",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040526000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸钐钆",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1513",
                                                        "linkid": "1486",
                                                        "code": "1070203040527",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸钐铕",
                                                        "alias": "硝酸钐铕",
                                                        "about": null,
                                                        "kws": "硝酸钐铕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040527000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸钐铕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1514",
                                                        "linkid": "1486",
                                                        "code": "1070203040528",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸钐铕钆",
                                                        "alias": "硝酸钐铕钆",
                                                        "about": null,
                                                        "kws": "硝酸钐铕钆",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040528000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸钐铕钆",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1515",
                                                        "linkid": "1486",
                                                        "code": "1070203040529",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸铽镝",
                                                        "alias": "硝酸铽镝",
                                                        "about": "铽镝硝酸盐等",
                                                        "kws": "硝酸铽镝",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040529000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸铽镝",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1516",
                                                        "linkid": "1486",
                                                        "code": "1070203040530",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸富镧",
                                                        "alias": "硝酸富镧",
                                                        "about": "富镧硝酸盐等",
                                                        "kws": "硝酸富镧",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040530000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸富镧",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1517",
                                                        "linkid": "1486",
                                                        "code": "1070203040531",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸富铈",
                                                        "alias": "硝酸富铈",
                                                        "about": "富铈硝酸盐等",
                                                        "kws": "硝酸富铈",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040531000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸富铈",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1518",
                                                        "linkid": "1486",
                                                        "code": "1070203040532",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸富镨",
                                                        "alias": "硝酸富镨",
                                                        "about": null,
                                                        "kws": "硝酸富镨",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040532000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸富镨",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1519",
                                                        "linkid": "1486",
                                                        "code": "1070203040533",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸富钕",
                                                        "alias": "硝酸富钕",
                                                        "about": null,
                                                        "kws": "硝酸富钕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040533000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸富钕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1520",
                                                        "linkid": "1486",
                                                        "code": "1070203040534",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸富钐",
                                                        "alias": "硝酸富钐",
                                                        "about": "富钐硝酸盐等",
                                                        "kws": "硝酸富钐",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040534000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸富钐",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1521",
                                                        "linkid": "1486",
                                                        "code": "1070203040535",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸富铕",
                                                        "alias": "硝酸富铕",
                                                        "about": "粗铕硝酸盐等",
                                                        "kws": "硝酸富铕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040535000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸富铕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1522",
                                                        "linkid": "1486",
                                                        "code": "1070203040536",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸富钆",
                                                        "alias": "硝酸富钆",
                                                        "about": "富钆硝酸盐等",
                                                        "kws": "硝酸富钆",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040536000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸富钆",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1523",
                                                        "linkid": "1486",
                                                        "code": "1070203040537",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸富钬",
                                                        "alias": "硝酸富钬",
                                                        "about": "富钬硝酸盐等",
                                                        "kws": "硝酸富钬",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040537000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸富钬",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1524",
                                                        "linkid": "1486",
                                                        "code": "1070203040538",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸富铥",
                                                        "alias": "硝酸富铥",
                                                        "about": "富铥硝酸盐等",
                                                        "kws": "硝酸富铥",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040538000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸富铥",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1525",
                                                        "linkid": "1486",
                                                        "code": "1070203040539",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸富镱",
                                                        "alias": "硝酸富镱",
                                                        "about": "富镱硝酸盐等",
                                                        "kws": "硝酸富镱",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040539000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸富镱",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1526",
                                                        "linkid": "1486",
                                                        "code": "1070203040540",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸富镥",
                                                        "alias": "硝酸富镥",
                                                        "about": "富镥硝酸盐等",
                                                        "kws": "硝酸富镥",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040540000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸富镥",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1527",
                                                        "linkid": "1486",
                                                        "code": "1070203040541",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸富铽",
                                                        "alias": "硝酸富铽",
                                                        "about": "富铽硝酸盐等",
                                                        "kws": "硝酸富铽",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040541000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸富铽",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1528",
                                                        "linkid": "1486",
                                                        "code": "1070203040542",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸富镝",
                                                        "alias": "硝酸富镝",
                                                        "about": "富镝硝酸盐等",
                                                        "kws": "硝酸富镝",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040542000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸富镝",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1529",
                                                        "linkid": "1486",
                                                        "code": "1070203040543",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸富铒",
                                                        "alias": "硝酸富铒",
                                                        "about": "富铒硝酸盐等",
                                                        "kws": "硝酸富铒",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040543000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸富铒",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1530",
                                                        "linkid": "1486",
                                                        "code": "1070203040544",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸富钇",
                                                        "alias": "硝酸富钇",
                                                        "about": "富钇硝酸盐等",
                                                        "kws": "硝酸富钇",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040544000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸富钇",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1531",
                                                        "linkid": "1486",
                                                        "code": "1070203040545",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸钬铒铥镱镥",
                                                        "alias": "硝酸钬铒铥镱镥",
                                                        "about": "铥镱镥硝酸盐、钬铒铥镱镥硝酸盐等",
                                                        "kws": "硝酸钬铒铥镱镥",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040545000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸钬铒铥镱镥",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1532",
                                                        "linkid": "1486",
                                                        "code": "1070203040546",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸钬铒钇",
                                                        "alias": "硝酸钬铒钇",
                                                        "about": "钬铒硝酸稀土、钬铒钇硝酸盐等",
                                                        "kws": "硝酸钬铒钇",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040546000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸钬铒钇",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1533",
                                                        "linkid": "1486",
                                                        "code": "1070203040547",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸钇铕",
                                                        "alias": "硝酸钇铕",
                                                        "about": null,
                                                        "kws": "硝酸钇铕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040547000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸钇铕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1534",
                                                        "linkid": "1486",
                                                        "code": "1070203040548",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸钇铽",
                                                        "alias": "硝酸钇铽",
                                                        "about": null,
                                                        "kws": "硝酸钇铽",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040548000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸钇铽",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1535",
                                                        "linkid": "1486",
                                                        "code": "1070203040549",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "硝酸钇镥",
                                                        "alias": "硝酸钇镥",
                                                        "about": null,
                                                        "kws": "硝酸钇镥",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040549000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硝酸钇镥",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1536",
                                                        "linkid": "1486",
                                                        "code": "1070203040599",
                                                        "paCode": "10702030405",
                                                        "yn": "N",
                                                        "title": "其他硝酸稀土",
                                                        "alias": "其他硝酸稀土",
                                                        "about": null,
                                                        "kws": "硝酸稀土",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040599000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*其他硝酸稀土",
                                                        "children": []
                                                    }
                                                ]
                                            },
                                            {
                                                "id": "1537",
                                                "linkid": "1316",
                                                "code": "10702030406",
                                                "paCode": "107020304",
                                                "yn": "Y",
                                                "title": "醋酸稀土",
                                                "alias": "醋酸稀土",
                                                "about": null,
                                                "kws": "醋酸稀土",
                                                "taxName": "稀土冶炼分离产品",
                                                "taxRate": "",
                                                "vip": "7",
                                                "itaxRate": null,
                                                "taxCode": "1070203040600000000",
                                                "taxCodeTitle": "稀土冶炼分离产品",
                                                "iTitle": "*稀土冶炼分离产品*醋酸稀土",
                                                "children": [
                                                    {
                                                        "id": "1538",
                                                        "linkid": "1537",
                                                        "code": "1070203040601",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸镧",
                                                        "alias": "醋酸镧",
                                                        "about": "镧化合物",
                                                        "kws": "醋酸镧",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040601000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸镧",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1539",
                                                        "linkid": "1537",
                                                        "code": "1070203040602",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸铈",
                                                        "alias": "醋酸铈",
                                                        "about": "铈化合物",
                                                        "kws": "醋酸铈",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040602000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸铈",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1540",
                                                        "linkid": "1537",
                                                        "code": "1070203040603",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸镨",
                                                        "alias": "醋酸镨",
                                                        "about": null,
                                                        "kws": "醋酸镨",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040603000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸镨",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1541",
                                                        "linkid": "1537",
                                                        "code": "1070203040604",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸钕",
                                                        "alias": "醋酸钕",
                                                        "about": null,
                                                        "kws": "醋酸钕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040604000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸钕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1542",
                                                        "linkid": "1537",
                                                        "code": "1070203040605",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸钐",
                                                        "alias": "醋酸钐",
                                                        "about": null,
                                                        "kws": "醋酸钐",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040605000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸钐",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1543",
                                                        "linkid": "1537",
                                                        "code": "1070203040606",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸铕",
                                                        "alias": "醋酸铕",
                                                        "about": null,
                                                        "kws": "醋酸铕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040606000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸铕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1544",
                                                        "linkid": "1537",
                                                        "code": "1070203040607",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸钆",
                                                        "alias": "醋酸钆",
                                                        "about": null,
                                                        "kws": "醋酸钆",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040607000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸钆",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1545",
                                                        "linkid": "1537",
                                                        "code": "1070203040608",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸铽",
                                                        "alias": "醋酸铽",
                                                        "about": null,
                                                        "kws": "醋酸铽",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040608000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸铽",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1546",
                                                        "linkid": "1537",
                                                        "code": "1070203040609",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸镝",
                                                        "alias": "醋酸镝",
                                                        "about": null,
                                                        "kws": "醋酸镝",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040609000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸镝",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1547",
                                                        "linkid": "1537",
                                                        "code": "1070203040610",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸钬",
                                                        "alias": "醋酸钬",
                                                        "about": null,
                                                        "kws": "醋酸钬",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040610000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸钬",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1548",
                                                        "linkid": "1537",
                                                        "code": "1070203040611",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸铒",
                                                        "alias": "醋酸铒",
                                                        "about": null,
                                                        "kws": "醋酸铒",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040611000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸铒",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1549",
                                                        "linkid": "1537",
                                                        "code": "1070203040612",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸铥",
                                                        "alias": "醋酸铥",
                                                        "about": null,
                                                        "kws": "醋酸铥",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040612000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸铥",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1550",
                                                        "linkid": "1537",
                                                        "code": "1070203040613",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸镱",
                                                        "alias": "醋酸镱",
                                                        "about": null,
                                                        "kws": "醋酸镱",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040613000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸镱",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1551",
                                                        "linkid": "1537",
                                                        "code": "1070203040614",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸镥",
                                                        "alias": "醋酸镥",
                                                        "about": null,
                                                        "kws": "醋酸镥",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040614000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸镥",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1552",
                                                        "linkid": "1537",
                                                        "code": "1070203040615",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸钪",
                                                        "alias": "醋酸钪",
                                                        "about": null,
                                                        "kws": "醋酸钪",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040615000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸钪",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1553",
                                                        "linkid": "1537",
                                                        "code": "1070203040616",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸钇",
                                                        "alias": "醋酸钇",
                                                        "about": null,
                                                        "kws": "醋酸钇",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040616000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸钇",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1554",
                                                        "linkid": "1537",
                                                        "code": "1070203040617",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸镧铈",
                                                        "alias": "醋酸镧铈",
                                                        "about": null,
                                                        "kws": "醋酸镧铈",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040617000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸镧铈",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1555",
                                                        "linkid": "1537",
                                                        "code": "1070203040618",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸镧铈镨",
                                                        "alias": "醋酸镧铈镨",
                                                        "about": null,
                                                        "kws": "醋酸镧铈镨",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040618000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸镧铈镨",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1556",
                                                        "linkid": "1537",
                                                        "code": "1070203040619",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸镧铈钕",
                                                        "alias": "醋酸镧铈钕",
                                                        "about": null,
                                                        "kws": "醋酸镧铈钕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040619000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸镧铈钕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1557",
                                                        "linkid": "1537",
                                                        "code": "1070203040620",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸镧铈镨钕",
                                                        "alias": "醋酸镧铈镨钕",
                                                        "about": null,
                                                        "kws": "醋酸镧铈镨钕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040620000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸镧铈镨钕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1558",
                                                        "linkid": "1537",
                                                        "code": "1070203040621",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸镧镨钕",
                                                        "alias": "醋酸镧镨钕",
                                                        "about": null,
                                                        "kws": "醋酸镧镨钕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040621000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸镧镨钕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1559",
                                                        "linkid": "1537",
                                                        "code": "1070203040622",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸镧铈铽",
                                                        "alias": "醋酸镧铈铽",
                                                        "about": null,
                                                        "kws": "醋酸镧铈铽",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040622000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸镧铈铽",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1560",
                                                        "linkid": "1537",
                                                        "code": "1070203040623",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸铈铽",
                                                        "alias": "醋酸铈铽",
                                                        "about": null,
                                                        "kws": "醋酸铈铽",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040623000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸铈铽",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1561",
                                                        "linkid": "1537",
                                                        "code": "1070203040624",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸镨钕",
                                                        "alias": "醋酸镨钕",
                                                        "about": null,
                                                        "kws": "醋酸镨钕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040624000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸镨钕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1562",
                                                        "linkid": "1537",
                                                        "code": "1070203040625",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸钐钆",
                                                        "alias": "醋酸钐钆",
                                                        "about": null,
                                                        "kws": "醋酸钐钆",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040625000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸钐钆",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1563",
                                                        "linkid": "1537",
                                                        "code": "1070203040626",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸钐铕",
                                                        "alias": "醋酸钐铕",
                                                        "about": null,
                                                        "kws": "醋酸钐铕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040626000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸钐铕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1564",
                                                        "linkid": "1537",
                                                        "code": "1070203040627",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸钐铕钆",
                                                        "alias": "醋酸钐铕钆",
                                                        "about": null,
                                                        "kws": "醋酸钐铕钆",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040627000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸钐铕钆",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1565",
                                                        "linkid": "1537",
                                                        "code": "1070203040628",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸铽镝",
                                                        "alias": "醋酸铽镝",
                                                        "about": null,
                                                        "kws": "醋酸铽镝",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040628000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸铽镝",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1566",
                                                        "linkid": "1537",
                                                        "code": "1070203040629",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸富镧",
                                                        "alias": "醋酸富镧",
                                                        "about": null,
                                                        "kws": "醋酸富镧",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040629000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸富镧",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1567",
                                                        "linkid": "1537",
                                                        "code": "1070203040630",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸富铈",
                                                        "alias": "醋酸富铈",
                                                        "about": null,
                                                        "kws": "醋酸富铈",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040630000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸富铈",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1568",
                                                        "linkid": "1537",
                                                        "code": "1070203040631",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸富镨",
                                                        "alias": "醋酸富镨",
                                                        "about": null,
                                                        "kws": "醋酸富镨",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040631000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸富镨",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1569",
                                                        "linkid": "1537",
                                                        "code": "1070203040632",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸富钕",
                                                        "alias": "醋酸富钕",
                                                        "about": null,
                                                        "kws": "醋酸富钕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040632000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸富钕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1570",
                                                        "linkid": "1537",
                                                        "code": "1070203040633",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸富钐",
                                                        "alias": "醋酸富钐",
                                                        "about": null,
                                                        "kws": "醋酸富钐",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040633000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸富钐",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1571",
                                                        "linkid": "1537",
                                                        "code": "1070203040634",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸富铕",
                                                        "alias": "醋酸富铕",
                                                        "about": "粗铕醋酸盐等",
                                                        "kws": "醋酸富铕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040634000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸富铕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1572",
                                                        "linkid": "1537",
                                                        "code": "1070203040635",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸富钆",
                                                        "alias": "醋酸富钆",
                                                        "about": null,
                                                        "kws": "醋酸富钆",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040635000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸富钆",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1573",
                                                        "linkid": "1537",
                                                        "code": "1070203040636",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸富钬",
                                                        "alias": "醋酸富钬",
                                                        "about": null,
                                                        "kws": "醋酸富钬",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040636000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸富钬",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1574",
                                                        "linkid": "1537",
                                                        "code": "1070203040637",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸富铥",
                                                        "alias": "醋酸富铥",
                                                        "about": null,
                                                        "kws": "醋酸富铥",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040637000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸富铥",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1575",
                                                        "linkid": "1537",
                                                        "code": "1070203040638",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸富镱",
                                                        "alias": "醋酸富镱",
                                                        "about": null,
                                                        "kws": "醋酸富镱",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040638000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸富镱",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1576",
                                                        "linkid": "1537",
                                                        "code": "1070203040639",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸富镥",
                                                        "alias": "醋酸富镥",
                                                        "about": null,
                                                        "kws": "醋酸富镥",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040639000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸富镥",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1577",
                                                        "linkid": "1537",
                                                        "code": "1070203040640",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸富铽",
                                                        "alias": "醋酸富铽",
                                                        "about": null,
                                                        "kws": "醋酸富铽",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040640000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸富铽",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1578",
                                                        "linkid": "1537",
                                                        "code": "1070203040641",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸富镝",
                                                        "alias": "醋酸富镝",
                                                        "about": null,
                                                        "kws": "醋酸富镝",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040641000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸富镝",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1579",
                                                        "linkid": "1537",
                                                        "code": "1070203040642",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸富铒",
                                                        "alias": "醋酸富铒",
                                                        "about": null,
                                                        "kws": "醋酸富铒",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040642000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸富铒",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1580",
                                                        "linkid": "1537",
                                                        "code": "1070203040643",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸富钇",
                                                        "alias": "醋酸富钇",
                                                        "about": null,
                                                        "kws": "醋酸富钇",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040643000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸富钇",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1581",
                                                        "linkid": "1537",
                                                        "code": "1070203040644",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸钬铒铥镱镥",
                                                        "alias": "醋酸钬铒铥镱镥",
                                                        "about": null,
                                                        "kws": "醋酸钬铒铥镱镥",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040644000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸钬铒铥镱镥",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1582",
                                                        "linkid": "1537",
                                                        "code": "1070203040645",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸钬铒钇",
                                                        "alias": "醋酸钬铒钇",
                                                        "about": null,
                                                        "kws": "醋酸钬铒钇",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040645000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸钬铒钇",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1583",
                                                        "linkid": "1537",
                                                        "code": "1070203040646",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸钇铕",
                                                        "alias": "醋酸钇铕",
                                                        "about": null,
                                                        "kws": "醋酸钇铕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040646000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸钇铕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1584",
                                                        "linkid": "1537",
                                                        "code": "1070203040647",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸钇铽",
                                                        "alias": "醋酸钇铽",
                                                        "about": null,
                                                        "kws": "醋酸钇铽",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040647000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸钇铽",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1585",
                                                        "linkid": "1537",
                                                        "code": "1070203040648",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "醋酸钇镥",
                                                        "alias": "醋酸钇镥",
                                                        "about": null,
                                                        "kws": "醋酸钇镥",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040648000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*醋酸钇镥",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1586",
                                                        "linkid": "1537",
                                                        "code": "1070203040699",
                                                        "paCode": "10702030406",
                                                        "yn": "N",
                                                        "title": "其他醋酸稀土",
                                                        "alias": "其他醋酸稀土",
                                                        "about": null,
                                                        "kws": "醋酸稀土",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040699000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*其他醋酸稀土",
                                                        "children": []
                                                    }
                                                ]
                                            },
                                            {
                                                "id": "1587",
                                                "linkid": "1316",
                                                "code": "10702030407",
                                                "paCode": "107020304",
                                                "yn": "Y",
                                                "title": "草酸稀土",
                                                "alias": "草酸稀土",
                                                "about": null,
                                                "kws": "草酸稀土",
                                                "taxName": "稀土冶炼分离产品",
                                                "taxRate": "",
                                                "vip": "7",
                                                "itaxRate": null,
                                                "taxCode": "1070203040700000000",
                                                "taxCodeTitle": "稀土冶炼分离产品",
                                                "iTitle": "*稀土冶炼分离产品*草酸稀土",
                                                "children": [
                                                    {
                                                        "id": "1588",
                                                        "linkid": "1587",
                                                        "code": "1070203040701",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸镧",
                                                        "alias": "草酸镧",
                                                        "about": "包括低钙草酸镧、低钙镧草酸盐、镧化合物等",
                                                        "kws": "草酸镧",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040701000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸镧",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1589",
                                                        "linkid": "1587",
                                                        "code": "1070203040702",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸铈",
                                                        "alias": "草酸铈",
                                                        "about": "指铈化合物",
                                                        "kws": "草酸铈",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040702000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸铈",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1590",
                                                        "linkid": "1587",
                                                        "code": "1070203040703",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸镨",
                                                        "alias": "草酸镨",
                                                        "about": null,
                                                        "kws": "草酸镨",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040703000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸镨",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1591",
                                                        "linkid": "1587",
                                                        "code": "1070203040704",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸钕",
                                                        "alias": "草酸钕",
                                                        "about": null,
                                                        "kws": "草酸钕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040704000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸钕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1592",
                                                        "linkid": "1587",
                                                        "code": "1070203040705",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸钐",
                                                        "alias": "草酸钐",
                                                        "about": null,
                                                        "kws": "草酸钐",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040705000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸钐",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1593",
                                                        "linkid": "1587",
                                                        "code": "1070203040706",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸铕",
                                                        "alias": "草酸铕",
                                                        "about": null,
                                                        "kws": "草酸铕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040706000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸铕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1594",
                                                        "linkid": "1587",
                                                        "code": "1070203040707",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸钆",
                                                        "alias": "草酸钆",
                                                        "about": null,
                                                        "kws": "草酸钆",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040707000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸钆",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1595",
                                                        "linkid": "1587",
                                                        "code": "1070203040708",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸铽",
                                                        "alias": "草酸铽",
                                                        "about": null,
                                                        "kws": "草酸铽",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040708000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸铽",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1596",
                                                        "linkid": "1587",
                                                        "code": "1070203040709",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸镝",
                                                        "alias": "草酸镝",
                                                        "about": null,
                                                        "kws": "草酸镝",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040709000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸镝",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1597",
                                                        "linkid": "1587",
                                                        "code": "1070203040710",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸钬",
                                                        "alias": "草酸钬",
                                                        "about": null,
                                                        "kws": "草酸钬",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040710000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸钬",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1598",
                                                        "linkid": "1587",
                                                        "code": "1070203040711",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸铒",
                                                        "alias": "草酸铒",
                                                        "about": null,
                                                        "kws": "草酸铒",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040711000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸铒",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1599",
                                                        "linkid": "1587",
                                                        "code": "1070203040712",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸铥",
                                                        "alias": "草酸铥",
                                                        "about": null,
                                                        "kws": "草酸铥",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040712000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸铥",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1600",
                                                        "linkid": "1587",
                                                        "code": "1070203040713",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸镱",
                                                        "alias": "草酸镱",
                                                        "about": null,
                                                        "kws": "草酸镱",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040713000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸镱",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1601",
                                                        "linkid": "1587",
                                                        "code": "1070203040714",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸镥",
                                                        "alias": "草酸镥",
                                                        "about": null,
                                                        "kws": "草酸镥",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040714000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸镥",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1602",
                                                        "linkid": "1587",
                                                        "code": "1070203040715",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸钪",
                                                        "alias": "草酸钪",
                                                        "about": null,
                                                        "kws": "草酸钪",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040715000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸钪",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1603",
                                                        "linkid": "1587",
                                                        "code": "1070203040716",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸钇",
                                                        "alias": "草酸钇",
                                                        "about": null,
                                                        "kws": "草酸钇",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040716000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸钇",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1604",
                                                        "linkid": "1587",
                                                        "code": "1070203040717",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸镧铈",
                                                        "alias": "草酸镧铈",
                                                        "about": "包括镧铈草酸盐等",
                                                        "kws": "草酸镧铈、镧铈草酸盐",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040717000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸镧铈",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1605",
                                                        "linkid": "1587",
                                                        "code": "1070203040718",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸镧铈镨",
                                                        "alias": "草酸镧铈镨",
                                                        "about": "包括镧铈镨草酸盐、少钕草酸稀土等",
                                                        "kws": "草酸镧铈镨、少钕草酸稀土",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040718000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸镧铈镨",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1606",
                                                        "linkid": "1587",
                                                        "code": "1070203040719",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸镧铈钕",
                                                        "alias": "草酸镧铈钕",
                                                        "about": null,
                                                        "kws": "草酸镧铈钕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040719000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸镧铈钕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1607",
                                                        "linkid": "1587",
                                                        "code": "1070203040720",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸镧铈镨钕",
                                                        "alias": "草酸镧铈镨钕",
                                                        "about": "包括镧铈镨钕草酸盐等",
                                                        "kws": "草酸镧铈镨钕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040720000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸镧铈镨钕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1608",
                                                        "linkid": "1587",
                                                        "code": "1070203040721",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸镧镨钕",
                                                        "alias": "草酸镧镨钕",
                                                        "about": "包括镧钕草酸盐、镧镨钕草酸盐等",
                                                        "kws": "草酸镧镨钕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040721000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸镧镨钕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1609",
                                                        "linkid": "1587",
                                                        "code": "1070203040722",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸镧铈铽",
                                                        "alias": "草酸镧铈铽",
                                                        "about": null,
                                                        "kws": "草酸镧铈铽",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040722000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸镧铈铽",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1610",
                                                        "linkid": "1587",
                                                        "code": "1070203040723",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸铈铽",
                                                        "alias": "草酸铈铽",
                                                        "about": "铈铽草酸盐等",
                                                        "kws": "铈铽草酸盐、草酸铈铽",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040723000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸铈铽",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1611",
                                                        "linkid": "1587",
                                                        "code": "1070203040724",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸镨钕",
                                                        "alias": "草酸镨钕",
                                                        "about": "镨钕草酸盐等",
                                                        "kws": "镨钕草酸盐、草酸镨钕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040724000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸镨钕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1612",
                                                        "linkid": "1587",
                                                        "code": "1070203040725",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸钐钆",
                                                        "alias": "草酸钐钆",
                                                        "about": "钐钆草酸盐等",
                                                        "kws": "草酸钐钆",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040725000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸钐钆",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1613",
                                                        "linkid": "1587",
                                                        "code": "1070203040726",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸钐铕",
                                                        "alias": "草酸钐铕",
                                                        "about": "钐铕草酸盐等",
                                                        "kws": "钐铕草酸盐、草酸钐铕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040726000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸钐铕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1614",
                                                        "linkid": "1587",
                                                        "code": "1070203040727",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸钐铕钆",
                                                        "alias": "草酸钐铕钆",
                                                        "about": "钐铕钆草酸盐等",
                                                        "kws": "钐铕钆草酸盐、草酸钐铕钆",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040727000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸钐铕钆",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1615",
                                                        "linkid": "1587",
                                                        "code": "1070203040728",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸铽镝",
                                                        "alias": "草酸铽镝",
                                                        "about": "铽镝草酸盐等",
                                                        "kws": "铽镝草酸盐、草酸铽镝",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040728000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸铽镝",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1616",
                                                        "linkid": "1587",
                                                        "code": "1070203040729",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸富镧",
                                                        "alias": "草酸富镧",
                                                        "about": "富镧草酸盐等",
                                                        "kws": "富镧草酸盐、草酸富镧",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040729000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸富镧",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1617",
                                                        "linkid": "1587",
                                                        "code": "1070203040730",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸富铈",
                                                        "alias": "草酸富铈",
                                                        "about": "富铈草酸盐等",
                                                        "kws": "富铈草酸盐、草酸富铈",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040730000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸富铈",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1618",
                                                        "linkid": "1587",
                                                        "code": "1070203040731",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸富镨",
                                                        "alias": "草酸富镨",
                                                        "about": null,
                                                        "kws": "草酸富镨",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040731000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸富镨",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1619",
                                                        "linkid": "1587",
                                                        "code": "1070203040732",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸富钕",
                                                        "alias": "草酸富钕",
                                                        "about": null,
                                                        "kws": "草酸富钕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040732000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸富钕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1620",
                                                        "linkid": "1587",
                                                        "code": "1070203040733",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸富钐",
                                                        "alias": "草酸富钐",
                                                        "about": "富钐草酸盐等",
                                                        "kws": "草酸富钐",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040733000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸富钐",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1621",
                                                        "linkid": "1587",
                                                        "code": "1070203040734",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸富铕",
                                                        "alias": "草酸富铕",
                                                        "about": "粗铕、富铕草酸盐等",
                                                        "kws": "粗铕草酸盐、富钐草酸盐、草酸富铕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040734000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸富铕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1622",
                                                        "linkid": "1587",
                                                        "code": "1070203040735",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸富钆",
                                                        "alias": "草酸富钆",
                                                        "about": "富钆草酸盐等",
                                                        "kws": "富钆草酸盐、草酸富钆",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040735000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸富钆",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1623",
                                                        "linkid": "1587",
                                                        "code": "1070203040736",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸富钬",
                                                        "alias": "草酸富钬",
                                                        "about": "富钬草酸盐等",
                                                        "kws": "富钬草酸盐、草酸富钬",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040736000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸富钬",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1624",
                                                        "linkid": "1587",
                                                        "code": "1070203040737",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸富铥",
                                                        "alias": "草酸富铥",
                                                        "about": "富铥草酸盐等",
                                                        "kws": "富铥草酸盐、草酸富铥",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040737000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸富铥",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1625",
                                                        "linkid": "1587",
                                                        "code": "1070203040738",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸富镱",
                                                        "alias": "草酸富镱",
                                                        "about": "富镱草酸盐等",
                                                        "kws": "富镱草酸盐、草酸富镱",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040738000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸富镱",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1626",
                                                        "linkid": "1587",
                                                        "code": "1070203040739",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸富镥",
                                                        "alias": "草酸富镥",
                                                        "about": "富镥草酸盐等",
                                                        "kws": "富镥草酸盐、草酸富镥",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040739000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸富镥",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1627",
                                                        "linkid": "1587",
                                                        "code": "1070203040740",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸富铽",
                                                        "alias": "草酸富铽",
                                                        "about": "富铽草酸盐等",
                                                        "kws": "富铽草酸盐、草酸富铽",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040740000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸富铽",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1628",
                                                        "linkid": "1587",
                                                        "code": "1070203040741",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸富镝",
                                                        "alias": "草酸富镝",
                                                        "about": "富镝草酸盐等",
                                                        "kws": "富镝草酸盐、草酸富镝",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040741000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸富镝",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1629",
                                                        "linkid": "1587",
                                                        "code": "1070203040742",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸富铒",
                                                        "alias": "草酸富铒",
                                                        "about": "富铒草酸盐等",
                                                        "kws": "富铒草酸盐、草酸富铒",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040742000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸富铒",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1630",
                                                        "linkid": "1587",
                                                        "code": "1070203040743",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸富钇",
                                                        "alias": "草酸富钇",
                                                        "about": "富钇草酸盐等",
                                                        "kws": "富钇草酸盐、草酸富钇",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040743000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸富钇",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1631",
                                                        "linkid": "1587",
                                                        "code": "1070203040744",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸钬铒铥镱镥",
                                                        "alias": "草酸钬铒铥镱镥",
                                                        "about": "铥镱镥草酸盐、钬铒铥镱镥草酸盐、钬镥草酸盐等",
                                                        "kws": "铥镱镥草酸盐、钬铒铥镱镥草酸盐、钬镥草酸盐、草酸钬铒铥镱镥",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040744000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸钬铒铥镱镥",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1632",
                                                        "linkid": "1587",
                                                        "code": "1070203040745",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸钬铒钇",
                                                        "alias": "草酸钬铒钇",
                                                        "about": "钬铒草酸盐、钬铒钇草酸盐等",
                                                        "kws": "草酸钬铒钇",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040745000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸钬铒钇",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1633",
                                                        "linkid": "1587",
                                                        "code": "1070203040746",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸钇铕",
                                                        "alias": "草酸钇铕",
                                                        "about": null,
                                                        "kws": "草酸钇铕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040746000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸钇铕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1634",
                                                        "linkid": "1587",
                                                        "code": "1070203040747",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸钇铽",
                                                        "alias": "草酸钇铽",
                                                        "about": null,
                                                        "kws": "草酸钇铽",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040747000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸钇铽",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1635",
                                                        "linkid": "1587",
                                                        "code": "1070203040748",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "草酸钇镥",
                                                        "alias": "草酸钇镥",
                                                        "about": null,
                                                        "kws": "草酸钇镥",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040748000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*草酸钇镥",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1636",
                                                        "linkid": "1587",
                                                        "code": "1070203040799",
                                                        "paCode": "10702030407",
                                                        "yn": "N",
                                                        "title": "其他草酸稀土",
                                                        "alias": "其他草酸稀土",
                                                        "about": null,
                                                        "kws": null,
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040799000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*其他草酸稀土",
                                                        "children": []
                                                    }
                                                ]
                                            },
                                            {
                                                "id": "1637",
                                                "linkid": "1316",
                                                "code": "10702030408",
                                                "paCode": "107020304",
                                                "yn": "Y",
                                                "title": "氢氧化稀土",
                                                "alias": "氢氧化稀土",
                                                "about": null,
                                                "kws": "氢氧化稀土",
                                                "taxName": "稀土冶炼分离产品",
                                                "taxRate": "",
                                                "vip": "7",
                                                "itaxRate": null,
                                                "taxCode": "1070203040800000000",
                                                "taxCodeTitle": "稀土冶炼分离产品",
                                                "iTitle": "*稀土冶炼分离产品*氢氧化稀土",
                                                "children": [
                                                    {
                                                        "id": "1638",
                                                        "linkid": "1637",
                                                        "code": "1070203040801",
                                                        "paCode": "10702030408",
                                                        "yn": "N",
                                                        "title": "氢氧化镧",
                                                        "alias": "氢氧化镧",
                                                        "about": "镧化合物",
                                                        "kws": "氢氧化镧",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040801000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氢氧化镧",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1639",
                                                        "linkid": "1637",
                                                        "code": "1070203040802",
                                                        "paCode": "10702030408",
                                                        "yn": "N",
                                                        "title": "氢氧化铈",
                                                        "alias": "氢氧化铈",
                                                        "about": "铈化合物",
                                                        "kws": "氢氧化铈",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040802000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氢氧化铈",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1640",
                                                        "linkid": "1637",
                                                        "code": "1070203040803",
                                                        "paCode": "10702030408",
                                                        "yn": "N",
                                                        "title": "氢氧化镨",
                                                        "alias": "氢氧化镨",
                                                        "about": null,
                                                        "kws": "氢氧化镨",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040803000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氢氧化镨",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1641",
                                                        "linkid": "1637",
                                                        "code": "1070203040804",
                                                        "paCode": "10702030408",
                                                        "yn": "N",
                                                        "title": "氢氧化钕",
                                                        "alias": "氢氧化钕",
                                                        "about": null,
                                                        "kws": "氢氧化钕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040804000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氢氧化钕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1642",
                                                        "linkid": "1637",
                                                        "code": "1070203040805",
                                                        "paCode": "10702030408",
                                                        "yn": "N",
                                                        "title": "氢氧化钐",
                                                        "alias": "氢氧化钐",
                                                        "about": null,
                                                        "kws": "氢氧化钐",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040805000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氢氧化钐",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1643",
                                                        "linkid": "1637",
                                                        "code": "1070203040806",
                                                        "paCode": "10702030408",
                                                        "yn": "N",
                                                        "title": "氢氧化铕",
                                                        "alias": "氢氧化铕",
                                                        "about": null,
                                                        "kws": "氢氧化铕",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040806000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氢氧化铕",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1644",
                                                        "linkid": "1637",
                                                        "code": "1070203040807",
                                                        "paCode": "10702030408",
                                                        "yn": "N",
                                                        "title": "氢氧化钆",
                                                        "alias": "氢氧化钆",
                                                        "about": null,
                                                        "kws": "氢氧化钆",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040807000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氢氧化钆",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1645",
                                                        "linkid": "1637",
                                                        "code": "1070203040808",
                                                        "paCode": "10702030408",
                                                        "yn": "N",
                                                        "title": "氢氧化铽",
                                                        "alias": "氢氧化铽",
                                                        "about": null,
                                                        "kws": "氢氧化铽",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040808000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氢氧化铽",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1646",
                                                        "linkid": "1637",
                                                        "code": "1070203040809",
                                                        "paCode": "10702030408",
                                                        "yn": "N",
                                                        "title": "氢氧化镝",
                                                        "alias": "氢氧化镝",
                                                        "about": null,
                                                        "kws": "氢氧化镝",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040809000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氢氧化镝",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1647",
                                                        "linkid": "1637",
                                                        "code": "1070203040810",
                                                        "paCode": "10702030408",
                                                        "yn": "N",
                                                        "title": "氢氧化钬",
                                                        "alias": "氢氧化钬",
                                                        "about": null,
                                                        "kws": "氢氧化钬",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040810000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氢氧化钬",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1648",
                                                        "linkid": "1637",
                                                        "code": "1070203040811",
                                                        "paCode": "10702030408",
                                                        "yn": "N",
                                                        "title": "氢氧化铒",
                                                        "alias": "氢氧化铒",
                                                        "about": null,
                                                        "kws": "氢氧化铒",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040811000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氢氧化铒",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1649",
                                                        "linkid": "1637",
                                                        "code": "1070203040812",
                                                        "paCode": "10702030408",
                                                        "yn": "N",
                                                        "title": "氢氧化铥",
                                                        "alias": "氢氧化铥",
                                                        "about": null,
                                                        "kws": "氢氧化铥",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040812000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氢氧化铥",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1650",
                                                        "linkid": "1637",
                                                        "code": "1070203040813",
                                                        "paCode": "10702030408",
                                                        "yn": "N",
                                                        "title": "氢氧化镱",
                                                        "alias": "氢氧化镱",
                                                        "about": null,
                                                        "kws": "氢氧化镱",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040813000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氢氧化镱",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1651",
                                                        "linkid": "1637",
                                                        "code": "1070203040814",
                                                        "paCode": "10702030408",
                                                        "yn": "N",
                                                        "title": "氢氧化镥",
                                                        "alias": "氢氧化镥",
                                                        "about": null,
                                                        "kws": "氢氧化镥",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040814000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氢氧化镥",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1652",
                                                        "linkid": "1637",
                                                        "code": "1070203040815",
                                                        "paCode": "10702030408",
                                                        "yn": "N",
                                                        "title": "氢氧化钪",
                                                        "alias": "氢氧化钪",
                                                        "about": null,
                                                        "kws": "氢氧化钪",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040815000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氢氧化钪",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1653",
                                                        "linkid": "1637",
                                                        "code": "1070203040816",
                                                        "paCode": "10702030408",
                                                        "yn": "N",
                                                        "title": "氢氧化钇",
                                                        "alias": "氢氧化钇",
                                                        "about": null,
                                                        "kws": "氢氧化钇",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040816000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*氢氧化钇",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1654",
                                                        "linkid": "1637",
                                                        "code": "1070203040899",
                                                        "paCode": "10702030408",
                                                        "yn": "N",
                                                        "title": "其他氢氧化稀土",
                                                        "alias": "其他氢氧化稀土",
                                                        "about": null,
                                                        "kws": null,
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203040899000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*其他氢氧化稀土",
                                                        "children": []
                                                    }
                                                ]
                                            },
                                            {
                                                "id": "1655",
                                                "linkid": "1316",
                                                "code": "10702030499",
                                                "paCode": "107020304",
                                                "yn": "Y",
                                                "title": "其他稀土化合物",
                                                "alias": "其他稀土化合物",
                                                "about": null,
                                                "kws": null,
                                                "taxName": "稀土冶炼分离产品",
                                                "taxRate": "",
                                                "vip": "7",
                                                "itaxRate": null,
                                                "taxCode": "1070203049900000000",
                                                "taxCodeTitle": "稀土冶炼分离产品",
                                                "iTitle": "*稀土冶炼分离产品*其他稀土化合物",
                                                "children": [
                                                    {
                                                        "id": "1656",
                                                        "linkid": "1655",
                                                        "code": "1070203049901",
                                                        "paCode": "10702030499",
                                                        "yn": "N",
                                                        "title": "硫酸稀土",
                                                        "alias": "硫酸稀土",
                                                        "about": "包括低钙镧硫酸盐、富镝硫酸盐、富铒硫酸盐、富镧硫酸盐、富钐硫酸盐、富铈硫酸盐、富铽硫酸盐、富钇硫酸盐、钬铒铥镱镥硫酸盐、钬铒钇硫酸盐、镧铈硫酸盐、镧铈镨钕硫酸盐、镨钕硫酸盐、钐钆硫酸盐、铽镝硫酸盐、液体硫酸稀土、其他硫酸盐等",
                                                        "kws": "硫酸稀土、低钙镧硫酸盐、富镝硫酸盐、富铒硫酸盐、富镧硫酸盐、富钐硫酸盐、富铈硫酸盐、富铽硫酸盐、富钇硫酸盐、钬铒铥镱镥硫酸盐、钬铒钇硫酸盐、镧铈硫酸盐、镧铈镨钕硫酸盐、镨钕硫酸盐、钐钆硫酸盐、铽镝硫酸盐、液体硫酸稀土",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203049901000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*硫酸稀土",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1657",
                                                        "linkid": "1655",
                                                        "code": "1070203049902",
                                                        "paCode": "10702030499",
                                                        "yn": "N",
                                                        "title": "磷酸镧铈铽稀土",
                                                        "alias": "磷酸镧铈铽稀土",
                                                        "about": "镧铈铽磷酸盐等",
                                                        "kws": "磷酸镧铈铽稀土、镧铈铽磷酸盐",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203049902000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*磷酸镧铈铽稀土",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1658",
                                                        "linkid": "1655",
                                                        "code": "1070203049903",
                                                        "paCode": "10702030499",
                                                        "yn": "N",
                                                        "title": "磷酸铈铽稀土",
                                                        "alias": "磷酸铈铽稀土",
                                                        "about": null,
                                                        "kws": "磷酸铈铽稀土",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203049903000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*磷酸铈铽稀土",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1659",
                                                        "linkid": "1655",
                                                        "code": "1070203049904",
                                                        "paCode": "10702030499",
                                                        "yn": "N",
                                                        "title": "其他磷酸稀土",
                                                        "alias": "其他磷酸稀土",
                                                        "about": "包括磷酸镧、磷酸钕、磷酸镨、磷酸镨钕、磷酸铈、铈铽铕磷酸盐系、其他磷酸盐等",
                                                        "kws": "磷酸镧、磷酸钕、磷酸镨、磷酸镨钕、磷酸铈、铈铽铕磷酸盐",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203049904000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*其他磷酸稀土",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1660",
                                                        "linkid": "1655",
                                                        "code": "1070203049905",
                                                        "paCode": "10702030499",
                                                        "yn": "N",
                                                        "title": "柠檬酸镧稀土",
                                                        "alias": "柠檬酸镧稀土",
                                                        "about": null,
                                                        "kws": "柠檬酸镧稀土",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203049905000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*柠檬酸镧稀土",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1661",
                                                        "linkid": "1655",
                                                        "code": "1070203049906",
                                                        "paCode": "10702030499",
                                                        "yn": "N",
                                                        "title": "柠檬酸铈稀土",
                                                        "alias": "柠檬酸铈稀土",
                                                        "about": null,
                                                        "kws": "柠檬酸铈稀土",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203049906000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*柠檬酸铈稀土",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1662",
                                                        "linkid": "1655",
                                                        "code": "1070203049907",
                                                        "paCode": "10702030499",
                                                        "yn": "N",
                                                        "title": "其他柠檬酸稀土",
                                                        "alias": "其他柠檬酸稀土",
                                                        "about": null,
                                                        "kws": null,
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203049907000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*其他柠檬酸稀土",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1663",
                                                        "linkid": "1655",
                                                        "code": "1070203049908",
                                                        "paCode": "10702030499",
                                                        "yn": "N",
                                                        "title": "铈锆氧化物",
                                                        "alias": "铈锆氧化物",
                                                        "about": null,
                                                        "kws": "铈锆氧化物",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203049908000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*铈锆氧化物",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1664",
                                                        "linkid": "1655",
                                                        "code": "1070203049909",
                                                        "paCode": "10702030499",
                                                        "yn": "N",
                                                        "title": "钇锆氧化物",
                                                        "alias": "钇锆氧化物",
                                                        "about": null,
                                                        "kws": "钇锆氧化物",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203049909000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*钇锆氧化物",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1665",
                                                        "linkid": "1655",
                                                        "code": "1070203049910",
                                                        "paCode": "10702030499",
                                                        "yn": "N",
                                                        "title": "镧铈锆氧化物",
                                                        "alias": "镧铈锆氧化物",
                                                        "about": null,
                                                        "kws": "镧铈锆氧化物",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203049910000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*镧铈锆氧化物",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1666",
                                                        "linkid": "1655",
                                                        "code": "1070203049911",
                                                        "paCode": "10702030499",
                                                        "yn": "N",
                                                        "title": "镧铈钇锆氧化物",
                                                        "alias": "镧铈钇锆氧化物",
                                                        "about": "镧钇铈锆氧化物等",
                                                        "kws": "镧铈钇锆氧化物",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203049911000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*镧铈钇锆氧化物",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1667",
                                                        "linkid": "1655",
                                                        "code": "1070203049912",
                                                        "paCode": "10702030499",
                                                        "yn": "N",
                                                        "title": "镧铈镨锆氧化物",
                                                        "alias": "镧铈镨锆氧化物",
                                                        "about": null,
                                                        "kws": "镧铈镨锆氧化物",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203049912000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*镧铈镨锆氧化物",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1668",
                                                        "linkid": "1655",
                                                        "code": "1070203049913",
                                                        "paCode": "10702030499",
                                                        "yn": "N",
                                                        "title": "铝铈锆氧化物",
                                                        "alias": "铝铈锆氧化物",
                                                        "about": null,
                                                        "kws": "铝铈锆氧化物",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203049913000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*铝铈锆氧化物",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "1669",
                                                        "linkid": "1655",
                                                        "code": "1070203049914",
                                                        "paCode": "10702030499",
                                                        "yn": "N",
                                                        "title": "其他稀土锆氧化物",
                                                        "alias": "其他稀土锆氧化物",
                                                        "about": "包括氧化铈镨锆",
                                                        "kws": "氧化铈镨锆",
                                                        "taxName": "稀土冶炼分离产品",
                                                        "taxRate": "13%",
                                                        "vip": "7",
                                                        "itaxRate": "0.13",
                                                        "taxCode": "1070203049914000000",
                                                        "taxCodeTitle": "稀土冶炼分离产品",
                                                        "iTitle": "*稀土冶炼分离产品*其他稀土锆氧化物",
                                                        "children": []
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "id": "1670",
                                        "linkid": "1309",
                                        "code": "107020305",
                                        "paCode": "1070203",
                                        "yn": "N",
                                        "title": "氢化物、氮化物、叠氮化物",
                                        "alias": "氢化物、氮化物、叠氮化物",
                                        "about": "氢化物是氢与其他元素形成的二元化合物。氮化物是一类氮的化合物，包括金属氮化物、非金属氮化物等。",
                                        "kws": "氢化物、氮化物、叠氮化物",
                                        "taxName": "基础化学品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070203050000000000",
                                        "taxCodeTitle": "基础化学品",
                                        "iTitle": "*基础化学品*氢化物、氮化物、叠氮化物",
                                        "children": []
                                    },
                                    {
                                        "id": "1671",
                                        "linkid": "1309",
                                        "code": "107020306",
                                        "paCode": "1070203",
                                        "yn": "N",
                                        "title": "气体及稀有气体",
                                        "alias": "气体及稀有气体",
                                        "about": null,
                                        "kws": "气体、稀有气体",
                                        "taxName": "基础化学品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070203060000000000",
                                        "taxCodeTitle": "基础化学品",
                                        "iTitle": "*基础化学品*气体及稀有气体",
                                        "children": []
                                    },
                                    {
                                        "id": "1672",
                                        "linkid": "1309",
                                        "code": "107020307",
                                        "paCode": "1070203",
                                        "yn": "N",
                                        "title": "有机－无机化合物",
                                        "alias": "有机－无机化合物",
                                        "about": null,
                                        "kws": "有机化合物、无机化合物",
                                        "taxName": "基础化学品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070203070000000000",
                                        "taxCodeTitle": "基础化学品",
                                        "iTitle": "*基础化学品*有机－无机化合物",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1673",
                                "linkid": "1226",
                                "code": "1070204",
                                "paCode": "10702",
                                "yn": "Y",
                                "title": "化学肥料",
                                "alias": "化学肥料",
                                "about": "简称化肥，是指经化学和机械加工制成的各种化学肥料。化肥的范围包括：化学氮肥、磷肥、钾肥、复合肥料、微量元素肥和其他肥。",
                                "kws": null,
                                "taxName": "肥料",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070204000000000000",
                                "taxCodeTitle": "肥料",
                                "iTitle": "*肥料*化学肥料",
                                "children": [
                                    {
                                        "id": "1674",
                                        "linkid": "1673",
                                        "code": "107020401",
                                        "paCode": "1070204",
                                        "yn": "N",
                                        "title": "氨及氨水",
                                        "alias": "氨及氨水",
                                        "about": null,
                                        "kws": "氨、氨水",
                                        "taxName": "肥料",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1070204010000000000",
                                        "taxCodeTitle": "肥料",
                                        "iTitle": "*肥料*氨及氨水",
                                        "children": []
                                    },
                                    {
                                        "id": "1675",
                                        "linkid": "1673",
                                        "code": "107020402",
                                        "paCode": "1070204",
                                        "yn": "N",
                                        "title": "氮肥",
                                        "alias": "氮肥",
                                        "about": "以氮为主要养分的肥料，肥效的大小决定于其氮含量。主要品种有尿素和硫酸铵、硝酸铵、碳酸氢铵、氯化铵、石灰氨、硝酸钠等。",
                                        "kws": "尿素、硫酸铵、硝酸铵、碳酸氢铵、氯化铵、石灰氨、氮肥、硝酸钠",
                                        "taxName": "肥料",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1070204020000000000",
                                        "taxCodeTitle": "肥料",
                                        "iTitle": "*肥料*氮肥",
                                        "children": []
                                    },
                                    {
                                        "id": "1676",
                                        "linkid": "1673",
                                        "code": "107020403",
                                        "paCode": "1070204",
                                        "yn": "N",
                                        "title": "磷肥",
                                        "alias": "磷肥",
                                        "about": "是指以磷矿石为主要原料，用化学方法制成的含有作物营养元素磷的化肥。包括磷矿粉、过磷酸钙（普通过磷酸钙和重过磷酸钙两种）、钙镁磷肥、钢渣磷肥等。",
                                        "kws": "磷矿粉、过磷酸钙、普通过磷酸钙、重过磷酸钙、钙镁磷肥、钢渣磷肥、磷肥",
                                        "taxName": "肥料",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1070204030000000000",
                                        "taxCodeTitle": "肥料",
                                        "iTitle": "*肥料*磷肥",
                                        "children": []
                                    },
                                    {
                                        "id": "1677",
                                        "linkid": "1673",
                                        "code": "107020404",
                                        "paCode": "1070204",
                                        "yn": "N",
                                        "title": "钾肥",
                                        "alias": "钾肥",
                                        "about": "用天然钾盐矿经富集精加工制成的含有作物营养元素钾的化肥。主要品种有硫酸钾、氯化钾等。",
                                        "kws": "硫酸钾、氯化钾、钾肥",
                                        "taxName": "肥料",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1070204040000000000",
                                        "taxCodeTitle": "肥料",
                                        "iTitle": "*肥料*钾肥",
                                        "children": []
                                    },
                                    {
                                        "id": "1678",
                                        "linkid": "1673",
                                        "code": "107020405",
                                        "paCode": "1070204",
                                        "yn": "N",
                                        "title": "中量元素肥料",
                                        "alias": "中量元素肥料",
                                        "about": "中量元素肥料包括非水溶钙、镁产品和水溶硅元素等产品。",
                                        "kws": "中量元素肥料、非水溶钙、镁产品、水溶硅元素",
                                        "taxName": "肥料",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1070204050000000000",
                                        "taxCodeTitle": "肥料",
                                        "iTitle": "*肥料*中量元素肥料",
                                        "children": []
                                    },
                                    {
                                        "id": "1679",
                                        "linkid": "1673",
                                        "code": "107020406",
                                        "paCode": "1070204",
                                        "yn": "N",
                                        "title": "微量元素肥料",
                                        "alias": "微量元素肥料",
                                        "about": "指含有一种或多种植物生长所必需的，但需要量又极少的营养元素的肥料，如硼肥、锰肥、锌肥、铜肥、钼肥等。",
                                        "kws": "硼肥、锰肥、锌肥、铜肥、钼肥、微量元素肥料",
                                        "taxName": "肥料",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1070204060000000000",
                                        "taxCodeTitle": "肥料",
                                        "iTitle": "*肥料*微量元素肥料",
                                        "children": []
                                    },
                                    {
                                        "id": "1680",
                                        "linkid": "1673",
                                        "code": "107020407",
                                        "paCode": "1070204",
                                        "yn": "N",
                                        "title": "复合肥、复混合肥",
                                        "alias": "复合肥、复混合肥",
                                        "about": "是用化学方法合成或混配制成含有氮、磷、钾中的两种或两种以上的营养元素的肥料。含有两种的称二元复合肥，含有三种的称三元复合肥料，也有含三种元素和某些其他元素的叫多元复合肥料。包括硝酸磷肥、磷酸铵、磷酸二氢钾肥、钙镁磷钾肥、磷酸一铵、磷粉二铵、氮磷钾复合肥等。",
                                        "kws": "硝酸磷肥、磷酸铵、磷酸二氢钾肥、钙镁磷钾肥、磷酸一铵、磷粉二铵、氮磷钾复合肥、复合肥、复混合肥",
                                        "taxName": "肥料",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1070204070000000000",
                                        "taxCodeTitle": "肥料",
                                        "iTitle": "*肥料*复合肥、复混合肥",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1681",
                                "linkid": "1226",
                                "code": "1070205",
                                "paCode": "10702",
                                "yn": "Y",
                                "title": "有机肥料及微生物肥料",
                                "alias": "有机肥料及微生物肥料",
                                "about": "包括有机肥料，微生物肥料，动物、植物肥料",
                                "kws": null,
                                "taxName": "肥料",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070205000000000000",
                                "taxCodeTitle": "肥料",
                                "iTitle": "*肥料*有机肥料及微生物肥料",
                                "children": [
                                    {
                                        "id": "1682",
                                        "linkid": "1681",
                                        "code": "107020501",
                                        "paCode": "1070205",
                                        "yn": "N",
                                        "title": "有机肥料",
                                        "alias": "有机肥料",
                                        "about": "指来源于植物、动物，施于土壤以提供植物养分为其主要功效的含碳物料，包括有机-无机混合肥料",
                                        "kws": "有机肥料、有机无机混合肥料",
                                        "taxName": "肥料",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1070205010000000000",
                                        "taxCodeTitle": "肥料",
                                        "iTitle": "*肥料*有机肥料",
                                        "children": []
                                    },
                                    {
                                        "id": "1683",
                                        "linkid": "1681",
                                        "code": "107020502",
                                        "paCode": "1070205",
                                        "yn": "N",
                                        "title": "微生物肥料",
                                        "alias": "微生物肥料",
                                        "about": "指含有特定微生物活体的制品，通过其中所含微生物增加植物养分或者促进植物生长、改善农产品品质及农业生态环境的肥料",
                                        "kws": "微生物肥料",
                                        "taxName": "肥料",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1070205020000000000",
                                        "taxCodeTitle": "肥料",
                                        "iTitle": "*肥料*微生物肥料",
                                        "children": []
                                    },
                                    {
                                        "id": "1684",
                                        "linkid": "1681",
                                        "code": "107020503",
                                        "paCode": "1070205",
                                        "yn": "N",
                                        "title": "动物、植物肥料",
                                        "alias": "动物、植物肥料",
                                        "about": null,
                                        "kws": "动物肥料、植物肥料",
                                        "taxName": "肥料",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1070205030000000000",
                                        "taxCodeTitle": "肥料",
                                        "iTitle": "*肥料*动物、植物肥料",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1685",
                                "linkid": "1226",
                                "code": "1070206",
                                "paCode": "10702",
                                "yn": "Y",
                                "title": "化学农药",
                                "alias": "化学农药",
                                "about": "包括化学农药原药和化学农药制剂",
                                "kws": "化学农药原药、化学农药制剂",
                                "taxName": "农药",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070206000000000000",
                                "taxCodeTitle": "农药",
                                "iTitle": "*农药*化学农药",
                                "children": [
                                    {
                                        "id": "1686",
                                        "linkid": "1685",
                                        "code": "107020601",
                                        "paCode": "1070206",
                                        "yn": "N",
                                        "title": "化学农药原药",
                                        "alias": "化学农药原药",
                                        "about": "指经化学合成而生产的，未经过配制、稀释加工的化学农药原料药（原药）；化学农药（原药）包括用于防治农作物病虫草害的杀虫剂、杀菌剂、除草剂以及植物生长调节剂等",
                                        "kws": "有机磷杀虫剂原药、氨基甲酸酯杀虫剂原药、拟除虫菊酯杀虫剂原药、有机氯杀虫剂原药、熏蒸剂原药、杀螨剂原药、沙蚕毒类杀虫剂原药、杂环类杀虫剂、取代脲类杀虫剂、有机磷、胂类杀菌剂原药、有机硫杀菌剂原药、取代苯类杀菌剂原药、杂环类杀菌剂原药、唑类杀菌剂原药、无机杀菌剂原药、杀线虫剂原药、苯类除草剂、酰胺类除草剂原药、取代脲类除草剂原药、有机磷类除草剂原药、氨基甲酸酯类除草剂原药、二苯醚类除草剂原药、三氮苯类除草剂原药、苯氧羧酸类除草剂原药、磺酰脲类除草剂原药、杂环类除草剂原药、植物生长调节剂原药、杀鼠剂原药",
                                        "taxName": "农药",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1070206010000000000",
                                        "taxCodeTitle": "农药",
                                        "iTitle": "*农药*化学农药原药",
                                        "children": []
                                    },
                                    {
                                        "id": "1687",
                                        "linkid": "1685",
                                        "code": "107020602",
                                        "paCode": "1070206",
                                        "yn": "N",
                                        "title": "化学农药制剂",
                                        "alias": "化学农药制剂",
                                        "about": "指用外购农药原药生产的农药制剂",
                                        "kws": "农药制剂",
                                        "taxName": "农药",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1070206020000000000",
                                        "taxCodeTitle": "农药",
                                        "iTitle": "*农药*化学农药制剂",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1688",
                                "linkid": "1226",
                                "code": "1070207",
                                "paCode": "10702",
                                "yn": "Y",
                                "title": "生物农药及微生物农药",
                                "alias": "生物农药及微生物农药",
                                "about": "包括生物农药制剂和微生物农药",
                                "kws": null,
                                "taxName": "农药",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070207000000000000",
                                "taxCodeTitle": "农药",
                                "iTitle": "*农药*生物农药及微生物农药",
                                "children": [
                                    {
                                        "id": "1689",
                                        "linkid": "1688",
                                        "code": "107020701",
                                        "paCode": "1070207",
                                        "yn": "N",
                                        "title": "生物农药制剂",
                                        "alias": "生物农药制剂",
                                        "about": "是指利用生物活体（真菌，细菌，昆虫病毒，转基因生物，天敌等）或其代谢产物（信息素，生长素，萘乙酸，2，4-D等）针对农业有害生物进行杀灭或抑制的制剂。包括生物除草剂制剂、生物杀虫剂制剂、生物杀菌剂制剂、生物植物生长调节剂制剂。",
                                        "kws": "生物农药制剂、生物除草剂制剂、生物杀虫剂制剂、生物杀菌剂制剂、生物植物生长调节剂制剂",
                                        "taxName": "农药",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1070207010000000000",
                                        "taxCodeTitle": "农药",
                                        "iTitle": "*农药*生物农药制剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1690",
                                        "linkid": "1688",
                                        "code": "107020702",
                                        "paCode": "1070207",
                                        "yn": "N",
                                        "title": "微生物农药",
                                        "alias": "微生物农药",
                                        "about": "包括农用抗生素和活体微生物农药。",
                                        "kws": "农用抗生素、活体微生物农药",
                                        "taxName": "农药",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1070207020000000000",
                                        "taxCodeTitle": "农药",
                                        "iTitle": "*农药*微生物农药",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1691",
                                "linkid": "1226",
                                "code": "1070208",
                                "paCode": "10702",
                                "yn": "Y",
                                "title": "涂料",
                                "alias": "涂料",
                                "about": "指用油料、树脂、颜料、溶剂、催干剂以及其他辅料，经加工后制成的符合产品质量标准规定的喷涂覆盖材料；涂料（油漆）按主要成膜物质分为二类：即水性涂料和非水性涂料；按用途分为三类：即工业涂料、建筑涂料和涂料辅助材料",
                                "kws": "涂料",
                                "taxName": "涂料",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070208000000000000",
                                "taxCodeTitle": "涂料",
                                "iTitle": "*涂料*涂料",
                                "children": [
                                    {
                                        "id": "1691",
                                        "linkid": "1690",
                                        "code": "107020800",
                                        "paCode": "1070207",
                                        "yn": "N",
                                        "title": "乳液",
                                        "alias": "乳液",
                                        "about": "对施工状态下挥发性有机物乳液免征消费税",
                                        "kws": null,
                                        "taxName": "涂料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070208010000000000",
                                        "taxCodeTitle": "涂料",
                                        "iTitle": "*涂料*乳液",
                                        "children": []
                                    },
                                    {
                                        "id": "1692",
                                        "linkid": "1691",
                                        "code": "107020801",
                                        "paCode": "1070208",
                                        "yn": "N",
                                        "title": "VOC含量低于420克/升（含）的涂料",
                                        "alias": "VOC含量低于420克/升（含）的涂料",
                                        "about": "对施工状态下挥发性有机物（VOC）含量低于420克/升(含)的涂料免征消费税",
                                        "kws": null,
                                        "taxName": "涂料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070208010000000000",
                                        "taxCodeTitle": "涂料",
                                        "iTitle": "*涂料*VOC含量低于420克/升（含）的涂料",
                                        "children": []
                                    },
                                    {
                                        "id": "1693",
                                        "linkid": "1691",
                                        "code": "107020802",
                                        "paCode": "1070208",
                                        "yn": "N",
                                        "title": "VOC含量高于420克/升的涂料",
                                        "alias": "VOC含量高于420克/升的涂料",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "涂料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070208020000000000",
                                        "taxCodeTitle": "涂料",
                                        "iTitle": "*涂料*VOC含量高于420克/升的涂料",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1694",
                                "linkid": "1226",
                                "code": "1070209",
                                "paCode": "10702",
                                "yn": "Y",
                                "title": "油墨及类似产品",
                                "alias": "油墨及类似产品",
                                "about": "包含油墨和印刷用助剂和油",
                                "kws": null,
                                "taxName": "油墨",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070209000000000000",
                                "taxCodeTitle": "油墨",
                                "iTitle": "*油墨*油墨及类似产品",
                                "children": [
                                    {
                                        "id": "1695",
                                        "linkid": "1694",
                                        "code": "107020901",
                                        "paCode": "1070209",
                                        "yn": "N",
                                        "title": "油墨",
                                        "alias": "油墨",
                                        "about": "指用于印刷的有色胶状物质；由颜料微粒均匀地分散在联结料中而成；联结料用植物油、矿物油、合成树脂和挥发性溶剂等配制；分为印刷油墨和专用油墨",
                                        "kws": "油墨、印刷油墨、平版油墨、凸版油墨、凹版油墨、网孔版油墨、柔性版油墨、水性柔印油墨、专用油墨、金属印刷油墨、紫外线固化油墨、防伪油墨、水基喷印油墨、溶剂基喷印油墨、电子油墨",
                                        "taxName": "油墨",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070209010000000000",
                                        "taxCodeTitle": "油墨",
                                        "iTitle": "*油墨*油墨",
                                        "children": []
                                    },
                                    {
                                        "id": "1696",
                                        "linkid": "1694",
                                        "code": "107020902",
                                        "paCode": "1070209",
                                        "yn": "N",
                                        "title": "印刷用助剂和油",
                                        "alias": "印刷用助剂和油",
                                        "about": "在印刷中或油墨配方中为改善油墨性能而附加的一些材料。又称辅助剂、附加剂。常用的油墨助剂有催干剂、冲淡剂、减粘剂、稀薄剂、抗氧化剂、反胶化剂、消泡剂、表面活性剂、防针孔剂、爽滑剂、增塑剂、防腐剂和香料等。",
                                        "kws": "印刷用助剂、印刷用油、涂布用光油、印刷用光油、白燥油、红燥油、维利油、防潮油、调金油、调墨油、印刷用稀释剂、印刷用干燥剂、印刷用冲淡剂",
                                        "taxName": "油墨",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070209020000000000",
                                        "taxCodeTitle": "油墨",
                                        "iTitle": "*油墨*印刷用助剂和油",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1697",
                                "linkid": "1226",
                                "code": "1070210",
                                "paCode": "10702",
                                "yn": "Y",
                                "title": "颜料",
                                "alias": "颜料",
                                "about": "按其化学组成和结构可划分为无机颜料和有机颜料两类",
                                "kws": null,
                                "taxName": "颜料",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070210000000000000",
                                "taxCodeTitle": "颜料",
                                "iTitle": "*颜料*颜料",
                                "children": [
                                    {
                                        "id": "1698",
                                        "linkid": "1697",
                                        "code": "107021001",
                                        "paCode": "1070210",
                                        "yn": "N",
                                        "title": "无机颜料",
                                        "alias": "无机颜料",
                                        "about": "无机颜料的化学组成为无机物，即由各种纯金属或单一元素及各种金属氧化物、金属盐（正盐、碱式盐、复盐）类等组成，不溶于水或其他介质",
                                        "kws": "无机颜料、钛白粉、柠檬黄、钼铬红、群青、镉红、锌钡白、立德粉、锌铬黄、铬绿、铬黄、氧化铁绿、氧化铁红、氧化铁黄、铁兰、氧化铁黑、氧化铁棕、钒锆蓝、银粉浆、锌浆、镨黄、茶赤",
                                        "taxName": "颜料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070210010000000000",
                                        "taxCodeTitle": "颜料",
                                        "iTitle": "*颜料*无机颜料",
                                        "children": []
                                    },
                                    {
                                        "id": "1699",
                                        "linkid": "1697",
                                        "code": "107021002",
                                        "paCode": "1070210",
                                        "yn": "N",
                                        "title": "有机颜料",
                                        "alias": "有机颜料",
                                        "about": "指沉淀色料等有机颜料和以其为基本成分的配制品；有机颜料属于不溶性的有机化合物，一般不溶于水，也不溶于被着色物质；有机颜料常以高度分散状态加入到被着色物质中，以达到着色的目的",
                                        "kws": "亚硝基类颜料、偶氮类颜料、联苯胺黄G、色淀类颜料、酞菁类颜料、酞菁、喹吖啶酮类颜料、二口恶嗪类颜料、还原类颜料、异吲哚啉酮类颜料、三芳甲烷类颜料、苯并咪唑酮类颜料",
                                        "taxName": "颜料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070210020000000000",
                                        "taxCodeTitle": "颜料",
                                        "iTitle": "*颜料*有机颜料",
                                        "children": []
                                    },
                                    {
                                        "id": "1700",
                                        "linkid": "1697",
                                        "code": "107021003",
                                        "paCode": "1070210",
                                        "yn": "N",
                                        "title": "矿物颜料",
                                        "alias": "矿物颜料",
                                        "about": "矿物颜料即是无机颜料，是无机物的一类，属于无机性质的有色颜料，它的来源主要有两类：一类是用天然矿石经选矿，粉碎，研磨，分级，精制而成，主要用于绘画，工艺品，仿古，文物修复等。无机颜料的另一个来源是有天然矿产品经过一系列化学处理加工而制成的化工合成颜料。",
                                        "kws": "土红、朱砂、页岩黑、硅黑、锌灰、矿物颜料",
                                        "taxName": "颜料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070210030000000000",
                                        "taxCodeTitle": "颜料",
                                        "iTitle": "*颜料*矿物颜料",
                                        "children": []
                                    },
                                    {
                                        "id": "1701",
                                        "linkid": "1697",
                                        "code": "107021004",
                                        "paCode": "1070210",
                                        "yn": "N",
                                        "title": "植物性着色料",
                                        "alias": "植物性着色料",
                                        "about": "提炼自植物，耐久不退色的有色物质",
                                        "kws": "天然靛蓝、藤黄、姜黄素、苏木精、植物性着色料",
                                        "taxName": "颜料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070210040000000000",
                                        "taxCodeTitle": "颜料",
                                        "iTitle": "*颜料*植物性着色料",
                                        "children": []
                                    },
                                    {
                                        "id": "1702",
                                        "linkid": "1697",
                                        "code": "107021005",
                                        "paCode": "1070210",
                                        "yn": "N",
                                        "title": "工业用调制颜料、遮光剂和着色剂及类似颜料",
                                        "alias": "工业用调制颜料、遮光剂和着色剂及类似颜料",
                                        "about": "用于陶瓷、搪瓷、玻璃等工业的调制颜料、遮光剂和着色剂及其他类似颜料",
                                        "kws": "工业用调制颜料、遮光剂、着色剂、珐琅、釉底料、泥釉、光瓷釉、搪瓷玻璃料",
                                        "taxName": "颜料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070210050000000000",
                                        "taxCodeTitle": "颜料",
                                        "iTitle": "*颜料*工业用调制颜料、遮光剂和着色剂及类似颜料",
                                        "children": []
                                    },
                                    {
                                        "id": "1703",
                                        "linkid": "1697",
                                        "code": "107021006",
                                        "paCode": "1070210",
                                        "yn": "N",
                                        "title": "艺术、美工用颜料、调色料",
                                        "alias": "艺术、美工用颜料、调色料",
                                        "about": "包括艺术家、学生或美工广告用的制成色料、颜料，以及调色料、文娱颜料及类似品（水彩、树胶水彩画颜料、油涂料等），但它们必呈片状或制成管装、小罐装、瓶装、扁盒装及类似形状或包装",
                                        "kws": "水彩颜料、水粉颜料、油画颜料、国画颜料、丙烯颜料",
                                        "taxName": "颜料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070210060000000000",
                                        "taxCodeTitle": "颜料",
                                        "iTitle": "*颜料*艺术、美工用颜料、调色料",
                                        "children": []
                                    },
                                    {
                                        "id": "1704",
                                        "linkid": "1697",
                                        "code": "107021007",
                                        "paCode": "1070210",
                                        "yn": "N",
                                        "title": "美工塑型用膏",
                                        "alias": "美工塑型用膏",
                                        "about": "包括供美工、金工用以造模塑型用膏，但不包括儿童娱乐塑型用膏（详见106040806）。",
                                        "kws": "美工塑型用膏",
                                        "taxName": "颜料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070210070000000000",
                                        "taxCodeTitle": "颜料",
                                        "iTitle": "*颜料*美工塑型用膏",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1705",
                                "linkid": "1226",
                                "code": "1070211",
                                "paCode": "10702",
                                "yn": "Y",
                                "title": "染料类",
                                "alias": "染料类",
                                "about": "包括染料、用作发光体有机及无机产品",
                                "kws": null,
                                "taxName": "染料",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070211000000000000",
                                "taxCodeTitle": "染料",
                                "iTitle": "*染料*染料类",
                                "children": [
                                    {
                                        "id": "1706",
                                        "linkid": "1705",
                                        "code": "107021101",
                                        "paCode": "1070211",
                                        "yn": "N",
                                        "title": "染料",
                                        "alias": "染料",
                                        "about": "指能将纤维或其他被染物染成各种颜色的有机化合物；染料均按最终成品、指商品化拼混后的成品染料、实物量计算产量，而不按原染料计算产量；为避免染料总计算数量重复，企业外购染料进行拼混的混合染料，一律不计算产量",
                                        "kws": "安安蓝B盐、大红色基G、大红色基RC、分散黑S-2BL-M、分散红3B、分散黄RFL、分散黄棕S-2RFL、分散蓝2BLN、分散深蓝HGL、还原靛蓝、合成靛蓝、还原橄榄绿B、还原黄GCN、还原咔叽2G、还原蓝RSN、还原棕BR、红色基B、活性橙、活性翠蓝K-GL、活性翠蓝KGN、活性黑K-BR、活性黑KN-B、活性黄X-RG、活性艳橙X-GN、活性艳红X-3B、活性艳蓝KN-R、活性艳蓝X-BR、碱性玫瑰精、碱性嫩黄O、碱性品红、碱性品绿、硫化还原蓝RNX、硫化黑、硫化蓝、色酚AS、酸性橙Ⅱ、酸性大红GR",
                                        "taxName": "染料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070211010000000000",
                                        "taxCodeTitle": "染料",
                                        "iTitle": "*染料*染料",
                                        "children": []
                                    },
                                    {
                                        "id": "1707",
                                        "linkid": "1705",
                                        "code": "107021102",
                                        "paCode": "1070211",
                                        "yn": "N",
                                        "title": "用作发光体有机、无机产品",
                                        "alias": "用作发光体有机、无机产品",
                                        "about": "指用作荧光增白剂的有机合成产品",
                                        "kws": "A系列荧光增白剂、C系列荧光增白剂、D系列荧光增白剂、W系列荧光增白剂、稀土激光材料、稀土荧光粉、荧光橙ROR-4、荧光红、荧光湖绿G、荧光黄、荧光橘红GG、荧光蓝YJB-1、荧光绿GG、荧光探伤液、荧光透明红、荧光紫B、染料指示剂、生物染色剂、荧光增白剂",
                                        "taxName": "染料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070211020000000000",
                                        "taxCodeTitle": "染料",
                                        "iTitle": "*染料*用作发光体有机、无机产品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1708",
                                "linkid": "1226",
                                "code": "1070212",
                                "paCode": "10702",
                                "yn": "Y",
                                "title": "密封用填料及类似品",
                                "alias": "密封用填料及类似品",
                                "about": "包括非定型密封材料、定形密封材料、密封用粘胶品",
                                "kws": "非定型密封材料、定形密封材料、密封用粘胶品",
                                "taxName": "密封用填料",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070212000000000000",
                                "taxCodeTitle": "密封用填料",
                                "iTitle": "*密封用填料*密封用填料及类似品",
                                "children": [
                                    {
                                        "id": "1709",
                                        "linkid": "1708",
                                        "code": "107021201",
                                        "paCode": "1070212",
                                        "yn": "N",
                                        "title": "非定型密封材料",
                                        "alias": "非定型密封材料",
                                        "about": "建筑防水嵌缝密封材料",
                                        "kws": "SBS改性沥青弹性密封膏、丙烯酸酯密封膏、丁苯橡胶密封膏、丁基橡胶密封膏、硅酮密封膏、聚氨筑密封膏、聚硫密封膏、氯丁胶防水嵌缝油膏、氯磺化聚乙烯密封膏、桐油沥青改性防水油膏、橡胶改性聚酯密封膏、橡胶沥青防水嵌缝膏、改性沥青密封材料建筑窗用弹性密封膏、中空玻璃用弹性密封膏、玻璃幕墙用结构密封胶",
                                        "taxName": "密封用填料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070212010000000000",
                                        "taxCodeTitle": "密封用填料",
                                        "iTitle": "*密封用填料*非定型密封材料",
                                        "children": []
                                    },
                                    {
                                        "id": "1710",
                                        "linkid": "1708",
                                        "code": "107021202",
                                        "paCode": "1070212",
                                        "yn": "N",
                                        "title": "定形密封材料",
                                        "alias": "定形密封材料",
                                        "about": "具有一定形状和尺寸的密封材料",
                                        "kws": "带胶三聚氰胺纸封边条、丁基橡胶防水密封胶粘带、聚氯乙烯胶泥防水带、I型遇水自膨胀橡胶止水材料、II型遇水自膨胀橡胶止水材料、腻子型遇水自膨胀橡胶止水材料、树脂胶泥、橡胶止水带、制品型遇水自膨胀橡胶止水材料、自粘性橡胶密封带",
                                        "taxName": "密封用填料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070212020000000000",
                                        "taxCodeTitle": "密封用填料",
                                        "iTitle": "*密封用填料*定形密封材料",
                                        "children": []
                                    },
                                    {
                                        "id": "1711",
                                        "linkid": "1708",
                                        "code": "107021203",
                                        "paCode": "1070212",
                                        "yn": "N",
                                        "title": "密封用粘胶品",
                                        "alias": "密封用粘胶品",
                                        "about": null,
                                        "kws": "油灰、石膏型粘胶品、蜡型粘胶品、甘油型粘胶品",
                                        "taxName": "密封用填料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070212030000000000",
                                        "taxCodeTitle": "密封用填料",
                                        "iTitle": "*密封用填料*密封用粘胶品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1712",
                                "linkid": "1226",
                                "code": "1070213",
                                "paCode": "10702",
                                "yn": "Y",
                                "title": "化学合成材料",
                                "alias": "化学合成材料",
                                "about": "又称人造材料、合成材料，是人为地把不同物质经化学方法或聚合作用加工而成的材料，其特质与原料不同，如塑料、玻璃、钢铁等。",
                                "kws": "人造材料、合成材料",
                                "taxName": "化学合成材料",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070213000000000000",
                                "taxCodeTitle": "化学合成材料",
                                "iTitle": "*化学合成材料*化学合成材料",
                                "children": [
                                    {
                                        "id": "1712",
                                        "linkid": "1711",
                                        "code": "107021300",
                                        "paCode": "1070212",
                                        "yn": "N",
                                        "title": "胶粘剂",
                                        "alias": "胶粘剂",
                                        "about": "是合成的高分子弹性体，又称人造橡胶；根据化学结构的不同，分为烯烃类、二烯烃类和元素有机类等；主要品种有：丁苯橡胶、丁腈橡胶、顺丁橡胶、丁基橡胶、氯丁橡胶、SBS热塑弹性体、乙丙橡胶、氯磺化聚乙烯、聚氨酯弹性体、聚硫橡胶、硅橡胶、氟橡胶等",
                                        "kws": "初级形状聚氨酯橡胶、聚氨酯橡胶板片带、SBS充油热塑丁苯橡胶、SBS热塑丁苯橡胶、SIS充油热塑丁苯橡胶、SIS热塑丁苯橡胶、充油丁苯橡胶、初级形状丁二烯橡胶、初级形状丁基橡胶、初级形状丁腈橡胶、初级形状氟橡胶、初级形状卤代丁基橡胶、初级形状氯丁橡胶、初级形状氯磺化聚乙烯橡胶、初级形状羧基丁苯橡胶、初级形状乙丙橡胶、初级形状异戊二烯橡胶、丁苯橡胶胶乳、丁二烯橡胶板片带、丁基橡胶板片带、丁腈橡胶板片带、丁腈橡胶胶乳、氟橡胶板片带、氟橡胶胶乳、氯丁橡胶板片带、氯丁橡胶胶乳、氯磺化聚乙烯橡胶板片带、氯磺化聚乙烯",
                                        "taxName": "化学合成材料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070213070000000000",
                                        "taxCodeTitle": "化学合成材料",
                                        "iTitle": "*化学合成材料*胶粘剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1713",
                                        "linkid": "1712",
                                        "code": "107021301",
                                        "paCode": "1070213",
                                        "yn": "Y",
                                        "title": "初级形态塑料",
                                        "alias": "初级形态塑料",
                                        "about": "即塑料树脂及共聚物；是指以合成树脂为基本成分，并含有辅助材料，如填料、增塑剂、颜料、稳定剂等",
                                        "kws": "ABS树脂、AS树脂、丙烯共聚物、不饱和聚酯树脂、超高分子量聚乙烯、UHMW、醇酸树脂、醋酸纤维素塑料、低密度聚乙烯树脂、LDPE、酚醛环氧树脂、酚醛塑料、呋喃树脂、高密度聚乙烯树脂、HDPE、硅橡胶、过氯乙烯树脂、聚氨基甲酸酯、聚苯硫醚环氧树脂、聚苯硫醚树脂、PPS、聚苯醚、聚苯乙烯树脂、聚丙烯树脂、聚丙烯酸甲酯、聚丁二烯树脂、聚砜树脂、聚氟乙烯、聚甲基丙烯酸甲酯、有机玻璃、聚甲醛、聚氯乙烯糊树脂、聚氯乙烯树脂、聚醚砜树脂、聚醚醚酮、聚醚树脂、聚三氟氯乙烯、聚四氟乙烯、聚碳酸酯、聚酰胺树脂、聚酰亚胺、聚",
                                        "taxName": "化学合成材料",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1070213010000000000",
                                        "taxCodeTitle": "化学合成材料",
                                        "iTitle": "*化学合成材料*初级形态塑料",
                                        "children": [
                                            {
                                                "id": "1714",
                                                "linkid": "1713",
                                                "code": "10702130101",
                                                "paCode": "107021301",
                                                "yn": "N",
                                                "title": "聚对苯二甲酸乙二醇酯、PET、树脂",
                                                "alias": "聚对苯二甲酸乙二醇酯、PET、树脂",
                                                "about": "聚对苯二甲酸乙二醇酯化学式为-OCH2-CH2OCOC6H4CO-英文名：polyethyleneterephthalate，简称PET，为高聚合物，由对苯二甲酸乙二醇酯发生脱水缩合反应而来。",
                                                "kws": "PET、聚对苯二甲酸乙二醇酯树脂",
                                                "taxName": "化学合成材料",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070213010100000000",
                                                "taxCodeTitle": "化学合成材料",
                                                "iTitle": "*化学合成材料*聚对苯二甲酸乙二醇酯、PET、树脂",
                                                "children": []
                                            },
                                            {
                                                "id": "1715",
                                                "linkid": "1713",
                                                "code": "10702130199",
                                                "paCode": "107021301",
                                                "yn": "N",
                                                "title": "其他初级形态塑料",
                                                "alias": "其他初级形态塑料",
                                                "about": null,
                                                "kws": null,
                                                "taxName": "化学合成材料",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070213019900000000",
                                                "taxCodeTitle": "化学合成材料",
                                                "iTitle": "*化学合成材料*其他初级形态塑料",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "1716",
                                        "linkid": "1712",
                                        "code": "107021302",
                                        "paCode": "1070213",
                                        "yn": "N",
                                        "title": "合成橡胶",
                                        "alias": "合成橡胶",
                                        "about": "是合成的高分子弹性体，又称人造橡胶；根据化学结构的不同，分为烯烃类、二烯烃类和元素有机类等；主要品种有：丁苯橡胶、丁腈橡胶、顺丁橡胶、丁基橡胶、氯丁橡胶、SBS热塑弹性体、乙丙橡胶、氯磺化聚乙烯、聚氨酯弹性体、聚硫橡胶、硅橡胶、氟橡胶等",
                                        "kws": "初级形状聚氨酯橡胶、聚氨酯橡胶板片带、SBS充油热塑丁苯橡胶、SBS热塑丁苯橡胶、SIS充油热塑丁苯橡胶、SIS热塑丁苯橡胶、充油丁苯橡胶、初级形状丁二烯橡胶、初级形状丁基橡胶、初级形状丁腈橡胶、初级形状氟橡胶、初级形状卤代丁基橡胶、初级形状氯丁橡胶、初级形状氯磺化聚乙烯橡胶、初级形状羧基丁苯橡胶、初级形状乙丙橡胶、初级形状异戊二烯橡胶、丁苯橡胶胶乳、丁二烯橡胶板片带、丁基橡胶板片带、丁腈橡胶板片带、丁腈橡胶胶乳、氟橡胶板片带、氟橡胶胶乳、氯丁橡胶板片带、氯丁橡胶胶乳、氯磺化聚乙烯橡胶板片带、氯磺化聚乙烯",
                                        "taxName": "化学合成材料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070213020000000000",
                                        "taxCodeTitle": "化学合成材料",
                                        "iTitle": "*化学合成材料*合成橡胶",
                                        "children": []
                                    },
                                    {
                                        "id": "1717",
                                        "linkid": "1712",
                                        "code": "107021303",
                                        "paCode": "1070213",
                                        "yn": "N",
                                        "title": "合成纤维单体",
                                        "alias": "合成纤维单体",
                                        "about": "一部分可直接生产合成纤维，一部分要聚合后生产合成纤维；主要有：己内酰胺、丙烯腈、精对苯二甲酸、PTA、对苯二甲酸二甲酯、DMT、纤维级聚丙烯、尼龙66盐、乙二醇等",
                                        "kws": "己内酰胺、对苯二甲酸二甲酯、DMT、纤维级聚丙烯、尼龙66盐、乙二醇、精对苯二甲酸、PTA、丙烯腈、聚酰胺",
                                        "taxName": "化学合成材料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070213030000000000",
                                        "taxCodeTitle": "化学合成材料",
                                        "iTitle": "*化学合成材料*合成纤维单体",
                                        "children": []
                                    },
                                    {
                                        "id": "1718",
                                        "linkid": "1712",
                                        "code": "107021304",
                                        "paCode": "1070213",
                                        "yn": "N",
                                        "title": "合成纤维聚合物",
                                        "alias": "合成纤维聚合物",
                                        "about": "包括聚酯、半消光涤纶切片、聚乙烯醇、聚酰胺等",
                                        "kws": "聚酯、半消光涤纶切片、聚乙烯醇、聚酰胺、聚酰胺切片、尼龙切片",
                                        "taxName": "化学合成材料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070213040000000000",
                                        "taxCodeTitle": "化学合成材料",
                                        "iTitle": "*化学合成材料*合成纤维聚合物",
                                        "children": []
                                    },
                                    {
                                        "id": "1719",
                                        "linkid": "1712",
                                        "code": "107021305",
                                        "paCode": "1070213",
                                        "yn": "N",
                                        "title": "离子交换树脂",
                                        "alias": "离子交换树脂",
                                        "about": "即离子交换剂",
                                        "kws": "阴离子交换树脂、阳离子交换树脂、离子交换剂、强碱性季胺Ⅰ型阴离子交换树脂、弱碱性苯乙烯系阴离子交换树脂、弱碱性环氧系阴离子交换树脂、强酸性苯乙烯系阳离子交换树脂、弱酸性丙烯酸系阳离子交换树脂、螯合型胺羧基阳离子交换树脂",
                                        "taxName": "化学合成材料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070213050000000000",
                                        "taxCodeTitle": "化学合成材料",
                                        "iTitle": "*化学合成材料*离子交换树脂",
                                        "children": []
                                    },
                                    {
                                        "id": "1720",
                                        "linkid": "1712",
                                        "code": "107021306",
                                        "paCode": "1070213",
                                        "yn": "N",
                                        "title": "油脂类高分子聚合物",
                                        "alias": "油脂类高分子聚合物",
                                        "about": "包括硅油和硅脂",
                                        "kws": "乙基含氢硅油、乙基硅油、二甲基硅油、甲基含氢硅油、苯甲基硅油、环甲基硅油、氨基硅油、导热硅脂、抗水性食品级硅脂、含氟油、酯类油、聚醚型油",
                                        "taxName": "化学合成材料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070213060000000000",
                                        "taxCodeTitle": "化学合成材料",
                                        "iTitle": "*化学合成材料*油脂类高分子聚合物",
                                        "children": []
                                    },
                                    {
                                        "id": "1721",
                                        "linkid": "1712",
                                        "code": "107021307",
                                        "paCode": "1070213",
                                        "yn": "N",
                                        "title": "调制粘合剂",
                                        "alias": "调制粘合剂",
                                        "about": "包括调制胶及其他调制粘合剂",
                                        "kws": "聚酰胺粘合剂、环氧树脂粘合剂、聚乙烯醇粘合剂、聚醋酸乙烯粘合剂、丙烯酸酯粘合剂、聚氨脂粘合剂、酚醛、脲醛、三聚氰胺粘合剂、氯丁橡胶粘合剂、聚氯乙烯粘合剂、无机粘合剂、胶粘剂、磷酸盐型粘合剂、硼酸盐型粘合剂、硅酸盐型粘合剂、玻璃胶、陶瓷胶、热溶胶、乙烯-醋酸乙烯热溶胶、共聚酰胺热溶胶、聚酯热溶胶、聚烯烃耐高温热溶胶、改性淀粉调制胶、糊精胶、淀粉胶、沥青粘合剂、热塑性树脂型胶粘剂、热固性树脂胶粘剂、橡胶型胶粘剂、混合型胶粘剂",
                                        "taxName": "化学合成材料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070213070000000000",
                                        "taxCodeTitle": "化学合成材料",
                                        "iTitle": "*化学合成材料*调制粘合剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1722",
                                        "linkid": "1712",
                                        "code": "107021308",
                                        "paCode": "1070213",
                                        "yn": "N",
                                        "title": "功能高分子材料",
                                        "alias": "功能高分子材料",
                                        "about": "功能高分子材料一般指具有传递、转换或贮存物质、能量和信息作用的高分子及其复合材料，或具体地指在原有力学性能的基础上，还具有化学反应活性、光敏性、导电性、催化性、生物相容性、药理性、选择分离性、能量转换性、磁性等功能的高分子及其复合材料。",
                                        "kws": "离子交换树脂、螯合树脂、感光性树脂、氧化还原树脂、高分子试剂、高分子催化剂、高分子增感剂、分解性高分子、电子交换树脂、导电高分子材料、电致发光高分子材料、医用高分子材料、水溶性聚合物、高吸水性树脂、智能高分子聚合物",
                                        "taxName": "化学合成材料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070213080000000000",
                                        "taxCodeTitle": "化学合成材料",
                                        "iTitle": "*化学合成材料*功能高分子材料",
                                        "children": []
                                    },
                                    {
                                        "id": "1723",
                                        "linkid": "1712",
                                        "code": "107021399",
                                        "paCode": "1070213",
                                        "yn": "N",
                                        "title": "其他橡胶",
                                        "alias": "其他橡胶",
                                        "about": "包括复合橡胶等",
                                        "kws": "复合橡胶",
                                        "taxName": "化学合成材料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070213990000000000",
                                        "taxCodeTitle": "化学合成材料",
                                        "iTitle": "*化学合成材料*其他橡胶",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1724",
                                "linkid": "1226",
                                "code": "1070214",
                                "paCode": "10702",
                                "yn": "Y",
                                "title": "化学试剂和助剂",
                                "alias": "化学试剂和助剂",
                                "about": "包括化学试剂、催化剂、橡胶助剂、塑料助剂、农药乳化剂、纺织工业用整理剂、助剂、造纸工业用整理剂、助剂、制革工业用整理剂、助剂、润滑剂及类似制品、钻井用助剂、建工建材用化学助剂、生物化学制剂、炭黑、增炭剂、脱硫剂、石墨增碳剂、栲胶",
                                "kws": null,
                                "taxName": "化学试剂助剂",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070214000000000000",
                                "taxCodeTitle": "化学试剂助剂",
                                "iTitle": "*化学试剂助剂*化学试剂和助剂",
                                "children": [
                                    {
                                        "id": "1725",
                                        "linkid": "1724",
                                        "code": "107021401",
                                        "paCode": "1070214",
                                        "yn": "N",
                                        "title": "化学试剂",
                                        "alias": "化学试剂",
                                        "about": "指化学分析中为测定物质的成分或组成而使用的纯粹化学药品；化学试剂包括：通用试剂、高纯试剂及高纯物质、分析试剂、仪器分析用试剂及制品、生化试剂、临床诊断检查用试剂、稳定性同位素及其标记化合物、高纯气体、新兴工业用特种化学品、有机合成研究用试剂及其他化学试剂",
                                        "kws": "金属化合物试剂、磷化剂、试剂硫酸、盐酸试剂、试剂氨水、AFU试剂、GPDA试剂、GGT试剂、铵化合物试剂、有机化合物试剂、高纯试剂、高纯物质、标准试剂、分析用试剂、络合滴定剂、生物化学试剂",
                                        "taxName": "化学试剂助剂",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070214010000000000",
                                        "taxCodeTitle": "化学试剂助剂",
                                        "iTitle": "*化学试剂助剂*化学试剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1726",
                                        "linkid": "1724",
                                        "code": "107021402",
                                        "paCode": "1070214",
                                        "yn": "N",
                                        "title": "催化剂",
                                        "alias": "催化剂",
                                        "about": "指化学反应中能改变反应速度，而本身的组成和重量在反应后保持不变的物质；催化剂中包括石油精制催化剂、石油化工用催化剂、无机化工用催化剂、硫酸用、合成氨用、有机化工催化剂及防治公害用催化剂",
                                        "kws": "2.6催化剂用载体、54#阳离子交换树脂催化剂、8013催化剂、CEP-1催化剂、CIP系列催化剂、COMET-4A催化剂、DVR-1催化剂、GOR系列催化剂、MLC-5A催化剂、ORBIT系列催化剂、RAG系列催化剂、XJ-1型氧化氮净化剂催化剂、ZC系列催化剂、氨合成用催化剂、苯胺催化剂、苯酐催化剂、苯加氢催化剂NCG、丙烯腈催化剂、铂催化剂S-201、催化剂S-24、催化重整催化剂、大孔强酸树脂催化剂、低温变换催化剂、叠合催化剂SKP-1型、非晶态合金催化剂、高温变换催化剂、高效氟化催化剂、高效脱硫",
                                        "taxName": "化学试剂助剂",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070214020000000000",
                                        "taxCodeTitle": "化学试剂助剂",
                                        "iTitle": "*化学试剂助剂*催化剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1727",
                                        "linkid": "1724",
                                        "code": "107021403",
                                        "paCode": "1070214",
                                        "yn": "N",
                                        "title": "橡胶助剂",
                                        "alias": "橡胶助剂",
                                        "about": "为提高橡胶制品的耐磨性、弹性，使其经久耐用、不老化；橡胶制品在加工过程中，需要加入各种助剂；橡胶助剂主要有橡胶促进剂、防老剂、防焦剂及增粘剂等",
                                        "kws": "橡胶促进剂、橡胶防老剂、橡胶防焦剂、橡胶增粘剂、橡胶抗氧制剂、橡胶润滑剂、橡胶脱膜剂、橡胶隔离剂、橡胶再生胶活化剂、胶乳专用配合剂、橡胶补强剂、促进剂D、促进剂M、促进剂DM、促进剂TMTD、促进剂TETD、促进剂CZ、促进剂ZDC、促进剂NOBS、促进剂NA-22、促进剂DIBS、促进剂PX、促进剂NS、促进剂DZ、防老剂甲、防老剂丁、防老剂4010、防老剂4010-NA、防老剂H、防老剂MB、防老剂AW、防老剂SP、防老剂BLE、防老剂264、防老剂DNP、防老剂DBH、防老剂RD、防老剂4020",
                                        "taxName": "化学试剂助剂",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070214030000000000",
                                        "taxCodeTitle": "化学试剂助剂",
                                        "iTitle": "*化学试剂助剂*橡胶助剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1728",
                                        "linkid": "1724",
                                        "code": "107021404",
                                        "paCode": "1070214",
                                        "yn": "N",
                                        "title": "塑料助剂",
                                        "alias": "塑料助剂",
                                        "about": "在塑料生产和加工过程中必须使用的助剂，以利充分发挥塑料的优良性能并便于加工成型；主要的助剂有：增塑剂、热稳定剂、抗紫外线剂、抗氧化剂、阻燃剂、发泡剂、固化剂、补强剂和填充剂、润滑剂等",
                                        "kws": "塑料增塑剂、塑料热稳定剂、抗紫外线剂、抗氧化剂、阻燃剂、发泡剂、固化剂、补强剂和填充剂、润滑剂、邻苯二甲酸二丁酯增塑剂、邻苯二甲酸二辛酯增塑剂、邻苯二甲酸仲辛酯、邻苯二甲酸七九酯、邻苯二甲酸甲氧基乙酯、邻苯二甲酸丁苄酯、邻苯二甲酸二异癸酯、邻苯二甲酸混合酯、对苯二甲酸二辛酯、癸二酸二丁酯、癸二酸二辛酯增塑剂、烷基磺酸苯酯、环氧酯、氯化石蜡、磷酸三苯酯、磷酸三甲苯酯、亚磷酸三苯酯、亚磷酸二丁酯、塑料抗氧剂、三盐基性硫酸铅、二盐基性亚磷酸铅复合稳定剂、硬酯酸盐类",
                                        "taxName": "化学试剂助剂",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070214040000000000",
                                        "taxCodeTitle": "化学试剂助剂",
                                        "iTitle": "*化学试剂助剂*塑料助剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1729",
                                        "linkid": "1724",
                                        "code": "107021405",
                                        "paCode": "1070214",
                                        "yn": "N",
                                        "title": "农药乳化剂",
                                        "alias": "农药乳化剂",
                                        "about": "乳化剂是能够改善乳浊液中各种构成相之间的表面张力，使之形成均匀稳定的分散体系或乳浊液的物质。农药乳化剂就是是用于农药的乳化剂。",
                                        "kws": "农药乳化剂",
                                        "taxName": "化学试剂助剂",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070214050000000000",
                                        "taxCodeTitle": "化学试剂助剂",
                                        "iTitle": "*化学试剂助剂*农药乳化剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1730",
                                        "linkid": "1724",
                                        "code": "107021406",
                                        "paCode": "1070214",
                                        "yn": "N",
                                        "title": "纺织工业用整理剂、助剂",
                                        "alias": "纺织工业用整理剂、助剂",
                                        "about": "包括纺织及类似工业用整理剂、助剂；纺织工业用整理剂，由醚化脲醛、醚化氰醛、醚化糠醛符合制得",
                                        "kws": "印染用匀染剂、印染用交联剂、印染用防缩水剂、印染用分散剂、印染用消泡剂、印染用染抗静电剂、印染用渗透剂、印染用防染盐、印染用染料加速着色、固色助剂、印染用媒染剂、印染用连二亚硫酸钠、印染用保险粉、纺织上浆剂、增重剂、防滑整理剂、防钩丝整理剂、防垢整理剂、不毡合剂、去油剂、抗水剂、聚丙烯酸酯浆料、苯丙烯乳胶、毛绒胶、静电植绒粘合剂、喷胶棉粘合剂、低温涂料印花粘合剂、纺织定型树脂",
                                        "taxName": "化学试剂助剂",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070214060000000000",
                                        "taxCodeTitle": "化学试剂助剂",
                                        "iTitle": "*化学试剂助剂*纺织工业用整理剂、助剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1731",
                                        "linkid": "1724",
                                        "code": "107021407",
                                        "paCode": "1070214",
                                        "yn": "N",
                                        "title": "造纸工业用整理剂、助剂",
                                        "alias": "造纸工业用整理剂、助剂",
                                        "about": "包括造纸及类似工业用整理剂、助剂",
                                        "kws": "造纸用粘合剂、造纸上浆剂、上浆添加剂、增湿剂、增强剂、助留剂、造纸用成型剂",
                                        "taxName": "化学试剂助剂",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070214070000000000",
                                        "taxCodeTitle": "化学试剂助剂",
                                        "iTitle": "*化学试剂助剂*造纸工业用整理剂、助剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1732",
                                        "linkid": "1724",
                                        "code": "107021408",
                                        "paCode": "1070214",
                                        "yn": "N",
                                        "title": "制革工业用整理剂、助剂",
                                        "alias": "制革工业用整理剂、助剂",
                                        "about": "包括制革及类似工业用整理剂、助剂",
                                        "kws": "制革用粘合剂、上光剂、涂饰剂、软皮剂、皮革防水剂、助剂",
                                        "taxName": "化学试剂助剂",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070214080000000000",
                                        "taxCodeTitle": "化学试剂助剂",
                                        "iTitle": "*化学试剂助剂*制革工业用整理剂、助剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1733",
                                        "linkid": "1724",
                                        "code": "107021409",
                                        "paCode": "1070214",
                                        "yn": "N",
                                        "title": "润滑剂及类似制品",
                                        "alias": "润滑剂及类似制品",
                                        "about": "包括润滑剂及纺织材料、皮革等材料的油脂处理剂",
                                        "kws": "矿物油制润滑剂、非矿物油制润滑剂、纺织用润滑制剂、皮革用润滑制剂、脱模剂",
                                        "taxName": "化学试剂助剂",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070214090000000000",
                                        "taxCodeTitle": "化学试剂助剂",
                                        "iTitle": "*化学试剂助剂*润滑剂及类似制品",
                                        "children": []
                                    },
                                    {
                                        "id": "1734",
                                        "linkid": "1724",
                                        "code": "107021410",
                                        "paCode": "1070214",
                                        "yn": "N",
                                        "title": "钻井用助剂",
                                        "alias": "钻井用助剂",
                                        "about": null,
                                        "kws": "钻井用破乳剂、泥浆用助剂、钻井用注水剂、钻井用降粘剂、钻井用助剂",
                                        "taxName": "化学试剂助剂",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070214100000000000",
                                        "taxCodeTitle": "化学试剂助剂",
                                        "iTitle": "*化学试剂助剂*钻井用助剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1735",
                                        "linkid": "1724",
                                        "code": "107021411",
                                        "paCode": "1070214",
                                        "yn": "N",
                                        "title": "建工建材用化学助剂",
                                        "alias": "建工建材用化学助剂",
                                        "about": "包括建筑防水剂、水泥、灰泥及混凝土用添加剂、建工建材用交联剂、快速堵漏剂",
                                        "kws": "抗裂防水剂、减水剂、防水粉、防水促凝剂、避水浆、建筑防水剂、混凝土泡沫剂、混凝土膨胀剂、高效无声破碎剂、无收缩高强灌浆材料、灌注桩膨胀剂、泵送剂、流化剂、抗酸添加剂、混凝土防冻剂、水泥、灰泥用添加剂、混凝土用添加剂、建工建材用交联剂、快速堵漏剂、建工建材用化学助剂",
                                        "taxName": "化学试剂助剂",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070214110000000000",
                                        "taxCodeTitle": "化学试剂助剂",
                                        "iTitle": "*化学试剂助剂*建工建材用化学助剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1736",
                                        "linkid": "1724",
                                        "code": "107021412",
                                        "paCode": "1070214",
                                        "yn": "N",
                                        "title": "生物化学制剂",
                                        "alias": "生物化学制剂",
                                        "about": "包括黄腐酸制剂和其他生物化学制剂",
                                        "kws": "大豆重茬剂、克黄枯、稻香素、丰抗剂、花生宝、稳定性二氧化氯、黄腐酸制剂、生物化学制剂",
                                        "taxName": "化学试剂助剂",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070214120000000000",
                                        "taxCodeTitle": "化学试剂助剂",
                                        "iTitle": "*化学试剂助剂*生物化学制剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1737",
                                        "linkid": "1724",
                                        "code": "107021413",
                                        "paCode": "1070214",
                                        "yn": "N",
                                        "title": "炭黑",
                                        "alias": "炭黑",
                                        "about": "又称炉黑，包括天然气槽法炭黑、天然气半补强炭黑、混气碳黑；是轻松而极细的无定形炭粉末；是由有机物质经不完全燃烧或经热分解而成的不纯产品；广泛用作橡胶的补强剂；炭黑种类很多；可作黑色颜料，用于中国墨、油墨、油漆等工业",
                                        "kws": "炭黑、中超耐磨炉黑、高耐磨炉黑、耐磨炉黑、高结构通用炉黑、低结构通用炉黑、通用炉黑、色素炭黑、喷雾炭黑、乙炔炭黑",
                                        "taxName": "化学试剂助剂",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070214130000000000",
                                        "taxCodeTitle": "化学试剂助剂",
                                        "iTitle": "*化学试剂助剂*炭黑",
                                        "children": []
                                    },
                                    {
                                        "id": "1738",
                                        "linkid": "1724",
                                        "code": "107021414",
                                        "paCode": "1070214",
                                        "yn": "N",
                                        "title": "增炭剂",
                                        "alias": "增炭剂",
                                        "about": "以石墨化焦、电极石黑碎、煅后石油焦、煤焦为基本原料，通过选料，电炉煅烧、烘干、破碎、整料、筛分、包装等一整套工艺过程，生产出各种品质和粒级的增炭剂",
                                        "kws": "增炭剂",
                                        "taxName": "化学试剂助剂",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070214140000000000",
                                        "taxCodeTitle": "化学试剂助剂",
                                        "iTitle": "*化学试剂助剂*增炭剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1739",
                                        "linkid": "1724",
                                        "code": "107021415",
                                        "paCode": "1070214",
                                        "yn": "N",
                                        "title": "脱硫剂",
                                        "alias": "脱硫剂",
                                        "about": "一般指脱除燃料、原料或其他物料中的游离硫或硫化合物的药剂；在污染物的控制和处理中主要指能去除废气中硫氧化物（包括SO2和SO3）所用的药剂。",
                                        "kws": "脱硫剂",
                                        "taxName": "化学试剂助剂",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070214150000000000",
                                        "taxCodeTitle": "化学试剂助剂",
                                        "iTitle": "*化学试剂助剂*脱硫剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1740",
                                        "linkid": "1724",
                                        "code": "107021416",
                                        "paCode": "1070214",
                                        "yn": "N",
                                        "title": "石墨增碳剂",
                                        "alias": "石墨增碳剂",
                                        "about": null,
                                        "kws": "石墨增碳剂",
                                        "taxName": "化学试剂助剂",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070214160000000000",
                                        "taxCodeTitle": "化学试剂助剂",
                                        "iTitle": "*化学试剂助剂*石墨增碳剂",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1741",
                                "linkid": "1226",
                                "code": "1070215",
                                "paCode": "10702",
                                "yn": "Y",
                                "title": "专项化学用品",
                                "alias": "专项化学用品",
                                "about": null,
                                "kws": null,
                                "taxName": "专项化学用品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070215000000000000",
                                "taxCodeTitle": "专项化学用品",
                                "iTitle": "*专项化学用品*专项化学用品",
                                "children": [
                                    {
                                        "id": "1742",
                                        "linkid": "1741",
                                        "code": "107021501",
                                        "paCode": "1070215",
                                        "yn": "N",
                                        "title": "油田用化学制剂",
                                        "alias": "油田用化学制剂",
                                        "about": "供油田使用的化学制剂",
                                        "kws": "KDS-901油田缓蚀剂、KDS-902油田缓蚀剂、KDS-903炼油装置用缓蚀剂、油田缓蚀剂、KDS-906丙烯酰胺乳液聚合物、钻井泥浆增稠剂、KDS-904油田破乳剂、KDS-905原油破乳剂、原油破乳剂、KDS系列油井水泥促凝早强剂、KDS-93低密度水泥浆体系稳定增强剂、水泥外加剂、KDS903S油井水泥促凝剂、KDS88油井水泥高温缓凝剂、油井水泥不渗透剂、固井外加剂、羧烷基羟烷基纤维素压裂液、磷酸酯凝析油、压裂用化学品、防止石蜡凝结化学品",
                                        "taxName": "专项化学用品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070215010000000000",
                                        "taxCodeTitle": "专项化学用品",
                                        "iTitle": "*专项化学用品*油田用化学制剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1743",
                                        "linkid": "1741",
                                        "code": "107021502",
                                        "paCode": "1070215",
                                        "yn": "N",
                                        "title": "矿物油用配制添加剂",
                                        "alias": "矿物油用配制添加剂",
                                        "about": "供矿物油等同样用途液体的配制添加剂",
                                        "kws": "防腐蚀添加剂、原油添加剂、抗震剂、抗爆剂、金属钝化剂、抗氧化剂、防冰剂、抗静电剂、抗磨剂、抗烧蚀剂、流动改进剂、燃油防腐蚀剂、消烟剂、助燃剂、防胶剂、十六烷值改进剂、清净分散剂、热安定剂、燃油用添加剂、润滑油用粘度改良剂、润滑油用倾点下降剂、润滑油用氧化抑制剂、润滑油用耐特压添加剂、润滑油用去垢剂、润滑油用分散剂、润滑油用防锈剂、润滑油用消泡剂、润滑油用添加剂、防冻剂、解冻剂、矿物油用添加剂",
                                        "taxName": "专项化学用品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070215020000000000",
                                        "taxCodeTitle": "专项化学用品",
                                        "iTitle": "*专项化学用品*矿物油用配制添加剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1744",
                                        "linkid": "1741",
                                        "code": "107021503",
                                        "paCode": "1070215",
                                        "yn": "N",
                                        "title": "鞣料及鞣料制剂",
                                        "alias": "鞣料及鞣料制剂",
                                        "about": "包括有机合成鞣料、无机鞣料及鞣料制剂",
                                        "kws": "萘磺酸甲醛缩合物、来酸-丙烯酸共聚物、氨基树脂鞣剂、有机合成鞣料、无机鞣料、皮革鞣剂ks-1、鞣剂3N、鞣料制剂、预鞣酶制剂",
                                        "taxName": "专项化学用品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070215030000000000",
                                        "taxCodeTitle": "专项化学用品",
                                        "iTitle": "*专项化学用品*鞣料及鞣料制剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1745",
                                        "linkid": "1741",
                                        "code": "107021504",
                                        "paCode": "1070215",
                                        "yn": "N",
                                        "title": "酶及酶制品",
                                        "alias": "酶及酶制品",
                                        "about": "酶是由活细胞合成的，对特异底物起高效催化作用的蛋白质，是机体内催化各种代谢反应的最主要的催化剂。",
                                        "kws": "凝乳酶、碱性蛋白酶、碱性脂肪酶、胃蛋白酶、胰酶、麦芽糖酶、木瓜蛋白酶、菠萝蛋白酶、无花果蛋白酶、转化酶、葡萄糖异构酶、二肽酶、核苷酶、歧化酶、脱氧核糖核酸酶、酶、工业用酶制剂、酶制品",
                                        "taxName": "专项化学用品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070215040000000000",
                                        "taxCodeTitle": "专项化学用品",
                                        "iTitle": "*专项化学用品*酶及酶制品",
                                        "children": []
                                    },
                                    {
                                        "id": "1746",
                                        "linkid": "1741",
                                        "code": "107021505",
                                        "paCode": "1070215",
                                        "yn": "N",
                                        "title": "化学陶瓷",
                                        "alias": "化学陶瓷",
                                        "about": "包括氧化物陶瓷、碳化物陶、瓷氮化物陶瓷、氟化物陶瓷和其他化学陶瓷",
                                        "kws": "氧化铝陶瓷、氧化锆陶瓷、氧化铍陶瓷、氧化镁陶瓷、氧化物陶瓷、碳化硅陶瓷、碳化硼陶瓷、碳化钛陶瓷、碳化物陶瓷、氮化硅陶瓷、氮化硼陶瓷、氮化铝陶瓷、氮化钛陶瓷、氮化物陶瓷",
                                        "taxName": "专项化学用品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070215050000000000",
                                        "taxCodeTitle": "专项化学用品",
                                        "iTitle": "*专项化学用品*化学陶瓷",
                                        "children": []
                                    },
                                    {
                                        "id": "1747",
                                        "linkid": "1741",
                                        "code": "107021506",
                                        "paCode": "1070215",
                                        "yn": "N",
                                        "title": "特种纤维及高功能化工产品",
                                        "alias": "特种纤维及高功能化工产品",
                                        "about": "包括碳纤维增强复合材料、硼纤维增强复合材料、碳化硅纤维增强复合材料、氧化铝纤维增强复合材料。",
                                        "kws": "碳纤维增强摩擦材料、碳纤维增强塑料、碳纤维增强金属基复合材料、碳纤维增强复合材料、硼纤维增强塑料、硼纤维增强钛合金复合材料、硼纤维增强复合材料、碳化硅纤维增强塑料、碳化硅纤维增强玻璃陶瓷复合材料、碳化硅增强铝基复合材料、碳化硅纤维增强复合材料、氧化铝纤维增强复合材料、磷酸锆类离子交换剂、磷酸铝系分子筛、特种纤维",
                                        "taxName": "专项化学用品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070215060000000000",
                                        "taxCodeTitle": "专项化学用品",
                                        "iTitle": "*专项化学用品*特种纤维及高功能化工产品",
                                        "children": []
                                    },
                                    {
                                        "id": "1748",
                                        "linkid": "1741",
                                        "code": "107021507",
                                        "paCode": "1070215",
                                        "yn": "N",
                                        "title": "金属表面处理剂",
                                        "alias": "金属表面处理剂",
                                        "about": "金属表面处理剂指对金属表面进行各种处理的化学药剂的总称。主要包括清洗剂、防锈剂、磷化液三大类。",
                                        "kws": "油污清洗剂、高温除油剂、鳞皮清除剂、金属表面调整剂、金属清洗剂、酸洗钝化剂、酸洗抑制剂、金属酸洗膏、金属表面酸洗剂、锌系磷化剂、防锈磷化剂、锰系磷化剂、拉伸磷化剂、金属表面磷化剂、金属表面防锈油、金属表面防锈剂、金属表面除锈、防锈剂、镀镍光亮剂791、铜酸洗光亮剂、镀镍光亮剂、氰化镀铜光亮剂、防铜变色剂、电镀添加剂、沥青抗剥落剂、退锡剂、二乙胺基丙炔胺、乙氧基丙炔醇、二乙氧基丁炔二醇、氨基磺酸铵、聚二硫丙基磺酸钠、无氰镀锌添加剂、氨基磺酸镍、电镀用化学品",
                                        "taxName": "专项化学用品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070215070000000000",
                                        "taxCodeTitle": "专项化学用品",
                                        "iTitle": "*专项化学用品*金属表面处理剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1749",
                                        "linkid": "1741",
                                        "code": "107021508",
                                        "paCode": "1070215",
                                        "yn": "N",
                                        "title": "工业用脂肪醇",
                                        "alias": "工业用脂肪醇",
                                        "about": null,
                                        "kws": "工业用增塑剂醇、工业用洗涤剂醇、工业用齐格勒醇C12-14、工业用脂肪醇、工业用洗涤剂醇C12-13、工业用洗涤剂醇C14-15、工业用洗涤剂醇C12-15、工业用洗涤剂醇C12-14、工业用洗涤剂醇C14-16、工业用洗涤剂醇C16-18",
                                        "taxName": "专项化学用品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070215080000000000",
                                        "taxCodeTitle": "专项化学用品",
                                        "iTitle": "*专项化学用品*工业用脂肪醇",
                                        "children": []
                                    },
                                    {
                                        "id": "1750",
                                        "linkid": "1741",
                                        "code": "107021509",
                                        "paCode": "1070215",
                                        "yn": "N",
                                        "title": "工业用脂肪酸",
                                        "alias": "工业用脂肪酸",
                                        "about": null,
                                        "kws": "工业用椰子油、棕榈仁油、脂肪酸、工业用棕榈油脂肪酸、工业用油酸、工业用妥尔油脂肪酸、工业用合成脂肪酸、工业用脂肪酸",
                                        "taxName": "专项化学用品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070215090000000000",
                                        "taxCodeTitle": "专项化学用品",
                                        "iTitle": "*专项化学用品*工业用脂肪酸",
                                        "children": []
                                    },
                                    {
                                        "id": "1751",
                                        "linkid": "1741",
                                        "code": "107021510",
                                        "paCode": "1070215",
                                        "yn": "N",
                                        "title": "工业用脂肪胺",
                                        "alias": "工业用脂肪胺",
                                        "about": null,
                                        "kws": "工业用脂肪烷基伯胺、工业用脂肪烷基仲胺、工业用脂肪烷基叔胺、工业用脂肪胺",
                                        "taxName": "专项化学用品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070215100000000000",
                                        "taxCodeTitle": "专项化学用品",
                                        "iTitle": "*专项化学用品*工业用脂肪胺",
                                        "children": []
                                    },
                                    {
                                        "id": "1752",
                                        "linkid": "1741",
                                        "code": "107021511",
                                        "paCode": "1070215",
                                        "yn": "N",
                                        "title": "工业级混合油",
                                        "alias": "工业级混合油",
                                        "about": "餐饮业和食品业用后的植物油与动物油的混合物，经脱水、去渣、降酸、脱色、去味处理，只被用于工业化生产，如用于生产生物柴油（脂肪酸甲酯）、油酸、环氧甲酯、甘油、植物沥青、增塑剂等；",
                                        "kws": "工业级混合油",
                                        "taxName": "专项化学用品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070215110000000000",
                                        "taxCodeTitle": "专项化学用品",
                                        "iTitle": "*专项化学用品*工业级混合油",
                                        "children": []
                                    },
                                    {
                                        "id": "1753",
                                        "linkid": "1741",
                                        "code": "107021512",
                                        "paCode": "1070215",
                                        "yn": "N",
                                        "title": "脂肪酸甲酯",
                                        "alias": "脂肪酸甲酯",
                                        "about": "脂肪酸甲酯为黄色澄清透明液体（精馏后为无色），具有一种温和的、特有的气味，结构稳定，没有腐蚀性。脂肪酸甲酯是用途广泛的表面活性剂(SAA)的原料。",
                                        "kws": "脂肪酸甲酯、己二酸单甲酯、己二酸氢甲酯、脂肪酸甲酯C12-14、脂肪酸甲酯C12-16",
                                        "taxName": "专项化学用品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070215120000000000",
                                        "taxCodeTitle": "专项化学用品",
                                        "iTitle": "*专项化学用品*脂肪酸甲酯",
                                        "children": []
                                    },
                                    {
                                        "id": "1754",
                                        "linkid": "1741",
                                        "code": "107021599",
                                        "paCode": "1070215",
                                        "yn": "N",
                                        "title": "其他专项化学用品",
                                        "alias": "其他专项化学用品",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "专项化学用品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070215990000000000",
                                        "taxCodeTitle": "专项化学用品",
                                        "iTitle": "*专项化学用品*其他专项化学用品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1755",
                                "linkid": "1226",
                                "code": "1070216",
                                "paCode": "10702",
                                "yn": "Y",
                                "title": "林产化学产品",
                                "alias": "林产化学产品",
                                "about": null,
                                "kws": null,
                                "taxName": "林产化学产品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070216000000000000",
                                "taxCodeTitle": "林产化学产品",
                                "iTitle": "*林产化学产品*林产化学产品",
                                "children": [
                                    {
                                        "id": "1756",
                                        "linkid": "1755",
                                        "code": "107021601",
                                        "paCode": "1070216",
                                        "yn": "N",
                                        "title": "松节油类产品",
                                        "alias": "松节油类产品",
                                        "about": "指利用松节油制成的相关产品",
                                        "kws": "松节油、脂松节油、木松节油、浮油松节油、硫酸盐松节油、松油、萜烯油、粗制二聚戊烯、对异丙基苯甲烷、萜稀树脂、松油醇、松油精、松节油深加工产品",
                                        "taxName": "林产化学产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070216010000000000",
                                        "taxCodeTitle": "林产化学产品",
                                        "iTitle": "*林产化学产品*松节油类产品",
                                        "children": []
                                    },
                                    {
                                        "id": "1757",
                                        "linkid": "1755",
                                        "code": "107021602",
                                        "paCode": "1070216",
                                        "yn": "N",
                                        "title": "松香类产品",
                                        "alias": "松香类产品",
                                        "about": "指利用松香制成的相关产品",
                                        "kws": "脂松香、木松香、浮油松香、松香、氢化松香、歧化松香、聚合松香、马来松香、改性松香、歧化松香钾造、酚醛改性松香、酚醛改性松香甘油酯、松香衍生物、树脂酸、酯胶、松香精、松香油、松香类产品",
                                        "taxName": "林产化学产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070216020000000000",
                                        "taxCodeTitle": "林产化学产品",
                                        "iTitle": "*林产化学产品*松香类产品",
                                        "children": []
                                    },
                                    {
                                        "id": "1758",
                                        "linkid": "1755",
                                        "code": "107021603",
                                        "paCode": "1070216",
                                        "yn": "N",
                                        "title": "栲胶",
                                        "alias": "栲胶",
                                        "about": "包括落叶松栲胶、桕梅栲胶、油柑栲胶、黑荆树栲胶、槲树栲胶、红根栲胶、木麻黄栲胶、橡碗栲胶、化香果栲胶、混合栲胶",
                                        "kws": "落叶松栲胶、桕梅栲胶、油柑栲胶、黑荆树栲胶、槲树栲胶、红根栲胶、木麻黄栲胶、橡碗栲胶、化香果栲胶、混合栲胶、水解类单宁栲胶、凝缩类单宁栲胶、类栲胶产品",
                                        "taxName": "林产化学产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070216030000000000",
                                        "taxCodeTitle": "林产化学产品",
                                        "iTitle": "*林产化学产品*栲胶",
                                        "children": []
                                    },
                                    {
                                        "id": "1759",
                                        "linkid": "1755",
                                        "code": "107021604",
                                        "paCode": "1070216",
                                        "yn": "N",
                                        "title": "樟脑",
                                        "alias": "樟脑",
                                        "about": "樟脑为樟科植物樟的枝、干、叶及根部，经提炼制得的颗粒状结晶，包括天然樟脑和合成樟脑",
                                        "kws": "天然樟脑、合成樟脑",
                                        "taxName": "林产化学产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070216040000000000",
                                        "taxCodeTitle": "林产化学产品",
                                        "iTitle": "*林产化学产品*樟脑",
                                        "children": []
                                    },
                                    {
                                        "id": "1760",
                                        "linkid": "1755",
                                        "code": "107021605",
                                        "paCode": "1070216",
                                        "yn": "N",
                                        "title": "冰片（龙脑）",
                                        "alias": "冰片（龙脑）",
                                        "about": "是由菊科艾纳香茎叶或樟科植物龙脑樟枝叶经水蒸汽蒸馏并重结晶而得。包括天然冰片和合成冰片。",
                                        "kws": "天然冰片、合成冰片、片脑、桔片、艾片、龙脑香、梅花冰片、羯布罗香、梅花脑、冰片脑、梅冰",
                                        "taxName": "林产化学产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070216050000000000",
                                        "taxCodeTitle": "林产化学产品",
                                        "iTitle": "*林产化学产品*冰片（龙脑）",
                                        "children": []
                                    },
                                    {
                                        "id": "1761",
                                        "linkid": "1755",
                                        "code": "107021606",
                                        "paCode": "1070216",
                                        "yn": "N",
                                        "title": "五倍子单宁产品",
                                        "alias": "五倍子单宁产品",
                                        "about": null,
                                        "kws": "工业单宁酸、工业没食子酸、焦性没食子酸、药用草柔酸、五倍子单宁产品",
                                        "taxName": "林产化学产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070216060000000000",
                                        "taxCodeTitle": "林产化学产品",
                                        "iTitle": "*林产化学产品*五倍子单宁产品",
                                        "children": []
                                    },
                                    {
                                        "id": "1762",
                                        "linkid": "1755",
                                        "code": "107021607",
                                        "paCode": "1070216",
                                        "yn": "N",
                                        "title": "紫胶类产品",
                                        "alias": "紫胶类产品",
                                        "about": "利用紫胶制成的相关产品",
                                        "kws": "普通紫胶片、专用紫胶片、脱色紫胶片、改性紫胶片、漂白紫胶片、脱醋紫胶片、紫胶类产品",
                                        "taxName": "林产化学产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070216070000000000",
                                        "taxCodeTitle": "林产化学产品",
                                        "iTitle": "*林产化学产品*紫胶类产品",
                                        "children": []
                                    },
                                    {
                                        "id": "1763",
                                        "linkid": "1755",
                                        "code": "107021608",
                                        "paCode": "1070216",
                                        "yn": "N",
                                        "title": "木材热解、水解产品",
                                        "alias": "木材热解、水解产品",
                                        "about": "利用热解、水解的化学方法将树木组织或造材剩余物加工而成的非木材的其他林、副产品",
                                        "kws": "木炭、焦木水、木焦油、松焦油、木材热解产品、木糖醇、木素、水解饲料酵母、植物沥青、木沥青、松香沥青、硫酸盐沥青",
                                        "taxName": "林产化学产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070216080000000000",
                                        "taxCodeTitle": "林产化学产品",
                                        "iTitle": "*林产化学产品*木材热解、水解产品",
                                        "children": []
                                    },
                                    {
                                        "id": "1764",
                                        "linkid": "1755",
                                        "code": "107021609",
                                        "paCode": "1070216",
                                        "yn": "N",
                                        "title": "竹材热解产品",
                                        "alias": "竹材热解产品",
                                        "about": "利用热解的方法将竹材组织或造材剩余物加工而成的非竹材的其他林、副产品",
                                        "kws": "竹炭、竹材热解产品",
                                        "taxName": "林产化学产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070216090000000000",
                                        "taxCodeTitle": "林产化学产品",
                                        "iTitle": "*林产化学产品*竹材热解产品",
                                        "children": []
                                    },
                                    {
                                        "id": "1765",
                                        "linkid": "1755",
                                        "code": "107021610",
                                        "paCode": "1070216",
                                        "yn": "N",
                                        "title": "林产色素（紫胶红色素）",
                                        "alias": "林产色素（紫胶红色素）",
                                        "about": "从豆科、桑科植物上的紫胶虫（Laccifelacca）的雌虫所分泌的树脂状物质紫胶，用稀碳酸钠水溶液萃取、精制而得。",
                                        "kws": "紫胶红、虫胶红、虫胶红色素、紫胶色素、林产色素、紫胶红色素",
                                        "taxName": "林产化学产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070216100000000000",
                                        "taxCodeTitle": "林产化学产品",
                                        "iTitle": "*林产化学产品*林产色素（紫胶红色素）",
                                        "children": []
                                    },
                                    {
                                        "id": "1766",
                                        "linkid": "1755",
                                        "code": "107021611",
                                        "paCode": "1070216",
                                        "yn": "N",
                                        "title": "林产蜡（虫白蜡）",
                                        "alias": "林产蜡（虫白蜡）",
                                        "about": "中药名。为介壳虫科昆虫白蜡虫的雄虫群栖于木犀科植物白蜡树、女贞或女贞属他种植物枝干上分泌的蜡，经精制而成。常作为赋形剂，制丸、片的润滑剂。",
                                        "kws": "白蜡、虫蜡、木蜡、树蜡、蜡膏、林产蜡、虫白蜡",
                                        "taxName": "林产化学产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070216110000000000",
                                        "taxCodeTitle": "林产化学产品",
                                        "iTitle": "*林产化学产品*林产蜡（虫白蜡）",
                                        "children": []
                                    },
                                    {
                                        "id": "1767",
                                        "linkid": "1755",
                                        "code": "107021612",
                                        "paCode": "1070216",
                                        "yn": "N",
                                        "title": "桃胶粉",
                                        "alias": "桃胶粉",
                                        "about": "桃胶粉是一种无外来可见杂质、白色或乳黄色粉末的添加剂。",
                                        "kws": "桃胶粉",
                                        "taxName": "林产化学产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070216120000000000",
                                        "taxCodeTitle": "林产化学产品",
                                        "iTitle": "*林产化学产品*桃胶粉",
                                        "children": []
                                    },
                                    {
                                        "id": "1768",
                                        "linkid": "1755",
                                        "code": "107021613",
                                        "paCode": "1070216",
                                        "yn": "N",
                                        "title": "糠醛",
                                        "alias": "糠醛",
                                        "about": null,
                                        "kws": "糠醛",
                                        "taxName": "林产化学产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070216130000000000",
                                        "taxCodeTitle": "林产化学产品",
                                        "iTitle": "*林产化学产品*糠醛",
                                        "children": []
                                    },
                                    {
                                        "id": "1769",
                                        "linkid": "1755",
                                        "code": "107021614",
                                        "paCode": "1070216",
                                        "yn": "N",
                                        "title": "阿拉伯糖",
                                        "alias": "阿拉伯糖",
                                        "about": null,
                                        "kws": "阿拉伯糖",
                                        "taxName": "林产化学产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070216140000000000",
                                        "taxCodeTitle": "林产化学产品",
                                        "iTitle": "*林产化学产品*阿拉伯糖",
                                        "children": []
                                    },
                                    {
                                        "id": "1770",
                                        "linkid": "1755",
                                        "code": "107021615",
                                        "paCode": "1070216",
                                        "yn": "N",
                                        "title": "木质素",
                                        "alias": "木质素",
                                        "about": null,
                                        "kws": "木素",
                                        "taxName": "林产化学产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070216150000000000",
                                        "taxCodeTitle": "林产化学产品",
                                        "iTitle": "*林产化学产品*木质素",
                                        "children": []
                                    },
                                    {
                                        "id": "1771",
                                        "linkid": "1755",
                                        "code": "107021616",
                                        "paCode": "1070216",
                                        "yn": "N",
                                        "title": "纤维素",
                                        "alias": "纤维素",
                                        "about": null,
                                        "kws": "纤维素",
                                        "taxName": "林产化学产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070216160000000000",
                                        "taxCodeTitle": "林产化学产品",
                                        "iTitle": "*林产化学产品*纤维素",
                                        "children": []
                                    },
                                    {
                                        "id": "1772",
                                        "linkid": "1755",
                                        "code": "107021699",
                                        "paCode": "1070216",
                                        "yn": "N",
                                        "title": "其他林产化学产品",
                                        "alias": "其他林产化学产品",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "林产化学产品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070216990000000000",
                                        "taxCodeTitle": "林产化学产品",
                                        "iTitle": "*林产化学产品*其他林产化学产品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1773",
                                "linkid": "1226",
                                "code": "1070217",
                                "paCode": "10702",
                                "yn": "Y",
                                "title": "炸药、烟火及火工产品",
                                "alias": "炸药、烟火及火工产品",
                                "about": null,
                                "kws": null,
                                "taxName": "炸药烟火",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070217000000000000",
                                "taxCodeTitle": "炸药烟火",
                                "iTitle": "*炸药烟火*炸药、烟火及火工产品",
                                "children": [
                                    {
                                        "id": "1774",
                                        "linkid": "1773",
                                        "code": "107021701",
                                        "paCode": "1070217",
                                        "yn": "N",
                                        "title": "发射药",
                                        "alias": "发射药",
                                        "about": "指装在枪炮弹膛内用以发射弹丸的火药。",
                                        "kws": "黑色火药、火器用发射药、无烟药、复合药、火箭用发射药、均相发射药、复合发射药",
                                        "taxName": "炸药烟火",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070217010000000000",
                                        "taxCodeTitle": "炸药烟火",
                                        "iTitle": "*炸药烟火*发射药",
                                        "children": []
                                    },
                                    {
                                        "id": "1775",
                                        "linkid": "1773",
                                        "code": "107021702",
                                        "paCode": "1070217",
                                        "yn": "N",
                                        "title": "炸药",
                                        "alias": "炸药",
                                        "about": "指配制炸药，不包括发射药（详见107021701）。",
                                        "kws": "铵油类炸药、乳化炸药、铵锑类炸药、硝铵炸药、硝化甘油炸药、谢德炸药、起爆炸药、配制炸药",
                                        "taxName": "炸药烟火",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070217020000000000",
                                        "taxCodeTitle": "炸药烟火",
                                        "iTitle": "*炸药烟火*炸药",
                                        "children": []
                                    },
                                    {
                                        "id": "1776",
                                        "linkid": "1773",
                                        "code": "107021703",
                                        "paCode": "1070217",
                                        "yn": "N",
                                        "title": "火工产品",
                                        "alias": "火工产品",
                                        "about": "指装有火药或炸药，受外界刺激后产生燃烧或爆炸，以引燃火药、引爆炸药或做机械功的一次性使用的元器件和装置的总称。",
                                        "kws": "雷管、火雷管、电雷管、磁电雷管、导爆管雷管、塑料导爆管、继爆管、引信火帽、底火火帽、药筒火帽、摩擦火帽、撞击火帽、电底火、火帽、导火索、导爆索、切割索、引火线、索类火工品、引爆器、起爆器、电引爆器、化学引爆器",
                                        "taxName": "炸药烟火",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070217030000000000",
                                        "taxCodeTitle": "炸药烟火",
                                        "iTitle": "*炸药烟火*火工产品",
                                        "children": []
                                    },
                                    {
                                        "id": "1777",
                                        "linkid": "1773",
                                        "code": "107021704",
                                        "paCode": "1070217",
                                        "yn": "N",
                                        "title": "爆破器材",
                                        "alias": "爆破器材",
                                        "about": "用于爆破的炸药、火具、爆破器、核爆破装置、起爆器、导电线和检测仪表等的统称。包括地震勘探用爆破器材",
                                        "kws": "震源药柱、震源弹、聚能射孔弹、复合射孔器、聚能切割弹、高能气体压裂弹、平炉出钢口穿孔弹、爆破器材",
                                        "taxName": "炸药烟火",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070217040000000000",
                                        "taxCodeTitle": "炸药烟火",
                                        "iTitle": "*炸药烟火*爆破器材",
                                        "children": []
                                    },
                                    {
                                        "id": "1778",
                                        "linkid": "1773",
                                        "code": "107021705",
                                        "paCode": "1070217",
                                        "yn": "N",
                                        "title": "烟火制品",
                                        "alias": "烟火制品",
                                        "about": "指供娱乐或其他用途的含有通过放热化学反应产生热、光、声、气或烟雾的物质或物质混合物的任何物品。",
                                        "kws": "信号弹、闪光弹、彩光弹、降雨火箭、抗冰雹火箭、抗冰雹弹、烟雾发生器、救生索火箭、技术用烟火制品、彩光元件、导向元件、烟火假目标、烟雾元件、烟火制品元件、烟火制品",
                                        "taxName": "炸药烟火",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070217050000000000",
                                        "taxCodeTitle": "炸药烟火",
                                        "iTitle": "*炸药烟火*烟火制品",
                                        "children": []
                                    },
                                    {
                                        "id": "1779",
                                        "linkid": "1773",
                                        "code": "107021706",
                                        "paCode": "1070217",
                                        "yn": "Y",
                                        "title": "焰火制品",
                                        "alias": "焰火制品",
                                        "about": "包括烟花和爆竹",
                                        "kws": "火炬、烟花、爆竹",
                                        "taxName": "炸药烟火",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1070217060000000000",
                                        "taxCodeTitle": "炸药烟火",
                                        "iTitle": "*炸药烟火*焰火制品",
                                        "children": [
                                            {
                                                "id": "1780",
                                                "linkid": "1779",
                                                "code": "10702170601",
                                                "paCode": "107021706",
                                                "yn": "N",
                                                "title": "烟花",
                                                "alias": "烟花",
                                                "about": "又名焰火",
                                                "kws": "花炮、烟火、焰火、烟花、地面烟花、玩具烟花、架子烟花、水上烟花、冷烟花、舞台烟花",
                                                "taxName": "炸药烟火",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070217060100000000",
                                                "taxCodeTitle": "炸药烟火",
                                                "iTitle": "*炸药烟火*烟花",
                                                "children": []
                                            },
                                            {
                                                "id": "1781",
                                                "linkid": "1779",
                                                "code": "10702170602",
                                                "paCode": "107021706",
                                                "yn": "N",
                                                "title": "爆竹",
                                                "alias": "爆竹",
                                                "about": "又名鞭炮",
                                                "kws": "爆仗、炮仗、鞭炮",
                                                "taxName": "炸药烟火",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070217060200000000",
                                                "taxCodeTitle": "炸药烟火",
                                                "iTitle": "*炸药烟火*爆竹",
                                                "children": []
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "id": "1782",
                                "linkid": "1226",
                                "code": "1070218",
                                "paCode": "10702",
                                "yn": "Y",
                                "title": "信息化学品",
                                "alias": "信息化学品",
                                "about": "指电影、照相、医用、幻灯及投影用的感光材料、冲洗套药，磁、光记录材料，光纤维通讯用辅助材料，及其专用化学制剂。",
                                "kws": null,
                                "taxName": "信息化学品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070218000000000000",
                                "taxCodeTitle": "信息化学品",
                                "iTitle": "*信息化学品*信息化学品",
                                "children": [
                                    {
                                        "id": "1783",
                                        "linkid": "1782",
                                        "code": "107021801",
                                        "paCode": "1070218",
                                        "yn": "N",
                                        "title": "感光胶片",
                                        "alias": "感光胶片",
                                        "about": "指银盐感光胶片，也叫菲林。由PC/PP/PET/PVC料制作而成。现在一般是指胶卷,也可以指印刷制版中的底片。",
                                        "kws": "彩色电影胶片、黑白电影胶片、彩色照相胶片、彩色照相胶卷、黑白照相胶片、黑白照相胶卷、一次成像感光胶片、X光用感光胶片、医用X光感光胶片、医用X光影象胶片、工业用X光感光胶片、用途X光感光胶片、激光照排胶片、激光影像胶片、PS版、预涂感光版、CTP版、照相制版用硬片和软片、照相制版用胶卷、激光照排片、制版用涂卤化银无齿孔胶卷、制印刷电路板光致抗蚀干膜、幻灯胶片、彩色幻灯胶片、黑白幻灯胶片、彩色缩微胶卷、黑白缩微胶卷、缩微胶片、彩色微型胶卷、微型胶卷、感光胶片",
                                        "taxName": "信息化学品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070218010000000000",
                                        "taxCodeTitle": "信息化学品",
                                        "iTitle": "*信息化学品*感光胶片",
                                        "children": []
                                    },
                                    {
                                        "id": "1784",
                                        "linkid": "1782",
                                        "code": "107021802",
                                        "paCode": "1070218",
                                        "yn": "N",
                                        "title": "摄影感光纸、纸板及纺织物",
                                        "alias": "摄影感光纸、纸板及纺织物",
                                        "about": "指摄影感光纸及传真纸、照排纸、示波记录纸和其他工业技术用的感光纸。",
                                        "kws": "彩色摄影用感光纸、非彩色摄影用感光纸、摄影感光纸板、彩色摄影用感光纸板、非彩色摄影用感光纸板、摄影感光纺织物、彩色摄影用感光纺织物、非彩色摄影用感光纺织物",
                                        "taxName": "信息化学品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070218020000000000",
                                        "taxCodeTitle": "信息化学品",
                                        "iTitle": "*信息化学品*摄影感光纸、纸板及纺织物",
                                        "children": []
                                    },
                                    {
                                        "id": "1785",
                                        "linkid": "1782",
                                        "code": "107021803",
                                        "paCode": "1070218",
                                        "yn": "N",
                                        "title": "片基",
                                        "alias": "片基",
                                        "about": "感光胶片的支持体，是一种具有透明、柔软特性和一定机械强度的塑料薄膜",
                                        "kws": "醋酸纤维素片基、聚酯片基",
                                        "taxName": "信息化学品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070218030000000000",
                                        "taxCodeTitle": "信息化学品",
                                        "iTitle": "*信息化学品*片基",
                                        "children": []
                                    },
                                    {
                                        "id": "1786",
                                        "linkid": "1782",
                                        "code": "107021804",
                                        "paCode": "1070218",
                                        "yn": "N",
                                        "title": "摄影、复印用化学制剂",
                                        "alias": "摄影、复印用化学制剂",
                                        "about": "用于摄影、复印的化学制剂",
                                        "kws": "摄影用感光乳液、摄影用显影剂、摄影用漂白剂、摄影用定影剂、摄影用增厚剂、摄影用减薄剂、摄影用调色剂、摄影用去污渍剂、摄影用消泡剂、摄影用成色剂、摄影用坚膜剂、摄影用稳定剂、摄影用增粘剂、摄影用增墨剂、摄影用表面活性剂、摄影用光刻胶、摄影用化学制剂、复印机用化学制剂",
                                        "taxName": "信息化学品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070218040000000000",
                                        "taxCodeTitle": "信息化学品",
                                        "iTitle": "*信息化学品*摄影、复印用化学制剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1787",
                                        "linkid": "1782",
                                        "code": "107021805",
                                        "paCode": "1070218",
                                        "yn": "N",
                                        "title": "空白磁带",
                                        "alias": "空白磁带",
                                        "about": "磁带包括录音磁带和录像磁带；折算方法：磁带（折6.3mm）产量=产品实际宽度（mm）／6.3（mm）×产品实际长度",
                                        "kws": "未录制录音带、未录制录像带、计算机用空白磁带、空白磁带",
                                        "taxName": "信息化学品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070218050000000000",
                                        "taxCodeTitle": "信息化学品",
                                        "iTitle": "*信息化学品*空白磁带",
                                        "children": []
                                    },
                                    {
                                        "id": "1788",
                                        "linkid": "1782",
                                        "code": "107021806",
                                        "paCode": "1070218",
                                        "yn": "N",
                                        "title": "空白磁盘",
                                        "alias": "空白磁盘",
                                        "about": "一种类似磁带装置的计算机的外部存储器",
                                        "kws": "软磁盘、空白磁盘",
                                        "taxName": "信息化学品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070218060000000000",
                                        "taxCodeTitle": "信息化学品",
                                        "iTitle": "*信息化学品*空白磁盘",
                                        "children": []
                                    },
                                    {
                                        "id": "1789",
                                        "linkid": "1782",
                                        "code": "107021807",
                                        "paCode": "1070218",
                                        "yn": "N",
                                        "title": "空盘",
                                        "alias": "空盘",
                                        "about": "指空白的信息存储材料",
                                        "kws": "空白光盘、空白唱盘、空盘",
                                        "taxName": "信息化学品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070218070000000000",
                                        "taxCodeTitle": "信息化学品",
                                        "iTitle": "*信息化学品*空盘",
                                        "children": []
                                    },
                                    {
                                        "id": "1790",
                                        "linkid": "1782",
                                        "code": "107021808",
                                        "paCode": "1070218",
                                        "yn": "N",
                                        "title": "未灌（录）制相关媒体",
                                        "alias": "未灌（录）制相关媒体",
                                        "about": "包括磁片、磁条、金属条、蜡盘等",
                                        "kws": "磁片、磁条、金属条、蜡盘",
                                        "taxName": "信息化学品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070218080000000000",
                                        "taxCodeTitle": "信息化学品",
                                        "iTitle": "*信息化学品*未灌（录）制相关媒体",
                                        "children": []
                                    },
                                    {
                                        "id": "1791",
                                        "linkid": "1782",
                                        "code": "107021809",
                                        "paCode": "1070218",
                                        "yn": "N",
                                        "title": "电子半导体材料",
                                        "alias": "电子半导体材料",
                                        "about": "经掺杂用于电子工业的已切片化学元素等",
                                        "kws": "单晶硅、多晶硅、单晶硅片、多晶硅片、硅外延片、单晶锗片、砷化镓单晶片、砷化镓外延片、铌酸锂单晶片、钽酸锂单晶片、电子半导体材料",
                                        "taxName": "信息化学品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070218090000000000",
                                        "taxCodeTitle": "信息化学品",
                                        "iTitle": "*信息化学品*电子半导体材料",
                                        "children": []
                                    },
                                    {
                                        "id": "1792",
                                        "linkid": "1782",
                                        "code": "107021899",
                                        "paCode": "1070218",
                                        "yn": "N",
                                        "title": "其他信息化学品",
                                        "alias": "其他信息化学品",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "信息化学品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070218990000000000",
                                        "taxCodeTitle": "信息化学品",
                                        "iTitle": "*信息化学品*其他信息化学品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1793",
                                "linkid": "1226",
                                "code": "1070219",
                                "paCode": "10702",
                                "yn": "Y",
                                "title": "环境污染处理专用药剂材料",
                                "alias": "环境污染处理专用药剂材料",
                                "about": null,
                                "kws": null,
                                "taxName": "环境污染处理剂",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1070219000000000000",
                                "taxCodeTitle": "环境污染处理剂",
                                "iTitle": "*环境污染处理剂*环境污染处理专用药剂材料",
                                "children": [
                                    {
                                        "id": "1794",
                                        "linkid": "1793",
                                        "code": "107021901",
                                        "paCode": "1070219",
                                        "yn": "N",
                                        "title": "水处理剂",
                                        "alias": "水处理剂",
                                        "about": "指自来水净化过程中所用水处理剂。",
                                        "kws": "KDS-501铜缓蚀剂BTA、KDS-502甲基苯三唑、KDS-503铜缓蚀剂、KDS-504酸洗缓蚀剂、KDS-505酸洗缓蚀剂、水处理缓蚀剂、清洗预膜剂、KDS-101清洗剂、KDS-102消泡剂、KDS-103消泡剂、KDS-104预膜剂、阻垢分散剂、水解聚马来酸酐、氨基三亚甲基膦酸、羟基亚乙基二膦酸、水质稳定剂、软水剂、净水剂、KDS-801蒸汽锅炉阻垢剂、KDS-802蒸汽锅炉除氧剂、KDS-803热水锅炉除氧剂、锅炉水处理剂、KDS-315阻垢缓蚀剂、KDS-316阻垢缓蚀剂、KDS-317缓",
                                        "taxName": "环境污染处理剂",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070219010000000000",
                                        "taxCodeTitle": "环境污染处理剂",
                                        "iTitle": "*环境污染处理剂*水处理剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1795",
                                        "linkid": "1793",
                                        "code": "107021902",
                                        "paCode": "1070219",
                                        "yn": "N",
                                        "title": "污水处理化学药剂",
                                        "alias": "污水处理化学药剂",
                                        "about": "指污水处理过程需要使用的化学药剂。",
                                        "kws": "二氧化氯消毒剂、溴类杀菌剂、杀菌粘泥剥离剂、JH-704高效杀菌灭藻剂、JH-711B缓释型杀菌灭藻剂、复合非氧化性杀菌剂、杀菌灭藻剂、聚丙烯酰胺、PAM、聚丙烯酸、有机混凝剂、复合混凝剂PISC、聚合双酸铝铁高效净水剂、多元高分子水处理絮凝剂、无机混凝剂、污水处理化学药剂",
                                        "taxName": "环境污染处理剂",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070219020000000000",
                                        "taxCodeTitle": "环境污染处理剂",
                                        "iTitle": "*环境污染处理剂*污水处理化学药剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1796",
                                        "linkid": "1793",
                                        "code": "107021903",
                                        "paCode": "1070219",
                                        "yn": "N",
                                        "title": "污水处理生物药剂",
                                        "alias": "污水处理生物药剂",
                                        "about": "指污水处理过程需要使用的生物药剂。",
                                        "kws": "生物混凝剂、生物脱色剂、生物除臭剂、污水处理生物药剂",
                                        "taxName": "环境污染处理剂",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070219030000000000",
                                        "taxCodeTitle": "环境污染处理剂",
                                        "iTitle": "*环境污染处理剂*污水处理生物药剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1797",
                                        "linkid": "1793",
                                        "code": "107021904",
                                        "paCode": "1070219",
                                        "yn": "N",
                                        "title": "污水处理材料",
                                        "alias": "污水处理材料",
                                        "about": "指污水处理过程需要使用的材料。",
                                        "kws": "有机滤料、无机滤料、微滤膜、微滤膜组件、超滤膜、超滤膜组件、反渗透膜、反渗透膜膜组件、电渗析膜、吸附材料、膜材料",
                                        "taxName": "环境污染处理剂",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070219040000000000",
                                        "taxCodeTitle": "环境污染处理剂",
                                        "iTitle": "*环境污染处理剂*污水处理材料",
                                        "children": []
                                    },
                                    {
                                        "id": "1798",
                                        "linkid": "1793",
                                        "code": "107021905",
                                        "paCode": "1070219",
                                        "yn": "N",
                                        "title": "空气污染治理材料",
                                        "alias": "空气污染治理材料",
                                        "about": "指空气污染治理过程需要使用的材料。",
                                        "kws": "玻璃纤维滤料、合成纤维滤料、覆膜滤料、脱硫剂",
                                        "taxName": "环境污染处理剂",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070219050000000000",
                                        "taxCodeTitle": "环境污染处理剂",
                                        "iTitle": "*环境污染处理剂*空气污染治理材料",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1799",
                                "linkid": "1226",
                                "code": "1070220",
                                "paCode": "10702",
                                "yn": "Y",
                                "title": "动物炭黑、动物胶及其衍生物",
                                "alias": "动物炭黑、动物胶及其衍生物",
                                "about": "包括动物炭黑、动物胶及其衍生物",
                                "kws": null,
                                "taxName": "动物炭黑等",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070220000000000000",
                                "taxCodeTitle": "动物炭黑等",
                                "iTitle": "*动物炭黑等*动物炭黑、动物胶及其衍生物",
                                "children": [
                                    {
                                        "id": "1800",
                                        "linkid": "1799",
                                        "code": "107022001",
                                        "paCode": "1070220",
                                        "yn": "N",
                                        "title": "动物炭黑",
                                        "alias": "动物炭黑",
                                        "about": "动物尸体燃烧后剩下的产物炭黑",
                                        "kws": "骨炭黑、血炭黑、皮炭黑、角炭黑、动物炭黑",
                                        "taxName": "动物炭黑",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070220010000000000",
                                        "taxCodeTitle": "动物炭黑",
                                        "iTitle": "*动物炭黑*动物炭黑",
                                        "children": []
                                    },
                                    {
                                        "id": "1801",
                                        "linkid": "1799",
                                        "code": "107022002",
                                        "paCode": "1070220",
                                        "yn": "N",
                                        "title": "动物胶",
                                        "alias": "动物胶",
                                        "about": "指以动物的皮、骨或筋等为原料，将其中所含的胶原经过部分水解、萃取和干燥制成的蛋白质固形物。",
                                        "kws": "明胶、皮胶、骨胶、鱼胶、筋胶、腱胶、动物胶",
                                        "taxName": "动物胶",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070220020000000000",
                                        "taxCodeTitle": "动物胶",
                                        "iTitle": "*动物胶*动物胶",
                                        "children": []
                                    },
                                    {
                                        "id": "1802",
                                        "linkid": "1799",
                                        "code": "107022003",
                                        "paCode": "1070220",
                                        "yn": "N",
                                        "title": "明胶衍生物",
                                        "alias": "明胶衍生物",
                                        "about": null,
                                        "kws": "鞣酸明胶、溴化鞣酸明胶、明胶衍生物",
                                        "taxName": "明胶衍生物",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070220030000000000",
                                        "taxCodeTitle": "明胶衍生物",
                                        "iTitle": "*明胶衍生物*明胶衍生物",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1803",
                                "linkid": "1226",
                                "code": "1070221",
                                "paCode": "10702",
                                "yn": "Y",
                                "title": "焊接用制品",
                                "alias": "焊接用制品",
                                "about": null,
                                "kws": null,
                                "taxName": "焊接用制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070221000000000000",
                                "taxCodeTitle": "焊接用制品",
                                "iTitle": "*焊接用制品*焊接用制品",
                                "children": [
                                    {
                                        "id": "1804",
                                        "linkid": "1803",
                                        "code": "107022101",
                                        "paCode": "1070221",
                                        "yn": "N",
                                        "title": "金属材料制焊料",
                                        "alias": "金属材料制焊料",
                                        "about": "指用于填加到焊缝、堆焊层和钎缝中的金属合金材料的总称",
                                        "kws": "银铜焊粉、锡合金焊粉、无铅焊粉、焊粉、焊膏、银铜焊丝、低合金焊丝、不锈钢焊丝、焊丝",
                                        "taxName": "焊接用制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070221010000000000",
                                        "taxCodeTitle": "焊接用制品",
                                        "iTitle": "*焊接用制品*金属材料制焊料",
                                        "children": []
                                    },
                                    {
                                        "id": "1805",
                                        "linkid": "1803",
                                        "code": "107022102",
                                        "paCode": "1070221",
                                        "yn": "N",
                                        "title": "焊接辅助剂",
                                        "alias": "焊接辅助剂",
                                        "about": null,
                                        "kws": "助焊剂、焊嘴防堵剂、低碳铌铁、搪锡助焊剂、焊条粘接剂、焊接辅助剂",
                                        "taxName": "焊接用制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070221020000000000",
                                        "taxCodeTitle": "焊接用制品",
                                        "iTitle": "*焊接用制品*焊接辅助剂",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1806",
                                "linkid": "1226",
                                "code": "1070222",
                                "paCode": "10702",
                                "yn": "Y",
                                "title": "肥皂及合成洗涤剂",
                                "alias": "肥皂及合成洗涤剂",
                                "about": "包括产品及其水溶液，以喷洒、涂抹、浸泡等方式施于肌肤、器皿、织物，即冲即洗，起到清洁、去污、护理、除菌等功能的产品及其中间体表面活性剂",
                                "kws": null,
                                "taxName": "洗涤剂",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1070222000000000000",
                                "taxCodeTitle": "洗涤剂",
                                "iTitle": "*洗涤剂*肥皂及合成洗涤剂",
                                "children": [
                                    {
                                        "id": "1807",
                                        "linkid": "1806",
                                        "code": "107022201",
                                        "paCode": "1070222",
                                        "yn": "N",
                                        "title": "肥（香）皂",
                                        "alias": "肥（香）皂",
                                        "about": "包括各种形状、类型、功能，以脂肪酸钠盐为主体成分的皂类洗涤用品",
                                        "kws": "普通洗衣皂、复合洗衣皂、洗衣皂、普通香皂、功能性香皂、香皂、皂粉、肥皂",
                                        "taxName": "洗涤剂",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070222010000000000",
                                        "taxCodeTitle": "洗涤剂",
                                        "iTitle": "*洗涤剂*肥（香）皂",
                                        "children": []
                                    },
                                    {
                                        "id": "1808",
                                        "linkid": "1806",
                                        "code": "107022202",
                                        "paCode": "1070222",
                                        "yn": "N",
                                        "title": "合成洗涤剂",
                                        "alias": "合成洗涤剂",
                                        "about": "以表面活性剂为主体，配制、成型的粉状、膏状、液体状产品；供家庭、工业及公共设施用清洁洗涤剂",
                                        "kws": "普通洗衣粉、浓缩洗衣粉、工业用洗衣粉、洗衣粉、餐具、果蔬洗涤剂、衣用用洗涤剂、织物用洗涤剂、家居清洁护理剂、液体洗涤剂、工业清洗剂、公共设施、环境卫生洗涤清洁剂、合成洗涤剂",
                                        "taxName": "洗涤剂",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070222020000000000",
                                        "taxCodeTitle": "洗涤剂",
                                        "iTitle": "*洗涤剂*合成洗涤剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1809",
                                        "linkid": "1806",
                                        "code": "107022203",
                                        "paCode": "1070222",
                                        "yn": "N",
                                        "title": "表面活性剂",
                                        "alias": "表面活性剂",
                                        "about": "有机合成的化学品，具有润湿、渗透、乳化、分散作用，系合成洗涤剂的主体成分",
                                        "kws": "烷基苯磺酸盐、烷基硫酸盐、钠盐、胺盐、脂肪醇醚硫酸盐、烯基磺酸盐、脂肪酸甲酯磺酸盐、烷基磷酸酯盐、烷基醚磷酸酯盐、阴离子表面活性剂、烷基甲基季铵盐、双酯基乙基甲基季铵盐、咪唑啉型季铵盐、阳离子表面活性剂、非离子型表面活性剂、表面活性剂",
                                        "taxName": "洗涤剂",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070222030000000000",
                                        "taxCodeTitle": "洗涤剂",
                                        "iTitle": "*洗涤剂*表面活性剂",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1810",
                                "linkid": "1226",
                                "code": "1070223",
                                "paCode": "10702",
                                "yn": "Y",
                                "title": "美容、护肤、护发产品",
                                "alias": "美容、护肤、护发产品",
                                "about": "指施于人体表面的美容、护肤、护发及类似化妆品",
                                "kws": null,
                                "taxName": "美容护肤品",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1070223000000000000",
                                "taxCodeTitle": "美容护肤品",
                                "iTitle": "*美容护肤品*美容、护肤、护发产品",
                                "children": [
                                    {
                                        "id": "1811",
                                        "linkid": "1810",
                                        "code": "107022301",
                                        "paCode": "1070223",
                                        "yn": "N",
                                        "title": "清洁类化妆品",
                                        "alias": "清洁类化妆品",
                                        "about": "指个人清洁护理用品",
                                        "kws": "洗面奶、洗手液、洗发剂、香波、浴液、沐浴用制剂、浴盐、沐浴剂、人体除臭剂、止汗剂、剃须用制剂、面膜、花露水、痱子粉、爽身粉、清洁类化妆品",
                                        "taxName": "美容护肤品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070223010000000000",
                                        "taxCodeTitle": "美容护肤品",
                                        "iTitle": "*美容护肤品*清洁类化妆品",
                                        "children": []
                                    },
                                    {
                                        "id": "1812",
                                        "linkid": "1810",
                                        "code": "107022302",
                                        "paCode": "1070223",
                                        "yn": "N",
                                        "title": "护肤用化妆品",
                                        "alias": "护肤用化妆品",
                                        "about": "指个人护肤护理用品",
                                        "kws": "护肤膏霜、护肤乳液、护手霜、护甲水、润唇膏、眼用护肤膏、眼用护肤霜、化妆水、护肤啫喱膏、护肤啫喱水、粉底霜、护肤用化妆品",
                                        "taxName": "美容护肤品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070223020000000000",
                                        "taxCodeTitle": "美容护肤品",
                                        "iTitle": "*美容护肤品*护肤用化妆品",
                                        "children": []
                                    },
                                    {
                                        "id": "1813",
                                        "linkid": "1810",
                                        "code": "107022303",
                                        "paCode": "1070223",
                                        "yn": "N",
                                        "title": "护发用化妆品",
                                        "alias": "护发用化妆品",
                                        "about": "指个人护发护理用品",
                                        "kws": "烫发剂、染发剂、定型剂、护发素、发用啫喱膏、啫喱水、护发用化妆品",
                                        "taxName": "美容护肤品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070223030000000000",
                                        "taxCodeTitle": "美容护肤品",
                                        "iTitle": "*美容护肤品*护发用化妆品",
                                        "children": []
                                    },
                                    {
                                        "id": "1814",
                                        "linkid": "1810",
                                        "code": "107022304",
                                        "paCode": "1070223",
                                        "yn": "N",
                                        "title": "美容、修饰类化妆品",
                                        "alias": "美容、修饰类化妆品",
                                        "about": "包括口红、唇膏、唇彩、唇线笔及其他唇用化妆品，香水及其他美容、修饰类化妆品",
                                        "kws": "唇用化妆品、眼用化妆品、香粉、香水、指趾甲化妆品",
                                        "taxName": "美容护肤品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070223040000000000",
                                        "taxCodeTitle": "美容护肤品",
                                        "iTitle": "*美容护肤品*美容、修饰类化妆品",
                                        "children": []
                                    },
                                    {
                                        "id": "1815",
                                        "linkid": "1810",
                                        "code": "107022305",
                                        "paCode": "1070223",
                                        "yn": "N",
                                        "title": "高档护肤类化妆品",
                                        "alias": "高档护肤类化妆品",
                                        "about": "指生产（进口）环节销售（完税）价格（不含增值税）在10元/毫升（克）或15元/片（张）及以上的个人护肤护理用品。",
                                        "kws": "护肤膏霜、护肤乳液、护手霜、护甲水、润唇膏、眼用护肤膏、眼用护肤霜、化妆水、护肤啫喱膏、护肤啫喱水、粉底霜、护肤用化妆品",
                                        "taxName": "美容护肤品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070223050000000000",
                                        "taxCodeTitle": "美容护肤品",
                                        "iTitle": "*美容护肤品*高档护肤类化妆品",
                                        "children": []
                                    },
                                    {
                                        "id": "1816",
                                        "linkid": "1810",
                                        "code": "107022306",
                                        "paCode": "1070223",
                                        "yn": "N",
                                        "title": "高档美容、修饰类化妆品",
                                        "alias": "高档美容、修饰类化妆品",
                                        "about": "指生产（进口）环节销售（完税）价格（不含增值税）在10元/毫升（克）或15元/片（张）及以上的美容、修饰类化妆品。包括口红、唇膏、唇彩、唇线笔及其他唇用化妆品，香水及其他美容、修饰类化妆品",
                                        "kws": "护肤膏霜、护肤乳液、护手霜、护甲水、润唇膏、眼用护肤膏、眼用护肤霜、化妆水、护肤啫喱膏、护肤啫喱水、粉底霜、护肤用化妆品",
                                        "taxName": "美容护肤品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070223060000000000",
                                        "taxCodeTitle": "美容护肤品",
                                        "iTitle": "*美容护肤品*高档美容、修饰类化妆品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1817",
                                "linkid": "1226",
                                "code": "1070224",
                                "paCode": "10702",
                                "yn": "Y",
                                "title": "口腔清洁护理用品",
                                "alias": "口腔清洁护理用品",
                                "about": "指个人口腔清洁护理用品",
                                "kws": null,
                                "taxName": "口腔清洁护理品",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1070224000000000000",
                                "taxCodeTitle": "口腔清洁护理品",
                                "iTitle": "*口腔清洁护理品*口腔清洁护理用品",
                                "children": [
                                    {
                                        "id": "1818",
                                        "linkid": "1817",
                                        "code": "107022401",
                                        "paCode": "1070224",
                                        "yn": "N",
                                        "title": "牙膏、漱口液",
                                        "alias": "牙膏、漱口液",
                                        "about": null,
                                        "kws": "牙贴、牙凝胶、牙涂液、牙线、固齿膏、固齿粉、洁齿、护齿品、漱口液、口腔喷雾剂、口腔香水、假牙清洗剂、假牙胶、假牙模膏、假牙模粉、假牙模片、牙齿增白品、口腔牙齿清洁剂",
                                        "taxName": "口腔清洁护理品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070224010000000000",
                                        "taxCodeTitle": "口腔清洁护理品",
                                        "iTitle": "*口腔清洁护理品*牙膏、漱口液",
                                        "children": []
                                    },
                                    {
                                        "id": "1819",
                                        "linkid": "1817",
                                        "code": "107022499",
                                        "paCode": "1070224",
                                        "yn": "N",
                                        "title": "其他口腔清洁护理用品",
                                        "alias": "其他口腔清洁护理用品",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "口腔清洁护理品",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070224990000000000",
                                        "taxCodeTitle": "口腔清洁护理品",
                                        "iTitle": "*口腔清洁护理品*其他口腔清洁护理用品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1820",
                                "linkid": "1226",
                                "code": "1070225",
                                "paCode": "10702",
                                "yn": "N",
                                "title": "香料",
                                "alias": "香料",
                                "about": "含天然及合成，指具有香气和（或）香味的、用于调配各类香精的香原料；包括天然香料、生物技术香料和合成香料产品",
                                "kws": "香柠檬油、佛手油、橙油、柠檬油、白柠檬油、酸橙油、老鹳草油、香叶油、茉莉净油、薰衣草油、薄荷油、岩兰草油、香根油、香茅油、八角茴香油、肉桂油、山苍子油、桉叶油、玫瑰油、白兰花油、白兰叶油、树兰花油、椒样薄荷油、生姜油、广藿香油、留兰香油、柏木油、精油、桂花浸膏、白兰浸膏、赖百当浸膏、岩蔷薇浸膏、茉莉浸膏、鸢尾凝脂、枣子酊、油树脂、杭白菊浸膏、大花茉莉浸膏、浸提类香料、天然香料、天然薄荷脑、未列明天然香料、发酵法丁二酮、生物技术香料、薄荷醇、dl-薄荷脑、苯甲醛、合成香料、香草醛、香兰素、乙基香草醛、乙基香",
                                "taxName": "香料",
                                "taxRate": "13%",
                                "vip": "5",
                                "itaxRate": "0.13",
                                "taxCode": "1070225000000000000",
                                "taxCodeTitle": "香料",
                                "iTitle": "*香料*香料",
                                "children": []
                            },
                            {
                                "id": "1821",
                                "linkid": "1226",
                                "code": "1070226",
                                "paCode": "10702",
                                "yn": "Y",
                                "title": "香精",
                                "alias": "香精",
                                "about": "指以多种天然香料、合成香料等为主要原料和相应辅料组成的，用于起香气和（或）香味作用的浓缩调配混合物，包括热反应香精[指以食品加工方法加热食品原料和（或）食品组分生产的反应产物，加入或不加入天然香料、合成香料及相应辅料构成的具有特定香气香味的调配混合物]（如咸味食品香精等）",
                                "kws": null,
                                "taxName": "香精",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070226000000000000",
                                "taxCodeTitle": "香精",
                                "iTitle": "*香精*香精",
                                "children": [
                                    {
                                        "id": "1822",
                                        "linkid": "1821",
                                        "code": "107022601",
                                        "paCode": "1070226",
                                        "yn": "N",
                                        "title": "食品用香精",
                                        "alias": "食品用香精",
                                        "about": "指用在各种饮料、冷饮品、糖果、饼干、调味品等加香产品中的香精",
                                        "kws": "食品用香精、食用香精",
                                        "taxName": "香精",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070226010000000000",
                                        "taxCodeTitle": "香精",
                                        "iTitle": "*香精*食品用香精",
                                        "children": []
                                    },
                                    {
                                        "id": "1823",
                                        "linkid": "1821",
                                        "code": "107022602",
                                        "paCode": "1070226",
                                        "yn": "N",
                                        "title": "酒用香精",
                                        "alias": "酒用香精",
                                        "about": "指用在各类加香酒产品中的香精",
                                        "kws": "酒用香精",
                                        "taxName": "香精",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070226020000000000",
                                        "taxCodeTitle": "香精",
                                        "iTitle": "*香精*酒用香精",
                                        "children": []
                                    },
                                    {
                                        "id": "1824",
                                        "linkid": "1821",
                                        "code": "107022603",
                                        "paCode": "1070226",
                                        "yn": "N",
                                        "title": "烟用香精",
                                        "alias": "烟用香精",
                                        "about": "指用在各种烟草制品中的香精",
                                        "kws": "烟用香精",
                                        "taxName": "香精",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070226030000000000",
                                        "taxCodeTitle": "香精",
                                        "iTitle": "*香精*烟用香精",
                                        "children": []
                                    },
                                    {
                                        "id": "1825",
                                        "linkid": "1821",
                                        "code": "107022604",
                                        "paCode": "1070226",
                                        "yn": "N",
                                        "title": "日用香精",
                                        "alias": "日用香精",
                                        "about": "指用在各种日用产品中的香精",
                                        "kws": "日用香精",
                                        "taxName": "香精",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070226040000000000",
                                        "taxCodeTitle": "香精",
                                        "iTitle": "*香精*日用香精",
                                        "children": []
                                    },
                                    {
                                        "id": "1826",
                                        "linkid": "1821",
                                        "code": "107022605",
                                        "paCode": "1070226",
                                        "yn": "N",
                                        "title": "饲料用香精",
                                        "alias": "饲料用香精",
                                        "about": "指用在各种饲料中的香精",
                                        "kws": "饲料用香精",
                                        "taxName": "香精",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070226050000000000",
                                        "taxCodeTitle": "香精",
                                        "iTitle": "*香精*饲料用香精",
                                        "children": []
                                    },
                                    {
                                        "id": "1827",
                                        "linkid": "1821",
                                        "code": "107022699",
                                        "paCode": "1070226",
                                        "yn": "N",
                                        "title": "其他工业用香精",
                                        "alias": "其他工业用香精",
                                        "about": "指用在其他各类工业产品中的香精",
                                        "kws": "工业用香精",
                                        "taxName": "香精",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070226990000000000",
                                        "taxCodeTitle": "香精",
                                        "iTitle": "*香精*其他工业用香精",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1828",
                                "linkid": "1226",
                                "code": "1070299",
                                "paCode": "10702",
                                "yn": "Y",
                                "title": "其他化学制品",
                                "alias": "其他化学制品",
                                "about": null,
                                "kws": null,
                                "taxName": "其他化学制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070299000000000000",
                                "taxCodeTitle": "其他化学制品",
                                "iTitle": "*其他化学制品*其他化学制品",
                                "children": [
                                    {
                                        "id": "1829",
                                        "linkid": "1828",
                                        "code": "107029901",
                                        "paCode": "1070299",
                                        "yn": "N",
                                        "title": "室内散香或除臭制品",
                                        "alias": "室内散香或除臭制品",
                                        "about": "指使室内产生香气或除去异味的制品",
                                        "kws": "神香、香气制品、室内空气清新剂、房间用除臭剂、香袋、香纸",
                                        "taxName": "其他化学制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070299010000000000",
                                        "taxCodeTitle": "其他化学制品",
                                        "iTitle": "*其他化学制品*室内散香或除臭制品",
                                        "children": []
                                    },
                                    {
                                        "id": "1830",
                                        "linkid": "1828",
                                        "code": "107029902",
                                        "paCode": "1070299",
                                        "yn": "N",
                                        "title": "光洁用品",
                                        "alias": "光洁用品",
                                        "about": "指使物体表面产生光亮的用品，主要是上光剂等类似品",
                                        "kws": "人造蜡、调剂蜡、鞋靴油、皮夹克油、木制家具用上光剂、地板蜡、汽车用上光剂、玻璃用光洁剂、金属用光洁剂、光洁用品",
                                        "taxName": "其他化学制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070299020000000000",
                                        "taxCodeTitle": "其他化学制品",
                                        "iTitle": "*其他化学制品*光洁用品",
                                        "children": []
                                    },
                                    {
                                        "id": "1831",
                                        "linkid": "1828",
                                        "code": "107029903",
                                        "paCode": "1070299",
                                        "yn": "N",
                                        "title": "擦洗膏、去污粉及类似制品",
                                        "alias": "擦洗膏、去污粉及类似制品",
                                        "about": "指家庭日常清洁用品及类似制品",
                                        "kws": "擦洗膏、去污粉、擦洗、去污用制品",
                                        "taxName": "其他化学制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070299030000000000",
                                        "taxCodeTitle": "其他化学制品",
                                        "iTitle": "*其他化学制品*擦洗膏、去污粉及类似制品",
                                        "children": []
                                    },
                                    {
                                        "id": "1832",
                                        "linkid": "1828",
                                        "code": "107029904",
                                        "paCode": "1070299",
                                        "yn": "N",
                                        "title": "动物用化妆盥洗品",
                                        "alias": "动物用化妆盥洗品",
                                        "about": "指用于动物化妆盥洗的制品",
                                        "kws": "宠物猫狗用清洗剂、动物用清洗剂、脱毛剂、动物用化妆盥洗品",
                                        "taxName": "其他化学制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070299040000000000",
                                        "taxCodeTitle": "其他化学制品",
                                        "iTitle": "*其他化学制品*动物用化妆盥洗品",
                                        "children": []
                                    },
                                    {
                                        "id": "1833",
                                        "linkid": "1828",
                                        "code": "107029905",
                                        "paCode": "1070299",
                                        "yn": "N",
                                        "title": "火柴",
                                        "alias": "火柴",
                                        "about": "指根据物体摩擦生热的原理，利用强氧化剂和还原剂的化学活性，制造出的一种能摩擦发火的取火工具",
                                        "kws": "普通火柴、工艺火柴、火柴",
                                        "taxName": "其他化学制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070299050000000000",
                                        "taxCodeTitle": "其他化学制品",
                                        "iTitle": "*其他化学制品*火柴",
                                        "children": []
                                    },
                                    {
                                        "id": "1834",
                                        "linkid": "1828",
                                        "code": "107029906",
                                        "paCode": "1070299",
                                        "yn": "N",
                                        "title": "蜡烛及类似品",
                                        "alias": "蜡烛及类似品",
                                        "about": "指以石蜡和（或）植物蜡为主要原料，经加工而成的，主要用于燃烧和照明的各种蜡烛及类似品；包括普通照明用蜡烛、庆典用蜡烛，以及各种工艺蜡烛等，也包括罐装蜡烛",
                                        "kws": "工艺蜡烛、蜡烛",
                                        "taxName": "其他化学制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070299060000000000",
                                        "taxCodeTitle": "其他化学制品",
                                        "iTitle": "*其他化学制品*蜡烛及类似品",
                                        "children": []
                                    },
                                    {
                                        "id": "1835",
                                        "linkid": "1828",
                                        "code": "107029999",
                                        "paCode": "1070299",
                                        "yn": "N",
                                        "title": "其他未列明化学制品",
                                        "alias": "其他未列明化学制品",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "其他化学制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070299990000000000",
                                        "taxCodeTitle": "其他化学制品",
                                        "iTitle": "*其他化学制品*其他未列明化学制品",
                                        "children": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "id": "1836",
                        "linkid": "1172",
                        "code": "10703",
                        "paCode": "107",
                        "yn": "Y",
                        "title": "医药",
                        "alias": "医药",
                        "about": null,
                        "kws": null,
                        "taxName": "医药",
                        "taxRate": "",
                        "vip": "5",
                        "itaxRate": null,
                        "taxCode": "1070300000000000000",
                        "taxCodeTitle": "医药",
                        "iTitle": "*医药*医药",
                        "children": [
                            {
                                "id": "1837",
                                "linkid": "1836",
                                "code": "1070301",
                                "paCode": "10703",
                                "yn": "Y",
                                "title": "化学药品原药",
                                "alias": "化学药品原药",
                                "about": "指制药企业做出来的化学药物",
                                "kws": null,
                                "taxName": "化学药品原药",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070301000000000000",
                                "taxCodeTitle": "化学药品原药",
                                "iTitle": "*化学药品原药*化学药品原药",
                                "children": [
                                    {
                                        "id": "1838",
                                        "linkid": "1837",
                                        "code": "107030101",
                                        "paCode": "1070301",
                                        "yn": "N",
                                        "title": "抗菌素（抗感染药）",
                                        "alias": "抗菌素（抗感染药）",
                                        "about": "指一种具有杀灭或抑制细菌生长的药物",
                                        "kws": "青霉素钠、青霉素钾、普鲁卡因青霉素、氨苄青霉素、氨苄西林、氨苄青霉素盐、羟氨苄青霉素、阿莫西林、6氨基青霉烷酸、6APA、青霉素V、磺苄西林、氯唑西林、青霉素V钾、青霉素、链霉素、庆大霉素、卡那霉素、氨基糖苷类药、四环素、盐酸四环素、磷酸四环素、土霉素、盐酸土霉素、土霉素钙、多西环素、盐酸多西环素、多西环素钙、米诺环素、盐酸米诺环素、金霉素、盐酸金霉素、地美环素、盐酸地美环素、胍甲环素、盐酸胍甲环素、美他环素、四环素类药、氯霉素、琥珀氯霉素、棕榈氯霉素、氯霉素类药、红霉素类、麦迪霉素、乙酰螺旋霉素、克拉霉",
                                        "taxName": "化学药品原药",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070301010000000000",
                                        "taxCodeTitle": "化学药品原药",
                                        "iTitle": "*化学药品原药*抗菌素（抗感染药）",
                                        "children": []
                                    },
                                    {
                                        "id": "1839",
                                        "linkid": "1837",
                                        "code": "107030102",
                                        "paCode": "1070301",
                                        "yn": "N",
                                        "title": "消化系统用药",
                                        "alias": "消化系统用药",
                                        "about": "指主要作用于消化系统的药物",
                                        "kws": "碘化四甲铵、氢氧化四甲铵、甲酸四甲铵、甜菜碱、季铵化合物类、葡糖酸内酯、D-葡糖酸δ内酯、泛内酯、山道年、酚酞、碘苯酚酞、药用内酯、甘草酸、甘草酸钾、甘草酸二铵、甘草酸铵、复方甘草酸、甘草次酸甘草酸盐、芦荟素、消化系统用药",
                                        "taxName": "化学药品原药",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070301020000000000",
                                        "taxCodeTitle": "化学药品原药",
                                        "iTitle": "*化学药品原药*消化系统用药",
                                        "children": []
                                    },
                                    {
                                        "id": "1840",
                                        "linkid": "1837",
                                        "code": "107030103",
                                        "paCode": "1070301",
                                        "yn": "N",
                                        "title": "解热镇痛药",
                                        "alias": "解热镇痛药",
                                        "about": "指为一类具有解热、镇痛药理作用，同时还有显著抗炎、抗风湿作用的药物",
                                        "kws": "阿司匹林、精氨酸阿司匹林、卡巴匹林钙脲、阿司匹林锌、卡巴匹林镁、阿司匹林铝、赖氨匹林、邻羟基苯甲酸、水杨酸钠、水杨酸铋、水杨酸镁、水杨酰胺、水杨酸、水杨酸盐、水杨酸甲酯、水杨酸苯酯、水杨酸乙酯、水杨酸萘酯、水杨酸丁酯、双水杨酯、醋水杨胺、水杨酸二乙胺、水杨酸酯、安替比林、安乃近、异丙安替比林、氨基比林、环拉氨基比林、含有非稠合吡唑环化合物、对乙酰氨基苯乙醚、非那西丁、对乙酰氨基酚、扑热息痛、环酰胺类药、磺胺嘧啶、磺胺双甲基嘧啶、磺胺甲噁唑、胺麦角胺、酒石酸麦角胺、麦角胺、麦角胺盐、布洛芬、解热镇痛药",
                                        "taxName": "化学药品原药",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070301030000000000",
                                        "taxCodeTitle": "化学药品原药",
                                        "iTitle": "*化学药品原药*解热镇痛药",
                                        "children": []
                                    },
                                    {
                                        "id": "1841",
                                        "linkid": "1837",
                                        "code": "107030104",
                                        "paCode": "1070301",
                                        "yn": "N",
                                        "title": "维生素类",
                                        "alias": "维生素类",
                                        "about": "指未混合的维生素及其衍生物",
                                        "kws": "维生素A类原药、维生素B1类原药、维生素B2类原药、维生素B6类原药、维生素B12类原药、维生素C类原药、维生素D、DL-泛酸类原药、维生素E类原药、复合维生素类药、维生素",
                                        "taxName": "化学药品原药",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070301040000000000",
                                        "taxCodeTitle": "化学药品原药",
                                        "iTitle": "*化学药品原药*维生素类",
                                        "children": []
                                    },
                                    {
                                        "id": "1842",
                                        "linkid": "1837",
                                        "code": "107030105",
                                        "paCode": "1070301",
                                        "yn": "N",
                                        "title": "抗寄生虫病药",
                                        "alias": "抗寄生虫病药",
                                        "about": "指用于驱除和灭杀体内外寄生虫的药物",
                                        "kws": "盐酸奎宁、硫酸奎宁、无味奎宁、二盐酸奎宁、重硫酸奎宁、奎宁、奎宁盐、氯喹、磷酸氯喹、羟氯喹、硫酸羟氯喹、氯喹类、哌嗪、二亚乙基二胺、磷酸哌嗪、枸橼酸哌嗪、己二酸哌嗪、哌嗪类、噻嘧啶、双羟萘酸噻嘧啶、甲噻嘧啶、酒石酸甲噻嘧啶、噻乙嘧啶、噻嘧啶类、辛可宁、辛可尼丁、单宁酸奎宁、金鸡纳生物碱、抗寄生虫病药",
                                        "taxName": "化学药品原药",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070301050000000000",
                                        "taxCodeTitle": "化学药品原药",
                                        "iTitle": "*化学药品原药*抗寄生虫病药",
                                        "children": []
                                    },
                                    {
                                        "id": "1843",
                                        "linkid": "1837",
                                        "code": "107030106",
                                        "paCode": "1070301",
                                        "yn": "N",
                                        "title": "中枢神经系统用药",
                                        "alias": "中枢神经系统用药",
                                        "about": "指主要作用于中枢神经系统的药物",
                                        "kws": "阿洛巴比妥、异戊巴比妥、苯巴比妥、INN、阿莫巴比妥、司可巴比妥、环巴比妥、巴比妥类、甲丙氨酯、N,N－二甲基甲酰胺、乙酰胺、天冬酰胺、α-氨基丁二酸一酰胺、开链酰脲类、氨基甲酸乙酯、尿烷、谷氨酰胺、无环酰胺类、咖啡因、枸橼酸咖啡因、安钠咖啡因、枸橼酸钠咖啡因、无水咖啡因、中枢神经系统用药",
                                        "taxName": "化学药品原药",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070301060000000000",
                                        "taxCodeTitle": "化学药品原药",
                                        "iTitle": "*化学药品原药*中枢神经系统用药",
                                        "children": []
                                    },
                                    {
                                        "id": "1844",
                                        "linkid": "1837",
                                        "code": "107030107",
                                        "paCode": "1070301",
                                        "yn": "N",
                                        "title": "计划生育用药",
                                        "alias": "计划生育用药",
                                        "about": "主要用于计划生育方面的药物，不包括避孕药物用具（详见107030215）",
                                        "kws": "#计划生育用药",
                                        "taxName": "化学药品原药",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070301070000000000",
                                        "taxCodeTitle": "化学药品原药",
                                        "iTitle": "*化学药品原药*计划生育用药",
                                        "children": []
                                    },
                                    {
                                        "id": "1845",
                                        "linkid": "1837",
                                        "code": "107030108",
                                        "paCode": "1070301",
                                        "yn": "N",
                                        "title": "激素类药",
                                        "alias": "激素类药",
                                        "about": "包括其他甾族化合物及其作激素的衍生物",
                                        "kws": "垂体前叶素、垂体后叶素、脑垂体后叶、垂体激素类药、可的松、氢化可的松、脱氢可的松、地塞米松、肾上腺皮质激素类药、生长激素、重组人生长激素、生长抑素、醋酸生长抑素、奥曲肽、表皮生长因子、生长激素类似物、葡糖醛酸内酯、胰岛素、锌胰岛素、精蛋白锌胰岛素、低精蛋白锌胰岛素、单组分猪胰岛素、中性胰岛素、球蛋白锌胰岛素、人胰岛素、精蛋白锌人胰岛素、低精蛋白锌人胰岛素、中性人胰岛素、中性可溶性人胰岛素、重组人胰岛素、胰腺激素、雌二醇、聚磷酸雌二醇、半琥珀雌二醇、丙酸雌二醇、戊酸雌二醇、环戊雌醇、17β-雌二醇、炔雌醇、",
                                        "taxName": "化学药品原药",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070301080000000000",
                                        "taxCodeTitle": "化学药品原药",
                                        "iTitle": "*化学药品原药*激素类药",
                                        "children": []
                                    },
                                    {
                                        "id": "1846",
                                        "linkid": "1837",
                                        "code": "107030109",
                                        "paCode": "1070301",
                                        "yn": "N",
                                        "title": "抗肿瘤药",
                                        "alias": "抗肿瘤药",
                                        "about": "主要作用于肿瘤类疾病的药物",
                                        "kws": "洛莫司汀、卡莫司汀、司莫司汀、尼莫司汀、盐酸尼莫司汀、乌拉莫司汀、雌莫司汀、雌莫司汀磷酸钠、雷莫司汀、福莫司汀、莫司汀类、甲氨蝶呤、氨苯喋呤、氨喋呤、巯嘌呤、磺巯嘌呤钠、硫鸟嘌呤、氮鸟嘌呤、甲磺酸氮鸟嘌呤、甲基嘌呤、蝶呤、嘌呤类、长春碱、硫酸长春碱、长春新碱、硫酸长春新碱、长春地辛、硫酸长春地辛、长春瑞宾、重酒石酸长春瑞宾喜树碱、羟喜树碱、拓扑替康、伊立替康、秋水仙碱、秋裂胺、秋水仙胺、三尖杉碱、三尖杉酯碱、高三尖杉酯碱、野百合碱、天然来源类抗肿瘤药",
                                        "taxName": "化学药品原药",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070301090000000000",
                                        "taxCodeTitle": "化学药品原药",
                                        "iTitle": "*化学药品原药*抗肿瘤药",
                                        "children": []
                                    },
                                    {
                                        "id": "1847",
                                        "linkid": "1837",
                                        "code": "107030110",
                                        "paCode": "1070301",
                                        "yn": "N",
                                        "title": "心血管系统用药",
                                        "alias": "心血管系统用药",
                                        "about": "指主要作用于心血管系统的药物",
                                        "kws": "毛地黄苷、毒毛旋花苷、洋地黄、洋地黄毒苷、醋洋地黄毒苷、毛花苷C、去乙酰毛花苷、毒毛花苷K、毒毛花苷G、黄夹苷、桂竹糖芥总苷、万年青总苷、羊角拗苷、铃兰毒苷、苷类、麦角新碱、麦角袂春、麦角胺、麦角胺盐、麦角酸、麦角酸盐、麦角生物碱、地高辛、甲地高辛、α-乙酰地高辛、β-乙酰地高辛、地高辛类、奎尼丁、硫酸奎尼丁、葡萄糖酸奎尼丁、奎尼丁聚半乳糖醛酸盐、双氢奎尼丁、盐酸双氢奎尼丁、奎尼丁类、普萘洛尔、盐酸普萘洛尔、阿替洛尔、盐酸阿替洛尔、美托洛尔、酒石酸美托洛尔、氧烯洛尔、盐酸氧烯洛尔、烯丙洛尔、盐酸烯丙洛尔、",
                                        "taxName": "化学药品原药",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070301100000000000",
                                        "taxCodeTitle": "化学药品原药",
                                        "iTitle": "*化学药品原药*心血管系统用药",
                                        "children": []
                                    },
                                    {
                                        "id": "1848",
                                        "linkid": "1837",
                                        "code": "107030111",
                                        "paCode": "1070301",
                                        "yn": "N",
                                        "title": "呼吸系统用药",
                                        "alias": "呼吸系统用药",
                                        "about": "指主要作用于呼吸系统的药物",
                                        "kws": "愈创木酚、愈创木酚碳酸酯、愈创甘油醚、愈创木酚磺酸钠、愈创木酚磺酸钾、愈创木树脂、愈创木酚类、甲酚磺酸、甲酚磺酸钠、甲酚磺酸钙、甲酚磺酸类、卡拉美芬、盐酸卡拉美芬、乙二磺酸卡拉美芬、卡拉美芬类、麻黄碱、盐酸麻黄碱、甲麻黄碱、盐酸甲麻黄碱、伪麻黄碱、盐酸伪麻黄碱、硫酸伪麻黄碱、麻黄碱类、氨茶碱、无水茶碱、赖氨酸茶碱、二羟丙茶碱、丙羟茶碱、苄胺茶碱、盐酸苄胺茶碱、胆茶碱、甘氨酸茶碱、甘氨酸茶碱钠、多索茶碱、芬乙茶碱、INN、茶碱、芸香苷、皂草苷、扁桃苷、天然苷类",
                                        "taxName": "化学药品原药",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070301110000000000",
                                        "taxCodeTitle": "化学药品原药",
                                        "iTitle": "*化学药品原药*呼吸系统用药",
                                        "children": []
                                    },
                                    {
                                        "id": "1849",
                                        "linkid": "1837",
                                        "code": "107030112",
                                        "paCode": "1070301",
                                        "yn": "N",
                                        "title": "泌尿系统用药",
                                        "alias": "泌尿系统用药",
                                        "about": "指主要作用于泌尿系统的药物",
                                        "kws": "氢氯噻嗪、环戊噻嗪、氯噻嗪、甲氯噻嗪、苄氟噻嗪、三氯噻嗪、泊利噻嗪、环噻嗪、氢氟噻嗪、苄噻嗪、噻嗪类、可可碱、水杨酸钠可可碱、可可碱类、浆果苷、天然苷、合成苷、汞撒利、汞撒利茶碱、汞撒利酸、汞撒利类、泌尿系统用药",
                                        "taxName": "化学药品原药",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070301120000000000",
                                        "taxCodeTitle": "化学药品原药",
                                        "iTitle": "*化学药品原药*泌尿系统用药",
                                        "children": []
                                    },
                                    {
                                        "id": "1850",
                                        "linkid": "1837",
                                        "code": "107030113",
                                        "paCode": "1070301",
                                        "yn": "N",
                                        "title": "血液系统用药",
                                        "alias": "血液系统用药",
                                        "about": "指主要作用于血液系统的药物",
                                        "kws": "肝素、肝素钠、肝素钙、类肝素、依诺肝素、依诺肝素钠、那曲肝素钙、达肝素钠、肝素类、双香豆素、双香豆乙酯、乙双香豆素、醋硝香豆素、香豆素类、羟乙基淀粉、羟甲基淀粉钠、羧甲淀粉、羧甲淀粉钠、小分子羧甲淀粉钠、羟基淀粉类、血液系统用药",
                                        "taxName": "化学药品原药",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070301130000000000",
                                        "taxCodeTitle": "化学药品原药",
                                        "iTitle": "*化学药品原药*血液系统用药",
                                        "children": []
                                    },
                                    {
                                        "id": "1851",
                                        "linkid": "1837",
                                        "code": "107030114",
                                        "paCode": "1070301",
                                        "yn": "N",
                                        "title": "诊断用原药",
                                        "alias": "诊断用原药",
                                        "about": "指用于诊断的药物",
                                        "kws": "甲泛影酸、甲泛影钠、泛影酸、泛影酸钠、泛影酸类、葡甲胺、泛影葡胺、复方泛影葡胺、甲泛葡胺、碘他拉葡胺、碘卡葡胺、醋碘苯葡胺、碘曲葡胺、碘克沙葡胺、碘羟拉葡胺、胆影葡胺、钆喷葡胺、碘沙葡胺、碘达葡胺、葡胺类药、碘他拉酸、碘他拉酸钠、碘他拉酸类药",
                                        "taxName": "化学药品原药",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070301140000000000",
                                        "taxCodeTitle": "化学药品原药",
                                        "iTitle": "*化学药品原药*诊断用原药",
                                        "children": []
                                    },
                                    {
                                        "id": "1852",
                                        "linkid": "1837",
                                        "code": "107030115",
                                        "paCode": "1070301",
                                        "yn": "N",
                                        "title": "调解水、电解质、酸碱平衡药",
                                        "alias": "调解水、电解质、酸碱平衡药",
                                        "about": "指用于平衡人体酸碱、电解质的药物",
                                        "kws": "无水葡萄糖、液状葡萄糖、缩合葡萄糖、葡萄糖浆、医药用果糖、医药用甘果糖、半乳糖、山梨糖、医药用木糖醇、海藻糖、葡萄糖类药、羟丙基蔗糖、二磷酸果糖、果糖二磷酸钠、果糖二磷酸钙、糖醚、糖酯、糖酯盐、无水乳糖、乳果糖、化学纯乳糖、药用氯化钠、药用氯化钾、药用氯化钙、钙克斯、葡萄糖酸钙、枸橼酸钙、乳酸钙、药用碘化钙、果糖酸钙、门冬氨酸钙、药用氢氧化钙、磷酸氢钙、电解质平衡调节药、药用磷酸钙、珍珠钙、植酸、植酸钙、植酸钙镁、活性钙、牡蛎钙、酸碱平衡调节药、透析液、调解水、电解质、酸碱平衡药",
                                        "taxName": "化学药品原药",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070301150000000000",
                                        "taxCodeTitle": "化学药品原药",
                                        "iTitle": "*化学药品原药*调解水、电解质、酸碱平衡药",
                                        "children": []
                                    },
                                    {
                                        "id": "1853",
                                        "linkid": "1837",
                                        "code": "107030116",
                                        "paCode": "1070301",
                                        "yn": "N",
                                        "title": "麻醉用药",
                                        "alias": "麻醉用药",
                                        "about": "指用于麻醉的药物",
                                        "kws": "己氨胆碱、溴己氨胆碱、琥珀胆碱、氯化琥珀胆碱、溴化琥珀胆碱、胆碱、胆碱盐、鸦片碱、罂粟果提取物、丁丙诺啡、可卡因及其盐、普鲁卡因、盐酸普鲁卡因、氯普鲁卡因、奥布卡因、盐酸奥布卡因、利多卡因、盐酸利多卡因、碳酸利多卡因、辛可卡因、盐酸辛可卡因、新维他卡因、布比卡因、盐酸布比卡因、盐酸丁卡因、甲哌卡因、盐酸甲哌卡因、苯佐卡因、盐酸依替卡因、依替卡因、丙胺卡因、依鲁卡因、三甲卡因、福莫卡因、盐酸丙氧卡因、盐酸丙贝卡因、丙贝卡因、海克卡因、可卡因、麻醉用药",
                                        "taxName": "化学药品原药",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070301160000000000",
                                        "taxCodeTitle": "化学药品原药",
                                        "iTitle": "*化学药品原药*麻醉用药",
                                        "children": []
                                    },
                                    {
                                        "id": "1854",
                                        "linkid": "1837",
                                        "code": "107030117",
                                        "paCode": "1070301",
                                        "yn": "N",
                                        "title": "抗组织胺类药及解毒药",
                                        "alias": "抗组织胺类药及解毒药",
                                        "about": "指作用机制为抗组织胺的抗炎药。",
                                        "kws": "苯海拉明类、斯汀类药、拉敏类药、抗组织胺类药、巯类药、依地酸类药、解毒药",
                                        "taxName": "化学药品原药",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070301170000000000",
                                        "taxCodeTitle": "化学药品原药",
                                        "iTitle": "*化学药品原药*抗组织胺类药及解毒药",
                                        "children": []
                                    },
                                    {
                                        "id": "1855",
                                        "linkid": "1837",
                                        "code": "107030118",
                                        "paCode": "1070301",
                                        "yn": "N",
                                        "title": "生化药（酶及辅酶）",
                                        "alias": "生化药（酶及辅酶）",
                                        "about": "指从生物体分离、纯化所得，可用于预防、治疗和诊断疾病的生化物质",
                                        "kws": "磷脂、卵磷脂、大豆磷脂、氢化大豆磷脂、混合脂肪酸甘油酯、磷氨基类脂、赖氨酸、盐酸赖氨酸、醋酸赖氨酸、苄达赖氨酸、DL-赖氨酸、精氨酸、盐酸精氨酸、谷氨酸、谷氨酸钠、谷氨酸钾、谷氨酸钙、甘氨酸、苯丙氨酸、DL-苯丙氨酸、丙氨酸、DL-丙氨酸、甲硫氨酸、DL-甲硫氨酸、腺苷甲硫氨酸、脯氨酸、瓜氨酸、酪氨酸、亮氨酸、异亮氨酸鸟氨酸、鸟氨酰门冬氨酸、色氨酸、DL-色氨酸、丝氨酸、氨基酸及蛋白质类药、生化药",
                                        "taxName": "化学药品原药",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070301180000000000",
                                        "taxCodeTitle": "化学药品原药",
                                        "iTitle": "*化学药品原药*生化药（酶及辅酶）",
                                        "children": []
                                    },
                                    {
                                        "id": "1856",
                                        "linkid": "1837",
                                        "code": "107030119",
                                        "paCode": "1070301",
                                        "yn": "N",
                                        "title": "消毒防腐及创伤外科用药",
                                        "alias": "消毒防腐及创伤外科用药",
                                        "about": "消毒防腐药是指能迅速杀灭病原微生物的药物。创伤外科用药是指对治疗外伤所导致的对人体的伤害的药物。",
                                        "kws": "依沙吖啶、乳酸依沙吖啶、氨吖啶、盐酸氨吖啶、吖啶黄、盐酸吖啶黄、吖啶类药、氯己定、盐酸氯己定、枸橼酸氯己定、氯己定碘、醋酸氯己定、葡萄糖酸氯己定、氯己定类药、药用汞、药用氯化汞、药用氯化亚汞、硫柳汞、硝甲酚汞、氯化氨汞、汞溴红、黄氧化汞、汞类药、败坏翘摇素、丙酰基内酯、消毒防腐创伤外科用药",
                                        "taxName": "化学药品原药",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070301190000000000",
                                        "taxCodeTitle": "化学药品原药",
                                        "iTitle": "*化学药品原药*消毒防腐及创伤外科用药",
                                        "children": []
                                    },
                                    {
                                        "id": "1857",
                                        "linkid": "1837",
                                        "code": "107030120",
                                        "paCode": "1070301",
                                        "yn": "N",
                                        "title": "制剂用辅料及附加剂",
                                        "alias": "制剂用辅料及附加剂",
                                        "about": "指专用于人或兽药的化学制品",
                                        "kws": "凝胶制品、润滑剂、药偶合剂、制剂用辅料、制剂用附加剂",
                                        "taxName": "化学药品原药",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070301200000000000",
                                        "taxCodeTitle": "化学药品原药",
                                        "iTitle": "*化学药品原药*制剂用辅料及附加剂",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1858",
                                "linkid": "1836",
                                "code": "1070302",
                                "paCode": "10703",
                                "yn": "Y",
                                "title": "化学药品制剂",
                                "alias": "化学药品制剂",
                                "about": "指直接用于人体疾病防治、诊断等方面的化学药品制剂。通常是通过合成或者半合成的方法制得的原料药及其制剂；天然物质中提取或者通过发酵提取的新的有效单体及其制剂；用拆分或者合成等方法制得的已知药物中的光学异构体及其制剂。",
                                "kws": null,
                                "taxName": "化学药品制剂",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070302000000000000",
                                "taxCodeTitle": "化学药品制剂",
                                "iTitle": "*化学药品制剂*化学药品制剂",
                                "children": [
                                    {
                                        "id": "1859",
                                        "linkid": "1858",
                                        "code": "107030201",
                                        "paCode": "1070302",
                                        "yn": "N",
                                        "title": "冻干粉针剂",
                                        "alias": "冻干粉针剂",
                                        "about": "指无菌环境下将药物冷冻制成的供临用前用适宜的无菌溶液配制成澄清溶液或均匀混悬液的无菌粉末或无菌块状物。可用适宜的注射用溶剂配制后注射，也可用静脉输液配制后静脉滴注。",
                                        "kws": "注射用胸腺素、注射用重组人粒细胞巨噬细胞集落刺激因子、注射用重组人白介素-2、注射用重组人干扰素、注射用核糖核酸、低精蛋白胰岛素注射液、注射用人血白蛋白、注射用重组人生长激素",
                                        "taxName": "化学药品制剂",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070302010000000000",
                                        "taxCodeTitle": "化学药品制剂",
                                        "iTitle": "*化学药品制剂*冻干粉针剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1860",
                                        "linkid": "1858",
                                        "code": "107030202",
                                        "paCode": "1070302",
                                        "yn": "N",
                                        "title": "粉针剂",
                                        "alias": "粉针剂",
                                        "about": "指药物制成的供临用前用适宜的无菌溶液配制成澄清溶液或均匀混悬液的无菌粉末或无菌块状物。可用适宜的注射用溶剂配制后注射，也可用静脉输液配制后静脉滴注。包括含有青霉素及其衍生物粉针剂、含有链霉素及其衍生物粉针剂、头孢类粉针剂、含有相关抗菌素粉针剂、含有皮质甾类激素及其衍生物粉针剂、其他混合或非混合产品构成粉针剂。",
                                        "kws": "青霉素粉针剂、注射用青霉素钠、注射用青霉素钾、注射用氨苄西林钠、注射用阿莫西林钠克拉维酸钾、注射用哌拉西林、注射用舒他西林、含有链霉素粉针剂、注射用链霉素、头孢类粉针剂、注射用头孢唑林钠、注射用头孢拉定、注射用头孢他啶、注射用头孢曲松钠、注射用头孢噻肟钠、注射用头孢哌酮钠、注射用头孢哌酮钠-舒巴坦钠、注射用头孢呋辛钠、含有相关抗菌素粉针剂、注射用克拉霉素、注射用阿昔洛韦、含有皮质甾类激素粉针剂、注射用甲基强的松龙琥珀酸钠、注射用二磷酸果糖",
                                        "taxName": "化学药品制剂",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070302020000000000",
                                        "taxCodeTitle": "化学药品制剂",
                                        "iTitle": "*化学药品制剂*粉针剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1861",
                                        "linkid": "1858",
                                        "code": "107030203",
                                        "paCode": "1070302",
                                        "yn": "N",
                                        "title": "注射液",
                                        "alias": "注射液",
                                        "about": "指溶液型或乳状液型注射液。可用于肌内注射、静脉注射或静脉滴注等。包括含有相关抗菌素注射液、含有维生素原和维生素注射液、含有皮质甾类激素及其衍生物注射液、含有奎宁或其盐注射液、含有生物碱及其衍生物注射液、含有胰岛素注射液、避孕药注射液、其他混合或非混合产品构成注射液。",
                                        "kws": "相关抗菌素注射液、阿米卡星注射液、庆大霉素注射液、小诺霉素注射液、林可霉素注射液、克林霉素注射液、利巴韦林注射液、维生素原注射液、维生素注射液、维生素B1注射液、维生素B6注射液、维生素B12注射液、维生素C注射液、含有皮质甾类激素注射液、倍氯米松注射液、氢化可的松注射液、地塞米松注射液、含有奎宁或其盐注射液、复方奎宁注射液、奎宁乌拉坦注射液、含有生物碱注射液、氨茶碱注射液、含有胰岛素注射液、胰岛素注射液、重组人胰岛素注射液、避孕药注射液、单方庚酸炔诺酮注射液、复方庚酸炔诺酮二号注射液、微囊复方甲地孕酮避",
                                        "taxName": "化学药品制剂",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070302030000000000",
                                        "taxCodeTitle": "化学药品制剂",
                                        "iTitle": "*化学药品制剂*注射液",
                                        "children": []
                                    },
                                    {
                                        "id": "1862",
                                        "linkid": "1858",
                                        "code": "107030204",
                                        "paCode": "1070302",
                                        "yn": "N",
                                        "title": "输液",
                                        "alias": "输液",
                                        "about": "指药物与适宜的溶剂或分散介质制成的供注入体内的溶液、乳状液或混悬液及供临用前配制或稀释成溶液或混悬液的粉末或浓溶液的无菌制剂。包括含有抗菌素输液、其他混合或非混合输液",
                                        "kws": "抗菌素输液、诺氟沙星输液、氧氟沙星输液、左氧氟沙星输液、环丙沙星输液、甲硝唑输液、替硝唑输液、甘露醇输液、右旋糖酐输液、葡萄糖输液、氯化钠输液、复方氯化钠输液、葡萄糖氯化钠输液、脂肪乳输液、复方氨基酸输液",
                                        "taxName": "化学药品制剂",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070302040000000000",
                                        "taxCodeTitle": "化学药品制剂",
                                        "iTitle": "*化学药品制剂*输液",
                                        "children": []
                                    },
                                    {
                                        "id": "1863",
                                        "linkid": "1858",
                                        "code": "107030205",
                                        "paCode": "1070302",
                                        "yn": "N",
                                        "title": "片剂",
                                        "alias": "片剂",
                                        "about": "指药物与适宜的辅料混匀压制而成的圆片状或异形片状的固体制剂。包括含有青霉素及其衍生物片剂、含有先锋霉素片剂、含有抗菌素片剂、含有奎宁或其盐的片剂、含有磺胺类片剂、含有联苯双酯片剂、含有维生素及其衍生物片剂、含有皮质甾类激素及其衍生物片剂、含有生物碱及其衍生物片剂、避孕药片剂、其他混合产品构成片剂",
                                        "kws": "青霉素片剂、青霉素V钾片、阿莫西林-克拉维酸钾片、含有链霉素片剂、含有先锋霉素片剂、头孢克洛片、头孢呋辛酯片、含有抗菌素片剂、红霉素片、琥乙红霉素片、罗红霉素片、阿奇霉素片、克拉霉素片、交沙霉素片、磷霉素钙片、异烟肼片、氧氟沙星片、左氧氟沙星片、含有奎宁或其盐的片剂、无味奎宁片、重硫酸奎宁片、含有磺胺类片剂、复方磺胺甲噁唑片、增效联磺片、含有联苯双酯片剂、联苯双酯滴丸、联苯双酯片、复方联苯双酯片、含有维生素片剂、维生素B1片、维生素B2片、维生素B6片、维生素C片、含有皮质甾类激素片剂、地塞米松片、泼尼松",
                                        "taxName": "化学药品制剂",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070302050000000000",
                                        "taxCodeTitle": "化学药品制剂",
                                        "iTitle": "*化学药品制剂*片剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1864",
                                        "linkid": "1858",
                                        "code": "107030206",
                                        "paCode": "1070302",
                                        "yn": "N",
                                        "title": "胶囊剂",
                                        "alias": "胶囊剂",
                                        "about": "指药物或加有辅料充填于空心胶囊或密封于软质囊材中的固体制剂。包括含有青霉素及其衍生物胶囊、含有先锋霉素胶囊、含有相关抗菌素胶囊、含有维生素及其衍生物胶囊、其他混合或非混合产品构成胶囊。",
                                        "kws": "青霉素胶囊、阿莫西林胶囊、托西酸舒他西林胶囊、含有链霉素胶囊、含有先锋霉素胶囊、头孢拉定胶囊、头孢氨苄胶囊、头孢羟氨苄胶囊、含有相关抗菌素胶囊、米诺环素胶囊、克林霉素胶囊、林可霉素胶囊、利福平胶囊、诺氟沙星胶囊、环丙沙星胶囊、含有维生素胶囊、维生素AD胶囊、维生素E胶囊、速效伤风胶囊、吲哚美辛胶囊、吉非贝齐胶囊、氟桂利嗪胶囊、雷尼替丁胶囊、奥美拉唑胶囊、兰索拉唑胶囊、泛癸利酮胶囊",
                                        "taxName": "化学药品制剂",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070302060000000000",
                                        "taxCodeTitle": "化学药品制剂",
                                        "iTitle": "*化学药品制剂*胶囊剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1865",
                                        "linkid": "1858",
                                        "code": "107030207",
                                        "paCode": "1070302",
                                        "yn": "N",
                                        "title": "颗粒剂",
                                        "alias": "颗粒剂",
                                        "about": "指提取物与适宜的辅料或饮片细粉制成具有一定粒度的颗粒状制剂，分为可溶颗粒、混悬颗粒和泡腾颗粒。包括含有青霉素及其衍生物颗粒剂、含有先锋霉素颗粒剂、含有相关抗菌素颗粒剂、其他混合或非混合产品构成颗粒剂。",
                                        "kws": "青霉素颗粒剂、阿莫西林颗粒、托西酸舒他西林颗粒、含有链霉素颗粒剂、含有先锋霉素颗粒剂、头孢拉定颗粒、头孢羟氨苄颗粒、含有相关抗菌素颗粒剂、罗红霉素颗粒、克拉霉素颗粒、枸橼酸铋钾颗粒剂",
                                        "taxName": "化学药品制剂",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070302070000000000",
                                        "taxCodeTitle": "化学药品制剂",
                                        "iTitle": "*化学药品制剂*颗粒剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1866",
                                        "linkid": "1858",
                                        "code": "107030208",
                                        "paCode": "1070302",
                                        "yn": "N",
                                        "title": "缓释控释片",
                                        "alias": "缓释控释片",
                                        "about": "指在规定的释放介质中缓慢地非恒速释放药物的片剂。控释片系指在规定的释放介质中缓慢地恒速释放药物的片剂。包括含有抗菌素缓释控释片、含有奎宁或其盐的缓释控释片、含有磺胺类缓释控释片、含有联苯双酯缓释控释片、含有维生素及其衍生物缓释控释片、含有皮质甾类激素及其衍生物缓释控释片、含有生物碱及其衍生物缓释控释片、其他混合或非混合产品构成缓释控释片",
                                        "kws": "抗菌素缓释控释片、含有青霉素缓释控释片、含有链霉素缓释控释片、含有先锋霉素缓释控释片、含有奎宁或其盐的缓释控释片、含有磺胺类缓释控释片、含有联苯双酯缓释控释片、含有维生素缓释控释片、含有皮质甾类激素缓释控释片、含有生物碱缓释控释片",
                                        "taxName": "化学药品制剂",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070302080000000000",
                                        "taxCodeTitle": "化学药品制剂",
                                        "iTitle": "*化学药品制剂*缓释控释片",
                                        "children": []
                                    },
                                    {
                                        "id": "1867",
                                        "linkid": "1858",
                                        "code": "107030209",
                                        "paCode": "1070302",
                                        "yn": "N",
                                        "title": "滴剂",
                                        "alias": "滴剂",
                                        "about": "指一滴一滴服用或外用的液体药剂,如浓缩维生素A、D滴剂、滴鼻剂、滴眼剂等。",
                                        "kws": "滴剂",
                                        "taxName": "化学药品制剂",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070302090000000000",
                                        "taxCodeTitle": "化学药品制剂",
                                        "iTitle": "*化学药品制剂*滴剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1868",
                                        "linkid": "1858",
                                        "code": "107030210",
                                        "paCode": "1070302",
                                        "yn": "N",
                                        "title": "膏霜剂",
                                        "alias": "膏霜剂",
                                        "about": "指药物与油脂性或水溶性基质混合制成的均匀的半固体外用制剂；或者药物溶解或分散于乳状液型基质中形成的均匀的半固体外用制剂。",
                                        "kws": "膏霜剂",
                                        "taxName": "化学药品制剂",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070302100000000000",
                                        "taxCodeTitle": "化学药品制剂",
                                        "iTitle": "*化学药品制剂*膏霜剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1869",
                                        "linkid": "1858",
                                        "code": "107030211",
                                        "paCode": "1070302",
                                        "yn": "N",
                                        "title": "栓剂",
                                        "alias": "栓剂",
                                        "about": "指药物与适宜基质制成供腔道给药的固体制剂。",
                                        "kws": "栓剂",
                                        "taxName": "化学药品制剂",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070302110000000000",
                                        "taxCodeTitle": "化学药品制剂",
                                        "iTitle": "*化学药品制剂*栓剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1870",
                                        "linkid": "1858",
                                        "code": "107030212",
                                        "paCode": "1070302",
                                        "yn": "N",
                                        "title": "气雾剂",
                                        "alias": "气雾剂",
                                        "about": "指药物以特殊装置给药，经呼吸道深部、腔道、黏膜或皮肤等发挥全身或局部作用的制剂。",
                                        "kws": "气雾剂",
                                        "taxName": "化学药品制剂",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070302120000000000",
                                        "taxCodeTitle": "化学药品制剂",
                                        "iTitle": "*化学药品制剂*气雾剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1871",
                                        "linkid": "1858",
                                        "code": "107030213",
                                        "paCode": "1070302",
                                        "yn": "N",
                                        "title": "口服液体制剂",
                                        "alias": "口服液体制剂",
                                        "about": "指药物溶解于适宜溶剂中制成供口服的澄清液体制剂；或难溶性固体药物，分散在液体介质中，制成供口服的混悬液体制剂；或两种互不相溶的液体制成口服的稳定的水包油型乳液制剂。",
                                        "kws": "口服液",
                                        "taxName": "化学药品制剂",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070302130000000000",
                                        "taxCodeTitle": "化学药品制剂",
                                        "iTitle": "*化学药品制剂*口服液体制剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1872",
                                        "linkid": "1858",
                                        "code": "107030214",
                                        "paCode": "1070302",
                                        "yn": "N",
                                        "title": "外用液体制剂",
                                        "alias": "外用液体制剂",
                                        "about": "指药物与适宜的溶剂或分散介质制成的，通过体表给药以产生局部或全身性作用的溶液、混悬液或乳状液及供临用前稀释的高浓度液体制剂，一般有涂剂、洗剂、搽剂、涂膜剂、冲洗剂等，不包括滴剂（详见107030209）。",
                                        "kws": "外用液",
                                        "taxName": "化学药品制剂",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070302140000000000",
                                        "taxCodeTitle": "化学药品制剂",
                                        "iTitle": "*化学药品制剂*外用液体制剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1873",
                                        "linkid": "1858",
                                        "code": "107030215",
                                        "paCode": "1070302",
                                        "yn": "N",
                                        "title": "避孕药物用具",
                                        "alias": "避孕药物用具",
                                        "about": "避孕药物是能阻断生殖过程中任何一个环节的药物。避孕用具是以非药物形式去阻止受孕的用具，如避孕环、避孕套等。",
                                        "kws": "避孕药物用具、避孕套、避孕环、避孕胶棒、避孕膜",
                                        "taxName": "化学药品制剂",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070302150000000000",
                                        "taxCodeTitle": "化学药品制剂",
                                        "iTitle": "*化学药品制剂*避孕药物用具",
                                        "children": []
                                    },
                                    {
                                        "id": "1874",
                                        "linkid": "1858",
                                        "code": "107030216",
                                        "paCode": "1070302",
                                        "yn": "N",
                                        "title": "抗艾滋病病毒药品",
                                        "alias": "抗艾滋病病毒药品",
                                        "about": null,
                                        "kws": "抗艾滋病病毒药品、齐多夫定制剂、司他夫定制剂、去羟肌苷制剂、奈韦拉平制剂、硫酸茚地那韦制剂、甲磺酸沙奎那韦制剂、利托那韦制剂、拉米夫定制剂、依非韦伦制剂",
                                        "taxName": "化学药品制剂",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070302160000000000",
                                        "taxCodeTitle": "化学药品制剂",
                                        "iTitle": "*化学药品制剂*抗艾滋病病毒药品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1875",
                                "linkid": "1836",
                                "code": "1070303",
                                "paCode": "10703",
                                "yn": "Y",
                                "title": "中药饮片",
                                "alias": "中药饮片",
                                "about": "指根据调配或制剂的需要，对经产地加工的净药材进一步切制、炮炙而成的成品称为中药饮片，不包括外购的中药材（详见1010118）。",
                                "kws": null,
                                "taxName": "中药饮片",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070303000000000000",
                                "taxCodeTitle": "中药饮片",
                                "iTitle": "*中药饮片*中药饮片",
                                "children": [
                                    {
                                        "id": "1876",
                                        "linkid": "1875",
                                        "code": "107030301",
                                        "paCode": "1070303",
                                        "yn": "N",
                                        "title": "植物类饮片",
                                        "alias": "植物类饮片",
                                        "about": "指利用各种药用植物的根？茎？皮？叶？花？果实等加工制成的片？丝？块？段等中药饮片。包括根及根茎类饮片、块、根、茎类饮片、藤、茎类饮片、木、心材类饮片、树皮类饮片、叶片类饮片、花、蕊类饮片、果实、种子类饮片、草类饮片、藻、菌、地衣类饮片、植物加工类饮片、其他植物类饮片。",
                                        "kws": "巴戟天类饮片、白芍类饮片、柴胡类饮片、人参类饮片、苦参类饮片、党参类饮片、明党参片、北沙参类饮片、南沙参类饮片、丹参类饮片、太子参片、玄参类饮片、板蓝根片、三七类饮片、甘草类饮片、大黄类饮片、葛根类饮片、黄芪类饮片、桔梗类饮片、百部类饮片、草乌类饮片、何首乌类饮片、麦冬类饮片、白术类饮片、天麻类饮片、络实藤段、青枫藤片、落实藤、石楠藤、红藤片、红藤木、心材类饮片、檀香类饮片、树皮类饮片、地枫皮类饮片、合欢皮类饮片、苦楝皮类饮片、海桐皮类饮片、肉桂类饮片、白藓皮类饮片、地骨皮类饮片、椿根皮类饮片、五加皮类饮",
                                        "taxName": "中药饮片",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1070303010000000000",
                                        "taxCodeTitle": "中药饮片",
                                        "iTitle": "*中药饮片*植物类饮片",
                                        "children": []
                                    },
                                    {
                                        "id": "1877",
                                        "linkid": "1875",
                                        "code": "107030302",
                                        "paCode": "1070303",
                                        "yn": "N",
                                        "title": "动物类饮片",
                                        "alias": "动物类饮片",
                                        "about": "指利用各种药用动物的组织、血液、骨骼、内脏、皮等药材经净制、切制、炮炙等处理后的中药饮片。包括动物全体类饮片、去内脏动物类饮片、动物皮、角类饮片、动物鳞片、贝壳类饮片、动物骨骼、脏器类饮片、动物产物、加工类饮片、其他动物产物、加工类饮片。",
                                        "kws": "斑瞀虫类饮片、红娘虫类饮片、干蟾类饮片、虻虫类饮片、土鳖虫类饮片、蜈蚣、大蜈蚣、僵蚕类饮片、九香虫类饮片、水蛭类饮片、去内脏动物类饮片、地龙类饮片、蛤蚧类饮片、乌蛇类饮片、动物皮、角类饮片、蝉蜕类饮片、蛇蜕类饮片、刺猬皮类饮片、羚羊角类饮片、鹿角类饮片、水牛角类饮片、动物鳞片、鳖甲类饮片、玳瑁类饮片、生蛤壳类饮片、龟甲类饮片、牡蛎类饮片、贝壳类饮片、动物骨骼、海螵蛸类饮片、猴骨类饮片、鹿骨类饮片、狗鞭类饮片、鹿鞭类饮片、净羊胆类饮片、脏器类饮片、动物产物、加工类饮片、蚕砂类饮片、人工牛黄类饮片、桑螵蛸类饮",
                                        "taxName": "中药饮片",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070303020000000000",
                                        "taxCodeTitle": "中药饮片",
                                        "iTitle": "*中药饮片*动物类饮片",
                                        "children": []
                                    },
                                    {
                                        "id": "1878",
                                        "linkid": "1875",
                                        "code": "107030303",
                                        "paCode": "1070303",
                                        "yn": "N",
                                        "title": "矿物类饮片",
                                        "alias": "矿物类饮片",
                                        "about": "指药用矿物质经净制、切制、炮炙等处理后的中药饮片，不包括滑石粉（详见1020510）。",
                                        "kws": "矿物类饮片、白矾类饮片、大青盐类饮片、磁石类饮片、胆矾类饮片、赤石脂类饮片、鹅管石类饮片、红粉类饮片、花蕊石类饮片、海浮石类饮片、金礞石类饮片、硫磺类饮片、密陀僧类饮片、寒水石类饮片、紫硇砂类饮片、硼砂类饮片、青礞石类饮片、轻粉类饮片、石膏类饮片、龙齿类饮片、龙骨类饮片、炉甘石类饮片、雄黄类饮片、赭石类饮片、钟乳石类饮片、紫石英类饮片、自然铜类饮片、云母石类饮片、禹粮石类饮片",
                                        "taxName": "中药饮片",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070303030000000000",
                                        "taxCodeTitle": "中药饮片",
                                        "iTitle": "*中药饮片*矿物类饮片",
                                        "children": []
                                    },
                                    {
                                        "id": "1879",
                                        "linkid": "1875",
                                        "code": "107030399",
                                        "paCode": "1070303",
                                        "yn": "N",
                                        "title": "其他中药饮片",
                                        "alias": "其他中药饮片",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "中药饮片",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070303990000000000",
                                        "taxCodeTitle": "中药饮片",
                                        "iTitle": "*中药饮片*其他中药饮片",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1880",
                                "linkid": "1836",
                                "code": "1070304",
                                "paCode": "10703",
                                "yn": "Y",
                                "title": "中成药",
                                "alias": "中成药",
                                "about": "指在中医药理论指导下，以中药材为主原料，按照规定的处方、生产工艺和质量标准生产的制剂。通常分内服，外用和注射三种。",
                                "kws": null,
                                "taxName": "中成药",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070304000000000000",
                                "taxCodeTitle": "中成药",
                                "iTitle": "*中成药*中成药",
                                "children": [
                                    {
                                        "id": "1881",
                                        "linkid": "1880",
                                        "code": "107030401",
                                        "paCode": "1070304",
                                        "yn": "N",
                                        "title": "中成药丸剂",
                                        "alias": "中成药丸剂",
                                        "about": "指饮片细粉或提取物加适宜的黏合剂或其他辅料制成的球形或类球形制剂，分为蜜丸、水蜜丸、水丸、糊丸、蜡丸和浓缩丸等类型。",
                                        "kws": "中成药丸剂、解表丸丸剂、泻下丸剂、和解丸剂、温里丸剂、清热丸剂、祛暑丸剂、补益丸剂、固涩丸剂、安神丸剂、开窍丸剂、理气丸剂、理血丸剂、止血丸剂、治风丸剂、祛湿丸剂、祛风湿丸剂、祛痰丸剂、止咳平喘丸剂、消食丸剂、治泻剂、痢丸剂、小儿镇惊丸剂、调经丸剂、止带丸剂、治产后病丸剂、安胎丸剂、利咽丸剂、明目丸剂、通鼻丸剂、治耳丸剂、驱虫丸剂、杀虫丸剂、止痒丸剂、治痔丸剂、治疮疡丸剂、止酸解痉治胃痛丸剂、抗痨丸剂、抗癌丸剂",
                                        "taxName": "中成药",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070304010000000000",
                                        "taxCodeTitle": "中成药",
                                        "iTitle": "*中成药*中成药丸剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1882",
                                        "linkid": "1880",
                                        "code": "107030402",
                                        "paCode": "1070304",
                                        "yn": "N",
                                        "title": "中成药冲剂",
                                        "alias": "中成药冲剂",
                                        "about": "指药材提取物加适量赋形剂或部分药材细粉制成干燥颗粒状或块状的内服药剂，用时加开水冲服。",
                                        "kws": "中成药冲剂、解表冲剂、泻下冲剂、和解冲剂、温里冲剂、清热冲剂、祛暑冲剂、补益冲剂、固涩冲剂、安神冲剂、开窍冲剂、理气冲剂、理血冲剂、止血冲剂、治风冲剂、祛湿冲剂、祛风湿冲剂、祛痰冲剂、止咳平喘冲剂、消食冲剂、治泻痢冲剂、小儿镇惊冲剂、调经冲剂、止带冲剂、治产后病冲剂、安胎冲剂、利咽冲剂、明目冲剂、通鼻冲剂、治耳冲剂、驱虫冲剂、杀虫冲剂、止痒冲剂、治痔冲剂、治疮疡冲剂、止酸解痉治胃痛冲剂、抗痨冲剂、抗癌冲剂",
                                        "taxName": "中成药",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070304020000000000",
                                        "taxCodeTitle": "中成药",
                                        "iTitle": "*中成药*中成药冲剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1883",
                                        "linkid": "1880",
                                        "code": "107030403",
                                        "paCode": "1070304",
                                        "yn": "N",
                                        "title": "中成药糖浆",
                                        "alias": "中成药糖浆",
                                        "about": "指含有提取物的浓蔗糖水溶液。",
                                        "kws": "中成药糖浆、解表糖浆、泻下糖浆、和解糖浆、温里糖浆、清热糖浆、祛暑糖浆、补益糖浆、固涩糖浆、安神糖浆、开窍糖浆、理气糖浆、理血糖浆、止血糖浆、治风糖浆、祛湿糖浆、祛风湿糖浆、祛痰糖浆、止咳平喘糖浆、消食糖浆、治泻痢糖浆、小儿镇惊糖浆、调经糖浆、止带糖浆、治产后病糖浆、安胎糖浆、利咽糖浆、明目糖浆、通鼻糖浆、治耳糖浆、驱虫糖浆、杀虫糖浆、止痒糖浆、治痔糖浆、治疮疡糖浆、止酸解痉治胃痛糖浆、抗痨糖浆、抗癌糖浆",
                                        "taxName": "中成药",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070304030000000000",
                                        "taxCodeTitle": "中成药",
                                        "iTitle": "*中成药*中成药糖浆",
                                        "children": []
                                    },
                                    {
                                        "id": "1884",
                                        "linkid": "1880",
                                        "code": "107030404",
                                        "paCode": "1070304",
                                        "yn": "N",
                                        "title": "中成药片剂",
                                        "alias": "中成药片剂",
                                        "about": "指提取物、提取物加饮片细粉或饮片细粉与适宜辅料混匀压制或用其他适宜方法制成的圆片状或异形片状的制剂，有浸膏片、半浸膏片和全粉片等。",
                                        "kws": "中成药片剂、解表片剂、泻下片剂、和解片剂、温里片剂、清热片剂、祛暑片剂、补益片剂、固涩片剂、安神片剂、开窍片剂、理气片剂、理血片剂、止血片剂、治风片剂、祛湿片剂、祛风湿片剂、祛痰片剂、止咳平喘片剂、消食片剂、治泻痢片剂、小儿镇惊片剂、调经、止带片剂、治产后病片剂、安胎片剂、利咽片剂、明目片剂、通鼻片剂、治耳片剂、驱虫片剂、杀虫片剂、止痒片剂、治痔片剂、治疮疡片剂、止酸解痉治胃痛片剂、抗痨片剂、抗癌片剂",
                                        "taxName": "中成药",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070304040000000000",
                                        "taxCodeTitle": "中成药",
                                        "iTitle": "*中成药*中成药片剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1885",
                                        "linkid": "1880",
                                        "code": "107030405",
                                        "paCode": "1070304",
                                        "yn": "N",
                                        "title": "中成药注射剂",
                                        "alias": "中成药注射剂",
                                        "about": "指饮片经提取、纯化后制成的供注入体内的溶液、乳状液及临用前配制成溶液的粉末或浓溶液的无菌制剂。",
                                        "kws": "中成药注射剂、解表针剂、泻下针剂、和解针剂、温里针剂、清热针剂、祛暑针剂、补益针剂、固涩针剂、安神针剂、开窍针剂、理气针剂、理血针剂、止血针剂、治风针剂、祛湿针剂、祛风湿针剂、祛痰针剂、止咳平喘针剂、消食针剂、治泻痢针剂、小儿镇惊针剂、治产后病针剂、安胎针剂、利咽针剂、明目针剂、通鼻针剂、治耳针剂、驱虫针剂、杀虫针剂、止痒针剂、治痔针剂、治疮疡针剂、止酸解痉治胃痛针剂、抗痨针剂、抗癌针剂、解表注射液、泻下注射液、和解注射液、温里注射液、清热注射液、祛暑注射液、补益注射液、固涩注射液、安神注射液、开窍注射液",
                                        "taxName": "中成药",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070304050000000000",
                                        "taxCodeTitle": "中成药",
                                        "iTitle": "*中成药*中成药注射剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1886",
                                        "linkid": "1880",
                                        "code": "107030406",
                                        "paCode": "1070304",
                                        "yn": "N",
                                        "title": "膏药",
                                        "alias": "膏药",
                                        "about": "指饮片、食用植物油与红丹（铅丹）或官粉（铅粉）炼制成膏料，摊涂于裱背材料上制成的供皮肤贴敷的外用制剂。前者称为黑膏药，后者称为白膏药。包括蜜膏。",
                                        "kws": "膏药、解表膏药、泻下膏药、和解膏药、温里膏药、清热膏药、祛暑膏药、补益膏药、固涩膏药、安神膏药、开窍膏药、理气膏药、理血膏药、止血膏药、治风膏药、祛湿膏药、祛风湿膏药、祛痰膏药、止咳平喘膏药、消食膏药、治泻痢膏药、小儿镇惊膏药、调经膏药、止带膏药、治产后病膏药、安胎膏药、利咽膏药、明目膏药、通鼻膏药、治耳膏药、驱虫膏药、杀虫膏药、止痒膏药、治痔膏药、治疮疡膏药、止酸解痉治胃痛膏药、抗痨膏药、抗癌膏药",
                                        "taxName": "中成药",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070304060000000000",
                                        "taxCodeTitle": "中成药",
                                        "iTitle": "*中成药*膏药",
                                        "children": []
                                    },
                                    {
                                        "id": "1887",
                                        "linkid": "1880",
                                        "code": "107030407",
                                        "paCode": "1070304",
                                        "yn": "N",
                                        "title": "中成药口服液",
                                        "alias": "中成药口服液",
                                        "about": "指饮片用水或其他溶剂，采用适宜方法提取制成的口服液体制剂。",
                                        "kws": "中成药口服液、解表口服液、泻下口服液、和解口服液、温里口服液、清热口服液、祛暑口服液、补益口服液、固涩口服液、安神口服液、开窍口服液、理气口服液、理血口服液、止血口服液、治风口服液、祛湿口服液、祛风湿口服液、祛痰口服液、止咳平喘口服液、消食口服液、治泻痢口服液、小儿镇惊口服液、调经口服液、止带口服液、治产后病口服液、安胎口服液、利咽口服液、明目口服液、通鼻口服液、治耳口服液、驱虫口服液、杀虫口服液、止痒口服液、治痔口服液、治疮疡口服液、止酸解痉治胃痛口服液、抗痨口服液、抗癌口服液",
                                        "taxName": "中成药",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070304070000000000",
                                        "taxCodeTitle": "中成药",
                                        "iTitle": "*中成药*中成药口服液",
                                        "children": []
                                    },
                                    {
                                        "id": "1888",
                                        "linkid": "1880",
                                        "code": "107030408",
                                        "paCode": "1070304",
                                        "yn": "N",
                                        "title": "中成药胶囊",
                                        "alias": "中成药胶囊",
                                        "about": "指将提取物、饮片用适宜方法加工后，加入适宜辅料填充于空心胶囊或密封于软质囊材中的制剂，可分为硬胶囊、软胶囊（胶丸）和肠溶胶囊等，主要供口服用。",
                                        "kws": "中成药胶囊、解表胶囊、泻下胶囊、和解胶囊、温里胶囊、清热胶囊、祛暑胶囊、补益胶囊、固涩胶囊、安神胶囊、开窍胶囊、理气胶囊、理血胶囊、止血胶囊、治风胶囊、祛湿胶囊、祛风湿胶囊、祛痰胶囊、止咳平喘胶囊、消食胶囊、治泻痢胶囊、小儿镇惊胶囊、调经胶囊、止带胶囊、治产后病胶囊、安胎胶囊、利咽胶囊、明目胶囊、通鼻胶囊、治耳胶囊、驱虫胶囊、杀虫胶囊、止痒胶囊、治痔胶囊、治疮疡胶囊、止酸解痉治胃痛胶囊、抗痨胶囊、抗癌胶囊",
                                        "taxName": "中成药",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070304080000000000",
                                        "taxCodeTitle": "中成药",
                                        "iTitle": "*中成药*中成药胶囊",
                                        "children": []
                                    },
                                    {
                                        "id": "1889",
                                        "linkid": "1880",
                                        "code": "107030409",
                                        "paCode": "1070304",
                                        "yn": "N",
                                        "title": "中成药散剂",
                                        "alias": "中成药散剂",
                                        "about": "指饮片或提取物经粉碎、均匀混合制成的粉末状制剂，分为内服散剂和外用散剂。",
                                        "kws": "中成药散剂、解表散剂、泻下散剂、和解散剂、温里散剂、清热散剂、祛暑散剂、补益散剂、固涩散剂、安神散剂、开窍散剂、理气散剂、理血散剂、止血散剂、治风散剂、祛湿散剂、祛风湿散剂、祛痰散剂、止咳平喘散剂、消食散剂、治泻痢散剂、小儿镇惊散剂、调经散剂、止带散剂、治产后病散剂、安胎散剂、利咽散剂、明目散剂、通鼻散剂、治耳散剂、驱虫散剂、杀虫散剂、止痒散剂、治痔散剂、治疮疡散剂、止酸解痉治胃痛散剂、抗痨散剂、抗癌散剂",
                                        "taxName": "中成药",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070304090000000000",
                                        "taxCodeTitle": "中成药",
                                        "iTitle": "*中成药*中成药散剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1890",
                                        "linkid": "1880",
                                        "code": "107030410",
                                        "paCode": "1070304",
                                        "yn": "N",
                                        "title": "中成药栓剂",
                                        "alias": "中成药栓剂",
                                        "about": "指提取物或饮片细粉与适宜基质制成供腔道给药的固体制剂。",
                                        "kws": "中成药栓剂、解表栓剂、泻下栓剂、和解栓剂、温里栓剂、清热栓剂、祛暑栓剂、补益栓剂、固涩栓剂、安神栓剂、开窍栓剂、理气栓剂、理血栓剂、止血栓剂、治风栓剂、祛湿栓剂、祛风湿栓剂、祛痰栓剂、止咳平喘栓剂、消食栓剂、治泻痢栓剂、小儿镇惊栓剂、调经栓剂、止带栓剂、治产后病栓剂、安胎栓剂、利咽栓剂、明目栓剂、通鼻栓剂、治耳栓剂、驱虫栓剂、杀虫栓剂、止痒栓剂、治痔栓剂、治疮疡栓剂、止酸解痉治胃痛栓剂、抗痨栓剂、抗癌栓剂",
                                        "taxName": "中成药",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070304100000000000",
                                        "taxCodeTitle": "中成药",
                                        "iTitle": "*中成药*中成药栓剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1891",
                                        "linkid": "1880",
                                        "code": "107030411",
                                        "paCode": "1070304",
                                        "yn": "N",
                                        "title": "药酒",
                                        "alias": "药酒",
                                        "about": "指饮片用蒸馏酒提取制成的澄清液体制剂。",
                                        "kws": "药酒、补益药酒、固涩药酒、安神药酒、开窍药酒、理气药酒、理血药酒、止血药酒、治风药酒、祛湿药酒",
                                        "taxName": "中成药",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070304110000000000",
                                        "taxCodeTitle": "中成药",
                                        "iTitle": "*中成药*药酒",
                                        "children": []
                                    },
                                    {
                                        "id": "1892",
                                        "linkid": "1880",
                                        "code": "107030412",
                                        "paCode": "1070304",
                                        "yn": "N",
                                        "title": "清凉油",
                                        "alias": "清凉油",
                                        "about": "指含挥发性成分的饮片用水蒸气蒸馏法制成的芳香水剂。或指饮片用乙醇、油或其他适宜溶剂制成的供无破损患处揉擦用的液体制剂。",
                                        "kws": "清凉油、治风剂清凉油",
                                        "taxName": "中成药",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070304120000000000",
                                        "taxCodeTitle": "中成药",
                                        "iTitle": "*中成药*清凉油",
                                        "children": []
                                    },
                                    {
                                        "id": "1893",
                                        "linkid": "1880",
                                        "code": "107030499",
                                        "paCode": "1070304",
                                        "yn": "N",
                                        "title": "其他中成药",
                                        "alias": "其他中成药",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "中成药",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070304990000000000",
                                        "taxCodeTitle": "中成药",
                                        "iTitle": "*中成药*其他中成药",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1894",
                                "linkid": "1836",
                                "code": "1070305",
                                "paCode": "10703",
                                "yn": "Y",
                                "title": "兽用药品",
                                "alias": "兽用药品",
                                "about": "指调节动物机体功能、预防、治疗动物疾病等方面的药物。包括宠物类动物用药品。",
                                "kws": null,
                                "taxName": "兽用药品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070305000000000000",
                                "taxCodeTitle": "兽用药品",
                                "iTitle": "*兽用药品*兽用药品",
                                "children": [
                                    {
                                        "id": "1895",
                                        "linkid": "1894",
                                        "code": "107030501",
                                        "paCode": "1070305",
                                        "yn": "N",
                                        "title": "兽用化学药品",
                                        "alias": "兽用化学药品",
                                        "about": "指直接用于动物疾病防治、诊断等方面的化学药品制剂。通常是通过合成或者半合成的方法制得的原料药及其制剂；天然物质中提取或者通过发酵提取的新的有效单体及其制剂；用拆分或者合成等方法制得的已知药物中的光学异构体及其制剂。包括兽用抗菌素药品、含有奎宁及其盐的兽用药品、含有磺胺兽用药品、其他兽用化学药品。",
                                        "kws": "兽用化学药品、兽用抗菌素药品、兽用青霉素类药品、兽用链霉素类药品、兽用头孢菌素类药品、兽用氯霉素药品、含有奎宁及其盐的兽用药品、含有磺胺兽用药品、兽用中草药、兽用疫苗",
                                        "taxName": "兽用药品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070305010000000000",
                                        "taxCodeTitle": "兽用药品",
                                        "iTitle": "*兽用药品*兽用化学药品",
                                        "children": []
                                    },
                                    {
                                        "id": "1896",
                                        "linkid": "1894",
                                        "code": "107030502",
                                        "paCode": "1070305",
                                        "yn": "N",
                                        "title": "兽用中草药",
                                        "alias": "兽用中草药",
                                        "about": "指直接用于动物疾病防治、诊断等方面的兽用中药材、饮片和中成药。",
                                        "kws": "兽用中草药",
                                        "taxName": "兽用药品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1070305020000000000",
                                        "taxCodeTitle": "兽用药品",
                                        "iTitle": "*兽用药品*兽用中草药",
                                        "children": []
                                    },
                                    {
                                        "id": "1897",
                                        "linkid": "1894",
                                        "code": "107030503",
                                        "paCode": "1070305",
                                        "yn": "N",
                                        "title": "兽用疫苗",
                                        "alias": "兽用疫苗",
                                        "about": "指为了预防、控制传染病的发生、流行，用于动物预防接种的疫苗类预防性生物制品。",
                                        "kws": "兽用疫苗",
                                        "taxName": "兽用药品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070305030000000000",
                                        "taxCodeTitle": "兽用药品",
                                        "iTitle": "*兽用药品*兽用疫苗",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1898",
                                "linkid": "1836",
                                "code": "1070306",
                                "paCode": "10703",
                                "yn": "Y",
                                "title": "生物化学药品",
                                "alias": "生物化学药品",
                                "about": "指运用生物学、医学、生物化学等的研究成果，综合利用物理学、化学、生物化学、生物技术和药学等学科的原理和方法，利用生物体、生物组织、细胞、体液等制造的一类用于治疗和诊断的符合国家规定药品。",
                                "kws": null,
                                "taxName": "生物化学药品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070306000000000000",
                                "taxCodeTitle": "生物化学药品",
                                "iTitle": "*生物化学药品*生物化学药品",
                                "children": [
                                    {
                                        "id": "1899",
                                        "linkid": "1898",
                                        "code": "107030601",
                                        "paCode": "1070306",
                                        "yn": "N",
                                        "title": "酶类生化制剂",
                                        "alias": "酶类生化制剂",
                                        "about": "指通过生物化学技术从生物体内提取、分离、纯化与确认的用于消化、抗炎净创、血凝和解凝、解毒、诊断的酶类制剂。包括片剂、水针、粉针、胶囊、输液。包括胰蛋白酶制剂、糜蛋白酶制剂、菠萝蛋白酶制剂、链激酶制剂、重组链激酶制剂、双链酶制剂、尿激酶制剂、溶菌酶制剂、辅酶Q10制剂、辅酶Ⅰ制剂、复合辅酶制剂、门冬酰胺酶制剂、胰酶制剂、多酶制剂、胃蛋白酶制剂、含糖胃蛋白酶制剂、淀粉酶制剂、其他酶类生化制剂",
                                        "kws": "酶类生化制剂、胰蛋白酶制剂、注射用胰蛋白酶、注射用结晶糜胰蛋白酶、复方胰蛋白酶胶囊、糜蛋白酶制剂、注射用糜蛋白酶、菠萝蛋白酶制剂、芦笋菠萝蛋白酶胶囊、复方菠萝蛋白酶片、链激酶制剂、注射用冻干链激酶、重组链激酶制剂、注射用重组链激酶、双链酶制剂、双链酶片剂、注射用双链酶、尿激酶制剂、注射用尿激酶脂质体冻干品、口服用尿激酶脂质体冻干品、溶菌酶制剂、复方氯化溶菌酶胶囊、溶菌酶片剂、辅酶Q10制剂、辅酶Q10片剂、辅酶Q10胶囊剂、辅酶Ⅰ制剂、注射用辅酶Ⅰ、复合辅酶制剂、注射用复合辅酶、门冬酰胺酶制剂、注射用左旋",
                                        "taxName": "生物化学药品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070306010000000000",
                                        "taxCodeTitle": "生物化学药品",
                                        "iTitle": "*生物化学药品*酶类生化制剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1900",
                                        "linkid": "1898",
                                        "code": "107030602",
                                        "paCode": "1070306",
                                        "yn": "N",
                                        "title": "氨基酸及蛋白质类药",
                                        "alias": "氨基酸及蛋白质类药",
                                        "about": "指用于预防、治疗和诊断的氨基酸和蛋白质类物质生物药物。包括乙酰半胱氨酸制剂、羧甲司坦制剂、盐酸美司坦制剂、胱氨酸制剂、盐酸赖氨酸制剂、谷氨酸制剂、门冬氨酸制剂、门冬酰胺制剂、复合氨基酸制剂、复方氨基酸制剂、复方赖氨酸制剂、注射用氨基酸类药及输液、其他氨基酸及蛋白质药制剂。",
                                        "kws": "乙酰半胱氨酸制剂、乙酰半胱氨酸颗粒剂、乙酰半胱氨酸喷雾剂、羧甲司坦制剂、羧甲司坦口服溶液、羧甲司坦片、盐酸美司坦制剂、盐酸美司坦片剂、盐酸美司坦粉剂、胱氨酸制剂、注射用盐酸半胱氨酸、复方胱氨酸片、盐酸赖氨酸制剂、盐酸赖氨酸颗粒、盐酸赖氨酸片、谷氨酸制剂、精谷氨酸注射液、谷氨酸钠注射液、谷氨酸钾注射液、谷氨酸钙注射液、谷氨酸片、门冬氨酸制剂、门冬氨酸镁注射液、门冬氨酸钾镁注射液、注射用鸟氨酰门冬氨酸、门冬氨酸片剂、门冬酰胺制剂、门冬酰胺片、复合氨基酸制剂、复合氨基酸输液、9-复合结晶氨基酸注射液、18氨基酸",
                                        "taxName": "生物化学药品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070306020000000000",
                                        "taxCodeTitle": "生物化学药品",
                                        "iTitle": "*生物化学药品*氨基酸及蛋白质类药",
                                        "children": []
                                    },
                                    {
                                        "id": "1901",
                                        "linkid": "1898",
                                        "code": "107030603",
                                        "paCode": "1070306",
                                        "yn": "N",
                                        "title": "脂肪类药制剂",
                                        "alias": "脂肪类药制剂",
                                        "about": "包括注射用脂肪类药、脂肪类药胶囊、脂肪类药片剂。包括注射用脂肪类药、脂肪类药胶囊、脂肪类药片剂、其他脂肪类药制剂。",
                                        "kws": "脂肪类药制剂、注射用脂肪类药、注射用紫杉醇脂质体、油酸多相脂质体注射液、脂肪乳注射液、脂肪类药胶囊、磷脂软胶囊、磷脂维生素E胶囊、卵磷脂胶囊、脂肪类药片剂、卵磷脂片、复方α-酮酸片",
                                        "taxName": "生物化学药品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070306030000000000",
                                        "taxCodeTitle": "生物化学药品",
                                        "iTitle": "*生物化学药品*脂肪类药制剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1902",
                                        "linkid": "1898",
                                        "code": "107030604",
                                        "paCode": "1070306",
                                        "yn": "N",
                                        "title": "核酸类药制剂",
                                        "alias": "核酸类药制剂",
                                        "about": "包括三磷腺苷钠制剂、环磷腺苷制剂、肌苷制剂、核糖核酸制剂、其他核酸类药制剂。",
                                        "kws": "核酸类药制剂、三磷腺苷钠制剂、注射用三磷腺苷、三磷腺苷二钠注射液、三磷腺苷二钠肠溶片、三磷酸胞苷二钠制剂、环磷腺苷制剂、注射用环磷腺苷、注射用环磷腺苷葡胺、注射用双丁酰环磷腺苷、注射用双丁酰环磷腺苷钙、肌苷制剂、注射用肌苷、肌苷片、肌苷胶囊、核糖核酸制剂、免疫核糖核酸粉针剂、核糖核酸注射剂",
                                        "taxName": "生物化学药品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070306040000000000",
                                        "taxCodeTitle": "生物化学药品",
                                        "iTitle": "*生物化学药品*核酸类药制剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1903",
                                        "linkid": "1898",
                                        "code": "107030699",
                                        "paCode": "1070306",
                                        "yn": "N",
                                        "title": "其他生物化学药品",
                                        "alias": "其他生物化学药品",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "生物化学药品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070306990000000000",
                                        "taxCodeTitle": "生物化学药品",
                                        "iTitle": "*生物化学药品*其他生物化学药品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1904",
                                "linkid": "1836",
                                "code": "1070307",
                                "paCode": "10703",
                                "yn": "Y",
                                "title": "生物化学制品",
                                "alias": "生物化学制品",
                                "about": "指以微生物、细胞、动物或人源组织和体液等为原料，应用传统技术或现代生物技术制成，用于人类疾病预防、治疗和诊断的制品。不包括生物化学药品（详见1070306）。",
                                "kws": null,
                                "taxName": "生物化学制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070307000000000000",
                                "taxCodeTitle": "生物化学制品",
                                "iTitle": "*生物化学制品*生物化学制品",
                                "children": [
                                    {
                                        "id": "1905",
                                        "linkid": "1904",
                                        "code": "107030701",
                                        "paCode": "1070307",
                                        "yn": "N",
                                        "title": "菌苗",
                                        "alias": "菌苗",
                                        "about": "指用细菌体制成的生物制品称菌苗。",
                                        "kws": "菌苗、伤寒菌苗、霍乱菌苗、霍乱伤寒混合菌苗、霍乱伤寒副伤寒甲乙菌苗、伤寒副伤寒甲乙菌苗、伤寒副伤寒甲二联菌苗、伤寒？副伤寒甲？乙三联菌苗、霍乱？伤寒？副伤寒甲？乙四联菌苗、百日咳菌苗、钩端螺旋体菌苗、多价钩端螺旋体菌苗、脑膜炎球菌多糖菌苗、炭疽活菌苗、气管炎菌苗、气管炎溶菌菌苗、吸附霍乱菌苗、吸附霍乱类毒素菌苗、冻干牛痘苗、流脑菌苗",
                                        "taxName": "生物化学制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070307010000000000",
                                        "taxCodeTitle": "生物化学制品",
                                        "iTitle": "*生物化学制品*菌苗",
                                        "children": []
                                    },
                                    {
                                        "id": "1906",
                                        "linkid": "1904",
                                        "code": "107030702",
                                        "paCode": "1070307",
                                        "yn": "N",
                                        "title": "菌苗制剂",
                                        "alias": "菌苗制剂",
                                        "about": "指对某一特定传染病产生或增加人工免疫力的制剂。",
                                        "kws": "菌苗制剂、吸附百日咳白喉破伤风混合制剂、吸附百日咳菌苗白喉类毒素混合制剂、卡介苗多糖核酸、破伤风类毒素混合制剂、核酪制剂、口服多价痢疾噬菌体、哮喘菌苗注射液、气管炎菌苗片",
                                        "taxName": "生物化学制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070307020000000000",
                                        "taxCodeTitle": "生物化学制品",
                                        "iTitle": "*生物化学制品*菌苗制剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1907",
                                        "linkid": "1904",
                                        "code": "107030703",
                                        "paCode": "1070307",
                                        "yn": "N",
                                        "title": "人用疫苗",
                                        "alias": "人用疫苗",
                                        "about": "指用细菌、病毒等病原微生物制成的生物制品。包括脑炎疫苗、脑膜炎疫苗、麻疹、风疹及腮腺炎疫苗、狂犬病疫苗、脊髓灰质炎疫苗、肝炎疫苗、流感疫苗、肾综合症疫苗、破伤风、白喉及百日咳疫苗、黄热减毒活疫苗、其他人用疫苗。",
                                        "kws": "人用疫苗、脑炎疫苗、乙型脑炎灭活疫苗、乙型脑炎纯化疫苗细胞、冻干流行性乙型脑炎活疫苗、乙型脑炎减毒活疫苗、森林脑炎疫苗、森林脑炎灭活疫苗、脑膜炎疫苗、A群脑膜炎球菌多糖疫苗、A+C群脑膜炎球菌多糖疫苗、麻疹风疹及腮腺炎疫苗、冻干麻疹活疫苗、麻疹减毒活疫苗、风疹减毒活疫苗、麻疹风疹二联减毒活疫苗、麻疹腮腺炎、风疹三联减毒活疫苗、麻疹腮腺炎风疹活病毒疫苗、冻干流行性腮腺炎活疫苗、腮腺炎减毒活疫苗、流行性斑疹伤寒疫苗、狂犬病疫苗、人用浓缩狂犬病疫苗、人用狂犬病纯化疫苗、冻干人用狂犬病疫苗、脊髓灰质炎疫苗、口服脊",
                                        "taxName": "生物化学制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070307030000000000",
                                        "taxCodeTitle": "生物化学制品",
                                        "iTitle": "*生物化学制品*人用疫苗",
                                        "children": []
                                    },
                                    {
                                        "id": "1908",
                                        "linkid": "1904",
                                        "code": "107030704",
                                        "paCode": "1070307",
                                        "yn": "N",
                                        "title": "类毒素",
                                        "alias": "类毒素",
                                        "about": "指用细菌产生的外毒素，加入甲醛后使变为无毒性但仍有免疫性的制剂，称为“类毒素”，如破伤风类毒素、白喉类毒素等。",
                                        "kws": "类毒素、吸附精制白喉类毒素、吸附精制白喉破伤风二联类毒素、吸附精制破伤风类毒素、吸附精制破伤风·气性坏疽四联类毒类、葡萄球菌类毒素",
                                        "taxName": "生物化学制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070307040000000000",
                                        "taxCodeTitle": "生物化学制品",
                                        "iTitle": "*生物化学制品*类毒素",
                                        "children": []
                                    },
                                    {
                                        "id": "1909",
                                        "linkid": "1904",
                                        "code": "107030705",
                                        "paCode": "1070307",
                                        "yn": "N",
                                        "title": "抗毒素类",
                                        "alias": "抗毒素类",
                                        "about": "指动物血清制品。是细菌毒素（通常指外毒素)的对应抗体。包括白喉抗毒素、破伤风抗毒素、多价气性坏疽抗毒素、肉毒抗毒素制剂、其他抗毒素。",
                                        "kws": "抗毒素、白喉抗毒素、冻干白喉抗毒素、精制白喉抗毒素、冻干精制白喉抗毒素、破伤风抗毒素、冻干破伤风抗毒素、精制破伤风抗毒素、冻干精制破伤风抗毒素、多价气性坏疽抗毒素、多价精制气坏疽抗毒素、冻干多价气性坏疽抗毒素、冻干多价精制气坏疽抗毒素、肉毒抗毒素制剂、精制A型肉毒抗毒素、精制B型肉抗毒素、精制E型肉毒抗毒素、冻干精制B型肉毒抗毒素、冻干精制E型肉毒抗毒素",
                                        "taxName": "生物化学制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070307050000000000",
                                        "taxCodeTitle": "生物化学制品",
                                        "iTitle": "*生物化学制品*抗毒素类",
                                        "children": []
                                    },
                                    {
                                        "id": "1910",
                                        "linkid": "1904",
                                        "code": "107030706",
                                        "paCode": "1070307",
                                        "yn": "N",
                                        "title": "抗血清类",
                                        "alias": "抗血清类",
                                        "about": "指免疫血清亦称抗血清。含有抗体的血清制剂。是含有多克隆抗体的血清。包括抗蛇毒血清、抗狂犬病血清、抗炭疽血清、抗赤痢血清、精制抗腺病毒血清、抗淋巴细胞血清、其他抗血清。",
                                        "kws": "抗蛇毒血清、精制抗蝮蛇毒血清、精制抗眼镜蛇毒血清？、精制抗银环蛇毒血清、精制抗五步蛇毒血清？、抗狂犬病血清、冻干抗狂犬病血清、精制抗狂犬病血清、冻干精制抗狂犬病血清、抗炭疽血清、精制抗炭疽血清、冻干精制抗炭疽血清、抗赤痢血清、精制抗腺病毒血清、抗淋巴细胞血清",
                                        "taxName": "生物化学制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070307060000000000",
                                        "taxCodeTitle": "生物化学制品",
                                        "iTitle": "*生物化学制品*抗血清类",
                                        "children": []
                                    },
                                    {
                                        "id": "1911",
                                        "linkid": "1904",
                                        "code": "107030707",
                                        "paCode": "1070307",
                                        "yn": "Y",
                                        "title": "血液制品",
                                        "alias": "血液制品",
                                        "about": "指由健康人血浆或经特异免疫的人血浆，经分离、提纯或由重组DNA技术制成的血浆蛋白组分，以及血液细胞有形成分统称为血液制品。包括球蛋白、白蛋白、其他血液制品制剂。",
                                        "kws": "血液制品、球蛋白、白蛋白、人血丙种球蛋白、人胎盘血丙种球蛋白、冻干人胎盘血丙种球蛋白、组织胺丙种球蛋白、冻干组织胺丙种球蛋白、高效价免疫球蛋白、抗人胸腺球蛋白、抗人淋巴细胞球蛋白、富含人α2巨球蛋白、人血白蛋白、冻干人血白蛋白、人胎盘血白蛋白、冻干人胎盘血白蛋白、冻干人抗血友病球蛋白、冻干人纤维蛋白原、人血甲巨球蛋白、血液制品制剂、血浆蛋白溶液、人血蛋白、冻干健康人血浆、冻干抗绿脓杆菌人血浆、人红细胞水解蛋白注射液、人血丙种球蛋白静脉注射液、人胎盘组织液、人胎盘组织浆、人脐带组织浆、人胎盘血白蛋白注射剂、",
                                        "taxName": "生物化学制品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1070307070000000000",
                                        "taxCodeTitle": "生物化学制品",
                                        "iTitle": "*生物化学制品*血液制品",
                                        "children": [
                                            {
                                                "id": "1912",
                                                "linkid": "1911",
                                                "code": "10703070701",
                                                "paCode": "107030707",
                                                "yn": "N",
                                                "title": "临床用血",
                                                "alias": "临床用血",
                                                "about": "指可以临床使用的人体血液。",
                                                "kws": "临床用血",
                                                "taxName": "生物化学制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070307070100000000",
                                                "taxCodeTitle": "生物化学制品",
                                                "iTitle": "*生物化学制品*临床用血",
                                                "children": []
                                            },
                                            {
                                                "id": "1913",
                                                "linkid": "1911",
                                                "code": "10703070799",
                                                "paCode": "107030707",
                                                "yn": "N",
                                                "title": "其他血液制品",
                                                "alias": "其他血液制品",
                                                "about": null,
                                                "kws": null,
                                                "taxName": "生物化学制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070307079900000000",
                                                "taxCodeTitle": "生物化学制品",
                                                "iTitle": "*生物化学制品*其他血液制品",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "1914",
                                        "linkid": "1904",
                                        "code": "107030708",
                                        "paCode": "1070307",
                                        "yn": "N",
                                        "title": "细胞因子",
                                        "alias": "细胞因子",
                                        "about": "指机体的免疫细胞和非免疫细胞能合成和分泌小分子的多肽类因子，它们调节多种细胞生理功能，这些因子统称为细胞因子（cytokines）。细胞因子包括淋巴细胞产生的淋巴因子和单核巨噬细胞产生的单核因子等。包括干扰素制剂、胸腺肽制剂、转移因子制剂、促肝细胞生长素制剂、白介素制剂、其他细胞因子制剂。",
                                        "kws": "细胞因子、干扰素制剂、干扰素α-1b制剂、冻干重组人干扰素α-2a制剂、冻干重组人干扰素α-1b、冻干重组人干扰素α-2b制剂、注射用干扰素α1、干扰素α-n1注射液、注射用干扰素γ、注射用人白细胞干扰素、胸腺肽制剂、胸腺喷丁制剂、胸腺蛋白口服液、注射用胸腺肽α1、注射用胸腺因子、胸腺因子D注射液、转移因子制剂、P-转移因子制剂、β-转移因子制剂、冻干人白细胞转移因子、注射用抗乙型肝炎i-PSTF转移因子、促肝细胞生长素制剂、促肝细胞生长因子注射液、白介素制剂、注射用白介素-2、注射用重组人白介素-2",
                                        "taxName": "生物化学制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070307080000000000",
                                        "taxCodeTitle": "生物化学制品",
                                        "iTitle": "*生物化学制品*细胞因子",
                                        "children": []
                                    },
                                    {
                                        "id": "1915",
                                        "linkid": "1904",
                                        "code": "107030709",
                                        "paCode": "1070307",
                                        "yn": "N",
                                        "title": "诊断用生物制品",
                                        "alias": "诊断用生物制品",
                                        "about": "指用于诊断的生物制品。包括诊断用菌素、菌液、菌体、诊断血球、诊断用抗原、诊断用血凝素、诊断用血清、试验用毒素、诊断用生物试剂盒。",
                                        "kws": "诊断用生物制品、诊断用菌素、菌液、菌体、旧结核菌素、伤寒诊断菌液、副伤寒诊断菌液、伤寒副伤寒及变形菌诊断菌液、布氏菌素、试管凝集反应用布氏杆菌液、玻片凝集反应用布氏杆菌液、伤寒菌ViD诊断用噬菌体、金黄色葡萄球菌分型噬菌体、沙门氏菌诊断用噬菌体、志贺氏菌诊断用噬菌体、大肠艾希氏菌诊断用噬菌体、霍乱菌诊断用噬菌体、鼠疫菌诊断噬菌体、炭疽菌诊断噬菌体、诊断血球、流行性乙型脑炎抗体诊断血球、冻干乙型肝炎病毒诊断血球、流行性出血热诊断血球、诊断用抗原、诊断用冻干鼠疫菌F抗原、诊断用炭疽抗原、森林脑炎病毒补体结合抗",
                                        "taxName": "生物化学制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070307090000000000",
                                        "taxCodeTitle": "生物化学制品",
                                        "iTitle": "*生物化学制品*诊断用生物制品",
                                        "children": []
                                    },
                                    {
                                        "id": "1916",
                                        "linkid": "1904",
                                        "code": "107030710",
                                        "paCode": "1070307",
                                        "yn": "N",
                                        "title": "生物制剂",
                                        "alias": "生物制剂",
                                        "about": "包括生物菌及菌片、生物试剂盒、微生物培养基以及其他生物制剂。包括生物菌及菌片、生物试剂盒、微生物培养基、其他生物制剂。",
                                        "kws": "生物制剂、生物菌、菌片、双歧杆菌、乳杆菌、嗜热链球菌、三联活菌片、酪酸菌制剂片剂、乳酸菌素片、乳酸菌液、枯草芽孢杆菌喷雾剂、多维乳酸菌散、A群脑膜炎球菌多糖疫苗稀释液、生物试剂盒、微生物培养基",
                                        "taxName": "生物化学制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070307100000000000",
                                        "taxCodeTitle": "生物化学制品",
                                        "iTitle": "*生物化学制品*生物制剂",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1917",
                                "linkid": "1836",
                                "code": "1070308",
                                "paCode": "10703",
                                "yn": "Y",
                                "title": "医用材料",
                                "alias": "医用材料",
                                "about": "指医用软填料、纱布、绷带及类似物品。",
                                "kws": null,
                                "taxName": "医用材料",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070308000000000000",
                                "taxCodeTitle": "医用材料",
                                "iTitle": "*医用材料*医用材料",
                                "children": [
                                    {
                                        "id": "1918",
                                        "linkid": "1917",
                                        "code": "107030801",
                                        "paCode": "1070308",
                                        "yn": "N",
                                        "title": "卫生材料及敷料",
                                        "alias": "卫生材料及敷料",
                                        "about": "指用于物品主料之外的辅属材料，经药物浸涂胶粘敷料、脱脂棉花及类似医用软填料等。包括经药物浸涂胶粘敷料、纱布、脱脂棉花及类似医用软填料、医用敷料、医用缝合材料及外科用无菌材料、无菌外科肠线及类似缝合材料、无菌昆布及无菌昆布塞条、外科及牙科用无菌材料。",
                                        "kws": "经药物浸涂胶粘敷料、医用橡皮膏、创可贴止血膏布、消炎喷雾胶布、新霉素软膏纱布、脱脂棉花及类似医用软填料、医用脱脂棉花、绷带、纱布、医用敷料、皮肤敷料、液体敷料、医用缝合材料、外科用无菌材料、无菌外科肠线及类似缝合材料、肠线、天然纤维缝合材料、合成聚合纤维医用缝合材料、医用金属缝合材料、粘合胶布、无菌昆布、无菌昆布塞条、牙科用无菌材料",
                                        "taxName": "医药",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070308010000000000",
                                        "taxCodeTitle": "医药",
                                        "iTitle": "*医药*卫生材料及敷料",
                                        "children": []
                                    },
                                    {
                                        "id": "1919",
                                        "linkid": "1917",
                                        "code": "107030802",
                                        "paCode": "1070308",
                                        "yn": "N",
                                        "title": "牙科粘固剂、牙科填料",
                                        "alias": "牙科粘固剂、牙科填料",
                                        "about": "包括牙科填料、牙科粘固剂、骨骼粘固剂、其他牙科填料。不包括经特殊煅烧或精细研磨的牙科用熟石膏及以熟石膏为基本成分的牙科用制品（详见107030803）。",
                                        "kws": "牙科粘固剂、牙科填料、义齿材料、齿科植入材料、根管充填材料、永久性充填材料、暂封性充填材料、骨骼粘固剂",
                                        "taxName": "医药",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070308020000000000",
                                        "taxCodeTitle": "医药",
                                        "iTitle": "*医药*牙科粘固剂、牙科填料",
                                        "children": []
                                    },
                                    {
                                        "id": "1920",
                                        "linkid": "1917",
                                        "code": "107030803",
                                        "paCode": "1070308",
                                        "yn": "N",
                                        "title": "牙科用造型膏及类似制品",
                                        "alias": "牙科用造型膏及类似制品",
                                        "about": "指制作各种口腔组织阳模的材料。主要有石膏、人造石、低熔合金、模型蜡等。",
                                        "kws": "牙科用造型膏、牙科用蜡、牙科用熟石灰制品",
                                        "taxName": "医药",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070308030000000000",
                                        "taxCodeTitle": "医药",
                                        "iTitle": "*医药*牙科用造型膏及类似制品",
                                        "children": []
                                    },
                                    {
                                        "id": "1921",
                                        "linkid": "1917",
                                        "code": "107030804",
                                        "paCode": "1070308",
                                        "yn": "N",
                                        "title": "病人医用试剂",
                                        "alias": "病人医用试剂",
                                        "about": "包括血型试剂、影象检查用化学药制剂、器官功能检查剂。",
                                        "kws": "病人医用试剂、血型试剂、确定血型试剂、测定血清特征试剂、血型技术所需相关试剂、影象检查用化学药制剂、口服X光检查造影剂、注射用X光检查造影剂、器官功能检查剂、妊娠诊断剂、酚磺酞注射液、刚果红注射液、荧光素钠滴眼液、偶氮蓝注射液、糖精钠注射液",
                                        "taxName": "医药",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070308040000000000",
                                        "taxCodeTitle": "医药",
                                        "iTitle": "*医药*病人医用试剂",
                                        "children": []
                                    },
                                    {
                                        "id": "1922",
                                        "linkid": "1917",
                                        "code": "107030805",
                                        "paCode": "1070308",
                                        "yn": "N",
                                        "title": "非病人用诊断检验、实验用试剂",
                                        "alias": "非病人用诊断检验、实验用试剂",
                                        "about": "指用于医疗、兽医、科学及工业上诊断或实验用试剂及配制试剂，检定参照物；包括用诊断或实验用试剂浸渍或涂布的纸、塑料或其他材料（作衬背或载体用）。包括有衬背的诊断或实验用试剂、无衬背的诊断或实验用试剂、空心胶囊。",
                                        "kws": "非病人用诊断检验、实验用试剂、有衬背的诊断或实验用试剂、极谱纸、石蕊试纸、无衬背诊断用试剂、无衬背实验用试剂、基因诊断试剂、乙肝诊断试剂、艾滋诊断试剂、丙肝诊断试剂、二对半诊断试剂、空心胶囊、明胶胶囊、粉浆装药空囊、植物胶囊",
                                        "taxName": "医药",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070308050000000000",
                                        "taxCodeTitle": "医药",
                                        "iTitle": "*医药*非病人用诊断检验、实验用试剂",
                                        "children": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "id": "1923",
                        "linkid": "1172",
                        "code": "10704",
                        "paCode": "107",
                        "yn": "Y",
                        "title": "化学纤维",
                        "alias": "化学纤维",
                        "about": "指用天然的或人工合成的高分子物质为原料、经过化学或物理方法加工而制得的纤维的统称。",
                        "kws": null,
                        "taxName": "化学纤维",
                        "taxRate": "",
                        "vip": "7",
                        "itaxRate": null,
                        "taxCode": "1070400000000000000",
                        "taxCodeTitle": "化学纤维",
                        "iTitle": "*化学纤维*化学纤维",
                        "children": [
                            {
                                "id": "1924",
                                "linkid": "1923",
                                "code": "1070401",
                                "paCode": "10704",
                                "yn": "Y",
                                "title": "化学纤维用浆粕",
                                "alias": "化学纤维用浆粕",
                                "about": "生产纤维的基本原料。主要包括：棉浆粕、木浆粕和其他浆粕。",
                                "kws": null,
                                "taxName": "化学纤维",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070401000000000000",
                                "taxCodeTitle": "化学纤维",
                                "iTitle": "*化学纤维*化学纤维用浆粕",
                                "children": [
                                    {
                                        "id": "1925",
                                        "linkid": "1924",
                                        "code": "107040101",
                                        "paCode": "1070401",
                                        "yn": "N",
                                        "title": "化纤棉绒浆粕",
                                        "alias": "化纤棉绒浆粕",
                                        "about": "指以棉短绒为原料，经化学和机械加工制成的一种溶液或片状固体，是生产人造纤维的基本原料",
                                        "kws": "棉浆粕",
                                        "taxName": "化学纤维",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070401010000000000",
                                        "taxCodeTitle": "化学纤维",
                                        "iTitle": "*化学纤维*化纤棉绒浆粕",
                                        "children": []
                                    },
                                    {
                                        "id": "1926",
                                        "linkid": "1924",
                                        "code": "107040102",
                                        "paCode": "1070401",
                                        "yn": "N",
                                        "title": "化纤木浆粕",
                                        "alias": "化纤木浆粕",
                                        "about": "指以乔木类树木经过物理化学加工提取的植物纤维浆粕。",
                                        "kws": "木浆粕",
                                        "taxName": "化学纤维",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070401020000000000",
                                        "taxCodeTitle": "化学纤维",
                                        "iTitle": "*化学纤维*化纤木浆粕",
                                        "children": []
                                    },
                                    {
                                        "id": "1927",
                                        "linkid": "1924",
                                        "code": "107040103",
                                        "paCode": "1070401",
                                        "yn": "N",
                                        "title": "化纤用再生聚酯专用料",
                                        "alias": "化纤用再生聚酯专用料",
                                        "about": "指以废弃天然纤维、化学纤维及其制品为主要原料生产的再生聚酯产品。",
                                        "kws": "再生聚酯",
                                        "taxName": "化学纤维",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070401030000000000",
                                        "taxCodeTitle": "化学纤维",
                                        "iTitle": "*化学纤维*化纤用再生聚酯专用料",
                                        "children": []
                                    },
                                    {
                                        "id": "1928",
                                        "linkid": "1924",
                                        "code": "107040199",
                                        "paCode": "1070401",
                                        "yn": "N",
                                        "title": "其他化学纤维用浆粕",
                                        "alias": "其他化学纤维用浆粕",
                                        "about": "指由甘蔗、芦苇、芒草等天然纤维素制成的浆粕。",
                                        "kws": null,
                                        "taxName": "化学纤维",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070401990000000000",
                                        "taxCodeTitle": "化学纤维",
                                        "iTitle": "*化学纤维*其他化学纤维用浆粕",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1929",
                                "linkid": "1923",
                                "code": "1070402",
                                "paCode": "10704",
                                "yn": "Y",
                                "title": "人造纤维（纤维素纤维）",
                                "alias": "人造纤维（纤维素纤维）",
                                "about": "指以天然高分子化合物（如纤维素）为原料制成的化学纤维，如粘胶纤维、醋酯纤维。",
                                "kws": null,
                                "taxName": "化学纤维",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070402000000000000",
                                "taxCodeTitle": "化学纤维",
                                "iTitle": "*化学纤维*人造纤维（纤维素纤维）",
                                "children": [
                                    {
                                        "id": "1930",
                                        "linkid": "1929",
                                        "code": "107040201",
                                        "paCode": "1070402",
                                        "yn": "N",
                                        "title": "人造纤维短纤维",
                                        "alias": "人造纤维短纤维",
                                        "about": "指未梳或未经其他纺前加工的人造纤维短纤。包括粘胶短纤维、醋酸纤维短纤、其他人造纤维短纤维。",
                                        "kws": "人造纤维短纤维、粘胶短纤维、粘胶棉型短纤维、粘胶毛型短纤维、醋酸纤维短纤",
                                        "taxName": "化学纤维",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070402010000000000",
                                        "taxCodeTitle": "化学纤维",
                                        "iTitle": "*化学纤维*人造纤维短纤维",
                                        "children": []
                                    },
                                    {
                                        "id": "1931",
                                        "linkid": "1929",
                                        "code": "107040202",
                                        "paCode": "1070402",
                                        "yn": "N",
                                        "title": "人造纤维长丝",
                                        "alias": "人造纤维长丝",
                                        "about": "指用纤维素做原料制得的长丝的统称。主要品种有粘胶人造丝、醋酸人造丝和铜氨人造丝。包括粘胶纤维长丝、铜氨纤维长丝、醋酸纤维长丝、人造纤维长丝单丝、其他人造纤维长丝。",
                                        "kws": "人造纤维长丝、粘胶纤维长丝、粘胶纤维高强力丝、粘胶纤维单丝、铜氨纤维长丝、醋酸纤维长丝、二醋酸纤维长丝、三醋酸纤维长丝、人造纤维长丝单丝、醋酸纤维单丝",
                                        "taxName": "化学纤维",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070402020000000000",
                                        "taxCodeTitle": "化学纤维",
                                        "iTitle": "*化学纤维*人造纤维长丝",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1932",
                                "linkid": "1923",
                                "code": "1070403",
                                "paCode": "10704",
                                "yn": "Y",
                                "title": "合成纤维",
                                "alias": "合成纤维",
                                "about": "指以人工合成的高分子化合物为原料制成的化学纤维，如聚酯纤维、聚酰胺纤维、聚丙烯腈纤维。",
                                "kws": null,
                                "taxName": "化学纤维",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070403000000000000",
                                "taxCodeTitle": "化学纤维",
                                "iTitle": "*化学纤维*合成纤维",
                                "children": [
                                    {
                                        "id": "1933",
                                        "linkid": "1932",
                                        "code": "107040301",
                                        "paCode": "1070403",
                                        "yn": "N",
                                        "title": "锦纶纤维",
                                        "alias": "锦纶纤维",
                                        "about": "指聚酰胺纤维一种，又称耐纶或尼龙6。包括锦纶短纤维、锦纶长丝、综丝。",
                                        "kws": "锦纶纤维、锦纶短纤维、锦纶长丝、锦纶高强力丝、锦纶纤维长丝单丝",
                                        "taxName": "化学纤维",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070403010000000000",
                                        "taxCodeTitle": "化学纤维",
                                        "iTitle": "*化学纤维*锦纶纤维",
                                        "children": []
                                    },
                                    {
                                        "id": "1934",
                                        "linkid": "1932",
                                        "code": "107040302",
                                        "paCode": "1070403",
                                        "yn": "N",
                                        "title": "涤纶纤维",
                                        "alias": "涤纶纤维",
                                        "about": "指聚酯纤维，俗称涤纶。包括涤纶短纤维、涤纶长丝。",
                                        "kws": "涤纶纤维、涤纶短纤维、涤纶棉型短纤维、涤纶毛型短纤维、涤纶长丝、涤纶高强力丝",
                                        "taxName": "化学纤维",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070403020000000000",
                                        "taxCodeTitle": "化学纤维",
                                        "iTitle": "*化学纤维*涤纶纤维",
                                        "children": []
                                    },
                                    {
                                        "id": "1935",
                                        "linkid": "1932",
                                        "code": "107040303",
                                        "paCode": "1070403",
                                        "yn": "N",
                                        "title": "腈纶纤维",
                                        "alias": "腈纶纤维",
                                        "about": "也称聚丙烯腈纤维。包括腈纶短纤维、腈纶长纤丝束。",
                                        "kws": "腈纶纤维、腈纶短纤维、腈纶棉型短纤维、腈纶毛型短纤维、腈纶长纤丝束",
                                        "taxName": "化学纤维",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070403030000000000",
                                        "taxCodeTitle": "化学纤维",
                                        "iTitle": "*化学纤维*腈纶纤维",
                                        "children": []
                                    },
                                    {
                                        "id": "1936",
                                        "linkid": "1932",
                                        "code": "107040304",
                                        "paCode": "1070403",
                                        "yn": "N",
                                        "title": "维纶纤维",
                                        "alias": "维纶纤维",
                                        "about": "也称聚乙烯醇纤维。包括维纶纤维短纤维、维纶纤维长丝。",
                                        "kws": "维纶纤维、维纶纤维短纤维、维纶纤维长丝",
                                        "taxName": "化学纤维",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070403040000000000",
                                        "taxCodeTitle": "化学纤维",
                                        "iTitle": "*化学纤维*维纶纤维",
                                        "children": []
                                    },
                                    {
                                        "id": "1937",
                                        "linkid": "1932",
                                        "code": "107040305",
                                        "paCode": "1070403",
                                        "yn": "N",
                                        "title": "丙纶纤维",
                                        "alias": "丙纶纤维",
                                        "about": "也称聚丙烯纤维。包括丙纶短纤维、丙纶纤维长丝。",
                                        "kws": "丙纶纤维、丙纶短纤维、丙纶纤维长丝、丙纶高强力丝、丙纶长丝单丝",
                                        "taxName": "化学纤维",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070403050000000000",
                                        "taxCodeTitle": "化学纤维",
                                        "iTitle": "*化学纤维*丙纶纤维",
                                        "children": []
                                    },
                                    {
                                        "id": "1938",
                                        "linkid": "1932",
                                        "code": "107040306",
                                        "paCode": "1070403",
                                        "yn": "N",
                                        "title": "氯纶纤维",
                                        "alias": "氯纶纤维",
                                        "about": "也称聚氯乙稀纤维。包括氯纶短纤维、氯纶长丝。",
                                        "kws": "氯纶纤维、氯纶短纤维、氯纶长丝",
                                        "taxName": "化学纤维",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070403060000000000",
                                        "taxCodeTitle": "化学纤维",
                                        "iTitle": "*化学纤维*氯纶纤维",
                                        "children": []
                                    },
                                    {
                                        "id": "1939",
                                        "linkid": "1932",
                                        "code": "107040307",
                                        "paCode": "1070403",
                                        "yn": "N",
                                        "title": "氨纶纤维",
                                        "alias": "氨纶纤维",
                                        "about": "也称聚氨基甲酸酯纤维。包括氨纶纤维短纤维、氨纶纤维长丝。",
                                        "kws": "氨纶纤维、氨纶纤维短纤维、氨纶纤维长丝",
                                        "taxName": "化学纤维",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070403070000000000",
                                        "taxCodeTitle": "化学纤维",
                                        "iTitle": "*化学纤维*氨纶纤维",
                                        "children": []
                                    },
                                    {
                                        "id": "1940",
                                        "linkid": "1932",
                                        "code": "107040308",
                                        "paCode": "1070403",
                                        "yn": "N",
                                        "title": "腈氯纶纤维",
                                        "alias": "腈氯纶纤维",
                                        "about": "指氯乙烯与丙稀腈共聚纤维。包括腈氯纶短纤维、腈氯纶长纤丝束。",
                                        "kws": "腈氯纶纤维、腈氯纶短纤维、腈氯纶长纤丝束",
                                        "taxName": "化学纤维",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070403080000000000",
                                        "taxCodeTitle": "化学纤维",
                                        "iTitle": "*化学纤维*腈氯纶纤维",
                                        "children": []
                                    },
                                    {
                                        "id": "1941",
                                        "linkid": "1932",
                                        "code": "107040309",
                                        "paCode": "1070403",
                                        "yn": "N",
                                        "title": "PBT纤维",
                                        "alias": "PBT纤维",
                                        "about": "也称聚对苯二甲酸丁二酯纤维。包括PBT短纤维、PBT长丝、其他合成纤维。",
                                        "kws": "PBT纤维、PBT短纤维、PBT长丝",
                                        "taxName": "化学纤维",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070403090000000000",
                                        "taxCodeTitle": "化学纤维",
                                        "iTitle": "*化学纤维*PBT纤维",
                                        "children": []
                                    },
                                    {
                                        "id": "1942",
                                        "linkid": "1932",
                                        "code": "107040399",
                                        "paCode": "1070403",
                                        "yn": "N",
                                        "title": "其他合成纤维",
                                        "alias": "其他合成纤维",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "化学纤维",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070403990000000000",
                                        "taxCodeTitle": "化学纤维",
                                        "iTitle": "*化学纤维*其他合成纤维",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1943",
                                "linkid": "1923",
                                "code": "1070404",
                                "paCode": "10704",
                                "yn": "Y",
                                "title": "化学纤维加工丝",
                                "alias": "化学纤维加工丝",
                                "about": "指初生纤维经拉伸和热定形，卷绕成筒纺制成丝。",
                                "kws": null,
                                "taxName": "化学纤维",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070404000000000000",
                                "taxCodeTitle": "化学纤维",
                                "iTitle": "*化学纤维*化学纤维加工丝",
                                "children": [
                                    {
                                        "id": "1944",
                                        "linkid": "1943",
                                        "code": "107040401",
                                        "paCode": "1070404",
                                        "yn": "N",
                                        "title": "人造纤维长丝纱",
                                        "alias": "人造纤维长丝纱",
                                        "about": "包括人造纤维长丝变形纱和其他人造纤维长丝纱",
                                        "kws": "人造纤维长丝纱、人造纤维长丝变形纱",
                                        "taxName": "化学纤维",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070404010000000000",
                                        "taxCodeTitle": "化学纤维",
                                        "iTitle": "*化学纤维*人造纤维长丝纱",
                                        "children": []
                                    },
                                    {
                                        "id": "1945",
                                        "linkid": "1943",
                                        "code": "107040402",
                                        "paCode": "1070404",
                                        "yn": "N",
                                        "title": "锦纶加工丝",
                                        "alias": "锦纶加工丝",
                                        "about": "包括锦纶弹力丝、锦纶纤维长丝变形纱线（异型纤维）、其他锦纶加工丝",
                                        "kws": "锦纶加工丝、锦纶弹力丝、锦纶纤维长丝变形纱线、异型纤维",
                                        "taxName": "化学纤维",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070404020000000000",
                                        "taxCodeTitle": "化学纤维",
                                        "iTitle": "*化学纤维*锦纶加工丝",
                                        "children": []
                                    },
                                    {
                                        "id": "1946",
                                        "linkid": "1943",
                                        "code": "107040403",
                                        "paCode": "1070404",
                                        "yn": "N",
                                        "title": "涤纶加工丝",
                                        "alias": "涤纶加工丝",
                                        "about": "包括涤纶变形纱线、其他涤纶加工丝",
                                        "kws": "涤纶加工丝、涤纶变形纱线、涤纶弹力丝",
                                        "taxName": "化学纤维",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070404030000000000",
                                        "taxCodeTitle": "化学纤维",
                                        "iTitle": "*化学纤维*涤纶加工丝",
                                        "children": []
                                    },
                                    {
                                        "id": "1947",
                                        "linkid": "1943",
                                        "code": "107040404",
                                        "paCode": "1070404",
                                        "yn": "N",
                                        "title": "维纶纤维加工丝",
                                        "alias": "维纶纤维加工丝",
                                        "about": "包括维纶牵切纱、维纶纤维长丝变形纱线、其他维纶纤维加工丝",
                                        "kws": "维纶纤维加工丝、维纶牵切纱",
                                        "taxName": "化学纤维",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070404040000000000",
                                        "taxCodeTitle": "化学纤维",
                                        "iTitle": "*化学纤维*维纶纤维加工丝",
                                        "children": []
                                    },
                                    {
                                        "id": "1948",
                                        "linkid": "1943",
                                        "code": "107040405",
                                        "paCode": "1070404",
                                        "yn": "N",
                                        "title": "丙纶纤维加工丝",
                                        "alias": "丙纶纤维加工丝",
                                        "about": "包括丙纶弹力丝、丙纶长丝变形纱线、其他丙纶纤维加工丝",
                                        "kws": "丙纶纤维加工丝、丙纶弹力丝、丙纶长丝变形纱线",
                                        "taxName": "化学纤维",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070404050000000000",
                                        "taxCodeTitle": "化学纤维",
                                        "iTitle": "*化学纤维*丙纶纤维加工丝",
                                        "children": []
                                    },
                                    {
                                        "id": "1949",
                                        "linkid": "1943",
                                        "code": "107040499",
                                        "paCode": "1070404",
                                        "yn": "N",
                                        "title": "其他化学纤维加工丝",
                                        "alias": "其他化学纤维加工丝",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "化学纤维",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070404990000000000",
                                        "taxCodeTitle": "化学纤维",
                                        "iTitle": "*化学纤维*其他化学纤维加工丝",
                                        "children": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "id": "1950",
                        "linkid": "1172",
                        "code": "10705",
                        "paCode": "107",
                        "yn": "Y",
                        "title": "橡胶制品",
                        "alias": "橡胶制品",
                        "about": "指以天然及合成橡胶为原料经过一系列加工制得成品的总称，具有特殊的高弹性，优异的耐磨、减震、绝缘和密封等性能。包括利用废橡胶再生产的橡胶制品。",
                        "kws": null,
                        "taxName": "橡胶制品",
                        "taxRate": "",
                        "vip": "7",
                        "itaxRate": null,
                        "taxCode": "1070500000000000000",
                        "taxCodeTitle": "橡胶制品",
                        "iTitle": "*橡胶制品*橡胶制品",
                        "children": [
                            {
                                "id": "1951",
                                "linkid": "1950",
                                "code": "1070501",
                                "paCode": "10705",
                                "yn": "Y",
                                "title": "橡胶轮胎及内胎",
                                "alias": "橡胶轮胎及内胎",
                                "about": "指汽车、拖拉机、自行车等交通运输工具的轮子外围安装的环形橡胶制品。一般分内胎外胎。通称车胎或轮带。",
                                "kws": null,
                                "taxName": "橡胶制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070501000000000000",
                                "taxCodeTitle": "橡胶制品",
                                "iTitle": "*橡胶制品*橡胶轮胎及内胎",
                                "children": [
                                    {
                                        "id": "1952",
                                        "linkid": "1951",
                                        "code": "107050101",
                                        "paCode": "1070501",
                                        "yn": "N",
                                        "title": "橡胶轮胎外胎",
                                        "alias": "橡胶轮胎外胎",
                                        "about": "指橡胶制充气轮胎的环状外壳体。包括各类乘用车、摩托车轮胎外胎，不包括力车胎（详见107050105）。",
                                        "kws": "橡胶轮胎外胎、乘用车橡胶轮胎外胎、乘用车斜交线轮胎外胎、载货汽车橡胶轮胎外胎、载货汽车斜交线轮胎外胎、客车橡胶轮胎外胎、客车斜交线轮胎外胎、工程机械用橡胶轮胎外胎、工程机械用斜交线轮胎外胎、农林机械用橡胶轮胎外胎、农林机械用斜交线轮胎外胎、农林机械用橡胶履带、航空器充气橡胶轮胎外胎、航空器斜交线轮胎外胎、摩托车充气橡胶轮胎外胎",
                                        "taxName": "橡胶制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070501010000000000",
                                        "taxCodeTitle": "橡胶制品",
                                        "iTitle": "*橡胶制品*橡胶轮胎外胎",
                                        "children": []
                                    },
                                    {
                                        "id": "1953",
                                        "linkid": "1951",
                                        "code": "107050102",
                                        "paCode": "1070501",
                                        "yn": "N",
                                        "title": "子午线轮胎外胎",
                                        "alias": "子午线轮胎外胎",
                                        "about": "指胎体帘线层的排列与胎周方向垂直正交，与径向成零度，像地球子午线的排布；包括乘用车子午线轮胎外胎、载货汽车子午线轮胎外胎、客车子午线轮胎外胎、工程机械用子午线轮胎外胎、农、林机械用子午线轮胎外胎、航空器子午线轮胎外胎、其他子午线轮胎外胎。",
                                        "kws": "子午线轮胎外胎、乘用车子午线轮胎外胎、载货汽车子午线轮胎外胎、客车子午线轮胎外胎、工程机械用子午线轮胎外胎、农、林机械用子午线轮胎外胎、航空器子午线轮胎外胎",
                                        "taxName": "橡胶制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070501020000000000",
                                        "taxCodeTitle": "橡胶制品",
                                        "iTitle": "*橡胶制品*子午线轮胎外胎",
                                        "children": []
                                    },
                                    {
                                        "id": "1954",
                                        "linkid": "1951",
                                        "code": "107050103",
                                        "paCode": "1070501",
                                        "yn": "N",
                                        "title": "橡胶内胎",
                                        "alias": "橡胶内胎",
                                        "about": "包括机动车橡胶内胎、工程机械用橡胶内胎、航空器用橡胶内胎、摩托车用橡胶内胎、其他橡胶内胎。不包括力车内胎（详见107050105）。",
                                        "kws": "橡胶内胎、机动车橡胶内胎、乘用车橡胶内胎、载货汽车橡胶内胎、客车橡胶内胎、工程机械用橡胶内胎、航空器用橡胶内胎、摩托车用橡胶内胎",
                                        "taxName": "橡胶制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070501030000000000",
                                        "taxCodeTitle": "橡胶制品",
                                        "iTitle": "*橡胶制品*橡胶内胎",
                                        "children": []
                                    },
                                    {
                                        "id": "1955",
                                        "linkid": "1951",
                                        "code": "107050104",
                                        "paCode": "1070501",
                                        "yn": "N",
                                        "title": "橡胶实心或半实心轮胎",
                                        "alias": "橡胶实心或半实心轮胎",
                                        "about": "指与充气轮胎（空心轮胎）对应的一种轮胎，其胎体是实心的，不用帘线作骨架，不必充气，不需内胎或气密层。包括航空器用实心或半实心轮胎、机动车用实心或半实心轮胎、其他橡胶实心或半实心轮胎。",
                                        "kws": "轮胎、橡胶实心、橡胶半实心轮胎、航空器用实心、航空器用半实心轮胎、航空器用抗静电实心轮胎、航空器用导电实心轮胎、航空器用耐油实心轮胎、航空器用高负荷实心轮胎、机动车用实心、机动车用半实心轮胎、机动车用抗静电实心轮胎、机动车用导电实心轮胎、机动车用耐油实心轮胎、机动车用高负荷实心轮胎",
                                        "taxName": "橡胶制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070501040000000000",
                                        "taxCodeTitle": "橡胶制品",
                                        "iTitle": "*橡胶制品*橡胶实心或半实心轮胎",
                                        "children": []
                                    },
                                    {
                                        "id": "1956",
                                        "linkid": "1951",
                                        "code": "107050105",
                                        "paCode": "1070501",
                                        "yn": "N",
                                        "title": "力车胎",
                                        "alias": "力车胎",
                                        "about": "包括力车橡胶胎外胎、力车橡胶胎内胎。",
                                        "kws": "力车胎、力车橡胶胎外胎、自行车充气橡胶轮胎、畜力车外胎、力车橡胶胎内胎、自行车用橡胶内胎、畜力车橡胶内胎",
                                        "taxName": "橡胶制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070501050000000000",
                                        "taxCodeTitle": "橡胶制品",
                                        "iTitle": "*橡胶制品*力车胎",
                                        "children": []
                                    },
                                    {
                                        "id": "1957",
                                        "linkid": "1951",
                                        "code": "107050106",
                                        "paCode": "1070501",
                                        "yn": "N",
                                        "title": "翻新橡胶轮胎",
                                        "alias": "翻新橡胶轮胎",
                                        "about": "指经翻新后能继续使用的轮胎。",
                                        "kws": "翻新橡胶轮胎、乘用车用翻新橡胶轮胎、载货汽车翻新充气橡胶轮胎、客车用翻新橡胶轮胎、航空器用翻新橡胶轮胎",
                                        "taxName": "橡胶制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070501060000000000",
                                        "taxCodeTitle": "橡胶制品",
                                        "iTitle": "*橡胶制品*翻新橡胶轮胎",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1958",
                                "linkid": "1950",
                                "code": "1070502",
                                "paCode": "10705",
                                "yn": "N",
                                "title": "橡胶带、管",
                                "alias": "橡胶带、管",
                                "about": "指硫化橡胶带、管。包括橡胶传动带、橡胶输送带、纯胶管、金属合制橡胶管、纺织材料合制橡胶管。",
                                "kws": "橡胶带管、金属材料抗拉层输送带、钢丝绳芯输送带、钢缆牵引输送带、折迭式输送带、纤维材料抗拉层输送带、普通输送带、尼龙输送带、塑料加强橡胶输送带、橡胶V带、1.4V型传动带、普通V带、三角带、汽车V带风扇带、环形同步带、无附件纯胶管、带附件纯胶管、无附件金属合制橡胶管、带附件金属合制橡胶管、无附件纺织材料合制橡胶管、带附件纺织材料合制橡胶管",
                                "taxName": "橡胶制品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1070502000000000000",
                                "taxCodeTitle": "橡胶制品",
                                "iTitle": "*橡胶制品*橡胶带、管",
                                "children": []
                            },
                            {
                                "id": "1959",
                                "linkid": "1950",
                                "code": "1070503",
                                "paCode": "10705",
                                "yn": "N",
                                "title": "橡胶板、杆、型材",
                                "alias": "橡胶板、杆、型材",
                                "about": "指硫化橡胶板、杆、型材及线、绳。",
                                "kws": "橡胶板、杆、型材、海绵橡胶制板、海绵橡胶制片、海绵橡胶制带、非海绵橡胶制板、非海绵橡胶制片、非海绵橡胶制带、海绵橡胶制杆、海绵橡胶制型材、海绵橡胶制异型材、非海绵橡胶制杆、非海绵橡胶制型材、非海绵橡胶制异型材、橡胶线、橡胶绳",
                                "taxName": "橡胶制品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1070503000000000000",
                                "taxCodeTitle": "橡胶制品",
                                "iTitle": "*橡胶制品*橡胶板、杆、型材",
                                "children": []
                            },
                            {
                                "id": "1960",
                                "linkid": "1950",
                                "code": "1070504",
                                "paCode": "10705",
                                "yn": "Y",
                                "title": "涂胶纺织物、带",
                                "alias": "涂胶纺织物、带",
                                "about": "指涂覆胶浆的纺织物、带。",
                                "kws": null,
                                "taxName": "橡胶制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070504000000000000",
                                "taxCodeTitle": "橡胶制品",
                                "iTitle": "*橡胶制品*涂胶纺织物、带",
                                "children": [
                                    {
                                        "id": "1961",
                                        "linkid": "1960",
                                        "code": "107050401",
                                        "paCode": "1070504",
                                        "yn": "N",
                                        "title": "涂胶纺织物",
                                        "alias": "涂胶纺织物",
                                        "about": "指涂覆胶浆的纺织物。包括橡胶胶布（织物）、其他涂胶纺织物。",
                                        "kws": "涂胶纺织物、橡胶胶布、橡胶织物、防水胶布、耐酸胶布、耐碱胶布、隔热胶布、耐油胶布",
                                        "taxName": "橡胶制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070504010000000000",
                                        "taxCodeTitle": "橡胶制品",
                                        "iTitle": "*橡胶制品*涂胶纺织物",
                                        "children": []
                                    },
                                    {
                                        "id": "1962",
                                        "linkid": "1960",
                                        "code": "107050402",
                                        "paCode": "1070504",
                                        "yn": "N",
                                        "title": "橡胶粘带",
                                        "alias": "橡胶粘带",
                                        "about": "指以纺织物作底布的橡胶粘带，包括电气绝缘带，以及橡胶粘胶布。",
                                        "kws": "橡胶粘带、硅橡胶自粘带、电绝缘耐高温自粘性胶带、辐射硫化电绝缘耐热自粘带",
                                        "taxName": "橡胶制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070504020000000000",
                                        "taxCodeTitle": "橡胶制品",
                                        "iTitle": "*橡胶制品*橡胶粘带",
                                        "children": []
                                    },
                                    {
                                        "id": "1963",
                                        "linkid": "1960",
                                        "code": "107050499",
                                        "paCode": "1070504",
                                        "yn": "N",
                                        "title": "其他涂胶纺织物、带",
                                        "alias": "其他涂胶纺织物、带",
                                        "about": "指其他用橡胶处理纺织物或带。",
                                        "kws": null,
                                        "taxName": "橡胶制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070504990000000000",
                                        "taxCodeTitle": "橡胶制品",
                                        "iTitle": "*橡胶制品*其他涂胶纺织物、带",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1964",
                                "linkid": "1950",
                                "code": "1070505",
                                "paCode": "10705",
                                "yn": "Y",
                                "title": "未硫化复合橡胶及其制品",
                                "alias": "未硫化复合橡胶及其制品",
                                "about": "指没有经过硫化的生胶或混炼橡胶及其制品。",
                                "kws": null,
                                "taxName": "橡胶制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070505000000000000",
                                "taxCodeTitle": "橡胶制品",
                                "iTitle": "*橡胶制品*未硫化复合橡胶及其制品",
                                "children": [
                                    {
                                        "id": "1965",
                                        "linkid": "1964",
                                        "code": "107050501",
                                        "paCode": "1070505",
                                        "yn": "N",
                                        "title": "未硫化复合橡胶",
                                        "alias": "未硫化复合橡胶",
                                        "about": "指没有经过硫化的生胶或混炼橡胶。",
                                        "kws": "未硫化复合橡胶、混合碳黑未硫化复合橡胶、未硫化复合橡胶溶液、复合橡胶板、复合橡胶片、复合橡胶带",
                                        "taxName": "橡胶制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070505010000000000",
                                        "taxCodeTitle": "橡胶制品",
                                        "iTitle": "*橡胶制品*未硫化复合橡胶",
                                        "children": []
                                    },
                                    {
                                        "id": "1966",
                                        "linkid": "1964",
                                        "code": "107050502",
                                        "paCode": "1070505",
                                        "yn": "N",
                                        "title": "未硫化橡胶制品",
                                        "alias": "未硫化橡胶制品",
                                        "about": "指以没有经过硫化的生胶或混炼橡胶为原料制成的产品。",
                                        "kws": "未硫化橡胶制品、未硫化橡胶异型材、未硫化橡胶管、未硫化橡胶线、轮胎翻新用胎面补料胎条",
                                        "taxName": "橡胶制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070505020000000000",
                                        "taxCodeTitle": "橡胶制品",
                                        "iTitle": "*橡胶制品*未硫化橡胶制品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1967",
                                "linkid": "1950",
                                "code": "1070506",
                                "paCode": "10705",
                                "yn": "Y",
                                "title": "橡胶零件、附件",
                                "alias": "橡胶零件、附件",
                                "about": null,
                                "kws": null,
                                "taxName": "橡胶制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070506000000000000",
                                "taxCodeTitle": "橡胶制品",
                                "iTitle": "*橡胶制品*橡胶零件、附件",
                                "children": [
                                    {
                                        "id": "1968",
                                        "linkid": "1967",
                                        "code": "107050601",
                                        "paCode": "1070506",
                                        "yn": "N",
                                        "title": "橡胶密封件",
                                        "alias": "橡胶密封件",
                                        "about": "指利用橡胶硫化的方法或硫化成形后切削加工的方法制造的各种结构的密封。",
                                        "kws": "橡胶密封件、活塞杆密封、活塞密封、基础密封、防尘圈、旋转密封、往复密封、组合垫圈",
                                        "taxName": "橡胶制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070506010000000000",
                                        "taxCodeTitle": "橡胶制品",
                                        "iTitle": "*橡胶制品*橡胶密封件",
                                        "children": []
                                    },
                                    {
                                        "id": "1969",
                                        "linkid": "1967",
                                        "code": "107050602",
                                        "paCode": "1070506",
                                        "yn": "N",
                                        "title": "橡胶零附件",
                                        "alias": "橡胶零附件",
                                        "about": "包括模制成型塑胶零件、模制成型橡胶零件。",
                                        "kws": "橡胶零附件、模制成型塑胶零件、模制成型橡胶零件",
                                        "taxName": "橡胶制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070506020000000000",
                                        "taxCodeTitle": "橡胶制品",
                                        "iTitle": "*橡胶制品*橡胶零附件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1970",
                                "linkid": "1950",
                                "code": "1070507",
                                "paCode": "10705",
                                "yn": "Y",
                                "title": "再生橡胶",
                                "alias": "再生橡胶",
                                "about": "指以化学或机械方法使废旧的和磨损的橡胶制品以及生产中的废料经过再生而得到的橡胶,简称再生胶。",
                                "kws": null,
                                "taxName": "橡胶制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070507000000000000",
                                "taxCodeTitle": "橡胶制品",
                                "iTitle": "*橡胶制品*再生橡胶",
                                "children": [
                                    {
                                        "id": "1971",
                                        "linkid": "1970",
                                        "code": "107050701",
                                        "paCode": "1070507",
                                        "yn": "N",
                                        "title": "初级形状再生橡胶",
                                        "alias": "初级形状再生橡胶",
                                        "about": "指以各种化学或机械方法使旧橡胶制品（特别是轮胎）或硫化橡胶废碎料软化（“脱硫”）并除去不需要的物质制得，简称再生胶；旧橡胶制品包括废旧的和磨损的橡胶制品以及生产中的废料等。",
                                        "kws": "初级形状再生橡胶、再生橡胶制板、再生橡胶制片、再生橡胶制带",
                                        "taxName": "橡胶制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070507010000000000",
                                        "taxCodeTitle": "橡胶制品",
                                        "iTitle": "*橡胶制品*初级形状再生橡胶",
                                        "children": []
                                    },
                                    {
                                        "id": "1972",
                                        "linkid": "1970",
                                        "code": "107050702",
                                        "paCode": "1070507",
                                        "yn": "N",
                                        "title": "再生胶粉",
                                        "alias": "再生胶粉",
                                        "about": "指以化学或机械方法使废旧的和磨损的橡胶制品以及生产中的废料经过再生而得到的橡胶粉,简称再生胶粉。",
                                        "kws": "再生胶粉",
                                        "taxName": "橡胶制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070507020000000000",
                                        "taxCodeTitle": "橡胶制品",
                                        "iTitle": "*橡胶制品*再生胶粉",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1973",
                                "linkid": "1950",
                                "code": "1070508",
                                "paCode": "10705",
                                "yn": "Y",
                                "title": "日用及医用橡胶制品",
                                "alias": "日用及医用橡胶制品",
                                "about": "指日用橡胶制品是日常生活使用的橡胶制品；医用橡胶制品用于医院治疗疾病和置于人体内代替某些器官或组织的符合一定卫生标准的橡胶制品。",
                                "kws": null,
                                "taxName": "橡胶制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070508000000000000",
                                "taxCodeTitle": "橡胶制品",
                                "iTitle": "*橡胶制品*日用及医用橡胶制品",
                                "children": [
                                    {
                                        "id": "1974",
                                        "linkid": "1973",
                                        "code": "107050801",
                                        "paCode": "1070508",
                                        "yn": "N",
                                        "title": "橡胶手套",
                                        "alias": "橡胶手套",
                                        "about": "指用橡胶薄片或薄膜制成的一类手套；按用途分耐酸碱手套、电绝缘手套、防辐射手套、医用手套等；医用手套分光面和毛面两种；按橡胶原料或制造工艺分胶乳手套和模压手套等。",
                                        "kws": "橡胶手套、医用橡胶手套、检查用橡胶手套、家用橡胶手套、工业用橡胶手套",
                                        "taxName": "橡胶制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070508010000000000",
                                        "taxCodeTitle": "橡胶制品",
                                        "iTitle": "*橡胶制品*橡胶手套",
                                        "children": []
                                    },
                                    {
                                        "id": "1975",
                                        "linkid": "1973",
                                        "code": "107050802",
                                        "paCode": "1070508",
                                        "yn": "N",
                                        "title": "橡胶制衣着用品及附件",
                                        "alias": "橡胶制衣着用品及附件",
                                        "about": "指非缝制，包括医疗用橡胶制衣着用品、橡胶制潜水衣、橡胶制雨衣、其他橡胶制衣着用品及附件。",
                                        "kws": "橡胶制衣着用品、医疗用橡胶制衣着用品、橡胶制潜水衣、橡胶制雨衣",
                                        "taxName": "橡胶制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070508020000000000",
                                        "taxCodeTitle": "橡胶制品",
                                        "iTitle": "*橡胶制品*橡胶制衣着用品及附件",
                                        "children": []
                                    },
                                    {
                                        "id": "1976",
                                        "linkid": "1973",
                                        "code": "107050803",
                                        "paCode": "1070508",
                                        "yn": "N",
                                        "title": "日用橡胶制品",
                                        "alias": "日用橡胶制品",
                                        "about": "指用橡胶原料生产的日常生活用的橡胶制品；包括橡胶布、橡胶热水袋、橡胶冰囊、橡胶奶头等。",
                                        "kws": "日用橡胶制品、橡胶门垫、橡胶地板贴面、乳胶平板海绵、乳胶海绵制品",
                                        "taxName": "橡胶制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070508030000000000",
                                        "taxCodeTitle": "橡胶制品",
                                        "iTitle": "*橡胶制品*日用橡胶制品",
                                        "children": []
                                    },
                                    {
                                        "id": "1977",
                                        "linkid": "1973",
                                        "code": "107050804",
                                        "paCode": "1070508",
                                        "yn": "N",
                                        "title": "医疗、卫生用橡胶制品",
                                        "alias": "医疗、卫生用橡胶制品",
                                        "about": "指硫化橡胶制品；医用橡胶制品包括医用胶塞和胶垫、医用胶管及其他医用橡胶制品三大类；其中，医用胶管根据用途不同，可分为体外用和体内用两类。",
                                        "kws": "医疗用橡胶制品、卫生用橡胶制品、输血胶管、插管、医疗用胶管、洗肠用灌肠器及胶球、喷雾器、奶嘴、奶头罩、冰袋、氧气袋",
                                        "taxName": "橡胶制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070508040000000000",
                                        "taxCodeTitle": "橡胶制品",
                                        "iTitle": "*橡胶制品*医疗、卫生用橡胶制品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1978",
                                "linkid": "1950",
                                "code": "1070509",
                                "paCode": "10705",
                                "yn": "Y",
                                "title": "橡胶充气、减震制品",
                                "alias": "橡胶充气、减震制品",
                                "about": "指可充气的橡胶制品；具有减震功能的橡胶制品。",
                                "kws": null,
                                "taxName": "橡胶制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070509000000000000",
                                "taxCodeTitle": "橡胶制品",
                                "iTitle": "*橡胶制品*橡胶充气、减震制品",
                                "children": [
                                    {
                                        "id": "1979",
                                        "linkid": "1978",
                                        "code": "107050901",
                                        "paCode": "1070509",
                                        "yn": "N",
                                        "title": "充气橡胶制品",
                                        "alias": "充气橡胶制品",
                                        "about": "指硫化橡胶制可充气制品。",
                                        "kws": "充气橡胶制品、橡胶充气筏、橡胶充气浮桥、橡胶气球、橡胶救生圈、橡胶充气床垫、橡胶气囊",
                                        "taxName": "橡胶制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070509010000000000",
                                        "taxCodeTitle": "橡胶制品",
                                        "iTitle": "*橡胶制品*充气橡胶制品",
                                        "children": []
                                    },
                                    {
                                        "id": "1980",
                                        "linkid": "1978",
                                        "code": "107050902",
                                        "paCode": "1070509",
                                        "yn": "N",
                                        "title": "橡胶减震制品",
                                        "alias": "橡胶减震制品",
                                        "about": "指用于消除或减少机械震动的传递，达到减震、消音及减少冲击所致危害的橡胶制品统称橡胶减震制品。亦称橡胶防震、隔震制品。",
                                        "kws": "橡胶减震制品、橡胶制船舶碰垫、橡胶制码头碰垫、橡胶护舷、橡胶减震器、橡胶空气弹簧、可曲挠橡胶接头",
                                        "taxName": "橡胶制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070509020000000000",
                                        "taxCodeTitle": "橡胶制品",
                                        "iTitle": "*橡胶制品*橡胶减震制品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1981",
                                "linkid": "1950",
                                "code": "1070510",
                                "paCode": "10705",
                                "yn": "Y",
                                "title": "硬质橡胶及其制品",
                                "alias": "硬质橡胶及其制品",
                                "about": "指玻璃化温度在室温以上、几乎不能拉伸的橡胶称为硬质橡胶。",
                                "kws": null,
                                "taxName": "橡胶制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070510000000000000",
                                "taxCodeTitle": "橡胶制品",
                                "iTitle": "*橡胶制品*硬质橡胶及其制品",
                                "children": [
                                    {
                                        "id": "1982",
                                        "linkid": "1981",
                                        "code": "107051001",
                                        "paCode": "1070510",
                                        "yn": "N",
                                        "title": "硬质橡胶",
                                        "alias": "硬质橡胶",
                                        "about": "包括泡沫硬质橡胶、其他硬质橡胶。",
                                        "kws": "硬质橡胶、泡沫硬质橡胶",
                                        "taxName": "橡胶制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070510010000000000",
                                        "taxCodeTitle": "橡胶制品",
                                        "iTitle": "*橡胶制品*硬质橡胶",
                                        "children": []
                                    },
                                    {
                                        "id": "1983",
                                        "linkid": "1981",
                                        "code": "107051002",
                                        "paCode": "1070510",
                                        "yn": "N",
                                        "title": "硬质橡胶制品",
                                        "alias": "硬质橡胶制品",
                                        "about": "指由硬质橡胶制作的产品称为硬质橡胶产品。",
                                        "kws": "硬质橡胶制品、硬质橡胶制槽、硬质橡胶制大桶、硬质橡胶制管状物品、硬质橡胶制柄状物品、硬质橡胶制清洁卫生用品",
                                        "taxName": "橡胶制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070510020000000000",
                                        "taxCodeTitle": "橡胶制品",
                                        "iTitle": "*橡胶制品*硬质橡胶制品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "1984",
                                "linkid": "1950",
                                "code": "1070599",
                                "paCode": "10705",
                                "yn": "N",
                                "title": "其他橡胶制品",
                                "alias": "其他橡胶制品",
                                "about": null,
                                "kws": null,
                                "taxName": "橡胶制品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1070599000000000000",
                                "taxCodeTitle": "橡胶制品",
                                "iTitle": "*橡胶制品*其他橡胶制品",
                                "children": []
                            }
                        ]
                    },
                    {
                        "id": "1985",
                        "linkid": "1172",
                        "code": "10706",
                        "paCode": "107",
                        "yn": "Y",
                        "title": "塑料制品、半成品及辅料",
                        "alias": "塑料制品、半成品及辅料",
                        "about": "指以树脂(或在加工过程中用单体直接聚合)为主要成分，以增塑剂、填充剂、润滑剂、着色剂等添加剂为辅助成分，在加工过程中能流动成型的材料。",
                        "kws": null,
                        "taxName": "塑料制品",
                        "taxRate": "",
                        "vip": "7",
                        "itaxRate": null,
                        "taxCode": "1070600000000000000",
                        "taxCodeTitle": "塑料制品",
                        "iTitle": "*塑料制品*塑料制品、半成品及辅料",
                        "children": [
                            {
                                "id": "1986",
                                "linkid": "1985",
                                "code": "1070601",
                                "paCode": "10706",
                                "yn": "Y",
                                "title": "塑料制品",
                                "alias": "塑料制品",
                                "about": "指采用塑料为主要原料加工而成的生活用品、工业用品的统称。包括非降解塑料制品和降解塑料制品。",
                                "kws": null,
                                "taxName": "塑料制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070601000000000000",
                                "taxCodeTitle": "塑料制品",
                                "iTitle": "*塑料制品*塑料制品",
                                "children": [
                                    {
                                        "id": "1987",
                                        "linkid": "1986",
                                        "code": "107060101",
                                        "paCode": "1070601",
                                        "yn": "Y",
                                        "title": "塑料薄膜",
                                        "alias": "塑料薄膜",
                                        "about": "指非泡沫塑料薄膜，包括聚乙烯（PE）塑料薄膜、聚丙烯（PP）塑料薄膜、聚丙烯酸酯类塑料薄膜、聚苯乙烯（PS）塑料薄膜、聚酯塑料薄膜、纤维素衍生物塑料薄膜、聚酰胺塑料薄膜、离子交换膜、复合薄膜。不包括泡沫塑料膜（详见107060107），也不包括降解塑料薄膜（详见107060113）。",
                                        "kws": "塑料薄膜、聚乙烯塑料薄膜、聚乙烯塑料电池隔膜、聚乙烯塑料包装用薄膜、聚乙烯塑料防水薄膜、聚乙烯塑料土工膜、聚丙烯塑料薄膜、聚丙烯塑料电池隔膜、聚丙烯双向拉伸塑料薄膜、聚丙烯酸酯类塑料薄膜、聚甲基丙烯酸甲酯塑料薄膜、聚苯乙烯塑料薄膜、聚苯乙烯双向拉伸塑料薄膜、聚氯乙烯塑料薄膜、聚酯塑料薄膜、聚碳酸酯塑料薄膜、聚对苯二甲酸乙二酯塑料薄膜、不饱和聚酯塑料薄膜、纤维素衍生物塑料薄膜、钢纸制塑料薄膜、醋酸纤维素塑料薄膜、聚乙烯醇缩丁醛塑料薄膜、聚酰胺塑料薄膜、聚酰胺双向拉伸塑料薄膜、聚酰亚胺塑料薄膜、氨基树脂塑料薄",
                                        "taxName": "塑料制品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1070601010000000000",
                                        "taxCodeTitle": "塑料制品",
                                        "iTitle": "*塑料制品*塑料薄膜",
                                        "children": [
                                            {
                                                "id": "1988",
                                                "linkid": "1987",
                                                "code": "10706010101",
                                                "paCode": "107060101",
                                                "yn": "N",
                                                "title": "农用薄膜",
                                                "alias": "农用薄膜",
                                                "about": "指应用于农业生产的塑料薄膜。",
                                                "kws": "农用薄膜、聚乙烯塑料农用薄膜、聚氯乙烯塑料农用薄膜、乙烯-乙酸乙烯酯塑料农用薄膜",
                                                "taxName": "塑料制品",
                                                "taxRate": "9%",
                                                "vip": "7",
                                                "itaxRate": "0.09",
                                                "taxCode": "1070601010100000000",
                                                "taxCodeTitle": "塑料制品",
                                                "iTitle": "*塑料制品*农用薄膜",
                                                "children": []
                                            },
                                            {
                                                "id": "1989",
                                                "linkid": "1987",
                                                "code": "10706010102",
                                                "paCode": "107060101",
                                                "yn": "N",
                                                "title": "其他塑料薄膜",
                                                "alias": "其他塑料薄膜",
                                                "about": null,
                                                "kws": null,
                                                "taxName": "塑料制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1070601010200000000",
                                                "taxCodeTitle": "塑料制品",
                                                "iTitle": "*塑料制品*其他塑料薄膜",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "1990",
                                        "linkid": "1986",
                                        "code": "107060102",
                                        "paCode": "1070601",
                                        "yn": "N",
                                        "title": "塑料板、片",
                                        "alias": "塑料板、片",
                                        "about": "指非泡沫塑料硬板、软板、装饰板、瓦楞板、中空格子板、薄片等。包括聚乙烯塑料板、片、聚丙烯塑料板、片、聚苯乙烯塑料板、片、聚氯乙烯塑料板、片、聚丙烯酸酯类塑料板、片、聚酯塑料板、片、纤维素衍生物塑料板、片、ABS板、片、聚乙烯醇缩丁醛塑料板、片、聚酰胺塑料板、片、氨基塑料板、片、酚醛塑料板、片、聚四氟乙烯塑料板、片、其他塑料板、片。不包括泡沫塑料板、片（详见107060107），也不包括降解塑料板、片（详见107060113）。",
                                        "kws": "塑料板、塑料片、聚乙烯塑料板、聚乙烯塑料片、聚丙烯塑料板、聚丙烯塑料片、聚苯乙烯塑料板、聚苯乙烯塑料片、聚氯乙烯塑料板、聚氯乙烯塑料片、聚丙烯酸酯类塑料板、聚丙烯酸酯类塑料片、聚甲基丙烯酸甲酯塑料板、聚甲基丙烯酸甲酯塑料片、聚酯塑料板、聚酯塑料片、聚碳酸酯塑料板、聚碳酸酯塑料片、聚对苯二甲酸乙二酯塑料板、聚对苯二甲酸乙二酯塑料片、不饱和聚酯塑料板、不饱和聚酯塑料片、纤维素衍生物塑料板、纤维素衍生物塑料片、钢纸制塑料板、钢纸制塑料片、醋酸纤维素塑料板、醋酸纤维素塑料片、ABS板、ABS片、聚乙烯醇缩丁醛塑料",
                                        "taxName": "塑料制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070601020000000000",
                                        "taxCodeTitle": "塑料制品",
                                        "iTitle": "*塑料制品*塑料板、片",
                                        "children": []
                                    },
                                    {
                                        "id": "1991",
                                        "linkid": "1986",
                                        "code": "107060103",
                                        "paCode": "1070601",
                                        "yn": "N",
                                        "title": "塑料管",
                                        "alias": "塑料管",
                                        "about": "指非泡沫塑料管，包括塑料硬管、软管、管材。不包括泡沫塑料管（详见107060107），也不包括降解塑料管（详见107060113）。",
                                        "kws": "塑料管、塑料硬管、聚乙烯塑料硬管、聚丙烯塑料硬管、聚氯乙烯塑料硬管、塑料软管、香肠用人造肠衣",
                                        "taxName": "塑料制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070601030000000000",
                                        "taxCodeTitle": "塑料制品",
                                        "iTitle": "*塑料制品*塑料管",
                                        "children": []
                                    },
                                    {
                                        "id": "1992",
                                        "linkid": "1986",
                                        "code": "107060104",
                                        "paCode": "1070601",
                                        "yn": "N",
                                        "title": "塑料管附件",
                                        "alias": "塑料管附件",
                                        "about": "包括塑料管的塑料附件，管子接头、肘管、法兰等。",
                                        "kws": "塑料管附件、塑料制管子接头、塑料制管子肘管、塑料制法兰",
                                        "taxName": "塑料制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070601040000000000",
                                        "taxCodeTitle": "塑料制品",
                                        "iTitle": "*塑料制品*塑料管附件",
                                        "children": []
                                    },
                                    {
                                        "id": "1993",
                                        "linkid": "1986",
                                        "code": "107060105",
                                        "paCode": "1070601",
                                        "yn": "N",
                                        "title": "塑料条、棒、型材",
                                        "alias": "塑料条、棒、型材",
                                        "about": "指以塑料为主要原料，经连续挤出成型的非泡沫中空型材及异型材，主要用于室内天花板、墙裙、塑料门、塑料窗、扶手及其框架和门槛等类似制成，包括聚乙烯塑料条、棒、型材、聚氯乙烯塑料条、棒、型材。不包括泡沫塑料（详见107060107）、非泡沫塑料板、片、管、丝、绳（详见107060102）和塑料管（详见107060103），也不包括降解塑料条、棒、型材（详见107060113）。",
                                        "kws": "塑料条、塑料棒、塑料型材、聚乙烯塑料棒、聚乙烯塑料条、聚乙烯塑料型材、聚乙烯塑料异型材、聚氯乙烯塑料条、聚氯乙烯塑料棒、聚氯乙烯塑料型材、聚氯乙烯塑料异型材、聚酰胺塑料条、聚酰胺塑料棒、聚酰胺塑料型材、聚碳酸酯塑料条、聚碳酸酯塑料棒、聚碳酸酯塑料型材、聚甲基丙烯酸甲酯塑料条、聚甲基丙烯酸甲酯塑料棒、聚甲基丙烯酸甲酯塑料型材",
                                        "taxName": "塑料制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070601050000000000",
                                        "taxCodeTitle": "塑料制品",
                                        "iTitle": "*塑料制品*塑料条、棒、型材",
                                        "children": []
                                    },
                                    {
                                        "id": "1994",
                                        "linkid": "1986",
                                        "code": "107060106",
                                        "paCode": "1070601",
                                        "yn": "N",
                                        "title": "塑料丝、绳、袋及编织品",
                                        "alias": "塑料丝、绳、袋及编织品",
                                        "about": "包括塑料单丝、塑料绳、塑料扁条、塑料编织袋、塑料袋、塑料编织布等，不包括泡沫塑料（详见107060107）或非泡沫塑料板、片、管、丝、绳（详见107060102）和塑料管（详见107060103），也不包括降解塑料丝、绳及编织品（详见107060113）。",
                                        "kws": "塑料丝、塑料编织品、塑料单丝、聚乙烯塑料单丝、聚氯乙烯塑料单丝、聚酰胺塑料单丝、塑料绳、聚乙烯塑料绳、聚丙烯塑料绳、塑料扁条、聚酯塑料扁条、纤维素衍生物塑料扁条、聚乙烯醇缩丁醛塑料扁条、聚酰胺塑料扁条、氨基塑料扁条、酚醛塑料扁条、聚四氟乙烯扁条、塑料带状物品、塑料编织袋、聚乙烯塑料编织袋、聚丙烯塑料编织袋、聚乙烯复合塑料编织袋、聚丙烯复合塑料编织袋、塑料袋、聚乙烯塑料袋、塑料编织布",
                                        "taxName": "塑料制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070601060000000000",
                                        "taxCodeTitle": "塑料制品",
                                        "iTitle": "*塑料制品*塑料丝、绳、袋及编织品",
                                        "children": []
                                    },
                                    {
                                        "id": "1995",
                                        "linkid": "1986",
                                        "code": "107060107",
                                        "paCode": "1070601",
                                        "yn": "N",
                                        "title": "泡沫塑料",
                                        "alias": "泡沫塑料",
                                        "about": "包括聚乙烯泡沫塑料、聚苯乙烯泡沫塑料、聚氯乙烯泡沫塑料、聚氨酯泡沫塑料、其他泡沫塑料。不包括降解泡沫塑料（详见107060113）。",
                                        "kws": "泡沫塑料、聚乙烯泡沫塑料、聚乙烯泡沫塑料板、聚乙烯泡沫塑料片、聚乙烯泡沫塑料膜、聚乙烯泡沫模塑制品、聚苯乙烯泡沫塑料、聚苯乙烯泡沫塑料板、聚苯乙烯泡沫塑料片、聚苯乙烯泡沫塑料膜、聚苯乙烯泡沫模塑制品、聚氯乙烯泡沫塑料、聚氯乙烯泡沫塑料板、聚氯乙烯泡沫塑料片、聚氯乙烯泡沫塑料膜、聚氯乙烯泡沫模塑制品、聚氨酯泡沫塑料、聚氨酯泡沫塑料板、聚氨酯泡沫塑料片、聚氨酯泡沫塑料膜、聚氨酯泡沫模塑制品、硬质聚氨酯泡沫塑料管",
                                        "taxName": "塑料制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070601070000000000",
                                        "taxCodeTitle": "塑料制品",
                                        "iTitle": "*塑料制品*泡沫塑料",
                                        "children": []
                                    },
                                    {
                                        "id": "1996",
                                        "linkid": "1986",
                                        "code": "107060108",
                                        "paCode": "1070601",
                                        "yn": "N",
                                        "title": "塑料人造革、合成革",
                                        "alias": "塑料人造革、合成革",
                                        "about": "包括箱包、服装、鞋、蓬盖、灯箱、汽车、体育器材、家具等各种用途的塑料人造革、合成革，不包括塑料铺地制品（详见107060102）。",
                                        "kws": "塑料人造革、聚氯乙烯人造革、聚氨酯干法人造革、塑料合成革、聚氨酯合成革、超细纤维合成革",
                                        "taxName": "塑料制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070601080000000000",
                                        "taxCodeTitle": "塑料制品",
                                        "iTitle": "*塑料制品*塑料人造革、合成革",
                                        "children": []
                                    },
                                    {
                                        "id": "1997",
                                        "linkid": "1986",
                                        "code": "107060109",
                                        "paCode": "1070601",
                                        "yn": "N",
                                        "title": "塑料包装箱及容器",
                                        "alias": "塑料包装箱及容器",
                                        "about": "指供运输或包装货物用的塑料制品及塑料包装物附件，包括塑料包装箱及类似品、塑料盒及类似品、塑料容器，容积≤300L、塑料容器，容积＞300L、塑料包装物附件、其他塑料包装箱及容器。不包括家用塑料餐具和厨房用具（详见107060112），也不包括降解塑料包装箱及容器（详见107060113）。",
                                        "kws": "塑料包装箱、塑料周转箱、钙塑瓦楞箱、塑料整理箱、塑料托盘、塑料盒、塑料磁带盒、塑料容器、塑料桶、塑料瓶、塑料包装物附件、塑料卷轴、塑料纡子、塑料筒管、塑料塞子、塑料盖子",
                                        "taxName": "塑料制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070601090000000000",
                                        "taxCodeTitle": "塑料制品",
                                        "iTitle": "*塑料制品*塑料包装箱及容器",
                                        "children": []
                                    },
                                    {
                                        "id": "1998",
                                        "linkid": "1986",
                                        "code": "107060110",
                                        "paCode": "1070601",
                                        "yn": "N",
                                        "title": "塑料零件",
                                        "alias": "塑料零件",
                                        "about": "包括塑料绝缘零件、塑料密封制品、塑料紧固件、光学塑料零件、灯具及照明装置用塑料零件、家具用塑料零件、汽车或类似品塑料配件、其他塑料零件。不包括降解塑料零件（详见107060113）。",
                                        "kws": "塑料零件、塑料绝缘零件、密胺塑料制绝缘零件、塑料密封制品、塑料紧固件、光学塑料零件、灯具用塑料零件、照明装置用塑料零件、家具用塑料零件、汽车塑料配件",
                                        "taxName": "塑料制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070601100000000000",
                                        "taxCodeTitle": "塑料制品",
                                        "iTitle": "*塑料制品*塑料零件",
                                        "children": []
                                    },
                                    {
                                        "id": "1999",
                                        "linkid": "1986",
                                        "code": "107060111",
                                        "paCode": "1070601",
                                        "yn": "N",
                                        "title": "建筑用塑料制品",
                                        "alias": "建筑用塑料制品",
                                        "about": "包括塑料铺地制品、塑料类防水卷材、塑料糊墙品、塑料门、窗、塑料窗板、帘、建筑用固定安装塑料制品、塑料制建筑结构架及类似品、其他建筑用塑料制品。不包括建筑用降解塑料制品（详见107060113）。",
                                        "kws": "建筑用塑料制品、塑料铺地制品、成卷聚氯乙烯塑料地板、成卷非聚氯乙烯塑料地板、聚氯乙烯塑料地板块、非聚氯乙烯塑料地板块、塑料类防水卷材、宽幅聚氯乙烯塑料防水卷材、塑料糊墙品、聚氯乙烯塑料糊墙品、塑料门、塑料门框、门槛、塑料窗、塑料窗框、塑料窗板、塑料百叶窗帘、建筑用固定安装塑料制品、建筑用固定安装塑料盥洗物品、建筑用固定安装塑料零件、塑料制建筑结构架",
                                        "taxName": "塑料制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070601110000000000",
                                        "taxCodeTitle": "塑料制品",
                                        "iTitle": "*塑料制品*建筑用塑料制品",
                                        "children": []
                                    },
                                    {
                                        "id": "2000",
                                        "linkid": "1986",
                                        "code": "107060112",
                                        "paCode": "1070601",
                                        "yn": "N",
                                        "title": "日用塑料制品",
                                        "alias": "日用塑料制品",
                                        "about": "包括普通塑料餐、厨用具、密胺塑料餐、厨用具、微波炉用塑料餐、厨用具、塑料卫生设备、洁具及其配件、塑料服装及其附件、安全帽及塑料橡胶帽、医疗卫生用塑料制品、日用塑料装饰品、其他日用塑料制品。不包括降解塑料日用制品（详见107060113）。",
                                        "kws": "日用塑料制品、普通塑料餐、厨用具、普通塑料碗、普通塑料餐盘、碟、普通塑料杯、普通塑料刀、叉及汤匙、普通塑料调味品瓶盒、普通塑料食品罐箱盒、厨用具密胺塑料餐、厨用具微波炉用塑料餐、厨用具微波炉用塑料碗、微波炉用塑料餐盘碟、微波炉用塑料杯、塑料卫生设备、洁具、洁具配件、塑料浴缸、塑料淋浴盘、塑料坐浴盆、塑料盥洗盆、塑料便盆、尿壶、塑料卫生桶、非固定安装塑料盥洗物品、塑料马桶座圈及盖、塑料坐便器水箱、塑料卫生洁具排水配件、塑料服装、塑料服装附件、塑料雨衣、塑料围裙、塑料腰带、塑料手套、安全帽、塑料橡胶帽、塑料制",
                                        "taxName": "塑料制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070601120000000000",
                                        "taxCodeTitle": "塑料制品",
                                        "iTitle": "*塑料制品*日用塑料制品",
                                        "children": []
                                    },
                                    {
                                        "id": "2001",
                                        "linkid": "1986",
                                        "code": "107060113",
                                        "paCode": "1070601",
                                        "yn": "N",
                                        "title": "降解塑料制品",
                                        "alias": "降解塑料制品",
                                        "about": "指用在规定环境条件下，经过一段时间和包含一个或更多步骤，导致材料化学结构的显著变化而损失某些性能（如完整性、分子质量、结构或机械强度）和/或发生破碎的塑料制成的制品。包括生物分解塑料制品、光降解塑料制品、热氧降解塑料制品、生物基塑料制品、其他降解塑料制品。",
                                        "kws": "降解塑料制品、生物分解塑料制品、天然高分子材料生物分解塑料制品、石化基生物分解塑料制品、生物基生物分解塑料制品、共混型生物分解塑料制品、光降解塑料制品、热氧降解塑料制品、生物基塑料制品、淀粉基塑料制品、植物纤维基塑料制品",
                                        "taxName": "塑料制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070601130000000000",
                                        "taxCodeTitle": "塑料制品",
                                        "iTitle": "*塑料制品*降解塑料制品",
                                        "children": []
                                    },
                                    {
                                        "id": "2002",
                                        "linkid": "1986",
                                        "code": "107060114",
                                        "paCode": "1070601",
                                        "yn": "N",
                                        "title": "再生塑料制品",
                                        "alias": "再生塑料制品",
                                        "about": "指以废塑料生产的建筑材料（如钢材、棚栏和墙面板）、园艺用料（如花盆、花园桩）、农产品容器（如装盛鸡蛋、水果和蔬菜等的容器）、办公用品（如文件夹和封皮）、非食品容器及可重复利用的包装箱、娱乐设施和室外家具等塑料制品。",
                                        "kws": "再生塑料制品",
                                        "taxName": "塑料制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070601140000000000",
                                        "taxCodeTitle": "塑料制品",
                                        "iTitle": "*塑料制品*再生塑料制品",
                                        "children": []
                                    },
                                    {
                                        "id": "2003",
                                        "linkid": "1986",
                                        "code": "107060115",
                                        "paCode": "1070601",
                                        "yn": "N",
                                        "title": "塑木（木塑）制品",
                                        "alias": "塑木（木塑）制品",
                                        "about": "指利用聚乙烯、聚丙烯和聚氯乙烯等，代替通常的树脂胶粘剂，与超过35%-70%以上的木粉、稻壳、秸秆等废植物纤维混合成新的木质材料，再经挤压、模压、注塑成型等塑料制品。",
                                        "kws": "塑木制品、木塑制品",
                                        "taxName": "塑料制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070601150000000000",
                                        "taxCodeTitle": "塑料制品",
                                        "iTitle": "*塑料制品*塑木（木塑）制品",
                                        "children": []
                                    },
                                    {
                                        "id": "2004",
                                        "linkid": "1986",
                                        "code": "107060199",
                                        "paCode": "1070601",
                                        "yn": "N",
                                        "title": "其他塑料制品",
                                        "alias": "其他塑料制品",
                                        "about": "指其他非降解塑料制品，包括塑料胶粘板、带及类似材料、其他未列明塑料制品。不包括降解塑料制品（详见107060113）。",
                                        "kws": "塑料胶粘带、胶囊型反光膜、塑料胶粘板、塑料胶粘片",
                                        "taxName": "塑料制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070601990000000000",
                                        "taxCodeTitle": "塑料制品",
                                        "iTitle": "*塑料制品*其他塑料制品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2005",
                                "linkid": "1985",
                                "code": "1070602",
                                "paCode": "10706",
                                "yn": "Y",
                                "title": "塑料半成品、辅料",
                                "alias": "塑料半成品、辅料",
                                "about": "包括塑料粒料、其他塑料半成品、辅料",
                                "kws": null,
                                "taxName": "塑料制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070602000000000000",
                                "taxCodeTitle": "塑料制品",
                                "iTitle": "*塑料制品*塑料半成品、辅料",
                                "children": [
                                    {
                                        "id": "2006",
                                        "linkid": "2005",
                                        "code": "107060201",
                                        "paCode": "1070602",
                                        "yn": "N",
                                        "title": "塑料粒料",
                                        "alias": "塑料粒料",
                                        "about": "指以半成品形态进行储存、运输和加工成型的塑料原料。塑料颗粒的俗称。",
                                        "kws": "塑料粒料、塑料电缆料颗粒、塑料色母料颗粒、塑料填充母料颗粒、塑料功能母料颗粒、填充改性塑料颗粒、共混改性塑料颗粒、增强改性塑料颗粒、功能改性塑料颗粒、塑料热塑性弹性体颗粒、再生塑料颗粒",
                                        "taxName": "塑料制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070602010000000000",
                                        "taxCodeTitle": "塑料制品",
                                        "iTitle": "*塑料制品*塑料粒料",
                                        "children": []
                                    },
                                    {
                                        "id": "2007",
                                        "linkid": "2005",
                                        "code": "107060299",
                                        "paCode": "1070602",
                                        "yn": "N",
                                        "title": "其他塑料半成品、辅料",
                                        "alias": "其他塑料半成品、辅料",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "塑料制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070602990000000000",
                                        "taxCodeTitle": "塑料制品",
                                        "iTitle": "*塑料制品*其他塑料半成品、辅料",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2008",
                                "linkid": "1985",
                                "code": "1070603",
                                "paCode": "10706",
                                "yn": "Y",
                                "title": "纤维增强塑料制品",
                                "alias": "纤维增强塑料制品",
                                "about": "指以纤维（玻璃纤维、碳纤维、芳纶纤维及其他有机和无机纤维）或其制品为增强材料，合成树脂为基体的复合材料；广泛应用于建筑、石油化工、交通运输、能源电力、航空航天等领域。",
                                "kws": null,
                                "taxName": "塑料制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1070603000000000000",
                                "taxCodeTitle": "塑料制品",
                                "iTitle": "*塑料制品*纤维增强塑料制品",
                                "children": [
                                    {
                                        "id": "2009",
                                        "linkid": "2008",
                                        "code": "107060301",
                                        "paCode": "1070603",
                                        "yn": "N",
                                        "title": "建筑用纤维增强塑料制品",
                                        "alias": "建筑用纤维增强塑料制品",
                                        "about": "指用于建筑工程的含有增强材料的塑料制品。",
                                        "kws": "建筑用纤维增强塑料制品、纤维增强塑料板材、纤维增强塑料型材、纤维增强塑料输水管、纤维增强塑料排水管、纤维增强塑料水箱、纤维增强塑料吊顶、纤维增强塑料冷却塔、纤维增强塑料门、纤维增强塑料窗、纤维增强塑料格栅、纤维增强塑料净化槽、纤维增强塑料水处理制品、纤维增强塑料风机、纤维增强塑料井盖、井箅",
                                        "taxName": "塑料制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070603010000000000",
                                        "taxCodeTitle": "塑料制品",
                                        "iTitle": "*塑料制品*建筑用纤维增强塑料制品",
                                        "children": []
                                    },
                                    {
                                        "id": "2010",
                                        "linkid": "2008",
                                        "code": "107060302",
                                        "paCode": "1070603",
                                        "yn": "N",
                                        "title": "石化、酿造用纤维增强塑料制品",
                                        "alias": "石化、酿造用纤维增强塑料制品",
                                        "about": "指用于石化、酿造的含有增强材料的塑料制品。",
                                        "kws": "石化酿造用纤维增强塑料制品、纤维增强塑料贮罐、纤维增强塑料压力容器、纤维增强塑料塔器、纤维增强塑料槽池、纤维增强塑料输油管、纤维增强塑料抽油杆、纤维增强塑料阀门、纤维增强塑料管件",
                                        "taxName": "塑料制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070603020000000000",
                                        "taxCodeTitle": "塑料制品",
                                        "iTitle": "*塑料制品*石化、酿造用纤维增强塑料制品",
                                        "children": []
                                    },
                                    {
                                        "id": "2011",
                                        "linkid": "2008",
                                        "code": "107060303",
                                        "paCode": "1070603",
                                        "yn": "N",
                                        "title": "机械设备用纤维增强塑料制品",
                                        "alias": "机械设备用纤维增强塑料制品",
                                        "about": "指用于机械设备的含有增强材料的塑料制品。",
                                        "kws": "机械设备用纤维增强塑料制品、纤维增强塑料机械壳、纤维增强塑料机械罩、纤维增强塑料仪器仪表壳、纤维增强塑料仪器仪表罩、纤维增强塑料医疗器械部件",
                                        "taxName": "塑料制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070603030000000000",
                                        "taxCodeTitle": "塑料制品",
                                        "iTitle": "*塑料制品*机械设备用纤维增强塑料制品",
                                        "children": []
                                    },
                                    {
                                        "id": "2012",
                                        "linkid": "2008",
                                        "code": "107060304",
                                        "paCode": "1070603",
                                        "yn": "N",
                                        "title": "装饰用纤维增强塑料制品",
                                        "alias": "装饰用纤维增强塑料制品",
                                        "about": "包括建筑装饰、室内装饰、园林景观、纤维增强塑料整体卫浴间、浴缸、浴盆、托水盘、壁板等。",
                                        "kws": "装饰用纤维增强塑料制品、纤维增强塑料工艺品、纤维增强塑料仿古建筑制品、纤维增强塑料浮雕、雕塑、纤维增强塑料花盆、纤维增强塑料浴缸、纤维增强塑料托水盘、住宅用纤维增强塑料整体卫生间、车辆用纤维增强塑料整体卫生间",
                                        "taxName": "塑料制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070603040000000000",
                                        "taxCodeTitle": "塑料制品",
                                        "iTitle": "*塑料制品*装饰用纤维增强塑料制品",
                                        "children": []
                                    },
                                    {
                                        "id": "2013",
                                        "linkid": "2008",
                                        "code": "107060305",
                                        "paCode": "1070603",
                                        "yn": "N",
                                        "title": "交通运输用纤维增强塑料制品",
                                        "alias": "交通运输用纤维增强塑料制品",
                                        "about": "包括汽车、火车、城铁、地铁、特种车辆、交通设施等。",
                                        "kws": "交通运输用纤维增强塑料制品、纤维增强塑料汽车覆盖件、纤维增强塑料汽车结构件、纤维增强塑料轨道车辆部件、纤维增强塑料轨道设施部件、纤维增强塑料防眩板、纤维增强塑料交通设施制品",
                                        "taxName": "塑料制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070603050000000000",
                                        "taxCodeTitle": "塑料制品",
                                        "iTitle": "*塑料制品*交通运输用纤维增强塑料制品",
                                        "children": []
                                    },
                                    {
                                        "id": "2014",
                                        "linkid": "2008",
                                        "code": "107060306",
                                        "paCode": "1070603",
                                        "yn": "N",
                                        "title": "能源、电力用纤维增强塑料制品",
                                        "alias": "能源、电力用纤维增强塑料制品",
                                        "about": "指用于能源、电力的含有增强材料的塑料制品。",
                                        "kws": "能源电力用纤维增强塑料制品、纤维增强塑料风力发电机叶片、纤维增强塑料风力发电机舱罩、纤维增强塑料电缆桥架、纤维增强塑料电力控制柜、纤维增强塑料电表箱、纤维增强塑料脱硫喷淋管、纤维增强塑料烟道、烟囱、纤维增强塑料电缆保护管、纤维增强塑料灯杆、纤维增强塑料沼气池",
                                        "taxName": "塑料制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070603060000000000",
                                        "taxCodeTitle": "塑料制品",
                                        "iTitle": "*塑料制品*能源、电力用纤维增强塑料制品",
                                        "children": []
                                    },
                                    {
                                        "id": "2015",
                                        "linkid": "2008",
                                        "code": "107060307",
                                        "paCode": "1070603",
                                        "yn": "N",
                                        "title": "航空航天用纤维增强塑料制品",
                                        "alias": "航空航天用纤维增强塑料制品",
                                        "about": "指用于航空航天的含有增强材料的塑料制品。",
                                        "kws": "航空航天用纤维增强塑料制品",
                                        "taxName": "塑料制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070603070000000000",
                                        "taxCodeTitle": "塑料制品",
                                        "iTitle": "*塑料制品*航空航天用纤维增强塑料制品",
                                        "children": []
                                    },
                                    {
                                        "id": "2016",
                                        "linkid": "2008",
                                        "code": "107060399",
                                        "paCode": "1070603",
                                        "yn": "N",
                                        "title": "其他纤维增强塑料制品",
                                        "alias": "其他纤维增强塑料制品",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "塑料制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1070603990000000000",
                                        "taxCodeTitle": "塑料制品",
                                        "iTitle": "*塑料制品*其他纤维增强塑料制品",
                                        "children": []
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "id": "2017",
                "linkid": "1",
                "code": "108",
                "paCode": "1",
                "yn": "Y",
                "title": "金属及非金属制品",
                "alias": "金属及非金属制品",
                "about": null,
                "kws": null,
                "taxName": "金属及非金属制品",
                "taxRate": "",
                "vip": "7",
                "itaxRate": null,
                "taxCode": "1080000000000000000",
                "taxCodeTitle": "金属及非金属制品",
                "iTitle": "*金属及非金属制品*金属及非金属制品",
                "children": [
                    {
                        "id": "2018",
                        "linkid": "2017",
                        "code": "10801",
                        "paCode": "108",
                        "yn": "Y",
                        "title": "非金属矿物制品",
                        "alias": "非金属矿物制品",
                        "about": null,
                        "kws": null,
                        "taxName": "非金属矿物制品",
                        "taxRate": "",
                        "vip": "7",
                        "itaxRate": null,
                        "taxCode": "1080100000000000000",
                        "taxCodeTitle": "非金属矿物制品",
                        "iTitle": "*非金属矿物制品*非金属矿物制品",
                        "children": [
                            {
                                "id": "2018",
                                "linkid": "2018",
                                "code": "1080100",
                                "paCode": "10800",
                                "yn": "N",
                                "title": "泳池瓷砖",
                                "alias": "泳池瓷砖",
                                "about": "包括日用玻璃瓶（玻璃饮料瓶、玻璃食品瓶、玻璃啤酒瓶、玻璃白酒容器）、药用瓶（医药试剂用广口瓶、输液瓶、安瓿瓶、黄圆瓶、无色小药瓶、抗生素瓶、口服液瓶、农药用瓶）、其他玻璃瓶",
                                "kws": "玻璃饮料瓶、玻璃食品瓶、玻璃啤酒瓶、玻璃白酒容器、玻璃输液瓶、玻璃制安瓿",
                                "taxName": "非金属矿物制品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1080106010000000000",
                                "taxCodeTitle": "非金属矿物制品",
                                "iTitle": "*非金属矿物制品*泳池瓷砖",
                                "children": []
                            },
                            {
                                "id": "2019",
                                "linkid": "2018",
                                "code": "1080101",
                                "paCode": "10801",
                                "yn": "Y",
                                "title": "水泥熟料及水泥",
                                "alias": "水泥熟料及水泥",
                                "about": null,
                                "kws": null,
                                "taxName": "非金属矿物制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080101000000000000",
                                "taxCodeTitle": "非金属矿物制品",
                                "iTitle": "*非金属矿物制品*水泥熟料及水泥",
                                "children": [
                                    {
                                        "id": "2020",
                                        "linkid": "2019",
                                        "code": "108010101",
                                        "paCode": "1080101",
                                        "yn": "N",
                                        "title": "硅酸盐水泥熟料",
                                        "alias": "硅酸盐水泥熟料",
                                        "about": "即波特兰水泥熟料（简称水泥熟料），是一种由主要含CaO、SiO2、Al2O3、Fe2O3的原料按适当配比磨成细粉烧至部分熔融，所得以硅酸钙为主要矿物成分的水硬性胶凝物质；包括企业自产自用的水泥熟料和外销水泥熟料。",
                                        "kws": "水泥熟料",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080101010000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*硅酸盐水泥熟料",
                                        "children": []
                                    },
                                    {
                                        "id": "2021",
                                        "linkid": "2019",
                                        "code": "108010102",
                                        "paCode": "1080101",
                                        "yn": "N",
                                        "title": "水泥",
                                        "alias": "水泥",
                                        "about": "凡细磨成粉末状，加入适量水后，可成为塑性胶体，既能在空气中硬化，又能在水中硬化，并能把砂、石等材料牢固的胶结在一起的水硬性胶凝材料统称为水泥；水泥的种类很多，常用的是通用硅酸盐水泥",
                                        "kws": "水泥",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080101020000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*水泥",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2022",
                                "linkid": "2018",
                                "code": "1080102",
                                "paCode": "10801",
                                "yn": "Y",
                                "title": "石灰和石膏",
                                "alias": "石灰和石膏",
                                "about": null,
                                "kws": null,
                                "taxName": "非金属矿物制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080102000000000000",
                                "taxCodeTitle": "非金属矿物制品",
                                "iTitle": "*非金属矿物制品*石灰和石膏",
                                "children": [
                                    {
                                        "id": "2023",
                                        "linkid": "2022",
                                        "code": "108010201",
                                        "paCode": "1080102",
                                        "yn": "N",
                                        "title": "石灰",
                                        "alias": "石灰",
                                        "about": "不同化学组成和物理形态的生石灰、消石灰、水硬性石灰与气硬性石灰的统称",
                                        "kws": "石灰",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080102010000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*石灰",
                                        "children": []
                                    },
                                    {
                                        "id": "2024",
                                        "linkid": "2022",
                                        "code": "108010202",
                                        "paCode": "1080102",
                                        "yn": "N",
                                        "title": "熟石膏",
                                        "alias": "熟石膏",
                                        "about": "石膏经低温煅烧所得到的以β半水硫酸钙为主要成分、不预加任何外加剂的粉状胶凝材料",
                                        "kws": "熟石膏",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080102020000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*熟石膏",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2025",
                                "linkid": "2018",
                                "code": "1080103",
                                "paCode": "10801",
                                "yn": "Y",
                                "title": "水泥混凝土制品",
                                "alias": "水泥混凝土制品",
                                "about": "指水泥、混凝土制品",
                                "kws": null,
                                "taxName": "非金属矿物制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080103000000000000",
                                "taxCodeTitle": "非金属矿物制品",
                                "iTitle": "*非金属矿物制品*水泥混凝土制品",
                                "children": [
                                    {
                                        "id": "2026",
                                        "linkid": "2025",
                                        "code": "108010301",
                                        "paCode": "1080103",
                                        "yn": "N",
                                        "title": "商品混凝土",
                                        "alias": "商品混凝土",
                                        "about": "混凝土是指用水泥作胶凝材料，砂、石作集料，与水（加或不加外加剂和掺合料）按一定比例配合，经搅拌、成型、养护而得的水泥混凝土，也称普通混凝土；它广泛应用于土木工程",
                                        "kws": "混凝土",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080103010000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*商品混凝土",
                                        "children": []
                                    },
                                    {
                                        "id": "2027",
                                        "linkid": "2025",
                                        "code": "108010302",
                                        "paCode": "1080103",
                                        "yn": "N",
                                        "title": "水泥混凝土排水管",
                                        "alias": "水泥混凝土排水管",
                                        "about": "又称下水管，用于建设排除污水、雨水的下水道，排水管在生产时夹入钢筋的称钢筋混凝土排水管，不夹钢筋的称无筋混凝土排水管",
                                        "kws": "混凝土排水管",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080103020000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*水泥混凝土排水管",
                                        "children": []
                                    },
                                    {
                                        "id": "2028",
                                        "linkid": "2025",
                                        "code": "108010303",
                                        "paCode": "1080103",
                                        "yn": "N",
                                        "title": "水泥混凝土压力管",
                                        "alias": "水泥混凝土压力管",
                                        "about": "以钢筋混凝土为原料生产的，按照质量标准要求，可以承受一定的内压力，用于输送自来水、各种气体、石油的管道，按其生产时所用方法或原料不同，可分为预应力钢筋混凝土管和自应力钢筋混凝土管、普通钢筋混凝土管；包括水泥输水管、水泥输气管和水泥输油管",
                                        "kws": "混凝土压力管",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080103030000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*水泥混凝土压力管",
                                        "children": []
                                    },
                                    {
                                        "id": "2029",
                                        "linkid": "2025",
                                        "code": "108010304",
                                        "paCode": "1080103",
                                        "yn": "N",
                                        "title": "钢筋混凝土井管、烟道管，相关钢筋混凝土管",
                                        "alias": "钢筋混凝土井管、烟道管，相关钢筋混凝土管",
                                        "about": null,
                                        "kws": "钢筋混凝土",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080103040000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*钢筋混凝土井管、烟道管，相关钢筋混凝土管",
                                        "children": []
                                    },
                                    {
                                        "id": "2030",
                                        "linkid": "2025",
                                        "code": "108010305",
                                        "paCode": "1080103",
                                        "yn": "N",
                                        "title": "水泥混凝土电杆",
                                        "alias": "水泥混凝土电杆",
                                        "about": "按生产时配入钢筋的方法可分为预应力钢筋混凝土电杆和普通钢筋混凝土电杆以及簿壁轻型钢筋混凝土电杆，按其横截面形状可分为环形、矩型、工字型、双肢型等",
                                        "kws": "混凝土电杆",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080103050000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*水泥混凝土电杆",
                                        "children": []
                                    },
                                    {
                                        "id": "2031",
                                        "linkid": "2025",
                                        "code": "108010306",
                                        "paCode": "1080103",
                                        "yn": "N",
                                        "title": "预应力混凝土桩",
                                        "alias": "预应力混凝土桩",
                                        "about": "为加强建筑物基础而打入地下的一种混凝土制品；包括预应力混凝土管桩、方桩等",
                                        "kws": "混凝土桩",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080103060000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*预应力混凝土桩",
                                        "children": []
                                    },
                                    {
                                        "id": "2032",
                                        "linkid": "2025",
                                        "code": "108010307",
                                        "paCode": "1080103",
                                        "yn": "N",
                                        "title": "混凝土轨枕及铁道用混凝土制品",
                                        "alias": "混凝土轨枕及铁道用混凝土制品",
                                        "about": "包括预应力混凝土水泥轨枕、气垫火车导轨体段、预应力混凝土桥枕、岔枕、混凝土轨道板",
                                        "kws": "预应力混凝土水泥轨枕、气垫火车导轨体段、预应力混凝土桥枕、预应力混凝土岔枕、混凝土轨道板",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080103070000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*混凝土轨枕及铁道用混凝土制品",
                                        "children": []
                                    },
                                    {
                                        "id": "2033",
                                        "linkid": "2025",
                                        "code": "108010308",
                                        "paCode": "1080103",
                                        "yn": "N",
                                        "title": "水泥混凝土预制构件",
                                        "alias": "水泥混凝土预制构件",
                                        "about": "指建筑房屋用的各种梁、柱、板、楼梯等钢筋混凝土预制构件",
                                        "kws": "预制混凝土空心板、预应力混凝土空心板、架空防水混凝土板屋面、混凝土多孔条板、混凝土窗台板、氯氧镁水泥板块、水泥预制桁条、钢筋混凝土柱、钢筋混凝土梁、钢筋混凝土桩式桥台、钢筋混凝土结构人防门、钢筋混凝土双筋矩形受弯构件、水泥预制大坝结构件、水泥预制闸门、钢筋混凝土房屋结构、钢筋混凝土框架结构、无木四防活动房屋预制板、钢筋混凝土预制楼梯、钢筋混凝土预制门窗框架、水泥钢筋混凝土桥梁构件",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080103080000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*水泥混凝土预制构件",
                                        "children": []
                                    },
                                    {
                                        "id": "2034",
                                        "linkid": "2025",
                                        "code": "108010309",
                                        "paCode": "1080103",
                                        "yn": "N",
                                        "title": "水泥混凝土制砖、瓦及类似品",
                                        "alias": "水泥混凝土制砖、瓦及类似品",
                                        "about": "包括水泥混凝土砖、水泥混凝土瓦、混凝土路缘石、混凝土界石、墓碑及类似品",
                                        "kws": "混凝土路面砖、水泥混凝土空心砖、水泥花砖、混凝土多排孔砖、水泥彩瓦、玻璃纤维氯氧镁水泥波瓦、玻璃纤维氯氧镁水泥波脊瓦、普通路缘石、复合式路缘石、无孔波浪形路缘石、开孔波浪形路缘石、艺术路缘石、水泥混凝土制界石、水泥混凝土制墓碑、水泥混凝土制镶边石",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080103090000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*水泥混凝土制砖、瓦及类似品",
                                        "children": []
                                    },
                                    {
                                        "id": "2035",
                                        "linkid": "2025",
                                        "code": "108010310",
                                        "paCode": "1080103",
                                        "yn": "N",
                                        "title": "纤维增强水泥制品",
                                        "alias": "纤维增强水泥制品",
                                        "about": "包括石棉水泥制品、纤维增强硅酸钙板、GRC水泥制品等",
                                        "kws": "建筑用石棉水泥平板、电工用石棉水泥压力板、非对称截面石棉水泥半波板、石棉水泥小波瓦、石棉水泥中波瓦、石棉水泥波瓦脊瓦、钢丝网石棉水泥中波瓦、钢丝网石棉水泥小波瓦、石棉水泥输水管、石棉水泥电缆管、石棉硅酸钙板、高密度石棉硅酸钙板、中密度石棉硅酸钙板、低密度石棉硅酸钙板、高密度无石棉硅酸钙板、中密度无石棉硅酸钙板、低密度无石棉硅酸钙板、无石棉纤维水泥加压平板、无石棉纤维水泥轻质平板、无石棉纤维水泥实心披迭板、无石棉纤维水泥多孔披迭板、无石棉纤维水泥多孔条板、无石棉纤维水泥板预制复合墙板、无石棉纤维水泥小波瓦、",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080103100000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*纤维增强水泥制品",
                                        "children": []
                                    },
                                    {
                                        "id": "2036",
                                        "linkid": "2025",
                                        "code": "108010399",
                                        "paCode": "1080103",
                                        "yn": "N",
                                        "title": "其他水泥混凝土制品",
                                        "alias": "其他水泥混凝土制品",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080103990000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*其他水泥混凝土制品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2037",
                                "linkid": "2018",
                                "code": "1080104",
                                "paCode": "10801",
                                "yn": "Y",
                                "title": "轻质建筑材料及制品",
                                "alias": "轻质建筑材料及制品",
                                "about": "指石膏板、石膏制品及类似轻质建筑材料的制造",
                                "kws": null,
                                "taxName": "非金属矿物制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080104000000000000",
                                "taxCodeTitle": "非金属矿物制品",
                                "iTitle": "*非金属矿物制品*轻质建筑材料及制品",
                                "children": [
                                    {
                                        "id": "2038",
                                        "linkid": "2037",
                                        "code": "108010401",
                                        "paCode": "1080104",
                                        "yn": "Y",
                                        "title": "石膏板",
                                        "alias": "石膏板",
                                        "about": "包括纸面石膏板、石膏空心条板和其他石膏板",
                                        "kws": null,
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1080104010000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*石膏板",
                                        "children": [
                                            {
                                                "id": "2039",
                                                "linkid": "2038",
                                                "code": "10801040101",
                                                "paCode": "108010401",
                                                "yn": "N",
                                                "title": "纸面石膏板",
                                                "alias": "纸面石膏板",
                                                "about": null,
                                                "kws": "纸面石膏板",
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080104010100000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*纸面石膏板",
                                                "children": []
                                            },
                                            {
                                                "id": "2040",
                                                "linkid": "2038",
                                                "code": "10801040102",
                                                "paCode": "108010401",
                                                "yn": "N",
                                                "title": "石膏空心条板",
                                                "alias": "石膏空心条板",
                                                "about": "以建筑石膏为基材，掺以无机轻集料、无机纤维增强材料而制成的空心条板",
                                                "kws": "石膏空心条板",
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080104010200000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*石膏空心条板",
                                                "children": []
                                            },
                                            {
                                                "id": "2041",
                                                "linkid": "2038",
                                                "code": "10801040103",
                                                "paCode": "108010401",
                                                "yn": "N",
                                                "title": "其他石膏板",
                                                "alias": "其他石膏板",
                                                "about": null,
                                                "kws": null,
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080104010300000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*其他石膏板",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "2042",
                                        "linkid": "2037",
                                        "code": "108010402",
                                        "paCode": "1080104",
                                        "yn": "N",
                                        "title": "石膏龙骨，相关石膏制品",
                                        "alias": "石膏龙骨，相关石膏制品",
                                        "about": "包括石膏龙骨、相关石膏制品，不包括石膏砌块（详见10801050305）",
                                        "kws": "石膏龙骨",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080104020000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*石膏龙骨，相关石膏制品",
                                        "children": []
                                    },
                                    {
                                        "id": "2043",
                                        "linkid": "2037",
                                        "code": "108010403",
                                        "paCode": "1080104",
                                        "yn": "Y",
                                        "title": "轻质隔墙条板",
                                        "alias": "轻质隔墙条板",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1080104030000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*轻质隔墙条板",
                                        "children": [
                                            {
                                                "id": "2044",
                                                "linkid": "2043",
                                                "code": "10801040301",
                                                "paCode": "108010403",
                                                "yn": "N",
                                                "title": "蒸压加气混凝土板",
                                                "alias": "蒸压加气混凝土板",
                                                "about": "以硅质材料和钙质材料为主要原料，以铝粉为发泡剂，配以经防腐处理的钢筋网片，经加水搅拌、浇注成型、预养切割、蒸压养护制成的多孔板材，不包括加气混凝土砌块（详见108010503）。",
                                                "kws": "蒸压加气混凝土板",
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080104030100000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*蒸压加气混凝土板",
                                                "children": []
                                            },
                                            {
                                                "id": "2045",
                                                "linkid": "2043",
                                                "code": "10801040302",
                                                "paCode": "108010403",
                                                "yn": "N",
                                                "title": "建筑用轻质隔墙条板",
                                                "alias": "建筑用轻质隔墙条板",
                                                "about": "由无害化磷石膏、轻质钢渣、粉煤灰等多种工业废渣组成，经变频蒸汽加压养护而成。内层装有合理布局的隔热、吸声的无机发泡型材或其他保温材料。",
                                                "kws": "建筑用轻质隔墙条板",
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080104030200000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*建筑用轻质隔墙条板",
                                                "children": []
                                            },
                                            {
                                                "id": "2046",
                                                "linkid": "2043",
                                                "code": "10801040303",
                                                "paCode": "108010403",
                                                "yn": "N",
                                                "title": "外墙外保温系统用钢丝网架模塑聚苯乙烯板",
                                                "alias": "外墙外保温系统用钢丝网架模塑聚苯乙烯板",
                                                "about": "以工厂自动化设备生产的双面或单面钢丝网架为骨架，EPS为绝热材料，用于现浇混凝土建筑、砌体建筑及既有建筑外墙外保温系统的钢丝网架EPS板",
                                                "kws": "外墙外保温系统用钢丝网架模塑聚苯乙烯板",
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080104030300000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*外墙外保温系统用钢丝网架模塑聚苯乙烯板",
                                                "children": []
                                            },
                                            {
                                                "id": "2047",
                                                "linkid": "2043",
                                                "code": "10801040304",
                                                "paCode": "108010403",
                                                "yn": "N",
                                                "title": "纤维增强硅酸钙板",
                                                "alias": "纤维增强硅酸钙板",
                                                "about": null,
                                                "kws": "纤维增强硅酸钙板",
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080104030400000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*纤维增强硅酸钙板",
                                                "children": []
                                            },
                                            {
                                                "id": "2048",
                                                "linkid": "2043",
                                                "code": "10801040305",
                                                "paCode": "108010403",
                                                "yn": "N",
                                                "title": "玻璃纤维增强水泥轻质多孔隔墙条板",
                                                "alias": "玻璃纤维增强水泥轻质多孔隔墙条板",
                                                "about": "以耐碱玻璃纤维与硫铝酸盐水泥为主要原料的预制非承重轻质多孔内隔墙条扳",
                                                "kws": "玻璃纤维增强水泥轻质多孔隔墙条板",
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080104030500000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*玻璃纤维增强水泥轻质多孔隔墙条板",
                                                "children": []
                                            },
                                            {
                                                "id": "2049",
                                                "linkid": "2043",
                                                "code": "10801040306",
                                                "paCode": "108010403",
                                                "yn": "N",
                                                "title": "建筑用金属面绝热夹芯板",
                                                "alias": "建筑用金属面绝热夹芯板",
                                                "about": "以双金属面和粘接于两金属面之间的绝热夹芯材组成的自支撑的复合板材",
                                                "kws": "建筑用金属面绝热夹芯板",
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080104030600000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*建筑用金属面绝热夹芯板",
                                                "children": []
                                            },
                                            {
                                                "id": "2050",
                                                "linkid": "2043",
                                                "code": "10801040307",
                                                "paCode": "108010403",
                                                "yn": "N",
                                                "title": "中空钢网内模隔墙",
                                                "alias": "中空钢网内模隔墙",
                                                "about": null,
                                                "kws": "中空钢网内模隔墙",
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080104030700000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*中空钢网内模隔墙",
                                                "children": []
                                            },
                                            {
                                                "id": "2051",
                                                "linkid": "2043",
                                                "code": "10801040308",
                                                "paCode": "108010403",
                                                "yn": "N",
                                                "title": "建筑隔墙用保温条板",
                                                "alias": "建筑隔墙用保温条板",
                                                "about": "由无害化磷石膏、轻质钢渣、粉煤灰等多种工业废渣组成，经变频蒸汽加压养护而成。内层装有合理布局的隔热、吸声的无机发泡型材或其他保温材料。",
                                                "kws": "建筑隔墙用保温条板",
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080104030800000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*建筑隔墙用保温条板",
                                                "children": []
                                            },
                                            {
                                                "id": "2052",
                                                "linkid": "2043",
                                                "code": "10801040309",
                                                "paCode": "108010403",
                                                "yn": "N",
                                                "title": "预制复合墙板（体）",
                                                "alias": "预制复合墙板（体）",
                                                "about": null,
                                                "kws": "预制复合墙板、预制复合墙体",
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080104030900000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*预制复合墙板（体）",
                                                "children": []
                                            },
                                            {
                                                "id": "2053",
                                                "linkid": "2043",
                                                "code": "10801040310",
                                                "paCode": "108010403",
                                                "yn": "N",
                                                "title": "聚氨酯硬泡复合板",
                                                "alias": "聚氨酯硬泡复合板",
                                                "about": null,
                                                "kws": "聚氨酯硬泡复合板",
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080104031000000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*聚氨酯硬泡复合板",
                                                "children": []
                                            },
                                            {
                                                "id": "2054",
                                                "linkid": "2043",
                                                "code": "10801040311",
                                                "paCode": "108010403",
                                                "yn": "N",
                                                "title": "专用聚氨酯建筑墙体",
                                                "alias": "专用聚氨酯建筑墙体",
                                                "about": null,
                                                "kws": "专用聚氨酯建筑墙体",
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080104031100000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*专用聚氨酯建筑墙体",
                                                "children": []
                                            },
                                            {
                                                "id": "2055",
                                                "linkid": "2043",
                                                "code": "10801040312",
                                                "paCode": "108010403",
                                                "yn": "N",
                                                "title": "纤维增强低碱度水泥建筑平板",
                                                "alias": "纤维增强低碱度水泥建筑平板",
                                                "about": null,
                                                "kws": "纤维增强低碱度水泥建筑平板",
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080104031200000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*纤维增强低碱度水泥建筑平板",
                                                "children": []
                                            },
                                            {
                                                "id": "2056",
                                                "linkid": "2043",
                                                "code": "10801040313",
                                                "paCode": "108010403",
                                                "yn": "N",
                                                "title": "维纶纤维增强水泥平板",
                                                "alias": "维纶纤维增强水泥平板",
                                                "about": null,
                                                "kws": "维纶纤维增强水泥平板",
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080104031300000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*维纶纤维增强水泥平板",
                                                "children": []
                                            },
                                            {
                                                "id": "2057",
                                                "linkid": "2043",
                                                "code": "10801040314",
                                                "paCode": "108010403",
                                                "yn": "N",
                                                "title": "纤维水泥平板",
                                                "alias": "纤维水泥平板",
                                                "about": null,
                                                "kws": "纤维水泥平板",
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080104031400000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*纤维水泥平板",
                                                "children": []
                                            },
                                            {
                                                "id": "2058",
                                                "linkid": "2043",
                                                "code": "10801040399",
                                                "paCode": "108010403",
                                                "yn": "N",
                                                "title": "其他轻质隔墙条板",
                                                "alias": "其他轻质隔墙条板",
                                                "about": null,
                                                "kws": null,
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080104039900000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*其他轻质隔墙条板",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "2059",
                                        "linkid": "2037",
                                        "code": "108010404",
                                        "paCode": "1080104",
                                        "yn": "N",
                                        "title": "轻骨料，相关轻质建筑材料",
                                        "alias": "轻骨料，相关轻质建筑材料",
                                        "about": "包括天然轻骨料、人工轻骨料、轻钢龙骨",
                                        "kws": "火山天然轻骨料、水成天然轻骨料、页岩陶粒人工轻骨料、粉煤灰陶粒人工轻骨料、粘土陶粒人工轻骨料、轻钢墙体龙骨、轻钢吊顶龙骨、烤漆龙骨",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080104040000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*轻骨料，相关轻质建筑材料",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2060",
                                "linkid": "2018",
                                "code": "1080105",
                                "paCode": "10801",
                                "yn": "Y",
                                "title": "砖瓦及建筑砌块",
                                "alias": "砖瓦及建筑砌块",
                                "about": "用粘土和其他原材料生产的砖、瓦和建筑砌块",
                                "kws": null,
                                "taxName": "非金属矿物制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080105000000000000",
                                "taxCodeTitle": "非金属矿物制品",
                                "iTitle": "*非金属矿物制品*砖瓦及建筑砌块",
                                "children": [
                                    {
                                        "id": "2061",
                                        "linkid": "2060",
                                        "code": "108010501",
                                        "paCode": "1080105",
                                        "yn": "Y",
                                        "title": "砖",
                                        "alias": "砖",
                                        "about": "包括烧结粘土砖、蒸压砖、蒸养砖、碳化灰砂砖、免烧砖和其他转",
                                        "kws": null,
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1080105010000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*砖",
                                        "children": [
                                            {
                                                "id": "2062",
                                                "linkid": "2061",
                                                "code": "10801050101",
                                                "paCode": "108010501",
                                                "yn": "N",
                                                "title": "烧结普通砖",
                                                "alias": "烧结普通砖",
                                                "about": "指实心粘土砖",
                                                "kws": "烧结普通砖",
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080105010100000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*烧结普通砖",
                                                "children": []
                                            },
                                            {
                                                "id": "2063",
                                                "linkid": "2061",
                                                "code": "10801050102",
                                                "paCode": "108010501",
                                                "yn": "N",
                                                "title": "非粘土烧结多孔砖",
                                                "alias": "非粘土烧结多孔砖",
                                                "about": "利用页岩、煤矸石、粉煤灰、淤泥、硅藻土等非粘土材料为主要原料烧结的多孔砖",
                                                "kws": "非粘土烧结多孔砖",
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080105010200000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*非粘土烧结多孔砖",
                                                "children": []
                                            },
                                            {
                                                "id": "2064",
                                                "linkid": "2061",
                                                "code": "10801050103",
                                                "paCode": "108010501",
                                                "yn": "N",
                                                "title": "非粘土烧结空心砖",
                                                "alias": "非粘土烧结空心砖",
                                                "about": "利用页岩、煤矸石、粉煤灰、淤泥、硅藻土等非粘土材料为主要原料烧结的空心砖",
                                                "kws": "非粘土烧结空心砖",
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080105010300000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*非粘土烧结空心砖",
                                                "children": []
                                            },
                                            {
                                                "id": "2065",
                                                "linkid": "2061",
                                                "code": "10801050104",
                                                "paCode": "108010501",
                                                "yn": "N",
                                                "title": "烧结空心砌块",
                                                "alias": "烧结空心砌块",
                                                "about": "指以粘土、页岩、煤矸石为主要原料，经焙烧而成的主要用于非承重部位的空心砌块。",
                                                "kws": "烧结空心砌块",
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080105010400000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*烧结空心砌块",
                                                "children": []
                                            },
                                            {
                                                "id": "2066",
                                                "linkid": "2061",
                                                "code": "10801050105",
                                                "paCode": "108010501",
                                                "yn": "N",
                                                "title": "烧结多孔砌块",
                                                "alias": "烧结多孔砌块",
                                                "about": "指以粘土、页岩、煤矸石为主要原料，经焙烧而成的主要用于承重部位的多孔砌块",
                                                "kws": "烧结多孔砌块",
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080105010500000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*烧结多孔砌块",
                                                "children": []
                                            },
                                            {
                                                "id": "2067",
                                                "linkid": "2061",
                                                "code": "10801050106",
                                                "paCode": "108010501",
                                                "yn": "N",
                                                "title": "承重混凝土多孔砖",
                                                "alias": "承重混凝土多孔砖",
                                                "about": "指以水泥、砂、石为主要原料，经配料、搅拌、成型、养护制成，用于承重结构的多排孔混凝土砖",
                                                "kws": "承重混凝土多孔砖",
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080105010600000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*承重混凝土多孔砖",
                                                "children": []
                                            },
                                            {
                                                "id": "2068",
                                                "linkid": "2061",
                                                "code": "10801050107",
                                                "paCode": "108010501",
                                                "yn": "N",
                                                "title": "非承重混凝土空心砖",
                                                "alias": "非承重混凝土空心砖",
                                                "about": "指以水泥、集料为主要原材料，可掺入外加剂及其他材料经配料、搅拌、成型、养护制成的空心率不小于25%，用于非承重结构部位的砖",
                                                "kws": "非承重混凝土空心砖",
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080105010700000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*非承重混凝土空心砖",
                                                "children": []
                                            },
                                            {
                                                "id": "2069",
                                                "linkid": "2061",
                                                "code": "10801050108",
                                                "paCode": "108010501",
                                                "yn": "N",
                                                "title": "蒸压粉煤灰多孔砖",
                                                "alias": "蒸压粉煤灰多孔砖",
                                                "about": "指采用粉煤灰、磨细石灰、石膏与泡沫剂拌合成型，经蒸压养护而成的一种轻质多孔墙体材料",
                                                "kws": "蒸压粉煤灰多孔砖",
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080105010800000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*蒸压粉煤灰多孔砖",
                                                "children": []
                                            },
                                            {
                                                "id": "2070",
                                                "linkid": "2061",
                                                "code": "10801050109",
                                                "paCode": "108010501",
                                                "yn": "N",
                                                "title": "蒸压泡沫混凝土砖",
                                                "alias": "蒸压泡沫混凝土砖",
                                                "about": "指采用发泡剂通过机械制备泡沫，将优质不易破裂的泡沫强制加入到水泥基胶凝材料、集料、掺合料、外加剂和水拌合的混合料内，形成具有微气泡结构的轻质料浆，经浇注成型后再进行蒸压反应等工序而制作成的微孔硅酸盐制品。",
                                                "kws": "蒸压泡沫混凝土砖",
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080105010900000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*蒸压泡沫混凝土砖",
                                                "children": []
                                            },
                                            {
                                                "id": "2071",
                                                "linkid": "2061",
                                                "code": "10801050110",
                                                "paCode": "108010501",
                                                "yn": "N",
                                                "title": "烧结多孔砖",
                                                "alias": "烧结多孔砖",
                                                "about": "烧结多孔砖是指以粘土、页岩、煤矸石为主要原料，经焙烧而成的主要用于承重部位的多孔砖。",
                                                "kws": "烧结多孔砖",
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080105011000000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*烧结多孔砖",
                                                "children": []
                                            },
                                            {
                                                "id": "2072",
                                                "linkid": "2061",
                                                "code": "10801050111",
                                                "paCode": "108010501",
                                                "yn": "N",
                                                "title": "烧结空心砖",
                                                "alias": "烧结空心砖",
                                                "about": "烧结空心砖是指以粘土、页岩、煤矸石为主要原料，经焙烧而成的主要用于非承重部位的空心砖",
                                                "kws": "烧结空心砖",
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080105011100000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*烧结空心砖",
                                                "children": []
                                            },
                                            {
                                                "id": "2073",
                                                "linkid": "2061",
                                                "code": "10801050112",
                                                "paCode": "108010501",
                                                "yn": "N",
                                                "title": "其他混凝土砖",
                                                "alias": "其他混凝土砖",
                                                "about": null,
                                                "kws": null,
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080105011200000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*其他混凝土砖",
                                                "children": []
                                            },
                                            {
                                                "id": "2074",
                                                "linkid": "2061",
                                                "code": "10801050199",
                                                "paCode": "108010501",
                                                "yn": "N",
                                                "title": "其他砖",
                                                "alias": "其他砖",
                                                "about": null,
                                                "kws": null,
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080105019900000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*其他砖",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "2075",
                                        "linkid": "2060",
                                        "code": "108010502",
                                        "paCode": "1080105",
                                        "yn": "N",
                                        "title": "瓦",
                                        "alias": "瓦",
                                        "about": "以粘土、页岩和煤矸石、粉煤灰等工业废弃物为原料，通过焙烧或蒸压方法制成的建筑用瓦",
                                        "kws": "烧结粘土平瓦、烧结粘土小青瓦、烧结粘土脊瓦、烧结J形瓦、烧结S形瓦、蒸压炉渣瓦、蒸压矿渣瓦、蒸压粉煤灰瓦",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080105020000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*瓦",
                                        "children": []
                                    },
                                    {
                                        "id": "2076",
                                        "linkid": "2060",
                                        "code": "108010503",
                                        "paCode": "1080105",
                                        "yn": "Y",
                                        "title": "建筑砌块",
                                        "alias": "建筑砌块",
                                        "about": "用于砌筑墙体的砌块，尺寸大于砖，包括建筑墙体用混凝土砌块、水工市政用混凝土砌块、蒸压硅酸盐制品块材、石膏砌块等",
                                        "kws": null,
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1080105030000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*建筑砌块",
                                        "children": [
                                            {
                                                "id": "2077",
                                                "linkid": "2076",
                                                "code": "10801050301",
                                                "paCode": "108010503",
                                                "yn": "N",
                                                "title": "普通混凝土小型空心砌块",
                                                "alias": "普通混凝土小型空心砌块",
                                                "about": "用水泥作胶结材料，砂、石作集料，经搅拌、振动（或压制）成型、养护等工艺过程制成",
                                                "kws": "普通混凝土小型空心砌块",
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080105030100000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*普通混凝土小型空心砌块",
                                                "children": []
                                            },
                                            {
                                                "id": "2078",
                                                "linkid": "2076",
                                                "code": "10801050302",
                                                "paCode": "108010503",
                                                "yn": "N",
                                                "title": "轻集料混凝土小型空心砌块",
                                                "alias": "轻集料混凝土小型空心砌块",
                                                "about": "以水泥为胶结料，以各种轻集料为填充材料，经计量、搅拌、成型、养护等工艺制成的新型墙体材料",
                                                "kws": "轻集料混凝土小型空心砌块",
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080105030200000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*轻集料混凝土小型空心砌块",
                                                "children": []
                                            },
                                            {
                                                "id": "2079",
                                                "linkid": "2076",
                                                "code": "10801050303",
                                                "paCode": "108010503",
                                                "yn": "N",
                                                "title": "烧结保温砖（砌块）",
                                                "alias": "烧结保温砖（砌块）",
                                                "about": null,
                                                "kws": "烧结保温砖、烧结保温砌块",
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080105030300000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*烧结保温砖（砌块）",
                                                "children": []
                                            },
                                            {
                                                "id": "2080",
                                                "linkid": "2076",
                                                "code": "10801050304",
                                                "paCode": "108010503",
                                                "yn": "N",
                                                "title": "蒸压加气混凝土砌块",
                                                "alias": "蒸压加气混凝土砌块",
                                                "about": "指以水泥、石灰、砂或粉煤灰等胶凝材料为主要原材料，经计量、搅拌、发泡、切割、蒸压养护等工艺制成的一种多孔新型墙体材料。",
                                                "kws": "蒸压加气混凝土砌块",
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080105030400000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*蒸压加气混凝土砌块",
                                                "children": []
                                            },
                                            {
                                                "id": "2081",
                                                "linkid": "2076",
                                                "code": "10801050305",
                                                "paCode": "108010503",
                                                "yn": "N",
                                                "title": "石膏砌块",
                                                "alias": "石膏砌块",
                                                "about": "以石膏为主要原料，经加水搅拌、浇注成型和干燥等制成的轻质石膏制品，包括脱硫石膏。",
                                                "kws": "石膏砌块、脱硫石膏",
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080105030500000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*石膏砌块",
                                                "children": []
                                            },
                                            {
                                                "id": "2082",
                                                "linkid": "2076",
                                                "code": "10801050306",
                                                "paCode": "108010503",
                                                "yn": "N",
                                                "title": "粉煤灰混凝土小型空心砌块",
                                                "alias": "粉煤灰混凝土小型空心砌块",
                                                "about": "以粉煤灰、水泥、各种轻重集料、水为主要组分拌合制成的小型空心砌块",
                                                "kws": "粉煤灰混凝土小型空心砌块",
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080105030600000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*粉煤灰混凝土小型空心砌块",
                                                "children": []
                                            },
                                            {
                                                "id": "2083",
                                                "linkid": "2076",
                                                "code": "10801050307",
                                                "paCode": "108010503",
                                                "yn": "N",
                                                "title": "复合保温砖（砌块）",
                                                "alias": "复合保温砖（砌块）",
                                                "about": null,
                                                "kws": "复合保温砖、复合保温砌块",
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080105030700000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*复合保温砖（砌块）",
                                                "children": []
                                            },
                                            {
                                                "id": "2084",
                                                "linkid": "2076",
                                                "code": "10801050308",
                                                "paCode": "108010503",
                                                "yn": "N",
                                                "title": "蒸压泡沫混凝土砌块",
                                                "alias": "蒸压泡沫混凝土砌块",
                                                "about": "指将化学发泡剂或物理发泡剂发泡后加入到胶凝材料、掺合料、改性剂、卤水等制成的料浆中，经混合搅拌、浇注成型、自然养护所形成的一种含有大量封闭气孔的新型轻质保温材料。",
                                                "kws": "蒸压泡沫混凝土砌块",
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080105030800000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*蒸压泡沫混凝土砌块",
                                                "children": []
                                            },
                                            {
                                                "id": "2085",
                                                "linkid": "2076",
                                                "code": "10801050399",
                                                "paCode": "108010503",
                                                "yn": "N",
                                                "title": "其他建筑砌块",
                                                "alias": "其他建筑砌块",
                                                "about": null,
                                                "kws": null,
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080105039900000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*其他建筑砌块",
                                                "children": []
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "id": "2086",
                                "linkid": "2018",
                                "code": "1080106",
                                "paCode": "10801",
                                "yn": "Y",
                                "title": "建筑陶瓷制品",
                                "alias": "建筑陶瓷制品",
                                "about": null,
                                "kws": null,
                                "taxName": "非金属矿物制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080106000000000000",
                                "taxCodeTitle": "非金属矿物制品",
                                "iTitle": "*非金属矿物制品*建筑陶瓷制品",
                                "children": [
                                    {
                                        "id": "2087",
                                        "linkid": "2086",
                                        "code": "108010601",
                                        "paCode": "1080106",
                                        "yn": "N",
                                        "title": "陶瓷砖",
                                        "alias": "陶瓷砖",
                                        "about": "包括瓷质砖、炻瓷砖、细炻砖、炻质砖、陶质砖、陶瓷耐酸砖",
                                        "kws": "无釉瓷质砖、有釉瓷质砖、无釉炻瓷砖、有釉炻瓷砖、无釉细炻砖、有釉细炻砖、无釉炻质砖、有釉炻质砖、釉陶质砖、有釉陶质砖、陶瓷耐酸砖、高强致密耐酸砖、耐温耐酸砖、耐酸陶瓷砖板、复合耐酸砖",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080106010000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*陶瓷砖",
                                        "children": []
                                    },
                                    {
                                        "id": "2088",
                                        "linkid": "2086",
                                        "code": "108010602",
                                        "paCode": "1080106",
                                        "yn": "N",
                                        "title": "陶瓷马赛克",
                                        "alias": "陶瓷马赛克",
                                        "about": "包括无釉陶瓷锦砖、有釉陶瓷锦砖、纳米抗菌陶瓷锦砖、微晶玻璃陶瓷复合砖",
                                        "kws": "无釉陶瓷锦砖、有釉陶瓷锦砖、纳米抗菌陶瓷锦砖、微晶玻璃陶瓷复合砖",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080106020000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*陶瓷马赛克",
                                        "children": []
                                    },
                                    {
                                        "id": "2089",
                                        "linkid": "2086",
                                        "code": "108010603",
                                        "paCode": "1080106",
                                        "yn": "N",
                                        "title": "建筑陶瓷装饰物",
                                        "alias": "建筑陶瓷装饰物",
                                        "about": "房屋、墙壁、大门等上用的建筑陶瓷装饰物",
                                        "kws": "建筑琉璃制品、琉璃砖、琉璃瓦、琉璃屋脊、琉璃装饰花窗、非琉璃制建筑陶瓷装饰物",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080106030000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*建筑陶瓷装饰物",
                                        "children": []
                                    },
                                    {
                                        "id": "2090",
                                        "linkid": "2086",
                                        "code": "108010699",
                                        "paCode": "1080106",
                                        "yn": "N",
                                        "title": "其他建筑陶瓷制品",
                                        "alias": "其他建筑陶瓷制品",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080106990000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*其他建筑陶瓷制品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2091",
                                "linkid": "2018",
                                "code": "1080107",
                                "paCode": "10801",
                                "yn": "Y",
                                "title": "石材、石料加工品及制品",
                                "alias": "石材、石料加工品及制品",
                                "about": null,
                                "kws": null,
                                "taxName": "非金属矿物制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080107000000000000",
                                "taxCodeTitle": "非金属矿物制品",
                                "iTitle": "*非金属矿物制品*石材、石料加工品及制品",
                                "children": [
                                    {
                                        "id": "2092",
                                        "linkid": "2091",
                                        "code": "108010701",
                                        "paCode": "1080107",
                                        "yn": "N",
                                        "title": "加工天然石材、石料",
                                        "alias": "加工天然石材、石料",
                                        "about": "指除经劈、锯、粗切成块、片、板状（石面为方形或长方形）以外，还须经过进一步加工的石料、石块、石板或石片",
                                        "kws": "天然大理石建筑板材、天然花岗石建筑板材、天然板石、天然异型装饰石材、花岗岩铺路石、路边石、砂岩铺路石、板岩铺路石",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080107010000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*加工天然石材、石料",
                                        "children": []
                                    },
                                    {
                                        "id": "2093",
                                        "linkid": "2091",
                                        "code": "108010702",
                                        "paCode": "1080107",
                                        "yn": "N",
                                        "title": "人造石材、石料",
                                        "alias": "人造石材、石料",
                                        "about": "以不饱和聚酯树脂为粘结剂，配以天然大理石或方解石、白云石、硅砂、玻璃粉等无机物粉料，以及适量的阻燃剂、颜料等，经配料混合、瓷铸、振动压缩、挤压等方法成型固化制成",
                                        "kws": "人造石材、石料、人造石方料、人造石板材、有机树脂人造大理石装饰板、人造花岗岩装饰板、人造花岗岩免烧瓷板、复合式人造花岗岩装饰板材、人造石制异型装饰石材",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080107020000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*人造石材、石料",
                                        "children": []
                                    },
                                    {
                                        "id": "2094",
                                        "linkid": "2091",
                                        "code": "108010703",
                                        "paCode": "1080107",
                                        "yn": "N",
                                        "title": "天然石材制成品",
                                        "alias": "天然石材制成品",
                                        "about": "包括经加工的石砖、瓦、方块及类似品",
                                        "kws": "天然大理石砖、天然大理石瓦、天然大理石染色石粉粒、天然大理石方石、天然大理石墙石、天然大理石梯级、天然大理石梁托、天然大理石支柱、汉白玉栏杆、汉白玉门窗框架、门槛、汉白玉壁炉台、窗台、天然大理石台面板、天然花岗石砖、天然花岗石瓦、天然花岗石染色石粉粒、天然花岗石方石、天然花岗石墙石、天然花岗石梯级、天然花岗石梁托和支柱、天然花岗石炉台、天然花岗石窗台、天然板岩建筑瓦、天然板岩瓦板石、天然板岩地面板石、天然板岩墙面板石、天然板岩蘑菇石、天然大理石碑石、天然花岗岩碑石",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080107030000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*天然石材制成品",
                                        "children": []
                                    },
                                    {
                                        "id": "2095",
                                        "linkid": "2091",
                                        "code": "108010704",
                                        "paCode": "1080107",
                                        "yn": "N",
                                        "title": "人造石材制成品",
                                        "alias": "人造石材制成品",
                                        "about": null,
                                        "kws": "仿大理石制成品、仿大理石砖、聚酯型人造大理石台面、人造大理石制壁炉台、人造大理石制窗台、人造大理石制台阶、人造大理石浴缸、人造大理石洗涤槽、人造大理石抽水马桶、人造大理石便池、人造花岗岩免烧瓷砖、人造花岗岩制壁炉台、人造花岗岩制窗台、人造花岗岩制台阶、人造石碑石、人造石制界石、人造石制墓碑、人造石制镶边石、蜡石制成品、蜡石砖、蜡石粉粒、石材复合板",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080107040000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*人造石材制成品",
                                        "children": []
                                    },
                                    {
                                        "id": "2096",
                                        "linkid": "2091",
                                        "code": "108010705",
                                        "paCode": "1080107",
                                        "yn": "N",
                                        "title": "水磨石建筑制成品",
                                        "alias": "水磨石建筑制成品",
                                        "about": "以水泥、石渣和砂为主要原材料，经搅拌、振动或压制成型、养护、研磨等工序制作而成的建筑水磨石板材",
                                        "kws": "水磨石地板砖、水磨石装饰板、水磨石柱面",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080107050000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*水磨石建筑制成品",
                                        "children": []
                                    },
                                    {
                                        "id": "2097",
                                        "linkid": "2091",
                                        "code": "108010706",
                                        "paCode": "1080107",
                                        "yn": "N",
                                        "title": "PVC石英砂地板砖",
                                        "alias": "PVC石英砂地板砖",
                                        "about": null,
                                        "kws": "PVC石英砂地板砖",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080107060000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*PVC石英砂地板砖",
                                        "children": []
                                    },
                                    {
                                        "id": "2098",
                                        "linkid": "2091",
                                        "code": "108010799",
                                        "paCode": "1080107",
                                        "yn": "N",
                                        "title": "其他石制品",
                                        "alias": "其他石制品",
                                        "about": null,
                                        "kws": "大理石日用制品、花岗岩日用制品、石灰石日用制品、板石日用制品",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080107990000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*其他石制品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2099",
                                "linkid": "2018",
                                "code": "1080108",
                                "paCode": "10801",
                                "yn": "Y",
                                "title": "建筑防水卷材及制品",
                                "alias": "建筑防水卷材及制品",
                                "about": null,
                                "kws": null,
                                "taxName": "非金属矿物制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080108000000000000",
                                "taxCodeTitle": "非金属矿物制品",
                                "iTitle": "*非金属矿物制品*建筑防水卷材及制品",
                                "children": [
                                    {
                                        "id": "2100",
                                        "linkid": "2099",
                                        "code": "108010801",
                                        "paCode": "1080108",
                                        "yn": "N",
                                        "title": "沥青和改性沥青防水卷材",
                                        "alias": "沥青和改性沥青防水卷材",
                                        "about": "包括石油沥青防水卷材、改性沥青防水卷材、其他沥青防水卷材",
                                        "kws": "石油沥青纸胎油毡、石油沥青油纸、石油沥青玻璃纤维胎油毡、石油沥青玻璃布胎油毡、塑性体改性沥青防水卷材、弹性体改性沥青防水卷材、再生胶改性沥青防水卷材、改性沥青聚乙烯胎防水卷材、沥青复合胎柔性防水卷材、铝箔面油毡",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080108010000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*沥青和改性沥青防水卷材",
                                        "children": []
                                    },
                                    {
                                        "id": "2101",
                                        "linkid": "2099",
                                        "code": "108010802",
                                        "paCode": "1080108",
                                        "yn": "N",
                                        "title": "自粘防水卷材",
                                        "alias": "自粘防水卷材",
                                        "about": "包括自粘橡胶沥青防水卷材、自粘聚合物改性沥青聚酯胎防水卷材",
                                        "kws": "自粘橡胶沥青防水卷材、自粘聚合物改性沥青聚酯胎防水卷材",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080108020000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*自粘防水卷材",
                                        "children": []
                                    },
                                    {
                                        "id": "2102",
                                        "linkid": "2099",
                                        "code": "108010803",
                                        "paCode": "1080108",
                                        "yn": "N",
                                        "title": "玻纤胎沥青瓦",
                                        "alias": "玻纤胎沥青瓦",
                                        "about": "以石油沥青为主要原料，加入矿物填料，采用玻纤毡为胎基、上表面覆以保护材料，用于铺设搭接法施工的坡屋面的沥青瓦",
                                        "kws": "玻纤胎沥青瓦",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080108030000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*玻纤胎沥青瓦",
                                        "children": []
                                    },
                                    {
                                        "id": "2103",
                                        "linkid": "2099",
                                        "code": "108010804",
                                        "paCode": "1080108",
                                        "yn": "N",
                                        "title": "高分子防水卷（片）材",
                                        "alias": "高分子防水卷（片）材",
                                        "about": "包括橡胶防水卷（片）材、合成树脂类防水卷（片）材",
                                        "kws": "三元乙丙橡胶防水卷材、氯磺化聚乙烯防水卷材、氯丁橡胶防水卷材、丁基橡胶防水卷材、再生胶防水卷材、氯化聚乙烯防水卷材、氯化聚乙烯-橡胶共混防水卷材、三元丁橡胶防水卷材、聚氯乙烯防水卷材、高密度聚乙烯防水卷材、低密度聚乙烯防水卷材、乙烯-乙酸乙烯防水卷材、乙烯醋酸乙烯改性沥青共混卷材、聚乙烯丙纶防水卷材、热塑性聚烯烃防水卷材",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080108040000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*高分子防水卷（片）材",
                                        "children": []
                                    },
                                    {
                                        "id": "2104",
                                        "linkid": "2099",
                                        "code": "108010899",
                                        "paCode": "1080108",
                                        "yn": "N",
                                        "title": "其他建筑防水卷材及制品",
                                        "alias": "其他建筑防水卷材及制品",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080108990000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*其他建筑防水卷材及制品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2105",
                                "linkid": "2018",
                                "code": "1080109",
                                "paCode": "10801",
                                "yn": "Y",
                                "title": "隔热、隔音人造矿物材料及其制品",
                                "alias": "隔热、隔音人造矿物材料及其制品",
                                "about": null,
                                "kws": null,
                                "taxName": "非金属矿物制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080109000000000000",
                                "taxCodeTitle": "非金属矿物制品",
                                "iTitle": "*非金属矿物制品*隔热、隔音人造矿物材料及其制品",
                                "children": [
                                    {
                                        "id": "2106",
                                        "linkid": "2105",
                                        "code": "108010901",
                                        "paCode": "1080109",
                                        "yn": "N",
                                        "title": "矿物绝热和吸声材料",
                                        "alias": "矿物绝热和吸声材料",
                                        "about": "包括矿物棉、膨胀矿物材料",
                                        "kws": "矿渣棉、岩石棉、硅酸铝纤维棉、煤矸石纤维棉、高硅氧棉、膨胀蛭石、膨胀珍珠岩",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080109010000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*矿物绝热和吸声材料",
                                        "children": []
                                    },
                                    {
                                        "id": "2107",
                                        "linkid": "2105",
                                        "code": "108010902",
                                        "paCode": "1080109",
                                        "yn": "N",
                                        "title": "矿物材料制品",
                                        "alias": "矿物材料制品",
                                        "about": "主要起绝热、吸声作用",
                                        "kws": "岩矿棉板、岩矿棉管、热固性树脂棉、岩矿棉玻纤布缝毡、岩矿棉铁丝网缝毡、岩矿棉带、防水岩矿棉制品、喷涂岩矿棉制品、粒状岩矿棉、玻璃棉毡、玻璃棉板、玻璃棉管、粒状玻璃棉、微纤维玻璃棉、微纤维玻璃棉隔板、微纤维玻璃棉真空板、矿物棉装饰吸声板、矿棉贴面印花天花板、膨胀蛭石板、膨胀蛭石砖、膨胀蛭石管壳、膨胀蛭石异形砖、膨胀珍珠岩绝热制品、膨胀珍珠岩装饰吸声板、水玻璃膨胀珍珠岩制品、水泥膨胀珍珠岩制品、磷酸镁膨胀珍珠岩制品、镁质水泥膨胀珍珠岩制品、沥青膨胀珍珠岩制品、硅酸铝纤维毡、硅酸铝纤维管、硅酸铝纤维湿法板、硅酸",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080109020000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*矿物材料制品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2108",
                                "linkid": "2018",
                                "code": "1080110",
                                "paCode": "10801",
                                "yn": "Y",
                                "title": "玻璃",
                                "alias": "玻璃",
                                "about": null,
                                "kws": null,
                                "taxName": "非金属矿物制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080110000000000000",
                                "taxCodeTitle": "非金属矿物制品",
                                "iTitle": "*非金属矿物制品*玻璃",
                                "children": [
                                    {
                                        "id": "2109",
                                        "linkid": "2108",
                                        "code": "108011001",
                                        "paCode": "1080110",
                                        "yn": "N",
                                        "title": "平板玻璃",
                                        "alias": "平板玻璃",
                                        "about": "指板状硅酸盐玻璃，主要用于建筑业、车船业、电子工业、太阳能工业、制镜业、现代农业等部门，是重要的建筑材料和工业技术玻璃的基础材料",
                                        "kws": "浮法玻璃、压延玻璃、平拉玻璃",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080110010000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*平板玻璃",
                                        "children": []
                                    },
                                    {
                                        "id": "2110",
                                        "linkid": "2108",
                                        "code": "108011002",
                                        "paCode": "1080110",
                                        "yn": "Y",
                                        "title": "特种玻璃",
                                        "alias": "特种玻璃",
                                        "about": "包括石英玻璃制品、石英玻璃、光栅玻璃、微晶玻璃、U型玻璃、电子工业用超薄玻璃、太阳能工业用超白玻璃",
                                        "kws": "透明石英玻璃、不透明石英玻璃、光栅玻璃、微晶玻璃、电子工业用超薄玻璃、太阳能工业用超白玻璃、光纤生产用石英棒、光纤生产用石英管、光纤生产用石英半导体、太阳能用石英材料、太阳能用石英半导体、太阳能用石英坩埚、合成石英玻璃制品、石英纤维、石英纤维制品",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1080110020000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*特种玻璃",
                                        "children": [
                                            {
                                                "id": "2111",
                                                "linkid": "2110",
                                                "code": "10801100201",
                                                "paCode": "108011002",
                                                "yn": "N",
                                                "title": "微晶玻璃",
                                                "alias": "微晶玻璃",
                                                "about": "由适当组成的玻璃颗粒经烧结和晶化，制成由结晶相和玻璃相组成的质地坚实、致密均匀的复相材料",
                                                "kws": "微晶玻璃",
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080110020100000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*微晶玻璃",
                                                "children": []
                                            },
                                            {
                                                "id": "2112",
                                                "linkid": "2110",
                                                "code": "10801100202",
                                                "paCode": "108011002",
                                                "yn": "N",
                                                "title": "U型玻璃",
                                                "alias": "U型玻璃",
                                                "about": "是用先压延后成型的方法连续生产出来的，横截面呈U型的玻璃，适用于建筑的内外墙、隔墙、屋面及窗等",
                                                "kws": "U型玻璃",
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080110020200000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*U型玻璃",
                                                "children": []
                                            },
                                            {
                                                "id": "2113",
                                                "linkid": "2110",
                                                "code": "10801100299",
                                                "paCode": "108011002",
                                                "yn": "N",
                                                "title": "其他特种玻璃",
                                                "alias": "其他特种玻璃",
                                                "about": null,
                                                "kws": null,
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080110029900000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*其他特种玻璃",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "2114",
                                        "linkid": "2108",
                                        "code": "108011003",
                                        "paCode": "1080110",
                                        "yn": "N",
                                        "title": "玻璃陶瓷型材",
                                        "alias": "玻璃陶瓷型材",
                                        "about": "指将回收的各种有色或无色透明平板、瓶罐废玻璃与废陶瓷筛选后加工而成的新型装饰材料",
                                        "kws": "玻璃陶瓷板材、玻璃陶瓷片",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080110030000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*玻璃陶瓷型材",
                                        "children": []
                                    },
                                    {
                                        "id": "2115",
                                        "linkid": "2108",
                                        "code": "108011004",
                                        "paCode": "1080110",
                                        "yn": "N",
                                        "title": "玻璃熟料",
                                        "alias": "玻璃熟料",
                                        "about": "对成份差别大的碎玻璃统一加工制成的一种硅质原料",
                                        "kws": "玻璃熟料",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080110040000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*玻璃熟料",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2116",
                                "linkid": "2018",
                                "code": "1080111",
                                "paCode": "10801",
                                "yn": "Y",
                                "title": "玻璃制光学元件",
                                "alias": "玻璃制光学元件",
                                "about": null,
                                "kws": null,
                                "taxName": "非金属矿物制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080111000000000000",
                                "taxCodeTitle": "非金属矿物制品",
                                "iTitle": "*非金属矿物制品*玻璃制光学元件",
                                "children": [
                                    {
                                        "id": "2117",
                                        "linkid": "2116",
                                        "code": "108011101",
                                        "paCode": "1080111",
                                        "yn": "N",
                                        "title": "光学元件毛坯",
                                        "alias": "光学元件毛坯",
                                        "about": "指光学仪器用未经光学加工的光学元件毛坯",
                                        "kws": "光学元件毛坯型料、光电镜片毛坯、光学玻璃二次压型毛坯",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080111010000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*光学元件毛坯",
                                        "children": []
                                    },
                                    {
                                        "id": "2118",
                                        "linkid": "2116",
                                        "code": "108011102",
                                        "paCode": "1080111",
                                        "yn": "N",
                                        "title": "眼镜用光学玻璃坯件",
                                        "alias": "眼镜用光学玻璃坯件",
                                        "about": "包括视力矫正眼镜用玻璃、平光变色镜片坯件",
                                        "kws": "矫正视力眼镜用镜片坯件、矫正视力变色眼镜用镜片坯件、平光变色镜片坯件",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080111020000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*眼镜用光学玻璃坯件",
                                        "children": []
                                    },
                                    {
                                        "id": "2119",
                                        "linkid": "2116",
                                        "code": "108011103",
                                        "paCode": "1080111",
                                        "yn": "N",
                                        "title": "光学仪器用玻璃",
                                        "alias": "光学仪器用玻璃",
                                        "about": "使用于光学仪器上的玻璃",
                                        "kws": "显微镜玻璃、放大镜玻璃、望远镜玻璃、照相机镜头玻璃",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080111030000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*光学仪器用玻璃",
                                        "children": []
                                    },
                                    {
                                        "id": "2120",
                                        "linkid": "2116",
                                        "code": "108011199",
                                        "paCode": "1080111",
                                        "yn": "N",
                                        "title": "其他玻璃制光学元件",
                                        "alias": "其他玻璃制光学元件",
                                        "about": "指在制作中虽未经光学加工，但能产生某种所需的光学效果的元件，包括交通路灯、某种浮标灯、聚光灯泡、小手电、手电筒、配电盘灯或仪表板灯等的透镜及类似品",
                                        "kws": null,
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080111990000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*其他玻璃制光学元件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2121",
                                "linkid": "2018",
                                "code": "1080112",
                                "paCode": "10801",
                                "yn": "Y",
                                "title": "玻璃仪器及实验、医疗用玻璃器皿",
                                "alias": "玻璃仪器及实验、医疗用玻璃器皿",
                                "about": null,
                                "kws": null,
                                "taxName": "非金属矿物制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080112000000000000",
                                "taxCodeTitle": "非金属矿物制品",
                                "iTitle": "*非金属矿物制品*玻璃仪器及实验、医疗用玻璃器皿",
                                "children": [
                                    {
                                        "id": "2122",
                                        "linkid": "2121",
                                        "code": "108011201",
                                        "paCode": "1080112",
                                        "yn": "N",
                                        "title": "玻璃计、量器",
                                        "alias": "玻璃计、量器",
                                        "about": "指除石英玻璃制仪器和器皿（详见108011202）以外的计量用玻璃器具、仪器",
                                        "kws": "玻璃量筒、玻璃量杯、玻璃滴定管、玻璃吸量管、玻璃温度计",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080112010000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*玻璃计、量器",
                                        "children": []
                                    },
                                    {
                                        "id": "2123",
                                        "linkid": "2121",
                                        "code": "108011202",
                                        "paCode": "1080112",
                                        "yn": "N",
                                        "title": "石英玻璃制仪器和器皿",
                                        "alias": "石英玻璃制仪器和器皿",
                                        "about": "指二氧化硅含量应≥95%的玻璃仪器和器皿，包括熔融石英或其他熔融硅石制实验室、卫生及配药用的玻璃器皿",
                                        "kws": "石英玻璃器皿坩埚、石英玻璃烧瓶、石英玻璃烧杯、石英玻璃蒸发皿、液位计用透明石英玻璃管",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080112020000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*石英玻璃制仪器和器皿",
                                        "children": []
                                    },
                                    {
                                        "id": "2124",
                                        "linkid": "2121",
                                        "code": "108011203",
                                        "paCode": "1080112",
                                        "yn": "N",
                                        "title": "耐热玻璃制仪器和器皿",
                                        "alias": "耐热玻璃制仪器和器皿",
                                        "about": "指温度在0℃～300℃时，线膨胀系数不超过5*10-6/K的实验室、卫生及配药用玻璃仪器和器皿，但不包括石英玻璃制仪器和器皿（详见108011202）。",
                                        "kws": "玻璃烧器类器皿、玻璃蒸馏类器皿、玻璃蒸发类器皿",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080112030000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*耐热玻璃制仪器和器皿",
                                        "children": []
                                    },
                                    {
                                        "id": "2125",
                                        "linkid": "2121",
                                        "code": "108011299",
                                        "paCode": "1080112",
                                        "yn": "N",
                                        "title": "其他玻璃仪器及实验、医疗用玻璃器皿",
                                        "alias": "其他玻璃仪器及实验、医疗用玻璃器皿",
                                        "about": "包括实验室、医疗及配药用的玻璃制专用真空器皿、干燥器、容量瓶、培养皿、显微镜载片和盖片，玻璃制喷射嘴、漏斗、磨砂接头，玻璃制盛尿器、便盆、便壶，玻璃制吸杯、洗眼杯、吸入器、吸管、试管等仪器和器皿",
                                        "kws": null,
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080112990000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*其他玻璃仪器及实验、医疗用玻璃器皿",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2126",
                                "linkid": "2018",
                                "code": "1080113",
                                "paCode": "10801",
                                "yn": "N",
                                "title": "玻璃包装容器",
                                "alias": "玻璃包装容器",
                                "about": "包括日用玻璃瓶（玻璃饮料瓶、玻璃食品瓶、玻璃啤酒瓶、玻璃白酒容器）、药用瓶（医药试剂用广口瓶、输液瓶、安瓿瓶、黄圆瓶、无色小药瓶、抗生素瓶、口服液瓶、农药用瓶）、其他玻璃瓶",
                                "kws": "玻璃饮料瓶、玻璃食品瓶、玻璃啤酒瓶、玻璃白酒容器、玻璃输液瓶、玻璃制安瓿",
                                "taxName": "非金属矿物制品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1080113000000000000",
                                "taxCodeTitle": "非金属矿物制品",
                                "iTitle": "*非金属矿物制品*玻璃包装容器",
                                "children": []
                            },
                            {
                                "id": "2127",
                                "linkid": "2018",
                                "code": "1080114",
                                "paCode": "10801",
                                "yn": "Y",
                                "title": "日用玻璃制品",
                                "alias": "日用玻璃制品",
                                "about": "指供餐桌、厨房、盥洗室、办公室、室内装饰等用途的玻璃制品",
                                "kws": null,
                                "taxName": "非金属矿物制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080114000000000000",
                                "taxCodeTitle": "非金属矿物制品",
                                "iTitle": "*非金属矿物制品*日用玻璃制品",
                                "children": [
                                    {
                                        "id": "2128",
                                        "linkid": "2127",
                                        "code": "108011401",
                                        "paCode": "1080114",
                                        "yn": "N",
                                        "title": "餐饮用玻璃器皿",
                                        "alias": "餐饮用玻璃器皿",
                                        "about": "包括餐饮用玻璃杯和餐饮用其他玻璃器皿，不包括非餐饮用的其他玻璃器皿或器具（如盥洗用玻璃器具（详见108011402）、办公室及室内装饰用玻璃器具（详见108011403）等）。",
                                        "kws": "餐饮用玻璃杯、餐饮用玻璃器皿",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080114010000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*餐饮用玻璃器皿",
                                        "children": []
                                    },
                                    {
                                        "id": "2129",
                                        "linkid": "2127",
                                        "code": "108011402",
                                        "paCode": "1080114",
                                        "yn": "N",
                                        "title": "盥洗用玻璃器具",
                                        "alias": "盥洗用玻璃器具",
                                        "about": "包括玻璃洗手盆，不包括餐饮用玻璃器皿（详见108011401）。",
                                        "kws": "盥洗用铅晶质玻璃器具",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080114020000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*盥洗用玻璃器具",
                                        "children": []
                                    },
                                    {
                                        "id": "2130",
                                        "linkid": "2127",
                                        "code": "108011403",
                                        "paCode": "1080114",
                                        "yn": "N",
                                        "title": "室内及室内装饰用玻璃器具",
                                        "alias": "室内及室内装饰用玻璃器具",
                                        "about": "包括玻璃制镇纸、墨水台和墨水池、书档、装大头针的容器、笔架、烟灰缸、玻璃花瓶、装饰性水果盘、小塑像、小精品（动物、花、叶、果等）、玻璃艺术品、水晶玻璃制品、琉璃制品、衣饰配件、水钻等装饰玻璃制品，桌面中心、养鱼缸、香炉等以及玻璃风景画、玻璃纪念品等",
                                        "kws": "室内用铅晶质玻璃器具、室内装饰用铅晶质玻璃器具、玻璃珠仿珍珠玻璃、仿宝石玻璃、玻璃眼、玻璃塑像、玻璃装饰品",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080114030000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*室内及室内装饰用玻璃器具",
                                        "children": []
                                    },
                                    {
                                        "id": "2131",
                                        "linkid": "2127",
                                        "code": "108011499",
                                        "paCode": "1080114",
                                        "yn": "N",
                                        "title": "其他日用玻璃制品",
                                        "alias": "其他日用玻璃制品",
                                        "about": "不包括钟表（详见1090618）、灯泡（详见1090423）、仪器仪表（详见10906）等产品的玻璃制零配件",
                                        "kws": null,
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080114990000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*其他日用玻璃制品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2132",
                                "linkid": "2018",
                                "code": "1080115",
                                "paCode": "10801",
                                "yn": "Y",
                                "title": "玻璃保温容器及其玻璃胆",
                                "alias": "玻璃保温容器及其玻璃胆",
                                "about": null,
                                "kws": null,
                                "taxName": "非金属矿物制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080115000000000000",
                                "taxCodeTitle": "非金属矿物制品",
                                "iTitle": "*非金属矿物制品*玻璃保温容器及其玻璃胆",
                                "children": [
                                    {
                                        "id": "2133",
                                        "linkid": "2132",
                                        "code": "108011501",
                                        "paCode": "1080115",
                                        "yn": "N",
                                        "title": "玻璃保温容器",
                                        "alias": "玻璃保温容器",
                                        "about": "指带壳、带胆的成品保温容器；不包括保温容器用的瓶胆（详见108011502）。",
                                        "kws": "玻璃保温瓶、暖水瓶、玻璃保温杯、玻璃保温盒、玻璃保温桶",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080115010000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*玻璃保温容器",
                                        "children": []
                                    },
                                    {
                                        "id": "2134",
                                        "linkid": "2132",
                                        "code": "108011502",
                                        "paCode": "1080115",
                                        "yn": "N",
                                        "title": "玻璃保温瓶胆",
                                        "alias": "玻璃保温瓶胆",
                                        "about": "指玻璃保温容器用的，不带壳的玻璃瓶胆；不包括带壳、带胆的玻璃保温容器成品（详见108011501）。",
                                        "kws": "保温瓶用玻璃胆、保温杯用玻璃胆",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080115020000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*玻璃保温瓶胆",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2135",
                                "linkid": "2018",
                                "code": "1080116",
                                "paCode": "10801",
                                "yn": "N",
                                "title": "玻璃纤维及其制品",
                                "alias": "玻璃纤维及其制品",
                                "about": "包括玻璃纤维纱、短切玻璃纤维、玻璃纤维布、玻璃纤维毡、玻璃纤维土工格栅、玻璃纤维带、玻璃纤维套管等。",
                                "kws": "无碱玻璃球、中碱玻璃球、耐碱玻璃球、特种玻璃球、无碱玻璃纤维纱、无碱玻璃纤维有捻纱、无碱玻璃纤维无捻纱、中碱玻璃纤维有捻纱、中碱玻璃纤维无捻纱、耐碱玻璃纤维有捻纱、耐碱玻璃纤维无捻纱、特种玻璃纤维有捻纱、特种玻璃纤维无捻纱、无碱玻璃纤维无捻粗纱、中碱玻璃纤维无捻粗纱、耐碱玻璃纤维无捻粗纱、无碱短切玻璃纤维、中碱短切玻璃纤维、耐碱短切玻璃纤维、无碱玻璃纤维布、无碱玻璃纤维无捻粗纱织物、无碱玻璃纤维网格布、中碱玻璃纤维有捻纱织物、中碱玻璃纤维无捻纱织物、中碱玻璃纤维无捻粗纱织物、中碱玻璃纤维网格布、特种玻璃纤",
                                "taxName": "非金属矿物制品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1080116000000000000",
                                "taxCodeTitle": "非金属矿物制品",
                                "iTitle": "*非金属矿物制品*玻璃纤维及其制品",
                                "children": []
                            },
                            {
                                "id": "2136",
                                "linkid": "2018",
                                "code": "1080117",
                                "paCode": "10801",
                                "yn": "N",
                                "title": "玻璃制绝缘子",
                                "alias": "玻璃制绝缘子",
                                "about": "包括导引式绝缘子、刚性绝缘子、其他玻璃制绝缘子",
                                "kws": "导引式绝缘子、刚性绝缘子",
                                "taxName": "非金属矿物制品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1080117000000000000",
                                "taxCodeTitle": "非金属矿物制品",
                                "iTitle": "*非金属矿物制品*玻璃制绝缘子",
                                "children": []
                            },
                            {
                                "id": "2137",
                                "linkid": "2018",
                                "code": "1080118",
                                "paCode": "10801",
                                "yn": "N",
                                "title": "未封口玻璃外壳",
                                "alias": "未封口玻璃外壳",
                                "about": "指制灯泡、阴极射线管及类似品用的未封口玻璃外壳（包括玻璃泡及管）及其玻璃零件，但未装有配件",
                                "kws": "电光源用未封口玻璃泡、电光源用未封口玻璃管、电光源用透明石英玻璃管、电光源用相关未封口玻璃管、石英玻璃阴极射线管外壳、无臭氧石英玻璃管外壳、石英玻璃电子管外壳、无臭氧石英玻璃电子管外壳、未封口玻璃外壳玻璃零件、电光源玻璃外壳玻璃零件、阴极射线管用玻璃外壳玻璃零件、电子管玻璃外壳玻璃零件",
                                "taxName": "非金属矿物制品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1080118000000000000",
                                "taxCodeTitle": "非金属矿物制品",
                                "iTitle": "*非金属矿物制品*未封口玻璃外壳",
                                "children": []
                            },
                            {
                                "id": "2138",
                                "linkid": "2018",
                                "code": "1080119",
                                "paCode": "10801",
                                "yn": "N",
                                "title": "工业品用其他玻璃部件",
                                "alias": "工业品用其他玻璃部件",
                                "about": "包括工业用玻璃制品、玻璃制工业品零配件",
                                "kws": "工业用导电玻璃、绝缘子用玻璃伞盘、玻璃制安全保护罩、玻璃制保护装置、玻璃制滑脂杯、玻璃制导线器、玻璃观测孔、液面玻璃管、TST石英玻璃弹簧、玻璃制字母、玻璃制招牌板、灯具用玻璃制零配件、照明装置玻璃制零配件、玻璃制钟罩、玻璃制表蒙、仪器仪表用玻璃制零配件、玻璃制仪器仪表罩",
                                "taxName": "非金属矿物制品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1080119000000000000",
                                "taxCodeTitle": "非金属矿物制品",
                                "iTitle": "*非金属矿物制品*工业品用其他玻璃部件",
                                "children": []
                            },
                            {
                                "id": "2139",
                                "linkid": "2018",
                                "code": "1080120",
                                "paCode": "10801",
                                "yn": "Y",
                                "title": "技术陶瓷制品",
                                "alias": "技术陶瓷制品",
                                "about": "技术陶瓷制品也称特种陶瓷，包括结构陶瓷、功能陶瓷、生物陶瓷等",
                                "kws": null,
                                "taxName": "非金属矿物制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080120000000000000",
                                "taxCodeTitle": "非金属矿物制品",
                                "iTitle": "*非金属矿物制品*技术陶瓷制品",
                                "children": [
                                    {
                                        "id": "2140",
                                        "linkid": "2139",
                                        "code": "108012001",
                                        "paCode": "1080120",
                                        "yn": "N",
                                        "title": "结构陶瓷制品",
                                        "alias": "结构陶瓷制品",
                                        "about": "包括实验室用陶瓷制品、陶瓷阀及类似品、陶瓷轴承、陶瓷辊棒、陶瓷制发动机零部件、陶瓷蒸馏器、陶瓷旋管及类似管、陶瓷研磨器和研磨球、陶瓷模头、纺织用陶瓷件耐磨陶瓷件、可控硅瓷环、瓷管、陶瓷刀具、刃具、陶瓷密封件、陶瓷金属化瓷件、其他结构陶瓷制品",
                                        "kws": "陶瓷坩埚、陶瓷过滤器、实验用陶瓷小管、陶瓷泵、陶瓷阀、陶瓷汽缸阀门片、陶瓷轴承、陶瓷辊棒、陶瓷制发动机零部件、陶瓷蒸馏器、陶瓷旋管、陶瓷研磨器、研磨球、陶瓷模头、陶瓷引线器、氧化铝纺织陶瓷件、氧化铝耐磨陶瓷件、氧化铝可控硅瓷环、瓷管、氧化锆陶瓷刀具、氮化硅陶瓷刀具、氮化硅陶瓷刃具、碳化硅陶瓷密封件、陶瓷金属化基片瓷件、陶瓷金属化基片瓷管、陶瓷金属化基片瓷棒、高技术陶瓷制品、专门技术用陶瓷制品",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080120010000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*结构陶瓷制品",
                                        "children": []
                                    },
                                    {
                                        "id": "2141",
                                        "linkid": "2139",
                                        "code": "108012002",
                                        "paCode": "1080120",
                                        "yn": "N",
                                        "title": "功能陶瓷制品",
                                        "alias": "功能陶瓷制品",
                                        "about": "指具有电、光、磁、声、热、弹性及部分化学功能的陶瓷制品",
                                        "kws": "压电陶瓷制品、陶瓷超导体、电容器陶瓷零件、碳膜电阻瓷件、金属膜电阻瓷件、片式电阻器陶瓷基片、电位器陶瓷基片、集成电路陶瓷基片、厚膜集成电路陶瓷基片、输变电线路绝缘瓷套管",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080120020000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*功能陶瓷制品",
                                        "children": []
                                    },
                                    {
                                        "id": "2142",
                                        "linkid": "2139",
                                        "code": "108012003",
                                        "paCode": "1080120",
                                        "yn": "N",
                                        "title": "生物陶瓷制品",
                                        "alias": "生物陶瓷制品",
                                        "about": "主要指医疗专用的生物陶瓷制品（如生物陶瓷制假牙、关节、骨骼等人工器官）",
                                        "kws": "陶瓷假牙制品、陶瓷人造骨骼制品",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080120030000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*生物陶瓷制品",
                                        "children": []
                                    },
                                    {
                                        "id": "2143",
                                        "linkid": "2139",
                                        "code": "108012004",
                                        "paCode": "1080120",
                                        "yn": "N",
                                        "title": "陶瓷管及管子配件",
                                        "alias": "陶瓷管及管子配件",
                                        "about": "包括陶瓷套管、导管、槽管及管子配件",
                                        "kws": "陶瓷复合管、氧化铝陶瓷管、碳化硅陶瓷管、氧化锆陶瓷管、微孔陶瓷管、陶瓷管子配件",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080120040000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*陶瓷管及管子配件",
                                        "children": []
                                    },
                                    {
                                        "id": "2144",
                                        "linkid": "2139",
                                        "code": "108012005",
                                        "paCode": "1080120",
                                        "yn": "N",
                                        "title": "瓷绝缘子",
                                        "alias": "瓷绝缘子",
                                        "about": "由电工陶瓷制成的绝缘子",
                                        "kws": "瓷绝缘子",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080120050000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*瓷绝缘子",
                                        "children": []
                                    },
                                    {
                                        "id": "2145",
                                        "linkid": "2139",
                                        "code": "108012006",
                                        "paCode": "1080120",
                                        "yn": "N",
                                        "title": "耐火陶瓷制品",
                                        "alias": "耐火陶瓷制品",
                                        "about": "包括耐火陶瓷管、耐火陶瓷坩埚、硅质耐火陶瓷制品、其他耐火陶瓷制品",
                                        "kws": "耐火陶瓷管、耐火陶瓷坩埚、硅质耐火陶瓷制品",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080120060000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*耐火陶瓷制品",
                                        "children": []
                                    },
                                    {
                                        "id": "2146",
                                        "linkid": "2139",
                                        "code": "108012099",
                                        "paCode": "1080120",
                                        "yn": "N",
                                        "title": "其他技术陶瓷制品",
                                        "alias": "其他技术陶瓷制品",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080120990000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*其他技术陶瓷制品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2147",
                                "linkid": "2018",
                                "code": "1080121",
                                "paCode": "10801",
                                "yn": "Y",
                                "title": "日用陶瓷制品",
                                "alias": "日用陶瓷制品",
                                "about": "包括日用陶瓷餐具、厨房用陶瓷器具、盥洗用陶瓷器具、卫生陶瓷制品、园林艺术陶瓷制品和其他日用陶瓷制品。",
                                "kws": null,
                                "taxName": "非金属矿物制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080121000000000000",
                                "taxCodeTitle": "非金属矿物制品",
                                "iTitle": "*非金属矿物制品*日用陶瓷制品",
                                "children": [
                                    {
                                        "id": "2148",
                                        "linkid": "2147",
                                        "code": "108012101",
                                        "paCode": "1080121",
                                        "yn": "N",
                                        "title": "日用陶瓷餐具",
                                        "alias": "日用陶瓷餐具",
                                        "about": "包括日用瓷质餐具、陶质餐具、炻质餐具，如陶瓷茶具或咖啡用具，陶瓷盘、碗、碟、杯、汤匙、家用电热壶等",
                                        "kws": "瓷质餐具、陶质餐具、炻质餐具、陶瓷茶具、陶瓷咖啡用具、陶瓷盘",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080121010000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*日用陶瓷餐具",
                                        "children": []
                                    },
                                    {
                                        "id": "2149",
                                        "linkid": "2147",
                                        "code": "108012102",
                                        "paCode": "1080121",
                                        "yn": "N",
                                        "title": "厨房用陶瓷器具",
                                        "alias": "厨房用陶瓷器具",
                                        "about": "包括瓷质厨房用器具、陶质厨房用器具、炻质厨房用器具，如陶瓷烘烤盘、盆、壶、罐、坛等",
                                        "kws": "瓷质厨房用器具、陶质厨房用器具、炻质厨房用器具、陶瓷烘烤盘",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080121020000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*厨房用陶瓷器具",
                                        "children": []
                                    },
                                    {
                                        "id": "2150",
                                        "linkid": "2147",
                                        "code": "108012103",
                                        "paCode": "1080121",
                                        "yn": "N",
                                        "title": "盥洗用陶瓷器具",
                                        "alias": "盥洗用陶瓷器具",
                                        "about": "包括瓷质盥洗用器具、陶质盥洗用器具、炻质盥洗用器具，如陶瓷卫生桶、便盆、尿壶、便壶、痰孟、肥皂碟、毛巾架等，以及类似的盥洗用陶瓷器具",
                                        "kws": "瓷质盥洗用器具、陶质盥洗用器具、炻质盥洗用器具",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080121030000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*盥洗用陶瓷器具",
                                        "children": []
                                    },
                                    {
                                        "id": "2151",
                                        "linkid": "2147",
                                        "code": "108012104",
                                        "paCode": "1080121",
                                        "yn": "N",
                                        "title": "卫生陶瓷制品",
                                        "alias": "卫生陶瓷制品",
                                        "about": "又称卫生洁具，由粘土或其他无机物质经混练、成型、高温烧制而成的用做卫生设施的有釉陶瓷制品，包括各种不同型号的大便器、小便器、洗面器、妇女洗涤器、高低水箱、洗涤槽、返水管、浴盆等；包括陶瓷、仿瓷、玻璃陶瓷、玻璃纤维增强塑料制卫生设备",
                                        "kws": "陶瓷制洗涤器、陶瓷制洗面器、陶瓷制净身器、陶瓷制洗涤槽、仿瓷制洗涤器、玻璃陶瓷制洗涤器",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080121040000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*卫生陶瓷制品",
                                        "children": []
                                    },
                                    {
                                        "id": "2152",
                                        "linkid": "2147",
                                        "code": "108012105",
                                        "paCode": "1080121",
                                        "yn": "N",
                                        "title": "园林艺术陶瓷制品",
                                        "alias": "园林艺术陶瓷制品",
                                        "about": "包括瓷质或陶质的果皮箱、花盆等，不包括陶瓷制园林桌、椅、凳（详见105020108）。",
                                        "kws": "陶瓷制果皮箱、瓷制果皮箱、陶制果皮箱、陶瓷制花盆、瓷制装饰性花盆、瓷制非装饰性花盆、陶制装饰性花盆、陶制非装饰性花盆",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080121050000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*园林艺术陶瓷制品",
                                        "children": []
                                    },
                                    {
                                        "id": "2153",
                                        "linkid": "2147",
                                        "code": "108012199",
                                        "paCode": "1080121",
                                        "yn": "N",
                                        "title": "其他日用陶瓷制品",
                                        "alias": "其他日用陶瓷制品",
                                        "about": null,
                                        "kws": "瓷质日用器具、陶质日用器具、炻质日用器具、陶瓷烟灰缸、陶瓷水瓶、陶瓷火柴盒架、陶瓷电热炉",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080121990000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*其他日用陶瓷制品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2154",
                                "linkid": "2018",
                                "code": "1080122",
                                "paCode": "10801",
                                "yn": "Y",
                                "title": "运输及盛装货物用陶瓷容器",
                                "alias": "运输及盛装货物用陶瓷容器",
                                "about": "包括耐酸陶瓷容器、食品用陶瓷容器、药品或化妆品陶瓷容器和其他运输及盛装货物用陶瓷容器。",
                                "kws": null,
                                "taxName": "非金属矿物制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080122000000000000",
                                "taxCodeTitle": "非金属矿物制品",
                                "iTitle": "*非金属矿物制品*运输及盛装货物用陶瓷容器",
                                "children": [
                                    {
                                        "id": "2155",
                                        "linkid": "2154",
                                        "code": "108012201",
                                        "paCode": "1080122",
                                        "yn": "N",
                                        "title": "耐酸陶瓷容器",
                                        "alias": "耐酸陶瓷容器",
                                        "about": "指耐酸性侵蚀的陶瓷容器。",
                                        "kws": "耐酸陶瓷容器",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080122010000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*耐酸陶瓷容器",
                                        "children": []
                                    },
                                    {
                                        "id": "2156",
                                        "linkid": "2154",
                                        "code": "108012202",
                                        "paCode": "1080122",
                                        "yn": "N",
                                        "title": "食品用陶瓷容器",
                                        "alias": "食品用陶瓷容器",
                                        "about": "指用于盛装食品陶瓷瓶、坛、罐；包括果酱、调味品、肉酱、利口酒等用的陶瓷容器",
                                        "kws": "食品用陶瓷容器",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080122020000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*食品用陶瓷容器",
                                        "children": []
                                    },
                                    {
                                        "id": "2157",
                                        "linkid": "2154",
                                        "code": "108012203",
                                        "paCode": "1080122",
                                        "yn": "N",
                                        "title": "药品或化妆品陶瓷容器",
                                        "alias": "药品或化妆品陶瓷容器",
                                        "about": "包括药品、化妆品及墨水等的陶瓷瓶、坛、罐",
                                        "kws": "药品陶瓷容器、化妆品陶瓷容器",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080122030000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*药品或化妆品陶瓷容器",
                                        "children": []
                                    },
                                    {
                                        "id": "2158",
                                        "linkid": "2154",
                                        "code": "108012299",
                                        "paCode": "1080122",
                                        "yn": "N",
                                        "title": "其他运输及盛装货物用陶瓷容器",
                                        "alias": "其他运输及盛装货物用陶瓷容器",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080122990000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*其他运输及盛装货物用陶瓷容器",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2159",
                                "linkid": "2018",
                                "code": "1080123",
                                "paCode": "10801",
                                "yn": "N",
                                "title": "其他陶瓷制品",
                                "alias": "其他陶瓷制品",
                                "about": null,
                                "kws": "陶瓷壁画、陶瓷制塑像、瓷制塑像、陶制塑像、陶瓷制火炉、火炉用陶瓷砖、陶瓷刀柄、陶瓷制零件、陶瓷制门、陶瓷制窗",
                                "taxName": "非金属矿物制品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1080123000000000000",
                                "taxCodeTitle": "非金属矿物制品",
                                "iTitle": "*非金属矿物制品*其他陶瓷制品",
                                "children": []
                            },
                            {
                                "id": "2160",
                                "linkid": "2018",
                                "code": "1080124",
                                "paCode": "10801",
                                "yn": "Y",
                                "title": "石棉纤维及其制品",
                                "alias": "石棉纤维及其制品",
                                "about": "包括已加工石棉纤维、石棉制品。",
                                "kws": null,
                                "taxName": "非金属矿物制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080124000000000000",
                                "taxCodeTitle": "非金属矿物制品",
                                "iTitle": "*非金属矿物制品*石棉纤维及其制品",
                                "children": [
                                    {
                                        "id": "2161",
                                        "linkid": "2160",
                                        "code": "108012401",
                                        "paCode": "1080124",
                                        "yn": "N",
                                        "title": "已加工石棉纤维",
                                        "alias": "已加工石棉纤维",
                                        "about": "包括已加工石棉纤维，石棉为主的混合物及其制品",
                                        "kws": "加工石棉纤维、泡沫石棉、弹性泡沫石棉、耐水弹性泡沫石棉、防水泡沫石棉、",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080124010000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*已加工石棉纤维",
                                        "children": []
                                    },
                                    {
                                        "id": "2162",
                                        "linkid": "2160",
                                        "code": "108012402",
                                        "paCode": "1080124",
                                        "yn": "N",
                                        "title": "石棉制品",
                                        "alias": "石棉制品",
                                        "about": "包括石棉纱、线及其纺织制品、石棉隔热保温制品、石棉密封垫板、无石棉密封垫板、石棉密封垫片、垫圈、特种石棉制品、石棉摩擦材料、无石棉摩擦材料和其他石棉制品。",
                                        "kws": "石棉纱、石棉线、石棉绳、石棉防火服、石棉帽、石棉鞋、石棉靴、石棉编织带、石棉绝缘带、石棉纸类制品、石棉板类制品、石棉管类制品、石棉保温砖、压缩石棉纤维接合材料、石棉橡胶板、耐油石棉橡胶板、石棉乳胶抄取板、无石棉橡胶板、耐油无石棉橡胶板、乳胶无石棉抄取板、石棉气缸垫、石棉缠绕式垫片、普通石棉冲压垫、耐酸石棉橡胶板、耐酸石棉纸板、电绝缘石棉纸、除菌过滤石棉纸、SB16隔膜石棉布、SB19电解石棉布、石棉制动器衬片、石棉离合器面片、石棉火车合成闸瓦、石棉火车合成闸片、工业机械用石棉摩擦片、无石棉制动器衬片、无石",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080124020000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*石棉制品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2163",
                                "linkid": "2018",
                                "code": "1080125",
                                "paCode": "10801",
                                "yn": "Y",
                                "title": "已加工云母及其制品",
                                "alias": "已加工云母及其制品",
                                "about": "包括除劈分和整理外还经过进一步加工（如切割成形）的天然云母，也包括由粘聚（粘合）云母或纸浆（再造）云母制成的产品，以及上述任何材料的制品",
                                "kws": null,
                                "taxName": "非金属矿物制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080125000000000000",
                                "taxCodeTitle": "非金属矿物制品",
                                "iTitle": "*非金属矿物制品*已加工云母及其制品",
                                "children": [
                                    {
                                        "id": "2164",
                                        "linkid": "2163",
                                        "code": "108012501",
                                        "paCode": "1080125",
                                        "yn": "N",
                                        "title": "已加工云母",
                                        "alias": "已加工云母",
                                        "about": "包括厚片云母、薄片云母、云母粉。",
                                        "kws": "厚片云母、薄片云母、云母粉",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080125010000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*已加工云母",
                                        "children": []
                                    },
                                    {
                                        "id": "2165",
                                        "linkid": "2163",
                                        "code": "108012502",
                                        "paCode": "1080125",
                                        "yn": "N",
                                        "title": "云母制品",
                                        "alias": "云母制品",
                                        "about": "包括云母板、云母片、云母箔、云母带、模制云母制品、云母碎屑制品、云母纸制品和其他云母制品。",
                                        "kws": "云母板、云母片、云母箔、云母带、模制云母制品、云母碎屑制品、云母纸制品",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080125020000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*云母制品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2166",
                                "linkid": "2018",
                                "code": "1080126",
                                "paCode": "10801",
                                "yn": "N",
                                "title": "耐火材料制品",
                                "alias": "耐火材料制品",
                                "about": "包括致密定形耐火制品、隔热耐火制品、不定形耐火制品和其他耐火材料制品，不包括耐火陶瓷制品（详见108012006）。",
                                "kws": "粘土质砖、普通砖、高炉砖、热风炉砖、玻璃窑用砖、镁质砖、镁砖、镁铬砖、镁钙砖、镁铝砖、高铝质砖、一般高铝砖、炼钢电炉顶砖、盛钢桶用砖、高炉高铝质砖、热风炉、硅质砖、普通硅质砖、玻璃窑用硅质砖、焦炉用砖、热风炉用砖",
                                "taxName": "非金属矿物制品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1080126000000000000",
                                "taxCodeTitle": "非金属矿物制品",
                                "iTitle": "*非金属矿物制品*耐火材料制品",
                                "children": []
                            },
                            {
                                "id": "2167",
                                "linkid": "2018",
                                "code": "1080127",
                                "paCode": "10801",
                                "yn": "Y",
                                "title": "石墨及炭素制品",
                                "alias": "石墨及炭素制品",
                                "about": "以石油焦、天然石墨、煤沥青等富含炭元素的基材为主要原料，经特定工艺处理的人工制成品",
                                "kws": null,
                                "taxName": "非金属矿物制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080127000000000000",
                                "taxCodeTitle": "非金属矿物制品",
                                "iTitle": "*非金属矿物制品*石墨及炭素制品",
                                "children": [
                                    {
                                        "id": "2168",
                                        "linkid": "2167",
                                        "code": "108012701",
                                        "paCode": "1080127",
                                        "yn": "Y",
                                        "title": "石墨制品",
                                        "alias": "石墨制品",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1080127010000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*石墨制品",
                                        "children": [
                                            {
                                                "id": "2169",
                                                "linkid": "2168",
                                                "code": "10801270101",
                                                "paCode": "108012701",
                                                "yn": "N",
                                                "title": "石墨电极",
                                                "alias": "石墨电极",
                                                "about": "以优质石油焦为主要原料，煤沥青作粘结剂，经特定工艺加工而制成，是在电弧炉中以电弧形式释放热能对炉料进行加热溶化的导体，包括普通功率石墨电极、高功率石墨电极、超高功率石墨电极。",
                                                "kws": "普通功率石墨电极、高功率石墨电极、超高功率石墨电极",
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080127010100000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*石墨电极",
                                                "children": []
                                            },
                                            {
                                                "id": "2170",
                                                "linkid": "2168",
                                                "code": "10801270102",
                                                "paCode": "108012701",
                                                "yn": "N",
                                                "title": "石墨阳极",
                                                "alias": "石墨阳极",
                                                "about": "以石油焦为主要原料，煤沥青作粘结剂，经特定工艺加工而成，主要用于电化学工业中电解设备的导电阳极。",
                                                "kws": "石墨阳极",
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080127010200000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*石墨阳极",
                                                "children": []
                                            },
                                            {
                                                "id": "2171",
                                                "linkid": "2168",
                                                "code": "10801270103",
                                                "paCode": "108012701",
                                                "yn": "N",
                                                "title": "其他石墨制品",
                                                "alias": "其他石墨制品",
                                                "about": "指除石墨电极（详见10801270101）、石墨阳极（详见10801270102）以外的其他石墨制品，包括石墨块、石墨粉、石墨异型件。",
                                                "kws": "非标准石墨制品、不透性石墨、石墨块、石墨粉、石墨异型件",
                                                "taxName": "非金属矿物制品",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080127010300000000",
                                                "taxCodeTitle": "非金属矿物制品",
                                                "iTitle": "*非金属矿物制品*其他石墨制品",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "2172",
                                        "linkid": "2167",
                                        "code": "108012702",
                                        "paCode": "1080127",
                                        "yn": "N",
                                        "title": "炭制品",
                                        "alias": "炭制品",
                                        "about": "以无烟煤、冶金焦为主要原料，煤沥青作粘结剂，经特定工艺加工制作而成，主要用作高炉内衬、铝电解槽和其他电炉的炉衬材料和导电材料，包括炭块、炭电极、炭湖和其他炭制品。",
                                        "kws": "普通炭块、普通高炉炭块、普通电炉炭块、普通铝用炭块、半石墨质炭块、半石墨质高炉炭块、半石墨质电炉炭块、半石墨质铝用炭块、微孔炭块、炭电阻棒、炭阳极、焙烧电极毛坯、阳极糊、电极糊、底糊、密闭糊",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080127020000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*炭制品",
                                        "children": []
                                    },
                                    {
                                        "id": "2173",
                                        "linkid": "2167",
                                        "code": "108012703",
                                        "paCode": "1080127",
                                        "yn": "N",
                                        "title": "炭素新材料",
                                        "alias": "炭素新材料",
                                        "about": "包括特种石墨制品、热解石墨制品、炭素纤维类及制品和其他炭素新材料。",
                                        "kws": "超细结构石墨、细结构石墨、中粗结构石墨、粗结构石墨、光普纯石墨、各向同性石墨、热解石墨管、热解石墨片、炭纤维、石墨纤维、预浸料、预氧丝、炭布、炭绳、炭带、炭毡",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080127030000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*炭素新材料",
                                        "children": []
                                    },
                                    {
                                        "id": "2174",
                                        "linkid": "2167",
                                        "code": "108012799",
                                        "paCode": "1080127",
                                        "yn": "N",
                                        "title": "其他炭素产品",
                                        "alias": "其他炭素产品",
                                        "about": "包括石墨热交换器、柔性石墨制品、电炭产品。",
                                        "kws": "块孔式石墨热交换器、径向式石墨热交换器、降膜式石墨热交换器、列管式石墨热交换器、柔性石墨密封垫片、柔性石墨卷材、柔性石墨板材、柔性石墨填料、柔性石墨填料环、柔性石墨盘根、炭纤维增强柔性石墨盘根、镍丝增强柔性石墨盘根、炭刷、炭棒、炭焊条、炭精片、炭精轴承、炭精密封环、传声器用炭精零件、整流电子管用阳极、整流电子管用栅、整流电子管用屏",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080127990000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*其他炭素产品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2175",
                                "linkid": "2018",
                                "code": "1080128",
                                "paCode": "10801",
                                "yn": "Y",
                                "title": "磨具",
                                "alias": "磨具",
                                "about": "指用于磨削、研磨和抛光的工具",
                                "kws": null,
                                "taxName": "非金属矿物制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080128000000000000",
                                "taxCodeTitle": "非金属矿物制品",
                                "iTitle": "*非金属矿物制品*磨具",
                                "children": [
                                    {
                                        "id": "2176",
                                        "linkid": "2175",
                                        "code": "108012801",
                                        "paCode": "1080128",
                                        "yn": "N",
                                        "title": "固结磨具",
                                        "alias": "固结磨具",
                                        "about": "包括碾磨或磨浆用石磨、石碾、机用磨石、抛光石、砂轮、磨头、磨盘、磨齿、手用磨石。",
                                        "kws": "碾磨用石磨、磨浆用石磨、石碾、机用磨石、陶瓷制磨石、抛光石、陶瓷制砂轮、树脂砂轮、陶瓷制磨头、磨盘、磨齿、手用磨石、手用抛光石",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080128010000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*固结磨具",
                                        "children": []
                                    },
                                    {
                                        "id": "2177",
                                        "linkid": "2175",
                                        "code": "108012802",
                                        "paCode": "1080128",
                                        "yn": "N",
                                        "title": "天然石制磨具",
                                        "alias": "天然石制磨具",
                                        "about": "包括碾磨或磨浆用石磨、石碾及其零件；刀具、工具等磨刃用的磨石；磨刀石、油石及类似品",
                                        "kws": "天然石料制砂轮、天然石磨、天然石碾、天然石料制砂轮零件、天然石磨零件、天然石碾零件",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080128020000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*天然石制磨具",
                                        "children": []
                                    },
                                    {
                                        "id": "2178",
                                        "linkid": "2175",
                                        "code": "108012803",
                                        "paCode": "1080128",
                                        "yn": "N",
                                        "title": "涂附磨具",
                                        "alias": "涂附磨具",
                                        "about": "包括布基、纸基、涂附磨具异型产品和其他涂附磨具。",
                                        "kws": "布基、页状砂布、卷状砂布、带状砂布、纸基砂纸、页状砂纸、卷状砂纸、带状砂纸、涂附磨具异型产品、刚纸磨片、纸基不干胶磨片、布基不干胶磨片、砂盘、页轮、带柄页轮、布轮、开丝轮、尼龙大扣、尼龙抛光轮、尼龙抛光磨片、无纺布磨块、弹性海绵磨块",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080128030000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*涂附磨具",
                                        "children": []
                                    },
                                    {
                                        "id": "2179",
                                        "linkid": "2175",
                                        "code": "108012804",
                                        "paCode": "1080128",
                                        "yn": "N",
                                        "title": "超硬材料制品",
                                        "alias": "超硬材料制品",
                                        "about": "指用金刚石或立方氮化硼制成的磨削、切削、锯切、钻探、拉丝等各类工具",
                                        "kws": "树脂金刚石砂轮、树脂金刚石磨盘、树脂金刚石磨头、树脂立方氮化硼砂轮、树脂立方氮化硼磨盘、树脂立方氮化硼磨头、陶瓷金刚石砂轮、陶瓷金刚石磨盘、陶瓷金刚石磨头、陶瓷立方氮化硼砂轮、陶瓷立方氮化硼磨盘、陶瓷立方氮化硼磨头、金属金刚石砂轮、金属金刚石磨盘、金属金刚石磨辊、金属金刚石磨头、金刚石磨石、立方氮化硼磨石、超硬材料涂附磨具、金刚石薄壁钻头、金刚石石油天然气钻头、金刚石地质勘探钻头",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080128040000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*超硬材料制品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2180",
                                "linkid": "2018",
                                "code": "1080129",
                                "paCode": "10801",
                                "yn": "Y",
                                "title": "磨料",
                                "alias": "磨料",
                                "about": "包括天然研磨料、普通磨料、超硬材料。",
                                "kws": null,
                                "taxName": "非金属矿物制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080129000000000000",
                                "taxCodeTitle": "非金属矿物制品",
                                "iTitle": "*非金属矿物制品*磨料",
                                "children": [
                                    {
                                        "id": "2181",
                                        "linkid": "2180",
                                        "code": "108012901",
                                        "paCode": "1080129",
                                        "yn": "N",
                                        "title": "天然研磨料",
                                        "alias": "天然研磨料",
                                        "about": "包括刚玉砂、石榴石、浮石、燧石、石英砂等天然矿物粉及玻璃粉",
                                        "kws": "刚玉砂、石榴石、浮石、燧石、石英砂",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080129010000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*天然研磨料",
                                        "children": []
                                    },
                                    {
                                        "id": "2182",
                                        "linkid": "2180",
                                        "code": "108012902",
                                        "paCode": "1080129",
                                        "yn": "N",
                                        "title": "普通磨料",
                                        "alias": "普通磨料",
                                        "about": "包括人造刚玉、碳化硅磨料、碳化硼磨料(包括碳化硼碎块、颗粒、微粉)。",
                                        "kws": "人造刚玉、棕刚玉、白刚玉、碳化硅磨料、黑碳化硅磨料、绿碳化硅磨料、碳化硼磨料、碳化硼碎块、碳化硼颗粒、碳化硼微粉",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080129020000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*普通磨料",
                                        "children": []
                                    },
                                    {
                                        "id": "2183",
                                        "linkid": "2180",
                                        "code": "108012903",
                                        "paCode": "1080129",
                                        "yn": "N",
                                        "title": "超硬材料",
                                        "alias": "超硬材料",
                                        "about": "包括人造金刚石、立方氮化硼的单晶、多晶、微粉、纳米粉及其聚晶，化学气相沉积（CVD）金刚石",
                                        "kws": "人造金刚石、金刚石单晶、金刚石多晶、带金属衬底的金刚石聚晶（PDC）、不带金属衬底的金刚石聚晶（PCD）、立方氮化硼、立方氮化硼单晶、立方氮化硼多晶、带金属衬底的立方氮化硼聚晶、不带金属衬底的立方氮化硼聚晶、化学气相沉积（CVD）金刚石",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080129030000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*超硬材料",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2184",
                                "linkid": "2018",
                                "code": "1080130",
                                "paCode": "10801",
                                "yn": "Y",
                                "title": "沥青、泥炭",
                                "alias": "沥青、泥炭",
                                "about": "包括沥青混合物、泥炭制品。",
                                "kws": null,
                                "taxName": "非金属矿物制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080130000000000000",
                                "taxCodeTitle": "非金属矿物制品",
                                "iTitle": "*非金属矿物制品*沥青、泥炭",
                                "children": [
                                    {
                                        "id": "2185",
                                        "linkid": "2184",
                                        "code": "108013001",
                                        "paCode": "1080130",
                                        "yn": "N",
                                        "title": "沥青混合物",
                                        "alias": "沥青混合物",
                                        "about": "指以天然沥青、石油沥青、矿物焦油等为基本成分的沥青混合物",
                                        "kws": "普通沥青混合料、添加抗剥落剂沥青混合料、SBS聚合物改性沥青混合料、沥青玛蹄脂碎石混合料、热拌冷外沥青混合料、彩色沥青混合料、沥青胶粘剂、沥青混凝土、煤沥青",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080130010000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*沥青混合物",
                                        "children": []
                                    },
                                    {
                                        "id": "2186",
                                        "linkid": "2184",
                                        "code": "108013002",
                                        "paCode": "1080130",
                                        "yn": "N",
                                        "title": "泥炭制品",
                                        "alias": "泥炭制品",
                                        "about": "包括泥炭制片、泥炭制气缸壳体、植物培植盆和其他泥炭制品。",
                                        "kws": "泥炭制片、泥炭制气缸壳体、植物培植盆",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080130020000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*泥炭制品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2187",
                                "linkid": "2018",
                                "code": "1080199",
                                "paCode": "10801",
                                "yn": "Y",
                                "title": "其他非金属矿物制品",
                                "alias": "其他非金属矿物制品",
                                "about": null,
                                "kws": null,
                                "taxName": "非金属矿物制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080199000000000000",
                                "taxCodeTitle": "非金属矿物制品",
                                "iTitle": "*非金属矿物制品*其他非金属矿物制品",
                                "children": [
                                    {
                                        "id": "2188",
                                        "linkid": "2187",
                                        "code": "108019901",
                                        "paCode": "1080199",
                                        "yn": "N",
                                        "title": "以废渣生产非金属矿物制品",
                                        "alias": "以废渣生产非金属矿物制品",
                                        "about": "以废渣为原料生产墙板【不包括轻质隔墙条板（详见108010403）】、管材（管桩）【不包括预应力混凝土管桩（详见108010306）】、陶粒、砂浆、道路井盖、道路护栏、防火材料、保温材料、矿（岩）棉",
                                        "kws": "陶粒、砂浆、道路井盖、道路护栏、防火材料、保温材料、矿棉、岩棉、墙板、管桩",
                                        "taxName": "非金属矿物制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080199010000000000",
                                        "taxCodeTitle": "非金属矿物制品",
                                        "iTitle": "*非金属矿物制品*以废渣生产非金属矿物制品",
                                        "children": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "id": "2189",
                        "linkid": "2017",
                        "code": "10802",
                        "paCode": "108",
                        "yn": "Y",
                        "title": "黑色金属冶炼及压延产品",
                        "alias": "黑色金属冶炼及压延产品",
                        "about": null,
                        "kws": null,
                        "taxName": "黑色金属冶炼压延品",
                        "taxRate": "",
                        "vip": "7",
                        "itaxRate": null,
                        "taxCode": "1080200000000000000",
                        "taxCodeTitle": "黑色金属冶炼压延品",
                        "iTitle": "*黑色金属冶炼压延品*黑色金属冶炼及压延产品",
                        "children": [
                            {
                                "id": "2190",
                                "linkid": "2189",
                                "code": "1080201",
                                "paCode": "10802",
                                "yn": "N",
                                "title": "生铁",
                                "alias": "生铁",
                                "about": "高炉冶炼的合格生铁，包括炼钢生铁、铸造生铁、含钒生铁",
                                "kws": "炼钢生铁、铸造生铁、含钒生铁、球墨铸铁用铸造生铁",
                                "taxName": "黑色金属冶炼压延品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1080201000000000000",
                                "taxCodeTitle": "黑色金属冶炼压延品",
                                "iTitle": "*黑色金属冶炼压延品*生铁",
                                "children": []
                            },
                            {
                                "id": "2191",
                                "linkid": "2189",
                                "code": "1080202",
                                "paCode": "10802",
                                "yn": "N",
                                "title": "还原铁",
                                "alias": "还原铁",
                                "about": "包括直接还原铁、熔融还原铁",
                                "kws": "还原铁、炼钢用直接还原铁、煤基直接还原铁、气基直接还原铁、海绵铁、压块铁、炼钢用熔融还原铁",
                                "taxName": "黑色金属冶炼压延品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1080202000000000000",
                                "taxCodeTitle": "黑色金属冶炼压延品",
                                "iTitle": "*黑色金属冶炼压延品*还原铁",
                                "children": []
                            },
                            {
                                "id": "2192",
                                "linkid": "2189",
                                "code": "1080203",
                                "paCode": "10802",
                                "yn": "N",
                                "title": "球墨铸铁",
                                "alias": "球墨铸铁",
                                "about": "包括高炉生铁产球墨铸铁及其他生铁产球墨铸铁",
                                "kws": "球墨铸铁",
                                "taxName": "黑色金属冶炼压延品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1080203000000000000",
                                "taxCodeTitle": "黑色金属冶炼压延品",
                                "iTitle": "*黑色金属冶炼压延品*球墨铸铁",
                                "children": []
                            },
                            {
                                "id": "2193",
                                "linkid": "2189",
                                "code": "1080204",
                                "paCode": "10802",
                                "yn": "Y",
                                "title": "铸铁管及其附件",
                                "alias": "铸铁管及其附件",
                                "about": "包括铸铁管、铸铁直管、铸铁空心异型管、铸铁管附件",
                                "kws": "铸铁管、铸铁直管、铸铁空心异型管、铸铁管附件",
                                "taxName": "黑色金属冶炼压延品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080204000000000000",
                                "taxCodeTitle": "黑色金属冶炼压延品",
                                "iTitle": "*黑色金属冶炼压延品*铸铁管及其附件",
                                "children": [
                                    {
                                        "id": "2194",
                                        "linkid": "2193",
                                        "code": "108020401",
                                        "paCode": "1080204",
                                        "yn": "N",
                                        "title": "铸铁管",
                                        "alias": "铸铁管",
                                        "about": "指用铸铁浇铸成型的管子",
                                        "kws": "铸铁管",
                                        "taxName": "黑色金属冶炼压延品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080204010000000000",
                                        "taxCodeTitle": "黑色金属冶炼压延品",
                                        "iTitle": "*黑色金属冶炼压延品*铸铁管",
                                        "children": []
                                    },
                                    {
                                        "id": "2195",
                                        "linkid": "2193",
                                        "code": "108020402",
                                        "paCode": "1080204",
                                        "yn": "N",
                                        "title": "铸铁直管",
                                        "alias": "铸铁直管",
                                        "about": "包括连续式生产铸铁直管、离心式生产铸铁直管、其他方式生产铸铁直管、灰铁铸铁管、球墨铸铁管、其他铸铁管、大口径铸铁直管、中口径铸铁直管、小口径铸铁直管",
                                        "kws": "连续式生产铸铁直管、离心式生产铸铁直管、灰铁铸铁管、球墨铸铁管、大口径铸铁直管、中口径铸铁直管、小口径铸铁直管",
                                        "taxName": "黑色金属冶炼压延品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080204020000000000",
                                        "taxCodeTitle": "黑色金属冶炼压延品",
                                        "iTitle": "*黑色金属冶炼压延品*铸铁直管",
                                        "children": []
                                    },
                                    {
                                        "id": "2196",
                                        "linkid": "2193",
                                        "code": "108020403",
                                        "paCode": "1080204",
                                        "yn": "N",
                                        "title": "铸铁空心异型管",
                                        "alias": "铸铁空心异型管",
                                        "about": "指用铸铁浇铸成异型的空心管",
                                        "kws": "铸铁空心异型管",
                                        "taxName": "黑色金属冶炼压延品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080204030000000000",
                                        "taxCodeTitle": "黑色金属冶炼压延品",
                                        "iTitle": "*黑色金属冶炼压延品*铸铁空心异型管",
                                        "children": []
                                    },
                                    {
                                        "id": "2197",
                                        "linkid": "2193",
                                        "code": "108020404",
                                        "paCode": "1080204",
                                        "yn": "N",
                                        "title": "铸铁管附件",
                                        "alias": "铸铁管附件",
                                        "about": "包括无可锻性铸铁管子附件、可锻性铸铁及铸钢管子附件",
                                        "kws": "无可锻性铸铁管子附件、可锻性铸铁、可锻性铸钢管子附件",
                                        "taxName": "黑色金属冶炼压延品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080204040000000000",
                                        "taxCodeTitle": "黑色金属冶炼压延品",
                                        "iTitle": "*黑色金属冶炼压延品*铸铁管附件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2198",
                                "linkid": "2189",
                                "code": "1080205",
                                "paCode": "10802",
                                "yn": "N",
                                "title": "粗钢",
                                "alias": "粗钢",
                                "about": "指完成了冶炼过程、未经塑性加工的钢，其形态为液态或铸态固体，包括非合金钢粗钢、低合金钢粗钢、合金钢粗钢、不锈钢粗钢；方坯（粗钢）、矩形坯（粗钢）、板坯（粗钢）、圆坯（粗钢）、异形坯（粗钢）、管坯（粗钢）；模铸钢锭；铸造用液态钢；镇静钢、沸腾钢、半镇静钢；转炉钢、电弧炉钢、感应电炉钢",
                                "kws": "一般用途碳素结构钢、一般用途碳素结构粗钢、优质碳素结构钢、优质碳素结构粗钢、冷压延棒、线材用非合金钢、线材用非合金钢粗钢、电工用非合金钢、电工用非合金粗钢、优质铸造碳素钢、优质铸造碳素粗钢、易切削非合金结构钢、易切削非合金结构粗钢、特殊碳素结构钢、特殊碳素结构粗钢、特殊盘条钢、钢丝用非合金钢、钢丝用非合金粗钢、航空兵器等专用非合金结构钢、航空兵器等专用非合金结构粗钢、核能用非合金钢、核能用非合金粗钢）、碳素弹簧钢、碳素弹簧粗钢、特殊易切削钢、特殊易切削粗钢、碳素工具钢、中空钢、中空粗钢、电磁纯铁、电磁纯粗",
                                "taxName": "黑色金属冶炼压延品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1080205000000000000",
                                "taxCodeTitle": "黑色金属冶炼压延品",
                                "iTitle": "*黑色金属冶炼压延品*粗钢",
                                "children": []
                            },
                            {
                                "id": "2199",
                                "linkid": "2189",
                                "code": "1080206",
                                "paCode": "10802",
                                "yn": "N",
                                "title": "轧制、锻造钢坯",
                                "alias": "轧制、锻造钢坯",
                                "about": "包括非合金钢钢坯、合金钢钢坯、低合金钢钢坯、不锈钢钢坯；轧制坯、锻造坯；方坯（钢坯）、矩形坯（钢坯）、板坯（钢坯）、圆坯（钢坯）、异形坯（钢坯）、管坯（钢坯）",
                                "kws": "一般用途碳素结构钢、一般用途碳素结构钢坯、优质碳素结构钢、优质碳素结构钢坯、线材用非合金钢坯、特殊盘条钢用非合金钢坯、特殊盘条钢丝用非合金钢坯、合金结构钢坯、合金钢筋钢坯、高电阻电热钢坯、无磁钢坯、永磁钢坯、铬系不锈钢坯、铬镍系不锈钢坯、耐热不锈钢坯、连铸坯轧制坯、钢锭轧制坯、锻造坯、大方钢坯、小方钢坯、大矩形钢坯、小矩形钢坯、厚板钢坯、薄板钢坯、圆钢坯、异形钢坯、管钢坯、冷压延棒、电工用非合金钢坯、优质铸造碳素钢坯、易切削非合金结构钢坯、特殊碳素结构钢坯、特殊盘条钢及钢丝用非合金钢坯、航空兵器等专用非合",
                                "taxName": "黑色金属冶炼压延品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1080206000000000000",
                                "taxCodeTitle": "黑色金属冶炼压延品",
                                "iTitle": "*黑色金属冶炼压延品*轧制、锻造钢坯",
                                "children": []
                            },
                            {
                                "id": "2200",
                                "linkid": "2189",
                                "code": "1080207",
                                "paCode": "10802",
                                "yn": "Y",
                                "title": "钢材",
                                "alias": "钢材",
                                "about": "包括铁道用钢材、大型型钢、中小型型钢、棒材、钢筋、线材（盘条）、钢板、热轧薄板、冷轧薄板、钢带、板带、无缝钢管、焊接钢管、其他钢材",
                                "kws": "铁道用钢材、大型型钢、中小型型钢、棒材、钢筋、线材、盘条、钢板、热轧薄板、冷轧薄板、钢带、板带、无缝钢管、焊接钢管",
                                "taxName": "黑色金属冶炼压延品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080207000000000000",
                                "taxCodeTitle": "黑色金属冶炼压延品",
                                "iTitle": "*黑色金属冶炼压延品*钢材",
                                "children": [
                                    {
                                        "id": "2201",
                                        "linkid": "2200",
                                        "code": "108020701",
                                        "paCode": "1080207",
                                        "yn": "N",
                                        "title": "铁道用钢材",
                                        "alias": "铁道用钢材",
                                        "about": "指铁道及电车道铺轨用钢铁材料",
                                        "kws": "轻轨、重轨、道岔钢轨、钢轨配件、工业用钢轨、起重机用钢轨、导电钢轨、钢枕、车轮、轮箍、车轴、铁道用非合金钢、铁道用普通质量非合金钢、铁道用优质非合金钢、铁道用特殊质量非合金钢、铁道用低合金钢、铁道用普通质量低合金钢、铁道用优质低合金钢、铁道用特殊质量低合金钢",
                                        "taxName": "黑色金属冶炼压延品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080207010000000000",
                                        "taxCodeTitle": "黑色金属冶炼压延品",
                                        "iTitle": "*黑色金属冶炼压延品*铁道用钢材",
                                        "children": []
                                    },
                                    {
                                        "id": "2202",
                                        "linkid": "2200",
                                        "code": "108020702",
                                        "paCode": "1080207",
                                        "yn": "N",
                                        "title": "大型型钢",
                                        "alias": "大型型钢",
                                        "about": "产品的横截面如字母Ｉ、Ｕ、Ｌ、Ｚ、T等形状，其高度≥80mm（包括氧气瓶料）",
                                        "kws": "大型H型钢、大型I型钢、大型工字钢、大型Ｕ型钢、大型槽钢、大型角钢、大型Ｚ字钢、大型丁字钢、T型钢、钢板桩、矿用型钢、特殊大型型钢、衬板钢、π型钢、履带钢、非合金钢大型型钢、普通质量非合金钢大型型钢、优质非合金钢大型型钢、特殊质量非合金钢大型型钢、低合金钢大型型钢、普通质量低合金钢大型型钢、优质低合金钢大型型钢、特殊质量低合金钢大型型钢、合金钢大型型钢、优质合金钢大型型钢、特殊质量合金钢大型型钢、不锈钢大型型钢、铬系不锈钢大型型钢、铬镍系不锈钢大型型钢、耐热不锈钢大型型钢、大型型钢按加工工艺分、热轧大型型",
                                        "taxName": "黑色金属冶炼压延品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080207020000000000",
                                        "taxCodeTitle": "黑色金属冶炼压延品",
                                        "iTitle": "*黑色金属冶炼压延品*大型型钢",
                                        "children": []
                                    },
                                    {
                                        "id": "2203",
                                        "linkid": "2200",
                                        "code": "108020703",
                                        "paCode": "1080207",
                                        "yn": "N",
                                        "title": "中小型型钢",
                                        "alias": "中小型型钢",
                                        "about": "产品的横截面如字母Ｉ、Ｕ、Ｌ、Ｚ、T等形状，其高度＜80mm",
                                        "kws": "中小型H型钢、中小Ｉ型钢、小工字钢、中小U型钢、小槽钢、中小型角钢、中小等翼缘T型钢、复合钢、矿用支柱钢、矿用刮板钢、特殊中小型型钢、非合金钢中小型型钢、普通质量非合金钢中小型型钢、优质非合金钢中小型型钢、特殊质量非合金钢中小型型钢、低合金钢中小型型钢、普通质量低合金钢中小型型钢、优质低合金钢中小型型钢、特殊质量低合金钢中小型型钢、优质合金钢中小型型钢、特殊质量合金钢中小型型钢、不锈钢中小型型钢、铬系不锈钢中小型型钢、铬镍系不锈钢中小型型钢、耐热不锈钢中小型型钢、热轧中小型型钢、锻压中小型型钢、挤压中小型",
                                        "taxName": "黑色金属冶炼压延品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080207030000000000",
                                        "taxCodeTitle": "黑色金属冶炼压延品",
                                        "iTitle": "*黑色金属冶炼压延品*中小型型钢",
                                        "children": []
                                    },
                                    {
                                        "id": "2204",
                                        "linkid": "2200",
                                        "code": "108020704",
                                        "paCode": "1080207",
                                        "yn": "N",
                                        "title": "棒材",
                                        "alias": "棒材",
                                        "about": "横截面为圆形、方形、六角形、八角形、扁形等简单断面并以直条交货的钢材，不包括混凝土用钢筋（详见108020705）",
                                        "kws": "非合金钢棒材、普通质量非合金钢棒材、优质非合金钢棒材、特殊质量非合金钢棒材、低合金钢棒材、普通质量低合金钢棒材、优质低合金钢棒材、特殊质量低合金钢棒材、合金钢棒材、优质合金钢棒材、特殊质量合金钢棒材、不锈钢棒材、铬系不锈钢棒材、铬镍系不锈钢棒材、耐热不锈钢棒材、圆钢、大型圆钢、小型圆钢、方钢、大型方钢、小型方钢、六角钢、八角钢、扁钢、大型扁钢、小型扁钢、热轧棒材、冷轧棒材、锻压棒材、挤压棒材",
                                        "taxName": "黑色金属冶炼压延品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080207040000000000",
                                        "taxCodeTitle": "黑色金属冶炼压延品",
                                        "iTitle": "*黑色金属冶炼压延品*棒材",
                                        "children": []
                                    },
                                    {
                                        "id": "2205",
                                        "linkid": "2200",
                                        "code": "108020705",
                                        "paCode": "1080207",
                                        "yn": "N",
                                        "title": "钢筋",
                                        "alias": "钢筋",
                                        "about": "钢筋混凝土和预应力钢筋混凝土用的轧制产品，横截面通常为圆形或带有圆角的方形，包括光圆钢筋、带肋钢筋、扭转钢筋等；可以直条交货，也可以盘状交货；不包括线材轧机生产的产品（详见108020705）",
                                        "kws": "光圆钢筋、带肋钢筋、非合金钢钢筋、普通质量非合金钢钢筋、优质非合金钢钢筋、特殊质量非合金钢钢筋、低合金钢钢筋、普通质量低合金钢钢筋、优质低合金钢钢筋、特殊质量低合金钢钢筋、合金钢钢筋、优质合金钢钢筋、特殊质量合金钢钢筋、不锈钢钢筋、铬系不锈钢钢筋、铬镍系不锈钢钢筋、耐热不锈钢钢筋、热轧钢筋、一级钢筋、二级钢筋、三级钢筋、四级钢筋、五级钢筋、冷轧钢筋",
                                        "taxName": "黑色金属冶炼压延品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080207050000000000",
                                        "taxCodeTitle": "黑色金属冶炼压延品",
                                        "iTitle": "*黑色金属冶炼压延品*钢筋",
                                        "children": []
                                    },
                                    {
                                        "id": "2206",
                                        "linkid": "2200",
                                        "code": "108020706",
                                        "paCode": "1080207",
                                        "yn": "N",
                                        "title": "线材（盘条）",
                                        "alias": "线材（盘条）",
                                        "about": "经线材轧机热轧后卷成盘状交货的产品，其横截面通常为圆形、椭圆形、方形、矩形、六角形、八角形或其他形状包括调出及企业自用于拔制钢丝的盘条",
                                        "kws": "工程建筑结构用线材、制品原料用高碳钢线材、钢帘线用硬线材、钢纤维用硬线材、钢绞线用硬线材、拉拔用线材、电焊条用线材、弹簧用线材、冷镦铆螺用线材",
                                        "taxName": "黑色金属冶炼压延品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080207060000000000",
                                        "taxCodeTitle": "黑色金属冶炼压延品",
                                        "iTitle": "*黑色金属冶炼压延品*线材（盘条）",
                                        "children": []
                                    },
                                    {
                                        "id": "2207",
                                        "linkid": "2200",
                                        "code": "108020707",
                                        "paCode": "1080207",
                                        "yn": "N",
                                        "title": "钢板",
                                        "alias": "钢板",
                                        "about": "包括厚钢板和中板",
                                        "kws": "锅炉用厚钢板、火箱用厚钢板、造船用厚钢板、舰艇用厚钢板、航空用厚钢板、容器用厚钢板、工程机械用厚钢板、建筑用厚钢板、桥梁用厚钢板、管线用厚钢板、锅炉用中板、火箱用中板、造船用中板、火车车厢用中板、汽车用中板、容器用中板、工程机械用中板、农机用中板、集装箱用中板、管线用中板、建筑用中板、桥梁用中板、焊管用中板",
                                        "taxName": "黑色金属冶炼压延品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080207070000000000",
                                        "taxCodeTitle": "黑色金属冶炼压延品",
                                        "iTitle": "*黑色金属冶炼压延品*钢板",
                                        "children": []
                                    },
                                    {
                                        "id": "2208",
                                        "linkid": "2200",
                                        "code": "108020708",
                                        "paCode": "1080207",
                                        "yn": "N",
                                        "title": "热轧薄板",
                                        "alias": "热轧薄板",
                                        "about": "包括非合金钢热轧薄板、低合金钢热轧薄板、合金钢热轧薄板、不锈钢热轧薄板等",
                                        "kws": "汽车用热轧薄板、造船用热轧薄板、舰艇用热轧薄板、搪瓷用热轧薄板、农机用热轧薄板、建筑用热轧薄板、集装箱用热轧薄板、公路用热轧薄板、轻工家电用热轧薄板、容器用热轧薄板、工程机械用热轧薄板、焊管用热轧薄板",
                                        "taxName": "黑色金属冶炼压延品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080207080000000000",
                                        "taxCodeTitle": "黑色金属冶炼压延品",
                                        "iTitle": "*黑色金属冶炼压延品*热轧薄板",
                                        "children": []
                                    },
                                    {
                                        "id": "2209",
                                        "linkid": "2200",
                                        "code": "108020709",
                                        "paCode": "1080207",
                                        "yn": "N",
                                        "title": "冷轧薄板",
                                        "alias": "冷轧薄板",
                                        "about": "包括非合金钢冷轧薄板、低合金钢冷轧薄板、合金钢冷轧薄板、不锈钢冷轧薄板等",
                                        "kws": "汽车用冷轧薄板、轿车面板用冷轧薄板、火车车厢用冷轧薄板、造船用冷轧薄板、工程机械用冷轧薄板、搪瓷用冷轧薄板、农机用冷轧薄板、建筑用冷轧薄板、家电用冷轧薄板、集装箱用冷轧薄板、钢制家具用冷轧薄板、镀锡原板、冷连轧机生产冷轧薄板、单机架轧机生产冷轧薄板、双机架轧机生产冷轧薄板",
                                        "taxName": "黑色金属冶炼压延品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080207090000000000",
                                        "taxCodeTitle": "黑色金属冶炼压延品",
                                        "iTitle": "*黑色金属冶炼压延品*冷轧薄板",
                                        "children": []
                                    },
                                    {
                                        "id": "2210",
                                        "linkid": "2200",
                                        "code": "108020710",
                                        "paCode": "1080207",
                                        "yn": "N",
                                        "title": "钢带",
                                        "alias": "钢带",
                                        "about": "包括中厚宽钢带、热轧钢带、冷轧钢带",
                                        "kws": "锅炉用中厚宽钢带、火箱用中厚宽钢带、造船用中厚宽钢带、火车车箱用中厚宽钢带、汽车用中厚宽钢带、航空用中厚宽钢带、桥梁用中厚宽钢带、压力容器用中厚宽钢带、工程机械用中厚宽钢带、农机用中厚宽钢带、集装箱用中厚宽钢带、管线用中厚宽钢带、X60及以上管线用中厚宽钢带、建筑用中厚宽钢带、汽车用热轧薄宽钢带、造船用热轧薄宽钢带、搪瓷用热轧薄宽钢带、农机用热轧薄宽钢带、建筑用热轧薄宽钢带、集装箱用热轧薄宽钢带、公路用热轧薄宽钢带、轻工家电用热轧薄宽钢带、容器用热轧薄宽钢带、工程机械用热轧薄宽钢带、焊管用热轧薄宽钢带、汽",
                                        "taxName": "黑色金属冶炼压延品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080207100000000000",
                                        "taxCodeTitle": "黑色金属冶炼压延品",
                                        "iTitle": "*黑色金属冶炼压延品*钢带",
                                        "children": []
                                    },
                                    {
                                        "id": "2211",
                                        "linkid": "2200",
                                        "code": "108020711",
                                        "paCode": "1080207",
                                        "yn": "N",
                                        "title": "板带",
                                        "alias": "板带",
                                        "about": "包括镀层板带、涂层板带、电工钢板带等所有板带",
                                        "kws": "汽车用镀锌板带、轻工家电用镀锌板带、耐指纹板带、建筑用镀锌板带、机械用镀锌板带、包装用镀锡板带、建筑用涂层板带、机械用涂层板带、家电用涂层板带、家具用涂层板带、取向电工钢板带、无取向电工钢板带、热轧电工钢板带、冷轧电工钢板带、电工钢板、电工钢带",
                                        "taxName": "黑色金属冶炼压延品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080207110000000000",
                                        "taxCodeTitle": "黑色金属冶炼压延品",
                                        "iTitle": "*黑色金属冶炼压延品*板带",
                                        "children": []
                                    },
                                    {
                                        "id": "2212",
                                        "linkid": "2200",
                                        "code": "108020712",
                                        "paCode": "1080207",
                                        "yn": "N",
                                        "title": "无缝钢管",
                                        "alias": "无缝钢管",
                                        "about": "指具有中空截面，大量用作输送流体的管道，如输送石油、天然气、煤气、水及某些固体物料的管道等，不包括铸铁管（详见108020712）",
                                        "kws": "石油套管用无缝钢管、石油油管用无缝钢管、石油钻杆用无缝钢管、管线用无缝钢管、输送流体用无缝钢管、结构用无缝钢管、高压锅炉用无缝钢管、低中压锅炉用无缝钢管、气瓶用无缝钢管、高压化肥设备用无缝钢管、石油裂化用无缝钢管、锅炉热交换器用不锈钢无缝钢管、结构用不锈钢无缝钢管、流体输送用不锈钢无缝钢管、汽车半轴套用无缝钢管、金刚石岩芯钻探用无缝钢管、液压和气动钢筒用精密内径无缝钢管、轴承用无缝钢管、船舶用碳钢无缝钢管、碳锰钢无缝钢管、蓄能用无缝钢管、航空用无缝钢管、不锈耐酸钢极薄壁无缝钢管、不锈钢小直径无缝钢管、柴油",
                                        "taxName": "黑色金属冶炼压延品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080207120000000000",
                                        "taxCodeTitle": "黑色金属冶炼压延品",
                                        "iTitle": "*黑色金属冶炼压延品*无缝钢管",
                                        "children": []
                                    },
                                    {
                                        "id": "2213",
                                        "linkid": "2200",
                                        "code": "108020713",
                                        "paCode": "1080207",
                                        "yn": "N",
                                        "title": "焊接钢管",
                                        "alias": "焊接钢管",
                                        "about": "指用钢带或钢板弯曲变形为圆形、方形等形状后再焊接成的、表面有接缝的钢管",
                                        "kws": "石油套管用电阻焊钢管、石油油管用电阻焊钢管、管线用电阻焊钢管、管线用直缝埋弧焊接钢管、管线用螺旋缝焊接钢管、低压流体输送用焊接钢管、结构用直缝焊接钢管、结构用直缝埋弧焊接钢管、结构用螺旋缝焊接钢管、机械结构用不锈钢焊接钢管、流体输送用不锈钢焊接钢管、低中压锅炉用电焊钢管、换热器用焊接钢管、传动轴用电焊钢管、深井水泵用电焊钢管、普通碳素钢电线套管、带式输送机托辊用电焊钢管、装饰用焊接不锈钢管、矿用流体输送电焊钢管、双层卷焊钢管、镀锌管、镀铝管、S型钎焊不锈钢金属软管、P3型镀锌金属软管、不锈钢复合管",
                                        "taxName": "黑色金属冶炼压延品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080207130000000000",
                                        "taxCodeTitle": "黑色金属冶炼压延品",
                                        "iTitle": "*黑色金属冶炼压延品*焊接钢管",
                                        "children": []
                                    },
                                    {
                                        "id": "2214",
                                        "linkid": "2200",
                                        "code": "108020799",
                                        "paCode": "1080207",
                                        "yn": "N",
                                        "title": "其他钢材",
                                        "alias": "其他钢材",
                                        "about": "指除铁道用钢材、大型型钢、中小型型钢、棒材、钢筋、线材（盘条）、钢板、热轧薄板、冷轧薄板、钢带、板带、无缝钢管、焊接钢管以外的钢材；如钢铁企业锻钢车间生产的锻钢件（包括锻锤、精锻、快锻以及水压机、挤压机、液压机生产的锻钢件，也包括炼钢炉料，但不包括锻钢件中的型材（详见108020702、108020703）、棒材（详见108020704）和无缝钢管（详见108020712）、冷弯型钢、减振复合钢板等",
                                        "kws": "结构用冷弯型钢、汽车用冷弯型钢、卷帘门用冷弯型钢、钢窗用冷弯型钢、通用冷弯开口型钢、通用冷弯开口轮件、通用冷弯开口盘件、通用冷弯开口轴件、通用冷弯开口模块、通用冷弯开口环件、通用冷弯开口锻钢件、复合钢板、减振复合钢板、汽车用减振复合钢板、家电用减振复合钢板、不锈复合钢板",
                                        "taxName": "黑色金属冶炼压延品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080207990000000000",
                                        "taxCodeTitle": "黑色金属冶炼压延品",
                                        "iTitle": "*黑色金属冶炼压延品*其他钢材",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2215",
                                "linkid": "2189",
                                "code": "1080208",
                                "paCode": "10802",
                                "yn": "N",
                                "title": "铁合金",
                                "alias": "铁合金",
                                "about": "指炼钢时作为脱氧剂、元素添加剂等加入铁水中使钢具备某种特性或达到某种要求的一种产品，包括普通铁合金和特种铁合金",
                                "kws": "高炉锰铁、电炉普通铁合金、电炉锰铁、电炉中低碳锰铁、锰硅合金、电炉硅铁、高碳铬铁、电炉中低碳铬铁、微碳铬铁、钨铁、硅钨铁、钒铁、稀土铁合金、金属锰、磷铁、硼铁、金属硅、硅铬合金、硅钙合金、硅钙铁、硅钙钒合金、硅钡合金、硅钙钡合金、硅钙钡锶合金、硅铝钡钙锶合金、硅铝铁、硅铝、硅铝钡合金、硅镁合金、特种硅铁、转炉中碳锰铁、转炉低碳锰铁、转炉中碳铬铁、转炉低碳铬铁、钼铁、氧化钼铁、钛铁、铌铁、金属铬、硼铬合金、硼镍合金、钼铝合金、锆镁合金、锆铝合金、电解锰、电解铬、钒铝合金、真空铬铁、氮化锰铁、氮化钒铁、氮化铬",
                                "taxName": "黑色金属冶炼压延品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1080208000000000000",
                                "taxCodeTitle": "黑色金属冶炼压延品",
                                "iTitle": "*黑色金属冶炼压延品*铁合金",
                                "children": []
                            },
                            {
                                "id": "2216",
                                "linkid": "2189",
                                "code": "1080209",
                                "paCode": "10802",
                                "yn": "N",
                                "title": "废旧物资冶炼、提纯金属及合金",
                                "alias": "废旧物资冶炼、提纯金属及合金",
                                "about": "指利用废旧物资经冶炼、提纯或化合生产的金属、合金及金属化合，不包括铁（详见1080201）及铁合金（详见1080208）",
                                "kws": null,
                                "taxName": "黑色金属冶炼压延品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1080209000000000000",
                                "taxCodeTitle": "黑色金属冶炼压延品",
                                "iTitle": "*黑色金属冶炼压延品*废旧物资冶炼、提纯金属及合金",
                                "children": []
                            }
                        ]
                    },
                    {
                        "id": "2217",
                        "linkid": "2017",
                        "code": "10803",
                        "paCode": "108",
                        "yn": "Y",
                        "title": "有色金属冶炼及压延产品",
                        "alias": "有色金属冶炼及压延产品",
                        "about": "包括十种有色金属、镉、铋，相关常用有色金属、贵金属、稀有稀土金属、碱金属及碱土金属、有色金属合金",
                        "kws": null,
                        "taxName": "有色金属冶炼压延品",
                        "taxRate": "",
                        "vip": "7",
                        "itaxRate": null,
                        "taxCode": "1080300000000000000",
                        "taxCodeTitle": "有色金属冶炼压延品",
                        "iTitle": "*有色金属冶炼压延品*有色金属冶炼及压延产品",
                        "children": [
                            {
                                "id": "2218",
                                "linkid": "2217",
                                "code": "1080301",
                                "paCode": "10803",
                                "yn": "N",
                                "title": "铜",
                                "alias": "铜",
                                "about": "包括粗铜、阳极铜、精炼铜（电解铜）、直接利用再生铜",
                                "kws": "粗铜、矿产粗铜、再生粗铜、电积铜产粗铜、阳极铜、矿产阳极铜、再生阳极铜、电积铜产阳极铜、精炼铜、电解铜、矿产精炼铜、再生精炼铜、电积铜",
                                "taxName": "有色金属冶炼压延品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1080301000000000000",
                                "taxCodeTitle": "有色金属冶炼压延品",
                                "iTitle": "*有色金属冶炼压延品*铜",
                                "children": []
                            },
                            {
                                "id": "2219",
                                "linkid": "2217",
                                "code": "1080302",
                                "paCode": "10803",
                                "yn": "Y",
                                "title": "铅锌",
                                "alias": "铅锌",
                                "about": "包括铅和锌",
                                "kws": null,
                                "taxName": "有色金属冶炼压延品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080302000000000000",
                                "taxCodeTitle": "有色金属冶炼压延品",
                                "iTitle": "*有色金属冶炼压延品*铅锌",
                                "children": [
                                    {
                                        "id": "2220",
                                        "linkid": "2219",
                                        "code": "108030201",
                                        "paCode": "1080302",
                                        "yn": "N",
                                        "title": "铅",
                                        "alias": "铅",
                                        "about": "指用铅精矿和铅废料为原料生产的电铅（铅锭，含一号铅至三号铅，含铅≥99%）、铅基合金（含铅≥99%）、铸造锡铅焊料折铅（不含用成品铅作原料铸造的焊锡料和铅基合金）、其他铅（含铅≥99%）",
                                        "kws": "粗铅、矿产粗铅、再生粗铅、铅、矿产铅、再生铅、商品粗锌",
                                        "taxName": "有色金属冶炼压延品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080302010000000000",
                                        "taxCodeTitle": "有色金属冶炼压延品",
                                        "iTitle": "*有色金属冶炼压延品*铅",
                                        "children": []
                                    },
                                    {
                                        "id": "2221",
                                        "linkid": "2219",
                                        "code": "108030202",
                                        "paCode": "1080302",
                                        "yn": "N",
                                        "title": "锌",
                                        "alias": "锌",
                                        "about": "指以锌精矿或锌废碎料作原料经粗炼和精炼工艺生产的锌产品（包括电锌、精锌、商品蒸馏锌和锌品）",
                                        "kws": "锌、矿产锌、矿产电锌、矿产精锌、矿产商品蒸镏锌、锌品、再生锌、再生电锌、再生精锌、再生商品蒸镏锌",
                                        "taxName": "有色金属冶炼压延品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080302020000000000",
                                        "taxCodeTitle": "有色金属冶炼压延品",
                                        "iTitle": "*有色金属冶炼压延品*锌",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2222",
                                "linkid": "2217",
                                "code": "1080303",
                                "paCode": "10803",
                                "yn": "N",
                                "title": "镍",
                                "alias": "镍",
                                "about": "指以镍精矿及镍废碎料等物料为原料，经冶炼生产的镍产品",
                                "kws": "镍、高冰镍含镍量、高冰镍实物量、水淬镍、电镍、矿产镍、再生镍、湿法冶炼浸出镍、镍盐",
                                "taxName": "有色金属冶炼压延品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1080303000000000000",
                                "taxCodeTitle": "有色金属冶炼压延品",
                                "iTitle": "*有色金属冶炼压延品*镍",
                                "children": []
                            },
                            {
                                "id": "2223",
                                "linkid": "2217",
                                "code": "1080304",
                                "paCode": "10803",
                                "yn": "N",
                                "title": "锡",
                                "alias": "锡",
                                "about": "指未煅轧锡，包括电锡、精锡、锡基合金折锡、铸造锡铅焊料折锡",
                                "kws": "锡、矿产电锡、矿产精锡、再生锡",
                                "taxName": "有色金属冶炼压延品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1080304000000000000",
                                "taxCodeTitle": "有色金属冶炼压延品",
                                "iTitle": "*有色金属冶炼压延品*锡",
                                "children": []
                            },
                            {
                                "id": "2224",
                                "linkid": "2217",
                                "code": "1080305",
                                "paCode": "10803",
                                "yn": "N",
                                "title": "锑",
                                "alias": "锑",
                                "about": "包括锑品（矿产）、三氧化二锑、精锑、高铅锑、生锑（硫化锑）、其他未锻轧锑、再生锑",
                                "kws": "矿产锑品、三氧化二锑、精锑、高铅锑、生锑、硫化锑、再生锑",
                                "taxName": "有色金属冶炼压延品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1080305000000000000",
                                "taxCodeTitle": "有色金属冶炼压延品",
                                "iTitle": "*有色金属冶炼压延品*锑",
                                "children": []
                            },
                            {
                                "id": "2225",
                                "linkid": "2217",
                                "code": "1080306",
                                "paCode": "10803",
                                "yn": "Y",
                                "title": "铝",
                                "alias": "铝",
                                "about": "包括氧化铝、原铝、再生铝",
                                "kws": "氧化铝、原铝、再生铝",
                                "taxName": "有色金属冶炼压延品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080306000000000000",
                                "taxCodeTitle": "有色金属冶炼压延品",
                                "iTitle": "*有色金属冶炼压延品*铝",
                                "children": [
                                    {
                                        "id": "2226",
                                        "linkid": "2225",
                                        "code": "108030601",
                                        "paCode": "1080306",
                                        "yn": "N",
                                        "title": "氧化铝",
                                        "alias": "氧化铝",
                                        "about": "指将铝矾土原料经过化学处理，除去硅、铁、钛等的氧化物而制得",
                                        "kws": "氧化铝、冶金级氧化铝、一级品氧化铝、二级品氧化铝、三级品氧化铝、四级品氧化铝、普通氢氧化铝、特种氢氧化铝、白色氢氧化铝、细氢氧化铝、填料氢氧化铝、玛瑙填料氢氧化铝、活性氧化铝、煅烧氧化铝、煅烧氧化铝微粉、助燃剂用低温氧化铝、高纯氧化铝、电工填料氧化铝",
                                        "taxName": "有色金属冶炼压延品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080306010000000000",
                                        "taxCodeTitle": "有色金属冶炼压延品",
                                        "iTitle": "*有色金属冶炼压延品*氧化铝",
                                        "children": []
                                    },
                                    {
                                        "id": "2227",
                                        "linkid": "2225",
                                        "code": "108030602",
                                        "paCode": "1080306",
                                        "yn": "N",
                                        "title": "原铝（电解铝）",
                                        "alias": "原铝（电解铝）",
                                        "about": "指以氧化铝为原料生产的电解铝及直接用铝液生产的铝合金、铝母线、铝板卷及铝导杆等产品。",
                                        "kws": "原铝、电解铝、重熔用铝锭、脱氧铝、铝母线、铝板卷、铝导杆、原铝铝合金",
                                        "taxName": "有色金属冶炼压延品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080306020000000000",
                                        "taxCodeTitle": "有色金属冶炼压延品",
                                        "iTitle": "*有色金属冶炼压延品*原铝（电解铝）",
                                        "children": []
                                    },
                                    {
                                        "id": "2228",
                                        "linkid": "2225",
                                        "code": "108030603",
                                        "paCode": "1080306",
                                        "yn": "N",
                                        "title": "再生铝",
                                        "alias": "再生铝",
                                        "about": "指以废旧铝为原料通过废熔炉生产的再生铝，包括再生铝锭、再生铝合金及铝加工、制品企业熔铸使用的再生铝",
                                        "kws": "再生铝、再生铝锭、再生铝合金、加工再生铝、直接利用再生铝",
                                        "taxName": "有色金属冶炼压延品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080306030000000000",
                                        "taxCodeTitle": "有色金属冶炼压延品",
                                        "iTitle": "*有色金属冶炼压延品*再生铝",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2229",
                                "linkid": "2217",
                                "code": "1080307",
                                "paCode": "10803",
                                "yn": "N",
                                "title": "镁",
                                "alias": "镁",
                                "about": "包括原生镁（矿产镁锭）、再生镁、镁环、镁粒（粉）",
                                "kws": "原生镁、矿产镁锭、再生镁、镁环、镁粒、镁粉",
                                "taxName": "有色金属冶炼压延品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1080307000000000000",
                                "taxCodeTitle": "有色金属冶炼压延品",
                                "iTitle": "*有色金属冶炼压延品*镁",
                                "children": []
                            },
                            {
                                "id": "2230",
                                "linkid": "2217",
                                "code": "1080308",
                                "paCode": "10803",
                                "yn": "N",
                                "title": "钛",
                                "alias": "钛",
                                "about": "包括钛、海绵钛、高钛渣",
                                "kws": "钛、海绵钛、高钛渣",
                                "taxName": "有色金属冶炼压延品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1080308000000000000",
                                "taxCodeTitle": "有色金属冶炼压延品",
                                "iTitle": "*有色金属冶炼压延品*钛",
                                "children": []
                            },
                            {
                                "id": "2231",
                                "linkid": "2217",
                                "code": "1080309",
                                "paCode": "10803",
                                "yn": "N",
                                "title": "汞及汞化合物",
                                "alias": "汞及汞化合物",
                                "about": "包括汞（金属汞）、氧化汞、汞触媒，不包括朱砂（详见107021003）",
                                "kws": "汞、金属汞、氧化汞、汞触媒",
                                "taxName": "有色金属冶炼压延品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1080309000000000000",
                                "taxCodeTitle": "有色金属冶炼压延品",
                                "iTitle": "*有色金属冶炼压延品*汞及汞化合物",
                                "children": []
                            },
                            {
                                "id": "2232",
                                "linkid": "2217",
                                "code": "1080310",
                                "paCode": "10803",
                                "yn": "Y",
                                "title": "镉、铋，相关常用有色金属",
                                "alias": "镉、铋，相关常用有色金属",
                                "about": "包括镉、铋、钴和相关常用有色金属",
                                "kws": null,
                                "taxName": "有色金属冶炼压延品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080310000000000000",
                                "taxCodeTitle": "有色金属冶炼压延品",
                                "iTitle": "*有色金属冶炼压延品*镉、铋，相关常用有色金属",
                                "children": [
                                    {
                                        "id": "2233",
                                        "linkid": "2232",
                                        "code": "108031001",
                                        "paCode": "1080310",
                                        "yn": "N",
                                        "title": "镉",
                                        "alias": "镉",
                                        "about": "指用重有色金属伴生矿作原料经冶炼工艺综合回收的精镉（锭）和镉废碎料作原料生产的精镉（镉锭）",
                                        "kws": "镉、矿产镉、电解镉、精镉、再生镉",
                                        "taxName": "有色金属冶炼压延品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080310010000000000",
                                        "taxCodeTitle": "有色金属冶炼压延品",
                                        "iTitle": "*有色金属冶炼压延品*镉",
                                        "children": []
                                    },
                                    {
                                        "id": "2234",
                                        "linkid": "2232",
                                        "code": "108031002",
                                        "paCode": "1080310",
                                        "yn": "N",
                                        "title": "铋",
                                        "alias": "铋",
                                        "about": "包括矿产铋、一号铋、二号铋、其他矿产铋、再生铋",
                                        "kws": "矿产铋、一号铋、二号铋、再生铋",
                                        "taxName": "有色金属冶炼压延品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080310020000000000",
                                        "taxCodeTitle": "有色金属冶炼压延品",
                                        "iTitle": "*有色金属冶炼压延品*铋",
                                        "children": []
                                    },
                                    {
                                        "id": "2235",
                                        "linkid": "2232",
                                        "code": "108031003",
                                        "paCode": "1080310",
                                        "yn": "N",
                                        "title": "钴",
                                        "alias": "钴",
                                        "about": "包括氧化钴、金属钴、电解钴、电积钴、钴铁、其他钴盐",
                                        "kws": "氧化钴、金属钴、电解钴、电积钴、钴铁",
                                        "taxName": "有色金属冶炼压延品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080310030000000000",
                                        "taxCodeTitle": "有色金属冶炼压延品",
                                        "iTitle": "*有色金属冶炼压延品*钴",
                                        "children": []
                                    },
                                    {
                                        "id": "2236",
                                        "linkid": "2232",
                                        "code": "108031099",
                                        "paCode": "1080310",
                                        "yn": "N",
                                        "title": "其他常用有色金属",
                                        "alias": "其他常用有色金属",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "有色金属冶炼压延品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080310990000000000",
                                        "taxCodeTitle": "有色金属冶炼压延品",
                                        "iTitle": "*有色金属冶炼压延品*其他常用有色金属",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2237",
                                "linkid": "2217",
                                "code": "1080311",
                                "paCode": "10803",
                                "yn": "Y",
                                "title": "贵金属",
                                "alias": "贵金属",
                                "about": "包括黄金、白银、铂、钯、铑、铱、锇、钌和其他贵金属",
                                "kws": "黄金、白银、铂、钯、铑、铱、锇、钌",
                                "taxName": "贵金属",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080311000000000000",
                                "taxCodeTitle": "贵金属",
                                "iTitle": "*贵金属*贵金属",
                                "children": [
                                    {
                                        "id": "2238",
                                        "linkid": "2237",
                                        "code": "108031101",
                                        "paCode": "1080311",
                                        "yn": "Y",
                                        "title": "黄金",
                                        "alias": "黄金",
                                        "about": "指矿山成品金和冶炼产金（金锭），产品为一号、二号、三号金，含金≥99.9%",
                                        "kws": "黄金、矿山成品金、冶炼产金、金矿料产金、有色料副产金、再生金",
                                        "taxName": "黄金",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1080311010000000000",
                                        "taxCodeTitle": "黄金",
                                        "iTitle": "*黄金*黄金",
                                        "children": [
                                            {
                                                "id": "2239",
                                                "linkid": "2238",
                                                "code": "10803110101",
                                                "paCode": "108031101",
                                                "yn": "N",
                                                "title": "黄金矿砂（含伴生金）",
                                                "alias": "黄金矿砂（含伴生金）",
                                                "about": null,
                                                "kws": "黄金矿砂、伴生金",
                                                "taxName": "黄金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080311010100000000",
                                                "taxCodeTitle": "黄金",
                                                "iTitle": "*黄金*黄金矿砂（含伴生金）",
                                                "children": []
                                            },
                                            {
                                                "id": "2240",
                                                "linkid": "2238",
                                                "code": "10803110102",
                                                "paCode": "108031101",
                                                "yn": "N",
                                                "title": "其他黄金",
                                                "alias": "其他黄金",
                                                "about": null,
                                                "kws": null,
                                                "taxName": "黄金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080311010200000000",
                                                "taxCodeTitle": "黄金",
                                                "iTitle": "*黄金*其他黄金",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "2241",
                                        "linkid": "2237",
                                        "code": "108031102",
                                        "paCode": "1080311",
                                        "yn": "N",
                                        "title": "白银（银锭）",
                                        "alias": "白银（银锭）",
                                        "about": "指用银精矿及废杂银（回收的再生银）作原料生产的银（银锭），产品含一号、二号、三号银，银≥99.9%",
                                        "kws": "白银、银锭、银矿料产银、银矿料产银粉、银矿料产高纯银、金矿料产银、金矿料产银粉、金矿料产高纯银、有色料产银、有色副产银、有色料产银粉、有色料产高纯银、再生银、再生银粉、再生高纯银",
                                        "taxName": "其他贵金属",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080311020000000000",
                                        "taxCodeTitle": "其他贵金属",
                                        "iTitle": "*其他贵金属*白银（银锭）",
                                        "children": []
                                    },
                                    {
                                        "id": "2242",
                                        "linkid": "2237",
                                        "code": "108031103",
                                        "paCode": "1080311",
                                        "yn": "N",
                                        "title": "铂",
                                        "alias": "铂",
                                        "about": "包括金属铂（铂锭）、矿产铂、再生铂、铂粉",
                                        "kws": "金属铂、铂锭、矿产铂、再生铂、铂粉",
                                        "taxName": "其他贵金属",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080311030000000000",
                                        "taxCodeTitle": "其他贵金属",
                                        "iTitle": "*其他贵金属*铂",
                                        "children": []
                                    },
                                    {
                                        "id": "2243",
                                        "linkid": "2237",
                                        "code": "108031104",
                                        "paCode": "1080311",
                                        "yn": "N",
                                        "title": "钯",
                                        "alias": "钯",
                                        "about": "包括金属钯、矿产钯、再生钯、钯粉",
                                        "kws": "钯、金属钯、矿产钯、再生钯、钯粉",
                                        "taxName": "其他贵金属",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080311040000000000",
                                        "taxCodeTitle": "其他贵金属",
                                        "iTitle": "*其他贵金属*钯",
                                        "children": []
                                    },
                                    {
                                        "id": "2244",
                                        "linkid": "2237",
                                        "code": "108031105",
                                        "paCode": "1080311",
                                        "yn": "N",
                                        "title": "铑",
                                        "alias": "铑",
                                        "about": "包括未锻造铑、铑粉。",
                                        "kws": "铑、未锻造铑、铑粉",
                                        "taxName": "其他贵金属",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080311050000000000",
                                        "taxCodeTitle": "其他贵金属",
                                        "iTitle": "*其他贵金属*铑",
                                        "children": []
                                    },
                                    {
                                        "id": "2245",
                                        "linkid": "2237",
                                        "code": "108031106",
                                        "paCode": "1080311",
                                        "yn": "N",
                                        "title": "铱",
                                        "alias": "铱",
                                        "about": "包括未锻造铱、铱粉。",
                                        "kws": "铱、未锻造铱、铱粉",
                                        "taxName": "其他贵金属",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080311060000000000",
                                        "taxCodeTitle": "其他贵金属",
                                        "iTitle": "*其他贵金属*铱",
                                        "children": []
                                    },
                                    {
                                        "id": "2246",
                                        "linkid": "2237",
                                        "code": "108031107",
                                        "paCode": "1080311",
                                        "yn": "N",
                                        "title": "锇",
                                        "alias": "锇",
                                        "about": "包括未锻造锇、锇粉。",
                                        "kws": "锇、未锻造锇、锇粉",
                                        "taxName": "其他贵金属",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080311070000000000",
                                        "taxCodeTitle": "其他贵金属",
                                        "iTitle": "*其他贵金属*锇",
                                        "children": []
                                    },
                                    {
                                        "id": "2247",
                                        "linkid": "2237",
                                        "code": "108031108",
                                        "paCode": "1080311",
                                        "yn": "N",
                                        "title": "钌",
                                        "alias": "钌",
                                        "about": "包括未锻造钌、钌粉。",
                                        "kws": "钌、未锻造钌、钌粉",
                                        "taxName": "其他贵金属",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080311080000000000",
                                        "taxCodeTitle": "其他贵金属",
                                        "iTitle": "*其他贵金属*钌",
                                        "children": []
                                    },
                                    {
                                        "id": "2248",
                                        "linkid": "2237",
                                        "code": "108031199",
                                        "paCode": "1080311",
                                        "yn": "N",
                                        "title": "其他贵金属",
                                        "alias": "其他贵金属",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "其他贵金属",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080311990000000000",
                                        "taxCodeTitle": "其他贵金属",
                                        "iTitle": "*其他贵金属*其他贵金属",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2249",
                                "linkid": "2217",
                                "code": "1080312",
                                "paCode": "10803",
                                "yn": "Y",
                                "title": "稀有稀土金属",
                                "alias": "稀有稀土金属",
                                "about": "包括稀有金属、单一稀土金属、其他单一稀土金属、混合稀土金属",
                                "kws": null,
                                "taxName": "稀有稀土金属",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080312000000000000",
                                "taxCodeTitle": "稀有稀土金属",
                                "iTitle": "*稀有稀土金属*稀有稀土金属",
                                "children": [
                                    {
                                        "id": "2250",
                                        "linkid": "2249",
                                        "code": "108031201",
                                        "paCode": "1080312",
                                        "yn": "Y",
                                        "title": "稀有金属",
                                        "alias": "稀有金属",
                                        "about": "包括钨、钼、钽、铌、锆、铍（金属铍）、铊（金属铊）、镓、铪、铟、铼（金属铼）、其他稀有金属",
                                        "kws": null,
                                        "taxName": "稀有金属",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1080312010000000000",
                                        "taxCodeTitle": "稀有金属",
                                        "iTitle": "*稀有金属*稀有金属",
                                        "children": [
                                            {
                                                "id": "2251",
                                                "linkid": "2250",
                                                "code": "10803120101",
                                                "paCode": "108031201",
                                                "yn": "N",
                                                "title": "钨",
                                                "alias": "钨",
                                                "about": "指用钨精矿、仲钨酸铵及氧化钨作原料生产的钨冶炼产品，是钨材及硬质合金原料",
                                                "kws": "钨、钯粉、钨粉、钨条、钨杆、钨粒、钨板坯",
                                                "taxName": "稀有金属",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080312010100000000",
                                                "taxCodeTitle": "稀有金属",
                                                "iTitle": "*稀有金属*钨",
                                                "children": []
                                            },
                                            {
                                                "id": "2252",
                                                "linkid": "2250",
                                                "code": "10803120102",
                                                "paCode": "108031201",
                                                "yn": "N",
                                                "title": "钼",
                                                "alias": "钼",
                                                "about": "指用钼精矿、氧化钼及钼酸铵作原料生产的钼冶炼产品，是钼材及硬质合金原料",
                                                "kws": "钼、钼粉、钼条、钼杆",
                                                "taxName": "稀有金属",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080312010200000000",
                                                "taxCodeTitle": "稀有金属",
                                                "iTitle": "*稀有金属*钼",
                                                "children": []
                                            },
                                            {
                                                "id": "2253",
                                                "linkid": "2250",
                                                "code": "10803120103",
                                                "paCode": "108031201",
                                                "yn": "N",
                                                "title": "钽",
                                                "alias": "钽",
                                                "about": "指用钽铌精矿、钽氧化物及氟钽酸钾等物料作原料经火法或湿法冶炼生产的钽金属",
                                                "kws": "钽、钽锭、钽条、钽杆、电容器级钽粉、冶金级钽粉",
                                                "taxName": "稀有金属",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080312010300000000",
                                                "taxCodeTitle": "稀有金属",
                                                "iTitle": "*稀有金属*钽",
                                                "children": []
                                            },
                                            {
                                                "id": "2254",
                                                "linkid": "2250",
                                                "code": "10803120104",
                                                "paCode": "108031201",
                                                "yn": "N",
                                                "title": "铌",
                                                "alias": "铌",
                                                "about": "指用钽铌精矿、铌氧化物等物料作原料经火法或湿法冶炼生产的铌金属",
                                                "kws": "铌、铌条、铌锭、铌合金条、铌粉",
                                                "taxName": "稀有金属",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080312010400000000",
                                                "taxCodeTitle": "稀有金属",
                                                "iTitle": "*稀有金属*铌",
                                                "children": []
                                            },
                                            {
                                                "id": "2255",
                                                "linkid": "2250",
                                                "code": "10803120105",
                                                "paCode": "108031201",
                                                "yn": "N",
                                                "title": "锆",
                                                "alias": "锆",
                                                "about": "指用锆英石等物料为原料经冶炼生产的产品",
                                                "kws": "锆、海绵锆、锆粉",
                                                "taxName": "稀有金属",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080312010500000000",
                                                "taxCodeTitle": "稀有金属",
                                                "iTitle": "*稀有金属*锆",
                                                "children": []
                                            },
                                            {
                                                "id": "2256",
                                                "linkid": "2250",
                                                "code": "10803120106",
                                                "paCode": "108031201",
                                                "yn": "N",
                                                "title": "铍（金属铍）",
                                                "alias": "铍（金属铍）",
                                                "about": "指用铍矿石、工业氧化铍及铍废碎料为原料，经电解法和还原法生产的金属铍",
                                                "kws": "铍、金属铍、矿产铍、再生铍",
                                                "taxName": "稀有金属",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080312010600000000",
                                                "taxCodeTitle": "稀有金属",
                                                "iTitle": "*稀有金属*铍（金属铍）",
                                                "children": []
                                            },
                                            {
                                                "id": "2257",
                                                "linkid": "2250",
                                                "code": "10803120107",
                                                "paCode": "108031201",
                                                "yn": "N",
                                                "title": "铊（金属铊）",
                                                "alias": "铊（金属铊）",
                                                "about": "指在冶炼铜、铅锌等金属产品时综合回收的铊金属，铊含量一般在四个九以上",
                                                "kws": "铊、金属铊、原生铊、矿产铊、再生铊",
                                                "taxName": "稀有金属",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080312010700000000",
                                                "taxCodeTitle": "稀有金属",
                                                "iTitle": "*稀有金属*铊（金属铊）",
                                                "children": []
                                            },
                                            {
                                                "id": "2258",
                                                "linkid": "2250",
                                                "code": "10803120108",
                                                "paCode": "108031201",
                                                "yn": "N",
                                                "title": "镓",
                                                "alias": "镓",
                                                "about": "指在生产氧化铝过程中从铝土矿中回收金属镓（工业镓），包括原生镓和再生镓，镓含量99.99%",
                                                "kws": "镓、原生镓、矿产镓、再生镓",
                                                "taxName": "稀有金属",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080312010800000000",
                                                "taxCodeTitle": "稀有金属",
                                                "iTitle": "*稀有金属*镓",
                                                "children": []
                                            },
                                            {
                                                "id": "2259",
                                                "linkid": "2250",
                                                "code": "10803120109",
                                                "paCode": "108031201",
                                                "yn": "N",
                                                "title": "铪",
                                                "alias": "铪",
                                                "about": "指铪的冶炼产品，用于核能及军工领域",
                                                "kws": "铪、海绵铪、铪粉",
                                                "taxName": "稀有金属",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080312010900000000",
                                                "taxCodeTitle": "稀有金属",
                                                "iTitle": "*稀有金属*铪",
                                                "children": []
                                            },
                                            {
                                                "id": "2260",
                                                "linkid": "2250",
                                                "code": "10803120110",
                                                "paCode": "108031201",
                                                "yn": "N",
                                                "title": "铟",
                                                "alias": "铟",
                                                "about": "指属于稀散金属，金属铟主要来自铜、铅、锌及锡等有色金属冶炼过程中富集物的回收，铟分为In99.9%、In99.97%、In99.993%三个品种",
                                                "kws": "铟、原生铟、铟锭、再生铟",
                                                "taxName": "稀有金属",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080312011000000000",
                                                "taxCodeTitle": "稀有金属",
                                                "iTitle": "*稀有金属*铟",
                                                "children": []
                                            },
                                            {
                                                "id": "2261",
                                                "linkid": "2250",
                                                "code": "10803120111",
                                                "paCode": "108031201",
                                                "yn": "N",
                                                "title": "铼（金属铼）",
                                                "alias": "铼（金属铼）",
                                                "about": "指属于稀散金属，原料是与铜、钼、铀等矿伴生，在冶炼铜、钼等金属工程中采用氧化焙烧-沉淀法、石灰烧结法、萃取法、离子交换法、电溶氧化法及高压浸煮法等传统提铼方法提取金属铼",
                                                "kws": "铼、金属铼、矿产铼、再生铼",
                                                "taxName": "稀有金属",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080312011100000000",
                                                "taxCodeTitle": "稀有金属",
                                                "iTitle": "*稀有金属*铼（金属铼）",
                                                "children": []
                                            },
                                            {
                                                "id": "2262",
                                                "linkid": "2250",
                                                "code": "10803120199",
                                                "paCode": "108031201",
                                                "yn": "N",
                                                "title": "其他稀有金属",
                                                "alias": "其他稀有金属",
                                                "about": null,
                                                "kws": null,
                                                "taxName": "稀有金属",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080312019900000000",
                                                "taxCodeTitle": "稀有金属",
                                                "iTitle": "*稀有金属*其他稀有金属",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "2263",
                                        "linkid": "2249",
                                        "code": "108031202",
                                        "paCode": "1080312",
                                        "yn": "Y",
                                        "title": "单一稀土金属",
                                        "alias": "单一稀土金属",
                                        "about": "指采用熔盐电解、金属热还原和火法提纯三种冶炼工艺生产的单一稀土金属产品；单一稀土金属有17种，分为铈组轻金属7种：镧、铈、镨、钕、钷、钐、铕；钇组重金属9种：钆、铽、镝、钬、铒、铥、镱、镥和钇；钪为另类稀土金属。本类均指经冶炼后的单一稀土金属，且该单一稀土金属含量≥99%",
                                        "kws": "单一稀土金属",
                                        "taxName": "稀土金属及合金",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1080312020000000000",
                                        "taxCodeTitle": "稀土金属及合金",
                                        "iTitle": "*稀土金属及合金*单一稀土金属",
                                        "children": [
                                            {
                                                "id": "2264",
                                                "linkid": "2263",
                                                "code": "10803120201",
                                                "paCode": "108031202",
                                                "yn": "N",
                                                "title": "钕",
                                                "alias": "钕",
                                                "about": "指经冶炼后的单一稀土金属钕，金属含量≥99%",
                                                "kws": "金属钕",
                                                "taxName": "稀土金属及合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080312020100000000",
                                                "taxCodeTitle": "稀土金属及合金",
                                                "iTitle": "*稀土金属及合金*钕",
                                                "children": []
                                            },
                                            {
                                                "id": "2265",
                                                "linkid": "2263",
                                                "code": "10803120202",
                                                "paCode": "108031202",
                                                "yn": "N",
                                                "title": "镝",
                                                "alias": "镝",
                                                "about": "指经冶炼后的单一稀土金属镝，金属含量≥99%",
                                                "kws": "金属镝",
                                                "taxName": "稀土金属及合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080312020200000000",
                                                "taxCodeTitle": "稀土金属及合金",
                                                "iTitle": "*稀土金属及合金*镝",
                                                "children": []
                                            },
                                            {
                                                "id": "2266",
                                                "linkid": "2263",
                                                "code": "10803120203",
                                                "paCode": "108031202",
                                                "yn": "N",
                                                "title": "镧",
                                                "alias": "镧",
                                                "about": "指经冶炼后的单一稀土金属镧，金属含量≥99%",
                                                "kws": "金属镧",
                                                "taxName": "稀土金属及合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080312020300000000",
                                                "taxCodeTitle": "稀土金属及合金",
                                                "iTitle": "*稀土金属及合金*镧",
                                                "children": []
                                            },
                                            {
                                                "id": "2267",
                                                "linkid": "2263",
                                                "code": "10803120204",
                                                "paCode": "108031202",
                                                "yn": "N",
                                                "title": "镨",
                                                "alias": "镨",
                                                "about": "指经冶炼后的单一稀土金属镨，金属含量≥99%",
                                                "kws": "金属镨",
                                                "taxName": "稀土金属及合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080312020400000000",
                                                "taxCodeTitle": "稀土金属及合金",
                                                "iTitle": "*稀土金属及合金*镨",
                                                "children": []
                                            },
                                            {
                                                "id": "2268",
                                                "linkid": "2263",
                                                "code": "10803120205",
                                                "paCode": "108031202",
                                                "yn": "N",
                                                "title": "钐",
                                                "alias": "钐",
                                                "about": "指经冶炼后的单一稀土金属钐，金属含量≥99%",
                                                "kws": "金属钐",
                                                "taxName": "稀土金属及合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080312020500000000",
                                                "taxCodeTitle": "稀土金属及合金",
                                                "iTitle": "*稀土金属及合金*钐",
                                                "children": []
                                            },
                                            {
                                                "id": "2269",
                                                "linkid": "2263",
                                                "code": "10803120206",
                                                "paCode": "108031202",
                                                "yn": "N",
                                                "title": "铕",
                                                "alias": "铕",
                                                "about": "指经冶炼后的单一稀土金属铕，金属含量≥99%",
                                                "kws": "金属铕",
                                                "taxName": "稀土金属及合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080312020600000000",
                                                "taxCodeTitle": "稀土金属及合金",
                                                "iTitle": "*稀土金属及合金*铕",
                                                "children": []
                                            },
                                            {
                                                "id": "2270",
                                                "linkid": "2263",
                                                "code": "10803120207",
                                                "paCode": "108031202",
                                                "yn": "N",
                                                "title": "钆",
                                                "alias": "钆",
                                                "about": "指经冶炼后的单一稀土金属钆，金属含量≥99%",
                                                "kws": "金属钆",
                                                "taxName": "稀土金属及合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080312020700000000",
                                                "taxCodeTitle": "稀土金属及合金",
                                                "iTitle": "*稀土金属及合金*钆",
                                                "children": []
                                            },
                                            {
                                                "id": "2271",
                                                "linkid": "2263",
                                                "code": "10803120208",
                                                "paCode": "108031202",
                                                "yn": "N",
                                                "title": "铽",
                                                "alias": "铽",
                                                "about": "指经冶炼后的单一稀土金属铽，金属含量≥99%",
                                                "kws": "金属铽",
                                                "taxName": "稀土金属及合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080312020800000000",
                                                "taxCodeTitle": "稀土金属及合金",
                                                "iTitle": "*稀土金属及合金*铽",
                                                "children": []
                                            },
                                            {
                                                "id": "2272",
                                                "linkid": "2263",
                                                "code": "10803120209",
                                                "paCode": "108031202",
                                                "yn": "N",
                                                "title": "钪",
                                                "alias": "钪",
                                                "about": "指经冶炼后的单一稀土金属钪，金属含量≥99%",
                                                "kws": "金属钪",
                                                "taxName": "稀土金属及合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080312020900000000",
                                                "taxCodeTitle": "稀土金属及合金",
                                                "iTitle": "*稀土金属及合金*钪",
                                                "children": []
                                            },
                                            {
                                                "id": "2273",
                                                "linkid": "2263",
                                                "code": "10803120210",
                                                "paCode": "108031202",
                                                "yn": "N",
                                                "title": "钇",
                                                "alias": "钇",
                                                "about": "指经冶炼后的单一稀土金属钇，金属含量≥99%",
                                                "kws": "金属钇",
                                                "taxName": "稀土金属及合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080312021000000000",
                                                "taxCodeTitle": "稀土金属及合金",
                                                "iTitle": "*稀土金属及合金*钇",
                                                "children": []
                                            },
                                            {
                                                "id": "2274",
                                                "linkid": "2263",
                                                "code": "10803120211",
                                                "paCode": "108031202",
                                                "yn": "N",
                                                "title": "钬",
                                                "alias": "钬",
                                                "about": "指经冶炼后的单一稀土金属钬，金属含量≥99%",
                                                "kws": "金属钬",
                                                "taxName": "稀土金属及合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080312021100000000",
                                                "taxCodeTitle": "稀土金属及合金",
                                                "iTitle": "*稀土金属及合金*钬",
                                                "children": []
                                            },
                                            {
                                                "id": "2275",
                                                "linkid": "2263",
                                                "code": "10803120212",
                                                "paCode": "108031202",
                                                "yn": "N",
                                                "title": "铈",
                                                "alias": "铈",
                                                "about": "指经冶炼后的单一稀土金属铈，金属含量≥99%",
                                                "kws": "金属铈",
                                                "taxName": "稀土金属及合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080312021200000000",
                                                "taxCodeTitle": "稀土金属及合金",
                                                "iTitle": "*稀土金属及合金*铈",
                                                "children": []
                                            },
                                            {
                                                "id": "2276",
                                                "linkid": "2263",
                                                "code": "10803120213",
                                                "paCode": "108031202",
                                                "yn": "N",
                                                "title": "铒",
                                                "alias": "铒",
                                                "about": "指经冶炼后的单一稀土金属铒，金属含量≥99%",
                                                "kws": "金属铒",
                                                "taxName": "稀土金属及合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080312021300000000",
                                                "taxCodeTitle": "稀土金属及合金",
                                                "iTitle": "*稀土金属及合金*铒",
                                                "children": []
                                            },
                                            {
                                                "id": "2277",
                                                "linkid": "2263",
                                                "code": "10803120214",
                                                "paCode": "108031202",
                                                "yn": "N",
                                                "title": "铥",
                                                "alias": "铥",
                                                "about": "指经冶炼后的单一稀土金属銩，金属含量≥99%",
                                                "kws": "金属铥",
                                                "taxName": "稀土金属及合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080312021400000000",
                                                "taxCodeTitle": "稀土金属及合金",
                                                "iTitle": "*稀土金属及合金*铥",
                                                "children": []
                                            },
                                            {
                                                "id": "2278",
                                                "linkid": "2263",
                                                "code": "10803120215",
                                                "paCode": "108031202",
                                                "yn": "N",
                                                "title": "钷",
                                                "alias": "钷",
                                                "about": null,
                                                "kws": "金属钷",
                                                "taxName": "稀土金属及合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080312021500000000",
                                                "taxCodeTitle": "稀土金属及合金",
                                                "iTitle": "*稀土金属及合金*钷",
                                                "children": []
                                            },
                                            {
                                                "id": "2279",
                                                "linkid": "2263",
                                                "code": "10803120216",
                                                "paCode": "108031202",
                                                "yn": "N",
                                                "title": "镱",
                                                "alias": "镱",
                                                "about": null,
                                                "kws": "金属镱",
                                                "taxName": "稀土金属及合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080312021600000000",
                                                "taxCodeTitle": "稀土金属及合金",
                                                "iTitle": "*稀土金属及合金*镱",
                                                "children": []
                                            },
                                            {
                                                "id": "2280",
                                                "linkid": "2263",
                                                "code": "10803120217",
                                                "paCode": "108031202",
                                                "yn": "N",
                                                "title": "镥",
                                                "alias": "镥",
                                                "about": null,
                                                "kws": "金属镥",
                                                "taxName": "稀土金属及合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080312021700000000",
                                                "taxCodeTitle": "稀土金属及合金",
                                                "iTitle": "*稀土金属及合金*镥",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "2281",
                                        "linkid": "2249",
                                        "code": "108031203",
                                        "paCode": "1080312",
                                        "yn": "Y",
                                        "title": "混合稀土金属",
                                        "alias": "混合稀土金属",
                                        "about": "指两种以上稀土金属，稀土金属总含量≥99%",
                                        "kws": "混合稀土金属",
                                        "taxName": "稀土金属及合金",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1080312030000000000",
                                        "taxCodeTitle": "稀土金属及合金",
                                        "iTitle": "*稀土金属及合金*混合稀土金属",
                                        "children": [
                                            {
                                                "id": "2282",
                                                "linkid": "2281",
                                                "code": "10803120301",
                                                "paCode": "108031203",
                                                "yn": "N",
                                                "title": "镨钕",
                                                "alias": "镨钕",
                                                "about": null,
                                                "kws": "金属镨钕",
                                                "taxName": "稀土金属及合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080312030100000000",
                                                "taxCodeTitle": "稀土金属及合金",
                                                "iTitle": "*稀土金属及合金*镨钕",
                                                "children": []
                                            },
                                            {
                                                "id": "2283",
                                                "linkid": "2281",
                                                "code": "10803120302",
                                                "paCode": "108031203",
                                                "yn": "N",
                                                "title": "镧镨",
                                                "alias": "镧镨",
                                                "about": null,
                                                "kws": "金属镧镨",
                                                "taxName": "稀土金属及合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080312030200000000",
                                                "taxCodeTitle": "稀土金属及合金",
                                                "iTitle": "*稀土金属及合金*镧镨",
                                                "children": []
                                            },
                                            {
                                                "id": "2284",
                                                "linkid": "2281",
                                                "code": "10803120303",
                                                "paCode": "108031203",
                                                "yn": "N",
                                                "title": "镨镧",
                                                "alias": "镨镧",
                                                "about": null,
                                                "kws": "金属镨镧",
                                                "taxName": "稀土金属及合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080312030300000000",
                                                "taxCodeTitle": "稀土金属及合金",
                                                "iTitle": "*稀土金属及合金*镨镧",
                                                "children": []
                                            },
                                            {
                                                "id": "2285",
                                                "linkid": "2281",
                                                "code": "10803120304",
                                                "paCode": "108031203",
                                                "yn": "N",
                                                "title": "镧铈镨钕",
                                                "alias": "镧铈镨钕",
                                                "about": null,
                                                "kws": "金属镧铈镨钕",
                                                "taxName": "稀土金属及合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080312030400000000",
                                                "taxCodeTitle": "稀土金属及合金",
                                                "iTitle": "*稀土金属及合金*镧铈镨钕",
                                                "children": []
                                            },
                                            {
                                                "id": "2286",
                                                "linkid": "2281",
                                                "code": "10803120307",
                                                "paCode": "108031203",
                                                "yn": "N",
                                                "title": "镧铈",
                                                "alias": "镧铈",
                                                "about": null,
                                                "kws": "镧铈金属、镧铈合金",
                                                "taxName": "稀土金属及合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080312030700000000",
                                                "taxCodeTitle": "稀土金属及合金",
                                                "iTitle": "*稀土金属及合金*镧铈",
                                                "children": []
                                            },
                                            {
                                                "id": "2287",
                                                "linkid": "2281",
                                                "code": "10803120308",
                                                "paCode": "108031203",
                                                "yn": "N",
                                                "title": "镨钕镝",
                                                "alias": "镨钕镝",
                                                "about": null,
                                                "kws": "镨钕镝金属、镨钕镝合金",
                                                "taxName": "稀土金属及合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080312030800000000",
                                                "taxCodeTitle": "稀土金属及合金",
                                                "iTitle": "*稀土金属及合金*镨钕镝",
                                                "children": []
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "id": "2288",
                                "linkid": "2217",
                                "code": "1080313",
                                "paCode": "10803",
                                "yn": "Y",
                                "title": "碱金属及碱土金属",
                                "alias": "碱金属及碱土金属",
                                "about": "包括碱金属以及碱土金属",
                                "kws": null,
                                "taxName": "碱及碱土金属",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080313000000000000",
                                "taxCodeTitle": "碱及碱土金属",
                                "iTitle": "*碱及碱土金属*碱金属及碱土金属",
                                "children": [
                                    {
                                        "id": "2289",
                                        "linkid": "2288",
                                        "code": "108031301",
                                        "paCode": "1080313",
                                        "yn": "Y",
                                        "title": "碱金属",
                                        "alias": "碱金属",
                                        "about": "包括钠、锂、钾、铷、铯和其他碱金属",
                                        "kws": null,
                                        "taxName": "碱及碱土金属",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1080313010000000000",
                                        "taxCodeTitle": "碱及碱土金属",
                                        "iTitle": "*碱及碱土金属*碱金属",
                                        "children": [
                                            {
                                                "id": "2290",
                                                "linkid": "2289",
                                                "code": "10803130101",
                                                "paCode": "108031301",
                                                "yn": "N",
                                                "title": "钠",
                                                "alias": "钠",
                                                "about": null,
                                                "kws": "钠",
                                                "taxName": "碱及碱土金属",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080313010100000000",
                                                "taxCodeTitle": "碱及碱土金属",
                                                "iTitle": "*碱及碱土金属*钠",
                                                "children": []
                                            },
                                            {
                                                "id": "2291",
                                                "linkid": "2289",
                                                "code": "10803130102",
                                                "paCode": "108031301",
                                                "yn": "N",
                                                "title": "锂",
                                                "alias": "锂",
                                                "about": "指用电解或真空热还原-蒸馏技术生产的锂金属，锂含量≥99%",
                                                "kws": "锂",
                                                "taxName": "碱及碱土金属",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080313010200000000",
                                                "taxCodeTitle": "碱及碱土金属",
                                                "iTitle": "*碱及碱土金属*锂",
                                                "children": []
                                            },
                                            {
                                                "id": "2292",
                                                "linkid": "2289",
                                                "code": "10803130103",
                                                "paCode": "108031301",
                                                "yn": "N",
                                                "title": "钾",
                                                "alias": "钾",
                                                "about": null,
                                                "kws": "钾",
                                                "taxName": "碱及碱土金属",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080313010300000000",
                                                "taxCodeTitle": "碱及碱土金属",
                                                "iTitle": "*碱及碱土金属*钾",
                                                "children": []
                                            },
                                            {
                                                "id": "2293",
                                                "linkid": "2289",
                                                "code": "10803130104",
                                                "paCode": "108031301",
                                                "yn": "N",
                                                "title": "铷",
                                                "alias": "铷",
                                                "about": "指用锂云母、铯榴石及盐湖卤水作原料经冶炼工艺生产的铷金属，铷含量≥99%",
                                                "kws": "铷",
                                                "taxName": "碱及碱土金属",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080313010400000000",
                                                "taxCodeTitle": "碱及碱土金属",
                                                "iTitle": "*碱及碱土金属*铷",
                                                "children": []
                                            },
                                            {
                                                "id": "2294",
                                                "linkid": "2289",
                                                "code": "10803130105",
                                                "paCode": "108031301",
                                                "yn": "N",
                                                "title": "铯",
                                                "alias": "铯",
                                                "about": "指用铯榴石等原料经真空热还原法、热分解法和电解法生产的金属铯，铯含量≥99%",
                                                "kws": "铯",
                                                "taxName": "碱及碱土金属",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080313010500000000",
                                                "taxCodeTitle": "碱及碱土金属",
                                                "iTitle": "*碱及碱土金属*铯",
                                                "children": []
                                            },
                                            {
                                                "id": "2295",
                                                "linkid": "2289",
                                                "code": "10803130199",
                                                "paCode": "108031301",
                                                "yn": "N",
                                                "title": "其他碱金属",
                                                "alias": "其他碱金属",
                                                "about": null,
                                                "kws": null,
                                                "taxName": "碱及碱土金属",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080313019900000000",
                                                "taxCodeTitle": "碱及碱土金属",
                                                "iTitle": "*碱及碱土金属*其他碱金属",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "2296",
                                        "linkid": "2288",
                                        "code": "108031302",
                                        "paCode": "1080313",
                                        "yn": "Y",
                                        "title": "碱土金属",
                                        "alias": "碱土金属",
                                        "about": "包括钙、锶、钡和其他碱金属及碱土金属",
                                        "kws": "碱土金属",
                                        "taxName": "碱及碱土金属",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1080313020000000000",
                                        "taxCodeTitle": "碱及碱土金属",
                                        "iTitle": "*碱及碱土金属*碱土金属",
                                        "children": [
                                            {
                                                "id": "2297",
                                                "linkid": "2296",
                                                "code": "10803130201",
                                                "paCode": "108031302",
                                                "yn": "N",
                                                "title": "钙",
                                                "alias": "钙",
                                                "about": null,
                                                "kws": "钙",
                                                "taxName": "碱及碱土金属",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080313020100000000",
                                                "taxCodeTitle": "碱及碱土金属",
                                                "iTitle": "*碱及碱土金属*钙",
                                                "children": []
                                            },
                                            {
                                                "id": "2298",
                                                "linkid": "2296",
                                                "code": "10803130202",
                                                "paCode": "108031302",
                                                "yn": "N",
                                                "title": "锶",
                                                "alias": "锶",
                                                "about": null,
                                                "kws": "锶",
                                                "taxName": "碱及碱土金属",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080313020200000000",
                                                "taxCodeTitle": "碱及碱土金属",
                                                "iTitle": "*碱及碱土金属*锶",
                                                "children": []
                                            },
                                            {
                                                "id": "2299",
                                                "linkid": "2296",
                                                "code": "10803130203",
                                                "paCode": "108031302",
                                                "yn": "N",
                                                "title": "钡",
                                                "alias": "钡",
                                                "about": null,
                                                "kws": "钡",
                                                "taxName": "碱及碱土金属",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080313020300000000",
                                                "taxCodeTitle": "碱及碱土金属",
                                                "iTitle": "*碱及碱土金属*钡",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "2300",
                                        "linkid": "2288",
                                        "code": "108031399",
                                        "paCode": "1080313",
                                        "yn": "N",
                                        "title": "其他碱金属及碱土金属",
                                        "alias": "其他碱金属及碱土金属",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "碱及碱土金属",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080313990000000000",
                                        "taxCodeTitle": "碱及碱土金属",
                                        "iTitle": "*碱及碱土金属*其他碱金属及碱土金属",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2301",
                                "linkid": "2217",
                                "code": "1080314",
                                "paCode": "10803",
                                "yn": "Y",
                                "title": "有色金属合金",
                                "alias": "有色金属合金",
                                "about": "指含有两种以上有色金属铸造的未锻轧产品",
                                "kws": "有色金属合金",
                                "taxName": "有色金属合金",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080314000000000000",
                                "taxCodeTitle": "有色金属合金",
                                "iTitle": "*有色金属合金*有色金属合金",
                                "children": [
                                    {
                                        "id": "2302",
                                        "linkid": "2301",
                                        "code": "108031401",
                                        "paCode": "1080314",
                                        "yn": "Y",
                                        "title": "常用有色金属合金",
                                        "alias": "常用有色金属合金",
                                        "about": "包括铜合金、铅合金、锌合金、镍合金、铝合金、锡合金、镁合金、钛合金、铋合金、镉合金、钴合金以及其他常用有色金属合金",
                                        "kws": "常用有色金属合金",
                                        "taxName": "有色金属合金",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1080314010000000000",
                                        "taxCodeTitle": "有色金属合金",
                                        "iTitle": "*有色金属合金*常用有色金属合金",
                                        "children": [
                                            {
                                                "id": "2303",
                                                "linkid": "2302",
                                                "code": "10803140101",
                                                "paCode": "108031401",
                                                "yn": "N",
                                                "title": "铜合金",
                                                "alias": "铜合金",
                                                "about": "指以铜为基体，加入一种或几种其他有色金属元素所铸造的未锻轧的铜合金",
                                                "kws": "铜合金、铜锌合金、黄铜、铜锡合金、青铜、铜镍合金、白铜、铜镍锌合金、德银",
                                                "taxName": "有色金属合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080314010100000000",
                                                "taxCodeTitle": "有色金属合金",
                                                "iTitle": "*有色金属合金*铜合金",
                                                "children": []
                                            },
                                            {
                                                "id": "2304",
                                                "linkid": "2302",
                                                "code": "10803140102",
                                                "paCode": "108031401",
                                                "yn": "N",
                                                "title": "铅合金",
                                                "alias": "铅合金",
                                                "about": "指以铅为基体，加入一种或几种其他有色金属元素所铸造的未锻轧的铅合金",
                                                "kws": "铅合金、铅锡合金、铅锑锡合金、铅砷合金、铅锑合金、铅钙合金、铅锑镉合金、铅碲合金",
                                                "taxName": "有色金属合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080314010200000000",
                                                "taxCodeTitle": "有色金属合金",
                                                "iTitle": "*有色金属合金*铅合金",
                                                "children": []
                                            },
                                            {
                                                "id": "2305",
                                                "linkid": "2302",
                                                "code": "10803140103",
                                                "paCode": "108031401",
                                                "yn": "N",
                                                "title": "锌合金",
                                                "alias": "锌合金",
                                                "about": "指以锌为基体，加入一种或几种其他有色金属元素所铸造的未锻轧的锌合金",
                                                "kws": "锌合金、锌铝合金、锌铜合金",
                                                "taxName": "有色金属合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080314010300000000",
                                                "taxCodeTitle": "有色金属合金",
                                                "iTitle": "*有色金属合金*锌合金",
                                                "children": []
                                            },
                                            {
                                                "id": "2306",
                                                "linkid": "2302",
                                                "code": "10803140104",
                                                "paCode": "108031401",
                                                "yn": "N",
                                                "title": "镍合金",
                                                "alias": "镍合金",
                                                "about": "指以镍为基体，加入一种或几种其他有色金属元素所铸造的未锻轧的镍合金",
                                                "kws": "镍合金、镍铬合金、镍铜合金、镍锌合金",
                                                "taxName": "有色金属合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080314010400000000",
                                                "taxCodeTitle": "有色金属合金",
                                                "iTitle": "*有色金属合金*镍合金",
                                                "children": []
                                            },
                                            {
                                                "id": "2307",
                                                "linkid": "2302",
                                                "code": "10803140105",
                                                "paCode": "108031401",
                                                "yn": "N",
                                                "title": "铝合金",
                                                "alias": "铝合金",
                                                "about": "指以铝锭（铝液或再生铝）为基体，加入一种或几种其他有色金属元素所铸造的未锻轧的铝合金",
                                                "kws": "铝合金、铝铜合金、铝锌铜合金、铝硅合金、铝锰镁合金、铝镁硅合金、铝铜镁锰合金、铝镁合金、铝锰合金、铝稀土合金、铝锌镁合金",
                                                "taxName": "有色金属合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080314010500000000",
                                                "taxCodeTitle": "有色金属合金",
                                                "iTitle": "*有色金属合金*铝合金",
                                                "children": []
                                            },
                                            {
                                                "id": "2308",
                                                "linkid": "2302",
                                                "code": "10803140106",
                                                "paCode": "108031401",
                                                "yn": "N",
                                                "title": "锡合金",
                                                "alias": "锡合金",
                                                "about": "指以锡为基体，加入一种或几种其他有色金属元素所铸造的未锻轧的锡合金",
                                                "kws": "锡合金、巴氏合金、锡铅合金、锡锑合金、锡铅锑合金、锡镉合金",
                                                "taxName": "有色金属合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080314010600000000",
                                                "taxCodeTitle": "有色金属合金",
                                                "iTitle": "*有色金属合金*锡合金",
                                                "children": []
                                            },
                                            {
                                                "id": "2309",
                                                "linkid": "2302",
                                                "code": "10803140107",
                                                "paCode": "108031401",
                                                "yn": "N",
                                                "title": "镁合金",
                                                "alias": "镁合金",
                                                "about": "指以镁为基体，加入一种或几种其他有色金属元素所铸造的未锻轧的镁合金",
                                                "kws": "镁合金、镁铝合金、镁铝锌合金、镁锆合金、镁锰合金、镁铈合金",
                                                "taxName": "有色金属合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080314010700000000",
                                                "taxCodeTitle": "有色金属合金",
                                                "iTitle": "*有色金属合金*镁合金",
                                                "children": []
                                            },
                                            {
                                                "id": "2310",
                                                "linkid": "2302",
                                                "code": "10803140108",
                                                "paCode": "108031401",
                                                "yn": "N",
                                                "title": "钛合金",
                                                "alias": "钛合金",
                                                "about": "指以海绵钛为基体，加入一种或几种其他有色金属元素所铸造的未锻轧的钛合金",
                                                "kws": "钛合金",
                                                "taxName": "有色金属合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080314010800000000",
                                                "taxCodeTitle": "有色金属合金",
                                                "iTitle": "*有色金属合金*钛合金",
                                                "children": []
                                            },
                                            {
                                                "id": "2311",
                                                "linkid": "2302",
                                                "code": "10803140109",
                                                "paCode": "108031401",
                                                "yn": "N",
                                                "title": "铋合金",
                                                "alias": "铋合金",
                                                "about": "指以铋为基体，加入两种以上有色金属元素所铸造的未锻轧的铋合金",
                                                "kws": "铋合金、铋铅锡合金、铋铟铅锡镉合金",
                                                "taxName": "有色金属合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080314010900000000",
                                                "taxCodeTitle": "有色金属合金",
                                                "iTitle": "*有色金属合金*铋合金",
                                                "children": []
                                            },
                                            {
                                                "id": "2312",
                                                "linkid": "2302",
                                                "code": "10803140110",
                                                "paCode": "108031401",
                                                "yn": "N",
                                                "title": "镉合金",
                                                "alias": "镉合金",
                                                "about": null,
                                                "kws": "镉合金、镉锌合金",
                                                "taxName": "有色金属合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080314011000000000",
                                                "taxCodeTitle": "有色金属合金",
                                                "iTitle": "*有色金属合金*镉合金",
                                                "children": []
                                            },
                                            {
                                                "id": "2313",
                                                "linkid": "2302",
                                                "code": "10803140111",
                                                "paCode": "108031401",
                                                "yn": "N",
                                                "title": "钴合金",
                                                "alias": "钴合金",
                                                "about": "指以钴为基体，加入一种或几种金属铸造的未锻轧的钴合金",
                                                "kws": "钴合金、钴铬钨合金、钨铬钴合金、钴铁铬合金、钴铬钼合金",
                                                "taxName": "有色金属合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080314011100000000",
                                                "taxCodeTitle": "有色金属合金",
                                                "iTitle": "*有色金属合金*钴合金",
                                                "children": []
                                            },
                                            {
                                                "id": "2314",
                                                "linkid": "2302",
                                                "code": "10803140199",
                                                "paCode": "108031401",
                                                "yn": "N",
                                                "title": "其他常用有色金属合金",
                                                "alias": "其他常用有色金属合金",
                                                "about": null,
                                                "kws": null,
                                                "taxName": "有色金属合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080314019900000000",
                                                "taxCodeTitle": "有色金属合金",
                                                "iTitle": "*有色金属合金*其他常用有色金属合金",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "2315",
                                        "linkid": "2301",
                                        "code": "108031402",
                                        "paCode": "1080314",
                                        "yn": "N",
                                        "title": "硬质合金",
                                        "alias": "硬质合金",
                                        "about": "指以碳化钨（WC）粉、复式碳化钨（WC）粉、钴（Co）粉及钛粉等金属为原料，经混合料制备、压制成型和烧结工艺生产的产品称作硬质合金；按用途分为切削刀片硬质合金、矿用硬质合金、耐磨零件硬质合金和钢结硬质合金；按原料分为钨钴硬质合金、钨钴钛硬质合金、钢结硬质合金及其他硬质合金",
                                        "kws": "硬质合金、切削刀片用硬质合金、矿用硬质合金、耐磨零件用硬质合金、钢结合金",
                                        "taxName": "有色金属合金",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080314020000000000",
                                        "taxCodeTitle": "有色金属合金",
                                        "iTitle": "*有色金属合金*硬质合金",
                                        "children": []
                                    },
                                    {
                                        "id": "2316",
                                        "linkid": "2301",
                                        "code": "108031403",
                                        "paCode": "1080314",
                                        "yn": "Y",
                                        "title": "稀有稀土金属合金",
                                        "alias": "稀有稀土金属合金",
                                        "about": "包括稀有金属合金、稀土金属合金",
                                        "kws": "稀有稀土金属合金",
                                        "taxName": "有色金属合金",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1080314030000000000",
                                        "taxCodeTitle": "有色金属合金",
                                        "iTitle": "*有色金属合金*稀有稀土金属合金",
                                        "children": [
                                            {
                                                "id": "2317",
                                                "linkid": "2316",
                                                "code": "10803140301",
                                                "paCode": "108031403",
                                                "yn": "N",
                                                "title": "稀有金属合金",
                                                "alias": "稀有金属合金",
                                                "about": "包括铍铜合金、铍铝合金、铍镁合金、铌铁合金和其他稀有金属合金",
                                                "kws": "稀有金属合金、铍铜合金、铍铝合金、铍镁合金、铌铁合金",
                                                "taxName": "有色金属合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080314030100000000",
                                                "taxCodeTitle": "有色金属合金",
                                                "iTitle": "*有色金属合金*稀有金属合金",
                                                "children": []
                                            },
                                            {
                                                "id": "2318",
                                                "linkid": "2316",
                                                "code": "10803140302",
                                                "paCode": "108031403",
                                                "yn": "Y",
                                                "title": "稀土金属合金",
                                                "alias": "稀土金属合金",
                                                "about": "指由稀土金属作基体，加入一种或几种金属铸造的合金产品",
                                                "kws": "稀土金属合金、稀土铜合金、稀土铝合金、稀土铅合金、稀土锌合金、稀土钪铝合金、稀土钇镁合金、稀土镧合金、稀土镧镍合金、稀土铈镁合金、稀土铈钨合金、稀土铈钴合金、稀土铈钴铜合金、稀土镨铁合金、稀土钕铁合金、稀土钕镁合金、稀土镁铼合金、稀土钕铁硼合金、稀土钐钴合金、稀土永磁合金、稀土铽合金、稀土镝铁合金、稀土硅铁合金、电池极合金、打火石合金",
                                                "taxName": "稀土金属及合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080314030200000000",
                                                "taxCodeTitle": "稀土金属及合金",
                                                "iTitle": "*稀土金属及合金*稀土金属合金",
                                                "children": []
                                            },
                                            {
                                                "id": "2319",
                                                "linkid": "2316",
                                                "code": "10803140303",
                                                "paCode": "108031403",
                                                "yn": "N",
                                                "title": "镝铁",
                                                "alias": "镝铁",
                                                "about": null,
                                                "kws": "镝铁合金",
                                                "taxName": "稀土金属及合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080314030300000000",
                                                "taxCodeTitle": "稀土金属及合金",
                                                "iTitle": "*稀土金属及合金*镝铁",
                                                "children": []
                                            },
                                            {
                                                "id": "2320",
                                                "linkid": "2316",
                                                "code": "10803140304",
                                                "paCode": "108031403",
                                                "yn": "N",
                                                "title": "钬铁",
                                                "alias": "钬铁",
                                                "about": null,
                                                "kws": "钆铁合金",
                                                "taxName": "稀土金属及合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080314030400000000",
                                                "taxCodeTitle": "稀土金属及合金",
                                                "iTitle": "*稀土金属及合金*钬铁",
                                                "children": []
                                            },
                                            {
                                                "id": "2321",
                                                "linkid": "2316",
                                                "code": "10803140305",
                                                "paCode": "108031403",
                                                "yn": "N",
                                                "title": "钆铁",
                                                "alias": "钆铁",
                                                "about": null,
                                                "kws": "钆铁合金",
                                                "taxName": "稀土金属及合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080314030500000000",
                                                "taxCodeTitle": "稀土金属及合金",
                                                "iTitle": "*稀土金属及合金*钆铁",
                                                "children": []
                                            },
                                            {
                                                "id": "2322",
                                                "linkid": "2316",
                                                "code": "10803140306",
                                                "paCode": "108031403",
                                                "yn": "N",
                                                "title": "铈铁",
                                                "alias": "铈铁",
                                                "about": null,
                                                "kws": "铈铁合金",
                                                "taxName": "稀土金属及合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080314030600000000",
                                                "taxCodeTitle": "稀土金属及合金",
                                                "iTitle": "*稀土金属及合金*铈铁",
                                                "children": []
                                            },
                                            {
                                                "id": "2323",
                                                "linkid": "2316",
                                                "code": "10803140307",
                                                "paCode": "108031403",
                                                "yn": "N",
                                                "title": "钇铝",
                                                "alias": "钇铝",
                                                "about": null,
                                                "kws": "钇铝合金",
                                                "taxName": "稀土金属及合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080314030700000000",
                                                "taxCodeTitle": "稀土金属及合金",
                                                "iTitle": "*稀土金属及合金*钇铝",
                                                "children": []
                                            },
                                            {
                                                "id": "2324",
                                                "linkid": "2316",
                                                "code": "10803140308",
                                                "paCode": "108031403",
                                                "yn": "N",
                                                "title": "铒铝",
                                                "alias": "铒铝",
                                                "about": null,
                                                "kws": "铒铝合金",
                                                "taxName": "稀土金属及合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080314030800000000",
                                                "taxCodeTitle": "稀土金属及合金",
                                                "iTitle": "*稀土金属及合金*铒铝",
                                                "children": []
                                            },
                                            {
                                                "id": "2325",
                                                "linkid": "2316",
                                                "code": "10803140309",
                                                "paCode": "108031403",
                                                "yn": "N",
                                                "title": "铝钪",
                                                "alias": "铝钪",
                                                "about": null,
                                                "kws": "铝钪合金",
                                                "taxName": "稀土金属及合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080314030900000000",
                                                "taxCodeTitle": "稀土金属及合金",
                                                "iTitle": "*稀土金属及合金*铝钪",
                                                "children": []
                                            },
                                            {
                                                "id": "2326",
                                                "linkid": "2316",
                                                "code": "10803140310",
                                                "paCode": "108031403",
                                                "yn": "N",
                                                "title": "稀土铜合金",
                                                "alias": "稀土铜合金",
                                                "about": null,
                                                "kws": "钬铜合金、镧铜合金、铈铜合金、钇铜合金",
                                                "taxName": "稀土金属及合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080314031000000000",
                                                "taxCodeTitle": "稀土金属及合金",
                                                "iTitle": "*稀土金属及合金*稀土铜合金",
                                                "children": []
                                            },
                                            {
                                                "id": "2327",
                                                "linkid": "2316",
                                                "code": "10803140311",
                                                "paCode": "108031403",
                                                "yn": "N",
                                                "title": "钇镁",
                                                "alias": "钇镁",
                                                "about": null,
                                                "kws": "钇镁合金",
                                                "taxName": "稀土金属及合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080314031100000000",
                                                "taxCodeTitle": "稀土金属及合金",
                                                "iTitle": "*稀土金属及合金*钇镁",
                                                "children": []
                                            },
                                            {
                                                "id": "2328",
                                                "linkid": "2316",
                                                "code": "10803140312",
                                                "paCode": "108031403",
                                                "yn": "N",
                                                "title": "钆镁",
                                                "alias": "钆镁",
                                                "about": null,
                                                "kws": "钆镁合金",
                                                "taxName": "稀土金属及合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080314031200000000",
                                                "taxCodeTitle": "稀土金属及合金",
                                                "iTitle": "*稀土金属及合金*钆镁",
                                                "children": []
                                            },
                                            {
                                                "id": "2329",
                                                "linkid": "2316",
                                                "code": "10803140313",
                                                "paCode": "108031403",
                                                "yn": "N",
                                                "title": "钇钆镁",
                                                "alias": "钇钆镁",
                                                "about": null,
                                                "kws": "钇钆镁合金",
                                                "taxName": "稀土金属及合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080314031300000000",
                                                "taxCodeTitle": "稀土金属及合金",
                                                "iTitle": "*稀土金属及合金*钇钆镁",
                                                "children": []
                                            },
                                            {
                                                "id": "2330",
                                                "linkid": "2316",
                                                "code": "10803140314",
                                                "paCode": "108031403",
                                                "yn": "N",
                                                "title": "其他稀土元素含量≥35%的稀土合金",
                                                "alias": "其他稀土元素含量≥35%的稀土合金",
                                                "about": null,
                                                "kws": null,
                                                "taxName": "稀土金属及合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080314031400000000",
                                                "taxCodeTitle": "稀土金属及合金",
                                                "iTitle": "*稀土金属及合金*其他稀土元素含量≥35%的稀土合金",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "2331",
                                        "linkid": "2301",
                                        "code": "108031404",
                                        "paCode": "1080314",
                                        "yn": "Y",
                                        "title": "贵金属合金",
                                        "alias": "贵金属合金",
                                        "about": null,
                                        "kws": "贵金属合金",
                                        "taxName": "有色金属合金",
                                        "taxRate": "",
                                        "vip": "7",
                                        "itaxRate": null,
                                        "taxCode": "1080314040000000000",
                                        "taxCodeTitle": "有色金属合金",
                                        "iTitle": "*有色金属合金*贵金属合金",
                                        "children": [
                                            {
                                                "id": "2332",
                                                "linkid": "2331",
                                                "code": "10803140401",
                                                "paCode": "108031404",
                                                "yn": "N",
                                                "title": "金合金",
                                                "alias": "金合金",
                                                "about": "指以金为基体，加入一种或几种金属铸造的合金产品",
                                                "kws": "金合金、金银合金、金铜合金、金银铜合金、金铜镍合金、金镍合金、金铂合金、金银钯铜合金",
                                                "taxName": "有色金属合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080314040100000000",
                                                "taxCodeTitle": "有色金属合金",
                                                "iTitle": "*有色金属合金*金合金",
                                                "children": []
                                            },
                                            {
                                                "id": "2333",
                                                "linkid": "2331",
                                                "code": "10803140402",
                                                "paCode": "108031404",
                                                "yn": "N",
                                                "title": "银合金",
                                                "alias": "银合金",
                                                "about": "指以银为基体，加入一种或几种金属铸造的银合金产品",
                                                "kws": "银合金、银铜合金、银铜镉合金、银铜钛合金、银铟合金、银铜锌合金、银铜钯合金、银减磨合金、烧结银钨合金、银钼合金、银镍合金、银铁合金",
                                                "taxName": "有色金属合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080314040200000000",
                                                "taxCodeTitle": "有色金属合金",
                                                "iTitle": "*有色金属合金*银合金",
                                                "children": []
                                            },
                                            {
                                                "id": "2334",
                                                "linkid": "2331",
                                                "code": "10803140403",
                                                "paCode": "108031404",
                                                "yn": "N",
                                                "title": "铂合金",
                                                "alias": "铂合金",
                                                "about": "指以铂为基体，加入一种或几种金属铸造的铂合金",
                                                "kws": "铂合金、铂铑合金、铂铱合金、铂钌合金、铂铜合金、铂钨合金、铂钴合金",
                                                "taxName": "有色金属合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080314040300000000",
                                                "taxCodeTitle": "有色金属合金",
                                                "iTitle": "*有色金属合金*铂合金",
                                                "children": []
                                            },
                                            {
                                                "id": "2335",
                                                "linkid": "2331",
                                                "code": "10803140404",
                                                "paCode": "108031404",
                                                "yn": "N",
                                                "title": "钯合金",
                                                "alias": "钯合金",
                                                "about": "指以钯为基体，加入一种或几种金属铸造的钯合金",
                                                "kws": "钯合金、钯钌合金、钯银合金、钯铜合金、钯铝合金",
                                                "taxName": "有色金属合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080314040400000000",
                                                "taxCodeTitle": "有色金属合金",
                                                "iTitle": "*有色金属合金*钯合金",
                                                "children": []
                                            },
                                            {
                                                "id": "2336",
                                                "linkid": "2331",
                                                "code": "10803140405",
                                                "paCode": "108031404",
                                                "yn": "N",
                                                "title": "铑、铱、锇合金",
                                                "alias": "铑、铱、锇合金",
                                                "about": "包括铑铱合金、铱锇合金、铱钨合金和其他贵金属合金",
                                                "kws": "铑合金、铱合金、锇合金、铑铱合金、铱锇合金、铱钨合金",
                                                "taxName": "有色金属合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080314040500000000",
                                                "taxCodeTitle": "有色金属合金",
                                                "iTitle": "*有色金属合金*铑、铱、锇合金",
                                                "children": []
                                            },
                                            {
                                                "id": "2337",
                                                "linkid": "2331",
                                                "code": "10803140499",
                                                "paCode": "108031404",
                                                "yn": "N",
                                                "title": "其他贵金属合金",
                                                "alias": "其他贵金属合金",
                                                "about": null,
                                                "kws": null,
                                                "taxName": "有色金属合金",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1080314049900000000",
                                                "taxCodeTitle": "有色金属合金",
                                                "iTitle": "*有色金属合金*其他贵金属合金",
                                                "children": []
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "id": "2338",
                                "linkid": "2217",
                                "code": "1080315",
                                "paCode": "10803",
                                "yn": "Y",
                                "title": "铜压延加工材",
                                "alias": "铜压延加工材",
                                "about": "包括铜材、铜盘条（电工用铜线坯）、铜粉及片状粉末。",
                                "kws": null,
                                "taxName": "有色金属压延材",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080315000000000000",
                                "taxCodeTitle": "有色金属压延材",
                                "iTitle": "*有色金属压延材*铜压延加工材",
                                "children": [
                                    {
                                        "id": "2339",
                                        "linkid": "2338",
                                        "code": "108031501",
                                        "paCode": "1080315",
                                        "yn": "N",
                                        "title": "铜材",
                                        "alias": "铜材",
                                        "about": "指以铜金属为基体，经熔铸、挤压或轧制加工生产的板材、带材、箔材、棒材、型材、线材、管材等铜材",
                                        "kws": "铜板材、紫铜板材、铜锌合金板、铜锡合金板、铜镍合金板、铜镍锌合金板、铜带材、紫铜带材、铜锌合金带、铜锡合金带、铜镍合金带、铜镍锌合金带、铜箔材、紫铜箔材、铜镍合金箔、铜镍锌合金箔、铜棒材、紫铜棒材、铜锌合金棒材、铜镍合金棒材、铜镍锌合金棒材、铜型材、紫铜异型材、铜锌合金型材、铜镍合金型材、铜镍锌合金型材、铜线材、紫铜线材、铜锌合金线材、铜镍合金线材、铜镍锌合金线材、铜管材、紫铜管材、铜锌合金管、铜镍合金管、铜镍锌合金管、铜制管子附件、紫铜管子附件、铜镍合金管子附件、铜镍锌合金管子附件",
                                        "taxName": "有色金属压延材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080315010000000000",
                                        "taxCodeTitle": "有色金属压延材",
                                        "iTitle": "*有色金属压延材*铜材",
                                        "children": []
                                    },
                                    {
                                        "id": "2340",
                                        "linkid": "2338",
                                        "code": "108031502",
                                        "paCode": "1080315",
                                        "yn": "N",
                                        "title": "铜盘条（电工用铜线坯）",
                                        "alias": "铜盘条（电工用铜线坯）",
                                        "about": "指沿整个长度方向上具有均一的横截面，以卷状供应的实心中间产品，供进一步加工用，直径一般为6～35mm，铜加工材总计中不含铜盘条",
                                        "kws": "紫铜盘条、铜锌合金盘条、铜锡合金盘条、铜镍合金盘条、铜镍锌合金盘条",
                                        "taxName": "有色金属压延材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080315020000000000",
                                        "taxCodeTitle": "有色金属压延材",
                                        "iTitle": "*有色金属压延材*铜盘条（电工用铜线坯）",
                                        "children": []
                                    },
                                    {
                                        "id": "2341",
                                        "linkid": "2338",
                                        "code": "108031503",
                                        "paCode": "1080315",
                                        "yn": "N",
                                        "title": "铜粉及片状粉末",
                                        "alias": "铜粉及片状粉末",
                                        "about": "包括铜粉、片状铜粉末。",
                                        "kws": "铜粉、紫铜粉、铜镍合金粉、白铜粉、铜镍锌合金粉、铜锌合金粉、黄铜粉、铜锡合金粉、青铜粉、片状铜粉末、紫铜片状粉末、铜镍合金片状粉末、铜镍锌合金片状粉末",
                                        "taxName": "有色金属压延材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080315030000000000",
                                        "taxCodeTitle": "有色金属压延材",
                                        "iTitle": "*有色金属压延材*铜粉及片状粉末",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2342",
                                "linkid": "2217",
                                "code": "1080316",
                                "paCode": "10803",
                                "yn": "Y",
                                "title": "铝压延加工材",
                                "alias": "铝压延加工材",
                                "about": "包括铝材、铝盘条（电工用圆铝杆）、铝粉及片状粉末。",
                                "kws": null,
                                "taxName": "有色金属压延材",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080316000000000000",
                                "taxCodeTitle": "有色金属压延材",
                                "iTitle": "*有色金属压延材*铝压延加工材",
                                "children": [
                                    {
                                        "id": "2343",
                                        "linkid": "2342",
                                        "code": "108031601",
                                        "paCode": "1080316",
                                        "yn": "N",
                                        "title": "铝材",
                                        "alias": "铝材",
                                        "about": "指以铝金属为基体，经熔铸、挤压或轧制加工生产的板材、带材、箔材、棒材、型材、线材、管材及排材",
                                        "kws": "铝材、铝棒材、非合金铝棒材、铝合金棒材、铝型材、铝合金建筑型材、铝合金门窗幕墙、铝工业铝型材、铝合金工业铝型材、铝板材、非合金铝板材、铝合金板材、铝带材、非合金铝带、铝合金带、铝箔材、无衬背铝箔、有衬背铝箔、铝线材、非合金铝线材、铝合金线材、铝排材、铝扁棒、非合金铝排材、铝合金排材、铝管材、非合金铝管、铝合金管、铝制管子附件",
                                        "taxName": "有色金属压延材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080316010000000000",
                                        "taxCodeTitle": "有色金属压延材",
                                        "iTitle": "*有色金属压延材*铝材",
                                        "children": []
                                    },
                                    {
                                        "id": "2344",
                                        "linkid": "2342",
                                        "code": "108031602",
                                        "paCode": "1080316",
                                        "yn": "N",
                                        "title": "铝盘条（电工用圆铝杆）",
                                        "alias": "铝盘条（电工用圆铝杆）",
                                        "about": "指供进一步加工用的中间产品，直径一般为9～20mm",
                                        "kws": "非合金铝盘条、铝合金盘条",
                                        "taxName": "有色金属压延材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080316020000000000",
                                        "taxCodeTitle": "有色金属压延材",
                                        "iTitle": "*有色金属压延材*铝盘条（电工用圆铝杆）",
                                        "children": []
                                    },
                                    {
                                        "id": "2345",
                                        "linkid": "2342",
                                        "code": "108031603",
                                        "paCode": "1080316",
                                        "yn": "N",
                                        "title": "铝粉及铝片状粉末",
                                        "alias": "铝粉及铝片状粉末",
                                        "about": "包括铝非片状粉末、铝片状粉末。",
                                        "kws": "铝非片状粉末、铝片状粉末",
                                        "taxName": "有色金属压延材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080316030000000000",
                                        "taxCodeTitle": "有色金属压延材",
                                        "iTitle": "*有色金属压延材*铝粉及铝片状粉末",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2346",
                                "linkid": "2217",
                                "code": "1080317",
                                "paCode": "10803",
                                "yn": "Y",
                                "title": "铅压延加工材",
                                "alias": "铅压延加工材",
                                "about": "包括铅材、铅粉及片状粉末。",
                                "kws": null,
                                "taxName": "有色金属压延材",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080317000000000000",
                                "taxCodeTitle": "有色金属压延材",
                                "iTitle": "*有色金属压延材*铅压延加工材",
                                "children": [
                                    {
                                        "id": "2347",
                                        "linkid": "2346",
                                        "code": "108031701",
                                        "paCode": "1080317",
                                        "yn": "N",
                                        "title": "铅材",
                                        "alias": "铅材",
                                        "about": "指以铅为基体，加入一种或几种金属经挤压或轧制生产的产品",
                                        "kws": "铅棒材、非合金铅棒材、铅合金棒材、铅型材、非合金铅型材、铅合金型材、铅线材、非合金铅线材、铅合金线材、铅板、非合金铅板、铅合金板、铅片、非合金铅片、铅合金片、铅带、非合金铅带、铅合金带、铅箔、非合金铅箔、铅合金箔、铅管、铅管附件、铅制管子附件",
                                        "taxName": "有色金属压延材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080317010000000000",
                                        "taxCodeTitle": "有色金属压延材",
                                        "iTitle": "*有色金属压延材*铅材",
                                        "children": []
                                    },
                                    {
                                        "id": "2348",
                                        "linkid": "2346",
                                        "code": "108031702",
                                        "paCode": "1080317",
                                        "yn": "N",
                                        "title": "铅粉及铅片状粉末",
                                        "alias": "铅粉及铅片状粉末",
                                        "about": "包括铅粉、铅片状粉末。",
                                        "kws": "铅粉、铅片状粉末",
                                        "taxName": "有色金属压延材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080317020000000000",
                                        "taxCodeTitle": "有色金属压延材",
                                        "iTitle": "*有色金属压延材*铅粉及铅片状粉末",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2349",
                                "linkid": "2217",
                                "code": "1080318",
                                "paCode": "10803",
                                "yn": "Y",
                                "title": "锌压延加工材",
                                "alias": "锌压延加工材",
                                "about": "包括锌及锌合金压延加工材",
                                "kws": null,
                                "taxName": "有色金属压延材",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080318000000000000",
                                "taxCodeTitle": "有色金属压延材",
                                "iTitle": "*有色金属压延材*锌压延加工材",
                                "children": [
                                    {
                                        "id": "2350",
                                        "linkid": "2349",
                                        "code": "108031801",
                                        "paCode": "1080318",
                                        "yn": "N",
                                        "title": "锌材",
                                        "alias": "锌材",
                                        "about": "指以锌为基体，加入一种或几种金属经挤压或轧制生产的产品",
                                        "kws": "锌棒材、非合金锌棒材、锌合金棒材、锌型材、非合金锌型材、锌合金型材、锌线材、非合金锌线材、锌合金线材、锌板、非合金锌板、锌合金板、锌片、非合金锌片、锌合金片、锌带、非合金锌带、锌合金带、锌箔、非合金锌箔、锌合金箔、锌管、锌管附件、锌制管子附件",
                                        "taxName": "有色金属压延材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080318010000000000",
                                        "taxCodeTitle": "有色金属压延材",
                                        "iTitle": "*有色金属压延材*锌材",
                                        "children": []
                                    },
                                    {
                                        "id": "2351",
                                        "linkid": "2349",
                                        "code": "108031802",
                                        "paCode": "1080318",
                                        "yn": "N",
                                        "title": "锌末、锌粉及锌片状粉末",
                                        "alias": "锌末、锌粉及锌片状粉末",
                                        "about": "包括锌末、锌粉。",
                                        "kws": "锌末、锌粉、锌片状粉末",
                                        "taxName": "有色金属压延材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080318020000000000",
                                        "taxCodeTitle": "有色金属压延材",
                                        "iTitle": "*有色金属压延材*锌末、锌粉及锌片状粉末",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2352",
                                "linkid": "2217",
                                "code": "1080319",
                                "paCode": "10803",
                                "yn": "Y",
                                "title": "镍压延加工材",
                                "alias": "镍压延加工材",
                                "about": "包括镍及镍合金压延加工材",
                                "kws": null,
                                "taxName": "有色金属压延材",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080319000000000000",
                                "taxCodeTitle": "有色金属压延材",
                                "iTitle": "*有色金属压延材*镍压延加工材",
                                "children": [
                                    {
                                        "id": "2353",
                                        "linkid": "2352",
                                        "code": "108031901",
                                        "paCode": "1080319",
                                        "yn": "N",
                                        "title": "镍材",
                                        "alias": "镍材",
                                        "about": "指以镍为基体，加入一种或几种金属经挤压或轧制生产的产品",
                                        "kws": "镍棒材、非合金镍棒材、镍合金棒材、镍型材、非合金镍型材、镍合金型材、镍线材、非合金镍线材、镍合金线材、镍板材、非合金镍板、镍合金板、镍带材、非合金镍带、镍合金带、镍箔材、非合金镍箔、镍合金箔、镍管、管子附件、非合金镍管、镍合金管、镍管子附件、非合金镍材、镍合金材",
                                        "taxName": "有色金属压延材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080319010000000000",
                                        "taxCodeTitle": "有色金属压延材",
                                        "iTitle": "*有色金属压延材*镍材",
                                        "children": []
                                    },
                                    {
                                        "id": "2354",
                                        "linkid": "2352",
                                        "code": "108031902",
                                        "paCode": "1080319",
                                        "yn": "N",
                                        "title": "镍粉及镍片状粉末",
                                        "alias": "镍粉及镍片状粉末",
                                        "about": "指非合金镍粉、合金镍粉，包括片状粉末。",
                                        "kws": "非合金镍粉、合金镍粉、非合金镍片状粉末、合金镍片状粉末",
                                        "taxName": "有色金属压延材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080319020000000000",
                                        "taxCodeTitle": "有色金属压延材",
                                        "iTitle": "*有色金属压延材*镍粉及镍片状粉末",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2355",
                                "linkid": "2217",
                                "code": "1080320",
                                "paCode": "10803",
                                "yn": "Y",
                                "title": "锡压延加工材",
                                "alias": "锡压延加工材",
                                "about": "包括锡及锡合金压延加工材",
                                "kws": null,
                                "taxName": "有色金属压延材",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080320000000000000",
                                "taxCodeTitle": "有色金属压延材",
                                "iTitle": "*有色金属压延材*锡压延加工材",
                                "children": [
                                    {
                                        "id": "2356",
                                        "linkid": "2355",
                                        "code": "108032001",
                                        "paCode": "1080320",
                                        "yn": "N",
                                        "title": "锡材",
                                        "alias": "锡材",
                                        "about": "指以锡为基体，加入一种或几种金属经挤压或轧制及其他加工方法生产的产品",
                                        "kws": "锡材、锡棒材、非合金锡棒材、锡合金棒材、锡型材、非锡合金型材、锡合金型材、锡线材、非锡合金线材、锡合金线材、锡板、片材、非锡合金板、非锡合金片、锡合金板、锡合金片、锡带材、非锡合金带、锡合金带、锡箔材、非锡合金箔、锡合金箔、管子附件、锡管、锡管附件、锡球、锡球半球、锡盘、锡环、非锡合金材、锡合金材",
                                        "taxName": "有色金属压延材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080320010000000000",
                                        "taxCodeTitle": "有色金属压延材",
                                        "iTitle": "*有色金属压延材*锡材",
                                        "children": []
                                    },
                                    {
                                        "id": "2357",
                                        "linkid": "2355",
                                        "code": "108032002",
                                        "paCode": "1080320",
                                        "yn": "N",
                                        "title": "锡粉及锡片状粉末",
                                        "alias": "锡粉及锡片状粉末",
                                        "about": "指非锡合金锡粉、锡合金锡粉，包括片状粉末。",
                                        "kws": "非锡合金锡粉、锡合金锡粉",
                                        "taxName": "有色金属压延材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080320020000000000",
                                        "taxCodeTitle": "有色金属压延材",
                                        "iTitle": "*有色金属压延材*锡粉及锡片状粉末",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2358",
                                "linkid": "2217",
                                "code": "1080321",
                                "paCode": "10803",
                                "yn": "Y",
                                "title": "镁、钛，相关常用有色金属加工材",
                                "alias": "镁、钛，相关常用有色金属加工材",
                                "about": "包括镁材、钛材、镉材、锑材、铋材。",
                                "kws": null,
                                "taxName": "有色金属压延材",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080321000000000000",
                                "taxCodeTitle": "有色金属压延材",
                                "iTitle": "*有色金属压延材*镁、钛，相关常用有色金属加工材",
                                "children": [
                                    {
                                        "id": "2359",
                                        "linkid": "2358",
                                        "code": "108032101",
                                        "paCode": "1080321",
                                        "yn": "N",
                                        "title": "镁材",
                                        "alias": "镁材",
                                        "about": "指镁棒材、镁型材异型材、镁板材、镁带材、镁箔材、镁丝材、镁管及空心异型材和其他镁材，包括镁金属压延加工材",
                                        "kws": "镁棒材、镁型材异型材、镁板材、镁带材、镁箔材、镁丝材、镁管",
                                        "taxName": "有色金属压延材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080321010000000000",
                                        "taxCodeTitle": "有色金属压延材",
                                        "iTitle": "*有色金属压延材*镁材",
                                        "children": []
                                    },
                                    {
                                        "id": "2360",
                                        "linkid": "2358",
                                        "code": "108032102",
                                        "paCode": "1080321",
                                        "yn": "N",
                                        "title": "钛材",
                                        "alias": "钛材",
                                        "about": "指钛棒材、钛型材及异型材、钛线材、钛板材、钛带、钛箔材、钛管材、钛锻材和其他钛材，包括钛金属压延加工材",
                                        "kws": "钛棒材、钛型材、钛异型材、钛线材、钛板材、钛带、钛箔材、钛管材、钛锻材",
                                        "taxName": "有色金属压延材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080321020000000000",
                                        "taxCodeTitle": "有色金属压延材",
                                        "iTitle": "*有色金属压延材*钛材",
                                        "children": []
                                    },
                                    {
                                        "id": "2361",
                                        "linkid": "2358",
                                        "code": "108032103",
                                        "paCode": "1080321",
                                        "yn": "N",
                                        "title": "镉材",
                                        "alias": "镉材",
                                        "about": "包括镉板材、镉棒材和其他镉材。",
                                        "kws": "镉板材、镉棒材材",
                                        "taxName": "有色金属压延材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080321030000000000",
                                        "taxCodeTitle": "有色金属压延材",
                                        "iTitle": "*有色金属压延材*镉材",
                                        "children": []
                                    },
                                    {
                                        "id": "2362",
                                        "linkid": "2358",
                                        "code": "108032104",
                                        "paCode": "1080321",
                                        "yn": "N",
                                        "title": "锑材",
                                        "alias": "锑材",
                                        "about": "包括锑棒材、锑板材和其他锑材。",
                                        "kws": "锑棒材、锑板材",
                                        "taxName": "有色金属压延材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080321040000000000",
                                        "taxCodeTitle": "有色金属压延材",
                                        "iTitle": "*有色金属压延材*锑材",
                                        "children": []
                                    },
                                    {
                                        "id": "2363",
                                        "linkid": "2358",
                                        "code": "108032105",
                                        "paCode": "1080321",
                                        "yn": "N",
                                        "title": "铋材",
                                        "alias": "铋材",
                                        "about": null,
                                        "kws": "铋材",
                                        "taxName": "有色金属压延材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080321050000000000",
                                        "taxCodeTitle": "有色金属压延材",
                                        "iTitle": "*有色金属压延材*铋材",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2364",
                                "linkid": "2217",
                                "code": "1080322",
                                "paCode": "10803",
                                "yn": "Y",
                                "title": "贵金属压延加工材",
                                "alias": "贵金属压延加工材",
                                "about": "包括金加工材、银材、铂加工材、钯材、铑加工材、铱加工材、锇加工材、钌加工材和其他贵金属压延加工材。",
                                "kws": null,
                                "taxName": "贵金属加工材",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080322000000000000",
                                "taxCodeTitle": "贵金属加工材",
                                "iTitle": "*贵金属加工材*贵金属压延加工材",
                                "children": [
                                    {
                                        "id": "2365",
                                        "linkid": "2364",
                                        "code": "108032201",
                                        "paCode": "1080322",
                                        "yn": "N",
                                        "title": "金加工材",
                                        "alias": "金加工材",
                                        "about": "指金棒材和其他金加工材，包括金及金合金压延加工材",
                                        "kws": "金棒材、纯金棒材、金合金棒材",
                                        "taxName": "金加工材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080322010000000000",
                                        "taxCodeTitle": "金加工材",
                                        "iTitle": "*金加工材*金加工材",
                                        "children": []
                                    },
                                    {
                                        "id": "2366",
                                        "linkid": "2364",
                                        "code": "108032202",
                                        "paCode": "1080322",
                                        "yn": "N",
                                        "title": "银材",
                                        "alias": "银材",
                                        "about": "指银棒材、银型材、银板材、银片材、银带材和其他银材，包括银及银合金压延加工材",
                                        "kws": "银棒材、纯银棒、银合金棒、银型材、纯银型材、银合金型材、银板材、纯银板、银合金板、银片材、纯银片、银合金片、银带材、纯银带、银合金带",
                                        "taxName": "其他贵金属加工材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080322020000000000",
                                        "taxCodeTitle": "其他贵金属加工材",
                                        "iTitle": "*其他贵金属加工材*银材",
                                        "children": []
                                    },
                                    {
                                        "id": "2367",
                                        "linkid": "2364",
                                        "code": "108032203",
                                        "paCode": "1080322",
                                        "yn": "N",
                                        "title": "铂加工材",
                                        "alias": "铂加工材",
                                        "about": "指铂板材、铂片材、铂带材、铂条材、铂管材和其他铂加工材，包括铂及铂合金压延加工材",
                                        "kws": "铂板材、非合金铂板、铂合金板、铂片材、非合金铂片、铂合金片、铂带材、非合金铂带、铂合金带、铂条材、非合金铂条、铂合金条、铂管材、非合金铂管、铂合金管",
                                        "taxName": "其他贵金属加工材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080322030000000000",
                                        "taxCodeTitle": "其他贵金属加工材",
                                        "iTitle": "*其他贵金属加工材*铂加工材",
                                        "children": []
                                    },
                                    {
                                        "id": "2368",
                                        "linkid": "2364",
                                        "code": "108032204",
                                        "paCode": "1080322",
                                        "yn": "N",
                                        "title": "钯材",
                                        "alias": "钯材",
                                        "about": "指钯板材、钯片材、钯带材、钯条材、钯管材和其他钯材，包括钯及钯合金压延加工材",
                                        "kws": "钯板材、非合金钯板、钯合金板、钯片材、非合金钯片、钯合金片、钯带材、非合金钯带、钯合金带、钯条材、非合金钯条、钯合金条、钯管材、非合金钯管材、钯合金管材",
                                        "taxName": "其他贵金属加工材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080322040000000000",
                                        "taxCodeTitle": "其他贵金属加工材",
                                        "iTitle": "*其他贵金属加工材*钯材",
                                        "children": []
                                    },
                                    {
                                        "id": "2369",
                                        "linkid": "2364",
                                        "code": "108032205",
                                        "paCode": "1080322",
                                        "yn": "N",
                                        "title": "铑加工材",
                                        "alias": "铑加工材",
                                        "about": "指铑板材、铑片材、铑带材、铑条材和其他铑加工材，包括铑及铑合金压延加工材",
                                        "kws": "铑板材、非合金铑板、铑合金板、铑片材、非合金铑片、铑合金片、铑带材、非合金铑带、铑合金带、铑条材、非合金铑条、铑合金条",
                                        "taxName": "其他贵金属加工材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080322050000000000",
                                        "taxCodeTitle": "其他贵金属加工材",
                                        "iTitle": "*其他贵金属加工材*铑加工材",
                                        "children": []
                                    },
                                    {
                                        "id": "2370",
                                        "linkid": "2364",
                                        "code": "108032206",
                                        "paCode": "1080322",
                                        "yn": "N",
                                        "title": "铱加工材",
                                        "alias": "铱加工材",
                                        "about": "指铱板材、铱片材、铱薄带材和其他铱加工材，包括半制成品形状的铱、锇、钌及其他贵金属材",
                                        "kws": "铱板材、铱片材、铱薄带材",
                                        "taxName": "其他贵金属加工材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080322060000000000",
                                        "taxCodeTitle": "其他贵金属加工材",
                                        "iTitle": "*其他贵金属加工材*铱加工材",
                                        "children": []
                                    },
                                    {
                                        "id": "2371",
                                        "linkid": "2364",
                                        "code": "108032207",
                                        "paCode": "1080322",
                                        "yn": "N",
                                        "title": "锇加工材",
                                        "alias": "锇加工材",
                                        "about": "指锇板材、锇片材和其他锇加工材包括半制成品形状的铱、锇、钌及其他贵金属材",
                                        "kws": "锇板材、锇片材",
                                        "taxName": "其他贵金属加工材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080322070000000000",
                                        "taxCodeTitle": "其他贵金属加工材",
                                        "iTitle": "*其他贵金属加工材*锇加工材",
                                        "children": []
                                    },
                                    {
                                        "id": "2372",
                                        "linkid": "2364",
                                        "code": "108032208",
                                        "paCode": "1080322",
                                        "yn": "N",
                                        "title": "钌加工材",
                                        "alias": "钌加工材",
                                        "about": "包括钌板材、钌片材、钌带材和其他钌加工材。",
                                        "kws": "钌板材、钌片材、钌带材",
                                        "taxName": "其他贵金属加工材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080322080000000000",
                                        "taxCodeTitle": "其他贵金属加工材",
                                        "iTitle": "*其他贵金属加工材*钌加工材",
                                        "children": []
                                    },
                                    {
                                        "id": "2373",
                                        "linkid": "2364",
                                        "code": "108032299",
                                        "paCode": "1080322",
                                        "yn": "N",
                                        "title": "其他贵金属压延加工材",
                                        "alias": "其他贵金属压延加工材",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "其他贵金属加工材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080322990000000000",
                                        "taxCodeTitle": "其他贵金属加工材",
                                        "iTitle": "*其他贵金属加工材*其他贵金属压延加工材",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2374",
                                "linkid": "2217",
                                "code": "1080323",
                                "paCode": "10803",
                                "yn": "Y",
                                "title": "包覆贵金属金属材料",
                                "alias": "包覆贵金属金属材料",
                                "about": "包括包金金属材料、包银金属材料、包铂金属材料。",
                                "kws": null,
                                "taxName": "包覆贵金属金属材料",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080323000000000000",
                                "taxCodeTitle": "包覆贵金属金属材料",
                                "iTitle": "*包覆贵金属金属材料*包覆贵金属金属材料",
                                "children": [
                                    {
                                        "id": "2375",
                                        "linkid": "2374",
                                        "code": "108032301",
                                        "paCode": "1080323",
                                        "yn": "N",
                                        "title": "包金金属材料",
                                        "alias": "包金金属材料",
                                        "about": "指包金的金属材料用以制首饰（手镯、表链、耳环等）、表壳、雪茄嘴或香烟嘴、打火机、金器、电触头、化学装置等，包括包金棒、杆、包金板、片、包金带、包金型材、包金丝、包金管和其他包金金属材料。",
                                        "kws": "包金棒、包金杆、包金板、包金片、包金带、包金型材、包金丝、包金管",
                                        "taxName": "包覆贵金属金属材料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080323010000000000",
                                        "taxCodeTitle": "包覆贵金属金属材料",
                                        "iTitle": "*包覆贵金属金属材料*包金金属材料",
                                        "children": []
                                    },
                                    {
                                        "id": "2376",
                                        "linkid": "2374",
                                        "code": "108032302",
                                        "paCode": "1080323",
                                        "yn": "N",
                                        "title": "包银金属材料",
                                        "alias": "包银金属材料",
                                        "about": "包括包银棒、杆、包银板、片、包银带、包银型材、包银丝、包银管和其他包银金属材料。",
                                        "kws": "包银棒、包银杆、包银板、包银片、包银带、包银型材、包银丝、包银管",
                                        "taxName": "包覆贵金属金属材料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080323020000000000",
                                        "taxCodeTitle": "包覆贵金属金属材料",
                                        "iTitle": "*包覆贵金属金属材料*包银金属材料",
                                        "children": []
                                    },
                                    {
                                        "id": "2377",
                                        "linkid": "2374",
                                        "code": "108032303",
                                        "paCode": "1080323",
                                        "yn": "N",
                                        "title": "包铂金属材料",
                                        "alias": "包铂金属材料",
                                        "about": "指以银、金、及其他金属为底的包铂材料，包括包铂棒、杆、包铂板、片、包铂带、包铂型材、包铂丝、包铂管和其他包铂金属材料。",
                                        "kws": "包铂棒、包铂杆、包铂板、包铂片、包铂带、包铂型材、包铂丝、包铂管",
                                        "taxName": "包覆贵金属金属材料",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080323030000000000",
                                        "taxCodeTitle": "包覆贵金属金属材料",
                                        "iTitle": "*包覆贵金属金属材料*包铂金属材料",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2378",
                                "linkid": "2217",
                                "code": "1080324",
                                "paCode": "10803",
                                "yn": "Y",
                                "title": "稀有金属压延加工材",
                                "alias": "稀有金属压延加工材",
                                "about": "包括钨加工材、钼加工材、钽加工材、锆加工材、铌加工材、镓加工材、铪加工材、铟加工材、铼加工材、钴加工材、铍加工材、铊加工材、锗加工材、钒加工材和其他稀有稀土金属压延加工材",
                                "kws": null,
                                "taxName": "稀有金属压延材",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080324000000000000",
                                "taxCodeTitle": "稀有金属压延材",
                                "iTitle": "*稀有金属压延材*稀有金属压延加工材",
                                "children": [
                                    {
                                        "id": "2379",
                                        "linkid": "2378",
                                        "code": "108032401",
                                        "paCode": "1080324",
                                        "yn": "N",
                                        "title": "钨加工材",
                                        "alias": "钨加工材",
                                        "about": "指钨棒材、钨型材及异型材、钨板材、钨带材、钨箔、片材、钨丝材、钨高比重材、钨坩埚、钨阳极和其他钨加工材，包括钨及钨合金加工材",
                                        "kws": "钨棒材、钨型材、异型材、钨板材、钨带材、钨箔、片材、钨丝材、钨高比重材、钨坩埚、钨阳极",
                                        "taxName": "稀有金属压延材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080324010000000000",
                                        "taxCodeTitle": "稀有金属压延材",
                                        "iTitle": "*稀有金属压延材*钨加工材",
                                        "children": []
                                    },
                                    {
                                        "id": "2380",
                                        "linkid": "2378",
                                        "code": "108032402",
                                        "paCode": "1080324",
                                        "yn": "N",
                                        "title": "钼加工材",
                                        "alias": "钼加工材",
                                        "about": "指钼棒材、钼板材、钼带材、钼箔材、钼丝材、钼板坯、钼坩埚、钼顶头和其他钼材，包括钼及钼合金压延加工材",
                                        "kws": "钼棒材、钼板材、钼带材、钼箔材、钼丝材、钼板坯、钼坩埚、钼顶头、钼条、钼杆、钼片材",
                                        "taxName": "稀有金属压延材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080324020000000000",
                                        "taxCodeTitle": "稀有金属压延材",
                                        "iTitle": "*稀有金属压延材*钼加工材",
                                        "children": []
                                    },
                                    {
                                        "id": "2381",
                                        "linkid": "2378",
                                        "code": "108032403",
                                        "paCode": "1080324",
                                        "yn": "N",
                                        "title": "钽加工材",
                                        "alias": "钽加工材",
                                        "about": "指钽棒、钽板材、钽带、钽箔、钽管材、钽丝材和其他钽加工材，包括钽及钽合金加工材",
                                        "kws": "钽棒、钽板材、钽带、钽箔、钽管材、钽丝材、钽片",
                                        "taxName": "稀有金属压延材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080324030000000000",
                                        "taxCodeTitle": "稀有金属压延材",
                                        "iTitle": "*稀有金属压延材*钽加工材",
                                        "children": []
                                    },
                                    {
                                        "id": "2382",
                                        "linkid": "2378",
                                        "code": "108032404",
                                        "paCode": "1080324",
                                        "yn": "N",
                                        "title": "锆加工材",
                                        "alias": "锆加工材",
                                        "about": "指锆板材、锆棒材、锆丝材、锆管材和其他锆加工材，包括锆及锆合金加工材",
                                        "kws": "锆板材、锆棒材、锆丝材、锆管材",
                                        "taxName": "稀有金属压延材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080324040000000000",
                                        "taxCodeTitle": "稀有金属压延材",
                                        "iTitle": "*稀有金属压延材*锆加工材",
                                        "children": []
                                    },
                                    {
                                        "id": "2383",
                                        "linkid": "2378",
                                        "code": "108032405",
                                        "paCode": "1080324",
                                        "yn": "N",
                                        "title": "铌加工材",
                                        "alias": "铌加工材",
                                        "about": "指铌板材、铌棒材、铌丝材、铌管材和其他铌加工材，包括铌及铌合金加工材",
                                        "kws": "铌板材、铌棒材、铌丝材、铌管材",
                                        "taxName": "稀有金属压延材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080324050000000000",
                                        "taxCodeTitle": "稀有金属压延材",
                                        "iTitle": "*稀有金属压延材*铌加工材",
                                        "children": []
                                    },
                                    {
                                        "id": "2384",
                                        "linkid": "2378",
                                        "code": "108032406",
                                        "paCode": "1080324",
                                        "yn": "N",
                                        "title": "镓加工材",
                                        "alias": "镓加工材",
                                        "about": "指镓板材、镓棒材、镓丝材、镓管材和其他镓加工材，包括镓及镓合金加工材",
                                        "kws": "镓板材、镓棒材、镓丝材、镓管材",
                                        "taxName": "稀有金属压延材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080324060000000000",
                                        "taxCodeTitle": "稀有金属压延材",
                                        "iTitle": "*稀有金属压延材*镓加工材",
                                        "children": []
                                    },
                                    {
                                        "id": "2385",
                                        "linkid": "2378",
                                        "code": "108032407",
                                        "paCode": "1080324",
                                        "yn": "N",
                                        "title": "铪加工材",
                                        "alias": "铪加工材",
                                        "about": "指铪板材、铪棒材、铪丝材、铪管材和其他铪加工材，包括铪及铪合金加工材",
                                        "kws": "铪板材、铪棒材、铪丝材、铪管材",
                                        "taxName": "稀有金属压延材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080324070000000000",
                                        "taxCodeTitle": "稀有金属压延材",
                                        "iTitle": "*稀有金属压延材*铪加工材",
                                        "children": []
                                    },
                                    {
                                        "id": "2386",
                                        "linkid": "2378",
                                        "code": "108032408",
                                        "paCode": "1080324",
                                        "yn": "N",
                                        "title": "铟加工材",
                                        "alias": "铟加工材",
                                        "about": "指铟板材、铟棒材、铟丝材、铟管材和其他铟加工材，包括铟及铟合金加工材",
                                        "kws": "铟板材、铟棒材、铟丝材、铟管材",
                                        "taxName": "稀有金属压延材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080324080000000000",
                                        "taxCodeTitle": "稀有金属压延材",
                                        "iTitle": "*稀有金属压延材*铟加工材",
                                        "children": []
                                    },
                                    {
                                        "id": "2387",
                                        "linkid": "2378",
                                        "code": "108032409",
                                        "paCode": "1080324",
                                        "yn": "N",
                                        "title": "铼加工材",
                                        "alias": "铼加工材",
                                        "about": "指铼板材、铼棒材、铼丝材、铼管材和其他铼加工材，包括铼及铼合金加工材",
                                        "kws": "铼板材、铼棒材、铼丝材、铼管材",
                                        "taxName": "稀有金属压延材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080324090000000000",
                                        "taxCodeTitle": "稀有金属压延材",
                                        "iTitle": "*稀有金属压延材*铼加工材",
                                        "children": []
                                    },
                                    {
                                        "id": "2388",
                                        "linkid": "2378",
                                        "code": "108032410",
                                        "paCode": "1080324",
                                        "yn": "N",
                                        "title": "钴加工材",
                                        "alias": "钴加工材",
                                        "about": null,
                                        "kws": "钴加工材",
                                        "taxName": "稀有金属压延材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080324100000000000",
                                        "taxCodeTitle": "稀有金属压延材",
                                        "iTitle": "*稀有金属压延材*钴加工材",
                                        "children": []
                                    },
                                    {
                                        "id": "2389",
                                        "linkid": "2378",
                                        "code": "108032411",
                                        "paCode": "1080324",
                                        "yn": "N",
                                        "title": "铍加工材",
                                        "alias": "铍加工材",
                                        "about": null,
                                        "kws": "铍加工材",
                                        "taxName": "稀有金属压延材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080324110000000000",
                                        "taxCodeTitle": "稀有金属压延材",
                                        "iTitle": "*稀有金属压延材*铍加工材",
                                        "children": []
                                    },
                                    {
                                        "id": "2390",
                                        "linkid": "2378",
                                        "code": "108032412",
                                        "paCode": "1080324",
                                        "yn": "N",
                                        "title": "铊加工材",
                                        "alias": "铊加工材",
                                        "about": null,
                                        "kws": "铊加工材",
                                        "taxName": "稀有金属压延材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080324120000000000",
                                        "taxCodeTitle": "稀有金属压延材",
                                        "iTitle": "*稀有金属压延材*铊加工材",
                                        "children": []
                                    },
                                    {
                                        "id": "2391",
                                        "linkid": "2378",
                                        "code": "108032413",
                                        "paCode": "1080324",
                                        "yn": "N",
                                        "title": "锗加工材",
                                        "alias": "锗加工材",
                                        "about": null,
                                        "kws": "锗加工材",
                                        "taxName": "稀有金属压延材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080324130000000000",
                                        "taxCodeTitle": "稀有金属压延材",
                                        "iTitle": "*稀有金属压延材*锗加工材",
                                        "children": []
                                    },
                                    {
                                        "id": "2392",
                                        "linkid": "2378",
                                        "code": "108032414",
                                        "paCode": "1080324",
                                        "yn": "N",
                                        "title": "钒加工材",
                                        "alias": "钒加工材",
                                        "about": null,
                                        "kws": "钒加工材",
                                        "taxName": "稀有金属压延材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080324140000000000",
                                        "taxCodeTitle": "稀有金属压延材",
                                        "iTitle": "*稀有金属压延材*钒加工材",
                                        "children": []
                                    },
                                    {
                                        "id": "2393",
                                        "linkid": "2378",
                                        "code": "108032499",
                                        "paCode": "1080324",
                                        "yn": "N",
                                        "title": "其他稀有金属压延加工材",
                                        "alias": "其他稀有金属压延加工材",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "稀有金属压延材",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080324990000000000",
                                        "taxCodeTitle": "稀有金属压延材",
                                        "iTitle": "*稀有金属压延材*其他稀有金属压延加工材",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2394",
                                "linkid": "2217",
                                "code": "1080325",
                                "paCode": "10803",
                                "yn": "N",
                                "title": "废弃物资冶炼、提纯有色金属及合金",
                                "alias": "废弃物资冶炼、提纯有色金属及合金",
                                "about": "指以废弃物资为原料，经冶炼、提纯或化合生产的金属、合金及金属化合物，不包括铁（详见1080201）、铁合金（详见1080208）",
                                "kws": null,
                                "taxName": "有色金属及合金",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1080325000000000000",
                                "taxCodeTitle": "有色金属及合金",
                                "iTitle": "*有色金属及合金*废弃物资冶炼、提纯有色金属及合金",
                                "children": []
                            }
                        ]
                    },
                    {
                        "id": "2395",
                        "linkid": "2017",
                        "code": "10804",
                        "paCode": "108",
                        "yn": "Y",
                        "title": "金属制品",
                        "alias": "金属制品",
                        "about": null,
                        "kws": null,
                        "taxName": "金属制品",
                        "taxRate": "",
                        "vip": "7",
                        "itaxRate": null,
                        "taxCode": "1080400000000000000",
                        "taxCodeTitle": "金属制品",
                        "iTitle": "*金属制品*金属制品",
                        "children": [
                            {
                                "id": "2396",
                                "linkid": "2395",
                                "code": "1080401",
                                "paCode": "10804",
                                "yn": "Y",
                                "title": "金属结构",
                                "alias": "金属结构",
                                "about": "包括钢结构及其产品、锌制建筑结构体及其部件、预制建筑物（活动房屋）",
                                "kws": null,
                                "taxName": "金属制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080401000000000000",
                                "taxCodeTitle": "金属制品",
                                "iTitle": "*金属制品*金属结构",
                                "children": [
                                    {
                                        "id": "2397",
                                        "linkid": "2396",
                                        "code": "108040101",
                                        "paCode": "1080401",
                                        "yn": "N",
                                        "title": "钢结构及其产品",
                                        "alias": "钢结构及其产品",
                                        "about": "包括钢结构所用的已加工的各种型钢，不包括货架（详见109011602）",
                                        "kws": "钢结构、多高层建筑钢结构、桥梁用钢铁结构、塔桅钢结构、钢网架、钢网壳结构、钢管结构、钢模板、钢脚手架、坑道支撑用钢铁制支柱、钢制装配结构件、门式钢架轻型厂房结构、拱型波纹钢屋盖结构、城市建设钢制品、重型工业厂房结构、锅炉钢结构、钢铁可调或伸缩支柱、钢铁管状立柱、钢铁可伸缩格子平顶梁、钢铁制水闸门、钢铁制凸堤、钢栈桥、钢铁制船用桅杆、钢舷梯、钢铁制道口拦路杆、特种钢构筑物、住宅钢结构、钢铁结构体部件、钢铁结构体加工钢材",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080401010000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*钢结构及其产品",
                                        "children": []
                                    },
                                    {
                                        "id": "2398",
                                        "linkid": "2396",
                                        "code": "108040102",
                                        "paCode": "1080401",
                                        "yn": "N",
                                        "title": "锌制建筑结构体及其部件",
                                        "alias": "锌制建筑结构体及其部件",
                                        "about": "包括锌制檐槽、屋顶构件、暖房框架及房屋的其他锌制部件",
                                        "kws": "锌制建筑结构体、锌制檐槽、锌制屋顶构件、锌制暖房框架、锌制建筑结构体部件",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080401020000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*锌制建筑结构体及其部件",
                                        "children": []
                                    },
                                    {
                                        "id": "2399",
                                        "linkid": "2396",
                                        "code": "108040103",
                                        "paCode": "1080401",
                                        "yn": "N",
                                        "title": "金属结构预制建筑物（活动房屋）",
                                        "alias": "金属结构预制建筑物（活动房屋）",
                                        "about": null,
                                        "kws": "金属结构完整房屋、金属结构活动报亭、金属结构活动卫生间",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080401030000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*金属结构预制建筑物（活动房屋）",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2400",
                                "linkid": "2395",
                                "code": "1080402",
                                "paCode": "10804",
                                "yn": "Y",
                                "title": "金属门窗及类似制品",
                                "alias": "金属门窗及类似制品",
                                "about": null,
                                "kws": null,
                                "taxName": "金属制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080402000000000000",
                                "taxCodeTitle": "金属制品",
                                "iTitle": "*金属制品*金属门窗及类似制品",
                                "children": [
                                    {
                                        "id": "2401",
                                        "linkid": "2400",
                                        "code": "108040201",
                                        "paCode": "1080402",
                                        "yn": "N",
                                        "title": "金属制门及其框架、门槛",
                                        "alias": "金属制门及其框架、门槛",
                                        "about": "包括钢铁门及其框架、门槛、铝制门及其框架、门槛",
                                        "kws": "钢铁门、钢铁框架、钢铁门槛、钢铁制推拉门、钢铁制滑门、钢铁制旋转门、钢铁制防火门、钢铁制卷帘门、钢铁制防盗门、钢铁制栅栏门、铝制门、铝制门框架、门槛、铝合金推拉门、铝合金滑门、铝合金旋转门、铝合金防火门、铝合金卷帘门",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080402010000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*金属制门及其框架、门槛",
                                        "children": []
                                    },
                                    {
                                        "id": "2402",
                                        "linkid": "2400",
                                        "code": "108040202",
                                        "paCode": "1080402",
                                        "yn": "N",
                                        "title": "金属制窗及窗框",
                                        "alias": "金属制窗及窗框",
                                        "about": "包括钢铁制窗及窗框、铝制窗及窗框",
                                        "kws": "钢铁制推拉窗、钢铁制百叶窗、铝制窗、铝制窗框、铝制推拉窗、铝合金百叶窗",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080402020000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*金属制窗及窗框",
                                        "children": []
                                    },
                                    {
                                        "id": "2403",
                                        "linkid": "2400",
                                        "code": "108040203",
                                        "paCode": "1080402",
                                        "yn": "N",
                                        "title": "金属护栏及类似品",
                                        "alias": "金属护栏及类似品",
                                        "about": "包括金属制窗护网、栏、金属制阳台护栏及类似品",
                                        "kws": "钢铁制窗护网、铝合金窗护网、钢铁制窗护栏、钢铁制阳台护栏、铝制阳台护栏、锌制栏杆、锌制扶手",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080402030000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*金属护栏及类似品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2404",
                                "linkid": "2395",
                                "code": "1080403",
                                "paCode": "10804",
                                "yn": "Y",
                                "title": "金属切削工具",
                                "alias": "金属切削工具",
                                "about": "包括金属切削机床用切削刀具、工具系统、机器用刀具及刀片",
                                "kws": "金属切削机床用切削刀具、金属切削机床用刀片、硬质合金刀片、陶瓷刀片、金属陶瓷刀片、立方氮化硼刀片、金刚石刀片、车削工具、刨削工具、铣刀、可转位硬质合金铣刀、整体硬质合金铣刀、高速钢铣刀、孔加工刀具、高速钢钻头、整体硬质合金钻头、可转位硬质合金钻头、金刚石钻头、镗刀、铰刀、螺纹刀具、机用丝锥、手用丝锥、板牙、拉削刀具、齿轮刀具、滚刀、插齿刀、剃齿刀、锯削刀具、金属圆锯、双金属带锯条、硬质合金带锯条、金刚石带锯条、机用锯条、成形及专用刀具、工具系统、车削工具系统、镗铣工具系统、机器用刀具、机器用刀片、金工机械",
                                "taxName": "金属制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080403000000000000",
                                "taxCodeTitle": "金属制品",
                                "iTitle": "*金属制品*金属切削工具",
                                "children": [
                                    {
                                        "id": "2405",
                                        "linkid": "2404",
                                        "code": "108040301",
                                        "paCode": "1080403",
                                        "yn": "N",
                                        "title": "金属切削机床用切削刀具",
                                        "alias": "金属切削机床用切削刀具",
                                        "about": "包括高速钢与硬质合金材料的刀具等",
                                        "kws": "金属切削机床用刀片、硬质合金刀片、陶瓷刀片、金属陶瓷刀片、立方氮化硼刀片、金刚石刀片、车刨削工具、铣刀、可转位硬质合金铣刀、整体硬质合金铣刀、高速钢铣刀、孔加工刀具、高速钢钻头、整体硬质合金钻头、可转位硬质合金钻头、金刚石钻头、镗刀、铰刀、螺纹刀具、机用丝锥、手用丝锥、板牙、拉削刀具、齿轮刀具、滚刀、插齿刀、剃齿刀、锯削刀具、金属圆锯、双金属带锯条、硬质合金带锯条、金刚石带锯条、机用锯条、成形刀具",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080403010000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*金属切削机床用切削刀具",
                                        "children": []
                                    },
                                    {
                                        "id": "2406",
                                        "linkid": "2404",
                                        "code": "108040302",
                                        "paCode": "1080403",
                                        "yn": "N",
                                        "title": "工具系统",
                                        "alias": "工具系统",
                                        "about": "包括组合刀具、复合刀具",
                                        "kws": "车削工具系统、镗铣工具系统",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080403020000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*工具系统",
                                        "children": []
                                    },
                                    {
                                        "id": "2407",
                                        "linkid": "2404",
                                        "code": "108040303",
                                        "paCode": "1080403",
                                        "yn": "N",
                                        "title": "机器用刀具及刀片",
                                        "alias": "机器用刀具及刀片",
                                        "about": "指未装配的机器或机械器具的刀具及刀片",
                                        "kws": "金工机械用刀具刀片、木工机械用刀具刀片、厨房器具、食品工业机器用刀具刀片、农业园艺林业机器用刀具刀片、纸纺织品塑料切割机器用刀具刀片、烟叶切丝机用刀具刀片、皮革加工机器用刀具刀片",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080403030000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*机器用刀具及刀片",
                                        "children": []
                                    },
                                    {
                                        "id": "2408",
                                        "linkid": "2404",
                                        "code": "108040399",
                                        "paCode": "1080403",
                                        "yn": "N",
                                        "title": "其他金属切削工具",
                                        "alias": "其他金属切削工具",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080403990000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*其他金属切削工具",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2409",
                                "linkid": "2395",
                                "code": "1080404",
                                "paCode": "10804",
                                "yn": "Y",
                                "title": "通用手工具",
                                "alias": "通用手工具",
                                "about": "包括手工锯、锉及类似工具、钳子及类似工具、手动扳手及扳钳、锤子、螺丝刀、钻孔或攻丝工具、切管器及类似手工工具、白铁剪及类似工具、打孔冲及类似手工工具、通用手工具可互换部件、专用手工具",
                                "kws": null,
                                "taxName": "金属制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080404000000000000",
                                "taxCodeTitle": "金属制品",
                                "iTitle": "*金属制品*通用手工具",
                                "children": [
                                    {
                                        "id": "2410",
                                        "linkid": "2409",
                                        "code": "108040401",
                                        "paCode": "1080404",
                                        "yn": "N",
                                        "title": "手工锯",
                                        "alias": "手工锯",
                                        "about": "指锯木材、金属、石料或其他材料的手工锯，不论是专业用还是家庭用",
                                        "kws": "金工用手工锯、木工用手工锯",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080404010000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*手工锯",
                                        "children": []
                                    },
                                    {
                                        "id": "2411",
                                        "linkid": "2409",
                                        "code": "108040402",
                                        "paCode": "1080404",
                                        "yn": "N",
                                        "title": "锉及类似工具",
                                        "alias": "锉及类似工具",
                                        "about": "指钢锉、木锉、钢木两用锉及类似工具",
                                        "kws": "钢锉、木锉、钢木两用锉",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080404020000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*锉及类似工具",
                                        "children": []
                                    },
                                    {
                                        "id": "2412",
                                        "linkid": "2409",
                                        "code": "108040403",
                                        "paCode": "1080404",
                                        "yn": "N",
                                        "title": "钳子",
                                        "alias": "钳子",
                                        "about": "指以夹钳原理操作的颚式工具",
                                        "kws": "钳子、夹钳、镊子、起钉器",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080404030000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*钳子",
                                        "children": []
                                    },
                                    {
                                        "id": "2413",
                                        "linkid": "2409",
                                        "code": "108040404",
                                        "paCode": "1080404",
                                        "yn": "N",
                                        "title": "手动扳手及扳钳",
                                        "alias": "手动扳手及扳钳",
                                        "about": "包括各种手动扳手及扳钳，不包括消防用扳手及板钳（详见109025305）",
                                        "kws": "固定手动扳手、固定手动扳钳、可调手动扳手、可调手动扳钳",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080404040000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*手动扳手及扳钳",
                                        "children": []
                                    },
                                    {
                                        "id": "2414",
                                        "linkid": "2409",
                                        "code": "108040405",
                                        "paCode": "1080404",
                                        "yn": "N",
                                        "title": "锤子",
                                        "alias": "锤子",
                                        "about": "包括碎石锤、大木锤、石材修整锤、其他锤子",
                                        "kws": "锤子",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080404050000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*锤子",
                                        "children": []
                                    },
                                    {
                                        "id": "2415",
                                        "linkid": "2409",
                                        "code": "108040406",
                                        "paCode": "1080404",
                                        "yn": "N",
                                        "title": "螺丝刀",
                                        "alias": "螺丝刀",
                                        "about": "螺丝刀又称起子或改锥，是用来紧固或拆卸带槽螺钉的常用工具",
                                        "kws": "螺丝刀、起子、改锥",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080404060000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*螺丝刀",
                                        "children": []
                                    },
                                    {
                                        "id": "2416",
                                        "linkid": "2409",
                                        "code": "108040407",
                                        "paCode": "1080404",
                                        "yn": "N",
                                        "title": "钻孔或攻丝工具",
                                        "alias": "钻孔或攻丝工具",
                                        "about": "包括手摇曲柄钻、胸压式手摇钻及手钻、板牙铰手、丝锥扳手、搓丝板",
                                        "kws": "手摇曲柄钻、胸压式手摇钻、手钻、板牙铰手、丝锥扳手、搓丝板",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080404070000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*钻孔或攻丝工具",
                                        "children": []
                                    },
                                    {
                                        "id": "2417",
                                        "linkid": "2409",
                                        "code": "108040408",
                                        "paCode": "1080404",
                                        "yn": "N",
                                        "title": "切管器及类似手工工具",
                                        "alias": "切管器及类似手工工具",
                                        "about": "包括钳式切管器（带切割轮）、螺栓切头器、螺栓剪钳、链条切割器、其他切管器及类似手工工具",
                                        "kws": "带切割轮钳式切管器、螺栓切头器、螺栓剪钳、链条切割器",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080404080000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*切管器及类似手工工具",
                                        "children": []
                                    },
                                    {
                                        "id": "2418",
                                        "linkid": "2409",
                                        "code": "108040409",
                                        "paCode": "1080404",
                                        "yn": "N",
                                        "title": "白铁剪及类似工具",
                                        "alias": "白铁剪及类似工具",
                                        "about": "包括平头剪、切割剪、其他白铁剪及类似工具",
                                        "kws": "平头剪、切割剪",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080404090000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*白铁剪及类似工具",
                                        "children": []
                                    },
                                    {
                                        "id": "2419",
                                        "linkid": "2409",
                                        "code": "108040410",
                                        "paCode": "1080404",
                                        "yn": "N",
                                        "title": "打孔冲及类似手工工具",
                                        "alias": "打孔冲及类似手工工具",
                                        "about": "包括钮孔冲孔器、剪票钳、鞍工冲子、其他打孔冲及类似手工工具",
                                        "kws": "钮孔冲孔器、剪票钳、鞍工冲子",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080404100000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*打孔冲及类似手工工具",
                                        "children": []
                                    },
                                    {
                                        "id": "2420",
                                        "linkid": "2409",
                                        "code": "108040411",
                                        "paCode": "1080404",
                                        "yn": "N",
                                        "title": "通用手工具可互换部件",
                                        "alias": "通用手工具可互换部件",
                                        "about": "包括锯片、带锯片、圆锯片、链锯条、直锯片、其他锯片、可互换扳手套筒、其他通用手工具可互换部件",
                                        "kws": "锯片、带锯片、圆锯片、链锯条、直锯片、可互换扳手套筒",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080404110000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*通用手工具可互换部件",
                                        "children": []
                                    },
                                    {
                                        "id": "2421",
                                        "linkid": "2409",
                                        "code": "108040412",
                                        "paCode": "1080404",
                                        "yn": "N",
                                        "title": "专用手工具",
                                        "alias": "专用手工具",
                                        "about": "不包括消防、防爆专用手工工具（详见109025405）",
                                        "kws": "凿岩工具、钻探工具、金属陶瓷制凿岩工具、金属陶瓷制钻探工具、金刚石制凿岩钻探工具、立方氮化硼制凿岩钻探工具、木工专用切削工具、木工用刨子、木工用凿子、木工用辐刀、木工用木刨刀、木工用刻刀、木工用拉刮刀、木工用锛头、钟表匠用工具、压钻工具、摆轮平衡器、铆砧、主发条卷绕器、枢轴抛光工具、摆轮平衡螺钉安装工具、锻工手工具、平头錾、陷型模、套锤、方柄凿及冲头、采矿、撬杆、钢钎、截石錾、夯土器、筑路专用手工具、泥瓦、制模、镘刀、油灰托盘、刮刀、铲刀、整平针、清洁器、凹纹滚子、调色刀、玻璃刀、砂轮划片、油罐、油壶、手",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080404120000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*专用手工具",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2422",
                                "linkid": "2395",
                                "code": "1080405",
                                "paCode": "10804",
                                "yn": "Y",
                                "title": "农林、畜牧用金属工具",
                                "alias": "农林、畜牧用金属工具",
                                "about": "包括农林牧通用金属手工具、林业、园艺专用工具、畜牧专用手工具",
                                "kws": "锹、铲、叉、镐、锄、耙、斧子、钩刀、砍刀、镰刀、秣刀、林业用器类工具、种植器、播种器、点播器、泥铲、移植器、摘果器、园艺专用刀剪手工具、单手操作剪刀、双手操作剪刀、伐木专用工具、伐木楔子、木钩、木钳、木镐、畜牧专用剪刀、马鬃剪、马蹄剪、羊毛剪、羊毛抓子、动物用标记钳、牛梳、马梳、猪刮子",
                                "taxName": "金属制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080405000000000000",
                                "taxCodeTitle": "金属制品",
                                "iTitle": "*金属制品*农林、畜牧用金属工具",
                                "children": [
                                    {
                                        "id": "2423",
                                        "linkid": "2422",
                                        "code": "108040501",
                                        "paCode": "1080405",
                                        "yn": "N",
                                        "title": "农林牧通用金属手工具",
                                        "alias": "农林牧通用金属手工具",
                                        "about": "包括锹及铲、叉、镐、锄、耙、斧子、钩刀、砍刀类似砍伐工具、镰刀、秣刀、其他农林牧通用金属手工具",
                                        "kws": "锹、铲、叉、镐、锄、耙、斧子、钩刀、砍刀、镰刀、秣刀",
                                        "taxName": "金属制品",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1080405010000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*农林牧通用金属手工具",
                                        "children": []
                                    },
                                    {
                                        "id": "2424",
                                        "linkid": "2422",
                                        "code": "108040502",
                                        "paCode": "1080405",
                                        "yn": "N",
                                        "title": "林业、园艺专用工具",
                                        "alias": "林业、园艺专用工具",
                                        "about": "包括种植器、播种器、点播器、泥铲及移植器、摘果器、其他林业用器类工具、单手操作剪刀、双手操作剪刀、其他园艺专用刀剪手工具、伐木楔子、木钩、木钳、木镐、其他伐木专用工具",
                                        "kws": "种植器、播种器、点播器、泥铲、移植器、摘果器、单手操作剪刀、双手操作剪刀、伐木楔子、木钩、木钳、木镐",
                                        "taxName": "金属制品",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1080405020000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*林业、园艺专用工具",
                                        "children": []
                                    },
                                    {
                                        "id": "2425",
                                        "linkid": "2422",
                                        "code": "108040503",
                                        "paCode": "1080405",
                                        "yn": "N",
                                        "title": "畜牧专用手工具",
                                        "alias": "畜牧专用手工具",
                                        "about": "包括畜牧专用剪刀、马鬃剪、马蹄剪、羊毛剪、其他畜牧专用剪刀、羊毛抓子、动物用标记钳、牛梳、马梳及猪刮子、其他畜牧专用手工具",
                                        "kws": "畜牧专用剪刀、马鬃剪、马蹄剪、羊毛剪、羊毛抓子、动物用标记钳、牛梳、马梳、猪刮子",
                                        "taxName": "金属制品",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1080405030000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*畜牧专用手工具",
                                        "children": []
                                    },
                                    {
                                        "id": "2426",
                                        "linkid": "2422",
                                        "code": "108040599",
                                        "paCode": "1080405",
                                        "yn": "N",
                                        "title": "其他农林、畜牧用金属工具",
                                        "alias": "其他农林、畜牧用金属工具",
                                        "about": "包括犁铧、铡刀等农具",
                                        "kws": null,
                                        "taxName": "金属制品",
                                        "taxRate": "9%",
                                        "vip": "7",
                                        "itaxRate": "0.09",
                                        "taxCode": "1080405990000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*其他农林、畜牧用金属工具",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2427",
                                "linkid": "2395",
                                "code": "1080406",
                                "paCode": "10804",
                                "yn": "N",
                                "title": "专用刀具及类似器具",
                                "alias": "专用刀具及类似器具",
                                "about": "指游牧及其他特殊人员使用的金属制长刀、短刀、匕首及类似锐利器具，以及舞台、装饰用刀具和类似器具",
                                "kws": "专用刀具、专用匕首、专用剑器",
                                "taxName": "金属制品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1080406000000000000",
                                "taxCodeTitle": "金属制品",
                                "iTitle": "*金属制品*专用刀具及类似器具",
                                "children": []
                            },
                            {
                                "id": "2428",
                                "linkid": "2395",
                                "code": "1080407",
                                "paCode": "10804",
                                "yn": "Y",
                                "title": "刀剪及类似日用金属工具",
                                "alias": "刀剪及类似日用金属工具",
                                "about": "包括剪刀及类似品、日常用刀及类似制品、理发用手工具、修饰用手工具、其他刀剪及类似日用金属工具",
                                "kws": "剪刀、日常用剪刀、民用剪刀、小型折叠剪刀、缝纫剪刀、刀片、日常用刀、厨房用刀、折叠式刀、野营刀、运动刀、办公用刀、屠宰场用利口器、屠宰刀、砍骨刀、切肉刀、金属刀用零部件、刀具刀片、金属刀柄、成套刀具、理发用手工具、理发专用剪刀、手动理发推剪、削发器、手动剃须刀、手动剃须刀片、修饰用手工具、修指甲用剪刀、指甲钳、修指甲用具、修脚用具",
                                "taxName": "金属制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080407000000000000",
                                "taxCodeTitle": "金属制品",
                                "iTitle": "*金属制品*刀剪及类似日用金属工具",
                                "children": [
                                    {
                                        "id": "2429",
                                        "linkid": "2428",
                                        "code": "108040701",
                                        "paCode": "1080407",
                                        "yn": "N",
                                        "title": "剪刀及类似品",
                                        "alias": "剪刀及类似品",
                                        "about": "不包括农林牧渔用剪刀手工具（详见1080405），也不包括电工用剪刀及裁剪金属用剪刀（详见1090132）",
                                        "kws": "日常用剪刀、民用剪刀、小型折叠剪刀、缝纫剪刀、剪刀类似品、刀片",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080407010000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*剪刀及类似品",
                                        "children": []
                                    },
                                    {
                                        "id": "2430",
                                        "linkid": "2428",
                                        "code": "108040702",
                                        "paCode": "1080407",
                                        "yn": "N",
                                        "title": "日常用刀及类似制品",
                                        "alias": "日常用刀及类似制品",
                                        "about": "指有刃口的刀及其刀片和利口器，指机器或机械器具的刀及刀片除外（详见108040303）",
                                        "kws": "日常用刀、厨房用刀、折叠式刀、野营刀、运动刀、办公用刀、屠宰场用利口器、屠宰刀、砍骨刀、切肉刀、金属刀用零部件、刀具刀片、金属刀柄、成套刀具",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080407020000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*日常用刀及类似制品",
                                        "children": []
                                    },
                                    {
                                        "id": "2431",
                                        "linkid": "2428",
                                        "code": "108040703",
                                        "paCode": "1080407",
                                        "yn": "N",
                                        "title": "理发用手工具",
                                        "alias": "理发用手工具",
                                        "about": "不包括电动理发用工具(详见1090419)",
                                        "kws": "理发专用剪刀、手动理发推剪、削发器、手动剃须刀、手动剃须刀片",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080407030000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*理发用手工具",
                                        "children": []
                                    },
                                    {
                                        "id": "2432",
                                        "linkid": "2428",
                                        "code": "108040704",
                                        "paCode": "1080407",
                                        "yn": "N",
                                        "title": "修饰用手工具",
                                        "alias": "修饰用手工具",
                                        "about": "包括美容修饰用工具",
                                        "kws": "修指甲用剪刀、指甲钳、修指甲用具、修脚用具",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080407040000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*修饰用手工具",
                                        "children": []
                                    },
                                    {
                                        "id": "2433",
                                        "linkid": "2428",
                                        "code": "108040799",
                                        "paCode": "1080407",
                                        "yn": "N",
                                        "title": "其他刀剪及类似日用金属工具",
                                        "alias": "其他刀剪及类似日用金属工具",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080407990000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*其他刀剪及类似日用金属工具",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2434",
                                "linkid": "2395",
                                "code": "1080408",
                                "paCode": "10804",
                                "yn": "N",
                                "title": "喷灯、台钳，相关金属手工具",
                                "alias": "喷灯、台钳，相关金属手工具",
                                "about": "包括喷灯、台钳及类似制品、其他相关金属手工具",
                                "kws": "喷灯、台钳、夹钳、砧、轻便锻炉、带支架手摇、脚踏砂轮",
                                "taxName": "金属制品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1080408000000000000",
                                "taxCodeTitle": "金属制品",
                                "iTitle": "*金属制品*喷灯、台钳，相关金属手工具",
                                "children": []
                            },
                            {
                                "id": "2435",
                                "linkid": "2395",
                                "code": "1080409",
                                "paCode": "10804",
                                "yn": "N",
                                "title": "集装箱",
                                "alias": "集装箱",
                                "about": "包括邮政集装箱、运输液体的集装箱",
                                "kws": "保温集装箱、开顶集装箱、特种集装箱、液体运输集装箱、气体运输集装箱",
                                "taxName": "金属制品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1080409000000000000",
                                "taxCodeTitle": "金属制品",
                                "iTitle": "*金属制品*集装箱",
                                "children": []
                            },
                            {
                                "id": "2436",
                                "linkid": "2395",
                                "code": "1080410",
                                "paCode": "10804",
                                "yn": "N",
                                "title": "金属容器",
                                "alias": "金属容器",
                                "about": "包括金属压力容器、包装容器及其附件",
                                "kws": "钢铁制大型金属容器、普通碳钢制大型金属容器、不锈钢制大型金属容器、铝制大型金属容器、铝制大型槽、铝制大型罐、铝制大型桶、铜制大型容器、钢铁制包装容器、铝制包装容器、铝制软管容器、铝制易拉罐、铝制易拉罐体、铅制包装容器、铅制软管容器、锌制包装容器、锌制软管容器、锡制包装容器、锡制软管容器、铜制包装容器、金属容器塞子、金属容器盖子、金属制冠形瓶塞、瓶用倾注塞、牛奶瓶用手撕封盖、金属箔制组合式盖子、金属制封志",
                                "taxName": "金属制品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1080410000000000000",
                                "taxCodeTitle": "金属制品",
                                "iTitle": "*金属制品*金属容器",
                                "children": []
                            },
                            {
                                "id": "2437",
                                "linkid": "2395",
                                "code": "1080411",
                                "paCode": "10804",
                                "yn": "Y",
                                "title": "金属丝",
                                "alias": "金属丝",
                                "about": "包括铁丝、钢丝、铜丝、铝丝、铅丝、锌丝、镍丝、锡丝、钛丝、镁丝、金丝、银丝、钨丝、钼丝、铂丝、钯丝、铑丝、铱丝、钌丝、其他金属丝",
                                "kws": null,
                                "taxName": "金属制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080411000000000000",
                                "taxCodeTitle": "金属制品",
                                "iTitle": "*金属制品*金属丝",
                                "children": [
                                    {
                                        "id": "2438",
                                        "linkid": "2437",
                                        "code": "108041101",
                                        "paCode": "1080411",
                                        "yn": "N",
                                        "title": "铁丝",
                                        "alias": "铁丝",
                                        "about": null,
                                        "kws": "铁丝",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080411010000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*铁丝",
                                        "children": []
                                    },
                                    {
                                        "id": "2439",
                                        "linkid": "2437",
                                        "code": "108041102",
                                        "paCode": "1080411",
                                        "yn": "N",
                                        "title": "钢丝",
                                        "alias": "钢丝",
                                        "about": "包括非合金钢钢丝、低合金钢钢丝、合金、钢钢丝、不锈钢钢丝",
                                        "kws": "热镀锌中碳钢丝、高碳钢丝、热镀锌低碳钢丝、预应力钢丝、弹簧钢丝、回火胎圈钢丝、胶管钢丝、铝包钢丝或铜包钢丝、冷顶锻钢丝、冷冲压钢丝、低合金钢钢丝、合金弹簧钢丝、合金焊接钢丝、合金轴承钢丝、管桩钢丝、不锈钢钢丝",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080411020000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*钢丝",
                                        "children": []
                                    },
                                    {
                                        "id": "2440",
                                        "linkid": "2437",
                                        "code": "108041103",
                                        "paCode": "1080411",
                                        "yn": "N",
                                        "title": "铜丝",
                                        "alias": "铜丝",
                                        "about": "包括铜合金丝、铜合金丝",
                                        "kws": "精炼铜丝、铜锌合金丝、铜镍合金丝、铜镍锌合金丝",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080411030000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*铜丝",
                                        "children": []
                                    },
                                    {
                                        "id": "2441",
                                        "linkid": "2437",
                                        "code": "108041104",
                                        "paCode": "1080411",
                                        "yn": "N",
                                        "title": "铝丝",
                                        "alias": "铝丝",
                                        "about": "包括非合金铝丝、铝合金丝",
                                        "kws": "非合金铝丝、铝合金丝",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080411040000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*铝丝",
                                        "children": []
                                    },
                                    {
                                        "id": "2442",
                                        "linkid": "2437",
                                        "code": "108041105",
                                        "paCode": "1080411",
                                        "yn": "N",
                                        "title": "铅丝",
                                        "alias": "铅丝",
                                        "about": "包括非合金铅丝、铅合金丝",
                                        "kws": "非合金铅丝、铅合金丝",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080411050000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*铅丝",
                                        "children": []
                                    },
                                    {
                                        "id": "2443",
                                        "linkid": "2437",
                                        "code": "108041106",
                                        "paCode": "1080411",
                                        "yn": "N",
                                        "title": "锌丝",
                                        "alias": "锌丝",
                                        "about": "包括非合金锌丝、锌合金丝",
                                        "kws": "非合金锌丝、锌合金丝",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080411060000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*锌丝",
                                        "children": []
                                    },
                                    {
                                        "id": "2444",
                                        "linkid": "2437",
                                        "code": "108041107",
                                        "paCode": "1080411",
                                        "yn": "N",
                                        "title": "镍丝",
                                        "alias": "镍丝",
                                        "about": "包括非合金镍丝、镍合金丝",
                                        "kws": "非合金镍丝、镍合金丝",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080411070000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*镍丝",
                                        "children": []
                                    },
                                    {
                                        "id": "2445",
                                        "linkid": "2437",
                                        "code": "108041108",
                                        "paCode": "1080411",
                                        "yn": "N",
                                        "title": "锡丝",
                                        "alias": "锡丝",
                                        "about": "包括非锡合金丝、锡合金丝",
                                        "kws": "非锡合金丝、锡合金丝",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080411080000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*锡丝",
                                        "children": []
                                    },
                                    {
                                        "id": "2446",
                                        "linkid": "2437",
                                        "code": "108041109",
                                        "paCode": "1080411",
                                        "yn": "N",
                                        "title": "钛丝",
                                        "alias": "钛丝",
                                        "about": "包括非合金钛丝、钛合金丝",
                                        "kws": "非合金钛丝、钛合金丝",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080411090000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*钛丝",
                                        "children": []
                                    },
                                    {
                                        "id": "2447",
                                        "linkid": "2437",
                                        "code": "108041110",
                                        "paCode": "1080411",
                                        "yn": "N",
                                        "title": "镁丝",
                                        "alias": "镁丝",
                                        "about": "包括非合金镁丝、镁合金丝",
                                        "kws": "非合金镁丝、镁合金丝",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080411100000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*镁丝",
                                        "children": []
                                    },
                                    {
                                        "id": "2448",
                                        "linkid": "2437",
                                        "code": "108041111",
                                        "paCode": "1080411",
                                        "yn": "N",
                                        "title": "金丝",
                                        "alias": "金丝",
                                        "about": "包括纯金丝、金合金丝",
                                        "kws": "纯金丝、金合金丝",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080411110000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*金丝",
                                        "children": []
                                    },
                                    {
                                        "id": "2449",
                                        "linkid": "2437",
                                        "code": "108041112",
                                        "paCode": "1080411",
                                        "yn": "N",
                                        "title": "银丝",
                                        "alias": "银丝",
                                        "about": "包括纯银丝、银合金丝",
                                        "kws": "纯银丝、银合金丝",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080411120000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*银丝",
                                        "children": []
                                    },
                                    {
                                        "id": "2450",
                                        "linkid": "2437",
                                        "code": "108041113",
                                        "paCode": "1080411",
                                        "yn": "N",
                                        "title": "钨丝",
                                        "alias": "钨丝",
                                        "about": null,
                                        "kws": "钨丝",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080411130000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*钨丝",
                                        "children": []
                                    },
                                    {
                                        "id": "2451",
                                        "linkid": "2437",
                                        "code": "108041114",
                                        "paCode": "1080411",
                                        "yn": "N",
                                        "title": "钼丝",
                                        "alias": "钼丝",
                                        "about": null,
                                        "kws": "钼丝",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080411140000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*钼丝",
                                        "children": []
                                    },
                                    {
                                        "id": "2452",
                                        "linkid": "2437",
                                        "code": "108041115",
                                        "paCode": "1080411",
                                        "yn": "N",
                                        "title": "铂丝",
                                        "alias": "铂丝",
                                        "about": "包括非合金铂丝、铂合金丝",
                                        "kws": "非合金铂丝、铂合金丝",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080411150000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*铂丝",
                                        "children": []
                                    },
                                    {
                                        "id": "2453",
                                        "linkid": "2437",
                                        "code": "108041116",
                                        "paCode": "1080411",
                                        "yn": "N",
                                        "title": "钯丝",
                                        "alias": "钯丝",
                                        "about": "包括非合金钯丝、钯合金丝",
                                        "kws": "非合金钯丝、钯合金丝",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080411160000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*钯丝",
                                        "children": []
                                    },
                                    {
                                        "id": "2454",
                                        "linkid": "2437",
                                        "code": "108041117",
                                        "paCode": "1080411",
                                        "yn": "N",
                                        "title": "铑丝",
                                        "alias": "铑丝",
                                        "about": "包括非合金铑丝、铑合金丝",
                                        "kws": "非合金铑丝、铑合金丝",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080411170000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*铑丝",
                                        "children": []
                                    },
                                    {
                                        "id": "2455",
                                        "linkid": "2437",
                                        "code": "108041118",
                                        "paCode": "1080411",
                                        "yn": "N",
                                        "title": "铱丝",
                                        "alias": "铱丝",
                                        "about": null,
                                        "kws": "铱丝",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080411180000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*铱丝",
                                        "children": []
                                    },
                                    {
                                        "id": "2456",
                                        "linkid": "2437",
                                        "code": "108041119",
                                        "paCode": "1080411",
                                        "yn": "N",
                                        "title": "钌丝",
                                        "alias": "钌丝",
                                        "about": null,
                                        "kws": "钌丝",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080411190000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*钌丝",
                                        "children": []
                                    },
                                    {
                                        "id": "2457",
                                        "linkid": "2437",
                                        "code": "108041199",
                                        "paCode": "1080411",
                                        "yn": "N",
                                        "title": "其他金属丝",
                                        "alias": "其他金属丝",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080411990000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*其他金属丝",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2458",
                                "linkid": "2395",
                                "code": "1080412",
                                "paCode": "10804",
                                "yn": "Y",
                                "title": "金属制绳、缆",
                                "alias": "金属制绳、缆",
                                "about": "指非绝缘的金属制绳、缆、带，不包括裸电线（详见109040901）",
                                "kws": null,
                                "taxName": "金属制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080412000000000000",
                                "taxCodeTitle": "金属制品",
                                "iTitle": "*金属制品*金属制绳、缆",
                                "children": [
                                    {
                                        "id": "2459",
                                        "linkid": "2458",
                                        "code": "108041201",
                                        "paCode": "1080412",
                                        "yn": "N",
                                        "title": "钢铁制绳、缆、带",
                                        "alias": "钢铁制绳、缆、带",
                                        "about": "包括钢丝绳、钢绞线、钢绳缆、钢铁编带、钢丝绳吊具、其他钢铁制绳、缆、带",
                                        "kws": "钢丝绳、轮胎用钢帘线、矿井用钢丝绳、钻井用钢丝绳、机械用钢丝绳、电梯用钢丝绳、架空索道、缆车用钢丝绳、胶带用钢丝绳、航空用钢丝绳、钢绞线、预应力钢绞线、钢芯铝绞线用镀锌钢绞线、钢丝索、钢绳缆、钢铁编带、钢丝绳吊具",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080412010000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*钢铁制绳、缆、带",
                                        "children": []
                                    },
                                    {
                                        "id": "2460",
                                        "linkid": "2458",
                                        "code": "108041202",
                                        "paCode": "1080412",
                                        "yn": "N",
                                        "title": "铜丝绞线、缆、编带",
                                        "alias": "铜丝绞线、缆、编带",
                                        "about": "包括铜丝绞线、缆、编带、铜丝绞线、铜丝缆、铜丝编带",
                                        "kws": "铜缆、铜编带、铜丝绞线、铜丝缆、铜丝编带",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080412020000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*铜丝绞线、缆、编带",
                                        "children": []
                                    },
                                    {
                                        "id": "2461",
                                        "linkid": "2458",
                                        "code": "108041203",
                                        "paCode": "1080412",
                                        "yn": "N",
                                        "title": "铝制绞股线、缆、编带",
                                        "alias": "铝制绞股线、缆、编带",
                                        "about": "包括铝制绞股线、缆、编带、钢芯铝绞股线、钢芯铝制缆、钢芯铝制编带及类似品、其他铝制绞股线、缆、编带",
                                        "kws": "铝制绞股线、铝缆、铝编带、钢芯铝绞股线、钢芯铝制缆、钢芯铝制编带",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080412030000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*铝制绞股线、缆、编带",
                                        "children": []
                                    },
                                    {
                                        "id": "2462",
                                        "linkid": "2458",
                                        "code": "108041204",
                                        "paCode": "1080412",
                                        "yn": "N",
                                        "title": "铅绞线、束或绳",
                                        "alias": "铅绞线、束或绳",
                                        "about": "指用于包装或管子接口堵缝的铅线绞、束或绳",
                                        "kws": "铅绞线、铅绞束、铅绞绳",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080412040000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*铅绞线、束或绳",
                                        "children": []
                                    },
                                    {
                                        "id": "2463",
                                        "linkid": "2458",
                                        "code": "108041299",
                                        "paCode": "1080412",
                                        "yn": "N",
                                        "title": "其他金属制绳、缆",
                                        "alias": "其他金属制绳、缆",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080412990000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*其他金属制绳、缆",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2464",
                                "linkid": "2395",
                                "code": "1080413",
                                "paCode": "10804",
                                "yn": "Y",
                                "title": "金属丝绳制品",
                                "alias": "金属丝绳制品",
                                "about": "包括金属丝制的布、网、篱、格栅",
                                "kws": "钢铁丝制品、钢铁丝环形带、不锈钢制机器用环形带、钢丝布、不锈钢制相关机织布、镀锌钢丝布、钢铁丝网、交点焊接钢丝网、镀锌钢丝网、涂塑钢丝网、钢铁丝篱、交点焊接钢丝篱、镀锌钢丝篱、涂塑钢丝篱、网眼钢铁板、围篱用钢铁带、带刺钢铁丝、围篱钢铁绞带、围篱钢铁单股扁丝、围篱用钢铁松绞丝、铜丝制品、铜丝制布、工业用铜丝制布、非工业用铜丝制布、铜丝制网、工业用铜丝制网、非工业用铜丝制网、铜丝制格栅、工业用铜丝制格栅、非工业用铜丝制格栅、铜丝制网眼铜板、工业用铜丝制网眼铜板、非工业用铜丝制网眼铜板、铝丝制品、铝丝制布、工业",
                                "taxName": "金属制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080413000000000000",
                                "taxCodeTitle": "金属制品",
                                "iTitle": "*金属制品*金属丝绳制品",
                                "children": [
                                    {
                                        "id": "2465",
                                        "linkid": "2464",
                                        "code": "108041301",
                                        "paCode": "1080413",
                                        "yn": "N",
                                        "title": "钢铁丝制品",
                                        "alias": "钢铁丝制品",
                                        "about": "包括钢铁丝环形带、钢丝布、钢铁丝网、钢铁丝篱及格栅、网眼钢铁板、围篱用钢铁带及丝、其他钢铁丝制品",
                                        "kws": "钢铁丝制品、钢铁丝环形带、不锈钢制机器用环形带、钢丝布、不锈钢制机织布、镀锌钢丝布、钢铁丝网、交点焊接钢丝网、镀锌钢丝网、涂塑钢丝网、钢铁丝篱、交点焊接钢丝篱、镀锌钢丝篱、涂塑钢丝篱、网眼钢铁板、围篱用钢铁带、带刺钢铁丝、围篱钢铁绞带、围篱钢铁单股扁丝、围篱用钢铁松绞丝",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080413010000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*钢铁丝制品",
                                        "children": []
                                    },
                                    {
                                        "id": "2466",
                                        "linkid": "2464",
                                        "code": "108041302",
                                        "paCode": "1080413",
                                        "yn": "N",
                                        "title": "铜丝制品",
                                        "alias": "铜丝制品",
                                        "about": "包括铜丝布（包括环型带）、网、格栅",
                                        "kws": "铜丝制布、工业用铜丝制布、非工业用铜丝制布、铜丝制网、工业用铜丝制网、非工业用铜丝制网、铜丝制格栅、工业用铜丝制格栅、非工业用铜丝制格栅、铜丝制网眼铜板、工业用铜丝制网眼铜板、非工业用铜丝制网眼铜板",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080413020000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*铜丝制品",
                                        "children": []
                                    },
                                    {
                                        "id": "2467",
                                        "linkid": "2464",
                                        "code": "108041303",
                                        "paCode": "1080413",
                                        "yn": "N",
                                        "title": "铝丝制品",
                                        "alias": "铝丝制品",
                                        "about": "包括铝丝布、格栅、网及栏栅及类似铝丝制品",
                                        "kws": "铝丝制布、工业用铝丝布、非工业用铝丝布、铝丝制格栅、工业用铝丝格栅、非工业用铝丝格栅",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080413030000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*铝丝制品",
                                        "children": []
                                    },
                                    {
                                        "id": "2468",
                                        "linkid": "2464",
                                        "code": "108041304",
                                        "paCode": "1080413",
                                        "yn": "N",
                                        "title": "镍丝制品",
                                        "alias": "镍丝制品",
                                        "about": "包括镍丝布、格栅及网",
                                        "kws": "镍丝布、镍制格栅、镍制网、工业用镍格栅、非工业用镍格栅、网眼镍板",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080413040000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*镍丝制品",
                                        "children": []
                                    },
                                    {
                                        "id": "2469",
                                        "linkid": "2464",
                                        "code": "108041305",
                                        "paCode": "1080413",
                                        "yn": "N",
                                        "title": "锌丝制品",
                                        "alias": "锌丝制品",
                                        "about": "包括锌丝制的布、网、篱、格栅以及网眼锌板",
                                        "kws": "锌丝制布、锌丝制网、锌丝制篱、锌丝制网眼锌板",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080413050000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*锌丝制品",
                                        "children": []
                                    },
                                    {
                                        "id": "2470",
                                        "linkid": "2464",
                                        "code": "108041399",
                                        "paCode": "1080413",
                                        "yn": "N",
                                        "title": "其他金属丝绳制品",
                                        "alias": "其他金属丝绳制品",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080413990000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*其他金属丝绳制品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2471",
                                "linkid": "2395",
                                "code": "1080414",
                                "paCode": "10804",
                                "yn": "Y",
                                "title": "金属紧固件、金属钉",
                                "alias": "金属紧固件、金属钉",
                                "about": "包括金属制螺钉、螺栓、螺母、铆钉、销挡圈",
                                "kws": null,
                                "taxName": "金属制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080414000000000000",
                                "taxCodeTitle": "金属制品",
                                "iTitle": "*金属制品*金属紧固件、金属钉",
                                "children": [
                                    {
                                        "id": "2472",
                                        "linkid": "2471",
                                        "code": "108041401",
                                        "paCode": "1080414",
                                        "yn": "N",
                                        "title": "钢铁制紧固件",
                                        "alias": "钢铁制紧固件",
                                        "about": "包括螺钉、螺栓、螺母、钢铁制垫圈、铆钉、开尾销、销及锥形销、簧环、其他钢铁制紧固件",
                                        "kws": "螺钉、方头螺钉、螺旋道钉、木螺钉、钩头螺钉、环头螺钉、自攻螺钉、螺栓、U形螺栓、螺栓端、双头螺栓、螺母、钢铁制垫圈、弹簧垫圈、铆钉、开尾销、锥形销、簧环",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080414010000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*钢铁制紧固件",
                                        "children": []
                                    },
                                    {
                                        "id": "2473",
                                        "linkid": "2471",
                                        "code": "108041402",
                                        "paCode": "1080414",
                                        "yn": "N",
                                        "title": "铜制紧固件",
                                        "alias": "铜制紧固件",
                                        "about": "包括铜制螺钉、铜制木螺钉、其他铜制螺钉、铜制螺栓、铜制螺母、铜制垫圈、其他铜制紧固件",
                                        "kws": "铜制螺钉、铜制木螺钉、铜制螺栓、铜制螺母、铜制垫圈",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080414020000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*铜制紧固件",
                                        "children": []
                                    },
                                    {
                                        "id": "2474",
                                        "linkid": "2471",
                                        "code": "108041403",
                                        "paCode": "1080414",
                                        "yn": "N",
                                        "title": "铝制紧固件",
                                        "alias": "铝制紧固件",
                                        "about": "包括铝制螺钉、铝制螺栓、铝制螺母、铝制铆钉、其他铝制紧固件",
                                        "kws": "铝制螺钉、铝制螺栓、铝制螺母、铝制铆钉",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080414030000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*铝制紧固件",
                                        "children": []
                                    },
                                    {
                                        "id": "2475",
                                        "linkid": "2471",
                                        "code": "108041404",
                                        "paCode": "1080414",
                                        "yn": "N",
                                        "title": "其他金属紧固件",
                                        "alias": "其他金属紧固件",
                                        "about": "指除钢铁制紧固件（详见108041401）、铜制紧固件（详见108041402）、铝制紧固件（详见108041403）以外的金属紧固件",
                                        "kws": null,
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080414040000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*其他金属紧固件",
                                        "children": []
                                    },
                                    {
                                        "id": "2476",
                                        "linkid": "2471",
                                        "code": "108041405",
                                        "paCode": "1080414",
                                        "yn": "N",
                                        "title": "金属钉",
                                        "alias": "金属钉",
                                        "about": "包括钢铁制钉、铜制钉、铝制钉、其他金属钉",
                                        "kws": "钢铁制钉、圆铁钉、U形钉、锻造扣钉、扒钉、钩头道钉、波纹钉、针布钉、钢铁制大头钉、铜制钉、圆铜钉、U形铜钉、铜制大头钉、铜头铁钉、铜头钢钉、铝制钉",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080414050000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*金属钉",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2477",
                                "linkid": "2395",
                                "code": "1080415",
                                "paCode": "10804",
                                "yn": "Y",
                                "title": "弹簧",
                                "alias": "弹簧",
                                "about": "包括钢铁制弹簧、铜弹簧",
                                "kws": null,
                                "taxName": "金属制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080415000000000000",
                                "taxCodeTitle": "金属制品",
                                "iTitle": "*金属制品*弹簧",
                                "children": [
                                    {
                                        "id": "2478",
                                        "linkid": "2477",
                                        "code": "108041501",
                                        "paCode": "1080415",
                                        "yn": "N",
                                        "title": "钢铁制弹簧",
                                        "alias": "钢铁制弹簧",
                                        "about": "包括钢铁制弹簧及弹簧片",
                                        "kws": "钢铁片簧、铁道车辆用钢铁片簧、汽车用钢铁片簧、螺旋弹簧、铁道车辆用钢铁螺旋弹簧、压缩弹簧、铁道车辆用压缩弹簧、拉伸弹簧、铁道车辆用拉伸弹簧、扭转弹簧、铁道车辆用扭转弹簧、碟形弹簧、铁道车辆用碟形弹簧、钢铁涡旋弹簧、铁道车辆用涡旋弹簧",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080415010000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*钢铁制弹簧",
                                        "children": []
                                    },
                                    {
                                        "id": "2479",
                                        "linkid": "2477",
                                        "code": "108041502",
                                        "paCode": "1080415",
                                        "yn": "N",
                                        "title": "铜弹簧",
                                        "alias": "铜弹簧",
                                        "about": "包括磷青铜弹簧、铍铜弹簧、铝青铜弹簧、硅青铜弹簧、黄铜弹簧、德银弹簧、其他铜弹簧",
                                        "kws": "磷青铜弹簧、铍铜弹簧、铝青铜弹簧、硅青铜弹簧、黄铜弹簧、德银弹簧",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080415020000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*铜弹簧",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2480",
                                "linkid": "2395",
                                "code": "1080416",
                                "paCode": "10804",
                                "yn": "N",
                                "title": "锁及其附件",
                                "alias": "锁及其附件",
                                "about": "包括金属制的锁及带锁的扣环及扣环框架和钥匙",
                                "kws": "钥匙锁、门锁、挂锁、自行车锁、家具用锁、机动车用锁、机动车用中央控制门锁、数码锁、电子程控锁、带锁扣环、扣环框架、锁具零件、钥匙",
                                "taxName": "金属制品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1080416000000000000",
                                "taxCodeTitle": "金属制品",
                                "iTitle": "*金属制品*锁及其附件",
                                "children": []
                            },
                            {
                                "id": "2481",
                                "linkid": "2395",
                                "code": "1080417",
                                "paCode": "10804",
                                "yn": "N",
                                "title": "家具、建筑用金属附件及架座；金属制建筑装饰及其零件",
                                "alias": "家具、建筑用金属附件及架座；金属制建筑装饰及其零件",
                                "about": "包括用于家具、门窗、箱等的贱金属附件及架座",
                                "kws": "金属制铰链、金属制折叶、金属制小脚轮、家具用金属附件、家具腿用保护饰钉、金属装饰附件、家具用金属加强板、加强角、碗橱金属制附件、床架金属制附件、箱柜用金属附件、配件、金属拉手、球形把手、建筑用金属制附件、架座、门窗用五金件、楼梯用金属附件、金属制自动闭门器、金属制帽架、帽钩、托架、金属制晾衣架、金属制窗帘杆、信箱板、金属跳板、金属水泥钢隔板、脚手架扣件、金属制滑轨类制品、金属制滑轨、机动车辆用金属制附件、扶手杆、把手、遮帘用配件、车内行李架、开窗机件、专用金属烟灰缸、金属制后车厢板扣件、鞍具、盒子用金属附",
                                "taxName": "金属制品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1080417000000000000",
                                "taxCodeTitle": "金属制品",
                                "iTitle": "*金属制品*家具、建筑用金属附件及架座；金属制建筑装饰及其零件",
                                "children": []
                            },
                            {
                                "id": "2482",
                                "linkid": "2395",
                                "code": "1080418",
                                "paCode": "10804",
                                "yn": "Y",
                                "title": "散热器及其零件",
                                "alias": "散热器及其零件",
                                "about": null,
                                "kws": "供暖用散热器、暖气片、散热器、铸铁制供暖用散热器、钢铁制集中供暖散热器、散热器零件、暖气分布器、暖气分布器、空气加热器、暖气分布器零件",
                                "taxName": "金属制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080418000000000000",
                                "taxCodeTitle": "金属制品",
                                "iTitle": "*金属制品*散热器及其零件",
                                "children": [
                                    {
                                        "id": "2483",
                                        "linkid": "2482",
                                        "code": "108041801",
                                        "paCode": "1080418",
                                        "yn": "N",
                                        "title": "供暖用散热器（暖气片）",
                                        "alias": "供暖用散热器（暖气片）",
                                        "about": "指集中供暖用散热器；包括非电热的钢铁制集中供暖用散热器及其零件",
                                        "kws": "散热器、铸铁制供暖用散热器、钢铁制集中供暖散热器、散热器零件",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080418010000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*供暖用散热器（暖气片）",
                                        "children": []
                                    },
                                    {
                                        "id": "2484",
                                        "linkid": "2482",
                                        "code": "108041802",
                                        "paCode": "1080418",
                                        "yn": "N",
                                        "title": "暖气分布器及零件",
                                        "alias": "暖气分布器及零件",
                                        "about": "指非电热钢铁制暖气分布器及零件",
                                        "kws": "暖气分布器、空气加热器、暖气分布器零件",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080418020000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*暖气分布器及零件",
                                        "children": []
                                    },
                                    {
                                        "id": "2485",
                                        "linkid": "2482",
                                        "code": "108041899",
                                        "paCode": "1080418",
                                        "yn": "N",
                                        "title": "其他散热器及其零件",
                                        "alias": "其他散热器及其零件",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080418990000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*其他散热器及其零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2486",
                                "linkid": "2395",
                                "code": "1080419",
                                "paCode": "10804",
                                "yn": "Y",
                                "title": "安全、消防用金属制品",
                                "alias": "安全、消防用金属制品",
                                "about": "包括保险箱、柜、库门及钱箱、文件、档案柜、金属制安全帽、其他安全、消防用金属制品",
                                "kws": null,
                                "taxName": "金属制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1080419000000000000",
                                "taxCodeTitle": "金属制品",
                                "iTitle": "*金属制品*安全、消防用金属制品",
                                "children": [
                                    {
                                        "id": "2487",
                                        "linkid": "2486",
                                        "code": "108041901",
                                        "paCode": "1080419",
                                        "yn": "N",
                                        "title": "保险箱、柜、库门及钱箱",
                                        "alias": "保险箱、柜、库门及钱箱",
                                        "about": "指其壁已装甲（即用高强度合金钢铠装）的或其钢板已用钢筋混凝土等加强的用以保管贵重物品、珠宝首饰、文件等，可防盗防火的钢制容器及保险库的门",
                                        "kws": "保险库门、保险柜、便携式保险箱",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080419010000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*保险箱、柜、库门及钱箱",
                                        "children": []
                                    },
                                    {
                                        "id": "2488",
                                        "linkid": "2486",
                                        "code": "108041902",
                                        "paCode": "1080419",
                                        "yn": "N",
                                        "title": "文件、档案柜",
                                        "alias": "文件、档案柜",
                                        "about": "指非落地式的文件、档案柜，落地式的文件档案柜（详见108041901）",
                                        "kws": "金属制档案柜、金属制档案索引柜、金属制文件柜、金属制台式文件柜",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080419020000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*文件、档案柜",
                                        "children": []
                                    },
                                    {
                                        "id": "2489",
                                        "linkid": "2486",
                                        "code": "108041903",
                                        "paCode": "1080419",
                                        "yn": "N",
                                        "title": "金属制安全帽",
                                        "alias": "金属制安全帽",
                                        "about": "不包括体育专用头盔（详见106040606）",
                                        "kws": "消防员用钢制头盔、摩托车驾驶员用钢制头盔",
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080419030000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*金属制安全帽",
                                        "children": []
                                    },
                                    {
                                        "id": "2490",
                                        "linkid": "2486",
                                        "code": "108041999",
                                        "paCode": "1080419",
                                        "yn": "N",
                                        "title": "其他安全、消防用金属制品",
                                        "alias": "其他安全、消防用金属制品",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "金属制品",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1080419990000000000",
                                        "taxCodeTitle": "金属制品",
                                        "iTitle": "*金属制品*其他安全、消防用金属制品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2491",
                                "linkid": "2395",
                                "code": "1080420",
                                "paCode": "10804",
                                "yn": "N",
                                "title": "搪瓷制品",
                                "alias": "搪瓷制品",
                                "about": "包括工业生产配套用搪瓷制品、搪瓷洗涤器具、医、疗、卫生用搪瓷制品、搪瓷制厨房用具、搪瓷餐具、搪瓷铸铁制厨房、餐桌用具、其他搪瓷制品",
                                "kws": "搪瓷制大型金属容器、搪瓷反应罐、搪瓷反应锅、搪瓷制储存罐、家用电器配套用搪瓷制件、电热水器用搪瓷内胆、洗衣机用搪瓷内、搪瓷外壳、微波炉用搪瓷内胆、烤箱用搪瓷内壳、搪瓷制建筑装饰材料、高层建筑用搪瓷储水箱、搪瓷制内外墙板、隧道搪瓷墙面、地铁搪瓷墙面、卫生间搪瓷隔板、建筑用搪瓷管道、工业用搪瓷制管道、工业用搪瓷制阀门、搪瓷洗涤器具、搪瓷浴缸、搪瓷洗涤槽、搪瓷盥洗盆、医疗卫生用搪瓷制品、搪瓷针盒、搪瓷大便器、搪瓷尿壶及痰盂、搪瓷制厨房用具、搪瓷锅、搪瓷壶、搪瓷盆、搪瓷钢铁制烧烤炉、搪瓷桶、搪瓷盒、搪瓷餐具、搪瓷",
                                "taxName": "金属制品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1080420000000000000",
                                "taxCodeTitle": "金属制品",
                                "iTitle": "*金属制品*搪瓷制品",
                                "children": []
                            },
                            {
                                "id": "2492",
                                "linkid": "2395",
                                "code": "1080421",
                                "paCode": "10804",
                                "yn": "N",
                                "title": "金属制卫生器具",
                                "alias": "金属制卫生器具",
                                "about": "指供水或接受、排出污水或污物的金属容器或装置。包括便溺用金属卫生器具：如大便器、小便器等；盥洗、淋浴用金属卫生器具：如洗脸盆、淋浴器等；洗涤用卫生器具：如洗涤盆、污水盆等；专用金属卫生器具：如医疗、科学研究实验室等特殊需要的卫生器具",
                                "kws": "金属大便器、金属小便器、金属洗脸盆、金属淋浴器、金属洗涤盆、金属污水盆、医疗科学研究实验室特殊需要的金属制卫生器具",
                                "taxName": "金属制品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1080421000000000000",
                                "taxCodeTitle": "金属制品",
                                "iTitle": "*金属制品*金属制卫生器具",
                                "children": []
                            },
                            {
                                "id": "2493",
                                "linkid": "2395",
                                "code": "1080422",
                                "paCode": "10804",
                                "yn": "N",
                                "title": "金属制烹饪炊具",
                                "alias": "金属制烹饪炊具",
                                "about": "包括钢铝复合底炒锅、煎锅等锅具",
                                "kws": "金属制烹饪炊具、金属烹饪炊具",
                                "taxName": "金属制品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1080422000000000000",
                                "taxCodeTitle": "金属制品",
                                "iTitle": "*金属制品*金属制烹饪炊具",
                                "children": []
                            },
                            {
                                "id": "2494",
                                "linkid": "2395",
                                "code": "1080423",
                                "paCode": "10804",
                                "yn": "N",
                                "title": "金属制餐具",
                                "alias": "金属制餐具",
                                "about": "指以金属或其合金为基本材料制成的食器",
                                "kws": "金属制餐具、金属餐具",
                                "taxName": "金属制品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1080423000000000000",
                                "taxCodeTitle": "金属制品",
                                "iTitle": "*金属制品*金属制餐具",
                                "children": []
                            },
                            {
                                "id": "2495",
                                "linkid": "2395",
                                "code": "1080424",
                                "paCode": "10804",
                                "yn": "N",
                                "title": "金属制日用杂品",
                                "alias": "金属制日用杂品",
                                "about": "包括金属制烟具及类似制品、金属制缝衣针及类似制品、服装、鞋帽及类似品金属附件、厨房用金属丝绒、擦锅器、非电动金属制铃、钟、锣、铝箔纸制品、金属制普通标牌、奖杯、奖章及类似品、金属制钥匙扣及类似品、其他金属制日用杂品",
                                "kws": "金属制成套吸烟用具、金属制香烟盒、火柴盒、香案、香炉、金属制缝衣针、金属制织补针、金属制刺绣针、金属制编织针、金属制钩针、金属制环、金属制眼、金属制管形铆钉、开口铆钉、金属制钩、金属制扣、金属制带扣框架、金属制环扣、金属制扣夹、金属制珠子、金属制亮晶片、厨房用金属丝绒、擦锅器、钢铁丝绒、铝制擦锅器、洗刷擦光用块垫、铜制刷锅器、非电动金属制铃、钟、锣、非电动金属制普通铃、非电动金属制装饰钟、铃、铝箔纸制品、金属制奖杯、金属制奖章、金属制普通标牌、金属制普通奖杯、金属制钥匙扣",
                                "taxName": "金属制品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1080424000000000000",
                                "taxCodeTitle": "金属制品",
                                "iTitle": "*金属制品*金属制日用杂品",
                                "children": []
                            },
                            {
                                "id": "2496",
                                "linkid": "2395",
                                "code": "1080425",
                                "paCode": "10804",
                                "yn": "N",
                                "title": "铸币及贵金属制实验室用品",
                                "alias": "铸币及贵金属制实验室用品",
                                "about": "包括硬币、工业或实验室用贵金属制品、贵金属或包贵金属制品",
                                "kws": "硬币、非法定货币硬币、法定货币硬币、工业实验室用贵金属制品、铂催化剂、贵金属制坩埚、烤钵、贵金属容器、贵金属、包贵金属制品、贵金属电镀阳极、纯金片状金阳极、银阳极片、银挤压型材、铂阳极波纹铂片、铂带、铂丝网",
                                "taxName": "金属制品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1080425000000000000",
                                "taxCodeTitle": "金属制品",
                                "iTitle": "*金属制品*铸币及贵金属制实验室用品",
                                "children": []
                            },
                            {
                                "id": "2497",
                                "linkid": "2395",
                                "code": "1080426",
                                "paCode": "10804",
                                "yn": "N",
                                "title": "金属焊接材料",
                                "alias": "金属焊接材料",
                                "about": "包括金属、硬质合金焊接丝、条、管、板及类似品",
                                "kws": "焊条、电焊条、气焊条、焊剂",
                                "taxName": "金属制品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1080426000000000000",
                                "taxCodeTitle": "金属制品",
                                "iTitle": "*金属制品*金属焊接材料",
                                "children": []
                            },
                            {
                                "id": "2498",
                                "linkid": "2395",
                                "code": "1080427",
                                "paCode": "10804",
                                "yn": "N",
                                "title": "金属链条及零件",
                                "alias": "金属链条及零件",
                                "about": "包括金属链条、金属链零件",
                                "kws": "金属链条、钢铁铰接链、工业链条、滚子链、锚链、升降链、牵拖链、钢铁制非铰接链、防滑链、日字环节链、焊接链、褥式排链、铜制链条、铝制链条",
                                "taxName": "金属制品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1080427000000000000",
                                "taxCodeTitle": "金属制品",
                                "iTitle": "*金属制品*金属链条及零件",
                                "children": []
                            },
                            {
                                "id": "2499",
                                "linkid": "2395",
                                "code": "1080499",
                                "paCode": "10804",
                                "yn": "N",
                                "title": "其他金属制品",
                                "alias": "其他金属制品",
                                "about": "包括金属真空容器、其他未列明金属制品",
                                "kws": null,
                                "taxName": "金属制品",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1080499000000000000",
                                "taxCodeTitle": "金属制品",
                                "iTitle": "*金属制品*其他金属制品",
                                "children": []
                            }
                        ]
                    },
                    {
                        "id": "2500",
                        "linkid": "2017",
                        "code": "10805",
                        "paCode": "108",
                        "yn": "N",
                        "title": "核燃料",
                        "alias": "核燃料",
                        "about": null,
                        "kws": "核燃料",
                        "taxName": "核燃料",
                        "taxRate": "13%",
                        "vip": "7",
                        "itaxRate": "0.13",
                        "taxCode": "1080500000000000000",
                        "taxCodeTitle": "核燃料",
                        "iTitle": "*核燃料*核燃料",
                        "children": []
                    }
                ]
            },
            {
                "id": "2501",
                "linkid": "1",
                "code": "109",
                "paCode": "1",
                "yn": "Y",
                "title": "机械、设备类产品",
                "alias": "机械设备",
                "about": null,
                "kws": null,
                "taxName": "机械设备",
                "taxRate": "",
                "vip": "5",
                "itaxRate": null,
                "taxCode": "1090000000000000000",
                "taxCodeTitle": "机械设备",
                "iTitle": "*机械设备*机械、设备类产品",
                "children": [
                    {
                        "id": "2502",
                        "linkid": "2501",
                        "code": "10901",
                        "paCode": "109",
                        "yn": "Y",
                        "title": "通用设备",
                        "alias": "通用设备",
                        "about": null,
                        "kws": null,
                        "taxName": "通用设备",
                        "taxRate": "",
                        "vip": "7",
                        "itaxRate": null,
                        "taxCode": "1090100000000000000",
                        "taxCodeTitle": "通用设备",
                        "iTitle": "*通用设备*通用设备",
                        "children": [
                            {
                                "id": "2503",
                                "linkid": "2502",
                                "code": "1090101",
                                "paCode": "10901",
                                "yn": "Y",
                                "title": "锅炉及辅助设备",
                                "alias": "锅炉及辅助设备",
                                "about": "包括锅炉、锅炉辅助设备、锅炉及辅助设备零件、核反应堆及其零件",
                                "kws": null,
                                "taxName": "锅炉及辅助设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090101000000000000",
                                "taxCodeTitle": "锅炉及辅助设备",
                                "iTitle": "*锅炉及辅助设备*锅炉及辅助设备",
                                "children": [
                                    {
                                        "id": "2504",
                                        "linkid": "2503",
                                        "code": "109010101",
                                        "paCode": "1090101",
                                        "yn": "N",
                                        "title": "锅炉、辅助设备、零件",
                                        "alias": "锅炉、辅助设备、零件",
                                        "about": "包括电站锅炉（如：超临界电站锅炉、超超临界电站锅炉、亚临界电站锅炉、超高压电站锅炉、高压电站锅炉、中压电站锅炉、低压电站锅炉）、工业锅炉（如：蒸汽锅炉、热水锅炉、其他蒸汽锅炉）、有机热载体锅炉、船用蒸汽锅炉、锅炉用辅助设备及装置（如：蒸汽冷凝器；节热器、蒸汽收集器、蓄能器、烟垢清除器、气体回收器、泥渣刮除器、空气预热器、其他锅炉用辅助设备；蒸汽锅炉零件、热水锅炉零件、集中供暖用锅炉零件、蒸汽锅炉辅助设备零件）。",
                                        "kws": "电站锅炉、超临界电站锅炉、超超临界电站锅炉、亚临界电站锅炉、超高压电站锅炉、高压电站锅炉、中压电站锅炉、低压电站锅炉、工业锅炉、蒸汽锅炉、热水锅炉、有机热载体锅炉、船用蒸汽锅炉、锅炉用辅助设备、锅炉用辅助装置、蒸汽冷凝器、节热器、蒸汽收集器、蓄能器、烟垢清除器、气体回收器、泥渣刮除器、空气预热器、蒸汽锅炉零件、热水锅炉零件、集中供暖用锅炉零件、蒸汽锅炉辅助设备零件",
                                        "taxName": "锅炉及辅助设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090101010000000000",
                                        "taxCodeTitle": "锅炉及辅助设备",
                                        "iTitle": "*锅炉及辅助设备*锅炉、辅助设备、零件",
                                        "children": []
                                    },
                                    {
                                        "id": "2505",
                                        "linkid": "2503",
                                        "code": "109010102",
                                        "paCode": "1090101",
                                        "yn": "N",
                                        "title": "核反应堆及其零件",
                                        "alias": "核反应堆及其零件",
                                        "about": "包括核反应堆；核反应堆零件（如：未辐照相关组件、堆内构件、其他核反应堆零件）。",
                                        "kws": "核反应堆、未辐照相关组件、堆内构件",
                                        "taxName": "锅炉及辅助设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090101020000000000",
                                        "taxCodeTitle": "锅炉及辅助设备",
                                        "iTitle": "*锅炉及辅助设备*核反应堆及其零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2506",
                                "linkid": "2502",
                                "code": "1090102",
                                "paCode": "10901",
                                "yn": "Y",
                                "title": "发动机",
                                "alias": "发动机",
                                "about": "包括汽车用发动机、航空器用发动机、船舶用发动机、摩托车用发动机、发动机零部件、其他发动机。",
                                "kws": null,
                                "taxName": "发动机",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090102000000000000",
                                "taxCodeTitle": "发动机",
                                "iTitle": "*发动机*发动机",
                                "children": [
                                    {
                                        "id": "2507",
                                        "linkid": "2506",
                                        "code": "109010201",
                                        "paCode": "1090102",
                                        "yn": "N",
                                        "title": "汽车用发动机",
                                        "alias": "汽车用发动机",
                                        "about": "包括汽车用汽油发动机、汽车用柴油发动机、其他汽车用发动机。",
                                        "kws": "汽车用发动机、汽车用汽油发动机、汽车用柴油发动机",
                                        "taxName": "发动机",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090102010000000000",
                                        "taxCodeTitle": "发动机",
                                        "iTitle": "*发动机*汽车用发动机",
                                        "children": []
                                    },
                                    {
                                        "id": "2508",
                                        "linkid": "2506",
                                        "code": "109010202",
                                        "paCode": "1090102",
                                        "yn": "N",
                                        "title": "航空器用发动机",
                                        "alias": "航空器用发动机",
                                        "about": "包括飞机、其他航空器、航天器用发动机。",
                                        "kws": "航空器用发动机、活塞式发动机、星形发动机、水平对置型发动机、涡轮发动机、涡轮喷气发动机、涡轮风扇发动机、涡轮螺桨发动机、涡轮轴发动机、喷气发动机、冲压式发动机、脉冲式发动机",
                                        "taxName": "发动机",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090102020000000000",
                                        "taxCodeTitle": "发动机",
                                        "iTitle": "*发动机*航空器用发动机",
                                        "children": []
                                    },
                                    {
                                        "id": "2509",
                                        "linkid": "2506",
                                        "code": "109010203",
                                        "paCode": "1090102",
                                        "yn": "N",
                                        "title": "船舶用发动机",
                                        "alias": "船舶用发动机",
                                        "about": "包括船舶用汽油发动机、船舶用柴油发动机。",
                                        "kws": "船舶用发动、船舶用汽油发动机、船舶用柴油发动机",
                                        "taxName": "发动机",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090102030000000000",
                                        "taxCodeTitle": "发动机",
                                        "iTitle": "*发动机*船舶用发动机",
                                        "children": []
                                    },
                                    {
                                        "id": "2510",
                                        "linkid": "2506",
                                        "code": "109010204",
                                        "paCode": "1090102",
                                        "yn": "N",
                                        "title": "摩托车用发动机",
                                        "alias": "摩托车用发动机",
                                        "about": "包括摩托车用汽油机、摩托车用柴油发动机。",
                                        "kws": "摩托车用发动机、摩托车用汽油机、摩托车用柴油发动机",
                                        "taxName": "发动机",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090102040000000000",
                                        "taxCodeTitle": "发动机",
                                        "iTitle": "*发动机*摩托车用发动机",
                                        "children": []
                                    },
                                    {
                                        "id": "2511",
                                        "linkid": "2506",
                                        "code": "109010205",
                                        "paCode": "1090102",
                                        "yn": "N",
                                        "title": "农用柴油机",
                                        "alias": "农用柴油机",
                                        "about": "指主要配套于农田拖拉机、田间作业机具、农副产品加工机械以及排灌机械，以柴油为燃料的往复式内燃动力机械。",
                                        "kws": "农用柴油机",
                                        "taxName": "发动机",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "1090102050000000000",
                                        "taxCodeTitle": "发动机",
                                        "iTitle": "*发动机*农用柴油机",
                                        "children": []
                                    },
                                    {
                                        "id": "2512",
                                        "linkid": "2506",
                                        "code": "109010206",
                                        "paCode": "1090102",
                                        "yn": "N",
                                        "title": "发动机零部件",
                                        "alias": "发动机零部件",
                                        "about": "主要是指汽油机零件、柴油机零件、涡轮发动机零件、其他发动机零部件。包括活塞、活塞环、活塞销、气缸套、气缸体、气缸盖、气缸垫、进气门、排气门、进气或排气歧管；连杆；轴瓦、化油器、曲轴、凸轮轴、滤清器、发动机起动电机及电动机、发动机冷却水泵及机油泵、增压器及中冷器、喷油泵、油嘴、发动机废气再循环装置、发动机废气后处理装置、电控高压共轨系统、代用内燃机零件和混合动力内燃机零件等。",
                                        "kws": "发动机零部件、汽油机零件、柴油机零件、涡轮发动机零件、活塞、活塞环、活塞销、气缸套、气缸体、气缸盖、气缸垫、进气门、排气门、进气歧管、排气歧管、连杆、轴瓦、化油器、曲轴、凸轮轴、滤清器、发动机起动电机、发动机起动电动机、发动机冷却水泵、机油泵、增压器、中冷器、喷油泵、油嘴、发动机废气再循环装置、发动机废气后处理装置、电控高压共轨系统、代用内燃机零件、混合动力内燃机零件",
                                        "taxName": "发动机",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090102060000000000",
                                        "taxCodeTitle": "发动机",
                                        "iTitle": "*发动机*发动机零部件",
                                        "children": []
                                    },
                                    {
                                        "id": "2513",
                                        "linkid": "2506",
                                        "code": "109010299",
                                        "paCode": "1090102",
                                        "yn": "N",
                                        "title": "其他发动机",
                                        "alias": "其他发动机",
                                        "about": null,
                                        "kws": "点燃式活塞内燃机、沼气发动机",
                                        "taxName": "发动机",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090102990000000000",
                                        "taxCodeTitle": "发动机",
                                        "iTitle": "*发动机*其他发动机",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2514",
                                "linkid": "2502",
                                "code": "1090103",
                                "paCode": "10901",
                                "yn": "Y",
                                "title": "汽轮机、燃气轮机、水轮机",
                                "alias": "汽轮燃气轮水轮机",
                                "about": null,
                                "kws": null,
                                "taxName": "汽轮燃气轮水轮机",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090103000000000000",
                                "taxCodeTitle": "汽轮燃气轮水轮机",
                                "iTitle": "*汽轮燃气轮水轮机*汽轮机、燃气轮机、水轮机",
                                "children": [
                                    {
                                        "id": "2515",
                                        "linkid": "2514",
                                        "code": "109010301",
                                        "paCode": "1090103",
                                        "yn": "N",
                                        "title": "汽轮机",
                                        "alias": "汽轮机",
                                        "about": "包括船舶动力用汽轮机、电站用汽轮机、工业用汽轮机、其他用汽轮机。",
                                        "kws": "汽轮机、船舶动力用汽轮机、电站用汽轮机、工业用汽轮机",
                                        "taxName": "汽轮燃气轮水轮机",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090103010000000000",
                                        "taxCodeTitle": "汽轮燃气轮水轮机",
                                        "iTitle": "*汽轮燃气轮水轮机*汽轮机",
                                        "children": []
                                    },
                                    {
                                        "id": "2516",
                                        "linkid": "2514",
                                        "code": "109010302",
                                        "paCode": "1090103",
                                        "yn": "N",
                                        "title": "燃气轮机",
                                        "alias": "燃气轮机",
                                        "about": "包括专供工业用的燃气轮机设备，也包括具有其他用途的涡轮喷气发动机、涡轮风扇发动机或涡轮螺桨发动机。",
                                        "kws": "燃气轮机、发电用燃气轮机、船舶用燃气轮机、机车用燃气轮机",
                                        "taxName": "汽轮燃气轮水轮机",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090103020000000000",
                                        "taxCodeTitle": "汽轮燃气轮水轮机",
                                        "iTitle": "*汽轮燃气轮水轮机*燃气轮机",
                                        "children": []
                                    },
                                    {
                                        "id": "2517",
                                        "linkid": "2514",
                                        "code": "109010303",
                                        "paCode": "1090103",
                                        "yn": "N",
                                        "title": "水轮机",
                                        "alias": "水轮机",
                                        "about": "包括水轮机、水轮及辅机。",
                                        "kws": "水轮机、电站水轮机、混流式水轮机、轴流式水轮机、冲击式水轮机、贯流式水轮机、水泵水轮机",
                                        "taxName": "汽轮燃气轮水轮机",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090103030000000000",
                                        "taxCodeTitle": "汽轮燃气轮水轮机",
                                        "iTitle": "*汽轮燃气轮水轮机*水轮机",
                                        "children": []
                                    },
                                    {
                                        "id": "2518",
                                        "linkid": "2514",
                                        "code": "109010304",
                                        "paCode": "1090103",
                                        "yn": "N",
                                        "title": "汽轮机、燃气轮机、水轮机零件",
                                        "alias": "汽轮机、燃气轮机、水轮机零件",
                                        "about": "包括汽轮机转子、定子及其部件；转子轮叶或定子叶片；涡轮轴发动机用零件；燃气轮机的转子、涡轮喷气发动机的零件（定子环、不论是否带叶片；转子圆盘或轮子、不论是否带翅片；叶片及翅片）、燃料供给调节器、燃料喷嘴；水轮机调节器；水轮机及水轮的转子、定子、定子或转子的叶片、螺旋导管的壳套、调节器的阀针。",
                                        "kws": "汽轮机转子、汽轮机定子、转子轮叶、定子叶片、涡轮轴发动机用零件、燃气轮机转子、涡轮喷气发动机零件、定子环、转子圆盘、燃料供给调节器、燃料喷嘴、水轮机调节器、水轮机转子、水轮转子、定子、螺旋导管壳套、调节器阀针",
                                        "taxName": "汽轮燃气轮水轮机",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090103040000000000",
                                        "taxCodeTitle": "汽轮燃气轮水轮机",
                                        "iTitle": "*汽轮燃气轮水轮机*汽轮机、燃气轮机、水轮机零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2519",
                                "linkid": "2502",
                                "code": "1090104",
                                "paCode": "10901",
                                "yn": "Y",
                                "title": "非电力相关原动机",
                                "alias": "非电力相关原动机",
                                "about": "包括潮汐能源原动机、风力提水机组、风力发动机、风车、太阳能源原动机、其他非电力相关原动机。",
                                "kws": null,
                                "taxName": "非电力相关原动机",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090104000000000000",
                                "taxCodeTitle": "非电力相关原动机",
                                "iTitle": "*非电力相关原动机*非电力相关原动机",
                                "children": [
                                    {
                                        "id": "2520",
                                        "linkid": "2519",
                                        "code": "109010401",
                                        "paCode": "1090104",
                                        "yn": "N",
                                        "title": "潮汐能源原动机",
                                        "alias": "潮汐能源原动机",
                                        "about": "指利用潮汐能源产生原动力的机械。",
                                        "kws": "潮汐能源原动机",
                                        "taxName": "非电力相关原动机",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090104010000000000",
                                        "taxCodeTitle": "非电力相关原动机",
                                        "iTitle": "*非电力相关原动机*潮汐能源原动机",
                                        "children": []
                                    },
                                    {
                                        "id": "2521",
                                        "linkid": "2519",
                                        "code": "109010402",
                                        "paCode": "1090104",
                                        "yn": "N",
                                        "title": "风力提水机组",
                                        "alias": "风力提水机组",
                                        "about": "不包括风力发电机组（详见109040201）。",
                                        "kws": "风力提水机组",
                                        "taxName": "非电力相关原动机",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090104020000000000",
                                        "taxCodeTitle": "非电力相关原动机",
                                        "iTitle": "*非电力相关原动机*风力提水机组",
                                        "children": []
                                    },
                                    {
                                        "id": "2522",
                                        "linkid": "2519",
                                        "code": "109010403",
                                        "paCode": "1090104",
                                        "yn": "N",
                                        "title": "风力发动机（风车）",
                                        "alias": "风力发动机（风车）",
                                        "about": "利用风力驱动的带有可调节的叶片或梯级横木的轮子所产生的能量来运转的机械装置。",
                                        "kws": "风力发动机、风车",
                                        "taxName": "非电力相关原动机",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090104030000000000",
                                        "taxCodeTitle": "非电力相关原动机",
                                        "iTitle": "*非电力相关原动机*风力发动机（风车）",
                                        "children": []
                                    },
                                    {
                                        "id": "2523",
                                        "linkid": "2519",
                                        "code": "109010404",
                                        "paCode": "1090104",
                                        "yn": "N",
                                        "title": "太阳能源原动机",
                                        "alias": "太阳能源原动机",
                                        "about": "指利用太阳能源产生原动力的机械。",
                                        "kws": "太阳能源原动机",
                                        "taxName": "非电力相关原动机",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090104040000000000",
                                        "taxCodeTitle": "非电力相关原动机",
                                        "iTitle": "*非电力相关原动机*太阳能源原动机",
                                        "children": []
                                    },
                                    {
                                        "id": "2524",
                                        "linkid": "2519",
                                        "code": "109010499",
                                        "paCode": "1090104",
                                        "yn": "N",
                                        "title": "其他非电力相关原动机",
                                        "alias": "其他非电力相关原动机",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "非电力相关原动机",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090104990000000000",
                                        "taxCodeTitle": "非电力相关原动机",
                                        "iTitle": "*非电力相关原动机*其他非电力相关原动机",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2525",
                                "linkid": "2502",
                                "code": "1090105",
                                "paCode": "10901",
                                "yn": "Y",
                                "title": "金属切削机床",
                                "alias": "金属切削机床",
                                "about": "指用于加工金属的各种切削加工机床。不包括数控机床（详见1090108）。",
                                "kws": null,
                                "taxName": "机床",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1090105000000000000",
                                "taxCodeTitle": "机床",
                                "iTitle": "*机床*金属切削机床",
                                "children": [
                                    {
                                        "id": "2526",
                                        "linkid": "2525",
                                        "code": "109010501",
                                        "paCode": "1090105",
                                        "yn": "N",
                                        "title": "组合机床",
                                        "alias": "组合机床",
                                        "about": "以通用部件为基础，配以按工件特定形状和加工工艺设计的专用部件和夹具、组成的半自动或自动专用机床。",
                                        "kws": "组合机床",
                                        "taxName": "机床",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090105010000000000",
                                        "taxCodeTitle": "机床",
                                        "iTitle": "*机床*组合机床",
                                        "children": []
                                    },
                                    {
                                        "id": "2527",
                                        "linkid": "2525",
                                        "code": "109010502",
                                        "paCode": "1090105",
                                        "yn": "N",
                                        "title": "特种加工机床",
                                        "alias": "特种加工机床",
                                        "about": "包括激光及其他光子束处理机床、超声波加工机床、放电加工机床、干法蚀刻半导体材料加工机床、化学电化学（电解）法加工机床、离子束加工机床、电子束加工机床、快速成形加工机床、高压水射流加工机床、其他特种加工机床。",
                                        "kws": "特种加工机床、激光处理机床、光子束处理机床、超声波加工机床、放电加工机床、干法蚀刻半导体材料加工机床、化学电化学法加工机床、离子束加工机床、电子束加工机床、快速成形加工机床、高压水射流加工机床",
                                        "taxName": "机床",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090105020000000000",
                                        "taxCodeTitle": "机床",
                                        "iTitle": "*机床*特种加工机床",
                                        "children": []
                                    },
                                    {
                                        "id": "2528",
                                        "linkid": "2525",
                                        "code": "109010503",
                                        "paCode": "1090105",
                                        "yn": "N",
                                        "title": "车床",
                                        "alias": "车床",
                                        "about": "指切削金属的车床，包括车床、卧式车床、立式车床、转塔车床、回转车床。",
                                        "kws": "车床、卧式车床、立式车床、转塔车床、回转车床",
                                        "taxName": "机床",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090105030000000000",
                                        "taxCodeTitle": "机床",
                                        "iTitle": "*机床*车床",
                                        "children": []
                                    },
                                    {
                                        "id": "2529",
                                        "linkid": "2525",
                                        "code": "109010504",
                                        "paCode": "1090105",
                                        "yn": "N",
                                        "title": "钻床",
                                        "alias": "钻床",
                                        "about": "指主要用钻头在工件上加工孔的机床。包括立式钻床、龙门式钻床、摇臂钻床、深孔钻床、不包括台钻（详见109010703）。",
                                        "kws": "立式钻床、龙门式钻床、摇臂钻床、深孔钻床",
                                        "taxName": "机床",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090105040000000000",
                                        "taxCodeTitle": "机床",
                                        "iTitle": "*机床*钻床",
                                        "children": []
                                    },
                                    {
                                        "id": "2530",
                                        "linkid": "2525",
                                        "code": "109010505",
                                        "paCode": "1090105",
                                        "yn": "N",
                                        "title": "镗床",
                                        "alias": "镗床",
                                        "about": "指用镗刀对工件已有的预制孔进行镗削的机床，包括坐标镗床、立式镗床、卧式镗床、落地式铣镗床、龙门式铣镗床、深孔镗床、精镗床。",
                                        "kws": "镗床、坐标镗床、立式镗床、卧式镗床、落地式铣镗床、龙门式铣镗床、深孔镗床、精镗床",
                                        "taxName": "机床",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090105050000000000",
                                        "taxCodeTitle": "机床",
                                        "iTitle": "*机床*镗床",
                                        "children": []
                                    },
                                    {
                                        "id": "2531",
                                        "linkid": "2525",
                                        "code": "109010506",
                                        "paCode": "1090105",
                                        "yn": "N",
                                        "title": "铣床",
                                        "alias": "铣床",
                                        "about": "指用铣刀在工件上加工多种表面的机床，包括升降台式铣床、龙门铣床、床身铣床、成形铣床、钻铣床、龙门镗铣床。",
                                        "kws": "铣床、升降台式铣床、龙门铣床、床身铣床、成形铣床、钻铣床、龙门镗铣床",
                                        "taxName": "机床",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090105060000000000",
                                        "taxCodeTitle": "机床",
                                        "iTitle": "*机床*铣床",
                                        "children": []
                                    },
                                    {
                                        "id": "2532",
                                        "linkid": "2525",
                                        "code": "109010507",
                                        "paCode": "1090105",
                                        "yn": "N",
                                        "title": "螺纹加工机床",
                                        "alias": "螺纹加工机床",
                                        "about": "指加工螺纹（包括蜗杆、滚刀等）型面的专门化机床，包括螺纹车床、螺纹铣床。",
                                        "kws": "螺纹加工机床、螺纹车床、螺纹铣床",
                                        "taxName": "机床",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090105070000000000",
                                        "taxCodeTitle": "机床",
                                        "iTitle": "*机床*螺纹加工机床",
                                        "children": []
                                    },
                                    {
                                        "id": "2533",
                                        "linkid": "2525",
                                        "code": "109010508",
                                        "paCode": "1090105",
                                        "yn": "N",
                                        "title": "磨床",
                                        "alias": "磨床",
                                        "about": "指利用磨具对工件表面进行磨削加工的机床。包括平面磨床、导轨磨床、外圆磨床、内圆磨床、坐标磨床、立式磨床、曲轴、凸轮磨床、轧辊磨床、工具磨床、金属珩磨机床、金属研磨机床，不包括砂轮机（详见109010701）、抛光机（详见109010702）。",
                                        "kws": "磨床、平面磨床、导轨磨床、外圆磨床、内圆磨床、坐标磨床、立式磨床、曲轴、凸轮磨床、轧辊磨床、工具磨床、金属珩磨机床、金属研磨机床、端面磨床、无心磨床",
                                        "taxName": "机床",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090105080000000000",
                                        "taxCodeTitle": "机床",
                                        "iTitle": "*机床*磨床",
                                        "children": []
                                    },
                                    {
                                        "id": "2534",
                                        "linkid": "2525",
                                        "code": "109010509",
                                        "paCode": "1090105",
                                        "yn": "N",
                                        "title": "刨床",
                                        "alias": "刨床",
                                        "about": "指用刨刀对工件的平面、沟槽或成形表面进行刨削的直线运动机床。包括龙门刨床。",
                                        "kws": "刨床、龙门刨床",
                                        "taxName": "机床",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090105090000000000",
                                        "taxCodeTitle": "机床",
                                        "iTitle": "*机床*刨床",
                                        "children": []
                                    },
                                    {
                                        "id": "2535",
                                        "linkid": "2525",
                                        "code": "109010510",
                                        "paCode": "1090105",
                                        "yn": "N",
                                        "title": "插床",
                                        "alias": "插床",
                                        "about": "指利用插刀的竖直往复运动插削键槽和型孔的机床。",
                                        "kws": "插床",
                                        "taxName": "机床",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090105100000000000",
                                        "taxCodeTitle": "机床",
                                        "iTitle": "*机床*插床",
                                        "children": []
                                    },
                                    {
                                        "id": "2536",
                                        "linkid": "2525",
                                        "code": "109010511",
                                        "paCode": "1090105",
                                        "yn": "N",
                                        "title": "拉床",
                                        "alias": "拉床",
                                        "about": "指用拉刀作为刀具加工工件通孔、平面和成形表面的机床。",
                                        "kws": "拉床",
                                        "taxName": "机床",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090105110000000000",
                                        "taxCodeTitle": "机床",
                                        "iTitle": "*机床*拉床",
                                        "children": []
                                    },
                                    {
                                        "id": "2537",
                                        "linkid": "2525",
                                        "code": "109010512",
                                        "paCode": "1090105",
                                        "yn": "N",
                                        "title": "齿轮加工机床",
                                        "alias": "齿轮加工机床",
                                        "about": "指加工各种圆柱齿轮、锥齿轮和其他带齿零件齿部的机床。包括滚齿机、插齿机、磨齿机、珩齿机、剃齿机、成形铣齿机、成形磨齿机。",
                                        "kws": "齿轮加工机床、滚齿机、插齿机、磨齿机、珩齿机、剃齿机、成形铣齿机、成形磨齿机",
                                        "taxName": "机床",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090105120000000000",
                                        "taxCodeTitle": "机床",
                                        "iTitle": "*机床*齿轮加工机床",
                                        "children": []
                                    },
                                    {
                                        "id": "2538",
                                        "linkid": "2525",
                                        "code": "109010513",
                                        "paCode": "1090105",
                                        "yn": "N",
                                        "title": "锯床",
                                        "alias": "锯床",
                                        "about": "包括弓锯床、圆锯床、带锯床、砂轮锯床。",
                                        "kws": "锯床、弓锯床、圆锯床、带锯床、砂轮锯床",
                                        "taxName": "机床",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090105130000000000",
                                        "taxCodeTitle": "机床",
                                        "iTitle": "*机床*锯床",
                                        "children": []
                                    },
                                    {
                                        "id": "2539",
                                        "linkid": "2525",
                                        "code": "109010514",
                                        "paCode": "1090105",
                                        "yn": "N",
                                        "title": "直线移动式动力头机床",
                                        "alias": "直线移动式动力头机床",
                                        "about": "指没有底座，仅配有动力机支架及刀杆，另外配有导轨，以便放置在合适的底座上时可来回移动工件插入独立于直线移动式动力头钻床的工件夹具中，由直线移动式动力头钻床作水平来回移动，进行钻孔、镗削等加工活动的机床。",
                                        "kws": "直线移动式动力头机床",
                                        "taxName": "机床",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090105140000000000",
                                        "taxCodeTitle": "机床",
                                        "iTitle": "*机床*直线移动式动力头机床",
                                        "children": []
                                    },
                                    {
                                        "id": "2540",
                                        "linkid": "2525",
                                        "code": "109010599",
                                        "paCode": "1090105",
                                        "yn": "N",
                                        "title": "其他金属切削机床",
                                        "alias": "其他金属切削机床",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "机床",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090105990000000000",
                                        "taxCodeTitle": "机床",
                                        "iTitle": "*机床*其他金属切削机床",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2541",
                                "linkid": "2502",
                                "code": "1090106",
                                "paCode": "10901",
                                "yn": "Y",
                                "title": "金属成形机床",
                                "alias": "金属成形机床",
                                "about": "指以锻造、锤击、粉末压制方式加工金属的机床，或以弯曲、折叠、矫直、剪切、冲压、开槽、拉丝等方式加工金属的机床，本类及下面各个类别均不包括数控机床，（详见1090108）。",
                                "kws": null,
                                "taxName": "机床",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090106000000000000",
                                "taxCodeTitle": "机床",
                                "iTitle": "*机床*金属成形机床",
                                "children": [
                                    {
                                        "id": "2542",
                                        "linkid": "2541",
                                        "code": "109010601",
                                        "paCode": "1090106",
                                        "yn": "N",
                                        "title": "锻造机及冲压机",
                                        "alias": "锻造机及冲压机",
                                        "about": "包括机械式、液压式或气压式锻锤以及蒸汽锻锤。",
                                        "kws": "锻造机、冲压机、自由锻锤、模锻锤、自由锻液压机、模锻压机、多向模锤压机、金属挤压机、金属滚压机、金属辊锻机、模锻机械压力机、热模锻压力机、摩擦螺旋压力机、电动螺旋压力机、离合器式螺旋压力机、平锻机、高速热镦锻机、高速冷温镦锻机、标准件镦锻成形机、楔横轧机、冷温锻压力机、切边压力机、液压切边压力机、机械式切边压力机、粉末成形压力机",
                                        "taxName": "机床",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090106010000000000",
                                        "taxCodeTitle": "机床",
                                        "iTitle": "*机床*锻造机及冲压机",
                                        "children": []
                                    },
                                    {
                                        "id": "2543",
                                        "linkid": "2541",
                                        "code": "109010602",
                                        "paCode": "1090106",
                                        "yn": "N",
                                        "title": "金属加工压力机",
                                        "alias": "金属加工压力机",
                                        "about": "包括液压式压力机、机械式压力机、开式机械式压力机、气压式压力机。",
                                        "kws": "金属加工压力机、液压式压力机、机械式压力机、开式机械式压力机、气压式压力机",
                                        "taxName": "机床",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090106020000000000",
                                        "taxCodeTitle": "机床",
                                        "iTitle": "*机床*金属加工压力机",
                                        "children": []
                                    },
                                    {
                                        "id": "2544",
                                        "linkid": "2541",
                                        "code": "109010603",
                                        "paCode": "1090106",
                                        "yn": "N",
                                        "title": "弯曲、折叠、矫直或矫平机床",
                                        "alias": "弯曲、折叠、矫直或矫平机床",
                                        "about": "包括弯曲、折叠、矫直、矫平、矫正机床、其他弯曲、折叠、矫直或矫平机床。",
                                        "kws": "折弯机、折叠机、矫直机床、矫平机、矫正机",
                                        "taxName": "机床",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090106030000000000",
                                        "taxCodeTitle": "机床",
                                        "iTitle": "*机床*弯曲、折叠、矫直或矫平机床",
                                        "children": []
                                    },
                                    {
                                        "id": "2545",
                                        "linkid": "2541",
                                        "code": "109010604",
                                        "paCode": "1090106",
                                        "yn": "N",
                                        "title": "剪切机床",
                                        "alias": "剪切机床",
                                        "about": null,
                                        "kws": "剪切机床",
                                        "taxName": "机床",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090106040000000000",
                                        "taxCodeTitle": "机床",
                                        "iTitle": "*机床*剪切机床",
                                        "children": []
                                    },
                                    {
                                        "id": "2546",
                                        "linkid": "2541",
                                        "code": "109010605",
                                        "paCode": "1090106",
                                        "yn": "N",
                                        "title": "冲床",
                                        "alias": "冲床",
                                        "about": null,
                                        "kws": "冲床",
                                        "taxName": "机床",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090106050000000000",
                                        "taxCodeTitle": "机床",
                                        "iTitle": "*机床*冲床",
                                        "children": []
                                    },
                                    {
                                        "id": "2547",
                                        "linkid": "2541",
                                        "code": "109010606",
                                        "paCode": "1090106",
                                        "yn": "N",
                                        "title": "冲孔机床",
                                        "alias": "冲孔机床",
                                        "about": null,
                                        "kws": "冲孔机床",
                                        "taxName": "机床",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090106060000000000",
                                        "taxCodeTitle": "机床",
                                        "iTitle": "*机床*冲孔机床",
                                        "children": []
                                    },
                                    {
                                        "id": "2548",
                                        "linkid": "2541",
                                        "code": "109010607",
                                        "paCode": "1090106",
                                        "yn": "N",
                                        "title": "开槽机床",
                                        "alias": "开槽机床",
                                        "about": null,
                                        "kws": "开槽机床",
                                        "taxName": "机床",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090106070000000000",
                                        "taxCodeTitle": "机床",
                                        "iTitle": "*机床*开槽机床",
                                        "children": []
                                    },
                                    {
                                        "id": "2549",
                                        "linkid": "2541",
                                        "code": "109010699",
                                        "paCode": "1090106",
                                        "yn": "N",
                                        "title": "其他金属成形机床",
                                        "alias": "其他金属成形机床",
                                        "about": "包括金属螺纹滚轧机（滚丝机）、旋压螺纹机床、旋压车床、其他未列明金属成形机床；",
                                        "kws": "金属螺纹滚轧机、金属螺纹滚丝机、旋压螺纹机床、旋压车床",
                                        "taxName": "机床",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090106990000000000",
                                        "taxCodeTitle": "机床",
                                        "iTitle": "*机床*其他金属成形机床",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2550",
                                "linkid": "2502",
                                "code": "1090107",
                                "paCode": "10901",
                                "yn": "Y",
                                "title": "金属非切削、成形加工机械",
                                "alias": "金属非切削、成形加工机械",
                                "about": "本类及下面各个类别均不包括数控产品（详见1090108）。",
                                "kws": null,
                                "taxName": "机床",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090107000000000000",
                                "taxCodeTitle": "机床",
                                "iTitle": "*机床*金属非切削、成形加工机械",
                                "children": [
                                    {
                                        "id": "2551",
                                        "linkid": "2550",
                                        "code": "109010701",
                                        "paCode": "1090107",
                                        "yn": "N",
                                        "title": "砂轮机",
                                        "alias": "砂轮机",
                                        "about": "指用来刃磨各种刀具、工具的常用设备。",
                                        "kws": "砂轮机",
                                        "taxName": "机床",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090107010000000000",
                                        "taxCodeTitle": "机床",
                                        "iTitle": "*机床*砂轮机",
                                        "children": []
                                    },
                                    {
                                        "id": "2552",
                                        "linkid": "2550",
                                        "code": "109010702",
                                        "paCode": "1090107",
                                        "yn": "N",
                                        "title": "抛光机床",
                                        "alias": "抛光机床",
                                        "about": "指用磨石、磨料或抛光材料对金属进行精加工的机床。",
                                        "kws": "抛光机床",
                                        "taxName": "机床",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090107020000000000",
                                        "taxCodeTitle": "机床",
                                        "iTitle": "*机床*抛光机床",
                                        "children": []
                                    },
                                    {
                                        "id": "2553",
                                        "linkid": "2550",
                                        "code": "109010703",
                                        "paCode": "1090107",
                                        "yn": "N",
                                        "title": "台钻",
                                        "alias": "台钻",
                                        "about": null,
                                        "kws": "台钻",
                                        "taxName": "机床",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090107030000000000",
                                        "taxCodeTitle": "机床",
                                        "iTitle": "*机床*台钻",
                                        "children": []
                                    },
                                    {
                                        "id": "2554",
                                        "linkid": "2550",
                                        "code": "109010704",
                                        "paCode": "1090107",
                                        "yn": "N",
                                        "title": "切断机",
                                        "alias": "切断机",
                                        "about": null,
                                        "kws": "切断机",
                                        "taxName": "机床",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090107040000000000",
                                        "taxCodeTitle": "机床",
                                        "iTitle": "*机床*切断机",
                                        "children": []
                                    },
                                    {
                                        "id": "2555",
                                        "linkid": "2550",
                                        "code": "109010705",
                                        "paCode": "1090107",
                                        "yn": "N",
                                        "title": "金属拉拔机",
                                        "alias": "金属拉拔机",
                                        "about": "包括金属杆、型材、异型材、丝等的拉拔机，不包括管棒材拉拔机、管棒材拉拔机（详见109010705）。",
                                        "kws": "金属拉拔机",
                                        "taxName": "机床",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090107050000000000",
                                        "taxCodeTitle": "机床",
                                        "iTitle": "*机床*金属拉拔机",
                                        "children": []
                                    },
                                    {
                                        "id": "2556",
                                        "linkid": "2550",
                                        "code": "109010706",
                                        "paCode": "1090107",
                                        "yn": "N",
                                        "title": "金属丝加工机",
                                        "alias": "金属丝加工机",
                                        "about": null,
                                        "kws": "金属丝加工机",
                                        "taxName": "机床",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090107060000000000",
                                        "taxCodeTitle": "机床",
                                        "iTitle": "*机床*金属丝加工机",
                                        "children": []
                                    },
                                    {
                                        "id": "2557",
                                        "linkid": "2550",
                                        "code": "109010707",
                                        "paCode": "1090107",
                                        "yn": "N",
                                        "title": "旋锻机",
                                        "alias": "旋锻机",
                                        "about": null,
                                        "kws": "旋锻机",
                                        "taxName": "机床",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090107070000000000",
                                        "taxCodeTitle": "机床",
                                        "iTitle": "*机床*旋锻机",
                                        "children": []
                                    },
                                    {
                                        "id": "2558",
                                        "linkid": "2550",
                                        "code": "109010708",
                                        "paCode": "1090107",
                                        "yn": "N",
                                        "title": "软管加工机",
                                        "alias": "软管加工机",
                                        "about": null,
                                        "kws": "软管加工机",
                                        "taxName": "机床",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090107080000000000",
                                        "taxCodeTitle": "机床",
                                        "iTitle": "*机床*软管加工机",
                                        "children": []
                                    },
                                    {
                                        "id": "2559",
                                        "linkid": "2550",
                                        "code": "109010799",
                                        "paCode": "1090107",
                                        "yn": "N",
                                        "title": "其他金属非切削、成形加工机械",
                                        "alias": "其他金属非切削、成形加工机械",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "机床",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090107990000000000",
                                        "taxCodeTitle": "机床",
                                        "iTitle": "*机床*其他金属非切削、成形加工机械",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2560",
                                "linkid": "2502",
                                "code": "1090108",
                                "paCode": "10901",
                                "yn": "Y",
                                "title": "数控机床及加工机械",
                                "alias": "数控机床及加工机械",
                                "about": "包括加工中心、数控金属切削机床、数控金属成形机床（数控锻压设备）、机床数控系统。",
                                "kws": null,
                                "taxName": "机床",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090108000000000000",
                                "taxCodeTitle": "机床",
                                "iTitle": "*机床*数控机床及加工机械",
                                "children": [
                                    {
                                        "id": "2561",
                                        "linkid": "2560",
                                        "code": "109010801",
                                        "paCode": "1090108",
                                        "yn": "N",
                                        "title": "加工中心",
                                        "alias": "加工中心",
                                        "about": "全部为数控机床，包括加工中心、立式加工中心、卧式加工中心、超重型龙门式加工中心、重型龙门式加工中心、大型龙门式加工中心、中小型龙门式加工中心、其他加工中心。",
                                        "kws": "加工中心、立式加工中心、卧式加工中心、超重型龙门式加工中心、重型龙门式加工中心、大型龙门式加工中心、中小型龙门式加工中心",
                                        "taxName": "机床",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090108010000000000",
                                        "taxCodeTitle": "机床",
                                        "iTitle": "*机床*加工中心",
                                        "children": []
                                    },
                                    {
                                        "id": "2562",
                                        "linkid": "2560",
                                        "code": "109010802",
                                        "paCode": "1090108",
                                        "yn": "N",
                                        "title": "数控金属切削机床",
                                        "alias": "数控金属切削机床",
                                        "about": "本类及下面各个类别均属于金属切削机床及各个类别的其中项，包括数控金属切削机床、数控组合机床、数控特种加工机床、数控激光、相关光子束加工机床、数控超声波加工机床、数控电火花成形加工机床、数控电火花线切割加工机床、数控电火花小孔加工机床、数控相关放电加工机床、数控化学、电化学（电解）加工机床、数控离子束加工机床、数控电子束加工机床、数控快速成形加工机床、数控高压水射流切割机床、其他数控特种加工机床、数控车床、数控超重型卧式车床、数控重型卧式车床、数控大型卧式车床、数控中小型卧式车床、数控超重型立式车床、数控重",
                                        "kws": "数控金属切削机床、数控组合机床、数控特种加工机床、数控激光、相关光子束加工机床、数控超声波加工机床、数控电火花成形加工机床、数控电火花线切割加工机床、数控电火花小孔加工机床、数控相关放电加工机床、数控化学、电化学加工机床、电解加工机床、数控离子束加工机床、数控电子束加工机床、数控快速成形加工机床、数控高压水射流切割机床、数控车床、数控超重型卧式车床、数控重型卧式车床、数控大型卧式车床、数控中小型卧式车床、数控超重型立式车床、数控重型立式车床、数控大型立式车床、数控中小型立式车床、数控钻床、数控立式钻床、数",
                                        "taxName": "机床",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090108020000000000",
                                        "taxCodeTitle": "机床",
                                        "iTitle": "*机床*数控金属切削机床",
                                        "children": []
                                    },
                                    {
                                        "id": "2563",
                                        "linkid": "2560",
                                        "code": "109010803",
                                        "paCode": "1090108",
                                        "yn": "N",
                                        "title": "数控金属成形机床（数控锻压设备）",
                                        "alias": "数控金属成形机床（数控锻压设备）",
                                        "about": "本类及下面各类别均属于金属成形机床及各类别的其中项，包括数控金属成形机床、数控锻压设备、数控锻造机及冲压机、数控自由锻锤、数控模锻锤、数控自由锻液压机、数控模锻压机、数控多向模锤压机、数控液压挤压机、数控机械式挤压机、数控金属滚压机、数控金属辊锻机、其他数控锻造机及冲压机、数控金属加工压力机、数控重型液压式压力机、数控大型液压式压力机、数控中型液压式压力机、数控小型液压式压力机、数控重型闭式机械式压力机、数控大型闭式机械式压力机、数控中型闭式机械式压力机、数控小型闭式机械式压力机、数控气压式压力机、数控弯",
                                        "kws": "数控金属成形机床、数控锻压设备、数控锻造机及冲压机、数控自由锻锤、数控模锻锤、数控自由锻液压机、数控模锻压机、数控多向模锤压机、数控液压挤压机、数控机械式挤压机、数控金属滚压机、数控金属辊锻机、数控金属加工压力机、数控重型液压式压力机、数控大型液压式压力机、数控中型液压式压力机、数控小型液压式压力机、数控重型闭式机械式压力机、数控大型闭式机械式压力机、数控中型闭式机械式压力机、数控小型闭式机械式压力机、数控气压式压力机、数控弯曲机、数控折弯机、数控折叠机、数控矫直机床、数控矫平机、数控矫正机、折叠机床、矫",
                                        "taxName": "机床",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090108030000000000",
                                        "taxCodeTitle": "机床",
                                        "iTitle": "*机床*数控金属成形机床（数控锻压设备）",
                                        "children": []
                                    },
                                    {
                                        "id": "2564",
                                        "linkid": "2560",
                                        "code": "109010804",
                                        "paCode": "1090108",
                                        "yn": "N",
                                        "title": "机床数控系统",
                                        "alias": "机床数控系统",
                                        "about": "包括机床数控装置、数控机床用伺服驱动单元、数控机床用电机。",
                                        "kws": "机床数控系统、机床数控装置、数控机床用伺服驱动单元、主轴伺服驱动单元、进给伺服驱动单元、数控机床用电机、主轴电机、伺服电机",
                                        "taxName": "机床",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090108040000000000",
                                        "taxCodeTitle": "机床",
                                        "iTitle": "*机床*机床数控系统",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2565",
                                "linkid": "2502",
                                "code": "1090109",
                                "paCode": "10901",
                                "yn": "N",
                                "title": "机床附件及辅助装置",
                                "alias": "机床附件及辅助装置",
                                "about": "包括金属切削机床、金属成形加工机床、其他金属加工机床附件、零件。",
                                "kws": "机床附件、工具夹具、卡盘、自动定心卡盘、单动卡盘、动力卡盘、夹头、钻夹头、丝锥夹头、弹簧夹头、铣夹头、车床刀架、砂轮架、铣头、插头、镗头、刀杆刀柄、回转工作台、机械回转工作台、自启板牙切头、工件夹具、工件夹盘、吸盘、虎钳普通虎钳、多联组合虎钳、特殊辅助装置、分度头机械分度头、数控分度头、定心装置、校平装置、仿形装置、数控机床功能部件、电主轴、机械主轴、数控刀架、普通数控刀架、电机直驱数控刀架、数控动力刀架、普通数控动力刀架、电机直驱动力刀架、B轴动力刀架、刀库及换刀机构、数控铣头、数控镗铣头、数控刀柄铣头",
                                "taxName": "机床",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1090109000000000000",
                                "taxCodeTitle": "机床",
                                "iTitle": "*机床*机床附件及辅助装置",
                                "children": []
                            },
                            {
                                "id": "2566",
                                "linkid": "2502",
                                "code": "1090110",
                                "paCode": "10901",
                                "yn": "Y",
                                "title": "焊接设备",
                                "alias": "焊接设备",
                                "about": "指实现焊接工艺所需要的装备，包括电焊机、气体焊接机械、钎焊机械、焊接设备用零件。",
                                "kws": "电焊机、电弧焊接机、等离子弧焊接机、电阻焊接机、电子束焊接机、激光焊接机、摩擦焊接机、超声波焊接机、金属感应焊接机、热塑性材料焊接机、气体焊接机械、气焊机、手提喷焊器、高压喷焊器、低压喷焊器、表面回火机、钎焊机械、钎焊机、钎焊烙铁、焊枪、焊接设备用零件、气体焊接机械零件、电焊机零件、钎焊机零件",
                                "taxName": "焊接设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090110000000000000",
                                "taxCodeTitle": "焊接设备",
                                "iTitle": "*焊接设备*焊接设备",
                                "children": [
                                    {
                                        "id": "2567",
                                        "linkid": "2566",
                                        "code": "109011001",
                                        "paCode": "1090110",
                                        "yn": "N",
                                        "title": "电焊机",
                                        "alias": "电焊机",
                                        "about": "包括电焊机及装置。",
                                        "kws": "电焊机、电弧焊接机、等离子弧焊接机、电阻焊接机、电子束焊接机、激光焊接机、摩擦焊接机、超声波焊接机、金属感应焊接机、热塑性材料焊接机",
                                        "taxName": "焊接设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090110010000000000",
                                        "taxCodeTitle": "焊接设备",
                                        "iTitle": "*焊接设备*电焊机",
                                        "children": []
                                    },
                                    {
                                        "id": "2568",
                                        "linkid": "2566",
                                        "code": "109011002",
                                        "paCode": "1090110",
                                        "yn": "N",
                                        "title": "气体焊接机械",
                                        "alias": "气体焊接机械",
                                        "about": "指利用气体焊接金属用的器具包括表面回火机。",
                                        "kws": "气体焊接机械、气焊机、手提喷焊器、高压喷焊器、低压喷焊器、表面回火机",
                                        "taxName": "焊接设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090110020000000000",
                                        "taxCodeTitle": "焊接设备",
                                        "iTitle": "*焊接设备*气体焊接机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2569",
                                        "linkid": "2566",
                                        "code": "109011003",
                                        "paCode": "1090110",
                                        "yn": "N",
                                        "title": "钎焊机械",
                                        "alias": "钎焊机械",
                                        "about": "包括软钎焊、硬钎焊或其他熔焊机械。",
                                        "kws": "钎焊机械、钎焊机、钎焊烙铁、焊枪",
                                        "taxName": "焊接设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090110030000000000",
                                        "taxCodeTitle": "焊接设备",
                                        "iTitle": "*焊接设备*钎焊机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2570",
                                        "linkid": "2566",
                                        "code": "109011004",
                                        "paCode": "1090110",
                                        "yn": "N",
                                        "title": "焊接设备用零件",
                                        "alias": "焊接设备用零件",
                                        "about": null,
                                        "kws": "焊接设备用零件、气体焊接机械零件、电焊机零件、钎焊机零件",
                                        "taxName": "焊接设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090110040000000000",
                                        "taxCodeTitle": "焊接设备",
                                        "iTitle": "*焊接设备*焊接设备用零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2571",
                                "linkid": "2502",
                                "code": "1090111",
                                "paCode": "10901",
                                "yn": "Y",
                                "title": "轻小型起重设备",
                                "alias": "轻小型起重设备",
                                "about": "指结构轻巧、动作简单、作业范围投影以点线为主，可在狭小场合升降或移动重物的简易起重设备及器具；包括起重滑车、手动葫芦、电动葫芦、普通卷扬机、千斤顶、汽车举升机、单轨小车及类似设备等。",
                                "kws": null,
                                "taxName": "小型起重设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090111000000000000",
                                "taxCodeTitle": "小型起重设备",
                                "iTitle": "*小型起重设备*轻小型起重设备",
                                "children": [
                                    {
                                        "id": "2572",
                                        "linkid": "2571",
                                        "code": "109011101",
                                        "paCode": "1090111",
                                        "yn": "N",
                                        "title": "起重滑车",
                                        "alias": "起重滑车",
                                        "about": "指用于起吊物品、带有吊钩、链环或吊环的滑轮组；包括单轮、双轮、三轮及其他多轮滑车等通用滑车及林业滑车等。",
                                        "kws": "起重滑车",
                                        "taxName": "小型起重设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090111010000000000",
                                        "taxCodeTitle": "小型起重设备",
                                        "iTitle": "*小型起重设备*起重滑车",
                                        "children": []
                                    },
                                    {
                                        "id": "2573",
                                        "linkid": "2571",
                                        "code": "109011102",
                                        "paCode": "1090111",
                                        "yn": "N",
                                        "title": "手动葫芦",
                                        "alias": "手动葫芦",
                                        "about": "指由人力通过环链与链轮或板柄驱动链条或钢丝绳，以带动重物升降或运动的起重工具。",
                                        "kws": "手动葫芦、手拉葫芦、手扳葫芦、电动式手拉葫芦",
                                        "taxName": "小型起重设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090111020000000000",
                                        "taxCodeTitle": "小型起重设备",
                                        "iTitle": "*小型起重设备*手动葫芦",
                                        "children": []
                                    },
                                    {
                                        "id": "2574",
                                        "linkid": "2571",
                                        "code": "109011103",
                                        "paCode": "1090111",
                                        "yn": "N",
                                        "title": "电动葫芦",
                                        "alias": "电动葫芦",
                                        "about": "指由电机或其他动力驱动，通过起升机构卷筒装置或链轮卷放钢丝绳或链条以升降重物的简易起重设备。",
                                        "kws": "电动葫芦、钢丝绳电动葫芦、环链电动葫芦、板链电动葫芦、气动葫芦、液压葫芦、单相微型电动葫芦",
                                        "taxName": "小型起重设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090111030000000000",
                                        "taxCodeTitle": "小型起重设备",
                                        "iTitle": "*小型起重设备*电动葫芦",
                                        "children": []
                                    },
                                    {
                                        "id": "2575",
                                        "linkid": "2571",
                                        "code": "109011104",
                                        "paCode": "1090111",
                                        "yn": "N",
                                        "title": "卷扬机及绞盘",
                                        "alias": "卷扬机及绞盘",
                                        "about": "指由动力或人力驱动卷筒，通过挠性件起升，运移重物的简易起重装置。",
                                        "kws": "卷扬机、绞盘、卷绕式卷扬机、卷绕式绞车、摩擦式卷扬机、摩擦式绞车、手动卷扬机、手动绞车",
                                        "taxName": "小型起重设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090111040000000000",
                                        "taxCodeTitle": "小型起重设备",
                                        "iTitle": "*小型起重设备*卷扬机及绞盘",
                                        "children": []
                                    },
                                    {
                                        "id": "2576",
                                        "linkid": "2571",
                                        "code": "109011105",
                                        "paCode": "1090111",
                                        "yn": "N",
                                        "title": "千斤顶",
                                        "alias": "千斤顶",
                                        "about": "指利用高压油或机械传动，使刚性承载件在小行程内顶举或提升重物的起重工具。",
                                        "kws": "油压千斤顶、立式油压千斤顶、分离式油压千斤顶、机械千斤顶、螺旋千斤顶、齿条千斤顶",
                                        "taxName": "小型起重设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090111050000000000",
                                        "taxCodeTitle": "小型起重设备",
                                        "iTitle": "*小型起重设备*千斤顶",
                                        "children": []
                                    },
                                    {
                                        "id": "2577",
                                        "linkid": "2571",
                                        "code": "109011106",
                                        "paCode": "1090111",
                                        "yn": "N",
                                        "title": "汽车举升机",
                                        "alias": "汽车举升机",
                                        "about": "包括液压式汽车举升机、机械式汽车举升机、其他汽车举升机。",
                                        "kws": "液压式汽车举升机、机械式汽车举升机、汽车举升机",
                                        "taxName": "小型起重设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090111060000000000",
                                        "taxCodeTitle": "小型起重设备",
                                        "iTitle": "*小型起重设备*汽车举升机",
                                        "children": []
                                    },
                                    {
                                        "id": "2578",
                                        "linkid": "2571",
                                        "code": "109011107",
                                        "paCode": "1090111",
                                        "yn": "N",
                                        "title": "单轨（猫头）小车",
                                        "alias": "单轨（猫头）小车",
                                        "about": "指具有2轮或4轮，能带物品或起重葫芦及物品沿悬挂单轨行走的简易小车，与工字梁单轨配套使用，包括手推、手链、电动小车等。",
                                        "kws": "单轨小车、猫头小车",
                                        "taxName": "小型起重设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090111070000000000",
                                        "taxCodeTitle": "小型起重设备",
                                        "iTitle": "*小型起重设备*单轨（猫头）小车",
                                        "children": []
                                    },
                                    {
                                        "id": "2579",
                                        "linkid": "2571",
                                        "code": "109011108",
                                        "paCode": "1090111",
                                        "yn": "N",
                                        "title": "其他轻小型起重设备",
                                        "alias": "其他轻小型起重设备",
                                        "about": "包括举升机车车辆的架车机等。",
                                        "kws": "轻小型起重设备",
                                        "taxName": "小型起重设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090111080000000000",
                                        "taxCodeTitle": "小型起重设备",
                                        "iTitle": "*小型起重设备*其他轻小型起重设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2580",
                                        "linkid": "2571",
                                        "code": "109011109",
                                        "paCode": "1090111",
                                        "yn": "N",
                                        "title": "轻小型起重设备配套件",
                                        "alias": "轻小型起重设备配套件",
                                        "about": "指专用配套的附（配）件。",
                                        "kws": "轻小型起重设备配套件",
                                        "taxName": "小型起重设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090111090000000000",
                                        "taxCodeTitle": "小型起重设备",
                                        "iTitle": "*小型起重设备*轻小型起重设备配套件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2581",
                                "linkid": "2502",
                                "code": "1090112",
                                "paCode": "10901",
                                "yn": "Y",
                                "title": "起重机",
                                "alias": "起重机",
                                "about": "指具有起升、变幅或回转、行走等主要工作机构，使悬挂在起重吊钩或其他取物装置上的重物，在空间垂直升降和水平移动的周期性装卸作业机械。",
                                "kws": null,
                                "taxName": "起重机",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090112000000000000",
                                "taxCodeTitle": "起重机",
                                "iTitle": "*起重机*起重机",
                                "children": [
                                    {
                                        "id": "2582",
                                        "linkid": "2581",
                                        "code": "109011201",
                                        "paCode": "1090112",
                                        "yn": "N",
                                        "title": "桥式起重机",
                                        "alias": "桥式起重机",
                                        "about": "指具有桥架结构梁、桥架两端通过行走装置直接支承在高架轨道上，取物装置悬挂在可沿桥架运行的起重小车或起重葫芦上的起重机。",
                                        "kws": "通用桥式起重机、电动葫芦梁式起重机、冶金起重机、铸造起重机、加料起重机、脱锭起重机、板坯起重机、夹钳起重机、料耙起重机、揭盖起重机、锻造起重机、淬火起重机、电解起重机、专用桥式起重机、核电站桥式起重机、防爆桥式起重机、桥式堆垛起重机、手动桥式起重机、手动梁式起重机",
                                        "taxName": "起重机",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090112010000000000",
                                        "taxCodeTitle": "起重机",
                                        "iTitle": "*起重机*桥式起重机",
                                        "children": []
                                    },
                                    {
                                        "id": "2583",
                                        "linkid": "2581",
                                        "code": "109011202",
                                        "paCode": "1090112",
                                        "yn": "N",
                                        "title": "门式起重机（龙门起重机）",
                                        "alias": "门式起重机（龙门起重机）",
                                        "about": "指具有桥架结构梁、桥架两端通过两侧支腿支承在地面轨道或地基上，取物装置悬挂在可沿桥架运行的起重小车或葫芦小车上的桥架型起重机；包括半门式起重机。",
                                        "kws": "门式起重机、龙门起重机、通用门式起重机、水电站门式起重机、造船用门式起重机、轮胎式集装箱门式起重机、轨道式集装箱门式起重机、手动门式起重机",
                                        "taxName": "起重机",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090112020000000000",
                                        "taxCodeTitle": "起重机",
                                        "iTitle": "*起重机*门式起重机（龙门起重机）",
                                        "children": []
                                    },
                                    {
                                        "id": "2584",
                                        "linkid": "2581",
                                        "code": "109011203",
                                        "paCode": "1090112",
                                        "yn": "N",
                                        "title": "装卸桥",
                                        "alias": "装卸桥",
                                        "about": "指小车运行及提升速度大、跨度大运行距离长、生产效率高并以抓斗为主的一类门式起重机。",
                                        "kws": "装卸桥、通用抓斗装卸桥、抓斗卸船起重机、岸边集装箱装卸桥",
                                        "taxName": "起重机",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090112030000000000",
                                        "taxCodeTitle": "起重机",
                                        "iTitle": "*起重机*装卸桥",
                                        "children": []
                                    },
                                    {
                                        "id": "2585",
                                        "linkid": "2581",
                                        "code": "109011204",
                                        "paCode": "1090112",
                                        "yn": "N",
                                        "title": "缆索起重机",
                                        "alias": "缆索起重机",
                                        "about": null,
                                        "kws": "缆索起重机",
                                        "taxName": "起重机",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090112040000000000",
                                        "taxCodeTitle": "起重机",
                                        "iTitle": "*起重机*缆索起重机",
                                        "children": []
                                    },
                                    {
                                        "id": "2586",
                                        "linkid": "2581",
                                        "code": "109011205",
                                        "paCode": "1090112",
                                        "yn": "N",
                                        "title": "门座起重机",
                                        "alias": "门座起重机",
                                        "about": "指具有起重臂架和门型座架结构，取物装置悬挂在臂架顶端，可沿地面轨道运行的可回转的臂架型起重机。",
                                        "kws": "门座起重机、港口门座起重机、通用门座起重机、带斗门座起重机、集装箱门座起重机、多用途门座起重机、造船门座起重机、建筑门座起重机",
                                        "taxName": "起重机",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090112050000000000",
                                        "taxCodeTitle": "起重机",
                                        "iTitle": "*起重机*门座起重机",
                                        "children": []
                                    },
                                    {
                                        "id": "2587",
                                        "linkid": "2581",
                                        "code": "109011206",
                                        "paCode": "1090112",
                                        "yn": "N",
                                        "title": "塔式起重机",
                                        "alias": "塔式起重机",
                                        "about": "指起重臂架安装在垂直塔身顶部，取物装置悬挂在可沿臂架运行的起重小车上的可回转的臂架型起重机。",
                                        "kws": "塔式起重机、轨道式塔式起重机、固定塔式起重机、自升式塔式起重机、轮式塔式起重机、履带式塔式起重机",
                                        "taxName": "起重机",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090112060000000000",
                                        "taxCodeTitle": "起重机",
                                        "iTitle": "*起重机*塔式起重机",
                                        "children": []
                                    },
                                    {
                                        "id": "2588",
                                        "linkid": "2581",
                                        "code": "109011207",
                                        "paCode": "1090112",
                                        "yn": "N",
                                        "title": "流动式起重机",
                                        "alias": "流动式起重机",
                                        "about": "指工作场所经常变换，能在带载或空载情况下沿无轨路面运行，依靠自保持稳定的臂架型起重机。",
                                        "kws": "流动式起重机、轮式起重机、汽车起重机、轮胎起重机、越野轮胎起重机、全地面起重机、全路面起重机、履带式起重机、特殊底盘起重机、随车起重机",
                                        "taxName": "起重机",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090112070000000000",
                                        "taxCodeTitle": "起重机",
                                        "iTitle": "*起重机*流动式起重机",
                                        "children": []
                                    },
                                    {
                                        "id": "2589",
                                        "linkid": "2581",
                                        "code": "109011208",
                                        "paCode": "1090112",
                                        "yn": "N",
                                        "title": "桅杆起重机及甲板起重机",
                                        "alias": "桅杆起重机及甲板起重机",
                                        "about": "包括船舶起重机、船用升降机、电动起货机等。",
                                        "kws": "桅杆起重机、甲板起重机、船舶起重机、船用升降机、电动起货机",
                                        "taxName": "起重机",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090112080000000000",
                                        "taxCodeTitle": "起重机",
                                        "iTitle": "*起重机*桅杆起重机及甲板起重机",
                                        "children": []
                                    },
                                    {
                                        "id": "2590",
                                        "linkid": "2581",
                                        "code": "109011209",
                                        "paCode": "1090112",
                                        "yn": "N",
                                        "title": "悬臂起重机",
                                        "alias": "悬臂起重机",
                                        "about": "包括柱式臂架起重机、壁上起重机、平衡起重机、其他悬臂起重机。",
                                        "kws": "悬臂起重机、柱式臂架起重机、壁上起重机、平衡起重机",
                                        "taxName": "起重机",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090112090000000000",
                                        "taxCodeTitle": "起重机",
                                        "iTitle": "*起重机*悬臂起重机",
                                        "children": []
                                    },
                                    {
                                        "id": "2591",
                                        "linkid": "2581",
                                        "code": "109011210",
                                        "paCode": "1090112",
                                        "yn": "N",
                                        "title": "移动式吊运架",
                                        "alias": "移动式吊运架",
                                        "about": "包括胶轮移动式吊运架、其他移动式吊运架。",
                                        "kws": "移动式吊运架、胶轮移动式吊运架",
                                        "taxName": "起重机",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090112100000000000",
                                        "taxCodeTitle": "起重机",
                                        "iTitle": "*起重机*移动式吊运架",
                                        "children": []
                                    },
                                    {
                                        "id": "2592",
                                        "linkid": "2581",
                                        "code": "109011211",
                                        "paCode": "1090112",
                                        "yn": "N",
                                        "title": "铁路起重机",
                                        "alias": "铁路起重机",
                                        "about": null,
                                        "kws": "铁路起重机",
                                        "taxName": "起重机",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090112110000000000",
                                        "taxCodeTitle": "起重机",
                                        "iTitle": "*起重机*铁路起重机",
                                        "children": []
                                    },
                                    {
                                        "id": "2593",
                                        "linkid": "2581",
                                        "code": "109011212",
                                        "paCode": "1090112",
                                        "yn": "N",
                                        "title": "浮式起重机",
                                        "alias": "浮式起重机",
                                        "about": "指安装在专用的船体或囤船上的固定式起重机。",
                                        "kws": "浮式起重机",
                                        "taxName": "起重机",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090112120000000000",
                                        "taxCodeTitle": "起重机",
                                        "iTitle": "*起重机*浮式起重机",
                                        "children": []
                                    },
                                    {
                                        "id": "2594",
                                        "linkid": "2581",
                                        "code": "109011213",
                                        "paCode": "1090112",
                                        "yn": "N",
                                        "title": "其他起重机",
                                        "alias": "其他起重机",
                                        "about": "包括浮式起重机（自航、非自航、驳船式等）、铁路起重机等。",
                                        "kws": null,
                                        "taxName": "起重机",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090112130000000000",
                                        "taxCodeTitle": "起重机",
                                        "iTitle": "*起重机*其他起重机",
                                        "children": []
                                    },
                                    {
                                        "id": "2595",
                                        "linkid": "2581",
                                        "code": "109011214",
                                        "paCode": "1090112",
                                        "yn": "N",
                                        "title": "起重机专用配套件",
                                        "alias": "起重机专用配套件",
                                        "about": "指专用配套附（配）件，包括抓斗、吊具、索具、夹轨器、缓冲器等。",
                                        "kws": "起重机专用配套件、起重机专用抓斗、起重机专用吊具、起重机专用索具、起重机专用夹轨器、起重机专用缓冲器",
                                        "taxName": "起重机",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090112140000000000",
                                        "taxCodeTitle": "起重机",
                                        "iTitle": "*起重机*起重机专用配套件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2596",
                                "linkid": "2502",
                                "code": "1090113",
                                "paCode": "10901",
                                "yn": "Y",
                                "title": "工业车辆",
                                "alias": "工业车辆",
                                "about": "指用于工业企业内部，进行装卸、堆跺或短距离搬运、牵引、顶推等作业的无轨车辆。",
                                "kws": null,
                                "taxName": "工业车辆",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090113000000000000",
                                "taxCodeTitle": "工业车辆",
                                "iTitle": "*工业车辆*工业车辆",
                                "children": [
                                    {
                                        "id": "2597",
                                        "linkid": "2596",
                                        "code": "109011301",
                                        "paCode": "1090113",
                                        "yn": "N",
                                        "title": "电动（起升）车辆",
                                        "alias": "电动（起升）车辆",
                                        "about": "指采用货叉或其他取物装置，以高能蓄电池作动力，对成件货物进行装卸、堆垛、短距离搬运作业的无轨起升车辆，俗称电动叉车。",
                                        "kws": "电动起升车辆、电动平衡重乘驾式叉车、电动乘驾式仓储叉车、电动步行式仓储车辆",
                                        "taxName": "工业车辆",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090113010000000000",
                                        "taxCodeTitle": "工业车辆",
                                        "iTitle": "*工业车辆*电动（起升）车辆",
                                        "children": []
                                    },
                                    {
                                        "id": "2598",
                                        "linkid": "2596",
                                        "code": "109011302",
                                        "paCode": "1090113",
                                        "yn": "N",
                                        "title": "内燃叉车",
                                        "alias": "内燃叉车",
                                        "about": "指采用货叉或其他属具，以内燃机作动力，对成件货物进行装卸、堆垛、短距离搬运作业的无轨高起升车辆。",
                                        "kws": "内燃叉车、内燃室内叉车、标准内燃平衡重式叉车、集装箱叉车、集装箱正面吊运机、内燃侧面式叉车",
                                        "taxName": "工业车辆",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090113020000000000",
                                        "taxCodeTitle": "工业车辆",
                                        "iTitle": "*工业车辆*内燃叉车",
                                        "children": []
                                    },
                                    {
                                        "id": "2599",
                                        "linkid": "2596",
                                        "code": "109011303",
                                        "paCode": "1090113",
                                        "yn": "N",
                                        "title": "越野叉车",
                                        "alias": "越野叉车",
                                        "about": "指在机场、码头、车站等路况条件较差的物资集散地装卸物资的设备。",
                                        "kws": "越野叉车、野战叉车",
                                        "taxName": "工业车辆",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090113030000000000",
                                        "taxCodeTitle": "工业车辆",
                                        "iTitle": "*工业车辆*越野叉车",
                                        "children": []
                                    },
                                    {
                                        "id": "2600",
                                        "linkid": "2596",
                                        "code": "109011304",
                                        "paCode": "1090113",
                                        "yn": "N",
                                        "title": "其他工业车辆",
                                        "alias": "其他工业车辆",
                                        "about": null,
                                        "kws": "短距离牵引车、电动牵引车、内燃牵引车、短距离固定平台搬运车、电动固定平台搬运车、电瓶车、内燃固定平台搬运车、电动游览车、跨运车、跨车、集装箱跨运车、手动搬运车、堆跺车、拣选车、手动托盘搬运车、手动平台搬运车、手动托盘堆跺车、手动液压油桶搬运车、手推拣选车、自动导向小车",
                                        "taxName": "工业车辆",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090113040000000000",
                                        "taxCodeTitle": "工业车辆",
                                        "iTitle": "*工业车辆*其他工业车辆",
                                        "children": []
                                    },
                                    {
                                        "id": "2601",
                                        "linkid": "2596",
                                        "code": "109011305",
                                        "paCode": "1090113",
                                        "yn": "N",
                                        "title": "工业车辆专用配套件",
                                        "alias": "工业车辆专用配套件",
                                        "about": "指专用配套附（配）件，包括专用夹具、货叉、托盘等。",
                                        "kws": "#工业车辆专用配套件",
                                        "taxName": "工业车辆",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090113050000000000",
                                        "taxCodeTitle": "工业车辆",
                                        "iTitle": "*工业车辆*工业车辆专用配套件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2602",
                                "linkid": "2502",
                                "code": "1090114",
                                "paCode": "10901",
                                "yn": "Y",
                                "title": "连续搬运设备",
                                "alias": "连续搬运设备",
                                "about": "指在同一方向上、按照规定的线路连续或间歇地运送或装卸散状物料和成件物品的搬运设备及其专门配套件；主要包括输送机械、装卸机械、给料机械等三类产品及其专门配套件。",
                                "kws": null,
                                "taxName": "搬运设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090114000000000000",
                                "taxCodeTitle": "搬运设备",
                                "iTitle": "*搬运设备*连续搬运设备",
                                "children": [
                                    {
                                        "id": "2603",
                                        "linkid": "2602",
                                        "code": "109011401",
                                        "paCode": "1090114",
                                        "yn": "N",
                                        "title": "输送机械（输送机和提升机）",
                                        "alias": "输送机械（输送机和提升机）",
                                        "about": "指在同一方向上，连续或间断地沿预定的线路上输送散状物料和成件物品的搬运设备。",
                                        "kws": "输送机械、输送机、提升机、斗式提升输送机、带式斗式提升机、链斗式提升机、带式输送机、固定通用带式输送机、移动带式输送机、件货专用固定带式输送机、波状挡边带式输送机、气垫带式输送机、井巷专用带式输送机、井下专用带式输送机、管状带式输送机、刮板输送机、高刮板输送机、管式刮板输送机、埋刮板输送机、通用埋刮板输送机、特殊型埋刮板输送机、板式输送机、平板式输送机、鳞板式输送机、悬挂输送机、链式输送机、通用悬挂输送机、积放式悬挂输送机、地面链输送机",
                                        "taxName": "搬运设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090114010000000000",
                                        "taxCodeTitle": "搬运设备",
                                        "iTitle": "*搬运设备*输送机械（输送机和提升机）",
                                        "children": []
                                    },
                                    {
                                        "id": "2604",
                                        "linkid": "2602",
                                        "code": "109011402",
                                        "paCode": "1090114",
                                        "yn": "N",
                                        "title": "装卸机械",
                                        "alias": "装卸机械",
                                        "about": "指具有自行装卸功能或具有转载装置和连续装卸功能、，能按照规定线路连续或间歇装卸作业的搬运设备。",
                                        "kws": "装卸机械、连续装船机、移动式连续装船机、连续卸船机、链斗卸船机、气力卸船机、堆取料机械、臂式堆料机、臂式斗轮堆取料机、桥门式斗轮堆取料机、刮板式取料机、铁路敞车翻车机系统、单车翻车机系统、多车翻车机系统、不解列翻车机系统、铁路货车装车机、铁路货车卸车机、链斗卸车机、螺旋卸车机、物料装载机、装卸机械专用配套件、悬挂输送机、链式输送机、通用悬挂输送机、积放式悬挂输送机、地面链输送机",
                                        "taxName": "搬运设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090114020000000000",
                                        "taxCodeTitle": "搬运设备",
                                        "iTitle": "*搬运设备*装卸机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2605",
                                        "linkid": "2602",
                                        "code": "109011403",
                                        "paCode": "1090114",
                                        "yn": "N",
                                        "title": "给料机械",
                                        "alias": "给料机械",
                                        "about": "指将物料由储料装置输送到受料装置中，并可控制物料输送速度和流量的机械设备。",
                                        "kws": "给料机械、圆盘给料机、板式给料机、振动给料机、螺旋给料机、带式给料机、叶轮给料机、往复式给料机、给料机专用配套件、臂式堆料机、臂式斗轮堆取料机、桥门式斗轮堆取料机、刮板式取料机、铁路敞车翻车机系统、单车翻车机系统、多车翻车机系统、不解列翻车机系统、铁路货车装车机、铁路货车卸车机、链斗卸车机、螺旋卸车机、物料装载机、装卸机械专用配套件、悬挂输送机、链式输送机、通用悬挂输送机、积放式悬挂输送机、地面链输送机",
                                        "taxName": "搬运设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090114030000000000",
                                        "taxCodeTitle": "搬运设备",
                                        "iTitle": "*搬运设备*给料机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2606",
                                        "linkid": "2602",
                                        "code": "109011499",
                                        "paCode": "1090114",
                                        "yn": "N",
                                        "title": "其他连续搬运设备",
                                        "alias": "其他连续搬运设备",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "搬运设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090114990000000000",
                                        "taxCodeTitle": "搬运设备",
                                        "iTitle": "*搬运设备*其他连续搬运设备",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2607",
                                "linkid": "2502",
                                "code": "1090115",
                                "paCode": "10901",
                                "yn": "Y",
                                "title": "电梯、自动扶梯及升降机",
                                "alias": "电梯、自动扶梯及升降机",
                                "about": "指主要用于建筑物或建筑工程中，沿导轨垂直升降或沿斜面及水平移动运送乘客和货物的机械设备。",
                                "kws": null,
                                "taxName": "搬运设备",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1090115000000000000",
                                "taxCodeTitle": "搬运设备",
                                "iTitle": "*搬运设备*电梯、自动扶梯及升降机",
                                "children": [
                                    {
                                        "id": "2608",
                                        "linkid": "2607",
                                        "code": "109011501",
                                        "paCode": "1090115",
                                        "yn": "N",
                                        "title": "电梯",
                                        "alias": "电梯",
                                        "about": "指靠电力拖动（或液压缸顶举），使轿厢沿垂直导轨升降，在规定的楼层间运送人和货物的固定提升设备。",
                                        "kws": "乘客电梯、载货电梯、住宅电梯、病床电梯、观光电梯、杂货电梯",
                                        "taxName": "搬运设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090115010000000000",
                                        "taxCodeTitle": "搬运设备",
                                        "iTitle": "*搬运设备*电梯",
                                        "children": []
                                    },
                                    {
                                        "id": "2609",
                                        "linkid": "2607",
                                        "code": "109011502",
                                        "paCode": "1090115",
                                        "yn": "N",
                                        "title": "自动扶梯等连续运载乘客输送机",
                                        "alias": "自动扶梯等连续运载乘客输送机",
                                        "about": "包括自动扶梯、自动人行道、其他连续运载乘客输送机。",
                                        "kws": "自动扶梯、自动人行道",
                                        "taxName": "搬运设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090115020000000000",
                                        "taxCodeTitle": "搬运设备",
                                        "iTitle": "*搬运设备*自动扶梯等连续运载乘客输送机",
                                        "children": []
                                    },
                                    {
                                        "id": "2610",
                                        "linkid": "2607",
                                        "code": "109011503",
                                        "paCode": "1090115",
                                        "yn": "N",
                                        "title": "升降机",
                                        "alias": "升降机",
                                        "about": "是指重物或取物装置只能沿导轨升降的设备。",
                                        "kws": "升降机、小型货物升降机、施工升降机、装修用升降机、装修用升降机工作平台、升降工作平台",
                                        "taxName": "搬运设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090115030000000000",
                                        "taxCodeTitle": "搬运设备",
                                        "iTitle": "*搬运设备*升降机",
                                        "children": []
                                    },
                                    {
                                        "id": "2611",
                                        "linkid": "2607",
                                        "code": "109011504",
                                        "paCode": "1090115",
                                        "yn": "N",
                                        "title": "电梯自动扶梯及升降机专用配套件",
                                        "alias": "电梯自动扶梯及升降机专用配套件",
                                        "about": "指专用配套附（配）件。",
                                        "kws": "电梯自动扶梯专用配套件、升降机专用配套件",
                                        "taxName": "搬运设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090115040000000000",
                                        "taxCodeTitle": "搬运设备",
                                        "iTitle": "*搬运设备*电梯自动扶梯及升降机专用配套件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2612",
                                "linkid": "2502",
                                "code": "1090116",
                                "paCode": "10901",
                                "yn": "Y",
                                "title": "立体仓库设备、相关物料搬运设备",
                                "alias": "立体仓库设备、相关物料搬运设备",
                                "about": null,
                                "kws": null,
                                "taxName": "搬运设备",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1090116000000000000",
                                "taxCodeTitle": "搬运设备",
                                "iTitle": "*搬运设备*立体仓库设备、相关物料搬运设备",
                                "children": [
                                    {
                                        "id": "2613",
                                        "linkid": "2612",
                                        "code": "109011601",
                                        "paCode": "1090116",
                                        "yn": "N",
                                        "title": "立体（高架）仓库存储系统",
                                        "alias": "立体（高架）仓库存储系统",
                                        "about": "包括有轨巷道堆垛机、有轨巷道堆垛机转移机、穿梭车、自动拣选机、立体仓库循环货架系统、其他立体仓库存储系统。",
                                        "kws": "立体仓库存储系统、高架仓库存储系统、有轨巷道堆垛机、有轨巷道堆垛机转移机、穿梭车、自动拣选机、立体仓库循环货架系统",
                                        "taxName": "搬运设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090116010000000000",
                                        "taxCodeTitle": "搬运设备",
                                        "iTitle": "*搬运设备*立体（高架）仓库存储系统",
                                        "children": []
                                    },
                                    {
                                        "id": "2614",
                                        "linkid": "2612",
                                        "code": "109011602",
                                        "paCode": "1090116",
                                        "yn": "N",
                                        "title": "仓储货物堆放架",
                                        "alias": "仓储货物堆放架",
                                        "about": "包括钢铁制仓储用货架、铝制仓储用货架、锌制货架、其他仓储货物堆放架。",
                                        "kws": "仓储货物堆放架、钢铁制仓储用货架、铝制仓储用货架、锌制货架",
                                        "taxName": "搬运设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090116020000000000",
                                        "taxCodeTitle": "搬运设备",
                                        "iTitle": "*搬运设备*仓储货物堆放架",
                                        "children": []
                                    },
                                    {
                                        "id": "2615",
                                        "linkid": "2612",
                                        "code": "109011603",
                                        "paCode": "1090116",
                                        "yn": "N",
                                        "title": "灌装码垛系统搬运设备",
                                        "alias": "灌装码垛系统搬运设备",
                                        "about": "包括灌装码垛系统专用输送设备、码包、堆包设备等。",
                                        "kws": "灌装码垛系统搬运设备、输送与料袋姿态控制装置、码包设备、堆包设备",
                                        "taxName": "搬运设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090116030000000000",
                                        "taxCodeTitle": "搬运设备",
                                        "iTitle": "*搬运设备*灌装码垛系统搬运设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2616",
                                        "linkid": "2612",
                                        "code": "109011604",
                                        "paCode": "1090116",
                                        "yn": "N",
                                        "title": "机械式停车设备",
                                        "alias": "机械式停车设备",
                                        "about": "包括升降横移类停车设备、平面移动类停车设备、简易升降类停车设备、垂直循环类停车设备、水平循环类停车设备、巷道堆垛类停车设备、其他机械式停车设备。",
                                        "kws": "机械式停车设备、升降横移类停车设备、平面移动类停车设备、简易升降类停车设备、垂直循环类停车设备、水平循环类停车设备、巷道堆垛类停车设备",
                                        "taxName": "搬运设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090116040000000000",
                                        "taxCodeTitle": "搬运设备",
                                        "iTitle": "*搬运设备*机械式停车设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2617",
                                        "linkid": "2612",
                                        "code": "109011605",
                                        "paCode": "1090116",
                                        "yn": "N",
                                        "title": "机场专用搬运机械",
                                        "alias": "机场专用搬运机械",
                                        "about": "包括旅客登机桥、行李传送设备、飞机牵引车、机场集装箱（板）升降平台车、机场集装箱（板）搬运车、其他机场专用搬运机械、其他机械式停车设备。",
                                        "kws": "机场专用搬运机械、旅客登机桥、行李传送设备、飞机牵引车、机场集装箱升降平台车、机场集装箱搬运车、机场集装板升降平台车、机场集装板搬运车",
                                        "taxName": "搬运设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090116050000000000",
                                        "taxCodeTitle": "搬运设备",
                                        "iTitle": "*搬运设备*机场专用搬运机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2618",
                                        "linkid": "2612",
                                        "code": "109011606",
                                        "paCode": "1090116",
                                        "yn": "N",
                                        "title": "搬运机械及装置",
                                        "alias": "搬运机械及装置",
                                        "about": "包括矿车推动机、货车倾卸装置、铁路货车推车器、电动平车、薄气垫搬运设备（装置）、舞台机械化搬运设备、其他搬运机械及装置。",
                                        "kws": "搬运机械、矿车推动机、货车倾卸装置、铁路货车推车器、电动平车、薄气垫搬运设备、薄气垫搬运装置、舞台机械化搬运设备",
                                        "taxName": "搬运设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090116060000000000",
                                        "taxCodeTitle": "搬运设备",
                                        "iTitle": "*搬运设备*搬运机械及装置",
                                        "children": []
                                    },
                                    {
                                        "id": "2619",
                                        "linkid": "2612",
                                        "code": "109011607",
                                        "paCode": "1090116",
                                        "yn": "N",
                                        "title": "其他相关物料搬运设备",
                                        "alias": "其他相关物料搬运设备",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "搬运设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090116070000000000",
                                        "taxCodeTitle": "搬运设备",
                                        "iTitle": "*搬运设备*其他相关物料搬运设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2620",
                                        "linkid": "2612",
                                        "code": "109011608",
                                        "paCode": "1090116",
                                        "yn": "N",
                                        "title": "立体仓储及物料搬运设备专用配套件",
                                        "alias": "立体仓储及物料搬运设备专用配套件",
                                        "about": "指专用配套附（配）件。",
                                        "kws": "立体仓储设备专用配套件、物料搬运设备专用配套件",
                                        "taxName": "搬运设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090116080000000000",
                                        "taxCodeTitle": "搬运设备",
                                        "iTitle": "*搬运设备*立体仓储及物料搬运设备专用配套件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2621",
                                "linkid": "2502",
                                "code": "1090117",
                                "paCode": "10901",
                                "yn": "Y",
                                "title": "泵及液体提升机",
                                "alias": "泵及液体提升机",
                                "about": null,
                                "kws": null,
                                "taxName": "泵",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090117000000000000",
                                "taxCodeTitle": "泵",
                                "iTitle": "*泵*泵及液体提升机",
                                "children": [
                                    {
                                        "id": "2622",
                                        "linkid": "2621",
                                        "code": "109011701",
                                        "paCode": "1090117",
                                        "yn": "N",
                                        "title": "泵",
                                        "alias": "泵",
                                        "about": "指是输送液体或使液体增压的机械，不包括液压泵（详见1090120010000）、农用水泵（详见1090117020000）。",
                                        "kws": "泵、动力式泵、单级单吸清水离心泵、单级双吸清水离心泵、多级清水离心泵、锅炉给水泵、热水循环泵、冷凝泵、化工流程泵、潜水电泵、潜水排污泵、管道泵、液下泵、自吸泵、船用泵、消防泵、家用泵、空调泵、食品泵、混流泵、轴流泵、旋涡泵、污水泵、无堵塞排污泵、泥浆泵、渣浆泵、容积泵、电动往复泵、液压隔膜泵、气动往复泵、计量泵、试压泵、齿轮泵、单螺杆泵、双螺杆泵、单转子泵、双转子泵、滑片泵、真空泵、旋片真空泵、罗茨真空泵、滑阀真空泵、蒸汽流真空泵、分子泵、干式真空泵、离子泵、低温泵、水环真空泵、往复真空泵、分子筛吸附泵、",
                                        "taxName": "泵",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090117010000000000",
                                        "taxCodeTitle": "泵",
                                        "iTitle": "*泵*泵",
                                        "children": []
                                    },
                                    {
                                        "id": "2623",
                                        "linkid": "2621",
                                        "code": "109011702",
                                        "paCode": "1090117",
                                        "yn": "N",
                                        "title": "农用水泵",
                                        "alias": "农用水泵",
                                        "about": "指主要用于农业生产的水泵，包括农村水井用泵、农田作业面潜水泵、农用轻便离心泵、与喷灌机配套的喷灌自吸泵。",
                                        "kws": "农用水泵",
                                        "taxName": "泵",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "1090117020000000000",
                                        "taxCodeTitle": "泵",
                                        "iTitle": "*泵*农用水泵",
                                        "children": []
                                    },
                                    {
                                        "id": "2624",
                                        "linkid": "2621",
                                        "code": "109011703",
                                        "paCode": "1090117",
                                        "yn": "N",
                                        "title": "液体提升机",
                                        "alias": "液体提升机",
                                        "about": "包括升运鼓轮、链式或缆式提升机、带式提升机、阿基米德螺旋式提升机、其他液体提升机。",
                                        "kws": "液体提升机、升运鼓轮、链式提升机、缆式提升机、带式提升机、阿基米德螺旋式提升机",
                                        "taxName": "泵",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090117030000000000",
                                        "taxCodeTitle": "泵",
                                        "iTitle": "*泵*液体提升机",
                                        "children": []
                                    },
                                    {
                                        "id": "2625",
                                        "linkid": "2621",
                                        "code": "109011704",
                                        "paCode": "1090117",
                                        "yn": "N",
                                        "title": "泵、液体提升机零件",
                                        "alias": "泵、液体提升机零件",
                                        "about": "包括泵零件、液体提升机零件、液体泵零件、液体提升机零件、空气泵和真空泵零件。",
                                        "kws": "泵零件、液体泵零件、液体提升机零件、空气泵、真空泵零件、泵缸、泵体、抽吸杆、活塞杆、活塞、柱塞、叶片、凸轮、螺杆、叶轮、扩散器叶片、戽斗、装有戽斗的链、带式液体提升机的带、压力室、轮叶",
                                        "taxName": "泵",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090117040000000000",
                                        "taxCodeTitle": "泵",
                                        "iTitle": "*泵*泵、液体提升机零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2626",
                                "linkid": "2502",
                                "code": "1090118",
                                "paCode": "10901",
                                "yn": "N",
                                "title": "气体压缩机",
                                "alias": "气体压缩机",
                                "about": "包括制冷设备用压缩机（空调压缩机、冰箱压缩机、车用空调压缩机、其他制冷设备用压缩机）；非制冷设备用压缩机（容积式压缩机、回转式压缩机、速度式压缩机、其他非制冷设备用压缩机）；气体压缩机零件。",
                                "kws": "气体压缩机、制冷设备用压缩机、空调压缩机、冰箱压缩机、车用空调压缩机、非制冷设备用压缩机、容积式压缩机、往复式压缩机、隔膜式压缩机、回转式压缩机、空气压缩机、工艺压缩机、速度式压缩机、离心式压缩机、轴流式压缩机、冷藏压缩机、冷冻箱压缩机、气体压缩机零件、往复式天然气压缩机、车用空气压缩机、螺杆、滑片式压缩机、滚动活塞式压缩机、涡旋式压缩机",
                                "taxName": "气体压缩机",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1090118000000000000",
                                "taxCodeTitle": "气体压缩机",
                                "iTitle": "*气体压缩机*气体压缩机",
                                "children": []
                            },
                            {
                                "id": "2627",
                                "linkid": "2502",
                                "code": "1090119",
                                "paCode": "10901",
                                "yn": "Y",
                                "title": "阀门和龙头",
                                "alias": "阀门和龙头",
                                "about": null,
                                "kws": null,
                                "taxName": "阀门龙头",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090119000000000000",
                                "taxCodeTitle": "阀门龙头",
                                "iTitle": "*阀门龙头*阀门和龙头",
                                "children": [
                                    {
                                        "id": "2628",
                                        "linkid": "2627",
                                        "code": "109011901",
                                        "paCode": "1090119",
                                        "yn": "N",
                                        "title": "阀门",
                                        "alias": "阀门",
                                        "about": "包括普通阀门中的闸阀、截止阀、止回阀、蝶阀、球阀、安全阀、旋塞阀、隔膜阀、疏水阀、节流阀、减压阀、自动阻止气体倒流的阀门、高温高压截止阀、接头针形截止阀、内丝口针形截止阀、其他普通阀门、真空阀门中的蝶阀类、球阀类、挡板阀、翻板阀、电磁压差阀、充气阀类、微调阀类、隔膜阀类、角座阀类、管道阀类、其他真空阀门，不包括液压阀（详见109012001）。",
                                        "kws": "阀门、闸阀、截止阀、止回阀、蝶阀、球阀、安全阀、旋塞阀、隔膜阀、疏水阀、节流阀、减压阀、蝶阀类、球阀类、挡板阀、翻板阀、电磁压差阀、充气阀类、微调阀类、隔膜阀类、角座阀类、管道阀类",
                                        "taxName": "阀门龙头",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090119010000000000",
                                        "taxCodeTitle": "阀门龙头",
                                        "iTitle": "*阀门龙头*阀门",
                                        "children": []
                                    },
                                    {
                                        "id": "2629",
                                        "linkid": "2627",
                                        "code": "109011902",
                                        "paCode": "1090119",
                                        "yn": "N",
                                        "title": "龙头",
                                        "alias": "龙头",
                                        "about": "包括水龙头（水嘴）、单柄单控水嘴、冷热水混合水嘴、散热器放水龙头、润滑油龙头、带有软管或伸缩套管的润滑油龙头、用以润滑轮船的轴、罐瓶机用龙头、其他龙头。",
                                        "kws": "水龙头、水嘴、单柄单控水嘴、冷热水混合水嘴、散热器放水龙头、润滑油龙头、罐瓶机用龙头",
                                        "taxName": "阀门龙头",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090119020000000000",
                                        "taxCodeTitle": "阀门龙头",
                                        "iTitle": "*阀门龙头*龙头",
                                        "children": []
                                    },
                                    {
                                        "id": "2630",
                                        "linkid": "2627",
                                        "code": "109011903",
                                        "paCode": "1090119",
                                        "yn": "N",
                                        "title": "阀门、龙头零件",
                                        "alias": "阀门、龙头零件",
                                        "about": "各类用于阀门和龙头的零配件。",
                                        "kws": "阀门零件、龙头零件",
                                        "taxName": "阀门龙头",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090119030000000000",
                                        "taxCodeTitle": "阀门龙头",
                                        "iTitle": "*阀门龙头*阀门、龙头零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2631",
                                "linkid": "2502",
                                "code": "1090120",
                                "paCode": "10901",
                                "yn": "Y",
                                "title": "液压元件、系统及装置",
                                "alias": "液压元件、系统及装置",
                                "about": "指使用受压的液体作为介质来进行能量转换、传递、控制和分配的元件、系统及装置。",
                                "kws": null,
                                "taxName": "液压元件",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090120000000000000",
                                "taxCodeTitle": "液压元件",
                                "iTitle": "*液压元件*液压元件、系统及装置",
                                "children": [
                                    {
                                        "id": "2632",
                                        "linkid": "2631",
                                        "code": "109012001",
                                        "paCode": "1090120",
                                        "yn": "N",
                                        "title": "液压元件",
                                        "alias": "液压元件",
                                        "about": "包括液压泵、齿轮式液压泵、叶片式液压泵、轴向柱塞泵、径向柱塞泵、螺杆式液压泵、液压马达、齿轮马达、叶片马达、柱塞马达、摆动马达、低速大扭矩马达、液压阀、方向阀、压力阀、流量阀、比例阀、伺服阀、多路阀、插装阀、叠加阀、液压缸、高压重型液压缸、车辆工程系列液压缸、拉杆式液压缸、回转液压缸、摆动液压缸。",
                                        "kws": "液压元件、液压泵、齿轮式液压泵、叶片式液压泵、轴向柱塞泵、径向柱塞泵、螺杆式液压泵、液压马达、齿轮马达、叶片马达、柱塞马达、摆动马达、低速大扭矩马达、液压阀、方向阀、压力阀、流量阀、比例阀、伺服阀、多路阀、插装阀、叠加阀、液压缸、高压重型液压缸、车辆工程系列液压缸、拉杆式液压缸、回转液压缸、摆动液压缸",
                                        "taxName": "液压元件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090120010000000000",
                                        "taxCodeTitle": "液压元件",
                                        "iTitle": "*液压元件*液压元件",
                                        "children": []
                                    },
                                    {
                                        "id": "2633",
                                        "linkid": "2631",
                                        "code": "109012002",
                                        "paCode": "1090120",
                                        "yn": "N",
                                        "title": "液压系统及装置",
                                        "alias": "液压系统及装置",
                                        "about": "指用液压技术实现的满足主机需要的动力传输或控制的系统，包括整体静液压传动装置、液压泵站、其他液压系统装置（包括机动船只用的喷水推进器（水力机））。",
                                        "kws": "液压系统、整体静液压传动装置、液压泵站、喷水推进器、水力机",
                                        "taxName": "液压元件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090120020000000000",
                                        "taxCodeTitle": "液压元件",
                                        "iTitle": "*液压元件*液压系统及装置",
                                        "children": []
                                    },
                                    {
                                        "id": "2634",
                                        "linkid": "2631",
                                        "code": "109012003",
                                        "paCode": "1090120",
                                        "yn": "N",
                                        "title": "液压辅件",
                                        "alias": "液压辅件",
                                        "about": "包括液压蓄能器、冷却器、吸油系列过滤器、磁性系列过滤器、压力管路过滤器、回油系列过滤器、双筒系列过滤器、液压管件、油箱辅件。",
                                        "kws": "液压辅件、液压蓄能器、冷却器、吸油系列过滤器、磁性系列过滤器、压力管路过滤器、回油系列过滤器、双筒系列过滤器、液压管件、油箱辅件",
                                        "taxName": "液压元件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090120030000000000",
                                        "taxCodeTitle": "液压元件",
                                        "iTitle": "*液压元件*液压辅件",
                                        "children": []
                                    },
                                    {
                                        "id": "2635",
                                        "linkid": "2631",
                                        "code": "109012004",
                                        "paCode": "1090120",
                                        "yn": "N",
                                        "title": "液力机械及装置",
                                        "alias": "液力机械及装置",
                                        "about": "指将流体动能转换为机械能的装置，包括液力变矩器、向心涡轮定轴式、内分流双涡轮、向心涡轮三项、单向轴流式涡轮、单向向心涡轮、液力耦合器、调速型、限矩型、传动装置、液粘调速、调速机组、液粘离合器、其他液力机械及装置。",
                                        "kws": "液力机械、液力变矩器、向心涡轮定轴式、内分流双涡轮、向心涡轮三项、单向轴流式涡轮、单向向心涡轮、液力耦合器、调速型、限矩型、传动装置、液粘调速、调速机组、液粘离合器",
                                        "taxName": "液压元件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090120040000000000",
                                        "taxCodeTitle": "液压元件",
                                        "iTitle": "*液压元件*液力机械及装置",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2636",
                                "linkid": "2502",
                                "code": "1090121",
                                "paCode": "10901",
                                "yn": "Y",
                                "title": "气动元件、系统及装置",
                                "alias": "气动元件、系统及装置",
                                "about": "指使用受压的空气作为介质来进行能量转换、传递、控制和分配的元件、系统及装置。",
                                "kws": null,
                                "taxName": "气动元件",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090121000000000000",
                                "taxCodeTitle": "气动元件",
                                "iTitle": "*气动元件*气动元件、系统及装置",
                                "children": [
                                    {
                                        "id": "2637",
                                        "linkid": "2636",
                                        "code": "109012101",
                                        "paCode": "1090121",
                                        "yn": "N",
                                        "title": "气动元件",
                                        "alias": "气动元件",
                                        "about": "指使用受压的空气作为介质来进行能量转换、传递、控制和分配的元件，包括气动执行元件、气缸、气马达、管道式气动阀、管道式气动调节阀、气动控制元件（气阀）、方向控制阀、压力控制阀、流量控制阀、气源处理元件、二、三联件、油雾器（气动元件）、过滤器（气动元件）、干燥器（气动元件）、消声器（气动元件）。",
                                        "kws": "气动元件、气动执行元件、气缸、气马达、管道式气动阀、管道式气动调节阀、气动控制元件、方向控制阀、压力控制阀、流量控制阀、气源处理元件、二三联件、油雾器、过滤器、干燥器、消声器",
                                        "taxName": "气动元件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090121010000000000",
                                        "taxCodeTitle": "气动元件",
                                        "iTitle": "*气动元件*气动元件",
                                        "children": []
                                    },
                                    {
                                        "id": "2638",
                                        "linkid": "2636",
                                        "code": "109012102",
                                        "paCode": "1090121",
                                        "yn": "N",
                                        "title": "气动系统及机械",
                                        "alias": "气动系统及机械",
                                        "about": "由气动动力源（包括气源处理元件）、气动控制元件、气动执行元件及所需的管道组成，完成工作机构的动作，包括气动系统和气动机械。",
                                        "kws": "气动系统、气动机械",
                                        "taxName": "气动元件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090121020000000000",
                                        "taxCodeTitle": "气动元件",
                                        "iTitle": "*气动元件*气动系统及机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2639",
                                        "linkid": "2636",
                                        "code": "109012103",
                                        "paCode": "1090121",
                                        "yn": "N",
                                        "title": "气动电磁线圈、气动管件系列",
                                        "alias": "气动电磁线圈、气动管件系列",
                                        "about": "用以气阀的电磁铁线圈以及气动管路用管接头、管夹、塑料管等，包括气动电磁线圈、气动管接头及管路。",
                                        "kws": "气动电磁线圈、气动管接头、气动管路",
                                        "taxName": "气动元件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090121030000000000",
                                        "taxCodeTitle": "气动元件",
                                        "iTitle": "*气动元件*气动电磁线圈、气动管件系列",
                                        "children": []
                                    },
                                    {
                                        "id": "2640",
                                        "linkid": "2636",
                                        "code": "109012199",
                                        "paCode": "1090121",
                                        "yn": "N",
                                        "title": "其他气动装置",
                                        "alias": "其他气动装置",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "气动元件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090121990000000000",
                                        "taxCodeTitle": "气动元件",
                                        "iTitle": "*气动元件*其他气动装置",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2641",
                                "linkid": "2502",
                                "code": "1090122",
                                "paCode": "10901",
                                "yn": "Y",
                                "title": "真空应用设备",
                                "alias": "真空应用设备",
                                "about": null,
                                "kws": null,
                                "taxName": "真空应用设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090122000000000000",
                                "taxCodeTitle": "真空应用设备",
                                "iTitle": "*真空应用设备*真空应用设备",
                                "children": [
                                    {
                                        "id": "2642",
                                        "linkid": "2641",
                                        "code": "109012201",
                                        "paCode": "1090122",
                                        "yn": "N",
                                        "title": "真空镀膜设备",
                                        "alias": "真空镀膜设备",
                                        "about": "包括真空卷绕镀膜机、光学镀膜机、太阳能镀膜设备、其他真空镀膜设备。",
                                        "kws": "真空镀膜设备、真空卷绕镀膜机、光学镀膜机、太阳能镀膜设备",
                                        "taxName": "真空应用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090122010000000000",
                                        "taxCodeTitle": "真空应用设备",
                                        "iTitle": "*真空应用设备*真空镀膜设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2643",
                                        "linkid": "2641",
                                        "code": "109012202",
                                        "paCode": "1090122",
                                        "yn": "N",
                                        "title": "真空浸渍设备",
                                        "alias": "真空浸渍设备",
                                        "about": "包括其他真空浸渍设备、真空压力浸渍设备。",
                                        "kws": "真空浸渍设备、真空压力浸渍设备",
                                        "taxName": "真空应用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090122020000000000",
                                        "taxCodeTitle": "真空应用设备",
                                        "iTitle": "*真空应用设备*真空浸渍设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2644",
                                        "linkid": "2641",
                                        "code": "109012203",
                                        "paCode": "1090122",
                                        "yn": "N",
                                        "title": "真空干燥设备",
                                        "alias": "真空干燥设备",
                                        "about": "包括真空耙式干燥机、双锥真空回转干燥机、真空冷冻干燥机、真空热风干燥设备、倾斜式真空干燥机、圆筒式真空干燥器、回转真空干燥机、其他真空干燥设备。",
                                        "kws": "真空干燥设备、真空耙式干燥机、双锥真空回转干燥机、真空冷冻干燥机、真空热风干燥设备、倾斜式真空干燥机、圆筒式真空干燥器、回转真空干燥机",
                                        "taxName": "真空应用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090122030000000000",
                                        "taxCodeTitle": "真空应用设备",
                                        "iTitle": "*真空应用设备*真空干燥设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2645",
                                        "linkid": "2641",
                                        "code": "109012204",
                                        "paCode": "1090122",
                                        "yn": "N",
                                        "title": "真空炉",
                                        "alias": "真空炉",
                                        "about": "包括真空充氮退火炉、真空热处理炉、真空烧结炉、高温真空钎焊炉、真空熔炼炉、其他真空炉。",
                                        "kws": "真空炉、真空充氮退火炉、真空热处理炉、真空烧结炉、高温真空钎焊炉、真空熔炼炉",
                                        "taxName": "真空应用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090122040000000000",
                                        "taxCodeTitle": "真空应用设备",
                                        "iTitle": "*真空应用设备*真空炉",
                                        "children": []
                                    },
                                    {
                                        "id": "2646",
                                        "linkid": "2641",
                                        "code": "109012299",
                                        "paCode": "1090122",
                                        "yn": "N",
                                        "title": "其他真空应用设备",
                                        "alias": "其他真空应用设备",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "真空应用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090122990000000000",
                                        "taxCodeTitle": "真空应用设备",
                                        "iTitle": "*真空应用设备*其他真空应用设备",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2647",
                                "linkid": "2502",
                                "code": "1090123",
                                "paCode": "10901",
                                "yn": "Y",
                                "title": "轴承及其零件",
                                "alias": "轴承及其零件",
                                "about": null,
                                "kws": null,
                                "taxName": "轴承",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090123000000000000",
                                "taxCodeTitle": "轴承",
                                "iTitle": "*轴承*轴承及其零件",
                                "children": [
                                    {
                                        "id": "2648",
                                        "linkid": "2647",
                                        "code": "109012301",
                                        "paCode": "1090123",
                                        "yn": "N",
                                        "title": "滚动轴承",
                                        "alias": "滚动轴承",
                                        "about": "包括球轴承、深沟球轴承、调心球轴承、角接触球轴承、推力球轴承、滚子轴承、锥形滚子轴承、调心滚子轴承、滚针轴承、圆柱滚子轴承、带座外球面球轴承、组合轴承、直线运动轴承、关节轴承、转盘轴承、回转支承、其他滚动轴承。",
                                        "kws": "滚动轴承、球轴承、深沟球轴承、调心球轴承、角接触球轴承、推力球轴承、滚子轴承、锥形滚子轴承、调心滚子轴承、滚针轴承、圆柱滚子轴承、带座外球面球轴承、组合轴承、直线运动轴承、关节轴承、转盘轴承、回转支承",
                                        "taxName": "轴承",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090123010000000000",
                                        "taxCodeTitle": "轴承",
                                        "iTitle": "*轴承*滚动轴承",
                                        "children": []
                                    },
                                    {
                                        "id": "2649",
                                        "linkid": "2647",
                                        "code": "109012302",
                                        "paCode": "1090123",
                                        "yn": "N",
                                        "title": "滑动轴承",
                                        "alias": "滑动轴承",
                                        "about": "包括未装配轴承座滑动轴承、已装配轴承座滑动轴承、其他滑动轴承。",
                                        "kws": "未装配轴承座滑动轴承、已装配轴承座滑动轴承、滑动轴承",
                                        "taxName": "轴承",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090123020000000000",
                                        "taxCodeTitle": "轴承",
                                        "iTitle": "*轴承*滑动轴承",
                                        "children": []
                                    },
                                    {
                                        "id": "2650",
                                        "linkid": "2647",
                                        "code": "109012303",
                                        "paCode": "1090123",
                                        "yn": "N",
                                        "title": "轴承零配件",
                                        "alias": "轴承零配件",
                                        "about": "包括钢球、滚珠、滚针、滚子、轴承保持器、轴承座、其他轴承零件（包括环（套圈）、定位圈、紧定套、固定座套等）。",
                                        "kws": "轴承钢球、轴承滚珠、轴承滚针、轴承滚子、轴承保持器、轴承座、轴承零件、轴承环、轴承套圈、轴承定位圈、轴承紧定套、轴承固定座套",
                                        "taxName": "轴承",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090123030000000000",
                                        "taxCodeTitle": "轴承",
                                        "iTitle": "*轴承*轴承零配件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2651",
                                "linkid": "2502",
                                "code": "1090124",
                                "paCode": "10901",
                                "yn": "Y",
                                "title": "齿轮、传动轴和驱动部件",
                                "alias": "齿轮、传动轴和驱动部件",
                                "about": null,
                                "kws": null,
                                "taxName": "齿轮",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090124000000000000",
                                "taxCodeTitle": "齿轮",
                                "iTitle": "*齿轮*齿轮、传动轴和驱动部件",
                                "children": [
                                    {
                                        "id": "2652",
                                        "linkid": "2651",
                                        "code": "109012401",
                                        "paCode": "1090124",
                                        "yn": "N",
                                        "title": "齿轮传动轴",
                                        "alias": "齿轮传动轴",
                                        "about": "包括齿轮传动轴、船舶用传动轴、曲柄及曲柄轴、活动关节轴、挠性轴、凸轮轴及偏心轴、副轴、其他齿轮传动轴。",
                                        "kws": "齿轮传动轴、船舶用传动轴、曲柄、曲柄轴、活动关节轴、挠性轴、凸轮轴、偏心轴、副轴",
                                        "taxName": "齿轮",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090124010000000000",
                                        "taxCodeTitle": "齿轮",
                                        "iTitle": "*齿轮*齿轮传动轴",
                                        "children": []
                                    },
                                    {
                                        "id": "2653",
                                        "linkid": "2651",
                                        "code": "109012402",
                                        "paCode": "1090124",
                                        "yn": "N",
                                        "title": "齿轮",
                                        "alias": "齿轮",
                                        "about": "包括圆柱齿轮、锥齿轮、非圆齿轮、齿条、差动齿轮、其他齿轮、其他粉末冶金齿轮、其他塑料齿轮、其他未列明齿轮。",
                                        "kws": "齿轮、圆柱齿轮、粉末冶金圆柱齿轮、塑料圆柱齿轮、锥齿轮、粉末冶金锥齿轮、塑料锥齿轮、非圆齿轮、粉末冶金非圆齿轮、塑料非圆齿轮、齿条、粉末冶金齿条、塑料齿条、差动齿轮、粉末冶金差动齿轮、塑料差动齿轮、粉末冶金齿轮、塑料齿轮",
                                        "taxName": "齿轮",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090124020000000000",
                                        "taxCodeTitle": "齿轮",
                                        "iTitle": "*齿轮*齿轮",
                                        "children": []
                                    },
                                    {
                                        "id": "2654",
                                        "linkid": "2651",
                                        "code": "109012403",
                                        "paCode": "1090124",
                                        "yn": "N",
                                        "title": "齿轮传动装置（齿轮箱）",
                                        "alias": "齿轮传动装置（齿轮箱）",
                                        "about": "指用于传递动力和转速，由齿轮传动件组成的传动装置，也称齿轮箱；主要包括齿轮减速机及变速箱。",
                                        "kws": "齿轮传动装置、减速机、圆柱齿轮减速机、圆锥、圆柱圆锥齿轮减速机、圆柱蜗杆减速机、环面蜗杆减速机、普通行星齿轮减速机、少齿差行星齿轮减速机、摆线针轮减速机、变速器、有级变速器、机械无级变速器、链轮、摩擦轮",
                                        "taxName": "齿轮",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090124030000000000",
                                        "taxCodeTitle": "齿轮",
                                        "iTitle": "*齿轮*齿轮传动装置（齿轮箱）",
                                        "children": []
                                    },
                                    {
                                        "id": "2655",
                                        "linkid": "2651",
                                        "code": "109012404",
                                        "paCode": "1090124",
                                        "yn": "N",
                                        "title": "滚珠、滚子螺杆及传动装置",
                                        "alias": "滚珠、滚子螺杆及传动装置",
                                        "about": "包括滚珠、滚子螺杆及传动装置、滚子螺杆传动轴、滚珠螺杆传动装置、摩擦圆盘联轴节、摩擦锥体联轴节、其他滚珠、滚子螺杆及传动装置。",
                                        "kws": "滚珠、滚子螺杆、传动装置、滚子螺杆传动轴、滚珠螺杆传动装置、摩擦圆盘联轴节、摩擦锥体联轴节",
                                        "taxName": "齿轮",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090124040000000000",
                                        "taxCodeTitle": "齿轮",
                                        "iTitle": "*齿轮*滚珠、滚子螺杆及传动装置",
                                        "children": []
                                    },
                                    {
                                        "id": "2656",
                                        "linkid": "2651",
                                        "code": "109012405",
                                        "paCode": "1090124",
                                        "yn": "N",
                                        "title": "飞轮及滑轮",
                                        "alias": "飞轮及滑轮",
                                        "about": "包括飞轮、滑轮、滑轮组。",
                                        "kws": "飞轮、滑轮、滑轮组",
                                        "taxName": "齿轮",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090124050000000000",
                                        "taxCodeTitle": "齿轮",
                                        "iTitle": "*齿轮*飞轮及滑轮",
                                        "children": []
                                    },
                                    {
                                        "id": "2657",
                                        "linkid": "2651",
                                        "code": "109012406",
                                        "paCode": "1090124",
                                        "yn": "N",
                                        "title": "离合器",
                                        "alias": "离合器",
                                        "about": "包括摩擦离合器、犬牙式（爪形）离合器、自动离心离合器、压缩空气离合器、液压离合器、超越离合器、其他离合器，不包括液粘离合器（详见109012004）。",
                                        "kws": "离合器、摩擦离合器、犬牙式离合器、爪形离合器、自动离心离合器、压缩空气离合器、液压离合器、超越离合器",
                                        "taxName": "齿轮",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090124060000000000",
                                        "taxCodeTitle": "齿轮",
                                        "iTitle": "*齿轮*离合器",
                                        "children": []
                                    },
                                    {
                                        "id": "2658",
                                        "linkid": "2651",
                                        "code": "109012407",
                                        "paCode": "1090124",
                                        "yn": "N",
                                        "title": "联轴器",
                                        "alias": "联轴器",
                                        "about": "包括套管联轴器、凸轮联轴器、挠性联轴器、液压联轴器、万向联轴器、其他联轴器。",
                                        "kws": "联轴器、套管联轴器、凸轮联轴器、挠性联轴器、液压联轴器、万向联轴器",
                                        "taxName": "齿轮",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090124070000000000",
                                        "taxCodeTitle": "齿轮",
                                        "iTitle": "*齿轮*联轴器",
                                        "children": []
                                    },
                                    {
                                        "id": "2659",
                                        "linkid": "2651",
                                        "code": "109012408",
                                        "paCode": "1090124",
                                        "yn": "N",
                                        "title": "齿轮、传动和驱动部件零件",
                                        "alias": "齿轮、传动和驱动部件零件",
                                        "about": "指各类用于齿轮、传动和驱动部件零配件。",
                                        "kws": "齿轮、传动部件零件、驱动部件零件",
                                        "taxName": "齿轮",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090124080000000000",
                                        "taxCodeTitle": "齿轮",
                                        "iTitle": "*齿轮*齿轮、传动和驱动部件零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2660",
                                "linkid": "2502",
                                "code": "1090125",
                                "paCode": "10901",
                                "yn": "N",
                                "title": "密封垫及类似接合衬垫",
                                "alias": "密封垫及类似接合衬垫",
                                "about": "指用金属、非金属材料或金属片与其他材料复合制成的密封垫或类似接合衬垫，用于静连接部位的密封，由相对运动的并与旋转轴垂直的组成多组摩擦副，借机械力与介质压力产生密封作用的密封装置，其摩擦副可以是金属、石墨、陶瓷等各种材料，包括金属密封件、金属密封垫、多层金属片制密封垫、其他金属密封件、机械密封件、滑动密封环、弹簧密封环、其他机械密封件、其他密封垫及类似接合衬垫。",
                                "kws": "金属密封件、金属密封垫、多层金属片制密封垫、机械密封件、滑动密封环、弹簧密封环、密封垫、接合衬垫",
                                "taxName": "密封垫",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1090125000000000000",
                                "taxCodeTitle": "密封垫",
                                "iTitle": "*密封垫*密封垫及类似接合衬垫",
                                "children": []
                            },
                            {
                                "id": "2661",
                                "linkid": "2502",
                                "code": "1090126",
                                "paCode": "10901",
                                "yn": "Y",
                                "title": "窑炉、熔炉及电炉",
                                "alias": "窑炉、熔炉及电炉",
                                "about": null,
                                "kws": null,
                                "taxName": "窑炉电炉",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090126000000000000",
                                "taxCodeTitle": "窑炉电炉",
                                "iTitle": "*窑炉电炉*窑炉、熔炉及电炉",
                                "children": [
                                    {
                                        "id": "2662",
                                        "linkid": "2661",
                                        "code": "109012601",
                                        "paCode": "1090126",
                                        "yn": "N",
                                        "title": "炉用燃烧器",
                                        "alias": "炉用燃烧器",
                                        "about": "指供各种液体、气体、煤粉、混合燃料燃烧的炉用燃烧器，包括重油燃烧器（雾化燃烧器）、油燃烧器、气体燃烧器、天然气燃烧器、煤气燃烧器、其他气体燃烧器、煤粉燃烧器、油气混合燃烧器、其他炉用燃烧器。",
                                        "kws": "炉用燃烧器、油燃烧器、气体燃烧器、天然气燃烧器、煤气燃烧器、煤粉燃烧器、油气混合燃烧器、重油燃烧器、雾化燃烧器",
                                        "taxName": "窑炉电炉",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090126010000000000",
                                        "taxCodeTitle": "窑炉电炉",
                                        "iTitle": "*窑炉电炉*炉用燃烧器",
                                        "children": []
                                    },
                                    {
                                        "id": "2663",
                                        "linkid": "2661",
                                        "code": "109012602",
                                        "paCode": "1090126",
                                        "yn": "N",
                                        "title": "机械加煤机",
                                        "alias": "机械加煤机",
                                        "about": "包括给煤机、机械炉篦（机械筛）、机械吹灰器、自动出渣器、其他机械加煤机。",
                                        "kws": "机械加煤机、给煤机、机械炉篦、机械筛、机械吹灰器、自动出渣器",
                                        "taxName": "窑炉电炉",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090126020000000000",
                                        "taxCodeTitle": "窑炉电炉",
                                        "iTitle": "*窑炉电炉*机械加煤机",
                                        "children": []
                                    },
                                    {
                                        "id": "2664",
                                        "linkid": "2661",
                                        "code": "109012603",
                                        "paCode": "1090126",
                                        "yn": "N",
                                        "title": "工业电炉",
                                        "alias": "工业电炉",
                                        "about": "包括工业或实验室用电炉及电烘箱等加热设备。",
                                        "kws": "电阻炉、可控气氛热处理炉、间歇作业式电阻炉、连续作业式电阻炉、氢气电阻炉、空气电阻炉、电感应炉、低频感应炉、高频感应炉、介质电容炉、电弧炉、红外线辐射烘箱牙科用电烘箱、工业电炉",
                                        "taxName": "窑炉电炉",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090126030000000000",
                                        "taxCodeTitle": "窑炉电炉",
                                        "iTitle": "*窑炉电炉*工业电炉",
                                        "children": []
                                    },
                                    {
                                        "id": "2665",
                                        "linkid": "2661",
                                        "code": "109012604",
                                        "paCode": "1090126",
                                        "yn": "N",
                                        "title": "非电热金属处理用炉",
                                        "alias": "非电热金属处理用炉",
                                        "about": "指燃气或煤的矿砂或金属热处理用炉。",
                                        "kws": "非电热金属处理用炉、焙烧炉、金属熔化炉、热处理窑炉、锻造炉、渗碳炉",
                                        "taxName": "窑炉电炉",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090126040000000000",
                                        "taxCodeTitle": "窑炉电炉",
                                        "iTitle": "*窑炉电炉*非电热金属处理用炉",
                                        "children": []
                                    },
                                    {
                                        "id": "2666",
                                        "linkid": "2661",
                                        "code": "109012605",
                                        "paCode": "1090126",
                                        "yn": "N",
                                        "title": "其他电炉",
                                        "alias": "其他电炉",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "窑炉电炉",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090126050000000000",
                                        "taxCodeTitle": "窑炉电炉",
                                        "iTitle": "*窑炉电炉*其他电炉",
                                        "children": []
                                    },
                                    {
                                        "id": "2667",
                                        "linkid": "2661",
                                        "code": "109012606",
                                        "paCode": "1090126",
                                        "yn": "N",
                                        "title": "窑炉",
                                        "alias": "窑炉",
                                        "about": "包括辊道窑、电热辊道窑、非电热辊道窑、隧道窑、电热隧道窑、非电热隧道窑、梭式窑、电热梭式窑、非电热梭式窑、推板窑、电推板窑炉、非电推板窑、保护气氛窑炉、电热保护气氛窑、非电热保护气氛窑炉、氮化窑、电热氮化窑、非电热氮化窑、烧成窑炉、电子陶瓷烧成窑炉、纳米材料烧成窑、其他烧成窑炉、电热全辊道窑、电热全自控催化剂辊道窑、燃气、煤辊道窑、高温推板式隧道电窑等、稀土隧道窑、铁粉还原隧道窑、空心砖烧成隧道窑、西式瓦烧成隧道窑、微晶玻璃晶化隧道窑、卫生洁具装配式隧道窑、空心砖干燥隧道窑等、卫生瓷重烧梭式窑、卫生瓷本烧",
                                        "kws": "辊道窑、电热辊道窑、非电热辊道窑、隧道窑、电热隧道窑、非电热隧道窑、梭式窑、电热梭式窑、非电热梭式窑、推板窑、电推板窑炉、非电推板窑、保护气氛窑炉、电热保护气氛窑、非电热保护气氛窑炉、氮化窑、电热氮化窑、非电热氮化窑、烧成窑炉、电子陶瓷烧成窑炉、纳米材料烧成窑、电热全辊道窑、电热全自控催化剂辊道窑、煤辊道窑、高温推板式隧道电窑、稀土隧道窑、铁粉还原隧道窑、空心砖烧成隧道窑、西式瓦烧成隧道窑、微晶玻璃晶化隧道窑、卫生洁具装配式隧道窑、空心砖干燥隧道窑、卫生瓷重烧梭式窑、卫生瓷本烧梭式窑、耐火材料梭式窑、高压",
                                        "taxName": "窑炉电炉",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090126060000000000",
                                        "taxCodeTitle": "窑炉电炉",
                                        "iTitle": "*窑炉电炉*窑炉",
                                        "children": []
                                    },
                                    {
                                        "id": "2668",
                                        "linkid": "2661",
                                        "code": "109012607",
                                        "paCode": "1090126",
                                        "yn": "N",
                                        "title": "熔炉",
                                        "alias": "熔炉",
                                        "about": "指烘烤干燥炉。",
                                        "kws": "烘烤干燥炉",
                                        "taxName": "窑炉电炉",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090126070000000000",
                                        "taxCodeTitle": "窑炉电炉",
                                        "iTitle": "*窑炉电炉*熔炉",
                                        "children": []
                                    },
                                    {
                                        "id": "2669",
                                        "linkid": "2661",
                                        "code": "109012608",
                                        "paCode": "1090126",
                                        "yn": "N",
                                        "title": "窑炉、熔炉及电炉用零件",
                                        "alias": "窑炉、熔炉及电炉用零件",
                                        "about": "包括炉用燃烧器、机械加煤机零件、工业电炉及电烘箱零件、非电热炉及烘箱零件。",
                                        "kws": "窑炉零件、熔炉零件、电炉零件、炉用燃烧器、机械加煤机零件、工业电炉零件、电烘箱零件、非电热炉、烘箱零件",
                                        "taxName": "窑炉电炉",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090126080000000000",
                                        "taxCodeTitle": "窑炉电炉",
                                        "iTitle": "*窑炉电炉*窑炉、熔炉及电炉用零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2670",
                                "linkid": "2502",
                                "code": "1090127",
                                "paCode": "10901",
                                "yn": "Y",
                                "title": "风机、风扇及类似设备",
                                "alias": "风机、风扇及类似设备",
                                "about": null,
                                "kws": null,
                                "taxName": "风机风扇",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090127000000000000",
                                "taxCodeTitle": "风机风扇",
                                "iTitle": "*风机风扇*风机、风扇及类似设备",
                                "children": [
                                    {
                                        "id": "2671",
                                        "linkid": "2670",
                                        "code": "109012701",
                                        "paCode": "1090127",
                                        "yn": "N",
                                        "title": "风机",
                                        "alias": "风机",
                                        "about": "包括纺织专用风机、防爆风机、离心式通风机、电站锅炉鼓引风机、锅炉用通风机（离心式）、通风换气用通风机（离心式）、工业炉用通风机（离心式）、矿井用风机（离心式）、煤粉用通风机（离心式）、高温风机（离心式）、空调风机（离心式）、消防风机（离心式）、烟草风机（离心式）、粮食风机（离心式）、船用风机（离心式）、排尘风机（离心式）、屋顶风机（离心式）、其他离心通风机、贯流通风机、轴流式通风机、锅炉用通风机（轴流式）、通风换气用通风机（轴流式）、工业炉用通风机（轴流式）、矿井用风机（轴流式）、煤粉用通风机（轴流式）、",
                                        "kws": "风机、离心式通风机、电站锅炉鼓引风机、离心式锅炉用通风机、离心式通风换气用通风机、离心式工业炉用通风机、离心式矿井用风机、离心式煤粉用通风机、离心式高温风机、离心式空调风机、离心式消防风机、离心式烟草风机、离心式粮食风机、离心式船用风机、离心式排尘风机、离心式屋顶风机、轴流式通风机、贯流通风机、轴流式锅炉用通风机、轴流式通风换气用通风机、轴流式工业炉用通风机、轴流式矿井用风机、轴流式煤粉用通风机、轴流式高温风机、轴流式空调风机、轴流式消防风机、轴流式烟草风机、轴流式粮食风机、轴流式船用风机、轴流式排尘风机",
                                        "taxName": "风机风扇",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090127010000000000",
                                        "taxCodeTitle": "风机风扇",
                                        "iTitle": "*风机风扇*风机",
                                        "children": []
                                    },
                                    {
                                        "id": "2672",
                                        "linkid": "2670",
                                        "code": "109012702",
                                        "paCode": "1090127",
                                        "yn": "N",
                                        "title": "工业风扇",
                                        "alias": "工业风扇",
                                        "about": "包括工业吊扇、工业换气扇、工业壁扇、工业用排气风扇、工业用排风扇（功率≤5W）、百叶排气风扇、机器和仪器（如计算机）等设备用排风扇、农牧风机（扇）、其他工业用排气风扇、其他工业风扇，不包括5W＜功率≤125W的家用和类似用途电风扇（详见109041601）。",
                                        "kws": "工业风扇、工业吊扇、工业换气扇、工业壁扇、工业用排气风扇、百叶排气风扇、机器用排风扇、仪器设备用排风扇、农牧风机、农牧风扇",
                                        "taxName": "风机风扇",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090127020000000000",
                                        "taxCodeTitle": "风机风扇",
                                        "iTitle": "*风机风扇*工业风扇",
                                        "children": []
                                    },
                                    {
                                        "id": "2673",
                                        "linkid": "2670",
                                        "code": "109012703",
                                        "paCode": "1090127",
                                        "yn": "N",
                                        "title": "工业用通风罩、循环气罩",
                                        "alias": "工业用通风罩、循环气罩",
                                        "about": "包括循环气罩、自由活塞式发生器、通风罩、循环气罩。",
                                        "kws": "工业用通风罩、工业用循环气罩、自由活塞式发生器、自由活塞式通风罩、自由活塞式循环气罩",
                                        "taxName": "风机风扇",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090127030000000000",
                                        "taxCodeTitle": "风机风扇",
                                        "iTitle": "*风机风扇*工业用通风罩、循环气罩",
                                        "children": []
                                    },
                                    {
                                        "id": "2674",
                                        "linkid": "2670",
                                        "code": "109012704",
                                        "paCode": "1090127",
                                        "yn": "N",
                                        "title": "风机、工业风扇用零件",
                                        "alias": "风机、工业风扇用零件",
                                        "about": "指各类用于风机、工业风扇的零配件。",
                                        "kws": "风机用零件、工业风扇用零件",
                                        "taxName": "风机风扇",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090127040000000000",
                                        "taxCodeTitle": "风机风扇",
                                        "iTitle": "*风机风扇*风机、工业风扇用零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2675",
                                "linkid": "2502",
                                "code": "1090128",
                                "paCode": "10901",
                                "yn": "Y",
                                "title": "气体分离及液化设备",
                                "alias": "气体分离及液化设备",
                                "about": null,
                                "kws": null,
                                "taxName": "通用设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090128000000000000",
                                "taxCodeTitle": "通用设备",
                                "iTitle": "*通用设备*气体分离及液化设备",
                                "children": [
                                    {
                                        "id": "2676",
                                        "linkid": "2675",
                                        "code": "109012801",
                                        "paCode": "1090128",
                                        "yn": "N",
                                        "title": "气体发生器",
                                        "alias": "气体发生器",
                                        "about": "包括发生炉煤气发生器、水煤气发生器、水解乙炔气体发生器、氧气发生器、氢气发生器、氮气发生器、空气发生器、乙烯发生器、其他气体发生器。",
                                        "kws": "气体发生器、发生炉煤气发生器、水煤气发生器、水解乙炔气体发生器、氧气发生器、氢气发生器、氮气发生器、空气发生器、乙烯发生器",
                                        "taxName": "通用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090128010000000000",
                                        "taxCodeTitle": "通用设备",
                                        "iTitle": "*通用设备*气体发生器",
                                        "children": []
                                    },
                                    {
                                        "id": "2677",
                                        "linkid": "2675",
                                        "code": "109012802",
                                        "paCode": "1090128",
                                        "yn": "N",
                                        "title": "制氮设备",
                                        "alias": "制氮设备",
                                        "about": "包括深冷法制氮设备、变压吸附制氮设备、膜分离制氮设备、其他制氮设备",
                                        "kws": "制氮设备、深冷法制氮设备、变压吸附制氮设备、膜分离制氮设备",
                                        "taxName": "通用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090128020000000000",
                                        "taxCodeTitle": "通用设备",
                                        "iTitle": "*通用设备*制氮设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2678",
                                        "linkid": "2675",
                                        "code": "109012803",
                                        "paCode": "1090128",
                                        "yn": "N",
                                        "title": "制氢设备",
                                        "alias": "制氢设备",
                                        "about": "包括水电解制氢设备、甲醇重整制氢设备、氨分解制氢设备、其他制氢设备。",
                                        "kws": "制氢设备、水电解制氢设备、甲醇重整制氢设备、氨分解制氢设备",
                                        "taxName": "通用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090128030000000000",
                                        "taxCodeTitle": "通用设备",
                                        "iTitle": "*通用设备*制氢设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2679",
                                        "linkid": "2675",
                                        "code": "109012804",
                                        "paCode": "1090128",
                                        "yn": "N",
                                        "title": "制氧设备",
                                        "alias": "制氧设备",
                                        "about": "指制氧机，包括深冷法制氧设备、变压吸附制氧设备、膜分离制氧设备、其他制氧设备。",
                                        "kws": "制氧设备、深冷法制氧设备、变压吸附制氧设备、膜分离制氧设备",
                                        "taxName": "通用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090128040000000000",
                                        "taxCodeTitle": "通用设备",
                                        "iTitle": "*通用设备*制氧设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2680",
                                        "linkid": "2675",
                                        "code": "109012805",
                                        "paCode": "1090128",
                                        "yn": "N",
                                        "title": "稀有气体提取设备",
                                        "alias": "稀有气体提取设备",
                                        "about": "指主要产品不是稀有气体的设备不列入此。",
                                        "kws": "稀有气体提取设备",
                                        "taxName": "通用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090128050000000000",
                                        "taxCodeTitle": "通用设备",
                                        "iTitle": "*通用设备*稀有气体提取设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2681",
                                        "linkid": "2675",
                                        "code": "109012806",
                                        "paCode": "1090128",
                                        "yn": "N",
                                        "title": "气体纯化设备",
                                        "alias": "气体纯化设备",
                                        "about": "指适用于含氧量≤3%的氮气、氢气、一氧化碳、二氧化碳、甲烷和惰性气体纯化，包括氢气提纯装置、加氢脱氧纯化装置、其他气体纯化设备。",
                                        "kws": "气体纯化设备、氢气提纯装置、加氢脱氧纯化装置",
                                        "taxName": "通用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090128060000000000",
                                        "taxCodeTitle": "通用设备",
                                        "iTitle": "*通用设备*气体纯化设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2682",
                                        "linkid": "2675",
                                        "code": "109012807",
                                        "paCode": "1090128",
                                        "yn": "N",
                                        "title": "气体液化设备",
                                        "alias": "气体液化设备",
                                        "about": "包括天然气液化设备、氧液化设备、氮液化设备、氩液化设备、煤气液化设备、其他气体液化设备。",
                                        "kws": "气体液化设备、天然气液化设备、氧液化设备、氮液化设备、氩液化设备、煤气液化设备",
                                        "taxName": "通用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090128070000000000",
                                        "taxCodeTitle": "通用设备",
                                        "iTitle": "*通用设备*气体液化设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2683",
                                        "linkid": "2675",
                                        "code": "109012899",
                                        "paCode": "1090128",
                                        "yn": "N",
                                        "title": "其他气体分离及液化设备",
                                        "alias": "其他气体分离及液化设备",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "通用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090128990000000000",
                                        "taxCodeTitle": "通用设备",
                                        "iTitle": "*通用设备*其他气体分离及液化设备",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2684",
                                "linkid": "2502",
                                "code": "1090129",
                                "paCode": "10901",
                                "yn": "Y",
                                "title": "利用温度变化加工机械",
                                "alias": "利用温度变化加工机械",
                                "about": null,
                                "kws": null,
                                "taxName": "通用设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090129000000000000",
                                "taxCodeTitle": "通用设备",
                                "iTitle": "*通用设备*利用温度变化加工机械",
                                "children": [
                                    {
                                        "id": "2685",
                                        "linkid": "2684",
                                        "code": "109012901",
                                        "paCode": "1090129",
                                        "yn": "N",
                                        "title": "蒸馏或精馏设备",
                                        "alias": "蒸馏或精馏设备",
                                        "about": "包括制药用蒸馏水机、提净塔、粗馏塔、泡罩式粗馏塔、其他粗馏塔、精馏塔、斜孔板式精馏塔、釜式精镏塔、玻璃降膜再沸式精馏塔、高真空蒸馏塔、分子蒸馏设备、其他精馏塔、酒精回收设备、甲醇回收塔、酒精回收塔、多功能酒精回收器、废酒精回收系统、其他酒精回收设备、水洗塔、蒸馏锅、蒸馏釜、油酸蒸馏装置、挥发油提取器、填料式回收塔和列管式换热器、其他蒸馏或精馏设备。",
                                        "kws": "蒸馏设备、精馏设备、提净塔、粗馏塔、泡罩式粗馏塔、精馏塔、斜孔板式精馏塔、釜式精镏塔、玻璃降膜再沸式精馏塔、高真空蒸馏塔、分子蒸馏设备、酒精回收设备、甲醇回收塔、酒精回收塔、多功能酒精回收器、废酒精回收系统、水洗塔、蒸馏锅、蒸馏釜、油酸蒸馏装置、挥发油提取器、填料式回收塔、列管式换热器",
                                        "taxName": "通用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090129010000000000",
                                        "taxCodeTitle": "通用设备",
                                        "iTitle": "*通用设备*蒸馏或精馏设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2686",
                                        "linkid": "2684",
                                        "code": "109012902",
                                        "paCode": "1090129",
                                        "yn": "N",
                                        "title": "发酵、提取设备",
                                        "alias": "发酵、提取设备",
                                        "about": "包括发酵设备、普通罐型发酵设备、伍式罐型发酵设备、自吸式罐型发酵设备、锥型发酵设备、其他发酵设备、提取罐、多功能提取罐、动态提取罐、其他提取罐、物料罐（主要用于生化发酵生产、如生产味精、柠檬酸、酶制剂、甘油、制药、食品等行业）、其他发酵、提取设备。",
                                        "kws": "发酵设备、普通罐型发酵设备、伍式罐型发酵设备、自吸式罐型发酵设备、锥型发酵设备、提取罐、多功能提取罐、动态提取罐",
                                        "taxName": "通用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090129020000000000",
                                        "taxCodeTitle": "通用设备",
                                        "iTitle": "*通用设备*发酵、提取设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2687",
                                        "linkid": "2684",
                                        "code": "109012903",
                                        "paCode": "1090129",
                                        "yn": "N",
                                        "title": "浓缩设备",
                                        "alias": "浓缩设备",
                                        "about": "包括污水处理用蒸发装置、蒸发器、真空蒸发器、薄膜蒸发器、氨蒸发器、旋转蒸发器、悬框式蒸发器、螺旋管蒸发器、其他蒸发器、浓缩机（罐）、真空减压浓缩罐、外循环浓缩锅、动态热回流提取浓缩机、真空浓缩器、其他浓缩机（罐）、结晶设备、套管结晶机、结晶釜、其他结晶设备、冻干设备、多功能真空冻干设备、其他冻干设备、外加热式真空蒸发器、离心式刮板薄膜蒸发器、刮膜式薄膜蒸发器、三效节能外循换环真空浓缩器、其他浓缩设备",
                                        "kws": "浓缩设备、蒸发器、真空蒸发器、薄膜蒸发器、氨蒸发器、旋转蒸发器、悬框式蒸发器、螺旋管蒸发器、浓缩机、浓缩罐、真空减压浓缩罐、外循环浓缩锅、动态热回流提取浓缩机、真空浓缩器、结晶设备、套管结晶机、结晶釜、冻干设备、多功能真空冻干设备、外加热式真空蒸发器、离心式刮板薄膜蒸发器、刮膜式薄膜蒸发器、三效节能外循换环真空浓缩器",
                                        "taxName": "通用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090129030000000000",
                                        "taxCodeTitle": "通用设备",
                                        "iTitle": "*通用设备*浓缩设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2688",
                                        "linkid": "2684",
                                        "code": "109012904",
                                        "paCode": "1090129",
                                        "yn": "N",
                                        "title": "干燥、分散、混合设备及类似设备",
                                        "alias": "干燥、分散、混合设备及类似设备",
                                        "about": "包括干燥设备、流化床干燥设备、喷雾干燥设备、气流干燥设备、桨叶式干燥设备、盘式干燥设备、耙式干燥设备、厢式和带式干燥设备、回转干燥设备、转鼓干燥设备、太阳能干燥、微波干燥设备、远红外干燥设备、造粒设备、煅烧设备、蒸汽回转干燥机、流态化煅烧机、组合干燥设备、管束式干燥机、旋转闪蒸干燥机、其他干燥设备、均质乳化设备、真空均质乳化成套设备、真空均质乳化锅、高剪切混合乳化机、其他均质乳化设备、分散、混合设备、GF系列分散机、调速分散机、高速分散机、臂式非对称双螺锥形混合机、ZKH-V型混合机、其他分散、混合设备。",
                                        "kws": "干燥设备、流化床干燥设备、喷雾干燥设备、气流干燥设备、桨叶式干燥设备、盘式干燥设备、耙式干燥设备、厢式干燥设备、带式干燥设备、回转干燥设备、转鼓干燥设备、太阳能干燥、微波干燥设备、远红外干燥设备、造粒设备、煅烧设备、蒸汽回转干燥机、流态化煅烧机、组合干燥设备、管束式干燥机、旋转闪蒸干燥机、均质乳化设备、真空均质乳化成套设备、真空均质乳化锅、GF系列分散机、调速分散机、高速分散机、臂式非对称双螺锥形混合机、ZKH-V型混合机",
                                        "taxName": "通用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090129040000000000",
                                        "taxCodeTitle": "通用设备",
                                        "iTitle": "*通用设备*干燥、分散、混合设备及类似设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2689",
                                        "linkid": "2684",
                                        "code": "109012905",
                                        "paCode": "1090129",
                                        "yn": "N",
                                        "title": "热交换装置",
                                        "alias": "热交换装置",
                                        "about": "包括浮头列管式换热器、石墨制浮头列管式换热器、其他浮头列管式换热器、重整换热器、加氢换热器、螺纹锁紧环式加氢换热器、其他加氢换热器、圆块孔式换热器、石墨制圆块孔式换热器、其他圆块孔式换热器、矩形块孔式换热器、石墨制矩形块孔式换热器、其他矩形块孔式换热器、螺旋板式换热器、淋洒式换热器、套筒式换热器、碟片式换热器、列管式再沸器、石墨制浮头列管式再沸器、其他列管式再沸器、其他热交换装置。",
                                        "kws": "热交换装置、浮头列管式换热器、石墨制浮头列管式换热器、重整换热器、加氢换热器、螺纹锁紧环式加氢换热器、圆块孔式换热器、石墨制圆块孔式换热器、矩形块孔式换热器、石墨制矩形块孔式换热器、螺旋板式换热器、淋洒式换热器、套筒式换热器、碟片式换热器、列管式再沸器、石墨制浮头列管式再沸器",
                                        "taxName": "通用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090129050000000000",
                                        "taxCodeTitle": "通用设备",
                                        "iTitle": "*通用设备*热交换装置",
                                        "children": []
                                    },
                                    {
                                        "id": "2690",
                                        "linkid": "2684",
                                        "code": "109012906",
                                        "paCode": "1090129",
                                        "yn": "N",
                                        "title": "加热设备",
                                        "alias": "加热设备",
                                        "about": "包括蒸煮设备、蒸煮器、汽蒸设备、杀菌锅、碱熔锅、中和槽、固碱锅、洗液锅、水油相溶解锅、其他蒸煮设备、压热器、水解木材用压热器、硫化橡胶用压热器、其他压热器、退火炉、分汽缸、其他加热设备，不包括造纸用蒸煮设备（详见109022101）。",
                                        "kws": "加热设备、蒸煮设备、蒸煮器、汽蒸设备、杀菌锅、碱熔锅、中和槽、固碱锅、洗液锅、水油相溶解锅、压热器、水解木材用压热器、硫化橡胶用压热器、退火炉、分汽缸",
                                        "taxName": "通用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090129060000000000",
                                        "taxCodeTitle": "通用设备",
                                        "iTitle": "*通用设备*加热设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2691",
                                        "linkid": "2684",
                                        "code": "109012907",
                                        "paCode": "1090129",
                                        "yn": "N",
                                        "title": "冷却设备",
                                        "alias": "冷却设备",
                                        "about": "包括冰盐冷却装置、气体冷凝器、氮或其他气体的冷凝器、冷却塔、供粮食磨粉工业用的冷却塔、炼油、化工用高压空气冷却器、胶片冷却装置、注塑模具冷却机、其他冷却设备，不包括蒸汽冷凝器（详见109010101）。",
                                        "kws": "冷却设备、冰盐冷却装置、气体冷凝器、冷却塔、供粮食磨粉工业用的冷却塔、炼油、化工用高压空气冷却器、胶片冷却装置、注塑模具冷却机",
                                        "taxName": "通用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090129070000000000",
                                        "taxCodeTitle": "通用设备",
                                        "iTitle": "*通用设备*冷却设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2692",
                                        "linkid": "2684",
                                        "code": "109012999",
                                        "paCode": "1090129",
                                        "yn": "N",
                                        "title": "其他利用温度变化加工机械",
                                        "alias": "其他利用温度变化加工机械",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "通用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090129990000000000",
                                        "taxCodeTitle": "通用设备",
                                        "iTitle": "*通用设备*其他利用温度变化加工机械",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2693",
                                "linkid": "2502",
                                "code": "1090130",
                                "paCode": "10901",
                                "yn": "Y",
                                "title": "液体气体过滤、净化机械",
                                "alias": "液体气体过滤、净化机械",
                                "about": null,
                                "kws": null,
                                "taxName": "通用设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090130000000000000",
                                "taxCodeTitle": "通用设备",
                                "iTitle": "*通用设备*液体气体过滤、净化机械",
                                "children": [
                                    {
                                        "id": "2694",
                                        "linkid": "2693",
                                        "code": "109013001",
                                        "paCode": "1090130",
                                        "yn": "N",
                                        "title": "液体过滤、净化机械",
                                        "alias": "液体过滤、净化机械",
                                        "about": "包括水过滤、净化机械及装置、反渗透装置、EDI装置、超滤设备、医用滤水器（超滤）、纳滤装置、精滤装置、机械过滤装置、软水器、离子交换器、中水回用装置（指洗车废水回用水处理设备）、其他水过滤、净化机械及装、压滤机、厢式压滤机、隔膜压榨式压滤机、板框式压滤机、带式压滤机、全自动压滤机、制药用水设备、其他压滤机、袋式过滤器、单式过滤器、双联过滤器、其他袋式过滤器、烛式过滤机、预涂式烛式过滤机、ZL烛式过滤机、倒立式烛式过滤机、ZTG烛式过滤机、烛式硅藻土过滤机、其他烛式过滤机、液体真空过滤器、转筒式真空过滤机、",
                                        "kws": "液体过滤、净化机械、水过滤、反渗透装置、EDI装置、超滤设备、医用滤水器、纳滤装置、精滤装置、机械过滤装置、软水器、离子交换器、制药用水设备、中水回用装置、厢式压滤机、隔膜压榨式压滤机、板框式压滤机、带式压滤机、全自动压滤机、压滤机、袋式过滤器、单式过滤器、双联过滤器、烛式过滤机、预涂式烛式过滤机、ZL烛式过滤机、倒立式烛式过滤机、ZTG烛式过滤机、烛式硅藻土过滤机、液体真空过滤器、转筒式真空过滤机、间歇式真空过滤机、高效真空净油机、电渗析器、自动频繁倒极电渗析器、反渗透制水装置、PO反渗透净水设备系统",
                                        "taxName": "通用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090130010000000000",
                                        "taxCodeTitle": "通用设备",
                                        "iTitle": "*通用设备*液体过滤、净化机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2695",
                                        "linkid": "2693",
                                        "code": "109013002",
                                        "paCode": "1090130",
                                        "yn": "N",
                                        "title": "气体过滤、净化机械及装置",
                                        "alias": "气体过滤、净化机械及装置",
                                        "about": "包括机械法气体过滤器、滤袋式过滤器、网式过滤器、转鼓过滤器、纸质过滤器、纤维填充过滤器、滤烟器、机械或物理法气体过滤器及净化器、板框过滤机、叶滤机、其他过滤机、其他机械法气体过滤器、气体真空过滤机、圆盘真空过滤机、转台真空过滤机、带式真空过滤机、转鼓真空过滤机、外滤面转鼓真空过滤机、密闭式转鼓真空过滤机、其他转鼓真空过滤机、其他气体真空过滤机、气体净化器、再生式气体净化器、有害气体净化器、其他气体净化器、涤气器（用于净化发生炉煤气或煤气）、干湿涤气器、旋转涤气器、其他涤气器、吸收器（塔）、降膜吸收器、石墨",
                                        "kws": "气体过滤、净化机械、净化装置、机械法气体过滤器、滤袋式过滤器、网式过滤器、转鼓过滤器、纸质过滤器、纤维填充过滤器、滤烟器、机械气体过滤器、物理法气体过滤器、机械气体净化器、物理法气体净化器、板框过滤机、叶滤机、气体真空过滤机、圆盘真空过滤机、转台真空过滤机、带式真空过滤机、转鼓真空过滤机、外滤面转鼓真空过滤机、密闭式转鼓真空过滤机、气体净化器、再生式气体净化器、有害气体净化器、涤气器、干湿涤气器、旋转涤气器、吸收器、吸收塔、降膜吸收器、石墨降膜吸收器、石墨制浮头列管式吸收器",
                                        "taxName": "通用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090130020000000000",
                                        "taxCodeTitle": "通用设备",
                                        "iTitle": "*通用设备*气体过滤、净化机械及装置",
                                        "children": []
                                    },
                                    {
                                        "id": "2696",
                                        "linkid": "2693",
                                        "code": "109013003",
                                        "paCode": "1090130",
                                        "yn": "N",
                                        "title": "发动机燃油、进气过滤器",
                                        "alias": "发动机燃油、进气过滤器",
                                        "about": "包括滤油器（指供内燃发动机、机床等用的滤油器）、吸气过滤器、机动车净化装置、其他发动机燃油、进气过滤器。",
                                        "kws": "发动机燃油、进气过滤器、滤油器、吸气过滤器、机动车净化装置",
                                        "taxName": "通用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090130030000000000",
                                        "taxCodeTitle": "通用设备",
                                        "iTitle": "*通用设备*发动机燃油、进气过滤器",
                                        "children": []
                                    },
                                    {
                                        "id": "2697",
                                        "linkid": "2693",
                                        "code": "109013004",
                                        "paCode": "1090130",
                                        "yn": "N",
                                        "title": "离心机",
                                        "alias": "离心机",
                                        "about": "包括脱水离心机、污泥脱水离心机、高速脱水离心机、其他脱水用离心机、固液分离机、螺旋卸料沉降离心机、三足式沉降离心机、管式分离机、碟式分离机、刮刀卸料沉降离心机、其他固液分离机、过滤离心机、三足式上卸料过滤离心机、立式锥篮离心机、上悬式离心机、卧式刮刀卸料离心机、卧式活塞推料离心机、螺旋卸料过滤离心机、螺旋卸料沉降-过滤离心机、旁滤式离心机、其他过滤离心机、离心干燥机、颗粒离心干燥机、热风离心干燥机、普通离心式喷雾干燥机、高速离心喷雾干燥机、离心真空干燥机、其他离心干燥机、医用离心机、冷冻超速离心机、冷冻高",
                                        "kws": "离心机、脱水离心机、污泥脱水离心机、高速脱水离心机、固液分离机、螺旋卸料沉降离心机、三足式沉降离心机、管式分离机、碟式分离机、刮刀卸料沉降离心机、过滤离心机、三足式上卸料过滤离心机、立式锥篮离心机、上悬式离心机、卧式刮刀卸料离心机、卧式活塞推料离心机、螺旋卸料过滤离心机、螺旋卸料沉降-过滤离心机、旁滤式离心机、离心干燥机、颗粒离心干燥机、热风离心干燥机、普通离心式喷雾干燥机、高速离心喷雾干燥机、离心真空干燥机、医用离心机、冷冻超速离心机、冷冻高速离心机、高速离心机、低速离心机、密闭离心机、SB密闭离心机、",
                                        "taxName": "通用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090130040000000000",
                                        "taxCodeTitle": "通用设备",
                                        "iTitle": "*通用设备*离心机",
                                        "children": []
                                    },
                                    {
                                        "id": "2698",
                                        "linkid": "2693",
                                        "code": "109013005",
                                        "paCode": "1090130",
                                        "yn": "N",
                                        "title": "离心、过滤、净化机设备及其零件",
                                        "alias": "离心、过滤、净化机设备及其零件",
                                        "about": "包括分离、过滤、净化机械零件、离心机零件、离心干燥机零件。",
                                        "kws": "离心过滤净化机设备、离心过滤净化机设备零件、分离过滤净化机械零件、离心机零件、离心干燥机零件",
                                        "taxName": "通用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090130050000000000",
                                        "taxCodeTitle": "通用设备",
                                        "iTitle": "*通用设备*离心、过滤、净化机设备及其零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2699",
                                "linkid": "2502",
                                "code": "1090131",
                                "paCode": "10901",
                                "yn": "Y",
                                "title": "工商用制冷、空调设备",
                                "alias": "工商用制冷、空调设备",
                                "about": null,
                                "kws": null,
                                "taxName": "制冷空调设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090131000000000000",
                                "taxCodeTitle": "制冷空调设备",
                                "iTitle": "*制冷空调设备*工商用制冷、空调设备",
                                "children": [
                                    {
                                        "id": "2700",
                                        "linkid": "2699",
                                        "code": "109013101",
                                        "paCode": "1090131",
                                        "yn": "N",
                                        "title": "工商用制冷设备",
                                        "alias": "工商用制冷设备",
                                        "about": "包括工商用制冰机（最大产冰量为310kg/24h）、速冻机（制造冰的制冷设备）、冷饮机（降温速率很快的冻结、以便在被冻结的食品或其他物品中产生预期结晶结构的设备）、雪泥机、工商用冰淇淋机、软冰淇淋机、硬冰淇淋机、冰淇淋原料杀菌机炒冰机、单锅炒冰机、双锅炒冰机、食品真空冷冻干燥机（由使食品干燥的真空容器及加热系统、制冷系统、真空系统和电气空气系统等组成的成套设备）、谷物冷却机（一种用于粮食低温处藏、向粮仓提供一定温度、湿度空气的设备；主要包括制冷系统以及送风和净化装置、还可以包括调湿和风量调节装置）、组合式",
                                        "kws": "工商用制冷设备、工商用制冰机、速冻机、冷饮机、雪泥机、工商用冰淇淋机、软冰淇淋机、硬冰淇淋机、冰淇淋原料杀菌机炒冰机、单锅炒冰机、双锅炒冰机、食品真空冷冻干燥机、谷物冷却机、组合式冷库、气调库",
                                        "taxName": "制冷空调设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090131010000000000",
                                        "taxCodeTitle": "制冷空调设备",
                                        "iTitle": "*制冷空调设备*工商用制冷设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2701",
                                        "linkid": "2699",
                                        "code": "109013102",
                                        "paCode": "1090131",
                                        "yn": "N",
                                        "title": "工商用冷藏、冷冻柜",
                                        "alias": "工商用冷藏、冷冻柜",
                                        "about": "指工业用、医用及商用等非家用冷藏、冷冻柜，包括工商用冷藏、冷冻柜、冷冻冷藏陈列展示柜（带制冷机组的能展示内放冷藏商品的货柜）、冷冻陈列展示柜、冷藏陈列展示柜、食品冷冻冷藏箱（柜）（比家用冰箱容量大的隔热体、如厨房冰箱、商用冷藏柜等）、医用及科研用冷冻冷藏箱（柜）、工作台冰箱、其他工商用冷藏、冷冻柜，不包括家用和类似用途的冷藏冷冻箱、冷藏箱、冷冻箱、冷藏冷冻箱展示柜（详见190414）。",
                                        "kws": "工商用冷藏、冷冻柜、冷冻冷藏陈列展示柜、冷冻陈列展示柜、冷藏陈列展示柜、食品冷冻冷藏箱、医用冷冻冷藏冰箱、科研用冷冻冷藏冰箱、工作台冰箱",
                                        "taxName": "制冷空调设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090131020000000000",
                                        "taxCodeTitle": "制冷空调设备",
                                        "iTitle": "*制冷空调设备*工商用冷藏、冷冻柜",
                                        "children": []
                                    },
                                    {
                                        "id": "2702",
                                        "linkid": "2699",
                                        "code": "109013103",
                                        "paCode": "1090131",
                                        "yn": "N",
                                        "title": "中央空调冷水/热泵机组",
                                        "alias": "中央空调冷水/热泵机组",
                                        "about": "指通过四通换向阀实现蒸发器与冷凝器的功能切换，达到使载冷剂（一般为水）被冷却（加热）的制冷机组；该机组一般被用作公共建筑中中央空调的主机。包括活塞式冷水（热泵）机组、涡旋式冷水（热泵）机组、螺杆式冷水（热泵）机组、离心式冷水（热泵）机组、溴化锂式冷水机组（以水为制冷剂、溴化锂水溶液为吸收剂、按吸收式制冷循环工作的冷水机组）、水源热泵机组（一种采用循环流动于共用管路中的水、从水井、湖泊或河流中抽取的水或在地下盘管中循环流动的水为冷（热）源、制取冷（热）风或冷（热）水的设备；包括一个使用侧换热设备、压缩机、热",
                                        "kws": "中央空调冷热水泵机组、活塞式冷水机组、涡旋式冷水机组、螺杆式冷水机组、离心式冷水机组、溴化锂式冷水机组、水源热泵机组、活塞式热泵机组、涡旋式热泵机组、螺杆式热泵机组、离心式热泵机组",
                                        "taxName": "制冷空调设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090131030000000000",
                                        "taxCodeTitle": "制冷空调设备",
                                        "iTitle": "*制冷空调设备*中央空调冷水/热泵机组",
                                        "children": []
                                    },
                                    {
                                        "id": "2703",
                                        "linkid": "2699",
                                        "code": "109013104",
                                        "paCode": "1090131",
                                        "yn": "N",
                                        "title": "工商用空调设备",
                                        "alias": "工商用空调设备",
                                        "about": "包括房间空调器、制冷量＞14000W、窗式空调器、制冷量＞14000W、壁挂式空调器、制冷量＞14000W、其他房间空调器、制冷量＞14000W、单元式空调机组、屋顶式空调（热泵）机组、多联式空调（热泵）机组、风管送风式空调（热泵）机组、专用空调机组（工艺性）、机房空调机、洁净空调、医用空调、恒湿机、防爆空调、车用空调设备、轿车用空调、中/大巴用空调、工程车用空调、加湿设备、除湿设备、其他工商用空调设备，不包括制冷量≤14000W的家用和类似用途空调设备、家用房间空气调节器、家用加湿器、家用除湿器（详见1",
                                        "kws": "工商用空调设备、房间空调器、窗式空调器、壁挂式空调器、单元式空调机组、屋顶式空调机组、多联式空调机组、风管送风式空调机组、专用空调机组、机房空调机、洁净空调、医用空调、恒湿机、防爆空调、车用空调设备、加湿设备、除湿设备",
                                        "taxName": "制冷空调设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090131040000000000",
                                        "taxCodeTitle": "制冷空调设备",
                                        "iTitle": "*制冷空调设备*工商用空调设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2704",
                                        "linkid": "2699",
                                        "code": "109013105",
                                        "paCode": "1090131",
                                        "yn": "N",
                                        "title": "工商用制冷、空调设备零部件",
                                        "alias": "工商用制冷、空调设备零部件",
                                        "about": "指各类用于工商用制冷、空调设备零部件。",
                                        "kws": "工商用制冷、空调设备零部件",
                                        "taxName": "制冷空调设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090131050000000000",
                                        "taxCodeTitle": "制冷空调设备",
                                        "iTitle": "*制冷空调设备*工商用制冷、空调设备零部件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2705",
                                "linkid": "2502",
                                "code": "1090132",
                                "paCode": "10901",
                                "yn": "Y",
                                "title": "风动和电动工具",
                                "alias": "风动和电动工具",
                                "about": null,
                                "kws": null,
                                "taxName": "风动电动工具",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090132000000000000",
                                "taxCodeTitle": "风动电动工具",
                                "iTitle": "*风动电动工具*风动和电动工具",
                                "children": [
                                    {
                                        "id": "2706",
                                        "linkid": "2705",
                                        "code": "109013201",
                                        "paCode": "1090132",
                                        "yn": "N",
                                        "title": "风动手提工具",
                                        "alias": "风动手提工具",
                                        "about": "指手提式风动或液压工具，包括装有气动机（或气动活塞）、内燃机或其他非电动的动力机（例如、小型液力涡轮机）的工具、包括风动钻机、风镐（气镐）、风铲、手提式气动锯、手提式链锯、液压混凝土振动器、风动攻丝机、风动铰孔机、气动冲击扳手/液压扳手、风动镗孔机、风砂轮、风动锤、錾平锤、敲锈锤、堵缝锤、铆钉锤等、风动锉机、气动锉刀、风动研磨机、风板机、气动螺刀、机动螺丝刀、螺帽拧入或拧出器、气动剪刀、气动式手提夹钳工具、气动手提打包机、气动式油脂枪、手提式气动羊毛取样钻、其他手提式风动工具。",
                                        "kws": "风动手提工具、风动钻机、风镐、风铲、手提式气动锯、手提式链锯、液压混凝土振动器、风动攻丝机、风动铰孔机、气动冲击扳手、液压扳手、风动镗孔机、风砂轮、风动锤、錾平锤、敲锈锤、堵缝锤、铆钉锤、风动锉机、气动锉刀、风动研磨机、风板机、气动螺刀、机动螺丝刀、螺帽拧入拧出器、气动剪刀、气动式手提夹钳工具、气动手提打包机、气动式油脂枪、手提式气动羊毛取样钻",
                                        "taxName": "风动电动工具",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090132010000000000",
                                        "taxCodeTitle": "风动电动工具",
                                        "iTitle": "*风动电动工具*风动手提工具",
                                        "children": []
                                    },
                                    {
                                        "id": "2707",
                                        "linkid": "2705",
                                        "code": "109013202",
                                        "paCode": "1090132",
                                        "yn": "N",
                                        "title": "电动手提式工具",
                                        "alias": "电动手提式工具",
                                        "about": "指手提式电动液压开孔器，包括电钻（手提式）、冲击钻、手电钻、其他电钻、电锯、电动链锯、其他电锯、手提式电刨（包括电动刨削、修整、磨平器具及类似工具）、电动锤、电动琢锤、铲锤、捻缝锤、铆钉锤、电动锉削机、电动雕刻工具、电动射钉枪、电动铆钉枪、电动锉具、电动手提磨床、电动手提砂光机、电动手提抛光器、电剪刀、电动刷具、电动钢丝刷机、其他电动手提式工具。",
                                        "kws": "电动手提式工具、电钻、冲击钻、手电钻、电锯、电动链锯、手提式电刨、电动锤、电动琢锤、铲锤、捻缝锤、铆钉锤、电动锉削机、电动雕刻工具、电动射钉枪、电动铆钉枪、电动锉具、电动手提磨床、电动手提砂光机、电动手提抛光器、电剪刀、电动刷具、电动钢丝刷机",
                                        "taxName": "风动电动工具",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090132020000000000",
                                        "taxCodeTitle": "风动电动工具",
                                        "iTitle": "*风动电动工具*电动手提式工具",
                                        "children": []
                                    },
                                    {
                                        "id": "2708",
                                        "linkid": "2705",
                                        "code": "109013203",
                                        "paCode": "1090132",
                                        "yn": "N",
                                        "title": "风动和电动工具零件",
                                        "alias": "风动和电动工具零件",
                                        "about": "包括手提式链锯零件、风动手提式工具零件、电动手提式链锯用零件、其他风动和电动工具零件。",
                                        "kws": "风动工具零件、电动工具零件、手提式链锯零件、风动手提式工具零件、电动手提式链锯用零件",
                                        "taxName": "风动电动工具",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090132030000000000",
                                        "taxCodeTitle": "风动电动工具",
                                        "iTitle": "*风动电动工具*风动和电动工具零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2709",
                                "linkid": "2502",
                                "code": "1090133",
                                "paCode": "10901",
                                "yn": "Y",
                                "title": "喷枪及类似器具",
                                "alias": "喷枪及类似器具",
                                "about": "指用于喷射油漆或涂料、清漆、油、塑料、水泥、金属粉、纺织纤维粉末等，也可喷射出强大的压缩空气流或蒸汽流，用以在建筑、雕塑等工作中清洗石料的器具。",
                                "kws": null,
                                "taxName": "喷枪",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090133000000000000",
                                "taxCodeTitle": "喷枪",
                                "iTitle": "*喷枪*喷枪及类似器具",
                                "children": [
                                    {
                                        "id": "2710",
                                        "linkid": "2709",
                                        "code": "109013301",
                                        "paCode": "1090133",
                                        "yn": "N",
                                        "title": "喷枪",
                                        "alias": "喷枪",
                                        "about": "包括金属线材喷涂枪、自动喷枪、自动无气喷枪、空气自动喷枪、空气辅助无气自动喷枪、手动喷枪、手动无气喷枪、离子风喷枪（适用于电子、胶片）、精细空气喷枪、光触媒喷枪、光触媒喷涂专用喷枪、其他喷枪。",
                                        "kws": "喷枪、金属线材喷涂枪、自动喷枪、自动无气喷枪、空气自动喷枪、空气辅助无气自动喷枪、手动喷枪、手动无气喷枪、离子风喷枪、精细空气喷枪、光触媒喷枪、光触媒喷涂专用喷枪",
                                        "taxName": "喷枪",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090133010000000000",
                                        "taxCodeTitle": "喷枪",
                                        "iTitle": "*喷枪*喷枪",
                                        "children": []
                                    },
                                    {
                                        "id": "2711",
                                        "linkid": "2709",
                                        "code": "109013302",
                                        "paCode": "1090133",
                                        "yn": "N",
                                        "title": "喷涂机",
                                        "alias": "喷涂机",
                                        "about": "包括喷漆设备、高能喷涂枪、推式喷涂枪、拉式喷涂枪、静电喷涂机、手动静电喷涂机、自动静电喷涂机、手动静电双系统喷涂机、手动静电漆枪、实验喷涂机、高压无气喷涂机（建筑装饰用）、二液无气喷涂机、管道内壁喷涂器、旋蝶喷漆设备、其他喷涂机。",
                                        "kws": "喷漆设备、喷涂机、高能喷涂枪、推式喷涂枪、拉式喷涂枪、静电喷涂机、手动静电喷涂机、自动静电喷涂机、手动静电双系统喷涂机、手动静电漆枪、实验喷涂机、高压无气喷涂机、二液无气喷涂机、管道内壁喷涂器、旋蝶喷漆设备",
                                        "taxName": "喷枪",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090133020000000000",
                                        "taxCodeTitle": "喷枪",
                                        "iTitle": "*喷枪*喷涂机",
                                        "children": []
                                    },
                                    {
                                        "id": "2712",
                                        "linkid": "2709",
                                        "code": "109013303",
                                        "paCode": "1090133",
                                        "yn": "N",
                                        "title": "喷射机械",
                                        "alias": "喷射机械",
                                        "about": "包括喷砂机、液体喷砂机、干式喷砂机、循环回收式喷砂机（指集喷砂、回收、循环、分离、除尘于一体、无污染及砂料四处飞扬现象、是新一代的环保型喷砂设备）、普压式手动喷砂机、其他喷砂机、喷汽机（用以除去金属机件上的油漆等）、灰浆机、喷砂房、其他喷射机械。",
                                        "kws": "喷射机械、喷砂机、液体喷砂机、干式喷砂机、循环回收式喷砂机、普压式手动喷砂机、喷汽机、灰浆机、喷砂房",
                                        "taxName": "喷枪",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090133030000000000",
                                        "taxCodeTitle": "喷枪",
                                        "iTitle": "*喷枪*喷射机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2713",
                                        "linkid": "2709",
                                        "code": "109013304",
                                        "paCode": "1090133",
                                        "yn": "N",
                                        "title": "喷水器、喷雾器",
                                        "alias": "喷水器、喷雾器",
                                        "about": "包括家用喷雾器、喷壶及类似喷射器具、船用洗舱机、水枪（指可喷射强大的水柱、用以从山坡等处冲落矿物（例如、金矿砂）的器具）、冲洗机械装置（包括汽车挡风玻璃及车头灯的冲洗机械装置）、其他喷水器、喷雾器，不包括农用喷射机械及器具（详见109023708）。",
                                        "kws": "喷水器、喷雾器、家用喷雾器、喷壶、喷射器具、船用洗舱机、冲洗机械装置",
                                        "taxName": "喷枪",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090133040000000000",
                                        "taxCodeTitle": "喷枪",
                                        "iTitle": "*喷枪*喷水器、喷雾器",
                                        "children": []
                                    },
                                    {
                                        "id": "2714",
                                        "linkid": "2709",
                                        "code": "109013305",
                                        "paCode": "1090133",
                                        "yn": "N",
                                        "title": "喷枪及类似器具零件",
                                        "alias": "喷枪及类似器具零件",
                                        "about": "包括家用液体或粉末喷射机械零件、其他喷枪及类似器具零件。",
                                        "kws": "喷枪、喷枪零件、家用液体喷射机械零件、家用粉末喷射机械零件",
                                        "taxName": "喷枪",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090133050000000000",
                                        "taxCodeTitle": "喷枪",
                                        "iTitle": "*喷枪*喷枪及类似器具零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2715",
                                "linkid": "2502",
                                "code": "1090134",
                                "paCode": "10901",
                                "yn": "Y",
                                "title": "包装专用设备",
                                "alias": "包装专用设备",
                                "about": null,
                                "kws": null,
                                "taxName": "包装设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090134000000000000",
                                "taxCodeTitle": "包装设备",
                                "iTitle": "*包装设备*包装专用设备",
                                "children": [
                                    {
                                        "id": "2716",
                                        "linkid": "2715",
                                        "code": "109013401",
                                        "paCode": "1090134",
                                        "yn": "N",
                                        "title": "包装容器洗涤及干燥机械",
                                        "alias": "包装容器洗涤及干燥机械",
                                        "about": "包括药品包装容器的清洁、洗涤、冲洗机械、清洁、洗涤、冲洗机械、安瓿擦瓶机、包装容器专用干燥机械、灭菌检漏设备、其他包装容器洗涤及干燥机械。",
                                        "kws": "药品包装容器清洗机械、包装容器洗涤、包装容器干燥机械、安瓿擦瓶机、包装容器专用干燥机械、灭菌检漏设备",
                                        "taxName": "包装设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090134010000000000",
                                        "taxCodeTitle": "包装设备",
                                        "iTitle": "*包装设备*包装容器洗涤及干燥机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2717",
                                        "linkid": "2715",
                                        "code": "109013402",
                                        "paCode": "1090134",
                                        "yn": "N",
                                        "title": "灌装、装填容器用机械",
                                        "alias": "灌装、装填容器用机械",
                                        "about": "指桶、琵琶桶、罐、瓶、坛、管、安瓿、箱、包、袋等容器的装填机器，常配有辅助性的自动计量或计重控制装置，以及对容器进行封口的设备，包括饮料及液体食品灌装设备、手提式液体食品灌装机、电动手提式的饮料及液体食品罐装设备、非手提式液体食品灌装机械、饮料真空包装机、饮料收缩包装机、饮料充气机、其他饮料及液体食品灌装设备、水泥灌装机、全自动水泥灌包机、其他水泥灌装机、固体产品灌装机（包括固体食品及其他产品灌装机、包装机）、包装机、固体产品真空包装机、裹包机、充填机、贴体包装机、吸塑包装机、塑料袋封口机、泡罩包装机、热",
                                        "kws": "饮料液体食品灌装设备、手提式液体食品灌装机、电动手提式饮料液体食品罐装设备、非手提式液体食品灌装机械、饮料真空包装机、饮料收缩包装机、饮料充气机、水泥灌装机、全自动水泥灌包机、固体产品灌装机、包装机、固体产品真空包装机、裹包机、充填机、贴体包装机、吸塑包装机、塑料袋封口机、泡罩包装机、热成型包装机、物料整理排列机、移动式定量包装车",
                                        "taxName": "包装设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090134020000000000",
                                        "taxCodeTitle": "包装设备",
                                        "iTitle": "*包装设备*灌装、装填容器用机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2718",
                                        "linkid": "2715",
                                        "code": "109013403",
                                        "paCode": "1090134",
                                        "yn": "N",
                                        "title": "容器装封、贴标签及包封机",
                                        "alias": "容器装封、贴标签及包封机",
                                        "about": "指本类机械可配有定型、印刷、捆扎、装订、包边、胶贴、封口装置或对包装进行最后整理的装置包括把已装填好的罐头、瓶子等装入外包装（板条箱、箱子等）的机械，包括装箱机、装盒机、纸箱封口机、其他纸板箱装箱包装机、瓶、坛封口、加塞或压盖机械、封罐机、焊接封口机、封盖机、压盖机、旋盖机、振荡落盖装置、掀盖装置、其他瓶、坛封口、加塞或压盖机械、贴标签机械、贴标机、安瓿色标机、喷码机、标签压印器、其他贴标签机械、打包机及捆扎机、扎口机、捆扎机、便携式打包器械（指手工操作的便携式打包器械）、热缩包装机、其他打包机及捆扎机、",
                                        "kws": "纸板箱装箱包装机、装箱机、装盒机、纸箱封口机、瓶坛封口机械、加塞压盖机械、封罐机、焊接封口机、封盖机、压盖机、旋盖机、振荡落盖装置、掀盖装置、贴标签机械、贴标机、安瓿色标机、喷码机、标签压印器、打包机、捆扎机、扎口机、便携式打包器械、热缩包装机",
                                        "taxName": "包装设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090134030000000000",
                                        "taxCodeTitle": "包装设备",
                                        "iTitle": "*包装设备*容器装封、贴标签及包封机",
                                        "children": []
                                    },
                                    {
                                        "id": "2719",
                                        "linkid": "2715",
                                        "code": "109013404",
                                        "paCode": "1090134",
                                        "yn": "N",
                                        "title": "包装专用设备零件",
                                        "alias": "包装专用设备零件",
                                        "about": "包括饮料及液体食品灌装设备零件、其他包装专用设备零件。",
                                        "kws": "包装专用设备零件、饮料液体食品灌装设备零件",
                                        "taxName": "包装设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090134040000000000",
                                        "taxCodeTitle": "包装设备",
                                        "iTitle": "*包装设备*包装专用设备零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2720",
                                "linkid": "2502",
                                "code": "1090135",
                                "paCode": "10901",
                                "yn": "Y",
                                "title": "衡器（秤）",
                                "alias": "衡器（秤）",
                                "about": "指由秤体（承载器）、传力机构、显示器三部分组成的整体衡器（缺任一部分都只能统计为衡器部件）。",
                                "kws": null,
                                "taxName": "衡器",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090135000000000000",
                                "taxCodeTitle": "衡器",
                                "iTitle": "*衡器*衡器（秤）",
                                "children": [
                                    {
                                        "id": "2721",
                                        "linkid": "2720",
                                        "code": "109013501",
                                        "paCode": "1090135",
                                        "yn": "N",
                                        "title": "工业用衡器",
                                        "alias": "工业用衡器",
                                        "about": "包括地上衡、地上平台秤、地上汽车衡、地上钢材秤、地上轴重秤、地上轮重秤、地上牲畜秤、地上飞机秤、其他地上衡、地中衡、地中平台秤、地中汽车衡、地中钢材秤、地中轴重秤、地中轮重秤、地中牲畜秤、地中飞机秤、其他地中衡、轨道衡、标准轨道衡、自动轨道衡、静态轨道衡、轻轨衡（矿车衡）、煤塔秤、其他轨道衡、料斗秤、粮食秤、液体秤、容器秤、配料秤、秤量车、灌装秤、定量秤、包装秤、其他料斗秤、吊秤、有线式吊秤、无线式吊秤、无线直示式吊秤、无线传输式吊秤、其他吊秤、皮带秤、单托辊皮带秤、多托辊皮带秤、悬浮式皮带秤、悬臂式皮带",
                                        "kws": "工业用衡器、地上衡、地上平台秤、地上汽车衡、地上钢材秤、地上轴重秤、地上轮重秤、地上牲畜秤、地上飞机秤、地中衡、地中平台秤、地中汽车衡、地中钢材秤、地中轴重秤、地中轮重秤、地中牲畜秤、地中飞机秤、轨道衡、标准轨道衡、自动轨道衡、静态轨道衡、轻轨衡、矿车衡、煤塔秤、料斗秤、粮食秤、液体秤、容器秤、配料秤、秤量车、灌装秤、定量秤、包装秤、吊秤、有线式吊秤、无线式吊秤、无线直示式吊秤、无线传输式吊秤、皮带秤、单托辊皮带秤、多托辊皮带秤、悬浮式皮带秤、悬臂式皮带秤、滚轮式皮带秤、核子皮带秤、分类秤、重量检验秤、重",
                                        "taxName": "衡器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090135010000000000",
                                        "taxCodeTitle": "衡器",
                                        "iTitle": "*衡器*工业用衡器",
                                        "children": []
                                    },
                                    {
                                        "id": "2722",
                                        "linkid": "2720",
                                        "code": "109013502",
                                        "paCode": "1090135",
                                        "yn": "N",
                                        "title": "商业用衡器",
                                        "alias": "商业用衡器",
                                        "about": "包括商业用案秤、计价案秤、计重案秤、计数案秤、包裹案秤、信函案秤、运费案秤、度盘案秤、百分案秤、其他商业用案秤、商业用台秤、计价台秤、计重台秤、计数台秤、包裹台秤、度盘台秤、百分台秤、其他商业用台秤。",
                                        "kws": "商业用案秤、计价案秤、计重案秤、计数案秤、包裹案秤、信函案秤、运费案秤、度盘案秤、百分案秤、商业用台秤、计价台秤、计重台秤、计数台秤、包裹台秤、度盘台秤、百分台秤",
                                        "taxName": "衡器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090135020000000000",
                                        "taxCodeTitle": "衡器",
                                        "iTitle": "*衡器*商业用衡器",
                                        "children": []
                                    },
                                    {
                                        "id": "2723",
                                        "linkid": "2720",
                                        "code": "109013503",
                                        "paCode": "1090135",
                                        "yn": "N",
                                        "title": "称重系统",
                                        "alias": "称重系统",
                                        "about": "包括机械式台秤和电子式台秤。",
                                        "kws": "机械式台秤、电子式台秤",
                                        "taxName": "衡器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090135030000000000",
                                        "taxCodeTitle": "衡器",
                                        "iTitle": "*衡器*称重系统",
                                        "children": []
                                    },
                                    {
                                        "id": "2724",
                                        "linkid": "2720",
                                        "code": "109013504",
                                        "paCode": "1090135",
                                        "yn": "N",
                                        "title": "家用秤",
                                        "alias": "家用秤",
                                        "about": "包括人体秤、婴儿秤、配餐秤、浴室秤、家用便携秤（指家用或类似用途的便于携带的秤（又称口袋秤、手掌秤、袖珍秤等））、其他家用秤、其他衡器（秤）。",
                                        "kws": "家用秤、人体秤、体重秤、婴儿秤、配餐秤、浴室秤、家用便携秤",
                                        "taxName": "衡器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090135040000000000",
                                        "taxCodeTitle": "衡器",
                                        "iTitle": "*衡器*家用秤",
                                        "children": []
                                    },
                                    {
                                        "id": "2725",
                                        "linkid": "2720",
                                        "code": "109013505",
                                        "paCode": "1090135",
                                        "yn": "N",
                                        "title": "衡器零配件",
                                        "alias": "衡器零配件",
                                        "about": "包括衡器用砝码、秤砣、称重显示控制器、称重传感器、应变计、其他衡器零配件。",
                                        "kws": "衡器零配件、衡器用砝码、秤砣、称重显示控制器、称重传感器、应变计",
                                        "taxName": "衡器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090135050000000000",
                                        "taxCodeTitle": "衡器",
                                        "iTitle": "*衡器*衡器零配件",
                                        "children": []
                                    },
                                    {
                                        "id": "2726",
                                        "linkid": "2720",
                                        "code": "109013599",
                                        "paCode": "1090135",
                                        "yn": "N",
                                        "title": "其他衡器（秤）",
                                        "alias": "其他衡器（秤）",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "衡器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090135990000000000",
                                        "taxCodeTitle": "衡器",
                                        "iTitle": "*衡器*其他衡器（秤）",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2727",
                                "linkid": "2502",
                                "code": "1090136",
                                "paCode": "10901",
                                "yn": "Y",
                                "title": "金属铸件",
                                "alias": "金属铸件",
                                "about": "包括黑色金属和有色金属铸件。",
                                "kws": null,
                                "taxName": "金属铸件",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090136000000000000",
                                "taxCodeTitle": "金属铸件",
                                "iTitle": "*金属铸件*金属铸件",
                                "children": [
                                    {
                                        "id": "2728",
                                        "linkid": "2727",
                                        "code": "109013601",
                                        "paCode": "1090136",
                                        "yn": "N",
                                        "title": "铸铁件",
                                        "alias": "铸铁件",
                                        "about": "指无可锻性铸铁制品，包括灰铸铁、球墨铸铁、可锻铸铁、特种铸铁制品（包括耐热、耐磨、耐蚀铸铁件）、工业用灰铸铁制品（指工业领域中各行业、如汽车、机床、重型机械、工程机城、通用机械、轻工机械、纺织机械、石化机械、航天、航空、电站、造船、机车车辆等行业用铸铁件）、非工业用灰铸铁制品、工业用球墨铸铁制品、非工业用球墨铸铁制品、工业用可锻铸铁制品、非工业用可锻铸铁制品、消防用铸铁件、井盖井圈、供暖散热器、景观铸件等如消防栓及盖、火警柱；路旁栅栏、下水道及供水系统用铸件；电讯盖板、边侧防水盖板、进水井箅子、漏水箅子、",
                                        "kws": "铸铁件、灰铸铁件、工业用灰铸铁制品、非工业用灰铸铁制品、球墨铸铁件、工业用球墨铸铁制品、非工业用球墨铸铁制品、可锻铸铁件、工业用可锻铸铁制品、非工业用可锻铸铁制品、特种铸铁件、消防用铸铁件、井盖井圈、供暖散热器、消防栓、消防盖、火警柱、路旁栅栏、下水道用铸件、供水系统用铸件、电讯盖板、边侧防水盖板、进水井箅子、漏水箅子、下水道检查闸门、滤栅、阴沟盖",
                                        "taxName": "金属铸件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090136010000000000",
                                        "taxCodeTitle": "金属铸件",
                                        "iTitle": "*金属铸件*铸铁件",
                                        "children": []
                                    },
                                    {
                                        "id": "2729",
                                        "linkid": "2727",
                                        "code": "109013602",
                                        "paCode": "1090136",
                                        "yn": "N",
                                        "title": "铸钢件",
                                        "alias": "铸钢件",
                                        "about": "指工业领域中各行业如汽车、机床、重型机械、工程机械、通用机械、轻工机械、纺织机械、石化机械、航天、航空、电站、造船机车车辆等行业用铸钢件，包括碳钢铸钢件、合金钢铸钢件、不锈钢铸钢件。",
                                        "kws": "铸钢件、碳钢铸钢件、合金钢铸钢件、不锈钢铸钢件",
                                        "taxName": "金属铸件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090136020000000000",
                                        "taxCodeTitle": "金属铸件",
                                        "iTitle": "*金属铸件*铸钢件",
                                        "children": []
                                    },
                                    {
                                        "id": "2730",
                                        "linkid": "2727",
                                        "code": "109013603",
                                        "paCode": "1090136",
                                        "yn": "N",
                                        "title": "铜铸件",
                                        "alias": "铜铸件",
                                        "about": "包括工业用铜铸件、非工业用铜铸件。",
                                        "kws": "铜铸件、工业用铜铸件、非工业用铜铸件",
                                        "taxName": "金属铸件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090136030000000000",
                                        "taxCodeTitle": "金属铸件",
                                        "iTitle": "*金属铸件*铜铸件",
                                        "children": []
                                    },
                                    {
                                        "id": "2731",
                                        "linkid": "2727",
                                        "code": "109013604",
                                        "paCode": "1090136",
                                        "yn": "N",
                                        "title": "铝铸件",
                                        "alias": "铝铸件",
                                        "about": "包括工业用铝铸件、非工业用铝铸件。",
                                        "kws": "铝铸件、工业用铝铸件、非工业用铝铸件",
                                        "taxName": "金属铸件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090136040000000000",
                                        "taxCodeTitle": "金属铸件",
                                        "iTitle": "*金属铸件*铝铸件",
                                        "children": []
                                    },
                                    {
                                        "id": "2732",
                                        "linkid": "2727",
                                        "code": "109013605",
                                        "paCode": "1090136",
                                        "yn": "N",
                                        "title": "锌铸件",
                                        "alias": "锌铸件",
                                        "about": null,
                                        "kws": "锌铸件",
                                        "taxName": "金属铸件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090136050000000000",
                                        "taxCodeTitle": "金属铸件",
                                        "iTitle": "*金属铸件*锌铸件",
                                        "children": []
                                    },
                                    {
                                        "id": "2733",
                                        "linkid": "2727",
                                        "code": "109013606",
                                        "paCode": "1090136",
                                        "yn": "N",
                                        "title": "镁铸件",
                                        "alias": "镁铸件",
                                        "about": null,
                                        "kws": "镁铸件",
                                        "taxName": "金属铸件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090136060000000000",
                                        "taxCodeTitle": "金属铸件",
                                        "iTitle": "*金属铸件*镁铸件",
                                        "children": []
                                    },
                                    {
                                        "id": "2734",
                                        "linkid": "2727",
                                        "code": "109013699",
                                        "paCode": "1090136",
                                        "yn": "N",
                                        "title": "其他金属铸件",
                                        "alias": "其他金属铸件",
                                        "about": null,
                                        "kws": "钛铸件",
                                        "taxName": "金属铸件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090136990000000000",
                                        "taxCodeTitle": "金属铸件",
                                        "iTitle": "*金属铸件*其他金属铸件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2735",
                                "linkid": "2502",
                                "code": "1090137",
                                "paCode": "10901",
                                "yn": "Y",
                                "title": "锻件、粉末冶金件",
                                "alias": "锻件、粉末冶金件",
                                "about": null,
                                "kws": null,
                                "taxName": "锻件",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090137000000000000",
                                "taxCodeTitle": "锻件",
                                "iTitle": "*锻件*锻件、粉末冶金件",
                                "children": [
                                    {
                                        "id": "2736",
                                        "linkid": "2735",
                                        "code": "109013701",
                                        "paCode": "1090137",
                                        "yn": "N",
                                        "title": "锻件",
                                        "alias": "锻件",
                                        "about": "包括模锻件（指在模锻锤、无砧座锤、模锻压机等锻造设备上闭模成形锻件）、自由锻件（指在自由锻锤、自由锻压机、快锻压机等锻造设备上开模、胎模成形锻件及钢锭、钢坯的开坯锻坯件等）、钢锭、钢坯开坯（各种锻材）、其他自由锻件、冷锻件、特殊成形锻件（指旋压成形、辊锻成形、环轧成形等特殊成形工艺成形的锻件）、有色金属锻件、铜锻件、铝锻件、钛合金锻件、其他有色金属锻件。",
                                        "kws": "锻件、模锻件、自由锻件、钢锭、钢坯开坯、冷锻件、特殊成形锻件、有色金属锻件、铜锻件、铝锻件、钛合金锻件",
                                        "taxName": "锻件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090137010000000000",
                                        "taxCodeTitle": "锻件",
                                        "iTitle": "*锻件*锻件",
                                        "children": []
                                    },
                                    {
                                        "id": "2737",
                                        "linkid": "2735",
                                        "code": "109013702",
                                        "paCode": "1090137",
                                        "yn": "N",
                                        "title": "冲压件、钣金件",
                                        "alias": "冲压件、钣金件",
                                        "about": "包括冲压件、拉深件、冲裁件、其他冲压件（包括黑色金属和有色金属制品件）、钣金件、汽车、摩托车等运输机械钣金件、其他钣金件。",
                                        "kws": "冲压件、拉深件、冲裁件、黑色金属、有色金属制品件、钣金件、运输机械钣金件",
                                        "taxName": "锻件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090137020000000000",
                                        "taxCodeTitle": "锻件",
                                        "iTitle": "*锻件*冲压件、钣金件",
                                        "children": []
                                    },
                                    {
                                        "id": "2738",
                                        "linkid": "2735",
                                        "code": "109013703",
                                        "paCode": "1090137",
                                        "yn": "N",
                                        "title": "粉末冶金零件",
                                        "alias": "粉末冶金零件",
                                        "about": "包括粉末冶金结构件、粉末冶金含油轴承、粉末冶金双金属制品、粉末冶金摩擦片、粉末冶金软、硬磁性零件。",
                                        "kws": "粉末冶金零件、粉末冶金结构件、粉末冶金含油轴承、粉末冶金双金属制品、粉末冶金摩擦片、粉末冶金软硬磁性零件",
                                        "taxName": "锻件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090137030000000000",
                                        "taxCodeTitle": "锻件",
                                        "iTitle": "*锻件*粉末冶金零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2739",
                                "linkid": "2502",
                                "code": "1090199",
                                "paCode": "10901",
                                "yn": "N",
                                "title": "其他通用设备和零件",
                                "alias": "其他通用设备和零件",
                                "about": "包括砑光机及类似机械、平整机、砑光机（包括橡胶砑光机、塑料砑光机、造纸砑光机等）、其他砑光机及类似机械（指其他滚压机械）、其他未列明通用设备、砑光机零件、滚筒、滚压机械零件、其他未列明通用设备用零件（包括非自动润滑脂壶、加脂嘴、手轮、杠杆及手柄、安全防护罩及底板、油封环、其他通用机械设备用零件）。",
                                "kws": "平整机、砑光机、橡胶砑光机、塑料砑光机、造纸砑光机、通用设备零件、砑光机零件、滚筒、滚压机械零件、非自动润滑脂壶、加脂嘴、手轮、杠杆、手柄、安全防护罩、安全防护罩底板、油封环、通用机械设备用零件",
                                "taxName": "通用设备",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1090199000000000000",
                                "taxCodeTitle": "通用设备",
                                "iTitle": "*通用设备*其他通用设备和零件",
                                "children": []
                            }
                        ]
                    },
                    {
                        "id": "2740",
                        "linkid": "2501",
                        "code": "10902",
                        "paCode": "109",
                        "yn": "Y",
                        "title": "专用设备",
                        "alias": "专用设备",
                        "about": "指只在一个特定产业，用来生产、加工、处理特定产品或者改变特定物质形态的机械设备及其专门配套件",
                        "kws": null,
                        "taxName": "专用设备",
                        "taxRate": "",
                        "vip": "7",
                        "itaxRate": null,
                        "taxCode": "1090200000000000000",
                        "taxCodeTitle": "专用设备",
                        "iTitle": "*专用设备*专用设备",
                        "children": [
                            {
                                "id": "2741",
                                "linkid": "2740",
                                "code": "1090201",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "矿山专用设备",
                                "alias": "矿山专用设备",
                                "about": "指用于各种固体矿物及石料的开采和选别的机械设备及其专门配套设备",
                                "kws": null,
                                "taxName": "矿山专用设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090201000000000000",
                                "taxCodeTitle": "矿山专用设备",
                                "iTitle": "*矿山专用设备*矿山专用设备",
                                "children": [
                                    {
                                        "id": "2742",
                                        "linkid": "2741",
                                        "code": "109020101",
                                        "paCode": "1090201",
                                        "yn": "N",
                                        "title": "建井设备",
                                        "alias": "建井设备",
                                        "about": "包括钻井机、平巷掘进机、天井掘进设备、伞形钻架、抓岩机、其他建井设备",
                                        "kws": "钻井机、平巷掘进机、天井掘进设备、伞形钻架、抓岩机、建井设备",
                                        "taxName": "矿山专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090201010000000000",
                                        "taxCodeTitle": "矿山专用设备",
                                        "iTitle": "*矿山专用设备*建井设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2743",
                                        "linkid": "2741",
                                        "code": "109020102",
                                        "paCode": "1090201",
                                        "yn": "N",
                                        "title": "采掘、凿岩设备",
                                        "alias": "采掘、凿岩设备",
                                        "about": "包括凿岩机、矿用钻车、钻孔设备、穿孔设备、装药填充设备、矿用挖掘机、装岩机、矿用铲斗式装载机、矿用装运机、矿用地下铲运机、矿用连续式装载机、矿车翻车机、刨煤机、截煤机、采掘辅助设备、其他采掘凿岩设备",
                                        "kws": "凿岩机、矿用钻车、钻孔设备、穿孔设备、装药填充设备、矿用挖掘机、装岩机、矿用铲斗式装载机、矿用装运机、矿用地下铲运机、矿用连续式装载机、矿车翻车机、刨煤机、截煤机、采掘辅助设备、采掘凿岩设备",
                                        "taxName": "矿山专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090201020000000000",
                                        "taxCodeTitle": "矿山专用设备",
                                        "iTitle": "*矿山专用设备*采掘、凿岩设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2744",
                                        "linkid": "2741",
                                        "code": "109020103",
                                        "paCode": "1090201",
                                        "yn": "N",
                                        "title": "矿山提升设备",
                                        "alias": "矿山提升设备",
                                        "about": "包括矿山提升设备、矿用提升绞车、矿用辅助绞车、其他矿山提升设备",
                                        "kws": "矿山提升设备、矿用提升绞车、矿用辅助绞车",
                                        "taxName": "矿山专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090201030000000000",
                                        "taxCodeTitle": "矿山专用设备",
                                        "iTitle": "*矿山专用设备*矿山提升设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2745",
                                        "linkid": "2741",
                                        "code": "109020104",
                                        "paCode": "1090201",
                                        "yn": "N",
                                        "title": "矿物破碎机械",
                                        "alias": "矿物破碎机械",
                                        "about": "包括颚式破碎机、旋回破碎机、圆锥破碎机、辊式破碎机、锤式破碎机、旋盘破碎机、反击式破碎机、立式复合破碎机、立式冲击破碎机、辊压机、破碎筛分联合设备（破碎站）、其他矿物破碎机械",
                                        "kws": "颚式破碎机、旋回破碎机、圆锥破碎机、辊式破碎机、锤式破碎机、旋盘破碎机、反击式破碎机、立式复合破碎机、立式冲击破碎机、辊压机、破碎筛分联合设备、矿物破碎机械",
                                        "taxName": "矿山专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090201040000000000",
                                        "taxCodeTitle": "矿山专用设备",
                                        "iTitle": "*矿山专用设备*矿物破碎机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2746",
                                        "linkid": "2741",
                                        "code": "109020105",
                                        "paCode": "1090201",
                                        "yn": "N",
                                        "title": "矿物粉磨机械",
                                        "alias": "矿物粉磨机械",
                                        "about": "包括球、棒磨机、自（半）磨机、振动磨机、钢球磨煤机、辊盘式磨煤机、风扇磨煤机、微介质水泥磨机、摆式磨粉机（雷蒙磨）、砾磨机、管磨机、立式水泥磨机、其他矿物磨粉机械",
                                        "kws": "球磨机、棒磨机、自磨机、半磨机、振动磨机、钢球磨煤机、辊盘式磨煤机、风扇磨煤机、微介质水泥磨机、摆式磨粉机、雷蒙磨、砾磨机、管磨机、立式水泥磨机、矿物磨粉机械",
                                        "taxName": "矿山专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090201050000000000",
                                        "taxCodeTitle": "矿山专用设备",
                                        "iTitle": "*矿山专用设备*矿物粉磨机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2747",
                                        "linkid": "2741",
                                        "code": "109020106",
                                        "paCode": "1090201",
                                        "yn": "N",
                                        "title": "矿物筛分、洗选设备",
                                        "alias": "矿物筛分、洗选设备",
                                        "about": "包括振动筛、分级设备、磁选设备、浮选设备、重力选矿设备、脱水设备、其他矿物筛分设备、其他矿物洗选设备",
                                        "kws": "振动筛、分级设备、磁选设备、浮选设备、重力选矿设备、脱水设备、矿物筛分设备、矿物洗选设备",
                                        "taxName": "矿山专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090201060000000000",
                                        "taxCodeTitle": "矿山专用设备",
                                        "iTitle": "*矿山专用设备*矿物筛分、洗选设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2748",
                                        "linkid": "2741",
                                        "code": "109020107",
                                        "paCode": "1090201",
                                        "yn": "N",
                                        "title": "矿山用牵引车及其矿车",
                                        "alias": "矿山用牵引车及其矿车",
                                        "about": "包括露天矿用移设车、地下矿用车辆、其他矿山用牵引车及矿车",
                                        "kws": "露天矿用移设车、地下矿用车辆、矿山用牵引车、矿车",
                                        "taxName": "矿山专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090201070000000000",
                                        "taxCodeTitle": "矿山专用设备",
                                        "iTitle": "*矿山专用设备*矿山用牵引车及其矿车",
                                        "children": []
                                    },
                                    {
                                        "id": "2749",
                                        "linkid": "2741",
                                        "code": "109020108",
                                        "paCode": "1090201",
                                        "yn": "N",
                                        "title": "矿山设备专用配套件",
                                        "alias": "矿山设备专用配套件",
                                        "about": "指专用配套附（配）件",
                                        "kws": "建井设备专用配套件、采掘凿岩设备专用配套件、矿用提升设备专用配套件、破碎机械专用配套件、粉磨机械专用配套件、筛分设备专用配套件、洗选设备专用配套件、矿山用牵引车专用套件、矿山用矿车专用配套件、矿山设备专用配套件",
                                        "taxName": "矿山专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090201080000000000",
                                        "taxCodeTitle": "矿山专用设备",
                                        "iTitle": "*矿山专用设备*矿山设备专用配套件",
                                        "children": []
                                    },
                                    {
                                        "id": "2750",
                                        "linkid": "2741",
                                        "code": "109020199",
                                        "paCode": "1090201",
                                        "yn": "N",
                                        "title": "其他矿山专用设备",
                                        "alias": "其他矿山专用设备",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "矿山专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090201990000000000",
                                        "taxCodeTitle": "矿山专用设备",
                                        "iTitle": "*矿山专用设备*其他矿山专用设备",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2751",
                                "linkid": "2740",
                                "code": "1090202",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "石油钻探、开采专用设备",
                                "alias": "石油钻探、开采专用设备",
                                "about": "包括石油、天然气钻采专用设备",
                                "kws": null,
                                "taxName": "石油开采设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090202000000000000",
                                "taxCodeTitle": "石油开采设备",
                                "iTitle": "*石油开采设备*石油钻探、开采专用设备",
                                "children": [
                                    {
                                        "id": "2752",
                                        "linkid": "2751",
                                        "code": "109020201",
                                        "paCode": "1090202",
                                        "yn": "N",
                                        "title": "石油钻井设备",
                                        "alias": "石油钻井设备",
                                        "about": "包括陆地石油钻机、海洋石油钻采设备",
                                        "kws": "沙漠钻机、电驱动钻机、机械驱动钻机、交流变频电驱动钻机、车载钻机、陆地石油钻机、海上石油钻机、油气水处理系统、平台修井模块、海上石油生产平台、海洋石油钻采设备",
                                        "taxName": "石油开采设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090202010000000000",
                                        "taxCodeTitle": "石油开采设备",
                                        "iTitle": "*石油开采设备*石油钻井设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2753",
                                        "linkid": "2751",
                                        "code": "109020202",
                                        "paCode": "1090202",
                                        "yn": "N",
                                        "title": "采油设备",
                                        "alias": "采油设备",
                                        "about": "指在经济有效的前提下，最大限度地把原油从油层中抽到地面上来所需要的设备；陆地采油设备包括抽油机有杆泵、潜油电动离心泵、水力活塞泵、射流泵等；海上采油设备是指专门为海上采油而设计的装置（平台或浮船）；按种类可分为固定式和移动式两种；固定式采油平台分为人工岛和固定式平台两类；移动式采油平台又可分为移动式采油平台（简称MPI）和移动式采油储油平台（简称MPSU）等；不包括开采近海油田或天然气田的固定式平台（详见109020201）。",
                                        "kws": "抽油机、系列搅拌机、潜油电机、取样器、车载多元配注装置、聚合物分散溶解装置、抽油泵、稠油杆、采油设备",
                                        "taxName": "石油开采设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090202020000000000",
                                        "taxCodeTitle": "石油开采设备",
                                        "iTitle": "*石油开采设备*采油设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2754",
                                        "linkid": "2751",
                                        "code": "109020203",
                                        "paCode": "1090202",
                                        "yn": "N",
                                        "title": "修井设备",
                                        "alias": "修井设备",
                                        "about": "系列修井机、其他修井设备",
                                        "kws": "修井机、修井设备",
                                        "taxName": "石油开采设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090202030000000000",
                                        "taxCodeTitle": "石油开采设备",
                                        "iTitle": "*石油开采设备*修井设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2755",
                                        "linkid": "2751",
                                        "code": "109020204",
                                        "paCode": "1090202",
                                        "yn": "N",
                                        "title": "固井压裂设备",
                                        "alias": "固井压裂设备",
                                        "about": "包括泥浆固控系统、泥浆振动筛、防喷器及井口装置、除砂清洁器、泥浆清洁器、真空除气器、圆弧齿蜗轮泥浆搅拌器、砂泵、其他固井压裂设备",
                                        "kws": "泥浆固控系统、泥浆振动筛、防喷器、井口装置、除砂清洁器、泥浆清洁器、真空除气器、圆弧齿蜗轮泥浆搅拌器、砂泵、固井压裂设备",
                                        "taxName": "石油开采设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090202040000000000",
                                        "taxCodeTitle": "石油开采设备",
                                        "iTitle": "*石油开采设备*固井压裂设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2756",
                                        "linkid": "2751",
                                        "code": "109020205",
                                        "paCode": "1090202",
                                        "yn": "N",
                                        "title": "原油稳定站专用设备",
                                        "alias": "原油稳定站专用设备",
                                        "about": "包括普通型高效分水器、智能型高效分水器、油井多项存储收集器、其他原油稳定站专用设备",
                                        "kws": "普通型高效分水器、智能型高效分水器、油井多项存储收集器、原油稳定站专用设备",
                                        "taxName": "石油开采设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090202050000000000",
                                        "taxCodeTitle": "石油开采设备",
                                        "iTitle": "*石油开采设备*原油稳定站专用设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2757",
                                        "linkid": "2751",
                                        "code": "109020206",
                                        "paCode": "1090202",
                                        "yn": "N",
                                        "title": "石油专用工程车辆设备",
                                        "alias": "石油专用工程车辆设备",
                                        "about": "包括石油测井车、石油压裂车、石油混砂车、其他石油专用工程车辆设备",
                                        "kws": "石油测井车、石油压裂车、石油混砂车、石油专用工程车辆设备",
                                        "taxName": "石油开采设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090202060000000000",
                                        "taxCodeTitle": "石油开采设备",
                                        "iTitle": "*石油开采设备*石油专用工程车辆设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2758",
                                        "linkid": "2751",
                                        "code": "109020207",
                                        "paCode": "1090202",
                                        "yn": "N",
                                        "title": "石油测井仪器设备",
                                        "alias": "石油测井仪器设备",
                                        "about": "包括双侧向测井仪、双感应-球形聚焦测井仪、微球型聚焦测井仪、高分辨率声波测井仪、声波变密度测井仪、自然伽马测井仪、补偿中子测井仪、小井眼系列测井仪、其他石油测井仪器设备",
                                        "kws": "双侧向测井仪、双感应-球形聚焦测井仪、微球型聚焦测井仪、高分辨率声波测井仪、声波变密度测井仪、自然伽马测井仪、补偿中子测井仪、小井眼系列测井仪、石油测井仪器设备",
                                        "taxName": "石油开采设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090202070000000000",
                                        "taxCodeTitle": "石油开采设备",
                                        "iTitle": "*石油开采设备*石油测井仪器设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2759",
                                        "linkid": "2751",
                                        "code": "109020208",
                                        "paCode": "1090202",
                                        "yn": "N",
                                        "title": "石油钻井工具",
                                        "alias": "石油钻井工具",
                                        "about": "包括井上工具、井下工具",
                                        "kws": "钻井吊钳、钻井吊卡、钻井卡瓦、钻井吊环、井上工具、钻井钻头、钻井螺杆钻具、钻井打捞工具、钻井扶正器、钻井震击器、钻井减震器、钻井取芯器、钻井安全接头、钻井高压旋塞阀、钻井射孔枪、井下测试设备、井下工具",
                                        "taxName": "石油开采设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090202080000000000",
                                        "taxCodeTitle": "石油开采设备",
                                        "iTitle": "*石油开采设备*石油钻井工具",
                                        "children": []
                                    },
                                    {
                                        "id": "2760",
                                        "linkid": "2751",
                                        "code": "109020209",
                                        "paCode": "1090202",
                                        "yn": "N",
                                        "title": "石油钻探、开采专用设备零件",
                                        "alias": "石油钻探、开采专用设备零件",
                                        "about": "包括石油或天然气钻机零件，其他石油钻探、开采专用设备零件",
                                        "kws": "石油钻机零件、天然气钻机零件、石油钻探专用设备零件、石油钻探开采专用设备零件",
                                        "taxName": "石油开采设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090202090000000000",
                                        "taxCodeTitle": "石油开采设备",
                                        "iTitle": "*石油开采设备*石油钻探、开采专用设备零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2761",
                                "linkid": "2740",
                                "code": "1090203",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "建筑工程用机械",
                                "alias": "建筑工程用机械",
                                "about": "推土机、筑路机、平地机、铲运机等工程机械",
                                "kws": null,
                                "taxName": "建筑工程机械",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090203000000000000",
                                "taxCodeTitle": "建筑工程机械",
                                "iTitle": "*建筑工程机械*建筑工程用机械",
                                "children": [
                                    {
                                        "id": "2762",
                                        "linkid": "2761",
                                        "code": "109020301",
                                        "paCode": "1090203",
                                        "yn": "N",
                                        "title": "挖掘、铲土运输机械",
                                        "alias": "挖掘、铲土运输机械",
                                        "about": "包括挖掘机、推土机、平地机、铲运机、装载机、机械铲、路面开凿机、非自推进铲运机、其他挖掘、铲土运输机械。",
                                        "kws": "履带式挖掘机、轮式挖掘机、挖装机、连续式挖掘机、连续式挖掘机配套设备、特种挖掘机、挖掘机、履带式推土机、侧铲推土机、推土机、平地机、铲运机、装载机、单向控制机械铲、双向控制机械铲、机械铲",
                                        "taxName": "建筑工程机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090203010000000000",
                                        "taxCodeTitle": "建筑工程机械",
                                        "iTitle": "*建筑工程机械*挖掘、铲土运输机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2763",
                                        "linkid": "2761",
                                        "code": "109020302",
                                        "paCode": "1090203",
                                        "yn": "N",
                                        "title": "压实机械",
                                        "alias": "压实机械",
                                        "about": "包括机动压路机、非机动压路机、打夯机、其他压实机械",
                                        "kws": "机动压路机、手扶式压路机、压路机、机动打夯机、非机动打夯机",
                                        "taxName": "建筑工程机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090203020000000000",
                                        "taxCodeTitle": "建筑工程机械",
                                        "iTitle": "*建筑工程机械*压实机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2764",
                                        "linkid": "2761",
                                        "code": "109020303",
                                        "paCode": "1090203",
                                        "yn": "N",
                                        "title": "捣固机（车）",
                                        "alias": "捣固机（车）",
                                        "about": "包括机动捣固机、捣固车（建筑工程用）、非自推进式捣固机等",
                                        "kws": "气动捣固机、振动器捣固机、液压捣固机、机动捣固机、清筛捣固车、捣固车",
                                        "taxName": "建筑工程机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090203030000000000",
                                        "taxCodeTitle": "建筑工程机械",
                                        "iTitle": "*建筑工程机械*捣固机（车）",
                                        "children": []
                                    },
                                    {
                                        "id": "2765",
                                        "linkid": "2761",
                                        "code": "109020304",
                                        "paCode": "1090203",
                                        "yn": "N",
                                        "title": "工程钻机",
                                        "alias": "工程钻机",
                                        "about": "包括锚固工程钻机、锚杆旋喷工程钻机、冲击式工程钻机、回旋工程钻机、三轴深搅工程钻机、其他工程钻机",
                                        "kws": "锚固工程钻机、锚杆旋喷工程钻机、冲击式工程钻机、回旋工程钻机、三轴深搅工程钻机",
                                        "taxName": "建筑工程机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090203040000000000",
                                        "taxCodeTitle": "建筑工程机械",
                                        "iTitle": "*建筑工程机械*工程钻机",
                                        "children": []
                                    },
                                    {
                                        "id": "2766",
                                        "linkid": "2761",
                                        "code": "109020305",
                                        "paCode": "1090203",
                                        "yn": "N",
                                        "title": "桩工机械",
                                        "alias": "桩工机械",
                                        "about": "包括打桩机、拔桩机、压桩机、打桩锤、柴油锤打桩架、其他桩工机械",
                                        "kws": "电动履带式桩机、履带式螺纹桩机、步履式桩机、地下连续墙钻机、非圆形桩钻机、打桩机、振动沉拔桩机、步履沉拔桩机、拔桩机、机械式压桩机、液压式压桩机、压桩机、柴油打桩锤、液压打桩锤、振动桩锤、打桩锤、走管式柴油锤打桩架、履带式柴油锤打桩架、步履式柴油锤打桩架、轨道式柴油锤打桩架、轮胎式柴油锤打桩架、柴油锤打桩架",
                                        "taxName": "建筑工程机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090203050000000000",
                                        "taxCodeTitle": "建筑工程机械",
                                        "iTitle": "*建筑工程机械*桩工机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2767",
                                        "linkid": "2761",
                                        "code": "109020306",
                                        "paCode": "1090203",
                                        "yn": "N",
                                        "title": "公共工程用机械",
                                        "alias": "公共工程用机械",
                                        "about": "包括摊铺机械、筑路机械、线路铺装机械、扫雪设备、管道疏通机械、其他公共工程用机械，不包括垃圾车（详见1090306），及其他类似的市政环卫车辆（详见109030702）。",
                                        "kws": "沥青混凝土摊铺机、混凝土摊铺整平机、稳定土摊铺机、散状物料撒布机、多功能混凝土摊铺机、摊铺机械、沥青路面机械、混凝土路面机械、通用路面机械、筑路机械、管道吊管机、铺设机、架桥机、挖沟联合机、管道吊装联合机、线路铺装机械、除雪机、吹雪机、扫雪设备",
                                        "taxName": "建筑工程机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090203060000000000",
                                        "taxCodeTitle": "建筑工程机械",
                                        "iTitle": "*建筑工程机械*公共工程用机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2768",
                                        "linkid": "2761",
                                        "code": "109020307",
                                        "paCode": "1090203",
                                        "yn": "N",
                                        "title": "建筑工程用货运自卸车",
                                        "alias": "建筑工程用货运自卸车",
                                        "about": "不包括垃圾车（详见1090306）。",
                                        "kws": "电动轮非公路用货运自卸车、自卸车、翻斗车、建筑工程用货运自卸车",
                                        "taxName": "建筑工程机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090203070000000000",
                                        "taxCodeTitle": "建筑工程机械",
                                        "iTitle": "*建筑工程机械*建筑工程用货运自卸车",
                                        "children": []
                                    },
                                    {
                                        "id": "2769",
                                        "linkid": "2761",
                                        "code": "109020308",
                                        "paCode": "1090203",
                                        "yn": "N",
                                        "title": "混凝土机械",
                                        "alias": "混凝土机械",
                                        "about": "包括混凝土泵、混凝土泵车、混凝土搅拌车、散装水泥车、布料杆、其他混凝土机械",
                                        "kws": "混凝土泵、混凝土泵车、混凝土搅拌车、散装水泥车、布料杆、混凝土机械",
                                        "taxName": "建筑工程机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090203080000000000",
                                        "taxCodeTitle": "建筑工程机械",
                                        "iTitle": "*建筑工程机械*混凝土机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2770",
                                        "linkid": "2761",
                                        "code": "109020309",
                                        "paCode": "1090203",
                                        "yn": "N",
                                        "title": "建筑工程用机械零件",
                                        "alias": "建筑工程用机械零件",
                                        "about": "包括推土机机铲、挖掘机用铲、其他建筑工程用机械零件",
                                        "kws": "推土机机铲、挖掘机用铲、建筑工程用机械零件",
                                        "taxName": "建筑工程机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090203090000000000",
                                        "taxCodeTitle": "建筑工程机械",
                                        "iTitle": "*建筑工程机械*建筑工程用机械零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2771",
                                "linkid": "2740",
                                "code": "1090204",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "建筑材料及制品专用生产机械",
                                "alias": "建筑材料及制品专用生产机械",
                                "about": null,
                                "kws": null,
                                "taxName": "建筑工程机械",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "1090204000000000000",
                                "taxCodeTitle": "建筑工程机械",
                                "iTitle": "*建筑工程机械*建筑材料及制品专用生产机械",
                                "children": [
                                    {
                                        "id": "2772",
                                        "linkid": "2771",
                                        "code": "109020401",
                                        "paCode": "1090204",
                                        "yn": "N",
                                        "title": "水泥专用设备",
                                        "alias": "水泥专用设备",
                                        "about": "包括水泥生产的全套设备及散装水泥专用设备",
                                        "kws": "原料均化设备、立式辊磨机、熟料冷却机、选粉机、旋风预热器、增湿塔、水泥烘干机、水泥散装设备、水泥专用设备",
                                        "taxName": "水泥专用设备",
                                        "taxRate": "13%",
                                        "vip": "7",
                                        "itaxRate": "0.13",
                                        "taxCode": "1090204010000000000",
                                        "taxCodeTitle": "水泥专用设备",
                                        "iTitle": "*水泥专用设备*水泥专用设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2773",
                                        "linkid": "2771",
                                        "code": "109020402",
                                        "paCode": "1090204",
                                        "yn": "N",
                                        "title": "建筑材料专用窑炉",
                                        "alias": "建筑材料专用窑炉",
                                        "about": "窑外分解窑、干法回转窑、其他水泥回转窑、混凝土砌块（砖）生产用养护窑、其他砖瓦生产专用窑炉。不包括粉碎、磨粉等通用设备",
                                        "kws": "水泥回转窑、机械立窑、石灰石分解炉、石灰窑、浮法玻璃熔窑、浮法玻璃锡槽、浮法玻璃退火窑、砖瓦生产专用窑炉、旋转式石膏炉、建筑陶瓷辊道窑、建筑陶瓷隧道窑、建筑陶瓷多孔推板窑、卫生陶瓷隧道窑、卫生陶瓷梭式窑、窑车自动运转系统、玻璃纤维熔窑、建筑材料专用窑炉",
                                        "taxName": "水泥专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090204020000000000",
                                        "taxCodeTitle": "水泥专用设备",
                                        "iTitle": "*水泥专用设备*建筑材料专用窑炉",
                                        "children": []
                                    },
                                    {
                                        "id": "2774",
                                        "linkid": "2771",
                                        "code": "109020403",
                                        "paCode": "1090204",
                                        "yn": "N",
                                        "title": "平板玻璃制造及深加工机械",
                                        "alias": "平板玻璃制造及深加工机械",
                                        "about": "包括平板玻璃制造机械、平板玻璃深加工设备、其他平板玻璃及深加工制造机械",
                                        "kws": "浮法玻璃生产成套设备、平板玻璃投料机、平板玻璃拉边机、平板玻璃连续压延机、平板玻璃掰边机、平板玻璃原片输送机、平板玻璃真空吸盘垛扳机、平板玻璃自动码片机、平板玻璃横切机、平板玻璃纵切机、平板玻璃随动切割机、平板玻璃切割台、平板玻璃制造机械、钢化玻璃设备、夹层玻璃设备、镀膜玻璃设备、ow-E玻璃设备、平板玻璃深加工设备",
                                        "taxName": "水泥专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090204030000000000",
                                        "taxCodeTitle": "水泥专用设备",
                                        "iTitle": "*水泥专用设备*平板玻璃制造及深加工机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2775",
                                        "linkid": "2771",
                                        "code": "109020404",
                                        "paCode": "1090204",
                                        "yn": "N",
                                        "title": "玻璃纤维加工机械",
                                        "alias": "玻璃纤维加工机械",
                                        "about": "包括光导纤维生产机械、玻璃纤维专用加工机械、其他玻璃纤维加工机械",
                                        "kws": "光纤拉丝机、光纤焊接机、光纤强度筛选机、光纤着色机、光纤挤出机、光纤预制棒生产设备、光导纤维生产机械、制球机、加球机、玻璃纤维拉丝机、玻璃纤维捻线机、玻璃纤维分条整经机、玻璃纤维制毡机组、玻璃纤维烘干炉、无捻粗纱络纱机、纤维短切机组、玻璃纤维专用加工机械",
                                        "taxName": "水泥专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090204040000000000",
                                        "taxCodeTitle": "水泥专用设备",
                                        "iTitle": "*水泥专用设备*玻璃纤维加工机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2776",
                                        "linkid": "2771",
                                        "code": "109020405",
                                        "paCode": "1090204",
                                        "yn": "N",
                                        "title": "建筑卫生陶瓷机械",
                                        "alias": "建筑卫生陶瓷机械",
                                        "about": "包括原料制备设备、建筑陶瓷机械、卫生陶瓷机械等",
                                        "kws": "制浆制粉搅拌机、喷雾干燥塔、增湿造粒机、大颗粒制备系统、泥浆磁选机、原料制备设备、液压全自动压砖机、单层卧式辊道干燥器、多层卧式辊道干燥器、立式干燥器、一次烧成彩釉墙地砖多功能施釉线、二次烧成釉面砖多功能施釉彩饰联动线、瓷质砖抛光线、抛坯机、建筑陶瓷机械、械台式注浆机、压组合浇注线、低压快排水注浆线、中压注浆机组、高压注浆机组、加热泥浆罐、室式干燥器、隧道干燥器、施釉彩饰设备、卫生陶瓷机械",
                                        "taxName": "水泥专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090204050000000000",
                                        "taxCodeTitle": "水泥专用设备",
                                        "iTitle": "*水泥专用设备*建筑卫生陶瓷机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2777",
                                        "linkid": "2771",
                                        "code": "109020406",
                                        "paCode": "1090204",
                                        "yn": "N",
                                        "title": "复合材料成型设备",
                                        "alias": "复合材料成型设备",
                                        "about": "包括缠绕机、拉挤机、连续制板机、其他复合材料成型设备",
                                        "kws": "缠绕机、拉挤机、连续制板机、复合材料成型设备",
                                        "taxName": "水泥专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090204060000000000",
                                        "taxCodeTitle": "水泥专用设备",
                                        "iTitle": "*水泥专用设备*复合材料成型设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2778",
                                        "linkid": "2771",
                                        "code": "109020407",
                                        "paCode": "1090204",
                                        "yn": "N",
                                        "title": "非金属矿物混合搅拌机械",
                                        "alias": "非金属矿物混合搅拌机械",
                                        "about": "包括混凝土配料机、混凝土或砂浆混合机、混凝土搅拌机（站）、沥青混凝土搅拌设备、干粉砂浆生产设备、双混式干混砂浆生产设备、矿石混合机、其他非金属矿物混合搅拌机械",
                                        "kws": "混凝土配料机、混凝土混合机、砂浆混合机、混凝土搅拌机、沥青混凝土搅拌设备、干粉砂浆生产设备、双混式干混砂浆生产设备、矿石混合机、非金属矿物混合搅拌机械",
                                        "taxName": "水泥专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090204070000000000",
                                        "taxCodeTitle": "水泥专用设备",
                                        "iTitle": "*水泥专用设备*非金属矿物混合搅拌机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2779",
                                        "linkid": "2771",
                                        "code": "109020408",
                                        "paCode": "1090204",
                                        "yn": "N",
                                        "title": "建筑材料制品成型机械",
                                        "alias": "建筑材料制品成型机械",
                                        "about": "包括制管机械、非配筋小型混凝土块材生产机械、烧结类制砖生产机械、加气混凝土装备、瓦片模压机、石棉瓦设备、路面砖、路缘石成型机、电杆及类似制品成型机械、轻质隔墙体板成型设备、石膏制品模制成型机械、人工制砂成型机械、防水材料加工成型设备、保温绝热材料加工设备、其他建筑材料制品成型机械",
                                        "kws": "挤压制管机、混凝土管离心式模制机、水管离心成型机、水管悬辊成型机、陶管模压机、陶管挤出机、制管机械、混凝土砌块砖振动成型机、混凝土块材液压成型机、混凝土块材二次深加工机械、混凝土砌块砖模具、混凝土砌块砖生产用栈板、混凝土砌块砖全自动生产线成套装备、非配筋小型混凝土块材生产机械、真空挤砖机、压砖机、切条切、切坯机、翻坯机组、码坯机、二次码烧工艺设备、烧结类制砖生产机械、浇注机、蒸压釜、加气混凝土切割机、加气混凝土装备、辊压成型隐形瓦机、彩钢琉璃瓦机、自动拉模压瓦机、彩瓦生产设备、全自动彩瓦设备生产线、瓦片模",
                                        "taxName": "水泥专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090204080000000000",
                                        "taxCodeTitle": "水泥专用设备",
                                        "iTitle": "*水泥专用设备*建筑材料制品成型机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2780",
                                        "linkid": "2771",
                                        "code": "109020409",
                                        "paCode": "1090204",
                                        "yn": "N",
                                        "title": "矿石烘干机",
                                        "alias": "矿石烘干机",
                                        "about": "包括转筒烘干机、转筒干燥机、矿用烘干机、矿石干燥机、其他矿石烘干机",
                                        "kws": "筒烘干机、转筒干燥机、矿用烘干机、矿石干燥机",
                                        "taxName": "水泥专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090204090000000000",
                                        "taxCodeTitle": "水泥专用设备",
                                        "iTitle": "*水泥专用设备*矿石烘干机",
                                        "children": []
                                    },
                                    {
                                        "id": "2781",
                                        "linkid": "2771",
                                        "code": "109020410",
                                        "paCode": "1090204",
                                        "yn": "N",
                                        "title": "石材加工机床",
                                        "alias": "石材加工机床",
                                        "about": "包括石材加工锯床、石材研磨及抛光机床、石材板材薄板生产线设备、其他石材加工机床",
                                        "kws": "圆盘锯床、圆盘切割机、钢丝锯床、石材锯切机、全自动多片组合锯切中心、多片横切机、红外线桥切机、石材加工锯床、磨边倒角机、石料研磨机床、石料抛光机床、石料压纹机床、石料研磨、抛光机床",
                                        "taxName": "水泥专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090204100000000000",
                                        "taxCodeTitle": "水泥专用设备",
                                        "iTitle": "*水泥专用设备*石材加工机床",
                                        "children": []
                                    },
                                    {
                                        "id": "2782",
                                        "linkid": "2771",
                                        "code": "109020411",
                                        "paCode": "1090204",
                                        "yn": "N",
                                        "title": "建筑材料及制品专用机械零件",
                                        "alias": "建筑材料及制品专用机械零件",
                                        "about": "包括平板玻璃制造及深加工机械零件、其他建筑材料及制品专用机械零件",
                                        "kws": "平板玻璃制造机械零件、深加工机械零件、建筑材料专用机械零件、建筑材料制品专用机械零件",
                                        "taxName": "水泥专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090204110000000000",
                                        "taxCodeTitle": "水泥专用设备",
                                        "iTitle": "*水泥专用设备*建筑材料及制品专用机械零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2783",
                                "linkid": "2740",
                                "code": "1090205",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "玻璃、陶瓷制品生产专用设备",
                                "alias": "玻璃、陶瓷制品生产专用设备",
                                "about": null,
                                "kws": null,
                                "taxName": "玻璃陶瓷设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090205000000000000",
                                "taxCodeTitle": "玻璃陶瓷设备",
                                "iTitle": "*玻璃陶瓷设备*玻璃、陶瓷制品生产专用设备",
                                "children": [
                                    {
                                        "id": "2784",
                                        "linkid": "2783",
                                        "code": "109020501",
                                        "paCode": "1090205",
                                        "yn": "N",
                                        "title": "玻璃制品制造机械",
                                        "alias": "玻璃制品制造机械",
                                        "about": "包括玻璃热加工机械、压制玻璃器皿专用机械、玻璃吹制机械、其他玻璃制品制造机械",
                                        "kws": "连续式玻璃热弯炉、制玻璃珠用机械、玻璃螺旋管烧成用高温窑、玻璃餐具陶瓷成型烤花窑、玻璃热加工机械、玻璃制品模制机、璃器皿压制成型机、玻璃器皿压制生产线、制瓶机、制保温瓶设备、制管机、吹制玻璃器皿专用机械",
                                        "taxName": "玻璃陶瓷设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090205010000000000",
                                        "taxCodeTitle": "玻璃陶瓷设备",
                                        "iTitle": "*玻璃陶瓷设备*玻璃制品制造机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2785",
                                        "linkid": "2783",
                                        "code": "109020502",
                                        "paCode": "1090205",
                                        "yn": "N",
                                        "title": "玻璃材料加工机床",
                                        "alias": "玻璃材料加工机床",
                                        "about": "包括玻璃冷加工机床、其他玻璃材料加工机床",
                                        "kws": "玻璃圆盘锯床、玻璃钢丝锯床、玻璃冷加工研磨机床、玻璃冷加工抛光机床、玻璃切割机、玻璃刻花机、玻璃冷加工机床",
                                        "taxName": "玻璃陶瓷设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090205020000000000",
                                        "taxCodeTitle": "玻璃陶瓷设备",
                                        "iTitle": "*玻璃陶瓷设备*玻璃材料加工机床",
                                        "children": []
                                    },
                                    {
                                        "id": "2786",
                                        "linkid": "2783",
                                        "code": "109020503",
                                        "paCode": "1090205",
                                        "yn": "N",
                                        "title": "日用陶瓷制品成型机械",
                                        "alias": "日用陶瓷制品成型机械",
                                        "about": "指日用陶瓷坯泥粘聚或成型机械",
                                        "kws": "陶轮机械、陶轮类似机械、陶瓷坯体精加工设备、模制陶瓷假牙用机械、日用陶瓷制品成型机械",
                                        "taxName": "玻璃陶瓷设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090205030000000000",
                                        "taxCodeTitle": "玻璃陶瓷设备",
                                        "iTitle": "*玻璃陶瓷设备*日用陶瓷制品成型机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2787",
                                        "linkid": "2783",
                                        "code": "109020504",
                                        "paCode": "1090205",
                                        "yn": "N",
                                        "title": "玻璃、陶瓷制品专用设备零件",
                                        "alias": "玻璃、陶瓷制品专用设备零件",
                                        "about": "包括玻璃冷加工机床零件、附件，其他玻璃、陶瓷制品专用设备零件。",
                                        "kws": "玻璃冷加工机床零件、璃冷加工机床附件、玻璃制品专用设备零件、陶瓷制品专用设备零件",
                                        "taxName": "玻璃陶瓷设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090205040000000000",
                                        "taxCodeTitle": "玻璃陶瓷设备",
                                        "iTitle": "*玻璃陶瓷设备*玻璃、陶瓷制品专用设备零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2788",
                                "linkid": "2740",
                                "code": "1090206",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "冶金专用设备",
                                "alias": "冶金专用设备",
                                "about": "指钢铁和有色金属冶炼、金属锭坯铸造及轧制钢材和有色金属材料的机械成套设备及其专门配套设备",
                                "kws": null,
                                "taxName": "冶金专用设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090206000000000000",
                                "taxCodeTitle": "冶金专用设备",
                                "iTitle": "*冶金专用设备*冶金专用设备",
                                "children": [
                                    {
                                        "id": "2789",
                                        "linkid": "2788",
                                        "code": "109020601",
                                        "paCode": "1090206",
                                        "yn": "N",
                                        "title": "金属冶炼设备",
                                        "alias": "金属冶炼设备",
                                        "about": "包括造块设备、炼焦设备、炼铁设备、炼钢设备、铁合金冶炼设备、有色金属冶炼设备等",
                                        "kws": "烧结设备、球团设备、造块设备、顶装式焦炉设备、捣固式焦炉设备、炼焦设备、高炉设备、直接还原设备、熔融还原设备、混铁炉、炉前机械设备、炼铁设备、转炉炼钢设备、电炉炼钢设备、炉外精炼设备、真空熔炼设备、电渣重熔设备、炼钢设备、鼓风炉、反射炉、冶炼电炉、闪速炉、有色金属冶炼设备",
                                        "taxName": "冶金专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090206010000000000",
                                        "taxCodeTitle": "冶金专用设备",
                                        "iTitle": "*冶金专用设备*金属冶炼设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2790",
                                        "linkid": "2788",
                                        "code": "109020602",
                                        "paCode": "1090206",
                                        "yn": "N",
                                        "title": "铸造机械",
                                        "alias": "铸造机械",
                                        "about": "包括连续铸钢设备、铸锭设备、铸造机、铸砂造型制芯机、自动造型线、砂处理机、铸造清理机、熔炼浇注设备、金属型压铸机、砂芯或铸模烘干炉、铸造工具、其他铸造机械",
                                        "kws": "方坯连铸机、板坯连铸机、圆坯连铸机、薄板坯连铸机、有色金属连铸设备、连续铸钢设备、生铁铸锭设备、钢锭真空铸锭设备、有色金属铸锭设备、铸锭设备、压力浇铸机、离心浇铸机、铸造机、砂模成型机、摇震压缩型造型机、芯机、铸砂造型、制芯机、树脂砂生产线、自动造型线、混砂机、铸砂搅拌机、松砂机、落砂机、砂处理机、滚筒式清理机、抛丸清理机、铸造清理机、非电动铸造工具、动铸造工具",
                                        "taxName": "冶金专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090206020000000000",
                                        "taxCodeTitle": "冶金专用设备",
                                        "iTitle": "*冶金专用设备*铸造机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2791",
                                        "linkid": "2788",
                                        "code": "109020603",
                                        "paCode": "1090206",
                                        "yn": "N",
                                        "title": "金属轧制设备",
                                        "alias": "金属轧制设备",
                                        "about": "包括开坯轧机、板带材轧机、无缝钢管轧机、型材轧机、线材轧机、特殊轧机、轧材精整设备（轧机辅机设备）、轧材深加工设备等",
                                        "kws": "初轧机、板坯轧机、薄板坯轧机、钢坯轧机、开坯轧机、热轧板带材轧机、冷轧板带材轧机、板带材轧机、热轧无缝管轧机、冷轧无缝管轧机、定减径轧管机、无缝钢管轧机、轨梁轧机、大型型材轧机、中型型材轧机、小型型材轧机、型材轧机、高速线材轧机、高速无扭线材轧机、棒线材轧机、预应力轧机线材生产线、线材轧机、车轮轧机、齿轮轧机、特殊轧机、轧材剪切设备、锯切设备、矫正机、轧材开卷、卷取机、轧材酸洗、退火设备、轧材精整设备、管棒材拉拔机、金属制品设备、轧材涂层设备、轧材镀层设备、轧材深加工设备",
                                        "taxName": "冶金专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090206030000000000",
                                        "taxCodeTitle": "冶金专用设备",
                                        "iTitle": "*冶金专用设备*金属轧制设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2792",
                                        "linkid": "2788",
                                        "code": "109020604",
                                        "paCode": "1090206",
                                        "yn": "N",
                                        "title": "冶金专用有轨车辆",
                                        "alias": "冶金专用有轨车辆",
                                        "about": "指专门为冶金企业生产配套的运送冶炼材料或其他功能的专用有轨车辆",
                                        "kws": "铁水车、混铁水车、钢水车、铸锭车、钢锭保温车、烧结矿运输车、铝氧矿车、渣罐车、料槽车、转炉修炉车、冶金专用有轨车辆",
                                        "taxName": "冶金专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090206040000000000",
                                        "taxCodeTitle": "冶金专用设备",
                                        "iTitle": "*冶金专用设备*冶金专用有轨车辆",
                                        "children": []
                                    },
                                    {
                                        "id": "2793",
                                        "linkid": "2788",
                                        "code": "109020605",
                                        "paCode": "1090206",
                                        "yn": "N",
                                        "title": "冶金专用设备配套件",
                                        "alias": "冶金专用设备配套件",
                                        "about": "指专用配套附（配）件，包括金属冶炼设备配套件、铸锭及连铸机用配套件、金属轧制设备用配套件、冶金专用有轨车辆配套件、其他冶金专用设备配套件",
                                        "kws": "焦炉零件、炼钢电炉零件、炉外精炼设备零件、金属冶炼设备配套件、钢坯连铸机用结晶器、钢坯连铸机用振动装置、连铸机扇形段、铸锭用浇包、铸锭用锭模、连铸机用配套件、金属轧机用轧辊、金属轧制设备用配套件",
                                        "taxName": "冶金专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090206050000000000",
                                        "taxCodeTitle": "冶金专用设备",
                                        "iTitle": "*冶金专用设备*冶金专用设备配套件",
                                        "children": []
                                    },
                                    {
                                        "id": "2794",
                                        "linkid": "2788",
                                        "code": "109020699",
                                        "paCode": "1090206",
                                        "yn": "N",
                                        "title": "其他冶金专用设备",
                                        "alias": "其他冶金专用设备",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "冶金专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090206990000000000",
                                        "taxCodeTitle": "冶金专用设备",
                                        "iTitle": "*冶金专用设备*其他冶金专用设备",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2795",
                                "linkid": "2740",
                                "code": "1090207",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "炼油、化工生产专用设备",
                                "alias": "炼油、化工生产专用设备",
                                "about": "指炼油、化学工业生产专用的设备，包括炼油主要设备和化工主要设备两大类；不包括包装机械（详见1090134），工业动力设备（详见1090102、1090103、1090104），电子计算机（详见1090509），机械手（详见109025602），工业机器人（详见109025601）。",
                                "kws": null,
                                "taxName": "炼化专用设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090207000000000000",
                                "taxCodeTitle": "炼化专用设备",
                                "iTitle": "*炼化专用设备*炼油、化工生产专用设备",
                                "children": [
                                    {
                                        "id": "2796",
                                        "linkid": "2795",
                                        "code": "109020701",
                                        "paCode": "1090207",
                                        "yn": "N",
                                        "title": "塔类设备",
                                        "alias": "塔类设备",
                                        "about": "包括板式塔（包括筛板、浮网、泡罩）、填料塔、焦炭塔、干燥塔、冷却塔、造粒塔",
                                        "kws": "填料塔、筛板塔、泡罩塔、浮阀塔、浮动喷射塔、冷凝塔、吸附塔、塔类设备",
                                        "taxName": "炼化专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090207010000000000",
                                        "taxCodeTitle": "炼化专用设备",
                                        "iTitle": "*炼化专用设备*塔类设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2797",
                                        "linkid": "2795",
                                        "code": "109020702",
                                        "paCode": "1090207",
                                        "yn": "N",
                                        "title": "反应器（釜）",
                                        "alias": "反应器（釜）",
                                        "about": "包括高压反应釜、聚合釜、烷化歧化反应釜、树脂反应釜、回转筒式反应器、多功能分散反应釜、石油化工用加氢反应器、其他反应器（釜）",
                                        "kws": "高压反应釜、聚合釜、烷化歧化反应釜、树脂反应釜、回转筒式反应器、多功能分散反应釜、石油化工用加氢反应器、反应器、反应釜",
                                        "taxName": "炼化专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090207020000000000",
                                        "taxCodeTitle": "炼化专用设备",
                                        "iTitle": "*炼化专用设备*反应器（釜）",
                                        "children": []
                                    },
                                    {
                                        "id": "2798",
                                        "linkid": "2795",
                                        "code": "109020703",
                                        "paCode": "1090207",
                                        "yn": "N",
                                        "title": "化工专用炉",
                                        "alias": "化工专用炉",
                                        "about": "包括变换炉、蒸汽煅烧炉、合成炉、乙烯裂解炉、电石炉、电烷化炉、废热锅炉、沸腾干氨炉、沸腾凉碱炉、其他化工专用炉",
                                        "kws": "变换炉、蒸汽煅烧炉、合成炉、乙烯裂解炉、电石炉、电烷化炉、废热锅炉、沸腾干氨炉、沸腾凉碱炉、化工专用炉",
                                        "taxName": "炼化专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090207030000000000",
                                        "taxCodeTitle": "炼化专用设备",
                                        "iTitle": "*炼化专用设备*化工专用炉",
                                        "children": []
                                    },
                                    {
                                        "id": "2799",
                                        "linkid": "2795",
                                        "code": "109020704",
                                        "paCode": "1090207",
                                        "yn": "N",
                                        "title": "混合搅拌设备",
                                        "alias": "混合搅拌设备",
                                        "about": "包括搅拌器（碳钢、碳钢制衬不锈钢、不锈钢）",
                                        "kws": "双螺旋双锥型混合机、静态混合器、混合搅拌设备",
                                        "taxName": "炼化专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090207040000000000",
                                        "taxCodeTitle": "炼化专用设备",
                                        "iTitle": "*炼化专用设备*混合搅拌设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2800",
                                        "linkid": "2795",
                                        "code": "109020705",
                                        "paCode": "1090207",
                                        "yn": "N",
                                        "title": "化工用液体运送机械",
                                        "alias": "化工用液体运送机械",
                                        "about": "包括液环泵、化工用屏蔽泵、内圆弧齿轮输送泵、高粘度旋转活塞泵、蜗壳辐流泵、循环水泵、陶瓷清液泵、其他化工用液体运送机械",
                                        "kws": "化工用屏蔽泵、内圆弧齿轮输送泵、高粘度旋转活塞泵、蜗壳辐流泵、循环水泵、陶瓷清液泵、化工用液体运送机械",
                                        "taxName": "炼化专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090207050000000000",
                                        "taxCodeTitle": "炼化专用设备",
                                        "iTitle": "*炼化专用设备*化工用液体运送机械",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2801",
                                "linkid": "2740",
                                "code": "1090208",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "橡胶加工专用设备",
                                "alias": "橡胶加工专用设备",
                                "about": "指将橡胶制成橡胶制品的塑炼、混炼、压延或压出（即挤出）、成型和硫化等专用设备",
                                "kws": null,
                                "taxName": "橡胶加工设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090208000000000000",
                                "taxCodeTitle": "橡胶加工设备",
                                "iTitle": "*橡胶加工设备*橡胶加工专用设备",
                                "children": [
                                    {
                                        "id": "2802",
                                        "linkid": "2801",
                                        "code": "109020801",
                                        "paCode": "1090208",
                                        "yn": "N",
                                        "title": "橡胶前加工机械",
                                        "alias": "橡胶前加工机械",
                                        "about": "包括橡胶破碎、搅拌、研磨、筛选、均化机械",
                                        "kws": "原料混合机、胶浆搅拌机、立式胶浆搅拌机、橡胶前加工机械",
                                        "taxName": "橡胶加工设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090208010000000000",
                                        "taxCodeTitle": "橡胶加工设备",
                                        "iTitle": "*橡胶加工设备*橡胶前加工机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2803",
                                        "linkid": "2801",
                                        "code": "109020802",
                                        "paCode": "1090208",
                                        "yn": "N",
                                        "title": "橡胶初加工机械",
                                        "alias": "橡胶初加工机械",
                                        "about": "包括约片机、压片机（橡胶加工用）、压薄机、选粒机、胶乳凝固槽、洗涤机等",
                                        "kws": "约片机、橡胶加工用压片机、压薄机、选粒机、胶乳凝固槽、洗涤机",
                                        "taxName": "橡胶加工设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090208020000000000",
                                        "taxCodeTitle": "橡胶加工设备",
                                        "iTitle": "*橡胶加工设备*橡胶初加工机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2804",
                                        "linkid": "2801",
                                        "code": "109020803",
                                        "paCode": "1090208",
                                        "yn": "N",
                                        "title": "炼胶机械",
                                        "alias": "炼胶机械",
                                        "about": "指橡胶或塑料等用的一种加工机械设备；主要供塑炼或混炼胶料之用；常用的油开放式炼胶机和密闭式炼胶机等；包括翻新炼胶机械。不包括再生橡胶精炼机（详见109020809）。",
                                        "kws": "密闭式炼胶机、开放式炼胶机、翻斗式密炼机、橡胶捏炼机、炼塑机、炼胶机械",
                                        "taxName": "橡胶加工设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090208030000000000",
                                        "taxCodeTitle": "橡胶加工设备",
                                        "iTitle": "*橡胶加工设备*炼胶机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2805",
                                        "linkid": "2801",
                                        "code": "109020804",
                                        "paCode": "1090208",
                                        "yn": "N",
                                        "title": "橡胶挤出机",
                                        "alias": "橡胶挤出机",
                                        "about": "指热塑性塑料和橡胶主要加工成型的设备；将原料由挤出机的加料漏斗连续加入加热的料筒中，软化后借料筒内螺旋杆的作用，电机头口型挤出，经冷却定形，成为一定形状的连续制品，如管、棒、板等；包括橡胶胎面挤出机",
                                        "kws": "橡胶冷喂料挤出机、橡胶过滤挤出机、橡胶挤出机",
                                        "taxName": "橡胶加工设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090208040000000000",
                                        "taxCodeTitle": "橡胶加工设备",
                                        "iTitle": "*橡胶加工设备*橡胶挤出机",
                                        "children": []
                                    },
                                    {
                                        "id": "2806",
                                        "linkid": "2801",
                                        "code": "109020805",
                                        "paCode": "1090208",
                                        "yn": "N",
                                        "title": "橡胶压延机械",
                                        "alias": "橡胶压延机械",
                                        "about": "指将混炼胶（或塑料）进行压片或压型的一种机械设备；根据用途可分为下列主要类型：⑴压型压延机，用以将胶料压成一定厚度和一定断面形状；⑵万能压延机，能进行擦胶、贴胶和压片各项工作；⑶实验用压延机，供试验用",
                                        "kws": "二辊立式压延机、二辊卧式压延机、立式三辊压延机、四辊压延机、五辊压延机、橡胶压片机、橡胶压延机械",
                                        "taxName": "橡胶加工设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090208050000000000",
                                        "taxCodeTitle": "橡胶加工设备",
                                        "iTitle": "*橡胶加工设备*橡胶压延机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2807",
                                        "linkid": "2801",
                                        "code": "109020806",
                                        "paCode": "1090208",
                                        "yn": "N",
                                        "title": "橡胶注射机",
                                        "alias": "橡胶注射机",
                                        "about": "简称注射机，主要用于生产密封圈、防震垫、防尘罩、电器绝缘零件、瓶塞、鞋底、工矿雨鞋、吸尘软管、劳保手套以及热水袋和气门嘴胶垫等橡胶模型制品",
                                        "kws": "橡胶注射成型机、橡胶注射机",
                                        "taxName": "橡胶加工设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090208060000000000",
                                        "taxCodeTitle": "橡胶加工设备",
                                        "iTitle": "*橡胶加工设备*橡胶注射机",
                                        "children": []
                                    },
                                    {
                                        "id": "2808",
                                        "linkid": "2801",
                                        "code": "109020807",
                                        "paCode": "1090208",
                                        "yn": "N",
                                        "title": "橡胶成型压力机",
                                        "alias": "橡胶成型压力机",
                                        "about": "指将混炼胶（或塑料）进行压型的一种机械设备，包括充气轮胎模塑成型机、力车胎成型机、胶管成型机、橡胶带成组成型机、胶球成型机、其他橡胶成型压力机",
                                        "kws": "胎面压出联动装置、层贴法成型机、套筒法成型机、子午线轮胎成型机、轮胎装卸胶囊定型机、胎面压合机、充气轮胎模塑成型机、软边胎成型机、双鼓硬边自行车胎成型机、力车胎成型机、单面胶管成型机、双面胶管成型机、吸引胶管成型机、胶管无芯成型机、胶管成型机、运输带成型机、三角带挤压法组成型机、橡胶带成组成型机",
                                        "taxName": "橡胶加工设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090208070000000000",
                                        "taxCodeTitle": "橡胶加工设备",
                                        "iTitle": "*橡胶加工设备*橡胶成型压力机",
                                        "children": []
                                    },
                                    {
                                        "id": "2809",
                                        "linkid": "2801",
                                        "code": "109020808",
                                        "paCode": "1090208",
                                        "yn": "N",
                                        "title": "橡胶硫化设备",
                                        "alias": "橡胶硫化设备",
                                        "about": "在橡胶工业中，指生橡胶与硫磺和促进剂等在一定的温度和压力下作用而成熟橡胶的加工设备",
                                        "kws": "水压平板硫化机、油压平板硫化机、鼓式硫化机、气囊硫化机、隔膜硫化机、轮胎定型硫化机、翻胎硫化机、硫化装置、橡胶连续硫化生产线",
                                        "taxName": "橡胶加工设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090208080000000000",
                                        "taxCodeTitle": "橡胶加工设备",
                                        "iTitle": "*橡胶加工设备*橡胶硫化设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2810",
                                        "linkid": "2801",
                                        "code": "109020809",
                                        "paCode": "1090208",
                                        "yn": "N",
                                        "title": "再生橡胶设备",
                                        "alias": "再生橡胶设备",
                                        "about": "包括破胶机、橡胶精炼机、其他再生橡胶设备",
                                        "kws": "破胶机、橡胶精炼机、再生橡胶设备",
                                        "taxName": "橡胶加工设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090208090000000000",
                                        "taxCodeTitle": "橡胶加工设备",
                                        "iTitle": "*橡胶加工设备*再生橡胶设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2811",
                                        "linkid": "2801",
                                        "code": "109020810",
                                        "paCode": "1090208",
                                        "yn": "N",
                                        "title": "裁切橡胶专用机械",
                                        "alias": "裁切橡胶专用机械",
                                        "about": "包括胶丝切割机、单刀切胶机、橡胶定长裁断装置、内胎阀孔切割机、海绵滚切机、橡胶切条机、衬里片割机、其他裁切橡胶专用机械",
                                        "kws": "胶丝切割机、单刀切胶机、橡胶定长裁断装置、内胎阀孔切割机、海绵滚切机、橡胶切条机、衬里片割机、裁切橡胶专用机械",
                                        "taxName": "橡胶加工设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090208100000000000",
                                        "taxCodeTitle": "橡胶加工设备",
                                        "iTitle": "*橡胶加工设备*裁切橡胶专用机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2812",
                                        "linkid": "2801",
                                        "code": "109020811",
                                        "paCode": "1090208",
                                        "yn": "N",
                                        "title": "橡胶制品卷绕、包覆机械",
                                        "alias": "橡胶制品卷绕、包覆机械",
                                        "about": "指橡胶轮胎、管件卷绕、包覆机械",
                                        "kws": "缠绕机、橡胶制品包布机、垫布整理机、帘布裂布机、大胎层布贴合机、吸引胶管包胶机、胶球包皮机、橡胶制品卷绕机械、橡胶制品包覆机械",
                                        "taxName": "橡胶加工设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090208110000000000",
                                        "taxCodeTitle": "橡胶加工设备",
                                        "iTitle": "*橡胶加工设备*橡胶制品卷绕、包覆机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2813",
                                        "linkid": "2801",
                                        "code": "109020812",
                                        "paCode": "1090208",
                                        "yn": "N",
                                        "title": "橡胶干燥、去水、刺孔机械",
                                        "alias": "橡胶干燥、去水、刺孔机械",
                                        "about": "包括辊式干燥机、螺杆去水机、转筒式脱胶罐",
                                        "kws": "辊式干燥机、螺杆去水机、转筒式脱胶罐",
                                        "taxName": "橡胶加工设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090208120000000000",
                                        "taxCodeTitle": "橡胶加工设备",
                                        "iTitle": "*橡胶加工设备*橡胶干燥、去水、刺孔机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2814",
                                        "linkid": "2801",
                                        "code": "109020813",
                                        "paCode": "1090208",
                                        "yn": "N",
                                        "title": "橡胶制品加工机械",
                                        "alias": "橡胶制品加工机械",
                                        "about": "包括二爪加重式扩胎机、内胎接头机、轮胎胎胚刺孔机、胶管穿管机、吸引胶管解绳机、吸引胶管解水布机、其他橡胶制品加工机械",
                                        "kws": "二爪加重式扩胎机、内胎接头机、轮胎胎胚刺孔机、胶管穿管机、吸引胶管解绳机、吸引胶管解水布机、橡胶制品加工机械",
                                        "taxName": "橡胶加工设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090208130000000000",
                                        "taxCodeTitle": "橡胶加工设备",
                                        "iTitle": "*橡胶加工设备*橡胶制品加工机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2815",
                                        "linkid": "2801",
                                        "code": "109020814",
                                        "paCode": "1090208",
                                        "yn": "N",
                                        "title": "橡胶专用生产设备零件",
                                        "alias": "橡胶专用生产设备零件",
                                        "about": "包括炼胶辊、其他橡胶专用生产设备零件",
                                        "kws": "炼胶辊、橡胶专用生产设备零件",
                                        "taxName": "橡胶加工设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090208140000000000",
                                        "taxCodeTitle": "橡胶加工设备",
                                        "iTitle": "*橡胶加工设备*橡胶专用生产设备零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2816",
                                "linkid": "2740",
                                "code": "1090209",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "塑料加工专用设备",
                                "alias": "塑料加工专用设备",
                                "about": null,
                                "kws": null,
                                "taxName": "塑料加工设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090209000000000000",
                                "taxCodeTitle": "塑料加工设备",
                                "iTitle": "*塑料加工设备*塑料加工专用设备",
                                "children": [
                                    {
                                        "id": "2817",
                                        "linkid": "2816",
                                        "code": "109020901",
                                        "paCode": "1090209",
                                        "yn": "N",
                                        "title": "注塑机",
                                        "alias": "注塑机",
                                        "about": "不包括用于光盘的精密注塑机（详见109022301）。",
                                        "kws": "塑料注射成型机械、注塑机",
                                        "taxName": "塑料加工设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090209010000000000",
                                        "taxCodeTitle": "塑料加工设备",
                                        "iTitle": "*塑料加工设备*注塑机",
                                        "children": []
                                    },
                                    {
                                        "id": "2818",
                                        "linkid": "2816",
                                        "code": "109020902",
                                        "paCode": "1090209",
                                        "yn": "N",
                                        "title": "挤塑机",
                                        "alias": "挤塑机",
                                        "about": "包括单螺杆挤出机、双螺杆挤出机、组合式挤出机、双阶式挤出机、往复式挤出机、塑料造粒机、其他挤塑机",
                                        "kws": "单螺杆挤出机、双螺杆挤出机、组合式挤出机、双阶式挤出机、往复式挤出机、塑料造粒机、挤塑机",
                                        "taxName": "塑料加工设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090209020000000000",
                                        "taxCodeTitle": "塑料加工设备",
                                        "iTitle": "*塑料加工设备*挤塑机",
                                        "children": []
                                    },
                                    {
                                        "id": "2819",
                                        "linkid": "2816",
                                        "code": "109020903",
                                        "paCode": "1090209",
                                        "yn": "N",
                                        "title": "吹塑机",
                                        "alias": "吹塑机",
                                        "about": "包括塑料吹瓶机、自动模内贴标机、其他吹塑机",
                                        "kws": "塑料吹瓶机、自动模内贴标机",
                                        "taxName": "塑料加工设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090209030000000000",
                                        "taxCodeTitle": "塑料加工设备",
                                        "iTitle": "*塑料加工设备*吹塑机",
                                        "children": []
                                    },
                                    {
                                        "id": "2820",
                                        "linkid": "2816",
                                        "code": "109020904",
                                        "paCode": "1090209",
                                        "yn": "N",
                                        "title": "塑料成型机械",
                                        "alias": "塑料成型机械",
                                        "about": "包括塑料中空成型机、塑料压延成型机、压塑机、滚塑机、发泡成型机、真空模塑机、其他塑料成型机械",
                                        "kws": "塑料中空成型机、塑料压延成型机、压塑机、滚塑机、发泡成型机、真空模塑机、塑料成型机械",
                                        "taxName": "塑料加工设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090209040000000000",
                                        "taxCodeTitle": "塑料加工设备",
                                        "iTitle": "*塑料加工设备*塑料成型机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2821",
                                        "linkid": "2816",
                                        "code": "109020905",
                                        "paCode": "1090209",
                                        "yn": "N",
                                        "title": "塑料破碎、研磨、筛选、均化机械",
                                        "alias": "塑料破碎、研磨、筛选、均化机械",
                                        "about": "包括塑料破碎机、塑料研磨机、塑料搅拌机、塑料切粒机、其他塑料筛选、均化机械",
                                        "kws": "塑料破碎机、塑料研磨机、塑料搅拌机、塑料切粒机、塑料筛选、均化机械",
                                        "taxName": "塑料加工设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090209050000000000",
                                        "taxCodeTitle": "塑料加工设备",
                                        "iTitle": "*塑料加工设备*塑料破碎、研磨、筛选、均化机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2822",
                                        "linkid": "2816",
                                        "code": "109020906",
                                        "paCode": "1090209",
                                        "yn": "N",
                                        "title": "塑料二次加工机械",
                                        "alias": "塑料二次加工机械",
                                        "about": "包括塑料热成型机、塑料真空蒸镀机、塑料异型材拼装机械、其他塑料二次加工机械",
                                        "kws": "塑料热成型机、塑料真空蒸镀机、塑料异型材拼装机械、塑料二次加工机械",
                                        "taxName": "塑料加工设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090209060000000000",
                                        "taxCodeTitle": "塑料加工设备",
                                        "iTitle": "*塑料加工设备*塑料二次加工机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2823",
                                        "linkid": "2816",
                                        "code": "109020907",
                                        "paCode": "1090209",
                                        "yn": "N",
                                        "title": "塑料加工辅助机械或装置",
                                        "alias": "塑料加工辅助机械或装置",
                                        "about": "包括自动计量供料装置、塑料边角料自动回收装置、注塑制品自动取出装置、注塑模具冷却机等",
                                        "kws": "自动计量供料装置、塑料边角料自动回收装置、注塑制品自动取出装置、注塑模具冷却机",
                                        "taxName": "塑料加工设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090209070000000000",
                                        "taxCodeTitle": "塑料加工设备",
                                        "iTitle": "*塑料加工设备*塑料加工辅助机械或装置",
                                        "children": []
                                    },
                                    {
                                        "id": "2824",
                                        "linkid": "2816",
                                        "code": "109020908",
                                        "paCode": "1090209",
                                        "yn": "N",
                                        "title": "连续混炼挤出造粒机",
                                        "alias": "连续混炼挤出造粒机",
                                        "about": null,
                                        "kws": "连续混炼挤出造粒机",
                                        "taxName": "塑料加工设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090209080000000000",
                                        "taxCodeTitle": "塑料加工设备",
                                        "iTitle": "*塑料加工设备*连续混炼挤出造粒机",
                                        "children": []
                                    },
                                    {
                                        "id": "2825",
                                        "linkid": "2816",
                                        "code": "109020909",
                                        "paCode": "1090209",
                                        "yn": "N",
                                        "title": "塑料加工专用设备零件",
                                        "alias": "塑料加工专用设备零件",
                                        "about": null,
                                        "kws": "塑料加工专用设备零件",
                                        "taxName": "塑料加工设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090209090000000000",
                                        "taxCodeTitle": "塑料加工设备",
                                        "iTitle": "*塑料加工设备*塑料加工专用设备零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2826",
                                "linkid": "2740",
                                "code": "1090210",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "木材加工、处理机械",
                                "alias": "木材加工、处理机械",
                                "about": null,
                                "kws": null,
                                "taxName": "木材加工机械",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090210000000000000",
                                "taxCodeTitle": "木材加工机械",
                                "iTitle": "*木材加工机械*木材加工、处理机械",
                                "children": [
                                    {
                                        "id": "2827",
                                        "linkid": "2826",
                                        "code": "109021001",
                                        "paCode": "1090210",
                                        "yn": "N",
                                        "title": "木工机床",
                                        "alias": "木工机床",
                                        "about": "包括木材、软木加工机床",
                                        "kws": "木工锯床、木工刨床、木工铣床、木工砂光机、木工抛光机、木工钻孔机床、凿榫机、凿制榫机、木工车床、木工切片、刮削机床、木工弯曲机床、木工粘合机床、木材挤压装配机械、木工组合加工机床、封边机、木工机床",
                                        "taxName": "木材加工机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090210010000000000",
                                        "taxCodeTitle": "木材加工机械",
                                        "iTitle": "*木材加工机械*木工机床",
                                        "children": []
                                    },
                                    {
                                        "id": "2828",
                                        "linkid": "2826",
                                        "code": "109021002",
                                        "paCode": "1090210",
                                        "yn": "N",
                                        "title": "木质板材挤压加工机械",
                                        "alias": "木质板材挤压加工机械",
                                        "about": "包括粘聚木纤维、木片、锯屑或软木粉用的挤压机、特种压力机等木材处理机",
                                        "kws": "纤维板挤压机、刨花板预热压机、刨花板生产线、中密度板专用生产线、胶合板专用生产线、木材硬化压力机、浸渍木材压力机、木质板材挤压加工机械",
                                        "taxName": "木材加工机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090210020000000000",
                                        "taxCodeTitle": "木材加工机械",
                                        "iTitle": "*木材加工机械*木质板材挤压加工机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2829",
                                        "linkid": "2826",
                                        "code": "109021003",
                                        "paCode": "1090210",
                                        "yn": "N",
                                        "title": "木材处理及制品加工机械",
                                        "alias": "木材处理及制品加工机械",
                                        "about": "包括木材干燥机、木材剥皮去节机、喷水树皮剥离机、软木处理机、木粉磨制机械、制桶机、其他木材处理及制品加工机械",
                                        "kws": "木材干燥机、木材剥皮去节机、喷水树皮剥离机、软木处理机、木粉磨制机械、制桶机、木材处理、木材制品加工机械",
                                        "taxName": "木材加工机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090210030000000000",
                                        "taxCodeTitle": "木材加工机械",
                                        "iTitle": "*木材加工机械*木材处理及制品加工机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2830",
                                        "linkid": "2826",
                                        "code": "109021004",
                                        "paCode": "1090210",
                                        "yn": "N",
                                        "title": "木材加工机械用零件、附件",
                                        "alias": "木材加工机械用零件、附件",
                                        "about": "包括木材加工机床、木材专用机械用零件、附件",
                                        "kws": "木材加工机床、木材专用机械用零件附件",
                                        "taxName": "木材加工机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090210040000000000",
                                        "taxCodeTitle": "木材加工机械",
                                        "iTitle": "*木材加工机械*木材加工机械用零件、附件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2831",
                                "linkid": "2740",
                                "code": "1090211",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "模具",
                                "alias": "模具",
                                "about": null,
                                "kws": null,
                                "taxName": "模具",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090211000000000000",
                                "taxCodeTitle": "模具",
                                "iTitle": "*模具*模具",
                                "children": [
                                    {
                                        "id": "2832",
                                        "linkid": "2831",
                                        "code": "109021101",
                                        "paCode": "1090211",
                                        "yn": "N",
                                        "title": "金属铸造用型箱、型模底板",
                                        "alias": "金属铸造用型箱、型模底板",
                                        "about": "包括金属铸造用型箱、型模底板、阳模等",
                                        "kws": "金属铸造用型箱、型模底板、阳模",
                                        "taxName": "模具",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090211010000000000",
                                        "taxCodeTitle": "模具",
                                        "iTitle": "*模具*金属铸造用型箱、型模底板",
                                        "children": []
                                    },
                                    {
                                        "id": "2833",
                                        "linkid": "2831",
                                        "code": "109021102",
                                        "paCode": "1090211",
                                        "yn": "N",
                                        "title": "金属、硬质合金用模具",
                                        "alias": "金属、硬质合金用模具",
                                        "about": "包括金属冲压模具、金属铸造模具、金属锻造模具、金属粉末冶金模具、丝模具、其他金属和硬质合金用模具",
                                        "kws": "金属冲压模具、金属铸造模具、金属锻造模具、金属粉末冶金模具、丝模具、金属用模具、硬质合金用模具",
                                        "taxName": "模具",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090211020000000000",
                                        "taxCodeTitle": "模具",
                                        "iTitle": "*模具*金属、硬质合金用模具",
                                        "children": []
                                    },
                                    {
                                        "id": "2834",
                                        "linkid": "2831",
                                        "code": "109021103",
                                        "paCode": "1090211",
                                        "yn": "N",
                                        "title": "玻璃制品用模具",
                                        "alias": "玻璃制品用模具",
                                        "about": "包括玻璃建筑材料用模具、制瓶模、中空玻璃器皿模具、璃绝缘子模具、玻璃加工成形模具、其他玻璃制品用模具",
                                        "kws": "玻璃建筑材料用模具、制瓶模、中空玻璃器皿模具、璃绝缘子模具、玻璃加工成形模具、玻璃制品用模具",
                                        "taxName": "模具",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090211030000000000",
                                        "taxCodeTitle": "模具",
                                        "iTitle": "*模具*玻璃制品用模具",
                                        "children": []
                                    },
                                    {
                                        "id": "2835",
                                        "linkid": "2831",
                                        "code": "109021104",
                                        "paCode": "1090211",
                                        "yn": "N",
                                        "title": "矿物材料用模具",
                                        "alias": "矿物材料用模具",
                                        "about": "包括陶瓷制品用模具、水泥制品用模具、砂轮成型模具、石膏制品用模具、灰泥制品用模具、其他矿物材料用模具",
                                        "kws": "陶瓷制品用模具、水泥制品用模具、砂轮成型模具、石膏制品用模具、灰泥制品用模具、矿物材料用模具",
                                        "taxName": "模具",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090211040000000000",
                                        "taxCodeTitle": "模具",
                                        "iTitle": "*模具*矿物材料用模具",
                                        "children": []
                                    },
                                    {
                                        "id": "2836",
                                        "linkid": "2831",
                                        "code": "109021105",
                                        "paCode": "1090211",
                                        "yn": "N",
                                        "title": "塑料用模具",
                                        "alias": "塑料用模具",
                                        "about": "包括塑料注射模、塑料压注模、塑料压缩模、塑料挤出模、塑封模、其他塑料用模具",
                                        "kws": "塑料注射模、塑料压注模、塑料压缩模、塑料挤出模、塑封模、塑料用模具",
                                        "taxName": "模具",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090211050000000000",
                                        "taxCodeTitle": "模具",
                                        "iTitle": "*模具*塑料用模具",
                                        "children": []
                                    },
                                    {
                                        "id": "2837",
                                        "linkid": "2831",
                                        "code": "109021106",
                                        "paCode": "1090211",
                                        "yn": "N",
                                        "title": "橡胶用模具",
                                        "alias": "橡胶用模具",
                                        "about": "包括橡胶注射模、橡胶压胶模、硫化轮胎用囊式模具、其他橡胶用模具",
                                        "kws": "橡胶注射模、橡胶压胶模、硫化轮胎用囊式模具、橡胶用模具",
                                        "taxName": "模具",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090211060000000000",
                                        "taxCodeTitle": "模具",
                                        "iTitle": "*模具*橡胶用模具",
                                        "children": []
                                    },
                                    {
                                        "id": "2838",
                                        "linkid": "2831",
                                        "code": "109021107",
                                        "paCode": "1090211",
                                        "yn": "N",
                                        "title": "模架、模具标准件",
                                        "alias": "模架、模具标准件",
                                        "about": "指根据标准化的技术标准生产的模架、模具成型产品",
                                        "kws": "模架标准件、模具标准件",
                                        "taxName": "模具",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090211070000000000",
                                        "taxCodeTitle": "模具",
                                        "iTitle": "*模具*模架、模具标准件",
                                        "children": []
                                    },
                                    {
                                        "id": "2839",
                                        "linkid": "2831",
                                        "code": "109021199",
                                        "paCode": "1090211",
                                        "yn": "N",
                                        "title": "其他模具",
                                        "alias": "其他模具",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "模具",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090211990000000000",
                                        "taxCodeTitle": "模具",
                                        "iTitle": "*模具*其他模具",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2840",
                                "linkid": "2740",
                                "code": "1090212",
                                "paCode": "10902",
                                "yn": "N",
                                "title": "硬质材料加工机床及其零件",
                                "alias": "硬质材料加工机床及其零件",
                                "about": "包括骨、硬橡胶、硬塑料等硬质材料加工机床",
                                "kws": "硬质材料组合加工机床零件、硬质材料加工机床零件、硬质材料加工机床用零件、硬质材料组合加工机床附件、硬质材料加工机床附件、硬质材料加工机床用附件",
                                "taxName": "专用设备",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1090212000000000000",
                                "taxCodeTitle": "专用设备",
                                "iTitle": "*专用设备*硬质材料加工机床及其零件",
                                "children": []
                            },
                            {
                                "id": "2841",
                                "linkid": "2740",
                                "code": "1090213",
                                "paCode": "10902",
                                "yn": "N",
                                "title": "非金属相关成型、加工机械",
                                "alias": "非金属相关成型、加工机械",
                                "about": "包括非金属矿物材料成型机械，通用加料、分配装置，其他非金属相关成型、加工机械",
                                "kws": "砂轮成型机、石墨电极磨制用机械、非金属矿物材料成型机械、非专用容量分配装置、电动震抖装置、电磁振动机、装有机械装置容器、搅混机械、轧碎机械、研磨机械、筛选机械、均化机械、乳化机械、铆钉铆接机械、通用加料装置、通用分配装置",
                                "taxName": "专用设备",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1090213000000000000",
                                "taxCodeTitle": "专用设备",
                                "iTitle": "*专用设备*非金属相关成型、加工机械",
                                "children": []
                            },
                            {
                                "id": "2842",
                                "linkid": "2740",
                                "code": "1090214",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "食品制造机械",
                                "alias": "食品制造机械",
                                "about": "包括糕点、米面食品、糖果、可可及巧克力、调味食品类加工专用机械",
                                "kws": null,
                                "taxName": "食品制造机械",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090214000000000000",
                                "taxCodeTitle": "食品制造机械",
                                "iTitle": "*食品制造机械*食品制造机械",
                                "children": [
                                    {
                                        "id": "2843",
                                        "linkid": "2842",
                                        "code": "109021401",
                                        "paCode": "1090214",
                                        "yn": "N",
                                        "title": "烹煮、调制、腌制食品设备",
                                        "alias": "烹煮、调制、腌制食品设备",
                                        "about": "包括烘炒设备、烹煮器、烹炸设备、食品工业用压热器、食品工业用冷却器、巴氏杀菌器以及其他烹煮、调制、腌制食品设备",
                                        "kws": "烘炒设备、烹煮器、烹炸设备、食品工业用压热器、食品工业用冷却器、巴氏杀菌器、烹煮食品设备、调制食品设备、腌制食品设备",
                                        "taxName": "食品制造机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090214010000000000",
                                        "taxCodeTitle": "食品制造机械",
                                        "iTitle": "*食品制造机械*烹煮、调制、腌制食品设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2844",
                                        "linkid": "2842",
                                        "code": "109021402",
                                        "paCode": "1090214",
                                        "yn": "N",
                                        "title": "食品用烤炉及烘箱",
                                        "alias": "食品用烤炉及烘箱",
                                        "about": "包括糕点、饼干、面包房用烤炉及烘箱",
                                        "kws": "非电力食品用烤炉、非电力食品用烘箱、电力食品烘箱",
                                        "taxName": "食品制造机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090214020000000000",
                                        "taxCodeTitle": "食品制造机械",
                                        "iTitle": "*食品制造机械*食品用烤炉及烘箱",
                                        "children": []
                                    },
                                    {
                                        "id": "2845",
                                        "linkid": "2842",
                                        "code": "109021403",
                                        "paCode": "1090214",
                                        "yn": "N",
                                        "title": "糕点、米面食品类加工专用机械",
                                        "alias": "糕点、米面食品类加工专用机械",
                                        "about": "包括用于制造面包、饼干、糕点、通心粉、面条或类似产品生产机械",
                                        "kws": "和面机、调粉机、发酵机、醒发机、熟化机、轧片机、切面机、切块机、分面机、揉圆机、连续挤出机、填馅机械、糕点装模机、糕点模制机、糕点滚压机、糖果滚压机、饼干滚压机、饼干生产线、挂面机、方便面生产线、谷物膨化机、食品膨化机",
                                        "taxName": "食品制造机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090214030000000000",
                                        "taxCodeTitle": "食品制造机械",
                                        "iTitle": "*食品制造机械*糕点、米面食品类加工专用机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2846",
                                        "linkid": "2842",
                                        "code": "109021404",
                                        "paCode": "1090214",
                                        "yn": "N",
                                        "title": "糖果生产专用机械",
                                        "alias": "糖果生产专用机械",
                                        "about": "包括糖霜用碾磨、捣碎机，糖果拌和机，糖果拉条机，糖衣锅，糖果模制、切制或成形机，糖果滚压机械，其他糖果生产专用机械",
                                        "kws": "糖霜用碾磨、捣碎机、糖果拌和机、糖果拉条机、糖衣锅、糖果滚压机械、糖果生产专用机械",
                                        "taxName": "食品制造机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090214040000000000",
                                        "taxCodeTitle": "食品制造机械",
                                        "iTitle": "*食品制造机械*糖果生产专用机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2847",
                                        "linkid": "2842",
                                        "code": "109021405",
                                        "paCode": "1090214",
                                        "yn": "N",
                                        "title": "可可及巧克力生产专用机械",
                                        "alias": "可可及巧克力生产专用机械",
                                        "about": "包括咖啡豆去壳去皮机、可可豆脱壳去芽机械、可可豆碾粉机械、可可混合机、可可揉捏机及碾磨机、提取可可脂压榨机、可可粉用生产机械、可可脂可可粉糖等混合机械、巧克力均化处理机械、巧克力机压块及模制机、其他可可及巧克力生产专用机械",
                                        "kws": "咖啡豆去壳去皮机、可可豆脱壳去芽机械、可可豆碾粉机械、可可混合机、可可揉捏机、可可碾磨机、提取可可脂压榨机、可可粉用生产机械、可可脂可可粉糖等混合机械、巧克力均化处理机械、巧克力机压块机、巧克力模制机、可可生产专用机械、巧克力生产专用机械",
                                        "taxName": "食品制造机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090214050000000000",
                                        "taxCodeTitle": "食品制造机械",
                                        "iTitle": "*食品制造机械*可可及巧克力生产专用机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2848",
                                        "linkid": "2842",
                                        "code": "109021406",
                                        "paCode": "1090214",
                                        "yn": "N",
                                        "title": "调味食品加工机械",
                                        "alias": "调味食品加工机械",
                                        "about": "指将调味食品原材料加工成成品或半成品的机械设备",
                                        "kws": "调味食品加工机械",
                                        "taxName": "食品制造机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090214060000000000",
                                        "taxCodeTitle": "食品制造机械",
                                        "iTitle": "*食品制造机械*调味食品加工机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2849",
                                        "linkid": "2842",
                                        "code": "109021499",
                                        "paCode": "1090214",
                                        "yn": "N",
                                        "title": "其他食品制造机械",
                                        "alias": "其他食品制造机械",
                                        "about": null,
                                        "kws": "罐头制造机械",
                                        "taxName": "食品制造机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090214990000000000",
                                        "taxCodeTitle": "食品制造机械",
                                        "iTitle": "*食品制造机械*其他食品制造机械",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2850",
                                "linkid": "2740",
                                "code": "1090215",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "乳品加工机械",
                                "alias": "乳品加工机械",
                                "about": null,
                                "kws": "乳品加工机械",
                                "taxName": "食品制造机械",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090215000000000000",
                                "taxCodeTitle": "食品制造机械",
                                "iTitle": "*食品制造机械*乳品加工机械",
                                "children": [
                                    {
                                        "id": "2851",
                                        "linkid": "2850",
                                        "code": "109021501",
                                        "paCode": "1090215",
                                        "yn": "N",
                                        "title": "乳品分离、搅拌加工机械",
                                        "alias": "乳品分离、搅拌加工机械",
                                        "about": "包括奶油分离器、打碎及均化机、搅乳机、黄油加工机、搅乳加工联合机、乳品模制机械、奶酪压制机、均质机、奶粉喷粉机械，分离、净化、调脂三用机，其他乳品分离、搅拌加工机械",
                                        "kws": "奶油分离器、打碎机、奶油均化机、搅乳机、黄油加工机、搅乳加工联合机、乳品模制机械、奶酪压制机、均质机、奶粉喷粉机械",
                                        "taxName": "食品制造机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090215010000000000",
                                        "taxCodeTitle": "食品制造机械",
                                        "iTitle": "*食品制造机械*乳品分离、搅拌加工机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2852",
                                        "linkid": "2850",
                                        "code": "109021502",
                                        "paCode": "1090215",
                                        "yn": "N",
                                        "title": "乳品加热及冷却设备",
                                        "alias": "乳品加热及冷却设备",
                                        "about": "包括牛奶巴氏灭菌设备、牛奶浓缩设备、牛奶冷却设备、奶酪加工及熟化桶、多效蒸发器、乳品热交换器、人造黄油固化槽、其他乳品加热及冷却设备",
                                        "kws": "牛奶巴氏灭菌设备、牛奶浓缩设备、牛奶冷却设备、奶酪加工桶、奶酪熟化桶、多效蒸发器、乳品热交换器、人造黄油固化槽、乳品加热设备、乳品冷却设备",
                                        "taxName": "食品制造机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090215020000000000",
                                        "taxCodeTitle": "食品制造机械",
                                        "iTitle": "*食品制造机械*乳品加热及冷却设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2853",
                                        "linkid": "2850",
                                        "code": "109021599",
                                        "paCode": "1090215",
                                        "yn": "N",
                                        "title": "其他乳品加工机械",
                                        "alias": "其他乳品加工机械",
                                        "about": null,
                                        "kws": "发酵罐、结晶缸、脱臭机",
                                        "taxName": "食品制造机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090215990000000000",
                                        "taxCodeTitle": "食品制造机械",
                                        "iTitle": "*食品制造机械*其他乳品加工机械",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2854",
                                "linkid": "2740",
                                "code": "1090216",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "酒及饮料加工机械",
                                "alias": "酒及饮料加工机械",
                                "about": null,
                                "kws": null,
                                "taxName": "食品制造机械",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090216000000000000",
                                "taxCodeTitle": "食品制造机械",
                                "iTitle": "*食品制造机械*酒及饮料加工机械",
                                "children": [
                                    {
                                        "id": "2855",
                                        "linkid": "2854",
                                        "code": "109021601",
                                        "paCode": "1090216",
                                        "yn": "N",
                                        "title": "原料压榨、轧碎机械",
                                        "alias": "原料压榨、轧碎机械",
                                        "about": "指制酒、果汁原料的压榨机、轧碎机械",
                                        "kws": "水果轧碎机、水果破碎机、水果碎裂机、原料压榨机械、原料轧碎机械",
                                        "taxName": "食品制造机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090216010000000000",
                                        "taxCodeTitle": "食品制造机械",
                                        "iTitle": "*食品制造机械*原料压榨、轧碎机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2856",
                                        "linkid": "2854",
                                        "code": "109021602",
                                        "paCode": "1090216",
                                        "yn": "N",
                                        "title": "酿酒设备",
                                        "alias": "酿酒设备",
                                        "about": "包括酿酒用催芽机、麦芽压榨机、麦芽浆桶、泄料桶、其他酿酒设备",
                                        "kws": "酿酒用催芽机、麦芽压榨机、麦芽浆桶、泄料桶、酿酒设备",
                                        "taxName": "食品制造机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090216020000000000",
                                        "taxCodeTitle": "食品制造机械",
                                        "iTitle": "*食品制造机械*酿酒设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2857",
                                        "linkid": "2854",
                                        "code": "109021603",
                                        "paCode": "1090216",
                                        "yn": "N",
                                        "title": "制酒、饮料加热及冷却设备",
                                        "alias": "制酒、饮料加热及冷却设备",
                                        "about": "指用以对制酒、果汁饮料材料进行加热、煮沸、烹煮、浓缩、蒸发、气化、冷却等简单处理的通用设备",
                                        "kws": "果汁浓缩设备、酒浓缩设备、果汁冷却器、酒冷却器、浸渍容器、捣碎槽、啤酒花煎熬容器、啤酒巴氏杀菌器、制酒加热设备、制酒冷却设备、饮料加热设备、饮料冷却设备",
                                        "taxName": "食品制造机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090216030000000000",
                                        "taxCodeTitle": "食品制造机械",
                                        "iTitle": "*食品制造机械*制酒、饮料加热及冷却设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2858",
                                        "linkid": "2854",
                                        "code": "109021604",
                                        "paCode": "1090216",
                                        "yn": "N",
                                        "title": "醋化机械设备（制醋用）",
                                        "alias": "醋化机械设备（制醋用）",
                                        "about": null,
                                        "kws": "醋化机械设备",
                                        "taxName": "食品制造机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090216040000000000",
                                        "taxCodeTitle": "食品制造机械",
                                        "iTitle": "*食品制造机械*醋化机械设备（制醋用）",
                                        "children": []
                                    },
                                    {
                                        "id": "2859",
                                        "linkid": "2854",
                                        "code": "109021699",
                                        "paCode": "1090216",
                                        "yn": "N",
                                        "title": "其他酒及饮料加工机械",
                                        "alias": "其他酒及饮料加工机械",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "食品制造机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090216990000000000",
                                        "taxCodeTitle": "食品制造机械",
                                        "iTitle": "*食品制造机械*其他酒及饮料加工机械",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2860",
                                "linkid": "2740",
                                "code": "1090217",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "烟草、盐加工机械",
                                "alias": "烟草、盐加工机械",
                                "about": null,
                                "kws": null,
                                "taxName": "烟草及盐加工机械",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090217000000000000",
                                "taxCodeTitle": "烟草及盐加工机械",
                                "iTitle": "*烟草及盐加工机械*烟草、盐加工机械",
                                "children": [
                                    {
                                        "id": "2861",
                                        "linkid": "2860",
                                        "code": "109021701",
                                        "paCode": "1090217",
                                        "yn": "N",
                                        "title": "烟草加工机械",
                                        "alias": "烟草加工机械",
                                        "about": "包括打叶复烤生产线、烟叶制丝生产线、烟用打叶复烤生产线、烟叶制丝生产线、烟用加温加湿机械、烟用解把机械、烟用除杂筛分机械、烟用叶梗分离机械、烟用烘烤机械、烟用预压打包机械、烟用开（拆）包机械、烟用叶片分切机械、烟用切丝机械、烟用烘丝机械、烟用冷却机械、烟用香精香料调配及加料加香机械、烟用压梗机械、烟丝膨胀机械、烟用输送机械、烟用储存机械、再造烟叶机械、烟用卷接机械、烟用包装机械、烟用滤棒成型机械、烟用装封箱机械、废烟支烟丝回收机械、其他烟草加工机械",
                                        "kws": "打叶复烤生产线、烟用打叶复烤生产线、烟叶制丝生产线、烟用加温加湿机械、烟用解把机械、烟用除杂筛分机械、烟用叶梗分离机械、烟用烘烤机械、烟用预压打包机械、烟用开拆包机械、烟用叶片分切机械、烟用切丝机械、烟用烘丝机械、烟用冷却机械、烟用香精香料调配机械、烟用香精香料加料加香机械、烟用压梗机械、烟丝膨胀机械、烟用输送机械、烟用储存机械、再造烟叶机械、烟用卷接机械、烟用包装机械、烟用滤棒成型机械、烟用装封箱机械、废烟支烟丝回收机械、烟草加工机械",
                                        "taxName": "烟草及盐加工机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090217010000000000",
                                        "taxCodeTitle": "烟草及盐加工机械",
                                        "iTitle": "*烟草及盐加工机械*烟草加工机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2862",
                                        "linkid": "2860",
                                        "code": "109021702",
                                        "paCode": "1090217",
                                        "yn": "N",
                                        "title": "采盐及盐加工机械",
                                        "alias": "采盐及盐加工机械",
                                        "about": "包括采盐机械、盐加工机械",
                                        "kws": "采盐机械、盐加工机械",
                                        "taxName": "烟草及盐加工机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090217020000000000",
                                        "taxCodeTitle": "烟草及盐加工机械",
                                        "iTitle": "*烟草及盐加工机械*采盐及盐加工机械",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2863",
                                "linkid": "2740",
                                "code": "1090218",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "农产品加工专用设备",
                                "alias": "农产品加工专用设备",
                                "about": null,
                                "kws": null,
                                "taxName": "农产品加工设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090218000000000000",
                                "taxCodeTitle": "农产品加工设备",
                                "iTitle": "*农产品加工设备*农产品加工专用设备",
                                "children": [
                                    {
                                        "id": "2864",
                                        "linkid": "2863",
                                        "code": "109021801",
                                        "paCode": "1090218",
                                        "yn": "N",
                                        "title": "制糖机械",
                                        "alias": "制糖机械",
                                        "about": "包括甘蔗榨汁机械、甜菜榨糖机械、蔗糖加工机械、制糖用加热及冷却机械、提取糖或炼糖用机械、其他制糖机械",
                                        "kws": "切蔗机、甘蔗纤维分离机、甘蔗撕裂机、甘蔗轧碎机、甘蔗压榨机、甘蔗榨汁机械、制糖菜冲洗机、甜菜抱丝机、甜菜浸出器、浸出汁除渣器、石灰消和机、制糖泥汁罐、甜菜榨糖蒸发罐、甜菜榨糖结晶罐、糖糊混合机、制糖搅拌机、制糖干燥机、制糖中和器、制糖硫熏器、制糖沉淀器、制糖抽汁罐、蔗糖蒸发罐、蔗糖结晶罐、助晶罐、制糖输送机、制糖卸料离心机、制糖提净容器、糖汁浓缩设备、制糖真空煮沸锅、制糖碳化槽、制糖亚硫酸化槽、制糖精炼桶、制糖用加热机械、制糖用冷却机械",
                                        "taxName": "农产品加工设备",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "1090218010000000000",
                                        "taxCodeTitle": "农产品加工设备",
                                        "iTitle": "*农产品加工设备*制糖机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2865",
                                        "linkid": "2863",
                                        "code": "109021802",
                                        "paCode": "1090218",
                                        "yn": "N",
                                        "title": "屠宰及肉制品加工机械",
                                        "alias": "屠宰及肉制品加工机械",
                                        "about": "包括屠宰分割设备、肉制品加工机械、其他屠宰及肉制品加工机械",
                                        "kws": "电击刀、放血刀、刮毛机、拔毛机、扯皮机、切肉机、剁肉机、锯骨机、砍骨机、骨肉分离机、打肉机、剥胗肝机、挖肺机、洗牛肚机、吹粪机、屠宰分割设备、绞肉机、切粒机、内脏清洗机、灌肠机、斩拌机、肉模压机、脂肪模压机、腌肉机、骨泥加工机、肉制品加工机械",
                                        "taxName": "农产品加工设备",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "1090218020000000000",
                                        "taxCodeTitle": "农产品加工设备",
                                        "iTitle": "*农产品加工设备*屠宰及肉制品加工机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2866",
                                        "linkid": "2863",
                                        "code": "109021803",
                                        "paCode": "1090218",
                                        "yn": "N",
                                        "title": "油脂加工机械",
                                        "alias": "油脂加工机械",
                                        "about": "指动植物油脂榨油提取加工机械",
                                        "kws": "预处理机械、去壳机、油料轧坯机、榨油成套设备、麻油加工成套设备、榨油用磨粉机、榨油专用破碎机、预榨机、榨油机、蒸脱机、蒸炒锅、加热罐、轧粕机、油脂浸出设备、振动流化床干燥机、板框式毛油过滤机、油脂精炼设备、脱臭罐、脱色罐、脱皂机比配混合机、净化油槽、油脂加工机械",
                                        "taxName": "农产品加工设备",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "1090218030000000000",
                                        "taxCodeTitle": "农产品加工设备",
                                        "iTitle": "*农产品加工设备*油脂加工机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2867",
                                        "linkid": "2863",
                                        "code": "109021804",
                                        "paCode": "1090218",
                                        "yn": "N",
                                        "title": "水果、坚果或蔬菜加工机械",
                                        "alias": "水果、坚果或蔬菜加工机械",
                                        "about": "包括蔬菜脱水机械、水果去皮机、去荚机械、去梗机械、水果磨切机械、切菜机、切丝机、切丁机、切片机、酱菜切口机、水浴灭菌机、蔬菜速冻机、水果籽去核机、蔬菜去籽去核机、软化机、水果破碎机、水果榨汁机、蔬菜榨汁机、果汁浓缩机、蔬菜腌制机械、果酱加工机械、调味酱加工机械、番茄酱加工机械，本类不含家用食品加工电动器具，详见109041705。",
                                        "kws": "蔬菜脱水机械、水果去皮机、去荚机械、去梗机械、水果磨切机械、切菜机、切丝机、切丁机、切片机、酱菜切口机、水浴灭菌机、蔬菜速冻机、水果籽去核机、蔬菜去籽去核机、软化机、水果破碎机、水果榨汁机、蔬菜榨汁机、果汁浓缩机、蔬菜腌制机械、果酱加工机械、调味酱加工机械、番茄酱加工机械",
                                        "taxName": "农产品加工设备",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "1090218040000000000",
                                        "taxCodeTitle": "农产品加工设备",
                                        "iTitle": "*农产品加工设备*水果、坚果或蔬菜加工机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2868",
                                        "linkid": "2863",
                                        "code": "109021805",
                                        "paCode": "1090218",
                                        "yn": "N",
                                        "title": "薯类加工机械",
                                        "alias": "薯类加工机械",
                                        "about": "包括薯类切片切丝机、薯类磨浆机、薯类搅糊机等",
                                        "kws": "薯类切片切丝机、薯类磨浆机、薯类搅糊机",
                                        "taxName": "农产品加工设备",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "1090218050000000000",
                                        "taxCodeTitle": "农产品加工设备",
                                        "iTitle": "*农产品加工设备*薯类加工机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2869",
                                        "linkid": "2863",
                                        "code": "109021806",
                                        "paCode": "1090218",
                                        "yn": "N",
                                        "title": "食用菌生产机械",
                                        "alias": "食用菌生产机械",
                                        "about": "包括菌类装袋机、木耳袋装粉机、木耳栽种机、木耳压块机等",
                                        "kws": "菌类装袋机、木耳袋装粉机、木耳栽种机、木耳压块机",
                                        "taxName": "农产品加工设备",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "1090218060000000000",
                                        "taxCodeTitle": "农产品加工设备",
                                        "iTitle": "*农产品加工设备*食用菌生产机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2870",
                                        "linkid": "2863",
                                        "code": "109021807",
                                        "paCode": "1090218",
                                        "yn": "N",
                                        "title": "养蚕机械",
                                        "alias": "养蚕机械",
                                        "about": "包括切桑叶机、蚕种催青机、加热补湿器、蚕种浸酸架、养脱蚕用水机、蚕茧收烘处理器具等",
                                        "kws": "切桑叶机、蚕种催青机、加热补湿器、蚕种浸酸架、养脱蚕用水机、蚕茧收烘处理器具",
                                        "taxName": "农产品加工设备",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "1090218070000000000",
                                        "taxCodeTitle": "农产品加工设备",
                                        "iTitle": "*农产品加工设备*养蚕机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2871",
                                        "linkid": "2863",
                                        "code": "109021808",
                                        "paCode": "1090218",
                                        "yn": "N",
                                        "title": "淀粉加工机械",
                                        "alias": "淀粉加工机械",
                                        "about": "指生产淀粉的机械设备及其专门配套设备",
                                        "kws": "淀粉去杂机、清洗机、玉米籽粒浸泡罐、籽粒破碎机、液浆泵、冲击磨、锉磨机、细磨机、筛分机、离心筛、旋转振动筛、曲筛、淀粉分离机、螺旋沉降分离机、淀粉加工用卧式刮刀卸料离心机、浓缩分离机旋液分离器、粗渣脱水螺旋挤压机、胚芽脱水螺旋挤压机、胚芽旋流器、真空脱水机、淀粉烘干机、螺旋进粉器、悬浮机、真空过滤机、淀粉加工压滤机、浸出液水分蒸发器、糖化罐、连续糖化器、油脂分离器、滤布清洗机、淀粉加工过滤机、淀粉加工蒸发器、管罩式热交换器、扑集器、气压冷凝器、淀粉加工冷却器、粉丝机、粉条机、制粉机、粉丝烘干机",
                                        "taxName": "农产品加工设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090218080000000000",
                                        "taxCodeTitle": "农产品加工设备",
                                        "iTitle": "*农产品加工设备*淀粉加工机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2872",
                                        "linkid": "2863",
                                        "code": "109021809",
                                        "paCode": "1090218",
                                        "yn": "N",
                                        "title": "水产品加工机械",
                                        "alias": "水产品加工机械",
                                        "about": "包括鱼类处理加工机械、虾类处理加工机械、贝类加工机械、贝类加工机械、藻类和海带加工机械、水产熟制品加工机械、其他水产品加工机械",
                                        "kws": "洗鱼机、鱼品分级机、自动投鱼机、刮鳞机、剥皮机、去内脏机械、去鱼头机械、鱼段机、鱼片机、鱼肉采集机、鱼肉精滤机、鱼肉调质机、鱼糜成形机、鱼类处理加工机械、虾仁机、虾仁清理机、摘虾头机、虾仁脱壳机、虾类处理加工机械、贝壳脱壳机、贝类清洗机、贝类加工机械、紫菜切洗机、紫菜制饼机、紫菜脱水机、藻类加工机械、海带加工机械、碎鱼机械、预煮机、鱼粉磨制机、榨饼松散机、鱼粉干燥机械、鱼油分离机械、水产熟制品加工机械",
                                        "taxName": "农产品加工设备",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "1090218090000000000",
                                        "taxCodeTitle": "农产品加工设备",
                                        "iTitle": "*农产品加工设备*水产品加工机械",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2873",
                                "linkid": "2740",
                                "code": "1090219",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "饲料生产专用设备",
                                "alias": "饲料生产专用设备",
                                "about": "包括饲料粉碎机(饲料专用设备)，配制、加工饲料用机械，其他饲料生产专用设备",
                                "kws": null,
                                "taxName": "饲料生产设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090219000000000000",
                                "taxCodeTitle": "饲料生产设备",
                                "iTitle": "*饲料生产设备*饲料生产专用设备",
                                "children": [
                                    {
                                        "id": "2874",
                                        "linkid": "2873",
                                        "code": "109021901",
                                        "paCode": "1090219",
                                        "yn": "N",
                                        "title": "饲料粉碎机（饲料专用设备）",
                                        "alias": "饲料粉碎机（饲料专用设备）",
                                        "about": "包括饲料磨粉机、颗粒饲料微粉碎机、油饼轧碎机、青饲料切片机或压碎机、其他饲料粉碎机",
                                        "kws": "饲料磨粉机、颗粒饲料微粉碎机、油饼轧碎机、青饲料切片机、青饲料压碎机、饲料粉碎机",
                                        "taxName": "饲料生产设备",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "1090219010000000000",
                                        "taxCodeTitle": "饲料生产设备",
                                        "iTitle": "*饲料生产设备*饲料粉碎机（饲料专用设备）",
                                        "children": []
                                    },
                                    {
                                        "id": "2875",
                                        "linkid": "2873",
                                        "code": "109021902",
                                        "paCode": "1090219",
                                        "yn": "N",
                                        "title": "配制、加工饲料用机械",
                                        "alias": "配制、加工饲料用机械",
                                        "about": "包括饲料混合机（饲料专用设备）、料制粒机、饲料膨化机（饲料专用设备）等",
                                        "kws": "饲料混合机、料制粒机、饲料膨化机",
                                        "taxName": "饲料生产设备",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "1090219020000000000",
                                        "taxCodeTitle": "饲料生产设备",
                                        "iTitle": "*饲料生产设备*配制、加工饲料用机械",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2876",
                                "linkid": "2740",
                                "code": "1090220",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "食品、饮料、烟草专用生产设备零件",
                                "alias": "食品、饮料、烟草专用生产设备零件",
                                "about": null,
                                "kws": null,
                                "taxName": "食品制造机械",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090220000000000000",
                                "taxCodeTitle": "食品制造机械",
                                "iTitle": "*食品制造机械*食品、饮料、烟草专用生产设备零件",
                                "children": [
                                    {
                                        "id": "2877",
                                        "linkid": "2876",
                                        "code": "109022001",
                                        "paCode": "1090220",
                                        "yn": "N",
                                        "title": "食品生产设备零件",
                                        "alias": "食品生产设备零件",
                                        "about": "包括食品生产用模具或焙锅、其他设备零件",
                                        "kws": "#食品生产设备零件",
                                        "taxName": "食品制造机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090220010000000000",
                                        "taxCodeTitle": "食品制造机械",
                                        "iTitle": "*食品制造机械*食品生产设备零件",
                                        "children": []
                                    },
                                    {
                                        "id": "2878",
                                        "linkid": "2876",
                                        "code": "109022002",
                                        "paCode": "1090220",
                                        "yn": "N",
                                        "title": "乳品加工机械零件",
                                        "alias": "乳品加工机械零件",
                                        "about": "包括黄油搅拌桶、黄油加工机的滚筒及放料盘、黄油及奶酪模制用模具",
                                        "kws": "黄油搅拌桶、黄油加工机滚筒、黄油加工机放料盘、黄油模制用模具、奶酪模制用模具",
                                        "taxName": "食品制造机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090220020000000000",
                                        "taxCodeTitle": "食品制造机械",
                                        "iTitle": "*食品制造机械*乳品加工机械零件",
                                        "children": []
                                    },
                                    {
                                        "id": "2879",
                                        "linkid": "2876",
                                        "code": "109022003",
                                        "paCode": "1090220",
                                        "yn": "N",
                                        "title": "酒及饮料加工机械零件",
                                        "alias": "酒及饮料加工机械零件",
                                        "about": "包括榨汁机压榨滚筒、轧碎机的带齿滚筒、轧碎机磨碎器、果汁收集器、压榨板及机架、水果轧碎机用带齿滚筒及刀片",
                                        "kws": "榨汁机压榨滚筒、轧碎机的带齿滚筒、轧碎机磨碎器、果汁收集器、压榨板、压榨机架、水果轧碎机用带齿滚筒、水果轧碎机用刀片",
                                        "taxName": "食品制造机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090220030000000000",
                                        "taxCodeTitle": "食品制造机械",
                                        "iTitle": "*食品制造机械*酒及饮料加工机械零件",
                                        "children": []
                                    },
                                    {
                                        "id": "2880",
                                        "linkid": "2876",
                                        "code": "109022004",
                                        "paCode": "1090220",
                                        "yn": "N",
                                        "title": "烟草加工及制作机械零件",
                                        "alias": "烟草加工及制作机械零件",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "食品制造机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090220040000000000",
                                        "taxCodeTitle": "食品制造机械",
                                        "iTitle": "*食品制造机械*烟草加工及制作机械零件",
                                        "children": []
                                    },
                                    {
                                        "id": "2881",
                                        "linkid": "2876",
                                        "code": "109022005",
                                        "paCode": "1090220",
                                        "yn": "N",
                                        "title": "谷物磨粉工业用机械零件",
                                        "alias": "谷物磨粉工业用机械零件",
                                        "about": "包括谷物磨粉工业用筛及筛架、混合或分离滚筒、谷物磨粉机的滚筒或变换器、其他谷物磨粉工业用机械零件",
                                        "kws": "谷物磨粉工业用筛、谷物磨粉工业用筛架、混合滚筒、分离滚筒、谷物磨粉机的滚筒、谷物磨粉机的变换器、谷物磨粉工业用机械零件",
                                        "taxName": "食品制造机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090220050000000000",
                                        "taxCodeTitle": "食品制造机械",
                                        "iTitle": "*食品制造机械*谷物磨粉工业用机械零件",
                                        "children": []
                                    },
                                    {
                                        "id": "2882",
                                        "linkid": "2876",
                                        "code": "109022099",
                                        "paCode": "1090220",
                                        "yn": "N",
                                        "title": "其他食品加工专用设备零件",
                                        "alias": "其他食品加工专用设备零件",
                                        "about": "包括食品生产设备零件、乳品加工机械零件、酒及饮料加工机械零件、烟草加工及制作机械零件、谷物磨粉工业用机械零件、其他食品加工专用设备零件",
                                        "kws": "食品生产设备零件、乳品加工机械零件、酒加工机械零件、饮料加工机械零件、烟草加工机械零件、烟草制作机械零件、谷物磨粉工业用机械零件、食品加工专用设备零件",
                                        "taxName": "食品制造机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090220990000000000",
                                        "taxCodeTitle": "食品制造机械",
                                        "iTitle": "*食品制造机械*其他食品加工专用设备零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2883",
                                "linkid": "2740",
                                "code": "1090221",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "制浆和造纸专用设备",
                                "alias": "制浆和造纸专用设备",
                                "about": null,
                                "kws": null,
                                "taxName": "造纸专用设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090221000000000000",
                                "taxCodeTitle": "造纸专用设备",
                                "iTitle": "*造纸专用设备*制浆和造纸专用设备",
                                "children": [
                                    {
                                        "id": "2884",
                                        "linkid": "2883",
                                        "code": "109022101",
                                        "paCode": "1090221",
                                        "yn": "N",
                                        "title": "制浆设备",
                                        "alias": "制浆设备",
                                        "about": "包括制浆原料处理设备，洗涤、筛选、漂白、打浆等设备",
                                        "kws": "蒸球、造纸用蒸锅、喷放锅、连续蒸煮器、造纸用蒸煮设备、磨木机、破布清洗、破布打碎机、爆破法纤维分离机、打浆机、挤浆机、洗浆机、滤浆器、压浆机、精浆机、筛浆机、匀浆机、纤维回收机、除砂器、废纸制浆机、废纸板制浆机、造纸原料粉碎机、制浆设备、打浆设备",
                                        "taxName": "造纸专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090221010000000000",
                                        "taxCodeTitle": "造纸专用设备",
                                        "iTitle": "*造纸专用设备*制浆设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2885",
                                        "linkid": "2883",
                                        "code": "109022102",
                                        "paCode": "1090221",
                                        "yn": "N",
                                        "title": "造纸机",
                                        "alias": "造纸机",
                                        "about": "包括多层纸或纸板生产设备、制造测验用样纸的小型机械",
                                        "kws": "长网造纸机、圆网造纸机、板纸机、压光机、造纸机",
                                        "taxName": "造纸专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090221020000000000",
                                        "taxCodeTitle": "造纸专用设备",
                                        "iTitle": "*造纸专用设备*造纸机",
                                        "children": []
                                    },
                                    {
                                        "id": "2886",
                                        "linkid": "2883",
                                        "code": "109022103",
                                        "paCode": "1090221",
                                        "yn": "N",
                                        "title": "纸或纸板整理机械",
                                        "alias": "纸或纸板整理机械",
                                        "about": "复卷机、卷纸机、打包线、打包机、涂布机、烤版机、纸张浸渍机、绉纸加工机、纸张调湿机、压纹机、压花机、瓦楞纸加工机、瓦楞纸板生产线、其他纸整理机械、其他纸板整理机械",
                                        "kws": "复卷机、卷纸机、打包线、打包机、涂布机、烤版机、纸张浸渍机、绉纸加工机、纸张调湿机、压纹机、压花机、瓦楞纸加工机、瓦楞纸板生产线、纸整理机械、纸板整理机械",
                                        "taxName": "造纸专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090221030000000000",
                                        "taxCodeTitle": "造纸专用设备",
                                        "iTitle": "*造纸专用设备*纸或纸板整理机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2887",
                                        "linkid": "2883",
                                        "code": "109022104",
                                        "paCode": "1090221",
                                        "yn": "N",
                                        "title": "纸制品生产专用机械",
                                        "alias": "纸制品生产专用机械",
                                        "about": "纸包专用生产机械、纸袋专用生产机械、信封专用生产机械",
                                        "kws": "切纸机、纵切复绕机、堆叠机、穿孔机、模切机、袋专用机械、信封专用机械、卷烟纸折叠机械、夹页机械、包装机械、纸塑铝复合罐生产设备、纸塑铝复合软包装生产设备、纸制品模制成型机械、切角开槽机、订箱机、粘箱机、纸制品生产专用机械",
                                        "taxName": "造纸专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090221040000000000",
                                        "taxCodeTitle": "造纸专用设备",
                                        "iTitle": "*造纸专用设备*纸制品生产专用机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2888",
                                        "linkid": "2883",
                                        "code": "109022105",
                                        "paCode": "1090221",
                                        "yn": "N",
                                        "title": "纸浆、造纸及纸制品机械零件",
                                        "alias": "纸浆、造纸及纸制品机械零件",
                                        "about": "包括纤维素纸浆机械用零件、造纸及纸板机械用零件、纸制品机械用零件",
                                        "kws": "纤维素纸浆机械用零件、造纸机械用零件、纸板机械用零件、纸制品机械用零件",
                                        "taxName": "造纸专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090221050000000000",
                                        "taxCodeTitle": "造纸专用设备",
                                        "iTitle": "*造纸专用设备*纸浆、造纸及纸制品机械零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2889",
                                "linkid": "2740",
                                "code": "1090222",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "印刷专用设备",
                                "alias": "印刷专用设备",
                                "about": null,
                                "kws": null,
                                "taxName": "印刷专用设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090222000000000000",
                                "taxCodeTitle": "印刷专用设备",
                                "iTitle": "*印刷专用设备*印刷专用设备",
                                "children": [
                                    {
                                        "id": "2890",
                                        "linkid": "2889",
                                        "code": "109022201",
                                        "paCode": "1090222",
                                        "yn": "N",
                                        "title": "印前设备",
                                        "alias": "印前设备",
                                        "about": "包括平版制版设备、凹版制版设备、凸版制版设备、直接制版系统（CTP）、特种模压机、打样机、喷绘机、晒版机、显影机、铸字机、其他印前设备",
                                        "kws": "激光照相排版设备、模版制版设备、平版制版设备、凹版晒版机、凹版碳素纸过版机、凹版腐蚀机、凹版镀铬机、凹版制版设备、铅版制版机、感光树脂版制版设备、铜锌版制版设备、凸版制版设备",
                                        "taxName": "印刷专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090222010000000000",
                                        "taxCodeTitle": "印刷专用设备",
                                        "iTitle": "*印刷专用设备*印前设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2891",
                                        "linkid": "2889",
                                        "code": "109022202",
                                        "paCode": "1090222",
                                        "yn": "N",
                                        "title": "印刷机设备",
                                        "alias": "印刷机设备",
                                        "about": "包括平版印刷机（胶印机）、凸版印刷机、柔版印刷机、凹版印刷机、数字印刷机、网式印刷机、印刷装订联动机、组合印刷机、重复图案印刷设备、特种印刷设备、制卡设备、其他印刷机设备",
                                        "kws": "单张纸平版印刷机、卷筒纸平版印刷机、平版印刷机、卷筒纸凸版印刷机、凸版印刷机、照相凹版印刷机、单张纸凹版印刷机、卷筒纸凹版印刷机、凹版印刷机、数字喷墨印刷机、数字印刷机、圆网印刷机、平网印刷机、网式印刷机、平版凸版组合印刷机、平版凹版组合印刷机、网版凸版组合印刷机、组合印刷机、印袋机、印铁机、塑料烫印机、贴花印刷机、软管印刷机、电化铝烫印机、刻版印刷机、重复图案印刷机、盲文印刷机、移印机、磁性移印机、热转移印刷机、不干胶印刷机、水松纸印刷机、凹凸印刷机、膜版印刷机、印刷上光机、特种印刷机",
                                        "taxName": "印刷专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090222020000000000",
                                        "taxCodeTitle": "印刷专用设备",
                                        "iTitle": "*印刷专用设备*印刷机设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2892",
                                        "linkid": "2889",
                                        "code": "109022203",
                                        "paCode": "1090222",
                                        "yn": "N",
                                        "title": "装订机械",
                                        "alias": "装订机械",
                                        "about": "包括折页机（印刷设备）、配页机、搭页机、数纸机、锁线装订机、胶订机、金属线缝合机、三面切书机、装订联动机械、无线胶订书刊生产线、平装胶订生产线、精装书籍装订生产线、其他装订机械",
                                        "kws": "印刷折页机、配页机、搭页机、数纸机、锁线装订机、胶订机、金属线缝合机、三面切书机、装订联动机械、无线胶订书刊生产线、平装胶订生产线、精装书籍装订生产线、装订机械",
                                        "taxName": "印刷专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090222030000000000",
                                        "taxCodeTitle": "印刷专用设备",
                                        "iTitle": "*印刷专用设备*装订机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2893",
                                        "linkid": "2889",
                                        "code": "109022204",
                                        "paCode": "1090222",
                                        "yn": "N",
                                        "title": "印刷包装机械",
                                        "alias": "印刷包装机械",
                                        "about": "包括印刷捆扎机、印刷打包机、堆积机、糊盒机等",
                                        "kws": "印刷捆扎机、印刷打包机、堆积机、糊盒机",
                                        "taxName": "印刷专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090222040000000000",
                                        "taxCodeTitle": "印刷专用设备",
                                        "iTitle": "*印刷专用设备*印刷包装机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2894",
                                        "linkid": "2889",
                                        "code": "109022205",
                                        "paCode": "1090222",
                                        "yn": "N",
                                        "title": "印刷用辅助机械",
                                        "alias": "印刷用辅助机械",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "印刷专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090222050000000000",
                                        "taxCodeTitle": "印刷专用设备",
                                        "iTitle": "*印刷专用设备*印刷用辅助机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2895",
                                        "linkid": "2889",
                                        "code": "109022206",
                                        "paCode": "1090222",
                                        "yn": "N",
                                        "title": "印刷、装订机械零件",
                                        "alias": "印刷、装订机械零件",
                                        "about": "包括印刷机械用零件、印刷用辅助机械零件、书本装订机械用零件、其他印刷装订机械零件",
                                        "kws": "印刷机械用零件、印刷用辅助机械零件、书本装订机械用零件、印刷装订机械零件",
                                        "taxName": "印刷专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090222060000000000",
                                        "taxCodeTitle": "印刷专用设备",
                                        "iTitle": "*印刷专用设备*印刷、装订机械零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2896",
                                "linkid": "2740",
                                "code": "1090223",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "信息化学品生产设备",
                                "alias": "信息化学品生产设备",
                                "about": null,
                                "kws": null,
                                "taxName": "信息化学品设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090223000000000000",
                                "taxCodeTitle": "信息化学品设备",
                                "iTitle": "*信息化学品设备*信息化学品生产设备",
                                "children": [
                                    {
                                        "id": "2897",
                                        "linkid": "2896",
                                        "code": "109022301",
                                        "paCode": "1090223",
                                        "yn": "N",
                                        "title": "光盘复制生产设备",
                                        "alias": "光盘复制生产设备",
                                        "about": "包括用于光盘精密注塑机、真空金属溅镀机、保护胶涂覆机、金属母盘生产设备、其他光盘复制生产设备",
                                        "kws": "光盘精密注塑机、真空金属溅镀机、保护胶涂覆机、金属母盘生产设备、光盘复制生产设备",
                                        "taxName": "信息化学品设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090223010000000000",
                                        "taxCodeTitle": "信息化学品设备",
                                        "iTitle": "*信息化学品设备*光盘复制生产设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2898",
                                        "linkid": "2896",
                                        "code": "109022302",
                                        "paCode": "1090223",
                                        "yn": "N",
                                        "title": "录音带、录像带复制生产设备",
                                        "alias": "录音带、录像带复制生产设备",
                                        "about": "包括高速数码复录母机、高速数码复录子机、裁带机、其他录音带录像带复制生产设备",
                                        "kws": "高速数码复录母机、高速数码复录子机、裁带机、录音带录像带复制生产设备",
                                        "taxName": "信息化学品设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090223020000000000",
                                        "taxCodeTitle": "信息化学品设备",
                                        "iTitle": "*信息化学品设备*录音带、录像带复制生产设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2899",
                                        "linkid": "2896",
                                        "code": "109022303",
                                        "paCode": "1090223",
                                        "yn": "N",
                                        "title": "软磁盘复制生产设备",
                                        "alias": "软磁盘复制生产设备",
                                        "about": "包括拷贝机、格式化仪、其他软磁盘复制生产设备",
                                        "kws": "拷贝机、格式化仪、软磁盘复制生产设备",
                                        "taxName": "信息化学品设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090223030000000000",
                                        "taxCodeTitle": "信息化学品设备",
                                        "iTitle": "*信息化学品设备*软磁盘复制生产设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2900",
                                        "linkid": "2896",
                                        "code": "109022304",
                                        "paCode": "1090223",
                                        "yn": "N",
                                        "title": "感光胶片生产设备",
                                        "alias": "感光胶片生产设备",
                                        "about": "包括电影胶片生产设备、摄影胶片生产设备、医疗胶片生产设备、其他感光胶片生产设备",
                                        "kws": "电影胶片生产设备、摄影胶片生产设备、医疗胶片生产设备、感光胶片生产设备",
                                        "taxName": "信息化学品设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090223040000000000",
                                        "taxCodeTitle": "信息化学品设备",
                                        "iTitle": "*信息化学品设备*感光胶片生产设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2901",
                                        "linkid": "2896",
                                        "code": "109022305",
                                        "paCode": "1090223",
                                        "yn": "N",
                                        "title": "感光纸及类似品生产设备",
                                        "alias": "感光纸及类似品生产设备",
                                        "about": null,
                                        "kws": "感光纸生产设备",
                                        "taxName": "信息化学品设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090223050000000000",
                                        "taxCodeTitle": "信息化学品设备",
                                        "iTitle": "*信息化学品设备*感光纸及类似品生产设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2902",
                                        "linkid": "2896",
                                        "code": "109022306",
                                        "paCode": "1090223",
                                        "yn": "N",
                                        "title": "摄影、复印化学制剂生产设备",
                                        "alias": "摄影、复印化学制剂生产设备",
                                        "about": "包括摄影用化学制剂生产设备、复印用化学制剂生产设备",
                                        "kws": "摄影用化学制剂生产设备、复印用化学制剂生产设备",
                                        "taxName": "信息化学品设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090223060000000000",
                                        "taxCodeTitle": "信息化学品设备",
                                        "iTitle": "*信息化学品设备*摄影、复印化学制剂生产设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2903",
                                        "linkid": "2896",
                                        "code": "109022399",
                                        "paCode": "1090223",
                                        "yn": "N",
                                        "title": "其他信息化学品生产设备",
                                        "alias": "其他信息化学品生产设备",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "信息化学品设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090223990000000000",
                                        "taxCodeTitle": "信息化学品设备",
                                        "iTitle": "*信息化学品设备*其他信息化学品生产设备",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2904",
                                "linkid": "2740",
                                "code": "1090224",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "制药专用设备",
                                "alias": "制药专用设备",
                                "about": null,
                                "kws": null,
                                "taxName": "制药专用设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090224000000000000",
                                "taxCodeTitle": "制药专用设备",
                                "iTitle": "*制药专用设备*制药专用设备",
                                "children": [
                                    {
                                        "id": "2905",
                                        "linkid": "2904",
                                        "code": "109022401",
                                        "paCode": "1090224",
                                        "yn": "N",
                                        "title": "化学药原料药生产设备",
                                        "alias": "化学药原料药生产设备",
                                        "about": "包括药用反应设备、药用结晶设备、药用萃取设备、其他化学药原料药生产设备",
                                        "kws": "药用反应设备、药用结晶设备、药用萃取设备、化学药原料药生产设备",
                                        "taxName": "制药专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090224010000000000",
                                        "taxCodeTitle": "制药专用设备",
                                        "iTitle": "*制药专用设备*化学药原料药生产设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2906",
                                        "linkid": "2904",
                                        "code": "109022402",
                                        "paCode": "1090224",
                                        "yn": "N",
                                        "title": "饮片生产机械",
                                        "alias": "饮片生产机械",
                                        "about": "包括洗药机、润药机、切药机、筛选机、炒药机等",
                                        "kws": "洗药机、润药机、切药机、筛选机、炒药机、饮片生产机械",
                                        "taxName": "制药专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090224020000000000",
                                        "taxCodeTitle": "制药专用设备",
                                        "iTitle": "*制药专用设备*饮片生产机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2907",
                                        "linkid": "2904",
                                        "code": "109022403",
                                        "paCode": "1090224",
                                        "yn": "N",
                                        "title": "制药专用粉碎机械",
                                        "alias": "制药专用粉碎机械",
                                        "about": "包括机械式药用粉碎机、气流式粉碎机、低温粉碎机、药用粉碎机组、其他药用粉碎机械",
                                        "kws": "机械式药用粉碎机、气流式粉碎机、低温粉碎机、药用粉碎机组、药用粉碎机械",
                                        "taxName": "制药专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090224030000000000",
                                        "taxCodeTitle": "制药专用设备",
                                        "iTitle": "*制药专用设备*制药专用粉碎机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2908",
                                        "linkid": "2904",
                                        "code": "109022404",
                                        "paCode": "1090224",
                                        "yn": "N",
                                        "title": "药品专用包装机械",
                                        "alias": "药品专用包装机械",
                                        "about": "包括药用计数充填机、安瓿印字包装机、胶囊印字机、药用泡罩包装机、多功能药用瓶装包装机、药用袋装包装机、药用盒装包装机、微型铝塑包装机、空心胶囊制造机、其他药品专用包装机械",
                                        "kws": "药用计数充填机、安瓿印字包装机、胶囊印字机、药用泡罩包装机、多功能药用瓶装包装机、药用袋装包装机、药用盒装包装机、微型铝塑包装机、空心胶囊制造机、药品专用包装机械",
                                        "taxName": "制药专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090224040000000000",
                                        "taxCodeTitle": "制药专用设备",
                                        "iTitle": "*制药专用设备*药品专用包装机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2909",
                                        "linkid": "2904",
                                        "code": "109022405",
                                        "paCode": "1090224",
                                        "yn": "N",
                                        "title": "制剂生产设备",
                                        "alias": "制剂生产设备",
                                        "about": "包括中成药制剂生产设备",
                                        "kws": "胶囊剂生产机械、丸剂机械、片剂生产机械、水针生产线、口服液生产机械、制剂生产设备",
                                        "taxName": "制药专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090224050000000000",
                                        "taxCodeTitle": "制药专用设备",
                                        "iTitle": "*制药专用设备*制剂生产设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2910",
                                        "linkid": "2904",
                                        "code": "109022406",
                                        "paCode": "1090224",
                                        "yn": "N",
                                        "title": "药物检测设备及仪器",
                                        "alias": "药物检测设备及仪器",
                                        "about": "包括药物检测设备、药物检测仪器",
                                        "kws": "检片机、安瓿注射液异物检查设备、玻璃瓶输液异物半自动检查机、药物检测设备、硬度检测仪、溶出试验仪、除气仪、崩解仪、脆碎仪、冻力仪、药物检测仪器",
                                        "taxName": "制药专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090224060000000000",
                                        "taxCodeTitle": "制药专用设备",
                                        "iTitle": "*制药专用设备*药物检测设备及仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "2911",
                                        "linkid": "2904",
                                        "code": "109022407",
                                        "paCode": "1090224",
                                        "yn": "N",
                                        "title": "脏器生化制药机械",
                                        "alias": "脏器生化制药机械",
                                        "about": null,
                                        "kws": "脏器生化制药机械",
                                        "taxName": "制药专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090224070000000000",
                                        "taxCodeTitle": "制药专用设备",
                                        "iTitle": "*制药专用设备*脏器生化制药机械",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2912",
                                "linkid": "2740",
                                "code": "1090225",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "照明器具生产专用设备",
                                "alias": "照明器具生产专用设备",
                                "about": null,
                                "kws": null,
                                "taxName": "照明器具生产设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090225000000000000",
                                "taxCodeTitle": "照明器具生产设备",
                                "iTitle": "*照明器具生产设备*照明器具生产专用设备",
                                "children": [
                                    {
                                        "id": "2913",
                                        "linkid": "2912",
                                        "code": "109022501",
                                        "paCode": "1090225",
                                        "yn": "N",
                                        "title": "玻壳加工机械",
                                        "alias": "玻壳加工机械",
                                        "about": "包括灯泡、灯管、电子真空器件及类似品的玻壳加工机械（封装机械）",
                                        "kws": "灯泡吹制机、闪光灯泡玻壳加工机、电子真空器件玻壳加工机械、玻壳加工机械",
                                        "taxName": "照明器具生产设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090225010000000000",
                                        "taxCodeTitle": "照明器具生产设备",
                                        "iTitle": "*照明器具生产设备*玻壳加工机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2914",
                                        "linkid": "2912",
                                        "code": "109022502",
                                        "paCode": "1090225",
                                        "yn": "N",
                                        "title": "灯丝、灯头玻璃零件加工机械",
                                        "alias": "灯丝、灯头玻璃零件加工机械",
                                        "about": "包括基座垫块加工设备、灯头加工设备、灯丝支架加工设备、以及其他灯丝、灯头玻璃零件加工机械",
                                        "kws": "基座垫块加工设备、灯头加工设备、灯丝支架加工设备、灯丝玻璃零件加工机械、灯头玻璃零件加工机械",
                                        "taxName": "照明器具生产设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090225020000000000",
                                        "taxCodeTitle": "照明器具生产设备",
                                        "iTitle": "*照明器具生产设备*灯丝、灯头玻璃零件加工机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2915",
                                        "linkid": "2912",
                                        "code": "109022503",
                                        "paCode": "1090225",
                                        "yn": "N",
                                        "title": "灯泡及类似品封装机",
                                        "alias": "灯泡及类似品封装机",
                                        "about": "包括灯泡、灯管、电子真空器件及类似品的封装机械，以及配套装置",
                                        "kws": "灯泡真空封口机、白炽灯泡旋转自动封装机、电子真空器件旋转自动封装机、喷焊器、加压装、闭合装置、灯具组装设备、照明器具组装设备、电子真空器件组装设备、灯泡封装机、灯泡类似品封装机",
                                        "taxName": "照明器具生产设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090225030000000000",
                                        "taxCodeTitle": "照明器具生产设备",
                                        "iTitle": "*照明器具生产设备*灯泡及类似品封装机",
                                        "children": []
                                    },
                                    {
                                        "id": "2916",
                                        "linkid": "2912",
                                        "code": "109022504",
                                        "paCode": "1090225",
                                        "yn": "N",
                                        "title": "灯泡及类似品封装机零件",
                                        "alias": "灯泡及类似品封装机零件",
                                        "about": "包括灯泡、灯管、电子真空器件及类似品的封装机械零件",
                                        "kws": "灯泡、灯管、电子真空器件",
                                        "taxName": "照明器具生产设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090225040000000000",
                                        "taxCodeTitle": "照明器具生产设备",
                                        "iTitle": "*照明器具生产设备*灯泡及类似品封装机零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2917",
                                "linkid": "2740",
                                "code": "1090226",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "日用化工专用设备",
                                "alias": "日用化工专用设备",
                                "about": null,
                                "kws": null,
                                "taxName": "日化专用设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090226000000000000",
                                "taxCodeTitle": "日化专用设备",
                                "iTitle": "*日化专用设备*日用化工专用设备",
                                "children": [
                                    {
                                        "id": "2918",
                                        "linkid": "2917",
                                        "code": "109022601",
                                        "paCode": "1090226",
                                        "yn": "N",
                                        "title": "合成洗涤剂专用设备",
                                        "alias": "合成洗涤剂专用设备",
                                        "about": "包括喷粉塔、高压泵、配料罐、后配料混合器、其他合成洗涤剂专用设备",
                                        "kws": "喷粉塔、高压泵、配料罐、后配料混合器、合成洗涤剂专用设备",
                                        "taxName": "日化专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090226010000000000",
                                        "taxCodeTitle": "日化专用设备",
                                        "iTitle": "*日化专用设备*合成洗涤剂专用设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2919",
                                        "linkid": "2917",
                                        "code": "109022602",
                                        "paCode": "1090226",
                                        "yn": "N",
                                        "title": "肥皂成型专用设备",
                                        "alias": "肥皂成型专用设备",
                                        "about": "包括压条机、皂类切割机、香皂真空出条机、皂类自动打印机、其他肥皂成型专用设备",
                                        "kws": "压条机、皂类切割机、香皂真空出条机、皂类自动打印机、肥皂成型专用设备",
                                        "taxName": "日化专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090226020000000000",
                                        "taxCodeTitle": "日化专用设备",
                                        "iTitle": "*日化专用设备*肥皂成型专用设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2920",
                                        "linkid": "2917",
                                        "code": "109022603",
                                        "paCode": "1090226",
                                        "yn": "N",
                                        "title": "牙膏、化妆品、香精、香料专用设备",
                                        "alias": "牙膏、化妆品、香精、香料专用设备",
                                        "about": "包括牙膏配制机、真空均质制膏机、香精、香料搅拌机、软管冲挤机、刮扳式浸花机以及其他牙膏、化妆品专用设备",
                                        "kws": "牙膏配制机、真空均质制膏机、香精香料搅拌机、软管冲挤机、刮扳式浸花机、牙膏专用设备、化妆品专用设备",
                                        "taxName": "日化专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090226030000000000",
                                        "taxCodeTitle": "日化专用设备",
                                        "iTitle": "*日化专用设备*牙膏、化妆品、香精、香料专用设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2921",
                                        "linkid": "2917",
                                        "code": "109022604",
                                        "paCode": "1090226",
                                        "yn": "N",
                                        "title": "火柴专用生产设备",
                                        "alias": "火柴专用生产设备",
                                        "about": "包括火柴浸渍机、其他火柴专用生产设备",
                                        "kws": "火柴浸渍机、火柴专用生产设备",
                                        "taxName": "日化专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090226040000000000",
                                        "taxCodeTitle": "日化专用设备",
                                        "iTitle": "*日化专用设备*火柴专用生产设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2922",
                                        "linkid": "2917",
                                        "code": "109022699",
                                        "paCode": "1090226",
                                        "yn": "N",
                                        "title": "其他日用化工专用设备",
                                        "alias": "其他日用化工专用设备",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "日化专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090226990000000000",
                                        "taxCodeTitle": "日化专用设备",
                                        "iTitle": "*日化专用设备*其他日用化工专用设备",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2923",
                                "linkid": "2740",
                                "code": "1090227",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "搪瓷制品，相关日用品生产设备",
                                "alias": "搪瓷制品，相关日用品生产设备",
                                "about": null,
                                "kws": null,
                                "taxName": "其他日用品生产设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090227000000000000",
                                "taxCodeTitle": "其他日用品生产设备",
                                "iTitle": "*其他日用品生产设备*搪瓷制品，相关日用品生产设备",
                                "children": [
                                    {
                                        "id": "2924",
                                        "linkid": "2923",
                                        "code": "109022701",
                                        "paCode": "1090227",
                                        "yn": "N",
                                        "title": "搪瓷制品生产设备",
                                        "alias": "搪瓷制品生产设备",
                                        "about": "包括搪瓷烧成炉、搪瓷施釉设备、搪瓷制坯设备、搪瓷涂搪设备、搪瓷饰花设备、搪瓷静电喷涂设备、其他搪瓷制品生产设备",
                                        "kws": "搪瓷烧成炉、搪瓷施釉设备、搪瓷制坯设备、搪瓷涂搪设备、搪瓷饰花设备、搪瓷静电喷涂设备、搪瓷制品生产设备",
                                        "taxName": "其他日用品生产设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090227010000000000",
                                        "taxCodeTitle": "其他日用品生产设备",
                                        "iTitle": "*其他日用品生产设备*搪瓷制品生产设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2925",
                                        "linkid": "2923",
                                        "code": "109022702",
                                        "paCode": "1090227",
                                        "yn": "N",
                                        "title": "文教体育用品专用机械",
                                        "alias": "文教体育用品专用机械",
                                        "about": "包括铅笔木杆加工机械、石墨铅笔芯挤出机械、粉笔用模制机械、纤维灰浆制品模制成型机械、灰泥制品模制成型机械、其他文教体育用品专用机械",
                                        "kws": "铅笔木杆加工机械、石墨铅笔芯挤出机械、粉笔用模制机械、纤维灰浆制品模制成型机械、灰泥制品模制成型机械、文教体育用品专用机械",
                                        "taxName": "其他日用品生产设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090227020000000000",
                                        "taxCodeTitle": "其他日用品生产设备",
                                        "iTitle": "*其他日用品生产设备*文教体育用品专用机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2926",
                                        "linkid": "2923",
                                        "code": "109022703",
                                        "paCode": "1090227",
                                        "yn": "N",
                                        "title": "日用杂品生产专用设备",
                                        "alias": "日用杂品生产专用设备",
                                        "about": "包括制木纽扣用机械、拉链设备、煤制品生产专用机械、毛刷加工机械、其他日用杂品生产专用设备",
                                        "kws": "制木纽扣用机械、拉链设备、煤粉混合机械、蜂窝煤成型机、煤球机、压球机、型煤设备、煤制品生产专用机械、制刷机、毛发整理加工机械、鬃毛整理加工机械",
                                        "taxName": "其他日用品生产设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090227030000000000",
                                        "taxCodeTitle": "其他日用品生产设备",
                                        "iTitle": "*其他日用品生产设备*日用杂品生产专用设备",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2927",
                                "linkid": "2740",
                                "code": "1090228",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "纺织专用设备",
                                "alias": "纺织专用设备",
                                "about": null,
                                "kws": null,
                                "taxName": "纺织专用设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090228000000000000",
                                "taxCodeTitle": "纺织专用设备",
                                "iTitle": "*纺织专用设备*纺织专用设备",
                                "children": [
                                    {
                                        "id": "2928",
                                        "linkid": "2927",
                                        "code": "109022801",
                                        "paCode": "1090228",
                                        "yn": "N",
                                        "title": "化学纺织纤维加工专用机械",
                                        "alias": "化学纺织纤维加工专用机械",
                                        "about": "包括化学纺织纤维原料制取、熔融、拉伸、变形或切断的机械",
                                        "kws": "长丝纺丝设备、长丝后加工设备、短丝纺丝设备、短丝后加工设备、短丝纺牵联合机、纤维打包机、合成纤维设备、原液制取设备、原液纺纺丝设备、原液纺后处理设备、长丝打包机、短丝打包机、人造纤维设备、生物纤维设备、特种纤维设备、化学纺织纤维加工专用机械",
                                        "taxName": "纺织专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090228010000000000",
                                        "taxCodeTitle": "纺织专用设备",
                                        "iTitle": "*纺织专用设备*化学纺织纤维加工专用机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2929",
                                        "linkid": "2927",
                                        "code": "109022802",
                                        "paCode": "1090228",
                                        "yn": "N",
                                        "title": "棉纺前纺设备",
                                        "alias": "棉纺前纺设备",
                                        "about": "棉纺的抓、开、混、清设备。",
                                        "kws": "抓棉机、开棉机、混棉机、清棉机、棉纺除尘杂机、棉纺用棉箱、成卷机、棉纺前纺设备、圆盘抓棉机、往复抓棉机、帘子输送给棉机、混开棉机、轴流圆筒开棉机、多仓混棉机、精开棉机、滚筒式清棉机、强力除尘机、除微尘机、储棉箱、成卷用棉箱、清梳联用棉箱",
                                        "taxName": "纺织专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090228020000000000",
                                        "taxCodeTitle": "纺织专用设备",
                                        "iTitle": "*纺织专用设备*棉纺前纺设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2930",
                                        "linkid": "2927",
                                        "code": "109022803",
                                        "paCode": "1090228",
                                        "yn": "N",
                                        "title": "毛、麻预处理机械",
                                        "alias": "毛、麻预处理机械",
                                        "about": "包括毛预处理机械、麻预处理机械以及其他毛、麻预处理机械",
                                        "kws": "洗毛机、开毛机、混毛机、浸渍羊毛、苎麻机械、苎麻毛机、亚麻预处理机械、苎麻预处理机械、黄麻预处理机械、剑麻预处理机械",
                                        "taxName": "纺织专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090228030000000000",
                                        "taxCodeTitle": "纺织专用设备",
                                        "iTitle": "*纺织专用设备*毛、麻预处理机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2931",
                                        "linkid": "2927",
                                        "code": "109022804",
                                        "paCode": "1090228",
                                        "yn": "N",
                                        "title": "丝、绢预处理机械",
                                        "alias": "丝、绢预处理机械",
                                        "about": "用于真丝、绢纺原料处理的机械",
                                        "kws": "丝预处理机械、绢纺预处理机械",
                                        "taxName": "纺织专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090228040000000000",
                                        "taxCodeTitle": "纺织专用设备",
                                        "iTitle": "*纺织专用设备*丝、绢预处理机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2932",
                                        "linkid": "2927",
                                        "code": "109022805",
                                        "paCode": "1090228",
                                        "yn": "N",
                                        "title": "纺织纤维梳理机",
                                        "alias": "纺织纤维梳理机",
                                        "about": "指用于梳理棉、毛、化学短纤维、韧皮纤维（亚麻、苎麻等）等的机械包括棉纤维型、毛纤维型、麻纤维型及其他梳理机",
                                        "kws": "棉纤维型梳理机、清梳联合机、成卷用梳棉机、清梳联用梳棉机、粗毛纺梳理机、精毛纺梳理机、特种毛纺梳理机、毛纤维型梳理机、麻纤维梳理机、亚麻纤维梳理机、苎麻纤维梳理机、黄麻纤维梳理机、绢纺梳绵机械、纺织纤维梳理机",
                                        "taxName": "纺织专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090228050000000000",
                                        "taxCodeTitle": "纺织专用设备",
                                        "iTitle": "*纺织专用设备*纺织纤维梳理机",
                                        "children": []
                                    },
                                    {
                                        "id": "2933",
                                        "linkid": "2927",
                                        "code": "109022806",
                                        "paCode": "1090228",
                                        "yn": "N",
                                        "title": "精梳机械",
                                        "alias": "精梳机械",
                                        "about": "指棉、毛、麻等精梳机械",
                                        "kws": "棉精梳准备机械、棉精梳机、毛精梳机、麻精梳机、精梳机械",
                                        "taxName": "纺织专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090228060000000000",
                                        "taxCodeTitle": "纺织专用设备",
                                        "iTitle": "*纺织专用设备*精梳机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2934",
                                        "linkid": "2927",
                                        "code": "109022807",
                                        "paCode": "1090228",
                                        "yn": "N",
                                        "title": "成条、针梳机",
                                        "alias": "成条、针梳机",
                                        "about": "用于成条、针梳等机械",
                                        "kws": "棉纺并条机、毛纺制条机、毛条针梳机、麻成条机、针梳机",
                                        "taxName": "纺织专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090228070000000000",
                                        "taxCodeTitle": "纺织专用设备",
                                        "iTitle": "*纺织专用设备*成条、针梳机",
                                        "children": []
                                    },
                                    {
                                        "id": "2935",
                                        "linkid": "2927",
                                        "code": "109022808",
                                        "paCode": "1090228",
                                        "yn": "N",
                                        "title": "粗纱机",
                                        "alias": "粗纱机",
                                        "about": "包括棉纺粗纱机、毛纺粗纱机、麻纺粗纱机、绢纺粗纱机、其他粗纱机",
                                        "kws": "托锭粗纱机、悬锭粗纱机、毛有捻粗纱机、托锭型式毛粗纱机、悬锭型式毛粗纱机、毛无捻粗纱机、卧式无捻粗纱机、立式无捻粗纱机、毛纺粗纱机、亚麻纺粗纱机、苎麻纺粗纱机、麻纺粗纱机",
                                        "taxName": "纺织专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090228080000000000",
                                        "taxCodeTitle": "纺织专用设备",
                                        "iTitle": "*纺织专用设备*粗纱机",
                                        "children": []
                                    },
                                    {
                                        "id": "2936",
                                        "linkid": "2927",
                                        "code": "109022809",
                                        "paCode": "1090228",
                                        "yn": "N",
                                        "title": "细纱机",
                                        "alias": "细纱机",
                                        "about": "指环锭纺、转杯纺、喷气纺、摩擦纺等各类用于棉毛麻丝纺制细纱的机械",
                                        "kws": "棉纺细纱机、毛纺细纱机、麻纺细纱机、缫丝机、绢纺细纱机、紧密集聚环锭细纱机、转杯纺纱机喷气纺纱机、摩擦纺纱机、细纱机",
                                        "taxName": "纺织专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090228090000000000",
                                        "taxCodeTitle": "纺织专用设备",
                                        "iTitle": "*纺织专用设备*细纱机",
                                        "children": []
                                    },
                                    {
                                        "id": "2937",
                                        "linkid": "2927",
                                        "code": "109022810",
                                        "paCode": "1090228",
                                        "yn": "N",
                                        "title": "纺织纱线处理机械",
                                        "alias": "纺织纱线处理机械",
                                        "about": "指各类纱的加捻、并合、络纱等的机械",
                                        "kws": "并纱机、并线机、加捻机、络纱机、花式纱设备、花色纱设备、花式线设备、花色线设备、纺织纱线处理机械",
                                        "taxName": "纺织专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090228100000000000",
                                        "taxCodeTitle": "纺织专用设备",
                                        "iTitle": "*纺织专用设备*纺织纱线处理机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2938",
                                        "linkid": "2927",
                                        "code": "109022811",
                                        "paCode": "1090228",
                                        "yn": "N",
                                        "title": "织造准备设备",
                                        "alias": "织造准备设备",
                                        "about": "包括整经机（纺织设备）、浆纱机、捻丝机、丝束直接纺纱机、穿经架及穿筘机、整经筒子架、并轴机、整浆联合机、其他织造准备设备",
                                        "kws": "整经机、浆纱机、捻丝机、丝束直接纺纱机、穿经架、穿筘机、整经筒子架、并轴机、整浆联合机、织造准备设备",
                                        "taxName": "纺织专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090228110000000000",
                                        "taxCodeTitle": "纺织专用设备",
                                        "iTitle": "*纺织专用设备*织造准备设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2939",
                                        "linkid": "2927",
                                        "code": "109022812",
                                        "paCode": "1090228",
                                        "yn": "N",
                                        "title": "织机",
                                        "alias": "织机",
                                        "about": "包括用纺织纱线（包括泥炭纤维纱线）或其他纤维纱线（例如，金属纱线、玻璃纤维纱线或石棉纤维纱线）织造织物的纺织机械",
                                        "kws": "无梭织机、动力梭织机、手工梭织机、毛巾织机、提花织机、窄幅织物织机、多梭圆织机、特种织机",
                                        "taxName": "纺织专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090228120000000000",
                                        "taxCodeTitle": "纺织专用设备",
                                        "iTitle": "*纺织专用设备*织机",
                                        "children": []
                                    },
                                    {
                                        "id": "2940",
                                        "linkid": "2927",
                                        "code": "109022813",
                                        "paCode": "1090228",
                                        "yn": "N",
                                        "title": "针织机械",
                                        "alias": "针织机械",
                                        "about": "包括纬编机、纬编准备机械、圆型纬编机、横机、袜机、经编整经机、特利考经编机、拉舍尔经编机、缝编机、钩编机、其他针织机械",
                                        "kws": "纬编机、纬编准备机械、圆型纬编机、横机、袜机、经编整经机、特利考经编机、拉舍尔经编机、缝编机、钩编机、针织机械",
                                        "taxName": "纺织专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090228130000000000",
                                        "taxCodeTitle": "纺织专用设备",
                                        "iTitle": "*纺织专用设备*针织机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2941",
                                        "linkid": "2927",
                                        "code": "109022814",
                                        "paCode": "1090228",
                                        "yn": "N",
                                        "title": "非织造机械",
                                        "alias": "非织造机械",
                                        "about": "包括干法成网机械、湿法成网机械、聚合物直接成网机械、加固机械、后整理机械、非织造布生产线联合机、其他非织造机械",
                                        "kws": "干法成网机械、湿法成网机械、聚合物直接成网机械、加固机械、后整理机械、非织造布生产线联合机、非织造机械",
                                        "taxName": "纺织专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090228140000000000",
                                        "taxCodeTitle": "纺织专用设备",
                                        "iTitle": "*纺织专用设备*非织造机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2942",
                                        "linkid": "2927",
                                        "code": "109022815",
                                        "paCode": "1090228",
                                        "yn": "N",
                                        "title": "纺织废料回用、处理设备",
                                        "alias": "纺织废料回用、处理设备",
                                        "about": "包括纺织用废棉处理设备、纺织用废纺处理设备",
                                        "kws": "废棉除杂机组、粗纱头机、纤维切断机、多功能开松机",
                                        "taxName": "纺织专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090228150000000000",
                                        "taxCodeTitle": "纺织专用设备",
                                        "iTitle": "*纺织专用设备*纺织废料回用、处理设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2943",
                                        "linkid": "2927",
                                        "code": "109022816",
                                        "paCode": "1090228",
                                        "yn": "N",
                                        "title": "印染机械",
                                        "alias": "印染机械",
                                        "about": "包括印染前处理设备、染色设备、印花设备、整理设备、成品设备、印染辅机及通用单元设备、其他印染机械",
                                        "kws": "印染前处理设备、染色设备、印花设备、整理设备、成品设备、印染辅机、印染通用单元设备、印染机械",
                                        "taxName": "纺织专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090228160000000000",
                                        "taxCodeTitle": "纺织专用设备",
                                        "iTitle": "*纺织专用设备*印染机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2944",
                                        "linkid": "2927",
                                        "code": "109022817",
                                        "paCode": "1090228",
                                        "yn": "N",
                                        "title": "织造辅助机械及装置",
                                        "alias": "织造辅助机械及装置",
                                        "about": "包括织造辅助机械、织机辅助装置",
                                        "kws": "织造辅助机械、织机辅助装置",
                                        "taxName": "纺织专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090228170000000000",
                                        "taxCodeTitle": "纺织专用设备",
                                        "iTitle": "*纺织专用设备*织造辅助机械及装置",
                                        "children": []
                                    },
                                    {
                                        "id": "2945",
                                        "linkid": "2927",
                                        "code": "109022818",
                                        "paCode": "1090228",
                                        "yn": "N",
                                        "title": "纺织机械及其辅助机械零件、附件",
                                        "alias": "纺织机械及其辅助机械零件、附件",
                                        "about": "包括化学纺织纤维机械零件，纺织机械专用零、部件，织机及其辅助机械零件，针织机械及其辅助机械零件，其他纺织机械及其辅助机械零件、附件",
                                        "kws": "化学纺织纤维机械零件、纺织机械专用零部件、织机机械零件、织机辅助机械零件、针织机械零件、针织机辅助机械零件、纺织机械零件、纺织机辅助机械零附件",
                                        "taxName": "纺织专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090228180000000000",
                                        "taxCodeTitle": "纺织专用设备",
                                        "iTitle": "*纺织专用设备*纺织机械及其辅助机械零件、附件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2946",
                                "linkid": "2740",
                                "code": "1090229",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "皮革、毛皮及其制品加工专用设备",
                                "alias": "皮革、毛皮及其制品加工专用设备",
                                "about": "对皮革、毛皮各工艺环节进行加工处理及对其制品进行加工、制作的设备。",
                                "kws": "皮革加工专用设备、毛皮加工专用设备、皮革制品专用设备、毛皮制品专用设备",
                                "taxName": "皮革专用设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090229000000000000",
                                "taxCodeTitle": "皮革专用设备",
                                "iTitle": "*皮革专用设备*皮革、毛皮及其制品加工专用设备",
                                "children": [
                                    {
                                        "id": "2947",
                                        "linkid": "2946",
                                        "code": "109022901",
                                        "paCode": "1090229",
                                        "yn": "N",
                                        "title": "生皮处理机械",
                                        "alias": "生皮处理机械",
                                        "about": "对生皮（从动物身上剥下来的皮）进行浸水、脱毛、浸灰、软化、浸酸等一系列加工处理的机械。包括脱毛机(用以将生皮上预先用化学方法松脱的毛发除去)、制革去肉机、刮皮机、挤水伸展机、皮革拉软机、量革机、其他生皮处理机械。",
                                        "kws": "生皮处理机械、脱毛机、制革去肉机、刮皮机、挤水伸展机、皮革拉软机、量革机、",
                                        "taxName": "皮革专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090229010000000000",
                                        "taxCodeTitle": "皮革专用设备",
                                        "iTitle": "*皮革专用设备*生皮处理机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2948",
                                        "linkid": "2946",
                                        "code": "109022902",
                                        "paCode": "1090229",
                                        "yn": "N",
                                        "title": "皮革鞣制加工机械",
                                        "alias": "皮革鞣制加工机械",
                                        "about": "对生皮进行鞣制(使生皮转变成革）处理的机械。鞣制是鞣剂分子向皮内渗透并与生皮胶原分子活性基团结合而发生性质改变的过程。鞣制使皮胶原多肽链之间生成交联键，增加了胶原结构的稳定性，提高了收缩温度及耐湿热稳定性，改善了抗酸、碱、酶等化学品的能力。包括鞣革机（锤磨机）、滚筒敲打机、锤打机、锤实机、修刮或剖皮机、皮革砂磨机、刷皮机、皮革柔软整理机、打光机、起粒机、其他皮革鞣制加工机械。",
                                        "kws": "皮革鞣制加工机械、鞣革机、锤磨机、滚筒敲打机、锤打机、锤实机、修刮机、剖皮机、皮革砂磨机、刷皮机、皮革柔软整理机、打光机、起粒机、",
                                        "taxName": "皮革专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090229020000000000",
                                        "taxCodeTitle": "皮革专用设备",
                                        "iTitle": "*皮革专用设备*皮革鞣制加工机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2949",
                                        "linkid": "2946",
                                        "code": "109022903",
                                        "paCode": "1090229",
                                        "yn": "N",
                                        "title": "皮革制品制作机械",
                                        "alias": "皮革制品制作机械",
                                        "about": "包括制造或修补生皮（包括毛皮）或皮革制品（例如，鞋靴、手套、茄克衫及其他衣着用品、鞍具、书籍封面、手提包、旅行容器等）的机械。含皮革制品通用制作机械：片皮机（皮革切片或削皮机）、皮革特定形状切割机、皮革穿孔机、皮革刺孔机、皮箱接头机、其他皮革制品通用制作机械；鞋靴专用生产机械：片底机、片帮机、皮革切槽机、楦鞋机、主跟成型机、合布机、抿边机、粘底机、上底机、底工转车、帮角熨平机（包括鞋底边缘或鞋跟边缘的修整、磨光或后处理机械）、鞋靴拉撑机、其他鞋靴专用生产机械；其他皮革制品制作机械。",
                                        "kws": "皮革制品制作机械、皮革制品通用制作机械、片皮机、皮革切片削皮机、皮革特定形状切割机、皮革穿孔机、皮革刺孔机、皮箱接头机、鞋靴专用生产机械、片底机、片帮机、皮革切槽机、楦鞋机、主跟成型机、合布机、抿边机、粘底机、上底机、底工转车、帮角熨平机、鞋底边缘处理机械、鞋跟边缘处理机械、鞋靴拉撑机",
                                        "taxName": "皮革专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090229030000000000",
                                        "taxCodeTitle": "皮革专用设备",
                                        "iTitle": "*皮革专用设备*皮革制品制作机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2950",
                                        "linkid": "2946",
                                        "code": "109022904",
                                        "paCode": "1090229",
                                        "yn": "N",
                                        "title": "毛皮及其制品制作及修理机械",
                                        "alias": "毛皮及其制品制作及修理机械",
                                        "about": "对毛皮（指带毛的动物皮）进行鞣制、染整等制作的机械，制作毛皮制品的机械及对毛皮、毛皮制品进行修理修补的机械。包括毛皮加工机（将皮毛修齐、剪去长毛的专用机械）、毛皮加工机（皮毛刷毛机械）、皮毛染色机械、其他毛皮及其制品制作及修理机械。",
                                        "kws": "毛皮加工机、皮毛刷毛机械、皮毛染色机械",
                                        "taxName": "皮革专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090229040000000000",
                                        "taxCodeTitle": "皮革专用设备",
                                        "iTitle": "*皮革专用设备*毛皮及其制品制作及修理机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2951",
                                        "linkid": "2946",
                                        "code": "109022905",
                                        "paCode": "1090229",
                                        "yn": "N",
                                        "title": "生皮、皮革处理、鞣制及加工机械零件",
                                        "alias": "生皮、皮革处理、鞣制及加工机械零件",
                                        "about": "组成生皮、皮革处理、鞣制及加工机械和机器的不可分拆的单个制件。",
                                        "kws": null,
                                        "taxName": "皮革专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090229050000000000",
                                        "taxCodeTitle": "皮革专用设备",
                                        "iTitle": "*皮革专用设备*生皮、皮革处理、鞣制及加工机械零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2952",
                                "linkid": "2740",
                                "code": "1090230",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "服装、鞋帽加工机械",
                                "alias": "服装、鞋帽加工机械",
                                "about": null,
                                "kws": "服装加工机械、鞋帽加工机械",
                                "taxName": "服装加工机械",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090230000000000000",
                                "taxCodeTitle": "服装加工机械",
                                "iTitle": "*服装加工机械*服装、鞋帽加工机械",
                                "children": [
                                    {
                                        "id": "2953",
                                        "linkid": "2952",
                                        "code": "109023001",
                                        "paCode": "1090230",
                                        "yn": "N",
                                        "title": "缝纫机及其零件",
                                        "alias": "缝纫机及其零件",
                                        "about": "包括普通家用型缝纫机(作锁式线迹缝纫，装上相应的附件后能作绣花、卷边、镶嵌、锁眼等缝纫的机械)、多功能家用型缝纫机(具有普通家用缝纫机功能，并有多种曲折缝纫功能的缝纫机。如：拼缝、包边、嵌线、锁眼、钉扣，通过花样装置能刺绣图案等。包括机械控制、电子控制和电脑控制的多功能家用型缝纫机)、其他家用型缝纫机(包括家用小包缝机等)、工业用电控平缝机(指用微型计算机控制，具有自动剪线、拔线、倒缝、定位针及抬压脚等功能，直线缝锁式线迹的工业用缝纫机)、工业用相关电控缝纫机(指用微型计算机控制，具有自动剪线、拔线、倒缝",
                                        "kws": "缝纫机",
                                        "taxName": "服装加工机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090230010000000000",
                                        "taxCodeTitle": "服装加工机械",
                                        "iTitle": "*服装加工机械*缝纫机及其零件",
                                        "children": []
                                    },
                                    {
                                        "id": "2954",
                                        "linkid": "2952",
                                        "code": "109023002",
                                        "paCode": "1090230",
                                        "yn": "N",
                                        "title": "服装裁剪定型设备",
                                        "alias": "服装裁剪定型设备",
                                        "about": "包括裁剪机、蒸汽人像机、蒸、烫机、拉布机、粘合机、其他服装裁剪定型设备。",
                                        "kws": "裁剪机、蒸汽人像机、拉布机、粘合机",
                                        "taxName": "服装加工机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090230020000000000",
                                        "taxCodeTitle": "服装加工机械",
                                        "iTitle": "*服装加工机械*服装裁剪定型设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2955",
                                        "linkid": "2952",
                                        "code": "109023003",
                                        "paCode": "1090230",
                                        "yn": "N",
                                        "title": "羽绒加工设备",
                                        "alias": "羽绒加工设备",
                                        "about": "包括羽绒预分机、羽绒除灰机、羽绒四厢分毛机、羽绒洗脱机/水洗机(含RDY30羽绒专用打包机、除灰小样机等辅助设备)、羽绒烘干机（羽绒专用烘干设备）、充绒机（装填绒被褥或褥垫的机械）、其他羽绒加工设备。不包括服装裁剪、缝纫、定型设备（详见109023002）。",
                                        "kws": "充绒机",
                                        "taxName": "服装加工机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090230030000000000",
                                        "taxCodeTitle": "服装加工机械",
                                        "iTitle": "*服装加工机械*羽绒加工设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2956",
                                        "linkid": "2952",
                                        "code": "109023004",
                                        "paCode": "1090230",
                                        "yn": "N",
                                        "title": "制帽机械",
                                        "alias": "制帽机械",
                                        "about": "包括毡呢压机、滚筒压机（用以使帽坯完全毡化）、毡呢帽扩张机（使锥形帽坯进一步成形，并将锥形顶端滚圆）、帽边成形机（帽边通过锥形滚筒时，将其压制成形）、帽坯磨光机（即用浮石或纱布将毡帽坯面上突出的毛发磨去）、帽沿上浆机、楦帽机、沙压机、帽模、其他制帽机械。",
                                        "kws": "制帽机械、毡呢压机、滚筒压机、毡呢帽扩张机、帽边成形机、帽坯磨光机、帽沿上浆机、楦帽机、沙压机、帽模",
                                        "taxName": "服装加工机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090230040000000000",
                                        "taxCodeTitle": "服装加工机械",
                                        "iTitle": "*服装加工机械*制帽机械",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2957",
                                "linkid": "2740",
                                "code": "1090231",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "电工机械专用设备",
                                "alias": "电工机械专用设备",
                                "about": "指电机、电线、电缆等电站、电工专用机械及器材的生产设备。",
                                "kws": "电工机械专用设备",
                                "taxName": "电工机械设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090231000000000000",
                                "taxCodeTitle": "电工机械设备",
                                "iTitle": "*电工机械设备*电工机械专用设备",
                                "children": [
                                    {
                                        "id": "2958",
                                        "linkid": "2957",
                                        "code": "109023101",
                                        "paCode": "1090231",
                                        "yn": "Y",
                                        "title": "电机、变压器专用生产机械",
                                        "alias": "电机、变压器专用生产机械",
                                        "about": "包括铁芯制造专用设备、电机定子铁芯迭压机、自制定子铁芯卷迭机、铁芯叠压机及压装机、其他铁芯制造专用设备。",
                                        "kws": "电机专用生产机械、变压器专用生产机械、铁芯制造专用设备、电机定子铁芯迭压机、自制定子铁芯卷迭机、铁芯叠压机、铁芯压装机",
                                        "taxName": "电工机械设备",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "1090231010000000000",
                                        "taxCodeTitle": "电工机械设备",
                                        "iTitle": "*电工机械设备*电机、变压器专用生产机械",
                                        "children": [
                                            {
                                                "id": "2959",
                                                "linkid": "2958",
                                                "code": "10902310101",
                                                "paCode": "109023101",
                                                "yn": "N",
                                                "title": "线圈绕线机",
                                                "alias": "线圈绕线机",
                                                "about": "包括电线线圈卷绕机、绝缘材料线圈绕线机、线圈包扎设备、定子线圈绕线机、电磁铁线圈绕线机、其他线圈绕线机。",
                                                "kws": "线圈绕线机、电线线圈卷绕机、绝缘材料线圈绕线机、线圈包扎设备、定子线圈绕线机、电磁铁线圈绕线机",
                                                "taxName": "电工机械设备",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090231010100000000",
                                                "taxCodeTitle": "电工机械设备",
                                                "iTitle": "*电工机械设备*线圈绕线机",
                                                "children": []
                                            },
                                            {
                                                "id": "2960",
                                                "linkid": "2958",
                                                "code": "10902310102",
                                                "paCode": "109023101",
                                                "yn": "N",
                                                "title": "嵌线设备",
                                                "alias": "嵌线设备",
                                                "about": "包括绕嵌线机、定子绕组嵌线机、其他嵌线设备。",
                                                "kws": "嵌线设备、绕嵌线机、定子绕组嵌线机",
                                                "taxName": "电工机械设备",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090231010200000000",
                                                "taxCodeTitle": "电工机械设备",
                                                "iTitle": "*电工机械设备*嵌线设备",
                                                "children": []
                                            },
                                            {
                                                "id": "2961",
                                                "linkid": "2958",
                                                "code": "10902310103",
                                                "paCode": "109023101",
                                                "yn": "N",
                                                "title": "绝缘处理设备",
                                                "alias": "绝缘处理设备",
                                                "about": "包括槽绝缘片插入机、自动连续沉浸机、滚浸机、其他绝缘处理设备。",
                                                "kws": "绝缘处理设备、槽绝缘片插入机、自动连续沉浸机、滚浸机",
                                                "taxName": "电工机械设备",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090231010300000000",
                                                "taxCodeTitle": "电工机械设备",
                                                "iTitle": "*电工机械设备*绝缘处理设备",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "2962",
                                        "linkid": "2957",
                                        "code": "109023102",
                                        "paCode": "1090231",
                                        "yn": "N",
                                        "title": "电线、电缆专用生产机械",
                                        "alias": "电线、电缆专用生产机械",
                                        "about": "包括拉线机、型线轧拉机、拉线联合机组、铜粉流屑过滤机、镀锡机、高速绞线机、压出机、其他电线、电缆专用生产机械。",
                                        "kws": "电线专用生产机械、电缆专用生产机械、拉线机、型线轧拉机、拉线联合机组、铜粉流屑过滤机、镀锡机、高速绞线机、压出机",
                                        "taxName": "电工机械设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090231020000000000",
                                        "taxCodeTitle": "电工机械设备",
                                        "iTitle": "*电工机械设备*电线、电缆专用生产机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2963",
                                        "linkid": "2957",
                                        "code": "109023103",
                                        "paCode": "1090231",
                                        "yn": "N",
                                        "title": "电器绝缘材料设备",
                                        "alias": "电器绝缘材料设备",
                                        "about": "包括上胶设备、不干胶带涂机、卷制设备、钢/铝塑热贴复合机组、绝缘材料涂复卷管机、板纸复合机组、其他电器绝缘材料设备。",
                                        "kws": "电器绝缘材料、上胶设备、不干胶带涂机、卷制设备、钢塑热贴复合机组、铝塑热贴复合机组、绝缘材料涂复卷管机、板纸复合机组",
                                        "taxName": "电工机械设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090231030000000000",
                                        "taxCodeTitle": "电工机械设备",
                                        "iTitle": "*电工机械设备*电器绝缘材料设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2964",
                                        "linkid": "2957",
                                        "code": "109023104",
                                        "paCode": "1090231",
                                        "yn": "N",
                                        "title": "电池生产专用设备",
                                        "alias": "电池生产专用设备",
                                        "about": "包括蓄电池流程生产线、圆筒干电池生产线、扣式电池生产线、太阳能电池生产线、其他电池生产专用设备。",
                                        "kws": "蓄电池流程生产线、圆筒干电池生产线、扣式电池生产线、太阳能电池生产线",
                                        "taxName": "电工机械设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090231040000000000",
                                        "taxCodeTitle": "电工机械设备",
                                        "iTitle": "*电工机械设备*电池生产专用设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2965",
                                        "linkid": "2957",
                                        "code": "109023199",
                                        "paCode": "1090231",
                                        "yn": "N",
                                        "title": "其他电工机械专用设备",
                                        "alias": "其他电工机械专用设备",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "电工机械设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090231990000000000",
                                        "taxCodeTitle": "电工机械设备",
                                        "iTitle": "*电工机械设备*其他电工机械专用设备",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2966",
                                "linkid": "2740",
                                "code": "1090232",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "电子工业专用设备",
                                "alias": "电子工业专用设备",
                                "about": "指生产半导体器件、集成电路、电子元件、电真空器件的生产设备，以及电子设备整机装配的生产设备。",
                                "kws": "电子工业专用设备",
                                "taxName": "电子工业设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090232000000000000",
                                "taxCodeTitle": "电子工业设备",
                                "iTitle": "*电子工业设备*电子工业专用设备",
                                "children": [
                                    {
                                        "id": "2967",
                                        "linkid": "2966",
                                        "code": "109023201",
                                        "paCode": "1090232",
                                        "yn": "N",
                                        "title": "半导体材料、器件及集成电路生产设备",
                                        "alias": "半导体材料、器件及集成电路生产设备",
                                        "about": "包括晶体生长及晶圆制备设备、电子材料切片机、电子器件研磨机、电子器件抛光机、硅片倒角机、外延设备。",
                                        "kws": "晶体生长设备、晶圆制备设备、电子材料切片机、电子器件研磨机、电子器件抛光机、硅片倒角机、外延设备",
                                        "taxName": "电子工业设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090232010000000000",
                                        "taxCodeTitle": "电子工业设备",
                                        "iTitle": "*电子工业设备*半导体材料、器件及集成电路生产设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2968",
                                        "linkid": "2966",
                                        "code": "109023202",
                                        "paCode": "1090232",
                                        "yn": "N",
                                        "title": "制版设备",
                                        "alias": "制版设备",
                                        "about": null,
                                        "kws": "制版设备",
                                        "taxName": "电子工业设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090232020000000000",
                                        "taxCodeTitle": "电子工业设备",
                                        "iTitle": "*电子工业设备*制版设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2969",
                                        "linkid": "2966",
                                        "code": "109023203",
                                        "paCode": "1090232",
                                        "yn": "N",
                                        "title": "掩模修补设备",
                                        "alias": "掩模修补设备",
                                        "about": null,
                                        "kws": "掩模修补设备",
                                        "taxName": "电子工业设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090232030000000000",
                                        "taxCodeTitle": "电子工业设备",
                                        "iTitle": "*电子工业设备*掩模修补设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2970",
                                        "linkid": "2966",
                                        "code": "109023204",
                                        "paCode": "1090232",
                                        "yn": "N",
                                        "title": "芯片制造设备",
                                        "alias": "芯片制造设备",
                                        "about": "包括光学光刻设备、电子束光刻机、离子束投影光刻机、邻近X射线光刻机、蚀刻设备、掺杂设备、退火设备、快速热处理设备、薄膜生长设备、化学气相淀积设备、中测设备。",
                                        "kws": "光学光刻设备、电子束光刻机、离子束投影光刻机、邻近X射线光刻机、蚀刻设备、掺杂设备、退火设备、快速热处理设备、薄膜生长设备、化学气相淀积设备、中测设备",
                                        "taxName": "电子工业设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090232040000000000",
                                        "taxCodeTitle": "电子工业设备",
                                        "iTitle": "*电子工业设备*芯片制造设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2971",
                                        "linkid": "2966",
                                        "code": "109023205",
                                        "paCode": "1090232",
                                        "yn": "N",
                                        "title": "封装测试设备",
                                        "alias": "封装测试设备",
                                        "about": "包括晶圆划片设备、贴膜设备、键合设备、芯片贴装机、引线键合机、封装设备、焊凸形成设备。",
                                        "kws": "封装测试设备、晶圆划片设备、贴膜设备、键合设备、芯片贴装机、引线键合机、封装设备、焊凸形成设备",
                                        "taxName": "电子工业设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090232050000000000",
                                        "taxCodeTitle": "电子工业设备",
                                        "iTitle": "*电子工业设备*封装测试设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2972",
                                        "linkid": "2966",
                                        "code": "109023206",
                                        "paCode": "1090232",
                                        "yn": "N",
                                        "title": "检测设备",
                                        "alias": "检测设备",
                                        "about": "包括晶片检测设备、掩膜检查设备、晶圆检测设备、线宽测量设备、终测设备。",
                                        "kws": "晶片检测设备、掩膜检查设备、晶圆检测设备、线宽测量设备、终测设备",
                                        "taxName": "电子工业设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090232060000000000",
                                        "taxCodeTitle": "电子工业设备",
                                        "iTitle": "*电子工业设备*检测设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2973",
                                        "linkid": "2966",
                                        "code": "109023207",
                                        "paCode": "1090232",
                                        "yn": "N",
                                        "title": "电子元件及机电组件生产设备",
                                        "alias": "电子元件及机电组件生产设备",
                                        "about": "包括碳膜、金属膜电阻生产设备、片式电阻、电阻网络生产设备、电感器件、特种变压器生产设备、厚膜电路生产设备、薄膜电路生产设备、电位器生产设备、陶瓷电容器生产设备、薄膜电容器生产设备、铝电解电容器生产设备、敏感元件生产设备、传感器生产设备、压电晶体生产设备、压电陶瓷滤波器生产设备、表面波滤波器生产设备、磁性材料及器件生产设备、电声器件生产设备、开关接插件生产设备、特种线缆加工设备、镍氢电池生产设备、锂离子电池生产设备、太阳能电池片生产设备、其他电子元件及机电组件生产设备。",
                                        "kws": "电子元件生产设备、碳膜生产设备、金属膜电阻生产设备、片式电阻生产设备、电阻网络生产设备、电感器件生产设备、特种变压器生产设备、厚膜电路生产设备、薄膜电路生产设备、电位器生产设备、陶瓷电容器生产设备、薄膜电容器生产设备、铝电解电容器生产设备、敏感元件生产设备、传感器生产设备、压电晶体生产设备、压电陶瓷滤波器生产设备、表面波滤波器生产设备、磁性材料生产设备、磁性材料器件生产设备、电声器件生产设备、开关接插件生产设备、特种线缆加工设备、镍氢电池生产设备、锂离子电池生产设备、太阳能电池片生产设备",
                                        "taxName": "电子工业设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090232070000000000",
                                        "taxCodeTitle": "电子工业设备",
                                        "iTitle": "*电子工业设备*电子元件及机电组件生产设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2974",
                                        "linkid": "2966",
                                        "code": "109023208",
                                        "paCode": "1090232",
                                        "yn": "N",
                                        "title": "电子真空器件生产设备",
                                        "alias": "电子真空器件生产设备",
                                        "about": "包括玻壳生产设备、真空开关管生产设备、彩管生产设备、其他电子真空器件生产设备。",
                                        "kws": "电子真空器件生产设备、玻壳生产设备、真空开关管生产设备、彩管生产设备",
                                        "taxName": "电子工业设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090232080000000000",
                                        "taxCodeTitle": "电子工业设备",
                                        "iTitle": "*电子工业设备*电子真空器件生产设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2975",
                                        "linkid": "2966",
                                        "code": "109023209",
                                        "paCode": "1090232",
                                        "yn": "N",
                                        "title": "平板显示器件（FPD）生产设备",
                                        "alias": "平板显示器件（FPD）生产设备",
                                        "about": "包括液晶显示器件（LCD）生产设备、等离子显示器件（PDP）生产设备、VFD生产设备、其他平板显示器件生产设备。",
                                        "kws": "平板显示器生产设备、液晶显示器件生产设备、等离子显示器件生产设备、VFD生产设备",
                                        "taxName": "电子工业设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090232090000000000",
                                        "taxCodeTitle": "电子工业设备",
                                        "iTitle": "*电子工业设备*平板显示器件（FPD）生产设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2976",
                                        "linkid": "2966",
                                        "code": "109023210",
                                        "paCode": "1090232",
                                        "yn": "N",
                                        "title": "净化设备及类似设备",
                                        "alias": "净化设备及类似设备",
                                        "about": "包括空气净化设备、高纯气体制取设备、超纯水制取设备、废水处理设备、电磁屏蔽设备、防静电设备、其他净化设备及类似设备。",
                                        "kws": "净化设备、空气净化设备、高纯气体制取设备、超纯水制取设备、废水处理设备、电磁屏蔽设备、防静电设备",
                                        "taxName": "电子工业设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090232100000000000",
                                        "taxCodeTitle": "电子工业设备",
                                        "iTitle": "*电子工业设备*净化设备及类似设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2977",
                                        "linkid": "2966",
                                        "code": "109023211",
                                        "paCode": "1090232",
                                        "yn": "N",
                                        "title": "环境模拟和可靠性设备",
                                        "alias": "环境模拟和可靠性设备",
                                        "about": "包括力学试验设备、气候环境模拟试验设备、综合试验箱。",
                                        "kws": "环境模拟和可靠性设备、力学试验设备、气候环境模拟试验设备、综合试验箱",
                                        "taxName": "电子工业设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090232110000000000",
                                        "taxCodeTitle": "电子工业设备",
                                        "iTitle": "*电子工业设备*环境模拟和可靠性设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2978",
                                        "linkid": "2966",
                                        "code": "109023212",
                                        "paCode": "1090232",
                                        "yn": "N",
                                        "title": "电子整机装联设备",
                                        "alias": "电子整机装联设备",
                                        "about": "包括有引线元器件整机装配生产设备、表面贴装（SMT）设备。",
                                        "kws": "电子整机、有引线元器件整机装配生产设备、表面贴装设备",
                                        "taxName": "电子工业设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090232120000000000",
                                        "taxCodeTitle": "电子工业设备",
                                        "iTitle": "*电子工业设备*电子整机装联设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2979",
                                        "linkid": "2966",
                                        "code": "109023299",
                                        "paCode": "1090232",
                                        "yn": "N",
                                        "title": "其他电子工业专用设备",
                                        "alias": "其他电子工业专用设备",
                                        "about": "指未列明的半导体器件和集成电路设备及其他设备",
                                        "kws": null,
                                        "taxName": "电子工业设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090232990000000000",
                                        "taxCodeTitle": "电子工业设备",
                                        "iTitle": "*电子工业设备*其他电子工业专用设备",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2980",
                                "linkid": "2740",
                                "code": "1090233",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "金属处理机械",
                                "alias": "金属处理机械",
                                "about": null,
                                "kws": null,
                                "taxName": "金属处理机械",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090233000000000000",
                                "taxCodeTitle": "金属处理机械",
                                "iTitle": "*金属处理机械*金属处理机械",
                                "children": [
                                    {
                                        "id": "2981",
                                        "linkid": "2980",
                                        "code": "109023301",
                                        "paCode": "1090233",
                                        "yn": "N",
                                        "title": "金属表面处理机械",
                                        "alias": "金属表面处理机械",
                                        "about": "包括全自动氧化生产线、全自动磷化生产线、其他金属表面处理机械含抛丸清理机、钢瓶除锈机、酸洗设备等",
                                        "kws": "金属表面处理机械、全自动氧化生产线、全自动磷化生产线、抛丸清理机、钢瓶除锈机、酸洗设备",
                                        "taxName": "金属处理机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090233010000000000",
                                        "taxCodeTitle": "金属处理机械",
                                        "iTitle": "*金属处理机械*金属表面处理机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2982",
                                        "linkid": "2980",
                                        "code": "109023302",
                                        "paCode": "1090233",
                                        "yn": "N",
                                        "title": "电解设备及装置",
                                        "alias": "电解设备及装置",
                                        "about": "包括电解箱、其他电解设备及装置。",
                                        "kws": "电解箱、电解设备、电解设备装置",
                                        "taxName": "金属处理机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090233020000000000",
                                        "taxCodeTitle": "金属处理机械",
                                        "iTitle": "*金属处理机械*电解设备及装置",
                                        "children": []
                                    },
                                    {
                                        "id": "2983",
                                        "linkid": "2980",
                                        "code": "109023303",
                                        "paCode": "1090233",
                                        "yn": "N",
                                        "title": "电镀设备及装置",
                                        "alias": "电镀设备及装置",
                                        "about": "包括全自动直线形电镀生产线、全自动环形垂直升降生产线、全自动卷对卷连续镀生产线、其他电镀设备及装置。",
                                        "kws": "电镀设备、电镀设备装置、全自动直线形电镀生产线、全自动环形垂直升降生产线、全自动卷对卷连续镀生产线",
                                        "taxName": "金属处理机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090233030000000000",
                                        "taxCodeTitle": "金属处理机械",
                                        "iTitle": "*金属处理机械*电镀设备及装置",
                                        "children": []
                                    },
                                    {
                                        "id": "2984",
                                        "linkid": "2980",
                                        "code": "109023399",
                                        "paCode": "1090233",
                                        "yn": "N",
                                        "title": "其他金属处理机械",
                                        "alias": "其他金属处理机械",
                                        "about": "包括吸引胶管脱铁芯机、钢丝搓齿机",
                                        "kws": "吸引胶管脱铁芯机、钢丝搓齿机",
                                        "taxName": "金属处理机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090233990000000000",
                                        "taxCodeTitle": "金属处理机械",
                                        "iTitle": "*金属处理机械*其他金属处理机械",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2985",
                                "linkid": "2740",
                                "code": "1090234",
                                "paCode": "10902",
                                "yn": "N",
                                "title": "航空、航天设备，相关专用设备",
                                "alias": "航空、航天设备，相关专用设备",
                                "about": "包括航天试验专用设备、宇航模拟设备、其他航天试验专用设备、航天器总装调试设备含电子式飞行模拟器、名为“林克式地面飞行训练器”的设备等、同位素分离机械、装置、生产重水（氧化氘）机械或装置、浓缩铀235机械或装置、电磁式同位素分离器（卡留管）、其他同位素分离机械、装置含零件。",
                                "kws": "航空设备、航天设备、航天试验专用设备、宇航模拟设备、航天器总装调试设备含电子式飞行模拟器、林克式地面飞行训练器、同位素分离机械、装置、生产重水机械、浓缩铀235机械、浓缩铀235机械装置、电磁式同位素分离器",
                                "taxName": "航空航天设备",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1090234000000000000",
                                "taxCodeTitle": "航空航天设备",
                                "iTitle": "*航空航天设备*航空、航天设备，相关专用设备",
                                "children": []
                            },
                            {
                                "id": "2986",
                                "linkid": "2740",
                                "code": "1090235",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "拖拉机及农林牧渔用挂车",
                                "alias": "拖拉机及农林牧渔用挂车",
                                "about": null,
                                "kws": "拖拉机、农林牧渔用挂车",
                                "taxName": "农用车",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090235000000000000",
                                "taxCodeTitle": "农用车",
                                "iTitle": "*农用车*拖拉机及农林牧渔用挂车",
                                "children": [
                                    {
                                        "id": "2987",
                                        "linkid": "2986",
                                        "code": "109023501",
                                        "paCode": "1090235",
                                        "yn": "N",
                                        "title": "拖拉机",
                                        "alias": "拖拉机",
                                        "about": "包括大型拖拉机（配套动力大于等于73.5kW（100马力）的大型轮式拖拉机、大型履带式拖拉机）、中型拖拉机（配套动力为18.4～73.5kW（25～100马力），不含73.5kW（100马力）的中型轮式拖拉机、中型履带式拖拉机）、小型拖拉机（小型四轮拖拉机配套动力小于18.4kW（25马力）、手扶拖拉机、其他小型拖拉机。",
                                        "kws": "拖拉机",
                                        "taxName": "农用车",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "1090235010000000000",
                                        "taxCodeTitle": "农用车",
                                        "iTitle": "*农用车*拖拉机",
                                        "children": []
                                    },
                                    {
                                        "id": "2988",
                                        "linkid": "2986",
                                        "code": "109023502",
                                        "paCode": "1090235",
                                        "yn": "N",
                                        "title": "特种结构拖拉机",
                                        "alias": "特种结构拖拉机",
                                        "about": "包括运输型拖拉机、船式拖拉机（机耕船）、高架拖拉机、坡地拖拉机、其他特种结构拖拉机。",
                                        "kws": "特种结构拖拉机、运输型拖拉机、船式拖拉机、机耕船、高架拖拉机、坡地拖拉机",
                                        "taxName": "农用车",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "1090235020000000000",
                                        "taxCodeTitle": "农用车",
                                        "iTitle": "*农用车*特种结构拖拉机",
                                        "children": []
                                    },
                                    {
                                        "id": "2989",
                                        "linkid": "2986",
                                        "code": "109023503",
                                        "paCode": "1090235",
                                        "yn": "N",
                                        "title": "农林用自装或自卸式挂车",
                                        "alias": "农林用自装或自卸式挂车",
                                        "about": "包括农用半挂车、自装或自卸式挂车、其他农林用自装或自卸式挂车。",
                                        "kws": "农林用自装挂车、农林用自卸式挂车、农用半挂车、农用自装式挂车、农用自卸式挂车",
                                        "taxName": "农用车",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "1090235030000000000",
                                        "taxCodeTitle": "农用车",
                                        "iTitle": "*农用车*农林用自装或自卸式挂车",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "2990",
                                "linkid": "2740",
                                "code": "1090236",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "机械化农业及园艺机具",
                                "alias": "机械化农业及园艺机具",
                                "about": null,
                                "kws": "机械化农业机具、园艺机具",
                                "taxName": "农业机械",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090236000000000000",
                                "taxCodeTitle": "农业机械",
                                "iTitle": "*农业机械*机械化农业及园艺机具",
                                "children": [
                                    {
                                        "id": "2991",
                                        "linkid": "2990",
                                        "code": "109023601",
                                        "paCode": "1090236",
                                        "yn": "N",
                                        "title": "土壤耕整机械",
                                        "alias": "土壤耕整机械",
                                        "about": "指开垦、翻土、耕地、犁地、松土等农用机械。包括耕地机械（翻转犁、铧式犁、圆盘犁、栅条犁、旋耕机、耕整机、微耕机、田园管理机、开沟机（器）、浅松机、深松机、浅耕深松机、机滚船、机耕船、其他耕地机械）、整地机械（钉齿耙、弹齿耙、圆盘耙、滚子耙、驱动耙、起垄机、镇压器、合墒器、灭茬机、其他整地机械）、其他土壤耕整机械。",
                                        "kws": "土壤耕整机械、翻转犁、铧式犁、圆盘犁、栅条犁、旋耕机、耕整机、微耕机、田园管理机、开沟机、开沟机器、浅松机、深松机、浅耕深松机、机滚船、机耕船、整地机械、钉齿耙、弹齿耙、圆盘耙、滚子耙、驱动耙、起垄机、镇压器、合墒器、灭茬机",
                                        "taxName": "农业机械",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "1090236010000000000",
                                        "taxCodeTitle": "农业机械",
                                        "iTitle": "*农业机械*土壤耕整机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2992",
                                        "linkid": "2990",
                                        "code": "109023602",
                                        "paCode": "1090236",
                                        "yn": "N",
                                        "title": "种植施肥机械",
                                        "alias": "种植施肥机械",
                                        "about": "包括播种机械（条播机、穴播机、异性种子播种机、小粒种子播种机、根茎类种子播种机、水稻（水、旱）直播机、撒播机、免耕播种机、其他播种机械）、育苗机械（秧盘播种成套设备、秧田播种机、种子处理设备、营养钵压制机、起苗机、其他育苗机械设备）、栽植机械（蔬菜移栽机、油菜直播机、水稻插秧机、水稻抛秧机、水稻摆秧机、甘蔗种植机、草皮栽补机、树木移栽机、其他栽植机械）、施肥机械（施肥机（化肥）、撒肥机（厩肥）、追肥机、中耕追肥机、其他施肥机械）、地膜机械（地膜覆盖机、残膜回收机、其他地膜机械）、其他种植施肥机械。",
                                        "kws": "种植施肥机械、播种机、条播机、穴播机、水稻直播机、撒播机、育苗机械、秧盘播种成套设备、种子处理设备、营养钵压制机、起苗机、栽植机械、蔬菜移栽机、油菜直播机、水稻插秧机、水稻抛秧机、水稻摆秧机、甘蔗种植机、草皮栽补机、树木移栽机、施肥机械、施肥机、撒肥机、追肥机、中耕追肥机、地膜机械、地膜覆盖机、残膜回收机",
                                        "taxName": "农业机械",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "1090236020000000000",
                                        "taxCodeTitle": "农业机械",
                                        "iTitle": "*农业机械*种植施肥机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2993",
                                        "linkid": "2990",
                                        "code": "109023603",
                                        "paCode": "1090236",
                                        "yn": "N",
                                        "title": "田间管理机械",
                                        "alias": "田间管理机械",
                                        "about": "包括中耕机械（中耕机、培土机、除草机、埋藤机、其他中耕机械）、植保机械（手动喷雾器含背负式、压缩式、踏板式，电动喷雾器含背负式、手提式，机动喷雾喷粉机，机动喷雾机含担架式、推车式，喷杆喷雾机含牵引式、自走式、悬挂式，喷杆喷雾机含牵引式，烟雾机含常温烟雾机、热烟雾机，杀虫灯含灭蛾灯、诱虫灯，其他植保机械）、修剪机械（嫁接设备、茶树修剪机、果树修剪机、草坪修剪机、割灌机（田间机械）、其他修剪机械）、其他田间管理机械。",
                                        "kws": "田间管理机械、中耕机械、中耕机、培土机、除草机、埋藤机、植保机械、手动喷雾器含背负式、压缩式、踏板式、电动喷雾器含背负式、手提式、机动喷雾喷粉机、机动喷雾机含担架式、推车式、喷杆喷雾机含牵引式、自走式、悬挂式、烟雾机含常温烟雾机、热烟雾机、杀虫灯、灭蛾灯、诱虫灯、修剪机械、嫁接设备、茶树修剪机、果树修剪机、草坪修剪机、割灌机",
                                        "taxName": "农业机械",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "1090236030000000000",
                                        "taxCodeTitle": "农业机械",
                                        "iTitle": "*农业机械*田间管理机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2994",
                                        "linkid": "2990",
                                        "code": "109023604",
                                        "paCode": "1090236",
                                        "yn": "N",
                                        "title": "收获机械",
                                        "alias": "收获机械",
                                        "about": "包括谷物收获机械（自走轮式谷物联合收获机（全喂入）、自走履带式谷物联合收获机（全喂入）、背负式谷物联合收割机、牵引式谷物联合收割机、半喂入联合收割机、梳穗联合收割机、大豆收获专用割台、割晒机、割捆机、其他谷物收获机械）、玉米收获机械（背负式玉米收获机、牵引式玉米收获机、自走式玉米联合收获机、穗茎兼收玉米收获机、其他玉米收获机械）、棉麻作物收获机械（棉花收获机、麻类作物收获机、其他棉麻作物收获机械）、果实收获机械（葡萄收获机、果实捡拾机、草莓收获机、其他果实收获机械）、蔬菜收获机械（豆类蔬菜收获机、叶类蔬菜",
                                        "kws": "收获机、收割机、大豆收获专用割台、割晒机、割捆机、采收机械、采茶机、药材挖掘机、甘蔗割铺机、甘蔗剥叶机、割草机、翻晒机、搂草机、捡拾压捆机、压捆机、茎秆收集处理机械、秸秆粉碎还田机、高秆作物割晒机",
                                        "taxName": "农业机械",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "1090236040000000000",
                                        "taxCodeTitle": "农业机械",
                                        "iTitle": "*农业机械*收获机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2995",
                                        "linkid": "2990",
                                        "code": "109023605",
                                        "paCode": "1090236",
                                        "yn": "N",
                                        "title": "收获后处理机械",
                                        "alias": "收获后处理机械",
                                        "about": "脱粒机械（稻麦脱粒机、玉米脱粒机、脱扬机、其他脱粒机械）、清选机械（粮食清选机、种子清选机、甜菜清理机、籽棉清理机、扬场机、其他清选机械）、剥壳（去皮）机械（玉米剥壳机、花生脱壳机、棉籽剥壳机、干坚果脱壳机、青豆脱壳机、大蒜去皮机、其他剥壳（去皮）机械）、农产品干燥机械（粮食烘干机、种子烘干机、籽棉烘干机、果蔬烘干机、药材烘干机、油菜籽烘干机、其他农产品干燥机械）、种子加工机械（脱芒（绒）机、种子分级机、种子包衣机、种子加工机组、种子丸化处理机、棉籽脱绒成套设备、其他种子加工机械）、仓储机械（金属筒仓、输",
                                        "kws": "收获后处理机械、脱粒机、脱扬机、清选机、清理机、扬场机、剥壳机、脱壳机、去皮机、农产品干燥机械、烘干机、种子加工机、脱芒机、脱绒机、种子分级机、种子包衣机、种子加工机组、种子丸化处理机、棉籽脱绒成套设备、输粮机、简易保鲜储藏设备",
                                        "taxName": "农业机械",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "1090236050000000000",
                                        "taxCodeTitle": "农业机械",
                                        "iTitle": "*农业机械*收获后处理机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2996",
                                        "linkid": "2990",
                                        "code": "109023606",
                                        "paCode": "1090236",
                                        "yn": "N",
                                        "title": "设施农业设备",
                                        "alias": "设施农业设备",
                                        "about": "指专门用于设施农业的设备。包括日光温室设施设备、塑料大棚设施设备、连栋温室设施设备、其他设施农业设备。",
                                        "kws": "设施农业设备、日光温室设施设备、塑料大棚设施设备、连栋温室设施设备",
                                        "taxName": "农业机械",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "1090236060000000000",
                                        "taxCodeTitle": "农业机械",
                                        "iTitle": "*农业机械*设施农业设备",
                                        "children": []
                                    },
                                    {
                                        "id": "2997",
                                        "linkid": "2990",
                                        "code": "109023607",
                                        "paCode": "1090236",
                                        "yn": "N",
                                        "title": "农田基本建设机械",
                                        "alias": "农田基本建设机械",
                                        "about": "包括农田挖掘机械（农田挖掘机、开沟机（开渠用）、农田挖坑机、农田推土机、其他农田挖掘机械）、农田平地机械（农田平地机、农田铲运机、其他农田平地机械）、其他农田基本建设机械。",
                                        "kws": "农田基本建设机械、挖掘机、开沟机、农田挖坑机、推土机、平地机",
                                        "taxName": "农业机械",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "1090236070000000000",
                                        "taxCodeTitle": "农业机械",
                                        "iTitle": "*农业机械*农田基本建设机械",
                                        "children": []
                                    },
                                    {
                                        "id": "2998",
                                        "linkid": "2990",
                                        "code": "109023608",
                                        "paCode": "1090236",
                                        "yn": "Y",
                                        "title": "喷灌机械设备",
                                        "alias": "喷灌机械设备",
                                        "about": "包括草坪、果园等用的喷水器及喷雾器，不包括农用水泵（详见109011702）。",
                                        "kws": "喷灌机械设备",
                                        "taxName": "农业机械",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "1090236080000000000",
                                        "taxCodeTitle": "农业机械",
                                        "iTitle": "*农业机械*喷灌机械设备",
                                        "children": [
                                            {
                                                "id": "2999",
                                                "linkid": "2998",
                                                "code": "10902360801",
                                                "paCode": "109023608",
                                                "yn": "N",
                                                "title": "微灌设备",
                                                "alias": "微灌设备",
                                                "about": "包括微喷、滴灌、渗灌设备",
                                                "kws": "微灌设备、微喷设备、滴灌设备、渗灌设备",
                                                "taxName": "农业机械",
                                                "taxRate": "",
                                                "vip": null,
                                                "itaxRate": null,
                                                "taxCode": "1090236080100000000",
                                                "taxCodeTitle": "农业机械",
                                                "iTitle": "*农业机械*微灌设备",
                                                "children": []
                                            },
                                            {
                                                "id": "3000",
                                                "linkid": "2998",
                                                "code": "10902360899",
                                                "paCode": "109023608",
                                                "yn": "N",
                                                "title": "其他喷灌机械设备",
                                                "alias": "其他喷灌机械设备",
                                                "about": null,
                                                "kws": null,
                                                "taxName": "农业机械",
                                                "taxRate": "",
                                                "vip": null,
                                                "itaxRate": null,
                                                "taxCode": "1090236089900000000",
                                                "taxCodeTitle": "农业机械",
                                                "iTitle": "*农业机械*其他喷灌机械设备",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "3001",
                                        "linkid": "2990",
                                        "code": "109023609",
                                        "paCode": "1090236",
                                        "yn": "N",
                                        "title": "园艺、草坪专用机械",
                                        "alias": "园艺、草坪专用机械",
                                        "about": "包括无土栽培机械和设施、草坪及运动场地滚压机、草坪机动割草机、起草皮机、其他园艺、草坪专用机械",
                                        "kws": "园艺专用机械、草坪专用机械、无土栽培机械、草坪滚压机、运动场地滚压机、草坪机动割草机、起草皮机",
                                        "taxName": "农业机械",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "1090236090000000000",
                                        "taxCodeTitle": "农业机械",
                                        "iTitle": "*农业机械*园艺、草坪专用机械",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3002",
                                "linkid": "2740",
                                "code": "1090237",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "营林及木竹采伐机械",
                                "alias": "营林及木竹采伐机械",
                                "about": null,
                                "kws": "营林采伐机械、木竹采伐机械",
                                "taxName": "农业机械",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090237000000000000",
                                "taxCodeTitle": "农业机械",
                                "iTitle": "*农业机械*营林及木竹采伐机械",
                                "children": [
                                    {
                                        "id": "3003",
                                        "linkid": "3002",
                                        "code": "109023701",
                                        "paCode": "1090237",
                                        "yn": "N",
                                        "title": "林地清理机械",
                                        "alias": "林地清理机械",
                                        "about": "指清除灌木丛、矮林丛的茎、树根等用机械，包括割灌机（林地机械）、除灌机、挖坑机、其他林地清理机械。",
                                        "kws": "林地清理机械、割灌机、除灌机、挖坑机",
                                        "taxName": "农业机械",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "1090237010000000000",
                                        "taxCodeTitle": "农业机械",
                                        "iTitle": "*农业机械*林地清理机械",
                                        "children": []
                                    },
                                    {
                                        "id": "3004",
                                        "linkid": "3002",
                                        "code": "109023702",
                                        "paCode": "1090237",
                                        "yn": "N",
                                        "title": "造林机械",
                                        "alias": "造林机械",
                                        "about": "包括植树机（植树器）、容器苗栽植机、飞机播种装置、树木挖根机、树木移植机、树木削枝机、其他造林机械",
                                        "kws": "造林机械、植树机、植树器、容器苗栽植机、飞机播种装置、树木挖根机、树木移植机、树木削枝机",
                                        "taxName": "农业机械",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "1090237020000000000",
                                        "taxCodeTitle": "农业机械",
                                        "iTitle": "*农业机械*造林机械",
                                        "children": []
                                    },
                                    {
                                        "id": "3005",
                                        "linkid": "3002",
                                        "code": "109023703",
                                        "paCode": "1090237",
                                        "yn": "N",
                                        "title": "营林机械",
                                        "alias": "营林机械",
                                        "about": "包括林木种子加工机械、采种机、树木种子处理及脱粒机。",
                                        "kws": "营林机械、林木种子加工机械、采种机、树木种子处理机、树木种子脱粒机",
                                        "taxName": "农业机械",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "1090237030000000000",
                                        "taxCodeTitle": "农业机械",
                                        "iTitle": "*农业机械*营林机械",
                                        "children": []
                                    },
                                    {
                                        "id": "3006",
                                        "linkid": "3002",
                                        "code": "109023704",
                                        "paCode": "1090237",
                                        "yn": "N",
                                        "title": "风力灭火机具",
                                        "alias": "风力灭火机具",
                                        "about": "包括风力灭火机、风力灭火器。",
                                        "kws": "#风力灭火机、风力灭火器",
                                        "taxName": "农业机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090237040000000000",
                                        "taxCodeTitle": "农业机械",
                                        "iTitle": "*农业机械*风力灭火机具",
                                        "children": []
                                    },
                                    {
                                        "id": "3007",
                                        "linkid": "3002",
                                        "code": "109023705",
                                        "paCode": "1090237",
                                        "yn": "N",
                                        "title": "竹木采集机械",
                                        "alias": "竹木采集机械",
                                        "about": "包括伐木机、伐木集材机、树桩挖除机、竹木材出河机、摇树机、其他竹木采集机械。",
                                        "kws": "竹木采集机械、伐木机、伐木集材机、树桩挖除机、竹木材出河机、摇树机",
                                        "taxName": "农业机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090237050000000000",
                                        "taxCodeTitle": "农业机械",
                                        "iTitle": "*农业机械*竹木采集机械",
                                        "children": []
                                    },
                                    {
                                        "id": "3008",
                                        "linkid": "3002",
                                        "code": "109023706",
                                        "paCode": "1090237",
                                        "yn": "N",
                                        "title": "木材运输机械",
                                        "alias": "木材运输机械",
                                        "about": "包括运材挂车、其他木材运输机械。",
                                        "kws": "木材运输机械、运材挂车",
                                        "taxName": "农业机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090237060000000000",
                                        "taxCodeTitle": "农业机械",
                                        "iTitle": "*农业机械*木材运输机械",
                                        "children": []
                                    },
                                    {
                                        "id": "3009",
                                        "linkid": "3002",
                                        "code": "109023707",
                                        "paCode": "1090237",
                                        "yn": "N",
                                        "title": "木生产专用工具",
                                        "alias": "木生产专用工具",
                                        "about": "包括原木装车机、抓具、木材出河机、木材装载机、编扎机、装排机。",
                                        "kws": "木生产专用工具、原木装车机、抓具、木材出河机、木材装载机、编扎机、装排机",
                                        "taxName": "农业机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090237070000000000",
                                        "taxCodeTitle": "农业机械",
                                        "iTitle": "*农业机械*木生产专用工具",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3010",
                                "linkid": "2740",
                                "code": "1090238",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "畜牧机械",
                                "alias": "畜牧机械",
                                "about": null,
                                "kws": null,
                                "taxName": "农业机械",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090238000000000000",
                                "taxCodeTitle": "农业机械",
                                "iTitle": "*农业机械*畜牧机械",
                                "children": [
                                    {
                                        "id": "3011",
                                        "linkid": "3010",
                                        "code": "109023801",
                                        "paCode": "1090238",
                                        "yn": "N",
                                        "title": "草原建设机械",
                                        "alias": "草原建设机械",
                                        "about": "包括牧草补播种机、草地深松机、网围栏设备、其他草原建设机械。",
                                        "kws": "草原建设机械、牧草补播种机、草地深松机、草地网围栏设备",
                                        "taxName": "农业机械",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "1090238010000000000",
                                        "taxCodeTitle": "农业机械",
                                        "iTitle": "*农业机械*草原建设机械",
                                        "children": []
                                    },
                                    {
                                        "id": "3012",
                                        "linkid": "3010",
                                        "code": "109023802",
                                        "paCode": "1090238",
                                        "yn": "N",
                                        "title": "饲料（草）加工机械设备",
                                        "alias": "饲料（草）加工机械设备",
                                        "about": "包括青贮切碎机、铡草机、揉丝机、压块机、饲料粉碎机（畜牧机械）、饲料混合机（畜牧机械）、饲料破碎机、饲料分级筛、饲料打浆机、颗粒饲料压制机、饲料搅拌机、饲料加工成套设备、饲料膨化机（畜牧机械）、其他饲料（草）加工机械设备。",
                                        "kws": "饲料加工机械设备、饲草加工机械设备、青贮切碎机、铡草机、揉丝机、压块机、畜牧饲料粉碎机、畜牧饲料混合机、饲料破碎机、饲料分级筛、饲料打浆机、颗粒饲料压制机、饲料搅拌机、饲料加工成套设备、畜牧饲料膨化机",
                                        "taxName": "农业机械",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "1090238020000000000",
                                        "taxCodeTitle": "农业机械",
                                        "iTitle": "*农业机械*饲料（草）加工机械设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3013",
                                        "linkid": "3010",
                                        "code": "109023803",
                                        "paCode": "1090238",
                                        "yn": "N",
                                        "title": "畜牧饲养机械",
                                        "alias": "畜牧饲养机械",
                                        "about": "包括孵化机、育雏保温伞、螺旋喂料机、送料机、饮水器、清粪机（车）、鸡笼鸡架、消毒机、药浴机、网围栏、其他畜牧饲养机械。",
                                        "kws": "畜牧饲养机械、孵化机、育雏保温伞、螺旋喂料机、畜牧送料机、畜牧饮水器、畜牧清粪机、畜牧清粪车、鸡笼鸡架、畜牧消毒机、畜牧药浴机",
                                        "taxName": "农业机械",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "1090238030000000000",
                                        "taxCodeTitle": "农业机械",
                                        "iTitle": "*农业机械*畜牧饲养机械",
                                        "children": []
                                    },
                                    {
                                        "id": "3014",
                                        "linkid": "3010",
                                        "code": "109023804",
                                        "paCode": "1090238",
                                        "yn": "N",
                                        "title": "畜产品采集加工机械设备",
                                        "alias": "畜产品采集加工机械设备",
                                        "about": "包括挤奶机、剪羊毛机、牛奶分离机、储奶罐、家禽脱羽设备、家禽浸烫设备、生猪浸烫设备、生猪刮毛设备、屠宰加工成套设备、其他畜产品采集加工机械设备。",
                                        "kws": "畜产品采集加工机械设备、挤奶机、剪羊毛机、牛奶分离机、储奶罐、家禽脱羽设备、家禽浸烫设备、生猪浸烫设备、生猪刮毛设备、屠宰加工成套设备",
                                        "taxName": "农业机械",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "1090238040000000000",
                                        "taxCodeTitle": "农业机械",
                                        "iTitle": "*农业机械*畜产品采集加工机械设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3015",
                                        "linkid": "3010",
                                        "code": "109023805",
                                        "paCode": "1090238",
                                        "yn": "N",
                                        "title": "养蜂设备",
                                        "alias": "养蜂设备",
                                        "about": "包括榨蜜机、巢础机、蜂巢重熔用热水浴器、其他养蜂设备。",
                                        "kws": "养蜂设备、榨蜜机、巢础机、蜂巢重熔用热水浴器",
                                        "taxName": "农业机械",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "1090238050000000000",
                                        "taxCodeTitle": "农业机械",
                                        "iTitle": "*农业机械*养蜂设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3016",
                                        "linkid": "3010",
                                        "code": "109023899",
                                        "paCode": "1090238",
                                        "yn": "N",
                                        "title": "其他畜牧机械",
                                        "alias": "其他畜牧机械",
                                        "about": "指其他畜禽动物饲养机械",
                                        "kws": null,
                                        "taxName": "农业机械",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "1090238990000000000",
                                        "taxCodeTitle": "农业机械",
                                        "iTitle": "*农业机械*其他畜牧机械",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3017",
                                "linkid": "2740",
                                "code": "1090239",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "渔业捕捞养殖机械",
                                "alias": "渔业捕捞养殖机械",
                                "about": null,
                                "kws": null,
                                "taxName": "农业机械",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090239000000000000",
                                "taxCodeTitle": "农业机械",
                                "iTitle": "*农业机械*渔业捕捞养殖机械",
                                "children": [
                                    {
                                        "id": "3018",
                                        "linkid": "3017",
                                        "code": "109023901",
                                        "paCode": "1090239",
                                        "yn": "N",
                                        "title": "渔业养殖机械",
                                        "alias": "渔业养殖机械",
                                        "about": "包括投饵机械、增氧机械、工厂化养殖机械、网箱养殖设备、藻类养殖机械、水体净化处理设备、水产品采集机械、其他渔业养殖机械。",
                                        "kws": "渔业养殖机械、投饵机械、增氧机械、工厂化养殖机械、网箱养殖设备、藻类养殖机械、水体净化处理设备、水产品采集机械",
                                        "taxName": "农业机械",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "1090239010000000000",
                                        "taxCodeTitle": "农业机械",
                                        "iTitle": "*农业机械*渔业养殖机械",
                                        "children": []
                                    },
                                    {
                                        "id": "3019",
                                        "linkid": "3017",
                                        "code": "109023902",
                                        "paCode": "1090239",
                                        "yn": "N",
                                        "title": "捕捞机械",
                                        "alias": "捕捞机械",
                                        "about": "包括绞钢机械、起网机械、起钓机械、绞贝类捕捞机械、其他捕捞机械。",
                                        "kws": "捕捞机械、绞钢机械、起网机械、起钓机械、绞贝类捕捞机械",
                                        "taxName": "农业机械",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "1090239020000000000",
                                        "taxCodeTitle": "农业机械",
                                        "iTitle": "*农业机械*捕捞机械",
                                        "children": []
                                    },
                                    {
                                        "id": "3020",
                                        "linkid": "3017",
                                        "code": "109023903",
                                        "paCode": "1090239",
                                        "yn": "N",
                                        "title": "鱼货起卸设备",
                                        "alias": "鱼货起卸设备",
                                        "about": "包括船用吸鱼机、码头吸鱼机、鱼货出舱机、其他鱼货起卸设备。",
                                        "kws": "鱼货起卸设备、船用吸鱼机、码头吸鱼机、鱼货出舱机",
                                        "taxName": "农业机械",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "1090239030000000000",
                                        "taxCodeTitle": "农业机械",
                                        "iTitle": "*农业机械*鱼货起卸设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3021",
                                        "linkid": "3017",
                                        "code": "109023904",
                                        "paCode": "1090239",
                                        "yn": "N",
                                        "title": "渔业织网机械",
                                        "alias": "渔业织网机械",
                                        "about": "包括织网机、编网机、绕线机、整经机（捕捞机械）。",
                                        "kws": "渔业织网机械、织网机、编网机、绕线机、整经机、捕捞机械",
                                        "taxName": "农业机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090239040000000000",
                                        "taxCodeTitle": "农业机械",
                                        "iTitle": "*农业机械*渔业织网机械",
                                        "children": []
                                    },
                                    {
                                        "id": "3022",
                                        "linkid": "3017",
                                        "code": "109023905",
                                        "paCode": "1090239",
                                        "yn": "N",
                                        "title": "网片处理机械",
                                        "alias": "网片处理机械",
                                        "about": "包括网片定型机、网片拉伸机、网片染色机、网片脱水机。",
                                        "kws": "网片处理机械、网片定型机、网片拉伸机、网片染色机、网片脱水机",
                                        "taxName": "农业机械",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "1090239050000000000",
                                        "taxCodeTitle": "农业机械",
                                        "iTitle": "*农业机械*网片处理机械",
                                        "children": []
                                    },
                                    {
                                        "id": "3023",
                                        "linkid": "3017",
                                        "code": "109023999",
                                        "paCode": "1090239",
                                        "yn": "N",
                                        "title": "其他渔业捕捞养殖机械",
                                        "alias": "其他渔业捕捞养殖机械",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "农业机械",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "1090239990000000000",
                                        "taxCodeTitle": "农业机械",
                                        "iTitle": "*农业机械*其他渔业捕捞养殖机械",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3024",
                                "linkid": "2740",
                                "code": "1090240",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "农产品初加工机械",
                                "alias": "农产品初加工机械",
                                "about": null,
                                "kws": "农产品初加工机械",
                                "taxName": "农业机械",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090240000000000000",
                                "taxCodeTitle": "农业机械",
                                "iTitle": "*农业机械*农产品初加工机械",
                                "children": [
                                    {
                                        "id": "3025",
                                        "linkid": "3024",
                                        "code": "109024001",
                                        "paCode": "1090240",
                                        "yn": "N",
                                        "title": "碾米机",
                                        "alias": "碾米机",
                                        "about": "包括碾米机、砻谷机、谷糙分离机、砻碾组合米机、碾米加工成套设备、其他碾米机械。",
                                        "kws": "碾米机、砻谷机、谷糙分离机、砻碾组合米机、碾米加工成套设备",
                                        "taxName": "农业机械",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "1090240010000000000",
                                        "taxCodeTitle": "农业机械",
                                        "iTitle": "*农业机械*碾米机",
                                        "children": []
                                    },
                                    {
                                        "id": "3026",
                                        "linkid": "3024",
                                        "code": "109024002",
                                        "paCode": "1090240",
                                        "yn": "N",
                                        "title": "磨粉（浆）机械",
                                        "alias": "磨粉（浆）机械",
                                        "about": "包括打麦机、洗麦机、磨粉机、面粉加工成套设备、磨浆机、其他磨粉（浆）机械。",
                                        "kws": "磨粉机械、磨浆机械、打麦机、洗麦机、磨粉机、面粉加工成套设备、磨浆机",
                                        "taxName": "农业机械",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "1090240020000000000",
                                        "taxCodeTitle": "农业机械",
                                        "iTitle": "*农业机械*磨粉（浆）机械",
                                        "children": []
                                    },
                                    {
                                        "id": "3027",
                                        "linkid": "3024",
                                        "code": "109024003",
                                        "paCode": "1090240",
                                        "yn": "N",
                                        "title": "茶叶加工机械",
                                        "alias": "茶叶加工机械",
                                        "about": "包括杀青机、揉捻机、切茶机、炒茶机、拣梗机、茶叶压实机械、茶叶加工成套机械、茶叶炒（烘）干机、茶叶萎凋机、茶叶揉切机、茶叶解块筛选机、茶叶发酵机、茶叶烘干机、茶叶筛分机、茶叶风选机、茶叶炒车机、茶叶切细机、特种茶叶加工机械、其他茶叶加工机械。",
                                        "kws": "茶叶加工机械、杀青机、揉捻机、切茶机、炒茶机、拣梗机、茶叶压实机械、茶叶加工成套机械、茶叶炒干机、茶叶烘干机、茶叶萎凋机、茶叶揉切机、茶叶解块筛选机、茶叶发酵机、茶叶筛分机、茶叶风选机、茶叶炒车机、茶叶切细机、特种茶叶加工机械",
                                        "taxName": "农业机械",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "1090240030000000000",
                                        "taxCodeTitle": "农业机械",
                                        "iTitle": "*农业机械*茶叶加工机械",
                                        "children": []
                                    },
                                    {
                                        "id": "3028",
                                        "linkid": "3024",
                                        "code": "109024004",
                                        "paCode": "1090240",
                                        "yn": "N",
                                        "title": "纺织纤维初加工机械",
                                        "alias": "纺织纤维初加工机械",
                                        "about": "包括棉花加工机械（轧花机、皮棉清理机、剥绒机、棉花打包机、其他棉花加工机械）、麻类加工机械（刮麻机、剥麻机、洗麻机、其他麻类加工机械）、蚕丝捻丝前预处理机（蚕茧成套剥衣机、抽丝用容器、其他蚕丝捻丝前预处理机）、其他纺织纤维初加工机械（含除去生丝纱上瘤节、粗丝等用的机械）。",
                                        "kws": "纺织纤维初加工机械、棉花加工机械、轧花机、皮棉清理机、剥绒机、棉花打包机、麻类加工机械、刮麻机、剥麻机、洗麻机、蚕丝捻丝前预处理机、蚕茧成套剥衣机、抽丝用容器",
                                        "taxName": "农业机械",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "1090240040000000000",
                                        "taxCodeTitle": "农业机械",
                                        "iTitle": "*农业机械*纺织纤维初加工机械",
                                        "children": []
                                    },
                                    {
                                        "id": "3029",
                                        "linkid": "3024",
                                        "code": "109024005",
                                        "paCode": "1090240",
                                        "yn": "N",
                                        "title": "农产品清洁、分选机械",
                                        "alias": "农产品清洁、分选机械",
                                        "about": "包括蛋类清洁、分选机械（蛋类光电检验器、蛋类光电分级器、其他蛋类清洁、分选机械）、种子、谷物清洁、分选机械（谷物清洁机及分级机、磁性分级机、电磁分级机、谷物或干豆去壳机、风选机、分级簸扬机、旋转簸扬机、种子或谷物挑选机、筛选带、种子专用分选、分级机械、清洁、分选及分级操作联合机械、其他种子、谷物清洁、分选机械）、果蔬清洁、分选机械（水果分级机、水果打蜡机、蔬菜清洗机、薯类分级机、蔬菜分级机、其他果蔬清洁、分选机械）。",
                                        "kws": "农产品清洁分选机械、蛋类清洁、分选机械、蛋类光电检验器、蛋类光电分级器、谷物清洁机、谷物分级机、磁性分级机、电磁分级机、去壳机、风选机、分级簸扬机、旋转簸扬机、挑选机、筛选带、水果分级机、水果打蜡机、蔬菜清洗机、薯类分级机、蔬菜分级机",
                                        "taxName": "农业机械",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "1090240050000000000",
                                        "taxCodeTitle": "农业机械",
                                        "iTitle": "*农业机械*农产品清洁、分选机械",
                                        "children": []
                                    },
                                    {
                                        "id": "3030",
                                        "linkid": "3024",
                                        "code": "109024006",
                                        "paCode": "1090240",
                                        "yn": "N",
                                        "title": "农用包装机械",
                                        "alias": "农用包装机械",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "农业机械",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "1090240060000000000",
                                        "taxCodeTitle": "农业机械",
                                        "iTitle": "*农业机械*农用包装机械",
                                        "children": []
                                    },
                                    {
                                        "id": "3031",
                                        "linkid": "3024",
                                        "code": "109024007",
                                        "paCode": "1090240",
                                        "yn": "N",
                                        "title": "竹、藤、棕、草材料制品加工机械",
                                        "alias": "竹、藤、棕、草材料制品加工机械",
                                        "about": "指用柳条、竹料、藤、草、木条、塑料等编织篮筐等的机械。包括柳条、藤条加工机械（柳条、藤条等剥皮、分切、削圆等加工机械），柳竹藤草、塑料编织机械，其他竹、藤、棕、草材料制品加工机械。",
                                        "kws": "竹材料制品加工机械、藤材料制品加工机械、棕材料制品加工机械、草材料制品加工机械、柳条加工机械、藤条加工机械、柳竹藤草、编席机、用草编织瓶罩机、编织篮筐",
                                        "taxName": "农业机械",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "1090240070000000000",
                                        "taxCodeTitle": "农业机械",
                                        "iTitle": "*农业机械*竹、藤、棕、草材料制品加工机械",
                                        "children": []
                                    },
                                    {
                                        "id": "3032",
                                        "linkid": "3024",
                                        "code": "109024099",
                                        "paCode": "1090240",
                                        "yn": "N",
                                        "title": "其他农产品初加工机械",
                                        "alias": "其他农产品初加工机械",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "农业机械",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "1090240990000000000",
                                        "taxCodeTitle": "农业机械",
                                        "iTitle": "*农业机械*其他农产品初加工机械",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3033",
                                "linkid": "2740",
                                "code": "1090241",
                                "paCode": "10902",
                                "yn": "N",
                                "title": "农林牧渔机械零配件",
                                "alias": "农林牧渔机械零配件",
                                "about": "包括拖拉机零配件、农用喷射机械或器具零件、整地或耕作机械零件（农业、园艺及林业用整地或耕作机械的零件）、作物收获机械零件（包括作物收割、脱粒、打包机械的零件）、联合收割机零件、其他作物收获机械零件、畜牧业机械零件、家禽饲养、孵卵及育雏机械零件、挤奶机零件（包括供挤奶机用的桶、盖、脉动器、挤奶杯及其配件）、其他畜牧业机械零件。",
                                "kws": "农林牧渔机械零配件、拖拉机零配件、农用喷射机械零件、农用喷射机械器具零件、整地机械零件、耕作机械零件、农业园艺林业用整地机械零件、作物收获机械零件、作物收割脱粒打包机械零件、联合收割机零件、家禽饲养、孵卵机械零件、育雏机械零件、挤奶机零件、供挤奶机用桶、供挤奶机用盖、供挤奶机用脉动器、供挤奶机用挤奶杯、供挤奶机用桶配件、供挤奶机用盖配件、供挤奶机用脉动器配件、供挤奶机用挤奶杯配件",
                                "taxName": "农业机械",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1090241000000000000",
                                "taxCodeTitle": "农业机械",
                                "iTitle": "*农业机械*农林牧渔机械零配件",
                                "children": []
                            },
                            {
                                "id": "3034",
                                "linkid": "2740",
                                "code": "1090242",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "医疗仪器设备及器械",
                                "alias": "医疗仪器设备及器械",
                                "about": null,
                                "kws": null,
                                "taxName": "医疗仪器器械",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090242000000000000",
                                "taxCodeTitle": "医疗仪器器械",
                                "iTitle": "*医疗仪器器械*医疗仪器设备及器械",
                                "children": [
                                    {
                                        "id": "3035",
                                        "linkid": "3034",
                                        "code": "109024201",
                                        "paCode": "1090242",
                                        "yn": "N",
                                        "title": "医用X射线设备",
                                        "alias": "医用X射线设备",
                                        "about": "包括X射线诊断设备（常规透视用X射线机、乳腺X射线机、泌尿系统诊断X射线机、胃肠检查用X射线机、X射线骨密度测量设备、摄影用X射线机、骨科X射线设备、胸部荧光缩影X射线装置、数字减影X射线机、便携式X射线机、其他X射线诊断设备）、射线断层摄影设备（CT机）（头部CT机、全身CT机、螺旋CT机、螺旋扇扫CT机、其他射线断层摄影设备）、牙科用X射线应用设备（牙科（单牙）X射线机、口腔颔面全景X射线机含全颔X射线机、其他牙科用X射线应用设备）、医疗用X射线应用设备（深层治疗X射线设备、浅层治疗X射线设备、接触治",
                                        "kws": "医用X射线设备、X射线、射线断层摄影设备、CT机",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090242010000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*医用X射线设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3036",
                                        "linkid": "3034",
                                        "code": "109024202",
                                        "paCode": "1090242",
                                        "yn": "N",
                                        "title": "X射线附属设备及部件",
                                        "alias": "X射线附属设备及部件",
                                        "about": "包括X射线管、X光发生器、检查用家具及医用射线设备零件。X射线管、管组件或源组件含工业用、其他用途的X光管（X射线管、医用固定阳极X射线管、旋转阳极X射线管、X射线CT管、栅极X射线管及管组件含栅极X射线管及管组件、源组件、其他X射线附属设备及部件指其他医用X射线管及管组件、源组件）、X射线相关附属设备及部件（X射线影像增强器、医用透视荧光屏、医用增感屏含医用中速、高速增感屏、牙用增感屏、X光发生器、其他X射线相关附属设备及部件）、医用X射线机配套用家具（X射线检查用电动胃肠床、电动摄影平床、电动导管床、",
                                        "kws": "X射线附属设备、X射线附属部件",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090242020000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*X射线附属设备及部件",
                                        "children": []
                                    },
                                    {
                                        "id": "3037",
                                        "linkid": "3034",
                                        "code": "109024203",
                                        "paCode": "1090242",
                                        "yn": "N",
                                        "title": "医用α、β、γ射线应用设备",
                                        "alias": "医用α、β、γ射线应用设备",
                                        "about": "包括医用高能射线治疗设备（医用电子直线加速器、医用回旋加速器、医用中子治疗机、医用质子治疗机、其他医用高能射线治疗设备）、医用放射性核素诊断设备（PECT（正电子发射断层扫描装置）、SPECT（单光子发射断层扫描装置）、放射性核素透视机、r射线探测仪、放射性核素扫描仪、甲状腺放射性核素显像、放射性核素骨密度测量设备、核素听诊器、其他医用放射性核素诊断设备）、医用放射性核素治疗设备（钴60治疗机、核素后装近距离治疗机、医用核素远距离治疗装置、植入式放射源、其他医用放射性核素治疗设备）、核素标本测定装置（放射",
                                        "kws": "医用射线应用设备、医用高能射线治疗设备、医用电子直线加速器、医用回旋加速器、医用中子治疗机、医用质子治疗机、医用放射性核素诊断设备、PECT、正电子发射断层扫描装置、SPECT、单光子发射断层扫描装置、放射性核素透视机、r射线探测仪、放射性核素扫描仪、甲状腺放射性核素显像、放射性核素骨密度测量设备、核素听诊器、医用放射性核素治疗设备、钴60治疗机、核素后装近距离治疗机、医用核素远距离治疗装置、植入式放射源、核素标本测定装置、放射免疫测定仪、医用离子射线检验设备",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090242030000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*医用α、β、γ射线应用设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3038",
                                        "linkid": "3034",
                                        "code": "109024204",
                                        "paCode": "1090242",
                                        "yn": "N",
                                        "title": "医用超声诊断、治疗仪器及设备",
                                        "alias": "医用超声诊断、治疗仪器及设备",
                                        "about": "包括医用超声诊断仪器设备（B型超声波诊断仪含眼科专用B超诊断仪、便携式B型超声诊断设备、其他B型超声波诊断仪，彩色超声波诊断仪含全数字化复合式彩超仪、超声彩色血流成像设备、“模-数”复合式专用型彩超仪、机械扇形或复合式彩超仪，M型超声波诊断仪，A型超声波诊断仪含眼科专用A超诊断仪器，C型超声波诊断仪，超声多普勒设备含经颅超声多普勒设备、超声多普勒胎音（心）仪，超声血流检测设备，超声骨密度检测设备含超声骨密度（骨质）仪，超声胃镜，超声结肠镜，超声内窥镜，超声宫内镜，复合式扫描超声诊断仪，相控阵超声诊断仪，多",
                                        "kws": "医用超声诊断仪器",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090242040000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*医用超声诊断、治疗仪器及设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3039",
                                        "linkid": "3034",
                                        "code": "109024205",
                                        "paCode": "1090242",
                                        "yn": "N",
                                        "title": "医用电气诊断仪器及装置",
                                        "alias": "医用电气诊断仪器及装置",
                                        "about": "包括功能检查或生理参数检查用装置。心电诊断仪器（心电图记录仪含胎儿心电图机、心电向量图机、单导心电图机、多导心电图机、心电图综合测试仪，心音描记器指以心音图形式记录心脏声音的专门仪器，也可作为心电图记录仪使用，心动冲击图仪器，心磁图仪器，心输出量测定仪器，心脏检查器，心电阻描记器指测量由心功能所引起的电阻变化用的电气设备，心电分析仪含心电多相分析仪，晚电位测试仪，无损伤心功能检测仪，心率变异性检测仪，运动心电功量计，心电遥测仪，心电电话传递系统，实时心律分析记录仪，长程心电记录仪，心电标测图仪，心电工作站",
                                        "kws": "医用电气诊断仪器、医用电气诊断仪器装置、心电诊断仪器、心电图记录仪含胎儿心电图机、心电向量图机、单导心电图机、多导心电图机、心电图综合测试仪、心音描记器、动冲击图仪器、心磁图仪器、心输出量测定仪器、心脏检查器、心电阻描记器、心电分析仪、心电多相分析仪、晚电位测试仪、无损伤心功能检测仪、心率变异性检测仪、运动心电功量计、心电遥测仪、心电电话传递系统、实时心律分析记录仪、长程心电记录仪、心电标测图仪、心电工作站、脑电诊断仪器、脑电图机、脑电阻仪、脑电流描记器、脑电波分析仪、脑地形图仪、脑电实时分析记录仪、医用",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090242050000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*医用电气诊断仪器及装置",
                                        "children": []
                                    },
                                    {
                                        "id": "3040",
                                        "linkid": "3034",
                                        "code": "109024206",
                                        "paCode": "1090242",
                                        "yn": "N",
                                        "title": "医用激光诊断、治疗仪器及设备",
                                        "alias": "医用激光诊断、治疗仪器及设备",
                                        "about": "包括激光诊断仪器（氦镉激光器、激光白内障诊断装置、激光眼科诊断仪、激光肿瘤光谱诊断装置、激光荧光肿瘤诊断仪、眼科激光扫描仪、2类（弱激光）激光诊断仪、激光血液分析仪、激光多普勒血流仪、其他激光诊断仪器）、激光手术和治疗设备（气体激光手术设备、眼科激光光凝机、固体激光手术设备、3B类半导体激光治疗仪、4类（强激光）半导体激光治疗仪、氮分子激光治疗仪、晶体激光乳化设备、激光血管焊接机、介入式激光诊治仪器含He-Ne激光血管内照射治疗仪、其他激光手术和治疗设备）、弱激光体外治疗仪器（氦氖激光治疗机、氦镉激光治疗",
                                        "kws": "医用激光诊断仪器",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090242060000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*医用激光诊断、治疗仪器及设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3041",
                                        "linkid": "3034",
                                        "code": "109024207",
                                        "paCode": "1090242",
                                        "yn": "N",
                                        "title": "医用高频仪器设备",
                                        "alias": "医用高频仪器设备",
                                        "about": "包括高频手术和电凝设备（高频电刀、高频扁桃体手术器、高频息肉手术器、高频眼科电凝器、内窥镜高频手术器、后尿道电切开刀、高频腋臭治疗仪、高频鼻甲电凝器、高频痔疮治疗仪、射频控温热凝器、其他高频手术和电凝设备）、高频电熨设备（高频电灼器、高频妇科电熨器、高频五官科电熨器、其他高频电熨设备）",
                                        "kws": "#高频电刀、高频扁桃体手术器、高频息肉手术器、高频眼科电凝器、内窥镜高频手术器、后尿道电切开刀、高频腋臭治疗仪、高频鼻甲电凝器、高频痔疮治疗仪、射频控温热凝器、高频电灼器、高频妇科电熨器、高频五官科电熨器",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090242070000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*医用高频仪器设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3042",
                                        "linkid": "3034",
                                        "code": "109024208",
                                        "paCode": "1090242",
                                        "yn": "N",
                                        "title": "微波、射频、高频诊断治疗设备",
                                        "alias": "微波、射频、高频诊断治疗设备",
                                        "about": "包括微波诊断设备（微波肿瘤诊断仪、其他微波诊断设备）、微波治疗设备（微波手术刀、微波肿瘤热疗仪、微波前列腺治疗仪、微波治疗机、其他微波治疗设备）、射频治疗设备（射频前列腺治疗仪、射频消融治疗仪、内生物肿瘤热疗系统、肿瘤射频热疗机、短波治疗机、超短波电疗机、其他射频治疗设备）、高频电极装置（电凝钳、电凝镊、手术电极、其他高频电极装置）、其他微波、射频、高频诊断治疗设备",
                                        "kws": "微波诊断治疗设备、射频诊断治疗设备、热疗诊断治疗设备、电凝诊断治疗设备",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090242080000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*微波、射频、高频诊断治疗设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3043",
                                        "linkid": "3034",
                                        "code": "109024209",
                                        "paCode": "1090242",
                                        "yn": "N",
                                        "title": "中医诊断、治疗仪器设备",
                                        "alias": "中医诊断、治疗仪器设备",
                                        "about": "包括中医诊断仪器（中医诊断仪、痛阈测量仪、经络分析仪、其他中医诊断仪器）、中医治疗仪器（综合电针仪、电麻仪、定量针麻仪、电子穴位测定治疗仪、探穴针麻仪、穴位测试仪、耳穴探测治疗机、其他中医治疗仪器）",
                                        "kws": "中医诊断设备、中医治疗设备",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090242090000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*中医诊断、治疗仪器设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3044",
                                        "linkid": "3034",
                                        "code": "109024210",
                                        "paCode": "1090242",
                                        "yn": "N",
                                        "title": "病人监护设备及器具",
                                        "alias": "病人监护设备及器具",
                                        "about": "包括无创病人监护仪器（心律失常监护报警器、麻醉气体监护扩护仪、呼吸功能监护仪、睡眠监护评价系统、分娩监护仪、带T段分析监护仪、其他无创病人监护仪器）、有创式电生理仪器（体外震波碎石机、病人有创监护系统、颅内压监护仪、有创心输出量计、有创多导生理记录仪、心内希氏束电图机、心内外膜标测图仪、有创性电子血压计、其他有创式电生理仪器）生物反馈仪（肌电生物反馈仪、温度生物反馈仪、心率反馈仪、其他生物反馈仪）、体外反搏及其辅助循环装置（气囊式体外反搏装置、睡眠呼吸治疗系统、心电电极、心电导联线、其他体外反搏及其辅助循",
                                        "kws": "监护仪、记录仪、反馈仪",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090242100000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*病人监护设备及器具",
                                        "children": []
                                    },
                                    {
                                        "id": "3045",
                                        "linkid": "3034",
                                        "code": "109024211",
                                        "paCode": "1090242",
                                        "yn": "N",
                                        "title": "临床检验分析仪器及诊断系统",
                                        "alias": "临床检验分析仪器及诊断系统",
                                        "about": "包括血液分析仪器设备（血红蛋白测定仪、血小板聚集仪、全自动血细胞分析仪、全自动涂片机、流式细胞分析仪、全自动凝血纤溶分析仪、半自动血细胞分析仪、血凝分析仪、自动血库系统、血糖分析仪、血流变仪、血液粘度计、红细胞变形仪、血液流变参数测试仪、血栓弹力仪、其他血液分析仪器设备）、血气分析系统（全自动血气分析仪、组织氧含量测定仪、血氧饱和度测试仪、CO2红外分析仪、经皮血氧分压监测仪、血气酸碱分析仪、电化学测氧仪、其他血气分析系统）、生理研究实验仪器（方波生理仪、生物电脉冲分析仪、生物电脉冲频率分析仪、微电极控制",
                                        "kws": "临床检验分析仪器、临床检验诊断系统",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090242110000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*临床检验分析仪器及诊断系统",
                                        "children": []
                                    },
                                    {
                                        "id": "3046",
                                        "linkid": "3034",
                                        "code": "109024212",
                                        "paCode": "1090242",
                                        "yn": "N",
                                        "title": "医用电泳仪",
                                        "alias": "医用电泳仪",
                                        "about": "包括低压电泳仪、中压电泳仪、高压电泳仪",
                                        "kws": "电泳仪",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090242120000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*医用电泳仪",
                                        "children": []
                                    },
                                    {
                                        "id": "3047",
                                        "linkid": "3034",
                                        "code": "109024213",
                                        "paCode": "1090242",
                                        "yn": "N",
                                        "title": "医用化验和基础设备器具",
                                        "alias": "医用化验和基础设备器具",
                                        "about": "包括医用培养箱主要由透明塑料制的箱体、电气加温装置、安全报警装置、氧气及空气过滤和调节装置组成（CO2培养箱、超净恒温培养箱、厌氧培养装置、其他医用培养箱）、病理分析前处理设备（切片机（医用）、整体切片机、自动组织脱水机、染色机、包埋机、组织处理机、其他病理分析前处理设备）、血液化验器具（红白血球吸管、采血管含定量采血管、真空采血管、微量血液搅拌器、微量血液振荡器、其他血液化验器具）、其他医用化验和基础设备器具。",
                                        "kws": "医用培养箱、CO2培养箱、超净恒温培养箱、厌氧培养装置、病理分析前处理设备、医用切片机、整体切片机、自动组织脱水机、染色机、包埋机、组织处理机、血液化验器具、红白血球吸管、采血管、微量血液搅拌器、微量血液振荡器",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090242130000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*医用化验和基础设备器具",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3048",
                                "linkid": "2740",
                                "code": "1090243",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "口腔科用设备及器具",
                                "alias": "口腔科用设备及器具",
                                "about": null,
                                "kws": null,
                                "taxName": "医疗仪器器械",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090243000000000000",
                                "taxCodeTitle": "医疗仪器器械",
                                "iTitle": "*医疗仪器器械*口腔科用设备及器具",
                                "children": [
                                    {
                                        "id": "3049",
                                        "linkid": "3048",
                                        "code": "109024301",
                                        "paCode": "1090243",
                                        "yn": "N",
                                        "title": "牙钻机",
                                        "alias": "牙钻机",
                                        "about": "包括电动牙钻机、涡轮牙钻机、其他牙钻机。",
                                        "kws": "牙钻机",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090243010000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*牙钻机",
                                        "children": []
                                    },
                                    {
                                        "id": "3050",
                                        "linkid": "3048",
                                        "code": "109024302",
                                        "paCode": "1090243",
                                        "yn": "N",
                                        "title": "口腔综合治疗设备",
                                        "alias": "口腔综合治疗设备",
                                        "about": "指装有牙科设备的牙科用椅。包括牙科综合治疗机、牙科综合治疗台、其他口腔综合治疗设备",
                                        "kws": "#牙科综合治疗机、牙科综合治疗台",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090243020000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*口腔综合治疗设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3051",
                                        "linkid": "3048",
                                        "code": "109024303",
                                        "paCode": "1090243",
                                        "yn": "N",
                                        "title": "牙钻机配件",
                                        "alias": "牙钻机配件",
                                        "about": "包括牙钻机专用牙钻、牙钻机专用金刚砂片、牙钻机专用刷子、其他牙钻机配件",
                                        "kws": "牙钻机配件",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090243030000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*牙钻机配件",
                                        "children": []
                                    },
                                    {
                                        "id": "3052",
                                        "linkid": "3048",
                                        "code": "109024304",
                                        "paCode": "1090243",
                                        "yn": "N",
                                        "title": "牙科手机",
                                        "alias": "牙科手机",
                                        "about": "包括牙科直手机、连扣直手机、牙科弯手机、连扣弯手机、低速牙科手机、涡轮手机、电动手机、其他牙科手机",
                                        "kws": "牙科直手机、连扣直手机、牙科弯手机、连扣弯手机、低速牙科手机、涡轮手机、电动手机",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090243040000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*牙科手机",
                                        "children": []
                                    },
                                    {
                                        "id": "3053",
                                        "linkid": "3048",
                                        "code": "109024305",
                                        "paCode": "1090243",
                                        "yn": "N",
                                        "title": "洁牙、补牙设备",
                                        "alias": "洁牙、补牙设备",
                                        "about": "包括牙根管长度测定仪、牙打磨机、牙抛光机、牙冠机、光固化机（器）、医用洁牙机、牙髓活力测试仪、根管治疗仪、包埋材料搅拌机、其他洁牙、补牙设备",
                                        "kws": "牙根管长度测定仪、牙打磨机、牙抛光机、牙冠机、光固化机、医用洁牙机、牙髓活力测试仪、根管治疗仪、包埋材料搅拌机",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090243050000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*洁牙、补牙设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3054",
                                        "linkid": "3048",
                                        "code": "109024306",
                                        "paCode": "1090243",
                                        "yn": "N",
                                        "title": "口腔综合治疗设备配件",
                                        "alias": "口腔综合治疗设备配件",
                                        "about": "包括三用喷枪、强力吸引器、吸唾器、电动抽吸系统、牙模测试仪、银汞调和器、其他口腔综合治疗设备配件",
                                        "kws": "三用喷枪、强力吸引器、吸唾器、电动抽吸系统、牙模测试仪、银汞调和器",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090243060000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*口腔综合治疗设备配件",
                                        "children": []
                                    },
                                    {
                                        "id": "3055",
                                        "linkid": "3048",
                                        "code": "109024307",
                                        "paCode": "1090243",
                                        "yn": "N",
                                        "title": "口腔科手术器械",
                                        "alias": "口腔科手术器械",
                                        "about": "包括口腔科用刀(粘固粉调刀、牙龈刀、水门调刀、蜡型雕刻刀、石膏切刀、调刀等)、口腔科用凿(阻生牙骨凿、牙釉凿、牙骨凿)、口腔科用剪(牙龈剪、金冠剪等)、口腔科用牙钳(牙槽咬骨钳、拔牙钳、切断牙钳、舌钳、根钳、扩大钳等)、口腔科用牙挺(牙根尖挺、丁字形牙挺)、口腔科专用镊、夹(牙用镊（棉花镊）、成形片夹、残根镊（牙根镊）、长镊)、切除颌骨用器械(切除颌骨及上颌窦的牙骨凿、牙骨锤、牙骨膜分离器、牙龈分离器、骨刮、牙用锉、牙骨剪及类似器械)",
                                        "kws": "口腔科用刀、粘固粉调刀、牙龈刀、水门调刀、蜡型雕刻刀、石膏切刀、口腔科用凿、阻生牙骨凿、牙釉凿、牙骨凿、口腔科用剪、牙龈剪、金冠剪、口腔科用牙钳、牙槽咬骨钳、拔牙钳、切断牙钳、舌钳、根钳、扩大钳、口腔科用牙挺、牙根尖挺、丁字形牙挺、口腔科专用镊、夹牙用镊、棉花镊、成形片夹、残根镊、牙根镊、切除颌骨用器械、切除颌骨上颌窦牙骨凿、牙骨锤、牙骨膜分离器、牙龈分离器、骨刮锉、牙用锉、牙骨剪",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090243070000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*口腔科手术器械",
                                        "children": []
                                    },
                                    {
                                        "id": "3056",
                                        "linkid": "3048",
                                        "code": "109024308",
                                        "paCode": "1090243",
                                        "yn": "N",
                                        "title": "口腔治疗用器械",
                                        "alias": "口腔治疗用器械",
                                        "about": "包括治疗牙神经用器械包括牙探针、脓肿探针、牙周袋探针（刻度牙探针）、神经钩、神经针、神经探寻器、拔髓针及其他拔出器，清洁牙龈及牙槽专用器械包括治疗牙石、牙垢的牙刮器、刮匙及牙釉质凿，口腔镜，口腔治疗用枪头包括水枪头、热气枪头，口腔治疗通用器械包括汞合金输送器、研光器、根管充填器、粘固粉充填器、银汞合金充填器、去冠器、咬合器、弓形成型器、磨牙带环就位器，其他口腔治疗用器械包括拔髓针柄、吹火管、印模托盘、煮牙盒、结扎杆、带环推子",
                                        "kws": "治疗牙神经用器械、牙探针、脓肿探针、牙周袋探针、刻度牙探针、牙神经钩、牙神经针、神经探寻器、牙拔髓针、牙刮器、牙刮匙、牙釉质凿、口腔镜、口腔治疗用枪头、口腔治疗用水枪头、口腔治疗用热气枪头、口腔治疗通用器械、汞合金输送器、牙研光器、牙根管充填器、牙粘固粉充填器、牙银汞合金充填器、牙去冠器、牙咬合器、牙弓形成型器、磨牙带环就位器、牙拔髓针柄、口腔治疗用吹火管、口腔治疗用印模托盘、口腔治疗用煮牙盒、口腔治疗用结扎杆、口腔治疗用带环推子",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090243080000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*口腔治疗用器械",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3057",
                                "linkid": "2740",
                                "code": "1090244",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "医用消毒灭菌设备",
                                "alias": "医用消毒灭菌设备",
                                "about": "包括实验室及医用消毒、灭菌设备和器具",
                                "kws": null,
                                "taxName": "医疗仪器器械",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090244000000000000",
                                "taxCodeTitle": "医疗仪器器械",
                                "iTitle": "*医疗仪器器械*医用消毒灭菌设备",
                                "children": [
                                    {
                                        "id": "3058",
                                        "linkid": "3057",
                                        "code": "109024401",
                                        "paCode": "1090244",
                                        "yn": "N",
                                        "title": "热力消毒设备及器具",
                                        "alias": "热力消毒设备及器具",
                                        "about": "指普通消毒设备及器具，包括压力蒸汽灭菌设备（立式、卧式矩形、卧式圆形压力蒸汽灭菌器）、干热消毒灭菌设备、煮沸消毒设备（电热煮沸消毒器、自动控制电热煮沸消毒器）、其他热力消毒设备及器具",
                                        "kws": "压力蒸汽灭菌设备、干热消毒灭菌设备、煮沸消毒设备",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090244010000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*热力消毒设备及器具",
                                        "children": []
                                    },
                                    {
                                        "id": "3059",
                                        "linkid": "3057",
                                        "code": "109024402",
                                        "paCode": "1090244",
                                        "yn": "N",
                                        "title": "气体消毒灭菌设备",
                                        "alias": "气体消毒灭菌设备",
                                        "about": "包括环氧乙烷灭菌器、轻便型自动气体灭菌器、其他气体消毒灭菌设备",
                                        "kws": "环氧乙烷灭菌器、轻便型自动气体灭菌器",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090244020000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*气体消毒灭菌设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3060",
                                        "linkid": "3057",
                                        "code": "109024403",
                                        "paCode": "1090244",
                                        "yn": "N",
                                        "title": "特种消毒灭菌设备",
                                        "alias": "特种消毒灭菌设备",
                                        "about": "包括辐射消毒灭菌设备（医用伽玛r射线灭菌装置、紫外线消毒器、红外线灭菌器等）、超声波消毒设备、微波消毒设备、真空蒸气灭菌器（预真空蒸气灭菌器）、脉动真空压力蒸汽灭菌器、高压电离灭菌设备（手术室用高压电离灭菌设备、病房用高压电离灭菌设备）、医用内窥镜清洗机、其他特种消毒灭菌设备",
                                        "kws": "辐射消毒灭菌设备、超声波消毒设备、微波消毒设备、真空蒸气灭菌器、高压电离灭菌设备、医用内窥镜清洗机",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090244030000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*特种消毒灭菌设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3061",
                                        "linkid": "3057",
                                        "code": "109024404",
                                        "paCode": "1090244",
                                        "yn": "N",
                                        "title": "医用消毒灭菌器具",
                                        "alias": "医用消毒灭菌器具",
                                        "about": "指医疗器械配套消毒灭菌器具，包括灭菌指示条、其他医用消毒灭菌器具。",
                                        "kws": "医用消毒灭菌器具、灭菌指示条",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090244040000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*医用消毒灭菌器具",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3062",
                                "linkid": "2740",
                                "code": "1090245",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "医疗、外科及兽医用器械",
                                "alias": "医疗、外科及兽医用器械",
                                "about": null,
                                "kws": null,
                                "taxName": "医疗仪器器械",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090245000000000000",
                                "taxCodeTitle": "医疗仪器器械",
                                "iTitle": "*医疗仪器器械*医疗、外科及兽医用器械",
                                "children": [
                                    {
                                        "id": "3063",
                                        "linkid": "3062",
                                        "code": "109024501",
                                        "paCode": "1090245",
                                        "yn": "N",
                                        "title": "诊断专用器械",
                                        "alias": "诊断专用器械",
                                        "about": "包括体温计、听诊器、叩诊锤（无电能）、血压测量仪器及器具、测颅器、骨盆测量器，呼吸功能测定装置、诊察治疗设备、检镜及反光器具、其他诊断专用器械。",
                                        "kws": "体温计、无电能体温计、电能体温计、听诊器、叩诊锤、血压测量仪器、血压测量器具、血压计、电子血压计、表面张力计、示波计、测颅器、骨盆测量器、呼吸功能测定装置、综合肺功能测定器、呼吸功能测试仪、肺通气功能测试仪、肺内气体分布功能测试仪、电能肺量计、肺活量计、诊察治疗设备、舌象仪、脉象仪、脑脊液贮存器、耳鼻喉科检查治疗台、耳鼻喉科检镜、反光器具、额带反光镜、电额灯、反光喉镜",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090245010000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*诊断专用器械",
                                        "children": []
                                    },
                                    {
                                        "id": "3064",
                                        "linkid": "3062",
                                        "code": "109024502",
                                        "paCode": "1090245",
                                        "yn": "N",
                                        "title": "内窥镜",
                                        "alias": "内窥镜",
                                        "about": "包括诊断用内窥镜（观察用硬管内窥镜-膀胱镜、诊断用纤维内窥镜-支气管镜包括支气管电子内窥镜、诊断用纤维内窥镜-上消化道镜包括上消化道电子内窥镜、诊断用纤维内窥镜-结肠镜包括结肠电子内窥镜、诊断用纤维内窥镜-大肠镜包括大肠电子内窥镜、观察用硬管内窥镜-喉镜、观察用硬管内窥镜-鼻镜、观察用硬管内窥镜-子宫镜、观察用硬管内窥镜-直肠镜、观察用硬管内窥镜-羊水镜、内窥镜冷光源、胰腺电子内窥镜、其他诊断用内窥镜）、手术用窥镜包括心血管、有创、腔内手术用窥镜（有创内窥镜-腹腔镜、有创内窥镜-关节镜、有创内窥镜-肾镜、",
                                        "kws": "内窥镜",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090245020000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*内窥镜",
                                        "children": []
                                    },
                                    {
                                        "id": "3065",
                                        "linkid": "3062",
                                        "code": "109024503",
                                        "paCode": "1090245",
                                        "yn": "N",
                                        "title": "注射穿刺器械",
                                        "alias": "注射穿刺器械",
                                        "about": "包括注射器不论是否装有针头包括普通注射器、穿刺注射器、麻醉注射器、冲洗注射器、伤口清洗注射器、吸引器（带或不带唧筒）、眼、耳或喉的注射器、子宫及其他妇科注射器（玻璃注射器、一次性注射器、其他注射器）、管状金属针头包括结扎针、接种针、验血针、皮下注射针等（静脉采血针、一次性注射针、一次性静脉输液针、一次性使用光纤针、留置针）、医用缝合针、套针包括穿刺用套针、胆囊套针、普通套针等、套管、插管、导管、吸管及类似品、其他注射穿刺器械",
                                        "kws": "注射器、吸引器、管状金属针头、结扎针、接种针、验血针、注射针、静脉采血针、一次性静脉输液针、一次性使用光纤针、留置针、医用缝合针、套针、穿刺用套针、胆囊套针、普通套针、套管、插管、导管、吸管",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090245030000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*注射穿刺器械",
                                        "children": []
                                    },
                                    {
                                        "id": "3066",
                                        "linkid": "3062",
                                        "code": "109024504",
                                        "paCode": "1090245",
                                        "yn": "N",
                                        "title": "眼科专用仪器及器具",
                                        "alias": "眼科专用仪器及器具",
                                        "about": "包括视轴矫正或视力检查用设备、眼科诊断用设备。弱视镜、眼膜曲率器视网膜镜、斜视镜、角膜散光计、角膜镜、验光镜箱眼压计、开睑器、检眼镜、其他眼科专用仪器及器具含支承验光镜片的试镜架、视力测定尺、测试表等。",
                                        "kws": "弱视镜、眼膜曲率器视网膜镜、斜视镜、角膜散光计、角膜镜、验光镜箱眼压计、开睑器、检眼镜、试镜架、视力测定尺、视力测试表",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090245040000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*眼科专用仪器及器具",
                                        "children": []
                                    },
                                    {
                                        "id": "3067",
                                        "linkid": "3062",
                                        "code": "109024505",
                                        "paCode": "1090245",
                                        "yn": "N",
                                        "title": "兽医专用仪器及机械",
                                        "alias": "兽医专用仪器及机械",
                                        "about": "包括阉割、牲畜生产用仪器及器械（去势器、阉割夹钳、割虎钳及镊子、卵巢切除器械、产科专用钳子及钩子、牲畜生产机械助产器、其他牲畜生产用仪器及器械含产科专用索带、头围等）、牲畜乳房疾病治疗仪器（乳头扩张器、乳头穿刺探针、母牛产褥热治疗器械、母牛生乳热治疗器械、其他牲畜乳房疾病治疗仪器）、其他兽医专用器械（人工授精器、剪尾器、截角器、器官疾病治疗喷雾器含治疗动物呼吸、消化、泌尿、生殖等器官疾病的喷雾器、专用控制器械即在手术时防止挣扎用的开口器、脚枷等、药物特殊注射器含准备装填麻醉药或其他药剂（抗血清、疫苗等）、",
                                        "kws": "阉割去势器、阉割夹钳、阉割虎钳、阉割夹钳镊子、阉割虎钳镊子、卵巢切除器械、产科专用钳子、产科专用钩子、牲畜生产机械助产器、牲畜乳房疾病治疗仪器、乳头扩张器、乳头穿刺探针、母牛产褥热治疗器械、母牛生乳热治疗器械、人工授精器、剪尾器、截角器、器官疾病治疗喷雾器、专用控制器械、药物特殊注射器、远距离注射器、投药器械、检查鸡雏雌雄用内窥器",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090245050000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*兽医专用仪器及机械",
                                        "children": []
                                    },
                                    {
                                        "id": "3068",
                                        "linkid": "3062",
                                        "code": "109024506",
                                        "paCode": "1090245",
                                        "yn": "N",
                                        "title": "外科手术器械",
                                        "alias": "外科手术器械",
                                        "about": "包括显微外科手术器械、显微外科用刀、凿、显微外科用剪、显微外科用钳、显微外科用镊、夹、显微外科用针、钩、显微合拢器、其他显微外科手术器械、基础外科手术器械、通用外科用刀、通用外科用剪、通用外科用钳、通用外科用镊、夹、通用外科用针、钩、通用外科用开口器、通用外科用皮肤刮匙、其他基础外科手术器械、神经外科手术器械、神经外科脑内用刀、神经外科脑内用钳、神经外科脑内用镊、神经外科脑内用钩、神经外科脑内用刮匙、后颅凹牵开器、脑膜剥离器、脑活检抽吸器、脑吸引器、脑打针锤、手摇颅骨钻、其他神经外科手术器械、眼科手术器械",
                                        "kws": "显微外科手术器械、显微外科用刀、显微外科用凿、显微外科用剪、显微外科用钳、显微外科用镊、显微外科用夹、显微外科用针、显微外科用钩、显微合拢器、基础外科手术器械、通用外科用刀、通用外科用剪、通用外科用钳、通用外科用镊、通用外科用夹、通用外科用针、通用外科用钩、通用外科用开口器、通用外科用皮肤刮匙、神经外科手术器械、神经外科脑内用刀、神经外科脑内用钳、神经外科脑内用镊、神经外科脑内用钩、神经外科脑内用刮匙、后颅凹牵开器、脑膜剥离器、脑活检抽吸器、脑吸引器、脑打针锤、手摇颅骨钻、眼科手术器械、眼科手术用刀剪、眼",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090245060000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*外科手术器械",
                                        "children": []
                                    },
                                    {
                                        "id": "3069",
                                        "linkid": "3062",
                                        "code": "109024507",
                                        "paCode": "1090245",
                                        "yn": "N",
                                        "title": "手术室、急救室、诊疗室设备及器具",
                                        "alias": "手术室、急救室、诊疗室设备及器具",
                                        "about": "包括输血设备、单采血浆机、人体血液处理机、腹水浓缩机、血液成分输血装置、血液成分分离机、血液过滤装置、血液净化管路、人工心肺机血路、自体血回输装置、吸附器、血液解毒（灌流灌注）器、血液净化体外循环血路（管道）、其他输血设备、麻醉设备及附件、立式麻醉机、综合麻醉机、小儿麻醉机、麻醉开口器、麻醉咽喉镜、麻醉面罩、其他麻醉设备及附件、呼吸机、电动呼吸机、气动呼吸机、高频喷射呼吸机、同步呼吸机、其他呼吸机、呼吸设备配件、手术及急救装置、止血带、输液、注射辅助装置、洗胃机、灌肠机（医疗）、洗肠机、胃肠冲吸器、胃肠减",
                                        "kws": "输血设备、单采血浆机、人体血液处理机、腹水浓缩机、血液成分输血装置、血液成分分离机、血液过滤装置、血液净化管路、人工心肺机血路、自体血回输装置、吸附器、血液解毒器、血液灌流灌注器、血液净化体外循环血路、血液净化体外循环血管道、麻醉设备、麻醉设备附件、立式麻醉机、综合麻醉机、小儿麻醉机、麻醉开口器、麻醉咽喉镜、麻醉面罩、呼吸机、电动呼吸机、气动呼吸机、高频喷射呼吸机、同步呼吸机、呼吸设备配件、手术装置、急救装置、止血带、输液注射辅助装置、洗胃机、灌肠机、洗肠机、胃肠冲吸器、胃肠减压器、输卵管通气机、负压吸引",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090245070000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*手术室、急救室、诊疗室设备及器具",
                                        "children": []
                                    },
                                    {
                                        "id": "3070",
                                        "linkid": "3062",
                                        "code": "109024508",
                                        "paCode": "1090245",
                                        "yn": "N",
                                        "title": "中医治疗器具",
                                        "alias": "中医治疗器具",
                                        "about": "包括中医用针、中医用钩、叉（含针灸针（毫针）、皮肤针（七星针、梅花针）、三棱针）、灸类器械、拔火罐类器械含负压罐、中医骨伤器具、其他中医治疗器具（含小针刀、刮痧板）。",
                                        "kws": "中医用针、中医用钩、中医用叉、中医用灸类器械、拔火罐类器械、中医骨伤器具",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090245080000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*中医治疗器具",
                                        "children": []
                                    },
                                    {
                                        "id": "3071",
                                        "linkid": "3062",
                                        "code": "109024599",
                                        "paCode": "1090245",
                                        "yn": "N",
                                        "title": "其他医疗、外科及兽医用器械",
                                        "alias": "其他医疗、外科及兽医用器械",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090245990000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*其他医疗、外科及兽医用器械",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3072",
                                "linkid": "2740",
                                "code": "1090246",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "机械治疗及病房护理设备",
                                "alias": "机械治疗及病房护理设备",
                                "about": null,
                                "kws": null,
                                "taxName": "医疗仪器器械",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090246000000000000",
                                "taxCodeTitle": "医疗仪器器械",
                                "iTitle": "*医疗仪器器械*机械治疗及病房护理设备",
                                "children": [
                                    {
                                        "id": "3073",
                                        "linkid": "3072",
                                        "code": "109024601",
                                        "paCode": "1090246",
                                        "yn": "N",
                                        "title": "机械治疗器具",
                                        "alias": "机械治疗器具",
                                        "about": "包括电动按摩器具、震颤按摩器、超声波安眠器、磁力按摩床、按摩褥垫、其他电动按摩器具、手动式按摩器、手握式按摩圈、足底按摩轮、橡胶滚筒按摩器具、其他手动式按摩器、机械疗法器械、上肢综合训练器、手指功能恢复器具、旋转活动脚部器具、活动躯干器具、练习行走器具、下肢康复运动器、机动式多功能器具、其他机械疗法器械、氧气治疗器、空气加压氧舱、氧气加压氧舱、其他氧气治疗器、臭氧治疗器、喷雾治疗器、人工呼吸器、心理功能测验装置、测验下意识反应能力装置、测验肢体灵巧程度装置、旋转椅、智商测试装置、其他心理功能测验装置、牵引",
                                        "kws": "按摩安眠器、超声波安眠器、上肢综合训练器、手指功能恢复器具、旋转活动脚部器具、活动躯干器具、练习行走器具、下肢康复运动器、机动式多功能器具、氧气治疗器、空气加压氧舱、氧气加压氧舱、臭氧治疗器、喷雾治疗器、人工呼吸器、心理功能测验装置、测验下意识反应能力装置、测验肢体灵巧程度装置、智商测试装置、胸背部矫正装置、防治打鼾器械、仿真性辅助器具",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090246010000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*机械治疗器具",
                                        "children": []
                                    },
                                    {
                                        "id": "3074",
                                        "linkid": "3072",
                                        "code": "109024602",
                                        "paCode": "1090246",
                                        "yn": "N",
                                        "title": "电疗仪器",
                                        "alias": "电疗仪器",
                                        "about": "包括音频电疗机、差频电疗机、体内低频脉冲治疗仪、电化学癌症治疗机、离子导入治疗仪、高压低频脉冲治疗机、高压电位治疗仪、场效应治疗仪（热垫式治疗仪）、电击治疗设备、其他电疗仪器",
                                        "kws": "电疗机、体内低频脉冲治疗仪、电化学癌症治疗机、离子导入治疗仪、高压低频脉冲治疗机、高压电位治疗仪、场效应治疗、热垫式治疗仪、电击治疗设备",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090246020000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*电疗仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3075",
                                        "linkid": "3072",
                                        "code": "109024603",
                                        "paCode": "1090246",
                                        "yn": "N",
                                        "title": "光谱辐射治疗仪器",
                                        "alias": "光谱辐射治疗仪器",
                                        "about": "包括常规光源医疗机、光量子血液治疗机、光谱治疗仪、强光辐射治疗仪、其他光谱辐射治疗仪器、",
                                        "kws": "常规光源医疗机、光量子血液治疗机、光谱治疗仪、强光辐射治疗仪",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090246030000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*光谱辐射治疗仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3076",
                                        "linkid": "3072",
                                        "code": "109024604",
                                        "paCode": "1090246",
                                        "yn": "N",
                                        "title": "透热疗法设备",
                                        "alias": "透热疗法设备",
                                        "about": "用于医治某些可采用热作用治疗的疾病（例如，风湿病、神经痛、牙科疾病），采用高频电流（短波、超声波、超短波等电流）和使用各种形状（例如，片状、环状、管状）的电极进行工作",
                                        "kws": "透热疗法设备",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090246040000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*透热疗法设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3077",
                                        "linkid": "3072",
                                        "code": "109024605",
                                        "paCode": "1090246",
                                        "yn": "N",
                                        "title": "磁疗设备",
                                        "alias": "磁疗设备",
                                        "about": "包括磁疗机、磁感应电疗机、低频电磁综合治疗机、特定电磁波治疗机",
                                        "kws": "磁疗机、磁感应电疗机、低频电磁综合治疗机、特定电磁波治疗机",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090246050000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*磁疗设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3078",
                                        "linkid": "3072",
                                        "code": "109024606",
                                        "paCode": "1090246",
                                        "yn": "N",
                                        "title": "离子电渗治疗设备",
                                        "alias": "离子电渗治疗设备",
                                        "about": "离子电渗治疗设备，通过电流将活性药物（水杨酸钠、水杨酸锂、碘化钾、组胺等）透过皮肤导入病灶",
                                        "kws": "离子电渗治疗设备",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090246060000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*离子电渗治疗设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3079",
                                        "linkid": "3072",
                                        "code": "109024607",
                                        "paCode": "1090246",
                                        "yn": "N",
                                        "title": "眼科康复治疗仪器",
                                        "alias": "眼科康复治疗仪器",
                                        "about": "包括视力训练仪、弱视治疗仪、其他眼科康复治疗仪器",
                                        "kws": "视力训练仪、弱视治疗仪",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090246070000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*眼科康复治疗仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3080",
                                        "linkid": "3072",
                                        "code": "109024608",
                                        "paCode": "1090246",
                                        "yn": "N",
                                        "title": "水疗仪器",
                                        "alias": "水疗仪器",
                                        "about": null,
                                        "kws": "水疗仪器",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090246080000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*水疗仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3081",
                                        "linkid": "3072",
                                        "code": "109024609",
                                        "paCode": "1090246",
                                        "yn": "N",
                                        "title": "低温治疗仪器",
                                        "alias": "低温治疗仪器",
                                        "about": "即冷疗仪器包括液氮冷疗机、宫腔冷冻治疗仪、冷冻低温治疗机、低温变速降温仪、压缩式冷冻治疗仪、体内肿瘤低温治疗仪、肝脏冷冻治疗仪、直肠癌低温治疗仪、其他低温治疗仪器、",
                                        "kws": "液氮冷疗机、宫腔冷冻治疗仪、冷冻低温治疗机、低温变速降温仪、压缩式冷冻治疗仪、体内肿瘤低温治疗仪、肝脏冷冻治疗仪、直肠癌低温治疗仪",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090246090000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*低温治疗仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3082",
                                        "linkid": "3072",
                                        "code": "109024610",
                                        "paCode": "1090246",
                                        "yn": "N",
                                        "title": "医用刺激器",
                                        "alias": "医用刺激器",
                                        "about": "包括带刺激器心脏工作站、声刺激器、光刺激器、电刺激器、磁刺激器、其他医用刺激器",
                                        "kws": "#带刺激器心脏工作站、声刺激器、光刺激器、电刺激器、磁刺激器",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090246100000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*医用刺激器",
                                        "children": []
                                    },
                                    {
                                        "id": "3083",
                                        "linkid": "3072",
                                        "code": "109024611",
                                        "paCode": "1090246",
                                        "yn": "N",
                                        "title": "体外循环设备",
                                        "alias": "体外循环设备",
                                        "about": "包括肾脏透析设备（人工肾）、血液透析机、血液透析管、血液透析装置、血液透析滤过装置、透析血路、中空纤维透析器、多层平板型透析器、其他肾脏透析设备（人工肾）、人工心肺设备及辅助装置、人工心肺机、气泡去除器、微栓过滤器、其他人工心肺设备及辅助装置、氧合器、鼓泡式氧合器、膜式氧合器、其他氧合器、其他体外循环设备。",
                                        "kws": "肾脏透析设备、血液透析机、血液透析管、血液透析装置、血液透析滤过装置、透析血路、中空纤维透析器、多层平板型透析器、人工心肺设备、人工心肺辅助装置、人工心肺机、气泡去除器、微栓过滤器、氧合器、鼓泡式氧合器、膜式氧合器",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090246110000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*体外循环设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3084",
                                        "linkid": "3072",
                                        "code": "109024612",
                                        "paCode": "1090246",
                                        "yn": "N",
                                        "title": "婴儿保育设备",
                                        "alias": "婴儿保育设备",
                                        "about": "主要由透明塑料制的箱体、电气加温装置、安全报警装置、氧气及空气过滤和调节装置组成。包括早产儿培养箱、辐射式新生儿抢救台、新生儿运输培养箱、其他婴儿保育设备。",
                                        "kws": "早产儿培养箱、辐射式新生儿抢救台、新生儿运输培养箱",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090246120000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*婴儿保育设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3085",
                                        "linkid": "3072",
                                        "code": "109024613",
                                        "paCode": "1090246",
                                        "yn": "N",
                                        "title": "医院制气供气设备及装置",
                                        "alias": "医院制气供气设备及装置",
                                        "about": "包括医用制氧机、氧浓度监察仪、氧气减压装置、手提氧气发生器、制氧袋、吸排氧三通阀箱、吸氧调节器、排氧装置、其他医院制气供气设备及装置",
                                        "kws": "医用制氧机、氧浓度监察仪、氧气减压装置、手提氧气发生器、制氧袋、吸排氧三通阀箱、吸氧调节器、排氧装置",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090246130000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*医院制气供气设备及装置",
                                        "children": []
                                    },
                                    {
                                        "id": "3086",
                                        "linkid": "3072",
                                        "code": "109024614",
                                        "paCode": "1090246",
                                        "yn": "N",
                                        "title": "呼吸器具",
                                        "alias": "呼吸器具",
                                        "about": "自备式呼吸器具指通过自带氧气瓶或压缩空气瓶供气、带呼吸装置辐射防护服包括带呼吸装置的防污染保护服、其他呼吸器具包括与气密潜水服配套的潜水头盔、氧气袋、输氧面罩、鼻氧管",
                                        "kws": "#防污染保护服、潜水头盔、氧气袋、输氧面罩、鼻氧管",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090246140000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*呼吸器具",
                                        "children": []
                                    },
                                    {
                                        "id": "3087",
                                        "linkid": "3072",
                                        "code": "109024615",
                                        "paCode": "1090246",
                                        "yn": "N",
                                        "title": "防毒面具",
                                        "alias": "防毒面具",
                                        "about": null,
                                        "kws": "防毒面具",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090246150000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*防毒面具",
                                        "children": []
                                    },
                                    {
                                        "id": "3088",
                                        "linkid": "3072",
                                        "code": "109024616",
                                        "paCode": "1090246",
                                        "yn": "N",
                                        "title": "医用低温设备",
                                        "alias": "医用低温设备",
                                        "about": "包括冷冻干燥血浆机、真空冷冻干燥箱、尸体冷冻、冷藏箱、低温生物降温仪、其他医用低温设备。不包括血液、脏器冷藏装置冷藏箱（详见109013102）",
                                        "kws": "冷冻干燥血浆机、真空冷冻干燥箱、尸体冷冻冷藏箱、低温生物降温仪",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090246160000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*医用低温设备",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3089",
                                "linkid": "2740",
                                "code": "1090247",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "假肢、人工器官及植（介）入器械",
                                "alias": "假肢、人工器官及植（介）入器械",
                                "about": null,
                                "kws": "假肢、矫型器",
                                "taxName": "医疗仪器器械",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090247000000000000",
                                "taxCodeTitle": "医疗仪器器械",
                                "iTitle": "*医疗仪器器械*假肢、人工器官及植（介）入器械",
                                "children": [
                                    {
                                        "id": "3090",
                                        "linkid": "3089",
                                        "code": "109024701",
                                        "paCode": "1090247",
                                        "yn": "N",
                                        "title": "矫形器具",
                                        "alias": "矫形器具",
                                        "about": "用于预防或矫治躯体畸变，或病后或手术后的器官支撑、固定。包括植入式人工器具、人造关节、人工椎体、人造乳房、人工颅骨、人工颌骨、人工肛门封闭器、其他植入式人工器具、矫形或骨折用器具、颌骨治疗器具、肱骨夹、矫治脊柱器具、疝带及疝气治疗器具、脚部矫形器具、矫形鞋、特种鞋垫、牙箍、圈环、其他矫形或骨折用器具、其他矫形器具。",
                                        "kws": "植入式人工器具、人造关节、人工椎体、人造乳房、人工颅骨、人工颌骨、人工肛门封闭器、矫形用器具、骨折用器具、颌骨治疗器具、肱骨夹、矫治脊柱器具、疝带治疗器具、疝气治疗器具、脚部矫形器具、矫形鞋、特种鞋垫、牙箍、牙圈环",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090247010000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*矫形器具",
                                        "children": []
                                    },
                                    {
                                        "id": "3091",
                                        "linkid": "3089",
                                        "code": "109024702",
                                        "paCode": "1090247",
                                        "yn": "N",
                                        "title": "穿戴或植入式人造人体器官",
                                        "alias": "穿戴或植入式人造人体器官",
                                        "about": "包括假牙（包括用瓷料或塑料（特别是丙烯酸聚合物）制成的实心假牙、空心假牙）、假牙固定件（包括托牙（全口或部分）、用于保护真牙的预制金属牙冠等其他物品）、义眼（眼内填充物（玻璃体等））、人造假肢、其他穿戴或植入式人造人体器官（包括人工角、人造眼内椎晶状体等）",
                                        "kws": "假牙、假牙固定件、义眼、人造假肢",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090247020000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*穿戴或植入式人造人体器官",
                                        "children": []
                                    },
                                    {
                                        "id": "3092",
                                        "linkid": "3089",
                                        "code": "109024703",
                                        "paCode": "1090247",
                                        "yn": "N",
                                        "title": "助听器",
                                        "alias": "助听器",
                                        "about": "包括外带式助听器、植入式助听器。",
                                        "kws": "助听器",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090247030000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*助听器",
                                        "children": []
                                    },
                                    {
                                        "id": "3093",
                                        "linkid": "3089",
                                        "code": "109024704",
                                        "paCode": "1090247",
                                        "yn": "N",
                                        "title": "心脏起搏器",
                                        "alias": "心脏起搏器",
                                        "about": "包括植入式心脏起搏器、体外心脏起搏器、心脏除颤器、心脏调搏器、主动脉内囊反搏器、心脏除颤起搏器、其他心脏起搏器。",
                                        "kws": "起搏器",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090247040000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*心脏起搏器",
                                        "children": []
                                    },
                                    {
                                        "id": "3094",
                                        "linkid": "3089",
                                        "code": "109024705",
                                        "paCode": "1090247",
                                        "yn": "N",
                                        "title": "植入人体支夹（器）",
                                        "alias": "植入人体支夹（器）",
                                        "about": "包括血管吻合夹（器）、血管内支架、食管支架、动脉瘤支架、其他植入人体支夹（器）",
                                        "kws": "血管吻合夹、血管吻合器、血管内支架、食管支架、动脉瘤支架",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090247050000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*植入人体支夹（器）",
                                        "children": []
                                    },
                                    {
                                        "id": "3095",
                                        "linkid": "3089",
                                        "code": "109024706",
                                        "paCode": "1090247",
                                        "yn": "N",
                                        "title": "有创医用传感器（植入体内）",
                                        "alias": "有创医用传感器（植入体内）",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090247060000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*有创医用传感器（植入体内）",
                                        "children": []
                                    },
                                    {
                                        "id": "3096",
                                        "linkid": "3089",
                                        "code": "109024799",
                                        "paCode": "1090247",
                                        "yn": "N",
                                        "title": "其他假肢、人工器官及植（介）入器械",
                                        "alias": "其他假肢、人工器官及植（介）入器械",
                                        "about": "指其他穿戴或植入人体器具，包括助语器（人工喉）、导盲器等",
                                        "kws": null,
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090247990000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*其他假肢、人工器官及植（介）入器械",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3097",
                                "linkid": "2740",
                                "code": "1090248",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "医疗、外科、牙科或兽医用家具",
                                "alias": "医疗、外科、牙科或兽医用家具",
                                "about": null,
                                "kws": null,
                                "taxName": "医疗仪器器械",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090248000000000000",
                                "taxCodeTitle": "医疗仪器器械",
                                "iTitle": "*医疗仪器器械*医疗、外科、牙科或兽医用家具",
                                "children": [
                                    {
                                        "id": "3098",
                                        "linkid": "3097",
                                        "code": "109024801",
                                        "paCode": "1090248",
                                        "yn": "N",
                                        "title": "手术台床",
                                        "alias": "手术台床",
                                        "about": "包括电动、液压手术台床指通用或专用外科手术台可以通过调校、倾斜、旋转或升高以使病人按各种不同手术的要求而处于适当的位置的手术台，电动综合手术台、综合产床、骨科手术床、烫伤翻转床、特种矫形手术台供复杂手术（例如，臀部、肩部、脊柱手术）之用，其他电动、液压手术台床含括泌尿科、膀胱镜等检查或手术用床，手动手术床含综合手术床、普通产床、轻便产床、坐式产床、骨科整形床、解剖台，牙科椅指没有装上牙科器械的牙科用椅（包括麻醉椅床），但它们带有装在中心支架上作升降、倾斜，有时还能旋转的机械装置，不论是否装有照明器具等装置",
                                        "kws": "电动手术台床、液压手术台床、电动综合手术台、综合产床、骨科手术床、烫伤翻转床、特种矫形手术台、手动手术床、牙科椅",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090248010000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*手术台床",
                                        "children": []
                                    },
                                    {
                                        "id": "3099",
                                        "linkid": "3097",
                                        "code": "109024802",
                                        "paCode": "1090248",
                                        "yn": "N",
                                        "title": "病床及相关医用家具",
                                        "alias": "病床及相关医用家具",
                                        "about": "包括病床（带机械装置病床包括附加设施、电动间隙牵引床、普通病床、防褥疮床垫包括电动防褥疮床垫、充气式防褥疮座垫、其他病床）、医用特制坐具、担架、消毒及类似用途家具（包括手推式器械消毒车、特制消毒脸盆、自动开启的消毒敷料箱）、装有脚轮架床指运送病人的装有脚轮的架床、其他病用家具（包括医疗治理、按摩等用的台、床及类似家具）。",
                                        "kws": "带机械装置病床、电动间隙牵引床、普通病床、防褥疮床垫、医用特制坐具、担架、消毒用途家具、装有脚轮架床",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090248020000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*病床及相关医用家具",
                                        "children": []
                                    },
                                    {
                                        "id": "3100",
                                        "linkid": "3097",
                                        "code": "109024803",
                                        "paCode": "1090248",
                                        "yn": "N",
                                        "title": "医用家具零件",
                                        "alias": "医用家具零件",
                                        "about": "包括牙科椅零件（牙科椅专用头靠、靠背、搁脚板、扶手、肘靠等）、其他医用家具零件（安装在手术台上专门用于防止病人身体挪动的物品，例如，肩、小腿或大腿的扣夹、腿垫、固定头部的头靠、臂或胸的支架及类似品）",
                                        "kws": "医用家具零件",
                                        "taxName": "医疗仪器器械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090248030000000000",
                                        "taxCodeTitle": "医疗仪器器械",
                                        "iTitle": "*医疗仪器器械*医用家具零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3101",
                                "linkid": "2740",
                                "code": "1090249",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "环境污染防治专用设备",
                                "alias": "环境污染防治专用设备",
                                "about": null,
                                "kws": null,
                                "taxName": "污染防治设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090249000000000000",
                                "taxCodeTitle": "污染防治设备",
                                "iTitle": "*污染防治设备*环境污染防治专用设备",
                                "children": [
                                    {
                                        "id": "3102",
                                        "linkid": "3101",
                                        "code": "109024901",
                                        "paCode": "1090249",
                                        "yn": "N",
                                        "title": "大气污染防治设备",
                                        "alias": "大气污染防治设备",
                                        "about": "包括除尘设备（不包括家用除尘器（详见109041805））、静电除尘器（静电过滤器、高效静电除尘枪、离子除尘枪、离子吹尘枪、静电消除器、板极式静电除尘器、管极式静电除尘器）、袋式除尘器（械振动式袋式除尘器、分室反吹式袋式除尘器、脉冲喷吹式袋式除尘器、回转反吹袋式除尘器）、旋风式除尘器、湿式除尘器（湿式烟气脱硫除尘装置、湿式静电除尘器、花岗石类湿式烟气脱硫除尘装置）、颗粒层除尘器、组合式电除尘器、其他除尘设备指其他非家用除尘设备，压缩空气除尘器、空气净化装置、氧化还原净化装置、生物法净化装置、冷凝净化装置、",
                                        "kws": "除尘器、净化装置、吸附装置、吸收装置",
                                        "taxName": "污染防治设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090249010000000000",
                                        "taxCodeTitle": "污染防治设备",
                                        "iTitle": "*污染防治设备*大气污染防治设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3103",
                                        "linkid": "3101",
                                        "code": "109024902",
                                        "paCode": "1090249",
                                        "yn": "N",
                                        "title": "水质污染防治设备",
                                        "alias": "水质污染防治设备",
                                        "about": "包括沉淀、过滤装置、平流沉砂装置、辐流沉砂装置、旋流沉砂装置、曝气沉砂装置、管式沉砂装置、搅拌沉砂装置、平流沉淀装置、辐流沉淀装置、其他沉淀、过滤装置、池类设备、澄清池、上浮池、隔油池、粗滤池、调节池、搅拌池、生物处理设备、生物滤池、生物滤塔、生物流化床、生物活性炭床、生物转盘、其他生物处理设备、化学法处理设备、氧化还原装置、湿式催化氧化装置、兼氧活性污泥反应器、其他化学法处理设备、厌氧类设备、水解酸化厌氧反应器、厌氧污泥床、厌氧流化床、厌氧膨胀床、折流板厌氧反应器、厌氧生物膜反应器、其他厌氧类设备、物理",
                                        "kws": "沉淀过滤装置、沉砂装置、沉淀装置、过滤装置、池类设备、澄清池、上浮池、隔油池、粗滤池、调节池、搅拌池、生物处理设备、生物滤池、生物滤塔、生物流化床、生物活性炭床、生物转盘、化学法处理设备、氧化还原装置、湿式催化氧化装置、兼氧活性污泥反应器、厌氧类设备、水解酸化厌氧反应器、厌氧污泥床、厌氧流化床、厌氧膨胀床、折流板厌氧反应器、厌氧生物膜反应器、物理法处理设备、萃取装置、混凝装置、絮凝装置、气浮分离装置、膜分离装置、离子交换装置、中和装置、螺旋桨式搅拌机、框式双桨搅拌机、带罐框架式搅拌机、污泥处理设备、污泥处",
                                        "taxName": "污染防治设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090249020000000000",
                                        "taxCodeTitle": "污染防治设备",
                                        "iTitle": "*污染防治设备*水质污染防治设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3104",
                                        "linkid": "3101",
                                        "code": "109024903",
                                        "paCode": "1090249",
                                        "yn": "N",
                                        "title": "固体废弃物处理设备",
                                        "alias": "固体废弃物处理设备",
                                        "about": "包括废弃物专用处理机械、废弃物压缩装置、废弃物剪切式破碎机、废弃物湿式破碎机、废弃物筛分机、气流分选机、永磁滚筒、辊筒式静电分选机、光电分选机、其他废弃物专用处理机械、垃圾焚烧炉、垃圾焚化电炉、平推式炉排炉、斜推式炉排炉、逆推式炉排炉、辊筒式炉排炉、流化床焚烧炉、回转窑室焚烧炉、其他垃圾焚烧炉、无害化处理设备、堆肥翻堆机、堆肥发酵装置、水泥固化装置、塑料固化装置、熔融固化装置、其他无害化处理设备、资源再利用设备、填埋气体回收利用设备、废物转化回收装置、废液处理用分离器、酸、碱回收设备、汞回收设备、废物回收",
                                        "kws": "废弃物专用处理机械、废弃物压缩装置、废弃物剪切式破碎机、废弃物湿式破碎机、废弃物筛分机、气流分选机、永磁滚筒、辊筒式静电分选机、光电分选机、垃圾焚烧炉、垃圾焚化电炉、平推式炉排炉、斜推式炉排炉、逆推式炉排炉、辊筒式炉排炉、流化床焚烧炉、回转窑室焚烧炉、无害化处理设备、堆肥翻堆机、堆肥发酵装置、水泥固化装置、塑料固化装置、熔融固化装置、资源再利用设备、填埋气体回收利用设备、废物转化回收装置、废液处理用分离器、酸碱回收设备、汞回收设备、废物回收装置",
                                        "taxName": "污染防治设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090249030000000000",
                                        "taxCodeTitle": "污染防治设备",
                                        "iTitle": "*污染防治设备*固体废弃物处理设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3105",
                                        "linkid": "3101",
                                        "code": "109024904",
                                        "paCode": "1090249",
                                        "yn": "N",
                                        "title": "噪音与振动控制设备",
                                        "alias": "噪音与振动控制设备",
                                        "about": "包括消声器（噪音控制设备）、阻性消声器、抗性消声器、阻抗复合消声器、微穿孔板消声器、高压气体排放消声器、有源（主动）消声器、特殊消声器、消声装置配件、其他消声器、噪音与振动控制材料及元件、薄板共振吸声结构、穿孔板共振吸声结构、空间吸声体、装饰性吸声体、隔声罩、隔声屏障、隔振器、隔振元件、其他噪音与振动控制材料及元件",
                                        "kws": "噪音与振动控制材料、消声器、噪音与振动控制元件、薄板共振吸声结构、穿孔板共振吸声结构、空间吸声体、装饰性吸声体、隔声罩、隔声屏障、隔振器、隔振元件",
                                        "taxName": "污染防治设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090249040000000000",
                                        "taxCodeTitle": "污染防治设备",
                                        "iTitle": "*污染防治设备*噪音与振动控制设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3106",
                                        "linkid": "3101",
                                        "code": "109024905",
                                        "paCode": "1090249",
                                        "yn": "N",
                                        "title": "放射性污染防治和处理设备",
                                        "alias": "放射性污染防治和处理设备",
                                        "about": "包括放射性污染防治设备、放射性废物压实机、放射燃料用分离器、其他放射性污染防治设备、放射性材料处理炉、放射性废物焚烧炉、可裂变材料回收处理专用炉、分离已辐照核燃料专用炉、其他放射性材料处理炉、电磁波污染防治设备、其他放射性污染防治和处理设备",
                                        "kws": "放射性污染防治设备、放射性废物压实机、放射燃料用分离器、放射性材料处理炉、放射性废物焚烧炉、可裂变材料回收处理专用炉、分离已辐照核燃料专用炉、电磁波污染防治设备",
                                        "taxName": "污染防治设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090249050000000000",
                                        "taxCodeTitle": "污染防治设备",
                                        "iTitle": "*污染防治设备*放射性污染防治和处理设备",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3107",
                                "linkid": "2740",
                                "code": "1090250",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "地质勘查专用设备",
                                "alias": "地质勘查专用设备",
                                "about": null,
                                "kws": null,
                                "taxName": "地质勘查设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090250000000000000",
                                "taxCodeTitle": "地质勘查设备",
                                "iTitle": "*地质勘查设备*地质勘查专用设备",
                                "children": [
                                    {
                                        "id": "3108",
                                        "linkid": "3107",
                                        "code": "109025001",
                                        "paCode": "1090250",
                                        "yn": "N",
                                        "title": "地质钻探机",
                                        "alias": "地质钻探机",
                                        "about": "包括工程勘察钻机（直径＞3m）、地质岩心钻机、物探钻机、坑探钻机、取样钻机、水文水井钻机、其他地质钻探机。",
                                        "kws": "钻探机",
                                        "taxName": "地质勘查设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090250010000000000",
                                        "taxCodeTitle": "地质勘查设备",
                                        "iTitle": "*地质勘查设备*地质钻探机",
                                        "children": []
                                    },
                                    {
                                        "id": "3109",
                                        "linkid": "3107",
                                        "code": "109025002",
                                        "paCode": "1090250",
                                        "yn": "N",
                                        "title": "实验室选矿制样设备",
                                        "alias": "实验室选矿制样设备",
                                        "about": "包括微机激电仪、高密度电测仪、质子核旋磁力仪、其他实验室选矿制样设备",
                                        "kws": "微机激电仪、高密度电测仪、质子核旋磁力仪",
                                        "taxName": "地质勘查设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090250020000000000",
                                        "taxCodeTitle": "地质勘查设备",
                                        "iTitle": "*地质勘查设备*实验室选矿制样设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3110",
                                        "linkid": "3107",
                                        "code": "109025003",
                                        "paCode": "1090250",
                                        "yn": "N",
                                        "title": "专用勘探设备",
                                        "alias": "专用勘探设备",
                                        "about": "包括重力法勘探设备、电法勘探设备、磁法勘探设备",
                                        "kws": "勘探设备",
                                        "taxName": "地质勘查设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090250030000000000",
                                        "taxCodeTitle": "地质勘查设备",
                                        "iTitle": "*地质勘查设备*专用勘探设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3111",
                                        "linkid": "3107",
                                        "code": "109025099",
                                        "paCode": "1090250",
                                        "yn": "N",
                                        "title": "其他地质勘查专用设备",
                                        "alias": "其他地质勘查专用设备",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "地质勘查设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090250990000000000",
                                        "taxCodeTitle": "地质勘查设备",
                                        "iTitle": "*地质勘查设备*其他地质勘查专用设备",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3112",
                                "linkid": "2740",
                                "code": "1090251",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "邮政专用机械及器材",
                                "alias": "邮政专用机械及器材",
                                "about": "指邮政内部处理及转运设备",
                                "kws": null,
                                "taxName": "邮政专用机械",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090251000000000000",
                                "taxCodeTitle": "邮政专用机械",
                                "iTitle": "*邮政专用机械*邮政专用机械及器材",
                                "children": [
                                    {
                                        "id": "3113",
                                        "linkid": "3112",
                                        "code": "109025101",
                                        "paCode": "1090251",
                                        "yn": "N",
                                        "title": "邮资机",
                                        "alias": "邮资机",
                                        "about": "包括大型邮资机、大型喷印式邮资机、大型机械戳印式邮资机、动态称重邮资机、中型邮资机、中型机械戳印机邮资机、中型喷印式邮资机、小型邮资机、小型热转印式邮资机、小型喷印式邮资机、小型机械戳印式邮资机、邮资盖戳机",
                                        "kws": "邮资机、盖戳机",
                                        "taxName": "邮政专用机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090251010000000000",
                                        "taxCodeTitle": "邮政专用机械",
                                        "iTitle": "*邮政专用机械*邮资机",
                                        "children": []
                                    },
                                    {
                                        "id": "3114",
                                        "linkid": "3112",
                                        "code": "109025102",
                                        "paCode": "1090251",
                                        "yn": "N",
                                        "title": "邮政分拣机",
                                        "alias": "邮政分拣机",
                                        "about": "包括信函分拣及封装设备、包裹分拣设备、印刷品分拣机",
                                        "kws": "#信函分拣、封装设备、包裹分拣设备、印刷品分拣机",
                                        "taxName": "邮政专用机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090251020000000000",
                                        "taxCodeTitle": "邮政专用机械",
                                        "iTitle": "*邮政专用机械*邮政分拣机",
                                        "children": []
                                    },
                                    {
                                        "id": "3115",
                                        "linkid": "3112",
                                        "code": "109025103",
                                        "paCode": "1090251",
                                        "yn": "N",
                                        "title": "信件处理机械",
                                        "alias": "信件处理机械",
                                        "about": "包括信件折迭机、信件开封机、粘贴或盖销邮票机、推挂机、信盒输送系统、其他信件处理机械",
                                        "kws": "信件折迭机、信件开封机、粘贴邮票机、盖销邮票机、推挂机、信盒输送系统",
                                        "taxName": "邮政专用机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090251030000000000",
                                        "taxCodeTitle": "邮政专用机械",
                                        "iTitle": "*邮政专用机械*信件处理机械",
                                        "children": []
                                    },
                                    {
                                        "id": "3116",
                                        "linkid": "3112",
                                        "code": "109025104",
                                        "paCode": "1090251",
                                        "yn": "N",
                                        "title": "邮政计费、缴费设备",
                                        "alias": "邮政计费、缴费设备",
                                        "about": "包括邮局自助缴费机、电话计费器、其他邮政计费、缴费设备",
                                        "kws": "邮局自助缴费机、电话计费器",
                                        "taxName": "邮政专用机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090251040000000000",
                                        "taxCodeTitle": "邮政专用机械",
                                        "iTitle": "*邮政专用机械*邮政计费、缴费设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3117",
                                        "linkid": "3112",
                                        "code": "109025105",
                                        "paCode": "1090251",
                                        "yn": "N",
                                        "title": "邮政专用器材",
                                        "alias": "邮政专用器材",
                                        "about": "包括交接箱、金属制信报箱、邮箱、邮政集装箱",
                                        "kws": "交接箱、金属制信报箱、邮箱、邮政集装箱",
                                        "taxName": "邮政专用机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090251050000000000",
                                        "taxCodeTitle": "邮政专用机械",
                                        "iTitle": "*邮政专用机械*邮政专用器材",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3118",
                                "linkid": "2740",
                                "code": "1090252",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "商业、饮食、服务专用设备",
                                "alias": "商业、饮食、服务专用设备",
                                "about": "不包括商用制冷设备（详见109013102）。",
                                "kws": null,
                                "taxName": "商用设备",
                                "taxRate": "",
                                "vip": "3",
                                "itaxRate": null,
                                "taxCode": "1090252000000000000",
                                "taxCodeTitle": "商用设备",
                                "iTitle": "*商用设备*商业、饮食、服务专用设备",
                                "children": [
                                    {
                                        "id": "3119",
                                        "linkid": "3118",
                                        "code": "109025201",
                                        "paCode": "1090252",
                                        "yn": "N",
                                        "title": "自动售货机、售票机",
                                        "alias": "自动售货机、售票机",
                                        "about": "包括饮料自动销售机、加热饮料自动销售机、冷饮料自动销售机、其他饮料自动销售机、自动售货机、自动售票机、火车票自动售票机、邮票自动售票机、其他自动售票机、钱币自动兑换机、其他自动售货机、售票机",
                                        "kws": "自动销售机、自动售货机、自动售票机、钱币自动兑换机",
                                        "taxName": "商用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090252010000000000",
                                        "taxCodeTitle": "商用设备",
                                        "iTitle": "*商用设备*自动售货机、售票机",
                                        "children": []
                                    },
                                    {
                                        "id": "3120",
                                        "linkid": "3118",
                                        "code": "109025202",
                                        "paCode": "1090252",
                                        "yn": "N",
                                        "title": "餐饮服务用机械",
                                        "alias": "餐饮服务用机械",
                                        "about": "指非家用餐饮机械。包括加热或烹煮设备、抽油烟机、洗碗机",
                                        "kws": "加热设备、烹煮设备、抽油烟机、洗碗机",
                                        "taxName": "商用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090252020000000000",
                                        "taxCodeTitle": "商用设备",
                                        "iTitle": "*商用设备*餐饮服务用机械",
                                        "children": []
                                    },
                                    {
                                        "id": "3121",
                                        "linkid": "3118",
                                        "code": "109025203",
                                        "paCode": "1090252",
                                        "yn": "N",
                                        "title": "理发用椅",
                                        "alias": "理发用椅",
                                        "about": "指有旋转、倾斜或升降装置的理发用椅及类似椅，包括理发用椅零件",
                                        "kws": "理发用椅",
                                        "taxName": "商用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090252030000000000",
                                        "taxCodeTitle": "商用设备",
                                        "iTitle": "*商用设备*理发用椅",
                                        "children": []
                                    },
                                    {
                                        "id": "3122",
                                        "linkid": "3118",
                                        "code": "109025204",
                                        "paCode": "1090252",
                                        "yn": "N",
                                        "title": "自动擦鞋器",
                                        "alias": "自动擦鞋器",
                                        "about": null,
                                        "kws": "自动擦鞋器",
                                        "taxName": "商用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090252040000000000",
                                        "taxCodeTitle": "商用设备",
                                        "iTitle": "*商用设备*自动擦鞋器",
                                        "children": []
                                    },
                                    {
                                        "id": "3123",
                                        "linkid": "3118",
                                        "code": "109025205",
                                        "paCode": "1090252",
                                        "yn": "N",
                                        "title": "洗衣店用洗衣机械",
                                        "alias": "洗衣店用洗衣机械",
                                        "about": "指设计为供洗衣店、宾馆、汽车旅馆、医院等单位使用的（干衣量超过10kg）洗衣机、衣服甩干机、烘干机、干洗机等。包括洗衣机、洗涤干燥两用机、干洗机、干燥机（洗衣用）、离心干衣机、烫平机、其他洗衣店用洗衣机械。",
                                        "kws": "洗衣机、洗涤干燥两用机、干洗机、洗衣用干燥机、离心干衣机、烫平机",
                                        "taxName": "商用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090252050000000000",
                                        "taxCodeTitle": "商用设备",
                                        "iTitle": "*商用设备*洗衣店用洗衣机械",
                                        "children": []
                                    },
                                    {
                                        "id": "3124",
                                        "linkid": "3118",
                                        "code": "109025206",
                                        "paCode": "1090252",
                                        "yn": "N",
                                        "title": "焚尸炉",
                                        "alias": "焚尸炉",
                                        "about": "指火葬场用的焚尸炉。包括焚尸电炉、非电热焚尸炉",
                                        "kws": "焚尸电炉、非电热焚尸炉",
                                        "taxName": "商用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090252060000000000",
                                        "taxCodeTitle": "商用设备",
                                        "iTitle": "*商用设备*焚尸炉",
                                        "children": []
                                    },
                                    {
                                        "id": "3125",
                                        "linkid": "3118",
                                        "code": "109025299",
                                        "paCode": "1090252",
                                        "yn": "N",
                                        "title": "其他商业、饮食、服务专用设备",
                                        "alias": "其他商业、饮食、服务专用设备",
                                        "about": "包括自动售货机零件、钱币兑换机零件、洗碗机零件、洗衣机零件、干衣机零件",
                                        "kws": null,
                                        "taxName": "商用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090252990000000000",
                                        "taxCodeTitle": "商用设备",
                                        "iTitle": "*商用设备*其他商业、饮食、服务专用设备",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3126",
                                "linkid": "2740",
                                "code": "1090253",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "社会公共安全设备及器材",
                                "alias": "社会公共安全设备及器材",
                                "about": null,
                                "kws": null,
                                "taxName": "公共安全设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090253000000000000",
                                "taxCodeTitle": "公共安全设备",
                                "iTitle": "*公共安全设备*社会公共安全设备及器材",
                                "children": [
                                    {
                                        "id": "3127",
                                        "linkid": "3126",
                                        "code": "109025301",
                                        "paCode": "1090253",
                                        "yn": "N",
                                        "title": "消防自动系统",
                                        "alias": "消防自动系统",
                                        "about": "包括自动化消防设备、自动灭火系统、湿式自动喷水系统、其他消防自动系统。不包括灭火器（详见109025302）",
                                        "kws": "自动化消防设备、自动灭火系统、湿式自动喷水系统",
                                        "taxName": "公共安全设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090253010000000000",
                                        "taxCodeTitle": "公共安全设备",
                                        "iTitle": "*公共安全设备*消防自动系统",
                                        "children": []
                                    },
                                    {
                                        "id": "3128",
                                        "linkid": "3126",
                                        "code": "109025302",
                                        "paCode": "1090253",
                                        "yn": "N",
                                        "title": "灭火器",
                                        "alias": "灭火器",
                                        "about": "包括泡沫灭火器、背负式灭火器、背式水枪、其他灭火器，不包括风力灭火机（详见109023704）。",
                                        "kws": "灭火器、背式水枪",
                                        "taxName": "公共安全设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090253020000000000",
                                        "taxCodeTitle": "公共安全设备",
                                        "iTitle": "*公共安全设备*灭火器",
                                        "children": []
                                    },
                                    {
                                        "id": "3129",
                                        "linkid": "3126",
                                        "code": "109025303",
                                        "paCode": "1090253",
                                        "yn": "N",
                                        "title": "灭火器零件",
                                        "alias": "灭火器零件",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "公共安全设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090253030000000000",
                                        "taxCodeTitle": "公共安全设备",
                                        "iTitle": "*公共安全设备*灭火器零件",
                                        "children": []
                                    },
                                    {
                                        "id": "3130",
                                        "linkid": "3126",
                                        "code": "109025304",
                                        "paCode": "1090253",
                                        "yn": "N",
                                        "title": "灭火器用装配药及灭火弹",
                                        "alias": "灭火器用装配药及灭火弹",
                                        "about": "包括灭火器用装配药、灭火弹。",
                                        "kws": "灭火器用装配药、灭火弹",
                                        "taxName": "公共安全设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090253040000000000",
                                        "taxCodeTitle": "公共安全设备",
                                        "iTitle": "*公共安全设备*灭火器用装配药及灭火弹",
                                        "children": []
                                    },
                                    {
                                        "id": "3131",
                                        "linkid": "3126",
                                        "code": "109025305",
                                        "paCode": "1090253",
                                        "yn": "N",
                                        "title": "消防、防爆专用手工工具",
                                        "alias": "消防、防爆专用手工工具",
                                        "about": "包括扑火工具、消防斧、消防接口破拆工具、消防钩、防爆扳手、防爆锤、其他消防、防爆专用手工工具。",
                                        "kws": "扑火工具、消防斧、消防接口破拆工具、消防钩、防爆扳手、防爆锤、防爆专用手工工具",
                                        "taxName": "公共安全设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090253050000000000",
                                        "taxCodeTitle": "公共安全设备",
                                        "iTitle": "*公共安全设备*消防、防爆专用手工工具",
                                        "children": []
                                    },
                                    {
                                        "id": "3132",
                                        "linkid": "3126",
                                        "code": "109025306",
                                        "paCode": "1090253",
                                        "yn": "N",
                                        "title": "消防设备附件",
                                        "alias": "消防设备附件",
                                        "about": "包括消防栓（立管）、消防旋塞、水龙软管嘴及类似品",
                                        "kws": "消防栓、消防旋塞、水龙软管嘴",
                                        "taxName": "公共安全设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090253060000000000",
                                        "taxCodeTitle": "公共安全设备",
                                        "iTitle": "*公共安全设备*消防设备附件",
                                        "children": []
                                    },
                                    {
                                        "id": "3133",
                                        "linkid": "3126",
                                        "code": "109025307",
                                        "paCode": "1090253",
                                        "yn": "N",
                                        "title": "警棍及类似警用器械",
                                        "alias": "警棍及类似警用器械",
                                        "about": "包括警棍、自卫器、橡胶棒、警察等用灌铅手杖、烟雾喷射罐、其他警用器械",
                                        "kws": "警棍、自卫器、橡胶棒、警察用灌铅手杖、烟雾喷射罐",
                                        "taxName": "公共安全设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090253070000000000",
                                        "taxCodeTitle": "公共安全设备",
                                        "iTitle": "*公共安全设备*警棍及类似警用器械",
                                        "children": []
                                    },
                                    {
                                        "id": "3134",
                                        "linkid": "3126",
                                        "code": "109025308",
                                        "paCode": "1090253",
                                        "yn": "N",
                                        "title": "取证鉴定专用器材",
                                        "alias": "取证鉴定专用器材",
                                        "about": "包括刑侦现场勘查器材、刑侦检验鉴定分析器材、其他取证鉴定专用器材。",
                                        "kws": "刑侦现场勘查器材、刑侦检验鉴定分析器材",
                                        "taxName": "公共安全设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090253080000000000",
                                        "taxCodeTitle": "公共安全设备",
                                        "iTitle": "*公共安全设备*取证鉴定专用器材",
                                        "children": []
                                    },
                                    {
                                        "id": "3135",
                                        "linkid": "3126",
                                        "code": "109025309",
                                        "paCode": "1090253",
                                        "yn": "N",
                                        "title": "安全检查仪器",
                                        "alias": "安全检查仪器",
                                        "about": "指低剂量X射线安全检查设备。包括行李包裹安检仪、射线探测器、安全检查人行通道、虹膜输入装置、指纹输入装置、其他安全检查仪器",
                                        "kws": "行李包裹安检仪、射线探测器、安全检查人行通道、虹膜输入装置、指纹输入装置",
                                        "taxName": "公共安全设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090253090000000000",
                                        "taxCodeTitle": "公共安全设备",
                                        "iTitle": "*公共安全设备*安全检查仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3136",
                                        "linkid": "3126",
                                        "code": "109025310",
                                        "paCode": "1090253",
                                        "yn": "N",
                                        "title": "监控电视摄像机",
                                        "alias": "监控电视摄像机",
                                        "about": "包括公共场所、交通管理用的监控用电视摄像机。补光智能型摄像机、日夜转换型摄像机、一体化彩色摄像机、低照度彩色摄像机、其他监控电视摄像机",
                                        "kws": "摄像机",
                                        "taxName": "公共安全设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090253100000000000",
                                        "taxCodeTitle": "公共安全设备",
                                        "iTitle": "*公共安全设备*监控电视摄像机",
                                        "children": []
                                    },
                                    {
                                        "id": "3137",
                                        "linkid": "3126",
                                        "code": "109025311",
                                        "paCode": "1090253",
                                        "yn": "N",
                                        "title": "防盗、防火报警器及类似装置",
                                        "alias": "防盗、防火报警器及类似装置",
                                        "about": "包括机动车辆防盗装置、防盗报警器、防火报警器、电气气体报警器、火焰报警器（火焰探测器）、其他防盗、防火报警器及类似装置。不包括核辐射剂量监测报警仪器（详见109061503）",
                                        "kws": "机动车辆防盗装置、防盗报警器、防火报警器、电气气体报警器、火焰报警器、火焰探测器",
                                        "taxName": "公共安全设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090253110000000000",
                                        "taxCodeTitle": "公共安全设备",
                                        "iTitle": "*公共安全设备*防盗、防火报警器及类似装置",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3138",
                                "linkid": "2740",
                                "code": "1090254",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "交通安全及管制专用设备",
                                "alias": "交通安全及管制专用设备",
                                "about": null,
                                "kws": null,
                                "taxName": "交通管制设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090254000000000000",
                                "taxCodeTitle": "交通管制设备",
                                "iTitle": "*交通管制设备*交通安全及管制专用设备",
                                "children": [
                                    {
                                        "id": "3139",
                                        "linkid": "3138",
                                        "code": "109025401",
                                        "paCode": "1090254",
                                        "yn": "N",
                                        "title": "道路交通安全管制设备",
                                        "alias": "道路交通安全管制设备",
                                        "about": "包括区域交通中心控制机、道路交通安全检测设备、雷达测速仪、酒精检测仪、其他道路交通安全检测设备、交通事故现场勘查救援设备、智能交通事故现场勘查车、气动破拆工具、气动破拆气枪、便携式多功能钳、剪断器、无火花电锯、起重气垫、液压开门器、牵拉器、切割机、撬棍、撬斧、其他交通事故现场勘查救援设备、道路、停车场用电气信号装置、交通灯、盲人过街音响器、路口自动信号装置、停车场用电气信号装置、其他道路用电气信号装置、其他道路交通安全管制设备",
                                        "kws": "区域交通中心控制机、道路交通安全检测设备、雷达测速仪、酒精检测仪、交通事故现场勘查救援设备、智能交通事故现场勘查车、气动破拆工具、气动破拆气枪、便携式多功能钳、剪断器、无火花电锯、起重气垫、液压开门器、牵拉器、切割机、撬棍、撬斧、道路用电气信号装置、停车场用电气信号装置、交通灯、盲人过街音响器、路口自动信号装置",
                                        "taxName": "交通管制设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090254010000000000",
                                        "taxCodeTitle": "交通管制设备",
                                        "iTitle": "*交通管制设备*道路交通安全管制设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3140",
                                        "linkid": "3138",
                                        "code": "109025402",
                                        "paCode": "1090254",
                                        "yn": "N",
                                        "title": "铁道电气交通管理设备",
                                        "alias": "铁道电气交通管理设备",
                                        "about": "包括铁道、电车道、地下矿井铁道设备以及气垫火车运输系统电气信号、安全或交通管理设备、信号或安全设备、轨道控制设备。",
                                        "kws": "铁道电气交通管理设备、信号安全设备、轨道控制设备",
                                        "taxName": "交通管制设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090254020000000000",
                                        "taxCodeTitle": "交通管制设备",
                                        "iTitle": "*交通管制设备*铁道电气交通管理设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3141",
                                        "linkid": "3138",
                                        "code": "109025403",
                                        "paCode": "1090254",
                                        "yn": "N",
                                        "title": "内河航道、港口用交通管制设备",
                                        "alias": "内河航道、港口用交通管制设备",
                                        "about": "包括内河航道电气信号装置、港口用电气信号装置",
                                        "kws": "内河航道电气信号装置、港口用电气信号装置",
                                        "taxName": "交通管制设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090254030000000000",
                                        "taxCodeTitle": "交通管制设备",
                                        "iTitle": "*交通管制设备*内河航道、港口用交通管制设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3142",
                                        "linkid": "3138",
                                        "code": "109025404",
                                        "paCode": "1090254",
                                        "yn": "N",
                                        "title": "飞机场用电气交通管理设备",
                                        "alias": "飞机场用电气交通管理设备",
                                        "about": "包括飞机场用盲降控制设备、飞机场用交通控制设备、飞机场用电气信号装置",
                                        "kws": "飞机场用盲降控制设备、飞机场用交通控制设备、飞机场用电气信号装置",
                                        "taxName": "交通管制设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090254040000000000",
                                        "taxCodeTitle": "交通管制设备",
                                        "iTitle": "*交通管制设备*飞机场用电气交通管理设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3143",
                                        "linkid": "3138",
                                        "code": "109025499",
                                        "paCode": "1090254",
                                        "yn": "N",
                                        "title": "其他交通安全及管制专用设备",
                                        "alias": "其他交通安全及管制专用设备",
                                        "about": "包括其他电气信号、安全或交通管理设备",
                                        "kws": null,
                                        "taxName": "交通管制设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090254990000000000",
                                        "taxCodeTitle": "交通管制设备",
                                        "iTitle": "*交通管制设备*其他交通安全及管制专用设备",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3144",
                                "linkid": "2740",
                                "code": "1090255",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "水资源专用机械",
                                "alias": "水资源专用机械",
                                "about": null,
                                "kws": null,
                                "taxName": "水资源专用机械",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090255000000000000",
                                "taxCodeTitle": "水资源专用机械",
                                "iTitle": "*水资源专用机械*水资源专用机械",
                                "children": [
                                    {
                                        "id": "3145",
                                        "linkid": "3144",
                                        "code": "109025501",
                                        "paCode": "1090255",
                                        "yn": "N",
                                        "title": "地平线开凿机系统",
                                        "alias": "地平线开凿机系统",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "水资源专用机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090255010000000000",
                                        "taxCodeTitle": "水资源专用机械",
                                        "iTitle": "*水资源专用机械*地平线开凿机系统",
                                        "children": []
                                    },
                                    {
                                        "id": "3146",
                                        "linkid": "3144",
                                        "code": "109025502",
                                        "paCode": "1090255",
                                        "yn": "N",
                                        "title": "清淤机械",
                                        "alias": "清淤机械",
                                        "about": "包括沟渠清淤机械、水库清淤机械、港口清淤机械、水电站尾水清淤机械、管道清淤机械、其他清淤机械。",
                                        "kws": "沟渠清淤机械、水库清淤机械、港口清淤机械、水电站尾水清淤机械、管道清淤机械",
                                        "taxName": "水资源专用机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090255020000000000",
                                        "taxCodeTitle": "水资源专用机械",
                                        "iTitle": "*水资源专用机械*清淤机械",
                                        "children": []
                                    },
                                    {
                                        "id": "3147",
                                        "linkid": "3144",
                                        "code": "109025503",
                                        "paCode": "1090255",
                                        "yn": "N",
                                        "title": "水利专用机械",
                                        "alias": "水利专用机械",
                                        "about": "包括排水机械、闸门启闭机（器）、升船机、拦污装置、破冰机械、其他水利专用机械",
                                        "kws": "排水机械、闸门启闭机、升船机、拦污装置、破冰机械",
                                        "taxName": "水资源专用机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090255030000000000",
                                        "taxCodeTitle": "水资源专用机械",
                                        "iTitle": "*水资源专用机械*水利专用机械",
                                        "children": []
                                    },
                                    {
                                        "id": "3148",
                                        "linkid": "3144",
                                        "code": "109025504",
                                        "paCode": "1090255",
                                        "yn": "N",
                                        "title": "自来水生产专用设备",
                                        "alias": "自来水生产专用设备",
                                        "about": "包括自动加压给水设备、无塔供水装置、其他自来水生产专用设备",
                                        "kws": "自动加压给水设备、无塔供水装置",
                                        "taxName": "水资源专用机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090255040000000000",
                                        "taxCodeTitle": "水资源专用机械",
                                        "iTitle": "*水资源专用机械*自来水生产专用设备",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3149",
                                "linkid": "2740",
                                "code": "1090256",
                                "paCode": "10902",
                                "yn": "Y",
                                "title": "机器人及具有独立功能专用机械",
                                "alias": "机器人",
                                "about": "包括工业机器人、机械式遥控操作装置（遥控机械手）、具有独立功能专用机械",
                                "kws": null,
                                "taxName": "机器人",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1090256000000000000",
                                "taxCodeTitle": "机器人",
                                "iTitle": "*机器人*机器人及具有独立功能专用机械",
                                "children": [
                                    {
                                        "id": "3150",
                                        "linkid": "3149",
                                        "code": "109025601",
                                        "paCode": "1090256",
                                        "yn": "N",
                                        "title": "工业机器人",
                                        "alias": "工业机器人",
                                        "about": "工业机器人是一种自动机器设备，可按程序重复进行一套动作，包括简单更换不同工具即可执行各种功能的工业机器人。具体包括多功能工业机器人、焊接专用机器人、工业机器人零部件、其他工业机器人。",
                                        "kws": "工业机器人、多功能工业机器人、焊接专用机器人、工业机器人零部件",
                                        "taxName": "机器人",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090256010000000000",
                                        "taxCodeTitle": "机器人",
                                        "iTitle": "*机器人*工业机器人",
                                        "children": []
                                    },
                                    {
                                        "id": "3151",
                                        "linkid": "3149",
                                        "code": "109025602",
                                        "paCode": "1090256",
                                        "yn": "N",
                                        "title": "机械式遥控操作装置（遥控机械手）",
                                        "alias": "机械式遥控操作装置（遥控机械手）",
                                        "about": "指对一定距离外的物体进行手动操纵的遥控装置，简称遥操器，又称遥控机械手。遥操器主要用于操纵一定距离外太大、太小或难于接近的对象。",
                                        "kws": "#遥控机械手",
                                        "taxName": "机器人",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090256020000000000",
                                        "taxCodeTitle": "机器人",
                                        "iTitle": "*机器人*机械式遥控操作装置（遥控机械手）",
                                        "children": []
                                    },
                                    {
                                        "id": "3152",
                                        "linkid": "3149",
                                        "code": "109025603",
                                        "paCode": "1090256",
                                        "yn": "N",
                                        "title": "具有独立功能专用机械",
                                        "alias": "具有独立功能专用机械",
                                        "about": "包括空气增湿器及减湿器、蒸发式空气冷却器、涂敷研磨料机械、发动机启动器、泵式自动加润滑脂机、电焊条涂层机、清洗胶印墨辊机械、重涂胶印墨辊机械、金属芯拔除机、螺栓安装及拆除机、具有独立功能专用机械零部件、其他具有独立功能专用机械。",
                                        "kws": "#空气增湿器、空气减湿器、蒸发式空气冷却器、涂敷研磨料机械、发动机启动器、泵式自动加润滑脂机、电焊条涂层机、清洗胶印墨辊机械、重涂胶印墨辊机械、金属芯拔除机、螺栓安装及拆除机",
                                        "taxName": "机器人",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090256030000000000",
                                        "taxCodeTitle": "机器人",
                                        "iTitle": "*机器人*具有独立功能专用机械",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3153",
                                "linkid": "2740",
                                "code": "1090299",
                                "paCode": "10902",
                                "yn": "N",
                                "title": "其他专用设备及零部件",
                                "alias": "其他专用设备及零部件",
                                "about": "包括其他专用设备、其他专用设备零部件。",
                                "kws": null,
                                "taxName": "其他专用设备",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1090299000000000000",
                                "taxCodeTitle": "其他专用设备",
                                "iTitle": "*其他专用设备*其他专用设备及零部件",
                                "children": []
                            }
                        ]
                    },
                    {
                        "id": "3154",
                        "linkid": "2501",
                        "code": "10903",
                        "paCode": "109",
                        "yn": "Y",
                        "title": "交通运输设备",
                        "alias": "交通运输设备",
                        "about": null,
                        "kws": null,
                        "taxName": "交通运输设备",
                        "taxRate": "",
                        "vip": "7",
                        "itaxRate": null,
                        "taxCode": "1090300000000000000",
                        "taxCodeTitle": "交通运输设备",
                        "iTitle": "*交通运输设备*交通运输设备",
                        "children": [
                            {
                                "id": "3155",
                                "linkid": "3154",
                                "code": "1090301",
                                "paCode": "10903",
                                "yn": "Y",
                                "title": "铁道及电车道用机车、车辆及动车组",
                                "alias": "铁道及电车道用机车、车辆及动车组",
                                "about": null,
                                "kws": null,
                                "taxName": "交通运输设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090301000000000000",
                                "taxCodeTitle": "交通运输设备",
                                "iTitle": "*交通运输设备*铁道及电车道用机车、车辆及动车组",
                                "children": [
                                    {
                                        "id": "3156",
                                        "linkid": "3155",
                                        "code": "109030101",
                                        "paCode": "1090301",
                                        "yn": "N",
                                        "title": "铁路机车",
                                        "alias": "铁路机车",
                                        "about": "指配有各种动力装置（蒸汽机、柴油机、汽轮机、汽油机、气动机等），或由外部电源或蓄电池驱动的各种铁道机车",
                                        "kws": "铁路电力机车、微机控制直流电力机车、交流电力机车、铁路内燃机车、微机控制柴油电力铁道机车、液力传动柴油机车、机械传动柴油机车、铁路蒸汽机车、蓄电池电力机车",
                                        "taxName": "交通运输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090301010000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*铁路机车",
                                        "children": []
                                    },
                                    {
                                        "id": "3157",
                                        "linkid": "3155",
                                        "code": "109030102",
                                        "paCode": "1090301",
                                        "yn": "N",
                                        "title": "动车组",
                                        "alias": "动车组",
                                        "about": "亦称多动力单元列车,包括城间动车组车辆",
                                        "kws": "电力动车组、集中动力动车组、分散动力动车组、内燃动车组、集中式动力动车组、分散式动力动车组",
                                        "taxName": "交通运输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090301020000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*动车组",
                                        "children": []
                                    },
                                    {
                                        "id": "3158",
                                        "linkid": "3155",
                                        "code": "109030103",
                                        "paCode": "1090301",
                                        "yn": "N",
                                        "title": "城市轨道车辆",
                                        "alias": "城市轨道车辆",
                                        "about": "具有运量大、速度快、安全、准点、保护环境、节约能源和用地等特点的交通方式，简称”轨交“，包括地铁、轻轨、快轨、有轨电车等",
                                        "kws": "轨道车辆、地铁车辆、轻轨车辆、单轨车辆、有轨电车",
                                        "taxName": "交通运输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090301030000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*城市轨道车辆",
                                        "children": []
                                    },
                                    {
                                        "id": "3159",
                                        "linkid": "3155",
                                        "code": "109030104",
                                        "paCode": "1090301",
                                        "yn": "N",
                                        "title": "铁路客车",
                                        "alias": "铁路客车",
                                        "about": "铁路客车是指载运旅客的车辆、为旅客提供服务的车辆以及挂运在旅客列车中的其他用途的车辆。客车分旅客运送、旅客服务和特殊用途等3种车辆。目前，中国铁路客车根据用途的不同，主要有如下几种：硬座车、软座车、硬卧车、软卧车、行李车、餐车、邮政车、试验车。高速客车中还有一等软座车、二等软座等车。此外，还有公务车、卫生车、医务车、维修车、文教车、特种车等。",
                                        "kws": "铁路客车、厢式客车、单层硬座客车、双层硬座客车、单层软座客车、双层软座客车、卧铺客车、单层硬卧客车、双层硬卧客车、单层软卧客车、双层软卧客车、娱乐车",
                                        "taxName": "交通运输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090301040000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*铁路客车",
                                        "children": []
                                    },
                                    {
                                        "id": "3160",
                                        "linkid": "3155",
                                        "code": "109030105",
                                        "paCode": "1090301",
                                        "yn": "N",
                                        "title": "铁路货车",
                                        "alias": "铁路货车",
                                        "about": "在铁路上用于载运货物的车辆称为铁路货车。按其用途不同，可分为通用货车和专用货车。主要类型有棚车、敞车、罐车、平板车等。包括各种非机动有篷及无篷货车，铁道运输用特种平车；不包括在矿区、建筑工地、工厂、仓库等处的轨道上运输货物的小型车辆或敞车（详见1090302）",
                                        "kws": "铁路货车、敞车、封闭货车、铁路油罐货车、铁路保温车、铁路冷藏货车、铁路自动卸货车、铁路带篷货车、铁路液罐车、铁路运输用特种平车、铁路双层货车、铁路载运活物特制货车",
                                        "taxName": "交通运输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090301050000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*铁路货车",
                                        "children": []
                                    },
                                    {
                                        "id": "3161",
                                        "linkid": "3155",
                                        "code": "109030106",
                                        "paCode": "1090301",
                                        "yn": "N",
                                        "title": "铁路特殊用途车辆",
                                        "alias": "铁路特殊用途车辆",
                                        "about": "包括铁路起居车、行李车、轨道流动邮政车、轨道救护车、医务车、装甲客车、铁路用通讯特种车、轨路文教车、其他铁路特殊用途车辆等在内的铁路运输车辆。",
                                        "kws": "铁路特殊用途车辆、铁路起居车、行李车、轨道流动邮政车、轨道救护车、医务车、装甲客车、铁路用通讯特种车、轨路文教车",
                                        "taxName": "交通运输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090301060000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*铁路特殊用途车辆",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3162",
                                "linkid": "3154",
                                "code": "1090302",
                                "paCode": "10903",
                                "yn": "N",
                                "title": "工矿有轨专用车辆（窄轨机车车辆）",
                                "alias": "工矿有轨专用车辆（窄轨机车车辆）",
                                "about": "指可用作交通运输的窄轨内燃机车、电力机车和窄轨非机动车辆总称",
                                "kws": "工矿有轨专用车辆、窄轨机车车辆、窄轨非机动车辆、窄轨客车、窄轨货车、窄轨牵引机车、窄轨电力机车、窄轨内燃机车、窄轨蒸汽机车",
                                "taxName": "交通运输设备",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1090302000000000000",
                                "taxCodeTitle": "交通运输设备",
                                "iTitle": "*交通运输设备*工矿有轨专用车辆（窄轨机车车辆）",
                                "children": []
                            },
                            {
                                "id": "3163",
                                "linkid": "3154",
                                "code": "1090303",
                                "paCode": "10903",
                                "yn": "N",
                                "title": "铁路机车车辆配件及零件",
                                "alias": "铁路机车车辆配件及零件",
                                "about": "包括铁道及电车道机车、动车组及其他车辆的配件及零件",
                                "kws": null,
                                "taxName": "交通运输设备",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1090303000000000000",
                                "taxCodeTitle": "交通运输设备",
                                "iTitle": "*交通运输设备*铁路机车车辆配件及零件",
                                "children": []
                            },
                            {
                                "id": "3164",
                                "linkid": "3154",
                                "code": "1090304",
                                "paCode": "10903",
                                "yn": "N",
                                "title": "铁路专用设备及器材、配件",
                                "alias": "铁路专用设备及器材、配件",
                                "about": "包含铁路及电车道检查、维修车，铁路作业及服务车，铺轨、调轨机械，轨道固定装置及附件，平交道、道岔口控制器固定装置及附件，铁路用电动气动操纵设备，铁路用机械信号、交通管理装置，铁路专用测量或检验仪器等设备",
                                "kws": null,
                                "taxName": "交通运输设备",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1090304000000000000",
                                "taxCodeTitle": "交通运输设备",
                                "iTitle": "*交通运输设备*铁路专用设备及器材、配件",
                                "children": []
                            },
                            {
                                "id": "3165",
                                "linkid": "3154",
                                "code": "1090305",
                                "paCode": "10903",
                                "yn": "Y",
                                "title": "汽车",
                                "alias": "汽车",
                                "about": "指汽车整车",
                                "kws": null,
                                "taxName": "交通运输设备",
                                "taxRate": "",
                                "vip": "3",
                                "itaxRate": null,
                                "taxCode": "1090305000000000000",
                                "taxCodeTitle": "交通运输设备",
                                "iTitle": "*交通运输设备*汽车",
                                "children": [
                                    {
                                        "id": "3166",
                                        "linkid": "3165",
                                        "code": "109030501",
                                        "paCode": "1090305",
                                        "yn": "Y",
                                        "title": "乘用车",
                                        "alias": "乘用车",
                                        "about": "含9座（含）以下客车",
                                        "kws": "乘用车、基本型乘用车、多功能乘用车、运动型多用途乘用车、交叉型乘用车",
                                        "taxName": "机动车",
                                        "taxRate": "",
                                        "vip": "5",
                                        "itaxRate": null,
                                        "taxCode": "1090305010000000000",
                                        "taxCodeTitle": "机动车",
                                        "iTitle": "*机动车*乘用车",
                                        "children": [
                                            {
                                                "id": "3167",
                                                "linkid": "3166",
                                                "code": "10903050101",
                                                "paCode": "109030501",
                                                "yn": "N",
                                                "title": "乘用车（排气量在1.0升以下（含））",
                                                "alias": "乘用车（排气量在1.0升以下（含））",
                                                "about": "包括出租汽车、运动车及赛车，活顶乘用车、高级乘用车、小型乘用车、敞篷车、仓背乘用车",
                                                "kws": "#出租汽车、运动车及赛车，活顶乘用车、高级乘用车、小型乘用车、敞篷车、仓背乘用车",
                                                "taxName": "机动车",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090305010100000000",
                                                "taxCodeTitle": "机动车",
                                                "iTitle": "*机动车*乘用车（排气量在1.0升以下（含））",
                                                "children": []
                                            },
                                            {
                                                "id": "3168",
                                                "linkid": "3166",
                                                "code": "10903050102",
                                                "paCode": "109030501",
                                                "yn": "N",
                                                "title": "乘用车（排气量在1.0升以上至1.5升（含））",
                                                "alias": "乘用车（排气量在1.0升以上至1.5升（含））",
                                                "about": "包括出租汽车、运动车及赛车，活顶乘用车、高级乘用车、小型乘用车、敞篷车、仓背乘用车",
                                                "kws": "#出租汽车、运动车及赛车，活顶乘用车、高级乘用车、小型乘用车、敞篷车、仓背乘用车",
                                                "taxName": "机动车",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090305010200000000",
                                                "taxCodeTitle": "机动车",
                                                "iTitle": "*机动车*乘用车（排气量在1.0升以上至1.5升（含））",
                                                "children": []
                                            },
                                            {
                                                "id": "3169",
                                                "linkid": "3166",
                                                "code": "10903050103",
                                                "paCode": "109030501",
                                                "yn": "N",
                                                "title": "乘用车（排气量在1.5升以上至2.0升（含））",
                                                "alias": "乘用车（排气量在1.5升以上至2.0升（含））",
                                                "about": "包括出租汽车、运动车及赛车，活顶乘用车、高级乘用车、小型乘用车、敞篷车、仓背乘用车",
                                                "kws": "#出租汽车、运动车及赛车，活顶乘用车、高级乘用车、小型乘用车、敞篷车、仓背乘用车",
                                                "taxName": "机动车",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090305010300000000",
                                                "taxCodeTitle": "机动车",
                                                "iTitle": "*机动车*乘用车（排气量在1.5升以上至2.0升（含））",
                                                "children": []
                                            },
                                            {
                                                "id": "3170",
                                                "linkid": "3166",
                                                "code": "10903050104",
                                                "paCode": "109030501",
                                                "yn": "N",
                                                "title": "乘用车（排气量在2.0升以上至2.5升（含））",
                                                "alias": "乘用车（排气量在2.0升以上至2.5升（含））",
                                                "about": "包括出租汽车、运动车及赛车，活顶乘用车、高级乘用车、小型乘用车、敞篷车、仓背乘用车",
                                                "kws": "#出租汽车、运动车及赛车，活顶乘用车、高级乘用车、小型乘用车、敞篷车、仓背乘用车",
                                                "taxName": "机动车",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090305010400000000",
                                                "taxCodeTitle": "机动车",
                                                "iTitle": "*机动车*乘用车（排气量在2.0升以上至2.5升（含））",
                                                "children": []
                                            },
                                            {
                                                "id": "3171",
                                                "linkid": "3166",
                                                "code": "10903050105",
                                                "paCode": "109030501",
                                                "yn": "N",
                                                "title": "乘用车（排气量在2.5升以上至3.0升（含））",
                                                "alias": "乘用车（排气量在2.5升以上至3.0升（含））",
                                                "about": "包括出租汽车、运动车及赛车，活顶乘用车、高级乘用车、小型乘用车、敞篷车、仓背乘用车",
                                                "kws": "#出租汽车、运动车及赛车，活顶乘用车、高级乘用车、小型乘用车、敞篷车、仓背乘用车",
                                                "taxName": "机动车",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090305010500000000",
                                                "taxCodeTitle": "机动车",
                                                "iTitle": "*机动车*乘用车（排气量在2.5升以上至3.0升（含））",
                                                "children": []
                                            },
                                            {
                                                "id": "3172",
                                                "linkid": "3166",
                                                "code": "10903050106",
                                                "paCode": "109030501",
                                                "yn": "N",
                                                "title": "乘用车（排气量在3.0升以上至4.0升（含））",
                                                "alias": "乘用车（排气量在3.0升以上至4.0升（含））",
                                                "about": "包括出租汽车、运动车及赛车，活顶乘用车、高级乘用车、小型乘用车、敞篷车、仓背乘用车",
                                                "kws": "#出租汽车、运动车及赛车，活顶乘用车、高级乘用车、小型乘用车、敞篷车、仓背乘用车",
                                                "taxName": "机动车",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090305010600000000",
                                                "taxCodeTitle": "机动车",
                                                "iTitle": "*机动车*乘用车（排气量在3.0升以上至4.0升（含））",
                                                "children": []
                                            },
                                            {
                                                "id": "3173",
                                                "linkid": "3166",
                                                "code": "10903050107",
                                                "paCode": "109030501",
                                                "yn": "N",
                                                "title": "乘用车（排气量在4.0升以上）",
                                                "alias": "乘用车（排气量在4.0升以上）",
                                                "about": "包括出租汽车、运动车及赛车，活顶乘用车、高级乘用车、小型乘用车、敞篷车、仓背乘用车",
                                                "kws": "#出租汽车、运动车及赛车，活顶乘用车、高级乘用车、小型乘用车、敞篷车、仓背乘用车",
                                                "taxName": "机动车",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090305010700000000",
                                                "taxCodeTitle": "机动车",
                                                "iTitle": "*机动车*乘用车（排气量在4.0升以上）",
                                                "children": []
                                            },
                                            {
                                                "id": "3174",
                                                "linkid": "3166",
                                                "code": "10903050108",
                                                "paCode": "109030501",
                                                "yn": "N",
                                                "title": "超豪华小汽车",
                                                "alias": "超豪华小汽车",
                                                "about": "包括每辆零售价格130万元（不含增值税）及以上的乘用车和中轻型商用客车，即乘用车和中轻型商用客车子税目中的超豪华小汽车。",
                                                "kws": "豪华小汽车、乘用车、中轻型商用客车",
                                                "taxName": "机动车",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090305010800000000",
                                                "taxCodeTitle": "机动车",
                                                "iTitle": "*机动车*超豪华小汽车",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "3175",
                                        "linkid": "3165",
                                        "code": "109030502",
                                        "paCode": "1090305",
                                        "yn": "Y",
                                        "title": "客车",
                                        "alias": "客车",
                                        "about": "不含9座（含）以下客车",
                                        "kws": "客车",
                                        "taxName": "机动车",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "1090305020000000000",
                                        "taxCodeTitle": "机动车",
                                        "iTitle": "*机动车*客车",
                                        "children": [
                                            {
                                                "id": "3176",
                                                "linkid": "3175",
                                                "code": "10903050201",
                                                "paCode": "109030502",
                                                "yn": "N",
                                                "title": "客车（大于23座）",
                                                "alias": "客车（大于23座）",
                                                "about": "一般具有方形车厢，用于载运乘客及其随身行李的商用车，这类车型主要用于公共交通和团体运输使用。",
                                                "kws": "大于23座客车",
                                                "taxName": "机动车",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090305020100000000",
                                                "taxCodeTitle": "机动车",
                                                "iTitle": "*机动车*客车（大于23座）",
                                                "children": []
                                            },
                                            {
                                                "id": "3177",
                                                "linkid": "3175",
                                                "code": "10903050202",
                                                "paCode": "109030502",
                                                "yn": "N",
                                                "title": "客车（10至23座，含10，23座）",
                                                "alias": "客车（10至23座，含10，23座）",
                                                "about": "一般具有方形车厢，用于载运乘客及其随身行李的商用车，这类车型主要用于公共交通和团体运输使用。",
                                                "kws": "10至23座客车",
                                                "taxName": "机动车",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090305020200000000",
                                                "taxCodeTitle": "机动车",
                                                "iTitle": "*机动车*客车（10至23座，含10，23座）",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "3178",
                                        "linkid": "3165",
                                        "code": "109030503",
                                        "paCode": "1090305",
                                        "yn": "N",
                                        "title": "载货汽车",
                                        "alias": "载货汽车",
                                        "about": "指货运机动车，包括平板式、油布篷式、封闭箱式等各种送货汽车、搬家具车",
                                        "kws": "货车、货运汽车、载货汽车",
                                        "taxName": "机动车",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090305030000000000",
                                        "taxCodeTitle": "机动车",
                                        "iTitle": "*机动车*载货汽车",
                                        "children": []
                                    },
                                    {
                                        "id": "3179",
                                        "linkid": "3165",
                                        "code": "109030504",
                                        "paCode": "1090305",
                                        "yn": "N",
                                        "title": "半挂牵引车",
                                        "alias": "半挂牵引车",
                                        "about": "指装备有特殊装置用于牵引半挂车的商用车辆",
                                        "kws": "半挂牵引车",
                                        "taxName": "机动车",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090305040000000000",
                                        "taxCodeTitle": "机动车",
                                        "iTitle": "*机动车*半挂牵引车",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3180",
                                "linkid": "3154",
                                "code": "1090306",
                                "paCode": "10903",
                                "yn": "Y",
                                "title": "改装汽车",
                                "alias": "改装汽车",
                                "about": null,
                                "kws": null,
                                "taxName": "机动车",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "1090306000000000000",
                                "taxCodeTitle": "机动车",
                                "iTitle": "*机动车*改装汽车",
                                "children": [
                                    {
                                        "id": "3181",
                                        "linkid": "3180",
                                        "code": "109030601",
                                        "paCode": "1090306",
                                        "yn": "N",
                                        "title": "排气量在1.0升以下（含1.0升）的乘用车底盘（车架）改装、改制的车辆",
                                        "alias": "排气量在1.0升以下（含1.0升）的乘用车底盘（车架）改装、改制的车辆",
                                        "about": "改装汽车是完成专用任务的汽车。在普通汽车底盘上装备或附加某些专用机构而组成。",
                                        "kws": "#改装汽车",
                                        "taxName": "机动车",
                                        "taxRate": "13%",
                                        "vip": "8",
                                        "itaxRate": "0.13",
                                        "taxCode": "1090306010000000000",
                                        "taxCodeTitle": "机动车",
                                        "iTitle": "*机动车*排气量在1.0升以下（含1.0升）的乘用车底盘（车架）改装、改制的车辆",
                                        "children": []
                                    },
                                    {
                                        "id": "3182",
                                        "linkid": "3180",
                                        "code": "109030602",
                                        "paCode": "1090306",
                                        "yn": "N",
                                        "title": "排气量在1.0升以上至1.5升（含1.5升）的乘用车底盘（车架）改装、改制的车辆",
                                        "alias": "排气量在1.0升以上至1.5升（含1.5升）的乘用车底盘（车架）改装、改制的车辆",
                                        "about": "改装汽车是完成专用任务的汽车。在普通汽车底盘上装备或附加某些专用机构而组成。",
                                        "kws": "#改装汽车",
                                        "taxName": "机动车",
                                        "taxRate": "13%",
                                        "vip": "8",
                                        "itaxRate": "0.13",
                                        "taxCode": "1090306020000000000",
                                        "taxCodeTitle": "机动车",
                                        "iTitle": "*机动车*排气量在1.0升以上至1.5升（含1.5升）的乘用车底盘（车架）改装、改制的车辆",
                                        "children": []
                                    },
                                    {
                                        "id": "3183",
                                        "linkid": "3180",
                                        "code": "109030603",
                                        "paCode": "1090306",
                                        "yn": "N",
                                        "title": "中轻型商用客车底盘（车架）改装、改制的车辆",
                                        "alias": "中轻型商用客车底盘（车架）改装、改制的车辆",
                                        "about": "改装汽车是完成专用任务的汽车。在普通汽车底盘上装备或附加某些专用机构而组成。",
                                        "kws": "10至23座改装客车",
                                        "taxName": "机动车",
                                        "taxRate": "13%",
                                        "vip": "8",
                                        "itaxRate": "0.13",
                                        "taxCode": "1090306030000000000",
                                        "taxCodeTitle": "机动车",
                                        "iTitle": "*机动车*中轻型商用客车底盘（车架）改装、改制的车辆",
                                        "children": []
                                    },
                                    {
                                        "id": "3184",
                                        "linkid": "3180",
                                        "code": "109030699",
                                        "paCode": "1090306",
                                        "yn": "N",
                                        "title": "其他改装汽车",
                                        "alias": "其他改装汽车",
                                        "about": "改装汽车是完成专用任务的汽车。在普通汽车底盘上装备或附加某些专用机构而组成。",
                                        "kws": null,
                                        "taxName": "机动车",
                                        "taxRate": "13%",
                                        "vip": "8",
                                        "itaxRate": "0.13",
                                        "taxCode": "1090306990000000000",
                                        "taxCodeTitle": "机动车",
                                        "iTitle": "*机动车*其他改装汽车",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3185",
                                "linkid": "3154",
                                "code": "1090307",
                                "paCode": "10903",
                                "yn": "Y",
                                "title": "低速载货汽车",
                                "alias": "低速载货汽车",
                                "about": null,
                                "kws": null,
                                "taxName": "机动车",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1090307000000000000",
                                "taxCodeTitle": "机动车",
                                "iTitle": "*机动车*低速载货汽车",
                                "children": [
                                    {
                                        "id": "3186",
                                        "linkid": "3185",
                                        "code": "109030701",
                                        "paCode": "1090307",
                                        "yn": "N",
                                        "title": "三轮运输车",
                                        "alias": "三轮运输车",
                                        "about": "以柴油机为动力，最高设计车速小于等于50km/h，最大设计总质量不大于2000kg，长小于等于4.6m，宽小于等于1.6m，高小于等于2m，具有三个车轮的货车。采用方向盘转向、由传递轴传递功力、有驾驶室且驾驶员座椅后有物品放置空间的，长小于等于5.2m，宽小于等于1.8m，高小于等于2.2m。",
                                        "kws": "三轮农用车",
                                        "taxName": "机动车",
                                        "taxRate": "",
                                        "vip": "5",
                                        "itaxRate": null,
                                        "taxCode": "1090307010000000000",
                                        "taxCodeTitle": "机动车",
                                        "iTitle": "*机动车*三轮运输车",
                                        "children": []
                                    },
                                    {
                                        "id": "3187",
                                        "linkid": "3185",
                                        "code": "109030702",
                                        "paCode": "1090307",
                                        "yn": "N",
                                        "title": "其他低速载货汽车",
                                        "alias": "其他低速载货汽车",
                                        "about": "以柴油机为动力，最高设计车速小于70km/h，最大设计总质量小于等于4500kg，长小于等于6m，宽小于等于2m，高小于等于2.5m，具有四个车轮的货车",
                                        "kws": "低速载货车",
                                        "taxName": "机动车",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090307020000000000",
                                        "taxCodeTitle": "机动车",
                                        "iTitle": "*机动车*其他低速载货汽车",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3188",
                                "linkid": "3154",
                                "code": "1090308",
                                "paCode": "10903",
                                "yn": "Y",
                                "title": "汽车车身、挂车",
                                "alias": "汽车车身、挂车",
                                "about": "包含汽车车身，挂车、半挂车，挂车及半挂车零件",
                                "kws": "汽车车身、挂车",
                                "taxName": "交通运输设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090308000000000000",
                                "taxCodeTitle": "交通运输设备",
                                "iTitle": "*交通运输设备*汽车车身、挂车",
                                "children": [
                                    {
                                        "id": "3189",
                                        "linkid": "3188",
                                        "code": "109030801",
                                        "paCode": "1090308",
                                        "yn": "N",
                                        "title": "汽车车身",
                                        "alias": "汽车车身",
                                        "about": "包括驾驶室，以及预备装在机动车底盘上的车身，也包括无底盘车辆的车身（这种车的发动机及驱动桥由车身本身支承），还包括组合式车身，其底盘的某些部件也装在车身内",
                                        "kws": "汽车车身",
                                        "taxName": "交通运输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090308010000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*汽车车身",
                                        "children": []
                                    },
                                    {
                                        "id": "3190",
                                        "linkid": "3188",
                                        "code": "109030802",
                                        "paCode": "1090308",
                                        "yn": "N",
                                        "title": "挂车、半挂车",
                                        "alias": "挂车、半挂车",
                                        "about": "包括其他非机械驱动车辆",
                                        "kws": "挂车、半挂车",
                                        "taxName": "交通运输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090308020000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*挂车、半挂车",
                                        "children": []
                                    },
                                    {
                                        "id": "3191",
                                        "linkid": "3188",
                                        "code": "109030803",
                                        "paCode": "1090308",
                                        "yn": "N",
                                        "title": "挂车及半挂车零件",
                                        "alias": "挂车及半挂车零件",
                                        "about": "指必须可确定为专用于或主要用于机动车车辆的零件；包括挂车底盘及其部件、挂车车轴、车身、挂车车轮、挂钩装置、挂车制动器、挂车传动轴、旋转杆及类似零件",
                                        "kws": "挂车零件、半挂车零件",
                                        "taxName": "交通运输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090308030000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*挂车及半挂车零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3192",
                                "linkid": "3154",
                                "code": "1090309",
                                "paCode": "10903",
                                "yn": "N",
                                "title": "电动汽车",
                                "alias": "电动汽车",
                                "about": "电动汽车(BEV)是指以车载电源为动力，用电机驱动车轮行驶，符合道路交通、安全法规各项要求的车辆。",
                                "kws": "电动汽车",
                                "taxName": "机动车",
                                "taxRate": "13%",
                                "vip": "5",
                                "itaxRate": "0.13",
                                "taxCode": "1090309000000000000",
                                "taxCodeTitle": "机动车",
                                "iTitle": "*机动车*电动汽车",
                                "children": []
                            },
                            {
                                "id": "3193",
                                "linkid": "3154",
                                "code": "1090310",
                                "paCode": "10903",
                                "yn": "Y",
                                "title": "机动车零部件及配件",
                                "alias": "机动车零部件及配件",
                                "about": null,
                                "kws": null,
                                "taxName": "交通运输设备",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1090310000000000000",
                                "taxCodeTitle": "交通运输设备",
                                "iTitle": "*交通运输设备*机动车零部件及配件",
                                "children": [
                                    {
                                        "id": "3194",
                                        "linkid": "3193",
                                        "code": "109031001",
                                        "paCode": "1090310",
                                        "yn": "Y",
                                        "title": "机动车（汽车）零配件",
                                        "alias": "机动车（汽车）零配件",
                                        "about": "是构成汽车整体的各个单元及服务于汽车的一种产品。指装配机动车机械的零件或部件；或损坏后重新安装上的零件或部件。",
                                        "kws": "机动车零配件",
                                        "taxName": "交通运输设备",
                                        "taxRate": "",
                                        "vip": "5",
                                        "itaxRate": null,
                                        "taxCode": "1090310010000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*机动车（汽车）零配件",
                                        "children": [
                                            {
                                                "id": "3195",
                                                "linkid": "3194",
                                                "code": "10903100101",
                                                "paCode": "109031001",
                                                "yn": "N",
                                                "title": "机动车制动系统",
                                                "alias": "机动车制动系统",
                                                "about": "对机动车某些部分（主要是车轮）施加一定的力，从而对其进行一定程度的强制制动的一系列专门装置。",
                                                "kws": "机动车制动摩擦片、防抱死制动系统、机动车制动器",
                                                "taxName": "交通运输设备",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090310010100000000",
                                                "taxCodeTitle": "交通运输设备",
                                                "iTitle": "*交通运输设备*机动车制动系统",
                                                "children": []
                                            },
                                            {
                                                "id": "3196",
                                                "linkid": "3194",
                                                "code": "10903100102",
                                                "paCode": "109031001",
                                                "yn": "N",
                                                "title": "机动车缓冲器及其零件",
                                                "alias": "机动车缓冲器及其零件",
                                                "about": "用来安装在汽车悬挂系统的螺旋弹簧处，主要起到缓冲避震作用并对避震器起到保护的设备及其组成单元",
                                                "kws": "缓冲器、缓冲器配件、机动车缓冲器、机动车保险杠",
                                                "taxName": "交通运输设备",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090310010200000000",
                                                "taxCodeTitle": "交通运输设备",
                                                "iTitle": "*交通运输设备*机动车缓冲器及其零件",
                                                "children": []
                                            },
                                            {
                                                "id": "3197",
                                                "linkid": "3194",
                                                "code": "10903100103",
                                                "paCode": "109031001",
                                                "yn": "N",
                                                "title": "变速器总成",
                                                "alias": "变速器总成",
                                                "about": "包括机械式、超速传动式、预选式、电动机械式、自动式变速箱等，还包括变矩转换器、变速箱体、传动轴、小齿轮、直接传动爪形离合器及变速拉杆等",
                                                "kws": "变速器总成、牵引车用变速器总成、拖拉机用变速器总成、大型机动客车用变速器总成、非公路用自卸车用变速器总成、轻型柴油货车用变速器总成、汽油货车用变速器总成、重型柴油货车用变速器总成、基本型乘用车用自动换挡变速箱",
                                                "taxName": "交通运输设备",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090310010300000000",
                                                "taxCodeTitle": "交通运输设备",
                                                "iTitle": "*交通运输设备*变速器总成",
                                                "children": []
                                            },
                                            {
                                                "id": "3198",
                                                "linkid": "3194",
                                                "code": "10903100104",
                                                "paCode": "109031001",
                                                "yn": "N",
                                                "title": "驱动桥总成",
                                                "alias": "驱动桥总成",
                                                "about": "指机动车辆用装有差速器的驱动桥",
                                                "kws": "牵引车用驱动桥总成、拖拉机用驱动桥总成、大型机动客车用驱动桥总成、非公路用自卸车用驱动桥总成、轻型柴油货车用驱动桥总成、汽油货车用驱动桥总成、重型柴油货车用驱动桥总成",
                                                "taxName": "交通运输设备",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090310010400000000",
                                                "taxCodeTitle": "交通运输设备",
                                                "iTitle": "*交通运输设备*驱动桥总成",
                                                "children": []
                                            },
                                            {
                                                "id": "3199",
                                                "linkid": "3194",
                                                "code": "10903100105",
                                                "paCode": "109031001",
                                                "yn": "N",
                                                "title": "非驱动桥总成",
                                                "alias": "非驱动桥总成",
                                                "about": "指机动车辆用装有差速器的驱动桥",
                                                "kws": "牵引车用非驱动桥总成、拖拉机用非驱动桥总成、大型机动客车用非驱动桥总成、非公路用自卸车用非驱动桥总成、轻型柴油货车用非驱动桥总成、汽油货车用非驱动桥总成、重型柴油货车用非驱动桥总成",
                                                "taxName": "交通运输设备",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090310010500000000",
                                                "taxCodeTitle": "交通运输设备",
                                                "iTitle": "*交通运输设备*非驱动桥总成",
                                                "children": []
                                            },
                                            {
                                                "id": "3200",
                                                "linkid": "3194",
                                                "code": "10903100106",
                                                "paCode": "109031001",
                                                "yn": "N",
                                                "title": "机动车车轮总成",
                                                "alias": "机动车车轮总成",
                                                "about": "包括机动车车轮及其零件、附件",
                                                "kws": "牵引车车轮总成、大型机动客车车轮总成、非公路用自卸车车轮总成、轻型柴油货车车轮总成、汽油货车车轮总成、重型柴油货车车轮总成、拖拉机用车轮总成",
                                                "taxName": "交通运输设备",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090310010600000000",
                                                "taxCodeTitle": "交通运输设备",
                                                "iTitle": "*交通运输设备*机动车车轮总成",
                                                "children": []
                                            },
                                            {
                                                "id": "3201",
                                                "linkid": "3194",
                                                "code": "10903100107",
                                                "paCode": "109031001",
                                                "yn": "N",
                                                "title": "机动车悬挂减震器",
                                                "alias": "机动车悬挂减震器",
                                                "about": "包括摩擦式悬挂减震器、液压式悬挂减震器等及其他悬架零件、扭杆弹簧",
                                                "kws": "减震器、乘用车悬挂减震器",
                                                "taxName": "交通运输设备",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090310010700000000",
                                                "taxCodeTitle": "交通运输设备",
                                                "iTitle": "*交通运输设备*机动车悬挂减震器",
                                                "children": []
                                            },
                                            {
                                                "id": "3202",
                                                "linkid": "3194",
                                                "code": "10903100108",
                                                "paCode": "109031001",
                                                "yn": "N",
                                                "title": "机动车辆散热器、消声器及其零件",
                                                "alias": "机动车辆散热器、消声器及其零件",
                                                "about": "散热器属于机动车冷却系统，发动机水冷系统中的散热器由进水室、出水室、主片及散热器芯等三部分构成。消音器，主要用于降低机动车的发电机工作时产生的噪声，其原理是汽车排气管由两个长度不同的管道构成，这两个管道先分开再交汇，由于这两个管道的的长度差值等于汽车所发出的声波的波长的一半，使得两列声波在叠加时发生干涉相互抵消而减弱声强，使传过来的声音减小，从而起到消音的效果。",
                                                "kws": "机动车辆散热器、机动车辆散热水箱、机动车辆消声器、机动车辆排气管",
                                                "taxName": "交通运输设备",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090310010800000000",
                                                "taxCodeTitle": "交通运输设备",
                                                "iTitle": "*交通运输设备*机动车辆散热器、消声器及其零件",
                                                "children": []
                                            },
                                            {
                                                "id": "3203",
                                                "linkid": "3194",
                                                "code": "10903100109",
                                                "paCode": "109031001",
                                                "yn": "N",
                                                "title": "离合器总成",
                                                "alias": "离合器总成",
                                                "about": "包括锥形离合器、盘式离合器、液压离合器、自动离合器、离合器外壳、离合器盘、离合器杆及已装配的离合器摩擦片，不包括电磁离合器零件（详见109041202）。",
                                                "kws": "牵引车用离合器总成、拖拉机用离合器总成、大型机动客车用离合器总成、非公路用自卸车用离合器总成、轻型柴油货车用离合器总成、汽油货车用离合器总成、重型柴油货车用离合器总成",
                                                "taxName": "交通运输设备",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090310010900000000",
                                                "taxCodeTitle": "交通运输设备",
                                                "iTitle": "*交通运输设备*离合器总成",
                                                "children": []
                                            },
                                            {
                                                "id": "3204",
                                                "linkid": "3194",
                                                "code": "10903100110",
                                                "paCode": "109031001",
                                                "yn": "N",
                                                "title": "机动车用控制装置总成",
                                                "alias": "机动车用控制装置总成",
                                                "about": "包括车辆用转向盘、转向柱及转向器、转向轮轴、变速操纵杆及手刹车操纵杆、加速踏板、制动踏板、离合器踏板、制动器及离合器的连杆",
                                                "kws": "牵引车用控制装置总成、拖拉机用控制装置总成、大型机动客车用控制装置总成、非公路用自卸车用控制装置总成、轻型柴油货车用控制装置总成、汽油货车用控制装置总成、重型柴油货车用控制装置总成",
                                                "taxName": "交通运输设备",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090310011000000000",
                                                "taxCodeTitle": "交通运输设备",
                                                "iTitle": "*交通运输设备*机动车用控制装置总成",
                                                "children": []
                                            },
                                            {
                                                "id": "3205",
                                                "linkid": "3194",
                                                "code": "10903100199",
                                                "paCode": "109031001",
                                                "yn": "N",
                                                "title": "其他机动车（汽车）零配件",
                                                "alias": "其他机动车（汽车）零配件",
                                                "about": "其他用于构成汽车整体的各个单元及服务于汽车的一种产品。",
                                                "kws": null,
                                                "taxName": "交通运输设备",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090310019900000000",
                                                "taxCodeTitle": "交通运输设备",
                                                "iTitle": "*交通运输设备*其他机动车（汽车）零配件",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "3206",
                                        "linkid": "3193",
                                        "code": "109031002",
                                        "paCode": "1090310",
                                        "yn": "Y",
                                        "title": "汽车底盘车架、车身及其零配件",
                                        "alias": "汽车底盘车架、车身及其零配件",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "交通运输设备",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "1090310020000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*汽车底盘车架、车身及其零配件",
                                        "children": [
                                            {
                                                "id": "3207",
                                                "linkid": "3206",
                                                "code": "10903100201",
                                                "paCode": "109031002",
                                                "yn": "N",
                                                "title": "汽车底盘车架及其零件",
                                                "alias": "汽车底盘车架及其零件",
                                                "about": "包括汽车底盘车架（未装有发动机）、机动车大梁、支架、横梁、悬挂装置、支撑车身、汽车底盘部件的支架及托架",
                                                "kws": "底盘、车架",
                                                "taxName": "交通运输设备",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090310020100000000",
                                                "taxCodeTitle": "交通运输设备",
                                                "iTitle": "*交通运输设备*汽车底盘车架及其零件",
                                                "children": []
                                            },
                                            {
                                                "id": "3208",
                                                "linkid": "3206",
                                                "code": "10903100202",
                                                "paCode": "109031002",
                                                "yn": "N",
                                                "title": "座椅安全带",
                                                "alias": "座椅安全带",
                                                "about": "安全带是为了在碰撞时对乘员进行约束以及避免碰撞时乘员与方向盘及仪表板等发生二次碰撞或避免碰撞时冲出车外导致死伤的安全装置。",
                                                "kws": "安全带",
                                                "taxName": "交通运输设备",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090310020200000000",
                                                "taxCodeTitle": "交通运输设备",
                                                "iTitle": "*交通运输设备*座椅安全带",
                                                "children": []
                                            },
                                            {
                                                "id": "3209",
                                                "linkid": "3206",
                                                "code": "10903100203",
                                                "paCode": "109031002",
                                                "yn": "N",
                                                "title": "安全气囊装置",
                                                "alias": "安全气囊装置",
                                                "about": "安全气囊是指撞车时在乘员产生二次碰撞前，使气囊膨胀保护乘员的装置。",
                                                "kws": "安全气囊",
                                                "taxName": "交通运输设备",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090310020300000000",
                                                "taxCodeTitle": "交通运输设备",
                                                "iTitle": "*交通运输设备*安全气囊装置",
                                                "children": []
                                            },
                                            {
                                                "id": "3210",
                                                "linkid": "3206",
                                                "code": "10903100204",
                                                "paCode": "109031002",
                                                "yn": "N",
                                                "title": "车窗玻璃升降器",
                                                "alias": "车窗玻璃升降器",
                                                "about": "玻璃升降器是汽车门窗玻璃的升降装置，主要分电动玻璃升降器与手动玻璃升降器两大类。",
                                                "kws": "玻璃升降机",
                                                "taxName": "交通运输设备",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090310020400000000",
                                                "taxCodeTitle": "交通运输设备",
                                                "iTitle": "*交通运输设备*车窗玻璃升降器",
                                                "children": []
                                            },
                                            {
                                                "id": "3211",
                                                "linkid": "3206",
                                                "code": "10903100205",
                                                "paCode": "109031002",
                                                "yn": "N",
                                                "title": "车身底板、侧板及类似板",
                                                "alias": "车身底板、侧板及类似板",
                                                "about": "包括车身底板、侧板、前面板、后面板、行李舱等",
                                                "kws": "叶子板",
                                                "taxName": "交通运输设备",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090310020500000000",
                                                "taxCodeTitle": "交通运输设备",
                                                "iTitle": "*交通运输设备*车身底板、侧板及类似板",
                                                "children": []
                                            },
                                            {
                                                "id": "3212",
                                                "linkid": "3206",
                                                "code": "10903100206",
                                                "paCode": "109031002",
                                                "yn": "N",
                                                "title": "机动车门及其零件",
                                                "alias": "机动车门及其零件",
                                                "about": "用于封闭机动车内部空间的设置及其配套附件，包含密封胶带、内装饰板、车内控制器、车门锁闭机构、外部开启装置等。",
                                                "kws": "车门板",
                                                "taxName": "交通运输设备",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090310020600000000",
                                                "taxCodeTitle": "交通运输设备",
                                                "iTitle": "*交通运输设备*机动车门及其零件",
                                                "children": []
                                            },
                                            {
                                                "id": "3213",
                                                "linkid": "3206",
                                                "code": "10903100207",
                                                "paCode": "109031002",
                                                "yn": "N",
                                                "title": "机动车车窗、窗框",
                                                "alias": "机动车车窗、窗框",
                                                "about": "包括机动车带框玻璃窗、装有加热电阻器及电气接头的窗、窗框",
                                                "kws": "车窗",
                                                "taxName": "交通运输设备",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090310020700000000",
                                                "taxCodeTitle": "交通运输设备",
                                                "iTitle": "*交通运输设备*机动车车窗、窗框",
                                                "children": []
                                            },
                                            {
                                                "id": "3214",
                                                "linkid": "3206",
                                                "code": "10903100299",
                                                "paCode": "109031002",
                                                "yn": "N",
                                                "title": "其他车身零配件",
                                                "alias": "其他车身零配件",
                                                "about": "指其他车身零件及其配套附件，包括发动机罩、散热器护罩、机动车脚踏板、挡泥板、叶子板、仪表板、车牌照托架、转向柱托架、机动车的外部行李架、遮阳板，由车辆发动机供热的非电气供暖及除霜设备，还包括尚未具有不完整车身特征的组合体",
                                                "kws": null,
                                                "taxName": "交通运输设备",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090310029900000000",
                                                "taxCodeTitle": "交通运输设备",
                                                "iTitle": "*交通运输设备*其他车身零配件",
                                                "children": []
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "id": "3215",
                                "linkid": "3154",
                                "code": "1090311",
                                "paCode": "10903",
                                "yn": "N",
                                "title": "汽车底盘",
                                "alias": "汽车底盘",
                                "about": "不带车身的机动车辆，包括装有发动机、传动机构、转向机构及驱动桥（不论是否装有车轮）、机动车辆用的底盘车架或底盘车身整体式车架",
                                "kws": "汽车底盘",
                                "taxName": "交通运输设备",
                                "taxRate": "13%",
                                "vip": null,
                                "itaxRate": "0.13",
                                "taxCode": "1090311000000000000",
                                "taxCodeTitle": "交通运输设备",
                                "iTitle": "*交通运输设备*汽车底盘",
                                "children": []
                            },
                            {
                                "id": "3216",
                                "linkid": "3154",
                                "code": "1090312",
                                "paCode": "10903",
                                "yn": "Y",
                                "title": "摩托车整车",
                                "alias": "摩托车整车",
                                "about": null,
                                "kws": null,
                                "taxName": "机动车",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1090312000000000000",
                                "taxCodeTitle": "机动车",
                                "iTitle": "*机动车*摩托车整车",
                                "children": [
                                    {
                                        "id": "3217",
                                        "linkid": "3216",
                                        "code": "109031201",
                                        "paCode": "1090312",
                                        "yn": "N",
                                        "title": "摩托车，排气量在250毫升以下（不含250毫升）",
                                        "alias": "摩托车，排气量在250毫升以下（不含250毫升）",
                                        "about": "指往复式内燃机摩托车,含普通型摩托车、踏板摩托车、三轮摩托车和其他摩托车",
                                        "kws": "#普通型摩托车、踏板摩托车、三轮摩托车和其他摩托车",
                                        "taxName": "机动车",
                                        "taxRate": "13%",
                                        "vip": "8",
                                        "itaxRate": "0.13",
                                        "taxCode": "1090312010000000000",
                                        "taxCodeTitle": "机动车",
                                        "iTitle": "*机动车*摩托车，排气量在250毫升以下（不含250毫升）",
                                        "children": []
                                    },
                                    {
                                        "id": "3218",
                                        "linkid": "3216",
                                        "code": "109031202",
                                        "paCode": "1090312",
                                        "yn": "N",
                                        "title": "摩托车，排气量是250毫升以上（含250毫升）",
                                        "alias": "摩托车，排气量是250毫升以上（含250毫升）",
                                        "about": "指往复式内燃机摩托车,含普通型摩托车、踏板摩托车、三轮摩托车和其他摩托车",
                                        "kws": "#普通型摩托车、踏板摩托车、三轮摩托车和其他摩托车",
                                        "taxName": "机动车",
                                        "taxRate": "13%",
                                        "vip": "8",
                                        "itaxRate": "0.13",
                                        "taxCode": "1090312020000000000",
                                        "taxCodeTitle": "机动车",
                                        "iTitle": "*机动车*摩托车，排气量是250毫升以上（含250毫升）",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3219",
                                "linkid": "3154",
                                "code": "1090313",
                                "paCode": "10903",
                                "yn": "N",
                                "title": "摩托车零部件及配件",
                                "alias": "摩托车零部件及配件",
                                "about": "是构成摩托车整体的各个单元及服务于摩托车的一种产品。指装配摩托车机械的零件或部件；或损坏后重新安装上的零件或部件。",
                                "kws": "摩托配件",
                                "taxName": "交通运输设备",
                                "taxRate": "13%",
                                "vip": "5",
                                "itaxRate": "0.13",
                                "taxCode": "1090313000000000000",
                                "taxCodeTitle": "交通运输设备",
                                "iTitle": "*交通运输设备*摩托车零部件及配件",
                                "children": []
                            },
                            {
                                "id": "3220",
                                "linkid": "3154",
                                "code": "1090314",
                                "paCode": "10903",
                                "yn": "Y",
                                "title": "脚踏自行车及其零件",
                                "alias": "脚踏自行车及其零件",
                                "about": null,
                                "kws": "自行车",
                                "taxName": "交通运输设备",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1090314000000000000",
                                "taxCodeTitle": "交通运输设备",
                                "iTitle": "*交通运输设备*脚踏自行车及其零件",
                                "children": [
                                    {
                                        "id": "3221",
                                        "linkid": "3220",
                                        "code": "109031401",
                                        "paCode": "1090314",
                                        "yn": "N",
                                        "title": "两轮脚踏自行车",
                                        "alias": "两轮脚踏自行车",
                                        "about": "不包括助动自行车（详见1090316）",
                                        "kws": "两轮自行车",
                                        "taxName": "交通运输设备",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1090314010000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*两轮脚踏自行车",
                                        "children": []
                                    },
                                    {
                                        "id": "3222",
                                        "linkid": "3220",
                                        "code": "109031402",
                                        "paCode": "1090314",
                                        "yn": "N",
                                        "title": "三轮脚踏自行车",
                                        "alias": "三轮脚踏自行车",
                                        "about": "不包括机动三轮车（详见1090309）",
                                        "kws": "三轮自行车",
                                        "taxName": "交通运输设备",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1090314020000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*三轮脚踏自行车",
                                        "children": []
                                    },
                                    {
                                        "id": "3223",
                                        "linkid": "3220",
                                        "code": "109031403",
                                        "paCode": "1090314",
                                        "yn": "N",
                                        "title": "特种脚踏自行车",
                                        "alias": "特种脚踏自行车",
                                        "about": "包含双人脚踏自行车、独轮脚踏自行车、其他特种脚踏自行车",
                                        "kws": "特种自行车",
                                        "taxName": "交通运输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090314030000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*特种脚踏自行车",
                                        "children": []
                                    },
                                    {
                                        "id": "3224",
                                        "linkid": "3220",
                                        "code": "109031404",
                                        "paCode": "1090314",
                                        "yn": "N",
                                        "title": "脚踏自行车零件",
                                        "alias": "脚踏自行车零件",
                                        "about": null,
                                        "kws": "自行车配件",
                                        "taxName": "交通运输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090314040000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*脚踏自行车零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3225",
                                "linkid": "3154",
                                "code": "1090315",
                                "paCode": "10903",
                                "yn": "N",
                                "title": "残疾人用车",
                                "alias": "残疾人用车",
                                "about": "指专用于载运残疾人（病人、瘫痪者、残废人等）的车辆。",
                                "kws": "残疾人座车、非动力残疾人车、轮椅",
                                "taxName": "机动车",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1090315000000000000",
                                "taxCodeTitle": "机动车",
                                "iTitle": "*机动车*残疾人用车",
                                "children": []
                            },
                            {
                                "id": "3226",
                                "linkid": "3154",
                                "code": "1090316",
                                "paCode": "10903",
                                "yn": "N",
                                "title": "助动自行车及其零件",
                                "alias": "助动自行车及其零件",
                                "about": "不包括供儿童乘骑的带轮玩具及其零件（详见106040801）",
                                "kws": "助力车、助动自行车",
                                "taxName": "交通运输设备",
                                "taxRate": "13%",
                                "vip": "5",
                                "itaxRate": "0.13",
                                "taxCode": "1090316000000000000",
                                "taxCodeTitle": "交通运输设备",
                                "iTitle": "*交通运输设备*助动自行车及其零件",
                                "children": []
                            },
                            {
                                "id": "3227",
                                "linkid": "3154",
                                "code": "1090317",
                                "paCode": "10903",
                                "yn": "N",
                                "title": "休闲专用车及其零附件",
                                "alias": "休闲专用车及其零附件",
                                "about": "指车体轻便、可以用于休闲竞技、表演等场地，用于休闲活动赛道或赛场，49～800CC四轮或四轮以上气动或电动的沙滩车，用于休闲赛场、丘陵、沙漠等特殊地形等活动的卡丁车，用于农场、庄园等车前带拖斗可放置农用器具的农夫车，高尔夫球车，车身装有履带、雪橇、滑雪板、扫雪工具等，用于雪地休闲活动的休闲雪地车，指一般无动力或稍带一点动力用于草地等休闲活动草地车，观光车，代步车，其他休闲专用车，及其零附件。",
                                "kws": "休闲专用车、运动休闲两轮车、运动休闲三轮车、运动休闲两轮越野车、运动休闲两轮跑车、滑板车、四轮休闲车、四轮以上休闲车、沙滩车、卡丁车、农夫车、高尔夫球车、休闲雪地车、草地车、观光车",
                                "taxName": "交通运输设备",
                                "taxRate": "13%",
                                "vip": "5",
                                "itaxRate": "0.13",
                                "taxCode": "1090317000000000000",
                                "taxCodeTitle": "交通运输设备",
                                "iTitle": "*交通运输设备*休闲专用车及其零附件",
                                "children": []
                            },
                            {
                                "id": "3228",
                                "linkid": "3154",
                                "code": "1090318",
                                "paCode": "10903",
                                "yn": "Y",
                                "title": "金属船舶",
                                "alias": "金属船舶",
                                "about": "不包括游艇（详见1090320）",
                                "kws": "金属船舶",
                                "taxName": "交通运输设备",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "1090318000000000000",
                                "taxCodeTitle": "交通运输设备",
                                "iTitle": "*交通运输设备*金属船舶",
                                "children": [
                                    {
                                        "id": "3229",
                                        "linkid": "3228",
                                        "code": "109031801",
                                        "paCode": "1090318",
                                        "yn": "N",
                                        "title": "机动货船",
                                        "alias": "机动货船",
                                        "about": "包括客货船。由动力装置驱动或牵引在水上行驶的供运送货物的船只",
                                        "kws": "机动货船",
                                        "taxName": "交通运输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090318010000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*机动货船",
                                        "children": []
                                    },
                                    {
                                        "id": "3230",
                                        "linkid": "3228",
                                        "code": "109031802",
                                        "paCode": "1090318",
                                        "yn": "N",
                                        "title": "机动客船",
                                        "alias": "机动客船",
                                        "about": "由动力装置驱动或牵引在水上行驶供乘用的船只",
                                        "kws": "机动客船",
                                        "taxName": "交通运输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090318020000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*机动客船",
                                        "children": []
                                    },
                                    {
                                        "id": "3231",
                                        "linkid": "3228",
                                        "code": "109031803",
                                        "paCode": "1090318",
                                        "yn": "N",
                                        "title": "机动渔船",
                                        "alias": "机动渔船",
                                        "about": "由动力装置驱动或牵引在水上行驶的供捕捞的船只",
                                        "kws": "捕捞渔船、渔轮、渔业辅助船",
                                        "taxName": "交通运输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090318030000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*机动渔船",
                                        "children": []
                                    },
                                    {
                                        "id": "3232",
                                        "linkid": "3228",
                                        "code": "109031804",
                                        "paCode": "1090318",
                                        "yn": "N",
                                        "title": "机动工程（工作）船",
                                        "alias": "机动工程（工作）船",
                                        "about": "由动力装置驱动或牵引在水上行驶用于工程作业的船只",
                                        "kws": "工程船、巡逻船、拖轮、顶推船、挖泥船、起重船、航标船、灯船、消防船、海底钻探船、打捞船、破冰船、铺管船、引航船、交通艇、救生艇",
                                        "taxName": "交通运输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090318040000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*机动工程（工作）船",
                                        "children": []
                                    },
                                    {
                                        "id": "3233",
                                        "linkid": "3228",
                                        "code": "109031805",
                                        "paCode": "1090318",
                                        "yn": "N",
                                        "title": "其他机动船",
                                        "alias": "其他机动船",
                                        "about": "其他由动力装置驱动或牵引在水上行驶的船只",
                                        "kws": null,
                                        "taxName": "交通运输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090318050000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*其他机动船",
                                        "children": []
                                    },
                                    {
                                        "id": "3234",
                                        "linkid": "3228",
                                        "code": "109031806",
                                        "paCode": "1090318",
                                        "yn": "N",
                                        "title": "非机动船",
                                        "alias": "非机动船",
                                        "about": "包括驳船、浮船坞。",
                                        "kws": "非机动船",
                                        "taxName": "交通运输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090318060000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*非机动船",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3235",
                                "linkid": "3154",
                                "code": "1090319",
                                "paCode": "10903",
                                "yn": "N",
                                "title": "非金属船舶",
                                "alias": "非金属船舶",
                                "about": "包括玻璃钢渔船、木渔船、玻璃钢客货运输船、木船、橡皮船、气垫船等。不包括游艇（详见1090320）",
                                "kws": "非金属捕鱼船、玻璃钢渔船、木渔船、玻璃钢客货运输船、木船、橡皮船、气垫船",
                                "taxName": "交通运输设备",
                                "taxRate": "13%",
                                "vip": null,
                                "itaxRate": "0.13",
                                "taxCode": "1090319000000000000",
                                "taxCodeTitle": "交通运输设备",
                                "iTitle": "*交通运输设备*非金属船舶",
                                "children": []
                            },
                            {
                                "id": "3236",
                                "linkid": "3154",
                                "code": "1090320",
                                "paCode": "10903",
                                "yn": "N",
                                "title": "游艇",
                                "alias": "游艇",
                                "about": "艇身长度大于8米（含）小于90米（含），内置发动机，可以在水上移动，一般为私人或团体购置，主要用于水上运动和休闲娱乐等非牟利活动的各类机动艇。",
                                "kws": "游艇",
                                "taxName": "交通运输设备",
                                "taxRate": "13%",
                                "vip": null,
                                "itaxRate": "0.13",
                                "taxCode": "1090320000000000000",
                                "taxCodeTitle": "交通运输设备",
                                "iTitle": "*交通运输设备*游艇",
                                "children": []
                            },
                            {
                                "id": "3237",
                                "linkid": "3154",
                                "code": "1090321",
                                "paCode": "10903",
                                "yn": "Y",
                                "title": "船用配套设备",
                                "alias": "船用配套设备",
                                "about": "包括船用甲板机械、自动化、检测、监控系统、专用设备、环保设备、海上救生设备、船用配套设备零件",
                                "kws": "船用配套设备",
                                "taxName": "交通运输设备",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "1090321000000000000",
                                "taxCodeTitle": "交通运输设备",
                                "iTitle": "*交通运输设备*船用配套设备",
                                "children": [
                                    {
                                        "id": "3238",
                                        "linkid": "3237",
                                        "code": "109032101",
                                        "paCode": "1090321",
                                        "yn": "N",
                                        "title": "船用甲板机械",
                                        "alias": "船用甲板机械",
                                        "about": "不包括船用卷扬机及绞盘（详见109011104）",
                                        "kws": "舵机、锚泊设备、船舶专用起重设备、船用拖曳机械、快速止索器、辅助甲板机械、陀螺稳定器",
                                        "taxName": "交通运输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090321010000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*船用甲板机械",
                                        "children": []
                                    },
                                    {
                                        "id": "3239",
                                        "linkid": "3237",
                                        "code": "109032102",
                                        "paCode": "1090321",
                                        "yn": "N",
                                        "title": "船舶自动化、检测、监控系统",
                                        "alias": "船舶自动化、检测、监控系统",
                                        "about": "包括机舱自动化控制装置、综合船桥系统等",
                                        "kws": "船舶自动化检测监控系统、机舱自动化控制装置、综合船桥系统",
                                        "taxName": "交通运输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090321020000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*船舶自动化、检测、监控系统",
                                        "children": []
                                    },
                                    {
                                        "id": "3240",
                                        "linkid": "3237",
                                        "code": "109032103",
                                        "paCode": "1090321",
                                        "yn": "N",
                                        "title": "船舶专用设备",
                                        "alias": "船舶专用设备",
                                        "about": "船舶用陀螺稳定器，船舶驾驶及操舵设备，船用海水淡化装置，船舶安全装置，其他船舶专用设备，包括稳定装置、船舶防腐蚀装置、船舶管路系统、船舶应急设备等",
                                        "kws": "船舶用陀螺稳定器、船舶驾驶设备、操舵设备、船用海水淡化装置、船舶安全装置",
                                        "taxName": "交通运输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090321030000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*船舶专用设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3241",
                                        "linkid": "3237",
                                        "code": "109032104",
                                        "paCode": "1090321",
                                        "yn": "N",
                                        "title": "船用环保设备",
                                        "alias": "船用环保设备",
                                        "about": "包括油分浓度计、船用油水界面探测器等的船舶防污监测系统，船用垃圾焚烧炉，生化法污水处理装置，船用油污水分离装置，包括油水过滤器，其他船用环保设备",
                                        "kws": "船舶防污监测系统、船用垃圾焚烧炉、生化法污水处理装置、船用油污水分离装置",
                                        "taxName": "交通运输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090321040000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*船用环保设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3242",
                                        "linkid": "3237",
                                        "code": "109032105",
                                        "paCode": "1090321",
                                        "yn": "N",
                                        "title": "海上救生设备",
                                        "alias": "海上救生设备",
                                        "about": "包括船用救生设备，但不包括救生艇（详见109031804）",
                                        "kws": "救生筏、个人救生设备、降落设备、登乘设备",
                                        "taxName": "交通运输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090321050000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*海上救生设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3243",
                                        "linkid": "3237",
                                        "code": "109032106",
                                        "paCode": "1090321",
                                        "yn": "N",
                                        "title": "船用配套设备零件",
                                        "alias": "船用配套设备零件",
                                        "about": "包括船舶用舵机稳定器用零件，船舶用舵机及陀螺稳定器用零件，其他船用配套设备零件",
                                        "kws": "船用配套设备零件",
                                        "taxName": "交通运输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090321060000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*船用配套设备零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3244",
                                "linkid": "3154",
                                "code": "1090322",
                                "paCode": "10903",
                                "yn": "N",
                                "title": "船用推进器及螺旋桨、锚制品",
                                "alias": "船用推进器及螺旋桨、锚制品",
                                "about": "包括钢铁锚及零件，多爪锚及零件，喷水推进器，Z型推进器，侧向推进器，其他船用推进器，船用螺旋桨桨叶",
                                "kws": "船用推进器、船用螺旋桨、锚制品",
                                "taxName": "交通运输设备",
                                "taxRate": "13%",
                                "vip": null,
                                "itaxRate": "0.13",
                                "taxCode": "1090322000000000000",
                                "taxCodeTitle": "交通运输设备",
                                "iTitle": "*交通运输设备*船用推进器及螺旋桨、锚制品",
                                "children": []
                            },
                            {
                                "id": "3245",
                                "linkid": "3154",
                                "code": "1090323",
                                "paCode": "10903",
                                "yn": "Y",
                                "title": "航标器材，相关浮动装置",
                                "alias": "航标器材，相关浮动装置",
                                "about": null,
                                "kws": null,
                                "taxName": "交通运输设备",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "1090323000000000000",
                                "taxCodeTitle": "交通运输设备",
                                "iTitle": "*交通运输设备*航标器材，相关浮动装置",
                                "children": [
                                    {
                                        "id": "3246",
                                        "linkid": "3245",
                                        "code": "109032301",
                                        "paCode": "1090323",
                                        "yn": "N",
                                        "title": "航标器材",
                                        "alias": "航标器材",
                                        "about": "包含浮筒、浮标、浮罐、其他航标器材",
                                        "kws": "航标器材",
                                        "taxName": "交通运输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090323010000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*航标器材",
                                        "children": []
                                    },
                                    {
                                        "id": "3247",
                                        "linkid": "3245",
                                        "code": "109032302",
                                        "paCode": "1090323",
                                        "yn": "N",
                                        "title": "浮动结构体、浮式装置",
                                        "alias": "浮动结构体、浮式装置",
                                        "about": "包含浮舟、浮吊、浮柜、潜水箱、隔离舱、泊位平台、作坞门用浮动结构体、其他浮动结构体、浮式装置",
                                        "kws": "浮动结构体、浮式装置、浮舟、浮吊、浮柜、潜水箱、隔离舱、泊位平台、作坞门用浮动结构体",
                                        "taxName": "交通运输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090323020000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*浮动结构体、浮式装置",
                                        "children": []
                                    },
                                    {
                                        "id": "3248",
                                        "linkid": "3245",
                                        "code": "109032303",
                                        "paCode": "1090323",
                                        "yn": "N",
                                        "title": "海洋石油浮动工程结构物",
                                        "alias": "海洋石油浮动工程结构物",
                                        "about": "包含浮式生产储油船、浮动或潜水式钻探或生产平台",
                                        "kws": "浮式生产储油船、浮动钻探平台、浮动生产平台、潜水式钻探平台、潜水式生产平台、自升式平台、潜水式平台、半潜式平台、超大型海上结构物",
                                        "taxName": "交通运输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090323030000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*海洋石油浮动工程结构物",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3249",
                                "linkid": "3154",
                                "code": "1090324",
                                "paCode": "10903",
                                "yn": "Y",
                                "title": "航空器及其零件",
                                "alias": "航空器及其零件",
                                "about": null,
                                "kws": null,
                                "taxName": "交通运输设备",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "1090324000000000000",
                                "taxCodeTitle": "交通运输设备",
                                "iTitle": "*交通运输设备*航空器及其零件",
                                "children": [
                                    {
                                        "id": "3250",
                                        "linkid": "3249",
                                        "code": "109032401",
                                        "paCode": "1090324",
                                        "yn": "Y",
                                        "title": "民用飞机及直升机",
                                        "alias": "民用飞机及直升机",
                                        "about": "包含民用飞机和民用直升机",
                                        "kws": "民用飞机",
                                        "taxName": "交通运输设备",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "1090324010000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*民用飞机及直升机",
                                        "children": [
                                            {
                                                "id": "3251",
                                                "linkid": "3250",
                                                "code": "10903240101",
                                                "paCode": "109032401",
                                                "yn": "N",
                                                "title": "民用飞机",
                                                "alias": "民用飞机",
                                                "about": "又叫民用固定翼飞机分为商业飞机和通用飞机。商业飞机有国内和国际干线客机、货机或客货两用机以及国内支线运输机。通用飞机有公务机、农业机、林业机、轻型多用途机、巡逻救护机、体育运动机和私人飞机等。",
                                                "kws": "民用固定翼飞机",
                                                "taxName": "交通运输设备",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090324010100000000",
                                                "taxCodeTitle": "交通运输设备",
                                                "iTitle": "*交通运输设备*民用飞机",
                                                "children": []
                                            },
                                            {
                                                "id": "3252",
                                                "linkid": "3250",
                                                "code": "10903240102",
                                                "paCode": "109032401",
                                                "yn": "N",
                                                "title": "民用直升机",
                                                "alias": "民用直升机",
                                                "about": "非军事用途的直升机主要由机体和升力（含旋翼和尾桨）、动力、传动三大系统以及机载飞行设备等组成。旋翼一般由涡轮轴发动机或活塞式发动机通过由传动轴及减速器等组成的机械传动系统来驱动，也可由桨尖喷气产生的反作用力来驱动。",
                                                "kws": "民用直升机",
                                                "taxName": "交通运输设备",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090324010200000000",
                                                "taxCodeTitle": "交通运输设备",
                                                "iTitle": "*交通运输设备*民用直升机",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "3253",
                                        "linkid": "3249",
                                        "code": "109032402",
                                        "paCode": "1090324",
                                        "yn": "N",
                                        "title": "无动力航空器",
                                        "alias": "无动力航空器",
                                        "about": "滑翔机及悬挂滑翔机,自由或系留气球,专用气球,机动飞艇,其他无动力航空器等。",
                                        "kws": "滑翔机、悬挂滑翔机、自由气球、系留气球、专用气球、机动飞艇",
                                        "taxName": "交通运输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090324020000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*无动力航空器",
                                        "children": []
                                    },
                                    {
                                        "id": "3254",
                                        "linkid": "3249",
                                        "code": "109032403",
                                        "paCode": "1090324",
                                        "yn": "N",
                                        "title": "航空器发射、甲板停机装置及地面飞行训练装置",
                                        "alias": "航空器发射、甲板停机装置及地面飞行训练装置",
                                        "about": "包括航空器发射装置,甲板停机装置及其零件",
                                        "kws": "航空器发射、甲板停机装置、地面飞行训练装置",
                                        "taxName": "交通运输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090324030000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*航空器发射、甲板停机装置及地面飞行训练装置",
                                        "children": []
                                    },
                                    {
                                        "id": "3255",
                                        "linkid": "3249",
                                        "code": "109032404",
                                        "paCode": "1090324",
                                        "yn": "N",
                                        "title": "航空器零件",
                                        "alias": "航空器零件",
                                        "about": "飞机及直升机零件,气球、飞艇零件,航空器及其运载工具零件,其他航空器零件",
                                        "kws": null,
                                        "taxName": "交通运输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090324040000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*航空器零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3256",
                                "linkid": "3154",
                                "code": "1090325",
                                "paCode": "10903",
                                "yn": "Y",
                                "title": "航天器及其运载工具、零件",
                                "alias": "航天器及其运载工具、零件",
                                "about": null,
                                "kws": null,
                                "taxName": "交通运输设备",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "1090325000000000000",
                                "taxCodeTitle": "交通运输设备",
                                "iTitle": "*交通运输设备*航天器及其运载工具、零件",
                                "children": [
                                    {
                                        "id": "3257",
                                        "linkid": "3256",
                                        "code": "109032501",
                                        "paCode": "1090325",
                                        "yn": "Y",
                                        "title": "航天器及其运载工具",
                                        "alias": "航天器及其运载工具",
                                        "about": "又称空间飞行器、太空飞行器。按照天体力学的规律在太空运行，执行探索、开发、利用太空和天体等特定任务的各类飞行器。把有效载荷从地面运送到太空预定位置（轨道）、从太空某位置运回地面或运送到太空另一位置的运载工具的统称，包括一次性使用运载火箭、部分重复使用运载器和完全重复使用运载器。",
                                        "kws": "航天器、航天器运载工具、空间飞行器、太空飞行器",
                                        "taxName": "交通运输设备",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "1090325010000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*航天器及其运载工具",
                                        "children": [
                                            {
                                                "id": "3258",
                                                "linkid": "3257",
                                                "code": "10903250101",
                                                "paCode": "109032501",
                                                "yn": "N",
                                                "title": "航天飞机",
                                                "alias": "航天飞机",
                                                "about": "又称为太空梭或太空穿梭机，是可重复使用的、往返于太空和地面之间的航天器，结合了飞机与航天器的性质。它既能代表运载火箭把人造卫星等航天器送入太空，也能像载人飞船那样在轨道上运行，还能像飞机那样在大气层中滑翔着陆。",
                                                "kws": "航天飞机、太空梭、太空穿梭机",
                                                "taxName": "交通运输设备",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090325010100000000",
                                                "taxCodeTitle": "交通运输设备",
                                                "iTitle": "*交通运输设备*航天飞机",
                                                "children": []
                                            },
                                            {
                                                "id": "3259",
                                                "linkid": "3257",
                                                "code": "10903250102",
                                                "paCode": "109032501",
                                                "yn": "N",
                                                "title": "飞船",
                                                "alias": "飞船",
                                                "about": "飞船是一种一次性使用的航天器。它能基本保证航天员在太空短期生活并进行一定的工作。它的运行时间一般是几天到半个月，一般乘2到3名航天员。又称宇宙飞船。",
                                                "kws": "飞船、宇宙飞船、航天飞船",
                                                "taxName": "交通运输设备",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090325010200000000",
                                                "taxCodeTitle": "交通运输设备",
                                                "iTitle": "*交通运输设备*飞船",
                                                "children": []
                                            },
                                            {
                                                "id": "3260",
                                                "linkid": "3257",
                                                "code": "10903250103",
                                                "paCode": "109032501",
                                                "yn": "N",
                                                "title": "卫星",
                                                "alias": "卫星",
                                                "about": "人造卫星是由人类建造，以太空飞行载具如火箭、航天飞机等发射到太空中，像天然卫星一样环绕地球或其它行星的装置。",
                                                "kws": "卫星有效载荷、卫星平台、星上设备、卫星地面设备",
                                                "taxName": "交通运输设备",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090325010300000000",
                                                "taxCodeTitle": "交通运输设备",
                                                "iTitle": "*交通运输设备*卫星",
                                                "children": []
                                            },
                                            {
                                                "id": "3261",
                                                "linkid": "3257",
                                                "code": "10903250104",
                                                "paCode": "109032501",
                                                "yn": "N",
                                                "title": "运载火箭",
                                                "alias": "运载火箭",
                                                "about": "每一级都包括箭体结构、推进系统和飞行控制系统。末级有仪器舱，内装制导与控制系统、遥测系统和发射场安全系统。级与级之间靠级间段连接。有效载荷装在仪器舱的上面，外面套有整流罩。包括箭体结构,火箭发动机,箭上设备,运载火箭地面设备,其他运载火箭设备",
                                                "kws": "运载火箭、箭体结构、火箭发动机、箭上设备、运载火箭地面设备",
                                                "taxName": "交通运输设备",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090325010400000000",
                                                "taxCodeTitle": "交通运输设备",
                                                "iTitle": "*交通运输设备*运载火箭",
                                                "children": []
                                            },
                                            {
                                                "id": "3262",
                                                "linkid": "3257",
                                                "code": "10903250105",
                                                "paCode": "109032501",
                                                "yn": "N",
                                                "title": "探空火箭",
                                                "alias": "探空火箭",
                                                "about": "探空火箭（是一种比较特殊的运载工具，它只携带科学仪器进行亚轨道飞行。探空火箭一般为无控制火箭，具有结构简单、成本低廉、发射方便等优点。探空火箭系统由有效载荷、火箭、发射装置和地面台站组成。",
                                                "kws": "探空火箭",
                                                "taxName": "交通运输设备",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090325010500000000",
                                                "taxCodeTitle": "交通运输设备",
                                                "iTitle": "*交通运输设备*探空火箭",
                                                "children": []
                                            },
                                            {
                                                "id": "3263",
                                                "linkid": "3257",
                                                "code": "10903250106",
                                                "paCode": "109032501",
                                                "yn": "N",
                                                "title": "气象火箭",
                                                "alias": "气象火箭",
                                                "about": "探测高空大气参数（温度、压力、密度、风）的空火箭。气象火箭获得的高空大气资料可用于天气预报、气候变化和灾害性天气研究。",
                                                "kws": "气象火箭",
                                                "taxName": "交通运输设备",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090325010600000000",
                                                "taxCodeTitle": "交通运输设备",
                                                "iTitle": "*交通运输设备*气象火箭",
                                                "children": []
                                            },
                                            {
                                                "id": "3264",
                                                "linkid": "3257",
                                                "code": "10903250199",
                                                "paCode": "109032501",
                                                "yn": "N",
                                                "title": "其他航天器",
                                                "alias": "其他航天器",
                                                "about": null,
                                                "kws": null,
                                                "taxName": "交通运输设备",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090325019900000000",
                                                "taxCodeTitle": "交通运输设备",
                                                "iTitle": "*交通运输设备*其他航天器",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "3265",
                                        "linkid": "3256",
                                        "code": "109032502",
                                        "paCode": "1090325",
                                        "yn": "N",
                                        "title": "航天器及其运载工具零件",
                                        "alias": "航天器及其运载工具零件",
                                        "about": "用于航天飞机、卫星、运载火箭、探空火箭、气象火箭和其他航天器的附属部件及零配件。",
                                        "kws": "航天器、航天器运载工具零件",
                                        "taxName": "交通运输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090325020000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*航天器及其运载工具零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3266",
                                "linkid": "3154",
                                "code": "1090326",
                                "paCode": "10903",
                                "yn": "Y",
                                "title": "潜水及水下救捞装备",
                                "alias": "潜水及水下救捞装备",
                                "about": null,
                                "kws": null,
                                "taxName": "交通运输设备",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "1090326000000000000",
                                "taxCodeTitle": "交通运输设备",
                                "iTitle": "*交通运输设备*潜水及水下救捞装备",
                                "children": [
                                    {
                                        "id": "3267",
                                        "linkid": "3266",
                                        "code": "109032601",
                                        "paCode": "1090326",
                                        "yn": "N",
                                        "title": "潜水装备",
                                        "alias": "潜水装备",
                                        "about": "包括通风式重潜水装备，氦氧重潜水装备，轻潜水装备，其他潜水装备",
                                        "kws": "潜水装备、通风式重潜水装备、氦氧重潜水装备、轻潜水装备",
                                        "taxName": "交通运输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090326010000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*潜水装备",
                                        "children": []
                                    },
                                    {
                                        "id": "3268",
                                        "linkid": "3266",
                                        "code": "109032602",
                                        "paCode": "1090326",
                                        "yn": "N",
                                        "title": "潜水水下作业用装备",
                                        "alias": "潜水水下作业用装备",
                                        "about": "水下喷焊器，潜水通讯装置，潜水供气设备，饱和潜水系统，配有机械装置金属潜水衣，其他潜水水下作业用装备",
                                        "kws": "潜水水下作业用装备、水下喷焊器、潜水通讯装置、潜水供气设备、饱和潜水系统、配有机械装置金属潜水衣",
                                        "taxName": "交通运输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090326020000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*潜水水下作业用装备",
                                        "children": []
                                    },
                                    {
                                        "id": "3269",
                                        "linkid": "3266",
                                        "code": "109032603",
                                        "paCode": "1090326",
                                        "yn": "N",
                                        "title": "潜水服",
                                        "alias": "潜水服",
                                        "about": "指不带呼吸装置的潜水服，包括湿式潜水服，干式潜水服，潜水水暖服，其他潜水服，不包括配有机械装置的金属潜水衣（详见109032602）",
                                        "kws": "潜水服、湿式潜水服、干式潜水服、潜水水暖服",
                                        "taxName": "交通运输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090326030000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*潜水服",
                                        "children": []
                                    },
                                    {
                                        "id": "3270",
                                        "linkid": "3266",
                                        "code": "109032604",
                                        "paCode": "1090326",
                                        "yn": "N",
                                        "title": "水下潜器",
                                        "alias": "水下潜器",
                                        "about": "包括载人水下潜器，有缆无人水下潜器，无缆无人水下潜器，其水下潜器",
                                        "kws": "载人水下潜器、有缆无人水下潜器、无缆无人水下潜器",
                                        "taxName": "交通运输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090326040000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*水下潜器",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3271",
                                "linkid": "3154",
                                "code": "1090327",
                                "paCode": "10903",
                                "yn": "Y",
                                "title": "交通管理用金属标志及类似设施",
                                "alias": "交通管理用金属标志及类似设施",
                                "about": null,
                                "kws": null,
                                "taxName": "交通运输设备",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "1090327000000000000",
                                "taxCodeTitle": "交通运输设备",
                                "iTitle": "*交通运输设备*交通管理用金属标志及类似设施",
                                "children": [
                                    {
                                        "id": "3272",
                                        "linkid": "3271",
                                        "code": "109032701",
                                        "paCode": "1090327",
                                        "yn": "N",
                                        "title": "发光标志及类似品及其零件",
                                        "alias": "发光标志及类似品及其零件",
                                        "about": "包括指示牌或交通标志牌、交通护板、反光板、反光护栏，汽车牌（发光），其他交通管理用发光标志。",
                                        "kws": "发光标志、发光标志零件、交通管理用发光标志、指示牌、交通标志牌、交通护板、反光板、反光护栏、汽车牌、发光铭牌、广告牌",
                                        "taxName": "交通运输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090327010000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*发光标志及类似品及其零件",
                                        "children": []
                                    },
                                    {
                                        "id": "3273",
                                        "linkid": "3271",
                                        "code": "109032702",
                                        "paCode": "1090327",
                                        "yn": "N",
                                        "title": "金属制地名牌、号码及类似标志",
                                        "alias": "金属制地名牌、号码及类似标志",
                                        "about": "公共服务单位用标志牌、禁令牌，旅馆、商店、工厂用招牌，房屋、大门、信箱用地址牌，机器、仪表用类似标志，其他金属制类似标志",
                                        "kws": "金属制地名牌、金属制地名号码、公共服务单位用标志牌、公共服务单位用禁令牌、旅馆用招牌、商店用招牌、工厂用招牌、房屋用地址牌、大门用地址牌、信箱用地址牌",
                                        "taxName": "交通运输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090327020000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*金属制地名牌、号码及类似标志",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3274",
                                "linkid": "3154",
                                "code": "1090328",
                                "paCode": "10903",
                                "yn": "Y",
                                "title": "非机械驱动车辆",
                                "alias": "非机械驱动车辆",
                                "about": null,
                                "kws": null,
                                "taxName": "交通运输设备",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "1090328000000000000",
                                "taxCodeTitle": "交通运输设备",
                                "iTitle": "*交通运输设备*非机械驱动车辆",
                                "children": [
                                    {
                                        "id": "3275",
                                        "linkid": "3274",
                                        "code": "109032801",
                                        "paCode": "1090328",
                                        "yn": "N",
                                        "title": "手推车",
                                        "alias": "手推车",
                                        "about": "包含手推运货车，独轮手推车、斗式手推车，自卸手推车，行李手推车，手推餐车，小型保温手推车，超市购物车（金属制），其他手推车",
                                        "kws": "手推车、手推运货车、独轮手推车、斗式手推车、自卸手推车、行李手推车、手推餐车、小型保温手推车、超市购物车",
                                        "taxName": "交通运输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090328010000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*手推车",
                                        "children": []
                                    },
                                    {
                                        "id": "3276",
                                        "linkid": "3274",
                                        "code": "109032802",
                                        "paCode": "1090328",
                                        "yn": "N",
                                        "title": "畜力拖曳车辆",
                                        "alias": "畜力拖曳车辆",
                                        "about": "包括马车、驴车，牛、狗拉车辆，游览观光用马车，畜力滑撬，运货用兽力车，其他畜力拖曳车辆",
                                        "kws": "游览观光用马车、畜力滑撬车、运货用兽力车",
                                        "taxName": "交通运输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090328020000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*畜力拖曳车辆",
                                        "children": []
                                    },
                                    {
                                        "id": "3277",
                                        "linkid": "3274",
                                        "code": "109032803",
                                        "paCode": "1090328",
                                        "yn": "N",
                                        "title": "非机械驱动车辆零件",
                                        "alias": "非机械驱动车辆零件",
                                        "about": "用于手推车、畜力拖曳车辆、其他非机械动力车的零部件",
                                        "kws": "非机械驱动车辆零件",
                                        "taxName": "交通运输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090328030000000000",
                                        "taxCodeTitle": "交通运输设备",
                                        "iTitle": "*交通运输设备*非机械驱动车辆零件",
                                        "children": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "id": "3278",
                        "linkid": "2501",
                        "code": "10904",
                        "paCode": "109",
                        "yn": "Y",
                        "title": "电气机械及器材",
                        "alias": "电气机械及器材",
                        "about": null,
                        "kws": null,
                        "taxName": "电气机械",
                        "taxRate": "",
                        "vip": "7",
                        "itaxRate": null,
                        "taxCode": "1090400000000000000",
                        "taxCodeTitle": "电气机械",
                        "iTitle": "*电气机械*电气机械及器材",
                        "children": [
                            {
                                "id": "3279",
                                "linkid": "3278",
                                "code": "1090401",
                                "paCode": "10904",
                                "yn": "Y",
                                "title": "发电机",
                                "alias": "发电机",
                                "about": "包括交流发电机和直流发电机，不包括发电机组（详见1090402）",
                                "kws": "发电机",
                                "taxName": "发电机",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090401000000000000",
                                "taxCodeTitle": "发电机",
                                "iTitle": "*发电机*发电机",
                                "children": [
                                    {
                                        "id": "3280",
                                        "linkid": "3279",
                                        "code": "109040101",
                                        "paCode": "1090401",
                                        "yn": "N",
                                        "title": "交流发电机",
                                        "alias": "交流发电机",
                                        "about": "交流电动机主要由一个用以产生磁场的电磁铁绕组或分布的定子绕组和一个旋转电枢或转子组成。电动机利用通电线圈在磁场中受力转动的现象而制成的。",
                                        "kws": "交流发电机",
                                        "taxName": "发电机",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090401010000000000",
                                        "taxCodeTitle": "发电机",
                                        "iTitle": "*发电机*交流发电机",
                                        "children": []
                                    },
                                    {
                                        "id": "3281",
                                        "linkid": "3279",
                                        "code": "109040102",
                                        "paCode": "1090401",
                                        "yn": "N",
                                        "title": "直流发电机",
                                        "alias": "直流发电机",
                                        "about": "包括电磁式直流发电机，永磁式直流发电机，其他直流发电机",
                                        "kws": "直流发电机、电磁式直流发电机、永磁式直流发电机",
                                        "taxName": "发电机",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090401020000000000",
                                        "taxCodeTitle": "发电机",
                                        "iTitle": "*发电机*直流发电机",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3282",
                                "linkid": "3278",
                                "code": "1090402",
                                "paCode": "10904",
                                "yn": "Y",
                                "title": "发电机组、内燃发电机组及旋转式变流机",
                                "alias": "发电机组、内燃发电机组及旋转式变流机",
                                "about": null,
                                "kws": null,
                                "taxName": "发电机组",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090402000000000000",
                                "taxCodeTitle": "发电机组",
                                "iTitle": "*发电机组*发电机组、内燃发电机组及旋转式变流机",
                                "children": [
                                    {
                                        "id": "3283",
                                        "linkid": "3282",
                                        "code": "109040201",
                                        "paCode": "1090402",
                                        "yn": "N",
                                        "title": "发电机组",
                                        "alias": "发电机组",
                                        "about": "发电机组是指由发电机及其原动机组装成（或准备组装成）整套设备或装在同一底座上所组成的机械；不包括内燃发电机组（详见109040202）",
                                        "kws": "发电机组、水轮发电机组、汽轮发电机组、风力发电机组、核发电机组、移动电站",
                                        "taxName": "发电机组",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090402010000000000",
                                        "taxCodeTitle": "发电机组",
                                        "iTitle": "*发电机组*发电机组",
                                        "children": []
                                    },
                                    {
                                        "id": "3284",
                                        "linkid": "3282",
                                        "code": "109040202",
                                        "paCode": "1090402",
                                        "yn": "N",
                                        "title": "内燃发电机组",
                                        "alias": "内燃发电机组",
                                        "about": "以柴油机、汽油机及混合燃料压燃式发动机为动力源的内燃发电机组",
                                        "kws": "内燃发电机组",
                                        "taxName": "发电机组",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090402020000000000",
                                        "taxCodeTitle": "发电机组",
                                        "iTitle": "*发电机组*内燃发电机组",
                                        "children": []
                                    },
                                    {
                                        "id": "3285",
                                        "linkid": "3282",
                                        "code": "109040203",
                                        "paCode": "1090402",
                                        "yn": "N",
                                        "title": "旋转式变流机",
                                        "alias": "旋转式变流机",
                                        "about": "主要由一台发电机与一台原动机组成的交流发电机、直流发电机组，其原动机为电动机",
                                        "kws": "旋转式变流机",
                                        "taxName": "发电机组",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090402030000000000",
                                        "taxCodeTitle": "发电机组",
                                        "iTitle": "*发电机组*旋转式变流机",
                                        "children": []
                                    },
                                    {
                                        "id": "3286",
                                        "linkid": "3282",
                                        "code": "109040204",
                                        "paCode": "1090402",
                                        "yn": "N",
                                        "title": "电机及发电机组专用零件",
                                        "alias": "电机及发电机组专用零件",
                                        "about": "包括交流发电机零件，风力发电机组零件，其他电机及发电机组专用零件",
                                        "kws": "交流发电机零件、风力发电机组零件",
                                        "taxName": "发电机组",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090402040000000000",
                                        "taxCodeTitle": "发电机组",
                                        "iTitle": "*发电机组*电机及发电机组专用零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3287",
                                "linkid": "3278",
                                "code": "1090403",
                                "paCode": "10904",
                                "yn": "Y",
                                "title": "电动机",
                                "alias": "电动机",
                                "about": "不包括数控机床用电动机（详见109010804）",
                                "kws": "电动机",
                                "taxName": "电动机",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090403000000000000",
                                "taxCodeTitle": "电动机",
                                "iTitle": "*电动机*电动机",
                                "children": [
                                    {
                                        "id": "3288",
                                        "linkid": "3287",
                                        "code": "109040301",
                                        "paCode": "1090403",
                                        "yn": "N",
                                        "title": "直流电动机",
                                        "alias": "直流电动机",
                                        "about": "包括轧机用直流电动机、机床用直流电动机、电梯用直流电动机等",
                                        "kws": "直流电动机、轧机用直流电动机、机床用直流电动机、电梯用直流电动机",
                                        "taxName": "电动机",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090403010000000000",
                                        "taxCodeTitle": "电动机",
                                        "iTitle": "*电动机*直流电动机",
                                        "children": []
                                    },
                                    {
                                        "id": "3289",
                                        "linkid": "3287",
                                        "code": "109040302",
                                        "paCode": "1090403",
                                        "yn": "N",
                                        "title": "交流电动机",
                                        "alias": "交流电动机",
                                        "about": "包括多相交流电动机和单相交流电动机、其他交流电动机",
                                        "kws": "交流电动机、多相交流电动机、单相交流电动机",
                                        "taxName": "电动机",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090403020000000000",
                                        "taxCodeTitle": "电动机",
                                        "iTitle": "*电动机*交流电动机",
                                        "children": []
                                    },
                                    {
                                        "id": "3290",
                                        "linkid": "3287",
                                        "code": "109040303",
                                        "paCode": "1090403",
                                        "yn": "N",
                                        "title": "交直流两用电动机",
                                        "alias": "交直流两用电动机",
                                        "about": "P＞37.5W同步交流电动机，异步交流电动机，其他交直流两用电动机",
                                        "kws": "同步交流电动机、通用交流同步电动机、专用交流同步电动机、异步交流电动机、通用交流异步电动机、专用交流异步电动机",
                                        "taxName": "电动机",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090403030000000000",
                                        "taxCodeTitle": "电动机",
                                        "iTitle": "*电动机*交直流两用电动机",
                                        "children": []
                                    },
                                    {
                                        "id": "3291",
                                        "linkid": "3287",
                                        "code": "109040304",
                                        "paCode": "1090403",
                                        "yn": "N",
                                        "title": "小功率电动机",
                                        "alias": "小功率电动机",
                                        "about": "P≤37.5W交流小功率异步电动机，交流小功率同步电动机，小功率直线电动机，小功率直流电动机，小功率交流换向器电动机，其他小功率电动机",
                                        "kws": "小功率电动机、交流小功率异步电动机、交流小功率同步电动机、小功率直线电动机、小功率直流电动机、小功率交流换向器电动机",
                                        "taxName": "电动机",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090403040000000000",
                                        "taxCodeTitle": "电动机",
                                        "iTitle": "*电动机*小功率电动机",
                                        "children": []
                                    },
                                    {
                                        "id": "3292",
                                        "linkid": "3287",
                                        "code": "109040305",
                                        "paCode": "1090403",
                                        "yn": "N",
                                        "title": "微电机",
                                        "alias": "微电机",
                                        "about": "P≤37.5W玩具电动机，控制微电机，驱动微电机，移动通信终端用微型振动电机，专用微特电机，其他微电机。",
                                        "kws": "玩具电动机、控制微电机、自整角机、旋转变压器、感应移相器、感应同步器、伺服微电机、测速发电机、伺服测速机组、步进微电机、力矩微电机、微特电机机组、微特电机组合装置、驱动微电机、异步微电机、同步微电机、直流微电机、直线微电机、平面无刷微电机",
                                        "taxName": "电动机",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090403050000000000",
                                        "taxCodeTitle": "电动机",
                                        "iTitle": "*电动机*微电机",
                                        "children": []
                                    },
                                    {
                                        "id": "3293",
                                        "linkid": "3287",
                                        "code": "109040306",
                                        "paCode": "1090403",
                                        "yn": "N",
                                        "title": "与内燃机配用发电机",
                                        "alias": "与内燃机配用发电机",
                                        "about": "起动电机，两用起动发电机，其他与内燃机配用发电机",
                                        "kws": "起动电机、机车用起动电机、航空器用起动电机、船舶用起动电机、两用起动发电机、机车用两用起动发电机、航空器用两用起动发电机、船舶用两用起动发电机",
                                        "taxName": "电动机",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090403060000000000",
                                        "taxCodeTitle": "电动机",
                                        "iTitle": "*电动机*与内燃机配用发电机",
                                        "children": []
                                    },
                                    {
                                        "id": "3294",
                                        "linkid": "3287",
                                        "code": "109040307",
                                        "paCode": "1090403",
                                        "yn": "N",
                                        "title": "电动机零件",
                                        "alias": "电动机零件",
                                        "about": "交流电动机零件，直流电动机零件，玩具电动机专用零件，微电机专用零件",
                                        "kws": "电动机零件",
                                        "taxName": "电动机",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090403070000000000",
                                        "taxCodeTitle": "电动机",
                                        "iTitle": "*电动机*电动机零件",
                                        "children": []
                                    },
                                    {
                                        "id": "3295",
                                        "linkid": "3287",
                                        "code": "109040399",
                                        "paCode": "1090403",
                                        "yn": "N",
                                        "title": "其他电机",
                                        "alias": "其他电机",
                                        "about": "中频电机，分马力电机，电力测功电机，油泵电机，其他未列明电机",
                                        "kws": null,
                                        "taxName": "电动机",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090403990000000000",
                                        "taxCodeTitle": "电动机",
                                        "iTitle": "*电动机*其他电机",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3296",
                                "linkid": "3278",
                                "code": "1090404",
                                "paCode": "10904",
                                "yn": "Y",
                                "title": "变压器、整流器和电感器",
                                "alias": "变压器、整流器和电感器",
                                "about": "包括变压器，互感器，静止式变流器，电抗器，电感器，变压器、整流器和电感器零件",
                                "kws": "变压器、整流器、电感器、干式变压器、试验变压器、电源变压器、可调电源变压器",
                                "taxName": "变压器整流器",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090404000000000000",
                                "taxCodeTitle": "变压器整流器",
                                "iTitle": "*变压器整流器*变压器、整流器和电感器",
                                "children": [
                                    {
                                        "id": "3297",
                                        "linkid": "3296",
                                        "code": "109040401",
                                        "paCode": "1090404",
                                        "yn": "N",
                                        "title": "变压器",
                                        "alias": "变压器",
                                        "about": "包括电力变压器，换流变压器，干式变压器，试验变压器，电源变压器，可调电源变压器，其他变压器",
                                        "kws": "变压器、电力变压器、换流变压器",
                                        "taxName": "变压器整流器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090404010000000000",
                                        "taxCodeTitle": "变压器整流器",
                                        "iTitle": "*变压器整流器*变压器",
                                        "children": []
                                    },
                                    {
                                        "id": "3298",
                                        "linkid": "3296",
                                        "code": "109040402",
                                        "paCode": "1090404",
                                        "yn": "N",
                                        "title": "互感器",
                                        "alias": "互感器",
                                        "about": "包括电压互感器，电流互感器，组合互感器，其他互感器",
                                        "kws": "互感器",
                                        "taxName": "变压器整流器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090404020000000000",
                                        "taxCodeTitle": "变压器整流器",
                                        "iTitle": "*变压器整流器*互感器",
                                        "children": []
                                    },
                                    {
                                        "id": "3299",
                                        "linkid": "3296",
                                        "code": "109040403",
                                        "paCode": "1090404",
                                        "yn": "N",
                                        "title": "静止式变流器",
                                        "alias": "静止式变流器",
                                        "about": "包括稳压电源，稳流电源，不间断供电电源（UPS），半导体变流器，气体放电变流器，电解整流器，逆变器，交流电变换器，交流电变频设备，直流电变换器，其他静止式变流器备用电源组；不包括计算机用电源机（详见1090512）",
                                        "kws": "静止式变流器、稳压电源、稳流电源、不间断供电电源、电解整流器、半导体变流器、气体放电整流器",
                                        "taxName": "变压器整流器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090404030000000000",
                                        "taxCodeTitle": "变压器整流器",
                                        "iTitle": "*变压器整流器*静止式变流器",
                                        "children": []
                                    },
                                    {
                                        "id": "3300",
                                        "linkid": "3296",
                                        "code": "109040404",
                                        "paCode": "1090404",
                                        "yn": "N",
                                        "title": "电抗器",
                                        "alias": "电抗器",
                                        "about": "包括并联电抗器，串联电抗器，轭流式饱和电抗器，限流电抗器，滤波电抗器，启动电抗器，自饱和电抗器，调幅电抗器，试验用电抗器，整流用平衡电抗器，整流用平波电抗器，阴尼电抗器，接地电抗器，其他电抗器",
                                        "kws": "电抗器、并联电抗器、串联电抗器、轭流式饱、限流电抗器、滤波电抗器、启动电抗器、自饱和电抗器、调幅电抗器、试验用电抗器、整流用平衡电抗器、整流用平波电抗器、阴尼电抗器、接地电抗器",
                                        "taxName": "变压器整流器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090404040000000000",
                                        "taxCodeTitle": "变压器整流器",
                                        "iTitle": "*变压器整流器*电抗器",
                                        "children": []
                                    },
                                    {
                                        "id": "3301",
                                        "linkid": "3296",
                                        "code": "109040405",
                                        "paCode": "1090404",
                                        "yn": "N",
                                        "title": "电感器",
                                        "alias": "电感器",
                                        "about": "包括固定与色码电感器，叠层式片式电感器，线绕式片式电感器，ＬＣ滤波器，其他电感器",
                                        "kws": "电感器、固定电感器、色码电感器、叠层式片式电感器、线绕式片式电感器、ＬＣ滤波器",
                                        "taxName": "变压器整流器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090404050000000000",
                                        "taxCodeTitle": "变压器整流器",
                                        "iTitle": "*变压器整流器*电感器",
                                        "children": []
                                    },
                                    {
                                        "id": "3302",
                                        "linkid": "3296",
                                        "code": "109040406",
                                        "paCode": "1090404",
                                        "yn": "N",
                                        "title": "变压器、整流器和电感器零件",
                                        "alias": "变压器、整流器和电感器零件",
                                        "about": "用于变压器，互感器，静止式变流器，电抗器，电感器的零部件",
                                        "kws": "变压器零件、整流器零件、电感器零件",
                                        "taxName": "变压器整流器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090404060000000000",
                                        "taxCodeTitle": "变压器整流器",
                                        "iTitle": "*变压器整流器*变压器、整流器和电感器零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3303",
                                "linkid": "3278",
                                "code": "1090405",
                                "paCode": "10904",
                                "yn": "Y",
                                "title": "电力电容器及其配套设备",
                                "alias": "电力电容器及其配套设备",
                                "about": null,
                                "kws": null,
                                "taxName": "电力电容器",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090405000000000000",
                                "taxCodeTitle": "电力电容器",
                                "iTitle": "*电力电容器*电力电容器及其配套设备",
                                "children": [
                                    {
                                        "id": "3304",
                                        "linkid": "3303",
                                        "code": "109040501",
                                        "paCode": "1090405",
                                        "yn": "N",
                                        "title": "电力电容器",
                                        "alias": "电力电容器",
                                        "about": "50/60Hz电路用，P≥0.5千乏包括并联电容器、串联电容器、电热电容器、滤波电容器、断路器电容器、耦合电容器、保护电容器、脉冲电容器、标准电容器、其他电力电容器",
                                        "kws": "电力电容器、并联电容器、串联电容器、电热电容器、滤波电容器、断路器电容器、耦合电容器、保护电容器、脉冲电容器、标准电容器",
                                        "taxName": "电力电容器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090405010000000000",
                                        "taxCodeTitle": "电力电容器",
                                        "iTitle": "*电力电容器*电力电容器",
                                        "children": []
                                    },
                                    {
                                        "id": "3305",
                                        "linkid": "3303",
                                        "code": "109040502",
                                        "paCode": "1090405",
                                        "yn": "N",
                                        "title": "电力电容器成套装置",
                                        "alias": "电力电容器成套装置",
                                        "about": "包括并联电容器装置、串联电容器装置、无功就地补偿装置、交流滤波电容器装置、交流电压抽取装置、电容式电压互感器、阻容分压器、其他电力电容器成套装置",
                                        "kws": "电力电容器成套装置、并联电容器装置、串联电容器装置、无功就地补偿装置、交流滤波电容器装置、交流电压抽取装置、电容式电压互感器、阻容分压器",
                                        "taxName": "电力电容器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090405020000000000",
                                        "taxCodeTitle": "电力电容器",
                                        "iTitle": "*电力电容器*电力电容器成套装置",
                                        "children": []
                                    },
                                    {
                                        "id": "3306",
                                        "linkid": "3303",
                                        "code": "109040503",
                                        "paCode": "1090405",
                                        "yn": "N",
                                        "title": "电力电容器零件",
                                        "alias": "电力电容器零件",
                                        "about": "用于电力电容器、电力电容器成套装置的零部件",
                                        "kws": "电力电容器零件",
                                        "taxName": "电力电容器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090405030000000000",
                                        "taxCodeTitle": "电力电容器",
                                        "iTitle": "*电力电容器*电力电容器零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3307",
                                "linkid": "3278",
                                "code": "1090406",
                                "paCode": "10904",
                                "yn": "Y",
                                "title": "高压开关设备",
                                "alias": "高压开关设备",
                                "about": "包括全封闭组合电器（GIS）、六氟化硫断路器、敞开式组合电器、隔离开关、接地开关",
                                "kws": "高压开关设备",
                                "taxName": "高压开关设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090406000000000000",
                                "taxCodeTitle": "高压开关设备",
                                "iTitle": "*高压开关设备*高压开关设备",
                                "children": [
                                    {
                                        "id": "3308",
                                        "linkid": "3307",
                                        "code": "109040601",
                                        "paCode": "1090406",
                                        "yn": "N",
                                        "title": "全封闭组合电器（GIS）",
                                        "alias": "全封闭组合电器（GIS）",
                                        "about": null,
                                        "kws": "全封闭组合电器",
                                        "taxName": "高压开关设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090406010000000000",
                                        "taxCodeTitle": "高压开关设备",
                                        "iTitle": "*高压开关设备*全封闭组合电器（GIS）",
                                        "children": []
                                    },
                                    {
                                        "id": "3309",
                                        "linkid": "3307",
                                        "code": "109040602",
                                        "paCode": "1090406",
                                        "yn": "N",
                                        "title": "六氟化硫断路器",
                                        "alias": "六氟化硫断路器",
                                        "about": null,
                                        "kws": "六氟化硫断路器",
                                        "taxName": "高压开关设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090406020000000000",
                                        "taxCodeTitle": "高压开关设备",
                                        "iTitle": "*高压开关设备*六氟化硫断路器",
                                        "children": []
                                    },
                                    {
                                        "id": "3310",
                                        "linkid": "3307",
                                        "code": "109040603",
                                        "paCode": "1090406",
                                        "yn": "N",
                                        "title": "敞开式组合电器",
                                        "alias": "敞开式组合电器",
                                        "about": null,
                                        "kws": "敞开式组合电器",
                                        "taxName": "高压开关设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090406030000000000",
                                        "taxCodeTitle": "高压开关设备",
                                        "iTitle": "*高压开关设备*敞开式组合电器",
                                        "children": []
                                    },
                                    {
                                        "id": "3311",
                                        "linkid": "3307",
                                        "code": "109040604",
                                        "paCode": "1090406",
                                        "yn": "N",
                                        "title": "隔离开关",
                                        "alias": "隔离开关",
                                        "about": null,
                                        "kws": "隔离开关",
                                        "taxName": "高压开关设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090406040000000000",
                                        "taxCodeTitle": "高压开关设备",
                                        "iTitle": "*高压开关设备*隔离开关",
                                        "children": []
                                    },
                                    {
                                        "id": "3312",
                                        "linkid": "3307",
                                        "code": "109040605",
                                        "paCode": "1090406",
                                        "yn": "N",
                                        "title": "接地开关",
                                        "alias": "接地开关",
                                        "about": null,
                                        "kws": "接地开关",
                                        "taxName": "高压开关设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090406050000000000",
                                        "taxCodeTitle": "高压开关设备",
                                        "iTitle": "*高压开关设备*接地开关",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3313",
                                "linkid": "3278",
                                "code": "1090407",
                                "paCode": "10904",
                                "yn": "Y",
                                "title": "配电或电器控制设备",
                                "alias": "配电或电器控制设备",
                                "about": null,
                                "kws": null,
                                "taxName": "配电控制设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090407000000000000",
                                "taxCodeTitle": "配电控制设备",
                                "iTitle": "*配电控制设备*配电或电器控制设备",
                                "children": [
                                    {
                                        "id": "3314",
                                        "linkid": "3313",
                                        "code": "109040701",
                                        "paCode": "1090407",
                                        "yn": "N",
                                        "title": "高压电路开关、保护电器装置",
                                        "alias": "高压电路开关、保护电器装置",
                                        "about": "高压熔断器,高压自动断路器,隔离开关及断续开关,避雷器、电压限幅器及电涌抑制器,高压开关、保护或连接用组合装置,其他高压电路开关、保护电器装置",
                                        "kws": "高压开关、高压熔断器、高压断路器、高压自动断路器、隔离开关、断续开关、避雷器、电压限幅器、电涌抑制器",
                                        "taxName": "配电控制设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090407010000000000",
                                        "taxCodeTitle": "配电控制设备",
                                        "iTitle": "*配电控制设备*高压电路开关、保护电器装置",
                                        "children": []
                                    },
                                    {
                                        "id": "3315",
                                        "linkid": "3313",
                                        "code": "109040702",
                                        "paCode": "1090407",
                                        "yn": "N",
                                        "title": "低压开关、保护控制装置",
                                        "alias": "低压开关、保护控制装置",
                                        "about": "包括低压电路保护装置、低压电路开关装置、其他低压电路装置",
                                        "kws": "低压开关、低压熔断器、低压断路器、低压装置",
                                        "taxName": "配电控制设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090407020000000000",
                                        "taxCodeTitle": "配电控制设备",
                                        "iTitle": "*配电控制设备*低压开关、保护控制装置",
                                        "children": []
                                    },
                                    {
                                        "id": "3316",
                                        "linkid": "3313",
                                        "code": "109040703",
                                        "paCode": "1090407",
                                        "yn": "N",
                                        "title": "电路连接装置",
                                        "alias": "电路连接装置",
                                        "about": "包括插头、插座及类似电路连接装置、低压电路管座、连接器、端接件及接线装置、其他电路连接装置。",
                                        "kws": "插头、插座、电路连接装置、灯座、普通插座、低压电路管座、集成电路插座、半导体分立器件插座、显像管插座、电子管插座、继电器插座、谐振器插座、电池插座、连接器、低频连接器、射频连接器、光缆连接器、滑动接触器、端接件、接线装置、接线柱、线端条、低频连接器电缆组件、射频连接器电缆组件、光缆气密头、接线盒、光缆终端分线盒",
                                        "taxName": "配电控制设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090407030000000000",
                                        "taxCodeTitle": "配电控制设备",
                                        "iTitle": "*配电控制设备*电路连接装置",
                                        "children": []
                                    },
                                    {
                                        "id": "3317",
                                        "linkid": "3313",
                                        "code": "109040704",
                                        "paCode": "1090407",
                                        "yn": "N",
                                        "title": "电力控制或电力分配装置",
                                        "alias": "电力控制或电力分配装置",
                                        "about": "包括电力控制或配电用配电板、配电盘、数字控制板、盘，控制台等，高压电力控制或电力分配装置，低压电力控制或电力分配装置，安全、自动化监控设备，其他电力控制或电力分配装置",
                                        "kws": "电力控制器、电力分配器、高压电力控制装置、高压电力分配装置、低压电力控制装置、低压电力分配装置、安全监控设备、自动化监控设备",
                                        "taxName": "配电控制设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090407040000000000",
                                        "taxCodeTitle": "配电控制设备",
                                        "iTitle": "*配电控制设备*电力控制或电力分配装置",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3318",
                                "linkid": "3278",
                                "code": "1090408",
                                "paCode": "10904",
                                "yn": "Y",
                                "title": "电力电子元器件",
                                "alias": "电力电子元器件",
                                "about": null,
                                "kws": null,
                                "taxName": "电力电子元器件",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1090408000000000000",
                                "taxCodeTitle": "电力电子元器件",
                                "iTitle": "*电力电子元器件*电力电子元器件",
                                "children": [
                                    {
                                        "id": "3319",
                                        "linkid": "3318",
                                        "code": "109040801",
                                        "paCode": "1090408",
                                        "yn": "N",
                                        "title": "电力半导体器件（5A以上）",
                                        "alias": "电力半导体器件（5A以上）",
                                        "about": "包括整流管、电力晶闸管、电力晶体管、电力场效应器件、场控双极型复合器件、功率MOS场效应管、固态继电器模块、静电感应器件（SIT）、其他电力半导体器件。",
                                        "kws": "电力半导体器件、整流管、整流二极管、快恢复二极管、电力晶闸管、普通晶闸管、双向晶闸管、快速晶闸管、高频晶闸管、可关断晶闸管、晶闸管模块、晶闸管组件、集成门极换流晶闸管、电力晶体管、巨型晶体管、绝缘栅双极晶体管、电力场效应器件、场控双极型复合器件、功率MOS场效应管、固态继电器模块、静电感应器件",
                                        "taxName": "电力电子元器件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090408010000000000",
                                        "taxCodeTitle": "电力电子元器件",
                                        "iTitle": "*电力电子元器件*电力半导体器件（5A以上）",
                                        "children": []
                                    },
                                    {
                                        "id": "3320",
                                        "linkid": "3318",
                                        "code": "109040802",
                                        "paCode": "1090408",
                                        "yn": "N",
                                        "title": "电力微电子组件",
                                        "alias": "电力微电子组件",
                                        "about": "包括电力半导体模块、电力半导体组件",
                                        "kws": "微电子组件、电力半导体模块、电力半导体组件",
                                        "taxName": "电力电子元器件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090408020000000000",
                                        "taxCodeTitle": "电力电子元器件",
                                        "iTitle": "*电力电子元器件*电力微电子组件",
                                        "children": []
                                    },
                                    {
                                        "id": "3321",
                                        "linkid": "3318",
                                        "code": "109040803",
                                        "paCode": "1090408",
                                        "yn": "N",
                                        "title": "电力集成电路",
                                        "alias": "电力集成电路",
                                        "about": "包括普通稳压电路、开关电源控制电路、DC-DC变换器、其他电力集成电路",
                                        "kws": "集成电路、普通稳压电路、开关电源控制电路、DC-DC变换器",
                                        "taxName": "电力电子元器件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090408030000000000",
                                        "taxCodeTitle": "电力电子元器件",
                                        "iTitle": "*电力电子元器件*电力集成电路",
                                        "children": []
                                    },
                                    {
                                        "id": "3322",
                                        "linkid": "3318",
                                        "code": "109040804",
                                        "paCode": "1090408",
                                        "yn": "N",
                                        "title": "继电器",
                                        "alias": "继电器",
                                        "about": "包括电磁继电器、永磁继电器、热电继电器、感应继电器、静电继电器、光电继电器、电子继电器、其他继电器。",
                                        "kws": "继电器、电磁继电器、永磁继电器、热电继电器、感应继电器、静电继电器、光电继电器、电子继电器",
                                        "taxName": "电力电子元器件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090408040000000000",
                                        "taxCodeTitle": "电力电子元器件",
                                        "iTitle": "*电力电子元器件*继电器",
                                        "children": []
                                    },
                                    {
                                        "id": "3323",
                                        "linkid": "3318",
                                        "code": "109040805",
                                        "paCode": "1090408",
                                        "yn": "N",
                                        "title": "继电器保护装置",
                                        "alias": "继电器保护装置",
                                        "about": "包括电流保护装置、电压保护装置、差动保护装置、电动机保护装置、发电机保护装置、励磁机保护装置、其他继电器保护装置",
                                        "kws": "继电器保护器、电流保护装置、电压保护装置、差动保护装置、电动机保护装置、发电机保护装置、励磁机保护装置",
                                        "taxName": "电力电子元器件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090408050000000000",
                                        "taxCodeTitle": "电力电子元器件",
                                        "iTitle": "*电力电子元器件*继电器保护装置",
                                        "children": []
                                    },
                                    {
                                        "id": "3324",
                                        "linkid": "3318",
                                        "code": "109040806",
                                        "paCode": "1090408",
                                        "yn": "N",
                                        "title": "配电或电器控制设备专用零件",
                                        "alias": "配电或电器控制设备专用零件",
                                        "about": "包括高压控制柜及其底座、低压控制柜及其底座、电器辅件、其他配电或电器控制设备专用零件",
                                        "kws": "配电控制设备专用零件、电器控制设备专用零件、高压控制柜、高压控制柜底座、低压控制柜、低压控制底座",
                                        "taxName": "电力电子元器件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090408060000000000",
                                        "taxCodeTitle": "电力电子元器件",
                                        "iTitle": "*电力电子元器件*配电或电器控制设备专用零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3325",
                                "linkid": "3278",
                                "code": "1090409",
                                "paCode": "10904",
                                "yn": "Y",
                                "title": "电线电缆",
                                "alias": "电线电缆",
                                "about": "用以传输电（磁）能，信息和实现电磁能转换的线材产品，广义的电线电缆亦简称为电缆，狭义的电缆是指绝缘电缆，它可定义为：由下列部分组成的集合体；一根或多根绝缘线芯，以及它们各自可能具有的包覆层，总保护层及外护层，电缆亦可有附加的没有绝缘的导体。用以传输电（磁）能，信息和实现电磁能转换的线材产品。",
                                "kws": "电线、电缆、线缆",
                                "taxName": "电线电缆",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1090409000000000000",
                                "taxCodeTitle": "电线电缆",
                                "iTitle": "*电线电缆*电线电缆",
                                "children": [
                                    {
                                        "id": "3326",
                                        "linkid": "3325",
                                        "code": "109040901",
                                        "paCode": "1090409",
                                        "yn": "N",
                                        "title": "裸电线",
                                        "alias": "裸电线",
                                        "about": "包括裸铜线、裸铝线、铜包钢线、铜包铝丝、其他裸电线",
                                        "kws": "裸线、裸电线、裸铜线、裸铝线、铜包钢线、铜包铝丝",
                                        "taxName": "电线电缆",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090409010000000000",
                                        "taxCodeTitle": "电线电缆",
                                        "iTitle": "*电线电缆*裸电线",
                                        "children": []
                                    },
                                    {
                                        "id": "3327",
                                        "linkid": "3325",
                                        "code": "109040902",
                                        "paCode": "1090409",
                                        "yn": "N",
                                        "title": "绝缘电线",
                                        "alias": "绝缘电线",
                                        "about": "包括绕组电线、布线组、安装电线、电话机和计算机用弹簧绳、电源插头线、其他绝缘电线",
                                        "kws": "绝缘线、绝缘电线、绕组电线、布线组、安装电线、电话机用弹簧绳、计算机用弹簧绳、电源插头线",
                                        "taxName": "电线电缆",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090409020000000000",
                                        "taxCodeTitle": "电线电缆",
                                        "iTitle": "*电线电缆*绝缘电线",
                                        "children": []
                                    },
                                    {
                                        "id": "3328",
                                        "linkid": "3325",
                                        "code": "109040903",
                                        "paCode": "1090409",
                                        "yn": "N",
                                        "title": "同轴电缆",
                                        "alias": "同轴电缆",
                                        "about": "包括射频电缆、高频同轴电缆、其他同轴电缆",
                                        "kws": "同轴线、同轴电缆、射频电缆、高频同轴电缆",
                                        "taxName": "电线电缆",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090409030000000000",
                                        "taxCodeTitle": "电线电缆",
                                        "iTitle": "*电线电缆*同轴电缆",
                                        "children": []
                                    },
                                    {
                                        "id": "3329",
                                        "linkid": "3325",
                                        "code": "109040904",
                                        "paCode": "1090409",
                                        "yn": "N",
                                        "title": "专用电缆",
                                        "alias": "专用电缆",
                                        "about": "包括通信及电子网络用电缆、电力电缆、交通信号专用电缆、影音电源用阻燃软电缆、潜水电机用防水橡套软电缆、其他专用电缆",
                                        "kws": "专用电线、专用电缆、通信用电缆、电子网络用电缆、电力电缆、交通信号专用电缆、影音电源用阻燃软电缆、潜水电机用防水橡套软电缆",
                                        "taxName": "电线电缆",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090409040000000000",
                                        "taxCodeTitle": "电线电缆",
                                        "iTitle": "*电线电缆*专用电缆",
                                        "children": []
                                    },
                                    {
                                        "id": "3330",
                                        "linkid": "3325",
                                        "code": "109040905",
                                        "paCode": "1090409",
                                        "yn": "N",
                                        "title": "电子元器件引线",
                                        "alias": "电子元器件引线",
                                        "about": null,
                                        "kws": "元器件引线",
                                        "taxName": "电线电缆",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090409050000000000",
                                        "taxCodeTitle": "电线电缆",
                                        "iTitle": "*电线电缆*电子元器件引线",
                                        "children": []
                                    },
                                    {
                                        "id": "3331",
                                        "linkid": "3325",
                                        "code": "109040999",
                                        "paCode": "1090409",
                                        "yn": "N",
                                        "title": "其他电线电缆",
                                        "alias": "其他电线电缆",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "电线电缆",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090409990000000000",
                                        "taxCodeTitle": "电线电缆",
                                        "iTitle": "*电线电缆*其他电线电缆",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3332",
                                "linkid": "3278",
                                "code": "1090410",
                                "paCode": "10904",
                                "yn": "Y",
                                "title": "光纤、光缆",
                                "alias": "光纤、光缆",
                                "about": "包括塑料光纤、单模光纤、多模光纤、特种光纤、普通光缆、特种光缆",
                                "kws": "光纤、光缆",
                                "taxName": "光纤光缆",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090410000000000000",
                                "taxCodeTitle": "光纤光缆",
                                "iTitle": "*光纤光缆*光纤、光缆",
                                "children": [
                                    {
                                        "id": "3333",
                                        "linkid": "3332",
                                        "code": "109041001",
                                        "paCode": "1090410",
                                        "yn": "N",
                                        "title": "光纤",
                                        "alias": "光纤",
                                        "about": "包括塑料光纤、单模光纤、多模光纤、特种光纤",
                                        "kws": "光纤、塑料光纤、单模光纤、多模光纤、特种光纤",
                                        "taxName": "光纤光缆",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090410010000000000",
                                        "taxCodeTitle": "光纤光缆",
                                        "iTitle": "*光纤光缆*光纤",
                                        "children": []
                                    },
                                    {
                                        "id": "3334",
                                        "linkid": "3332",
                                        "code": "109041002",
                                        "paCode": "1090410",
                                        "yn": "N",
                                        "title": "光缆",
                                        "alias": "光缆",
                                        "about": "包括普通光缆、特种光缆",
                                        "kws": "a光缆、普通光缆、综合引入光缆、通信用室局内光缆、网络用光缆、特种光缆、无金属自承式光缆、架空地线复合光缆、松套束管式光缆、层绞式光缆、带状光缆、防蚂蚁光缆、无卤阻燃光缆、骨架式光缆、水线光缆、应急光缆",
                                        "taxName": "光纤光缆",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090410020000000000",
                                        "taxCodeTitle": "光纤光缆",
                                        "iTitle": "*光纤光缆*光缆",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3335",
                                "linkid": "3278",
                                "code": "1090411",
                                "paCode": "10904",
                                "yn": "Y",
                                "title": "绝缘制品",
                                "alias": "绝缘制品",
                                "about": null,
                                "kws": null,
                                "taxName": "绝缘制品",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090411000000000000",
                                "taxCodeTitle": "绝缘制品",
                                "iTitle": "*绝缘制品*绝缘制品",
                                "children": [
                                    {
                                        "id": "3336",
                                        "linkid": "3335",
                                        "code": "109041101",
                                        "paCode": "1090411",
                                        "yn": "N",
                                        "title": "电气绝缘子",
                                        "alias": "电气绝缘子",
                                        "about": "指熔融玄武岩、硬化橡胶、混合绝缘材料制电气绝缘子。",
                                        "kws": "电气绝缘子、混合绝缘材料制电气绝缘子、高压线路棒形悬式复合绝缘子、低压线路复合绝缘子、布线复合绝缘子、通信复合绝缘子、高压支柱复合绝缘子、高压穿墙复合套管、电器复合套管",
                                        "taxName": "绝缘制品",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090411010000000000",
                                        "taxCodeTitle": "绝缘制品",
                                        "iTitle": "*绝缘制品*电气绝缘子",
                                        "children": []
                                    },
                                    {
                                        "id": "3337",
                                        "linkid": "3335",
                                        "code": "109041102",
                                        "paCode": "1090411",
                                        "yn": "N",
                                        "title": "电气设备用绝缘配件",
                                        "alias": "电气设备用绝缘配件",
                                        "about": "包括电机或电气设备用的绝缘零件",
                                        "kws": "电气设备用绝缘配件、复合材料制绝缘配件、块滑石制绝缘配件、硬化橡胶制绝缘配件、绝缘金属电导管、绝缘金属电导管接头",
                                        "taxName": "绝缘制品",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090411020000000000",
                                        "taxCodeTitle": "绝缘制品",
                                        "iTitle": "*绝缘制品*电气设备用绝缘配件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3338",
                                "linkid": "3278",
                                "code": "1090412",
                                "paCode": "10904",
                                "yn": "Y",
                                "title": "内燃机电点火起动装置，相关电工器材",
                                "alias": "内燃机电点火起动装置，相关电工器材",
                                "about": "内燃机电点火起动装置及发电机、断流器",
                                "kws": null,
                                "taxName": "内燃机电器材",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090412000000000000",
                                "taxCodeTitle": "内燃机电器材",
                                "iTitle": "*内燃机电器材*内燃机电点火起动装置，相关电工器材",
                                "children": [
                                    {
                                        "id": "3339",
                                        "linkid": "3338",
                                        "code": "109041201",
                                        "paCode": "1090412",
                                        "yn": "N",
                                        "title": "内燃机电点火起动装置",
                                        "alias": "内燃机电点火起动装置",
                                        "about": "包括火花塞、点火磁电机、内燃机电点火永磁直流发电机、磁飞轮、分电器、点火线圈、内燃机用熔断器、其他内燃机电点火起动装置。",
                                        "kws": "内燃机电点火起动装置、火花塞、点火磁电机、机车用点火磁电机、航空器用点火磁电机、船舶用点火磁电机、内燃机电点火永磁直流发电机、机车用永磁直流发电机、航空器用永磁直流发电机、船舶用永磁直流发电机、磁飞轮、机车用磁飞轮、航空器用磁飞轮、船舶用磁飞轮、分电器、机车用分电器、航空器用分电器、船舶用分电器、点火线圈、机车用点火线圈、航空器用点火线圈、船舶用点火线圈、内燃机用断流器",
                                        "taxName": "内燃机电器材",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090412010000000000",
                                        "taxCodeTitle": "内燃机电器材",
                                        "iTitle": "*内燃机电器材*内燃机电点火起动装置",
                                        "children": []
                                    },
                                    {
                                        "id": "3340",
                                        "linkid": "3338",
                                        "code": "109041202",
                                        "paCode": "1090412",
                                        "yn": "N",
                                        "title": "电磁铁及电磁性装置",
                                        "alias": "电磁铁及电磁性装置",
                                        "about": "包括电磁联轴节、电磁离合器、电磁制动器、电磁起重吸盘、电磁铁、电磁或永磁卡盘、夹紧器或提吊磁铁、电磁性工件夹具",
                                        "kws": "电磁铁、电磁性装置、电磁联轴节、电磁离合器、电磁制动器、电磁起重吸盘、电磁卡盘、永磁卡盘、夹紧器、提吊磁铁、电磁性工件夹具",
                                        "taxName": "内燃机电器材",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090412020000000000",
                                        "taxCodeTitle": "内燃机电器材",
                                        "iTitle": "*内燃机电器材*电磁铁及电磁性装置",
                                        "children": []
                                    },
                                    {
                                        "id": "3341",
                                        "linkid": "3338",
                                        "code": "109041203",
                                        "paCode": "1090412",
                                        "yn": "N",
                                        "title": "风挡刮水器",
                                        "alias": "风挡刮水器",
                                        "about": "包括机动车辆风挡刮水器、电动风挡刮水器",
                                        "kws": "风挡刮水器、雨刮器、机动车辆风挡刮水器、电动风挡刮水器",
                                        "taxName": "内燃机电器材",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090412030000000000",
                                        "taxCodeTitle": "内燃机电器材",
                                        "iTitle": "*内燃机电器材*风挡刮水器",
                                        "children": []
                                    },
                                    {
                                        "id": "3342",
                                        "linkid": "3338",
                                        "code": "109041204",
                                        "paCode": "1090412",
                                        "yn": "N",
                                        "title": "除霜器",
                                        "alias": "除霜器",
                                        "about": "车辆除霜器、电阻除霜器",
                                        "kws": "除霜器、去霜器、车辆除霜器、电阻除霜器",
                                        "taxName": "内燃机电器材",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090412040000000000",
                                        "taxCodeTitle": "内燃机电器材",
                                        "iTitle": "*内燃机电器材*除霜器",
                                        "children": []
                                    },
                                    {
                                        "id": "3343",
                                        "linkid": "3338",
                                        "code": "109041205",
                                        "paCode": "1090412",
                                        "yn": "N",
                                        "title": "去雾器",
                                        "alias": "去雾器",
                                        "about": "车辆去雾器、电阻去雾器",
                                        "kws": "去雾器、除雾器、车辆去雾器、电阻去雾器",
                                        "taxName": "内燃机电器材",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090412050000000000",
                                        "taxCodeTitle": "内燃机电器材",
                                        "iTitle": "*内燃机电器材*去雾器",
                                        "children": []
                                    },
                                    {
                                        "id": "3344",
                                        "linkid": "3338",
                                        "code": "109041206",
                                        "paCode": "1090412",
                                        "yn": "N",
                                        "title": "内燃机电点火起动装置零件",
                                        "alias": "内燃机电点火起动装置零件",
                                        "about": "电磁性装置零件，机车、航空器及船舶用电点火装置零件、其他内燃机电点火起动装置零件。",
                                        "kws": "内燃机电点火起动装置零件、电磁性装置零件、机车用电点火装置零件、航空器用电点火装置零件、船舶用电点火装置零件",
                                        "taxName": "内燃机电器材",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090412060000000000",
                                        "taxCodeTitle": "内燃机电器材",
                                        "iTitle": "*内燃机电器材*内燃机电点火起动装置零件",
                                        "children": []
                                    },
                                    {
                                        "id": "3345",
                                        "linkid": "3338",
                                        "code": "109041299",
                                        "paCode": "1090412",
                                        "yn": "N",
                                        "title": "其他相关电工器材",
                                        "alias": "其他相关电工器材",
                                        "about": "包括同步器、矿用电雷管",
                                        "kws": null,
                                        "taxName": "内燃机电器材",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090412990000000000",
                                        "taxCodeTitle": "内燃机电器材",
                                        "iTitle": "*内燃机电器材*其他相关电工器材",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3346",
                                "linkid": "3278",
                                "code": "1090413",
                                "paCode": "10904",
                                "yn": "Y",
                                "title": "电池及其零部件",
                                "alias": "电池及其零部件",
                                "about": "指盛有电解质溶液和金属电极以产生电流的杯、槽或其他容器或复合容器的部分空间，能将化学能转化成电能的装置。具有正极、负极之分，以及其零部件。",
                                "kws": null,
                                "taxName": "电池",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1090413000000000000",
                                "taxCodeTitle": "电池",
                                "iTitle": "*电池*电池及其零部件",
                                "children": [
                                    {
                                        "id": "3347",
                                        "linkid": "3346",
                                        "code": "109041301",
                                        "paCode": "1090413",
                                        "yn": "Y",
                                        "title": "原电池及原电池组",
                                        "alias": "原电池及原电池组",
                                        "about": "又称一次电池,是按不可以充电设计的电池。按照电极所含的活性物质分类,原电池包括锌原电池、锂原电池和其他原电池。",
                                        "kws": "电池、原电池组",
                                        "taxName": "原电池",
                                        "taxRate": "",
                                        "vip": "5",
                                        "itaxRate": null,
                                        "taxCode": "1090413010000000000",
                                        "taxCodeTitle": "原电池",
                                        "iTitle": "*原电池*原电池及原电池组",
                                        "children": [
                                            {
                                                "id": "3348",
                                                "linkid": "3347",
                                                "code": "10904130101",
                                                "paCode": "109041301",
                                                "yn": "N",
                                                "title": "无汞锌原电池",
                                                "alias": "无汞锌原电池",
                                                "about": "以锌做负极，汞含量低于电池重量的0.0001%(扣式电池按0.0005%)的原电池",
                                                "kws": "无汞锌原电池",
                                                "taxName": "原电池",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090413010100000000",
                                                "taxCodeTitle": "原电池",
                                                "iTitle": "*原电池*无汞锌原电池",
                                                "children": []
                                            },
                                            {
                                                "id": "3349",
                                                "linkid": "3347",
                                                "code": "10904130102",
                                                "paCode": "109041301",
                                                "yn": "N",
                                                "title": "含汞锌原电池",
                                                "alias": "含汞锌原电池",
                                                "about": "以锌做负极，汞含量高于电池重量的0.0001%(扣式电池按0.0005%)的原电池",
                                                "kws": "含汞锌原电池",
                                                "taxName": "原电池",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090413010200000000",
                                                "taxCodeTitle": "原电池",
                                                "iTitle": "*原电池*含汞锌原电池",
                                                "children": []
                                            },
                                            {
                                                "id": "3350",
                                                "linkid": "3347",
                                                "code": "10904130103",
                                                "paCode": "109041301",
                                                "yn": "N",
                                                "title": "锂原电池",
                                                "alias": "锂原电池",
                                                "about": "以锂做负极的原电池,包括锂二氧化锰原电池、锂亚硫酰氯原电池、锂二硫化铁原电池、锂二氧化硫原电池、锂氧原电池(又称“锂空气原电池”)、锂氟化碳原电池等。",
                                                "kws": "锂原电池",
                                                "taxName": "原电池",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090413010300000000",
                                                "taxCodeTitle": "原电池",
                                                "iTitle": "*原电池*锂原电池",
                                                "children": []
                                            },
                                            {
                                                "id": "3351",
                                                "linkid": "3347",
                                                "code": "10904130104",
                                                "paCode": "109041301",
                                                "yn": "N",
                                                "title": "其他无汞原电池",
                                                "alias": "其他无汞原电池",
                                                "about": "其他汞含量低于电池重量的0.0001%(扣式电池按0.0005%)的原电池",
                                                "kws": null,
                                                "taxName": "原电池",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090413010400000000",
                                                "taxCodeTitle": "原电池",
                                                "iTitle": "*原电池*其他无汞原电池",
                                                "children": []
                                            },
                                            {
                                                "id": "3352",
                                                "linkid": "3347",
                                                "code": "10904130105",
                                                "paCode": "109041301",
                                                "yn": "N",
                                                "title": "其他含汞原电池",
                                                "alias": "其他含汞原电池",
                                                "about": "其他汞含量高于电池重量的0.0001%(扣式电池按0.0005%)的原电池",
                                                "kws": null,
                                                "taxName": "原电池",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090413010500000000",
                                                "taxCodeTitle": "原电池",
                                                "iTitle": "*原电池*其他含汞原电池",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "3353",
                                        "linkid": "3346",
                                        "code": "109041302",
                                        "paCode": "1090413",
                                        "yn": "Y",
                                        "title": "蓄电池",
                                        "alias": "蓄电池",
                                        "about": null,
                                        "kws": "蓄电池",
                                        "taxName": "蓄电池",
                                        "taxRate": "",
                                        "vip": "5",
                                        "itaxRate": null,
                                        "taxCode": "1090413020000000000",
                                        "taxCodeTitle": "蓄电池",
                                        "iTitle": "*蓄电池*蓄电池",
                                        "children": [
                                            {
                                                "id": "3354",
                                                "linkid": "3353",
                                                "code": "10904130201",
                                                "paCode": "109041302",
                                                "yn": "N",
                                                "title": "铅酸蓄电池",
                                                "alias": "铅酸蓄电池",
                                                "about": "铅酸蓄电池,指含以稀硫酸为主电解质、二氧化铅正极和铅负极的蓄电池。",
                                                "kws": "铅酸蓄电池",
                                                "taxName": "蓄电池",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090413020100000000",
                                                "taxCodeTitle": "蓄电池",
                                                "iTitle": "*蓄电池*铅酸蓄电池",
                                                "children": []
                                            },
                                            {
                                                "id": "3355",
                                                "linkid": "3353",
                                                "code": "10904130202",
                                                "paCode": "109041302",
                                                "yn": "N",
                                                "title": "其他酸性蓄电池",
                                                "alias": "其他酸性蓄电池",
                                                "about": "其他含酸性电解质的蓄电池",
                                                "kws": null,
                                                "taxName": "蓄电池",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090413020200000000",
                                                "taxCodeTitle": "蓄电池",
                                                "iTitle": "*蓄电池*其他酸性蓄电池",
                                                "children": []
                                            },
                                            {
                                                "id": "3356",
                                                "linkid": "3353",
                                                "code": "10904130203",
                                                "paCode": "109041302",
                                                "yn": "N",
                                                "title": "金属氢化物镍蓄电池",
                                                "alias": "金属氢化物镍蓄电池",
                                                "about": "又称“氢镍蓄电池”或“镍氢蓄电池”",
                                                "kws": "金属氢化物镍蓄电池",
                                                "taxName": "蓄电池",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090413020300000000",
                                                "taxCodeTitle": "蓄电池",
                                                "iTitle": "*蓄电池*金属氢化物镍蓄电池",
                                                "children": []
                                            },
                                            {
                                                "id": "3357",
                                                "linkid": "3353",
                                                "code": "10904130204",
                                                "paCode": "109041302",
                                                "yn": "N",
                                                "title": "锂离子蓄电池",
                                                "alias": "锂离子蓄电池",
                                                "about": "以锂做负极的原电池,包括锂二氧化锰原电池、锂亚硫酰氯原电池、锂二硫化铁原电池、锂二氧化硫原电池、锂氧原电池(又称“锂空气原电池”)、锂氟化碳原电池等按可充电、重复使用设计的电池",
                                                "kws": "锂离子蓄电池",
                                                "taxName": "蓄电池",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090413020400000000",
                                                "taxCodeTitle": "蓄电池",
                                                "iTitle": "*蓄电池*锂离子蓄电池",
                                                "children": []
                                            },
                                            {
                                                "id": "3358",
                                                "linkid": "3353",
                                                "code": "10904130205",
                                                "paCode": "109041302",
                                                "yn": "N",
                                                "title": "全钒液流电池",
                                                "alias": "全钒液流电池",
                                                "about": "全钒液流电池是通过正负极电解液中不同价态钒离子的电化学反应来实现电能和化学能互相转化的储能装置。",
                                                "kws": "全钒液流电池",
                                                "taxName": "蓄电池",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090413020500000000",
                                                "taxCodeTitle": "蓄电池",
                                                "iTitle": "*蓄电池*全钒液流电池",
                                                "children": []
                                            },
                                            {
                                                "id": "3359",
                                                "linkid": "3353",
                                                "code": "10904130206",
                                                "paCode": "109041302",
                                                "yn": "N",
                                                "title": "其他氧化还原液流电池",
                                                "alias": "其他氧化还原液流电池",
                                                "about": "除氧化还原液流电池以外的其他同原理电池。",
                                                "kws": null,
                                                "taxName": "蓄电池",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090413020600000000",
                                                "taxCodeTitle": "蓄电池",
                                                "iTitle": "*蓄电池*其他氧化还原液流电池",
                                                "children": []
                                            },
                                            {
                                                "id": "3360",
                                                "linkid": "3353",
                                                "code": "10904130299",
                                                "paCode": "109041302",
                                                "yn": "N",
                                                "title": "其他蓄电池",
                                                "alias": "其他蓄电池",
                                                "about": null,
                                                "kws": null,
                                                "taxName": "蓄电池",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1090413029900000000",
                                                "taxCodeTitle": "蓄电池",
                                                "iTitle": "*蓄电池*其他蓄电池",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "3361",
                                        "linkid": "3346",
                                        "code": "109041303",
                                        "paCode": "1090413",
                                        "yn": "N",
                                        "title": "太阳能电池",
                                        "alias": "太阳能电池",
                                        "about": "指将太阳光能转换成电能的装置,包括晶体硅太阳能电池、薄膜太阳能电池、化合物半导体太阳能电池等",
                                        "kws": "太阳能电池、太阳能电池板",
                                        "taxName": "其他电池",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1090413030000000000",
                                        "taxCodeTitle": "其他电池",
                                        "iTitle": "*其他电池*太阳能电池",
                                        "children": []
                                    },
                                    {
                                        "id": "3362",
                                        "linkid": "3346",
                                        "code": "109041304",
                                        "paCode": "1090413",
                                        "yn": "N",
                                        "title": "燃料电池",
                                        "alias": "燃料电池",
                                        "about": "指通过一个电化学过程,将连续供应的反应物和氧化剂的化学能直接转换为电能的电化学发电装置。",
                                        "kws": "燃料电池、质子交换膜燃料电池、固体氧化物燃料电池、熔融碳酸盐燃料电池、磷酸盐燃料电池、直接醇类燃料电池、微型燃料电池",
                                        "taxName": "其他电池",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090413040000000000",
                                        "taxCodeTitle": "其他电池",
                                        "iTitle": "*其他电池*燃料电池",
                                        "children": []
                                    },
                                    {
                                        "id": "3363",
                                        "linkid": "3346",
                                        "code": "109041305",
                                        "paCode": "1090413",
                                        "yn": "N",
                                        "title": "其他电池",
                                        "alias": "其他电池",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "其他电池",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090413050000000000",
                                        "taxCodeTitle": "其他电池",
                                        "iTitle": "*其他电池*其他电池",
                                        "children": []
                                    },
                                    {
                                        "id": "3364",
                                        "linkid": "3346",
                                        "code": "109041306",
                                        "paCode": "1090413",
                                        "yn": "N",
                                        "title": "电池零部件",
                                        "alias": "电池零部件",
                                        "about": null,
                                        "kws": "电池零部件",
                                        "taxName": "其他电池",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090413060000000000",
                                        "taxCodeTitle": "其他电池",
                                        "iTitle": "*其他电池*电池零部件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3365",
                                "linkid": "3278",
                                "code": "1090414",
                                "paCode": "10904",
                                "yn": "Y",
                                "title": "家用制冷电器具",
                                "alias": "家用制冷电器具",
                                "about": "指家用和类似用途制冷电器具，包括家用冷藏冷冻箱、家用冷藏箱、家用冷冻箱、其他家用制冷电器具。不包括工商用制冷、空调设备，其他非家用制冷电器具（详见1090131）",
                                "kws": null,
                                "taxName": "家用制冷器具",
                                "taxRate": "",
                                "vip": "3",
                                "itaxRate": null,
                                "taxCode": "1090414000000000000",
                                "taxCodeTitle": "家用制冷器具",
                                "iTitle": "*家用制冷器具*家用制冷电器具",
                                "children": [
                                    {
                                        "id": "3366",
                                        "linkid": "3365",
                                        "code": "109041401",
                                        "paCode": "1090414",
                                        "yn": "N",
                                        "title": "家用冷藏冷冻箱",
                                        "alias": "家用冷藏冷冻箱",
                                        "about": "指冷藏-冷冻组合机，包括单门冷藏冷冻箱、双门冷藏冷冻箱、多门冷藏冷冻箱",
                                        "kws": "家用冷藏冷冻箱",
                                        "taxName": "家用制冷器具",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090414010000000000",
                                        "taxCodeTitle": "家用制冷器具",
                                        "iTitle": "*家用制冷器具*家用冷藏冷冻箱",
                                        "children": []
                                    },
                                    {
                                        "id": "3367",
                                        "linkid": "3365",
                                        "code": "109041402",
                                        "paCode": "1090414",
                                        "yn": "N",
                                        "title": "家用冷藏箱",
                                        "alias": "家用冷藏箱",
                                        "about": "指家用和类似用途的单冷藏箱，包括电气吸收式、压缩式（含其中的家用酒柜）、半导体式、其他各式家用冷藏箱",
                                        "kws": "家用冷藏箱",
                                        "taxName": "家用制冷器具",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090414020000000000",
                                        "taxCodeTitle": "家用制冷器具",
                                        "iTitle": "*家用制冷器具*家用冷藏箱",
                                        "children": []
                                    },
                                    {
                                        "id": "3368",
                                        "linkid": "3365",
                                        "code": "109041403",
                                        "paCode": "1090414",
                                        "yn": "N",
                                        "title": "家用冷冻箱",
                                        "alias": "家用冷冻箱",
                                        "about": "指家用和类似用途的卧式、立式及其他各式冷冻箱（冷柜），含具有冷藏和冷冻转换功能的冷柜。不包括家用电冰箱（详见109041401）、家用冷藏箱（详见109041402）",
                                        "kws": "家用冷冻箱、冰箱",
                                        "taxName": "家用制冷器具",
                                        "taxRate": "13%",
                                        "vip": "3",
                                        "itaxRate": "0.13",
                                        "taxCode": "1090414030000000000",
                                        "taxCodeTitle": "家用制冷器具",
                                        "iTitle": "*家用制冷器具*家用冷冻箱",
                                        "children": []
                                    },
                                    {
                                        "id": "3369",
                                        "linkid": "3365",
                                        "code": "109041499",
                                        "paCode": "1090414",
                                        "yn": "N",
                                        "title": "其他家用制冷电器具",
                                        "alias": "其他家用制冷电器具",
                                        "about": null,
                                        "kws": "家用冰淇淋机、家用制冰机",
                                        "taxName": "家用制冷器具",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090414990000000000",
                                        "taxCodeTitle": "家用制冷器具",
                                        "iTitle": "*家用制冷器具*其他家用制冷电器具",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3370",
                                "linkid": "3278",
                                "code": "1090415",
                                "paCode": "10904",
                                "yn": "Y",
                                "title": "家用空气调节器",
                                "alias": "家用空气调节器",
                                "about": null,
                                "kws": null,
                                "taxName": "空调",
                                "taxRate": "",
                                "vip": "3",
                                "itaxRate": null,
                                "taxCode": "1090415000000000000",
                                "taxCodeTitle": "空调",
                                "iTitle": "*空调*家用空气调节器",
                                "children": [
                                    {
                                        "id": "3371",
                                        "linkid": "3370",
                                        "code": "109041501",
                                        "paCode": "1090415",
                                        "yn": "N",
                                        "title": "房间空气调节器",
                                        "alias": "房间空气调节器",
                                        "about": "指家用和类似用途的房间空气调节器（俗称空调机），用于向封闭的房间、空间或区域直接提供经过处理的空气的一种空气调节电器。包括整体式、分体式、一拖多式冷热或单冷的房间空气调节器，以及制冷量≤14000W的其他房间空气调节器。不包括家用房间空气清洁装置（详见109041503）、未装有制冷装置的家用空气湿度调节装置或空气调节器（详见109041502、109041599）、制冷量＞14000W的工商用房间空调器（详见109013104）",
                                        "kws": "空调、房间空气调节器",
                                        "taxName": "空调",
                                        "taxRate": "13%",
                                        "vip": "3",
                                        "itaxRate": "0.13",
                                        "taxCode": "1090415010000000000",
                                        "taxCodeTitle": "空调",
                                        "iTitle": "*空调*房间空气调节器",
                                        "children": []
                                    },
                                    {
                                        "id": "3372",
                                        "linkid": "3370",
                                        "code": "109041502",
                                        "paCode": "1090415",
                                        "yn": "N",
                                        "title": "家用空气湿度调节装置",
                                        "alias": "家用空气湿度调节装置",
                                        "about": "包括除湿机、加湿机、其他家用空气湿度调节装置",
                                        "kws": "除湿机、加湿机",
                                        "taxName": "空调",
                                        "taxRate": "13%",
                                        "vip": "3",
                                        "itaxRate": "0.13",
                                        "taxCode": "1090415020000000000",
                                        "taxCodeTitle": "空调",
                                        "iTitle": "*空调*家用空气湿度调节装置",
                                        "children": []
                                    },
                                    {
                                        "id": "3373",
                                        "linkid": "3370",
                                        "code": "109041503",
                                        "paCode": "1090415",
                                        "yn": "N",
                                        "title": "家用房间空气清洁装置",
                                        "alias": "家用房间空气清洁装置",
                                        "about": "包括空气清洁器、负离子发生器、其他家用房间空气清洁装置",
                                        "kws": "空气清洁器、负离子发生器",
                                        "taxName": "空调",
                                        "taxRate": "13%",
                                        "vip": "3",
                                        "itaxRate": "0.13",
                                        "taxCode": "1090415030000000000",
                                        "taxCodeTitle": "空调",
                                        "iTitle": "*空调*家用房间空气清洁装置",
                                        "children": []
                                    },
                                    {
                                        "id": "3374",
                                        "linkid": "3370",
                                        "code": "109041599",
                                        "paCode": "1090415",
                                        "yn": "N",
                                        "title": "其他家用空气调节器",
                                        "alias": "其他家用空气调节器",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "空调",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090415990000000000",
                                        "taxCodeTitle": "空调",
                                        "iTitle": "*空调*其他家用空气调节器",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3375",
                                "linkid": "3278",
                                "code": "1090416",
                                "paCode": "10904",
                                "yn": "Y",
                                "title": "家用通风电器具",
                                "alias": "家用通风电器具",
                                "about": "包括家用电风扇、家用吸排油烟机、电热干手器、家用换气扇、家用排气扇、其他家用通风电器具",
                                "kws": null,
                                "taxName": "家用通风电器具",
                                "taxRate": "",
                                "vip": "3",
                                "itaxRate": null,
                                "taxCode": "1090416000000000000",
                                "taxCodeTitle": "家用通风电器具",
                                "iTitle": "*家用通风电器具*家用通风电器具",
                                "children": [
                                    {
                                        "id": "3376",
                                        "linkid": "3375",
                                        "code": "109041601",
                                        "paCode": "1090416",
                                        "yn": "N",
                                        "title": "家用电风扇",
                                        "alias": "家用电风扇",
                                        "about": "指家用和类似用途的电风扇（5W＜功率≤125W），包括吊扇、落地扇、台扇、壁扇、塔式扇、箱式扇等。不包括房屋、设备、计算机等用的换气扇（详见109012702）",
                                        "kws": "风扇、吊扇、落地扇、台扇、壁扇、塔式扇、箱式扇",
                                        "taxName": "家用通风电器具",
                                        "taxRate": "13%",
                                        "vip": "3",
                                        "itaxRate": "0.13",
                                        "taxCode": "1090416010000000000",
                                        "taxCodeTitle": "家用通风电器具",
                                        "iTitle": "*家用通风电器具*家用电风扇",
                                        "children": []
                                    },
                                    {
                                        "id": "3377",
                                        "linkid": "3375",
                                        "code": "109041602",
                                        "paCode": "1090416",
                                        "yn": "N",
                                        "title": "家用吸排油烟机",
                                        "alias": "家用吸排油烟机",
                                        "about": "指家用和类似用途的吸排油烟机，包括深型吸排油烟机、欧式塔型吸排油烟机、侧吸式吸排油烟机、其他家用吸排油烟机",
                                        "kws": "家用吸排油烟机",
                                        "taxName": "家用通风电器具",
                                        "taxRate": "13%",
                                        "vip": "3",
                                        "itaxRate": "0.13",
                                        "taxCode": "1090416020000000000",
                                        "taxCodeTitle": "家用通风电器具",
                                        "iTitle": "*家用通风电器具*家用吸排油烟机",
                                        "children": []
                                    },
                                    {
                                        "id": "3378",
                                        "linkid": "3375",
                                        "code": "109041603",
                                        "paCode": "1090416",
                                        "yn": "N",
                                        "title": "家用换气、排气扇",
                                        "alias": "家用换气、排气扇",
                                        "about": "指家用和类似用途的换气、排气扇，包括卫生间、厨房等用换气、排气扇",
                                        "kws": "家用换气扇、家用排气扇",
                                        "taxName": "家用通风电器具",
                                        "taxRate": "13%",
                                        "vip": "3",
                                        "itaxRate": "0.13",
                                        "taxCode": "1090416030000000000",
                                        "taxCodeTitle": "家用通风电器具",
                                        "iTitle": "*家用通风电器具*家用换气、排气扇",
                                        "children": []
                                    },
                                    {
                                        "id": "3379",
                                        "linkid": "3375",
                                        "code": "109041604",
                                        "paCode": "1090416",
                                        "yn": "N",
                                        "title": "电热干手器",
                                        "alias": "电热干手器",
                                        "about": null,
                                        "kws": "电热干手器",
                                        "taxName": "家用通风电器具",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1090416040000000000",
                                        "taxCodeTitle": "家用通风电器具",
                                        "iTitle": "*家用通风电器具*电热干手器",
                                        "children": []
                                    },
                                    {
                                        "id": "3380",
                                        "linkid": "3375",
                                        "code": "109041699",
                                        "paCode": "1090416",
                                        "yn": "N",
                                        "title": "其他家用通风电器具",
                                        "alias": "其他家用通风电器具",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "家用通风电器具",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090416990000000000",
                                        "taxCodeTitle": "家用通风电器具",
                                        "iTitle": "*家用通风电器具*其他家用通风电器具",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3381",
                                "linkid": "3278",
                                "code": "1090417",
                                "paCode": "10904",
                                "yn": "Y",
                                "title": "家用厨房电器具",
                                "alias": "家用厨房电器具",
                                "about": "包括家用电热烹调器具、家用电热烘烤器具、家用水及饮料加热器具、家用电炉灶、家用食品加工电动器具、家用厨房电清洁器具、家用饮水电过滤装置、家用饮水电净化装置、其他家用厨房电器具",
                                "kws": null,
                                "taxName": "家用厨房电器具",
                                "taxRate": "",
                                "vip": "3",
                                "itaxRate": null,
                                "taxCode": "1090417000000000000",
                                "taxCodeTitle": "家用厨房电器具",
                                "iTitle": "*家用厨房电器具*家用厨房电器具",
                                "children": [
                                    {
                                        "id": "3382",
                                        "linkid": "3381",
                                        "code": "109041701",
                                        "paCode": "1090417",
                                        "yn": "N",
                                        "title": "家用电热烹调器具",
                                        "alias": "家用电热烹调器具",
                                        "about": "指家用和类似用途的电热烹调器具，包括电饭锅、电炒锅、电火锅、电饼铛、电煎锅、电煎炸锅、电压力锅、其他家用电热烹调器具",
                                        "kws": "电饭锅、电饭煲、电炒锅、电火锅、电饼铛、电煎锅、电煎炸锅、电压力锅",
                                        "taxName": "家用厨房电器具",
                                        "taxRate": "13%",
                                        "vip": "3",
                                        "itaxRate": "0.13",
                                        "taxCode": "1090417010000000000",
                                        "taxCodeTitle": "家用厨房电器具",
                                        "iTitle": "*家用厨房电器具*家用电热烹调器具",
                                        "children": []
                                    },
                                    {
                                        "id": "3383",
                                        "linkid": "3381",
                                        "code": "109041702",
                                        "paCode": "1090417",
                                        "yn": "N",
                                        "title": "家用电热烘烤器具",
                                        "alias": "家用电热烘烤器具",
                                        "about": "指家用和类似用途的电热烘烤器具，包括面包片烘烤炉、三明治炉、家用电烤箱、电热板、电烧烤炉、自动制面包机、其他家用电热烘烤器具",
                                        "kws": "电热烘烤器具、面包片烘烤炉、三明治炉、家用电烤箱、电热板、电烧烤炉、自动制面包机",
                                        "taxName": "家用厨房电器具",
                                        "taxRate": "13%",
                                        "vip": "3",
                                        "itaxRate": "0.13",
                                        "taxCode": "1090417020000000000",
                                        "taxCodeTitle": "家用厨房电器具",
                                        "iTitle": "*家用厨房电器具*家用电热烘烤器具",
                                        "children": []
                                    },
                                    {
                                        "id": "3384",
                                        "linkid": "3381",
                                        "code": "109041703",
                                        "paCode": "1090417",
                                        "yn": "N",
                                        "title": "家用水及饮料加热器具",
                                        "alias": "家用水及饮料加热器具",
                                        "about": "主要指家用水及饮料加热器具，包括电咖啡壶、电水壶、加热环、电冷热饮水机、电热水瓶、制酸奶机、其他家用水及饮料加热器具",
                                        "kws": "电咖啡壶、咖啡机、电水壶、加热环、电冷热饮水机、电热水瓶、制酸奶机",
                                        "taxName": "家用厨房电器具",
                                        "taxRate": "13%",
                                        "vip": "3",
                                        "itaxRate": "0.13",
                                        "taxCode": "1090417030000000000",
                                        "taxCodeTitle": "家用厨房电器具",
                                        "iTitle": "*家用厨房电器具*家用水及饮料加热器具",
                                        "children": []
                                    },
                                    {
                                        "id": "3385",
                                        "linkid": "3381",
                                        "code": "109041704",
                                        "paCode": "1090417",
                                        "yn": "N",
                                        "title": "家用电炉灶",
                                        "alias": "家用电炉灶",
                                        "about": "指家用和类似用途的电炉灶，包括微波炉、电磁灶、电灶、气电两用灶、其他家用电炉灶",
                                        "kws": "微波炉、电磁灶、电磁炉、电灶、气电两用灶",
                                        "taxName": "家用厨房电器具",
                                        "taxRate": "13%",
                                        "vip": "3",
                                        "itaxRate": "0.13",
                                        "taxCode": "1090417040000000000",
                                        "taxCodeTitle": "家用厨房电器具",
                                        "iTitle": "*家用厨房电器具*家用电炉灶",
                                        "children": []
                                    },
                                    {
                                        "id": "3386",
                                        "linkid": "3381",
                                        "code": "109041705",
                                        "paCode": "1090417",
                                        "yn": "N",
                                        "title": "家用食品加工电动器具",
                                        "alias": "家用食品加工电动器具",
                                        "about": "指家用和类似用途的食品加工电动器具，包括榨汁机（家用）、豆浆机、食品研磨机、电动绞肉机、咖啡研磨机、瓜果电动削皮机及类似机械、揉面轧面机、其他家用食品加工电动器具",
                                        "kws": "家用榨汁机、豆浆机、食品研磨机、电动绞肉机、咖啡研磨机、瓜果电动削皮机、揉面轧面机",
                                        "taxName": "家用厨房电器具",
                                        "taxRate": "13%",
                                        "vip": "3",
                                        "itaxRate": "0.13",
                                        "taxCode": "1090417050000000000",
                                        "taxCodeTitle": "家用厨房电器具",
                                        "iTitle": "*家用厨房电器具*家用食品加工电动器具",
                                        "children": []
                                    },
                                    {
                                        "id": "3387",
                                        "linkid": "3381",
                                        "code": "109041706",
                                        "paCode": "1090417",
                                        "yn": "N",
                                        "title": "家用厨房电清洁器具",
                                        "alias": "家用厨房电清洁器具",
                                        "about": "包括家用型洗碗机、厨房废物处理器、家用餐具消毒柜、家用餐具干燥器、磨刀器及净刀器、其他家用厨房电清洁器具",
                                        "kws": "家用型洗碗机、厨房废物处理器、家用餐具消毒柜、家用餐具干燥器、磨刀器、净刀器",
                                        "taxName": "家用厨房电器具",
                                        "taxRate": "13%",
                                        "vip": "3",
                                        "itaxRate": "0.13",
                                        "taxCode": "1090417060000000000",
                                        "taxCodeTitle": "家用厨房电器具",
                                        "iTitle": "*家用厨房电器具*家用厨房电清洁器具",
                                        "children": []
                                    },
                                    {
                                        "id": "3388",
                                        "linkid": "3381",
                                        "code": "109041707",
                                        "paCode": "1090417",
                                        "yn": "N",
                                        "title": "家用饮水电过滤、净化装置",
                                        "alias": "家用饮水电过滤、净化装置",
                                        "about": "包括家用型滤水器、其他家用饮水电过滤装置、其他家用饮水电净化装置",
                                        "kws": "家用型滤水器、净水器",
                                        "taxName": "家用厨房电器具",
                                        "taxRate": "13%",
                                        "vip": "3",
                                        "itaxRate": "0.13",
                                        "taxCode": "1090417070000000000",
                                        "taxCodeTitle": "家用厨房电器具",
                                        "iTitle": "*家用厨房电器具*家用饮水电过滤、净化装置",
                                        "children": []
                                    },
                                    {
                                        "id": "3389",
                                        "linkid": "3381",
                                        "code": "109041799",
                                        "paCode": "1090417",
                                        "yn": "N",
                                        "title": "其他家用厨房电器具",
                                        "alias": "其他家用厨房电器具",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "家用厨房电器具",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090417990000000000",
                                        "taxCodeTitle": "家用厨房电器具",
                                        "iTitle": "*家用厨房电器具*其他家用厨房电器具",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3390",
                                "linkid": "3278",
                                "code": "1090418",
                                "paCode": "10904",
                                "yn": "Y",
                                "title": "家用清洁卫生电器具",
                                "alias": "家用清洁卫生电器具",
                                "about": "包括家用洗衣机、家用干衣机、家用脱水机、电热水器、家用电清洁器具、其他家用清洁卫生电器具",
                                "kws": null,
                                "taxName": "家用清洁电器具",
                                "taxRate": "",
                                "vip": "3",
                                "itaxRate": null,
                                "taxCode": "1090418000000000000",
                                "taxCodeTitle": "家用清洁电器具",
                                "iTitle": "*家用清洁电器具*家用清洁卫生电器具",
                                "children": [
                                    {
                                        "id": "3391",
                                        "linkid": "3390",
                                        "code": "109041801",
                                        "paCode": "1090418",
                                        "yn": "N",
                                        "title": "家用洗衣机",
                                        "alias": "家用洗衣机",
                                        "about": "指干衣量≤10kg的家用洗衣机，包括全自动洗衣机、半自动双桶洗衣机、其他家用洗衣机",
                                        "kws": "全自动洗衣机、半自动双桶洗衣机",
                                        "taxName": "家用清洁电器具",
                                        "taxRate": "13%",
                                        "vip": "3",
                                        "itaxRate": "0.13",
                                        "taxCode": "1090418010000000000",
                                        "taxCodeTitle": "家用清洁电器具",
                                        "iTitle": "*家用清洁电器具*家用洗衣机",
                                        "children": []
                                    },
                                    {
                                        "id": "3392",
                                        "linkid": "3390",
                                        "code": "109041802",
                                        "paCode": "1090418",
                                        "yn": "N",
                                        "title": "家用干衣机",
                                        "alias": "家用干衣机",
                                        "about": "指干衣量≤10kg的家用衣服干燥机，是利用电加热来使洗好的衣物中的水分即时蒸发干燥的清洁类家用电器",
                                        "kws": "家用干衣机",
                                        "taxName": "家用清洁电器具",
                                        "taxRate": "13%",
                                        "vip": "3",
                                        "itaxRate": "0.13",
                                        "taxCode": "1090418020000000000",
                                        "taxCodeTitle": "家用清洁电器具",
                                        "iTitle": "*家用清洁电器具*家用干衣机",
                                        "children": []
                                    },
                                    {
                                        "id": "3393",
                                        "linkid": "3390",
                                        "code": "109041803",
                                        "paCode": "1090418",
                                        "yn": "N",
                                        "title": "家用脱水机",
                                        "alias": "家用脱水机",
                                        "about": null,
                                        "kws": "家用脱水机",
                                        "taxName": "家用清洁电器具",
                                        "taxRate": "13%",
                                        "vip": "3",
                                        "itaxRate": "0.13",
                                        "taxCode": "1090418030000000000",
                                        "taxCodeTitle": "家用清洁电器具",
                                        "iTitle": "*家用清洁电器具*家用脱水机",
                                        "children": []
                                    },
                                    {
                                        "id": "3394",
                                        "linkid": "3390",
                                        "code": "109041804",
                                        "paCode": "1090418",
                                        "yn": "N",
                                        "title": "电热水器",
                                        "alias": "电热水器",
                                        "about": "指以电作为能源进行加热的热水器，包括家用电热水器、非家用电热水器",
                                        "kws": "电热水器",
                                        "taxName": "家用清洁电器具",
                                        "taxRate": "13%",
                                        "vip": "3",
                                        "itaxRate": "0.13",
                                        "taxCode": "1090418040000000000",
                                        "taxCodeTitle": "家用清洁电器具",
                                        "iTitle": "*家用清洁电器具*电热水器",
                                        "children": []
                                    },
                                    {
                                        "id": "3395",
                                        "linkid": "3390",
                                        "code": "109041805",
                                        "paCode": "1090418",
                                        "yn": "N",
                                        "title": "家用电清洁器具",
                                        "alias": "家用电清洁器具",
                                        "about": "包括家用吸尘器、地板打蜡机、地板擦洗机、电动扫地机、蒸汽清洁机、其他家用电清洁器具",
                                        "kws": "家用吸尘器、地板打蜡机、地板擦洗机、电动扫地机、蒸汽清洁机、扫地机、扫地机器人",
                                        "taxName": "家用清洁电器具",
                                        "taxRate": "13%",
                                        "vip": "3",
                                        "itaxRate": "0.13",
                                        "taxCode": "1090418050000000000",
                                        "taxCodeTitle": "家用清洁电器具",
                                        "iTitle": "*家用清洁电器具*家用电清洁器具",
                                        "children": []
                                    },
                                    {
                                        "id": "3396",
                                        "linkid": "3390",
                                        "code": "109041899",
                                        "paCode": "1090418",
                                        "yn": "N",
                                        "title": "其他家用清洁卫生电器具",
                                        "alias": "其他家用清洁卫生电器具",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "家用清洁电器具",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090418990000000000",
                                        "taxCodeTitle": "家用清洁电器具",
                                        "iTitle": "*家用清洁电器具*其他家用清洁卫生电器具",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3397",
                                "linkid": "3278",
                                "code": "1090419",
                                "paCode": "10904",
                                "yn": "Y",
                                "title": "家用美容、保健电器具",
                                "alias": "家用美容、保健电器具",
                                "about": "指家用和类似用途的美容、保健电器具，包括家用理发电器具、吹风电器具、电动脱毛器、电美容仪、电动牙刷、家用电动按摩器、其他家用美容、保健电器具",
                                "kws": null,
                                "taxName": "家用美容保健电器",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1090419000000000000",
                                "taxCodeTitle": "家用美容保健电器",
                                "iTitle": "*家用美容保健电器*家用美容、保健电器具",
                                "children": [
                                    {
                                        "id": "3398",
                                        "linkid": "3397",
                                        "code": "109041901",
                                        "paCode": "1090419",
                                        "yn": "N",
                                        "title": "家用理发、吹风电器具",
                                        "alias": "家用理发、吹风电器具",
                                        "about": "指家用和类似用途的理发、吹风电器具，含理发店、美发店用理发、吹风电器具。包括电动剃须刀、电动理发推剪、电吹风机、电热卷发器、卷发电熨器、其他家用理发电器具",
                                        "kws": "电动剃须刀、电动理发推剪、电吹风机、电热卷发器、卷发电熨器",
                                        "taxName": "家用美容保健电器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090419010000000000",
                                        "taxCodeTitle": "家用美容保健电器",
                                        "iTitle": "*家用美容保健电器*家用理发、吹风电器具",
                                        "children": []
                                    },
                                    {
                                        "id": "3399",
                                        "linkid": "3397",
                                        "code": "109041902",
                                        "paCode": "1090419",
                                        "yn": "N",
                                        "title": "电动脱毛器",
                                        "alias": "电动脱毛器",
                                        "about": null,
                                        "kws": "电动脱毛器",
                                        "taxName": "家用美容保健电器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090419020000000000",
                                        "taxCodeTitle": "家用美容保健电器",
                                        "iTitle": "*家用美容保健电器*电动脱毛器",
                                        "children": []
                                    },
                                    {
                                        "id": "3400",
                                        "linkid": "3397",
                                        "code": "109041903",
                                        "paCode": "1090419",
                                        "yn": "N",
                                        "title": "电美容仪",
                                        "alias": "电美容仪",
                                        "about": "指家用和类似用途的电美容仪",
                                        "kws": "电美容仪",
                                        "taxName": "家用美容保健电器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090419030000000000",
                                        "taxCodeTitle": "家用美容保健电器",
                                        "iTitle": "*家用美容保健电器*电美容仪",
                                        "children": []
                                    },
                                    {
                                        "id": "3401",
                                        "linkid": "3397",
                                        "code": "109041904",
                                        "paCode": "1090419",
                                        "yn": "N",
                                        "title": "电动牙刷",
                                        "alias": "电动牙刷",
                                        "about": null,
                                        "kws": "电动牙刷",
                                        "taxName": "家用美容保健电器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090419040000000000",
                                        "taxCodeTitle": "家用美容保健电器",
                                        "iTitle": "*家用美容保健电器*电动牙刷",
                                        "children": []
                                    },
                                    {
                                        "id": "3402",
                                        "linkid": "3397",
                                        "code": "109041905",
                                        "paCode": "1090419",
                                        "yn": "N",
                                        "title": "家用电动按摩器",
                                        "alias": "家用电动按摩器",
                                        "about": "包括足底电动按摩器、多功能电动按摩器、电动按摩沙发、电动氧摇摆器、其他家用电动按摩器",
                                        "kws": "足底电动按摩器、多功能电动按摩器、电动按摩沙发、电动氧摇摆器",
                                        "taxName": "家用美容保健电器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090419050000000000",
                                        "taxCodeTitle": "家用美容保健电器",
                                        "iTitle": "*家用美容保健电器*家用电动按摩器",
                                        "children": []
                                    },
                                    {
                                        "id": "3403",
                                        "linkid": "3397",
                                        "code": "109041999",
                                        "paCode": "1090419",
                                        "yn": "N",
                                        "title": "其他家用美容、保健电器具",
                                        "alias": "其他家用美容、保健电器具",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "家用美容保健电器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090419990000000000",
                                        "taxCodeTitle": "家用美容保健电器",
                                        "iTitle": "*家用美容保健电器*其他家用美容、保健电器具",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3404",
                                "linkid": "3278",
                                "code": "1090420",
                                "paCode": "10904",
                                "yn": "Y",
                                "title": "家用电热电力器具及类似产品",
                                "alias": "家用电热电力器具及类似产品",
                                "about": "包括家用电热取暖器具、家用电熨烫器具、其他家用电热电力器具类似产品",
                                "kws": null,
                                "taxName": "家用电热电力器",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090420000000000000",
                                "taxCodeTitle": "家用电热电力器",
                                "iTitle": "*家用电热电力器*家用电热电力器具及类似产品",
                                "children": [
                                    {
                                        "id": "3405",
                                        "linkid": "3404",
                                        "code": "109042001",
                                        "paCode": "1090420",
                                        "yn": "N",
                                        "title": "家用电热取暖器具",
                                        "alias": "家用电热取暖器具",
                                        "about": "包括电暖气、电暖炉、电热毯、其他家用电热取暖器具",
                                        "kws": "电暖气、电暖炉、电热毯",
                                        "taxName": "家用电热电力器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090420010000000000",
                                        "taxCodeTitle": "家用电热电力器",
                                        "iTitle": "*家用电热电力器*家用电热取暖器具",
                                        "children": []
                                    },
                                    {
                                        "id": "3406",
                                        "linkid": "3404",
                                        "code": "109042002",
                                        "paCode": "1090420",
                                        "yn": "N",
                                        "title": "家用电熨烫器具",
                                        "alias": "家用电熨烫器具",
                                        "about": "包括电熨斗、其他家用电熨烫器具",
                                        "kws": "电熨斗",
                                        "taxName": "家用电热电力器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090420020000000000",
                                        "taxCodeTitle": "家用电热电力器",
                                        "iTitle": "*家用电热电力器*家用电熨烫器具",
                                        "children": []
                                    },
                                    {
                                        "id": "3407",
                                        "linkid": "3404",
                                        "code": "109042099",
                                        "paCode": "1090420",
                                        "yn": "N",
                                        "title": "其他家用电热电力器具类似产品",
                                        "alias": "其他家用电热电力器具类似产品",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "家用电热电力器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090420990000000000",
                                        "taxCodeTitle": "家用电热电力器",
                                        "iTitle": "*家用电热电力器*其他家用电热电力器具类似产品",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3408",
                                "linkid": "3278",
                                "code": "1090421",
                                "paCode": "10904",
                                "yn": "Y",
                                "title": "家用电力器具专用配件",
                                "alias": "家用电力器具专用配件",
                                "about": "包括家用空调设备零件、家用电冰箱用配件、家用洗衣机用配件、电动理发工具零件、电热器具零件、家用电动器具零件、家用型过滤装置零件、家用型净化装置零件、其他家用电力器具专用配件",
                                "kws": null,
                                "taxName": "家用电器配件",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1090421000000000000",
                                "taxCodeTitle": "家用电器配件",
                                "iTitle": "*家用电器配件*家用电力器具专用配件",
                                "children": [
                                    {
                                        "id": "3409",
                                        "linkid": "3408",
                                        "code": "109042101",
                                        "paCode": "1090421",
                                        "yn": "N",
                                        "title": "家用空调设备零件",
                                        "alias": "家用空调设备零件",
                                        "about": null,
                                        "kws": "家用空调设备零件",
                                        "taxName": "家用电器配件",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1090421010000000000",
                                        "taxCodeTitle": "家用电器配件",
                                        "iTitle": "*家用电器配件*家用空调设备零件",
                                        "children": []
                                    },
                                    {
                                        "id": "3410",
                                        "linkid": "3408",
                                        "code": "109042102",
                                        "paCode": "1090421",
                                        "yn": "N",
                                        "title": "家用电冰箱用配件",
                                        "alias": "家用电冰箱用配件",
                                        "about": "包括家用电冰箱用蒸发器、家用电冰箱用冷凝器、家用电冰箱用吸收器、家用电冰箱用温控器、其他家用电冰箱用配件",
                                        "kws": "家用电冰箱用蒸发器、家用电冰箱用冷凝器、家用电冰箱用吸收器、家用电冰箱用温控器",
                                        "taxName": "家用电器配件",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1090421020000000000",
                                        "taxCodeTitle": "家用电器配件",
                                        "iTitle": "*家用电器配件*家用电冰箱用配件",
                                        "children": []
                                    },
                                    {
                                        "id": "3411",
                                        "linkid": "3408",
                                        "code": "109042103",
                                        "paCode": "1090421",
                                        "yn": "N",
                                        "title": "家用洗衣机用配件",
                                        "alias": "家用洗衣机用配件",
                                        "about": "干衣量≤10kg洗衣机的零件，包括洗衣机用传感器、其他家用洗衣机用配件",
                                        "kws": "洗衣机用传感器",
                                        "taxName": "家用电器配件",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1090421030000000000",
                                        "taxCodeTitle": "家用电器配件",
                                        "iTitle": "*家用电器配件*家用洗衣机用配件",
                                        "children": []
                                    },
                                    {
                                        "id": "3412",
                                        "linkid": "3408",
                                        "code": "109042104",
                                        "paCode": "1090421",
                                        "yn": "N",
                                        "title": "电动理发工具零件",
                                        "alias": "电动理发工具零件",
                                        "about": "包括电动剃须刀零件、电动毛发推剪的零件等",
                                        "kws": "电动理发工具零件",
                                        "taxName": "家用电器配件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090421040000000000",
                                        "taxCodeTitle": "家用电器配件",
                                        "iTitle": "*家用电器配件*电动理发工具零件",
                                        "children": []
                                    },
                                    {
                                        "id": "3413",
                                        "linkid": "3408",
                                        "code": "109042105",
                                        "paCode": "1090421",
                                        "yn": "N",
                                        "title": "电热器具零件",
                                        "alias": "电热器具零件",
                                        "about": "包括微波炉用磁控管、其他电热器具零件",
                                        "kws": "电热器具零件",
                                        "taxName": "家用电器配件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090421050000000000",
                                        "taxCodeTitle": "家用电器配件",
                                        "iTitle": "*家用电器配件*电热器具零件",
                                        "children": []
                                    },
                                    {
                                        "id": "3414",
                                        "linkid": "3408",
                                        "code": "109042106",
                                        "paCode": "1090421",
                                        "yn": "N",
                                        "title": "家用电动器具零件",
                                        "alias": "家用电动器具零件",
                                        "about": null,
                                        "kws": "家用电动器具零件",
                                        "taxName": "家用电器配件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090421060000000000",
                                        "taxCodeTitle": "家用电器配件",
                                        "iTitle": "*家用电器配件*家用电动器具零件",
                                        "children": []
                                    },
                                    {
                                        "id": "3415",
                                        "linkid": "3408",
                                        "code": "109042107",
                                        "paCode": "1090421",
                                        "yn": "N",
                                        "title": "家用型过滤、净化装置零件",
                                        "alias": "家用型过滤、净化装置零件",
                                        "about": null,
                                        "kws": "家用型过滤装置零件、家用型净化装置零件",
                                        "taxName": "家用电器配件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090421070000000000",
                                        "taxCodeTitle": "家用电器配件",
                                        "iTitle": "*家用电器配件*家用型过滤、净化装置零件",
                                        "children": []
                                    },
                                    {
                                        "id": "3416",
                                        "linkid": "3408",
                                        "code": "109042199",
                                        "paCode": "1090421",
                                        "yn": "N",
                                        "title": "其他家用电力器具专用配件",
                                        "alias": "其他家用电力器具专用配件",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "家用电器配件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090421990000000000",
                                        "taxCodeTitle": "家用电器配件",
                                        "iTitle": "*家用电器配件*其他家用电力器具专用配件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3417",
                                "linkid": "3278",
                                "code": "1090422",
                                "paCode": "10904",
                                "yn": "Y",
                                "title": "非电力家用器具",
                                "alias": "非电力家用器具",
                                "about": "包括家用燃气用具、沼气用具、太阳能用具、液体燃料家用器具、固体燃料家用器具、铜制家用烹饪或供暖器具、非电力家用器具零件",
                                "kws": null,
                                "taxName": "非电力家用器具",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090422000000000000",
                                "taxCodeTitle": "非电力家用器具",
                                "iTitle": "*非电力家用器具*非电力家用器具",
                                "children": [
                                    {
                                        "id": "3418",
                                        "linkid": "3417",
                                        "code": "109042201",
                                        "paCode": "1090422",
                                        "yn": "N",
                                        "title": "家用燃气用具",
                                        "alias": "家用燃气用具",
                                        "about": "指用天然气、液化石油气等作燃料的燃气用具，包括家用燃气炊事器具、家用燃气保暖器、家用燃气热水器、淋浴房、淋浴设备、其他家用燃气用具",
                                        "kws": "家用燃气炊事器具、家用燃气保暖器、家用燃气热水器、淋浴房、淋浴设备",
                                        "taxName": "非电力家用器具",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090422010000000000",
                                        "taxCodeTitle": "非电力家用器具",
                                        "iTitle": "*非电力家用器具*家用燃气用具",
                                        "children": []
                                    },
                                    {
                                        "id": "3419",
                                        "linkid": "3417",
                                        "code": "109042202",
                                        "paCode": "1090422",
                                        "yn": "N",
                                        "title": "沼气用具",
                                        "alias": "沼气用具",
                                        "about": "包括沼气炊事器具、沼气保暖器、沼气热水器、其他沼气用具",
                                        "kws": "沼气炊事器具、沼气保暖器、沼气热水器",
                                        "taxName": "非电力家用器具",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090422020000000000",
                                        "taxCodeTitle": "非电力家用器具",
                                        "iTitle": "*非电力家用器具*沼气用具",
                                        "children": []
                                    },
                                    {
                                        "id": "3420",
                                        "linkid": "3417",
                                        "code": "109042203",
                                        "paCode": "1090422",
                                        "yn": "N",
                                        "title": "太阳能用具",
                                        "alias": "太阳能用具",
                                        "about": "包括太阳能炊事器具、太阳能保暖器、太阳能热水器、其他太阳能用具",
                                        "kws": "太阳能炊事器具、太阳能保暖器、太阳能热水器",
                                        "taxName": "非电力家用器具",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090422030000000000",
                                        "taxCodeTitle": "非电力家用器具",
                                        "iTitle": "*非电力家用器具*太阳能用具",
                                        "children": []
                                    },
                                    {
                                        "id": "3421",
                                        "linkid": "3417",
                                        "code": "109042204",
                                        "paCode": "1090422",
                                        "yn": "N",
                                        "title": "液体燃料家用器具",
                                        "alias": "液体燃料家用器具",
                                        "about": "包括液体燃料炊事器具、其他液体燃料家用器具",
                                        "kws": "液体燃料炊事器具、煤油炉、酒精炉、燃油散热器",
                                        "taxName": "非电力家用器具",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090422040000000000",
                                        "taxCodeTitle": "非电力家用器具",
                                        "iTitle": "*非电力家用器具*液体燃料家用器具",
                                        "children": []
                                    },
                                    {
                                        "id": "3422",
                                        "linkid": "3417",
                                        "code": "109042205",
                                        "paCode": "1090422",
                                        "yn": "N",
                                        "title": "固体燃料家用器具",
                                        "alias": "固体燃料家用器具",
                                        "about": null,
                                        "kws": "钢铁制家用炊事器具",
                                        "taxName": "非电力家用器具",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090422050000000000",
                                        "taxCodeTitle": "非电力家用器具",
                                        "iTitle": "*非电力家用器具*固体燃料家用器具",
                                        "children": []
                                    },
                                    {
                                        "id": "3423",
                                        "linkid": "3417",
                                        "code": "109042206",
                                        "paCode": "1090422",
                                        "yn": "N",
                                        "title": "铜制家用烹饪或供暖器具",
                                        "alias": "铜制家用烹饪或供暖器具",
                                        "about": "钢铁制家用非电力器具，包括铜火锅、铜制炭火盆、铜制暖手炉、其他铜制家用烹饪或供暖器具",
                                        "kws": "铜火锅、铜制炭火盆、铜制暖手炉",
                                        "taxName": "非电力家用器具",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090422060000000000",
                                        "taxCodeTitle": "非电力家用器具",
                                        "iTitle": "*非电力家用器具*铜制家用烹饪或供暖器具",
                                        "children": []
                                    },
                                    {
                                        "id": "3424",
                                        "linkid": "3417",
                                        "code": "109042207",
                                        "paCode": "1090422",
                                        "yn": "N",
                                        "title": "非电力家用器具零件",
                                        "alias": "非电力家用器具零件",
                                        "about": "包括家用燃气用具零件、沼气用具零件、太阳能用具零件、液体燃料家用器具零件、固体燃料家用器具零件、其他非电力家用器具零件",
                                        "kws": "家用燃气用具零件、沼气用具零件、太阳能用具零件、液体燃料家用器具零件、固体燃料家用器具零件",
                                        "taxName": "非电力家用器具",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090422070000000000",
                                        "taxCodeTitle": "非电力家用器具",
                                        "iTitle": "*非电力家用器具*非电力家用器具零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3425",
                                "linkid": "3278",
                                "code": "1090423",
                                "paCode": "10904",
                                "yn": "Y",
                                "title": "电光源",
                                "alias": "电光源",
                                "about": "包括白炽灯泡、荧光灯、冷阴极荧光灯、卤钨灯、高强度气体放电灯（HID灯）、照相闪光灯源、其他电光源",
                                "kws": null,
                                "taxName": "电光源",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090423000000000000",
                                "taxCodeTitle": "电光源",
                                "iTitle": "*电光源*电光源",
                                "children": [
                                    {
                                        "id": "3426",
                                        "linkid": "3425",
                                        "code": "109042301",
                                        "paCode": "1090423",
                                        "yn": "N",
                                        "title": "白炽灯泡",
                                        "alias": "白炽灯泡",
                                        "about": "指将灯丝通电加热到白炽状态，利用热辐射发出可见光的电光源。包括科研医疗专用白炽灯泡、火车用白炽灯泡、航空器用白炽灯泡、船舶用白炽灯泡、机动车辆用白炽灯泡、普通照明用白炽灯泡、其他白炽灯泡。不包括卤钨灯（详见109042304）、封闭式聚光灯（详见109042404）",
                                        "kws": "白炽灯泡",
                                        "taxName": "电光源",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090423010000000000",
                                        "taxCodeTitle": "电光源",
                                        "iTitle": "*电光源*白炽灯泡",
                                        "children": []
                                    },
                                    {
                                        "id": "3427",
                                        "linkid": "3425",
                                        "code": "109042302",
                                        "paCode": "1090423",
                                        "yn": "N",
                                        "title": "荧光灯",
                                        "alias": "荧光灯",
                                        "about": "指热阴极荧光灯，包括科研专用荧光灯、医疗专用荧光灯、火车用热阴极荧光灯、航空器用热阴极荧光灯、船舶用热阴极荧光灯、普通照明用荧光灯、其他荧光灯",
                                        "kws": "热阴极荧光灯、普通照明用荧光灯",
                                        "taxName": "电光源",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090423020000000000",
                                        "taxCodeTitle": "电光源",
                                        "iTitle": "*电光源*荧光灯",
                                        "children": []
                                    },
                                    {
                                        "id": "3428",
                                        "linkid": "3425",
                                        "code": "109042303",
                                        "paCode": "1090423",
                                        "yn": "N",
                                        "title": "冷阴极荧光灯",
                                        "alias": "冷阴极荧光灯",
                                        "about": "包括背景光源用冷阴极荧光灯、照明用冷阴极荧光灯、其他冷阴极荧光灯",
                                        "kws": "冷阴极荧光灯",
                                        "taxName": "电光源",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090423030000000000",
                                        "taxCodeTitle": "电光源",
                                        "iTitle": "*电光源*冷阴极荧光灯",
                                        "children": []
                                    },
                                    {
                                        "id": "3429",
                                        "linkid": "3425",
                                        "code": "109042304",
                                        "paCode": "1090423",
                                        "yn": "N",
                                        "title": "卤钨灯",
                                        "alias": "卤钨灯",
                                        "about": "指填充气体内含有部分卤族元素或卤化物的充气白炽灯。包括科研、医疗专用卤钨灯、火车用卤钨灯、航空器用卤钨灯、船舶用卤钨灯、机动车辆用卤钨灯、其他卤钨灯",
                                        "kws": "卤钨灯",
                                        "taxName": "电光源",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090423040000000000",
                                        "taxCodeTitle": "电光源",
                                        "iTitle": "*电光源*卤钨灯",
                                        "children": []
                                    },
                                    {
                                        "id": "3430",
                                        "linkid": "3425",
                                        "code": "109042305",
                                        "paCode": "1090423",
                                        "yn": "N",
                                        "title": "高强度气体放电灯（HID灯）",
                                        "alias": "高强度气体放电灯（HID灯）",
                                        "about": "包括汞蒸气灯（水银灯）、钠蒸气灯、金属卤化物灯、其他高强度气体放电灯",
                                        "kws": "汞蒸气灯、水银灯、钠蒸气灯、金属卤化物灯",
                                        "taxName": "电光源",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090423050000000000",
                                        "taxCodeTitle": "电光源",
                                        "iTitle": "*电光源*高强度气体放电灯（HID灯）",
                                        "children": []
                                    },
                                    {
                                        "id": "3431",
                                        "linkid": "3425",
                                        "code": "109042306",
                                        "paCode": "1090423",
                                        "yn": "N",
                                        "title": "照相闪光灯源",
                                        "alias": "照相闪光灯源",
                                        "about": "包括单端闪光灯泡、电池闪光灯、管形闪光灯、其他照相闪光灯源",
                                        "kws": "单端闪光灯泡、电池闪光灯、管形闪光灯",
                                        "taxName": "电光源",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090423060000000000",
                                        "taxCodeTitle": "电光源",
                                        "iTitle": "*电光源*照相闪光灯源",
                                        "children": []
                                    },
                                    {
                                        "id": "3432",
                                        "linkid": "3425",
                                        "code": "109042399",
                                        "paCode": "1090423",
                                        "yn": "N",
                                        "title": "其他电光源",
                                        "alias": "其他电光源",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "电光源",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090423990000000000",
                                        "taxCodeTitle": "电光源",
                                        "iTitle": "*电光源*其他电光源",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3433",
                                "linkid": "3278",
                                "code": "1090424",
                                "paCode": "10904",
                                "yn": "Y",
                                "title": "灯具及照明装置",
                                "alias": "灯具及照明装置",
                                "about": "包括室内照明灯具，户外照明用灯具及装置，装饰用灯，特殊用途灯具及照明装置，发光标志、发光铭牌及类似品，非电气灯具及照明装置，非电气灯具及照明装置，自供能源灯具，灯用电器附件，电光源、灯具及照明装置零件",
                                "kws": null,
                                "taxName": "照明装置",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090424000000000000",
                                "taxCodeTitle": "照明装置",
                                "iTitle": "*照明装置*灯具及照明装置",
                                "children": [
                                    {
                                        "id": "3434",
                                        "linkid": "3433",
                                        "code": "109042401",
                                        "paCode": "1090424",
                                        "yn": "N",
                                        "title": "室内照明灯具",
                                        "alias": "室内照明灯具",
                                        "about": "包括吊灯、吸顶灯、壁灯、台灯、落地灯、嵌入式灯具、轨道灯、支架灯具、射灯等",
                                        "kws": "吊灯、吸顶灯、壁灯、台灯、落地灯、嵌入式灯具、轨道灯、支架灯具、射灯",
                                        "taxName": "照明装置",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090424010000000000",
                                        "taxCodeTitle": "照明装置",
                                        "iTitle": "*照明装置*室内照明灯具",
                                        "children": []
                                    },
                                    {
                                        "id": "3435",
                                        "linkid": "3433",
                                        "code": "109042402",
                                        "paCode": "1090424",
                                        "yn": "N",
                                        "title": "户外照明用灯具及装置",
                                        "alias": "户外照明用灯具及装置",
                                        "about": "包括街灯及照明装置、庭院灯、投光灯、道路灯、草坪灯、地埋灯、其他户外照明用灯具及装置",
                                        "kws": "街灯、街灯照明装置、庭院灯、投光灯、道路灯、草坪灯、地埋灯",
                                        "taxName": "照明装置",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090424020000000000",
                                        "taxCodeTitle": "照明装置",
                                        "iTitle": "*照明装置*户外照明用灯具及装置",
                                        "children": []
                                    },
                                    {
                                        "id": "3436",
                                        "linkid": "3433",
                                        "code": "109042403",
                                        "paCode": "1090424",
                                        "yn": "N",
                                        "title": "装饰用灯",
                                        "alias": "装饰用灯",
                                        "about": "包括圣诞树用成套灯具、其他装饰用灯",
                                        "kws": "圣诞树用成套灯具、电气彩灯串、变色灯、滚柱彩灯",
                                        "taxName": "照明装置",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090424030000000000",
                                        "taxCodeTitle": "照明装置",
                                        "iTitle": "*照明装置*装饰用灯",
                                        "children": []
                                    },
                                    {
                                        "id": "3437",
                                        "linkid": "3433",
                                        "code": "109042404",
                                        "paCode": "1090424",
                                        "yn": "N",
                                        "title": "特殊用途灯具及照明装置",
                                        "alias": "特殊用途灯具及照明装置",
                                        "about": "包括农业用灯具、医疗用灯具、火车用照明装置、飞机用照明装置、船舶用照明装置、应急灯、防爆灯、水下灯、影视舞台灯、其他特殊用途灯具及照明装置",
                                        "kws": "农业用灯具、医疗用灯具、火车用照明装置、飞机用照明装置、船舶用照明装置、应急灯、防爆灯、水下灯、影视舞台灯、暗室灯、摄影室用灯具、聚光灯、防爆灯具、机器用灯、探照灯",
                                        "taxName": "照明装置",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090424040000000000",
                                        "taxCodeTitle": "照明装置",
                                        "iTitle": "*照明装置*特殊用途灯具及照明装置",
                                        "children": []
                                    },
                                    {
                                        "id": "3438",
                                        "linkid": "3433",
                                        "code": "109042405",
                                        "paCode": "1090424",
                                        "yn": "N",
                                        "title": "发光标志、发光铭牌及类似品",
                                        "alias": "发光标志、发光铭牌及类似品",
                                        "about": "包括灯饰招牌、灯饰铭牌、霓虹灯具、广告灯具、安全标志灯、其他发光标志、其他发光铭牌及类似品",
                                        "kws": "灯饰招牌、灯饰铭牌、霓虹灯具、广告灯具、安全标志灯",
                                        "taxName": "照明装置",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090424050000000000",
                                        "taxCodeTitle": "照明装置",
                                        "iTitle": "*照明装置*发光标志、发光铭牌及类似品",
                                        "children": []
                                    },
                                    {
                                        "id": "3439",
                                        "linkid": "3433",
                                        "code": "109042406",
                                        "paCode": "1090424",
                                        "yn": "N",
                                        "title": "非电气灯具及照明装置",
                                        "alias": "非电气灯具及照明装置",
                                        "about": "包括便携式灯具、烛台、烛架、其他非电气灯具及照明装置",
                                        "kws": "便携式灯具、防风灯、马厩灯、手提灯、矿灯、采石矿工用灯、烛台、烛架",
                                        "taxName": "照明装置",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090424060000000000",
                                        "taxCodeTitle": "照明装置",
                                        "iTitle": "*照明装置*非电气灯具及照明装置",
                                        "children": []
                                    },
                                    {
                                        "id": "3440",
                                        "linkid": "3433",
                                        "code": "109042407",
                                        "paCode": "1090424",
                                        "yn": "N",
                                        "title": "自供能源灯具",
                                        "alias": "自供能源灯具",
                                        "about": "指依靠自供电源进行工作的手提式电灯，包括手电筒、莫尔斯信号灯、矿工安全灯、头戴通用检查灯（头灯）、其他自供能源灯具",
                                        "kws": "手电筒、莫尔斯信号灯、矿工安全灯、头戴通用检查灯、头灯",
                                        "taxName": "照明装置",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090424070000000000",
                                        "taxCodeTitle": "照明装置",
                                        "iTitle": "*照明装置*自供能源灯具",
                                        "children": []
                                    },
                                    {
                                        "id": "3441",
                                        "linkid": "3433",
                                        "code": "109042408",
                                        "paCode": "1090424",
                                        "yn": "N",
                                        "title": "灯用电器附件",
                                        "alias": "灯用电器附件",
                                        "about": "包括灯用镇流器、灯用启辉器、灯用变压器、灯用触发器、灯用逆变器、其他灯用电器附件",
                                        "kws": "灯用镇流器、灯用启辉器、灯用变压器、灯用触发器、灯用逆变器",
                                        "taxName": "照明装置",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090424080000000000",
                                        "taxCodeTitle": "照明装置",
                                        "iTitle": "*照明装置*灯用电器附件",
                                        "children": []
                                    },
                                    {
                                        "id": "3442",
                                        "linkid": "3433",
                                        "code": "109042409",
                                        "paCode": "1090424",
                                        "yn": "N",
                                        "title": "电光源、灯具及照明装置零件",
                                        "alias": "电光源、灯具及照明装置零件",
                                        "about": "包括电光源零件、室内照明灯具零件、户外照明用灯具及装置零件、自供能源灯具零件、其他灯具及照明装置零件",
                                        "kws": "电光源零件、室内照明灯具零件、户外照明用灯具、户外照明用灯具装置零件、自供能源灯具零件",
                                        "taxName": "照明装置",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090424090000000000",
                                        "taxCodeTitle": "照明装置",
                                        "iTitle": "*照明装置*电光源、灯具及照明装置零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3443",
                                "linkid": "3278",
                                "code": "1090425",
                                "paCode": "10904",
                                "yn": "Y",
                                "title": "车辆专用照明、信号及其装置",
                                "alias": "车辆专用照明、信号及其装置",
                                "about": "包括机动车辆用电气照明装置，车辆用视觉信号装置，自行车照明或视觉、音响信号装置，车辆用电气音响信号装置，电气音响或视觉信号装置，其他车辆专用照明",
                                "kws": null,
                                "taxName": "车辆照明信号装置",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090425000000000000",
                                "taxCodeTitle": "车辆照明信号装置",
                                "iTitle": "*车辆照明信号装置*车辆专用照明、信号及其装置",
                                "children": [
                                    {
                                        "id": "3444",
                                        "linkid": "3443",
                                        "code": "109042501",
                                        "paCode": "1090425",
                                        "yn": "N",
                                        "title": "机动车辆用电气照明装置",
                                        "alias": "机动车辆用电气照明装置",
                                        "about": "包括车头灯、警车用探照灯、车用信号、指示灯、车用组合灯具、车辆内部照明灯具、其他机动车辆用电气照明装置",
                                        "kws": "车头灯、漫射驾驶灯、防雾灯、车头聚光灯、警车用探照灯、边灯、尾灯、停车灯、车牌照明灯、刹车灯、转向指示灯、倒车灯、车用组合灯具、车顶灯、壁灯、踏板指示灯、门框灯、仪表板灯",
                                        "taxName": "车辆照明信号装置",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090425010000000000",
                                        "taxCodeTitle": "车辆照明信号装置",
                                        "iTitle": "*车辆照明信号装置*机动车辆用电气照明装置",
                                        "children": []
                                    },
                                    {
                                        "id": "3445",
                                        "linkid": "3443",
                                        "code": "109042502",
                                        "paCode": "1090425",
                                        "yn": "N",
                                        "title": "车辆用视觉信号装置",
                                        "alias": "车辆用视觉信号装置",
                                        "about": "包括停车设备、发光超车信号装置、电气视觉信号设备、其他车辆用视觉信号装置",
                                        "kws": "停车设备、发光超车信号装置、电气视觉信号设备",
                                        "taxName": "车辆照明信号装置",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090425020000000000",
                                        "taxCodeTitle": "车辆照明信号装置",
                                        "iTitle": "*车辆照明信号装置*车辆用视觉信号装置",
                                        "children": []
                                    },
                                    {
                                        "id": "3446",
                                        "linkid": "3443",
                                        "code": "109042503",
                                        "paCode": "1090425",
                                        "yn": "N",
                                        "title": "自行车照明或视觉、音响信号装置",
                                        "alias": "自行车照明或视觉、音响信号装置",
                                        "about": "包括自行车电气照明装置，自行车视觉信号装置，自行车喇叭，其他自行车照明、音响信号装置",
                                        "kws": "自行车电气照明装置、自行车视觉信号装置、自行车喇叭",
                                        "taxName": "车辆照明信号装置",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090425030000000000",
                                        "taxCodeTitle": "车辆照明信号装置",
                                        "iTitle": "*车辆照明信号装置*自行车照明或视觉、音响信号装置",
                                        "children": []
                                    },
                                    {
                                        "id": "3447",
                                        "linkid": "3443",
                                        "code": "109042504",
                                        "paCode": "1090425",
                                        "yn": "N",
                                        "title": "车辆用电气音响信号装置",
                                        "alias": "车辆用电气音响信号装置",
                                        "about": "包括汽车喇叭、车辆用蜂鸣器、其他车辆用电气音响信号装置",
                                        "kws": "汽车喇叭、车辆用蜂鸣器",
                                        "taxName": "车辆照明信号装置",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090425040000000000",
                                        "taxCodeTitle": "车辆照明信号装置",
                                        "iTitle": "*车辆照明信号装置*车辆用电气音响信号装置",
                                        "children": []
                                    },
                                    {
                                        "id": "3448",
                                        "linkid": "3443",
                                        "code": "109042505",
                                        "paCode": "1090425",
                                        "yn": "N",
                                        "title": "电气音响或视觉信号装置",
                                        "alias": "电气音响或视觉信号装置",
                                        "about": "包括显示板及类似装置，电气音响、信号及类似装置，",
                                        "kws": "办公室显示器、电梯显示器、船舶传令装置、机舱传令装置、车站显示板、机场显示板、足球场用显示器、体育场用显示器、电蜂音器、电铃、电门钟、工厂用电笛、空袭警报器、船用电笛、船用喇叭、闪烁信号灯、间歇信号灯",
                                        "taxName": "车辆照明信号装置",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090425050000000000",
                                        "taxCodeTitle": "车辆照明信号装置",
                                        "iTitle": "*车辆照明信号装置*电气音响或视觉信号装置",
                                        "children": []
                                    },
                                    {
                                        "id": "3449",
                                        "linkid": "3443",
                                        "code": "109042506",
                                        "paCode": "1090425",
                                        "yn": "N",
                                        "title": "照明及电气信号装置零件",
                                        "alias": "照明及电气信号装置零件",
                                        "about": "包括车辆专用照明及电气信号装置零件、电气音响或视觉信号装置零件",
                                        "kws": "车辆专用照明装置零件、电气信号装置零件、电气音响装置零件、视觉信号装置零件",
                                        "taxName": "车辆照明信号装置",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090425060000000000",
                                        "taxCodeTitle": "车辆照明信号装置",
                                        "iTitle": "*车辆照明信号装置*照明及电气信号装置零件",
                                        "children": []
                                    },
                                    {
                                        "id": "3450",
                                        "linkid": "3443",
                                        "code": "109042599",
                                        "paCode": "1090425",
                                        "yn": "N",
                                        "title": "其他车辆专用照明、信号及其装置",
                                        "alias": "其他车辆专用照明、信号及其装置",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "车辆照明信号装置",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090425990000000000",
                                        "taxCodeTitle": "车辆照明信号装置",
                                        "iTitle": "*车辆照明信号装置*其他车辆专用照明、信号及其装置",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3451",
                                "linkid": "3278",
                                "code": "1090426",
                                "paCode": "10904",
                                "yn": "Y",
                                "title": "具有独立功能电气设备及装置",
                                "alias": "具有独立功能电气设备及装置",
                                "about": "包括粒子加速器、信号发生器（电气装置）、电气空间加热器具装置、电篱网激发器、紫外线辐照设备、其他具有独立功能电气设备及装置",
                                "kws": null,
                                "taxName": "其他电气设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090426000000000000",
                                "taxCodeTitle": "其他电气设备",
                                "iTitle": "*其他电气设备*具有独立功能电气设备及装置",
                                "children": [
                                    {
                                        "id": "3452",
                                        "linkid": "3451",
                                        "code": "109042601",
                                        "paCode": "1090426",
                                        "yn": "N",
                                        "title": "粒子加速器",
                                        "alias": "粒子加速器",
                                        "about": "包括回旋粒子加速器、其他粒子加速器",
                                        "kws": "粒子加速器",
                                        "taxName": "其他电气设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090426010000000000",
                                        "taxCodeTitle": "其他电气设备",
                                        "iTitle": "*其他电气设备*粒子加速器",
                                        "children": []
                                    },
                                    {
                                        "id": "3453",
                                        "linkid": "3451",
                                        "code": "109042602",
                                        "paCode": "1090426",
                                        "yn": "N",
                                        "title": "信号发生器（电气装置）",
                                        "alias": "信号发生器（电气装置）",
                                        "about": "包括通用信号发生器、其他信号发生器（电气装置）",
                                        "kws": "信号发生器",
                                        "taxName": "其他电气设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090426020000000000",
                                        "taxCodeTitle": "其他电气设备",
                                        "iTitle": "*其他电气设备*信号发生器（电气装置）",
                                        "children": []
                                    },
                                    {
                                        "id": "3454",
                                        "linkid": "3451",
                                        "code": "109042603",
                                        "paCode": "1090426",
                                        "yn": "N",
                                        "title": "电气空间加热器具装置",
                                        "alias": "电气空间加热器具装置",
                                        "about": "包括电气储存式散热器，对流加热器，加热嵌板，汽车、火车、飞机用电热装置，道路加热设备，电气土壤加热器，发动机加热器，加热电阻器，其他电气空间加热器具装置",
                                        "kws": "电气储存式散热器、对流加热器、加热嵌板、汽车用电热装置、火车用电热装置、飞机用电热装置、道路加热设备、电气土壤加热器、发动机加热器、加热电阻器",
                                        "taxName": "其他电气设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090426030000000000",
                                        "taxCodeTitle": "其他电气设备",
                                        "iTitle": "*其他电气设备*电气空间加热器具装置",
                                        "children": []
                                    },
                                    {
                                        "id": "3455",
                                        "linkid": "3451",
                                        "code": "109042604",
                                        "paCode": "1090426",
                                        "yn": "N",
                                        "title": "电篱网激发器",
                                        "alias": "电篱网激发器",
                                        "about": null,
                                        "kws": "电篱网激发器",
                                        "taxName": "其他电气设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090426040000000000",
                                        "taxCodeTitle": "其他电气设备",
                                        "iTitle": "*其他电气设备*电篱网激发器",
                                        "children": []
                                    },
                                    {
                                        "id": "3456",
                                        "linkid": "3451",
                                        "code": "109042605",
                                        "paCode": "1090426",
                                        "yn": "N",
                                        "title": "紫外线辐照设备",
                                        "alias": "紫外线辐照设备",
                                        "about": "指一般工业用的紫外线辐照设备",
                                        "kws": "紫外线辐照设备",
                                        "taxName": "其他电气设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090426050000000000",
                                        "taxCodeTitle": "其他电气设备",
                                        "iTitle": "*其他电气设备*紫外线辐照设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3457",
                                        "linkid": "3451",
                                        "code": "109042699",
                                        "paCode": "1090426",
                                        "yn": "N",
                                        "title": "其他具有独立功能电气设备及装置",
                                        "alias": "其他具有独立功能电气设备及装置",
                                        "about": "除粒子加速器、信号发生器（电气装置）、电气空间加热器具装置、电篱网激发器、紫外线辐照设备外的其他具有独立功能电气设备及装置，包括信号发电机、探雷器、电动地雷搜索器、臭氧发生及扩散电气装置等",
                                        "kws": "信号发电机、探雷器、电动地雷搜索器、臭氧发生电气装置、臭氧扩散电气装置",
                                        "taxName": "其他电气设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090426990000000000",
                                        "taxCodeTitle": "其他电气设备",
                                        "iTitle": "*其他电气设备*其他具有独立功能电气设备及装置",
                                        "children": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "id": "3458",
                        "linkid": "2501",
                        "code": "10905",
                        "paCode": "109",
                        "yn": "Y",
                        "title": "通信设备、计算机及其他电子设备",
                        "alias": "通信设备、计算机及其他电子设备",
                        "about": "包括通信传输设备、通信交换设备、通信终端设备、移动通信设备、移动通信终端设备及零部件、通信接入设备、雷达、无线电导航及无线电遥控设备、广播电视设备、电子计算机及其部件、计算机网络设备、电子计算机外部设备及装置、电子计算机配套产品及耗材、信息系统安全产品、真空电子器件及零件、半导体分立器件、光电子器件及激光器件、集成电路、微电子组件、电子元件、敏感元件及传感器、印制电路板、家用音视频设备、其他未列明电子设备",
                        "kws": null,
                        "taxName": "通信设备计算机",
                        "taxRate": "",
                        "vip": "7",
                        "itaxRate": null,
                        "taxCode": "1090500000000000000",
                        "taxCodeTitle": "通信设备计算机",
                        "iTitle": "*通信设备计算机*通信设备、计算机及其他电子设备",
                        "children": [
                            {
                                "id": "3459",
                                "linkid": "3458",
                                "code": "1090501",
                                "paCode": "10905",
                                "yn": "Y",
                                "title": "通信传输设备",
                                "alias": "通信传输设备",
                                "about": "包括光通信设备、卫星通信设备、微波通信设备、散射通信设备、载波通信设备、通信导航定向设备、通信传输设备零件",
                                "kws": null,
                                "taxName": "通信传输设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090501000000000000",
                                "taxCodeTitle": "通信传输设备",
                                "iTitle": "*通信传输设备*通信传输设备",
                                "children": [
                                    {
                                        "id": "3460",
                                        "linkid": "3459",
                                        "code": "109050101",
                                        "paCode": "1090501",
                                        "yn": "N",
                                        "title": "光通信设备",
                                        "alias": "光通信设备",
                                        "about": "包括光端机、光缆中继设备、光纤放大器、波分复用器、光交叉联接设备、光分插复用设备（ADM）、多业务传送设备（MSTP）、电光转换器、无源光分路器、自动交换光网络设备（ASON）、光传送网络设备（OTN）、分组传送网络设备（PTN）、其他光通信设备",
                                        "kws": "光端机、光缆中继设备、光纤放大器、波分复用器、光交叉联接设备、光分插复用设备、多业务传送设备、电光转换器、无源光分路器、自动交换光网络设备、光传送网络设备、分组传送网络设备",
                                        "taxName": "通信传输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090501010000000000",
                                        "taxCodeTitle": "通信传输设备",
                                        "iTitle": "*通信传输设备*光通信设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3461",
                                        "linkid": "3459",
                                        "code": "109050102",
                                        "paCode": "1090501",
                                        "yn": "N",
                                        "title": "卫星通信设备",
                                        "alias": "卫星通信设备",
                                        "about": "包括卫星地面接收机、卫星接收天线、卫星导航定位接收机、卫星导航定位天线、卫星通信地面站终端机、甚小型天线地球站（VSAT）、卫星地面站零部件、其他卫星通信设备。不包括电视用卫星通信设备（详见109050802）",
                                        "kws": "卫星地面接收机、卫星接收天线、卫星导航定位接收机、卫星导航定位天线、卫星通信地面站终端机、甚小型天线地球站、卫星地面站零部件",
                                        "taxName": "通信传输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090501020000000000",
                                        "taxCodeTitle": "通信传输设备",
                                        "iTitle": "*通信传输设备*卫星通信设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3462",
                                        "linkid": "3459",
                                        "code": "109050103",
                                        "paCode": "1090501",
                                        "yn": "N",
                                        "title": "微波通信设备",
                                        "alias": "微波通信设备",
                                        "about": "包括微波收发通信机，微波终端机，微波天线、馈线，其他微波通信设备",
                                        "kws": "微波收发通信机、微波终端机、微波天线、微波馈线",
                                        "taxName": "通信传输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090501030000000000",
                                        "taxCodeTitle": "通信传输设备",
                                        "iTitle": "*通信传输设备*微波通信设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3463",
                                        "linkid": "3459",
                                        "code": "109050104",
                                        "paCode": "1090501",
                                        "yn": "N",
                                        "title": "散射通信设备",
                                        "alias": "散射通信设备",
                                        "about": "包括散射通信终端机、散射信道机、散射通信天线、其他散射通信设备",
                                        "kws": "散射通信终端机、散射信道机、散射通信天线",
                                        "taxName": "通信传输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090501040000000000",
                                        "taxCodeTitle": "通信传输设备",
                                        "iTitle": "*通信传输设备*散射通信设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3464",
                                        "linkid": "3459",
                                        "code": "109050105",
                                        "paCode": "1090501",
                                        "yn": "N",
                                        "title": "载波通信设备",
                                        "alias": "载波通信设备",
                                        "about": "含海底电缆载波通信系统设备，包括载波终端机、载波增音机、电力线载波机、其他载波通信设备",
                                        "kws": "载波终端机、载波增音机、电力线载波机",
                                        "taxName": "通信传输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090501050000000000",
                                        "taxCodeTitle": "通信传输设备",
                                        "iTitle": "*通信传输设备*载波通信设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3465",
                                        "linkid": "3459",
                                        "code": "109050106",
                                        "paCode": "1090501",
                                        "yn": "N",
                                        "title": "通信导航定向设备",
                                        "alias": "通信导航定向设备",
                                        "about": "包括飞机通信导航定向设备、航用通信导航定向设备、地面通信导航定向设备、其他通信导航定向设备",
                                        "kws": "飞机通信导航定向设备、航用通信导航定向设备、地面通信导航定向设备",
                                        "taxName": "通信传输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090501060000000000",
                                        "taxCodeTitle": "通信传输设备",
                                        "iTitle": "*通信传输设备*通信导航定向设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3466",
                                        "linkid": "3459",
                                        "code": "109050107",
                                        "paCode": "1090501",
                                        "yn": "N",
                                        "title": "通信传输设备零件",
                                        "alias": "通信传输设备零件",
                                        "about": "包括天线滤波器及分离器、天线支架（底架）、天线及其反射器零件、光端机零件、脉冲编码调制设备零件、其他通信传输设备零件",
                                        "kws": "天线滤波器、天线分离器、天线支架、天线底架、天线、天线反射器零件、光端机零件、脉冲编码调制设备零件",
                                        "taxName": "通信传输设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090501070000000000",
                                        "taxCodeTitle": "通信传输设备",
                                        "iTitle": "*通信传输设备*通信传输设备零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3467",
                                "linkid": "3458",
                                "code": "1090502",
                                "paCode": "10905",
                                "yn": "Y",
                                "title": "通信交换设备",
                                "alias": "通信交换设备",
                                "about": "包括程控交换机、ATM交换机、光交换机、通信交换设备零件、其他通信交换设备",
                                "kws": null,
                                "taxName": "通信交换设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090502000000000000",
                                "taxCodeTitle": "通信交换设备",
                                "iTitle": "*通信交换设备*通信交换设备",
                                "children": [
                                    {
                                        "id": "3468",
                                        "linkid": "3467",
                                        "code": "109050201",
                                        "paCode": "1090502",
                                        "yn": "N",
                                        "title": "程控交换机",
                                        "alias": "程控交换机",
                                        "about": "包括数字程控交换机、固网软交换相关设备、七号信令转接设备。不包括移动交换机(详见109050401)",
                                        "kws": "数字程控交换机、软交换控制设备、综合接入设备、接入媒体网关、中继媒体网关、七号信令转接点、SIGTRAN信令网关",
                                        "taxName": "通信交换设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090502010000000000",
                                        "taxCodeTitle": "通信交换设备",
                                        "iTitle": "*通信交换设备*程控交换机",
                                        "children": []
                                    },
                                    {
                                        "id": "3469",
                                        "linkid": "3467",
                                        "code": "109050202",
                                        "paCode": "1090502",
                                        "yn": "N",
                                        "title": "ATM交换机",
                                        "alias": "ATM交换机",
                                        "about": null,
                                        "kws": "ATM交换机",
                                        "taxName": "通信交换设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090502020000000000",
                                        "taxCodeTitle": "通信交换设备",
                                        "iTitle": "*通信交换设备*ATM交换机",
                                        "children": []
                                    },
                                    {
                                        "id": "3470",
                                        "linkid": "3467",
                                        "code": "109050203",
                                        "paCode": "1090502",
                                        "yn": "N",
                                        "title": "光交换机",
                                        "alias": "光交换机",
                                        "about": null,
                                        "kws": "光交换机",
                                        "taxName": "通信交换设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090502030000000000",
                                        "taxCodeTitle": "通信交换设备",
                                        "iTitle": "*通信交换设备*光交换机",
                                        "children": []
                                    },
                                    {
                                        "id": "3471",
                                        "linkid": "3467",
                                        "code": "109050204",
                                        "paCode": "1090502",
                                        "yn": "N",
                                        "title": "通信交换设备零件",
                                        "alias": "通信交换设备零件",
                                        "about": "含通信交换设备专用箱、壳，包括数字式程控电话交换机零件、电报交换机零件、其他通信交换设备零件",
                                        "kws": "数字式程控电话交换机零件、电报交换机零件",
                                        "taxName": "通信交换设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090502040000000000",
                                        "taxCodeTitle": "通信交换设备",
                                        "iTitle": "*通信交换设备*通信交换设备零件",
                                        "children": []
                                    },
                                    {
                                        "id": "3472",
                                        "linkid": "3467",
                                        "code": "109050299",
                                        "paCode": "1090502",
                                        "yn": "N",
                                        "title": "其他通信交换设备",
                                        "alias": "其他通信交换设备",
                                        "about": "包括分组交换机、电报交换机等",
                                        "kws": "分组交换机、电报交换机",
                                        "taxName": "通信交换设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090502990000000000",
                                        "taxCodeTitle": "通信交换设备",
                                        "iTitle": "*通信交换设备*其他通信交换设备",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3473",
                                "linkid": "3458",
                                "code": "1090503",
                                "paCode": "10905",
                                "yn": "Y",
                                "title": "通信终端设备",
                                "alias": "通信终端设备",
                                "about": "包括收发合一中小型电台、电话单机、数据终端设备、通信终端设备用零件",
                                "kws": null,
                                "taxName": "通信终端设备",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1090503000000000000",
                                "taxCodeTitle": "通信终端设备",
                                "iTitle": "*通信终端设备*通信终端设备",
                                "children": [
                                    {
                                        "id": "3474",
                                        "linkid": "3473",
                                        "code": "109050301",
                                        "paCode": "1090503",
                                        "yn": "N",
                                        "title": "收发合一中小型电台",
                                        "alias": "收发合一中小型电台",
                                        "about": "指无线电报收发合一设备，包括短波电台、超短波电台、短波跳频电台、超短波跳频电台、其他收发合一中小型电台",
                                        "kws": "短波电台、超短波电台、短波跳频电台、超短波跳频电台",
                                        "taxName": "通信终端设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090503010000000000",
                                        "taxCodeTitle": "通信终端设备",
                                        "iTitle": "*通信终端设备*收发合一中小型电台",
                                        "children": []
                                    },
                                    {
                                        "id": "3475",
                                        "linkid": "3473",
                                        "code": "109050302",
                                        "paCode": "1090503",
                                        "yn": "N",
                                        "title": "电话单机",
                                        "alias": "电话单机",
                                        "about": "有线电话、电报设备，包括PSTN普通电话机、网络电话机（IP电话机）、特种电话机",
                                        "kws": "PSTN普通电话机、网络电话机、IP电话机、特种电话机",
                                        "taxName": "通信终端设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090503020000000000",
                                        "taxCodeTitle": "通信终端设备",
                                        "iTitle": "*通信终端设备*电话单机",
                                        "children": []
                                    },
                                    {
                                        "id": "3476",
                                        "linkid": "3473",
                                        "code": "109050303",
                                        "paCode": "1090503",
                                        "yn": "N",
                                        "title": "数据终端设备",
                                        "alias": "数据终端设备",
                                        "about": "包括传真机、数传机、其他数据终端设备",
                                        "kws": "传真机、基带数传机、群路数传机、低速数传机、电话网数传机、数码通信机、短波数传机",
                                        "taxName": "通信终端设备",
                                        "taxRate": "13%",
                                        "vip": "3",
                                        "itaxRate": "0.13",
                                        "taxCode": "1090503030000000000",
                                        "taxCodeTitle": "通信终端设备",
                                        "iTitle": "*通信终端设备*数据终端设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3477",
                                        "linkid": "3473",
                                        "code": "109050304",
                                        "paCode": "1090503",
                                        "yn": "N",
                                        "title": "通信终端设备用零件",
                                        "alias": "通信终端设备用零件",
                                        "about": "含通信终端设备专用箱、壳，包括传真机零件、其他通信终端设备用零件",
                                        "kws": "传真机零件",
                                        "taxName": "通信终端设备",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1090503040000000000",
                                        "taxCodeTitle": "通信终端设备",
                                        "iTitle": "*通信终端设备*通信终端设备用零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3478",
                                "linkid": "3458",
                                "code": "1090504",
                                "paCode": "10905",
                                "yn": "Y",
                                "title": "移动通信设备",
                                "alias": "移动通信设备",
                                "about": "包括数字蜂窝移动电话系统设备、集群通信系统设备、无中心选址通信系统设备、移动通信设备零件",
                                "kws": null,
                                "taxName": "移动通信设备",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1090504000000000000",
                                "taxCodeTitle": "移动通信设备",
                                "iTitle": "*移动通信设备*移动通信设备",
                                "children": [
                                    {
                                        "id": "3479",
                                        "linkid": "3478",
                                        "code": "109050401",
                                        "paCode": "1090504",
                                        "yn": "N",
                                        "title": "数字蜂窝移动电话系统设备",
                                        "alias": "数字蜂窝移动电话系统设备",
                                        "about": "包括移动通信基站设备、移动通信基站天线、直放站、干线放大器、移动交换机（MSC）、移动软交换设备、移动通信核心网分组域设备、其他数字蜂窝移动电话系统设备",
                                        "kws": "移动通信基站设备、移动通信基站天线、直放站、干线放大器、移动交换机、移动软交换设备、移动通信核心网分组域设备",
                                        "taxName": "移动通信设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090504010000000000",
                                        "taxCodeTitle": "移动通信设备",
                                        "iTitle": "*移动通信设备*数字蜂窝移动电话系统设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3480",
                                        "linkid": "3478",
                                        "code": "109050402",
                                        "paCode": "1090504",
                                        "yn": "N",
                                        "title": "集群通信系统设备",
                                        "alias": "集群通信系统设备",
                                        "about": "包括集群基站设备、集群基站天线、集群交换设备",
                                        "kws": "集群基站设备、集群基站天线、集群交换设备",
                                        "taxName": "移动通信设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090504020000000000",
                                        "taxCodeTitle": "移动通信设备",
                                        "iTitle": "*移动通信设备*集群通信系统设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3481",
                                        "linkid": "3478",
                                        "code": "109050403",
                                        "paCode": "1090504",
                                        "yn": "N",
                                        "title": "无中心选址通信系统设备",
                                        "alias": "无中心选址通信系统设备",
                                        "about": null,
                                        "kws": "无中心选址通信系统设备",
                                        "taxName": "移动通信设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090504030000000000",
                                        "taxCodeTitle": "移动通信设备",
                                        "iTitle": "*移动通信设备*无中心选址通信系统设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3482",
                                        "linkid": "3478",
                                        "code": "109050404",
                                        "paCode": "1090504",
                                        "yn": "N",
                                        "title": "移动通信设备零件",
                                        "alias": "移动通信设备零件",
                                        "about": null,
                                        "kws": "移动通信设备零件",
                                        "taxName": "移动通信设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090504040000000000",
                                        "taxCodeTitle": "移动通信设备",
                                        "iTitle": "*移动通信设备*移动通信设备零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3483",
                                "linkid": "3458",
                                "code": "1090505",
                                "paCode": "10905",
                                "yn": "Y",
                                "title": "移动通信终端设备及零部件",
                                "alias": "移动通信终端设备及零部件",
                                "about": "包括移动通信手持机（手机）、移动通信终端设备零件、其他移动通信终端设备",
                                "kws": null,
                                "taxName": "移动通信设备",
                                "taxRate": "",
                                "vip": "3",
                                "itaxRate": null,
                                "taxCode": "1090505000000000000",
                                "taxCodeTitle": "移动通信设备",
                                "iTitle": "*移动通信设备*移动通信终端设备及零部件",
                                "children": [
                                    {
                                        "id": "3484",
                                        "linkid": "3483",
                                        "code": "109050501",
                                        "paCode": "1090505",
                                        "yn": "N",
                                        "title": "移动通信手持机（手机）",
                                        "alias": "移动通信手持机（手机）",
                                        "about": "车载终端、无线固定话机等终端按照技术标准对应到下列细目中，包括GSM手持机、CDMA手持机、3G手持机、SCDMA终端",
                                        "kws": "手机",
                                        "taxName": "移动通信设备",
                                        "taxRate": "13%",
                                        "vip": "1",
                                        "itaxRate": "0.13",
                                        "taxCode": "1090505010000000000",
                                        "taxCodeTitle": "移动通信设备",
                                        "iTitle": "*移动通信设备*移动通信手持机（手机）",
                                        "children": []
                                    },
                                    {
                                        "id": "3485",
                                        "linkid": "3483",
                                        "code": "109050502",
                                        "paCode": "1090505",
                                        "yn": "N",
                                        "title": "移动通信终端设备零件",
                                        "alias": "移动通信终端设备零件",
                                        "about": "包括移动通信手持机零件、对讲机零件、其他移动通信终端设备零件",
                                        "kws": "移动通信手持机零件、对讲机零件",
                                        "taxName": "移动通信设备",
                                        "taxRate": "13%",
                                        "vip": "5",
                                        "itaxRate": "0.13",
                                        "taxCode": "1090505020000000000",
                                        "taxCodeTitle": "移动通信设备",
                                        "iTitle": "*移动通信设备*移动通信终端设备零件",
                                        "children": []
                                    },
                                    {
                                        "id": "3486",
                                        "linkid": "3483",
                                        "code": "109050599",
                                        "paCode": "1090505",
                                        "yn": "N",
                                        "title": "其他移动通信终端设备",
                                        "alias": "其他移动通信终端设备",
                                        "about": "除移动通信手持机（手机）、移动通信终端设备零件外的其他移动通信终端设备，包括集群通信终端、对讲机、小灵通、其他未列明移动通信终端设备",
                                        "kws": "集群通信终端、对讲机、小灵通",
                                        "taxName": "移动通信设备",
                                        "taxRate": "13%",
                                        "vip": "3",
                                        "itaxRate": "0.13",
                                        "taxCode": "1090505990000000000",
                                        "taxCodeTitle": "移动通信设备",
                                        "iTitle": "*移动通信设备*其他移动通信终端设备",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3487",
                                "linkid": "3458",
                                "code": "1090506",
                                "paCode": "10905",
                                "yn": "Y",
                                "title": "通信接入设备",
                                "alias": "通信接入设备",
                                "about": "包括光纤接入设备、铜缆接入设备、电力线宽带接入设备（BPL）、固定无线接入设备",
                                "kws": null,
                                "taxName": "通信接入设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090506000000000000",
                                "taxCodeTitle": "通信接入设备",
                                "iTitle": "*通信接入设备*通信接入设备",
                                "children": [
                                    {
                                        "id": "3488",
                                        "linkid": "3487",
                                        "code": "109050601",
                                        "paCode": "1090506",
                                        "yn": "N",
                                        "title": "光纤接入设备",
                                        "alias": "光纤接入设备",
                                        "about": "指为满足高速宽带业务和双向宽带业务的需要，在服务器端与用户之间完全以光纤作为传输媒体，以光波传输技术为主要技术形势的接入设备。包括无源光网络（PON）、有源光网络（AON）",
                                        "kws": "无源光网络、有源光网络",
                                        "taxName": "通信接入设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090506010000000000",
                                        "taxCodeTitle": "通信接入设备",
                                        "iTitle": "*通信接入设备*光纤接入设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3489",
                                        "linkid": "3487",
                                        "code": "109050602",
                                        "paCode": "1090506",
                                        "yn": "N",
                                        "title": "铜缆接入设备",
                                        "alias": "铜缆接入设备",
                                        "about": "指以铜线为传输介质的宽带接入技术。包括非对称数字用户线（ADSL）、高速率数字用户线路调制解调器（HDSLMODEM）、甚高速率数字用户线（VDSL）",
                                        "kws": "ADSL接入复用器、ADSL调制解调器、高速率数字用户线路调制解调器、VDSL接入复用器、VDSL交换机、VDSL调制解调器、语音分离器、甚高速率POTS分离器",
                                        "taxName": "通信接入设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090506020000000000",
                                        "taxCodeTitle": "通信接入设备",
                                        "iTitle": "*通信接入设备*铜缆接入设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3490",
                                        "linkid": "3487",
                                        "code": "109050603",
                                        "paCode": "1090506",
                                        "yn": "N",
                                        "title": "电力线宽带接入设备（BPL）",
                                        "alias": "电力线宽带接入设备（BPL）",
                                        "about": "电力宽带接入技术就是以电力线作为传输介质实现宽带接入的技术，包括电力网桥、电力线调制解调器（电力猫）",
                                        "kws": "电力网桥、电力线调制解调器、电力猫",
                                        "taxName": "通信接入设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090506030000000000",
                                        "taxCodeTitle": "通信接入设备",
                                        "iTitle": "*通信接入设备*电力线宽带接入设备（BPL）",
                                        "children": []
                                    },
                                    {
                                        "id": "3491",
                                        "linkid": "3487",
                                        "code": "109050604",
                                        "paCode": "1090506",
                                        "yn": "N",
                                        "title": "固定无线接入设备",
                                        "alias": "固定无线接入设备",
                                        "about": "包括WiMAX设备、McWill设备、其他固定无线接入设备",
                                        "kws": "WiMAX设备、McWill设备",
                                        "taxName": "通信接入设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090506040000000000",
                                        "taxCodeTitle": "通信接入设备",
                                        "iTitle": "*通信接入设备*固定无线接入设备",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3492",
                                "linkid": "3458",
                                "code": "1090507",
                                "paCode": "10905",
                                "yn": "Y",
                                "title": "雷达、无线电导航及无线电遥控设备",
                                "alias": "雷达、无线电导航及无线电遥控设备",
                                "about": "包括雷达设备、无线电导航设备、无线电遥控设备、雷达及无线电导航设备零件",
                                "kws": null,
                                "taxName": "导航遥控设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090507000000000000",
                                "taxCodeTitle": "导航遥控设备",
                                "iTitle": "*导航遥控设备*雷达、无线电导航及无线电遥控设备",
                                "children": [
                                    {
                                        "id": "3493",
                                        "linkid": "3492",
                                        "code": "109050701",
                                        "paCode": "1090507",
                                        "yn": "N",
                                        "title": "雷达设备",
                                        "alias": "雷达设备",
                                        "about": "包括导航用雷达设备、盲降及交通控制设备、雷达测高设备、气象雷达、空袭警报雷达装置、盲目投弹设备、雷达发射-应答器、其他雷达设备",
                                        "kws": "导航用雷达设备、盲降控制设备、交通控制设备、雷达测高设备、气象雷达、空袭警报雷达装置、盲目投弹设备、雷达发射-应答器",
                                        "taxName": "导航遥控设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090507010000000000",
                                        "taxCodeTitle": "导航遥控设备",
                                        "iTitle": "*导航遥控设备*雷达设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3494",
                                        "linkid": "3492",
                                        "code": "109050702",
                                        "paCode": "1090507",
                                        "yn": "N",
                                        "title": "无线电导航设备",
                                        "alias": "无线电导航设备",
                                        "about": "包括机动车辆用无线电导航设备、无线电罗盘、无线电信标、无线电浮标、接收机、其他无线电导航设备",
                                        "kws": "机动车辆用无线电导航设备、无线电罗盘、无线电信标、无线电浮标、接收机",
                                        "taxName": "导航遥控设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090507020000000000",
                                        "taxCodeTitle": "导航遥控设备",
                                        "iTitle": "*导航遥控设备*无线电导航设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3495",
                                        "linkid": "3492",
                                        "code": "109050703",
                                        "paCode": "1090507",
                                        "yn": "N",
                                        "title": "无线电遥控设备",
                                        "alias": "无线电遥控设备",
                                        "about": "包括船舶无线电遥控设备、无人驾驶飞机无线电遥控设备、遥控火箭、导弹无线电遥控设备、玩具、模型遥控用无线电装置、地雷引爆遥控用无线电装置、机器遥控用无线电装置、其他无线电遥控设备",
                                        "kws": "无线电遥控设备、遥控用无线电装置",
                                        "taxName": "导航遥控设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090507030000000000",
                                        "taxCodeTitle": "导航遥控设备",
                                        "iTitle": "*导航遥控设备*无线电遥控设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3496",
                                        "linkid": "3492",
                                        "code": "109050704",
                                        "paCode": "1090507",
                                        "yn": "N",
                                        "title": "雷达及无线电导航设备零件",
                                        "alias": "雷达及无线电导航设备零件",
                                        "about": "包括雷达天线及其反射器及零件、其他雷达及无线电导航设备零件",
                                        "kws": "雷达天线零件、雷达反射器零件",
                                        "taxName": "导航遥控设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090507040000000000",
                                        "taxCodeTitle": "导航遥控设备",
                                        "iTitle": "*导航遥控设备*雷达及无线电导航设备零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3497",
                                "linkid": "3458",
                                "code": "1090508",
                                "paCode": "10905",
                                "yn": "Y",
                                "title": "广播电视设备",
                                "alias": "广播电视设备",
                                "about": "包括广播电视节目制作及播控设备、广播电视发射及传输设备、应用广播电视设备、广播电视设备专用配件、",
                                "kws": null,
                                "taxName": "广播电视设备",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090508000000000000",
                                "taxCodeTitle": "广播电视设备",
                                "iTitle": "*广播电视设备*广播电视设备",
                                "children": [
                                    {
                                        "id": "3498",
                                        "linkid": "3497",
                                        "code": "109050801",
                                        "paCode": "1090508",
                                        "yn": "N",
                                        "title": "广播电视节目制作及播控设备",
                                        "alias": "广播电视节目制作及播控设备",
                                        "about": "包括音频节目制作和播控设备、视听节目制作及播控设备、电视转播车及现场新闻采集车",
                                        "kws": "广播专用录音、广播专用放音设备、调音台、音质加工与信号处理设备、监听机、广播电视专业录像机、广播电视专业摄像机、视频切换台、视频矩阵、非线性编辑设备、虚拟演播室设备、信号源设备、视频信号处理设备、电视信号同步设备、电视转播车、现场新闻采集车",
                                        "taxName": "广播电视设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090508010000000000",
                                        "taxCodeTitle": "广播电视设备",
                                        "iTitle": "*广播电视设备*广播电视节目制作及播控设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3499",
                                        "linkid": "3497",
                                        "code": "109050802",
                                        "paCode": "1090508",
                                        "yn": "N",
                                        "title": "广播电视发射及传输设备",
                                        "alias": "广播电视发射及传输设备",
                                        "about": "包括广播发射设备、电视发射设备、卫星电视设备、广播电视微波传输设备、有线电视网络设备",
                                        "kws": "广播发射设备、电视发射设备、卫星电视设备、广播电视微波传输设备、有线电视网络设备",
                                        "taxName": "广播电视设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090508020000000000",
                                        "taxCodeTitle": "广播电视设备",
                                        "iTitle": "*广播电视设备*广播电视发射及传输设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3500",
                                        "linkid": "3497",
                                        "code": "109050803",
                                        "paCode": "1090508",
                                        "yn": "N",
                                        "title": "应用广播电视设备",
                                        "alias": "应用广播电视设备",
                                        "about": "包括通用应用电视监控系统设备、特殊环境应用电视设备、特殊成像及功能应用电视设备、其他应用广播电视设备",
                                        "kws": "通用应用电视监控系统设备、特殊环境应用电视设备、特殊成像应用电视设备、特殊功能应用电视设备",
                                        "taxName": "广播电视设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090508030000000000",
                                        "taxCodeTitle": "广播电视设备",
                                        "iTitle": "*广播电视设备*应用广播电视设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3501",
                                        "linkid": "3497",
                                        "code": "109050804",
                                        "paCode": "1090508",
                                        "yn": "N",
                                        "title": "广播电视设备专用配件",
                                        "alias": "广播电视设备专用配件",
                                        "about": "包括激励器、中频调制器、双工器、输出滤波器、天线开关、发射天线、其他广播电视设备专用配件",
                                        "kws": "激励器、中频调制器、双工器、输出滤波器、天线开关、发射天线",
                                        "taxName": "广播电视设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090508040000000000",
                                        "taxCodeTitle": "广播电视设备",
                                        "iTitle": "*广播电视设备*广播电视设备专用配件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3502",
                                "linkid": "3458",
                                "code": "1090509",
                                "paCode": "10905",
                                "yn": "Y",
                                "title": "电子计算机及其部件",
                                "alias": "电子计算机及其部件",
                                "about": "包括电子计算机整机、计算机数字式处理部件",
                                "kws": null,
                                "taxName": "电子计算机",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1090509000000000000",
                                "taxCodeTitle": "电子计算机",
                                "iTitle": "*电子计算机*电子计算机及其部件",
                                "children": [
                                    {
                                        "id": "3503",
                                        "linkid": "3502",
                                        "code": "109050901",
                                        "paCode": "1090509",
                                        "yn": "N",
                                        "title": "电子计算机整机",
                                        "alias": "电子计算机整机",
                                        "about": "指数字式自动数据处理设备，含模拟式或混合式自动数据处理设备，包括计算机工作站、微型计算机设备、服务器、系统形式自动数据处理设备",
                                        "kws": "计算机工作站、微型计算机设备、服务器、系统形式自动数据处理设备",
                                        "taxName": "电子计算机",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090509010000000000",
                                        "taxCodeTitle": "电子计算机",
                                        "iTitle": "*电子计算机*电子计算机整机",
                                        "children": []
                                    },
                                    {
                                        "id": "3504",
                                        "linkid": "3502",
                                        "code": "109050902",
                                        "paCode": "1090509",
                                        "yn": "N",
                                        "title": "计算机数字式处理部件",
                                        "alias": "计算机数字式处理部件",
                                        "about": "包括高性能计算机数字式处理部件、微型计算机数字式处理部件、服务器数字式处理部件、笔记本计算机数字式处理部件、工业控制计算机处理部件、工业控制计算机输入输出部件、其他计算机数字式处理部件",
                                        "kws": "电脑、台式机、高性能计算机数字式处理部件、微型计算机数字式处理部件、服务器数字式处理部件、笔记本计算机数字式处理部件、工业控制计算机处理部件、工业控制计算机输入输出部件",
                                        "taxName": "电子计算机",
                                        "taxRate": "13%",
                                        "vip": "3",
                                        "itaxRate": "0.13",
                                        "taxCode": "1090509020000000000",
                                        "taxCodeTitle": "电子计算机",
                                        "iTitle": "*电子计算机*计算机数字式处理部件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3505",
                                "linkid": "3458",
                                "code": "1090510",
                                "paCode": "10905",
                                "yn": "Y",
                                "title": "计算机网络设备",
                                "alias": "计算机网络设备",
                                "about": "包括网络控制设备、网络接口和适配器、网络连接设备、网络优化设备、网络检测设备、其他计算机网络设备、其他计算机数字式处理部件",
                                "kws": null,
                                "taxName": "计算机网络设备",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1090510000000000000",
                                "taxCodeTitle": "计算机网络设备",
                                "iTitle": "*计算机网络设备*计算机网络设备",
                                "children": [
                                    {
                                        "id": "3506",
                                        "linkid": "3505",
                                        "code": "109051001",
                                        "paCode": "1090510",
                                        "yn": "N",
                                        "title": "网络控制设备",
                                        "alias": "网络控制设备",
                                        "about": "包括通信控制处理机、集中器、网络终端控制器、其他网络控制设备",
                                        "kws": "通信控制处理机、集中器、网络终端控制器",
                                        "taxName": "计算机网络设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090510010000000000",
                                        "taxCodeTitle": "计算机网络设备",
                                        "iTitle": "*计算机网络设备*网络控制设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3507",
                                        "linkid": "3505",
                                        "code": "109051002",
                                        "paCode": "1090510",
                                        "yn": "N",
                                        "title": "网络接口和适配器",
                                        "alias": "网络接口和适配器",
                                        "about": "包括网络收发器、网络转发器、网络分配器、通信网络时钟同步设备、其他网络接口和适配器",
                                        "kws": "网络收发器、网络转发器、网络分配器、通信网络时钟同步设备",
                                        "taxName": "计算机网络设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090510020000000000",
                                        "taxCodeTitle": "计算机网络设备",
                                        "iTitle": "*计算机网络设备*网络接口和适配器",
                                        "children": []
                                    },
                                    {
                                        "id": "3508",
                                        "linkid": "3505",
                                        "code": "109051003",
                                        "paCode": "1090510",
                                        "yn": "N",
                                        "title": "网络连接设备",
                                        "alias": "网络连接设备",
                                        "about": "包括集线器、路由器、数字数据网络节点设备、数字交叉连接设备、交换机、无线局域网接入点（AP）、其他网络连接设备",
                                        "kws": "集线器、路由器、数字数据网络节点设备、数字交叉连接设备、交换机、无线局域网接入点",
                                        "taxName": "计算机网络设备",
                                        "taxRate": "13%",
                                        "vip": "3",
                                        "itaxRate": "0.13",
                                        "taxCode": "1090510030000000000",
                                        "taxCodeTitle": "计算机网络设备",
                                        "iTitle": "*计算机网络设备*网络连接设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3509",
                                        "linkid": "3505",
                                        "code": "109051004",
                                        "paCode": "1090510",
                                        "yn": "N",
                                        "title": "网络优化设备",
                                        "alias": "网络优化设备",
                                        "about": "包括负载均衡器、流量控制器、其他网络优化设备",
                                        "kws": "负载均衡器、流量控制器",
                                        "taxName": "计算机网络设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090510040000000000",
                                        "taxCodeTitle": "计算机网络设备",
                                        "iTitle": "*计算机网络设备*网络优化设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3510",
                                        "linkid": "3505",
                                        "code": "109051005",
                                        "paCode": "1090510",
                                        "yn": "N",
                                        "title": "网络检测设备",
                                        "alias": "网络检测设备",
                                        "about": "包括协议分析器、协议测试设备、差错检测设备、其他网络检测设备",
                                        "kws": "协议分析器、协议测试设备、差错检测设备",
                                        "taxName": "计算机网络设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090510050000000000",
                                        "taxCodeTitle": "计算机网络设备",
                                        "iTitle": "*计算机网络设备*网络检测设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3511",
                                        "linkid": "3505",
                                        "code": "109051099",
                                        "paCode": "1090510",
                                        "yn": "N",
                                        "title": "其他计算机网络设备",
                                        "alias": "其他计算机网络设备",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "计算机网络设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090510990000000000",
                                        "taxCodeTitle": "计算机网络设备",
                                        "iTitle": "*计算机网络设备*其他计算机网络设备",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3512",
                                "linkid": "3458",
                                "code": "1090511",
                                "paCode": "10905",
                                "yn": "Y",
                                "title": "电子计算机外部设备及装置",
                                "alias": "电子计算机外部设备及装置",
                                "about": "包括终端显示设备、输入设备及装置、输出设备及装置、外存储设备及部件、阅读机、数据转录及处理机械",
                                "kws": null,
                                "taxName": "计算机外部设备",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1090511000000000000",
                                "taxCodeTitle": "计算机外部设备",
                                "iTitle": "*计算机外部设备*电子计算机外部设备及装置",
                                "children": [
                                    {
                                        "id": "3513",
                                        "linkid": "3512",
                                        "code": "109051101",
                                        "paCode": "1090511",
                                        "yn": "N",
                                        "title": "终端显示设备",
                                        "alias": "终端显示设备",
                                        "about": "包括字符汉字终端、图形图像终端、显示器",
                                        "kws": "字符汉字终端、图形图像终端、显示器",
                                        "taxName": "计算机外部设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090511010000000000",
                                        "taxCodeTitle": "计算机外部设备",
                                        "iTitle": "*计算机外部设备*终端显示设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3514",
                                        "linkid": "3512",
                                        "code": "109051102",
                                        "paCode": "1090511",
                                        "yn": "N",
                                        "title": "输入设备及装置",
                                        "alias": "输入设备及装置",
                                        "about": "包括绘图仪、人机交互式设备、扫描仪、IC卡读写机具、磁卡读写器、摄像头、图形板、触感屏、字符阅读机、射频卡读写机具、手写板、生物特征识别设备、其他输入设备及装置",
                                        "kws": "绘图仪、人机交互式设备、扫描仪、IC卡读写机具、磁卡读写器、摄像头、图形板、触感屏、字符阅读机、射频卡读写机具、手写板、生物特征识别设备",
                                        "taxName": "计算机外部设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090511020000000000",
                                        "taxCodeTitle": "计算机外部设备",
                                        "iTitle": "*计算机外部设备*输入设备及装置",
                                        "children": []
                                    },
                                    {
                                        "id": "3515",
                                        "linkid": "3512",
                                        "code": "109051103",
                                        "paCode": "1090511",
                                        "yn": "N",
                                        "title": "输出设备及装置",
                                        "alias": "输出设备及装置",
                                        "about": "包括打印机、语音输出设备、图形图像输出设备、其他输出设备及装置",
                                        "kws": "打印机、语音输出设备、图形图像输出设备",
                                        "taxName": "计算机外部设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090511030000000000",
                                        "taxCodeTitle": "计算机外部设备",
                                        "iTitle": "*计算机外部设备*输出设备及装置",
                                        "children": []
                                    },
                                    {
                                        "id": "3516",
                                        "linkid": "3512",
                                        "code": "109051104",
                                        "paCode": "1090511",
                                        "yn": "N",
                                        "title": "外存储设备及部件",
                                        "alias": "外存储设备及部件",
                                        "about": "包括软盘存储器、硬盘存储器、光盘存储器、半导体存储器、网络存储设备、磁性存储设备、其他外存储设备及部件",
                                        "kws": "软盘存储器、硬盘存储器、光盘存储器、半导体存储器、网络存储设备、磁性存储设备",
                                        "taxName": "计算机外部设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090511040000000000",
                                        "taxCodeTitle": "计算机外部设备",
                                        "iTitle": "*计算机外部设备*外存储设备及部件",
                                        "children": []
                                    },
                                    {
                                        "id": "3517",
                                        "linkid": "3512",
                                        "code": "109051105",
                                        "paCode": "1090511",
                                        "yn": "N",
                                        "title": "阅读机、数据转录及处理机械",
                                        "alias": "阅读机、数据转录及处理机械",
                                        "about": "包括磁性阅读机、光学阅读机、数据转录媒体机械、数据处理机械、其他阅读机",
                                        "kws": "磁性阅读机、光学阅读机、数据转录媒体机械、数据处理机械",
                                        "taxName": "计算机外部设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090511050000000000",
                                        "taxCodeTitle": "计算机外部设备",
                                        "iTitle": "*计算机外部设备*阅读机、数据转录及处理机械",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3518",
                                "linkid": "3458",
                                "code": "1090512",
                                "paCode": "10905",
                                "yn": "Y",
                                "title": "电子计算机配套产品及耗材",
                                "alias": "电子计算机配套产品及耗材",
                                "about": "包括微机板卡、计算机电源、其他电子计算机配套产品及耗材",
                                "kws": null,
                                "taxName": "计算机配套产品",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1090512000000000000",
                                "taxCodeTitle": "计算机配套产品",
                                "iTitle": "*计算机配套产品*电子计算机配套产品及耗材",
                                "children": [
                                    {
                                        "id": "3519",
                                        "linkid": "3518",
                                        "code": "109051201",
                                        "paCode": "1090512",
                                        "yn": "N",
                                        "title": "微机板卡",
                                        "alias": "微机板卡",
                                        "about": "包括微机主机板、内存条、声卡、显卡、网卡、其他微机板卡",
                                        "kws": "微机主机板、内存条、声卡、显卡、网卡",
                                        "taxName": "计算机配套产品",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090512010000000000",
                                        "taxCodeTitle": "计算机配套产品",
                                        "iTitle": "*计算机配套产品*微机板卡",
                                        "children": []
                                    },
                                    {
                                        "id": "3520",
                                        "linkid": "3518",
                                        "code": "109051202",
                                        "paCode": "1090512",
                                        "yn": "N",
                                        "title": "计算机电源",
                                        "alias": "计算机电源",
                                        "about": "指计算机专用电源，包括开关电源、UPS电源",
                                        "kws": "开关电源、UPS电源",
                                        "taxName": "计算机配套产品",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090512020000000000",
                                        "taxCodeTitle": "计算机配套产品",
                                        "iTitle": "*计算机配套产品*计算机电源",
                                        "children": []
                                    },
                                    {
                                        "id": "3521",
                                        "linkid": "3518",
                                        "code": "109051299",
                                        "paCode": "1090512",
                                        "yn": "N",
                                        "title": "其他电子计算机配套产品及耗材",
                                        "alias": "其他电子计算机配套产品及耗材",
                                        "about": "除外微机板卡、计算机电源的其他电子计算机配套产品及耗材，包括机箱、鼠标器、键盘、打印头、墨盒、磁卡、IC卡、色带、硒鼓、其他未列明电子计算机配套产品及耗材",
                                        "kws": "机箱、鼠标器、键盘、打印头、墨盒、磁卡、IC卡、色带、硒鼓",
                                        "taxName": "计算机配套产品",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090512990000000000",
                                        "taxCodeTitle": "计算机配套产品",
                                        "iTitle": "*计算机配套产品*其他电子计算机配套产品及耗材",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3522",
                                "linkid": "3458",
                                "code": "1090513",
                                "paCode": "10905",
                                "yn": "Y",
                                "title": "信息系统安全产品",
                                "alias": "信息系统安全产品",
                                "about": "包括访问控制类设备、边界防护类设备、数据保护类设备、安全检测类设备、安全智能卡类设备、密钥管理类设备、其他信息系统安全设备",
                                "kws": null,
                                "taxName": "信息安全产品",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1090513000000000000",
                                "taxCodeTitle": "信息安全产品",
                                "iTitle": "*信息安全产品*信息系统安全产品",
                                "children": [
                                    {
                                        "id": "3523",
                                        "linkid": "3522",
                                        "code": "109051301",
                                        "paCode": "1090513",
                                        "yn": "N",
                                        "title": "访问控制类设备",
                                        "alias": "访问控制类设备",
                                        "about": "包括单点登录系统、接入服务器、权限管理基础设施、其他访问控制类设备和系统",
                                        "kws": "单点登录系统、接入服务器、权限管理基础设施",
                                        "taxName": "信息安全产品",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090513010000000000",
                                        "taxCodeTitle": "信息安全产品",
                                        "iTitle": "*信息安全产品*访问控制类设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3524",
                                        "linkid": "3522",
                                        "code": "109051302",
                                        "paCode": "1090513",
                                        "yn": "N",
                                        "title": "边界防护类设备",
                                        "alias": "边界防护类设备",
                                        "about": "包括防火墙、防水墙、虚拟专用网设备（VPN）、抗拒绝服务（Dos）攻击系统、网络隔离设备、其他边界防护类设备和系统",
                                        "kws": "防火墙、防水墙、虚拟专用网设备、抗拒绝服务攻击系统、网络隔离设备",
                                        "taxName": "信息安全产品",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090513020000000000",
                                        "taxCodeTitle": "信息安全产品",
                                        "iTitle": "*信息安全产品*边界防护类设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3525",
                                        "linkid": "3522",
                                        "code": "109051303",
                                        "paCode": "1090513",
                                        "yn": "N",
                                        "title": "数据保护类设备",
                                        "alias": "数据保护类设备",
                                        "about": "包括防病毒系统、恶意代码检测系统、数据备份与恢复系统、数据防拷贝设备、其他数据保护类设备和系统",
                                        "kws": "防病毒系统、恶意代码检测系统、数据备份与恢复系统、数据防拷贝设备",
                                        "taxName": "信息安全产品",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090513030000000000",
                                        "taxCodeTitle": "信息安全产品",
                                        "iTitle": "*信息安全产品*数据保护类设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3526",
                                        "linkid": "3522",
                                        "code": "109051304",
                                        "paCode": "1090513",
                                        "yn": "N",
                                        "title": "安全检测类设备",
                                        "alias": "安全检测类设备",
                                        "about": "包括入侵检测系统、入侵防御系统、安全扫描器、安全审计系统、其他安全检测类设备和系统",
                                        "kws": "入侵检测系统、入侵防御系统、安全扫描器、安全审计系统",
                                        "taxName": "信息安全产品",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090513040000000000",
                                        "taxCodeTitle": "信息安全产品",
                                        "iTitle": "*信息安全产品*安全检测类设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3527",
                                        "linkid": "3522",
                                        "code": "109051305",
                                        "paCode": "1090513",
                                        "yn": "N",
                                        "title": "安全智能卡类设备",
                                        "alias": "安全智能卡类设备",
                                        "about": null,
                                        "kws": "安全智能卡类设备",
                                        "taxName": "信息安全产品",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090513050000000000",
                                        "taxCodeTitle": "信息安全产品",
                                        "iTitle": "*信息安全产品*安全智能卡类设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3528",
                                        "linkid": "3522",
                                        "code": "109051306",
                                        "paCode": "1090513",
                                        "yn": "N",
                                        "title": "密钥管理类设备",
                                        "alias": "密钥管理类设备",
                                        "about": null,
                                        "kws": "密钥管理类设备",
                                        "taxName": "信息安全产品",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090513060000000000",
                                        "taxCodeTitle": "信息安全产品",
                                        "iTitle": "*信息安全产品*密钥管理类设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3529",
                                        "linkid": "3522",
                                        "code": "109051307",
                                        "paCode": "1090513",
                                        "yn": "N",
                                        "title": "税控设备",
                                        "alias": "税控设备",
                                        "about": "包括金税盘、税控盘，不包括税控加油机（详见10906260101）、税控收款机（详见10906260102）",
                                        "kws": "#金税盘、税控盘",
                                        "taxName": "信息安全产品",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090513070000000000",
                                        "taxCodeTitle": "信息安全产品",
                                        "iTitle": "*信息安全产品*税控设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3530",
                                        "linkid": "3522",
                                        "code": "109051399",
                                        "paCode": "1090513",
                                        "yn": "N",
                                        "title": "其他信息系统安全设备",
                                        "alias": "其他信息系统安全设备",
                                        "about": "除访问控制类设备、边界防护类设备、数据保护类设备、安全检测类设备、安全智能卡类设备、密钥管理类设备外的其他信息系统安全设备",
                                        "kws": null,
                                        "taxName": "信息安全产品",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090513990000000000",
                                        "taxCodeTitle": "信息安全产品",
                                        "iTitle": "*信息安全产品*其他信息系统安全设备",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3531",
                                "linkid": "3458",
                                "code": "1090514",
                                "paCode": "10905",
                                "yn": "Y",
                                "title": "真空电子器件及零件",
                                "alias": "真空电子器件及零件",
                                "about": "包括电子管、电子束管、射线计数管、真空开关管、真空电子器件零件、其他真空电子器件",
                                "kws": null,
                                "taxName": "真空电子器件",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090514000000000000",
                                "taxCodeTitle": "真空电子器件",
                                "iTitle": "*真空电子器件*真空电子器件及零件",
                                "children": [
                                    {
                                        "id": "3532",
                                        "linkid": "3531",
                                        "code": "109051401",
                                        "paCode": "1090514",
                                        "yn": "N",
                                        "title": "电子管",
                                        "alias": "电子管",
                                        "about": "包括收讯放大管、微波管、发射管、稳定管、离子管",
                                        "kws": "收讯放大管、微波管、发射管、稳定管、离子管",
                                        "taxName": "真空电子器件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090514010000000000",
                                        "taxCodeTitle": "真空电子器件",
                                        "iTitle": "*真空电子器件*电子管",
                                        "children": []
                                    },
                                    {
                                        "id": "3533",
                                        "linkid": "3531",
                                        "code": "109051402",
                                        "paCode": "1090514",
                                        "yn": "N",
                                        "title": "电子束管",
                                        "alias": "电子束管",
                                        "about": "包括显像管、显示管、投影管、监视管、示波管、储存管、脉冲形成管、飞点扫描管、其他电子束管",
                                        "kws": "显像管、显示管、投影管、监视管、示波管、储存管、脉冲形成管、飞点扫描管",
                                        "taxName": "真空电子器件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090514020000000000",
                                        "taxCodeTitle": "真空电子器件",
                                        "iTitle": "*真空电子器件*电子束管",
                                        "children": []
                                    },
                                    {
                                        "id": "3534",
                                        "linkid": "3531",
                                        "code": "109051403",
                                        "paCode": "1090514",
                                        "yn": "N",
                                        "title": "射线计数管",
                                        "alias": "射线计数管",
                                        "about": null,
                                        "kws": "射线计数管",
                                        "taxName": "真空电子器件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090514030000000000",
                                        "taxCodeTitle": "真空电子器件",
                                        "iTitle": "*真空电子器件*射线计数管",
                                        "children": []
                                    },
                                    {
                                        "id": "3535",
                                        "linkid": "3531",
                                        "code": "109051404",
                                        "paCode": "1090514",
                                        "yn": "N",
                                        "title": "真空开关管",
                                        "alias": "真空开关管",
                                        "about": "包括高、中压真空开关管（3～36kV），低压真空开关管（3kV以下），其他真空开关管",
                                        "kws": "高压真空开关管、中压真空开关管、低压真空开关管",
                                        "taxName": "真空电子器件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090514040000000000",
                                        "taxCodeTitle": "真空电子器件",
                                        "iTitle": "*真空电子器件*真空开关管",
                                        "children": []
                                    },
                                    {
                                        "id": "3536",
                                        "linkid": "3531",
                                        "code": "109051405",
                                        "paCode": "1090514",
                                        "yn": "N",
                                        "title": "真空电子器件零件",
                                        "alias": "真空电子器件零件",
                                        "about": "包括显像管配件、电子管零件、其他真空电子器件零件",
                                        "kws": "显像管配件、电子管零件",
                                        "taxName": "真空电子器件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090514050000000000",
                                        "taxCodeTitle": "真空电子器件",
                                        "iTitle": "*真空电子器件*真空电子器件零件",
                                        "children": []
                                    },
                                    {
                                        "id": "3537",
                                        "linkid": "3531",
                                        "code": "109051499",
                                        "paCode": "1090514",
                                        "yn": "N",
                                        "title": "其他真空电子器件",
                                        "alias": "其他真空电子器件",
                                        "about": "包括真空荧光显示器件（VFD）、真空规管、频标管、其他未列明真空电子器件",
                                        "kws": "真空荧光显示器件、真空规管、频标管",
                                        "taxName": "真空电子器件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090514990000000000",
                                        "taxCodeTitle": "真空电子器件",
                                        "iTitle": "*真空电子器件*其他真空电子器件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3538",
                                "linkid": "3458",
                                "code": "1090515",
                                "paCode": "10905",
                                "yn": "Y",
                                "title": "半导体分立器件",
                                "alias": "半导体分立器件",
                                "about": "包括半导体二极管、半导体三极管、小信号晶体管、功率晶体管、半导体敏感器件、其他半导体分立器件",
                                "kws": null,
                                "taxName": "半导体",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090515000000000000",
                                "taxCodeTitle": "半导体",
                                "iTitle": "*半导体*半导体分立器件",
                                "children": [
                                    {
                                        "id": "3539",
                                        "linkid": "3538",
                                        "code": "109051501",
                                        "paCode": "1090515",
                                        "yn": "N",
                                        "title": "半导体二极管",
                                        "alias": "半导体二极管",
                                        "about": "包括小信号二极管、稳压、整流、开关二极管、过电过压保护二极管、微波二极管、其他半导体二极管。不包括光电器件(详见1090516)",
                                        "kws": "小信号二极管、稳压、整流、开关二极管、过电过压保护二极管、微波二极管",
                                        "taxName": "半导体",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090515010000000000",
                                        "taxCodeTitle": "半导体",
                                        "iTitle": "*半导体*半导体二极管",
                                        "children": []
                                    },
                                    {
                                        "id": "3540",
                                        "linkid": "3538",
                                        "code": "109051502",
                                        "paCode": "1090515",
                                        "yn": "N",
                                        "title": "半导体三极管",
                                        "alias": "半导体三极管",
                                        "about": null,
                                        "kws": "半导体三极管",
                                        "taxName": "半导体",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090515020000000000",
                                        "taxCodeTitle": "半导体",
                                        "iTitle": "*半导体*半导体三极管",
                                        "children": []
                                    },
                                    {
                                        "id": "3541",
                                        "linkid": "3538",
                                        "code": "109051503",
                                        "paCode": "1090515",
                                        "yn": "N",
                                        "title": "小信号晶体管",
                                        "alias": "小信号晶体管",
                                        "about": "包括双极晶体管、场效应晶体管、微波晶体管",
                                        "kws": "双极晶体管、场效应晶体管、微波晶体管",
                                        "taxName": "半导体",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090515030000000000",
                                        "taxCodeTitle": "半导体",
                                        "iTitle": "*半导体*小信号晶体管",
                                        "children": []
                                    },
                                    {
                                        "id": "3542",
                                        "linkid": "3538",
                                        "code": "109051504",
                                        "paCode": "1090515",
                                        "yn": "N",
                                        "title": "功率晶体管",
                                        "alias": "功率晶体管",
                                        "about": "包括双极功率晶体管、双极功率晶体管模块、场效应功率晶体管、场效应功率晶体管模块、微波功率晶体管、微波功率晶体管模块、绝缘栅双极晶体管、绝缘栅双极晶体管模块、晶闸管（5A以下）",
                                        "kws": "双极功率晶体管、双极功率晶体管模块、场效应功率晶体管、场效应功率晶体管模块、微波功率晶体管、微波功率晶体管模块、绝缘栅双极晶体管、绝缘栅双极晶体管模块、晶闸管",
                                        "taxName": "半导体",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090515040000000000",
                                        "taxCodeTitle": "半导体",
                                        "iTitle": "*半导体*功率晶体管",
                                        "children": []
                                    },
                                    {
                                        "id": "3543",
                                        "linkid": "3538",
                                        "code": "109051505",
                                        "paCode": "1090515",
                                        "yn": "N",
                                        "title": "半导体敏感器件",
                                        "alias": "半导体敏感器件",
                                        "about": "包括压力敏感器件、磁敏器件、气敏器件、湿敏器件、离子敏感器件、声敏感器件、射线敏感器件、生物敏感器件、静电敏感器件、光敏感器件、热敏感器件、其他半导体敏感器件",
                                        "kws": "压力敏感器件、磁敏器件、气敏器件、湿敏器件、离子敏感器件、声敏感器件、射线敏感器件、生物敏感器件、静电敏感器件、光敏感器件、热敏感器件",
                                        "taxName": "半导体",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090515050000000000",
                                        "taxCodeTitle": "半导体",
                                        "iTitle": "*半导体*半导体敏感器件",
                                        "children": []
                                    },
                                    {
                                        "id": "3544",
                                        "linkid": "3538",
                                        "code": "109051599",
                                        "paCode": "1090515",
                                        "yn": "N",
                                        "title": "其他半导体分立器件",
                                        "alias": "其他半导体分立器件",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "半导体",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090515990000000000",
                                        "taxCodeTitle": "半导体",
                                        "iTitle": "*半导体*其他半导体分立器件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3545",
                                "linkid": "3458",
                                "code": "1090516",
                                "paCode": "10905",
                                "yn": "Y",
                                "title": "光电子器件及激光器件",
                                "alias": "光电子器件及激光器件",
                                "about": "包括电子束光电器件、电真空光电子器件、半导体光电器件、激光器件",
                                "kws": null,
                                "taxName": "光电子器件",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090516000000000000",
                                "taxCodeTitle": "光电子器件",
                                "iTitle": "*光电子器件*光电子器件及激光器件",
                                "children": [
                                    {
                                        "id": "3546",
                                        "linkid": "3545",
                                        "code": "109051601",
                                        "paCode": "1090516",
                                        "yn": "N",
                                        "title": "电子束光电器件",
                                        "alias": "电子束光电器件",
                                        "about": "包括光电倍增管、X射线图像增强管、摄像管、光电图像器件、其他电子束光电器件",
                                        "kws": "光电倍增管、X射线图像增强管、摄像管、光电图像器件",
                                        "taxName": "光电子器件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090516010000000000",
                                        "taxCodeTitle": "光电子器件",
                                        "iTitle": "*光电子器件*电子束光电器件",
                                        "children": []
                                    },
                                    {
                                        "id": "3547",
                                        "linkid": "3545",
                                        "code": "109051602",
                                        "paCode": "1090516",
                                        "yn": "N",
                                        "title": "电真空光电子器件",
                                        "alias": "电真空光电子器件",
                                        "about": "包括显示器件、发光器件、光敏器件、光电耦合器件、红外器件、X射线（光）管、其他电真空光电子器件",
                                        "kws": "显示器件、发光器件、光敏器件、光电耦合器件、红外器件、X射线管",
                                        "taxName": "光电子器件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090516020000000000",
                                        "taxCodeTitle": "光电子器件",
                                        "iTitle": "*光电子器件*电真空光电子器件",
                                        "children": []
                                    },
                                    {
                                        "id": "3548",
                                        "linkid": "3545",
                                        "code": "109051603",
                                        "paCode": "1090516",
                                        "yn": "N",
                                        "title": "半导体光电器件",
                                        "alias": "半导体光电器件",
                                        "about": "包括光电探测器件、发光二极管（LED管）、其他半导体光电器件",
                                        "kws": "光电探测器件、发光二极管",
                                        "taxName": "光电子器件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090516030000000000",
                                        "taxCodeTitle": "光电子器件",
                                        "iTitle": "*光电子器件*半导体光电器件",
                                        "children": []
                                    },
                                    {
                                        "id": "3549",
                                        "linkid": "3545",
                                        "code": "109051604",
                                        "paCode": "1090516",
                                        "yn": "N",
                                        "title": "激光器件",
                                        "alias": "激光器件",
                                        "about": "包括半导体激光器件、固体激光器件、气体激光器件、其他激光器件",
                                        "kws": "半导体激光器件、固体激光器件、气体激光器件",
                                        "taxName": "光电子器件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090516040000000000",
                                        "taxCodeTitle": "光电子器件",
                                        "iTitle": "*光电子器件*激光器件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3550",
                                "linkid": "3458",
                                "code": "1090517",
                                "paCode": "10905",
                                "yn": "N",
                                "title": "集成电路",
                                "alias": "集成电路",
                                "about": "一种微型电子器件或部件，包括集成电路圆片、集成电路封装系列、集成电路成品",
                                "kws": "集成电路圆片、集成电路封装系列、集成电路成品",
                                "taxName": "集成电路",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1090517000000000000",
                                "taxCodeTitle": "集成电路",
                                "iTitle": "*集成电路*集成电路",
                                "children": []
                            },
                            {
                                "id": "3551",
                                "linkid": "3458",
                                "code": "1090518",
                                "paCode": "10905",
                                "yn": "N",
                                "title": "微电子组件",
                                "alias": "微电子组件",
                                "about": "包括集成电路模块、多芯片封装组件（MCM）、其他微电子组件",
                                "kws": "集成电路模块、多芯片封装组件",
                                "taxName": "微电子组件",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1090518000000000000",
                                "taxCodeTitle": "微电子组件",
                                "iTitle": "*微电子组件*微电子组件",
                                "children": []
                            },
                            {
                                "id": "3552",
                                "linkid": "3458",
                                "code": "1090519",
                                "paCode": "10905",
                                "yn": "Y",
                                "title": "电子元件",
                                "alias": "电子元件",
                                "about": "包括电容器、电阻器及电阻网络、电位器、频率控制元器件、磁性材料元件、电声器件、射频元器件、电子元件、组件零件、其他电子元件",
                                "kws": "电容器、电阻器、电阻网络、电位器、频率控制元器件、磁性材料元件、电声器件、射频元器件、电子元件、组件零件",
                                "taxName": "电子元件",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1090519000000000000",
                                "taxCodeTitle": "电子元件",
                                "iTitle": "*电子元件*电子元件",
                                "children": [
                                    {
                                        "id": "3553",
                                        "linkid": "3552",
                                        "code": "109051901",
                                        "paCode": "1090519",
                                        "yn": "N",
                                        "title": "电容器",
                                        "alias": "电容器",
                                        "about": "由两块金属电极之间夹一层绝缘电介质构成。包括电解电容器、瓷介电容器、纸介质电容器、塑料介质电容器、云母电容器、玻璃釉电容器、真空电容器、可变电容器、电容网络、其他电容器",
                                        "kws": "电容器、电容网络",
                                        "taxName": "电子元件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090519010000000000",
                                        "taxCodeTitle": "电子元件",
                                        "iTitle": "*电子元件*电容器",
                                        "children": []
                                    },
                                    {
                                        "id": "3554",
                                        "linkid": "3552",
                                        "code": "109051902",
                                        "paCode": "1090519",
                                        "yn": "N",
                                        "title": "电阻器及电阻网络",
                                        "alias": "电阻器及电阻网络",
                                        "about": "包括电阻器、电阻网络",
                                        "kws": "电阻器、电阻网络",
                                        "taxName": "电子元件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090519020000000000",
                                        "taxCodeTitle": "电子元件",
                                        "iTitle": "*电子元件*电阻器及电阻网络",
                                        "children": []
                                    },
                                    {
                                        "id": "3555",
                                        "linkid": "3552",
                                        "code": "109051903",
                                        "paCode": "1090519",
                                        "yn": "N",
                                        "title": "电位器",
                                        "alias": "电位器",
                                        "about": "是可变电阻器的一种，通常由电阻体与转动或滑动系统组成。包括线绕电位器、碳膜电位器、实芯电位器、玻璃釉电位器、导电塑料电位器、片式电位器、其他电位器",
                                        "kws": "电位器",
                                        "taxName": "电子元件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090519030000000000",
                                        "taxCodeTitle": "电子元件",
                                        "iTitle": "*电子元件*电位器",
                                        "children": []
                                    },
                                    {
                                        "id": "3556",
                                        "linkid": "3552",
                                        "code": "109051904",
                                        "paCode": "1090519",
                                        "yn": "N",
                                        "title": "频率控制元器件",
                                        "alias": "频率控制元器件",
                                        "about": "包括压电陶瓷及频率元件、压电石英晶体元器件",
                                        "kws": "压电陶瓷滤波器、压电陶磁谐振器、压电陶磁振荡器、压电陶瓷检频器、压电陶瓷换能器、片式压电陶瓷器件、音叉、频率控制元器件、声表面波滤波器、声表面波振荡器、片式声表面波器件、微波器件、压电石英晶体谐振器、压电石英晶体滤波器、压电石英晶体振荡器、片式压电晶体器件",
                                        "taxName": "电子元件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090519040000000000",
                                        "taxCodeTitle": "电子元件",
                                        "iTitle": "*电子元件*频率控制元器件",
                                        "children": []
                                    },
                                    {
                                        "id": "3557",
                                        "linkid": "3552",
                                        "code": "109051905",
                                        "paCode": "1090519",
                                        "yn": "N",
                                        "title": "磁性材料元件",
                                        "alias": "磁性材料元件",
                                        "about": "指金属永磁铁及磁化后准备制永磁铁的物品，包括金属软磁元件、铁氧体软磁元件、铁氧体永磁元件、稀土永磁元件、永磁合金、微波铁氧体器件、电子变压器",
                                        "kws": "金属软磁元件、铁氧体软磁元件、铁氧体永磁元件、稀土永磁元件、永磁合金、微波铁氧体器件、电子变压器",
                                        "taxName": "电子元件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090519050000000000",
                                        "taxCodeTitle": "电子元件",
                                        "iTitle": "*电子元件*磁性材料元件",
                                        "children": []
                                    },
                                    {
                                        "id": "3558",
                                        "linkid": "3552",
                                        "code": "109051906",
                                        "paCode": "1090519",
                                        "yn": "N",
                                        "title": "电声器件",
                                        "alias": "电声器件",
                                        "about": "指电和声相互转换的器件，利用电磁感应、静电感应或压电效应等来完成电声转换，传声器、扬声器、耳机及类似装置，包括通信传声器件、传声器（麦克风）、扬声器、音箱、耳机、蜂鸣器、蜂鸣片、其他电声器件",
                                        "kws": "通信传声器件、传声器、麦克风、扬声器、音箱、耳机、蜂鸣器、蜂鸣片",
                                        "taxName": "电子元件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090519060000000000",
                                        "taxCodeTitle": "电子元件",
                                        "iTitle": "*电子元件*电声器件",
                                        "children": []
                                    },
                                    {
                                        "id": "3559",
                                        "linkid": "3552",
                                        "code": "109051907",
                                        "paCode": "1090519",
                                        "yn": "N",
                                        "title": "射频元器件",
                                        "alias": "射频元器件",
                                        "about": null,
                                        "kws": "射频元器件",
                                        "taxName": "电子元件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090519070000000000",
                                        "taxCodeTitle": "电子元件",
                                        "iTitle": "*电子元件*射频元器件",
                                        "children": []
                                    },
                                    {
                                        "id": "3560",
                                        "linkid": "3552",
                                        "code": "109051908",
                                        "paCode": "1090519",
                                        "yn": "N",
                                        "title": "电子元件、组件零件",
                                        "alias": "电子元件、组件零件",
                                        "about": "包括电容器零件、电阻器零件、电位器零件、频率控制元器件零件、磁性元器件零件、电声器件零件，其他电子元件、组件零件",
                                        "kws": "电容器零件、电阻器零件、电位器零件、频率控制元器件零件、磁性元器件零件、电声器件零件",
                                        "taxName": "电子元件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090519080000000000",
                                        "taxCodeTitle": "电子元件",
                                        "iTitle": "*电子元件*电子元件、组件零件",
                                        "children": []
                                    },
                                    {
                                        "id": "3561",
                                        "linkid": "3552",
                                        "code": "109051999",
                                        "paCode": "1090519",
                                        "yn": "N",
                                        "title": "其他电子元件",
                                        "alias": "其他电子元件",
                                        "about": "除电容器，电阻器及电阻网络，电位器，频率控制元器件，磁性材料元件，电声器件，射频元器件，电子元件、组件零件外的其他电子元件",
                                        "kws": null,
                                        "taxName": "电子元件",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090519990000000000",
                                        "taxCodeTitle": "电子元件",
                                        "iTitle": "*电子元件*其他电子元件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3562",
                                "linkid": "3458",
                                "code": "1090520",
                                "paCode": "10905",
                                "yn": "N",
                                "title": "传感器",
                                "alias": "传感器",
                                "about": "敏感元件指能够灵敏地感受被测变量并做出响应的元件，是传感器中能直接感受被测量的部分；传感器指能感受规定的被测量件并按照一定的规律(数学函数法则)转换成可用信号的器件或装置，通常由敏感元件和转换元件组成。",
                                "kws": "力敏元件、压敏电阻器、光敏电阻器、热敏电阻器、磁敏感元件、湿敏元器件、气敏元器件、传感器",
                                "taxName": "敏感元件及传感器",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1090520000000000000",
                                "taxCodeTitle": "敏感元件及传感器",
                                "iTitle": "*敏感元件及传感器*传感器",
                                "children": []
                            },
                            {
                                "id": "3563",
                                "linkid": "3458",
                                "code": "1090521",
                                "paCode": "10905",
                                "yn": "N",
                                "title": "印制电路板",
                                "alias": "印制电路板",
                                "about": "又称印刷电路板，是电子元器件电气连接的提供者。包括刚性印制电路板、挠性印制电路板、刚挠印制电路板、金属芯印制电路板、齐平印制电路板、碳膜印制电路板、其他印制电路板",
                                "kws": "印制电路板",
                                "taxName": "印制电路板",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1090521000000000000",
                                "taxCodeTitle": "印制电路板",
                                "iTitle": "*印制电路板*印制电路板",
                                "children": []
                            },
                            {
                                "id": "3564",
                                "linkid": "3458",
                                "code": "1090522",
                                "paCode": "10905",
                                "yn": "Y",
                                "title": "家用音视频设备",
                                "alias": "家用音视频设备",
                                "about": "包括视频设备，家用影视摄、录、放设备，家用音响设备，汽车用音响设备，家用音视频设备用配件，其他家用音视频设备",
                                "kws": null,
                                "taxName": "家用音视频设备",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1090522000000000000",
                                "taxCodeTitle": "家用音视频设备",
                                "iTitle": "*家用音视频设备*家用音视频设备",
                                "children": [
                                    {
                                        "id": "3565",
                                        "linkid": "3564",
                                        "code": "109052201",
                                        "paCode": "1090522",
                                        "yn": "N",
                                        "title": "视频设备",
                                        "alias": "视频设备",
                                        "about": "包括彩色电视机、黑白电视机、其他视频设备",
                                        "kws": "电视机、彩色电视机、黑白电视机",
                                        "taxName": "家用音视频设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090522010000000000",
                                        "taxCodeTitle": "家用音视频设备",
                                        "iTitle": "*家用音视频设备*视频设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3566",
                                        "linkid": "3564",
                                        "code": "109052202",
                                        "paCode": "1090522",
                                        "yn": "N",
                                        "title": "家用影视摄、录、放设备",
                                        "alias": "家用影视摄、录、放设备",
                                        "about": "包括家用摄录像机，数字激光音、视盘机，其他家用影视摄、录、放设备",
                                        "kws": "家用摄录像机、数字激光音视盘机",
                                        "taxName": "家用音视频设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090522020000000000",
                                        "taxCodeTitle": "家用音视频设备",
                                        "iTitle": "*家用音视频设备*家用影视摄、录、放设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3567",
                                        "linkid": "3564",
                                        "code": "109052203",
                                        "paCode": "1090522",
                                        "yn": "N",
                                        "title": "家用音响设备",
                                        "alias": "家用音响设备",
                                        "about": "包括收音机及组合音响，半导体收音机，便携式收录（放）音组合机，家用电唱机、放声机，家用录放音机，数字化多媒体组合机，其他家用音响设备",
                                        "kws": "收音机、收音机组合音响、半导体收音机、便携式收录音组合机、便携式收放音组合机、家用电唱机、家用放声机、家用录放音机、数字化多媒体组合机",
                                        "taxName": "家用音视频设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090522030000000000",
                                        "taxCodeTitle": "家用音视频设备",
                                        "iTitle": "*家用音视频设备*家用音响设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3568",
                                        "linkid": "3564",
                                        "code": "109052204",
                                        "paCode": "1090522",
                                        "yn": "N",
                                        "title": "汽车用音响设备",
                                        "alias": "汽车用音响设备",
                                        "about": "包括汽车用收录（放）音组合机、其他汽车用音响设备",
                                        "kws": "汽车用收录音组合机、汽车用收放音组合机",
                                        "taxName": "家用音视频设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090522040000000000",
                                        "taxCodeTitle": "家用音视频设备",
                                        "iTitle": "*家用音视频设备*汽车用音响设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3569",
                                        "linkid": "3564",
                                        "code": "109052205",
                                        "paCode": "1090522",
                                        "yn": "N",
                                        "title": "家用音视频设备用配件",
                                        "alias": "家用音视频设备用配件",
                                        "about": "包括走带机芯、激光视盘机机芯、磁头、光学头、家用天线、电视接收机顶盒、调谐器、偏转线圈、录音录像磁鼓、充电器、遥控器、光机引擎、接口、其他家用音视频设备用配件。不包括传声器、扬声器、耳机及类似装置(详见109051906)",
                                        "kws": "走带机芯、激光视盘机机芯、磁头、光学头、家用天线、电视接收机顶盒、调谐器、偏转线圈、录音录像磁鼓、充电器、遥控器、光机引擎、接口",
                                        "taxName": "家用音视频设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090522050000000000",
                                        "taxCodeTitle": "家用音视频设备",
                                        "iTitle": "*家用音视频设备*家用音视频设备用配件",
                                        "children": []
                                    },
                                    {
                                        "id": "3570",
                                        "linkid": "3564",
                                        "code": "109052299",
                                        "paCode": "1090522",
                                        "yn": "N",
                                        "title": "其他家用音视频设备",
                                        "alias": "其他家用音视频设备",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "家用音视频设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090522990000000000",
                                        "taxCodeTitle": "家用音视频设备",
                                        "iTitle": "*家用音视频设备*其他家用音视频设备",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3571",
                                "linkid": "3458",
                                "code": "1090599",
                                "paCode": "10905",
                                "yn": "N",
                                "title": "其他未列明电子设备",
                                "alias": "其他未列明电子设备",
                                "about": null,
                                "kws": "电子加速器、电气加速器、邻近卡",
                                "taxName": "其他电子设备",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1090599000000000000",
                                "taxCodeTitle": "其他电子设备",
                                "iTitle": "*其他电子设备*其他未列明电子设备",
                                "children": []
                            }
                        ]
                    },
                    {
                        "id": "3572",
                        "linkid": "2501",
                        "code": "10906",
                        "paCode": "109",
                        "yn": "Y",
                        "title": "仪器仪表及文化、办公用机械",
                        "alias": "仪器仪表及文化、办公用机械",
                        "about": null,
                        "kws": null,
                        "taxName": "仪器仪表办公用机械",
                        "taxRate": "",
                        "vip": "7",
                        "itaxRate": null,
                        "taxCode": "1090600000000000000",
                        "taxCodeTitle": "仪器仪表办公用机械",
                        "iTitle": "*仪器仪表办公用机械*仪器仪表及文化、办公用机械",
                        "children": [
                            {
                                "id": "3573",
                                "linkid": "3572",
                                "code": "1090601",
                                "paCode": "10906",
                                "yn": "Y",
                                "title": "工业自动调节仪表与控制系统",
                                "alias": "工业自动调节仪表与控制系统",
                                "about": "指工业产品制造过程中进行自动控制的系统与仪表装置，不包括数控机床（详见1090108）",
                                "kws": null,
                                "taxName": "工业自动控制仪表系统",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090601000000000000",
                                "taxCodeTitle": "工业自动控制仪表系统",
                                "iTitle": "*工业自动控制仪表系统*工业自动调节仪表与控制系统",
                                "children": [
                                    {
                                        "id": "3574",
                                        "linkid": "3573",
                                        "code": "109060101",
                                        "paCode": "1090601",
                                        "yn": "N",
                                        "title": "工业自动调节仪表",
                                        "alias": "工业自动调节仪表",
                                        "about": "指在工业产品制造过程中，对流量、物位、压力、温度及其他变化量进行自动调节和控制的仪器仪表及装置，不论是否具有智能功能均包括在内。包括电动调节仪表、气动调节仪表、其他工业自动调节仪表。",
                                        "kws": "单回路调节仪表、多回路调节仪表、温度控制器、气动调节仪表",
                                        "taxName": "工业自动控制仪表系统",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090601010000000000",
                                        "taxCodeTitle": "工业自动控制仪表系统",
                                        "iTitle": "*工业自动控制仪表系统*工业自动调节仪表",
                                        "children": []
                                    },
                                    {
                                        "id": "3575",
                                        "linkid": "3573",
                                        "code": "109060102",
                                        "paCode": "1090601",
                                        "yn": "N",
                                        "title": "工业自动控制系统",
                                        "alias": "工业自动控制系统",
                                        "about": "包括自动控制非电量的仪器或设备，可分为分散型控制系统（DCS系统）、可编程控制系统（PLC系统）、其他工业自动控制系统",
                                        "kws": "分散型控制系统、DCS系统、可编程控制系统、PLC系统",
                                        "taxName": "工业自动控制仪表系统",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090601020000000000",
                                        "taxCodeTitle": "工业自动控制仪表系统",
                                        "iTitle": "*工业自动控制仪表系统*工业自动控制系统",
                                        "children": []
                                    },
                                    {
                                        "id": "3576",
                                        "linkid": "3573",
                                        "code": "109060103",
                                        "paCode": "1090601",
                                        "yn": "N",
                                        "title": "楼宇控制系统",
                                        "alias": "楼宇控制系统",
                                        "about": "指用于建筑物温度、湿度、能源、消防、安全、保安等控制的系统",
                                        "kws": "楼宇控制系统",
                                        "taxName": "工业自动控制仪表系统",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090601030000000000",
                                        "taxCodeTitle": "工业自动控制仪表系统",
                                        "iTitle": "*工业自动控制仪表系统*楼宇控制系统",
                                        "children": []
                                    },
                                    {
                                        "id": "3577",
                                        "linkid": "3573",
                                        "code": "109060104",
                                        "paCode": "1090601",
                                        "yn": "N",
                                        "title": "工业自动调节仪表与控制系统零件、附件",
                                        "alias": "工业自动调节仪表与控制系统零件、附件",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "工业自动控制仪表系统",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090601040000000000",
                                        "taxCodeTitle": "工业自动控制仪表系统",
                                        "iTitle": "*工业自动控制仪表系统*工业自动调节仪表与控制系统零件、附件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3578",
                                "linkid": "3572",
                                "code": "1090602",
                                "paCode": "10906",
                                "yn": "Y",
                                "title": "工业仪表",
                                "alias": "工业仪表",
                                "about": "指在工业产品制造过程中对流量、压力、物位、温度、比重、湿度等变化量进行测量的仪表和装置，以及相关显示、记录仪表",
                                "kws": null,
                                "taxName": "工业仪表",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090602000000000000",
                                "taxCodeTitle": "工业仪表",
                                "iTitle": "*工业仪表*工业仪表",
                                "children": [
                                    {
                                        "id": "3579",
                                        "linkid": "3578",
                                        "code": "109060201",
                                        "paCode": "1090602",
                                        "yn": "N",
                                        "title": "温度测量仪表",
                                        "alias": "温度测量仪表",
                                        "about": "指采用接触或非接触方式进行温度、热像测量的仪表及装置；包括智能和非智能仪表",
                                        "kws": "温度计、温度变送器、温度记录仪、温度仪表校验装置、温度仪表零附件",
                                        "taxName": "工业仪表",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090602010000000000",
                                        "taxCodeTitle": "工业仪表",
                                        "iTitle": "*工业仪表*温度测量仪表",
                                        "children": []
                                    },
                                    {
                                        "id": "3580",
                                        "linkid": "3578",
                                        "code": "109060202",
                                        "paCode": "1090602",
                                        "yn": "N",
                                        "title": "压力测量仪表",
                                        "alias": "压力测量仪表",
                                        "about": "指采用各种原理测量压力、差压的仪表与装置；包括智能和非智能检测液体或气体压力的仪表及装置",
                                        "kws": "液体压力计、弹簧管压力表、波纹管压力表、膜盒压力表、膜片压力表、半导体压力表、压力开关、压力校验装置",
                                        "taxName": "工业仪表",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090602020000000000",
                                        "taxCodeTitle": "工业仪表",
                                        "iTitle": "*工业仪表*压力测量仪表",
                                        "children": []
                                    },
                                    {
                                        "id": "3581",
                                        "linkid": "3578",
                                        "code": "109060203",
                                        "paCode": "1090602",
                                        "yn": "N",
                                        "title": "流量测量仪表",
                                        "alias": "流量测量仪表",
                                        "about": "指采用各种原理测量管道或明渠中气体、液体、多相流体的流量的仪表与装置；包括智能和非智能液体或气体流量、液位、压力检测仪器",
                                        "kws": "电磁流量计、涡街流量计、浮子流量计、科氏力质量流量计、热式质量流量计、气体质量流量计、超声波流量计、涡轮流量计、燃气表、水表、热量表",
                                        "taxName": "工业仪表",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090602030000000000",
                                        "taxCodeTitle": "工业仪表",
                                        "iTitle": "*工业仪表*流量测量仪表",
                                        "children": []
                                    },
                                    {
                                        "id": "3582",
                                        "linkid": "3578",
                                        "code": "109060204",
                                        "paCode": "1090602",
                                        "yn": "N",
                                        "title": "物位、液位测量仪表",
                                        "alias": "物位、液位测量仪表",
                                        "about": "指采用各种原理测量液体、固体的物位或界面位置的仪表和装置，包括浮子式物位仪表、电容物位仪表、压力式物位仪表、雷达物位仪表、核辐射物位仪表、超声物位仪表、微波物位仪表、直视式液位计",
                                        "kws": "浮子式物位仪表、电容物位仪表、压力式物位仪表、雷达物位仪表、核辐射物位仪表、超声物位仪表、微波物位仪表、直视式液位计",
                                        "taxName": "工业仪表",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090602040000000000",
                                        "taxCodeTitle": "工业仪表",
                                        "iTitle": "*工业仪表*物位、液位测量仪表",
                                        "children": []
                                    },
                                    {
                                        "id": "3583",
                                        "linkid": "3578",
                                        "code": "109060205",
                                        "paCode": "1090602",
                                        "yn": "N",
                                        "title": "显示仪表、记录仪",
                                        "alias": "显示仪表、记录仪",
                                        "about": "包括指示仪、记录仪、报警装置、其他显示仪表、其他记录仪",
                                        "kws": "指示仪、记录仪、报警装置",
                                        "taxName": "工业仪表",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090602050000000000",
                                        "taxCodeTitle": "工业仪表",
                                        "iTitle": "*工业仪表*显示仪表、记录仪",
                                        "children": []
                                    },
                                    {
                                        "id": "3584",
                                        "linkid": "3578",
                                        "code": "109060206",
                                        "paCode": "1090602",
                                        "yn": "N",
                                        "title": "执行器",
                                        "alias": "执行器",
                                        "about": "指接受控制系统信号，对被控介质进行调节的仪表，包括各种类型的调节阀，各种原理的执行机构及其各种附件。包括电动执行机构、气动执行机构、电液执行机构、阀门定位器、调节阀、电磁阀、其他执行器；",
                                        "kws": "角行程电动执行机构、直行程电动执行机构、气动执行机构、电液执行机构、阀门定位器、套筒阀、角形阀、偏心旋转阀、自力式调节阀、电磁阀",
                                        "taxName": "工业仪表",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090602060000000000",
                                        "taxCodeTitle": "工业仪表",
                                        "iTitle": "*工业仪表*执行器",
                                        "children": []
                                    },
                                    {
                                        "id": "3585",
                                        "linkid": "3578",
                                        "code": "109060299",
                                        "paCode": "1090602",
                                        "yn": "N",
                                        "title": "其他工业仪表",
                                        "alias": "其他工业仪表",
                                        "about": null,
                                        "kws": "防爆栅、隔离器、配电器、仪表柜、机架、仪表盘、操作台、仪表箱",
                                        "taxName": "工业仪表",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090602990000000000",
                                        "taxCodeTitle": "工业仪表",
                                        "iTitle": "*工业仪表*其他工业仪表",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3586",
                                "linkid": "3572",
                                "code": "1090603",
                                "paCode": "10906",
                                "yn": "Y",
                                "title": "电工仪器仪表",
                                "alias": "电工仪器仪表",
                                "about": "测量或检验电压、电流、电阻或功率的通用仪器装置",
                                "kws": null,
                                "taxName": "电工仪器仪表",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090603000000000000",
                                "taxCodeTitle": "电工仪器仪表",
                                "iTitle": "*电工仪器仪表*电工仪器仪表",
                                "children": [
                                    {
                                        "id": "3587",
                                        "linkid": "3586",
                                        "code": "109060301",
                                        "paCode": "1090603",
                                        "yn": "N",
                                        "title": "电能表",
                                        "alias": "电能表",
                                        "about": "用来测量电能的仪表，又称电度表，火表，千瓦小时表。包括单相感应式电能表、三相感应式电能表、单相电子式电能表、三相电子式电能表、多用户电能表、其他电能表。",
                                        "kws": "单相感应式电能表、三相感应式电能表、单相电子式电能表、三相电子式电能表、多用户电能表",
                                        "taxName": "电工仪器仪表",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090603010000000000",
                                        "taxCodeTitle": "电工仪器仪表",
                                        "iTitle": "*电工仪器仪表*电能表",
                                        "children": []
                                    },
                                    {
                                        "id": "3588",
                                        "linkid": "3586",
                                        "code": "109060302",
                                        "paCode": "1090603",
                                        "yn": "N",
                                        "title": "自动抄表系统（不含表）",
                                        "alias": "自动抄表系统（不含表）",
                                        "about": "自动抄表系统主要由电能表、采集器、集中器、数据传输通道、主站系统构成，包括低压载波自动抄表系统、无线自动抄表系统、专用线自动抄表系统、其他自动抄表系统。",
                                        "kws": "低压载波自动抄表系统、无线自动抄表系统、专用线自动抄表系统",
                                        "taxName": "电工仪器仪表",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090603020000000000",
                                        "taxCodeTitle": "电工仪器仪表",
                                        "iTitle": "*电工仪器仪表*自动抄表系统（不含表）",
                                        "children": []
                                    },
                                    {
                                        "id": "3589",
                                        "linkid": "3586",
                                        "code": "109060303",
                                        "paCode": "1090603",
                                        "yn": "N",
                                        "title": "电力负荷控制系统",
                                        "alias": "电力负荷控制系统",
                                        "about": null,
                                        "kws": "电力负荷控制系统",
                                        "taxName": "电工仪器仪表",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090603030000000000",
                                        "taxCodeTitle": "电工仪器仪表",
                                        "iTitle": "*电工仪器仪表*电力负荷控制系统",
                                        "children": []
                                    },
                                    {
                                        "id": "3590",
                                        "linkid": "3586",
                                        "code": "109060304",
                                        "paCode": "1090603",
                                        "yn": "N",
                                        "title": "电磁参数测量仪器仪表",
                                        "alias": "电磁参数测量仪器仪表",
                                        "about": "包括安装式仪表、便携式模拟仪表、数字仪表、精密仪器、测磁仪器、其他电磁参数测量仪器仪表。",
                                        "kws": "安装式模拟仪表、安装式数字仪表、万用表、钳形表、兆欧表、数字仪表、精密仪器、测磁仪器",
                                        "taxName": "电工仪器仪表",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090603040000000000",
                                        "taxCodeTitle": "电工仪器仪表",
                                        "iTitle": "*电工仪器仪表*电磁参数测量仪器仪表",
                                        "children": []
                                    },
                                    {
                                        "id": "3591",
                                        "linkid": "3586",
                                        "code": "109060305",
                                        "paCode": "1090603",
                                        "yn": "N",
                                        "title": "电磁参量分析与记录装置",
                                        "alias": "电磁参量分析与记录装置",
                                        "about": "包括示波器、电工用频谱分析仪、电工用逻辑分析仪、记录仪器、电磁参量分析与记录装置附件",
                                        "kws": "模拟示波器、数字示波器、手持示波器、混合示波器、虚拟示波器、示波器校准仪、微波频谱分析仪、电工用逻辑分析仪、记录仪器",
                                        "taxName": "电工仪器仪表",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090603050000000000",
                                        "taxCodeTitle": "电工仪器仪表",
                                        "iTitle": "*电工仪器仪表*电磁参量分析与记录装置",
                                        "children": []
                                    },
                                    {
                                        "id": "3592",
                                        "linkid": "3586",
                                        "code": "109060306",
                                        "paCode": "1090603",
                                        "yn": "N",
                                        "title": "配电系统电气安全检测与分析装置",
                                        "alias": "配电系统电气安全检测与分析装置",
                                        "about": "包括电能质量分析仪、电力参数综合测量装置、配电系统电气安全检测装置、其他配电系统电气安全检测与分析装置",
                                        "kws": "电能质量分析仪、电力参数综合测量装置、配电系统电气安全检测装置",
                                        "taxName": "电工仪器仪表",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090603060000000000",
                                        "taxCodeTitle": "电工仪器仪表",
                                        "iTitle": "*电工仪器仪表*配电系统电气安全检测与分析装置",
                                        "children": []
                                    },
                                    {
                                        "id": "3593",
                                        "linkid": "3586",
                                        "code": "109060307",
                                        "paCode": "1090603",
                                        "yn": "N",
                                        "title": "电源装置",
                                        "alias": "电源装置",
                                        "about": "包括测量电源、普通电源装置，不包括电源变压稳压稳流装置（详见1090404）、控制开关（详见1090407）。",
                                        "kws": "信号发生器、电源测量仪、标准信号发生器、标准电源、普通电源装置",
                                        "taxName": "电工仪器仪表",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090603070000000000",
                                        "taxCodeTitle": "电工仪器仪表",
                                        "iTitle": "*电工仪器仪表*电源装置",
                                        "children": []
                                    },
                                    {
                                        "id": "3594",
                                        "linkid": "3586",
                                        "code": "109060308",
                                        "paCode": "1090603",
                                        "yn": "N",
                                        "title": "标准与校验设备",
                                        "alias": "标准与校验设备",
                                        "about": "包括标准仪表、交直流仪器、校验装置",
                                        "kws": "标准仪表、交直流仪器、校验装置",
                                        "taxName": "电工仪器仪表",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090603080000000000",
                                        "taxCodeTitle": "电工仪器仪表",
                                        "iTitle": "*电工仪器仪表*标准与校验设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3595",
                                        "linkid": "3586",
                                        "code": "109060309",
                                        "paCode": "1090603",
                                        "yn": "N",
                                        "title": "扩大量限装置",
                                        "alias": "扩大量限装置",
                                        "about": null,
                                        "kws": "扩大量限装置",
                                        "taxName": "电工仪器仪表",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090603090000000000",
                                        "taxCodeTitle": "电工仪器仪表",
                                        "iTitle": "*电工仪器仪表*扩大量限装置",
                                        "children": []
                                    },
                                    {
                                        "id": "3596",
                                        "linkid": "3586",
                                        "code": "109060310",
                                        "paCode": "1090603",
                                        "yn": "N",
                                        "title": "电力自动化仪表及系统",
                                        "alias": "电力自动化仪表及系统",
                                        "about": "包括电量变送器、变送仪表及屏、输变电自动化系统、配用电自动化系统、其他电力自动化仪表及系统",
                                        "kws": "电量变送器、变送仪表、变送仪屏、输变电自动化系统、配用电自动化系统",
                                        "taxName": "电工仪器仪表",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090603100000000000",
                                        "taxCodeTitle": "电工仪器仪表",
                                        "iTitle": "*电工仪器仪表*电力自动化仪表及系统",
                                        "children": []
                                    },
                                    {
                                        "id": "3597",
                                        "linkid": "3586",
                                        "code": "109060311",
                                        "paCode": "1090603",
                                        "yn": "N",
                                        "title": "自动测试系统与虚拟仪器",
                                        "alias": "自动测试系统与虚拟仪器",
                                        "about": null,
                                        "kws": "自动测试系统、虚拟仪器",
                                        "taxName": "电工仪器仪表",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090603110000000000",
                                        "taxCodeTitle": "电工仪器仪表",
                                        "iTitle": "*电工仪器仪表*自动测试系统与虚拟仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3598",
                                        "linkid": "3586",
                                        "code": "109060312",
                                        "paCode": "1090603",
                                        "yn": "N",
                                        "title": "非电量电测仪表及装置",
                                        "alias": "非电量电测仪表及装置",
                                        "about": null,
                                        "kws": "非电量电测仪表",
                                        "taxName": "电工仪器仪表",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090603120000000000",
                                        "taxCodeTitle": "电工仪器仪表",
                                        "iTitle": "*电工仪器仪表*非电量电测仪表及装置",
                                        "children": []
                                    },
                                    {
                                        "id": "3599",
                                        "linkid": "3586",
                                        "code": "109060313",
                                        "paCode": "1090603",
                                        "yn": "N",
                                        "title": "电工仪器仪表零部件",
                                        "alias": "电工仪器仪表零部件",
                                        "about": "包括计量芯片、计量模块、计度器、仪表外壳、仪用互感器（内置）、仪用电源（内置）、其他电工仪器仪表零部件",
                                        "kws": "计量芯片、计量模块、计度器、仪表外壳、仪用互感器、仪用电源",
                                        "taxName": "电工仪器仪表",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090603130000000000",
                                        "taxCodeTitle": "电工仪器仪表",
                                        "iTitle": "*电工仪器仪表*电工仪器仪表零部件",
                                        "children": []
                                    },
                                    {
                                        "id": "3600",
                                        "linkid": "3586",
                                        "code": "109060399",
                                        "paCode": "1090603",
                                        "yn": "N",
                                        "title": "其他电工仪器仪表",
                                        "alias": "其他电工仪器仪表",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "电工仪器仪表",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090603990000000000",
                                        "taxCodeTitle": "电工仪器仪表",
                                        "iTitle": "*电工仪器仪表*其他电工仪器仪表",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3601",
                                "linkid": "3572",
                                "code": "1090604",
                                "paCode": "10906",
                                "yn": "Y",
                                "title": "绘图、计算及测量仪器",
                                "alias": "绘图、计算及测量仪器",
                                "about": "指供设计、制图、绘图、计算、测量等使用的测量和绘图用具、器具及量仪",
                                "kws": null,
                                "taxName": "绘图测量仪器",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090604000000000000",
                                "taxCodeTitle": "绘图测量仪器",
                                "iTitle": "*绘图测量仪器*绘图、计算及测量仪器",
                                "children": [
                                    {
                                        "id": "3602",
                                        "linkid": "3601",
                                        "code": "109060401",
                                        "paCode": "1090604",
                                        "yn": "N",
                                        "title": "绘图台及绘图机",
                                        "alias": "绘图台及绘图机",
                                        "about": "包括绘图台及绘图机、绘图台（桌）、绘图板、导轨式绘图机、轻便绘图机、其他绘图台及绘图机",
                                        "kws": "绘图台、绘图机、绘图桌、绘图板、导轨式绘图机、轻便绘图机",
                                        "taxName": "绘图测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090604010000000000",
                                        "taxCodeTitle": "绘图测量仪器",
                                        "iTitle": "*绘图测量仪器*绘图台及绘图机",
                                        "children": []
                                    },
                                    {
                                        "id": "3603",
                                        "linkid": "3601",
                                        "code": "109060402",
                                        "paCode": "1090604",
                                        "yn": "N",
                                        "title": "绘图工具",
                                        "alias": "绘图工具",
                                        "about": "包括缩放仪、缩放绘图仪、航线标绘器具、绘图圆规、分规、比例规、绘图用尺、板、线及类似器具、分度规、其他绘图工具",
                                        "kws": "缩放仪、缩放绘图仪、航线标绘器具、绘图圆规、分规、比例规、绘图用尺、绘图用板、绘图用线、分度规",
                                        "taxName": "绘图测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090604020000000000",
                                        "taxCodeTitle": "绘图测量仪器",
                                        "iTitle": "*绘图测量仪器*绘图工具",
                                        "children": []
                                    },
                                    {
                                        "id": "3604",
                                        "linkid": "3601",
                                        "code": "109060403",
                                        "paCode": "1090604",
                                        "yn": "N",
                                        "title": "划线用具",
                                        "alias": "划线用具",
                                        "about": "包括划线器、中心冲、其他划线用具",
                                        "kws": "划线器、中心冲",
                                        "taxName": "绘图测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090604030000000000",
                                        "taxCodeTitle": "绘图测量仪器",
                                        "iTitle": "*绘图测量仪器*划线用具",
                                        "children": []
                                    },
                                    {
                                        "id": "3605",
                                        "linkid": "3601",
                                        "code": "109060404",
                                        "paCode": "1090604",
                                        "yn": "N",
                                        "title": "数学计算器具",
                                        "alias": "数学计算器具",
                                        "about": "包括计算尺、盘式计算器、圆柱计算器、算盘、其他数学计算器具，不包括电子计算器（详见1090626）。",
                                        "kws": "计算尺、盘式计算器、圆柱计算器、算盘",
                                        "taxName": "绘图测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090604040000000000",
                                        "taxCodeTitle": "绘图测量仪器",
                                        "iTitle": "*绘图测量仪器*数学计算器具",
                                        "children": []
                                    },
                                    {
                                        "id": "3606",
                                        "linkid": "3601",
                                        "code": "109060405",
                                        "paCode": "1090604",
                                        "yn": "N",
                                        "title": "量具",
                                        "alias": "量具",
                                        "about": "包括卡尺、量块及量规、测微螺杆类量具、量表、角度和平直度量具、电子数显量具、辅助测量器具、其他量具",
                                        "kws": "卡尺、量块、量规、测微螺杆类量具、量表、角度量具、平直度量具、电子数显量具、辅助测量器具",
                                        "taxName": "绘图测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090604050000000000",
                                        "taxCodeTitle": "绘图测量仪器",
                                        "iTitle": "*绘图测量仪器*量具",
                                        "children": []
                                    },
                                    {
                                        "id": "3607",
                                        "linkid": "3601",
                                        "code": "109060406",
                                        "paCode": "1090604",
                                        "yn": "N",
                                        "title": "手动测量长度器具",
                                        "alias": "手动测量长度器具",
                                        "about": "包括比较仪（刻度盘式）、刻度尺、量图器（计图器）、其他手动测量长度器具",
                                        "kws": "比较仪、刻度尺、量图器、计图器",
                                        "taxName": "绘图测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090604060000000000",
                                        "taxCodeTitle": "绘图测量仪器",
                                        "iTitle": "*绘图测量仪器*手动测量长度器具",
                                        "children": []
                                    },
                                    {
                                        "id": "3608",
                                        "linkid": "3601",
                                        "code": "109060407",
                                        "paCode": "1090604",
                                        "yn": "N",
                                        "title": "量仪",
                                        "alias": "量仪",
                                        "about": "包括通用长度量仪、通用角度量仪、形状和位置误差量仪、表面质量量仪、三坐标测量仪、齿轮量仪、螺纹量仪、气动、电动、主动量仪检验机、其他量仪",
                                        "kws": "通用长度量仪、通用角度量仪、形状误差量仪、位置误差量仪、表面质量量仪、三坐标测量仪、齿轮量仪、螺纹量仪、气动量仪检验机、电动量仪检验机、主动量仪检验机",
                                        "taxName": "绘图测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090604070000000000",
                                        "taxCodeTitle": "绘图测量仪器",
                                        "iTitle": "*绘图测量仪器*量仪",
                                        "children": []
                                    },
                                    {
                                        "id": "3609",
                                        "linkid": "3601",
                                        "code": "109060408",
                                        "paCode": "1090604",
                                        "yn": "N",
                                        "title": "机械量仪表",
                                        "alias": "机械量仪表",
                                        "about": "包括尺度计、测力仪表、转距测量仪",
                                        "kws": "尺度计、测力仪表、转距测量仪",
                                        "taxName": "绘图测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090604080000000000",
                                        "taxCodeTitle": "绘图测量仪器",
                                        "iTitle": "*绘图测量仪器*机械量仪表",
                                        "children": []
                                    },
                                    {
                                        "id": "3610",
                                        "linkid": "3601",
                                        "code": "109060409",
                                        "paCode": "1090604",
                                        "yn": "N",
                                        "title": "数显装置",
                                        "alias": "数显装置",
                                        "about": "指位移传感器、数显表组成的位移测量系统，包括直线位移传感器、角位移传感器、其他数显装置",
                                        "kws": "光栅尺、磁栅尺、球栅尺、感应同步器尺、容栅尺、圆光栅编码器、圆磁栅编码器、圆感应同步器编码器、圆容栅编码器",
                                        "taxName": "绘图测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090604090000000000",
                                        "taxCodeTitle": "绘图测量仪器",
                                        "iTitle": "*绘图测量仪器*数显装置",
                                        "children": []
                                    },
                                    {
                                        "id": "3611",
                                        "linkid": "3601",
                                        "code": "109060410",
                                        "paCode": "1090604",
                                        "yn": "N",
                                        "title": "测量仪器",
                                        "alias": "测量仪器",
                                        "about": "包括面积仪、千分表式比较仪、柱式测量仪表、测斜仪、球径仪、其他测量仪器。不包括大地及水道测量、摄影测量用仪器（详见1090610）。",
                                        "kws": "面积仪、千分表式比较仪、柱式测量仪表、测斜仪、球径仪",
                                        "taxName": "绘图测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090604100000000000",
                                        "taxCodeTitle": "绘图测量仪器",
                                        "iTitle": "*绘图测量仪器*测量仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3612",
                                        "linkid": "3601",
                                        "code": "109060499",
                                        "paCode": "1090604",
                                        "yn": "N",
                                        "title": "其他绘图、计算仪器及零件",
                                        "alias": "其他绘图、计算仪器及零件",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "绘图测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090604990000000000",
                                        "taxCodeTitle": "绘图测量仪器",
                                        "iTitle": "*绘图测量仪器*其他绘图、计算仪器及零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3613",
                                "linkid": "3572",
                                "code": "1090605",
                                "paCode": "10906",
                                "yn": "Y",
                                "title": "分析仪器及装置",
                                "alias": "分析仪器及装置",
                                "about": "指对物质成分及微观结构、粘度、密度、浊度、比重、PH值等进行理化分析用的仪器与装置",
                                "kws": null,
                                "taxName": "分析仪器",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090605000000000000",
                                "taxCodeTitle": "分析仪器",
                                "iTitle": "*分析仪器*分析仪器及装置",
                                "children": [
                                    {
                                        "id": "3614",
                                        "linkid": "3613",
                                        "code": "109060501",
                                        "paCode": "1090605",
                                        "yn": "N",
                                        "title": "电化学式分析仪器",
                                        "alias": "电化学式分析仪器",
                                        "about": "包括极谱分析仪、电位式分析仪器、电解式分析仪器、电导式分析仪器、电量式分析仪器、滴定仪、湿化学分析仪、溶解氧测定仪、其他电化学式分析仪器",
                                        "kws": "极谱分析仪、电位式分析仪器、电解式分析仪器、电导式分析仪器、电量式分析仪器、滴定仪、湿化学分析仪、溶解氧测定仪",
                                        "taxName": "分析仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090605010000000000",
                                        "taxCodeTitle": "分析仪器",
                                        "iTitle": "*分析仪器*电化学式分析仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3615",
                                        "linkid": "3613",
                                        "code": "109060502",
                                        "paCode": "1090605",
                                        "yn": "N",
                                        "title": "光学分析仪器",
                                        "alias": "光学分析仪器",
                                        "about": "包括分光仪、分光光度计、摄谱仪、光电直读光谱仪、光度计、照度计、折光仪、光电比色分析仪器、光度式分析仪器、红外线分析仪器、激光气体分析仪器、其他光学分析仪器",
                                        "kws": "分光仪、可见分光光度计、紫外可见分光光度计、红外分光光度计、原子吸收分光光度计、荧光分光光度计、摄谱仪、光电直读光谱仪、光度计、照度计、折光仪、光电比色分析仪器、光度式分析仪器、红外线分析仪器、激光气体分析仪器",
                                        "taxName": "分析仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090605020000000000",
                                        "taxCodeTitle": "分析仪器",
                                        "iTitle": "*分析仪器*光学分析仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3616",
                                        "linkid": "3613",
                                        "code": "109060503",
                                        "paCode": "1090605",
                                        "yn": "N",
                                        "title": "热学分析仪器",
                                        "alias": "热学分析仪器",
                                        "about": "包括热重分析仪、差热分析仪、差热天平、热量计、量热仪、热物快速测定仪、差示扫描量热仪、平板导热仪、热膨胀仪、热机械分析仪、冰点测定器、沸点测定器、检镜切片机、其他热学分析仪器",
                                        "kws": "热重分析仪、差热分析仪、差热天平、热量计、量热仪、热物快速测定仪、差示扫描量热仪、平板导热仪、热膨胀仪、热机械分析仪、冰点测定器、沸点测定器、检镜切片机",
                                        "taxName": "分析仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090605030000000000",
                                        "taxCodeTitle": "分析仪器",
                                        "iTitle": "*分析仪器*热学分析仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3617",
                                        "linkid": "3613",
                                        "code": "109060504",
                                        "paCode": "1090605",
                                        "yn": "N",
                                        "title": "质谱仪器",
                                        "alias": "质谱仪器",
                                        "about": "包括有机质谱仪、同位素质谱仪、无机质谱仪、气体分析质谱计、表面分析质谱计、质谱联用仪、集成电路生产用氦质谱检漏台、其他质谱仪器",
                                        "kws": "有机质谱仪、同位素质谱仪、无机质谱仪、气体分析质谱计、表面分析质谱计、质谱联用仪、集成电路生产用氦质谱检漏台",
                                        "taxName": "分析仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090605040000000000",
                                        "taxCodeTitle": "分析仪器",
                                        "iTitle": "*分析仪器*质谱仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3618",
                                        "linkid": "3613",
                                        "code": "109060505",
                                        "paCode": "1090605",
                                        "yn": "N",
                                        "title": "波谱仪器",
                                        "alias": "波谱仪器",
                                        "about": "包括核磁共振波谱仪、顺磁共振波谱仪、核电四极矩共振波谱仪、光磁共振波谱仪、其他波谱仪器",
                                        "kws": "核磁共振波谱仪、顺磁共振波谱仪、核电四极矩共振波谱仪、光磁共振波谱仪",
                                        "taxName": "分析仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090605050000000000",
                                        "taxCodeTitle": "分析仪器",
                                        "iTitle": "*分析仪器*波谱仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3619",
                                        "linkid": "3613",
                                        "code": "109060506",
                                        "paCode": "1090605",
                                        "yn": "N",
                                        "title": "色谱仪器",
                                        "alias": "色谱仪器",
                                        "about": "包括气相色谱仪、液相色谱仪、色谱联用仪、色谱柱、自动进样器、其他色谱仪器",
                                        "kws": "气相色谱仪、液相色谱仪、色谱联用仪、色谱柱、自动进样器",
                                        "taxName": "分析仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090605060000000000",
                                        "taxCodeTitle": "分析仪器",
                                        "iTitle": "*分析仪器*色谱仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3620",
                                        "linkid": "3613",
                                        "code": "109060507",
                                        "paCode": "1090605",
                                        "yn": "N",
                                        "title": "电泳仪",
                                        "alias": "电泳仪",
                                        "about": "利用电泳现象对某些化学或生物化学组分进行分离分析的仪器，一般由分离装置、电源和检测装置构成，包括自由电泳仪、支持物电泳仪、其他电泳仪，不含医疗用电泳仪（详见109024312）。",
                                        "kws": "移界电泳仪、密度电泳仪、PH梯度电泳仪、等速电泳仪、纸电泳仪、醋酸纤维膜电泳仪、淀粉胶电泳仪、琼脂糖电泳仪",
                                        "taxName": "分析仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090605070000000000",
                                        "taxCodeTitle": "分析仪器",
                                        "iTitle": "*分析仪器*电泳仪",
                                        "children": []
                                    },
                                    {
                                        "id": "3621",
                                        "linkid": "3613",
                                        "code": "109060508",
                                        "paCode": "1090605",
                                        "yn": "N",
                                        "title": "能谱仪及射线分析仪器",
                                        "alias": "能谱仪及射线分析仪器",
                                        "about": "包括电子能谱仪、离子散射谱仪、二次离子谱仪、X射线衍射仪、发射式X射线谱仪、吸收式X射线谱仪、荧光折射仪、其他能谱仪及射线分析仪器",
                                        "kws": "电子能谱仪、离子散射谱仪、二次离子谱仪、X射线衍射仪、发射式X射线谱仪、吸收式X射线谱仪、荧光折射仪",
                                        "taxName": "分析仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090605080000000000",
                                        "taxCodeTitle": "分析仪器",
                                        "iTitle": "*分析仪器*能谱仪及射线分析仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3622",
                                        "linkid": "3613",
                                        "code": "109060509",
                                        "paCode": "1090605",
                                        "yn": "N",
                                        "title": "物性分析仪器",
                                        "alias": "物性分析仪器",
                                        "about": "指测量或检验粘性、多孔性、膨胀性、比重、湿度、表面张力及类似性能的仪器及装置。包括粘度计、偏振光镜、膨胀计、孔率计、渗透仪、浊度计、密度计、表面张力仪、rH（氧化还原值）计、比重计、湿度计、其他物性分析仪器。",
                                        "kws": "粘度计、偏振光镜、膨胀计、孔率计、渗透仪、浊度计、密度计、表面张力仪、rH计、氧化还原值计、比重计、湿度计",
                                        "taxName": "分析仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090605090000000000",
                                        "taxCodeTitle": "分析仪器",
                                        "iTitle": "*分析仪器*物性分析仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3623",
                                        "linkid": "3613",
                                        "code": "109060510",
                                        "paCode": "1090605",
                                        "yn": "N",
                                        "title": "气体分析测定装置",
                                        "alias": "气体分析测定装置",
                                        "about": "包括氮气计、微量气体分析器、氧浓度测定仪、弥散功能测试仪、压力型容积描绘仪、其他气体分析测定装置",
                                        "kws": "氮气计、微量气体分析器、氧浓度测定仪、弥散功能测试仪、压力型容积描绘仪",
                                        "taxName": "分析仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090605100000000000",
                                        "taxCodeTitle": "分析仪器",
                                        "iTitle": "*分析仪器*气体分析测定装置",
                                        "children": []
                                    },
                                    {
                                        "id": "3624",
                                        "linkid": "3613",
                                        "code": "109060511",
                                        "paCode": "1090605",
                                        "yn": "N",
                                        "title": "分析仪器及装置零件、附件",
                                        "alias": "分析仪器及装置零件、附件",
                                        "about": "包括理化分析、测量或检验粘性仪器的零附件",
                                        "kws": null,
                                        "taxName": "分析仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090605110000000000",
                                        "taxCodeTitle": "分析仪器",
                                        "iTitle": "*分析仪器*分析仪器及装置零件、附件",
                                        "children": []
                                    },
                                    {
                                        "id": "3625",
                                        "linkid": "3613",
                                        "code": "109060599",
                                        "paCode": "1090605",
                                        "yn": "N",
                                        "title": "其他分析仪器及装置",
                                        "alias": "其他分析仪器及装置",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "分析仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090605990000000000",
                                        "taxCodeTitle": "分析仪器",
                                        "iTitle": "*分析仪器*其他分析仪器及装置",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3626",
                                "linkid": "3572",
                                "code": "1090606",
                                "paCode": "10906",
                                "yn": "Y",
                                "title": "试验机械，相关检测仪器",
                                "alias": "试验机械，相关检测仪器",
                                "about": null,
                                "kws": null,
                                "taxName": "试验检测机械",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090606000000000000",
                                "taxCodeTitle": "试验检测机械",
                                "iTitle": "*试验检测机械*试验机械，相关检测仪器",
                                "children": [
                                    {
                                        "id": "3627",
                                        "linkid": "3626",
                                        "code": "109060601",
                                        "paCode": "1090606",
                                        "yn": "N",
                                        "title": "试验机",
                                        "alias": "试验机",
                                        "about": "指机械性能试验机械及器具；包括对各种材料（如金属、木材、混凝土、橡胶、塑料等）的硬度、弹性、抗张强度、可压缩性或其他机械性能的试验机械及器具。可分为金属材料试验机、非金属材料试验机、平衡试验机、探伤仪器、其他试验机。",
                                        "kws": "拉力试验机、金属硬度试验机、弯曲试验机、旋转弯折试验机、反转扭力试验机、复合应力试验机、冲击试验机、松弛试验机、蠕变试验机、持久强度试验机、疲劳试验机、延性试验机、折叠试验机、压缩试验机、剪切试验机、电磁疲劳试验机、电子万能试验机、硬度计、破裂强度试验仪、折叠试验仪、弹力计、回弹计、拉伸试验仪、耐磨试验机、塑度计、动平衡机、静平衡机、带电子平衡装置平衡机、超声波探伤机、X射线探伤机、工业X射线CT、γ射线探伤仪器、磁粉探伤机、电磁辐射探伤机、表面光洁度检验仪器、测量表面状况机械",
                                        "taxName": "试验检测机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090606010000000000",
                                        "taxCodeTitle": "试验检测机械",
                                        "iTitle": "*试验检测机械*试验机",
                                        "children": []
                                    },
                                    {
                                        "id": "3628",
                                        "linkid": "3626",
                                        "code": "109060602",
                                        "paCode": "1090606",
                                        "yn": "N",
                                        "title": "真空计",
                                        "alias": "真空计",
                                        "about": "测量真空度或气压的仪器",
                                        "kws": "真空计",
                                        "taxName": "试验检测机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090606020000000000",
                                        "taxCodeTitle": "试验检测机械",
                                        "iTitle": "*试验检测机械*真空计",
                                        "children": []
                                    },
                                    {
                                        "id": "3629",
                                        "linkid": "3626",
                                        "code": "109060603",
                                        "paCode": "1090606",
                                        "yn": "N",
                                        "title": "动力测试仪器",
                                        "alias": "动力测试仪器",
                                        "about": "包括电信号传递器、测功仪、测功器、压力测量仪器、油耗测量仪器、燃烧分析仪器、漏气量测量仪器、多参数测试装置、控制仪、动力测试专用校准仪器、其他动力测试仪器",
                                        "kws": "电信号传递器、测功仪、测功器、压力测量仪器、油耗测量仪器、燃烧分析仪器、漏气量测量仪器、多参数测试装置、控制仪、动力测试专用校准仪器",
                                        "taxName": "试验检测机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090606030000000000",
                                        "taxCodeTitle": "试验检测机械",
                                        "iTitle": "*试验检测机械*动力测试仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3630",
                                        "linkid": "3626",
                                        "code": "109060604",
                                        "paCode": "1090606",
                                        "yn": "N",
                                        "title": "天平仪器",
                                        "alias": "天平仪器",
                                        "about": "包括机械天平、电子天平、其他天平仪器，不包括差热天平（详见109060503）。",
                                        "kws": "机械天平、电子天平",
                                        "taxName": "试验检测机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090606040000000000",
                                        "taxCodeTitle": "试验检测机械",
                                        "iTitle": "*试验检测机械*天平仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3631",
                                        "linkid": "3626",
                                        "code": "109060605",
                                        "paCode": "1090606",
                                        "yn": "N",
                                        "title": "环境试验设备",
                                        "alias": "环境试验设备",
                                        "about": "指模仿环境温度、湿度、振动、冲击、盐雾、沙尘等实验的设备。包括力学环境试验设备、气候环境试验设备、可靠性试验设备、其他环境试验设备。",
                                        "kws": "振动试验台、冲击试验台、碰撞试验台、弹跳试验台、摇摆试验台、跌落试验台、运输试验台、稳态加速度试验机、声振试验设备、温度试验设备、生物培养设备、恒温箱、湿热试验设备、温度湿度试验设备、腐蚀试验设备、低气压试验设备、高气压试验设备、真空试验设备、老化试验设备、综合气候试验设备、防护试验设备、元器件标志耐久性试验设备、元器件引出端强度试验设备、引出端可焊性试验设备、引出端耐焊接热试验设备、阻容元件寿命试验设备、开关寿命试验设备、接插件寿命试验设备、电真空器件寿命试验设备、半导体器件寿命试验设备、集成电路寿命试",
                                        "taxName": "试验检测机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090606050000000000",
                                        "taxCodeTitle": "试验检测机械",
                                        "iTitle": "*试验检测机械*环境试验设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3632",
                                        "linkid": "3626",
                                        "code": "109060606",
                                        "paCode": "1090606",
                                        "yn": "N",
                                        "title": "产品、材料检验专用仪器",
                                        "alias": "产品、材料检验专用仪器",
                                        "about": "包括手表及零件检验专用仪器、材料厚度测量或检查仪器、光学加工用中心仪、其他产品、材料检验专用仪器",
                                        "kws": "游丝检验仪器、振幅计、电子校表仪、手表整机检验仪器、钢材厚度测量仪器、钢材厚度检查仪器、超声波厚度测量仪器、β射线厚度计、γ射线厚度计、光学加工用中心仪",
                                        "taxName": "试验检测机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090606060000000000",
                                        "taxCodeTitle": "试验检测机械",
                                        "iTitle": "*试验检测机械*产品、材料检验专用仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3633",
                                        "linkid": "3626",
                                        "code": "109060607",
                                        "paCode": "1090606",
                                        "yn": "N",
                                        "title": "检测器具及设备",
                                        "alias": "检测器具及设备",
                                        "about": "包括车辆发动机测试设备、制帽用头形量器、正弦规、铅垂线、校验标准器、多维测量设备、测微式标准测量机、振动、膨胀、冲击测定设备、测定粘土等收缩率仪器、应力及应变特殊电测量仪器、负荷传感器、电子记时计、电子计时仪、轮廓投影仪、其他检测器具及设备",
                                        "kws": "车辆发动机测试设备、制帽用头形量器、正弦规、铅垂线、校验标准器、多维测量设备、测微式标准测量机、振动测定设备、膨胀测定设备、冲击测定设备、收缩率仪器、应力特殊电测量仪器、应变特殊电测量仪器、负荷传感器、电子记时计、电子计时仪、轮廓投影仪",
                                        "taxName": "试验检测机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090606070000000000",
                                        "taxCodeTitle": "试验检测机械",
                                        "iTitle": "*试验检测机械*检测器具及设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3634",
                                        "linkid": "3626",
                                        "code": "109060608",
                                        "paCode": "1090606",
                                        "yn": "N",
                                        "title": "试验机械，相关检测仪器、器具零件",
                                        "alias": "试验机械，相关检测仪器、器具零件",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "试验检测机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090606080000000000",
                                        "taxCodeTitle": "试验检测机械",
                                        "iTitle": "*试验检测机械*试验机械，相关检测仪器、器具零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3635",
                                "linkid": "3572",
                                "code": "1090607",
                                "paCode": "10906",
                                "yn": "Y",
                                "title": "环境监测专用仪器仪表",
                                "alias": "环境监测专用仪器仪表",
                                "about": null,
                                "kws": null,
                                "taxName": "环境监测仪器",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090607000000000000",
                                "taxCodeTitle": "环境监测仪器",
                                "iTitle": "*环境监测仪器*环境监测专用仪器仪表",
                                "children": [
                                    {
                                        "id": "3636",
                                        "linkid": "3635",
                                        "code": "109060701",
                                        "paCode": "1090607",
                                        "yn": "N",
                                        "title": "水污染监测仪器",
                                        "alias": "水污染监测仪器",
                                        "about": "包括采水器、污水流量和液位计、沉淀物采样器、水质测试仪器、水质污染监测系统、水质污染遥测系统、其他水污染监测仪器",
                                        "kws": "采水器、污水流量计、液位计、沉淀物采样器、水质测试仪器、水质污染监测系统、水质污染遥测系统",
                                        "taxName": "环境监测仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090607010000000000",
                                        "taxCodeTitle": "环境监测仪器",
                                        "iTitle": "*环境监测仪器*水污染监测仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3637",
                                        "linkid": "3635",
                                        "code": "109060702",
                                        "paCode": "1090607",
                                        "yn": "N",
                                        "title": "气体或烟雾分析、检测仪器",
                                        "alias": "气体或烟雾分析、检测仪器",
                                        "about": "包括气体或烟雾分析仪、电子烟度检测器、沼气检定器、二氧化碳浓度检定器、尘埃仪、污染源采样器、空气环境质量测定仪、污染源污染物测定仪、其他气体或烟雾分析、检测仪器",
                                        "kws": "气体分析仪、烟雾分析仪、电子烟度检测器、沼气检定器、二氧化碳浓度检定器、尘埃仪、污染源采样器、空气环境质量测定仪、污染源污染物测定仪",
                                        "taxName": "环境监测仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090607020000000000",
                                        "taxCodeTitle": "环境监测仪器",
                                        "iTitle": "*环境监测仪器*气体或烟雾分析、检测仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3638",
                                        "linkid": "3635",
                                        "code": "109060703",
                                        "paCode": "1090607",
                                        "yn": "N",
                                        "title": "噪声监测仪器，相关环境监测仪器",
                                        "alias": "噪声监测仪器，相关环境监测仪器",
                                        "about": "包括噪声监测仪器、振动监测仪器等、放射性监测仪器、电磁波监测仪器、其他相关环境监测仪器",
                                        "kws": "噪声监测仪器、振动监测仪器、放射性监测仪器、电磁波监测仪器",
                                        "taxName": "环境监测仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090607030000000000",
                                        "taxCodeTitle": "环境监测仪器",
                                        "iTitle": "*环境监测仪器*噪声监测仪器，相关环境监测仪器",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3639",
                                "linkid": "3572",
                                "code": "1090608",
                                "paCode": "10906",
                                "yn": "Y",
                                "title": "汽车仪表，相关计数仪表",
                                "alias": "汽车仪表，相关计数仪表",
                                "about": null,
                                "kws": null,
                                "taxName": "汽车仪表",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090608000000000000",
                                "taxCodeTitle": "汽车仪表",
                                "iTitle": "*汽车仪表*汽车仪表，相关计数仪表",
                                "children": [
                                    {
                                        "id": "3640",
                                        "linkid": "3639",
                                        "code": "109060801",
                                        "paCode": "1090608",
                                        "yn": "N",
                                        "title": "汽车仪器仪表",
                                        "alias": "汽车仪器仪表",
                                        "about": "包括车辆用速度表、里程计、车费计价计、汽车油表、其他汽车仪器仪表",
                                        "kws": "车辆用速度表、里程计、车费计价计、汽车油表",
                                        "taxName": "汽车仪表",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090608010000000000",
                                        "taxCodeTitle": "汽车仪表",
                                        "iTitle": "*汽车仪表*汽车仪器仪表",
                                        "children": []
                                    },
                                    {
                                        "id": "3641",
                                        "linkid": "3639",
                                        "code": "109060802",
                                        "paCode": "1090608",
                                        "yn": "N",
                                        "title": "计数装置",
                                        "alias": "计数装置",
                                        "about": "包括转数计、产量计数器、步数计（计步器）、入场计数器、电子脉冲计数器、机器工作时间计数器、台球计分器、手揿计数器、其他计数装置",
                                        "kws": "转数计、产量计数器、步数计、计步器、入场计数器、电子脉冲计数器、机器工作时间计数器、台球计分器、手揿计数器",
                                        "taxName": "汽车仪表",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090608020000000000",
                                        "taxCodeTitle": "汽车仪表",
                                        "iTitle": "*汽车仪表*计数装置",
                                        "children": []
                                    },
                                    {
                                        "id": "3642",
                                        "linkid": "3639",
                                        "code": "109060803",
                                        "paCode": "1090608",
                                        "yn": "N",
                                        "title": "速度计及转速表",
                                        "alias": "速度计及转速表",
                                        "about": "指显示单位时间内的转数、速度、产量等速度计及转速表，包括速度测量仪表、精密计时系统、振荡式转速系统、离心式系统、电气式系统、其他速度计及转速表",
                                        "kws": "速度测量仪表、精密计时系统、振荡式转速系统、离心式系统、电气式系统",
                                        "taxName": "汽车仪表",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090608030000000000",
                                        "taxCodeTitle": "汽车仪表",
                                        "iTitle": "*汽车仪表*速度计及转速表",
                                        "children": []
                                    },
                                    {
                                        "id": "3643",
                                        "linkid": "3639",
                                        "code": "109060804",
                                        "paCode": "1090608",
                                        "yn": "N",
                                        "title": "汽车速测仪",
                                        "alias": "汽车速测仪",
                                        "about": "包括汽车电子速测仪、双像速测仪、自动归算速测仪、其他汽车速测仪",
                                        "kws": "汽车电子速测仪、双像速测仪、自动归算速测仪",
                                        "taxName": "汽车仪表",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090608040000000000",
                                        "taxCodeTitle": "汽车仪表",
                                        "iTitle": "*汽车仪表*汽车速测仪",
                                        "children": []
                                    },
                                    {
                                        "id": "3644",
                                        "linkid": "3639",
                                        "code": "109060805",
                                        "paCode": "1090608",
                                        "yn": "N",
                                        "title": "频闪观测仪",
                                        "alias": "频闪观测仪",
                                        "about": null,
                                        "kws": "频闪观测仪",
                                        "taxName": "汽车仪表",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090608050000000000",
                                        "taxCodeTitle": "汽车仪表",
                                        "iTitle": "*汽车仪表*频闪观测仪",
                                        "children": []
                                    },
                                    {
                                        "id": "3645",
                                        "linkid": "3639",
                                        "code": "109060806",
                                        "paCode": "1090608",
                                        "yn": "N",
                                        "title": "计数装置、速度计及转速表零件",
                                        "alias": "计数装置、速度计及转速表零件",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "汽车仪表",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090608060000000000",
                                        "taxCodeTitle": "汽车仪表",
                                        "iTitle": "*汽车仪表*计数装置、速度计及转速表零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3646",
                                "linkid": "3572",
                                "code": "1090609",
                                "paCode": "10906",
                                "yn": "Y",
                                "title": "导航仪器及装置",
                                "alias": "导航仪器及装置",
                                "about": null,
                                "kws": null,
                                "taxName": "导航仪器",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090609000000000000",
                                "taxCodeTitle": "导航仪器",
                                "iTitle": "*导航仪器*导航仪器及装置",
                                "children": [
                                    {
                                        "id": "3647",
                                        "linkid": "3646",
                                        "code": "109060901",
                                        "paCode": "1090609",
                                        "yn": "N",
                                        "title": "定向罗盘及定位系统",
                                        "alias": "定向罗盘及定位系统",
                                        "about": "包括定向罗盘、卫星定位系统（GPS）、激光导向仪",
                                        "kws": "罗盘仪、磁罗盘、陀螺罗盘、陀螺磁罗盘、航海罗经、卫星定位系统、GPS、激光导向仪",
                                        "taxName": "导航仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090609010000000000",
                                        "taxCodeTitle": "导航仪器",
                                        "iTitle": "*导航仪器*定向罗盘及定位系统",
                                        "children": []
                                    },
                                    {
                                        "id": "3648",
                                        "linkid": "3646",
                                        "code": "109060902",
                                        "paCode": "1090609",
                                        "yn": "N",
                                        "title": "航空或航天导航仪器及装置",
                                        "alias": "航空或航天导航仪器及装置",
                                        "about": "包括高度表、空速指示器、升降速度表、仿真地平仪及陀螺地平仪、转弯倾斜仪、马赫计、加速度计、自动驾驶仪、其他航空或航天导航仪器及装置，不包括定向罗盘及定位系统（详见109060901）。",
                                        "kws": "高度表、空速指示器、升降速度表、仿真地平仪、陀螺地平仪、转弯倾斜仪、马赫计、加速度计、自动驾驶仪",
                                        "taxName": "导航仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090609020000000000",
                                        "taxCodeTitle": "导航仪器",
                                        "iTitle": "*导航仪器*航空或航天导航仪器及装置",
                                        "children": []
                                    },
                                    {
                                        "id": "3649",
                                        "linkid": "3646",
                                        "code": "109060903",
                                        "paCode": "1090609",
                                        "yn": "N",
                                        "title": "船舶导航系统",
                                        "alias": "船舶导航系统",
                                        "about": "包括船舶定位仪器、船用天文导航设备、超声波探测或搜索设备、其他船舶导航系统",
                                        "kws": "罗经、六分仪、八分仪、方位角仪、计程仪、测深仪、自动舵、航线记录装置、倾斜仪、回声测深仪器、防潜仪、声纳",
                                        "taxName": "导航仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090609030000000000",
                                        "taxCodeTitle": "导航仪器",
                                        "iTitle": "*导航仪器*船舶导航系统",
                                        "children": []
                                    },
                                    {
                                        "id": "3650",
                                        "linkid": "3646",
                                        "code": "109060904",
                                        "paCode": "1090609",
                                        "yn": "N",
                                        "title": "导航仪器及装置零件、附件",
                                        "alias": "导航仪器及装置零件、附件",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "导航仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090609040000000000",
                                        "taxCodeTitle": "导航仪器",
                                        "iTitle": "*导航仪器*导航仪器及装置零件、附件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3651",
                                "linkid": "3572",
                                "code": "1090610",
                                "paCode": "10906",
                                "yn": "Y",
                                "title": "大地测量仪器",
                                "alias": "大地测量仪器",
                                "about": "包括大地测量、地形测量、水准测量或普通测量用的仪器及装置",
                                "kws": null,
                                "taxName": "大地测量仪器",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090610000000000000",
                                "taxCodeTitle": "大地测量仪器",
                                "iTitle": "*大地测量仪器*大地测量仪器",
                                "children": [
                                    {
                                        "id": "3652",
                                        "linkid": "3651",
                                        "code": "109061001",
                                        "paCode": "1090610",
                                        "yn": "N",
                                        "title": "测距仪",
                                        "alias": "测距仪",
                                        "about": "用于直接测量被测目标和测距仪的空间距离的仪器，包括光学测距仪、光电测距仪、微波测距仪、手持测距仪、其他测距仪",
                                        "kws": "光学测距仪、光电测距仪、微波测距仪、手持测距仪",
                                        "taxName": "大地测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090610010000000000",
                                        "taxCodeTitle": "大地测量仪器",
                                        "iTitle": "*大地测量仪器*测距仪",
                                        "children": []
                                    },
                                    {
                                        "id": "3653",
                                        "linkid": "3651",
                                        "code": "109061002",
                                        "paCode": "1090610",
                                        "yn": "N",
                                        "title": "经纬仪",
                                        "alias": "经纬仪",
                                        "about": "用于测量空间水平夹角和垂直夹角的仪器，包括光学经纬仪、电子经纬仪、激光经纬仪、陀螺经纬仪、其他经纬仪",
                                        "kws": "光学经纬仪、电子经纬仪、激光经纬仪、陀螺经纬仪",
                                        "taxName": "大地测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090610020000000000",
                                        "taxCodeTitle": "大地测量仪器",
                                        "iTitle": "*大地测量仪器*经纬仪",
                                        "children": []
                                    },
                                    {
                                        "id": "3654",
                                        "linkid": "3651",
                                        "code": "109061003",
                                        "paCode": "1090610",
                                        "yn": "N",
                                        "title": "电子速测仪",
                                        "alias": "电子速测仪",
                                        "about": "同时具有测量水平夹角、垂直夹角和距离功能的仪器，包括组合式电子速测仪、全站型电子速测仪、陀螺电子速测仪、其他电子速测仪",
                                        "kws": "组合式电子速测仪、全站型电子速测仪、陀螺电子速测仪",
                                        "taxName": "大地测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090610030000000000",
                                        "taxCodeTitle": "大地测量仪器",
                                        "iTitle": "*大地测量仪器*电子速测仪",
                                        "children": []
                                    },
                                    {
                                        "id": "3655",
                                        "linkid": "3651",
                                        "code": "109061004",
                                        "paCode": "1090610",
                                        "yn": "N",
                                        "title": "水准仪",
                                        "alias": "水准仪",
                                        "about": "用于测量空间两点高程差的，具有和视准轴垂直的竖轴的仪器，包括水准器水准仪、自动安平水准仪、数字水准仪、激光水准仪、其他水准仪",
                                        "kws": "水准器水准仪、自动安平水准仪、数字水准仪、激光水准仪",
                                        "taxName": "大地测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090610040000000000",
                                        "taxCodeTitle": "大地测量仪器",
                                        "iTitle": "*大地测量仪器*水准仪",
                                        "children": []
                                    },
                                    {
                                        "id": "3656",
                                        "linkid": "3651",
                                        "code": "109061005",
                                        "paCode": "1090610",
                                        "yn": "N",
                                        "title": "平板仪",
                                        "alias": "平板仪",
                                        "about": "在低精度地形测量中能同时测量和绘图的简易仪器",
                                        "kws": "一般平板仪、电子平板仪",
                                        "taxName": "大地测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090610050000000000",
                                        "taxCodeTitle": "大地测量仪器",
                                        "iTitle": "*大地测量仪器*平板仪",
                                        "children": []
                                    },
                                    {
                                        "id": "3657",
                                        "linkid": "3651",
                                        "code": "109061006",
                                        "paCode": "1090610",
                                        "yn": "N",
                                        "title": "垂准仪",
                                        "alias": "垂准仪",
                                        "about": "用于测量、监测垂直偏差或提供垂直基准线的仪器，包括光学垂准仪、自动安平垂准仪、激光垂准仪、其他垂准仪",
                                        "kws": "光学垂准仪、自动安平垂准仪、激光垂准仪",
                                        "taxName": "大地测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090610060000000000",
                                        "taxCodeTitle": "大地测量仪器",
                                        "iTitle": "*大地测量仪器*垂准仪",
                                        "children": []
                                    },
                                    {
                                        "id": "3658",
                                        "linkid": "3651",
                                        "code": "109061007",
                                        "paCode": "1090610",
                                        "yn": "N",
                                        "title": "建筑施工激光仪器",
                                        "alias": "建筑施工激光仪器",
                                        "about": "用于建筑施工中的利用可见激光作为指示和基准的仪器，包括激光扫平仪、激光投线仪、激光指向仪、其他建筑施工激光仪器",
                                        "kws": "激光扫平仪、激光投线仪、激光指向仪",
                                        "taxName": "大地测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090610070000000000",
                                        "taxCodeTitle": "大地测量仪器",
                                        "iTitle": "*大地测量仪器*建筑施工激光仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3659",
                                        "linkid": "3651",
                                        "code": "109061008",
                                        "paCode": "1090610",
                                        "yn": "N",
                                        "title": "空间扫描测量仪",
                                        "alias": "空间扫描测量仪",
                                        "about": "利用自动激光扫描测量获得被测目标表面空间点坐标的仪器，包括激光跟踪测量仪、三维激光扫描测量仪、断面扫描测量仪、其他空间扫描测量仪",
                                        "kws": "激光跟踪测量仪、三维激光扫描测量仪、断面扫描测量仪",
                                        "taxName": "大地测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090610080000000000",
                                        "taxCodeTitle": "大地测量仪器",
                                        "iTitle": "*大地测量仪器*空间扫描测量仪",
                                        "children": []
                                    },
                                    {
                                        "id": "3660",
                                        "linkid": "3651",
                                        "code": "109061009",
                                        "paCode": "1090610",
                                        "yn": "N",
                                        "title": "摄影测量系统",
                                        "alias": "摄影测量系统",
                                        "about": "利用照相摄影采集地表影像并通过图像数据处理进行测量和测绘的仪器系统，包括近景摄影测量系统、航空摄影测量系统、其他摄影测量系统",
                                        "kws": "近景摄影测量系统、航空摄影测量系统",
                                        "taxName": "大地测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090610090000000000",
                                        "taxCodeTitle": "大地测量仪器",
                                        "iTitle": "*大地测量仪器*摄影测量系统",
                                        "children": []
                                    },
                                    {
                                        "id": "3661",
                                        "linkid": "3651",
                                        "code": "109061010",
                                        "paCode": "1090610",
                                        "yn": "N",
                                        "title": "测量型GNSS接收机",
                                        "alias": "测量型GNSS接收机",
                                        "about": "用于测量的GNSS（全球导航卫星系统）信号接收机，包括测量型静态GNSS接收机、测量型实时差分GNSS接收机、其他测量型GNSS接收机",
                                        "kws": "测量型静态GNSS接收机、测量型实时差分GNSS接收机",
                                        "taxName": "大地测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090610100000000000",
                                        "taxCodeTitle": "大地测量仪器",
                                        "iTitle": "*大地测量仪器*测量型GNSS接收机",
                                        "children": []
                                    },
                                    {
                                        "id": "3662",
                                        "linkid": "3651",
                                        "code": "109061011",
                                        "paCode": "1090610",
                                        "yn": "N",
                                        "title": "大地测量仪器零件、附件",
                                        "alias": "大地测量仪器零件、附件",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "大地测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090610110000000000",
                                        "taxCodeTitle": "大地测量仪器",
                                        "iTitle": "*大地测量仪器*大地测量仪器零件、附件",
                                        "children": []
                                    },
                                    {
                                        "id": "3663",
                                        "linkid": "3651",
                                        "code": "109061099",
                                        "paCode": "1090610",
                                        "yn": "N",
                                        "title": "其他大地测量仪器",
                                        "alias": "其他大地测量仪器",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "大地测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090610990000000000",
                                        "taxCodeTitle": "大地测量仪器",
                                        "iTitle": "*大地测量仪器*其他大地测量仪器",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3664",
                                "linkid": "3572",
                                "code": "1090611",
                                "paCode": "10906",
                                "yn": "Y",
                                "title": "气象、水文仪器及装置",
                                "alias": "气象、水文仪器及装置",
                                "about": null,
                                "kws": null,
                                "taxName": "气象水文仪器",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090611000000000000",
                                "taxCodeTitle": "气象水文仪器",
                                "iTitle": "*气象水文仪器*气象、水文仪器及装置",
                                "children": [
                                    {
                                        "id": "3665",
                                        "linkid": "3664",
                                        "code": "109061101",
                                        "paCode": "1090611",
                                        "yn": "N",
                                        "title": "气象观测仪器",
                                        "alias": "气象观测仪器",
                                        "about": "包括气象专用测温仪器及温度传感器、气象专用测湿仪器及湿度传感器、温湿组合装置及温、湿传感器、测气压仪器、测风仪器、降水蒸发仪器、辐射、日照记录仪、测云仪、能见度仪、高空探测设备、气象仪器检定设备、其他气象观测仪器",
                                        "kws": "气象专用测温仪器、温度传感器、气象专用测湿仪器、湿度传感器、温湿记录仪、气压温湿记录仪、日光辐射计、测霜仪、测气压仪器、测风仪器、降水蒸发仪器、辐射记录仪、日照记录仪、测云仪、能见度仪、高空探测设备、气象仪器检定设备",
                                        "taxName": "气象水文仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090611010000000000",
                                        "taxCodeTitle": "气象水文仪器",
                                        "iTitle": "*气象水文仪器*气象观测仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3666",
                                        "linkid": "3664",
                                        "code": "109061102",
                                        "paCode": "1090611",
                                        "yn": "N",
                                        "title": "水文仪器",
                                        "alias": "水文仪器",
                                        "about": "包括海洋水文及其他水文仪器，可分为自动记录水位计、三用电导仪、旋杯式流速仪、旋桨式流速仪、涌浪或潮汐观测仪器、水动态测量仪、温度测量仪器、深度测量仪器、海冰测量仪器、多参数综合测量仪器、其他水文仪器",
                                        "kws": "自动记录水位计、三用电导仪、旋杯式流速仪、旋桨式流速仪、涌浪观测仪器、潮汐观测仪器、水动态测量仪、温度测量仪器、深度测量仪器、海冰测量仪器、多参数综合测量仪器",
                                        "taxName": "气象水文仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090611020000000000",
                                        "taxCodeTitle": "气象水文仪器",
                                        "iTitle": "*气象水文仪器*水文仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3667",
                                        "linkid": "3664",
                                        "code": "109061103",
                                        "paCode": "1090611",
                                        "yn": "N",
                                        "title": "气象、水文仪器及装置零件、附件",
                                        "alias": "气象、水文仪器及装置零件、附件",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "气象水文仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090611030000000000",
                                        "taxCodeTitle": "气象水文仪器",
                                        "iTitle": "*气象水文仪器*气象、水文仪器及装置零件、附件",
                                        "children": []
                                    },
                                    {
                                        "id": "3668",
                                        "linkid": "3664",
                                        "code": "109061199",
                                        "paCode": "1090611",
                                        "yn": "N",
                                        "title": "其他气象、水文仪器及装置",
                                        "alias": "其他气象、水文仪器及装置",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "气象水文仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090611990000000000",
                                        "taxCodeTitle": "气象水文仪器",
                                        "iTitle": "*气象水文仪器*其他气象、水文仪器及装置",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3669",
                                "linkid": "3572",
                                "code": "1090612",
                                "paCode": "10906",
                                "yn": "Y",
                                "title": "农林牧渔专用仪器仪表",
                                "alias": "农林牧渔专用仪器仪表",
                                "about": null,
                                "kws": null,
                                "taxName": "农用仪器仪表",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090612000000000000",
                                "taxCodeTitle": "农用仪器仪表",
                                "iTitle": "*农用仪器仪表*农林牧渔专用仪器仪表",
                                "children": [
                                    {
                                        "id": "3670",
                                        "linkid": "3669",
                                        "code": "109061201",
                                        "paCode": "1090612",
                                        "yn": "N",
                                        "title": "农、林专用仪器",
                                        "alias": "农、林专用仪器",
                                        "about": "包括土壤测试仪器、种子测试处理仪器、数粒仪、植物生长仪、叶绿素测定仪、活体叶绿素仪、光电叶面积仪、粮油检样器、木材水分测试仪、其他农、林专用仪器",
                                        "kws": "土壤测试仪器、种子测试处理仪器、数粒仪、植物生长仪、叶绿素测定仪、活体叶绿素仪、光电叶面积仪、粮油检样器、木材水分测试仪",
                                        "taxName": "农用仪器仪表",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090612010000000000",
                                        "taxCodeTitle": "农用仪器仪表",
                                        "iTitle": "*农用仪器仪表*农、林专用仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3671",
                                        "linkid": "3669",
                                        "code": "109061202",
                                        "paCode": "1090612",
                                        "yn": "N",
                                        "title": "牧业专用仪器",
                                        "alias": "牧业专用仪器",
                                        "about": "包括牧草生长仪、乳脂测定仪、测膘仪、牛胃金属异物探测仪、其他牧业专用仪器",
                                        "kws": "牧草生长仪、乳脂测定仪、测膘仪、牛胃金属异物探测仪",
                                        "taxName": "农用仪器仪表",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090612020000000000",
                                        "taxCodeTitle": "农用仪器仪表",
                                        "iTitle": "*农用仪器仪表*牧业专用仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3672",
                                        "linkid": "3669",
                                        "code": "109061203",
                                        "paCode": "1090612",
                                        "yn": "N",
                                        "title": "渔业专用仪器",
                                        "alias": "渔业专用仪器",
                                        "about": "包括探鱼仪、虾苗放流计数仪、其他渔业专用仪器",
                                        "kws": "探鱼仪、虾苗放流计数仪",
                                        "taxName": "农用仪器仪表",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090612030000000000",
                                        "taxCodeTitle": "农用仪器仪表",
                                        "iTitle": "*农用仪器仪表*渔业专用仪器",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3673",
                                "linkid": "3572",
                                "code": "1090613",
                                "paCode": "10906",
                                "yn": "Y",
                                "title": "地质勘探和地震专用仪器",
                                "alias": "地质勘探和地震专用仪器",
                                "about": "包括地质勘探、钻采、地震等地球物理专用仪器、仪表及类似装置",
                                "kws": null,
                                "taxName": "地质地震专用仪器",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090613000000000000",
                                "taxCodeTitle": "地质地震专用仪器",
                                "iTitle": "*地质地震专用仪器*地质勘探和地震专用仪器",
                                "children": [
                                    {
                                        "id": "3674",
                                        "linkid": "3673",
                                        "code": "109061301",
                                        "paCode": "1090613",
                                        "yn": "N",
                                        "title": "测震仪器",
                                        "alias": "测震仪器",
                                        "about": "包括甚宽频带测震仪器、宽频带测震仪器、短周期地震仪器、其他测震仪器",
                                        "kws": "甚宽频带测震仪器、宽频带测震仪器、短周期地震仪器",
                                        "taxName": "地质地震专用仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090613010000000000",
                                        "taxCodeTitle": "地质地震专用仪器",
                                        "iTitle": "*地质地震专用仪器*测震仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3675",
                                        "linkid": "3673",
                                        "code": "109061302",
                                        "paCode": "1090613",
                                        "yn": "N",
                                        "title": "地震前兆仪器",
                                        "alias": "地震前兆仪器",
                                        "about": "包括地下流体观测仪器、形变仪器、电磁仪器、强震仪器",
                                        "kws": "水位观测仪器、地温观测仪器、气体观测仪器、水准仪器、地倾斜观测仪器、钻孔应力应变观测仪器、硐体应变观测仪器、跨断层观测仪器、GPS观测仪器、重力观测仪器、地电阻率观测仪器、大地电场观测仪器、DI仪、磁力仪、电磁波观测仪器、地磁经纬仪、磁秤、自由场固定观测强震仪器、自由场流动观测强震仪器、结构观测台阵强震仪器",
                                        "taxName": "地质地震专用仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090613020000000000",
                                        "taxCodeTitle": "地质地震专用仪器",
                                        "iTitle": "*地质地震专用仪器*地震前兆仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3676",
                                        "linkid": "3673",
                                        "code": "109061303",
                                        "paCode": "1090613",
                                        "yn": "N",
                                        "title": "其他地震专用仪器",
                                        "alias": "其他地震专用仪器",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "地质地震专用仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090613030000000000",
                                        "taxCodeTitle": "地质地震专用仪器",
                                        "iTitle": "*地质地震专用仪器*其他地震专用仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3677",
                                        "linkid": "3673",
                                        "code": "109061304",
                                        "paCode": "1090613",
                                        "yn": "N",
                                        "title": "金属、矿藏探测器",
                                        "alias": "金属、矿藏探测器",
                                        "about": "包括金属探测器、井中物探仪器、核物探仪器、化探仪器、其他矿藏探测器",
                                        "kws": "金属探测器、井中物探仪器、核物探仪器、化探仪器",
                                        "taxName": "地质地震专用仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090613040000000000",
                                        "taxCodeTitle": "地质地震专用仪器",
                                        "iTitle": "*地质地震专用仪器*金属、矿藏探测器",
                                        "children": []
                                    },
                                    {
                                        "id": "3678",
                                        "linkid": "3673",
                                        "code": "109061305",
                                        "paCode": "1090613",
                                        "yn": "N",
                                        "title": "钻探测试、分析仪器",
                                        "alias": "钻探测试、分析仪器",
                                        "about": "包括钻探测井仪器、泥浆分析仪器、岩矿物理性质测量仪、其他钻探测试、分析仪器",
                                        "kws": "钻探测井仪器、泥浆分析仪器、岩矿物理性质测量仪",
                                        "taxName": "地质地震专用仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090613050000000000",
                                        "taxCodeTitle": "地质地震专用仪器",
                                        "iTitle": "*地质地震专用仪器*钻探测试、分析仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3679",
                                        "linkid": "3673",
                                        "code": "109061306",
                                        "paCode": "1090613",
                                        "yn": "N",
                                        "title": "金属、矿藏探测器零件",
                                        "alias": "金属、矿藏探测器零件",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "地质地震专用仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090613060000000000",
                                        "taxCodeTitle": "地质地震专用仪器",
                                        "iTitle": "*地质地震专用仪器*金属、矿藏探测器零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3680",
                                "linkid": "3572",
                                "code": "1090614",
                                "paCode": "10906",
                                "yn": "Y",
                                "title": "教学专用仪器",
                                "alias": "教学专用仪器",
                                "about": "包括各种专供示范（例如，学校、教室及展览会中所用）而无其他用途的仪器、装置及模型",
                                "kws": null,
                                "taxName": "教学专用仪器",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090614000000000000",
                                "taxCodeTitle": "教学专用仪器",
                                "iTitle": "*教学专用仪器*教学专用仪器",
                                "children": [
                                    {
                                        "id": "3681",
                                        "linkid": "3680",
                                        "code": "109061401",
                                        "paCode": "1090614",
                                        "yn": "N",
                                        "title": "电气化教学设备",
                                        "alias": "电气化教学设备",
                                        "about": "包括教学演示瓦特表、教学演示用直流电流表、教学演示用直流电压电表、教学演示交流电表、教学演示用交流电压电表、其他电气化教学设备",
                                        "kws": "教学演示瓦特表、教学演示用直流电流表、教学演示用直流电压电表、教学演示交流电表、教学演示用交流电压电表",
                                        "taxName": "教学专用仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090614010000000000",
                                        "taxCodeTitle": "教学专用仪器",
                                        "iTitle": "*教学专用仪器*电气化教学设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3682",
                                        "linkid": "3680",
                                        "code": "109061402",
                                        "paCode": "1090614",
                                        "yn": "N",
                                        "title": "供示范用机器或装置",
                                        "alias": "供示范用机器或装置",
                                        "about": "包括维姆休斯特起电机、阿特伍德机械、马德堡半球、格氏环、牛顿盘、其他供示范用机器或装置",
                                        "kws": "维姆休斯特起电机、阿特伍德机械、马德堡半球、格氏环、牛顿盘",
                                        "taxName": "教学专用仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090614020000000000",
                                        "taxCodeTitle": "教学专用仪器",
                                        "iTitle": "*教学专用仪器*供示范用机器或装置",
                                        "children": []
                                    },
                                    {
                                        "id": "3683",
                                        "linkid": "3680",
                                        "code": "109061499",
                                        "paCode": "1090614",
                                        "yn": "N",
                                        "title": "其他教学专用仪器",
                                        "alias": "其他教学专用仪器",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "教学专用仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090614990000000000",
                                        "taxCodeTitle": "教学专用仪器",
                                        "iTitle": "*教学专用仪器*其他教学专用仪器",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3684",
                                "linkid": "3572",
                                "code": "1090615",
                                "paCode": "10906",
                                "yn": "Y",
                                "title": "核子及核辐射测量仪器",
                                "alias": "核子及核辐射测量仪器",
                                "about": null,
                                "kws": null,
                                "taxName": "核辐射测量仪器",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090615000000000000",
                                "taxCodeTitle": "核辐射测量仪器",
                                "iTitle": "*核辐射测量仪器*核子及核辐射测量仪器",
                                "children": [
                                    {
                                        "id": "3685",
                                        "linkid": "3684",
                                        "code": "109061501",
                                        "paCode": "1090615",
                                        "yn": "N",
                                        "title": "离子射线测量或检验仪器",
                                        "alias": "离子射线测量或检验仪器",
                                        "about": "指α射线、β射线、γ射线、Ｘ射线、宇宙射线或其他离子射线的测量或检验仪器及装置，包括带有电离室检测仪器、盖革计数器、电离室、辐射剂量仪及类似设备、测量宇宙射线设备、热电堆中子探测仪器、热电堆中子测量仪器、射线测量或探测仪器、其他离子射线测量或检验仪器",
                                        "kws": "带有电离室检测仪器、盖革计数器、电离室、辐射剂量仪、测量宇宙射线设备、热电堆中子探测仪器、热电堆中子测量仪器、射线测量、探测仪器",
                                        "taxName": "核辐射测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090615010000000000",
                                        "taxCodeTitle": "核辐射测量仪器",
                                        "iTitle": "*核辐射测量仪器*离子射线测量或检验仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3686",
                                        "linkid": "3684",
                                        "code": "109061502",
                                        "paCode": "1090615",
                                        "yn": "N",
                                        "title": "离子射线应用设备",
                                        "alias": "离子射线应用设备",
                                        "about": "包括离子射线检验设备、离子射线测量仪器设备、电离风速计、其他离子射线应用设备",
                                        "kws": "离子射线检验设备、离子射线测量仪器设备、电离风速计",
                                        "taxName": "核辐射测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090615020000000000",
                                        "taxCodeTitle": "核辐射测量仪器",
                                        "iTitle": "*核辐射测量仪器*离子射线应用设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3687",
                                        "linkid": "3684",
                                        "code": "109061503",
                                        "paCode": "1090615",
                                        "yn": "N",
                                        "title": "核辐射监测报警仪器",
                                        "alias": "核辐射监测报警仪器",
                                        "about": "包括射线烟雾探测器火灾报警器、核辐射剂量监测报警仪器、核反应堆用记录、监测仪器、核反应堆用报警仪器、其他核辐射监测报警仪器",
                                        "kws": "射线烟雾探测器火灾报警器、核辐射剂量监测报警仪器、核反应堆用记录、监测仪器、核反应堆用报警仪器",
                                        "taxName": "核辐射测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090615030000000000",
                                        "taxCodeTitle": "核辐射测量仪器",
                                        "iTitle": "*核辐射测量仪器*核辐射监测报警仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3688",
                                        "linkid": "3684",
                                        "code": "109061504",
                                        "paCode": "1090615",
                                        "yn": "N",
                                        "title": "放射性物体加工计量仪器",
                                        "alias": "放射性物体加工计量仪器",
                                        "about": null,
                                        "kws": "放射性物体加工计量仪器",
                                        "taxName": "核辐射测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090615040000000000",
                                        "taxCodeTitle": "核辐射测量仪器",
                                        "iTitle": "*核辐射测量仪器*放射性物体加工计量仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3689",
                                        "linkid": "3684",
                                        "code": "109061505",
                                        "paCode": "1090615",
                                        "yn": "N",
                                        "title": "辐照加工用仪器设备",
                                        "alias": "辐照加工用仪器设备",
                                        "about": null,
                                        "kws": "辐照加工用仪器设备",
                                        "taxName": "核辐射测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090615050000000000",
                                        "taxCodeTitle": "核辐射测量仪器",
                                        "iTitle": "*核辐射测量仪器*辐照加工用仪器设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3690",
                                        "linkid": "3684",
                                        "code": "109061506",
                                        "paCode": "1090615",
                                        "yn": "N",
                                        "title": "辐射无损检测、探伤仪器",
                                        "alias": "辐射无损检测、探伤仪器",
                                        "about": null,
                                        "kws": "辐射无损检测、探伤仪器",
                                        "taxName": "核辐射测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090615060000000000",
                                        "taxCodeTitle": "核辐射测量仪器",
                                        "iTitle": "*核辐射测量仪器*辐射无损检测、探伤仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3691",
                                        "linkid": "3684",
                                        "code": "109061599",
                                        "paCode": "1090615",
                                        "yn": "N",
                                        "title": "其他核子及核辐射测量仪器",
                                        "alias": "其他核子及核辐射测量仪器",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "核辐射测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090615990000000000",
                                        "taxCodeTitle": "核辐射测量仪器",
                                        "iTitle": "*核辐射测量仪器*其他核子及核辐射测量仪器",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3692",
                                "linkid": "3572",
                                "code": "1090616",
                                "paCode": "10906",
                                "yn": "Y",
                                "title": "光学、电子测量仪器",
                                "alias": "光学、电子测量仪器",
                                "about": null,
                                "kws": null,
                                "taxName": "光电测量仪器",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090616000000000000",
                                "taxCodeTitle": "光电测量仪器",
                                "iTitle": "*光电测量仪器*光学、电子测量仪器",
                                "children": [
                                    {
                                        "id": "3693",
                                        "linkid": "3692",
                                        "code": "109061601",
                                        "paCode": "1090616",
                                        "yn": "N",
                                        "title": "光学检测仪器及设备",
                                        "alias": "光学检测仪器及设备",
                                        "about": "包括氦质谱检漏台、半导体器件光学检验仪器、光学或分度尺比较仪、光学表面检查仪、光学测角仪或角规、比长仪工作台、干涉仪、校直望远镜、光学尺、测微读数装置、焦距计、其他光学检测仪器及设备",
                                        "kws": "氦质谱检漏台、半导体器件光学检验仪器、光学比较仪、分度尺比较仪、光学表面检查仪、光学测角仪、光学测角规、比长仪工作台、干涉仪、校直望远镜、光学尺、测微读数装置、焦距计",
                                        "taxName": "光电测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090616010000000000",
                                        "taxCodeTitle": "光电测量仪器",
                                        "iTitle": "*光电测量仪器*光学检测仪器及设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3694",
                                        "linkid": "3692",
                                        "code": "109061602",
                                        "paCode": "1090616",
                                        "yn": "N",
                                        "title": "通信测量仪器",
                                        "alias": "通信测量仪器",
                                        "about": "包括有线通信测量仪器、无线通信测量仪器、移动通信测量仪器、光通信测量仪器、光纤特性测量仪器、网络通信测量仪器、基站测量仪器、手机测量仪器、其他通信测量仪器",
                                        "kws": "有线通信测量仪器、无线通信测量仪器、移动通信测量仪器、光通信测量仪器、光纤特性测量仪器、网络通信测量仪器、基站测量仪器、手机测量仪器",
                                        "taxName": "光电测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090616020000000000",
                                        "taxCodeTitle": "光电测量仪器",
                                        "iTitle": "*光电测量仪器*通信测量仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3695",
                                        "linkid": "3692",
                                        "code": "109061603",
                                        "paCode": "1090616",
                                        "yn": "N",
                                        "title": "通用电子测量仪器",
                                        "alias": "通用电子测量仪器",
                                        "about": "包括频率测量仪器、电子计数器、时间测量仪器、电压测量仪器、LCR电桥、电子元器件参数测量仪器、信号发生器（通用电子）、脉冲测量仪器、频谱波形分析仪、逻辑分析仪（通用电子）、频谱分析仪（通用电子）、扫频仪、网络分析仪、功率计及探头、噪声系数测试仪、超低频测量仪、总线测量仪器",
                                        "kws": "数字脉冲频率测量仪器、模拟式频率测量仪器、电子计数器扩频装置、特种计数器、频率标准、校频比相仪、电子计数器、时间测量仪器、直流数字电压表、高频数字电压表、数字多用表、电压标准装置、模拟式电压表、数字面板表、LCR电桥、半导体器件图示仪、数字存储半导体器件图示仪、电力电子器件测试仪、光电器件测试仪、低频信号发生器、高频信号发生器、超高频信号发生器、微波信号发生器、功率信号发生器、扫描信号发生器、频率合成信号发生器、数字合成信号发生器、数字信号发生器、函数信号发生器、脉冲测量仪器、失真度测量仪、频偏调制度测量",
                                        "taxName": "光电测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090616030000000000",
                                        "taxCodeTitle": "光电测量仪器",
                                        "iTitle": "*光电测量仪器*通用电子测量仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3696",
                                        "linkid": "3692",
                                        "code": "109061604",
                                        "paCode": "1090616",
                                        "yn": "N",
                                        "title": "广播电视测量仪器",
                                        "alias": "广播电视测量仪器",
                                        "about": "包括音视频测量仪器、数字电视测量仪器",
                                        "kws": "音视频测量仪器、数字电视测量仪器",
                                        "taxName": "光电测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090616040000000000",
                                        "taxCodeTitle": "光电测量仪器",
                                        "iTitle": "*光电测量仪器*广播电视测量仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3697",
                                        "linkid": "3692",
                                        "code": "109061605",
                                        "paCode": "1090616",
                                        "yn": "N",
                                        "title": "新型显示器件测量仪器",
                                        "alias": "新型显示器件测量仪器",
                                        "about": "包括TFT-LCD、PDP、OLED平板显示器件测试仪器、LED发光器件测量仪器、其他新型显示器件测量仪器",
                                        "kws": "TFT-LCD平板显示器件测试仪器、PDP平板显示器件测试仪器、OLED平板显示器件测试仪器、LED发光器件测量仪器",
                                        "taxName": "光电测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090616050000000000",
                                        "taxCodeTitle": "光电测量仪器",
                                        "iTitle": "*光电测量仪器*新型显示器件测量仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3698",
                                        "linkid": "3692",
                                        "code": "109061606",
                                        "paCode": "1090616",
                                        "yn": "N",
                                        "title": "新型材料测试仪器",
                                        "alias": "新型材料测试仪器",
                                        "about": "包括半导体材料测试仪器、新型显示器件材料测试仪器、光电子材料测试仪器、磁性材料测试仪器、电子功能材料测试仪器、其他新型材料测试仪器",
                                        "kws": "半导体材料测试仪器、新型显示器件材料测试仪器、光电子材料测试仪器、磁性材料测试仪器、电子功能材料测试仪器",
                                        "taxName": "光电测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090616060000000000",
                                        "taxCodeTitle": "光电测量仪器",
                                        "iTitle": "*光电测量仪器*新型材料测试仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3699",
                                        "linkid": "3692",
                                        "code": "109061607",
                                        "paCode": "1090616",
                                        "yn": "N",
                                        "title": "集成电路测试仪器",
                                        "alias": "集成电路测试仪器",
                                        "about": "包括数字IC测试仪、混合IC测试仪、SOC测试仪、边界扫描测试仪、其他集成电路测试仪器",
                                        "kws": "数字IC测试仪、混合IC测试仪、SOC测试仪、边界扫描测试仪",
                                        "taxName": "光电测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090616070000000000",
                                        "taxCodeTitle": "光电测量仪器",
                                        "iTitle": "*光电测量仪器*集成电路测试仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3700",
                                        "linkid": "3692",
                                        "code": "109061608",
                                        "paCode": "1090616",
                                        "yn": "N",
                                        "title": "微波测量仪器",
                                        "alias": "微波测量仪器",
                                        "about": "包括微波网络特性测试仪及网络分析仪、雷达综合测试仪、微波功率放大器、微波漏能测试仪、微波同轴器件、微波波导器件、微波集成器件、其他微波测量仪器",
                                        "kws": "微波网络特性测试仪、网络分析仪、雷达综合测试仪、微波功率放大器、微波漏能测试仪、微波同轴器件、微波波导器件、微波集成器件",
                                        "taxName": "光电测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090616080000000000",
                                        "taxCodeTitle": "光电测量仪器",
                                        "iTitle": "*光电测量仪器*微波测量仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3701",
                                        "linkid": "3692",
                                        "code": "109061609",
                                        "paCode": "1090616",
                                        "yn": "N",
                                        "title": "印制电路板测量仪器",
                                        "alias": "印制电路板测量仪器",
                                        "about": null,
                                        "kws": "印制电路板测量仪器",
                                        "taxName": "光电测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090616090000000000",
                                        "taxCodeTitle": "光电测量仪器",
                                        "iTitle": "*光电测量仪器*印制电路板测量仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3702",
                                        "linkid": "3692",
                                        "code": "109061610",
                                        "paCode": "1090616",
                                        "yn": "N",
                                        "title": "声学测量仪器",
                                        "alias": "声学测量仪器",
                                        "about": "包括声级计和噪声测量仪、电声测量仪、震动测量仪、噪声显示屏",
                                        "kws": "声震信号发生器、声级计、实时信号分析仪、电声测量仪、震动测量仪、噪声显示屏",
                                        "taxName": "光电测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090616100000000000",
                                        "taxCodeTitle": "光电测量仪器",
                                        "iTitle": "*光电测量仪器*声学测量仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3703",
                                        "linkid": "3692",
                                        "code": "109061611",
                                        "paCode": "1090616",
                                        "yn": "N",
                                        "title": "干扰场强测量仪器",
                                        "alias": "干扰场强测量仪器",
                                        "about": null,
                                        "kws": "干扰场强测量仪器",
                                        "taxName": "光电测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090616110000000000",
                                        "taxCodeTitle": "光电测量仪器",
                                        "iTitle": "*光电测量仪器*干扰场强测量仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3704",
                                        "linkid": "3692",
                                        "code": "109061612",
                                        "paCode": "1090616",
                                        "yn": "N",
                                        "title": "电子测量仪器零、附件",
                                        "alias": "电子测量仪器零、附件",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "光电测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090616120000000000",
                                        "taxCodeTitle": "光电测量仪器",
                                        "iTitle": "*光电测量仪器*电子测量仪器零、附件",
                                        "children": []
                                    },
                                    {
                                        "id": "3705",
                                        "linkid": "3692",
                                        "code": "109061699",
                                        "paCode": "1090616",
                                        "yn": "N",
                                        "title": "其他光学、电子测量仪器",
                                        "alias": "其他光学、电子测量仪器",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "光电测量仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090616990000000000",
                                        "taxCodeTitle": "光电测量仪器",
                                        "iTitle": "*光电测量仪器*其他光学、电子测量仪器",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3706",
                                "linkid": "3572",
                                "code": "1090617",
                                "paCode": "10906",
                                "yn": "Y",
                                "title": "纺织仪器，相关专用测试仪器",
                                "alias": "纺织仪器，相关专用测试仪器",
                                "about": null,
                                "kws": null,
                                "taxName": "纺织仪器",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090617000000000000",
                                "taxCodeTitle": "纺织仪器",
                                "iTitle": "*纺织仪器*纺织仪器，相关专用测试仪器",
                                "children": [
                                    {
                                        "id": "3707",
                                        "linkid": "3706",
                                        "code": "109061701",
                                        "paCode": "1090617",
                                        "yn": "N",
                                        "title": "纺织专用测试仪器",
                                        "alias": "纺织专用测试仪器",
                                        "about": "包括纺织品测试仪器、检验纺织材料设备",
                                        "kws": "纱线分级卷取机、纱线分级卷绕机、扭力计、扭力记录器、拉力计、纱线直径测量仪器、均匀度检测仪器、纺织品测力计、伸长计、耐磨试验仪、织物平磨仪",
                                        "taxName": "纺织仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090617010000000000",
                                        "taxCodeTitle": "纺织仪器",
                                        "iTitle": "*纺织仪器*纺织专用测试仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3708",
                                        "linkid": "3706",
                                        "code": "109061799",
                                        "paCode": "1090617",
                                        "yn": "N",
                                        "title": "其他纺织相关专用测试仪器",
                                        "alias": "其他纺织相关专用测试仪器",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "纺织仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090617990000000000",
                                        "taxCodeTitle": "纺织仪器",
                                        "iTitle": "*纺织仪器*其他纺织相关专用测试仪器",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3709",
                                "linkid": "3572",
                                "code": "1090618",
                                "paCode": "10906",
                                "yn": "Y",
                                "title": "钟表与计时仪器",
                                "alias": "钟表与计时仪器",
                                "about": null,
                                "kws": null,
                                "taxName": "钟表",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090618000000000000",
                                "taxCodeTitle": "钟表",
                                "iTitle": "*钟表*钟表与计时仪器",
                                "children": [
                                    {
                                        "id": "3710",
                                        "linkid": "3709",
                                        "code": "109061801",
                                        "paCode": "1090618",
                                        "yn": "N",
                                        "title": "钟",
                                        "alias": "钟",
                                        "about": "包括石英电子钟、机械钟、电波钟、设备、仪器仪表用钟、其他钟，不包括考勤钟等时间记录器及类似计时仪器（详见109061807）。",
                                        "kws": "表心石英钟、石英闹钟、石英挂钟、石英天文钟、石英落地钟、表心机械钟、机械闹钟、机械挂钟、机械落地钟、电波钟、仪表板钟、车辆用钟、航空器用钟、航天器用钟、船舶用钟",
                                        "taxName": "钟表",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090618010000000000",
                                        "taxCodeTitle": "钟表",
                                        "iTitle": "*钟表*钟",
                                        "children": []
                                    },
                                    {
                                        "id": "3711",
                                        "linkid": "3709",
                                        "code": "109061802",
                                        "paCode": "1090618",
                                        "yn": "N",
                                        "title": "高档手表",
                                        "alias": "高档手表",
                                        "about": "销售价格（不含增值税）每只在10000元（含）以上的各类手表。包括石英电子手表、机械手表、电波表、其他手表",
                                        "kws": "#石英电子手表、机械手表、电波表、其他手表",
                                        "taxName": "钟表",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090618020000000000",
                                        "taxCodeTitle": "钟表",
                                        "iTitle": "*钟表*高档手表",
                                        "children": []
                                    },
                                    {
                                        "id": "3712",
                                        "linkid": "3709",
                                        "code": "109061803",
                                        "paCode": "1090618",
                                        "yn": "N",
                                        "title": "其他表",
                                        "alias": "其他表",
                                        "about": "不包括高档手表（详见109061802)、停车计时表、时刻记录器等时间记录器及类似计时仪器（详见109061807）。",
                                        "kws": "石英电子手表、石英电子怀表、石英电子秒表、石英电子盲人表、机械手表、机械怀表、机械秒表、机械盲人表、电波表",
                                        "taxName": "钟表",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090618030000000000",
                                        "taxCodeTitle": "钟表",
                                        "iTitle": "*钟表*其他表",
                                        "children": []
                                    },
                                    {
                                        "id": "3713",
                                        "linkid": "3709",
                                        "code": "109061804",
                                        "paCode": "1090618",
                                        "yn": "N",
                                        "title": "组装钟表机心",
                                        "alias": "组装钟表机心",
                                        "about": "指已组装的完整钟表心，包括表机心（石英电子表心、机械表心、其他表机心）、钟机心（其他钟机心、机械表心、其他表机心）",
                                        "kws": "指针式电子表心、数字显示电子表心、自动上弦完整表心、石英电子钟机心、机械钟机心",
                                        "taxName": "钟表",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090618040000000000",
                                        "taxCodeTitle": "钟表",
                                        "iTitle": "*钟表*组装钟表机心",
                                        "children": []
                                    },
                                    {
                                        "id": "3714",
                                        "linkid": "3709",
                                        "code": "109061805",
                                        "paCode": "1090618",
                                        "yn": "N",
                                        "title": "未组装钟表机心",
                                        "alias": "未组装钟表机心",
                                        "about": "包括未组装或部分组装完整钟表心，不完整钟表心，包括未组装表机心、未组装钟机心",
                                        "kws": "未组装完整表机心、已组装不完整表机心、未组装完整钟机心、不完整钟机心",
                                        "taxName": "钟表",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090618050000000000",
                                        "taxCodeTitle": "钟表",
                                        "iTitle": "*钟表*未组装钟表机心",
                                        "children": []
                                    },
                                    {
                                        "id": "3715",
                                        "linkid": "3709",
                                        "code": "109061806",
                                        "paCode": "1090618",
                                        "yn": "N",
                                        "title": "定时器",
                                        "alias": "定时器",
                                        "about": "包括定时开关，指装有钟、表机心或同步电动机，能在设定时间段（通常根据每日或每周预先设定的时间或程序所规定的时间段）报时或自动接通或断开电源的装置。可分为电子式定时器、机械式定时器、其他定时器",
                                        "kws": "电风扇用电子式定时器、洗衣机用电子式定时器、电烤箱用电子式定时器、电风扇用机械式定时器、洗衣机用机械式定时器、电烤箱用机械式定时器、机械式响铃定时器",
                                        "taxName": "钟表",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090618060000000000",
                                        "taxCodeTitle": "钟表",
                                        "iTitle": "*钟表*定时器",
                                        "children": []
                                    },
                                    {
                                        "id": "3716",
                                        "linkid": "3709",
                                        "code": "109061807",
                                        "paCode": "1090618",
                                        "yn": "N",
                                        "title": "时间记录器及类似计时仪器",
                                        "alias": "时间记录器及类似计时仪器",
                                        "about": "指包括记录、测量或指示时间的装置，可分为考勤钟、时刻记录器、停车计时表、时段测量仪、其他时间记录器及类似计时仪器",
                                        "kws": "考勤钟、时刻记录器、停车计时表、时段测量仪",
                                        "taxName": "钟表",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090618070000000000",
                                        "taxCodeTitle": "钟表",
                                        "iTitle": "*钟表*时间记录器及类似计时仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3717",
                                        "linkid": "3709",
                                        "code": "109061808",
                                        "paCode": "1090618",
                                        "yn": "N",
                                        "title": "钟表零配件",
                                        "alias": "钟表零配件",
                                        "about": "可分为钟表元配件、表壳及其零件、钟壳及其零件，不包括已组装的完整表机心和钟机心（详见109061804），以及未组装钟表机心（含未组装或部分组装完整钟表机心和不完整钟表机心）（详见109061805）。",
                                        "kws": "钟表发条、钟表宝石轴承、钟盘、表盘、钟表夹板、表壳、钟壳",
                                        "taxName": "钟表",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090618080000000000",
                                        "taxCodeTitle": "钟表",
                                        "iTitle": "*钟表*钟表零配件",
                                        "children": []
                                    },
                                    {
                                        "id": "3718",
                                        "linkid": "3709",
                                        "code": "109061809",
                                        "paCode": "1090618",
                                        "yn": "N",
                                        "title": "表带及其零件",
                                        "alias": "表带及其零件",
                                        "about": "包括贵金属表带、其他金属表带及其零件、皮革制表带、化纤制表带、塑料制表带、其他非金属表带及其零件",
                                        "kws": "表带",
                                        "taxName": "钟表",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090618090000000000",
                                        "taxCodeTitle": "钟表",
                                        "iTitle": "*钟表*表带及其零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3719",
                                "linkid": "3572",
                                "code": "1090619",
                                "paCode": "10906",
                                "yn": "Y",
                                "title": "光学仪器、零件及附件",
                                "alias": "光学仪器、零件及附件",
                                "about": null,
                                "kws": null,
                                "taxName": "光学仪器",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090619000000000000",
                                "taxCodeTitle": "光学仪器",
                                "iTitle": "*光学仪器*光学仪器、零件及附件",
                                "children": [
                                    {
                                        "id": "3720",
                                        "linkid": "3719",
                                        "code": "109061901",
                                        "paCode": "1090619",
                                        "yn": "N",
                                        "title": "光学望远镜",
                                        "alias": "光学望远镜",
                                        "about": "包括望远镜座架，可分为双筒望远镜、天文望远镜、单筒望远镜、其他光学望远镜",
                                        "kws": "眼镜式望远镜、目镜变倍型双筒望远镜、狩猎用双筒望远镜、电子天文望远镜、单筒望远镜",
                                        "taxName": "光学仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090619010000000000",
                                        "taxCodeTitle": "光学仪器",
                                        "iTitle": "*光学仪器*光学望远镜",
                                        "children": []
                                    },
                                    {
                                        "id": "3721",
                                        "linkid": "3719",
                                        "code": "109061902",
                                        "paCode": "1090619",
                                        "yn": "N",
                                        "title": "天文仪器",
                                        "alias": "天文仪器",
                                        "about": "包括中星仪、赤道仪、天顶仪、地平经纬仪、地平经度度盘、日光摄谱仪、日光观测镜、定天镜、量日仪、日冕仪、其他天文仪器，不包括天文望远镜（详见109061901）。",
                                        "kws": "中星仪、赤道仪、天顶仪、地平经纬仪、地平经度度盘、日光摄谱仪、日光观测镜、定天镜、量日仪、日冕仪",
                                        "taxName": "光学仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090619020000000000",
                                        "taxCodeTitle": "光学仪器",
                                        "iTitle": "*光学仪器*天文仪器",
                                        "children": []
                                    },
                                    {
                                        "id": "3722",
                                        "linkid": "3719",
                                        "code": "109061903",
                                        "paCode": "1090619",
                                        "yn": "N",
                                        "title": "显微镜",
                                        "alias": "显微镜",
                                        "about": "包括光学显微镜、医用非光学显微镜设备、电子显微镜、质子显微镜、其他显微镜",
                                        "kws": "生物显微镜、体视显微镜、金相显微镜、偏光显微镜、检测显微镜、医用非光学显微镜设备、扫描电子显微镜、质子显微镜",
                                        "taxName": "光学仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090619030000000000",
                                        "taxCodeTitle": "光学仪器",
                                        "iTitle": "*光学仪器*显微镜",
                                        "children": []
                                    },
                                    {
                                        "id": "3723",
                                        "linkid": "3719",
                                        "code": "109061904",
                                        "paCode": "1090619",
                                        "yn": "N",
                                        "title": "望远镜瞄准具及类似器具",
                                        "alias": "望远镜瞄准具及类似器具",
                                        "about": "包括武器望远瞄准具、潜望望远镜、仪器或器具部件望远镜、激光器及激光器系统、放大镜、光学门眼、光学光束信号设备、体视镜、其他望远镜瞄准具及类似器具",
                                        "kws": "武器望远瞄准具、潜望望远镜、激光器、激光器系统、手术放大镜、双目放大镜、织物分析镜、手持式放大镜、放大器、光学门眼、光学光束信号设备、体视镜",
                                        "taxName": "光学仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090619040000000000",
                                        "taxCodeTitle": "光学仪器",
                                        "iTitle": "*光学仪器*望远镜瞄准具及类似器具",
                                        "children": []
                                    },
                                    {
                                        "id": "3724",
                                        "linkid": "3719",
                                        "code": "109061905",
                                        "paCode": "1090619",
                                        "yn": "N",
                                        "title": "物镜",
                                        "alias": "物镜",
                                        "about": "包括照相机用物镜、摄影机用物镜、放映机用物镜、缩微阅读机用物镜、放大机用物镜、缩片机用物镜、投影仪用物镜、其他物镜",
                                        "kws": "物镜",
                                        "taxName": "光学仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090619050000000000",
                                        "taxCodeTitle": "光学仪器",
                                        "iTitle": "*光学仪器*物镜",
                                        "children": []
                                    },
                                    {
                                        "id": "3725",
                                        "linkid": "3719",
                                        "code": "109061906",
                                        "paCode": "1090619",
                                        "yn": "N",
                                        "title": "已装配光学元件",
                                        "alias": "已装配光学元件",
                                        "about": "可分为滤色镜、照相机用附加镜、照相机用取景器、偏振滤光镜、目镜及物镜、棱镜、透镜、反射镜、已装配半色调网屏、其他已装配光学元件，不包括物镜（详见109061905）。",
                                        "kws": "滤色镜、照相机用附加镜、照相机用取景器、偏振滤光镜、目镜、物镜、棱镜、透镜、反射镜、已装配半色调网屏",
                                        "taxName": "光学仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090619060000000000",
                                        "taxCodeTitle": "光学仪器",
                                        "iTitle": "*光学仪器*已装配光学元件",
                                        "children": []
                                    },
                                    {
                                        "id": "3726",
                                        "linkid": "3719",
                                        "code": "109061907",
                                        "paCode": "1090619",
                                        "yn": "N",
                                        "title": "偏振材料制片及板",
                                        "alias": "偏振材料制片及板",
                                        "about": null,
                                        "kws": "偏振材料制片、偏振材料制板",
                                        "taxName": "光学仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090619070000000000",
                                        "taxCodeTitle": "光学仪器",
                                        "iTitle": "*光学仪器*偏振材料制片及板",
                                        "children": []
                                    },
                                    {
                                        "id": "3727",
                                        "linkid": "3719",
                                        "code": "109061908",
                                        "paCode": "1090619",
                                        "yn": "N",
                                        "title": "光学仪器零件、附件",
                                        "alias": "光学仪器零件、附件",
                                        "about": "包括光学望远镜及天文仪器零件、复式光学显微镜零件、附件、其他光学仪器零件、附件",
                                        "kws": null,
                                        "taxName": "光学仪器",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090619080000000000",
                                        "taxCodeTitle": "光学仪器",
                                        "iTitle": "*光学仪器*光学仪器零件、附件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3728",
                                "linkid": "3572",
                                "code": "1090620",
                                "paCode": "10906",
                                "yn": "Y",
                                "title": "眼镜类产品及其零部件和眼镜盒",
                                "alias": "眼镜类产品及其零部件和眼镜盒",
                                "about": null,
                                "kws": null,
                                "taxName": "眼镜类产品",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1090620000000000000",
                                "taxCodeTitle": "眼镜类产品",
                                "iTitle": "*眼镜类产品*眼镜类产品及其零部件和眼镜盒",
                                "children": [
                                    {
                                        "id": "3729",
                                        "linkid": "3728",
                                        "code": "109062001",
                                        "paCode": "1090620",
                                        "yn": "N",
                                        "title": "眼镜成镜",
                                        "alias": "眼镜成镜",
                                        "about": "包括矫正视力用眼镜、护目眼镜",
                                        "kws": "眼镜、老花成镜、低视力助视镜、太阳眼镜、运动眼镜、防护眼镜、活络眼镜、水下作业用护目镜、偏光立体电影专用眼镜",
                                        "taxName": "眼镜类产品",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090620010000000000",
                                        "taxCodeTitle": "眼镜类产品",
                                        "iTitle": "*眼镜类产品*眼镜成镜",
                                        "children": []
                                    },
                                    {
                                        "id": "3730",
                                        "linkid": "3728",
                                        "code": "109062002",
                                        "paCode": "1090620",
                                        "yn": "N",
                                        "title": "眼镜片",
                                        "alias": "眼镜片",
                                        "about": "包括角膜接触镜（隐形眼镜）、光学玻璃制眼镜片、树脂材料制眼镜片、其他眼镜片",
                                        "kws": "角膜接触镜、隐形眼镜、光学玻璃制矫正视力用眼镜片、光学玻璃制太阳眼镜片、光学玻璃制变色眼镜片、树脂材料制矫正视力用眼镜片、树脂材料制太阳眼镜片、树脂材料制变色眼镜片",
                                        "taxName": "眼镜类产品",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090620020000000000",
                                        "taxCodeTitle": "眼镜类产品",
                                        "iTitle": "*眼镜类产品*眼镜片",
                                        "children": []
                                    },
                                    {
                                        "id": "3731",
                                        "linkid": "3728",
                                        "code": "109062003",
                                        "paCode": "1090620",
                                        "yn": "N",
                                        "title": "眼镜框架及其零件",
                                        "alias": "眼镜框架及其零件",
                                        "about": "包括眼镜脚及眼镜脚芯、铰链或接头、镜圈、鼻梁架、托叶、夹鼻眼镜的弹簧装置、长柄眼镜的柄把等",
                                        "kws": "眼镜框架、眼镜脚、眼镜脚芯",
                                        "taxName": "眼镜类产品",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090620030000000000",
                                        "taxCodeTitle": "眼镜类产品",
                                        "iTitle": "*眼镜类产品*眼镜框架及其零件",
                                        "children": []
                                    },
                                    {
                                        "id": "3732",
                                        "linkid": "3728",
                                        "code": "109062004",
                                        "paCode": "1090620",
                                        "yn": "N",
                                        "title": "眼镜盒（袋）",
                                        "alias": "眼镜盒（袋）",
                                        "about": "一种为了携带方便而用于盛放眼镜的工具",
                                        "kws": "眼镜盒、眼镜袋",
                                        "taxName": "眼镜类产品",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090620040000000000",
                                        "taxCodeTitle": "眼镜类产品",
                                        "iTitle": "*眼镜类产品*眼镜盒（袋）",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3733",
                                "linkid": "3572",
                                "code": "1090621",
                                "paCode": "10906",
                                "yn": "Y",
                                "title": "电影机械",
                                "alias": "电影机械",
                                "about": null,
                                "kws": null,
                                "taxName": "电影机械",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090621000000000000",
                                "taxCodeTitle": "电影机械",
                                "iTitle": "*电影机械*电影机械",
                                "children": [
                                    {
                                        "id": "3734",
                                        "linkid": "3733",
                                        "code": "109062101",
                                        "paCode": "1090621",
                                        "yn": "N",
                                        "title": "电影摄影机",
                                        "alias": "电影摄影机",
                                        "about": "包括普通电影摄影机、特种电影摄影机、同期录音电影摄影机",
                                        "kws": "普通电影摄影机、高速摄影机、立体电影摄影机、环幕电影摄影机、球幕电影摄影机、字幕动画电影摄影机、特技合成摄影机、空中摄影机、水下摄影设备、同期录音电影摄影机",
                                        "taxName": "电影机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090621010000000000",
                                        "taxCodeTitle": "电影机械",
                                        "iTitle": "*电影机械*电影摄影机",
                                        "children": []
                                    },
                                    {
                                        "id": "3735",
                                        "linkid": "3733",
                                        "code": "109062102",
                                        "paCode": "1090621",
                                        "yn": "N",
                                        "title": "电影放映机",
                                        "alias": "电影放映机",
                                        "about": "包括模拟、数字电影放映机，可分为固定式电影放映机、便携式电影放映机、数字电影放映机、流动式数字电影放映设备、其他电影放映机",
                                        "kws": "固定式电影放映机、便携式电影放映机、数字电影放映机、流动式数字电影放映设备",
                                        "taxName": "电影机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090621020000000000",
                                        "taxCodeTitle": "电影机械",
                                        "iTitle": "*电影机械*电影放映机",
                                        "children": []
                                    },
                                    {
                                        "id": "3736",
                                        "linkid": "3733",
                                        "code": "109062103",
                                        "paCode": "1090621",
                                        "yn": "N",
                                        "title": "电路投影装置",
                                        "alias": "电路投影装置",
                                        "about": "指将电路绘制到感光半导体材料上的装置，包括直接记录到晶片上装置、分步重复校准器、其他电路投影装置",
                                        "kws": "直接记录到晶片上装置、分步重复校准器",
                                        "taxName": "电影机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090621030000000000",
                                        "taxCodeTitle": "电影机械",
                                        "iTitle": "*电影机械*电路投影装置",
                                        "children": []
                                    },
                                    {
                                        "id": "3737",
                                        "linkid": "3733",
                                        "code": "109062104",
                                        "paCode": "1090621",
                                        "yn": "N",
                                        "title": "银幕",
                                        "alias": "银幕",
                                        "about": "包括电影银幕、投影屏幕",
                                        "kws": "电影银幕、投影屏幕",
                                        "taxName": "电影机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090621040000000000",
                                        "taxCodeTitle": "电影机械",
                                        "iTitle": "*电影机械*银幕",
                                        "children": []
                                    },
                                    {
                                        "id": "3738",
                                        "linkid": "3733",
                                        "code": "109062105",
                                        "paCode": "1090621",
                                        "yn": "N",
                                        "title": "电影设备零件和附件",
                                        "alias": "电影设备零件和附件",
                                        "about": "包括电影摄影机零件、附件、电影放映机零件、附件",
                                        "kws": null,
                                        "taxName": "电影机械",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090621050000000000",
                                        "taxCodeTitle": "电影机械",
                                        "iTitle": "*电影机械*电影设备零件和附件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3739",
                                "linkid": "3572",
                                "code": "1090622",
                                "paCode": "10906",
                                "yn": "Y",
                                "title": "照相机及器材",
                                "alias": "照相机及器材",
                                "about": null,
                                "kws": null,
                                "taxName": "照相器材",
                                "taxRate": "",
                                "vip": "3",
                                "itaxRate": null,
                                "taxCode": "1090622000000000000",
                                "taxCodeTitle": "照相器材",
                                "iTitle": "*照相器材*照相机及器材",
                                "children": [
                                    {
                                        "id": "3740",
                                        "linkid": "3739",
                                        "code": "109062201",
                                        "paCode": "1090622",
                                        "yn": "N",
                                        "title": "照相机",
                                        "alias": "照相机",
                                        "about": "包括通用照相机、数码照相机、制版照相机、专用特种照相机",
                                        "kws": "单镜头反光照相机、透视取景照相机、数码单镜头反光照相机、普通数码照相机、电子分色机、缩微照相机、水下照相机、航空照相机、一次成相照相机、医用照相机、大地摄影测量用照相机",
                                        "taxName": "照相器材",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090622010000000000",
                                        "taxCodeTitle": "照相器材",
                                        "iTitle": "*照相器材*照相机",
                                        "children": []
                                    },
                                    {
                                        "id": "3741",
                                        "linkid": "3739",
                                        "code": "109062202",
                                        "paCode": "1090622",
                                        "yn": "N",
                                        "title": "照相机器材",
                                        "alias": "照相机器材",
                                        "about": "包括闪光灯装置、照片放大机、照片缩片机、其他照相机器材",
                                        "kws": "放电式闪光灯装置、电子式闪光灯装置、内藏式闪光灯装置、通用外接闪光灯装置、专用外接闪光灯装置、照片放大机、照片缩片机",
                                        "taxName": "照相器材",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090622020000000000",
                                        "taxCodeTitle": "照相器材",
                                        "iTitle": "*照相器材*照相机器材",
                                        "children": []
                                    },
                                    {
                                        "id": "3742",
                                        "linkid": "3739",
                                        "code": "109062203",
                                        "paCode": "1090622",
                                        "yn": "N",
                                        "title": "缩微设备",
                                        "alias": "缩微设备",
                                        "about": "不包括缩微照相机（详见109062201），可分为缩微胶卷阅读机、缩微胶片阅读机、缩微胶片装片机、缩微品检索设备、缩微品阅读复印机、缩微品放大复印机、其他缩微设备",
                                        "kws": "缩微胶卷阅读机、缩微胶片阅读机、缩微胶片装片机、缩微品检索设备、缩微品阅读复印机、缩微品放大复印机",
                                        "taxName": "照相器材",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090622030000000000",
                                        "taxCodeTitle": "照相器材",
                                        "iTitle": "*照相器材*缩微设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3743",
                                        "linkid": "3739",
                                        "code": "109062204",
                                        "paCode": "1090622",
                                        "yn": "N",
                                        "title": "照相机、缩微阅读机零件",
                                        "alias": "照相机、缩微阅读机零件",
                                        "about": "包括照相机零件、附件、照相闪光灯装置零件、缩微阅读机零件、照片放大机及缩片机零件",
                                        "kws": "照相机自动调焦组件、照相机用快门组件、照相闪光灯装置零件、缩微阅读机零件、照片放大机、缩片机零件",
                                        "taxName": "照相器材",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090622040000000000",
                                        "taxCodeTitle": "照相器材",
                                        "iTitle": "*照相器材*照相机、缩微阅读机零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3744",
                                "linkid": "3572",
                                "code": "1090623",
                                "paCode": "10906",
                                "yn": "Y",
                                "title": "照相及电影洗印设备",
                                "alias": "照相及电影洗印设备",
                                "about": null,
                                "kws": null,
                                "taxName": "照相器材",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090623000000000000",
                                "taxCodeTitle": "照相器材",
                                "iTitle": "*照相器材*照相及电影洗印设备",
                                "children": [
                                    {
                                        "id": "3745",
                                        "linkid": "3744",
                                        "code": "109062301",
                                        "paCode": "1090623",
                                        "yn": "N",
                                        "title": "自动洗印设备",
                                        "alias": "自动洗印设备",
                                        "about": "包括照相胶卷或成卷感光纸的自动洗印设备，可分为电影胶卷自动洗印设备、特种照相用胶卷自动洗印设备、成卷感光纸自动洗印设备、彩色胶卷洗印设备、数码冲印设备、公安数码制证设备、其他自动洗印设备",
                                        "kws": "电影胶卷自动洗印设备、特种照相用胶卷自动洗印设备、成卷感光纸自动洗印设备、彩色胶卷洗印设备、数码冲印设备、公安数码制证设备",
                                        "taxName": "照相器材",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090623010000000000",
                                        "taxCodeTitle": "照相器材",
                                        "iTitle": "*照相器材*自动洗印设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3746",
                                        "linkid": "3744",
                                        "code": "109062302",
                                        "paCode": "1090623",
                                        "yn": "N",
                                        "title": "非自动洗印用装置和设备",
                                        "alias": "非自动洗印用装置和设备",
                                        "about": "照相、电影洗印用其他装置和设备，包括负片显示器、胶片分裁机、胶片拷贝机、印片机、上光机（照相洗印用）、电影片缩印机、放大印片机、光学技巧机、同步配音控制设备、影片剪辑设备、加工处理影片剪辑台、影片字幕放映设备、数码片夹、其他非自动洗印用装置和设备",
                                        "kws": "负片显示器、胶片分裁机、胶片拷贝机、印片机、照相洗印用上光机、电影片缩印机、放大印片机、光学技巧机、同步配音控制设备、影片剪辑设备、加工处理影片剪辑台、影片字幕放映设备、数码片夹",
                                        "taxName": "照相器材",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090623020000000000",
                                        "taxCodeTitle": "照相器材",
                                        "iTitle": "*照相器材*非自动洗印用装置和设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3747",
                                        "linkid": "3744",
                                        "code": "109062303",
                                        "paCode": "1090623",
                                        "yn": "N",
                                        "title": "照相及电影洗印设备零件",
                                        "alias": "照相及电影洗印设备零件",
                                        "about": "包括照相及电影通用洗印设备及装置的零件、附件",
                                        "kws": null,
                                        "taxName": "照相器材",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090623030000000000",
                                        "taxCodeTitle": "照相器材",
                                        "iTitle": "*照相器材*照相及电影洗印设备零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3748",
                                "linkid": "3572",
                                "code": "1090624",
                                "paCode": "10906",
                                "yn": "Y",
                                "title": "影像投影仪",
                                "alias": "影像投影仪",
                                "about": "包括用于学校、课室等的幻灯机和其他静止影像投影仪",
                                "kws": null,
                                "taxName": "影像投影仪",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "1090624000000000000",
                                "taxCodeTitle": "影像投影仪",
                                "iTitle": "*影像投影仪*影像投影仪",
                                "children": [
                                    {
                                        "id": "3749",
                                        "linkid": "3748",
                                        "code": "109062401",
                                        "paCode": "1090624",
                                        "yn": "N",
                                        "title": "幻灯机",
                                        "alias": "幻灯机",
                                        "about": "包括小型幻灯机、大型固定式幻灯机，可分为自动程序控制幻灯机、氙灯光源幻灯机、其他幻灯机",
                                        "kws": "幻灯机",
                                        "taxName": "影像投影仪",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090624010000000000",
                                        "taxCodeTitle": "影像投影仪",
                                        "iTitle": "*影像投影仪*幻灯机",
                                        "children": []
                                    },
                                    {
                                        "id": "3750",
                                        "linkid": "3748",
                                        "code": "109062402",
                                        "paCode": "1090624",
                                        "yn": "N",
                                        "title": "投影仪",
                                        "alias": "投影仪",
                                        "about": "电影用影像投影仪除外（详见109062102），包括正射投影仪、光谱投影仪、显微投影仪、透射式投影仪、反射式投影仪、其他投影仪",
                                        "kws": "投影仪",
                                        "taxName": "影像投影仪",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090624020000000000",
                                        "taxCodeTitle": "影像投影仪",
                                        "iTitle": "*影像投影仪*投影仪",
                                        "children": []
                                    },
                                    {
                                        "id": "3751",
                                        "linkid": "3748",
                                        "code": "109062403",
                                        "paCode": "1090624",
                                        "yn": "N",
                                        "title": "幻灯及投影设备附件、零件",
                                        "alias": "幻灯及投影设备附件、零件",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "影像投影仪",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090624030000000000",
                                        "taxCodeTitle": "影像投影仪",
                                        "iTitle": "*影像投影仪*幻灯及投影设备附件、零件",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3752",
                                "linkid": "3572",
                                "code": "1090625",
                                "paCode": "10906",
                                "yn": "Y",
                                "title": "复印和胶版印制设备",
                                "alias": "复印和胶版印制设备",
                                "about": null,
                                "kws": null,
                                "taxName": "复印胶版印制设备",
                                "taxRate": "",
                                "vip": "3",
                                "itaxRate": null,
                                "taxCode": "1090625000000000000",
                                "taxCodeTitle": "复印胶版印制设备",
                                "iTitle": "*复印胶版印制设备*复印和胶版印制设备",
                                "children": [
                                    {
                                        "id": "3753",
                                        "linkid": "3752",
                                        "code": "109062501",
                                        "paCode": "1090625",
                                        "yn": "N",
                                        "title": "静电复印设备",
                                        "alias": "静电复印设备",
                                        "about": "采用静电方式将原稿通过光导鼓成像方式复制文件或图像的设备，包括模拟式复印设备、数字式复印设备、多功能一体机、多功能印刷机或印艺系统、喷墨复印机、重氮复印机（晒图机）、热敏复印设备、银盐复印设备",
                                        "kws": "彩色模拟式静电复印机、黑白模拟式静电复印机、彩色数字式静电复印机、黑白数字式静电复印机、多功能一体机、多功能印刷机、多功能印艺系统、彩色喷墨复印机、黑白喷墨复印机、氨熏式晒图机、无氨式晒图机、多色热敏复印设备、多色银盐复印设备",
                                        "taxName": "复印胶版印制设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090625010000000000",
                                        "taxCodeTitle": "复印胶版印制设备",
                                        "iTitle": "*复印胶版印制设备*静电复印设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3754",
                                        "linkid": "3752",
                                        "code": "109062502",
                                        "paCode": "1090625",
                                        "yn": "N",
                                        "title": "胶印设备",
                                        "alias": "胶印设备",
                                        "about": "采用水墨分离原理，将事先制好的印版复制成印品的设备；包括A2或A2以下幅面的单色小胶印机、彩色（或多色）小胶印机",
                                        "kws": "胶印设备",
                                        "taxName": "复印胶版印制设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090625020000000000",
                                        "taxCodeTitle": "复印胶版印制设备",
                                        "iTitle": "*复印胶版印制设备*胶印设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3755",
                                        "linkid": "3752",
                                        "code": "109062503",
                                        "paCode": "1090625",
                                        "yn": "N",
                                        "title": "办公印刷设备",
                                        "alias": "办公印刷设备",
                                        "about": "采用油墨在事先制好的镂板上印刷方式的设备，包括油印机、速印机、胶版复印机、其他办公印刷设备",
                                        "kws": "油印机、速印机、胶版复印机",
                                        "taxName": "复印胶版印制设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090625030000000000",
                                        "taxCodeTitle": "复印胶版印制设备",
                                        "iTitle": "*复印胶版印制设备*办公印刷设备",
                                        "children": []
                                    },
                                    {
                                        "id": "3756",
                                        "linkid": "3752",
                                        "code": "109062504",
                                        "paCode": "1090625",
                                        "yn": "N",
                                        "title": "复印设备配套装置、零件",
                                        "alias": "复印设备配套装置、零件",
                                        "about": "包括文件自动送入器、送纸器、分页器、盖章装置、有机光导体感光鼓、成像卡盒组件（总成）、黑色显影剂及装置、彩色显影剂及装置、其他复印设备配套装置、零件",
                                        "kws": "文件自动送入器、送纸器、分页器、盖章装置、有机光导体感光鼓、成像卡盒组件、黑色显影剂、黑色显影装置、彩色显影剂、彩色显影装置",
                                        "taxName": "复印胶版印制设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090625040000000000",
                                        "taxCodeTitle": "复印胶版印制设备",
                                        "iTitle": "*复印胶版印制设备*复印设备配套装置、零件",
                                        "children": []
                                    },
                                    {
                                        "id": "3757",
                                        "linkid": "3752",
                                        "code": "109062599",
                                        "paCode": "1090625",
                                        "yn": "N",
                                        "title": "其他复印和胶版印制设备",
                                        "alias": "其他复印和胶版印制设备",
                                        "about": null,
                                        "kws": "工程图纸复印机",
                                        "taxName": "复印胶版印制设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090625990000000000",
                                        "taxCodeTitle": "复印胶版印制设备",
                                        "iTitle": "*复印胶版印制设备*其他复印和胶版印制设备",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3758",
                                "linkid": "3572",
                                "code": "1090626",
                                "paCode": "10906",
                                "yn": "Y",
                                "title": "计算器及货币专用设备",
                                "alias": "计算器及货币专用设备",
                                "about": "包括金融、商业、交通及办公等使用的电子计算器、具有计算功能的数据记录、重现和显示机器，以及货币专用设备及类似机械",
                                "kws": null,
                                "taxName": "计算器货币专用设备",
                                "taxRate": "",
                                "vip": "3",
                                "itaxRate": null,
                                "taxCode": "1090626000000000000",
                                "taxCodeTitle": "计算器货币专用设备",
                                "iTitle": "*计算器货币专用设备*计算器及货币专用设备",
                                "children": [
                                    {
                                        "id": "3759",
                                        "linkid": "3758",
                                        "code": "109062601",
                                        "paCode": "1090626",
                                        "yn": "Y",
                                        "title": "装有计算和电子装置设备",
                                        "alias": "装有计算和电子装置设备",
                                        "about": "包括电子计算器、会计计算机、现金出纳机、转账POS机、售票机、税控机、条码打印机、其他装有计算和电子装置设备",
                                        "kws": null,
                                        "taxName": "计算器货币专用设备",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "1090626010000000000",
                                        "taxCodeTitle": "计算器货币专用设备",
                                        "iTitle": "*计算器货币专用设备*装有计算和电子装置设备",
                                        "children": [
                                            {
                                                "id": "3760",
                                                "linkid": "3759",
                                                "code": "10906260101",
                                                "paCode": "109062601",
                                                "yn": "N",
                                                "title": "税控加油机",
                                                "alias": "税控加油机",
                                                "about": null,
                                                "kws": "税控加油机",
                                                "taxName": "税控加油机",
                                                "taxRate": "13%",
                                                "vip": "5",
                                                "itaxRate": "0.13",
                                                "taxCode": "1090626010100000000",
                                                "taxCodeTitle": "税控加油机",
                                                "iTitle": "*税控加油机*税控加油机",
                                                "children": []
                                            },
                                            {
                                                "id": "3761",
                                                "linkid": "3759",
                                                "code": "10906260102",
                                                "paCode": "109062601",
                                                "yn": "N",
                                                "title": "税控收款机",
                                                "alias": "税控收款机",
                                                "about": null,
                                                "kws": "税控收款机",
                                                "taxName": "税控收款机",
                                                "taxRate": "13%",
                                                "vip": "5",
                                                "itaxRate": "0.13",
                                                "taxCode": "1090626010200000000",
                                                "taxCodeTitle": "税控收款机",
                                                "iTitle": "*税控收款机*税控收款机",
                                                "children": []
                                            },
                                            {
                                                "id": "3762",
                                                "linkid": "3759",
                                                "code": "10906260199",
                                                "paCode": "109062601",
                                                "yn": "N",
                                                "title": "其他装有计算和电子装置设备",
                                                "alias": "其他装有计算和电子装置设备",
                                                "about": null,
                                                "kws": null,
                                                "taxName": "计算器货币专用设备",
                                                "taxRate": "13%",
                                                "vip": "7",
                                                "itaxRate": "0.13",
                                                "taxCode": "1090626019900000000",
                                                "taxCodeTitle": "计算器货币专用设备",
                                                "iTitle": "*计算器货币专用设备*其他装有计算和电子装置设备",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "3763",
                                        "linkid": "3758",
                                        "code": "109062602",
                                        "paCode": "1090626",
                                        "yn": "N",
                                        "title": "银行专用机器",
                                        "alias": "银行专用机器",
                                        "about": "包括自动柜员机（ATM机）、硬币分类机、硬币计数机、验钞机、点钞机、清分机、复点机、自动登折机、其他银行专用机器",
                                        "kws": "自动柜员机、ATM机、硬币分类机、硬币计数机、验钞机、点钞机、清分机、复点机、自动登折机",
                                        "taxName": "计算器货币专用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090626020000000000",
                                        "taxCodeTitle": "计算器货币专用设备",
                                        "iTitle": "*计算器货币专用设备*银行专用机器",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3764",
                                "linkid": "3572",
                                "code": "1090627",
                                "paCode": "10906",
                                "yn": "Y",
                                "title": "文化、办公用设备或器具",
                                "alias": "文化、办公用设备或器具",
                                "about": "包括文件分页、装订、折页等文件处理、办公室其他机械设备",
                                "kws": null,
                                "taxName": "文化办公用设备",
                                "taxRate": "",
                                "vip": "3",
                                "itaxRate": null,
                                "taxCode": "1090627000000000000",
                                "taxCodeTitle": "文化办公用设备",
                                "iTitle": "*文化办公用设备*文化、办公用设备或器具",
                                "children": [
                                    {
                                        "id": "3765",
                                        "linkid": "3764",
                                        "code": "109062701",
                                        "paCode": "1090627",
                                        "yn": "N",
                                        "title": "打字机及文字处理机",
                                        "alias": "打字机及文字处理机",
                                        "about": "包括打字机、文字处理机",
                                        "kws": "打字机、文字处理机",
                                        "taxName": "文化办公用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090627010000000000",
                                        "taxCodeTitle": "文化办公用设备",
                                        "iTitle": "*文化办公用设备*打字机及文字处理机",
                                        "children": []
                                    },
                                    {
                                        "id": "3766",
                                        "linkid": "3764",
                                        "code": "109062702",
                                        "paCode": "1090627",
                                        "yn": "N",
                                        "title": "削笔类用具",
                                        "alias": "削笔类用具",
                                        "about": "包括手动削笔机、电动削笔机、卷笔刀、削笔刀、其他削笔类用具",
                                        "kws": "手动削笔机、电动削笔机、卷笔刀、削笔刀",
                                        "taxName": "文化办公用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090627020000000000",
                                        "taxCodeTitle": "文化办公用设备",
                                        "iTitle": "*文化办公用设备*削笔类用具",
                                        "children": []
                                    },
                                    {
                                        "id": "3767",
                                        "linkid": "3764",
                                        "code": "109062703",
                                        "paCode": "1090627",
                                        "yn": "N",
                                        "title": "文件装订用机械",
                                        "alias": "文件装订用机械",
                                        "about": "不包括订书枪、装订书籍用的订书机器（详见109022203），可分为订书机、打孔机、订折机、其他文件装订用机械",
                                        "kws": "订书机、打孔机、订折机",
                                        "taxName": "文化办公用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090627030000000000",
                                        "taxCodeTitle": "文化办公用设备",
                                        "iTitle": "*文化办公用设备*文件装订用机械",
                                        "children": []
                                    },
                                    {
                                        "id": "3768",
                                        "linkid": "3764",
                                        "code": "109062799",
                                        "paCode": "1090627",
                                        "yn": "N",
                                        "title": "其他文化、办公用设备或器具",
                                        "alias": "其他文化、办公用设备或器具",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "文化办公用设备",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1090627990000000000",
                                        "taxCodeTitle": "文化办公用设备",
                                        "iTitle": "*文化办公用设备*其他文化、办公用设备或器具",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3769",
                                "linkid": "3572",
                                "code": "1090699",
                                "paCode": "10906",
                                "yn": "N",
                                "title": "其他仪器仪表及文化、办公用机械",
                                "alias": "其他仪器仪表及文化、办公用机械",
                                "about": null,
                                "kws": null,
                                "taxName": "其他仪器仪表机械",
                                "taxRate": "13%",
                                "vip": "7",
                                "itaxRate": "0.13",
                                "taxCode": "1090699000000000000",
                                "taxCodeTitle": "其他仪器仪表机械",
                                "iTitle": "*其他仪器仪表机械*其他仪器仪表及文化、办公用机械",
                                "children": []
                            }
                        ]
                    },
                    {
                        "id": "3770",
                        "linkid": "2501",
                        "code": "10999",
                        "paCode": "109",
                        "yn": "N",
                        "title": "其他机械、设备类产品",
                        "alias": "其他机械、设备类产品",
                        "about": null,
                        "kws": "电子秤",
                        "taxName": "其他机械设备",
                        "taxRate": "13%",
                        "vip": "7",
                        "itaxRate": "0.13",
                        "taxCode": "1099900000000000000",
                        "taxCodeTitle": "其他机械设备",
                        "iTitle": "*其他机械设备*其他机械、设备类产品",
                        "children": []
                    }
                ]
            },
            {
                "id": "3771",
                "linkid": "1",
                "code": "110",
                "paCode": "1",
                "yn": "Y",
                "title": "电力、热力、水、燃气类产品",
                "alias": "电力、热力、水、燃气类产品",
                "about": null,
                "kws": null,
                "taxName": "电力热力水燃气",
                "taxRate": "",
                "vip": "3",
                "itaxRate": null,
                "taxCode": "1100000000000000000",
                "taxCodeTitle": "电力热力水燃气",
                "iTitle": "*电力热力水燃气*电力、热力、水、燃气类产品",
                "children": [
                    {
                        "id": "3772",
                        "linkid": "3771",
                        "code": "11001",
                        "paCode": "110",
                        "yn": "Y",
                        "title": "电力和热力、冷气",
                        "alias": "电力和热力、冷气",
                        "about": null,
                        "kws": null,
                        "taxName": "电力热力冷气",
                        "taxRate": "",
                        "vip": "5",
                        "itaxRate": null,
                        "taxCode": "1100100000000000000",
                        "taxCodeTitle": "电力热力冷气",
                        "iTitle": "*电力热力冷气*电力和热力、冷气",
                        "children": [
                            {
                                "id": "3773",
                                "linkid": "3772",
                                "code": "1100101",
                                "paCode": "11001",
                                "yn": "Y",
                                "title": "发电及供电",
                                "alias": "发电及供电",
                                "about": null,
                                "kws": null,
                                "taxName": "发电及供电",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1100101000000000000",
                                "taxCodeTitle": "发电及供电",
                                "iTitle": "*发电及供电*发电及供电",
                                "children": [
                                    {
                                        "id": "3774",
                                        "linkid": "3773",
                                        "code": "110010101",
                                        "paCode": "1100101",
                                        "yn": "Y",
                                        "title": "发电",
                                        "alias": "发电",
                                        "about": "包括火力发电、水力发电、核能发电、太阳能发电、风力发电、潮汐能发电、沼气发电、地热能发电、垃圾发电、竹木生物质燃料发电",
                                        "kws": null,
                                        "taxName": "发电",
                                        "taxRate": "",
                                        "vip": "5",
                                        "itaxRate": null,
                                        "taxCode": "1100101010000000000",
                                        "taxCodeTitle": "发电",
                                        "iTitle": "*发电*发电",
                                        "children": [
                                            {
                                                "id": "3775",
                                                "linkid": "3774",
                                                "code": "11001010101",
                                                "paCode": "110010101",
                                                "yn": "N",
                                                "title": "火力发电",
                                                "alias": "火力发电",
                                                "about": "包括以煤炭、石油、天然气、余热、余气为能源发电以及其他火力发电",
                                                "kws": "火力发电",
                                                "taxName": "发电",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1100101010100000000",
                                                "taxCodeTitle": "发电",
                                                "iTitle": "*发电*火力发电",
                                                "children": []
                                            },
                                            {
                                                "id": "3776",
                                                "linkid": "3774",
                                                "code": "11001010102",
                                                "paCode": "110010101",
                                                "yn": "N",
                                                "title": "5万千瓦以下（含5万千瓦）水力发电",
                                                "alias": "5万千瓦以下（含5万千瓦）水力发电",
                                                "about": null,
                                                "kws": null,
                                                "taxName": "发电",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1100101010200000000",
                                                "taxCodeTitle": "发电",
                                                "iTitle": "*发电*5万千瓦以下（含5万千瓦）水力发电",
                                                "children": []
                                            },
                                            {
                                                "id": "3777",
                                                "linkid": "3774",
                                                "code": "11001010103",
                                                "paCode": "110010101",
                                                "yn": "N",
                                                "title": "5万千瓦以上（不含5万千瓦）100万千瓦（含）以下水力发电",
                                                "alias": "5万千瓦以上（不含5万千瓦）100万千瓦（含）以下水力发电",
                                                "about": null,
                                                "kws": null,
                                                "taxName": "发电",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1100101010300000000",
                                                "taxCodeTitle": "发电",
                                                "iTitle": "*发电*5万千瓦以上（不含5万千瓦）100万千瓦（含）以下水力发电",
                                                "children": []
                                            },
                                            {
                                                "id": "3778",
                                                "linkid": "3774",
                                                "code": "11001010104",
                                                "paCode": "110010101",
                                                "yn": "N",
                                                "title": "100万千瓦以上（不含100万千瓦）水力发电",
                                                "alias": "100万千瓦以上（不含100万千瓦）水力发电",
                                                "about": null,
                                                "kws": null,
                                                "taxName": "发电",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1100101010400000000",
                                                "taxCodeTitle": "发电",
                                                "iTitle": "*发电*100万千瓦以上（不含100万千瓦）水力发电",
                                                "children": []
                                            },
                                            {
                                                "id": "3779",
                                                "linkid": "3774",
                                                "code": "11001010105",
                                                "paCode": "110010101",
                                                "yn": "N",
                                                "title": "核能发电",
                                                "alias": "核能发电",
                                                "about": null,
                                                "kws": "核能发电",
                                                "taxName": "发电",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1100101010500000000",
                                                "taxCodeTitle": "发电",
                                                "iTitle": "*发电*核能发电",
                                                "children": []
                                            },
                                            {
                                                "id": "3780",
                                                "linkid": "3774",
                                                "code": "11001010106",
                                                "paCode": "110010101",
                                                "yn": "N",
                                                "title": "太阳能发电",
                                                "alias": "太阳能发电",
                                                "about": null,
                                                "kws": "太阳能发电",
                                                "taxName": "发电",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1100101010600000000",
                                                "taxCodeTitle": "发电",
                                                "iTitle": "*发电*太阳能发电",
                                                "children": []
                                            },
                                            {
                                                "id": "3781",
                                                "linkid": "3774",
                                                "code": "11001010107",
                                                "paCode": "110010101",
                                                "yn": "N",
                                                "title": "风力发电",
                                                "alias": "风力发电",
                                                "about": null,
                                                "kws": "风力发电",
                                                "taxName": "发电",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1100101010700000000",
                                                "taxCodeTitle": "发电",
                                                "iTitle": "*发电*风力发电",
                                                "children": []
                                            },
                                            {
                                                "id": "3782",
                                                "linkid": "3774",
                                                "code": "11001010108",
                                                "paCode": "110010101",
                                                "yn": "N",
                                                "title": "潮汐能发电",
                                                "alias": "潮汐能发电",
                                                "about": null,
                                                "kws": "潮汐能发电",
                                                "taxName": "发电",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1100101010800000000",
                                                "taxCodeTitle": "发电",
                                                "iTitle": "*发电*潮汐能发电",
                                                "children": []
                                            },
                                            {
                                                "id": "3783",
                                                "linkid": "3774",
                                                "code": "11001010109",
                                                "paCode": "110010101",
                                                "yn": "N",
                                                "title": "沼气发电",
                                                "alias": "沼气发电",
                                                "about": null,
                                                "kws": "沼气发电",
                                                "taxName": "发电",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1100101010900000000",
                                                "taxCodeTitle": "发电",
                                                "iTitle": "*发电*沼气发电",
                                                "children": []
                                            },
                                            {
                                                "id": "3784",
                                                "linkid": "3774",
                                                "code": "11001010110",
                                                "paCode": "110010101",
                                                "yn": "N",
                                                "title": "地热能发电",
                                                "alias": "地热能发电",
                                                "about": null,
                                                "kws": "地热能发电",
                                                "taxName": "发电",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1100101011000000000",
                                                "taxCodeTitle": "发电",
                                                "iTitle": "*发电*地热能发电",
                                                "children": []
                                            },
                                            {
                                                "id": "3785",
                                                "linkid": "3774",
                                                "code": "11001010111",
                                                "paCode": "110010101",
                                                "yn": "N",
                                                "title": "垃圾发电",
                                                "alias": "垃圾发电",
                                                "about": null,
                                                "kws": "垃圾发电",
                                                "taxName": "发电",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1100101011100000000",
                                                "taxCodeTitle": "发电",
                                                "iTitle": "*发电*垃圾发电",
                                                "children": []
                                            },
                                            {
                                                "id": "3786",
                                                "linkid": "3774",
                                                "code": "11001010112",
                                                "paCode": "110010101",
                                                "yn": "N",
                                                "title": "竹木生物质燃料发电",
                                                "alias": "竹木生物质燃料发电",
                                                "about": null,
                                                "kws": "竹木生物质燃料发电",
                                                "taxName": "发电",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1100101011200000000",
                                                "taxCodeTitle": "发电",
                                                "iTitle": "*发电*竹木生物质燃料发电",
                                                "children": []
                                            },
                                            {
                                                "id": "3787",
                                                "linkid": "3774",
                                                "code": "11001010199",
                                                "paCode": "110010101",
                                                "yn": "N",
                                                "title": "其他发电",
                                                "alias": "其他发电",
                                                "about": "指其他能源发电，包括生物能发电、余热发电、余压发电",
                                                "kws": null,
                                                "taxName": "发电",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1100101019900000000",
                                                "taxCodeTitle": "发电",
                                                "iTitle": "*发电*其他发电",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "3788",
                                        "linkid": "3773",
                                        "code": "110010102",
                                        "paCode": "1100101",
                                        "yn": "Y",
                                        "title": "供电",
                                        "alias": "供电",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "供电",
                                        "taxRate": "",
                                        "vip": "5",
                                        "itaxRate": null,
                                        "taxCode": "1100101020000000000",
                                        "taxCodeTitle": "供电",
                                        "iTitle": "*供电*供电",
                                        "children": [
                                            {
                                                "id": "3789",
                                                "linkid": "3788",
                                                "code": "11001010201",
                                                "paCode": "110010102",
                                                "yn": "N",
                                                "title": "电力产品",
                                                "alias": "电力产品",
                                                "about": "指电力企业售给用户（包括趸售户）的电量以及供给本企业非电力生产、基本建设、大修和非生产部门（如食堂、宿舍）等所使用的电量",
                                                "kws": "电费、供电",
                                                "taxName": "供电",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1100101020100000000",
                                                "taxCodeTitle": "供电",
                                                "iTitle": "*供电*电力产品",
                                                "children": []
                                            },
                                            {
                                                "id": "3790",
                                                "linkid": "3788",
                                                "code": "11001010202",
                                                "paCode": "110010102",
                                                "yn": "N",
                                                "title": "售电",
                                                "alias": "售电",
                                                "about": "指电力企业售给用户（包括趸售户）的电量以及供给本企业非电力生产、基本建设、大修和非生产部门（如食堂、宿舍）等所使用的电量",
                                                "kws": "售电",
                                                "taxName": "供电",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1100101020200000000",
                                                "taxCodeTitle": "供电",
                                                "iTitle": "*供电*售电",
                                                "children": []
                                            },
                                            {
                                                "id": "3791",
                                                "linkid": "3788",
                                                "code": "11001010203",
                                                "paCode": "110010102",
                                                "yn": "N",
                                                "title": "农村电网维护费",
                                                "alias": "农村电网维护费",
                                                "about": "指农村电管站在收取电价时一并向用户收取的农村电网维护费（包括低压线路损耗和维护费以及电工经费）",
                                                "kws": "农村电网维护费",
                                                "taxName": "供电",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "1100101020300000000",
                                                "taxCodeTitle": "供电",
                                                "iTitle": "*供电*农村电网维护费",
                                                "children": []
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "id": "3792",
                                "linkid": "3772",
                                "code": "1100102",
                                "paCode": "11001",
                                "yn": "Y",
                                "title": "热力生产及供热",
                                "alias": "热力生产及供热",
                                "about": "包括公用热电站和企业自备电站及供热锅炉房的全部外供热力",
                                "kws": null,
                                "taxName": "热力",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "1100102000000000000",
                                "taxCodeTitle": "热力",
                                "iTitle": "*热力*热力生产及供热",
                                "children": [
                                    {
                                        "id": "3793",
                                        "linkid": "3792",
                                        "code": "110010201",
                                        "paCode": "1100102",
                                        "yn": "Y",
                                        "title": "热力",
                                        "alias": "热力",
                                        "about": "指可提供热源的热水、过热或饱和蒸汽；包括工业锅炉、公用热电站和企业自备电站生产的热水和蒸汽，使用单位的热水和蒸汽",
                                        "kws": "热力",
                                        "taxName": "热力",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "1100102010000000000",
                                        "taxCodeTitle": "热力",
                                        "iTitle": "*热力*热力",
                                        "children": [
                                            {
                                                "id": "3794",
                                                "linkid": "3793",
                                                "code": "11001020101",
                                                "paCode": "110010201",
                                                "yn": "N",
                                                "title": "三北热力",
                                                "alias": "三北热力",
                                                "about": "指北京、天津、河北、山西、内蒙古、辽宁、大连、吉林、黑龙江、山东、青岛、河南、陕西、甘肃、宁夏、新疆、青海的供热企业向居民个人供热而取得的采暖费",
                                                "kws": "取暖费",
                                                "taxName": "热力",
                                                "taxRate": "9%",
                                                "vip": null,
                                                "itaxRate": "0.09",
                                                "taxCode": "1100102010100000000",
                                                "taxCodeTitle": "热力",
                                                "iTitle": "*热力*三北热力",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "3795",
                                        "linkid": "3792",
                                        "code": "110010202",
                                        "paCode": "1100102",
                                        "yn": "Y",
                                        "title": "供热",
                                        "alias": "供热",
                                        "about": "指热电厂、热力公司和达到标准的集中采暖锅炉房向城市输送的全部蒸汽、热水量",
                                        "kws": "供热",
                                        "taxName": "供热",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "1100102020000000000",
                                        "taxCodeTitle": "供热",
                                        "iTitle": "*供热*供热",
                                        "children": [
                                            {
                                                "id": "3796",
                                                "linkid": "3795",
                                                "code": "11001020201",
                                                "paCode": "110010202",
                                                "yn": "N",
                                                "title": "蒸汽",
                                                "alias": "蒸汽",
                                                "about": "包括饱和蒸汽、过热蒸汽，主要用途有加热、加湿；还可以产生动力；作为机器驱动等",
                                                "kws": "蒸汽",
                                                "taxName": "供热",
                                                "taxRate": "9%",
                                                "vip": null,
                                                "itaxRate": "0.09",
                                                "taxCode": "1100102020100000000",
                                                "taxCodeTitle": "供热",
                                                "iTitle": "*供热*蒸汽",
                                                "children": []
                                            },
                                            {
                                                "id": "3797",
                                                "linkid": "3795",
                                                "code": "11001020202",
                                                "paCode": "110010202",
                                                "yn": "N",
                                                "title": "热水",
                                                "alias": "热水",
                                                "about": null,
                                                "kws": "热水",
                                                "taxName": "供热",
                                                "taxRate": "9%",
                                                "vip": null,
                                                "itaxRate": "0.09",
                                                "taxCode": "1100102020200000000",
                                                "taxCodeTitle": "供热",
                                                "iTitle": "*供热*热水",
                                                "children": []
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "id": "3798",
                                "linkid": "3772",
                                "code": "1100103",
                                "paCode": "11001",
                                "yn": "N",
                                "title": "冷气",
                                "alias": "冷气",
                                "about": null,
                                "kws": "冷气",
                                "taxName": "冷气",
                                "taxRate": "9%",
                                "vip": "5",
                                "itaxRate": "0.09",
                                "taxCode": "1100103000000000000",
                                "taxCodeTitle": "冷气",
                                "iTitle": "*冷气*冷气",
                                "children": []
                            }
                        ]
                    },
                    {
                        "id": "3799",
                        "linkid": "3771",
                        "code": "11002",
                        "paCode": "110",
                        "yn": "Y",
                        "title": "燃气",
                        "alias": "燃气",
                        "about": null,
                        "kws": null,
                        "taxName": "燃气",
                        "taxRate": "",
                        "vip": "5",
                        "itaxRate": null,
                        "taxCode": "1100200000000000000",
                        "taxCodeTitle": "燃气",
                        "iTitle": "*燃气*燃气",
                        "children": [
                            {
                                "id": "3800",
                                "linkid": "3799",
                                "code": "1100201",
                                "paCode": "11002",
                                "yn": "Y",
                                "title": "煤气",
                                "alias": "煤气",
                                "about": "包括煤气、水煤气、炉煤气及类似气体",
                                "kws": null,
                                "taxName": "燃气",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "1100201000000000000",
                                "taxCodeTitle": "燃气",
                                "iTitle": "*燃气*煤气",
                                "children": [
                                    {
                                        "id": "3801",
                                        "linkid": "3800",
                                        "code": "110020101",
                                        "paCode": "1100201",
                                        "yn": "N",
                                        "title": "焦炉煤气",
                                        "alias": "焦炉煤气",
                                        "about": "指在炼焦炉中，煤经过干馏炼焦过程生产的煤气",
                                        "kws": "焦炉煤气",
                                        "taxName": "燃气",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "1100201010000000000",
                                        "taxCodeTitle": "燃气",
                                        "iTitle": "*燃气*焦炉煤气",
                                        "children": []
                                    },
                                    {
                                        "id": "3802",
                                        "linkid": "3800",
                                        "code": "110020102",
                                        "paCode": "1100201",
                                        "yn": "N",
                                        "title": "高炉煤气",
                                        "alias": "高炉煤气",
                                        "about": "指在炼铁过程产生的煤气",
                                        "kws": "高炉煤气",
                                        "taxName": "燃气",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "1100201020000000000",
                                        "taxCodeTitle": "燃气",
                                        "iTitle": "*燃气*高炉煤气",
                                        "children": []
                                    },
                                    {
                                        "id": "3803",
                                        "linkid": "3800",
                                        "code": "110020103",
                                        "paCode": "1100201",
                                        "yn": "N",
                                        "title": "油制气",
                                        "alias": "油制气",
                                        "about": "指用重油或轻油裂解生产的燃气",
                                        "kws": "油制气",
                                        "taxName": "燃气",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "1100201030000000000",
                                        "taxCodeTitle": "燃气",
                                        "iTitle": "*燃气*油制气",
                                        "children": []
                                    },
                                    {
                                        "id": "3804",
                                        "linkid": "3800",
                                        "code": "110020104",
                                        "paCode": "1100201",
                                        "yn": "N",
                                        "title": "水煤气",
                                        "alias": "水煤气",
                                        "about": "指向固定床煤气化炉交替通入空气和水蒸气制得的煤气",
                                        "kws": "水煤气",
                                        "taxName": "燃气",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "1100201040000000000",
                                        "taxCodeTitle": "燃气",
                                        "iTitle": "*燃气*水煤气",
                                        "children": []
                                    },
                                    {
                                        "id": "3805",
                                        "linkid": "3800",
                                        "code": "110020105",
                                        "paCode": "1100201",
                                        "yn": "N",
                                        "title": "发生炉煤气",
                                        "alias": "发生炉煤气",
                                        "about": "指利用煤气发生炉使固体燃料转化成的煤气",
                                        "kws": "发生炉煤气",
                                        "taxName": "燃气",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "1100201050000000000",
                                        "taxCodeTitle": "燃气",
                                        "iTitle": "*燃气*发生炉煤气",
                                        "children": []
                                    },
                                    {
                                        "id": "3806",
                                        "linkid": "3800",
                                        "code": "110020106",
                                        "paCode": "1100201",
                                        "yn": "N",
                                        "title": "加压气化炉煤气",
                                        "alias": "加压气化炉煤气",
                                        "about": "指将煤与氧气、水蒸汽等介质通过加压气化炉在一定温度和压力下反应生成的可燃气体",
                                        "kws": "加压气化炉煤气",
                                        "taxName": "燃气",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "1100201060000000000",
                                        "taxCodeTitle": "燃气",
                                        "iTitle": "*燃气*加压气化炉煤气",
                                        "children": []
                                    },
                                    {
                                        "id": "3807",
                                        "linkid": "3800",
                                        "code": "110020199",
                                        "paCode": "1100201",
                                        "yn": "N",
                                        "title": "其他煤气",
                                        "alias": "其他煤气",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "燃气",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "1100201990000000000",
                                        "taxCodeTitle": "燃气",
                                        "iTitle": "*燃气*其他煤气",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3808",
                                "linkid": "3799",
                                "code": "1100202",
                                "paCode": "11002",
                                "yn": "Y",
                                "title": "其他燃气",
                                "alias": "其他燃气",
                                "about": null,
                                "kws": "燃气",
                                "taxName": "燃气",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "1100202000000000000",
                                "taxCodeTitle": "燃气",
                                "iTitle": "*燃气*其他燃气",
                                "children": [
                                    {
                                        "id": "3809",
                                        "linkid": "3808",
                                        "code": "110020201",
                                        "paCode": "1100202",
                                        "yn": "N",
                                        "title": "人工煤气",
                                        "alias": "人工煤气",
                                        "about": "包括煤制气、油制气。",
                                        "kws": "人工煤气",
                                        "taxName": "燃气",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "1100202010000000000",
                                        "taxCodeTitle": "燃气",
                                        "iTitle": "*燃气*人工煤气",
                                        "children": []
                                    },
                                    {
                                        "id": "3810",
                                        "linkid": "3808",
                                        "code": "110020202",
                                        "paCode": "1100202",
                                        "yn": "N",
                                        "title": "民用天然气",
                                        "alias": "民用天然气",
                                        "about": null,
                                        "kws": "天然气",
                                        "taxName": "燃气",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "1100202020000000000",
                                        "taxCodeTitle": "燃气",
                                        "iTitle": "*燃气*民用天然气",
                                        "children": []
                                    },
                                    {
                                        "id": "3811",
                                        "linkid": "3808",
                                        "code": "110020203",
                                        "paCode": "1100202",
                                        "yn": "N",
                                        "title": "液化天然气（LNG）",
                                        "alias": "液化天然气（LNG）",
                                        "about": null,
                                        "kws": "LNG液化天然气",
                                        "taxName": "燃气",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "1100202030000000000",
                                        "taxCodeTitle": "燃气",
                                        "iTitle": "*燃气*液化天然气（LNG）",
                                        "children": []
                                    },
                                    {
                                        "id": "3812",
                                        "linkid": "3808",
                                        "code": "110020204",
                                        "paCode": "1100202",
                                        "yn": "N",
                                        "title": "民用液化石油气",
                                        "alias": "民用液化石油气",
                                        "about": null,
                                        "kws": "液化石油气",
                                        "taxName": "燃气",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "1100202040000000000",
                                        "taxCodeTitle": "燃气",
                                        "iTitle": "*燃气*民用液化石油气",
                                        "children": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "id": "3813",
                        "linkid": "3771",
                        "code": "11003",
                        "paCode": "110",
                        "yn": "Y",
                        "title": "水、冰、雪",
                        "alias": "水、冰、雪",
                        "about": null,
                        "kws": null,
                        "taxName": "水冰雪",
                        "taxRate": "",
                        "vip": "5",
                        "itaxRate": null,
                        "taxCode": "1100300000000000000",
                        "taxCodeTitle": "水冰雪",
                        "iTitle": "*水冰雪*水、冰、雪",
                        "children": [
                            {
                                "id": "3814",
                                "linkid": "3813",
                                "code": "1100301",
                                "paCode": "11003",
                                "yn": "Y",
                                "title": "水",
                                "alias": "水",
                                "about": null,
                                "kws": null,
                                "taxName": "水冰雪",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "1100301000000000000",
                                "taxCodeTitle": "水冰雪",
                                "iTitle": "*水冰雪*水",
                                "children": [
                                    {
                                        "id": "3815",
                                        "linkid": "3814",
                                        "code": "110030101",
                                        "paCode": "1100301",
                                        "yn": "N",
                                        "title": "自来水",
                                        "alias": "自来水",
                                        "about": null,
                                        "kws": "水费、自来水",
                                        "taxName": "水冰雪",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "1100301010000000000",
                                        "taxCodeTitle": "水冰雪",
                                        "iTitle": "*水冰雪*自来水",
                                        "children": []
                                    },
                                    {
                                        "id": "3816",
                                        "linkid": "3814",
                                        "code": "110030102",
                                        "paCode": "1100301",
                                        "yn": "N",
                                        "title": "再生水",
                                        "alias": "再生水",
                                        "about": null,
                                        "kws": "再生水、中水",
                                        "taxName": "水冰雪",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1100301020000000000",
                                        "taxCodeTitle": "水冰雪",
                                        "iTitle": "*水冰雪*再生水",
                                        "children": []
                                    },
                                    {
                                        "id": "3817",
                                        "linkid": "3814",
                                        "code": "110030103",
                                        "paCode": "1100301",
                                        "yn": "N",
                                        "title": "淡化水",
                                        "alias": "淡化水",
                                        "about": null,
                                        "kws": "淡化水",
                                        "taxName": "水冰雪",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1100301030000000000",
                                        "taxCodeTitle": "水冰雪",
                                        "iTitle": "*水冰雪*淡化水",
                                        "children": []
                                    },
                                    {
                                        "id": "3818",
                                        "linkid": "3814",
                                        "code": "110030104",
                                        "paCode": "1100301",
                                        "yn": "N",
                                        "title": "天然水",
                                        "alias": "天然水",
                                        "about": "包括江河、海洋、冰川、湖泊、沼泽等地表水以及土壤、岩石层内的地下水等天然水体",
                                        "kws": "天然水",
                                        "taxName": "水冰雪",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1100301040000000000",
                                        "taxCodeTitle": "水冰雪",
                                        "iTitle": "*水冰雪*天然水",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3819",
                                "linkid": "3813",
                                "code": "1100302",
                                "paCode": "11003",
                                "yn": "Y",
                                "title": "冰雪",
                                "alias": "冰雪",
                                "about": "不包括食用冰（详见103020906）",
                                "kws": "冰雪",
                                "taxName": "水冰雪",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "1100302000000000000",
                                "taxCodeTitle": "水冰雪",
                                "iTitle": "*水冰雪*冰雪",
                                "children": [
                                    {
                                        "id": "3820",
                                        "linkid": "3819",
                                        "code": "110030201",
                                        "paCode": "1100302",
                                        "yn": "N",
                                        "title": "自然冰",
                                        "alias": "自然冰",
                                        "about": null,
                                        "kws": "自然冰",
                                        "taxName": "水冰雪",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1100302010000000000",
                                        "taxCodeTitle": "水冰雪",
                                        "iTitle": "*水冰雪*自然冰",
                                        "children": []
                                    },
                                    {
                                        "id": "3821",
                                        "linkid": "3819",
                                        "code": "110030202",
                                        "paCode": "1100302",
                                        "yn": "N",
                                        "title": "工业人造冰",
                                        "alias": "工业人造冰",
                                        "about": null,
                                        "kws": "工业人造冰",
                                        "taxName": "水冰雪",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1100302020000000000",
                                        "taxCodeTitle": "水冰雪",
                                        "iTitle": "*水冰雪*工业人造冰",
                                        "children": []
                                    },
                                    {
                                        "id": "3822",
                                        "linkid": "3819",
                                        "code": "110030203",
                                        "paCode": "1100302",
                                        "yn": "N",
                                        "title": "自然雪",
                                        "alias": "自然雪",
                                        "about": null,
                                        "kws": "自然雪",
                                        "taxName": "水冰雪",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1100302030000000000",
                                        "taxCodeTitle": "水冰雪",
                                        "iTitle": "*水冰雪*自然雪",
                                        "children": []
                                    },
                                    {
                                        "id": "3823",
                                        "linkid": "3819",
                                        "code": "110030204",
                                        "paCode": "1100302",
                                        "yn": "N",
                                        "title": "人造雪",
                                        "alias": "人造雪",
                                        "about": null,
                                        "kws": "人造雪",
                                        "taxName": "水冰雪",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "1100302040000000000",
                                        "taxCodeTitle": "水冰雪",
                                        "iTitle": "*水冰雪*人造雪",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3824",
                                "linkid": "3813",
                                "code": "1100399",
                                "paCode": "11003",
                                "yn": "N",
                                "title": "其他水冰雪",
                                "alias": "其他水冰雪",
                                "about": null,
                                "kws": null,
                                "taxName": "水冰雪",
                                "taxRate": "13%",
                                "vip": null,
                                "itaxRate": "0.13",
                                "taxCode": "1100399000000000000",
                                "taxCodeTitle": "水冰雪",
                                "iTitle": "*水冰雪*其他水冰雪",
                                "children": []
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "id": "3825",
        "linkid": "0",
        "code": "2",
        "paCode": null,
        "yn": "Y",
        "title": "劳务",
        "alias": "劳务",
        "about": null,
        "kws": null,
        "taxName": "劳务",
        "taxRate": "",
        "vip": "5",
        "itaxRate": null,
        "taxCode": "2000000000000000000",
        "taxCodeTitle": "劳务",
        "iTitle": "*劳务*劳务",
        "children": [
            {
                "id": "3826",
                "linkid": "3825",
                "code": "201",
                "paCode": "2",
                "yn": "Y",
                "title": "加工劳务",
                "alias": "加工劳务",
                "about": "指受托加工货物，即委托方提供原料及主要材料，受托方按照委托方的要求制造货物并收取加工费的业务。包括稀土冶炼分离产品加工劳务、垃圾处理、污泥处理处置劳务、污水处理劳务、工业废气处理劳务、其他加工劳务。",
                "kws": null,
                "taxName": "劳务",
                "taxRate": "",
                "vip": "5",
                "itaxRate": null,
                "taxCode": "2010000000000000000",
                "taxCodeTitle": "劳务",
                "iTitle": "*劳务*加工劳务",
                "children": [
                    {
                        "id": "3827",
                        "linkid": "3826",
                        "code": "20101",
                        "paCode": "201",
                        "yn": "N",
                        "title": "稀土冶炼分离产品加工费",
                        "alias": "稀土冶炼分离产品加工费",
                        "about": "指通过湿法冶炼分离各种稀土产品的加工劳务。",
                        "kws": null,
                        "taxName": "稀土产品加工费",
                        "taxRate": "13%",
                        "vip": "7",
                        "itaxRate": "0.13",
                        "taxCode": "2010100000000000000",
                        "taxCodeTitle": "稀土产品加工费",
                        "iTitle": "*稀土产品加工费*稀土冶炼分离产品加工费",
                        "children": []
                    },
                    {
                        "id": "3828",
                        "linkid": "3826",
                        "code": "20102",
                        "paCode": "201",
                        "yn": "N",
                        "title": "垃圾处理、污泥处理处置劳务",
                        "alias": "垃圾处理、污泥处理处置劳务",
                        "about": "垃圾处理是指运用填埋、焚烧、综合处理和回收利用等形式，对垃圾进行减量化、资源化和无害化处理处置的业务。污泥处理处置是指对污水处理后产生的污泥进行稳定化、减量化和无害化处理处置的业务。",
                        "kws": "垃圾处理、污泥处理处置",
                        "taxName": "劳务",
                        "taxRate": "13%",
                        "vip": "7",
                        "itaxRate": "0.13",
                        "taxCode": "2010200000000000000",
                        "taxCodeTitle": "劳务",
                        "iTitle": "*劳务*垃圾处理、污泥处理处置劳务",
                        "children": []
                    },
                    {
                        "id": "3829",
                        "linkid": "3826",
                        "code": "20103",
                        "paCode": "201",
                        "yn": "N",
                        "title": "污水处理劳务",
                        "alias": "污水处理劳务",
                        "about": "指将污水（包括城镇污水和工业废水）处理后达到《城镇污水处理厂污染物排放标准》（GB18918-2002），或达到相应的国家或地方水污染物排放标准中的直接排放限值的业务。其中，城镇污水是指城镇居民生活污水，机关、学校、医院、商业服务机构及各种公共设施排水，以及允许排入城镇污水收集系统的工业废水和初期雨水。工业废水是指工业生产过程中产生的，不允许排入城镇污水收集系统的废水和废液。",
                        "kws": "污水处理",
                        "taxName": "劳务",
                        "taxRate": "13%",
                        "vip": "7",
                        "itaxRate": "0.13",
                        "taxCode": "2010300000000000000",
                        "taxCodeTitle": "劳务",
                        "iTitle": "*劳务*污水处理劳务",
                        "children": []
                    },
                    {
                        "id": "3830",
                        "linkid": "3826",
                        "code": "20104",
                        "paCode": "201",
                        "yn": "N",
                        "title": "工业废气处理劳务",
                        "alias": "工业废气处理劳务",
                        "about": "指专门针对工业场所如工厂、车间产生的废气在对外排放前进行预处理，以达到国家废气对外排放标准的工作。",
                        "kws": "工业废气处理",
                        "taxName": "劳务",
                        "taxRate": "13%",
                        "vip": "7",
                        "itaxRate": "0.13",
                        "taxCode": "2010400000000000000",
                        "taxCodeTitle": "劳务",
                        "iTitle": "*劳务*工业废气处理劳务",
                        "children": []
                    },
                    {
                        "id": "3831",
                        "linkid": "3826",
                        "code": "20105",
                        "paCode": "201",
                        "yn": "N",
                        "title": "其他加工劳务",
                        "alias": "其他加工劳务",
                        "about": "指除稀土冶炼分离产品加工劳务、稀土金属及合金加工费、垃圾处理、污泥处理处置劳务、污水处理劳务、工业废气处理劳务以外的其他加工劳务。",
                        "kws": null,
                        "taxName": "劳务",
                        "taxRate": "13%",
                        "vip": "7",
                        "itaxRate": "0.13",
                        "taxCode": "2010500000000000000",
                        "taxCodeTitle": "劳务",
                        "iTitle": "*劳务*其他加工劳务",
                        "children": []
                    },
                    {
                        "id": "3832",
                        "linkid": "3826",
                        "code": "20106",
                        "paCode": "201",
                        "yn": "N",
                        "title": "稀土金属及合金加工费",
                        "alias": "稀土金属及合金加工费",
                        "about": "指稀土金属加工劳务、稀土金属加工费、稀土合金加工劳务、稀土合金加工费",
                        "kws": null,
                        "taxName": "稀土产品加工费",
                        "taxRate": "13%",
                        "vip": "7",
                        "itaxRate": "0.13",
                        "taxCode": "2010600000000000000",
                        "taxCodeTitle": "稀土产品加工费",
                        "iTitle": "*稀土产品加工费*稀土金属及合金加工费",
                        "children": []
                    }
                ]
            },
            {
                "id": "3833",
                "linkid": "3825",
                "code": "202",
                "paCode": "2",
                "yn": "N",
                "title": "修理修配劳务",
                "alias": "修理修配劳务",
                "about": "指受托对损伤和丧失功能的货物进行修复，使其恢复原状和功能的业务。",
                "kws": "修理修配、修理、修配",
                "taxName": "劳务",
                "taxRate": "13%",
                "vip": "3",
                "itaxRate": "0.13",
                "taxCode": "2020000000000000000",
                "taxCodeTitle": "劳务",
                "iTitle": "*劳务*修理修配劳务",
                "children": []
            },
            {
                "id": "3834",
                "linkid": "3825",
                "code": "203",
                "paCode": "2",
                "yn": "N",
                "title": "油气田企业为生产原油、天然气提供的生产性劳务",
                "alias": "油气田企业为生产原油、天然气提供的生产性劳务",
                "about": "生产性劳务是指油气田企业为生产原油、天然气，从地质普查、勘探开发到原油天然气销售的一系列生产过程所发生的劳务（具体见《增值税生产性劳务征税范围注释》）。",
                "kws": "地质勘探、采油采气、海上油田建设、油田基本建设",
                "taxName": "劳务",
                "taxRate": "13%",
                "vip": "7",
                "itaxRate": "0.13",
                "taxCode": "2030000000000000000",
                "taxCodeTitle": "劳务",
                "iTitle": "*劳务*油气田企业为生产原油、天然气提供的生产性劳务",
                "children": []
            },
            {
                "id": "3835",
                "linkid": "3825",
                "code": "204",
                "paCode": "2",
                "yn": "N",
                "title": "矿产资源开采、挖掘、切割、破碎、分拣、洗选等劳务",
                "alias": "矿产资源开采、挖掘、切割、破碎、分拣、洗选等劳务",
                "about": "包括矿产资源开采、挖掘、切割、破碎、分拣、洗选等。",
                "kws": "矿产开采、矿产挖掘、矿产分拣、矿产洗选",
                "taxName": "劳务",
                "taxRate": "13%",
                "vip": "7",
                "itaxRate": "0.13",
                "taxCode": "2040000000000000000",
                "taxCodeTitle": "劳务",
                "iTitle": "*劳务*矿产资源开采、挖掘、切割、破碎、分拣、洗选等劳务",
                "children": []
            }
        ]
    },
    {
        "id": "3836",
        "linkid": "0",
        "code": "3",
        "paCode": null,
        "yn": "Y",
        "title": "销售服务",
        "alias": "销售服务",
        "about": null,
        "kws": null,
        "taxName": "销售服务",
        "taxRate": "",
        "vip": "5",
        "itaxRate": null,
        "taxCode": "3000000000000000000",
        "taxCodeTitle": "销售服务",
        "iTitle": "*销售服务*销售服务",
        "children": [
            {
                "id": "3837",
                "linkid": "3836",
                "code": "301",
                "paCode": "3",
                "yn": "Y",
                "title": "交通运输服务",
                "alias": "交通运输服务",
                "about": "指使用运输工具将货物或者旅客送达目的地，使其空间位置得到转移的业务活动。",
                "kws": "交通运输",
                "taxName": "运输服务",
                "taxRate": "",
                "vip": "5",
                "itaxRate": null,
                "taxCode": "3010000000000000000",
                "taxCodeTitle": "运输服务",
                "iTitle": "*运输服务*交通运输服务",
                "children": [
                    {
                        "id": "3838",
                        "linkid": "3837",
                        "code": "30101",
                        "paCode": "301",
                        "yn": "Y",
                        "title": "陆路运输服务",
                        "alias": "陆路运输服务",
                        "about": "指通过陆路（地上或者地下）运送货物或者旅客的运输业务活动。",
                        "kws": "陆路运输",
                        "taxName": "运输服务",
                        "taxRate": "",
                        "vip": "5",
                        "itaxRate": null,
                        "taxCode": "3010100000000000000",
                        "taxCodeTitle": "运输服务",
                        "iTitle": "*运输服务*陆路运输服务",
                        "children": [
                            {
                                "id": "3839",
                                "linkid": "3838",
                                "code": "3010101",
                                "paCode": "30101",
                                "yn": "Y",
                                "title": "陆路旅客运输服务",
                                "alias": "陆路旅客运输服务",
                                "about": "指通过陆路（地上或者地下）运送旅客的运输业务活动。",
                                "kws": "陆路旅客运输",
                                "taxName": "运输服务",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "3010101000000000000",
                                "taxCodeTitle": "运输服务",
                                "iTitle": "*运输服务*陆路旅客运输服务",
                                "children": [
                                    {
                                        "id": "3840",
                                        "linkid": "3839",
                                        "code": "301010101",
                                        "paCode": "3010101",
                                        "yn": "Y",
                                        "title": "铁路旅客运输服务",
                                        "alias": "铁路旅客运输服务",
                                        "about": "指通过铁路运送旅客的运输业务活动。",
                                        "kws": "铁路旅客运输",
                                        "taxName": "运输服务",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "3010101010000000000",
                                        "taxCodeTitle": "运输服务",
                                        "iTitle": "*运输服务*铁路旅客运输服务",
                                        "children": [
                                            {
                                                "id": "3841",
                                                "linkid": "3840",
                                                "code": "30101010101",
                                                "paCode": "301010101",
                                                "yn": "N",
                                                "title": "国内铁路旅客运输服务",
                                                "alias": "国内铁路旅客运输服务",
                                                "about": "指起运地和目的地都在境内的铁路旅客运输业务活动。",
                                                "kws": "国内铁路旅客运输",
                                                "taxName": "运输服务",
                                                "taxRate": "9%",
                                                "vip": null,
                                                "itaxRate": "0.09",
                                                "taxCode": "3010101010100000000",
                                                "taxCodeTitle": "运输服务",
                                                "iTitle": "*运输服务*国内铁路旅客运输服务",
                                                "children": []
                                            },
                                            {
                                                "id": "3842",
                                                "linkid": "3840",
                                                "code": "30101010102",
                                                "paCode": "301010101",
                                                "yn": "N",
                                                "title": "国际铁路旅客运输服务",
                                                "alias": "国际铁路旅客运输服务",
                                                "about": "指通过铁路从境内载运旅客出境、从境外载运旅客入境，以及在境外载运旅客的运输业务活动。",
                                                "kws": "国际铁路旅客运输",
                                                "taxName": "运输服务",
                                                "taxRate": "9%",
                                                "vip": null,
                                                "itaxRate": "0.09",
                                                "taxCode": "3010101010200000000",
                                                "taxCodeTitle": "运输服务",
                                                "iTitle": "*运输服务*国际铁路旅客运输服务",
                                                "children": []
                                            },
                                            {
                                                "id": "3843",
                                                "linkid": "3840",
                                                "code": "30101010103",
                                                "paCode": "301010101",
                                                "yn": "N",
                                                "title": "港澳台铁路旅客运输服务",
                                                "alias": "港澳台铁路旅客运输服务",
                                                "about": "指通过铁路往返香港、澳门、台湾，以及在香港、澳门、台湾提供的旅客运输业务活动。",
                                                "kws": "港澳台铁路旅客运输",
                                                "taxName": "运输服务",
                                                "taxRate": "9%",
                                                "vip": null,
                                                "itaxRate": "0.09",
                                                "taxCode": "3010101010300000000",
                                                "taxCodeTitle": "运输服务",
                                                "iTitle": "*运输服务*港澳台铁路旅客运输服务",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "3844",
                                        "linkid": "3839",
                                        "code": "301010102",
                                        "paCode": "3010101",
                                        "yn": "Y",
                                        "title": "道路旅客运输服务",
                                        "alias": "道路旅客运输服务",
                                        "about": null,
                                        "kws": "道路旅客运输",
                                        "taxName": "运输服务",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "3010101020000000000",
                                        "taxCodeTitle": "运输服务",
                                        "iTitle": "*运输服务*道路旅客运输服务",
                                        "children": [
                                            {
                                                "id": "3845",
                                                "linkid": "3844",
                                                "code": "30101010201",
                                                "paCode": "301010102",
                                                "yn": "Y",
                                                "title": "公路旅客运输服务",
                                                "alias": "公路旅客运输服务",
                                                "about": "指城市以外道路的旅客运输业务活动。",
                                                "kws": "公路旅客运输",
                                                "taxName": "运输服务",
                                                "taxRate": "",
                                                "vip": null,
                                                "itaxRate": null,
                                                "taxCode": "3010101020100000000",
                                                "taxCodeTitle": "运输服务",
                                                "iTitle": "*运输服务*公路旅客运输服务",
                                                "children": [
                                                    {
                                                        "id": "3846",
                                                        "linkid": "3845",
                                                        "code": "3010101020101",
                                                        "paCode": "30101010201",
                                                        "yn": "Y",
                                                        "title": "长途汽车旅客运输服务",
                                                        "alias": "长途汽车旅客运输服务",
                                                        "about": "指通过汽车提供的长途旅客运输业务活动",
                                                        "kws": "长途旅客运输",
                                                        "taxName": "运输服务",
                                                        "taxRate": "",
                                                        "vip": null,
                                                        "itaxRate": null,
                                                        "taxCode": "3010101020101000000",
                                                        "taxCodeTitle": "运输服务",
                                                        "iTitle": "*运输服务*长途汽车旅客运输服务",
                                                        "children": [
                                                            {
                                                                "id": "3847",
                                                                "linkid": "3846",
                                                                "code": "301010102010101",
                                                                "paCode": "3010101020101",
                                                                "yn": "N",
                                                                "title": "国内长途汽车旅客运输服务",
                                                                "alias": "国内长途汽车旅客运输服务",
                                                                "about": "指起运地和目的地都在境内的长途旅客运输业务活动，含长途班车服务。",
                                                                "kws": "国内长途旅客运输",
                                                                "taxName": "运输服务",
                                                                "taxRate": "9%",
                                                                "vip": null,
                                                                "itaxRate": "0.09",
                                                                "taxCode": "3010101020101010000",
                                                                "taxCodeTitle": "运输服务",
                                                                "iTitle": "*运输服务*国内长途汽车旅客运输服务",
                                                                "children": []
                                                            },
                                                            {
                                                                "id": "3848",
                                                                "linkid": "3846",
                                                                "code": "301010102010102",
                                                                "paCode": "3010101020101",
                                                                "yn": "N",
                                                                "title": "国际长途汽车旅客运输服务",
                                                                "alias": "国际长途汽车旅客运输服务",
                                                                "about": "指通过道路从境内载运旅客出境、从境外载运旅客入境，以及在境外载运旅客的运输业务活动。",
                                                                "kws": "国际长途旅客运输",
                                                                "taxName": "运输服务",
                                                                "taxRate": "9%",
                                                                "vip": null,
                                                                "itaxRate": "0.09",
                                                                "taxCode": "3010101020101020000",
                                                                "taxCodeTitle": "运输服务",
                                                                "iTitle": "*运输服务*国际长途汽车旅客运输服务",
                                                                "children": []
                                                            },
                                                            {
                                                                "id": "3849",
                                                                "linkid": "3846",
                                                                "code": "301010102010103",
                                                                "paCode": "3010101020101",
                                                                "yn": "N",
                                                                "title": "港澳台长途汽车旅客运输服务",
                                                                "alias": "港澳台长途汽车旅客运输服务",
                                                                "about": "指通过道路往返香港、澳门、台湾，以及在香港、澳门、台湾提供的旅客运输业务活动。",
                                                                "kws": "港澳台长途旅客运输",
                                                                "taxName": "运输服务",
                                                                "taxRate": "9%",
                                                                "vip": null,
                                                                "itaxRate": "0.09",
                                                                "taxCode": "3010101020101030000",
                                                                "taxCodeTitle": "运输服务",
                                                                "iTitle": "*运输服务*港澳台长途汽车旅客运输服务",
                                                                "children": []
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "id": "3850",
                                                        "linkid": "3845",
                                                        "code": "3010101020102",
                                                        "paCode": "30101010201",
                                                        "yn": "N",
                                                        "title": "其他公路旅客运输服务",
                                                        "alias": "其他公路旅客运输服务",
                                                        "about": "指汽车以外的其他运输工具提供的旅客运输业务活动。",
                                                        "kws": null,
                                                        "taxName": "运输服务",
                                                        "taxRate": "9%",
                                                        "vip": null,
                                                        "itaxRate": "0.09",
                                                        "taxCode": "3010101020102000000",
                                                        "taxCodeTitle": "运输服务",
                                                        "iTitle": "*运输服务*其他公路旅客运输服务",
                                                        "children": []
                                                    }
                                                ]
                                            },
                                            {
                                                "id": "3851",
                                                "linkid": "3844",
                                                "code": "30101010202",
                                                "paCode": "301010102",
                                                "yn": "Y",
                                                "title": "城市旅客公共交通运输服务",
                                                "alias": "城市旅客公共交通运输服务",
                                                "about": "指城市道路旅客运输业务活动。",
                                                "kws": "城市旅客公共交通运输",
                                                "taxName": "运输服务",
                                                "taxRate": "",
                                                "vip": null,
                                                "itaxRate": null,
                                                "taxCode": "3010101020200000000",
                                                "taxCodeTitle": "运输服务",
                                                "iTitle": "*运输服务*城市旅客公共交通运输服务",
                                                "children": [
                                                    {
                                                        "id": "3852",
                                                        "linkid": "3851",
                                                        "code": "3010101020201",
                                                        "paCode": "30101010202",
                                                        "yn": "N",
                                                        "title": "公共电汽车客运服务",
                                                        "alias": "公共电汽车客运服务",
                                                        "about": "指通过公共电汽车提供的旅客运输业务活动。",
                                                        "kws": "公交、公共电汽车客运",
                                                        "taxName": "运输服务",
                                                        "taxRate": "9%",
                                                        "vip": null,
                                                        "itaxRate": "0.09",
                                                        "taxCode": "3010101020201000000",
                                                        "taxCodeTitle": "运输服务",
                                                        "iTitle": "*运输服务*公共电汽车客运服务",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "3853",
                                                        "linkid": "3851",
                                                        "code": "3010101020202",
                                                        "paCode": "30101010202",
                                                        "yn": "N",
                                                        "title": "城市轨道交通服务",
                                                        "alias": "城市轨道交通服务",
                                                        "about": "指通过城市地铁、轻轨、有轨电车等轨道交通提供的旅客运输业务活动。",
                                                        "kws": "城市轨道交通、城市地铁、轻轨、有轨电车",
                                                        "taxName": "运输服务",
                                                        "taxRate": "9%",
                                                        "vip": null,
                                                        "itaxRate": "0.09",
                                                        "taxCode": "3010101020202000000",
                                                        "taxCodeTitle": "运输服务",
                                                        "iTitle": "*运输服务*城市轨道交通服务",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "3854",
                                                        "linkid": "3851",
                                                        "code": "3010101020203",
                                                        "paCode": "30101010202",
                                                        "yn": "N",
                                                        "title": "出租汽车客运服务",
                                                        "alias": "出租汽车客运服务",
                                                        "about": "指轿车出租计程、轿车出租包车、中型客车出租、大型客车出租客运业务活动，含城市班车服务。",
                                                        "kws": "出租车、出租汽车客运、轿车出租计程、轿车出租包车、中型客车出租、大型客车出租、城市班车",
                                                        "taxName": "运输服务",
                                                        "taxRate": "9%",
                                                        "vip": null,
                                                        "itaxRate": "0.09",
                                                        "taxCode": "3010101020203000000",
                                                        "taxCodeTitle": "运输服务",
                                                        "iTitle": "*运输服务*出租汽车客运服务",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "3855",
                                                        "linkid": "3851",
                                                        "code": "3010101020204",
                                                        "paCode": "30101010202",
                                                        "yn": "N",
                                                        "title": "索道客运服务",
                                                        "alias": "索道客运服务",
                                                        "about": null,
                                                        "kws": "索道客运",
                                                        "taxName": "运输服务",
                                                        "taxRate": "9%",
                                                        "vip": null,
                                                        "itaxRate": "0.09",
                                                        "taxCode": "3010101020204000000",
                                                        "taxCodeTitle": "运输服务",
                                                        "iTitle": "*运输服务*索道客运服务",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "3856",
                                                        "linkid": "3851",
                                                        "code": "3010101020299",
                                                        "paCode": "30101010202",
                                                        "yn": "N",
                                                        "title": "其他城市旅客公共交通服务",
                                                        "alias": "其他城市旅客公共交通服务",
                                                        "about": "指其他未列明的城市旅客运输活动。",
                                                        "kws": null,
                                                        "taxName": "运输服务",
                                                        "taxRate": "9%",
                                                        "vip": null,
                                                        "itaxRate": "0.09",
                                                        "taxCode": "3010101020299000000",
                                                        "taxCodeTitle": "运输服务",
                                                        "iTitle": "*运输服务*其他城市旅客公共交通服务",
                                                        "children": []
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "id": "3857",
                                "linkid": "3838",
                                "code": "3010102",
                                "paCode": "30101",
                                "yn": "Y",
                                "title": "陆路货物运输服务",
                                "alias": "陆路货物运输服务",
                                "about": "指通过陆路（地上或者地下）运送货物的运输业务活动。",
                                "kws": "陆路货物运输",
                                "taxName": "运输服务",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "3010102000000000000",
                                "taxCodeTitle": "运输服务",
                                "iTitle": "*运输服务*陆路货物运输服务",
                                "children": [
                                    {
                                        "id": "3858",
                                        "linkid": "3857",
                                        "code": "301010201",
                                        "paCode": "3010102",
                                        "yn": "Y",
                                        "title": "铁路货物运输服务",
                                        "alias": "铁路货物运输服务",
                                        "about": "指通过铁路运送货物的运输业务活动。",
                                        "kws": "铁路货物运输",
                                        "taxName": "运输服务",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "3010102010000000000",
                                        "taxCodeTitle": "运输服务",
                                        "iTitle": "*运输服务*铁路货物运输服务",
                                        "children": [
                                            {
                                                "id": "3859",
                                                "linkid": "3858",
                                                "code": "30101020101",
                                                "paCode": "301010201",
                                                "yn": "N",
                                                "title": "国内铁路货物运输服务",
                                                "alias": "国内铁路货物运输服务",
                                                "about": "指起运地、目的地都在境内的铁路货物运输业务活动。",
                                                "kws": "国内铁路货物运输",
                                                "taxName": "运输服务",
                                                "taxRate": "9%",
                                                "vip": null,
                                                "itaxRate": "0.09",
                                                "taxCode": "3010102010100000000",
                                                "taxCodeTitle": "运输服务",
                                                "iTitle": "*运输服务*国内铁路货物运输服务",
                                                "children": []
                                            },
                                            {
                                                "id": "3860",
                                                "linkid": "3858",
                                                "code": "30101020102",
                                                "paCode": "301010201",
                                                "yn": "N",
                                                "title": "国际铁路货物运输服务",
                                                "alias": "国际铁路货物运输服务",
                                                "about": "指通过铁路从境内载运货物出境、从境外载运货物入境以及在境外载运货物的运输业务活动。",
                                                "kws": "国际铁路货物运输",
                                                "taxName": "运输服务",
                                                "taxRate": "9%",
                                                "vip": null,
                                                "itaxRate": "0.09",
                                                "taxCode": "3010102010200000000",
                                                "taxCodeTitle": "运输服务",
                                                "iTitle": "*运输服务*国际铁路货物运输服务",
                                                "children": []
                                            },
                                            {
                                                "id": "3861",
                                                "linkid": "3858",
                                                "code": "30101020103",
                                                "paCode": "301010201",
                                                "yn": "N",
                                                "title": "港澳台铁路货物运输服务",
                                                "alias": "港澳台铁路货物运输服务",
                                                "about": "指通过铁路往返香港、澳门、台湾以及在香港、澳门、台湾提供的货物运输业务活动。",
                                                "kws": "港澳台铁路货物运输",
                                                "taxName": "运输服务",
                                                "taxRate": "9%",
                                                "vip": null,
                                                "itaxRate": "0.09",
                                                "taxCode": "3010102010300000000",
                                                "taxCodeTitle": "运输服务",
                                                "iTitle": "*运输服务*港澳台铁路货物运输服务",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "3862",
                                        "linkid": "3857",
                                        "code": "301010202",
                                        "paCode": "3010102",
                                        "yn": "Y",
                                        "title": "道路货物运输服务",
                                        "alias": "道路货物运输服务",
                                        "about": "指所有道路的货物运输活动。",
                                        "kws": "道路货物运输",
                                        "taxName": "运输服务",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "3010102020000000000",
                                        "taxCodeTitle": "运输服务",
                                        "iTitle": "*运输服务*道路货物运输服务",
                                        "children": [
                                            {
                                                "id": "3863",
                                                "linkid": "3862",
                                                "code": "30101020201",
                                                "paCode": "301010202",
                                                "yn": "N",
                                                "title": "国内道路货物运输服务",
                                                "alias": "国内道路货物运输服务",
                                                "about": "指起运地、目的地都在境内的道路货物运输业务活动。",
                                                "kws": "国内道路货物运输",
                                                "taxName": "运输服务",
                                                "taxRate": "9%",
                                                "vip": null,
                                                "itaxRate": "0.09",
                                                "taxCode": "3010102020100000000",
                                                "taxCodeTitle": "运输服务",
                                                "iTitle": "*运输服务*国内道路货物运输服务",
                                                "children": []
                                            },
                                            {
                                                "id": "3864",
                                                "linkid": "3862",
                                                "code": "30101020202",
                                                "paCode": "301010202",
                                                "yn": "N",
                                                "title": "国际道路货物运输服务",
                                                "alias": "国际道路货物运输服务",
                                                "about": "指通过道路从境内载运货物出境、从境外载运货物入境以及在境外载运货物的运输业务活动。",
                                                "kws": "国际道路货物运输",
                                                "taxName": "运输服务",
                                                "taxRate": "9%",
                                                "vip": null,
                                                "itaxRate": "0.09",
                                                "taxCode": "3010102020200000000",
                                                "taxCodeTitle": "运输服务",
                                                "iTitle": "*运输服务*国际道路货物运输服务",
                                                "children": []
                                            },
                                            {
                                                "id": "3865",
                                                "linkid": "3862",
                                                "code": "30101020203",
                                                "paCode": "301010202",
                                                "yn": "N",
                                                "title": "港澳台道路货物运输服务",
                                                "alias": "港澳台道路货物运输服务",
                                                "about": "指通过道路往返香港、澳门、台湾以及在香港、澳门、台湾提供的货物运输业务活动。",
                                                "kws": "港澳台道路货物运输",
                                                "taxName": "运输服务",
                                                "taxRate": "9%",
                                                "vip": null,
                                                "itaxRate": "0.09",
                                                "taxCode": "3010102020300000000",
                                                "taxCodeTitle": "运输服务",
                                                "iTitle": "*运输服务*港澳台道路货物运输服务",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "3866",
                                        "linkid": "3857",
                                        "code": "301010299",
                                        "paCode": "3010102",
                                        "yn": "Y",
                                        "title": "其他陆路货物运输服务",
                                        "alias": "其他陆路货物运输服务",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "运输服务",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "3010102990000000000",
                                        "taxCodeTitle": "运输服务",
                                        "iTitle": "*运输服务*其他陆路货物运输服务",
                                        "children": [
                                            {
                                                "id": "3867",
                                                "linkid": "3866",
                                                "code": "30101029901",
                                                "paCode": "301010299",
                                                "yn": "N",
                                                "title": "国内其他陆路货物运输服务",
                                                "alias": "国内其他陆路货物运输服务",
                                                "about": "指起运地、目的地都在境内的其他陆路货物运输业务。",
                                                "kws": null,
                                                "taxName": "运输服务",
                                                "taxRate": "9%",
                                                "vip": null,
                                                "itaxRate": "0.09",
                                                "taxCode": "3010102990100000000",
                                                "taxCodeTitle": "运输服务",
                                                "iTitle": "*运输服务*国内其他陆路货物运输服务",
                                                "children": []
                                            },
                                            {
                                                "id": "3868",
                                                "linkid": "3866",
                                                "code": "30101029902",
                                                "paCode": "301010299",
                                                "yn": "N",
                                                "title": "国际其他陆路货物运输服务",
                                                "alias": "国际其他陆路货物运输服务",
                                                "about": "指通过其他陆运方式从境内载运货物出境、从境外载运货物入境以及在境外载运货物的运输业务活动。",
                                                "kws": null,
                                                "taxName": "运输服务",
                                                "taxRate": "9%",
                                                "vip": null,
                                                "itaxRate": "0.09",
                                                "taxCode": "3010102990200000000",
                                                "taxCodeTitle": "运输服务",
                                                "iTitle": "*运输服务*国际其他陆路货物运输服务",
                                                "children": []
                                            },
                                            {
                                                "id": "3869",
                                                "linkid": "3866",
                                                "code": "30101029903",
                                                "paCode": "301010299",
                                                "yn": "N",
                                                "title": "港澳台其他陆路货物运输服务",
                                                "alias": "港澳台其他陆路货物运输服务",
                                                "about": "指通过其他陆运方式往返香港、澳门、台湾以及在香港、澳门、台湾提供的货物运输业务活动。",
                                                "kws": null,
                                                "taxName": "运输服务",
                                                "taxRate": "9%",
                                                "vip": null,
                                                "itaxRate": "0.09",
                                                "taxCode": "3010102990300000000",
                                                "taxCodeTitle": "运输服务",
                                                "iTitle": "*运输服务*港澳台其他陆路货物运输服务",
                                                "children": []
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "id": "3870",
                        "linkid": "3837",
                        "code": "30102",
                        "paCode": "301",
                        "yn": "Y",
                        "title": "水路运输服务",
                        "alias": "水路运输服务",
                        "about": "指通过江、河、湖、川等天然、人工水道或者海洋航道运送货物或者旅客的运输业务活动。",
                        "kws": "水路运输",
                        "taxName": "运输服务",
                        "taxRate": "",
                        "vip": "5",
                        "itaxRate": null,
                        "taxCode": "3010200000000000000",
                        "taxCodeTitle": "运输服务",
                        "iTitle": "*运输服务*水路运输服务",
                        "children": [
                            {
                                "id": "3871",
                                "linkid": "3870",
                                "code": "3010201",
                                "paCode": "30102",
                                "yn": "Y",
                                "title": "水路旅客运输服务",
                                "alias": "水路旅客运输服务",
                                "about": "指通过江、河、湖、川等天然、人工水道或者海洋航道运送旅客的运输业务活动。",
                                "kws": "水路旅客运输",
                                "taxName": "运输服务",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "3010201000000000000",
                                "taxCodeTitle": "运输服务",
                                "iTitle": "*运输服务*水路旅客运输服务",
                                "children": [
                                    {
                                        "id": "3872",
                                        "linkid": "3871",
                                        "code": "301020101",
                                        "paCode": "3010201",
                                        "yn": "N",
                                        "title": "国内水路旅客运输服务",
                                        "alias": "国内水路旅客运输服务",
                                        "about": "指起运地和目的地都在境内的水路旅客运输业务活动，含轮客渡服务。",
                                        "kws": "国内水路旅客运输、轮客渡、轮渡",
                                        "taxName": "运输服务",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "3010201010000000000",
                                        "taxCodeTitle": "运输服务",
                                        "iTitle": "*运输服务*国内水路旅客运输服务",
                                        "children": []
                                    },
                                    {
                                        "id": "3873",
                                        "linkid": "3871",
                                        "code": "301020102",
                                        "paCode": "3010201",
                                        "yn": "N",
                                        "title": "国际水路旅客运输服务",
                                        "alias": "国际水路旅客运输服务",
                                        "about": "指通过水路运输方式在境内载运旅客出境、从境外载运旅客入境以及在境外载运旅客的运输业务活动。",
                                        "kws": "国际水路旅客运输",
                                        "taxName": "运输服务",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "3010201020000000000",
                                        "taxCodeTitle": "运输服务",
                                        "iTitle": "*运输服务*国际水路旅客运输服务",
                                        "children": []
                                    },
                                    {
                                        "id": "3874",
                                        "linkid": "3871",
                                        "code": "301020103",
                                        "paCode": "3010201",
                                        "yn": "N",
                                        "title": "港澳台水路旅客运输服务",
                                        "alias": "港澳台水路旅客运输服务",
                                        "about": "指通过水路运输方式往返香港、澳门、台湾，以及在香港、澳门、台湾提供的旅客运输业务活动。",
                                        "kws": "港澳台水路旅客运输",
                                        "taxName": "运输服务",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "3010201030000000000",
                                        "taxCodeTitle": "运输服务",
                                        "iTitle": "*运输服务*港澳台水路旅客运输服务",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3875",
                                "linkid": "3870",
                                "code": "3010202",
                                "paCode": "30102",
                                "yn": "Y",
                                "title": "水路货物运输服务",
                                "alias": "水路货物运输服务",
                                "about": "指通过江、河、湖、川等天然、人工水道或者海洋航道运送货物的运输业务活动。",
                                "kws": "水路货物运输",
                                "taxName": "运输服务",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "3010202000000000000",
                                "taxCodeTitle": "运输服务",
                                "iTitle": "*运输服务*水路货物运输服务",
                                "children": [
                                    {
                                        "id": "3876",
                                        "linkid": "3875",
                                        "code": "301020201",
                                        "paCode": "3010202",
                                        "yn": "N",
                                        "title": "国内水路货物运输服务",
                                        "alias": "国内水路货物运输服务",
                                        "about": "指起运地和目的地都在境内的水路货物运输业务活动。",
                                        "kws": "国内水路货物运输",
                                        "taxName": "运输服务",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "3010202010000000000",
                                        "taxCodeTitle": "运输服务",
                                        "iTitle": "*运输服务*国内水路货物运输服务",
                                        "children": []
                                    },
                                    {
                                        "id": "3877",
                                        "linkid": "3875",
                                        "code": "301020202",
                                        "paCode": "3010202",
                                        "yn": "N",
                                        "title": "国际水路货物运输服务",
                                        "alias": "国际水路货物运输服务",
                                        "about": "指通过水路运输方式从境内载运货物出境、从境外载运货物入境以及在境外载运货物的运输业务活动。",
                                        "kws": "国际水路货物运输",
                                        "taxName": "运输服务",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "3010202020000000000",
                                        "taxCodeTitle": "运输服务",
                                        "iTitle": "*运输服务*国际水路货物运输服务",
                                        "children": []
                                    },
                                    {
                                        "id": "3878",
                                        "linkid": "3875",
                                        "code": "301020203",
                                        "paCode": "3010202",
                                        "yn": "N",
                                        "title": "港澳台水路货物运输服务",
                                        "alias": "港澳台水路货物运输服务",
                                        "about": "指通过水路运输方式往返香港、澳门、台湾以及在香港、澳门、台湾提供的货物运输业务活动。",
                                        "kws": "港澳台水路货物运输",
                                        "taxName": "运输服务",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "3010202030000000000",
                                        "taxCodeTitle": "运输服务",
                                        "iTitle": "*运输服务*港澳台水路货物运输服务",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3879",
                                "linkid": "3870",
                                "code": "3010203",
                                "paCode": "30102",
                                "yn": "Y",
                                "title": "水路运输期租业务",
                                "alias": "水路运输期租业务",
                                "about": "指运输企业为租船人完成某一特定航次的运输任务并收取租赁费的业务。",
                                "kws": "期租",
                                "taxName": "运输服务",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "3010203000000000000",
                                "taxCodeTitle": "运输服务",
                                "iTitle": "*运输服务*水路运输期租业务",
                                "children": [
                                    {
                                        "id": "3880",
                                        "linkid": "3879",
                                        "code": "301020301",
                                        "paCode": "3010203",
                                        "yn": "N",
                                        "title": "水路旅客运输期租业务",
                                        "alias": "水路旅客运输期租业务",
                                        "about": "指运输企业为租船人完成某一特定航次的运输货物任务并收取租赁费的业务。",
                                        "kws": "水路旅客运输期租",
                                        "taxName": "运输服务",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "3010203010000000000",
                                        "taxCodeTitle": "运输服务",
                                        "iTitle": "*运输服务*水路旅客运输期租业务",
                                        "children": []
                                    },
                                    {
                                        "id": "3881",
                                        "linkid": "3879",
                                        "code": "301020302",
                                        "paCode": "3010203",
                                        "yn": "N",
                                        "title": "水路货物运输期租业务",
                                        "alias": "水路货物运输期租业务",
                                        "about": "指运输企业为租船人完成某一特定航次的运输旅客任务并收取租赁费的业务。",
                                        "kws": "水路货物运输期租、水路货运期租",
                                        "taxName": "运输服务",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "3010203020000000000",
                                        "taxCodeTitle": "运输服务",
                                        "iTitle": "*运输服务*水路货物运输期租业务",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3882",
                                "linkid": "3870",
                                "code": "3010204",
                                "paCode": "30102",
                                "yn": "Y",
                                "title": "水路运输程租业务",
                                "alias": "水路运输程租业务",
                                "about": "指运输企业将配备有操作人员的船舶承租给他人使用一定期限，承租期内听候承租方调遣，不论是否经营，均按天向承租方收取租赁费，发生的固定费用均由船东负担的业务。",
                                "kws": "水路程租",
                                "taxName": "运输服务",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "3010204000000000000",
                                "taxCodeTitle": "运输服务",
                                "iTitle": "*运输服务*水路运输程租业务",
                                "children": [
                                    {
                                        "id": "3883",
                                        "linkid": "3882",
                                        "code": "301020401",
                                        "paCode": "3010204",
                                        "yn": "N",
                                        "title": "水路旅客运输程租业务",
                                        "alias": "水路旅客运输程租业务",
                                        "about": "指运输企业将配备有操作人员的船舶承租给他人使用（主要用于旅客运输）一定期限，承租期内听候承租方调遣，不论是否经营，均按天向承租方收取租赁费，发生的固定费用均由船东负担的业务。",
                                        "kws": "水路旅客运输程租",
                                        "taxName": "运输服务",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "3010204010000000000",
                                        "taxCodeTitle": "运输服务",
                                        "iTitle": "*运输服务*水路旅客运输程租业务",
                                        "children": []
                                    },
                                    {
                                        "id": "3884",
                                        "linkid": "3882",
                                        "code": "301020402",
                                        "paCode": "3010204",
                                        "yn": "N",
                                        "title": "水路货物运输程租业务",
                                        "alias": "水路货物运输程租业务",
                                        "about": "指运输企业将配备有操作人员的船舶承租给他人使用（主要用于货物运输）一定期限，承租期内听候承租方调遣，不论是否经营，均按天向承租方收取租赁费，发生的固定费用均由船东负担的业务。",
                                        "kws": "水路货物运输程租、水路货运程租",
                                        "taxName": "运输服务",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "3010204020000000000",
                                        "taxCodeTitle": "运输服务",
                                        "iTitle": "*运输服务*水路货物运输程租业务",
                                        "children": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "id": "3885",
                        "linkid": "3837",
                        "code": "30103",
                        "paCode": "301",
                        "yn": "Y",
                        "title": "航空运输服务",
                        "alias": "航空运输服务",
                        "about": "指通过空天航线运送货物或者旅客的运输业务活动。",
                        "kws": "航空运输",
                        "taxName": "运输服务",
                        "taxRate": "",
                        "vip": "5",
                        "itaxRate": null,
                        "taxCode": "3010300000000000000",
                        "taxCodeTitle": "运输服务",
                        "iTitle": "*运输服务*航空运输服务",
                        "children": [
                            {
                                "id": "3886",
                                "linkid": "3885",
                                "code": "3010301",
                                "paCode": "30103",
                                "yn": "Y",
                                "title": "航空客货运输服务",
                                "alias": "航空客货运输服务",
                                "about": "指通过空中航线运送货物或者旅客的运输业务活动。",
                                "kws": "航空客货运输",
                                "taxName": "运输服务",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "3010301000000000000",
                                "taxCodeTitle": "运输服务",
                                "iTitle": "*运输服务*航空客货运输服务",
                                "children": [
                                    {
                                        "id": "3887",
                                        "linkid": "3886",
                                        "code": "301030101",
                                        "paCode": "3010301",
                                        "yn": "Y",
                                        "title": "航空旅客运输服务",
                                        "alias": "航空旅客运输服务",
                                        "about": "指通过空中航线运送旅客的运输业务活动。",
                                        "kws": "航空旅客运输",
                                        "taxName": "运输服务",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "3010301010000000000",
                                        "taxCodeTitle": "运输服务",
                                        "iTitle": "*运输服务*航空旅客运输服务",
                                        "children": [
                                            {
                                                "id": "3888",
                                                "linkid": "3887",
                                                "code": "30103010101",
                                                "paCode": "301030101",
                                                "yn": "N",
                                                "title": "国内航空旅客运输服务",
                                                "alias": "国内航空旅客运输服务",
                                                "about": "指起运地和目的地都在境内的航空旅客运输业务活动。",
                                                "kws": "国内航空旅客运输",
                                                "taxName": "运输服务",
                                                "taxRate": "9%",
                                                "vip": null,
                                                "itaxRate": "0.09",
                                                "taxCode": "3010301010100000000",
                                                "taxCodeTitle": "运输服务",
                                                "iTitle": "*运输服务*国内航空旅客运输服务",
                                                "children": []
                                            },
                                            {
                                                "id": "3889",
                                                "linkid": "3887",
                                                "code": "30103010102",
                                                "paCode": "301030101",
                                                "yn": "N",
                                                "title": "国际航空旅客运输服务",
                                                "alias": "国际航空旅客运输服务",
                                                "about": "指通过航空运输方式在境内载运旅客出境、从境外载运旅客入境以及在境外载运旅客的运输业务活动。",
                                                "kws": "国际航空旅客运输",
                                                "taxName": "运输服务",
                                                "taxRate": "9%",
                                                "vip": null,
                                                "itaxRate": "0.09",
                                                "taxCode": "3010301010200000000",
                                                "taxCodeTitle": "运输服务",
                                                "iTitle": "*运输服务*国际航空旅客运输服务",
                                                "children": []
                                            },
                                            {
                                                "id": "3890",
                                                "linkid": "3887",
                                                "code": "30103010103",
                                                "paCode": "301030101",
                                                "yn": "N",
                                                "title": "港澳台航空旅客运输服务",
                                                "alias": "港澳台航空旅客运输服务",
                                                "about": "指通过航空运输方式往返香港、澳门、台湾以及在香港、澳门、台湾提供的旅客运输业务活动。",
                                                "kws": "港澳台航空旅客运输",
                                                "taxName": "运输服务",
                                                "taxRate": "9%",
                                                "vip": null,
                                                "itaxRate": "0.09",
                                                "taxCode": "3010301010300000000",
                                                "taxCodeTitle": "运输服务",
                                                "iTitle": "*运输服务*港澳台航空旅客运输服务",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "3891",
                                        "linkid": "3886",
                                        "code": "301030102",
                                        "paCode": "3010301",
                                        "yn": "Y",
                                        "title": "航空货物运输服务",
                                        "alias": "航空货物运输服务",
                                        "about": "指通过空中航线运送货物的运输业务活动。",
                                        "kws": "航空货物运输",
                                        "taxName": "运输服务",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "3010301020000000000",
                                        "taxCodeTitle": "运输服务",
                                        "iTitle": "*运输服务*航空货物运输服务",
                                        "children": [
                                            {
                                                "id": "3892",
                                                "linkid": "3891",
                                                "code": "30103010201",
                                                "paCode": "301030102",
                                                "yn": "N",
                                                "title": "国内航空货物运输服务",
                                                "alias": "国内航空货物运输服务",
                                                "about": "指起运地和目的地都在境内的航空货物运输业务活动。",
                                                "kws": "国内航空货物运输",
                                                "taxName": "运输服务",
                                                "taxRate": "9%",
                                                "vip": null,
                                                "itaxRate": "0.09",
                                                "taxCode": "3010301020100000000",
                                                "taxCodeTitle": "运输服务",
                                                "iTitle": "*运输服务*国内航空货物运输服务",
                                                "children": []
                                            },
                                            {
                                                "id": "3893",
                                                "linkid": "3891",
                                                "code": "30103010202",
                                                "paCode": "301030102",
                                                "yn": "N",
                                                "title": "国际航空货物运输服务",
                                                "alias": "国际航空货物运输服务",
                                                "about": "指通过航空运输方式从境内载运货物出境、从境外载运货物入境以及在境外载运货物的运输业务活动。",
                                                "kws": "国际航空货物运输",
                                                "taxName": "运输服务",
                                                "taxRate": "9%",
                                                "vip": null,
                                                "itaxRate": "0.09",
                                                "taxCode": "3010301020200000000",
                                                "taxCodeTitle": "运输服务",
                                                "iTitle": "*运输服务*国际航空货物运输服务",
                                                "children": []
                                            },
                                            {
                                                "id": "3894",
                                                "linkid": "3891",
                                                "code": "30103010203",
                                                "paCode": "301030102",
                                                "yn": "N",
                                                "title": "港澳台航空货物运输服务",
                                                "alias": "港澳台航空货物运输服务",
                                                "about": "指通过航空运输方式往返香港、澳门、台湾以及在香港、澳门、台湾提供的货物运输业务活动。",
                                                "kws": "港澳台航空货物运输",
                                                "taxName": "运输服务",
                                                "taxRate": "9%",
                                                "vip": null,
                                                "itaxRate": "0.09",
                                                "taxCode": "3010301020300000000",
                                                "taxCodeTitle": "运输服务",
                                                "iTitle": "*运输服务*港澳台航空货物运输服务",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "3895",
                                        "linkid": "3886",
                                        "code": "301030103",
                                        "paCode": "3010301",
                                        "yn": "Y",
                                        "title": "航空运输湿租业务",
                                        "alias": "航空运输湿租业务",
                                        "about": "指航空运输企业将配备有机组人员的飞机承租给他人使用一定期限，承租期内听候承租方调遣，不论是否经营，均按一定标准向承租方收取租赁费，发生的固定费用均由承租方承担的业务。",
                                        "kws": "航空运输湿租",
                                        "taxName": "运输服务",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "3010301030000000000",
                                        "taxCodeTitle": "运输服务",
                                        "iTitle": "*运输服务*航空运输湿租业务",
                                        "children": [
                                            {
                                                "id": "3896",
                                                "linkid": "3895",
                                                "code": "30103010301",
                                                "paCode": "301030103",
                                                "yn": "N",
                                                "title": "航空旅客运输湿租业务",
                                                "alias": "航空旅客运输湿租业务",
                                                "about": "指航空运输企业将配备有机组人员的飞机承租给他人使用（主要用于旅客运输）一定期限，承租期内听候承租方调遣，不论是否经营，均按一定标准向承租方收取租赁费，发生的固定费用均由承租方承担的业务。",
                                                "kws": "航空货物运输湿租、航空货物湿租",
                                                "taxName": "运输服务",
                                                "taxRate": "9%",
                                                "vip": null,
                                                "itaxRate": "0.09",
                                                "taxCode": "3010301030100000000",
                                                "taxCodeTitle": "运输服务",
                                                "iTitle": "*运输服务*航空旅客运输湿租业务",
                                                "children": []
                                            },
                                            {
                                                "id": "3897",
                                                "linkid": "3895",
                                                "code": "30103010302",
                                                "paCode": "301030103",
                                                "yn": "N",
                                                "title": "航空货物运输湿租业务",
                                                "alias": "航空货物运输湿租业务",
                                                "about": "指航空运输企业将配备有机组人员的飞机承租给他人使用（主要用于货物运输）一定期限，承租期内听候承租方调遣，不论是否经营，均按一定标准向承租方收取租赁费，发生的固定费用均由承租方承担的业务。",
                                                "kws": "航空旅客运输湿租、航空旅客湿租",
                                                "taxName": "运输服务",
                                                "taxRate": "9%",
                                                "vip": null,
                                                "itaxRate": "0.09",
                                                "taxCode": "3010301030200000000",
                                                "taxCodeTitle": "运输服务",
                                                "iTitle": "*运输服务*航空货物运输湿租业务",
                                                "children": []
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "id": "3898",
                                "linkid": "3885",
                                "code": "3010302",
                                "paCode": "30103",
                                "yn": "N",
                                "title": "航天运输服务",
                                "alias": "航天运输服务",
                                "about": "指利用火箭等载体将卫星、空间探测器等空间飞行器发射到空间轨道的业务活动。",
                                "kws": "航天运输",
                                "taxName": "运输服务",
                                "taxRate": "9%",
                                "vip": null,
                                "itaxRate": "0.09",
                                "taxCode": "3010302000000000000",
                                "taxCodeTitle": "运输服务",
                                "iTitle": "*运输服务*航天运输服务",
                                "children": []
                            }
                        ]
                    },
                    {
                        "id": "3899",
                        "linkid": "3837",
                        "code": "30104",
                        "paCode": "301",
                        "yn": "Y",
                        "title": "管道运输服务",
                        "alias": "管道运输服务",
                        "about": "指通过管道设施输送气体、液体、固体物质的运输业务活动。",
                        "kws": "管道运输",
                        "taxName": "运输服务",
                        "taxRate": "",
                        "vip": "5",
                        "itaxRate": null,
                        "taxCode": "3010400000000000000",
                        "taxCodeTitle": "运输服务",
                        "iTitle": "*运输服务*管道运输服务",
                        "children": [
                            {
                                "id": "3900",
                                "linkid": "3899",
                                "code": "3010401",
                                "paCode": "30104",
                                "yn": "Y",
                                "title": "液体管道运输服务",
                                "alias": "液体管道运输服务",
                                "about": "指通过管道设施输送液体物质（如原油、成品油、水等）的运输业务活动。",
                                "kws": "液体管道运输",
                                "taxName": "运输服务",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "3010401000000000000",
                                "taxCodeTitle": "运输服务",
                                "iTitle": "*运输服务*液体管道运输服务",
                                "children": [
                                    {
                                        "id": "3901",
                                        "linkid": "3900",
                                        "code": "301040101",
                                        "paCode": "3010401",
                                        "yn": "N",
                                        "title": "国内液体管道运输服务",
                                        "alias": "国内液体管道运输服务",
                                        "about": "指起运地和目的地都在境内的液体管道运输业务活动。",
                                        "kws": "国内液体管道运输",
                                        "taxName": "运输服务",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "3010401010000000000",
                                        "taxCodeTitle": "运输服务",
                                        "iTitle": "*运输服务*国内液体管道运输服务",
                                        "children": []
                                    },
                                    {
                                        "id": "3902",
                                        "linkid": "3900",
                                        "code": "301040102",
                                        "paCode": "3010401",
                                        "yn": "N",
                                        "title": "国际液体管道运输服务",
                                        "alias": "国际液体管道运输服务",
                                        "about": "指通过管道运输方式从境内载运液体货物出境、从境外载运液体货物入境以及在境外载运液体货物的运输业务活动。",
                                        "kws": "国际液体管道运输",
                                        "taxName": "运输服务",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "3010401020000000000",
                                        "taxCodeTitle": "运输服务",
                                        "iTitle": "*运输服务*国际液体管道运输服务",
                                        "children": []
                                    },
                                    {
                                        "id": "3903",
                                        "linkid": "3900",
                                        "code": "301040103",
                                        "paCode": "3010401",
                                        "yn": "N",
                                        "title": "港澳台液体管道运输服务",
                                        "alias": "港澳台液体管道运输服务",
                                        "about": "指利用管道运输方式运送液体货物往返香港、澳门、台湾以及在香港、澳门、台湾运送液体货物的运输业务活动。",
                                        "kws": "港澳台液体管道运输",
                                        "taxName": "运输服务",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "3010401030000000000",
                                        "taxCodeTitle": "运输服务",
                                        "iTitle": "*运输服务*港澳台液体管道运输服务",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3904",
                                "linkid": "3899",
                                "code": "3010402",
                                "paCode": "30104",
                                "yn": "Y",
                                "title": "气体管道运输服务",
                                "alias": "气体管道运输服务",
                                "about": "指通过管道设施输送气体物质（如天然气、煤气、蒸气等）的运输业务活动。",
                                "kws": "气体管道运输",
                                "taxName": "运输服务",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "3010402000000000000",
                                "taxCodeTitle": "运输服务",
                                "iTitle": "*运输服务*气体管道运输服务",
                                "children": [
                                    {
                                        "id": "3905",
                                        "linkid": "3904",
                                        "code": "301040201",
                                        "paCode": "3010402",
                                        "yn": "N",
                                        "title": "国内气体管道运输服务",
                                        "alias": "国内气体管道运输服务",
                                        "about": "指起运地和目的地都在境内的气体管道运输业务活动。",
                                        "kws": "国内气体管道运输",
                                        "taxName": "运输服务",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "3010402010000000000",
                                        "taxCodeTitle": "运输服务",
                                        "iTitle": "*运输服务*国内气体管道运输服务",
                                        "children": []
                                    },
                                    {
                                        "id": "3906",
                                        "linkid": "3904",
                                        "code": "301040202",
                                        "paCode": "3010402",
                                        "yn": "N",
                                        "title": "国际气体管道运输服务",
                                        "alias": "国际气体管道运输服务",
                                        "about": "指通过管道运输方式从境内载运气体货物出境、从境外载运气体货物入境以及在境外载运气体货物的运输业务活动。",
                                        "kws": "国际气体管道运输",
                                        "taxName": "运输服务",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "3010402020000000000",
                                        "taxCodeTitle": "运输服务",
                                        "iTitle": "*运输服务*国际气体管道运输服务",
                                        "children": []
                                    },
                                    {
                                        "id": "3907",
                                        "linkid": "3904",
                                        "code": "301040203",
                                        "paCode": "3010402",
                                        "yn": "N",
                                        "title": "港澳台气体管道运输服务",
                                        "alias": "港澳台气体管道运输服务",
                                        "about": "指利用管道运输方式运送气体货物往返香港、澳门、台湾以及在香港、澳门、台湾运送气体货物的运输业务活动。",
                                        "kws": "港澳台气体管道运输",
                                        "taxName": "运输服务",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "3010402030000000000",
                                        "taxCodeTitle": "运输服务",
                                        "iTitle": "*运输服务*港澳台气体管道运输服务",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3908",
                                "linkid": "3899",
                                "code": "3010403",
                                "paCode": "30104",
                                "yn": "Y",
                                "title": "固体管道运输服务",
                                "alias": "固体管道运输服务",
                                "about": "指通过管道设施输送固体物质（如粉末等）的运输业务活动。",
                                "kws": "固体管道运输",
                                "taxName": "运输服务",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "3010403000000000000",
                                "taxCodeTitle": "运输服务",
                                "iTitle": "*运输服务*固体管道运输服务",
                                "children": [
                                    {
                                        "id": "3909",
                                        "linkid": "3908",
                                        "code": "301040301",
                                        "paCode": "3010403",
                                        "yn": "N",
                                        "title": "国内固体管道运输服务",
                                        "alias": "国内固体管道运输服务",
                                        "about": "指起运地和目的地都在境内的固体管道运输业务活动。",
                                        "kws": "国内固体管道运输",
                                        "taxName": "运输服务",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "3010403010000000000",
                                        "taxCodeTitle": "运输服务",
                                        "iTitle": "*运输服务*国内固体管道运输服务",
                                        "children": []
                                    },
                                    {
                                        "id": "3910",
                                        "linkid": "3908",
                                        "code": "301040302",
                                        "paCode": "3010403",
                                        "yn": "N",
                                        "title": "国际固体管道运输服务",
                                        "alias": "国际固体管道运输服务",
                                        "about": "指通过管道运输方式从境内载运固体货物出境、从境外载运固体货物入境以及在境外载运固体货物的运输业务活动。",
                                        "kws": "国际固体管道运输",
                                        "taxName": "运输服务",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "3010403020000000000",
                                        "taxCodeTitle": "运输服务",
                                        "iTitle": "*运输服务*国际固体管道运输服务",
                                        "children": []
                                    },
                                    {
                                        "id": "3911",
                                        "linkid": "3908",
                                        "code": "301040303",
                                        "paCode": "3010403",
                                        "yn": "N",
                                        "title": "港澳台固体管道运输服务",
                                        "alias": "港澳台固体管道运输服务",
                                        "about": "指利用管道运输方式运送固体货物往返香港、澳门、台湾的交通运输服务以及在香港、澳门、台湾提供管道运送固体货物的运输业务活动。",
                                        "kws": "港澳台固体管道运输",
                                        "taxName": "运输服务",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "3010403030000000000",
                                        "taxCodeTitle": "运输服务",
                                        "iTitle": "*运输服务*港澳台固体管道运输服务",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3912",
                                "linkid": "3899",
                                "code": "3010499",
                                "paCode": "30104",
                                "yn": "Y",
                                "title": "其他管道运输服务",
                                "alias": "其他管道运输服务",
                                "about": null,
                                "kws": null,
                                "taxName": "运输服务",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "3010499000000000000",
                                "taxCodeTitle": "运输服务",
                                "iTitle": "*运输服务*其他管道运输服务",
                                "children": [
                                    {
                                        "id": "3913",
                                        "linkid": "3912",
                                        "code": "301049901",
                                        "paCode": "3010499",
                                        "yn": "N",
                                        "title": "国内其他管道运输服务",
                                        "alias": "国内其他管道运输服务",
                                        "about": "指起运地和目的地都在境内的其他管道运输业务活动。",
                                        "kws": null,
                                        "taxName": "运输服务",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "3010499010000000000",
                                        "taxCodeTitle": "运输服务",
                                        "iTitle": "*运输服务*国内其他管道运输服务",
                                        "children": []
                                    },
                                    {
                                        "id": "3914",
                                        "linkid": "3912",
                                        "code": "301049902",
                                        "paCode": "3010499",
                                        "yn": "N",
                                        "title": "国际其他管道运输服务",
                                        "alias": "国际其他管道运输服务",
                                        "about": "指通过管道运输方式在境内载运其他货物出境、从境外载运其他货物入境以及在境外载运其他货物的运输业务活动。",
                                        "kws": null,
                                        "taxName": "运输服务",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "3010499020000000000",
                                        "taxCodeTitle": "运输服务",
                                        "iTitle": "*运输服务*国际其他管道运输服务",
                                        "children": []
                                    },
                                    {
                                        "id": "3915",
                                        "linkid": "3912",
                                        "code": "301049903",
                                        "paCode": "3010499",
                                        "yn": "N",
                                        "title": "港澳台其他管道运输服务",
                                        "alias": "港澳台其他管道运输服务",
                                        "about": "指利用管道运输方式运送其他货物往返香港、澳门、台湾以及在香港、澳门、台湾提供管道运送其他货物的运输业务活动。",
                                        "kws": null,
                                        "taxName": "运输服务",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "3010499030000000000",
                                        "taxCodeTitle": "运输服务",
                                        "iTitle": "*运输服务*港澳台其他管道运输服务",
                                        "children": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "id": "3916",
                        "linkid": "3837",
                        "code": "30105",
                        "paCode": "301",
                        "yn": "Y",
                        "title": "无运输工具承运业务",
                        "alias": "无运输工具承运业务",
                        "about": "指经营者以承运人身份与托运人签订运输服务合同，收取运费并承担承运人责任，然后委托实际承运人完成运输服务的经营活动。",
                        "kws": "无运输工具承运",
                        "taxName": "运输服务",
                        "taxRate": "",
                        "vip": "7",
                        "itaxRate": null,
                        "taxCode": "3010500000000000000",
                        "taxCodeTitle": "运输服务",
                        "iTitle": "*运输服务*无运输工具承运业务",
                        "children": [
                            {
                                "id": "3917",
                                "linkid": "3916",
                                "code": "3010502",
                                "paCode": "30105",
                                "yn": "Y",
                                "title": "无运输工具承运陆路运输业务",
                                "alias": "无运输工具承运陆路运输业务",
                                "about": "指经营者以承运人身份与托运人签订陆路运输服务合同，收取运费并承担承运人责任，然后委托实际承运人完成运输服务的经营活动。",
                                "kws": "无运输工具陆路承运",
                                "taxName": "运输服务",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "3010502000000000000",
                                "taxCodeTitle": "运输服务",
                                "iTitle": "*运输服务*无运输工具承运陆路运输业务",
                                "children": [
                                    {
                                        "id": "3918",
                                        "linkid": "3917",
                                        "code": "301050201",
                                        "paCode": "3010502",
                                        "yn": "Y",
                                        "title": "无运输工具承运铁路运输服务",
                                        "alias": "无运输工具承运铁路运输服务",
                                        "about": "指经营者以承运人身份与托运人签订铁路运输服务合同，收取运费并承担承运人责任，然后委托实际承运人完成运输服务的经营活动。",
                                        "kws": "无运输工具铁路承运",
                                        "taxName": "运输服务",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "3010502010000000000",
                                        "taxCodeTitle": "运输服务",
                                        "iTitle": "*运输服务*无运输工具承运铁路运输服务",
                                        "children": [
                                            {
                                                "id": "3919",
                                                "linkid": "3918",
                                                "code": "30105020101",
                                                "paCode": "301050201",
                                                "yn": "N",
                                                "title": "无运输工具承运铁路旅客运输服务",
                                                "alias": "无运输工具承运铁路旅客运输服务",
                                                "about": "指经营者以承运人身份与托运人签订铁路旅客运输服务合同，收取运费并承担承运人责任，然后委托实际承运人完成运输服务的经营活动。",
                                                "kws": "无运输工具铁路旅客承运",
                                                "taxName": "运输服务",
                                                "taxRate": "9%",
                                                "vip": null,
                                                "itaxRate": "0.09",
                                                "taxCode": "3010502010100000000",
                                                "taxCodeTitle": "运输服务",
                                                "iTitle": "*运输服务*无运输工具承运铁路旅客运输服务",
                                                "children": []
                                            },
                                            {
                                                "id": "3920",
                                                "linkid": "3918",
                                                "code": "30105020102",
                                                "paCode": "301050201",
                                                "yn": "N",
                                                "title": "无运输工具承运铁路货物运输服务",
                                                "alias": "无运输工具承运铁路货物运输服务",
                                                "about": "指经营者以承运人身份与托运人签订铁路货物运输服务合同，收取运费并承担承运人责任，然后委托实际承运人完成运输服务的经营活动。",
                                                "kws": "无运输工具铁路货物承运",
                                                "taxName": "运输服务",
                                                "taxRate": "9%",
                                                "vip": null,
                                                "itaxRate": "0.09",
                                                "taxCode": "3010502010200000000",
                                                "taxCodeTitle": "运输服务",
                                                "iTitle": "*运输服务*无运输工具承运铁路货物运输服务",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "3921",
                                        "linkid": "3917",
                                        "code": "301050202",
                                        "paCode": "3010502",
                                        "yn": "Y",
                                        "title": "无运输工具承运道路运输服务",
                                        "alias": "无运输工具承运道路运输服务",
                                        "about": "指经营者以承运人身份与托运人签订道路运输服务合同，收取运费并承担承运人责任，然后委托实际承运人完成运输服务的经营活动。",
                                        "kws": "无运输工具承运道路运输",
                                        "taxName": "运输服务",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "3010502020000000000",
                                        "taxCodeTitle": "运输服务",
                                        "iTitle": "*运输服务*无运输工具承运道路运输服务",
                                        "children": [
                                            {
                                                "id": "3922",
                                                "linkid": "3921",
                                                "code": "30105020201",
                                                "paCode": "301050202",
                                                "yn": "N",
                                                "title": "无运输工具承运道路旅客运输服务",
                                                "alias": "无运输工具承运道路旅客运输服务",
                                                "about": "指经营者以承运人身份与托运人签订道路旅客运输服务合同，收取运费并承担承运人责任，然后委托实际承运人完成运输服务的经营活动。",
                                                "kws": "无运输工具承运道路旅客运输",
                                                "taxName": "运输服务",
                                                "taxRate": "9%",
                                                "vip": null,
                                                "itaxRate": "0.09",
                                                "taxCode": "3010502020100000000",
                                                "taxCodeTitle": "运输服务",
                                                "iTitle": "*运输服务*无运输工具承运道路旅客运输服务",
                                                "children": []
                                            },
                                            {
                                                "id": "3923",
                                                "linkid": "3921",
                                                "code": "30105020202",
                                                "paCode": "301050202",
                                                "yn": "N",
                                                "title": "无运输工具承运道路货物运输服务",
                                                "alias": "无运输工具承运道路货物运输服务",
                                                "about": "指经营者以承运人身份与托运人签订道路货物运输服务合同，收取运费并承担承运人责任，然后委托实际承运人完成运输服务的经营活动。",
                                                "kws": "无运输工具承运道路货物运输",
                                                "taxName": "运输服务",
                                                "taxRate": "9%",
                                                "vip": null,
                                                "itaxRate": "0.09",
                                                "taxCode": "3010502020200000000",
                                                "taxCodeTitle": "运输服务",
                                                "iTitle": "*运输服务*无运输工具承运道路货物运输服务",
                                                "children": []
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "id": "3924",
                                "linkid": "3916",
                                "code": "3010503",
                                "paCode": "30105",
                                "yn": "Y",
                                "title": "无运输工具承运水路运输服务",
                                "alias": "无运输工具承运水路运输服务",
                                "about": "指经营者以承运人身份与托运人签订水路运输服务合同，收取运费并承担承运人责任，然后委托实际承运人完成运输服务的经营活动。",
                                "kws": "无运输工具承运水路运输",
                                "taxName": "运输服务",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "3010503000000000000",
                                "taxCodeTitle": "运输服务",
                                "iTitle": "*运输服务*无运输工具承运水路运输服务",
                                "children": [
                                    {
                                        "id": "3925",
                                        "linkid": "3924",
                                        "code": "301050301",
                                        "paCode": "3010503",
                                        "yn": "N",
                                        "title": "无运输工具承运水路旅客运输服务",
                                        "alias": "无运输工具承运水路旅客运输服务",
                                        "about": "指经营者以承运人身份与托运人签订水路旅客运输服务合同，收取运费并承担承运人责任，然后委托实际承运人完成运输服务的经营活动。",
                                        "kws": "无运输工具承运水路旅客运输",
                                        "taxName": "运输服务",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "3010503010000000000",
                                        "taxCodeTitle": "运输服务",
                                        "iTitle": "*运输服务*无运输工具承运水路旅客运输服务",
                                        "children": []
                                    },
                                    {
                                        "id": "3926",
                                        "linkid": "3924",
                                        "code": "301050302",
                                        "paCode": "3010503",
                                        "yn": "N",
                                        "title": "无运输工具承运水路货物运输服务",
                                        "alias": "无运输工具承运水路货物运输服务",
                                        "about": "指经营者以承运人身份与托运人签订水路货物运输服务合同，收取运费并承担承运人责任，然后委托实际承运人完成运输服务的经营活动。",
                                        "kws": "无运输工具承运水路货物运输",
                                        "taxName": "运输服务",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "3010503020000000000",
                                        "taxCodeTitle": "运输服务",
                                        "iTitle": "*运输服务*无运输工具承运水路货物运输服务",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3927",
                                "linkid": "3916",
                                "code": "3010504",
                                "paCode": "30105",
                                "yn": "Y",
                                "title": "无运输工具承运航空运输服务",
                                "alias": "无运输工具承运航空运输服务",
                                "about": "指经营者以承运人身份与托运人签订航空运输服务合同，收取运费并承担承运人责任，然后委托实际承运人完成运输服务的经营活动。",
                                "kws": "无运输工具承运航空运输",
                                "taxName": "运输服务",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "3010504000000000000",
                                "taxCodeTitle": "运输服务",
                                "iTitle": "*运输服务*无运输工具承运航空运输服务",
                                "children": [
                                    {
                                        "id": "3928",
                                        "linkid": "3927",
                                        "code": "301050401",
                                        "paCode": "3010504",
                                        "yn": "N",
                                        "title": "无运输工具承运航空旅客运输服务",
                                        "alias": "无运输工具承运航空旅客运输服务",
                                        "about": "指经营者以承运人身份与托运人签订航空旅客运输服务合同，收取运费并承担承运人责任，然后委托实际承运人完成运输服务的经营活动。",
                                        "kws": "无运输工具承运航空旅客运输",
                                        "taxName": "运输服务",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "3010504010000000000",
                                        "taxCodeTitle": "运输服务",
                                        "iTitle": "*运输服务*无运输工具承运航空旅客运输服务",
                                        "children": []
                                    },
                                    {
                                        "id": "3929",
                                        "linkid": "3927",
                                        "code": "301050402",
                                        "paCode": "3010504",
                                        "yn": "N",
                                        "title": "无运输工具承运航空货物运输服务",
                                        "alias": "无运输工具承运航空货物运输服务",
                                        "about": "指经营者以承运人身份与托运人签订航空货物运输服务合同，收取运费并承担承运人责任，然后委托实际承运人完成运输服务的经营活动。",
                                        "kws": "无运输工具承运航空货物运输",
                                        "taxName": "运输服务",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "3010504020000000000",
                                        "taxCodeTitle": "运输服务",
                                        "iTitle": "*运输服务*无运输工具承运航空货物运输服务",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3930",
                                "linkid": "3916",
                                "code": "3010505",
                                "paCode": "30105",
                                "yn": "N",
                                "title": "无运输工具承运管道运输服务",
                                "alias": "无运输工具承运管道运输服务",
                                "about": "指经营者以承运人身份与托运人签订管道运输服务合同，收取运费并承担承运人责任，然后委托实际承运人完成运输服务的经营活动。",
                                "kws": "无运输工具承运管道运输",
                                "taxName": "运输服务",
                                "taxRate": "9%",
                                "vip": null,
                                "itaxRate": "0.09",
                                "taxCode": "3010505000000000000",
                                "taxCodeTitle": "运输服务",
                                "iTitle": "*运输服务*无运输工具承运管道运输服务",
                                "children": []
                            },
                            {
                                "id": "3931",
                                "linkid": "3916",
                                "code": "3010506",
                                "paCode": "30105",
                                "yn": "Y",
                                "title": "无运输工具承运联运运输服务",
                                "alias": "无运输工具承运联运运输服务",
                                "about": "指经营者以承运人身份与托运人签订联运运输服务合同，收取运费并承担承运人责任，然后委托实际承运人利用多种运输工具完成运输服务的经营活动。",
                                "kws": "无运输工具承运联运运输",
                                "taxName": "运输服务",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "3010506000000000000",
                                "taxCodeTitle": "运输服务",
                                "iTitle": "*运输服务*无运输工具承运联运运输服务",
                                "children": [
                                    {
                                        "id": "3932",
                                        "linkid": "3931",
                                        "code": "301050601",
                                        "paCode": "3010506",
                                        "yn": "N",
                                        "title": "无运输工具承运旅客联运运输服务",
                                        "alias": "无运输工具承运旅客联运运输服务",
                                        "about": "指经营者以承运人身份与托运人签订旅客联运运输服务合同，收取运费并承担承运人责任，然后委托实际承运人利用多种运输工具完成运输服务的经营活动。",
                                        "kws": "无运输工具承运旅客联运运输",
                                        "taxName": "运输服务",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "3010506010000000000",
                                        "taxCodeTitle": "运输服务",
                                        "iTitle": "*运输服务*无运输工具承运旅客联运运输服务",
                                        "children": []
                                    },
                                    {
                                        "id": "3933",
                                        "linkid": "3931",
                                        "code": "301050602",
                                        "paCode": "3010506",
                                        "yn": "N",
                                        "title": "无运输工具承运货物联运运输服务",
                                        "alias": "无运输工具承运货物联运运输服务",
                                        "about": "指经营者以承运人身份与托运人签订货物联运运输服务合同，收取运费并承担承运人责任，然后委托实际承运人利用多种运输工具完成运输服务的经营活动。",
                                        "kws": "无运输工具承运货物联运运输",
                                        "taxName": "运输服务",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "3010506020000000000",
                                        "taxCodeTitle": "运输服务",
                                        "iTitle": "*运输服务*无运输工具承运货物联运运输服务",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3934",
                                "linkid": "3916",
                                "code": "3010599",
                                "paCode": "30105",
                                "yn": "Y",
                                "title": "其他无运输工具承运业务",
                                "alias": "其他无运输工具承运业务",
                                "about": null,
                                "kws": "其他无运输工具承运",
                                "taxName": "运输服务",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "3010599000000000000",
                                "taxCodeTitle": "运输服务",
                                "iTitle": "*运输服务*其他无运输工具承运业务",
                                "children": [
                                    {
                                        "id": "3935",
                                        "linkid": "3934",
                                        "code": "301059901",
                                        "paCode": "3010599",
                                        "yn": "N",
                                        "title": "其他无运输工具承运旅客运输业务",
                                        "alias": "其他无运输工具承运旅客运输业务",
                                        "about": null,
                                        "kws": "其他无运输工具承运旅客运输",
                                        "taxName": "运输服务",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "3010599010000000000",
                                        "taxCodeTitle": "运输服务",
                                        "iTitle": "*运输服务*其他无运输工具承运旅客运输业务",
                                        "children": []
                                    },
                                    {
                                        "id": "3936",
                                        "linkid": "3934",
                                        "code": "301059902",
                                        "paCode": "3010599",
                                        "yn": "N",
                                        "title": "其他无运输工具承运货物运输业务",
                                        "alias": "其他无运输工具承运货物运输业务",
                                        "about": null,
                                        "kws": "其他无运输工具承运货物运输",
                                        "taxName": "运输服务",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "3010599020000000000",
                                        "taxCodeTitle": "运输服务",
                                        "iTitle": "*运输服务*其他无运输工具承运货物运输业务",
                                        "children": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "id": "3937",
                        "linkid": "3837",
                        "code": "30106",
                        "paCode": "301",
                        "yn": "Y",
                        "title": "联运服务",
                        "alias": "联运服务",
                        "about": "指利用多种运输工具载运旅客、货物的业务活动。",
                        "kws": "联运",
                        "taxName": "运输服务",
                        "taxRate": "",
                        "vip": "7",
                        "itaxRate": null,
                        "taxCode": "3010600000000000000",
                        "taxCodeTitle": "运输服务",
                        "iTitle": "*运输服务*联运服务",
                        "children": [
                            {
                                "id": "3938",
                                "linkid": "3937",
                                "code": "3010601",
                                "paCode": "30106",
                                "yn": "N",
                                "title": "旅客联运服务",
                                "alias": "旅客联运服务",
                                "about": "指利用多种运输工具载运旅客的业务活动。",
                                "kws": "旅客联运",
                                "taxName": "运输服务",
                                "taxRate": "9%",
                                "vip": null,
                                "itaxRate": "0.09",
                                "taxCode": "3010601000000000000",
                                "taxCodeTitle": "运输服务",
                                "iTitle": "*运输服务*旅客联运服务",
                                "children": []
                            },
                            {
                                "id": "3939",
                                "linkid": "3937",
                                "code": "3010602",
                                "paCode": "30106",
                                "yn": "N",
                                "title": "货物联运服务",
                                "alias": "货物联运服务",
                                "about": "指利用多种运输工具载运货物的业务活动。",
                                "kws": "货物联运",
                                "taxName": "运输服务",
                                "taxRate": "9%",
                                "vip": null,
                                "itaxRate": "0.09",
                                "taxCode": "3010602000000000000",
                                "taxCodeTitle": "运输服务",
                                "iTitle": "*运输服务*货物联运服务",
                                "children": []
                            }
                        ]
                    },
                    {
                        "id": "3940",
                        "linkid": "3837",
                        "code": "30199",
                        "paCode": "301",
                        "yn": "Y",
                        "title": "其他运输服务",
                        "alias": "其他运输服务",
                        "about": "指其他未列明的运输活动。",
                        "kws": "其他运输",
                        "taxName": "运输服务",
                        "taxRate": "",
                        "vip": "7",
                        "itaxRate": null,
                        "taxCode": "3019900000000000000",
                        "taxCodeTitle": "运输服务",
                        "iTitle": "*运输服务*其他运输服务",
                        "children": [
                            {
                                "id": "3941",
                                "linkid": "3940",
                                "code": "3019901",
                                "paCode": "30199",
                                "yn": "N",
                                "title": "其他旅客运输服务",
                                "alias": "其他旅客运输服务",
                                "about": null,
                                "kws": "其他旅客运输",
                                "taxName": "运输服务",
                                "taxRate": "9%",
                                "vip": null,
                                "itaxRate": "0.09",
                                "taxCode": "3019901000000000000",
                                "taxCodeTitle": "运输服务",
                                "iTitle": "*运输服务*其他旅客运输服务",
                                "children": []
                            },
                            {
                                "id": "3942",
                                "linkid": "3940",
                                "code": "3019902",
                                "paCode": "30199",
                                "yn": "N",
                                "title": "其他货物运输服务",
                                "alias": "其他货物运输服务",
                                "about": null,
                                "kws": "其他货物运输",
                                "taxName": "运输服务",
                                "taxRate": "9%",
                                "vip": null,
                                "itaxRate": "0.09",
                                "taxCode": "3019902000000000000",
                                "taxCodeTitle": "运输服务",
                                "iTitle": "*运输服务*其他货物运输服务",
                                "children": []
                            }
                        ]
                    }
                ]
            },
            {
                "id": "3943",
                "linkid": "3836",
                "code": "302",
                "paCode": "3",
                "yn": "Y",
                "title": "邮政服务",
                "alias": "邮政服务",
                "about": "指中国邮政集团公司及其所属邮政企业提供邮件寄递、邮政汇兑和机要通信等邮政基本服务的业务活动。包括邮政普遍服务和邮政特殊服务。",
                "kws": null,
                "taxName": "邮政服务",
                "taxRate": "",
                "vip": "7",
                "itaxRate": null,
                "taxCode": "3020000000000000000",
                "taxCodeTitle": "邮政服务",
                "iTitle": "*邮政服务*邮政服务",
                "children": [
                    {
                        "id": "3944",
                        "linkid": "3943",
                        "code": "30201",
                        "paCode": "302",
                        "yn": "Y",
                        "title": "邮政普遍服务",
                        "alias": "邮政普遍服务",
                        "about": "指函件、包裹等邮件寄递，以及邮票发行、报刊发行和邮政汇兑等业务活动。",
                        "kws": null,
                        "taxName": "邮政服务",
                        "taxRate": "",
                        "vip": "5",
                        "itaxRate": null,
                        "taxCode": "3020100000000000000",
                        "taxCodeTitle": "邮政服务",
                        "iTitle": "*邮政服务*邮政普遍服务",
                        "children": [
                            {
                                "id": "3945",
                                "linkid": "3944",
                                "code": "3020101",
                                "paCode": "30201",
                                "yn": "Y",
                                "title": "邮件寄递服务",
                                "alias": "邮件寄递服务",
                                "about": "指函件、包裹等邮件寄递的服务业务。",
                                "kws": "邮件寄递",
                                "taxName": "邮政服务",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "3020101000000000000",
                                "taxCodeTitle": "邮政服务",
                                "iTitle": "*邮政服务*邮件寄递服务",
                                "children": [
                                    {
                                        "id": "3946",
                                        "linkid": "3945",
                                        "code": "302010101",
                                        "paCode": "3020101",
                                        "yn": "N",
                                        "title": "函件寄递服务",
                                        "alias": "函件寄递服务",
                                        "about": "指信函、印刷品、邮资封片卡、无名址函件和邮政小包等的寄递服务业务。",
                                        "kws": "函件寄递",
                                        "taxName": "邮政服务",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "3020101010000000000",
                                        "taxCodeTitle": "邮政服务",
                                        "iTitle": "*邮政服务*函件寄递服务",
                                        "children": []
                                    },
                                    {
                                        "id": "3947",
                                        "linkid": "3945",
                                        "code": "302010102",
                                        "paCode": "3020101",
                                        "yn": "N",
                                        "title": "包裹寄递服务",
                                        "alias": "包裹寄递服务",
                                        "about": "指寄递包裹的业务，包裹是指按照封装上的名址递送给特定个人或者单位的独立封装的物品，其重量不超过五十千克，任何一边的尺寸不超过一百五十厘米，长、宽、高合计不超过三百厘米。",
                                        "kws": "包裹寄递",
                                        "taxName": "邮政服务",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "3020101020000000000",
                                        "taxCodeTitle": "邮政服务",
                                        "iTitle": "*邮政服务*包裹寄递服务",
                                        "children": []
                                    },
                                    {
                                        "id": "3948",
                                        "linkid": "3945",
                                        "code": "302010199",
                                        "paCode": "3020101",
                                        "yn": "N",
                                        "title": "其他邮件寄递服务",
                                        "alias": "其他邮件寄递服务",
                                        "about": "指除函件、包裹以外的邮件寄递服务。",
                                        "kws": null,
                                        "taxName": "邮政服务",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "3020101990000000000",
                                        "taxCodeTitle": "邮政服务",
                                        "iTitle": "*邮政服务*其他邮件寄递服务",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3949",
                                "linkid": "3944",
                                "code": "3020102",
                                "paCode": "30201",
                                "yn": "N",
                                "title": "邮票发行服务",
                                "alias": "邮票发行服务",
                                "about": null,
                                "kws": "邮票发行",
                                "taxName": "邮政服务",
                                "taxRate": "9%",
                                "vip": null,
                                "itaxRate": "0.09",
                                "taxCode": "3020102000000000000",
                                "taxCodeTitle": "邮政服务",
                                "iTitle": "*邮政服务*邮票发行服务",
                                "children": []
                            },
                            {
                                "id": "3950",
                                "linkid": "3944",
                                "code": "3020103",
                                "paCode": "30201",
                                "yn": "N",
                                "title": "报刊发行服务",
                                "alias": "报刊发行服务",
                                "about": null,
                                "kws": "报刊发行",
                                "taxName": "邮政服务",
                                "taxRate": "9%",
                                "vip": null,
                                "itaxRate": "0.09",
                                "taxCode": "3020103000000000000",
                                "taxCodeTitle": "邮政服务",
                                "iTitle": "*邮政服务*报刊发行服务",
                                "children": []
                            },
                            {
                                "id": "3951",
                                "linkid": "3944",
                                "code": "3020104",
                                "paCode": "30201",
                                "yn": "N",
                                "title": "邮政汇兑",
                                "alias": "邮政汇兑",
                                "about": null,
                                "kws": "邮政汇兑",
                                "taxName": "邮政服务",
                                "taxRate": "9%",
                                "vip": null,
                                "itaxRate": "0.09",
                                "taxCode": "3020104000000000000",
                                "taxCodeTitle": "邮政服务",
                                "iTitle": "*邮政服务*邮政汇兑",
                                "children": []
                            },
                            {
                                "id": "3952",
                                "linkid": "3944",
                                "code": "3020199",
                                "paCode": "30201",
                                "yn": "N",
                                "title": "其他邮政普遍服务",
                                "alias": "其他邮政普遍服务",
                                "about": null,
                                "kws": null,
                                "taxName": "邮政服务",
                                "taxRate": "9%",
                                "vip": null,
                                "itaxRate": "0.09",
                                "taxCode": "3020199000000000000",
                                "taxCodeTitle": "邮政服务",
                                "iTitle": "*邮政服务*其他邮政普遍服务",
                                "children": []
                            }
                        ]
                    },
                    {
                        "id": "3953",
                        "linkid": "3943",
                        "code": "30202",
                        "paCode": "302",
                        "yn": "N",
                        "title": "邮政特殊服务",
                        "alias": "邮政特殊服务",
                        "about": "指义务兵平常信函、机要通信、盲人读物和革命烈士遗物的寄递等业务活动。",
                        "kws": null,
                        "taxName": "邮政服务",
                        "taxRate": "9%",
                        "vip": "5",
                        "itaxRate": "0.09",
                        "taxCode": "3020200000000000000",
                        "taxCodeTitle": "邮政服务",
                        "iTitle": "*邮政服务*邮政特殊服务",
                        "children": []
                    },
                    {
                        "id": "3954",
                        "linkid": "3943",
                        "code": "30203",
                        "paCode": "302",
                        "yn": "Y",
                        "title": "其他邮政服务",
                        "alias": "其他邮政服务",
                        "about": "指邮册等邮品销售、邮政代理等业务活动。",
                        "kws": null,
                        "taxName": "邮政服务",
                        "taxRate": "",
                        "vip": "5",
                        "itaxRate": null,
                        "taxCode": "3020300000000000000",
                        "taxCodeTitle": "邮政服务",
                        "iTitle": "*邮政服务*其他邮政服务",
                        "children": [
                            {
                                "id": "3955",
                                "linkid": "3954",
                                "code": "3020301",
                                "paCode": "30203",
                                "yn": "N",
                                "title": "邮册等邮品销售服务",
                                "alias": "邮册等邮品销售服务",
                                "about": null,
                                "kws": "邮册销售、邮品销售",
                                "taxName": "邮政服务",
                                "taxRate": "9%",
                                "vip": null,
                                "itaxRate": "0.09",
                                "taxCode": "3020301000000000000",
                                "taxCodeTitle": "邮政服务",
                                "iTitle": "*邮政服务*邮册等邮品销售服务",
                                "children": []
                            },
                            {
                                "id": "3956",
                                "linkid": "3954",
                                "code": "3020302",
                                "paCode": "30203",
                                "yn": "N",
                                "title": "邮政代理服务",
                                "alias": "邮政代理服务",
                                "about": null,
                                "kws": "邮政代理",
                                "taxName": "邮政服务",
                                "taxRate": "9%",
                                "vip": null,
                                "itaxRate": "0.09",
                                "taxCode": "3020302000000000000",
                                "taxCodeTitle": "邮政服务",
                                "iTitle": "*邮政服务*邮政代理服务",
                                "children": []
                            },
                            {
                                "id": "3957",
                                "linkid": "3954",
                                "code": "3020399",
                                "paCode": "30203",
                                "yn": "N",
                                "title": "其他未列邮政服务",
                                "alias": "其他未列邮政服务",
                                "about": null,
                                "kws": null,
                                "taxName": "邮政服务",
                                "taxRate": "9%",
                                "vip": null,
                                "itaxRate": "0.09",
                                "taxCode": "3020399000000000000",
                                "taxCodeTitle": "邮政服务",
                                "iTitle": "*邮政服务*其他未列邮政服务",
                                "children": []
                            }
                        ]
                    }
                ]
            },
            {
                "id": "3958",
                "linkid": "3836",
                "code": "303",
                "paCode": "3",
                "yn": "Y",
                "title": "电信服务",
                "alias": "电信服务",
                "about": "指利用有线、无线的电磁系统或者光电系统等各种通信网络资源，提供语音通话服务，传送、发射、接收或者应用图像、短信等电子数据和信息的业务活动。包括基础电信服务和增值电信服务。",
                "kws": "电信服务",
                "taxName": "电信服务",
                "taxRate": "",
                "vip": "5",
                "itaxRate": null,
                "taxCode": "3030000000000000000",
                "taxCodeTitle": "电信服务",
                "iTitle": "*电信服务*电信服务",
                "children": [
                    {
                        "id": "3959",
                        "linkid": "3958",
                        "code": "30301",
                        "paCode": "303",
                        "yn": "Y",
                        "title": "基础电信服务",
                        "alias": "基础电信服务",
                        "about": "指利用固网、移动网、卫星、互联网，提供语音通话服务的业务活动，以及出租或者出售带宽、波长等网络元素的业务活动。",
                        "kws": "基础电信",
                        "taxName": "电信服务",
                        "taxRate": "",
                        "vip": "3",
                        "itaxRate": null,
                        "taxCode": "3030100000000000000",
                        "taxCodeTitle": "电信服务",
                        "iTitle": "*电信服务*基础电信服务",
                        "children": [
                            {
                                "id": "3960",
                                "linkid": "3959",
                                "code": "3030101",
                                "paCode": "30301",
                                "yn": "N",
                                "title": "语音通话服务",
                                "alias": "语音通话服务",
                                "about": null,
                                "kws": "语音通话、话费",
                                "taxName": "电信服务",
                                "taxRate": "9%",
                                "vip": null,
                                "itaxRate": "0.09",
                                "taxCode": "3030101000000000000",
                                "taxCodeTitle": "电信服务",
                                "iTitle": "*电信服务*语音通话服务",
                                "children": []
                            },
                            {
                                "id": "3961",
                                "linkid": "3959",
                                "code": "3030102",
                                "paCode": "30301",
                                "yn": "N",
                                "title": "出租或出售网络元素",
                                "alias": "出租或出售网络元素",
                                "about": null,
                                "kws": null,
                                "taxName": "电信服务",
                                "taxRate": "9%",
                                "vip": null,
                                "itaxRate": "0.09",
                                "taxCode": "3030102000000000000",
                                "taxCodeTitle": "电信服务",
                                "iTitle": "*电信服务*出租或出售网络元素",
                                "children": []
                            }
                        ]
                    },
                    {
                        "id": "3962",
                        "linkid": "3958",
                        "code": "30302",
                        "paCode": "303",
                        "yn": "Y",
                        "title": "增值电信服务",
                        "alias": "增值电信服务",
                        "about": "指利用固网、移动网、卫星、互联网、有线电视网络，提供短信和彩信服务、电子数据和信息的传输及应用服务、互联网接入服务等业务活动。",
                        "kws": "增值电信",
                        "taxName": "电信服务",
                        "taxRate": "",
                        "vip": "5",
                        "itaxRate": null,
                        "taxCode": "3030200000000000000",
                        "taxCodeTitle": "电信服务",
                        "iTitle": "*电信服务*增值电信服务",
                        "children": [
                            {
                                "id": "3963",
                                "linkid": "3962",
                                "code": "3030201",
                                "paCode": "30302",
                                "yn": "N",
                                "title": "短信和彩信服务",
                                "alias": "短信和彩信服务",
                                "about": null,
                                "kws": "短信、彩信",
                                "taxName": "电信服务",
                                "taxRate": "6%",
                                "vip": null,
                                "itaxRate": "0.06",
                                "taxCode": "3030201000000000000",
                                "taxCodeTitle": "电信服务",
                                "iTitle": "*电信服务*短信和彩信服务",
                                "children": []
                            },
                            {
                                "id": "3964",
                                "linkid": "3962",
                                "code": "3030202",
                                "paCode": "30302",
                                "yn": "N",
                                "title": "电子数据和信息的传输及应用服务",
                                "alias": "电子数据和信息的传输及应用服务",
                                "about": null,
                                "kws": "电子数据传输",
                                "taxName": "电信服务",
                                "taxRate": "6%",
                                "vip": null,
                                "itaxRate": "0.06",
                                "taxCode": "3030202000000000000",
                                "taxCodeTitle": "电信服务",
                                "iTitle": "*电信服务*电子数据和信息的传输及应用服务",
                                "children": []
                            },
                            {
                                "id": "3965",
                                "linkid": "3962",
                                "code": "3030203",
                                "paCode": "30302",
                                "yn": "N",
                                "title": "互联网接入服务",
                                "alias": "互联网接入服务",
                                "about": null,
                                "kws": "宽带、互联网接入",
                                "taxName": "电信服务",
                                "taxRate": "6%",
                                "vip": null,
                                "itaxRate": "0.06",
                                "taxCode": "3030203000000000000",
                                "taxCodeTitle": "电信服务",
                                "iTitle": "*电信服务*互联网接入服务",
                                "children": []
                            },
                            {
                                "id": "3966",
                                "linkid": "3962",
                                "code": "3030204",
                                "paCode": "30302",
                                "yn": "N",
                                "title": "广播电视信号传输服务",
                                "alias": "广播电视信号传输服务",
                                "about": null,
                                "kws": "广播电视信号传输",
                                "taxName": "电信服务",
                                "taxRate": "6%",
                                "vip": null,
                                "itaxRate": "0.06",
                                "taxCode": "3030204000000000000",
                                "taxCodeTitle": "电信服务",
                                "iTitle": "*电信服务*广播电视信号传输服务",
                                "children": []
                            },
                            {
                                "id": "3967",
                                "linkid": "3962",
                                "code": "3030205",
                                "paCode": "30302",
                                "yn": "N",
                                "title": "卫星电视信号落地转接服务",
                                "alias": "卫星电视信号落地转接服务",
                                "about": null,
                                "kws": "卫星电视信号落地转接服务",
                                "taxName": "电信服务",
                                "taxRate": "6%",
                                "vip": null,
                                "itaxRate": "0.06",
                                "taxCode": "3030205000000000000",
                                "taxCodeTitle": "电信服务",
                                "iTitle": "*电信服务*卫星电视信号落地转接服务",
                                "children": []
                            },
                            {
                                "id": "3968",
                                "linkid": "3962",
                                "code": "3030299",
                                "paCode": "30302",
                                "yn": "N",
                                "title": "其他增值电信服务",
                                "alias": "其他增值电信服务",
                                "about": "指除短信和彩信服务、电子数据和信息的传输及应用服务、互联网接入服务、广播电视信号传输服务以外的增值电信服务。",
                                "kws": null,
                                "taxName": "电信服务",
                                "taxRate": "6%",
                                "vip": null,
                                "itaxRate": "0.06",
                                "taxCode": "3030299000000000000",
                                "taxCodeTitle": "电信服务",
                                "iTitle": "*电信服务*其他增值电信服务",
                                "children": []
                            }
                        ]
                    }
                ]
            },
            {
                "id": "3969",
                "linkid": "3836",
                "code": "304",
                "paCode": "3",
                "yn": "Y",
                "title": "现代服务",
                "alias": "现代服务",
                "about": "指围绕制造业、文化产业、现代物流产业等提供技术性、知识性服务的业务活动。",
                "kws": null,
                "taxName": "现代服务",
                "taxRate": "",
                "vip": "5",
                "itaxRate": null,
                "taxCode": "3040000000000000000",
                "taxCodeTitle": "现代服务",
                "iTitle": "*现代服务*现代服务",
                "children": [
                    {
                        "id": "3970",
                        "linkid": "3969",
                        "code": "30401",
                        "paCode": "304",
                        "yn": "Y",
                        "title": "研发和技术服务",
                        "alias": "研发和技术服务",
                        "about": "包括研发服务、技术咨询服务、合同能源管理服务、工程勘察勘探服务。",
                        "kws": "研发技术",
                        "taxName": "研发和技术服务",
                        "taxRate": "",
                        "vip": "5",
                        "itaxRate": null,
                        "taxCode": "3040100000000000000",
                        "taxCodeTitle": "研发和技术服务",
                        "iTitle": "*研发和技术服务*研发和技术服务",
                        "children": [
                            {
                                "id": "3971",
                                "linkid": "3970",
                                "code": "3040101",
                                "paCode": "30401",
                                "yn": "N",
                                "title": "研发服务",
                                "alias": "研发服务",
                                "about": "指就新技术、新产品、新工艺或者新材料及其系统进行研究与试验开发的业务活动。",
                                "kws": "研发",
                                "taxName": "研发和技术服务",
                                "taxRate": "6%",
                                "vip": null,
                                "itaxRate": "0.06",
                                "taxCode": "3040101000000000000",
                                "taxCodeTitle": "研发和技术服务",
                                "iTitle": "*研发和技术服务*研发服务",
                                "children": []
                            },
                            {
                                "id": "3972",
                                "linkid": "3970",
                                "code": "3040103",
                                "paCode": "30401",
                                "yn": "N",
                                "title": "合同能源管理服务",
                                "alias": "合同能源管理服务",
                                "about": "指节能服务公司与用能单位以契约形式约定节能目标，节能服务公司提供必要的服务，用能单位以节能效果支付节能服务公司投入及其合理报酬的业务活动。",
                                "kws": "合同能源",
                                "taxName": "研发和技术服务",
                                "taxRate": "6%",
                                "vip": null,
                                "itaxRate": "0.06",
                                "taxCode": "3040103000000000000",
                                "taxCodeTitle": "研发和技术服务",
                                "iTitle": "*研发和技术服务*合同能源管理服务",
                                "children": []
                            },
                            {
                                "id": "3973",
                                "linkid": "3970",
                                "code": "3040104",
                                "paCode": "30401",
                                "yn": "Y",
                                "title": "工程勘察勘探服务",
                                "alias": "工程勘察勘探服务",
                                "about": "指在采矿、工程施工前后，对地形、地质构造、地下资源蕴藏情况进行实地调查的业务活动。",
                                "kws": "勘察、勘探",
                                "taxName": "研发和技术服务",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "3040104000000000000",
                                "taxCodeTitle": "研发和技术服务",
                                "iTitle": "*研发和技术服务*工程勘察勘探服务",
                                "children": [
                                    {
                                        "id": "3974",
                                        "linkid": "3973",
                                        "code": "304010401",
                                        "paCode": "3040104",
                                        "yn": "N",
                                        "title": "工程勘察服务",
                                        "alias": "工程勘察服务",
                                        "about": "指研究和查明工程建设场地的地质地理环境特征的服务。",
                                        "kws": "工程勘察",
                                        "taxName": "研发和技术服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040104010000000000",
                                        "taxCodeTitle": "研发和技术服务",
                                        "iTitle": "*研发和技术服务*工程勘察服务",
                                        "children": []
                                    },
                                    {
                                        "id": "3975",
                                        "linkid": "3973",
                                        "code": "304010402",
                                        "paCode": "3040104",
                                        "yn": "Y",
                                        "title": "地质勘查服务",
                                        "alias": "地质勘查服务",
                                        "about": "指对岩石、地层构造、矿产、地下水、地貌等地质情况调查研究的服务。",
                                        "kws": "地质勘查",
                                        "taxName": "研发和技术服务",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "3040104020000000000",
                                        "taxCodeTitle": "研发和技术服务",
                                        "iTitle": "*研发和技术服务*地质勘查服务",
                                        "children": [
                                            {
                                                "id": "3976",
                                                "linkid": "3975",
                                                "code": "30401040201",
                                                "paCode": "304010402",
                                                "yn": "N",
                                                "title": "矿产地质勘查服务",
                                                "alias": "矿产地质勘查服务",
                                                "about": "指运用找矿方法、手段系统收集勘查区地质矿产信息资料，了解或查明勘查区地质特征、含矿特征、矿石质量、资源量、采选冶条件等。",
                                                "kws": "矿产地质勘查",
                                                "taxName": "研发和技术服务",
                                                "taxRate": "6%",
                                                "vip": null,
                                                "itaxRate": "0.06",
                                                "taxCode": "3040104020100000000",
                                                "taxCodeTitle": "研发和技术服务",
                                                "iTitle": "*研发和技术服务*矿产地质勘查服务",
                                                "children": []
                                            },
                                            {
                                                "id": "3977",
                                                "linkid": "3975",
                                                "code": "30401040202",
                                                "paCode": "304010402",
                                                "yn": "N",
                                                "title": "基础地质勘查服务",
                                                "alias": "基础地质勘查服务",
                                                "about": "指区域、海洋、环境和水文地质勘查活动。",
                                                "kws": "基础地质勘查",
                                                "taxName": "研发和技术服务",
                                                "taxRate": "6%",
                                                "vip": null,
                                                "itaxRate": "0.06",
                                                "taxCode": "3040104020200000000",
                                                "taxCodeTitle": "研发和技术服务",
                                                "iTitle": "*研发和技术服务*基础地质勘查服务",
                                                "children": []
                                            },
                                            {
                                                "id": "3978",
                                                "linkid": "3975",
                                                "code": "30401040299",
                                                "paCode": "304010402",
                                                "yn": "N",
                                                "title": "其他地质勘查服务",
                                                "alias": "其他地质勘查服务",
                                                "about": null,
                                                "kws": null,
                                                "taxName": "研发和技术服务",
                                                "taxRate": "6%",
                                                "vip": null,
                                                "itaxRate": "0.06",
                                                "taxCode": "3040104029900000000",
                                                "taxCodeTitle": "研发和技术服务",
                                                "iTitle": "*研发和技术服务*其他地质勘查服务",
                                                "children": []
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "id": "3979",
                                "linkid": "3970",
                                "code": "3040105",
                                "paCode": "30401",
                                "yn": "N",
                                "title": "专业技术服务",
                                "alias": "专业技术服务",
                                "about": "指气象服务、地震服务、海洋服务、测绘服务、城市规划、环境与生态监测服务等专项技术服务。",
                                "kws": "专业技术服务、气象服务、地震服务、海洋服务、测绘服务、城市规划、环境与生态监测服务",
                                "taxName": "研发和技术服务",
                                "taxRate": "6%",
                                "vip": null,
                                "itaxRate": "0.06",
                                "taxCode": "3040105000000000000",
                                "taxCodeTitle": "研发和技术服务",
                                "iTitle": "*研发和技术服务*专业技术服务",
                                "children": []
                            }
                        ]
                    },
                    {
                        "id": "3980",
                        "linkid": "3969",
                        "code": "30402",
                        "paCode": "304",
                        "yn": "Y",
                        "title": "信息技术服务",
                        "alias": "信息技术服务",
                        "about": "指利用计算机、通信网络等技术对信息进行生产、收集、处理、加工、存储、运输、检索和利用，并提供信息服务的业务活动。包括软件服务、电路设计及测试服务、信息系统服务、业务流程管理服务和信息系统增值服务。",
                        "kws": "信息技术、科技",
                        "taxName": "信息技术服务",
                        "taxRate": "",
                        "vip": "5",
                        "itaxRate": null,
                        "taxCode": "3040200000000000000",
                        "taxCodeTitle": "信息技术服务",
                        "iTitle": "*信息技术服务*信息技术服务",
                        "children": [
                            {
                                "id": "3981",
                                "linkid": "3980",
                                "code": "3040201",
                                "paCode": "30402",
                                "yn": "Y",
                                "title": "软件服务",
                                "alias": "软件服务",
                                "about": "指提供软件开发服务、软件维护服务、软件测试服务的业务活动。",
                                "kws": "软件服务",
                                "taxName": "信息技术服务",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "3040201000000000000",
                                "taxCodeTitle": "信息技术服务",
                                "iTitle": "*信息技术服务*软件服务",
                                "children": [
                                    {
                                        "id": "3982",
                                        "linkid": "3981",
                                        "code": "304020101",
                                        "paCode": "3040201",
                                        "yn": "N",
                                        "title": "软件开发服务",
                                        "alias": "软件开发服务",
                                        "about": "包括对基础软件、应用软件、嵌入式软件等软件提供的开发服务。",
                                        "kws": "软件开发",
                                        "taxName": "信息技术服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040201010000000000",
                                        "taxCodeTitle": "信息技术服务",
                                        "iTitle": "*信息技术服务*软件开发服务",
                                        "children": []
                                    },
                                    {
                                        "id": "3983",
                                        "linkid": "3981",
                                        "code": "304020103",
                                        "paCode": "3040201",
                                        "yn": "N",
                                        "title": "软件维护服务",
                                        "alias": "软件维护服务",
                                        "about": "包括对基础软件、应用软件、嵌入式软件等软件提供的维护服务。",
                                        "kws": "软件维护",
                                        "taxName": "信息技术服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040201030000000000",
                                        "taxCodeTitle": "信息技术服务",
                                        "iTitle": "*信息技术服务*软件维护服务",
                                        "children": []
                                    },
                                    {
                                        "id": "3984",
                                        "linkid": "3981",
                                        "code": "304020104",
                                        "paCode": "3040201",
                                        "yn": "N",
                                        "title": "软件测试服务",
                                        "alias": "软件测试服务",
                                        "about": "包括对基础软件、应用软件、嵌入式软件等软件提供的测试服务。",
                                        "kws": "软件测试",
                                        "taxName": "信息技术服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040201040000000000",
                                        "taxCodeTitle": "信息技术服务",
                                        "iTitle": "*信息技术服务*软件测试服务",
                                        "children": []
                                    },
                                    {
                                        "id": "3985",
                                        "linkid": "3981",
                                        "code": "304020199",
                                        "paCode": "3040201",
                                        "yn": "N",
                                        "title": "其他软件服务",
                                        "alias": "其他软件服务",
                                        "about": "指除软件开发、软件咨询、软件维护、软件测试以外的其他软件服务。",
                                        "kws": null,
                                        "taxName": "信息技术服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040201990000000000",
                                        "taxCodeTitle": "信息技术服务",
                                        "iTitle": "*信息技术服务*其他软件服务",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3986",
                                "linkid": "3980",
                                "code": "3040202",
                                "paCode": "30402",
                                "yn": "Y",
                                "title": "电路设计及测试服务",
                                "alias": "电路设计及测试服务",
                                "about": "指提供集成电路和电子电路产品设计、测试及相关技术支持服务的业务行为。",
                                "kws": "电路设计、电路测试",
                                "taxName": "信息技术服务",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "3040202000000000000",
                                "taxCodeTitle": "信息技术服务",
                                "iTitle": "*信息技术服务*电路设计及测试服务",
                                "children": [
                                    {
                                        "id": "3987",
                                        "linkid": "3986",
                                        "code": "304020201",
                                        "paCode": "3040202",
                                        "yn": "N",
                                        "title": "电路设计服务",
                                        "alias": "电路设计服务",
                                        "about": "指对集成电路、电子电路产品等提供的设计服务。",
                                        "kws": "电路设计",
                                        "taxName": "信息技术服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040202010000000000",
                                        "taxCodeTitle": "信息技术服务",
                                        "iTitle": "*信息技术服务*电路设计服务",
                                        "children": []
                                    },
                                    {
                                        "id": "3988",
                                        "linkid": "3986",
                                        "code": "304020202",
                                        "paCode": "3040202",
                                        "yn": "N",
                                        "title": "电路测试服务",
                                        "alias": "电路测试服务",
                                        "about": "指对集成电路、电子电路产品等提供的测试服务。",
                                        "kws": "电路测试",
                                        "taxName": "信息技术服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040202020000000000",
                                        "taxCodeTitle": "信息技术服务",
                                        "iTitle": "*信息技术服务*电路测试服务",
                                        "children": []
                                    },
                                    {
                                        "id": "3989",
                                        "linkid": "3986",
                                        "code": "304020203",
                                        "paCode": "3040202",
                                        "yn": "N",
                                        "title": "相关电路技术支持服务",
                                        "alias": "相关电路技术支持服务",
                                        "about": "指对集成电路、电子电路产品等提供的技术支持服务。",
                                        "kws": "电子电路、电路技术支持",
                                        "taxName": "信息技术服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040202030000000000",
                                        "taxCodeTitle": "信息技术服务",
                                        "iTitle": "*信息技术服务*相关电路技术支持服务",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3990",
                                "linkid": "3980",
                                "code": "3040203",
                                "paCode": "30402",
                                "yn": "N",
                                "title": "信息系统服务",
                                "alias": "信息系统服务",
                                "about": "是指提供信息系统集成、网络管理、网站内容维护、桌面管理与维护、信息系统应用、基础信息技术管理平台整合、信息技术基础设施管理、数据中心、托管中心、信息安全服务、在线杀毒、虚拟主机等业务活动。包括网站对非自有的网络游戏提供的网络运营服务。",
                                "kws": "信息科技、信息系统服务、信息系统集成、网络管理、网站内容维护、桌面管理与维护、信息系统应用、基础信息技术管理平台整合、信息技术基础设施管理、数据中心、托管中心、信息安全服务、在线杀毒、虚拟主机",
                                "taxName": "信息技术服务",
                                "taxRate": "6%",
                                "vip": null,
                                "itaxRate": "0.06",
                                "taxCode": "3040203000000000000",
                                "taxCodeTitle": "信息技术服务",
                                "iTitle": "*信息技术服务*信息系统服务",
                                "children": []
                            },
                            {
                                "id": "3991",
                                "linkid": "3980",
                                "code": "3040204",
                                "paCode": "30402",
                                "yn": "N",
                                "title": "业务流程管理服务",
                                "alias": "业务流程管理服务",
                                "about": "是指依托信息技术提供的人力资源管理、财务经济管理、审计管理、税务管理、物流信息管理、经营信息管理和呼叫中心等服务的活动。",
                                "kws": "业务流程管理",
                                "taxName": "信息技术服务",
                                "taxRate": "6%",
                                "vip": null,
                                "itaxRate": "0.06",
                                "taxCode": "3040204000000000000",
                                "taxCodeTitle": "信息技术服务",
                                "iTitle": "*信息技术服务*业务流程管理服务",
                                "children": []
                            },
                            {
                                "id": "3992",
                                "linkid": "3980",
                                "code": "3040205",
                                "paCode": "30402",
                                "yn": "N",
                                "title": "信息系统增值服务",
                                "alias": "信息系统增值服务",
                                "about": "指利用信息系统资源为用户附加提供的信息技术服务。包括数据处理、分析和整合、数据库管理、数据备份、数据存储、容灾服务、电子商务平台等。",
                                "kws": "信息增值、信息系统增值服务、数据处理、分析和整合、数据库管理、数据备份、数据存储、容灾服务、电子商务平台",
                                "taxName": "信息技术服务",
                                "taxRate": "6%",
                                "vip": null,
                                "itaxRate": "0.06",
                                "taxCode": "3040205000000000000",
                                "taxCodeTitle": "信息技术服务",
                                "iTitle": "*信息技术服务*信息系统增值服务",
                                "children": []
                            }
                        ]
                    },
                    {
                        "id": "3993",
                        "linkid": "3969",
                        "code": "30403",
                        "paCode": "304",
                        "yn": "Y",
                        "title": "文化创意服务",
                        "alias": "文化创意服务",
                        "about": "包括设计服务、知识产权服务、广告服务和会议展览服务等。",
                        "kws": null,
                        "taxName": "文化创意服务",
                        "taxRate": "",
                        "vip": "5",
                        "itaxRate": null,
                        "taxCode": "3040300000000000000",
                        "taxCodeTitle": "文化创意服务",
                        "iTitle": "*文化创意服务*文化创意服务",
                        "children": [
                            {
                                "id": "3994",
                                "linkid": "3993",
                                "code": "3040301",
                                "paCode": "30403",
                                "yn": "Y",
                                "title": "设计服务",
                                "alias": "设计服务",
                                "about": "指把计划、规划、设想通过文字、语言、图画、声音、视觉等形式传递出来的业务活动。包括工业设计、内部管理设计、业务运作设计、供应链设计、造型设计、服装设计、环境设计、平面设计、包装设计、动漫设计、网游设计、展示设计、网站设计、机械设计、工程设计、广告设计、创意策划、文印晒图等。",
                                "kws": "设计",
                                "taxName": "设计服务",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "3040301000000000000",
                                "taxCodeTitle": "设计服务",
                                "iTitle": "*设计服务*设计服务",
                                "children": [
                                    {
                                        "id": "3995",
                                        "linkid": "3994",
                                        "code": "304030101",
                                        "paCode": "3040301",
                                        "yn": "N",
                                        "title": "工程设计服务",
                                        "alias": "工程设计服务",
                                        "about": "包括为房屋建筑物工程、煤炭工程、化工石化医药工程、石油天然气工程、电力工程、冶金工程、机械工程、商业工程、仓储工程、粮食工程、核工业工程、电子通信广电工程、轻纺工程、建材工程、铁道工程、公路工程、水运工程、民航工程、市政工程、农林工程、水利工程、海洋工程、体育及休闲娱乐工程、室内装饰、专项工程等提供的设计服务。",
                                        "kws": "工程设计",
                                        "taxName": "设计服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040301010000000000",
                                        "taxCodeTitle": "设计服务",
                                        "iTitle": "*设计服务*工程设计服务",
                                        "children": []
                                    },
                                    {
                                        "id": "3996",
                                        "linkid": "3994",
                                        "code": "304030102",
                                        "paCode": "3040301",
                                        "yn": "N",
                                        "title": "专业设计服务",
                                        "alias": "专业设计服务",
                                        "about": "包括工业设计、造型设计、服装设计、环境设计、平面设计、包装设计、动漫设计、网游设计、展示设计、网站设计、机械设计、广告设计等。2016年5月1日起停用，归入304010403",
                                        "kws": "专业设计",
                                        "taxName": "设计服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040301020000000000",
                                        "taxCodeTitle": "设计服务",
                                        "iTitle": "*设计服务*专业设计服务",
                                        "children": []
                                    },
                                    {
                                        "id": "3997",
                                        "linkid": "3994",
                                        "code": "304030103",
                                        "paCode": "3040301",
                                        "yn": "N",
                                        "title": "文印晒图服务",
                                        "alias": "文印晒图服务",
                                        "about": null,
                                        "kws": "文印晒图、文印、晒图",
                                        "taxName": "设计服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040301030000000000",
                                        "taxCodeTitle": "设计服务",
                                        "iTitle": "*设计服务*文印晒图服务",
                                        "children": []
                                    },
                                    {
                                        "id": "3998",
                                        "linkid": "3994",
                                        "code": "304030199",
                                        "paCode": "3040301",
                                        "yn": "N",
                                        "title": "其他设计服务",
                                        "alias": "其他设计服务",
                                        "about": "包括创意策划等其他设计服务。",
                                        "kws": "其他设计、创意策划",
                                        "taxName": "设计服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040301990000000000",
                                        "taxCodeTitle": "设计服务",
                                        "iTitle": "*设计服务*其他设计服务",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "3999",
                                "linkid": "3993",
                                "code": "3040302",
                                "paCode": "30403",
                                "yn": "N",
                                "title": "知识产权服务",
                                "alias": "知识产权服务",
                                "about": "指处理知识产权事务的业务活动。包括对专利、商标、著作权、软件、集成电路布图设计的登记、鉴定、评估、认证、检索服务。",
                                "kws": "知识产权服务",
                                "taxName": "设计服务",
                                "taxRate": "6%",
                                "vip": null,
                                "itaxRate": "0.06",
                                "taxCode": "3040302000000000000",
                                "taxCodeTitle": "设计服务",
                                "iTitle": "*设计服务*知识产权服务",
                                "children": []
                            },
                            {
                                "id": "4000",
                                "linkid": "3993",
                                "code": "3040303",
                                "paCode": "30403",
                                "yn": "Y",
                                "title": "广告服务",
                                "alias": "广告服务",
                                "about": "是指利用图书、报纸、杂志、广播、电视、电影、幻灯、路牌、招贴、橱窗、霓虹灯、灯箱、互联网等各种形式为客户的商品、经营服务项目、文体节目或者通告、声明等委托事项进行宣传和提供相关服务的业务活动。包括广告代理和广告的发布、播映、宣传、展示等。",
                                "kws": "广告",
                                "taxName": "广告服务",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "3040303000000000000",
                                "taxCodeTitle": "广告服务",
                                "iTitle": "*广告服务*广告服务",
                                "children": [
                                    {
                                        "id": "4001",
                                        "linkid": "4000",
                                        "code": "304030301",
                                        "paCode": "3040303",
                                        "yn": "Y",
                                        "title": "广告发布服务",
                                        "alias": "广告发布服务",
                                        "about": "包括广告的发布、播映、宣传、展示等。",
                                        "kws": "广告发布",
                                        "taxName": "广告服务",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "3040303010000000000",
                                        "taxCodeTitle": "广告服务",
                                        "iTitle": "*广告服务*广告发布服务",
                                        "children": [
                                            {
                                                "id": "4002",
                                                "linkid": "4001",
                                                "code": "30403030101",
                                                "paCode": "304030301",
                                                "yn": "N",
                                                "title": "影视、广播广告发布服务",
                                                "alias": "影视、广播广告发布服务",
                                                "about": "指利用广播、电视、电影等形式进行的广告发布服务。",
                                                "kws": "影视广告、广播广告",
                                                "taxName": "广告服务",
                                                "taxRate": "6%",
                                                "vip": null,
                                                "itaxRate": "0.06",
                                                "taxCode": "3040303010100000000",
                                                "taxCodeTitle": "广告服务",
                                                "iTitle": "*广告服务*影视、广播广告发布服务",
                                                "children": []
                                            },
                                            {
                                                "id": "4003",
                                                "linkid": "4001",
                                                "code": "30403030102",
                                                "paCode": "304030301",
                                                "yn": "N",
                                                "title": "报纸、杂志广告发布服务",
                                                "alias": "报纸、杂志广告发布服务",
                                                "about": "指利用图书、报纸、杂志等形式进行的广告发布服务。",
                                                "kws": "报纸广告、杂志广告",
                                                "taxName": "广告服务",
                                                "taxRate": "6%",
                                                "vip": null,
                                                "itaxRate": "0.06",
                                                "taxCode": "3040303010200000000",
                                                "taxCodeTitle": "广告服务",
                                                "iTitle": "*广告服务*报纸、杂志广告发布服务",
                                                "children": []
                                            },
                                            {
                                                "id": "4004",
                                                "linkid": "4001",
                                                "code": "30403030103",
                                                "paCode": "304030301",
                                                "yn": "N",
                                                "title": "灯箱广告发布服务",
                                                "alias": "灯箱广告发布服务",
                                                "about": "指利用灯箱等形式进行的广告发布服务。",
                                                "kws": "灯箱广告",
                                                "taxName": "广告服务",
                                                "taxRate": "6%",
                                                "vip": null,
                                                "itaxRate": "0.06",
                                                "taxCode": "3040303010300000000",
                                                "taxCodeTitle": "广告服务",
                                                "iTitle": "*广告服务*灯箱广告发布服务",
                                                "children": []
                                            },
                                            {
                                                "id": "4005",
                                                "linkid": "4001",
                                                "code": "30403030104",
                                                "paCode": "304030301",
                                                "yn": "N",
                                                "title": "路牌广告发布服务",
                                                "alias": "路牌广告发布服务",
                                                "about": "指利用路牌等形式进行的广告发布服务。",
                                                "kws": "路牌广告",
                                                "taxName": "广告服务",
                                                "taxRate": "6%",
                                                "vip": null,
                                                "itaxRate": "0.06",
                                                "taxCode": "3040303010400000000",
                                                "taxCodeTitle": "广告服务",
                                                "iTitle": "*广告服务*路牌广告发布服务",
                                                "children": []
                                            },
                                            {
                                                "id": "4006",
                                                "linkid": "4001",
                                                "code": "30403030105",
                                                "paCode": "304030301",
                                                "yn": "N",
                                                "title": "建筑物广告发布服务",
                                                "alias": "建筑物广告发布服务",
                                                "about": "指利用外墙等建筑物结构进行的广告发布服务。",
                                                "kws": "建筑物广告",
                                                "taxName": "广告服务",
                                                "taxRate": "6%",
                                                "vip": null,
                                                "itaxRate": "0.06",
                                                "taxCode": "3040303010500000000",
                                                "taxCodeTitle": "广告服务",
                                                "iTitle": "*广告服务*建筑物广告发布服务",
                                                "children": []
                                            },
                                            {
                                                "id": "4007",
                                                "linkid": "4001",
                                                "code": "30403030106",
                                                "paCode": "304030301",
                                                "yn": "N",
                                                "title": "互联网广告发布服务",
                                                "alias": "互联网广告发布服务",
                                                "about": "指利用互联网等形式进行的广告发布服务。",
                                                "kws": "互联网广告",
                                                "taxName": "广告服务",
                                                "taxRate": "6%",
                                                "vip": null,
                                                "itaxRate": "0.06",
                                                "taxCode": "3040303010600000000",
                                                "taxCodeTitle": "广告服务",
                                                "iTitle": "*广告服务*互联网广告发布服务",
                                                "children": []
                                            },
                                            {
                                                "id": "4008",
                                                "linkid": "4001",
                                                "code": "30403030107",
                                                "paCode": "304030301",
                                                "yn": "N",
                                                "title": "流动广告发布服务",
                                                "alias": "流动广告发布服务",
                                                "about": "指利用机动车、非机动车车体等进行的广告发布服务，以及受雇人员身穿广告服装等进行的广告发布服务。",
                                                "kws": "流动广告",
                                                "taxName": "广告服务",
                                                "taxRate": "6%",
                                                "vip": null,
                                                "itaxRate": "0.06",
                                                "taxCode": "3040303010700000000",
                                                "taxCodeTitle": "广告服务",
                                                "iTitle": "*广告服务*流动广告发布服务",
                                                "children": []
                                            },
                                            {
                                                "id": "4009",
                                                "linkid": "4001",
                                                "code": "30403030199",
                                                "paCode": "304030301",
                                                "yn": "N",
                                                "title": "其他广告发布服务",
                                                "alias": "其他广告发布服务",
                                                "about": null,
                                                "kws": null,
                                                "taxName": "广告服务",
                                                "taxRate": "6%",
                                                "vip": null,
                                                "itaxRate": "0.06",
                                                "taxCode": "3040303019900000000",
                                                "taxCodeTitle": "广告服务",
                                                "iTitle": "*广告服务*其他广告发布服务",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "4010",
                                        "linkid": "4000",
                                        "code": "304030302",
                                        "paCode": "3040303",
                                        "yn": "N",
                                        "title": "广告代理服务",
                                        "alias": "广告代理服务",
                                        "about": "指广告经营者接受广告主或广告发布者委托，从事广告媒介安排等经营活动。",
                                        "kws": "广告代理",
                                        "taxName": "广告代理服务",
                                        "taxRate": "6%",
                                        "vip": "5",
                                        "itaxRate": "0.06",
                                        "taxCode": "3040303020000000000",
                                        "taxCodeTitle": "广告代理服务",
                                        "iTitle": "*广告代理服务*广告代理服务",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "4011",
                                "linkid": "3993",
                                "code": "3040304",
                                "paCode": "30403",
                                "yn": "Y",
                                "title": "会议展览服务",
                                "alias": "会议展览服务",
                                "about": "指为商品流通、促销、展示、经贸洽谈、民间交流、企业沟通、国际往来等举办或者组织安排的各类展览和会议的业务活动。",
                                "kws": "会议展览、会展",
                                "taxName": "会展服务",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "3040304000000000000",
                                "taxCodeTitle": "会展服务",
                                "iTitle": "*会展服务*会议展览服务",
                                "children": [
                                    {
                                        "id": "4012",
                                        "linkid": "4011",
                                        "code": "304030401",
                                        "paCode": "3040304",
                                        "yn": "N",
                                        "title": "会议服务",
                                        "alias": "会议服务",
                                        "about": "包括国际会议服务、国内会议服务及会议中心服务。",
                                        "kws": "会议服务",
                                        "taxName": "会展服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040304010000000000",
                                        "taxCodeTitle": "会展服务",
                                        "iTitle": "*会展服务*会议服务",
                                        "children": []
                                    },
                                    {
                                        "id": "4013",
                                        "linkid": "4011",
                                        "code": "304030402",
                                        "paCode": "3040304",
                                        "yn": "N",
                                        "title": "展览服务",
                                        "alias": "展览服务",
                                        "about": "包括为博览会、专业技术产品展览、生活消费品展览、文化产品展览、进出口交易展会、一般产品展会、产品订货展会等提供的展览服务。",
                                        "kws": "展览",
                                        "taxName": "会展服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040304020000000000",
                                        "taxCodeTitle": "会展服务",
                                        "iTitle": "*会展服务*展览服务",
                                        "children": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "id": "4014",
                        "linkid": "3969",
                        "code": "30404",
                        "paCode": "304",
                        "yn": "Y",
                        "title": "物流辅助服务",
                        "alias": "物流辅助服务",
                        "about": "包括航空服务、港口码头服务、货运客运场站服务、打捞救助服务、装卸搬运服务、仓储服务和收派服务。",
                        "kws": "物流辅助",
                        "taxName": "物流辅助服务",
                        "taxRate": "",
                        "vip": "5",
                        "itaxRate": null,
                        "taxCode": "3040400000000000000",
                        "taxCodeTitle": "物流辅助服务",
                        "iTitle": "*物流辅助服务*物流辅助服务",
                        "children": [
                            {
                                "id": "4015",
                                "linkid": "4014",
                                "code": "3040401",
                                "paCode": "30404",
                                "yn": "Y",
                                "title": "航空服务",
                                "alias": "航空服务",
                                "about": "包括航空地面服务和通用航空服务。",
                                "kws": null,
                                "taxName": "物流辅助服务",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "3040401000000000000",
                                "taxCodeTitle": "物流辅助服务",
                                "iTitle": "*物流辅助服务*航空服务",
                                "children": [
                                    {
                                        "id": "4016",
                                        "linkid": "4015",
                                        "code": "304040101",
                                        "paCode": "3040401",
                                        "yn": "Y",
                                        "title": "航空地面服务",
                                        "alias": "航空地面服务",
                                        "about": "指航空公司、飞机场、民航管理局、航站等向在境内航行或者在境内机场停留的境内外飞机或者其他飞行器提供的导航等劳务性地面服务的业务活动。包括旅客安全检查服务、停机坪管理服务、机场候机厅管理服务、飞机清洗消毒服务、空中飞行管理服务、飞机起降服务、飞行通讯服务、地面信号服务、飞机安全服务、飞机跑道管理服务、空中交通管理服务等。",
                                        "kws": "航空地面服务",
                                        "taxName": "物流辅助服务",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "3040401010000000000",
                                        "taxCodeTitle": "物流辅助服务",
                                        "iTitle": "*物流辅助服务*航空地面服务",
                                        "children": [
                                            {
                                                "id": "4017",
                                                "linkid": "4016",
                                                "code": "30404010101",
                                                "paCode": "304040101",
                                                "yn": "N",
                                                "title": "机场服务",
                                                "alias": "机场服务",
                                                "about": null,
                                                "kws": "机场服务",
                                                "taxName": "物流辅助服务",
                                                "taxRate": "6%",
                                                "vip": null,
                                                "itaxRate": "0.06",
                                                "taxCode": "3040401010100000000",
                                                "taxCodeTitle": "物流辅助服务",
                                                "iTitle": "*物流辅助服务*机场服务",
                                                "children": []
                                            },
                                            {
                                                "id": "4018",
                                                "linkid": "4016",
                                                "code": "30404010102",
                                                "paCode": "304040101",
                                                "yn": "N",
                                                "title": "空中交通管理服务",
                                                "alias": "空中交通管理服务",
                                                "about": null,
                                                "kws": "空中交通管理、空管",
                                                "taxName": "物流辅助服务",
                                                "taxRate": "6%",
                                                "vip": null,
                                                "itaxRate": "0.06",
                                                "taxCode": "3040401010200000000",
                                                "taxCodeTitle": "物流辅助服务",
                                                "iTitle": "*物流辅助服务*空中交通管理服务",
                                                "children": []
                                            },
                                            {
                                                "id": "4019",
                                                "linkid": "4016",
                                                "code": "30404010199",
                                                "paCode": "304040101",
                                                "yn": "N",
                                                "title": "其他航空地面服务",
                                                "alias": "其他航空地面服务",
                                                "about": null,
                                                "kws": null,
                                                "taxName": "物流辅助服务",
                                                "taxRate": "6%",
                                                "vip": null,
                                                "itaxRate": "0.06",
                                                "taxCode": "3040401019900000000",
                                                "taxCodeTitle": "物流辅助服务",
                                                "iTitle": "*物流辅助服务*其他航空地面服务",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "4020",
                                        "linkid": "4015",
                                        "code": "304040102",
                                        "paCode": "3040401",
                                        "yn": "Y",
                                        "title": "通用航空服务",
                                        "alias": "通用航空服务",
                                        "about": "指为专业工作提供飞行服务的业务活动，包括航空摄影、航空培训、航空测量、航空勘探、航空护林、航空吊挂播洒、航空降雨等。",
                                        "kws": "通用航空",
                                        "taxName": "物流辅助服务",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "3040401020000000000",
                                        "taxCodeTitle": "物流辅助服务",
                                        "iTitle": "*物流辅助服务*通用航空服务",
                                        "children": [
                                            {
                                                "id": "4021",
                                                "linkid": "4020",
                                                "code": "30404010201",
                                                "paCode": "304040102",
                                                "yn": "N",
                                                "title": "航空摄影",
                                                "alias": "航空摄影",
                                                "about": null,
                                                "kws": "航空摄影",
                                                "taxName": "物流辅助服务",
                                                "taxRate": "6%",
                                                "vip": null,
                                                "itaxRate": "0.06",
                                                "taxCode": "3040401020100000000",
                                                "taxCodeTitle": "物流辅助服务",
                                                "iTitle": "*物流辅助服务*航空摄影",
                                                "children": []
                                            },
                                            {
                                                "id": "4022",
                                                "linkid": "4020",
                                                "code": "30404010202",
                                                "paCode": "304040102",
                                                "yn": "N",
                                                "title": "航空培训",
                                                "alias": "航空培训",
                                                "about": null,
                                                "kws": "航空培训",
                                                "taxName": "物流辅助服务",
                                                "taxRate": "6%",
                                                "vip": null,
                                                "itaxRate": "0.06",
                                                "taxCode": "3040401020200000000",
                                                "taxCodeTitle": "物流辅助服务",
                                                "iTitle": "*物流辅助服务*航空培训",
                                                "children": []
                                            },
                                            {
                                                "id": "4023",
                                                "linkid": "4020",
                                                "code": "30404010203",
                                                "paCode": "304040102",
                                                "yn": "N",
                                                "title": "航空测量",
                                                "alias": "航空测量",
                                                "about": null,
                                                "kws": "航空测量",
                                                "taxName": "物流辅助服务",
                                                "taxRate": "6%",
                                                "vip": null,
                                                "itaxRate": "0.06",
                                                "taxCode": "3040401020300000000",
                                                "taxCodeTitle": "物流辅助服务",
                                                "iTitle": "*物流辅助服务*航空测量",
                                                "children": []
                                            },
                                            {
                                                "id": "4024",
                                                "linkid": "4020",
                                                "code": "30404010204",
                                                "paCode": "304040102",
                                                "yn": "N",
                                                "title": "航空勘探",
                                                "alias": "航空勘探",
                                                "about": null,
                                                "kws": "航空勘探",
                                                "taxName": "物流辅助服务",
                                                "taxRate": "6%",
                                                "vip": null,
                                                "itaxRate": "0.06",
                                                "taxCode": "3040401020400000000",
                                                "taxCodeTitle": "物流辅助服务",
                                                "iTitle": "*物流辅助服务*航空勘探",
                                                "children": []
                                            },
                                            {
                                                "id": "4025",
                                                "linkid": "4020",
                                                "code": "30404010205",
                                                "paCode": "304040102",
                                                "yn": "N",
                                                "title": "航空护林",
                                                "alias": "航空护林",
                                                "about": null,
                                                "kws": "航空护林",
                                                "taxName": "物流辅助服务",
                                                "taxRate": "6%",
                                                "vip": null,
                                                "itaxRate": "0.06",
                                                "taxCode": "3040401020500000000",
                                                "taxCodeTitle": "物流辅助服务",
                                                "iTitle": "*物流辅助服务*航空护林",
                                                "children": []
                                            },
                                            {
                                                "id": "4026",
                                                "linkid": "4020",
                                                "code": "30404010206",
                                                "paCode": "304040102",
                                                "yn": "N",
                                                "title": "航空播洒农药",
                                                "alias": "航空播洒农药",
                                                "about": null,
                                                "kws": "航空播洒农药",
                                                "taxName": "物流辅助服务",
                                                "taxRate": "6%",
                                                "vip": null,
                                                "itaxRate": "0.06",
                                                "taxCode": "3040401020600000000",
                                                "taxCodeTitle": "物流辅助服务",
                                                "iTitle": "*物流辅助服务*航空播洒农药",
                                                "children": []
                                            },
                                            {
                                                "id": "4027",
                                                "linkid": "4020",
                                                "code": "30404010207",
                                                "paCode": "304040102",
                                                "yn": "N",
                                                "title": "航空降雨",
                                                "alias": "航空降雨",
                                                "about": null,
                                                "kws": "航空降雨",
                                                "taxName": "物流辅助服务",
                                                "taxRate": "6%",
                                                "vip": null,
                                                "itaxRate": "0.06",
                                                "taxCode": "3040401020700000000",
                                                "taxCodeTitle": "物流辅助服务",
                                                "iTitle": "*物流辅助服务*航空降雨",
                                                "children": []
                                            },
                                            {
                                                "id": "4028",
                                                "linkid": "4020",
                                                "code": "30404010299",
                                                "paCode": "304040102",
                                                "yn": "N",
                                                "title": "其他通用航空服务",
                                                "alias": "其他通用航空服务",
                                                "about": null,
                                                "kws": null,
                                                "taxName": "物流辅助服务",
                                                "taxRate": "6%",
                                                "vip": null,
                                                "itaxRate": "0.06",
                                                "taxCode": "3040401029900000000",
                                                "taxCodeTitle": "物流辅助服务",
                                                "iTitle": "*物流辅助服务*其他通用航空服务",
                                                "children": []
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "id": "4029",
                                "linkid": "4014",
                                "code": "3040402",
                                "paCode": "30404",
                                "yn": "Y",
                                "title": "港口码头服务",
                                "alias": "港口码头服务",
                                "about": "指港务船舶调度服务、船舶通讯服务、航道管理服务、航道疏浚服务、灯塔管理服务、航标管理服务、船舶引航服务、理货服务、系解缆服务、停泊和移泊服务、海上船舶溢油清除服务、水上交通管理服务、船只专业清洗消毒检测服务和防止船只漏油服务等为船只提供服务的业务活动。",
                                "kws": "港口码头",
                                "taxName": "物流辅助服务",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "3040402000000000000",
                                "taxCodeTitle": "物流辅助服务",
                                "iTitle": "*物流辅助服务*港口码头服务",
                                "children": [
                                    {
                                        "id": "4030",
                                        "linkid": "4029",
                                        "code": "304040201",
                                        "paCode": "3040402",
                                        "yn": "N",
                                        "title": "客运港口码头服务",
                                        "alias": "客运港口码头服务",
                                        "about": null,
                                        "kws": "客运港口码头",
                                        "taxName": "物流辅助服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040402010000000000",
                                        "taxCodeTitle": "物流辅助服务",
                                        "iTitle": "*物流辅助服务*客运港口码头服务",
                                        "children": []
                                    },
                                    {
                                        "id": "4031",
                                        "linkid": "4029",
                                        "code": "304040202",
                                        "paCode": "3040402",
                                        "yn": "N",
                                        "title": "货运港口码头服务",
                                        "alias": "货运港口码头服务",
                                        "about": null,
                                        "kws": "货运港口码头",
                                        "taxName": "物流辅助服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040402020000000000",
                                        "taxCodeTitle": "物流辅助服务",
                                        "iTitle": "*物流辅助服务*货运港口码头服务",
                                        "children": []
                                    },
                                    {
                                        "id": "4032",
                                        "linkid": "4029",
                                        "code": "304040299",
                                        "paCode": "3040402",
                                        "yn": "N",
                                        "title": "其他港口码头服务",
                                        "alias": "其他港口码头服务",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "物流辅助服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040402990000000000",
                                        "taxCodeTitle": "物流辅助服务",
                                        "iTitle": "*物流辅助服务*其他港口码头服务",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "4033",
                                "linkid": "4014",
                                "code": "3040403",
                                "paCode": "30404",
                                "yn": "Y",
                                "title": "货运客运场站服务",
                                "alias": "货运客运场站服务",
                                "about": "指货运客运场站提供的货物配载服务、运输组织服务、中转换乘服务、车辆调度服务、票务服务、货物打包整理、铁路线路使用服务、加挂铁路客车服务、铁路行包专列发送服务、铁路到达和中转服务、铁路车辆编解服务、车辆挂运服务、铁路接触网服务、铁路机车牵引服务、车辆停放服务等业务活动。",
                                "kws": "货运客运场站",
                                "taxName": "物流辅助服务",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "3040403000000000000",
                                "taxCodeTitle": "物流辅助服务",
                                "iTitle": "*物流辅助服务*货运客运场站服务",
                                "children": [
                                    {
                                        "id": "4034",
                                        "linkid": "4033",
                                        "code": "304040301",
                                        "paCode": "3040403",
                                        "yn": "N",
                                        "title": "铁路货运客运场站服务",
                                        "alias": "铁路货运客运场站服务",
                                        "about": null,
                                        "kws": "铁路货运客运场站",
                                        "taxName": "物流辅助服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040403010000000000",
                                        "taxCodeTitle": "物流辅助服务",
                                        "iTitle": "*物流辅助服务*铁路货运客运场站服务",
                                        "children": []
                                    },
                                    {
                                        "id": "4035",
                                        "linkid": "4033",
                                        "code": "304040302",
                                        "paCode": "3040403",
                                        "yn": "N",
                                        "title": "道路货运客运场站服务",
                                        "alias": "道路货运客运场站服务",
                                        "about": null,
                                        "kws": "道路货运客运场站",
                                        "taxName": "物流辅助服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040403020000000000",
                                        "taxCodeTitle": "物流辅助服务",
                                        "iTitle": "*物流辅助服务*道路货运客运场站服务",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "4036",
                                "linkid": "4014",
                                "code": "3040404",
                                "paCode": "30404",
                                "yn": "N",
                                "title": "打捞救助服务",
                                "alias": "打捞救助服务",
                                "about": "指提供船舶人员救助、船舶财产救助、水上救助和沉船沉物打捞服务的业务活动。",
                                "kws": "打捞救助",
                                "taxName": "物流辅助服务",
                                "taxRate": "6%",
                                "vip": null,
                                "itaxRate": "0.06",
                                "taxCode": "3040404000000000000",
                                "taxCodeTitle": "物流辅助服务",
                                "iTitle": "*物流辅助服务*打捞救助服务",
                                "children": []
                            },
                            {
                                "id": "4037",
                                "linkid": "4014",
                                "code": "3040407",
                                "paCode": "30404",
                                "yn": "Y",
                                "title": "仓储服务",
                                "alias": "仓储服务",
                                "about": "指利用仓库、货场或者其他场所代客贮放、保管货物的业务活动。",
                                "kws": "仓储",
                                "taxName": "物流辅助服务",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "3040407000000000000",
                                "taxCodeTitle": "物流辅助服务",
                                "iTitle": "*物流辅助服务*仓储服务",
                                "children": [
                                    {
                                        "id": "4038",
                                        "linkid": "4037",
                                        "code": "304040701",
                                        "paCode": "3040407",
                                        "yn": "N",
                                        "title": "农产品仓储服务",
                                        "alias": "农产品仓储服务",
                                        "about": "指利用仓库等场所代客贮放、保管粮食、棉花、化肥等农产品的服务。",
                                        "kws": "农产品仓储",
                                        "taxName": "物流辅助服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040407010000000000",
                                        "taxCodeTitle": "物流辅助服务",
                                        "iTitle": "*物流辅助服务*农产品仓储服务",
                                        "children": []
                                    },
                                    {
                                        "id": "4039",
                                        "linkid": "4037",
                                        "code": "304040702",
                                        "paCode": "3040407",
                                        "yn": "N",
                                        "title": "专业仓储服务",
                                        "alias": "专业仓储服务",
                                        "about": "指利用仓库等场所代客贮放、保管原油、成品油、燃气、危险品、冷冻食品等的业务活动。",
                                        "kws": "专业仓储",
                                        "taxName": "物流辅助服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040407020000000000",
                                        "taxCodeTitle": "物流辅助服务",
                                        "iTitle": "*物流辅助服务*专业仓储服务",
                                        "children": []
                                    },
                                    {
                                        "id": "4040",
                                        "linkid": "4037",
                                        "code": "304040703",
                                        "paCode": "3040407",
                                        "yn": "N",
                                        "title": "运输货场仓储服务",
                                        "alias": "运输货场仓储服务",
                                        "about": "指货运客运场站提供的仓储服务。",
                                        "kws": "运输货场仓储",
                                        "taxName": "物流辅助服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040407030000000000",
                                        "taxCodeTitle": "物流辅助服务",
                                        "iTitle": "*物流辅助服务*运输货场仓储服务",
                                        "children": []
                                    },
                                    {
                                        "id": "4041",
                                        "linkid": "4037",
                                        "code": "304040704",
                                        "paCode": "3040407",
                                        "yn": "N",
                                        "title": "商业流通仓储服务",
                                        "alias": "商业流通仓储服务",
                                        "about": "包括百货仓储、连锁零售仓储、专卖店仓储等商业流通仓储服务。",
                                        "kws": "商业流通仓储",
                                        "taxName": "物流辅助服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040407040000000000",
                                        "taxCodeTitle": "物流辅助服务",
                                        "iTitle": "*物流辅助服务*商业流通仓储服务",
                                        "children": []
                                    },
                                    {
                                        "id": "4042",
                                        "linkid": "4037",
                                        "code": "304040799",
                                        "paCode": "3040407",
                                        "yn": "N",
                                        "title": "其他仓储服务",
                                        "alias": "其他仓储服务",
                                        "about": "指除农产品仓储、专业仓储、运输货场仓储、商业流通仓储以外的其他仓储服务。",
                                        "kws": null,
                                        "taxName": "物流辅助服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040407990000000000",
                                        "taxCodeTitle": "物流辅助服务",
                                        "iTitle": "*物流辅助服务*其他仓储服务",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "4043",
                                "linkid": "4014",
                                "code": "3040408",
                                "paCode": "30404",
                                "yn": "N",
                                "title": "装卸搬运服务",
                                "alias": "装卸搬运服务",
                                "about": "指使用装卸搬运工具或人力、畜力将货物在运输工具之间、装卸现场之间或者运输工具与装卸现场之间进行装卸和搬运的业务活动。",
                                "kws": "装卸搬运",
                                "taxName": "物流辅助服务",
                                "taxRate": "6%",
                                "vip": null,
                                "itaxRate": "0.06",
                                "taxCode": "3040408000000000000",
                                "taxCodeTitle": "物流辅助服务",
                                "iTitle": "*物流辅助服务*装卸搬运服务",
                                "children": []
                            },
                            {
                                "id": "4044",
                                "linkid": "4014",
                                "code": "3040409",
                                "paCode": "30404",
                                "yn": "Y",
                                "title": "收派服务",
                                "alias": "收派服务",
                                "about": "指接受寄件人委托，在承诺的时限内完成函件和包裹的收件、分拣、派送服务的业务活动。",
                                "kws": "快递、收派",
                                "taxName": "物流辅助服务",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "3040409000000000000",
                                "taxCodeTitle": "物流辅助服务",
                                "iTitle": "*物流辅助服务*收派服务",
                                "children": [
                                    {
                                        "id": "4045",
                                        "linkid": "4044",
                                        "code": "304040901",
                                        "paCode": "3040409",
                                        "yn": "N",
                                        "title": "收件服务",
                                        "alias": "收件服务",
                                        "about": "指从寄件人收取函件和包裹，并运送到服务提供方同城的集散中心的业务活动。",
                                        "kws": "快递、收件",
                                        "taxName": "物流辅助服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040409010000000000",
                                        "taxCodeTitle": "物流辅助服务",
                                        "iTitle": "*物流辅助服务*收件服务",
                                        "children": []
                                    },
                                    {
                                        "id": "4046",
                                        "linkid": "4044",
                                        "code": "304040902",
                                        "paCode": "3040409",
                                        "yn": "N",
                                        "title": "分拣服务",
                                        "alias": "分拣服务",
                                        "about": "指服务提供方在其集散中心对函件和包裹进行归类、分发的业务活动。",
                                        "kws": "分拣",
                                        "taxName": "物流辅助服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040409020000000000",
                                        "taxCodeTitle": "物流辅助服务",
                                        "iTitle": "*物流辅助服务*分拣服务",
                                        "children": []
                                    },
                                    {
                                        "id": "4047",
                                        "linkid": "4044",
                                        "code": "304040903",
                                        "paCode": "3040409",
                                        "yn": "N",
                                        "title": "派送服务",
                                        "alias": "派送服务",
                                        "about": "指服务提供方从其集散中心将函件和包裹送达同城的收件人的业务活动。",
                                        "kws": "快递、派送",
                                        "taxName": "物流辅助服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040409030000000000",
                                        "taxCodeTitle": "物流辅助服务",
                                        "iTitle": "*物流辅助服务*派送服务",
                                        "children": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "id": "4048",
                        "linkid": "3969",
                        "code": "30405",
                        "paCode": "304",
                        "yn": "Y",
                        "title": "租赁服务",
                        "alias": "租赁服务",
                        "about": "包括融资租赁和经营性租赁。",
                        "kws": "租赁、租赁服务",
                        "taxName": "租赁服务",
                        "taxRate": "",
                        "vip": "5",
                        "itaxRate": null,
                        "taxCode": "3040500000000000000",
                        "taxCodeTitle": "租赁服务",
                        "iTitle": "*租赁服务*租赁服务",
                        "children": [
                            {
                                "id": "4049",
                                "linkid": "4048",
                                "code": "3040501",
                                "paCode": "30405",
                                "yn": "Y",
                                "title": "融资租赁服务",
                                "alias": "融资租赁服务",
                                "about": "指具有融资性质和所有权转移特点的租赁活动。即出租人根据承租人所要求的规格、型号、性能等条件购入有形动产或者不动产租赁给承租人，合同期内租赁物所有权属于出租人，承租人只拥有使用权，合同期满付清租金后，承租人有权按照残值购入租赁物，以拥有其所有权。不论出租人是否将租赁物销售给承租人，均属于融资租赁。",
                                "kws": "融资租赁、直租、直接租赁",
                                "taxName": "融资租赁",
                                "taxRate": "",
                                "vip": "7",
                                "itaxRate": null,
                                "taxCode": "3040501000000000000",
                                "taxCodeTitle": "融资租赁",
                                "iTitle": "*融资租赁*融资租赁服务",
                                "children": [
                                    {
                                        "id": "4050",
                                        "linkid": "4049",
                                        "code": "304050101",
                                        "paCode": "3040501",
                                        "yn": "N",
                                        "title": "有形动产融资租赁服务",
                                        "alias": "有形动产融资租赁服务",
                                        "about": "指出租人根据承租人所要求的规格、型号、性能等条件购入有形动产直接租赁给承租人，合同期内设备所有权属于出租人，承租人只拥有使用权，合同期满付清租金后，承租人有权按照残值购入有形动产，以拥有其所有权。",
                                        "kws": "有形动产融资租赁",
                                        "taxName": "融资租赁",
                                        "taxRate": "13%",
                                        "vip": null,
                                        "itaxRate": "0.13",
                                        "taxCode": "3040501010000000000",
                                        "taxCodeTitle": "融资租赁",
                                        "iTitle": "*融资租赁*有形动产融资租赁服务",
                                        "children": []
                                    },
                                    {
                                        "id": "4051",
                                        "linkid": "4049",
                                        "code": "304050103",
                                        "paCode": "3040501",
                                        "yn": "N",
                                        "title": "不动产融资租赁服务",
                                        "alias": "不动产融资租赁服务",
                                        "about": "指承租方以融资为目的，将不动产出售给从事融资租赁业务的企业后，又将该资产租回的业务活动。",
                                        "kws": "不动产融资租赁",
                                        "taxName": "融资租赁",
                                        "taxRate": "9%",
                                        "vip": null,
                                        "itaxRate": "0.09",
                                        "taxCode": "3040501030000000000",
                                        "taxCodeTitle": "融资租赁",
                                        "iTitle": "*融资租赁*不动产融资租赁服务",
                                        "children": []
                                    },
                                    {
                                        "id": "4052",
                                        "linkid": "4049",
                                        "code": "304050199",
                                        "paCode": "3040501",
                                        "yn": "N",
                                        "title": "其他融资租赁服务",
                                        "alias": "其他融资租赁服务",
                                        "about": "指除有形动产和无形动产融资租赁以外的融资租赁服务。",
                                        "kws": "其他融资租赁",
                                        "taxName": "融资租赁",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "3040501990000000000",
                                        "taxCodeTitle": "融资租赁",
                                        "iTitle": "*融资租赁*其他融资租赁服务",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "4053",
                                "linkid": "4048",
                                "code": "3040502",
                                "paCode": "30405",
                                "yn": "Y",
                                "title": "经营租赁",
                                "alias": "经营租赁",
                                "about": "指在约定时间内将有形动产或者不动产转让他人使用且租赁物所有权不变更的业务活动，包括将建筑物、构筑物等不动产或者飞机、车辆等有形动产的广告位出租给其他单位或者个人用于发布广告。",
                                "kws": "经营性租赁、出租",
                                "taxName": "经营租赁",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "3040502000000000000",
                                "taxCodeTitle": "经营租赁",
                                "iTitle": "*经营租赁*经营租赁",
                                "children": [
                                    {
                                        "id": "4054",
                                        "linkid": "4053",
                                        "code": "304050201",
                                        "paCode": "3040502",
                                        "yn": "Y",
                                        "title": "有形动产经营租赁服务",
                                        "alias": "有形动产经营租赁服务",
                                        "about": "指在约定时间内将物品、设备等有形动产转让他人使用且租赁物所有权不变更的业务活动。",
                                        "kws": null,
                                        "taxName": "经营租赁",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "3040502010000000000",
                                        "taxCodeTitle": "经营租赁",
                                        "iTitle": "*经营租赁*有形动产经营租赁服务",
                                        "children": [
                                            {
                                                "id": "4055",
                                                "linkid": "4054",
                                                "code": "30405020101",
                                                "paCode": "304050201",
                                                "yn": "N",
                                                "title": "光租业务",
                                                "alias": "光租业务",
                                                "about": "是指运输企业将船舶在约定的时间内出租给他人使用，不配备操作人员，不承担运输过程中发生的各项费用，只收取固定租赁费的业务活动。",
                                                "kws": "船舶光租、有形动产光租",
                                                "taxName": "经营租赁",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "3040502010100000000",
                                                "taxCodeTitle": "经营租赁",
                                                "iTitle": "*经营租赁*光租业务",
                                                "children": []
                                            },
                                            {
                                                "id": "4056",
                                                "linkid": "4054",
                                                "code": "30405020102",
                                                "paCode": "304050201",
                                                "yn": "N",
                                                "title": "干租业务",
                                                "alias": "干租业务",
                                                "about": "是指航空运输企业将飞机在约定的时间内出租给他人使用，不配备机组人员，不承担运输过程中发生的各项费用，只收取固定租赁费的业务活动。",
                                                "kws": "航空干租、有形动产干租",
                                                "taxName": "经营租赁",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "3040502010200000000",
                                                "taxCodeTitle": "经营租赁",
                                                "iTitle": "*经营租赁*干租业务",
                                                "children": []
                                            },
                                            {
                                                "id": "4057",
                                                "linkid": "4054",
                                                "code": "30405020199",
                                                "paCode": "304050201",
                                                "yn": "N",
                                                "title": "其他有形动产经营租赁服务",
                                                "alias": "其他有形动产经营租赁服务",
                                                "about": "指光、干租以外其他有形动产经营租赁服务。",
                                                "kws": "动产租赁、汽车租赁、叉车租赁、电脑租赁、设备租赁",
                                                "taxName": "经营租赁",
                                                "taxRate": "13%",
                                                "vip": null,
                                                "itaxRate": "0.13",
                                                "taxCode": "3040502019900000000",
                                                "taxCodeTitle": "经营租赁",
                                                "iTitle": "*经营租赁*其他有形动产经营租赁服务",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "4058",
                                        "linkid": "4053",
                                        "code": "304050202",
                                        "paCode": "3040502",
                                        "yn": "Y",
                                        "title": "不动产经营租赁",
                                        "alias": "不动产经营租赁",
                                        "about": "指在约定时间内将不动产转让他人使用且租赁物所有权不变更的业务活动，以及车辆停放服务、道路通行服务（包括过路费、过桥费、过闸费等）。",
                                        "kws": null,
                                        "taxName": "经营租赁",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "3040502020000000000",
                                        "taxCodeTitle": "经营租赁",
                                        "iTitle": "*经营租赁*不动产经营租赁",
                                        "children": [
                                            {
                                                "id": "4059",
                                                "linkid": "4058",
                                                "code": "30405020201",
                                                "paCode": "304050202",
                                                "yn": "Y",
                                                "title": "住宅经营租赁服务",
                                                "alias": "住宅经营租赁服务",
                                                "about": null,
                                                "kws": "住宅租赁、住宅经营租赁、出租住房",
                                                "taxName": "经营租赁",
                                                "taxRate": "",
                                                "vip": null,
                                                "itaxRate": null,
                                                "taxCode": "3040502020100000000",
                                                "taxCodeTitle": "经营租赁",
                                                "iTitle": "*经营租赁*住宅经营租赁服务",
                                                "children": [
                                                    {
                                                        "id": "4060",
                                                        "linkid": "4059",
                                                        "code": "3040502020101",
                                                        "paCode": "30405020201",
                                                        "yn": "N",
                                                        "title": "公共住房租赁",
                                                        "alias": "公共住房租赁",
                                                        "about": null,
                                                        "kws": "住宅租赁、公共住房租赁",
                                                        "taxName": "经营租赁",
                                                        "taxRate": "9%",
                                                        "vip": null,
                                                        "itaxRate": "0.09",
                                                        "taxCode": "3040502020101000000",
                                                        "taxCodeTitle": "经营租赁",
                                                        "iTitle": "*经营租赁*公共住房租赁",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "4061",
                                                        "linkid": "4059",
                                                        "code": "3040502020102",
                                                        "paCode": "30405020201",
                                                        "yn": "N",
                                                        "title": "个人出租住房",
                                                        "alias": "个人出租住房",
                                                        "about": null,
                                                        "kws": "个人住宅租赁、个人出租住房",
                                                        "taxName": "经营租赁",
                                                        "taxRate": "9%",
                                                        "vip": null,
                                                        "itaxRate": "0.09",
                                                        "taxCode": "3040502020102000000",
                                                        "taxCodeTitle": "经营租赁",
                                                        "iTitle": "*经营租赁*个人出租住房",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "4062",
                                                        "linkid": "4059",
                                                        "code": "3040502020199",
                                                        "paCode": "30405020201",
                                                        "yn": "N",
                                                        "title": "其他住房租赁服务",
                                                        "alias": "其他住房租赁服务",
                                                        "about": null,
                                                        "kws": null,
                                                        "taxName": "经营租赁",
                                                        "taxRate": "9%",
                                                        "vip": null,
                                                        "itaxRate": "0.09",
                                                        "taxCode": "3040502020199000000",
                                                        "taxCodeTitle": "经营租赁",
                                                        "iTitle": "*经营租赁*其他住房租赁服务",
                                                        "children": []
                                                    }
                                                ]
                                            },
                                            {
                                                "id": "4063",
                                                "linkid": "4058",
                                                "code": "30405020202",
                                                "paCode": "304050202",
                                                "yn": "N",
                                                "title": "车辆停放服务",
                                                "alias": "车辆停放服务",
                                                "about": "指提供停放车辆服务",
                                                "kws": "车辆停放、停车、停车费",
                                                "taxName": "经营租赁",
                                                "taxRate": "9%",
                                                "vip": null,
                                                "itaxRate": "0.09",
                                                "taxCode": "3040502020200000000",
                                                "taxCodeTitle": "经营租赁",
                                                "iTitle": "*经营租赁*车辆停放服务",
                                                "children": []
                                            },
                                            {
                                                "id": "4064",
                                                "linkid": "4058",
                                                "code": "30405020203",
                                                "paCode": "304050202",
                                                "yn": "Y",
                                                "title": "道路通行服务",
                                                "alias": "道路通行服务",
                                                "about": "包括过路费、过桥费、过闸费",
                                                "kws": "过路费、过桥费、过闸费",
                                                "taxName": "经营租赁",
                                                "taxRate": "",
                                                "vip": null,
                                                "itaxRate": null,
                                                "taxCode": "3040502020300000000",
                                                "taxCodeTitle": "经营租赁",
                                                "iTitle": "*经营租赁*道路通行服务",
                                                "children": [
                                                    {
                                                        "id": "4065",
                                                        "linkid": "4064",
                                                        "code": "3040502020301",
                                                        "paCode": "30405020203",
                                                        "yn": "N",
                                                        "title": "高速公路通行服务",
                                                        "alias": "高速公路通行服务",
                                                        "about": null,
                                                        "kws": "高速公路通行、过路费",
                                                        "taxName": "经营租赁",
                                                        "taxRate": "9%",
                                                        "vip": null,
                                                        "itaxRate": "0.09",
                                                        "taxCode": "3040502020301000000",
                                                        "taxCodeTitle": "经营租赁",
                                                        "iTitle": "*经营租赁*高速公路通行服务",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "4066",
                                                        "linkid": "4064",
                                                        "code": "3040502020302",
                                                        "paCode": "30405020203",
                                                        "yn": "N",
                                                        "title": "江河等闸口通行服务",
                                                        "alias": "江河等闸口通行服务",
                                                        "about": null,
                                                        "kws": "闸口通行、过闸费",
                                                        "taxName": "经营租赁",
                                                        "taxRate": "9%",
                                                        "vip": null,
                                                        "itaxRate": "0.09",
                                                        "taxCode": "3040502020302000000",
                                                        "taxCodeTitle": "经营租赁",
                                                        "iTitle": "*经营租赁*江河等闸口通行服务",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "4067",
                                                        "linkid": "4064",
                                                        "code": "3040502020303",
                                                        "paCode": "30405020203",
                                                        "yn": "N",
                                                        "title": "桥梁通行服务",
                                                        "alias": "桥梁通行服务",
                                                        "about": null,
                                                        "kws": "桥梁通行、过桥费",
                                                        "taxName": "经营租赁",
                                                        "taxRate": "9%",
                                                        "vip": null,
                                                        "itaxRate": "0.09",
                                                        "taxCode": "3040502020303000000",
                                                        "taxCodeTitle": "经营租赁",
                                                        "iTitle": "*经营租赁*桥梁通行服务",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "4068",
                                                        "linkid": "4064",
                                                        "code": "3040502020399",
                                                        "paCode": "30405020203",
                                                        "yn": "N",
                                                        "title": "其他道路通行服务",
                                                        "alias": "其他道路通行服务",
                                                        "about": null,
                                                        "kws": null,
                                                        "taxName": "经营租赁",
                                                        "taxRate": "9%",
                                                        "vip": null,
                                                        "itaxRate": "0.09",
                                                        "taxCode": "3040502020399000000",
                                                        "taxCodeTitle": "经营租赁",
                                                        "iTitle": "*经营租赁*其他道路通行服务",
                                                        "children": []
                                                    }
                                                ]
                                            },
                                            {
                                                "id": "4069",
                                                "linkid": "4058",
                                                "code": "30405020204",
                                                "paCode": "304050202",
                                                "yn": "N",
                                                "title": "商业营业用房经营租赁服务",
                                                "alias": "商业营业用房经营租赁服务",
                                                "about": null,
                                                "kws": "房屋租赁、商房租赁、商品房租赁、商用房经营租赁、出租写字楼、写字楼出租、商铺出租、店面出租、厂房出租、仓库出租",
                                                "taxName": "经营租赁",
                                                "taxRate": "9%",
                                                "vip": null,
                                                "itaxRate": "0.09",
                                                "taxCode": "3040502020400000000",
                                                "taxCodeTitle": "经营租赁",
                                                "iTitle": "*经营租赁*商业营业用房经营租赁服务",
                                                "children": []
                                            },
                                            {
                                                "id": "4070",
                                                "linkid": "4058",
                                                "code": "30405020299",
                                                "paCode": "304050202",
                                                "yn": "Y",
                                                "title": "其他不动产经营租赁服务",
                                                "alias": "其他不动产经营租赁服务",
                                                "about": null,
                                                "kws": null,
                                                "taxName": "经营租赁",
                                                "taxRate": "",
                                                "vip": null,
                                                "itaxRate": null,
                                                "taxCode": "3040502029900000000",
                                                "taxCodeTitle": "经营租赁",
                                                "iTitle": "*经营租赁*其他不动产经营租赁服务",
                                                "children": [
                                                    {
                                                        "id": "4071",
                                                        "linkid": "4070",
                                                        "code": "3040502029901",
                                                        "paCode": "30405020299",
                                                        "yn": "N",
                                                        "title": "军队空余房产租赁服务",
                                                        "alias": "军队空余房产租赁服务",
                                                        "about": null,
                                                        "kws": null,
                                                        "taxName": "经营租赁",
                                                        "taxRate": "9%",
                                                        "vip": null,
                                                        "itaxRate": "0.09",
                                                        "taxCode": "3040502029901000000",
                                                        "taxCodeTitle": "经营租赁",
                                                        "iTitle": "*经营租赁*军队空余房产租赁服务",
                                                        "children": []
                                                    },
                                                    {
                                                        "id": "4072",
                                                        "linkid": "4070",
                                                        "code": "3040502029902",
                                                        "paCode": "30405020299",
                                                        "yn": "N",
                                                        "title": "其他情形不动产经营租赁服务",
                                                        "alias": "其他情形不动产经营租赁服务",
                                                        "about": null,
                                                        "kws": null,
                                                        "taxName": "经营租赁",
                                                        "taxRate": "9%",
                                                        "vip": null,
                                                        "itaxRate": "0.09",
                                                        "taxCode": "3040502029902000000",
                                                        "taxCodeTitle": "经营租赁",
                                                        "iTitle": "*经营租赁*其他情形不动产经营租赁服务",
                                                        "children": []
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "id": "4073",
                        "linkid": "3969",
                        "code": "30406",
                        "paCode": "304",
                        "yn": "Y",
                        "title": "鉴证咨询服务",
                        "alias": "鉴证咨询服务",
                        "about": "包括认证服务、鉴证服务和咨询服务。",
                        "kws": null,
                        "taxName": "鉴证咨询服务",
                        "taxRate": "",
                        "vip": "5",
                        "itaxRate": null,
                        "taxCode": "3040600000000000000",
                        "taxCodeTitle": "鉴证咨询服务",
                        "iTitle": "*鉴证咨询服务*鉴证咨询服务",
                        "children": [
                            {
                                "id": "4074",
                                "linkid": "4073",
                                "code": "3040601",
                                "paCode": "30406",
                                "yn": "N",
                                "title": "认证服务",
                                "alias": "认证服务",
                                "about": "指具有专业资质的单位利用检测、检验、计量等技术，证明产品、服务、管理体系符合相关技术规范、相关技术规范的强制性要求或者标准的业务活动。",
                                "kws": "认证、检测、检验、计量",
                                "taxName": "鉴证咨询服务",
                                "taxRate": "6%",
                                "vip": null,
                                "itaxRate": "0.06",
                                "taxCode": "3040601000000000000",
                                "taxCodeTitle": "鉴证咨询服务",
                                "iTitle": "*鉴证咨询服务*认证服务",
                                "children": []
                            },
                            {
                                "id": "4075",
                                "linkid": "4073",
                                "code": "3040602",
                                "paCode": "30406",
                                "yn": "Y",
                                "title": "鉴证服务",
                                "alias": "鉴证服务",
                                "about": "指具有专业资质的单位受托对相关事项进行鉴证，发表具有证明力的意见的业务活动。包括会计鉴证、税务鉴证、法律鉴证、职业技能鉴定、工程造价鉴证、工程监理、资产评估、环境评估、房地产土地评估、建筑图纸审核、医疗事故鉴定等。",
                                "kws": null,
                                "taxName": "鉴证咨询服务",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "3040602000000000000",
                                "taxCodeTitle": "鉴证咨询服务",
                                "iTitle": "*鉴证咨询服务*鉴证服务",
                                "children": [
                                    {
                                        "id": "4076",
                                        "linkid": "4075",
                                        "code": "304060201",
                                        "paCode": "3040602",
                                        "yn": "N",
                                        "title": "工程监理服务",
                                        "alias": "工程监理服务",
                                        "about": null,
                                        "kws": "工程监理",
                                        "taxName": "鉴证咨询服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040602010000000000",
                                        "taxCodeTitle": "鉴证咨询服务",
                                        "iTitle": "*鉴证咨询服务*工程监理服务",
                                        "children": []
                                    },
                                    {
                                        "id": "4077",
                                        "linkid": "4075",
                                        "code": "304060202",
                                        "paCode": "3040602",
                                        "yn": "N",
                                        "title": "涉税鉴证",
                                        "alias": "涉税鉴证",
                                        "about": null,
                                        "kws": "涉税鉴证",
                                        "taxName": "涉税鉴证",
                                        "taxRate": "6%",
                                        "vip": "5",
                                        "itaxRate": "0.06",
                                        "taxCode": "3040602020000000000",
                                        "taxCodeTitle": "涉税鉴证",
                                        "iTitle": "*涉税鉴证*涉税鉴证",
                                        "children": []
                                    },
                                    {
                                        "id": "4078",
                                        "linkid": "4075",
                                        "code": "304060203",
                                        "paCode": "3040602",
                                        "yn": "N",
                                        "title": "纳税情况审查",
                                        "alias": "纳税情况审查",
                                        "about": null,
                                        "kws": "纳税审查、纳税情况审查",
                                        "taxName": "纳税情况审查",
                                        "taxRate": "6%",
                                        "vip": "5",
                                        "itaxRate": "0.06",
                                        "taxCode": "3040602030000000000",
                                        "taxCodeTitle": "纳税情况审查",
                                        "iTitle": "*纳税情况审查*纳税情况审查",
                                        "children": []
                                    },
                                    {
                                        "id": "4079",
                                        "linkid": "4075",
                                        "code": "304060204",
                                        "paCode": "3040602",
                                        "yn": "N",
                                        "title": "审计服务",
                                        "alias": "审计服务",
                                        "about": "审查企业会计报表,出具审计报告；验证企业资本,出具验资报告；办理企业合并、分立、清算事宜中的审计业务,出具有关报告；办理法律、行政法规规定的其他审计业务",
                                        "kws": "审计、审计服务",
                                        "taxName": "审计服务",
                                        "taxRate": "6%",
                                        "vip": "5",
                                        "itaxRate": "0.06",
                                        "taxCode": "3040602040000000000",
                                        "taxCodeTitle": "审计服务",
                                        "iTitle": "*审计服务*审计服务",
                                        "children": []
                                    },
                                    {
                                        "id": "4080",
                                        "linkid": "4075",
                                        "code": "304060299",
                                        "paCode": "3040602",
                                        "yn": "N",
                                        "title": "其他鉴证服务",
                                        "alias": "其他鉴证服务",
                                        "about": null,
                                        "kws": "其他鉴证、会计鉴证、税务鉴证、法律鉴证、职业技能鉴定、工程造价鉴证、工程监理、资产评估、环境评估、房地产土地评估、建筑图纸审核、医疗事故鉴定",
                                        "taxName": "鉴证咨询服务",
                                        "taxRate": "6%",
                                        "vip": "5",
                                        "itaxRate": "0.06",
                                        "taxCode": "3040602990000000000",
                                        "taxCodeTitle": "鉴证咨询服务",
                                        "iTitle": "*鉴证咨询服务*其他鉴证服务",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "4081",
                                "linkid": "4073",
                                "code": "3040603",
                                "paCode": "30406",
                                "yn": "Y",
                                "title": "咨询服务",
                                "alias": "咨询服务",
                                "about": "是指提供信息、建议、策划、顾问等服务的活动。包括金融、软件、技术、财务、税收、法律、内部管理、业务运作、流程管理、健康等方面的咨询。",
                                "kws": null,
                                "taxName": "鉴证咨询服务",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "3040603000000000000",
                                "taxCodeTitle": "鉴证咨询服务",
                                "iTitle": "*鉴证咨询服务*咨询服务",
                                "children": [
                                    {
                                        "id": "4082",
                                        "linkid": "4081",
                                        "code": "304060301",
                                        "paCode": "3040603",
                                        "yn": "N",
                                        "title": "一般税务咨询",
                                        "alias": "一般税务咨询",
                                        "about": null,
                                        "kws": "一般税务咨询",
                                        "taxName": "一般税务咨询",
                                        "taxRate": "6%",
                                        "vip": "5",
                                        "itaxRate": "0.06",
                                        "taxCode": "3040603010000000000",
                                        "taxCodeTitle": "一般税务咨询",
                                        "iTitle": "*一般税务咨询*一般税务咨询",
                                        "children": []
                                    },
                                    {
                                        "id": "4083",
                                        "linkid": "4081",
                                        "code": "304060302",
                                        "paCode": "3040603",
                                        "yn": "N",
                                        "title": "专业税务顾问",
                                        "alias": "专业税务顾问",
                                        "about": null,
                                        "kws": "专业税务顾问",
                                        "taxName": "专业税务顾问",
                                        "taxRate": "6%",
                                        "vip": "5",
                                        "itaxRate": "0.06",
                                        "taxCode": "3040603020000000000",
                                        "taxCodeTitle": "专业税务顾问",
                                        "iTitle": "*专业税务顾问*专业税务顾问",
                                        "children": []
                                    },
                                    {
                                        "id": "4084",
                                        "linkid": "4081",
                                        "code": "304060303",
                                        "paCode": "3040603",
                                        "yn": "N",
                                        "title": "税收策划",
                                        "alias": "税收策划",
                                        "about": null,
                                        "kws": "税收策划",
                                        "taxName": "税收策划",
                                        "taxRate": "6%",
                                        "vip": "5",
                                        "itaxRate": "0.06",
                                        "taxCode": "3040603030000000000",
                                        "taxCodeTitle": "税收策划",
                                        "iTitle": "*税收策划*税收策划",
                                        "children": []
                                    },
                                    {
                                        "id": "4085",
                                        "linkid": "4081",
                                        "code": "304060304",
                                        "paCode": "3040603",
                                        "yn": "N",
                                        "title": "其他涉税服务",
                                        "alias": "其他涉税服务",
                                        "about": null,
                                        "kws": "其他涉税服务",
                                        "taxName": "其他涉税服务",
                                        "taxRate": "6%",
                                        "vip": "5",
                                        "itaxRate": "0.06",
                                        "taxCode": "3040603040000000000",
                                        "taxCodeTitle": "其他涉税服务",
                                        "iTitle": "*其他涉税服务*其他涉税服务",
                                        "children": []
                                    },
                                    {
                                        "id": "4086",
                                        "linkid": "4081",
                                        "code": "304060305",
                                        "paCode": "3040603",
                                        "yn": "N",
                                        "title": "会计服务",
                                        "alias": "会计服务",
                                        "about": null,
                                        "kws": "会计服务",
                                        "taxName": "会计服务",
                                        "taxRate": "6%",
                                        "vip": "5",
                                        "itaxRate": "0.06",
                                        "taxCode": "3040603050000000000",
                                        "taxCodeTitle": "会计服务",
                                        "iTitle": "*会计服务*会计服务",
                                        "children": []
                                    },
                                    {
                                        "id": "4087",
                                        "linkid": "4081",
                                        "code": "304060306",
                                        "paCode": "3040603",
                                        "yn": "N",
                                        "title": "会计咨询",
                                        "alias": "会计咨询",
                                        "about": null,
                                        "kws": "会计咨询",
                                        "taxName": "会计咨询",
                                        "taxRate": "6%",
                                        "vip": "5",
                                        "itaxRate": "0.06",
                                        "taxCode": "3040603060000000000",
                                        "taxCodeTitle": "会计咨询",
                                        "iTitle": "*会计咨询*会计咨询",
                                        "children": []
                                    },
                                    {
                                        "id": "4088",
                                        "linkid": "4081",
                                        "code": "304060307",
                                        "paCode": "3040603",
                                        "yn": "N",
                                        "title": "法律咨询",
                                        "alias": "法律咨询",
                                        "about": null,
                                        "kws": "法律咨询",
                                        "taxName": "法律咨询",
                                        "taxRate": "6%",
                                        "vip": "5",
                                        "itaxRate": "0.06",
                                        "taxCode": "3040603070000000000",
                                        "taxCodeTitle": "法律咨询",
                                        "iTitle": "*法律咨询*法律咨询",
                                        "children": []
                                    },
                                    {
                                        "id": "4089",
                                        "linkid": "4081",
                                        "code": "304060399",
                                        "paCode": "3040603",
                                        "yn": "N",
                                        "title": "其他咨询服务",
                                        "alias": "其他咨询服务",
                                        "about": null,
                                        "kws": "其他咨询",
                                        "taxName": "其他咨询服务",
                                        "taxRate": "6%",
                                        "vip": "5",
                                        "itaxRate": "0.06",
                                        "taxCode": "3040603990000000000",
                                        "taxCodeTitle": "其他咨询服务",
                                        "iTitle": "*其他咨询服务*其他咨询服务",
                                        "children": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "id": "4090",
                        "linkid": "3969",
                        "code": "30407",
                        "paCode": "304",
                        "yn": "Y",
                        "title": "广播影视服务",
                        "alias": "广播影视服务",
                        "about": "包括广播影视节目（作品）的制作服务、发行服务和播映（含放映）服务。",
                        "kws": "广播影视服务",
                        "taxName": "广播影视服务",
                        "taxRate": "",
                        "vip": "5",
                        "itaxRate": null,
                        "taxCode": "3040700000000000000",
                        "taxCodeTitle": "广播影视服务",
                        "iTitle": "*广播影视服务*广播影视服务",
                        "children": [
                            {
                                "id": "4091",
                                "linkid": "4090",
                                "code": "3040701",
                                "paCode": "30407",
                                "yn": "Y",
                                "title": "广播影视节目（作品）的制作服务",
                                "alias": "广播影视节目（作品）的制作服务",
                                "about": "指进行专题（特别节目）、专栏、综艺、体育、动画片、广播剧、电视剧、电影等广播影视节目和作品制作的服务。具体包括与广播影视节目和作品相关的策划、采编、拍摄、录音、音视频文字图片素材制作、场景布置、后期的剪辑、翻译（编译）、字幕制作、片头、片尾、片花制作、特效制作、影片修复、编目和确权等业务活动。",
                                "kws": "广电制作、广播影视节目制作、广播影视作品制作",
                                "taxName": "广播影视服务",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "3040701000000000000",
                                "taxCodeTitle": "广播影视服务",
                                "iTitle": "*广播影视服务*广播影视节目（作品）的制作服务",
                                "children": [
                                    {
                                        "id": "4092",
                                        "linkid": "4091",
                                        "code": "304070101",
                                        "paCode": "3040701",
                                        "yn": "N",
                                        "title": "广播节目制作服务",
                                        "alias": "广播节目制作服务",
                                        "about": "指广播电台的制作服务，以及专门为广播电台制作节目的服务。",
                                        "kws": "广播制作、广播节目制作",
                                        "taxName": "广播影视服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040701010000000000",
                                        "taxCodeTitle": "广播影视服务",
                                        "iTitle": "*广播影视服务*广播节目制作服务",
                                        "children": []
                                    },
                                    {
                                        "id": "4093",
                                        "linkid": "4091",
                                        "code": "304070102",
                                        "paCode": "3040701",
                                        "yn": "N",
                                        "title": "电视节目制作服务",
                                        "alias": "电视节目制作服务",
                                        "about": "指电视台的制作服务，以及专门为电视台制作节目的服务。",
                                        "kws": "电视制作、电视节目制作",
                                        "taxName": "广播影视服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040701020000000000",
                                        "taxCodeTitle": "广播影视服务",
                                        "iTitle": "*广播影视服务*电视节目制作服务",
                                        "children": []
                                    },
                                    {
                                        "id": "4094",
                                        "linkid": "4091",
                                        "code": "304070103",
                                        "paCode": "3040701",
                                        "yn": "N",
                                        "title": "电影制作服务",
                                        "alias": "电影制作服务",
                                        "about": "指电影节目和作品的制作服务。",
                                        "kws": "电影制作",
                                        "taxName": "广播影视服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040701030000000000",
                                        "taxCodeTitle": "广播影视服务",
                                        "iTitle": "*广播影视服务*电影制作服务",
                                        "children": []
                                    },
                                    {
                                        "id": "4095",
                                        "linkid": "4091",
                                        "code": "304070104",
                                        "paCode": "3040701",
                                        "yn": "N",
                                        "title": "音像制作服务",
                                        "alias": "音像制作服务",
                                        "about": "指音像节目和作品的制作服务。",
                                        "kws": "音像制作",
                                        "taxName": "广播影视服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040701040000000000",
                                        "taxCodeTitle": "广播影视服务",
                                        "iTitle": "*广播影视服务*音像制作服务",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "4096",
                                "linkid": "4090",
                                "code": "3040702",
                                "paCode": "30407",
                                "yn": "Y",
                                "title": "广播影视节目（作品）的发行服务",
                                "alias": "广播影视节目（作品）的发行服务",
                                "about": "指以分账、买断、委托、代理等方式，向影院、电台、电视台、网站等单位和个人发行广播影视节目（作品）以及转让体育赛事等活动的报道及播映权的业务活动。",
                                "kws": "广电发行",
                                "taxName": "广播影视服务",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "3040702000000000000",
                                "taxCodeTitle": "广播影视服务",
                                "iTitle": "*广播影视服务*广播影视节目（作品）的发行服务",
                                "children": [
                                    {
                                        "id": "4097",
                                        "linkid": "4096",
                                        "code": "304070201",
                                        "paCode": "3040702",
                                        "yn": "N",
                                        "title": "广播节目发行服务",
                                        "alias": "广播节目发行服务",
                                        "about": "指以分账、买断、委托、代理等方式，向单位和个人发行广播节目（作品）以及转让体育赛事等活动的报道及播映权的业务活动。",
                                        "kws": "广播发行、广播节目发行",
                                        "taxName": "广播影视服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040702010000000000",
                                        "taxCodeTitle": "广播影视服务",
                                        "iTitle": "*广播影视服务*广播节目发行服务",
                                        "children": []
                                    },
                                    {
                                        "id": "4098",
                                        "linkid": "4096",
                                        "code": "304070202",
                                        "paCode": "3040702",
                                        "yn": "N",
                                        "title": "电视节目发行服务",
                                        "alias": "电视节目发行服务",
                                        "about": "指以分账、买断、委托、代理等方式，向单位和个人发行电视节目（作品）以及转让体育赛事等活动的报道及播映权的业务活动。",
                                        "kws": "电视发行、电视节目发行",
                                        "taxName": "广播影视服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040702020000000000",
                                        "taxCodeTitle": "广播影视服务",
                                        "iTitle": "*广播影视服务*电视节目发行服务",
                                        "children": []
                                    },
                                    {
                                        "id": "4099",
                                        "linkid": "4096",
                                        "code": "304070203",
                                        "paCode": "3040702",
                                        "yn": "N",
                                        "title": "电影发行服务",
                                        "alias": "电影发行服务",
                                        "about": "指以分账、买断、委托、代理等方式，向单位和个人发行电影节目（作品）的业务活动。",
                                        "kws": "电影发行",
                                        "taxName": "广播影视服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040702030000000000",
                                        "taxCodeTitle": "广播影视服务",
                                        "iTitle": "*广播影视服务*电影发行服务",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "4100",
                                "linkid": "4090",
                                "code": "3040703",
                                "paCode": "30407",
                                "yn": "Y",
                                "title": "广播影视节目（作品）的播映（含放映）服务",
                                "alias": "广播影视节目（作品）的播映（含放映）服务",
                                "about": "指在影院、剧院、录像厅及其他场所播映广播影视节目（作品），以及通过电台、电视台、卫星通信、互联网、有线电视等无线或有线装置播映广播影视节目（作品）的业务活动。",
                                "kws": "广电播映",
                                "taxName": "广播影视服务",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "3040703000000000000",
                                "taxCodeTitle": "广播影视服务",
                                "iTitle": "*广播影视服务*广播影视节目（作品）的播映（含放映）服务",
                                "children": [
                                    {
                                        "id": "4101",
                                        "linkid": "4100",
                                        "code": "304070301",
                                        "paCode": "3040703",
                                        "yn": "N",
                                        "title": "广播节目播出服务",
                                        "alias": "广播节目播出服务",
                                        "about": "指通过电台等无线或有线装置播映广播节目（作品）的业务活动，包括通过互联网播出广播节目（作品）。",
                                        "kws": "广播播出、广播节目播出",
                                        "taxName": "广播影视服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040703010000000000",
                                        "taxCodeTitle": "广播影视服务",
                                        "iTitle": "*广播影视服务*广播节目播出服务",
                                        "children": []
                                    },
                                    {
                                        "id": "4102",
                                        "linkid": "4100",
                                        "code": "304070302",
                                        "paCode": "3040703",
                                        "yn": "N",
                                        "title": "电视节目播出服务",
                                        "alias": "电视节目播出服务",
                                        "about": "指通过电视台、有线电视等无线或有线装置播映电视节目（作品）的业务活动，包括通过互联网播出电视节目。",
                                        "kws": "电视播出、电视节目播出",
                                        "taxName": "广播影视服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040703020000000000",
                                        "taxCodeTitle": "广播影视服务",
                                        "iTitle": "*广播影视服务*电视节目播出服务",
                                        "children": []
                                    },
                                    {
                                        "id": "4103",
                                        "linkid": "4100",
                                        "code": "304070303",
                                        "paCode": "3040703",
                                        "yn": "Y",
                                        "title": "电影放映服务",
                                        "alias": "电影放映服务",
                                        "about": "指在影院、剧院、录像厅等场所播映电影节目（作品）的业务活动，包括通过互联网播出电影。",
                                        "kws": "电影放映",
                                        "taxName": "广播影视服务",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "3040703030000000000",
                                        "taxCodeTitle": "广播影视服务",
                                        "iTitle": "*广播影视服务*电影放映服务",
                                        "children": [
                                            {
                                                "id": "4104",
                                                "linkid": "4103",
                                                "code": "30407030301",
                                                "paCode": "304070303",
                                                "yn": "N",
                                                "title": "现场电影放映服务",
                                                "alias": "现场电影放映服务",
                                                "about": "指电影院线、普通影院、露天影院及录像等现场电影放映服务。",
                                                "kws": "电影票、现场电影放映",
                                                "taxName": "广播影视服务",
                                                "taxRate": "6%",
                                                "vip": null,
                                                "itaxRate": "0.06",
                                                "taxCode": "3040703030100000000",
                                                "taxCodeTitle": "广播影视服务",
                                                "iTitle": "*广播影视服务*现场电影放映服务",
                                                "children": []
                                            },
                                            {
                                                "id": "4105",
                                                "linkid": "4103",
                                                "code": "30407030302",
                                                "paCode": "304070303",
                                                "yn": "N",
                                                "title": "互联网电影播出服务",
                                                "alias": "互联网电影播出服务",
                                                "about": "指通过互联网播出电影的业务活动。",
                                                "kws": "互联网电影播出",
                                                "taxName": "广播影视服务",
                                                "taxRate": "6%",
                                                "vip": null,
                                                "itaxRate": "0.06",
                                                "taxCode": "3040703030200000000",
                                                "taxCodeTitle": "广播影视服务",
                                                "iTitle": "*广播影视服务*互联网电影播出服务",
                                                "children": []
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "id": "4106",
                        "linkid": "3969",
                        "code": "30408",
                        "paCode": "304",
                        "yn": "Y",
                        "title": "商务辅助服务",
                        "alias": "商务辅助服务",
                        "about": "包括企业管理服务、社团管理服务、经纪代理服务、人力资源服务、安全保护服务和道路管理服务。",
                        "kws": null,
                        "taxName": "商务辅助服务",
                        "taxRate": "",
                        "vip": "5",
                        "itaxRate": null,
                        "taxCode": "3040800000000000000",
                        "taxCodeTitle": "商务辅助服务",
                        "iTitle": "*商务辅助服务*商务辅助服务",
                        "children": [
                            {
                                "id": "4107",
                                "linkid": "4106",
                                "code": "3040801",
                                "paCode": "30408",
                                "yn": "Y",
                                "title": "企业管理服务",
                                "alias": "企业管理服务",
                                "about": "指提供总部管理、投资与资产管理、市场管理、物业管理、日常综合管理等服务的业务活动。",
                                "kws": "总部管理、投资与资产管理、市场管理、物业管理、日常综合管理",
                                "taxName": "企业管理服务",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "3040801000000000000",
                                "taxCodeTitle": "企业管理服务",
                                "iTitle": "*企业管理服务*企业管理服务",
                                "children": [
                                    {
                                        "id": "4108",
                                        "linkid": "4107",
                                        "code": "304080101",
                                        "paCode": "3040801",
                                        "yn": "N",
                                        "title": "物业管理服务",
                                        "alias": "物业管理服务",
                                        "about": null,
                                        "kws": "物业管理、物业费",
                                        "taxName": "企业管理服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040801010000000000",
                                        "taxCodeTitle": "企业管理服务",
                                        "iTitle": "*企业管理服务*物业管理服务",
                                        "children": []
                                    },
                                    {
                                        "id": "4109",
                                        "linkid": "4107",
                                        "code": "304080199",
                                        "paCode": "3040801",
                                        "yn": "N",
                                        "title": "其他企业管理服务",
                                        "alias": "其他企业管理服务",
                                        "about": null,
                                        "kws": "企业管理、总部管理、投资与资产管理、市场管理、日常综合管理",
                                        "taxName": "企业管理服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040801990000000000",
                                        "taxCodeTitle": "企业管理服务",
                                        "iTitle": "*企业管理服务*其他企业管理服务",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "4110",
                                "linkid": "4106",
                                "code": "3040802",
                                "paCode": "30408",
                                "yn": "Y",
                                "title": "经纪代理服务",
                                "alias": "经纪代理服务",
                                "about": "指各类经纪、中介、代理服务。包括金融代理、知识产权代理、货物运输代理、报关代理、法律代理、房地产中介、职业中介、婚姻中介、代理记账、拍卖等。",
                                "kws": null,
                                "taxName": "经纪代理服务",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "3040802000000000000",
                                "taxCodeTitle": "经纪代理服务",
                                "iTitle": "*经纪代理服务*经纪代理服务",
                                "children": [
                                    {
                                        "id": "4111",
                                        "linkid": "4110",
                                        "code": "304080201",
                                        "paCode": "3040802",
                                        "yn": "Y",
                                        "title": "货物运输代理服务",
                                        "alias": "货物运输代理服务",
                                        "about": "指接受货物收货人、发货人、船舶所有人、船舶承租人或者船舶经营人的委托，以委托人的名义，为委托人办理货物运输、装卸、仓储和船舶进出港口、引航、靠泊等相关手续的业务活动。",
                                        "kws": "货物代理、货物运输代理、货代",
                                        "taxName": "经纪代理服务",
                                        "taxRate": "",
                                        "vip": null,
                                        "itaxRate": null,
                                        "taxCode": "3040802010000000000",
                                        "taxCodeTitle": "经纪代理服务",
                                        "iTitle": "*经纪代理服务*货物运输代理服务",
                                        "children": [
                                            {
                                                "id": "4112",
                                                "linkid": "4111",
                                                "code": "30408020101",
                                                "paCode": "304080201",
                                                "yn": "N",
                                                "title": "国内货物运输代理服务",
                                                "alias": "国内货物运输代理服务",
                                                "about": "指提供国内货物运输代理服务。",
                                                "kws": "国内货物运输代理",
                                                "taxName": "经纪代理服务",
                                                "taxRate": "6%",
                                                "vip": null,
                                                "itaxRate": "0.06",
                                                "taxCode": "3040802010100000000",
                                                "taxCodeTitle": "经纪代理服务",
                                                "iTitle": "*经纪代理服务*国内货物运输代理服务",
                                                "children": []
                                            },
                                            {
                                                "id": "4113",
                                                "linkid": "4111",
                                                "code": "30408020102",
                                                "paCode": "304080201",
                                                "yn": "N",
                                                "title": "国际货物运输代理服务",
                                                "alias": "国际货物运输代理服务",
                                                "about": "指提供国际货物运输代理服务。",
                                                "kws": "国际货物运输代理",
                                                "taxName": "经纪代理服务",
                                                "taxRate": "6%",
                                                "vip": null,
                                                "itaxRate": "0.06",
                                                "taxCode": "3040802010200000000",
                                                "taxCodeTitle": "经纪代理服务",
                                                "iTitle": "*经纪代理服务*国际货物运输代理服务",
                                                "children": []
                                            },
                                            {
                                                "id": "4114",
                                                "linkid": "4111",
                                                "code": "30408020103",
                                                "paCode": "304080201",
                                                "yn": "N",
                                                "title": "港澳台货物运输代理服务",
                                                "alias": "港澳台货物运输代理服务",
                                                "about": "指港澳台货物运输代理服务。",
                                                "kws": "港澳台货物运输代理",
                                                "taxName": "经纪代理服务",
                                                "taxRate": "6%",
                                                "vip": null,
                                                "itaxRate": "0.06",
                                                "taxCode": "3040802010300000000",
                                                "taxCodeTitle": "经纪代理服务",
                                                "iTitle": "*经纪代理服务*港澳台货物运输代理服务",
                                                "children": []
                                            },
                                            {
                                                "id": "4115",
                                                "linkid": "4111",
                                                "code": "30408020199",
                                                "paCode": "304080201",
                                                "yn": "N",
                                                "title": "其他货物运输代理服务",
                                                "alias": "其他货物运输代理服务",
                                                "about": "除货物运输代理服务外其他经纪代理服务。",
                                                "kws": null,
                                                "taxName": "经纪代理服务",
                                                "taxRate": "6%",
                                                "vip": null,
                                                "itaxRate": "0.06",
                                                "taxCode": "3040802019900000000",
                                                "taxCodeTitle": "经纪代理服务",
                                                "iTitle": "*经纪代理服务*其他货物运输代理服务",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "4116",
                                        "linkid": "4110",
                                        "code": "304080202",
                                        "paCode": "3040802",
                                        "yn": "N",
                                        "title": "代理报关服务",
                                        "alias": "代理报关服务",
                                        "about": "指接受进出口货物的收、发货人委托，代为办理报关手续的业务活动。",
                                        "kws": "代理报关",
                                        "taxName": "经纪代理服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040802020000000000",
                                        "taxCodeTitle": "经纪代理服务",
                                        "iTitle": "*经纪代理服务*代理报关服务",
                                        "children": []
                                    },
                                    {
                                        "id": "4117",
                                        "linkid": "4110",
                                        "code": "304080203",
                                        "paCode": "3040802",
                                        "yn": "N",
                                        "title": "婚姻介绍服务",
                                        "alias": "婚姻介绍服务",
                                        "about": null,
                                        "kws": "婚姻介绍、婚介、婚介费",
                                        "taxName": "经纪代理服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040802030000000000",
                                        "taxCodeTitle": "经纪代理服务",
                                        "iTitle": "*经纪代理服务*婚姻介绍服务",
                                        "children": []
                                    },
                                    {
                                        "id": "4118",
                                        "linkid": "4110",
                                        "code": "304080205",
                                        "paCode": "3040802",
                                        "yn": "N",
                                        "title": "纳税申报代理",
                                        "alias": "纳税申报代理",
                                        "about": null,
                                        "kws": "纳税申报、纳税代理、纳税申报代理",
                                        "taxName": "纳税申报代理",
                                        "taxRate": "6%",
                                        "vip": "5",
                                        "itaxRate": "0.06",
                                        "taxCode": "3040802050000000000",
                                        "taxCodeTitle": "纳税申报代理",
                                        "iTitle": "*纳税申报代理*纳税申报代理",
                                        "children": []
                                    },
                                    {
                                        "id": "4119",
                                        "linkid": "4110",
                                        "code": "304080206",
                                        "paCode": "3040802",
                                        "yn": "N",
                                        "title": "其他税务事项代理",
                                        "alias": "其他税务事项代理",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "其他税务事项代理",
                                        "taxRate": "6%",
                                        "vip": "5",
                                        "itaxRate": "0.06",
                                        "taxCode": "3040802060000000000",
                                        "taxCodeTitle": "其他税务事项代理",
                                        "iTitle": "*其他税务事项代理*其他税务事项代理",
                                        "children": []
                                    },
                                    {
                                        "id": "4120",
                                        "linkid": "4110",
                                        "code": "304080207",
                                        "paCode": "3040802",
                                        "yn": "Y",
                                        "title": "法律代理",
                                        "alias": "法律代理",
                                        "about": "接受自然人、法人或者其他组织的委托，担任法律顾问",
                                        "kws": "法律代理",
                                        "taxName": "法律代理",
                                        "taxRate": "",
                                        "vip": "5",
                                        "itaxRate": null,
                                        "taxCode": "3040802070000000000",
                                        "taxCodeTitle": "法律代理",
                                        "iTitle": "*法律代理*法律代理",
                                        "children": [
                                            {
                                                "id": "4121",
                                                "linkid": "4120",
                                                "code": "30408020701",
                                                "paCode": "304080207",
                                                "yn": "N",
                                                "title": "诉讼代理",
                                                "alias": "诉讼代理",
                                                "about": "接受刑事案件犯罪嫌疑人、被告人的委托或者依法接受法律援助机构的指派，担任辩护人，接受自诉案件自诉人、公诉案件被害人或者其近亲属的委托，担任代理人，参加诉讼",
                                                "kws": "诉讼代理",
                                                "taxName": "诉讼代理",
                                                "taxRate": "6%",
                                                "vip": "5",
                                                "itaxRate": "0.06",
                                                "taxCode": "3040802070100000000",
                                                "taxCodeTitle": "诉讼代理",
                                                "iTitle": "*诉讼代理*诉讼代理",
                                                "children": []
                                            },
                                            {
                                                "id": "4122",
                                                "linkid": "4120",
                                                "code": "30408020702",
                                                "paCode": "304080207",
                                                "yn": "N",
                                                "title": "非诉讼代理",
                                                "alias": "非诉讼代理",
                                                "about": "接受委托，参加调解、仲裁活动；接受委托，提供非诉讼法律服务；代写诉讼文书和有关法律事务的其他文书",
                                                "kws": "非诉讼代理",
                                                "taxName": "非诉讼代理",
                                                "taxRate": "6%",
                                                "vip": "5",
                                                "itaxRate": "0.06",
                                                "taxCode": "3040802070200000000",
                                                "taxCodeTitle": "非诉讼代理",
                                                "iTitle": "*非诉讼代理*非诉讼代理",
                                                "children": []
                                            }
                                        ]
                                    },
                                    {
                                        "id": "4123",
                                        "linkid": "4110",
                                        "code": "304080208",
                                        "paCode": "3040802",
                                        "yn": "N",
                                        "title": "代理记账",
                                        "alias": "代理记账",
                                        "about": "根据委托人提供的原始凭证和其他相关资料，按照国家统一的会计制度的规定进行会计核算，包括审核原始凭证、填制记账凭证、登记会计账簿、编制财务会计报告等；对外提供财务会计报告；委托人委托的其他会计业务",
                                        "kws": "代理记账",
                                        "taxName": "代理记账",
                                        "taxRate": "6%",
                                        "vip": "5",
                                        "itaxRate": "0.06",
                                        "taxCode": "3040802080000000000",
                                        "taxCodeTitle": "代理记账",
                                        "iTitle": "*代理记账*代理记账",
                                        "children": []
                                    },
                                    {
                                        "id": "4124",
                                        "linkid": "4110",
                                        "code": "304080299",
                                        "paCode": "3040802",
                                        "yn": "N",
                                        "title": "其他经纪代理服务",
                                        "alias": "其他经纪代理服务",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "经纪代理服务",
                                        "taxRate": "6%",
                                        "vip": "5",
                                        "itaxRate": "0.06",
                                        "taxCode": "3040802990000000000",
                                        "taxCodeTitle": "经纪代理服务",
                                        "iTitle": "*经纪代理服务*其他经纪代理服务",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "4125",
                                "linkid": "4106",
                                "code": "3040803",
                                "paCode": "30408",
                                "yn": "Y",
                                "title": "人力资源服务",
                                "alias": "人力资源服务",
                                "about": "指提供公共就业、劳务派遣、人才委托招聘、劳动力外包等服务的业务活动。",
                                "kws": "公共就业、劳务派遣、人才委托招聘、劳动力外包",
                                "taxName": "人力资源服务",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "3040803000000000000",
                                "taxCodeTitle": "人力资源服务",
                                "iTitle": "*人力资源服务*人力资源服务",
                                "children": [
                                    {
                                        "id": "4126",
                                        "linkid": "4125",
                                        "code": "304080301",
                                        "paCode": "3040803",
                                        "yn": "N",
                                        "title": "劳务派遣服务",
                                        "alias": "劳务派遣服务",
                                        "about": null,
                                        "kws": "劳务派遣",
                                        "taxName": "人力资源服务",
                                        "taxRate": "6%",
                                        "vip": "3",
                                        "itaxRate": "0.06",
                                        "taxCode": "3040803010000000000",
                                        "taxCodeTitle": "人力资源服务",
                                        "iTitle": "*人力资源服务*劳务派遣服务",
                                        "children": []
                                    },
                                    {
                                        "id": "4127",
                                        "linkid": "4125",
                                        "code": "304080399",
                                        "paCode": "3040803",
                                        "yn": "N",
                                        "title": "其他人力资源服务",
                                        "alias": "其他人力资源服务",
                                        "about": null,
                                        "kws": "人力资源、公共就业、人才委托招聘、劳动力外包",
                                        "taxName": "人力资源服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3040803990000000000",
                                        "taxCodeTitle": "人力资源服务",
                                        "iTitle": "*人力资源服务*其他人力资源服务",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "4128",
                                "linkid": "4106",
                                "code": "3040804",
                                "paCode": "30408",
                                "yn": "N",
                                "title": "安全保护服务",
                                "alias": "安全保护服务",
                                "about": "指提供保护人身安全和财产安全，维护社会治安等的业务活动。包括场所住宅保安、特种保安、安全系统监控以及其他安保服务。",
                                "kws": "安全保护、安保、保安、场所住宅保安、特种保安、安全系统监控",
                                "taxName": "安全保护服务",
                                "taxRate": "6%",
                                "vip": "3",
                                "itaxRate": "0.06",
                                "taxCode": "3040804000000000000",
                                "taxCodeTitle": "安全保护服务",
                                "iTitle": "*安全保护服务*安全保护服务",
                                "children": []
                            }
                        ]
                    },
                    {
                        "id": "4129",
                        "linkid": "3969",
                        "code": "30499",
                        "paCode": "304",
                        "yn": "N",
                        "title": "其他现代服务",
                        "alias": "其他现代服务",
                        "about": "指除研发和技术服务、信息技术服务、文化创意服务、物流辅助服务、租赁服务、鉴证咨询服务、广播影视服务和商务辅助服务以外的现代服务。",
                        "kws": null,
                        "taxName": "现代服务",
                        "taxRate": "6%",
                        "vip": "5",
                        "itaxRate": "0.06",
                        "taxCode": "3049900000000000000",
                        "taxCodeTitle": "现代服务",
                        "iTitle": "*现代服务*其他现代服务",
                        "children": []
                    }
                ]
            },
            {
                "id": "4130",
                "linkid": "3836",
                "code": "305",
                "paCode": "3",
                "yn": "Y",
                "title": "建筑服务",
                "alias": "建筑服务",
                "about": "指各类建筑物、构筑物及其附属设施的建造、修缮、装饰，线路、管道、设备、设施等的安装以及其他工程作业的业务活动。",
                "kws": null,
                "taxName": "建筑服务",
                "taxRate": "",
                "vip": "5",
                "itaxRate": null,
                "taxCode": "3050000000000000000",
                "taxCodeTitle": "建筑服务",
                "iTitle": "*建筑服务*建筑服务",
                "children": [
                    {
                        "id": "4131",
                        "linkid": "4130",
                        "code": "30501",
                        "paCode": "305",
                        "yn": "N",
                        "title": "工程服务",
                        "alias": "工程服务",
                        "about": "指新建、改建各种建筑物、构筑物的工程作业，包括与建筑物相连的各种设备或者支柱、操作平台的安装或者装设工程作业，以及各种窑炉和金属结构工程作业。",
                        "kws": "工程服务",
                        "taxName": "建筑服务",
                        "taxRate": "9%",
                        "vip": "5",
                        "itaxRate": "0.09",
                        "taxCode": "3050100000000000000",
                        "taxCodeTitle": "建筑服务",
                        "iTitle": "*建筑服务*工程服务",
                        "children": []
                    },
                    {
                        "id": "4132",
                        "linkid": "4130",
                        "code": "30502",
                        "paCode": "305",
                        "yn": "N",
                        "title": "安装服务",
                        "alias": "安装服务",
                        "about": "指生产设备、动力设备、起重设备、运输设备、传动设备、医疗实验设备以及其他各种设备、设施的装配、安置工程作业，包括与被安装设备相连的工作台、梯子、栏杆的装设工程作业，以及被安装设备的绝缘、防腐、保温、油漆等工程作业。包括固定电话、有线电视、宽带、水、电、燃气、暖气等经营者向用户收取的安装费、初装费、开户费、扩容费以及类似收费。",
                        "kws": "安装服务",
                        "taxName": "建筑服务",
                        "taxRate": "9%",
                        "vip": "5",
                        "itaxRate": "0.09",
                        "taxCode": "3050200000000000000",
                        "taxCodeTitle": "建筑服务",
                        "iTitle": "*建筑服务*安装服务",
                        "children": []
                    },
                    {
                        "id": "4133",
                        "linkid": "4130",
                        "code": "30503",
                        "paCode": "305",
                        "yn": "N",
                        "title": "修缮服务",
                        "alias": "修缮服务",
                        "about": "指对建筑物、构筑物进行修补、加固、养护、改善，使之恢复原来的使用价值或者延长期使用期限的工程作业。",
                        "kws": "修缮服务、建筑物加固",
                        "taxName": "建筑服务",
                        "taxRate": "9%",
                        "vip": "5",
                        "itaxRate": "0.09",
                        "taxCode": "3050300000000000000",
                        "taxCodeTitle": "建筑服务",
                        "iTitle": "*建筑服务*修缮服务",
                        "children": []
                    },
                    {
                        "id": "4134",
                        "linkid": "4130",
                        "code": "30504",
                        "paCode": "305",
                        "yn": "N",
                        "title": "装饰服务",
                        "alias": "装饰服务",
                        "about": "指对建筑物、构筑物进行修饰装修，使之美观或者具有特定用途的工程作业。",
                        "kws": "装饰服务、装饰、装修",
                        "taxName": "建筑服务",
                        "taxRate": "9%",
                        "vip": "5",
                        "itaxRate": "0.09",
                        "taxCode": "3050400000000000000",
                        "taxCodeTitle": "建筑服务",
                        "iTitle": "*建筑服务*装饰服务",
                        "children": []
                    },
                    {
                        "id": "4135",
                        "linkid": "4130",
                        "code": "30599",
                        "paCode": "305",
                        "yn": "N",
                        "title": "其他建筑服务",
                        "alias": "其他建筑服务",
                        "about": "指上列工程作业之外的各种工程作业服务，如钻井（打井）、拆除建筑物或者构筑物、平整土地、园林绿化、疏浚（不包括航道疏浚）、建筑物平移、搭脚手架、爆破、矿山穿孔、表面附着物（包括岩层、土层、沙层等）剥离和清理劳务等工程作业。",
                        "kws": "其他建筑服务、搭脚手架、爆破、矿山穿孔",
                        "taxName": "建筑服务",
                        "taxRate": "9%",
                        "vip": "5",
                        "itaxRate": "0.09",
                        "taxCode": "3059900000000000000",
                        "taxCodeTitle": "建筑服务",
                        "iTitle": "*建筑服务*其他建筑服务",
                        "children": []
                    }
                ]
            },
            {
                "id": "4136",
                "linkid": "3836",
                "code": "306",
                "paCode": "3",
                "yn": "Y",
                "title": "金融服务",
                "alias": "金融服务",
                "about": "指经营金融保险的业务活动。包括贷款服务、直接收费金融服务、保险服务和金融商品转让。",
                "kws": "金融服务",
                "taxName": "金融服务",
                "taxRate": "",
                "vip": "5",
                "itaxRate": null,
                "taxCode": "3060000000000000000",
                "taxCodeTitle": "金融服务",
                "iTitle": "*金融服务*金融服务",
                "children": [
                    {
                        "id": "4137",
                        "linkid": "4136",
                        "code": "30601",
                        "paCode": "306",
                        "yn": "Y",
                        "title": "贷款服务",
                        "alias": "贷款服务",
                        "about": "指将资金贷与他人使用而取得利息收入的业务活动。包括各种占用、拆借资金取得的收入，包括金融商品持有期间（含到期）利息（保本收益、报酬、资金占用费、补偿金等）收入、信用卡透支利息收入、买入返售金融商品利息收入、融资融券收取的利息收入，以及融资性售后回租、押汇、罚息、票据贴现、转贷等业务取得的利息及利息性质的收入。",
                        "kws": "贷款",
                        "taxName": "金融服务",
                        "taxRate": "",
                        "vip": "5",
                        "itaxRate": null,
                        "taxCode": "3060100000000000000",
                        "taxCodeTitle": "金融服务",
                        "iTitle": "*金融服务*贷款服务",
                        "children": [
                            {
                                "id": "4138",
                                "linkid": "4137",
                                "code": "3060101",
                                "paCode": "30601",
                                "yn": "N",
                                "title": "金融同业往来业务",
                                "alias": "金融同业往来业务",
                                "about": null,
                                "kws": "同业往来",
                                "taxName": "金融服务",
                                "taxRate": "6%",
                                "vip": "7",
                                "itaxRate": "0.06",
                                "taxCode": "3060101000000000000",
                                "taxCodeTitle": "金融服务",
                                "iTitle": "*金融服务*金融同业往来业务",
                                "children": []
                            },
                            {
                                "id": "4139",
                                "linkid": "4137",
                                "code": "3060102",
                                "paCode": "30601",
                                "yn": "N",
                                "title": "金融机构农户小额贷款",
                                "alias": "金融机构农户小额贷款",
                                "about": null,
                                "kws": "农户小额贷款",
                                "taxName": "金融服务",
                                "taxRate": "6%",
                                "vip": "7",
                                "itaxRate": "0.06",
                                "taxCode": "3060102000000000000",
                                "taxCodeTitle": "金融服务",
                                "iTitle": "*金融服务*金融机构农户小额贷款",
                                "children": []
                            },
                            {
                                "id": "4140",
                                "linkid": "4137",
                                "code": "3060103",
                                "paCode": "30601",
                                "yn": "N",
                                "title": "国家助学贷款",
                                "alias": "国家助学贷款",
                                "about": null,
                                "kws": "国家助学贷款",
                                "taxName": "金融服务",
                                "taxRate": "6%",
                                "vip": "7",
                                "itaxRate": "0.06",
                                "taxCode": "3060103000000000000",
                                "taxCodeTitle": "金融服务",
                                "iTitle": "*金融服务*国家助学贷款",
                                "children": []
                            },
                            {
                                "id": "4141",
                                "linkid": "4137",
                                "code": "3060104",
                                "paCode": "30601",
                                "yn": "N",
                                "title": "国债",
                                "alias": "国债",
                                "about": null,
                                "kws": "国债",
                                "taxName": "金融服务",
                                "taxRate": "6%",
                                "vip": "7",
                                "itaxRate": "0.06",
                                "taxCode": "3060104000000000000",
                                "taxCodeTitle": "金融服务",
                                "iTitle": "*金融服务*国债",
                                "children": []
                            },
                            {
                                "id": "4142",
                                "linkid": "4137",
                                "code": "3060105",
                                "paCode": "30601",
                                "yn": "N",
                                "title": "地方政府债",
                                "alias": "地方政府债",
                                "about": null,
                                "kws": "地方政府债",
                                "taxName": "金融服务",
                                "taxRate": "6%",
                                "vip": "7",
                                "itaxRate": "0.06",
                                "taxCode": "3060105000000000000",
                                "taxCodeTitle": "金融服务",
                                "iTitle": "*金融服务*地方政府债",
                                "children": []
                            },
                            {
                                "id": "4143",
                                "linkid": "4137",
                                "code": "3060106",
                                "paCode": "30601",
                                "yn": "N",
                                "title": "住房公积金个人住房贷款",
                                "alias": "住房公积金个人住房贷款",
                                "about": null,
                                "kws": "公积金个人住房贷款",
                                "taxName": "金融服务",
                                "taxRate": "6%",
                                "vip": "7",
                                "itaxRate": "0.06",
                                "taxCode": "3060106000000000000",
                                "taxCodeTitle": "金融服务",
                                "iTitle": "*金融服务*住房公积金个人住房贷款",
                                "children": []
                            },
                            {
                                "id": "4144",
                                "linkid": "4137",
                                "code": "3060107",
                                "paCode": "30601",
                                "yn": "N",
                                "title": "外汇局外汇贷款",
                                "alias": "外汇局外汇贷款",
                                "about": null,
                                "kws": null,
                                "taxName": "金融服务",
                                "taxRate": "6%",
                                "vip": "7",
                                "itaxRate": "0.06",
                                "taxCode": "3060107000000000000",
                                "taxCodeTitle": "金融服务",
                                "iTitle": "*金融服务*外汇局外汇贷款",
                                "children": []
                            },
                            {
                                "id": "4145",
                                "linkid": "4137",
                                "code": "3060108",
                                "paCode": "30601",
                                "yn": "N",
                                "title": "统借统还",
                                "alias": "统借统还",
                                "about": null,
                                "kws": "统借统还利息收入",
                                "taxName": "金融服务",
                                "taxRate": "6%",
                                "vip": "7",
                                "itaxRate": "0.06",
                                "taxCode": "3060108000000000000",
                                "taxCodeTitle": "金融服务",
                                "iTitle": "*金融服务*统借统还",
                                "children": []
                            },
                            {
                                "id": "4146",
                                "linkid": "4137",
                                "code": "3060109",
                                "paCode": "30601",
                                "yn": "Y",
                                "title": "融资性售后回租",
                                "alias": "融资性售后回租",
                                "about": "是指承租方以融资为目的，将资产出售给从事融资租赁业务的企业后，又将该资产租回的业务活动。",
                                "kws": "融资性售后回租、售后回租",
                                "taxName": "金融服务",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "3060109000000000000",
                                "taxCodeTitle": "金融服务",
                                "iTitle": "*金融服务*融资性售后回租",
                                "children": [
                                    {
                                        "id": "4147",
                                        "linkid": "4146",
                                        "code": "306010901",
                                        "paCode": "3060109",
                                        "yn": "N",
                                        "title": "有形动产融资性售后回租",
                                        "alias": "有形动产融资性售后回租",
                                        "about": null,
                                        "kws": "有形动产售后回租、设备售后回租",
                                        "taxName": "金融服务",
                                        "taxRate": "",
                                        "vip": "5",
                                        "itaxRate": null,
                                        "taxCode": "3060109010000000000",
                                        "taxCodeTitle": "金融服务",
                                        "iTitle": "*金融服务*有形动产融资性售后回租",
                                        "children": []
                                    },
                                    {
                                        "id": "4148",
                                        "linkid": "4146",
                                        "code": "306010902",
                                        "paCode": "3060109",
                                        "yn": "N",
                                        "title": "不动产融资性售后回租",
                                        "alias": "不动产融资性售后回租",
                                        "about": null,
                                        "kws": "不动产售后回租",
                                        "taxName": "金融服务",
                                        "taxRate": "",
                                        "vip": "5",
                                        "itaxRate": null,
                                        "taxCode": "3060109020000000000",
                                        "taxCodeTitle": "金融服务",
                                        "iTitle": "*金融服务*不动产融资性售后回租",
                                        "children": []
                                    },
                                    {
                                        "id": "4149",
                                        "linkid": "4146",
                                        "code": "306010999",
                                        "paCode": "3060109",
                                        "yn": "N",
                                        "title": "其他融资性售后回租",
                                        "alias": "其他融资性售后回租",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "金融服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3060109990000000000",
                                        "taxCodeTitle": "金融服务",
                                        "iTitle": "*金融服务*其他融资性售后回租",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "4150",
                                "linkid": "4137",
                                "code": "3060110",
                                "paCode": "30601",
                                "yn": "Y",
                                "title": "客户贷款",
                                "alias": "客户贷款",
                                "about": "向企业和个人等客户发放贷款以及票据贴现业务，不包括编码3060101——3060109的贷款服务项目。",
                                "kws": "客户贷款",
                                "taxName": "金融服务",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "3060110000000000000",
                                "taxCodeTitle": "金融服务",
                                "iTitle": "*金融服务*客户贷款",
                                "children": [
                                    {
                                        "id": "4151",
                                        "linkid": "4150",
                                        "code": "306011001",
                                        "paCode": "3060110",
                                        "yn": "N",
                                        "title": "企业贷款",
                                        "alias": "企业贷款",
                                        "about": "向企业客户发放贷款业务。",
                                        "kws": "企业贷款",
                                        "taxName": "金融服务",
                                        "taxRate": "6%",
                                        "vip": "5",
                                        "itaxRate": "0.06",
                                        "taxCode": "3060110010000000000",
                                        "taxCodeTitle": "金融服务",
                                        "iTitle": "*金融服务*企业贷款",
                                        "children": []
                                    },
                                    {
                                        "id": "4152",
                                        "linkid": "4150",
                                        "code": "306011002",
                                        "paCode": "3060110",
                                        "yn": "N",
                                        "title": "个人贷款",
                                        "alias": "个人贷款",
                                        "about": "向个人客户发放贷款以及票据贴现业务。",
                                        "kws": "个人贷款",
                                        "taxName": "金融服务",
                                        "taxRate": "6%",
                                        "vip": "5",
                                        "itaxRate": "0.06",
                                        "taxCode": "3060110020000000000",
                                        "taxCodeTitle": "金融服务",
                                        "iTitle": "*金融服务*个人贷款",
                                        "children": []
                                    },
                                    {
                                        "id": "4153",
                                        "linkid": "4150",
                                        "code": "306011003",
                                        "paCode": "3060110",
                                        "yn": "N",
                                        "title": "票据贴现",
                                        "alias": "票据贴现",
                                        "about": "向企业和个人等客户票据贴现业务。",
                                        "kws": "票据贴现",
                                        "taxName": "金融服务",
                                        "taxRate": "6%",
                                        "vip": "5",
                                        "itaxRate": "0.06",
                                        "taxCode": "3060110030000000000",
                                        "taxCodeTitle": "金融服务",
                                        "iTitle": "*金融服务*票据贴现",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "4154",
                                "linkid": "4137",
                                "code": "3060199",
                                "paCode": "30601",
                                "yn": "N",
                                "title": "其他贷款服务",
                                "alias": "其他贷款服务",
                                "about": null,
                                "kws": "贷款服务",
                                "taxName": "金融服务",
                                "taxRate": "6%",
                                "vip": null,
                                "itaxRate": "0.06",
                                "taxCode": "3060199000000000000",
                                "taxCodeTitle": "金融服务",
                                "iTitle": "*金融服务*其他贷款服务",
                                "children": []
                            }
                        ]
                    },
                    {
                        "id": "4155",
                        "linkid": "4136",
                        "code": "30602",
                        "paCode": "306",
                        "yn": "N",
                        "title": "直接收费金融服务",
                        "alias": "直接收费金融服务",
                        "about": "指为货币资金融通及其他金融业务提供相关服务并且收取费用的业务活动。包括提供货币兑换、账户管理、电子银行、信用卡、信用证、财务担保、资产管理、信托管理、基金管理、金融商品交易、资金结算、资金清算、金融支付等服务。",
                        "kws": "私募、信托、担保、拍卖、典当、金融、投资、证券、货币兑换、账户管理、电子银行、信用卡、信用证、财务担保、资产管理、信托管理、基金管理、金融商品交易、资金结算、资金清算、金融支付",
                        "taxName": "金融服务",
                        "taxRate": "6%",
                        "vip": "7",
                        "itaxRate": "0.06",
                        "taxCode": "3060200000000000000",
                        "taxCodeTitle": "金融服务",
                        "iTitle": "*金融服务*直接收费金融服务",
                        "children": []
                    },
                    {
                        "id": "4156",
                        "linkid": "4136",
                        "code": "30603",
                        "paCode": "306",
                        "yn": "Y",
                        "title": "保险服务",
                        "alias": "保险服务",
                        "about": "指投保人根据合同约定，向保险人支付保险费，保险人对于合同约定的可能发生的事故因其发生所造成的财产损失承担赔偿保险金责任，或者当被保险人死亡、伤残、疾病或者达到合同约定的年龄、期限等条件时承担给付保险金责任的商业保险行为。包括人身保险服务和财产保险服务。",
                        "kws": "保险服务",
                        "taxName": "金融服务",
                        "taxRate": "",
                        "vip": "5",
                        "itaxRate": null,
                        "taxCode": "3060300000000000000",
                        "taxCodeTitle": "金融服务",
                        "iTitle": "*金融服务*保险服务",
                        "children": [
                            {
                                "id": "4157",
                                "linkid": "4156",
                                "code": "3060301",
                                "paCode": "30603",
                                "yn": "Y",
                                "title": "人身保险服务",
                                "alias": "人身保险服务",
                                "about": "指以人的寿命和身体为保险标的的保险业务活动。",
                                "kws": "人身保险、寿险、健康险、医疗保险",
                                "taxName": "保险服务",
                                "taxRate": "",
                                "vip": "5",
                                "itaxRate": null,
                                "taxCode": "3060301000000000000",
                                "taxCodeTitle": "保险服务",
                                "iTitle": "*保险服务*人身保险服务",
                                "children": [
                                    {
                                        "id": "4158",
                                        "linkid": "4157",
                                        "code": "306030101",
                                        "paCode": "3060301",
                                        "yn": "N",
                                        "title": "一年期以上的返还性人身保险和健康保险服务",
                                        "alias": "一年期以上的返还性人身保险和健康保险服务",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "保险服务",
                                        "taxRate": "6%",
                                        "vip": "5",
                                        "itaxRate": "0.06",
                                        "taxCode": "3060301010000000000",
                                        "taxCodeTitle": "保险服务",
                                        "iTitle": "*保险服务*一年期以上的返还性人身保险和健康保险服务",
                                        "children": []
                                    },
                                    {
                                        "id": "4159",
                                        "linkid": "4157",
                                        "code": "306030199",
                                        "paCode": "3060301",
                                        "yn": "N",
                                        "title": "其他人身保险服务",
                                        "alias": "其他人身保险服务",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "保险服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3060301990000000000",
                                        "taxCodeTitle": "保险服务",
                                        "iTitle": "*保险服务*其他人身保险服务",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "4160",
                                "linkid": "4156",
                                "code": "3060302",
                                "paCode": "30603",
                                "yn": "Y",
                                "title": "财产保险服务",
                                "alias": "财产保险服务",
                                "about": "指以财产及其有关利益为保险标的的保险业务活动。",
                                "kws": "财产保险、车险",
                                "taxName": "保险服务",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "3060302000000000000",
                                "taxCodeTitle": "保险服务",
                                "iTitle": "*保险服务*财产保险服务",
                                "children": [
                                    {
                                        "id": "4161",
                                        "linkid": "4160",
                                        "code": "306030201",
                                        "paCode": "3060302",
                                        "yn": "N",
                                        "title": "出口货物保险服务",
                                        "alias": "出口货物保险服务",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "保险服务",
                                        "taxRate": "6%",
                                        "vip": "5",
                                        "itaxRate": "0.06",
                                        "taxCode": "3060302010000000000",
                                        "taxCodeTitle": "保险服务",
                                        "iTitle": "*保险服务*出口货物保险服务",
                                        "children": []
                                    },
                                    {
                                        "id": "4162",
                                        "linkid": "4160",
                                        "code": "306030202",
                                        "paCode": "3060302",
                                        "yn": "N",
                                        "title": "机动车交通事故责任强制保险服务",
                                        "alias": "机动车交通事故责任强制保险服务",
                                        "about": null,
                                        "kws": "交强险、机动车交通事故责任强制保险",
                                        "taxName": "保险服务",
                                        "taxRate": "6%",
                                        "vip": "3",
                                        "itaxRate": "0.06",
                                        "taxCode": "3060302020000000000",
                                        "taxCodeTitle": "保险服务",
                                        "iTitle": "*保险服务*机动车交通事故责任强制保险服务",
                                        "children": []
                                    },
                                    {
                                        "id": "4163",
                                        "linkid": "4160",
                                        "code": "306030203",
                                        "paCode": "3060302",
                                        "yn": "N",
                                        "title": "农牧业保险服务",
                                        "alias": "农牧业保险服务",
                                        "about": null,
                                        "kws": "农牧保险",
                                        "taxName": "保险服务",
                                        "taxRate": "6%",
                                        "vip": "5",
                                        "itaxRate": "0.06",
                                        "taxCode": "3060302030000000000",
                                        "taxCodeTitle": "保险服务",
                                        "iTitle": "*保险服务*农牧业保险服务",
                                        "children": []
                                    },
                                    {
                                        "id": "4164",
                                        "linkid": "4160",
                                        "code": "306030204",
                                        "paCode": "3060302",
                                        "yn": "N",
                                        "title": "国际航运保险服务",
                                        "alias": "国际航运保险服务",
                                        "about": null,
                                        "kws": "国际航运保险",
                                        "taxName": "保险服务",
                                        "taxRate": "6%",
                                        "vip": "5",
                                        "itaxRate": "0.06",
                                        "taxCode": "3060302040000000000",
                                        "taxCodeTitle": "保险服务",
                                        "iTitle": "*保险服务*国际航运保险服务",
                                        "children": []
                                    },
                                    {
                                        "id": "4165",
                                        "linkid": "4160",
                                        "code": "306030299",
                                        "paCode": "3060302",
                                        "yn": "N",
                                        "title": "其他财产保险服务",
                                        "alias": "其他财产保险服务",
                                        "about": null,
                                        "kws": null,
                                        "taxName": "保险服务",
                                        "taxRate": "6%",
                                        "vip": null,
                                        "itaxRate": "0.06",
                                        "taxCode": "3060302990000000000",
                                        "taxCodeTitle": "保险服务",
                                        "iTitle": "*保险服务*其他财产保险服务",
                                        "children": []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "id": "4166",
                        "linkid": "4136",
                        "code": "30604",
                        "paCode": "306",
                        "yn": "Y",
                        "title": "金融商品转让",
                        "alias": "金融商品转让",
                        "about": "指转让外汇、有价证券、非货物期货和其他金融商品所有权的业务活动。",
                        "kws": "金融商品转让",
                        "taxName": "金融服务",
                        "taxRate": "",
                        "vip": "7",
                        "itaxRate": null,
                        "taxCode": "3060400000000000000",
                        "taxCodeTitle": "金融服务",
                        "iTitle": "*金融服务*金融商品转让",
                        "children": [
                            {
                                "id": "4167",
                                "linkid": "4166",
                                "code": "3060401",
                                "paCode": "30604",
                                "yn": "N",
                                "title": "股票转让",
                                "alias": "股票转让",
                                "about": null,
                                "kws": null,
                                "taxName": "金融服务",
                                "taxRate": "6%",
                                "vip": null,
                                "itaxRate": "0.06",
                                "taxCode": "3060401000000000000",
                                "taxCodeTitle": "金融服务",
                                "iTitle": "*金融服务*股票转让",
                                "children": []
                            },
                            {
                                "id": "4168",
                                "linkid": "4166",
                                "code": "3060402",
                                "paCode": "30604",
                                "yn": "N",
                                "title": "债券转让",
                                "alias": "债券转让",
                                "about": null,
                                "kws": null,
                                "taxName": "金融服务",
                                "taxRate": "6%",
                                "vip": null,
                                "itaxRate": "0.06",
                                "taxCode": "3060402000000000000",
                                "taxCodeTitle": "金融服务",
                                "iTitle": "*金融服务*债券转让",
                                "children": []
                            },
                            {
                                "id": "4169",
                                "linkid": "4166",
                                "code": "3060403",
                                "paCode": "30604",
                                "yn": "N",
                                "title": "外汇转让",
                                "alias": "外汇转让",
                                "about": null,
                                "kws": null,
                                "taxName": "金融服务",
                                "taxRate": "6%",
                                "vip": null,
                                "itaxRate": "0.06",
                                "taxCode": "3060403000000000000",
                                "taxCodeTitle": "金融服务",
                                "iTitle": "*金融服务*外汇转让",
                                "children": []
                            },
                            {
                                "id": "4170",
                                "linkid": "4166",
                                "code": "3060499",
                                "paCode": "30604",
                                "yn": "N",
                                "title": "其他金融商品转让",
                                "alias": "其他金融商品转让",
                                "about": "包括基金、信托、理财产品等各类资产管理产品和各种金融衍生品的转让。",
                                "kws": "其他金融商品转让",
                                "taxName": "金融服务",
                                "taxRate": "6%",
                                "vip": null,
                                "itaxRate": "0.06",
                                "taxCode": "3060499000000000000",
                                "taxCodeTitle": "金融服务",
                                "iTitle": "*金融服务*其他金融商品转让",
                                "children": []
                            }
                        ]
                    }
                ]
            },
            {
                "id": "4171",
                "linkid": "3836",
                "code": "307",
                "paCode": "3",
                "yn": "Y",
                "title": "生活服务",
                "alias": "生活服务",
                "about": "指为满足城乡居民日常生活需求提供的各类服务活动。包括文化体育服务、教育医疗服务、旅游娱乐服务、餐饮住宿服务、居民日常服务和其他生活服务。",
                "kws": null,
                "taxName": "生活服务",
                "taxRate": "",
                "vip": "5",
                "itaxRate": null,
                "taxCode": "3070000000000000000",
                "taxCodeTitle": "生活服务",
                "iTitle": "*生活服务*生活服务",
                "children": [
                    {
                        "id": "4172",
                        "linkid": "4171",
                        "code": "30701",
                        "paCode": "307",
                        "yn": "Y",
                        "title": "文化体育服务",
                        "alias": "文化体育服务",
                        "about": "包括文化服务和体育服务。",
                        "kws": null,
                        "taxName": "生活服务",
                        "taxRate": "",
                        "vip": "5",
                        "itaxRate": null,
                        "taxCode": "3070100000000000000",
                        "taxCodeTitle": "生活服务",
                        "iTitle": "*生活服务*文化体育服务",
                        "children": [
                            {
                                "id": "4173",
                                "linkid": "4172",
                                "code": "3070101",
                                "paCode": "30701",
                                "yn": "N",
                                "title": "文化服务",
                                "alias": "文化服务",
                                "about": "指为满足社会公众文化生活需求提供的各种服务。包括文艺创作、文艺表演、文化比赛、图书馆的图书和资料借阅、档案馆的档案管理、文物及非物质遗产保护、组织举办宗教活动、科技活动、文化活动。",
                                "kws": "文化服务",
                                "taxName": "文化服务",
                                "taxRate": "6%",
                                "vip": "5",
                                "itaxRate": "0.06",
                                "taxCode": "3070101000000000000",
                                "taxCodeTitle": "文化服务",
                                "iTitle": "*文化服务*文化服务",
                                "children": []
                            },
                            {
                                "id": "4174",
                                "linkid": "4172",
                                "code": "3070102",
                                "paCode": "30701",
                                "yn": "N",
                                "title": "体育服务",
                                "alias": "体育服务",
                                "about": "指组织举办体育比赛、体育表演、体育活动，提供体育训练、体育指导、体育管理的业务活动。",
                                "kws": "体育服务、体育比赛、体育表演、体育活动、体育训练、体育指导、体育管理",
                                "taxName": "体育服务",
                                "taxRate": "6%",
                                "vip": "5",
                                "itaxRate": "0.06",
                                "taxCode": "3070102000000000000",
                                "taxCodeTitle": "体育服务",
                                "iTitle": "*体育服务*体育服务",
                                "children": []
                            }
                        ]
                    },
                    {
                        "id": "4175",
                        "linkid": "4171",
                        "code": "30702",
                        "paCode": "307",
                        "yn": "Y",
                        "title": "教育医疗服务",
                        "alias": "教育医疗服务",
                        "about": "包括教育服务和医疗服务。",
                        "kws": null,
                        "taxName": "生活服务",
                        "taxRate": "",
                        "vip": "5",
                        "itaxRate": null,
                        "taxCode": "3070200000000000000",
                        "taxCodeTitle": "生活服务",
                        "iTitle": "*生活服务*教育医疗服务",
                        "children": [
                            {
                                "id": "4176",
                                "linkid": "4175",
                                "code": "3070201",
                                "paCode": "30702",
                                "yn": "Y",
                                "title": "教育服务",
                                "alias": "教育服务",
                                "about": "指提供学历教育服务、非学历教育服务、教育辅助服务的业务活动。",
                                "kws": null,
                                "taxName": "生活服务",
                                "taxRate": "",
                                "vip": null,
                                "itaxRate": null,
                                "taxCode": "3070201000000000000",
                                "taxCodeTitle": "生活服务",
                                "iTitle": "*生活服务*教育服务",
                                "children": [
                                    {
                                        "id": "4177",
                                        "linkid": "4176",
                                        "code": "307020101",
                                        "paCode": "3070201",
                                        "yn": "N",
                                        "title": "学历教育服务",
                                        "alias": "学历教育服务",
                                        "about": "指根据教育行政管理部门确定或者认可的招生和教学计划组织教学，并颁发相应学历证书的业务活动。包括初等教育、初级中等教育、高级中等教育、高等教育等。",
                                        "kws": "学历教育、初等教育、初级中等教育、高级中等教育、高等教育",
                                        "taxName": "学历教育服务",
                                        "taxRate": "6%",
                                        "vip": "5",
                                        "itaxRate": "0.06",
                                        "taxCode": "3070201010000000000",
                                        "taxCodeTitle": "学历教育服务",
                                        "iTitle": "*学历教育服务*学历教育服务",
                                        "children": []
                                    },
                                    {
                                        "id": "4178",
                                        "linkid": "4176",
                                        "code": "307020102",
                                        "paCode": "3070201",
                                        "yn": "N",
                                        "title": "非学历教育服务",
                                        "alias": "非学历教育服务",
                                        "about": "包括学前教育、各类培训、演讲、讲座、报告会等。",
                                        "kws": "培训教育、培训、非学历教育、学前教育、其他培训、演讲、讲座、报告会",
                                        "taxName": "非学历教育服务",
                                        "taxRate": "6%",
                                        "vip": "5",
                                        "itaxRate": "0.06",
                                        "taxCode": "3070201020000000000",
                                        "taxCodeTitle": "非学历教育服务",
                                        "iTitle": "*非学历教育服务*非学历教育服务",
                                        "children": []
                                    },
                                    {
                                        "id": "4179",
                                        "linkid": "4176",
                                        "code": "307020103",
                                        "paCode": "3070201",
                                        "yn": "N",
                                        "title": "教育辅助服务",
                                        "alias": "教育辅助服务",
                                        "about": "包括教育测评、考试、招生等服务。",
                                        "kws": "教育辅助、教育测评、考试、招生",
                                        "taxName": "教育辅助服务",
                                        "taxRate": "6%",
                                        "vip": "5",
                                        "itaxRate": "0.06",
                                        "taxCode": "3070201030000000000",
                                        "taxCodeTitle": "教育辅助服务",
                                        "iTitle": "*教育辅助服务*教育辅助服务",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": "4180",
                                "linkid": "4175",
                                "code": "3070202",
                                "paCode": "30702",
                                "yn": "N",
                                "title": "医疗服务",
                                "alias": "医疗服务",
                                "about": "指提供医学检查、诊断、治疗、康复、预防、保健、接生、计划生育、防疫服务等方面的服务，以及与这些服务有关的提供药品、医用材料器具、救护车、病房住宿和伙食的业务。",
                                "kws": "#医学检查、诊断、治疗、康复、预防、保健、接生、计划生育、防疫服务",
                                "taxName": "医疗服务",
                                "taxRate": "6%",
                                "vip": "5",
                                "itaxRate": "0.06",
                                "taxCode": "3070202000000000000",
                                "taxCodeTitle": "医疗服务",
                                "iTitle": "*医疗服务*医疗服务",
                                "children": []
                            }
                        ]
                    },
                    {
                        "id": "4181",
                        "linkid": "4171",
                        "code": "30703",
                        "paCode": "307",
                        "yn": "Y",
                        "title": "旅游娱乐服务",
                        "alias": "旅游娱乐服务",
                        "about": "包括旅游服务和娱乐服务。",
                        "kws": null,
                        "taxName": "生活服务",
                        "taxRate": "",
                        "vip": "5",
                        "itaxRate": null,
                        "taxCode": "3070300000000000000",
                        "taxCodeTitle": "生活服务",
                        "iTitle": "*生活服务*旅游娱乐服务",
                        "children": [
                            {
                                "id": "4182",
                                "linkid": "4181",
                                "code": "3070301",
                                "paCode": "30703",
                                "yn": "N",
                                "title": "旅游服务",
                                "alias": "旅游服务",
                                "about": "指根据旅游者的要求，组织安排交通、游览、住宿、餐饮、购物、文娱、商务等服务的业务活动。",
                                "kws": "旅游",
                                "taxName": "旅游服务",
                                "taxRate": "6%",
                                "vip": "5",
                                "itaxRate": "0.06",
                                "taxCode": "3070301000000000000",
                                "taxCodeTitle": "旅游服务",
                                "iTitle": "*旅游服务*旅游服务",
                                "children": []
                            },
                            {
                                "id": "4183",
                                "linkid": "4181",
                                "code": "3070302",
                                "paCode": "30703",
                                "yn": "N",
                                "title": "娱乐服务",
                                "alias": "娱乐服务",
                                "about": "指为娱乐活动同时提供场所和服务的业务，包括：歌厅、舞厅、夜总会、酒吧、台球、高尔夫球、保龄球、游艺（射击、狩猎、跑马、游戏机、蹦极、卡丁车、热气球、动力伞、射箭、飞镖）。",
                                "kws": "娱乐、KTV、足浴、歌厅、舞厅、夜总会、酒吧、台球、高尔夫球、保龄球、游艺",
                                "taxName": "娱乐服务",
                                "taxRate": "6%",
                                "vip": "5",
                                "itaxRate": "0.06",
                                "taxCode": "3070302000000000000",
                                "taxCodeTitle": "娱乐服务",
                                "iTitle": "*娱乐服务*娱乐服务",
                                "children": []
                            }
                        ]
                    },
                    {
                        "id": "4184",
                        "linkid": "4171",
                        "code": "30704",
                        "paCode": "307",
                        "yn": "Y",
                        "title": "餐饮住宿服务",
                        "alias": "餐饮住宿服务",
                        "about": "包括餐饮服务和住宿服务。",
                        "kws": null,
                        "taxName": "生活服务",
                        "taxRate": "",
                        "vip": "5",
                        "itaxRate": null,
                        "taxCode": "3070400000000000000",
                        "taxCodeTitle": "生活服务",
                        "iTitle": "*生活服务*餐饮住宿服务",
                        "children": [
                            {
                                "id": "4185",
                                "linkid": "4184",
                                "code": "3070401",
                                "paCode": "30704",
                                "yn": "N",
                                "title": "餐饮服务",
                                "alias": "餐饮服务",
                                "about": "指通过同时提供饮食和饮食场所的方式为消费者提供饮食消费服务的业务活动。",
                                "kws": "餐饮",
                                "taxName": "餐饮服务",
                                "taxRate": "6%",
                                "vip": "5",
                                "itaxRate": "0.06",
                                "taxCode": "3070401000000000000",
                                "taxCodeTitle": "餐饮服务",
                                "iTitle": "*餐饮服务*餐饮服务",
                                "children": []
                            },
                            {
                                "id": "4186",
                                "linkid": "4184",
                                "code": "3070402",
                                "paCode": "30704",
                                "yn": "N",
                                "title": "住宿服务",
                                "alias": "住宿服务",
                                "about": "指提供住宿场所及配套服务等的活动。包括宾馆、旅馆、旅社、度假村和其他经营性住宿场所提供的住宿服务。",
                                "kws": "住宿费、房费",
                                "taxName": "住宿服务",
                                "taxRate": "6%",
                                "vip": "5",
                                "itaxRate": "0.06",
                                "taxCode": "3070402000000000000",
                                "taxCodeTitle": "住宿服务",
                                "iTitle": "*住宿服务*住宿服务",
                                "children": []
                            }
                        ]
                    },
                    {
                        "id": "4187",
                        "linkid": "4171",
                        "code": "30705",
                        "paCode": "307",
                        "yn": "Y",
                        "title": "居民日常服务",
                        "alias": "居民日常服务",
                        "about": "指主要为满足居民个人及其家庭日常生活需求提供的服务，包括市容市政管理、家政、婚庆、养老、殡葬、照料和护理、救助救济、美容美发、按摩、桑拿、氧吧、足疗、沐浴、洗染、摄影扩印等服务。",
                        "kws": "居民日常服务",
                        "taxName": "生活服务",
                        "taxRate": "",
                        "vip": "5",
                        "itaxRate": null,
                        "taxCode": "3070500000000000000",
                        "taxCodeTitle": "生活服务",
                        "iTitle": "*生活服务*居民日常服务",
                        "children": [
                            {
                                "id": "4188",
                                "linkid": "4187",
                                "code": "3070501",
                                "paCode": "30705",
                                "yn": "N",
                                "title": "殡葬服务",
                                "alias": "殡葬服务",
                                "about": null,
                                "kws": "殡葬",
                                "taxName": "生活服务",
                                "taxRate": "6%",
                                "vip": null,
                                "itaxRate": "0.06",
                                "taxCode": "3070501000000000000",
                                "taxCodeTitle": "生活服务",
                                "iTitle": "*生活服务*殡葬服务",
                                "children": []
                            },
                            {
                                "id": "4189",
                                "linkid": "4187",
                                "code": "3070502",
                                "paCode": "30705",
                                "yn": "N",
                                "title": "养老服务",
                                "alias": "养老服务",
                                "about": null,
                                "kws": "养老",
                                "taxName": "生活服务",
                                "taxRate": "6%",
                                "vip": null,
                                "itaxRate": "0.06",
                                "taxCode": "3070502000000000000",
                                "taxCodeTitle": "生活服务",
                                "iTitle": "*生活服务*养老服务",
                                "children": []
                            },
                            {
                                "id": "4190",
                                "linkid": "4187",
                                "code": "3070503",
                                "paCode": "30705",
                                "yn": "N",
                                "title": "员工制家政服务",
                                "alias": "员工制家政服务",
                                "about": null,
                                "kws": "员工制家政",
                                "taxName": "生活服务",
                                "taxRate": "6%",
                                "vip": null,
                                "itaxRate": "0.06",
                                "taxCode": "3070503000000000000",
                                "taxCodeTitle": "生活服务",
                                "iTitle": "*生活服务*员工制家政服务",
                                "children": []
                            },
                            {
                                "id": "4191",
                                "linkid": "4187",
                                "code": "3070504",
                                "paCode": "30705",
                                "yn": "N",
                                "title": "育养服务",
                                "alias": "育养服务",
                                "about": "托儿所、幼儿园、残疾人福利机构提供的育养服务。",
                                "kws": "育养、托儿所、幼儿园、残疾人福利机构",
                                "taxName": "生活服务",
                                "taxRate": "6%",
                                "vip": null,
                                "itaxRate": "0.06",
                                "taxCode": "3070504000000000000",
                                "taxCodeTitle": "生活服务",
                                "iTitle": "*生活服务*育养服务",
                                "children": []
                            },
                            {
                                "id": "4192",
                                "linkid": "4187",
                                "code": "3070599",
                                "paCode": "30705",
                                "yn": "N",
                                "title": "其他居民日常服务",
                                "alias": "其他居民日常服务",
                                "about": null,
                                "kws": "其他居民日常",
                                "taxName": "生活服务",
                                "taxRate": "6%",
                                "vip": null,
                                "itaxRate": "0.06",
                                "taxCode": "3070599000000000000",
                                "taxCodeTitle": "生活服务",
                                "iTitle": "*生活服务*其他居民日常服务",
                                "children": []
                            }
                        ]
                    },
                    {
                        "id": "4193",
                        "linkid": "4171",
                        "code": "30799",
                        "paCode": "307",
                        "yn": "N",
                        "title": "其他生活服务",
                        "alias": "其他生活服务",
                        "about": "指除文化体育服务、教育医疗服务、旅游娱乐服务、餐饮住宿服务和居民日常服务之外的生活服务。",
                        "kws": "其他生活、美容美发",
                        "taxName": "生活服务",
                        "taxRate": "6%",
                        "vip": "5",
                        "itaxRate": "0.06",
                        "taxCode": "3079900000000000000",
                        "taxCodeTitle": "生活服务",
                        "iTitle": "*生活服务*其他生活服务",
                        "children": []
                    }
                ]
            }
        ]
    },
    {
        "id": "4194",
        "linkid": "0",
        "code": "4",
        "paCode": null,
        "yn": "Y",
        "title": "无形资产",
        "alias": "无形资产",
        "about": null,
        "kws": "无形资产",
        "taxName": "无形资产",
        "taxRate": "",
        "vip": "5",
        "itaxRate": null,
        "taxCode": "4000000000000000000",
        "taxCodeTitle": "无形资产",
        "iTitle": "*无形资产*无形资产",
        "children": [
            {
                "id": "4195",
                "linkid": "4194",
                "code": "401",
                "paCode": "4",
                "yn": "Y",
                "title": "技术",
                "alias": "技术",
                "about": "指专利或者非专利技术",
                "kws": "技术、专利商标",
                "taxName": "无形资产",
                "taxRate": "",
                "vip": "5",
                "itaxRate": null,
                "taxCode": "4010000000000000000",
                "taxCodeTitle": "无形资产",
                "iTitle": "*无形资产*技术",
                "children": [
                    {
                        "id": "4196",
                        "linkid": "4195",
                        "code": "40101",
                        "paCode": "401",
                        "yn": "N",
                        "title": "专利技术",
                        "alias": "专利技术",
                        "about": null,
                        "kws": "专利技术、专利权",
                        "taxName": "无形资产",
                        "taxRate": "6%",
                        "vip": "5",
                        "itaxRate": "0.06",
                        "taxCode": "4010100000000000000",
                        "taxCodeTitle": "无形资产",
                        "iTitle": "*无形资产*专利技术",
                        "children": []
                    },
                    {
                        "id": "4197",
                        "linkid": "4195",
                        "code": "40102",
                        "paCode": "401",
                        "yn": "N",
                        "title": "非专利技术",
                        "alias": "非专利技术",
                        "about": null,
                        "kws": "非专利技术",
                        "taxName": "无形资产",
                        "taxRate": "6%",
                        "vip": "5",
                        "itaxRate": "0.06",
                        "taxCode": "4010200000000000000",
                        "taxCodeTitle": "无形资产",
                        "iTitle": "*无形资产*非专利技术",
                        "children": []
                    }
                ]
            },
            {
                "id": "4198",
                "linkid": "4194",
                "code": "402",
                "paCode": "4",
                "yn": "N",
                "title": "商标",
                "alias": "商标",
                "about": null,
                "kws": "商标",
                "taxName": "无形资产",
                "taxRate": "6%",
                "vip": "5",
                "itaxRate": "0.06",
                "taxCode": "4020000000000000000",
                "taxCodeTitle": "无形资产",
                "iTitle": "*无形资产*商标",
                "children": []
            },
            {
                "id": "4199",
                "linkid": "4194",
                "code": "403",
                "paCode": "4",
                "yn": "N",
                "title": "著作权",
                "alias": "著作权",
                "about": null,
                "kws": "著作权",
                "taxName": "无形资产",
                "taxRate": "6%",
                "vip": "5",
                "itaxRate": "0.06",
                "taxCode": "4030000000000000000",
                "taxCodeTitle": "无形资产",
                "iTitle": "*无形资产*著作权",
                "children": []
            },
            {
                "id": "4200",
                "linkid": "4194",
                "code": "404",
                "paCode": "4",
                "yn": "N",
                "title": "商誉",
                "alias": "商誉",
                "about": null,
                "kws": "商誉",
                "taxName": "无形资产",
                "taxRate": "6%",
                "vip": "7",
                "itaxRate": "0.06",
                "taxCode": "4040000000000000000",
                "taxCodeTitle": "无形资产",
                "iTitle": "*无形资产*商誉",
                "children": []
            },
            {
                "id": "4201",
                "linkid": "4194",
                "code": "405",
                "paCode": "4",
                "yn": "Y",
                "title": "自然资源使用权",
                "alias": "自然资源使用权",
                "about": "指土地使用权、海域使用权、探矿权、采矿权、取水权和其他自然资源使用权。",
                "kws": null,
                "taxName": "无形资产",
                "taxRate": "",
                "vip": "7",
                "itaxRate": null,
                "taxCode": "4050000000000000000",
                "taxCodeTitle": "无形资产",
                "iTitle": "*无形资产*自然资源使用权",
                "children": [
                    {
                        "id": "4202",
                        "linkid": "4201",
                        "code": "40501",
                        "paCode": "405",
                        "yn": "Y",
                        "title": "土地使用权",
                        "alias": "土地使用权",
                        "about": null,
                        "kws": "土地使用权",
                        "taxName": "无形资产",
                        "taxRate": "",
                        "vip": "5",
                        "itaxRate": null,
                        "taxCode": "4050100000000000000",
                        "taxCodeTitle": "无形资产",
                        "iTitle": "*无形资产*土地使用权",
                        "children": [
                            {
                                "id": "4203",
                                "linkid": "4202",
                                "code": "4050101",
                                "paCode": "40501",
                                "yn": "N",
                                "title": "出让土地使用权",
                                "alias": "出让土地使用权",
                                "about": null,
                                "kws": null,
                                "taxName": "无形资产",
                                "taxRate": "9%",
                                "vip": null,
                                "itaxRate": "0.09",
                                "taxCode": "4050101000000000000",
                                "taxCodeTitle": "无形资产",
                                "iTitle": "*无形资产*出让土地使用权",
                                "children": []
                            },
                            {
                                "id": "4204",
                                "linkid": "4202",
                                "code": "4050102",
                                "paCode": "40501",
                                "yn": "N",
                                "title": "收回土地使用权",
                                "alias": "收回土地使用权",
                                "about": null,
                                "kws": null,
                                "taxName": "无形资产",
                                "taxRate": "9%",
                                "vip": null,
                                "itaxRate": "0.09",
                                "taxCode": "4050102000000000000",
                                "taxCodeTitle": "无形资产",
                                "iTitle": "*无形资产*收回土地使用权",
                                "children": []
                            },
                            {
                                "id": "4205",
                                "linkid": "4202",
                                "code": "4050199",
                                "paCode": "40501",
                                "yn": "N",
                                "title": "其他土地使用权",
                                "alias": "其他土地使用权",
                                "about": null,
                                "kws": null,
                                "taxName": "无形资产",
                                "taxRate": "9%",
                                "vip": null,
                                "itaxRate": "0.09",
                                "taxCode": "4050199000000000000",
                                "taxCodeTitle": "无形资产",
                                "iTitle": "*无形资产*其他土地使用权",
                                "children": []
                            }
                        ]
                    },
                    {
                        "id": "4206",
                        "linkid": "4201",
                        "code": "40502",
                        "paCode": "405",
                        "yn": "N",
                        "title": "探矿权",
                        "alias": "探矿权",
                        "about": null,
                        "kws": null,
                        "taxName": "无形资产",
                        "taxRate": "6%",
                        "vip": "7",
                        "itaxRate": "0.06",
                        "taxCode": "4050200000000000000",
                        "taxCodeTitle": "无形资产",
                        "iTitle": "*无形资产*探矿权",
                        "children": []
                    },
                    {
                        "id": "4207",
                        "linkid": "4201",
                        "code": "40503",
                        "paCode": "405",
                        "yn": "N",
                        "title": "采矿权",
                        "alias": "采矿权",
                        "about": null,
                        "kws": null,
                        "taxName": "无形资产",
                        "taxRate": "6%",
                        "vip": "7",
                        "itaxRate": "0.06",
                        "taxCode": "4050300000000000000",
                        "taxCodeTitle": "无形资产",
                        "iTitle": "*无形资产*采矿权",
                        "children": []
                    },
                    {
                        "id": "4208",
                        "linkid": "4201",
                        "code": "40599",
                        "paCode": "405",
                        "yn": "N",
                        "title": "其他自然资源使用权",
                        "alias": "其他自然资源使用权",
                        "about": null,
                        "kws": null,
                        "taxName": "无形资产",
                        "taxRate": "6%",
                        "vip": "7",
                        "itaxRate": "0.06",
                        "taxCode": "4059900000000000000",
                        "taxCodeTitle": "无形资产",
                        "iTitle": "*无形资产*其他自然资源使用权",
                        "children": []
                    }
                ]
            },
            {
                "id": "4209",
                "linkid": "4194",
                "code": "406",
                "paCode": "4",
                "yn": "N",
                "title": "其他权益性无形资产",
                "alias": "其他权益性无形资产",
                "about": "基础设施资产经营权、公共事业特许权、配额、经营权、经销权、分销权、代理权、会员权、席位权、网络游戏虚拟道具、域名、名称权、肖像权、冠名权、转会费",
                "kws": "基础设施资产经营权、公共事业特许权、配额、经营权、经销权、分销权、代理权、会员权、席位权、网络游戏虚拟道具、域名、名称权、肖像权、冠名权、转会费",
                "taxName": "无形资产",
                "taxRate": "6%",
                "vip": "5",
                "itaxRate": "0.06",
                "taxCode": "4060000000000000000",
                "taxCodeTitle": "无形资产",
                "iTitle": "*无形资产*其他权益性无形资产",
                "children": []
            }
        ]
    },
    {
        "id": "4210",
        "linkid": "0",
        "code": "5",
        "paCode": null,
        "yn": "Y",
        "title": "不动产",
        "alias": "不动产",
        "about": "是指不能移动或者移动后会引起性质、形状改变的财产，包括建筑物、构筑物等。",
        "kws": null,
        "taxName": "不动产",
        "taxRate": "",
        "vip": "5",
        "itaxRate": null,
        "taxCode": "5000000000000000000",
        "taxCodeTitle": "不动产",
        "iTitle": "*不动产*不动产",
        "children": [
            {
                "id": "4211",
                "linkid": "4210",
                "code": "501",
                "paCode": "5",
                "yn": "Y",
                "title": "建筑物",
                "alias": "建筑物",
                "about": "指住宅、商业营业用房、办公楼等建造物。",
                "kws": null,
                "taxName": "不动产",
                "taxRate": "",
                "vip": "5",
                "itaxRate": null,
                "taxCode": "5010000000000000000",
                "taxCodeTitle": "不动产",
                "iTitle": "*不动产*建筑物",
                "children": [
                    {
                        "id": "4212",
                        "linkid": "4211",
                        "code": "50101",
                        "paCode": "501",
                        "yn": "Y",
                        "title": "住宅",
                        "alias": "住宅",
                        "about": "包括普通住宅、高级公寓、别墅等居住用建筑物。",
                        "kws": "住宅、住房、公寓、别墅",
                        "taxName": "不动产",
                        "taxRate": "",
                        "vip": "5",
                        "itaxRate": null,
                        "taxCode": "5010100000000000000",
                        "taxCodeTitle": "不动产",
                        "iTitle": "*不动产*住宅",
                        "children": [
                            {
                                "id": "4213",
                                "linkid": "4212",
                                "code": "5010101",
                                "paCode": "50101",
                                "yn": "N",
                                "title": "房地产开发住宅",
                                "alias": "房地产开发住宅",
                                "about": "房地产企业开发的住宅（不含房改房）",
                                "kws": "住宅开发、房地产开发",
                                "taxName": "不动产",
                                "taxRate": "9%",
                                "vip": null,
                                "itaxRate": "0.09",
                                "taxCode": "5010101000000000000",
                                "taxCodeTitle": "不动产",
                                "iTitle": "*不动产*房地产开发住宅",
                                "children": []
                            },
                            {
                                "id": "4214",
                                "linkid": "4212",
                                "code": "5010102",
                                "paCode": "50101",
                                "yn": "N",
                                "title": "取得的住宅",
                                "alias": "取得的住宅",
                                "about": "以直接购买、接受捐赠、接受投资入股、自建以及抵债等各种形式取得的住宅。",
                                "kws": null,
                                "taxName": "不动产",
                                "taxRate": "9%",
                                "vip": null,
                                "itaxRate": "0.09",
                                "taxCode": "5010102000000000000",
                                "taxCodeTitle": "不动产",
                                "iTitle": "*不动产*取得的住宅",
                                "children": []
                            },
                            {
                                "id": "4215",
                                "linkid": "4212",
                                "code": "5010103",
                                "paCode": "50101",
                                "yn": "N",
                                "title": "房改房",
                                "alias": "房改房",
                                "about": "为了配合国家住房制度改革，企业、行政事业单位按房改成本价、标准价出售的住房。",
                                "kws": null,
                                "taxName": "不动产",
                                "taxRate": "9%",
                                "vip": null,
                                "itaxRate": "0.09",
                                "taxCode": "5010103000000000000",
                                "taxCodeTitle": "不动产",
                                "iTitle": "*不动产*房改房",
                                "children": []
                            },
                            {
                                "id": "4216",
                                "linkid": "4212",
                                "code": "5010199",
                                "paCode": "50101",
                                "yn": "N",
                                "title": "其他住房",
                                "alias": "其他住房",
                                "about": null,
                                "kws": null,
                                "taxName": "不动产",
                                "taxRate": "9%",
                                "vip": null,
                                "itaxRate": "0.09",
                                "taxCode": "5010199000000000000",
                                "taxCodeTitle": "不动产",
                                "iTitle": "*不动产*其他住房",
                                "children": []
                            }
                        ]
                    },
                    {
                        "id": "4217",
                        "linkid": "4211",
                        "code": "50102",
                        "paCode": "501",
                        "yn": "Y",
                        "title": "商业营业用房",
                        "alias": "商业营业用房",
                        "about": "包括各种商用店铺、商业楼宇、写字楼、饭店、旅店、购物中心、电影院、展览中心、娱乐设施、健身中心等。",
                        "kws": "商用房、写字楼、商用店铺、饭店、旅店、购物中心",
                        "taxName": "不动产",
                        "taxRate": "",
                        "vip": "5",
                        "itaxRate": null,
                        "taxCode": "5010200000000000000",
                        "taxCodeTitle": "不动产",
                        "iTitle": "*不动产*商业营业用房",
                        "children": [
                            {
                                "id": "4218",
                                "linkid": "4217",
                                "code": "5010201",
                                "paCode": "50102",
                                "yn": "N",
                                "title": "房地产开发商业用房",
                                "alias": "房地产开发商业用房",
                                "about": "房地产企业开发的商业营业用房",
                                "kws": "商业房产开发",
                                "taxName": "不动产",
                                "taxRate": "9%",
                                "vip": null,
                                "itaxRate": "0.09",
                                "taxCode": "5010201000000000000",
                                "taxCodeTitle": "不动产",
                                "iTitle": "*不动产*房地产开发商业用房",
                                "children": []
                            },
                            {
                                "id": "4219",
                                "linkid": "4217",
                                "code": "5010202",
                                "paCode": "50102",
                                "yn": "N",
                                "title": "取得的商业用房",
                                "alias": "取得的商业用房",
                                "about": "以直接购买、接受捐赠、接受投资入股、自建以及抵债等各种形式取得的商业营业用房。",
                                "kws": null,
                                "taxName": "不动产",
                                "taxRate": "9%",
                                "vip": null,
                                "itaxRate": "0.09",
                                "taxCode": "5010202000000000000",
                                "taxCodeTitle": "不动产",
                                "iTitle": "*不动产*取得的商业用房",
                                "children": []
                            },
                            {
                                "id": "4220",
                                "linkid": "4217",
                                "code": "5010299",
                                "paCode": "50102",
                                "yn": "N",
                                "title": "其他商业用房",
                                "alias": "其他商业用房",
                                "about": null,
                                "kws": null,
                                "taxName": "不动产",
                                "taxRate": "9%",
                                "vip": null,
                                "itaxRate": "0.09",
                                "taxCode": "5010299000000000000",
                                "taxCodeTitle": "不动产",
                                "iTitle": "*不动产*其他商业用房",
                                "children": []
                            }
                        ]
                    },
                    {
                        "id": "4221",
                        "linkid": "4211",
                        "code": "50199",
                        "paCode": "501",
                        "yn": "N",
                        "title": "其他建筑物",
                        "alias": "其他建筑物",
                        "about": "指住宅、商业营业用房以外的建筑物,包括工业厂房、仓库、办公楼、学校、教堂、寺庙等。",
                        "kws": "办公楼、工业厂房、厂房、仓库、学校、教堂、寺庙",
                        "taxName": "不动产",
                        "taxRate": "9%",
                        "vip": "7",
                        "itaxRate": "0.09",
                        "taxCode": "5019900000000000000",
                        "taxCodeTitle": "不动产",
                        "iTitle": "*不动产*其他建筑物",
                        "children": []
                    }
                ]
            },
            {
                "id": "4222",
                "linkid": "4210",
                "code": "502",
                "paCode": "5",
                "yn": "N",
                "title": "构筑物",
                "alias": "构筑物",
                "about": "包括道路、桥梁、隧道、水坝等建造物。",
                "kws": "构筑物、道路、桥梁、隧道、水坝",
                "taxName": "不动产",
                "taxRate": "9%",
                "vip": "7",
                "itaxRate": "0.09",
                "taxCode": "5020000000000000000",
                "taxCodeTitle": "不动产",
                "iTitle": "*不动产*构筑物",
                "children": []
            },
            {
                "id": "4223",
                "linkid": "4210",
                "code": "503",
                "paCode": "5",
                "yn": "N",
                "title": "其他不动产",
                "alias": "其他不动产",
                "about": "建筑物、构筑物以外的不动产。",
                "kws": null,
                "taxName": "不动产",
                "taxRate": "9%",
                "vip": "7",
                "itaxRate": "0.09",
                "taxCode": "5030000000000000000",
                "taxCodeTitle": "不动产",
                "iTitle": "*不动产*其他不动产",
                "children": []
            }
        ]
    },
    {
        "id": "4224",
        "linkid": "0",
        "code": "6",
        "paCode": null,
        "yn": "Y",
        "title": "未发生销售行为的不征税项目",
        "alias": "未发生销售行为的不征税项目",
        "about": "用于纳税人收取款项但未发生销售货物、服务、无形资产或不动产情形。",
        "kws": null,
        "taxName": "不征税项目",
        "taxRate": "",
        "vip": "5",
        "itaxRate": null,
        "taxCode": "6000000000000000000",
        "taxCodeTitle": "不征税项目",
        "iTitle": "*不征税项目*未发生销售行为的不征税项目",
        "children": [
            {
                "id": "4225",
                "linkid": "4224",
                "code": "601",
                "paCode": "6",
                "yn": "N",
                "title": "预付卡销售和充值",
                "alias": "预付卡销售和充值",
                "about": null,
                "kws": "预付卡",
                "taxName": "预付卡销售",
                "taxRate": "0%",
                "vip": "3",
                "itaxRate": "0",
                "taxCode": "6010000000000000000",
                "taxCodeTitle": "预付卡销售",
                "iTitle": "*预付卡销售*预付卡销售和充值",
                "children": []
            },
            {
                "id": "4226",
                "linkid": "4224",
                "code": "602",
                "paCode": "6",
                "yn": "N",
                "title": "销售自行开发的房地产项目预收款",
                "alias": "销售自行开发的房地产项目预收款",
                "about": null,
                "kws": "房地产预收款",
                "taxName": "房地产预收款",
                "taxRate": "0%",
                "vip": "7",
                "itaxRate": "0",
                "taxCode": "6020000000000000000",
                "taxCodeTitle": "房地产预收款",
                "iTitle": "*房地产预收款*销售自行开发的房地产项目预收款",
                "children": []
            },
            {
                "id": "4227",
                "linkid": "4224",
                "code": "603",
                "paCode": "6",
                "yn": "N",
                "title": "已申报缴纳营业税未开票补开票",
                "alias": "已申报缴纳营业税未开票补开票",
                "about": "在地税机关已申报营业税未开具发票的，补开增值税普通发票。",
                "kws": "补开营业税发票",
                "taxName": "补开营业税发票",
                "taxRate": "0%",
                "vip": "99",
                "itaxRate": "0",
                "taxCode": "6030000000000000000",
                "taxCodeTitle": "补开营业税发票",
                "iTitle": "*补开营业税发票*已申报缴纳营业税未开票补开票",
                "children": []
            },
            {
                "id": "4228",
                "linkid": "4224",
                "code": "604",
                "paCode": "6",
                "yn": "N",
                "title": "代收印花税",
                "alias": "代收印花税",
                "about": "非税务机关等其他单位为税务机关代收的印花税",
                "kws": "代收印花税",
                "taxName": "代收印花税",
                "taxRate": "0%",
                "vip": "99",
                "itaxRate": "0",
                "taxCode": "6040000000000000000",
                "taxCodeTitle": "代收印花税",
                "iTitle": "*代收印花税*代收印花税",
                "children": []
            },
            {
                "id": "4229",
                "linkid": "4224",
                "code": "605",
                "paCode": "6",
                "yn": "N",
                "title": "代收车船使用税",
                "alias": "代收车船使用税",
                "about": "代收车船税",
                "kws": "代收车船税",
                "taxName": "代收车船使用税",
                "taxRate": "0%",
                "vip": "99",
                "itaxRate": "0",
                "taxCode": "6050000000000000000",
                "taxCodeTitle": "代收车船使用税",
                "iTitle": "*代收车船使用税*代收车船使用税",
                "children": []
            },
            {
                "id": "4230",
                "linkid": "4224",
                "code": "606",
                "paCode": "6",
                "yn": "N",
                "title": "融资性售后回租承租方出售资产",
                "alias": "融资性售后回租承租方出售资产",
                "about": null,
                "kws": null,
                "taxName": "融资性售后回租承租方出售资产",
                "taxRate": "0%",
                "vip": "99",
                "itaxRate": "0",
                "taxCode": "6060000000000000000",
                "taxCodeTitle": "融资性售后回租承租方出售资产",
                "iTitle": "*融资性售后回租承租方出售资产*融资性售后回租承租方出售资产",
                "children": []
            },
            {
                "id": "4231",
                "linkid": "4224",
                "code": "607",
                "paCode": "6",
                "yn": "N",
                "title": "资产重组涉及的不动产",
                "alias": "资产重组涉及的不动产",
                "about": null,
                "kws": null,
                "taxName": "资产重组涉及的不动产",
                "taxRate": "0%",
                "vip": "99",
                "itaxRate": "0",
                "taxCode": "6070000000000000000",
                "taxCodeTitle": "资产重组涉及的不动产",
                "iTitle": "*资产重组涉及的不动产*资产重组涉及的不动产",
                "children": []
            },
            {
                "id": "4232",
                "linkid": "4224",
                "code": "608",
                "paCode": "6",
                "yn": "N",
                "title": "资产重组涉及的土地使用权",
                "alias": "资产重组涉及的土地使用权",
                "about": null,
                "kws": null,
                "taxName": "资产重组涉及的土地使用权",
                "taxRate": "0%",
                "vip": "99",
                "itaxRate": "0",
                "taxCode": "6080000000000000000",
                "taxCodeTitle": "资产重组涉及的土地使用权",
                "iTitle": "*资产重组涉及的土地使用权*资产重组涉及的土地使用权",
                "children": []
            },
            {
                "id": "4233",
                "linkid": "4224",
                "code": "609",
                "paCode": "6",
                "yn": "N",
                "title": "代理进口免税货物货款",
                "alias": "代理进口免税货物货款",
                "about": null,
                "kws": null,
                "taxName": "代理进口免税货物货款",
                "taxRate": "0%",
                "vip": "99",
                "itaxRate": "0",
                "taxCode": "6090000000000000000",
                "taxCodeTitle": "代理进口免税货物货款",
                "iTitle": "*代理进口免税货物货款*代理进口免税货物货款",
                "children": []
            },
            {
                "id": "4234",
                "linkid": "4224",
                "code": "610",
                "paCode": "6",
                "yn": "N",
                "title": "有奖发票奖金支付",
                "alias": "有奖发票奖金支付",
                "about": null,
                "kws": null,
                "taxName": "有奖发票奖金",
                "taxRate": "0%",
                "vip": "99",
                "itaxRate": "0",
                "taxCode": "6100000000000000000",
                "taxCodeTitle": "有奖发票奖金",
                "iTitle": "*有奖发票奖金*有奖发票奖金支付",
                "children": []
            },
            {
                "id": "4235",
                "linkid": "4224",
                "code": "611",
                "paCode": "6",
                "yn": "N",
                "title": "不征税自来水",
                "alias": "不征税自来水",
                "about": null,
                "kws": "不征税自来水",
                "taxName": "不征税自来水",
                "taxRate": "0%",
                "vip": "5",
                "itaxRate": "0",
                "taxCode": "6110000000000000000",
                "taxCodeTitle": "不征税自来水",
                "iTitle": "*不征税自来水*不征税自来水",
                "children": []
            },
            {
                "id": "4236",
                "linkid": "4224",
                "code": "612",
                "paCode": "6",
                "yn": "N",
                "title": "建筑服务预收款",
                "alias": "建筑服务预收款",
                "about": null,
                "kws": "建筑服务预收款",
                "taxName": "建筑服务预收款",
                "taxRate": "0%",
                "vip": "5",
                "itaxRate": "0",
                "taxCode": "6120000000000000000",
                "taxCodeTitle": "建筑服务预收款",
                "iTitle": "*建筑服务预收款*建筑服务预收款",
                "children": []
            },
            {
                "id": "4237",
                "linkid": "4224",
                "code": "613",
                "paCode": "6",
                "yn": "N",
                "title": "代收民航发展基金",
                "alias": "代收民航发展基金",
                "about": null,
                "kws": null,
                "taxName": "代收民航发展基金",
                "taxRate": "0%",
                "vip": "5",
                "itaxRate": "0",
                "taxCode": "6130000000000000000",
                "taxCodeTitle": "代收民航发展基金",
                "iTitle": "*代收民航发展基金*代收民航发展基金",
                "children": []
            }
        ]
    }
]